(function ($, ref, href) {
	if (!(/^http(?:s)?:\/\/(\w+\.)?onetwotrip\.(\w+)\//).test(document.referrer)) {
		var URL = '/_api/statistics/contextClick/';
		var DATA_TYPE = 'json';
		var TYPE = 'get';
		var encodedHref = encodeURI(href);

		if ($ && (ref || ~encodedHref.indexOf('?ds=') || ~encodedHref.indexOf('&ds='))) {
			$.ajax({
				type: TYPE,
				dataType: DATA_TYPE,
				url: URL,
				data: {
					referrer: ref,
					url: href
				}
			});
		}
	}
})(jQuery, document.referrer, location.href);

/**
 * cookie methods are moved from global.js for cross-project use
 * for history and annotations check global.bak.js
 * */


/**
 * Globals
 * Duplicated for other projects
 * */

window.tw = window.tw || {};

if (!tw.language) {
	tw.language = 'ru';
}

tw.params = getURLParams();

var rootre = /\/(ru|uk|en|de|az|ch|at|tr|pl|br|tr|es)(\-[a-z]{2})?\/$/i;
var flightsre = /^\/(.*?)([A-Z]{3}\-[A-Z]{3})(.*)$/i;
var path = window.document.location.pathname;
// 2nd condition due to seo search page
tw.root = rootre.test(path) || (flightsre.test(path) && !!location.hash);

runCookieMethods();

/**
 * Helpers
 * In Avia: overriden by global.js
 * Duplicated for other projects
 * */

function getObjParams(arrParams) {
	var objParams = {};
	var p1, p2;
	for(var i = 0, length = arrParams.length; i < length; i++) {
		var currentParam = arrParams[i];
		if(currentParam !== "") {
			var equalIndex = currentParam.indexOf('=');
			if(equalIndex === -1 ) {
				p1 = currentParam.substring(0, currentParam.length );
				p2 = null;
			} else {
				p1 = currentParam.substring(0, equalIndex );
				p2 = currentParam.substring(equalIndex+1, currentParam.length );
			}
			objParams[p1] = p2 === null ? true : p2;
		}
	}
	return objParams;
}

function getURLParams() {
	var arrParams = (decodeURIComponent(document.location.search)).substr(1).split('&');
	return getObjParams(arrParams);
}

function parseURL(url) {
	var expr = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
	return expr.exec(document.referrer);
}


/**
 * Base cookie methods
 * */

function makeCookie(name, value, days) {
	var date;
	if (days) {
		date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
	}

	document.cookie = [
		name, "=", escape(value),
		(days) ? "; expires=" + date.toGMTString() : "",
		"; path=/"
	].join('');
}

function setCookie(options){
	if (!options || options.name == null || options.value == null) {
		return;
	}
	var str = options.name + '=' + encodeURIComponent(options.value);
	if (options.days) {
		var date = new Date();
		date.setTime(date.getTime() + (options.days * 24 * 60 * 60 * 1000));
		str += '; expires=' + date.toGMTString();
	}

	str = str + ';path=' + (options.path || '/');

	if (!options.withoutDomain && !options.domain && window.location.hostname.indexOf("onetwotrip.com") > -1) {
		options.domain = "onetwotrip.com";
	}
	if (options.domain) {
		str += ';domain=' + options.domain;
	}
	if (options.secure) {
		str += ';secure';
	}
	document.cookie = str;
	if (options.xdm && window.location.hostname.indexOf("onetwotrip.com") == -1) {
		setPMCookie(options);
	}
}

function setPMCookie(options){
	iframe = document.getElementById('pm');
	if (!iframe) return;
	iframe.contentWindow.postMessage({
		type: 'cookie',
		options: options
	}, iframe.src);
}

function readCookie(name) {
	var matches = document.cookie.match(new RegExp(
		"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
	));
	return matches ? decodeURIComponent(matches[1]) : undefined;
}

function deleteCookie(options) {
	if(!options || !options.name) {
		return;
	}
	if (!options.domain && window.location.hostname.indexOf("onetwotrip.com") > -1) {
		options.domain = "onetwotrip.com";
	}

	var str = [
		options.name, "=",
		";expires=Thu, 01-Jan-1970 00:00:01 GMT",
		';path=', options.path || '/'
	].join('');

	if (options.domain) {
		str += ';domain=' + options.domain;
	}
	document.cookie = str;
}


/**
 * Referrer cookie methods
 * */

function createReferrerToSetInfo(referrer, marker, ttl){
	return {
		referrer: referrer,
		marker: marker,
		ttl: ttl
	};
}

function processReferrerVisit(justRead){
	// Логика работы с реферерами переезжает на backend
	// фронт может только читать данные, изменять нельзя
	// PM-475
	return false;


	//searchers
	var cookieReferrerInfo = readReferrerInfo();

	var acceptLangToVersion = {
		'ru': 'ru',
		'uk-ua': 'ua',
		'ru-ua': 'ua',
		'es': 'es',
		'de': 'de',
		'en-us': 'us',
		'en-gb': 'co.uk',
		'en': 'co.uk',
		'tr': 'tr',
		'pl': 'pl'
	};

	var adwordsMarkets = ['ru', 'de', 'es', 'ua', 'tr', 'az', 'us', 'en', 'pl'];

	var hostname = parseURL(document.referrer)[6];

	var isGoogle = false;
	var isYandex = false;

	if(hostname){
		var hostnameParts = hostname.split('.');
		isGoogle = hostnameParts[hostnameParts.length - 2] === 'google';
		isYandex = hostnameParts[hostnameParts.length - 2] === 'yandex';
	}

	var referrerToSetInfo = undefined;

	var adwordsParamName, adwordsParamValue;
	var isGoogleAdwords = false;
	var AFFILIATE = 'affiliate';
	var isAffiliatePartner = false;
	var isYandexDirect = false;

	var lowerParam;
	// looking for google adwords or yandex direct params
	for(var paramName in tw.params){
		if(isGoogle && paramName.toLowerCase().indexOf('adwords') > -1){
			adwordsParamName = paramName;
			adwordsParamValue = tw.params[paramName];
			isGoogleAdwords = (adwordsParamName && adwordsParamValue);
			break;
		}

		if (paramName === 'utm_source') {
			lowerParam = tw.params[paramName].toLowerCase();
			if (lowerParam === AFFILIATE) {
				isAffiliatePartner = true;
			} else
			if (isYandex && lowerParam === 'direct') {
				isYandexDirect = true;
				break;
			}
		}
	}

	var isBrandTraffic = false;
	var isOrganicTraffic = false;
	var isSavedMarkerBrand	= false;
	var forceChannelRewrite = false;

	if(cookieReferrerInfo.marker && cookieReferrerInfo.marker.toLowerCase instanceof Function){
		if(cookieReferrerInfo.marker.toLowerCase().indexOf('brand') == 0){
			isSavedMarkerBrand = true;
		}
	}

	//for welcome screen
	var showWS = false;
	if (isAffiliatePartner) {
		referrerToSetInfo = createReferrerToSetInfo(AFFILIATE, tw.params.srcmarker, 180);
	} else
	// google traffic
	if(isGoogleAdwords){
		var market = 'ru';
		var adwordsParamNameParts = adwordsParamName.split('_');

		if(adwordsParamNameParts.length == 2 && adwordsMarkets.indexOf(adwordsParamNameParts[1]) > -1){
			market = adwordsParamNameParts[1];
		}

		var profileToSet;
		isBrandTraffic = adwordsParamValue.toLowerCase().indexOf('brand') == 0;

		if(market == 'ru'){
			if(isBrandTraffic){
				profileToSet = 'google_adwords_brand';
			}
			else{
				profileToSet = 'google_adwords';
				showWS = true;
			}
		}
		else{
			profileToSet = 'google_adwords_' + market;
		}
		referrerToSetInfo = createReferrerToSetInfo(profileToSet, adwordsParamValue, 180);

	} // yandex traffic
	else if(isYandexDirect){
		isBrandTraffic = tw.params.utm_campaign && tw.params.utm_campaign.toLowerCase().indexOf('brand') === 0;

		if(isBrandTraffic){
			referrerToSetInfo = createReferrerToSetInfo('yandex_direct_brand', (tw.params.utm_campaign || 'not_set'), 180);
		}
		else{
			referrerToSetInfo = createReferrerToSetInfo('yandex_direct', (tw.params.utm_campaign || 'not_set'), 180);
		}

	} // google organic traffic
	else if(isGoogle){
		var versionToSet = acceptLangToVersion[tw.language];
		isOrganicTraffic = true;

		var googleOrganicReferrer = tw && tw.root ? 'google_adwords_organic' : 'google_organic_seo';
		if(versionToSet && versionToSet != 'ru'){
			referrerToSetInfo = createReferrerToSetInfo(googleOrganicReferrer + '_' + versionToSet, tw.params.utm_campaign, 180);
		}
		else{
			referrerToSetInfo = createReferrerToSetInfo(googleOrganicReferrer, tw.params.adwords, 180);
		}

	} // yandex organic traffic
	else if(isYandex){
		isOrganicTraffic = true;
		var yandexOrganicReferrer = tw && tw.root ? 'yandex_direct_organic' : 'yandex_organic_seo';
		referrerToSetInfo = createReferrerToSetInfo(yandexOrganicReferrer, undefined, 180);
	}

	// if cookie saved with old channels format tag=yandex_direct, mrk=brand -> change it to *_brand channel
	if((isBrandTraffic || isOrganicTraffic || !referrerToSetInfo) && isSavedMarkerBrand){
		switch(cookieReferrerInfo.tag){
			case 'yandex_direct'  :
				forceChannelRewrite = true;
				referrerToSetInfo = createReferrerToSetInfo('yandex_direct_brand', cookieReferrerInfo.marker, 180);
				break;
			case 'google_adwords' :
				forceChannelRewrite = true;
				referrerToSetInfo = createReferrerToSetInfo('google_adwords_brand', cookieReferrerInfo.marker, 180);
				break;
			default : break;
		}
	}


	if(justRead && justRead === true && referrerToSetInfo){
		return referrerToSetInfo;
	}

	if (referrerToSetInfo) {
		var noBrandToBrandTransition = false; // exception: don't rewrite noBrand referrer by brand
		var isContextTraffic = isGoogleAdwords || isYandexDirect;
		var cookieRefTag = cookieReferrerInfo.tag;

		if (cookieRefTag) {
			var cookieRefIsNoBrand =
				(~cookieRefTag.indexOf('google_adwords') || ~cookieRefTag.indexOf('yandex_direct'))
				&& !~cookieRefTag.indexOf('brand')
				&& !~cookieRefTag.indexOf('organic');
			noBrandToBrandTransition = cookieRefIsNoBrand && isContextTraffic && isBrandTraffic;

		}

		var isNoBrandContextTraffic = !isBrandTraffic && !isOrganicTraffic;
		if ((!cookieRefTag || isAffiliatePartner || forceChannelRewrite || isContextTraffic || isNoBrandContextTraffic)
			&& !noBrandToBrandTransition) {
			saveReferrerInfo(referrerToSetInfo.referrer, referrerToSetInfo.marker, referrerToSetInfo.ttl);
		}
		else{
			saveHistory(referrerToSetInfo.referrer);
		}
	}

	//for welcome screen
	if(!isBrandTraffic && !isOrganicTraffic && (isYandexDirect || showWS) ) {
		tw.showWS = true;
	}

	// hide welcome popup if user opened site from yandex or google ads
	var referrerTag = cookieReferrerInfo.tag;
	var isSearchEngine = ~referrerTag.indexOf('yandex_direct') || ~referrerTag.indexOf('google_adwords');
	var userFromAdvertising = isSearchEngine && !~referrerTag.indexOf('organic');

	if (userFromAdvertising) {
		tw.showWS = false;
	}
}

// setting initial referrer, to save if customer visited direct site first time
// then gone to meta/other channel
function setFirstTimeReferrerHistory(){
	// Логика работы с реферерами переезжает на backend
	// фронт может только читать данные, изменять нельзя
	// PM-475
	return false;

	if (tw.params.scp) {
		return;
	}

	var fullhash = decodeURI(document.location.hash).substr(1).split('|');
	var parsedHash = {};

	if(fullhash.length > 1){
		for (var HashInd = 3, HashL = fullhash.length; HashInd < HashL; HashInd++) {
			var curHash = fullhash[HashInd];
			var hashStr = curHash.split("=");
			parsedHash[hashStr[0]] = hashStr[1];
			if(HashInd==HashL-1 && hashStr.length==1 && !parsedHash.marker) {
				parsedHash.marker = hashStr[0];
			}
		}
	}

	if(parsedHash.tag){
		return;
	}

	var referrerInfo = processReferrerVisit(true);

	if(referrerInfo){
		return;
	}

	var referrer_hist = readCookie('referrer_hist');
	var referrer = readCookie('referrer');
	var referrer_first = readCookie('referrer_first');

	if (!referrer_hist) {
		if (referrer) {
			referrer_first = referrer;
			referrer_hist = referrer;
		}	else {
			referrer_hist = 'dir';
			referrer_first = 'dir';
		}

		setCookie({
			name: 'referrer_hist',
			value: referrer_hist,
			days: 180
		});
	}
}

function saveReferrerInfo(tag, marker, days, domain){
	// Логика работы с реферерами переезжает на backend
	// фронт может только читать данные, изменять нельзя
	// PM-475
	return false;

	if (tw.params.scp) {
		return;
	}

	if (!tag) {
		return;
	}

	var metaDays = 1;

	if (tag === 'aviasales' || tag === 'aviasales_cu') {
		metaDays = 180;  // Peter said
	} else if (tag === 'skyscanner' || tag === 'skyscanner_cu') {
		metaDays = 10;
	} else if (tag === 'kayak') { // Mamonov said
		metaDays = 30;
	} else if (tag === 'criteo') {
		metaDays = 14;
	} else if (tag === 'affiliate') {
		metaDays = 60;
	} else if (tag === '12trip_email_ru') {
		metaDays = 14;
	} else if (days !== undefined) {
		metaDays = days;
	}

	// set it everytime we call this method

	setCookie({
		name: 'source',
		value: tag
	});
	if (domain) {
		setCookie({
			name: 'referrer',
			value: tag,
			days: metaDays,
			domain: domain
		});
	} else {
		setCookie({
			name: 'referrer',
			value: tag,
			days: metaDays
		});
	}

	//4criteo
	var expireDate = new Date();
	expireDate.setTime(expireDate.getTime() + (24 * 60 * 60 * 1000));
	setCookie({
		name: 'cr-expire',
		value: expireDate.getTime(),
		days: 30
	});


	// if we don't have marker, delete it, otherwise override
	if(!marker){
		deleteCookie({
			name:'referrer_mrk'
		});
	} else {
		setCookie({
			name: 'referrer_mrk',
			value: marker,
			days: metaDays
		});
	}

	// set it only once when it's not present, do not update
	var referrer_first = readCookie('referrer_first');

	if(!referrer_first){
		setCookie({
			name: 'referrer_first',
			value: tag,
			days: 180
		});
	}

	saveHistory(tag);
}

function saveHistory(tag){
	// Логика работы с реферерами переезжает на backend
	// фронт может только читать данные, изменять нельзя
	// PM-475
	return false;

	if (tw.params.scp) {
		return;
	}

	// save history of tags in case if it's different this time from last time
	var referrer_hist = readCookie('referrer_hist');

	if(!referrer_hist){
		referrer_hist = [];
	} else {
		referrer_hist = referrer_hist.split('|');
	}

	if(referrer_hist[0] != tag){
		referrer_hist.unshift(tag);
	}

	if(referrer_hist.length > 20){
		referrer_hist = referrer_hist.slice(0, 20);
	}

	setCookie({
		name: 'referrer_hist',
		value: referrer_hist.join('|'),
		days: 180
	});

}

function readReferrerInfo() {
	var referrer = readCookie('referrer') || '';
	if (~referrer.indexOf('|')) {
		var referrerParts = referrer.split('|');
		return {
			tag:    referrerParts[0],
			marker: referrerParts[2]
		};
	} else {
		return {
			tag:     referrer,
			marker:  readCookie('referrer_mrk'),
			history: readCookie('referrer_hist')
		};
	}
}

function checkSrcMarker2() {
	// Логика работы с реферерами переезжает на backend
	// фронт может только читать данные, изменять нельзя
	// PM-475
	return false;

	var markerName = 'srcmarker2';
	var markerExpName = 'srcmarker2_exp';
	var params = getURLParams() || {};
	var markerValue = params[markerName];
	if (markerValue) {
		setCookie({
			name: markerName,
			value: markerValue,
			days: params[markerExpName] || 14,
		});
	}
}

function runCookieMethods() {
	// Логика работы с реферерами переезжает на backend
	// фронт может только читать данные, изменять нельзя
	// PM-475
	return false;
	
	setFirstTimeReferrerHistory();
	checkSrcMarker2();

	//inform seo project in case of moving processReferrerVisit

	// moved from common.js
	// var referrerToUse = document.referrer || 'empty';

	// if(!readCookie("src_ref")){
	// 	setCookie({
	// 		name: "src_ref",
	// 		value: referrerToUse,
	// 		days: 60
	// 	});
	// }

	// if(!readCookie("session_ref") || readCookie("session_ref") === 'empty'){
	// 	setCookie({
	// 		name: "session_ref",
	// 		value: referrerToUse
	// 	});
	// }
}

/**
 * previous version of this file with history and annotations is moved to global.bak.js
 * */

(function(win){

	var itemIsMirrored =  {};

	var prevItems =       {};
	var nextItems =       {};

	var changedIdsList =  [];
	var changedIdsMap =   {};

	var timeoutId =       null;
	var timeoutDelay =    2000;

	var localStorage =    win.localStorage;

	var updateLocalStorage = function(){
//		console.warn('updateLocalStorage', changedIdsList);
		var i = changedIdsList.length;
		var id;
		var next;
		while (i--) {
			id = changedIdsList[i];
			next = nextItems[id];
			if (next === undefined || next === null) {
				//console.warn('\tremoveItem\t', id, next);
				localStorage.removeItem(id);
				prevItems[id] = null;
			} else if (next !== prevItems[id]) {
				//console.warn('\tsetItem\t\t', id, next);
				localStorage.setItem(id, prevItems[id] = next);
			}
		}
		changedIdsList = [];
		changedIdsMap  = {};
	};

	var addChangeIdAndUpdateTimeout = function(id){
		if (!changedIdsMap[id]) {
			changedIdsList[changedIdsList.length] = id;
			changedIdsMap[id] = true;
		}
		clearTimeout(timeoutId);
		timeoutId = setTimeout(updateLocalStorage, timeoutDelay);
	};

	win.storage = {
		getItem: function(id) {
			if (itemIsMirrored[id]) {
				//console.warn('\t--getItem 1\t\t', id);
				return nextItems[id];
		 	} else {
				//console.warn('\t--getItem 2\t\t', id);
				itemIsMirrored[id] = true;
				return nextItems[id] = localStorage.getItem(id);
			}
		},
		setItem: function(id, val) {
			var type = typeof val;
			if (null === val) {
				val = val + '';
			} else if (type === 'undefined') {
				throw "TypeError: Failed to execute 'setItem' on 'Storage': 2 arguments required, but only 1 present.";
			} else if (type === 'number') {
				val = val + '';
			} else if (type === 'object') {
				val = val.toString();
			}
			nextItems[id] = val;
			itemIsMirrored[id] = true;
			//console.warn('\t--setItem\t\t', id, val);
			addChangeIdAndUpdateTimeout(id);
		},
		removeItem: function(id) {
			nextItems[id] = null;
			itemIsMirrored[id] = true;
			//console.warn('\t--removeItem\t\t', id);
			addChangeIdAndUpdateTimeout(id);
		},
		clear: function() {
			console.warn('\t--clear\t\t');
			var i = localStorage.length;
			while (i--) {
				this.removeItem(localStorage.key(i));
			}
		}
	}

})(this);

function twdevdisplay(params, type){
	if(localStorage && localStorage.twdev){
		try{
			var twdev = JSON.parse(localStorage.twdev);
			if(type && twdev){
				twdev = twdev[type];
			}
			for(var i in twdev){
				params[i] = twdev[i];
			}
			if(!twdev){
				return;
			}
			var twdevwin = window.document.getElementById('twdev');
			if(!twdevwin){
				twdevwin = window.document.createElement('div');
				twdevwin.id = 'twdev';
				twdevwin.style.position = 'fixed';
				twdevwin.style.top = '3px';
				twdevwin.style.right = '3px';
				twdevwin.style.width = '150px';
				twdevwin.style.opacity = '0.65';
				twdevwin.style.color = '#fff';
				twdevwin.style.backgroundColor = '#f00';
				twdevwin.style.borderRadius = '5px';
				twdevwin.style.padding = '5px';
				twdevwin.style.border = '2px solid';
				twdevwin.style.zIndex = '1000';
				twdevwin.style.wordWrap = "break-word";
				window.document.body.appendChild(twdevwin);
			}
			var twText = '';
			twText = 'localStorage:\n';
			twText += '>twdev[' + type + ']:\n';
			twText += '>' + JSON.stringify(twdev);
			if(twdevwin.textContent != undefined){
				twdevwin.textContent = twText;
			}
			else{
				twdevwin.innerText = twText;
			}
		}catch(e){}
	}
}

//OTT-5703
/*if (!~window.location.href.indexOf('optimizely_editor=true')) {
 try { top.location.toString(); } catch (er) { top.location = location; }
 }*/

window.tw = window.tw || {};

if (!tw.language) {
	tw.language = 'ru';
}

// Disable set accept_language cookie in hotel form
tw.disableSetAcceptLang = true;

tw.params = getURLParams();
tw.hashParams = getHashParams();
tw.refData = tw.refData || {};
tw.deferred = {};

if(parseFloat($().jquery) <1.7){
	/*WebKit issues with event.layerX and event.layerY*/
	$.event.props = $.event.props.join('|').replace('layerX|layerY|', '').split('|');
}

function log(data){ if (window.console) {console.log(data);}}
function warn(data){ if (window.console) {console.warn(data);}}
function error(data){ if (window.console) {console.error(data);}}

function inherits(Child, Parent){
	var F = function(){};
	F.prototype = Parent.prototype;
	Child.prototype = new F();
	Child.prototype.constructor = Child;
	Child.parent = Parent.prototype;
}

$.fn.trim = function(){
	var html = $(this).html();

	if (html) {
		return html.replace(/\n\t\s*/g,"").replace(/^\s*/, "").replace(/\s{2,}/g, " ").replace(/> </g, "><");
	} else {
		return '';
	}
};

function trim(text) { return (text || '').replace(/^\s+|\s+$/g, ''); }
var _ua = navigator.userAgent.toLowerCase();
var browser = {
	version: (_ua.match( /.+(?:me|ox|on|rv|it|era|opr|ie)[\/: ]([\d.]+)/ ) || [0,'0'])[1],
	opera: (/opera/i.test(_ua) || /opr/i.test(_ua)),
	msie: (/msie/i.test(_ua) && !/opera/i.test(_ua) || /trident\//i.test(_ua)) || /edge/i.test(_ua),
	msie9: (/msie 9/i.test(_ua) && !/opera/i.test(_ua)),
	mozilla: /firefox/i.test(_ua),
	chrome: /chrome/i.test(_ua) && !/edge/i.test(_ua),
	safari: (!(/chrome/i.test(_ua)) && /webkit|safari|khtml/i.test(_ua)),
	iphone: /iphone/i.test(_ua),
	ipad: /ipad/i.test(_ua),
	mobile: /midp|blackberry|netfront|nokia|panasonic|portalmmm|sharp|sie-|sonyericsson|symbian|windows ce|benq|mda|mot-|opera mini|opera mobi|iemobile|philips|pocket pc|sagem|samsung|sda|sgh-|vodafone|xda|palm|iphone|ipod|ipad|android/i.test(_ua),
	mac: /mac/i.test(_ua)
};

if (/msie (\d+\.\d+);/.test(_ua)) var IEVersion = new Number(RegExp.$1);
if (/gecko\//.test(_ua)) { var TempArr = _ua.match(/rv:(\d+)\.(\d+)(?:\.(\d+))?/);	if(TempArr){ var GeckoVersion = parseFloat(TempArr[1] + "." + TempArr.slice(2).join(''));} else {var GeckoVersion = 1.9}; TempArr = null;};
if (/applewebkit\/(\d+\.\d+?)/.test(_ua)) var WebKitVersion = new Number(RegExp.$1);
if (/opera[\/\s](\d+\.\d+)/.test(_ua)) var OperaVersion = opera.version();
if (/firefox[\/\s](\d+\.\d+)/.test(_ua)) var FirefoxVersion = new Number(RegExp.$1);
if (IEVersion < 9 || !JSON || GeckoVersion < 1.91 || WebKitVersion < 528.18 || FirefoxVersion < 3.5 || OperaVersion < 11.5) {
	location.href = '/misfortune/';
}

var rootre = /\/(ru|uk|en|de|az|ch|at|tr|br|tr|es)(\-[a-z]{2})?\/$/i;
var flightsre = /^\/(.*?)([A-Z]{3}\-[A-Z]{3})(.*)$/i;
var path = window.document.location.pathname;

// 2nd condition due to seo search page
tw.root = rootre.test(path) || (flightsre.test(path) && !!location.hash);

tw.campaign = readCookie("campaign") || false;
if (tw.params.adwords) {
	tw.campaign = '-GoogleAdwords-' + tw.params.adwords;
}
if (tw.params.utm_campaign && tw.params.utm_source && tw.params.utm_source == 'Direct') {
	tw.campaign = '-YandexDirect-' + tw.params.utm_campaign;
}
if (tw.campaign) {
	setCookie({
		name: "campaign",
		value: tw.campaign
	});
}
var _kmq = _kmq || [];
var _gaq = _gaq || [];

(function() {
	jQuery.support.placeholder = false;
	test = document.createElement('input');
	if('placeholder' in test) jQuery.support.placeholder = true;
})();

function getRandomArbitary(min, max){
	return Math.random() * (max - min) + min;
}

function getRandomInt(min, max){
	return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getURLParams() {
	var arrParams = (decodeURIComponent(document.location.search)).substr(1).split('&');
	return getObjParams(arrParams);
}

function getHashParams() {
	var arrParams = decodeURIComponent(document.location.hash).split('?');
	if(arrParams[1]) {
		arrParams = arrParams[1].split('&');
	} else {
		arrParams = [];
	}
	return getObjParams(arrParams);
}

function updateHash(parameters) {
	var hashParams = tw.hashParams = getHashParams();
	$.extend(hashParams, parameters);
	var url = [];
	for (var key in hashParams) {
		if (hashParams.hasOwnProperty(key)) {
			url.push(key + "=" + hashParams[key]);
		}
	}
	document.location.hash = document.location.hash.replace(/(#)?(.*)/i, "$2").split('?')[0] + "?" + url.join('&');
}

function getObjParams(arrParams) {
	var objParams = {};
	var p1, p2;
	for(var i = 0, length = arrParams.length; i < length; i++) {
		var currentParam = arrParams[i];
		if(currentParam !== "") {
			var equalIndex = currentParam.indexOf('=');
			if(equalIndex === -1 ) {
				p1 = currentParam.substring(0, currentParam.length );
				p2 = null;
			} else {
				p1 = currentParam.substring(0, equalIndex );
				p2 = currentParam.substring(equalIndex+1, currentParam.length );
			}
			objParams[p1] = p2 === null ? true : p2;
		}
	}
	return objParams;
}

function parseURL(url) {
	var expr = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
	return expr.exec(document.referrer);
}

function abortAjax(arrAjax) {
	try {
		for (oRequest in arrAjax) {
			if (arrAjax[oRequest].readyState !== 0 && arrAjax[oRequest].readyState != 4) arrAjax[oRequest].abort();
		}
	} catch (e) {}
}

function clearAjax(arrAjax) {
	try {
		for (oRequest in arrAjax) {
			if (arrAjax[oRequest].readyState === 0 || arrAjax[oRequest].readyState == 4)  delete arrAjax[oRequest];
		}
	} catch (e) {}
}

function checkAjaxError(xhr, options, errorMessage){
	if(xhr.status == 404) {
		addPopup({
			error: true,
			reason: l10n.popup.warning,
			comment: l10n.popup.serverText,
			close_button: true,
			button: l10n.popup.close,
			removeOnAction: true
		});
		try {options.ErrorFunction()} catch (e) {}
	}

	if (xhr.readyState === 4 && xhr.status < 500 && xhr.statusText !== 'parsererror' && errorMessage !== 'parsererror') {
		return;
	}

	options = options || {};
	xhr.url = xhr.url || '';
	options.retryTime = options.retryTime || 5000;
	options.RetryFunction = options.RetryFunction || function (){};

	if (options.repeats > 0) {
		options.repeats--;
		setTimeout(options.RetryFunction, options.retryTime);
	} else {
		if (xhr.readyState == 4) {
			switch (xhr.status) {
				//case 502:
				case 0:// no connection
					addPopup({
						error: true,
						reason: l10n.popup.noConnection,
						comment: l10n.popup.noConnectionComment,
						close_button: true,
						button: l10n.popup.close,
						removeOnAction: true
					});
					break;
				default://something wrong on server + timeout,504,404 etc
					if(!options.simpleRequest){
						addPopup({
							error: true,
							reason: l10n.popup.warning,
							comment: l10n.popup.serverText,
							close_button: true,
							button: l10n.popup.close,
							removeOnAction: true
						});
					}
					break;
			}
		} else {
			if (xhr.status === 0) {//setup timeout
				if (!options.simpleRequest) {
					addPopup({
						error: true,
						reason: l10n.popup.noConnection,
						comment: l10n.popup.noConnectionComment,
						close_button: true,
						button: l10n.popup.close,
						removeOnAction: true
					});
				}

				kmqRecord({
					name: 'ERROR_TIMEOUT',
					url: xhr.url,
					text: xhr.status + '  ajax setup timeout'
				});

			} else {//worstscenario
				if (options.backupRepeats) {
					options.repeats = 1;
					options.backupRepeats = false;
					setTimeout(function(){
						try {
							options.RetryFunction();
						}
						catch (e) {
						}
					}, options.retryTime);
				} else {
					if (!options.simpleRequest) {
						addPopup({
							error: true,
							reason: l10n.popup.warning,
							comment: l10n.popup.serverText,
							close_button: true,
							button: l10n.popup.close,
							removeOnAction: true
						});
					}
				}
			}
		}
		if (!options.repeats || options.repeats < 1) {
			try {
				options.ErrorFunction();
			}
			catch (e) {
			}
		}
	}
}


String.prototype.replaceByArray = function(arr){
	var str = this.valueOf();
	for(var i =0, AL = arr.length; i< AL; i++) {
		if (arr[i] instanceof Date) {
			str = str.replace(new RegExp('\\{'+i+'\\(([^\\}]+)\\)\\}', 'g'), function(substr){
				return arr[i].format1(substr.match(/\((.+)\)/)[1]);
			})
		} else {
			str = str.replace('{'+i+'}', arr[i]);
		}
	}
	return str;
};


String.prototype.replaceByHash = function(obj){
	var str = this.valueOf();
	for(var i in obj) {
		if (obj[i] instanceof Date) {
			str = str.replace(new RegExp('\\{'+i+'\\(([^\\}]+)\\)\\}', 'g'), function(substr){
				return obj[i].format1(substr.match(/\((.+)\)/)[1]);
			})
		} else {
			str = str.replace(new RegExp('{'+i+'}','g'),obj[i]);
		}
	}
	return str;
};

String.prototype.replaceBy = function(obj){
	if(obj instanceof Array) {
		return this.replaceByArray(obj);
	} else {
		return this.replaceByHash(obj);
	}
};

function capitalize(s) {
	return s && s[0].toUpperCase() + s.slice(1);
}

function getCurrentSegment() {
	var segment = readCookie('referrer');
	var marker = readCookie('referrer_mrk');
	switch(segment) {
		case "skyscanner":
		case "skyscanner_cu":
			return 1;
			break;
		case "aviasales":
		case "aviasales_cu":
			return 2;
			break;
		case "yandex_direct":
			return 3;
			break;
		case "google_adwords":
			return 4;
			break;
		case "yandex":
			return 5;
			break;
		case "momondo":
			return 6;
			break;
		case "criteo":
			switch(marker) {
				case "skyscanner":
				case "skyscanner_cu":
					return 11;
					break;
				case "aviasales":
				case "aviasales_cu":
					return 12;
					break;
				case "yandex_direct":
					return 13;
					break;
				case "google_adwords":
					return 14;
					break;
				case "yandex":
					return 15;
					break;
				case "momondo":
					return 16;
					break;
				default:
					return 0;
					break;
			}
			break;
		default:
			return 0;
			break;
	}
}

(function (win) {
	var w = win;
	var h = win.history;
	var d = w.document;
	var l = d.location;

	//набор разрешённых гет параметров
	var permittedParams = ["test", "srcmarker", "p", "s"];

	w.getParamsFromArray = function (arrParams) {
		var objParams = {};
		var pair;
		for (var i = 0, length = arrParams.length; i < length; i++) {
			var currentParam = arrParams[i];
			if (currentParam !== "") {
				if (~currentParam.indexOf('=')) {
					pair = currentParam.split('=');
					objParams[pair[0]] = pair[1];
				} else {
					objParams[currentParam] = true;
				}
			}
		}
		return objParams;
	};

	w.getParamsByUrl = function () {
		var arrParams = (decodeURI(encodeURI(l.search))).substr(1).split('&');
		return w.getParamsFromArray(arrParams);
	};

	w.getParamsByHash = function () {
		var arrParams = decodeURI(encodeURI(document.location.hash)).split('?');
		if (arrParams[1]) {
			arrParams = arrParams[1].split('&');
		} else {
			arrParams = [];
		}
		return w.getParamsFromArray(arrParams);
	};

	w.getHash = function (parameters) {
		var hashParams = w.getParamsByHash();
		hashParams = $.extend(hashParams, parameters);
		var url = [];
		for (var key in hashParams) {
			if (hashParams.hasOwnProperty(key)) {
				url.push(key + "=" + hashParams[key]);
			}
		}
		var addParams = "";
		if (url.length) {
			addParams += "?" + url.join('&');
		}
		return l.hash.replace(/(#)?(.*)/i, "$2").split('?')[0] + addParams;
	};

	w.setLocation = function (opt, silent) {
		var options = opt || {};
		var defaultFields = {
			"url": l.pathname,
			"hash": "",
			"title": d.title
		};
		options = $.extend(defaultFields, options);
		var href = options.url + options.hash;

		if (silent) {
			var updatedParams = [];
			var currentParams = w.getParamsByUrl();
			for (var i in currentParams) {
				if (~permittedParams.indexOf(i)) {
					updatedParams.push([i] + '=' + currentParams[i]);
				}
			}
			href = options.url;
			if (updatedParams.length) {
				if(href.indexOf('?') !== -1) { //если мы заменяем path уже с параметрами
					href += "&";
				} else {
					href += "?";
				}
				href += updatedParams.join('&');
			}
			var hash = w.getHash();
			if (hash.length > 1) {
				href += '#' + hash;
			}
			h.replaceState({}, options.title, href);
		} else {
			l.href = href;
		}
	};

	w.replaceLocation = function (opt) {
		if (h && h.replaceState) { //в старых браузерах ничего не реплейсим
			var options = opt || {};
			w.setLocation(options, true);
		}
	};

	w.uglifyUUID = function (uuid) {
		return uuid.replace(/-/g, function () {
			return (Math.random() * 9) | 0;
		})
	};
})(this);

var LOCALSTORAGE_VAR = 'showEasterEgg';
var LOCALSTORAGE_PARAMS_VAR = 'requestParams';

function getRequestParams(forGetParams) {
	var params = (localStorage && localStorage.getItem(LOCALSTORAGE_VAR) && localStorage.getItem(LOCALSTORAGE_PARAMS_VAR)) || '';
	if (!params) {
		return forGetParams ? '' : {};
	}
	if (forGetParams) {
		return params;
	} else {
		var result = {};
		params
			.split('&')
			.forEach(function(param) {
				var keyValue = param.split('=');
				result[keyValue[0]] = keyValue[1];
			});
		return result;
	}
}

function sendCriteoEvents(event) {
	var referrer = readCookie('referrer');
	var allowedSources = [
		'yandex_direct',
		'google_adwords',
		'aviasales',
		'skyscanner',
		'momondo',
		'yandex_meta',
		'biletyplus',
		'kayak'
	];

	if (allowedSources.indexOf(referrer) === -1) {
		return;
	}

	var events = [
		{ event: "setAccount", account: 14621 },
		{ event: "setSiteType", type: 'd' },
		{
			event: "setEmail",
			email: (tw.visitor && tw.visitor.email) ? readCookie('bidh') : "",
		}
	];

	if (event.type === 'index') {
		events.push({ event: "viewHome" });
	} else if (event.type === 'search') {
		var passengers = tw.passengers || {};

		var adultsCount = passengers.adult || 1;
		var childrenCount = passengers.children || 0;
		var infantsCount = passengers.infants || 0;

		var directions = objAvia.parseKey(event.searchRoute).directions;
		var routeType = kmqRouteType(event.searchRoute);

		events.push({
			event: "viewSearch",
			din: directions[0].date.format("yyyy-mm-dd"), //"##YYYY-MM-DD##"
			dout: routeType === "oneway" ? undefined : directions[directions.length - 1].date.format("yyyy-mm-dd"), //"##YYYY-MM-DD##"
			nbra: adultsCount, //##Количество взрослых##
			nbrc: childrenCount, //##Количество детей##
			nbri: infantsCount, //##Количество младенцев##
		});

		var slugData = routeType == "round"
			? [ directions[0].from, directions[0].to, directions[0].from ]
			: [ directions[0].from, directions[directions.length - 1].to ];
		slugData = slugData.filter(function (e) { return !!e });

		events.push({
			event: "viewItem",
			item: slugData, //##Идентификатор полета 1##", ##Идентификатор полета 2##", ##Идентификатор полета 3##"
		});
	}

	try {
		window.criteo_q = window.criteo_q || [];
		window.criteo_q.push.apply(window.criteo_q, events);
	} catch (e) {}
}

$(function() {
	// Show ENV info
	try {
		var CTRL_CODE = 17;
		var ONE_NUMBER_CODE = 49;
		var storageKeys = [];
		var passwordKeys  = [CTRL_CODE, CTRL_CODE, ONE_NUMBER_CODE];
		var keydornCounter = 0;
		var getResponseInfo = null;

		document.addEventListener('keydown', function(e) {
			var keyCode = e.keyCode;

			if (passwordKeys[keydornCounter] === e.keyCode) {
				keydornCounter++;
				storageKeys.push(keyCode);

				if (storageKeys.toString() === passwordKeys.toString()) {
					var alreadyShowed = localStorage && localStorage.getItem(LOCALSTORAGE_VAR);

					if (alreadyShowed) {
						localStorage && localStorage.removeItem(LOCALSTORAGE_VAR);
						removeENVnode();
					} else {
						localStorage && localStorage.setItem(LOCALSTORAGE_VAR, true);
						setENVnode();
					}

					keydornCounter = 0;
					storageKeys = [];
				}
			} else {
				keydornCounter = 0;
				storageKeys = [];
			}
		});

		function removeENVnode() {
			var envidNode = document.getElementById('debug_env_id');

			if (envidNode) {
				envidNode.parentNode.removeChild(envidNode);
			}
		}

		function setENVnode() {
			if (localStorage && localStorage.getItem(LOCALSTORAGE_VAR)) {
				var createRowNode = function(title, content) {
					var node = document.createElement('div');
					var titleNode = document.createElement('span');

					node.className = 'info_row';
					titleNode.className = 'info_row_title';

					titleNode.innerHTML = title + ': ';

					node.appendChild(titleNode);
					node.appendChild(document.createTextNode(content));

					return node;
				};

				var createInputNode = function(title) {
					var node = document.createElement('div');
					var titleNode = document.createElement('span');
					var inputNode = document.createElement('input');

					node.className = 'info_row';
					titleNode.className = 'info_row_title';

					titleNode.innerHTML = title + ': ';

					inputNode.value = localStorage.getItem(LOCALSTORAGE_PARAMS_VAR);

					inputNode.addEventListener('input', function (e) {
						if (localStorage) {
							localStorage.setItem(LOCALSTORAGE_PARAMS_VAR, inputNode.value);
						}
					}, false);

					node.appendChild(titleNode);
					node.appendChild(inputNode);
					return node;
				};

				function createContent(data) {
					try {
						Object.keys(data).forEach(function(paramKey) {
							wrapNode.appendChild(createRowNode(paramKey, data[paramKey]));
						});

						wrapNode.appendChild(createInputNode('params'));

						document.body.appendChild(wrapNode);
					} catch (err) {
						console.error('EASTER EGG: ', err);
					}
				}

				var wrapNode = document.createElement('div');

				wrapNode.id = 'debug_env_id';

				if (!getResponseInfo) {
					$.ajax({
						type: 'GET',
						url: '/_api/system/info2',
						data: {},
						success: function(data) {
							createContent(data)
						}
					})
				}
			}
		}
		setENVnode();
	} catch(e) {
		console.log('SHOW ENVID ->', e);
	}
});

window.banners = {
	profileTop: {
		containerId: 'div-gpt-ad-1537991310974-0',
		bannerId: '/21734590017/Personal_cabinet_long',
		size: [867, 100],
	},
	profileMiddle: {
		containerId: 'div-gpt-ad-1548408736569-0',
		bannerId: '/21734590017/Personal_Cabinet_long_middle',
		size: [865, 100],
	},
	profileSideSquare: {
		containerId: 'div-gpt-ad-1548408889144-0',
		bannerId: '/21734590017/Personal_Cabinet_square',
		size: [
			[200, 200],
			[200, 446],
			[195, 210],
		],
	},
};

/**
 * Created by vlad on 16/03/16.
 */

(function (root, factory) {
	if (typeof module === 'object' && module.exports) {
		module.exports = factory();
	} else {
		root.showCookiePolicyAlert = factory();
	}
})(window, factory);

function factory() {
	return function showCookiePolicyAlert() {
		function createCss() {
			var style = document.createElement('style');
			style.textContent = '.ottCookiePolicyAlert {  position: relative;  padding: 10px;  background: #222;  text-align: center;  line-height: 2;  font-size: 13px; }\n.ottCookiePolicyAlert__btnWrapper {  display: inline-block;  margin-left: 16px; }\n.ottCookiePolicyAlert__text {  color: #bebebe; }\n.ottCookiePolicyAlert__acceptBtn {  padding: 6px 14px;  margin-right: 16px;  background: #2B88D4;  color: white;  -webkit-border-radius: 5px;  -moz-border-radius: 5px;  border-radius: 5px;  text-transform: uppercase;  line-height: normal;  -webkit-transition: 150ms background;  -moz-transition: 150ms background;  -ms-transition: 150ms background;  -o-transition: 150ms background;  transition: 150ms background; }\n.ottCookiePolicyAlert__acceptBtn:hover {  background: #55a0dd; }\n.ottCookiePolicyAlert__moreLink {  color: #2B88D4; }\n.ottCookiePolicyAlert__moreLink:hover {  color: #55a0dd; }\n@media screen and (max-width: 768px), screen and (max-width: 768px) and (orientation: landscape) { .ottCookiePolicyAlert {display: none} }\n';
			document.head.appendChild(style);
		}

		var cookies = {
			getCookie: function (name) {
				var matches = document.cookie.match(new RegExp(
					'(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
				));
				return matches ? decodeURIComponent(matches[1]) : undefined;
			},
			setCookie: function (options) {
				if (!options || options.name == null || options.value == null) {
					return;
				}
				var str = options.name + '=' + encodeURIComponent(options.value);
				if (options.days) {
					var date = new Date();
					date.setTime(date.getTime() + (options.days * 24 * 60 * 60 * 1000));
					str += '; expires=' + date.toGMTString();
				}

				str = str + ';path=' + (options.path || '/');

				if (!options.domain && window.location.hostname.indexOf("onetwotrip.com") > -1) {
					options.domain = "onetwotrip.com";
				}
				if (options.domain) {
					str += ';domain=' + options.domain;
				}
				if (options.secure) {
					str += ';secure';
				}
				document.cookie = str;
				if (options.xdm && window.location.hostname.indexOf("onetwotrip.com") == -1) {
					this.setPMCookie(options);
				}
			},
			deleteCookie: function (options) {
				if (!options || !options.name) {
					return;
				}
				if (!options.domain && window.location.hostname.indexOf("onetwotrip.com") > -1) {
					options.domain = "onetwotrip.com";
				}

				var str = [
					options.name, "=",
					";expires=Thu, 01-Jan-1970 00:00:01 GMT",
					';path=', options.path || '/'
				].join('');

				if (options.domain) {
					str += ';domain=' + options.domain;
				}
				document.cookie = str;
			},
			setPMCookie: function (options) {
				iframe = document.getElementById('pm');
				if (!iframe) return;
				iframe.contentWindow.postMessage({
					type: 'cookie',
					options: options
				}, iframe.src);
			}
		};

		function template(data, url) {
			return '<div class="ottCookiePolicyAlert" id="cookie-policy-alert">' +
				'<span class="ottCookiePolicyAlert__text">' + data.text + '</span>' +
				'<div class="ottCookiePolicyAlert__btnWrapper">' +
				'<button class="ottCookiePolicyAlert__acceptBtn" id="accept-cookie" type="button">' + data.btnText + '</button>' +
				'<a href="' + url + '" class="ottCookiePolicyAlert__moreLink" target="_blank">' + data.moreLinkText + '</a>' +
				'</div>' +
				'</div>';
		}

		function showCookieAlert() {
			var locales = {
				'en-gb': true,
				'en-us': true,
				'en-ie': true,
				'ru': true,
				'ru-kz': true,
				'ru-ua': true,
				'es': true,
				'de': true,
				'uk-ua': true,
				'pl': true,
			};

			var urls = {
				'en-gb': 'https://support.onetwotrip.com/hc/en-gb/articles/208028745-Cookies-Policy',
				'en-us': 'https://support.onetwotrip.com/hc/en-us/articles/208028745-Cookies-Policy',
				'en-ie': 'https://support.onetwotrip.com/hc/en-ie/articles/208028745-Cookies-Policy',
				'ru': 'https://support.onetwotrip.com/hc/ru/articles/208028745-%D0%9F%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0-%D0%B8%D1%81%D0%BF%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F-cookie-%D1%84%D0%B0%D0%B9%D0%BB%D0%BE%D0%B2',
				'ru-kz': 'https://support.onetwotrip.com/hc/ru/articles/208028745-%D0%9F%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0-%D0%B8%D1%81%D0%BF%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F-cookie-%D1%84%D0%B0%D0%B9%D0%BB%D0%BE%D0%B2',
				'ru-ua': 'https://support.onetwotrip.com/hc/ru/articles/208028745-%D0%9F%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0-%D0%B8%D1%81%D0%BF%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F-cookie-%D1%84%D0%B0%D0%B9%D0%BB%D0%BE%D0%B2',
				'es': 'https://support.onetwotrip.com/hc/es/articles/208028755-Pol%C3%ADtica-de-Cookies',
				'de': 'https://support.onetwotrip.com/hc/de/articles/208028745-Richtlinien-zur-Verwendung-von-Cookies',
				'uk-ua': "https://support.onetwotrip.com/hc/uk/articles/208028745-%D0%9F%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0-%D0%B8%D1%81%D0%BF%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F-cookie-%D1%84%D0%B0%D0%B9%D0%BB%D0%BE%D0%B2",
				'pl': 'https://support.onetwotrip.com/hc/en-gb/articles/208028745-Cookies-Policy',
			};

			if (!locales[tw.language]) {
				return false;
			}

			createCss();
			document.body.insertAdjacentHTML('afterbegin', template(l10n.cookiePolicy, urls[tw.language]));

			var acceptBtn = document.getElementById('accept-cookie');
			var cookieAlertBlock = document.getElementById('cookie-policy-alert');

			acceptBtn.addEventListener('click', function () {
				cookies.setCookie({
					name: 'cookiePolicyHasAccepted',
					value: true,
					days: 30
				});

				cookies.deleteCookie({name: 'cookiePolicyBannerLastPage'});

				hide(cookieAlertBlock, 5, function () {
					this.parentNode.removeChild(this)
				});
			}, false);


			function hide(el, duration, callback) {
				var elStyles = window.getComputedStyle(el);
				var height = parseInt(elStyles.height, 10);
				var padding = parseInt(elStyles.padding, 10);
				var opacity = parseInt(elStyles.opacity, 10);

				var animateId = setInterval(frame, duration);

				function frame() {
					if (height) {
						if (opacity > 0) {
							opacity = (opacity * 10 - .06 * 10) / 10;
							el.style.opacity = opacity;
						}

						padding--;
						height--;

						el.style.padding = padding + 'px';
						el.style.height = height + 'px';
					} else {
						clearInterval(animateId);
						callback.apply(el);
					}
				}
			}
		}

		var cookieHasAccepted = cookies.getCookie('cookiePolicyHasAccepted');
		var isNativeApp = ~location.search.indexOf('view=app');

		// если нет куки о согласии использовании кук
		if (!cookieHasAccepted && !isNativeApp) {
			var LOCALE_PATH = tw.language + '/';
			var currentLocation = window.location.pathname.replace(LOCALE_PATH, '');

			// проверяем куку lastPageCookie, которая выставляется при переходе на любую страницу сайта
			var lastPageCookie = cookies.getCookie('cookiePolicyBannerLastPage');

			/**
			 * Если кука отличается от текущего адреса баннер не показываем,
			 * удаляем куку и ставим cookiePolicyHasAccepted в true
			 */
			if (lastPageCookie && lastPageCookie !== currentLocation) {
				cookies.deleteCookie({name: 'cookiePolicyBannerLastPage'});
				cookies.setCookie({
					name: 'cookiePolicyHasAccepted',
					value: true,
					days: 1
				});
			} else {
				//   показываем баннер и создаем куку с текущим адресом
				showCookieAlert();
				cookies.setCookie({
					name: 'cookiePolicyBannerLastPage',
					value: currentLocation,
					days: 30
				});
			}
		}
	}
}

document.addEventListener('DOMContentLoaded', function () {
	try {
		window.showCookiePolicyAlert();
	} catch (error) {
		console.warn('Cookie Policy error:', error);
	}
});

"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @typedef {Object} ValidationResult
 * @property {boolean} res - Validation result
 * @property {ValidationStatus[]} err - Array of validation errors
 */

/**
 * Enum for password validate method
 * @readonly
 * @enum {number}
 */
var ValidationStatus = {
	/**
	 * Password is valid
	 * @type {number}
	 */
	OK: 0,
	/**
	 * Password is too short
	 * @type {number}
	 */
	ERROR_SHORT: 1,
	/**
	 * Password has no lower case chars
	 * @type {number}
	 */
	ERROR_NO_LOW: 2,
	/**
	 * Password has no upper case chars
	 * @type {number}
	 */
	ERROR_NO_UPPER: 3,
	/**
	 * Password has no digits
	 * @type {number}
	 */
	ERROR_NO_DIGIT: 4
};

/**
 * Password validator
 */

var PasswordValidator = function () {
	function PasswordValidator() {
		_classCallCheck(this, PasswordValidator);
	}

	/**
	 * Check if password longer than 8 chars and has at least 1 upper char, 1 lower and 1 digit
	 * @param {String} password
	 * @return {ValidationResult}
	 */
	PasswordValidator.validate = function validate(password) {
		var err = [];

		if (password.length < 8) {
			err.push(ValidationStatus.ERROR_SHORT);
		}
		if (password.toLocaleUpperCase() === password) {
			err.push(ValidationStatus.ERROR_NO_LOW);
		}
		if (password.toLocaleLowerCase() === password) {
			err.push(ValidationStatus.ERROR_NO_UPPER);
		}
		if (!/\d/.test(password)) {
			err.push(ValidationStatus.ERROR_NO_DIGIT);
		}

		return err.length > 0 ? { res: false, err: err } : { res: true, err: [ValidationStatus.OK] };
	};

	return PasswordValidator;
}();

window.PasswordValidator = PasswordValidator;
window.ValidationStatus = ValidationStatus;

tw.region = tw.language.substr(-2).toUpperCase();

tw.partnerName = '';

var mouseEvent;
var infoBaloonHidden = true;
for(var i in l10n.currency) {l10n.currency[i].code = i;}

var appSessionStorage = (function () {
	var storage = {};
	var length = 0;
	var calculateLength = function () {
		var key;
		var len = 0;
		for (key in storage) {
			len += 1;
		}
		return len;
	};
	var storageProxy = {
		getItem: function (key) {
			return storage[key];
		},
		setItem: function (key, value) {
			storage[key] = typeof value === 'object' ? JSON.stringify(value) : String(value);
			this.length = calculateLength();
		},
		removeItem: function (key) {
			delete storage[key];
			this.length = calculateLength();
		},
		length: length
	};
	var randomProp = '___' + Math.random() * 1234 + +(new Date());
	try {
		sessionStorage[randomProp] = randomProp;
		if (sessionStorage[randomProp] === randomProp) {
			storageProxy = sessionStorage;
			delete sessionStorage[randomProp];
		}
	} catch (e) {}
	return storageProxy;
}());

$(document).on('click', '.removePopupButton', function() {
	removePopup();
});

function FormSwitcher() {
	var self = this;
	this.$aviaLink = $('#topMenu_avia');
	this.$trainLink = $('#topMenu_railways');

	this.$aviaLink.click(function(event){
		if(tw.root) {
			self.$aviaLink.addClass('selected');
			if(tw.language != "ru") {
				event.preventDefault();
			}
		}
	});

	if(document.location.pathname.indexOf('railways') !== -1) {
		this.$trainLink.addClass('selected');
	} else {
		this.$aviaLink.click();
	}
}

getCurrentPosition();
function getCurrentPosition(){
	tw.position = false;
	if (navigator.geolocation && 1 == 2) {
		navigator.geolocation.getCurrentPosition(function(position){
			tw.position = {
				lat: position.coords.latitude,
				lng: position.coords.longitude
			};
			$(document).trigger("getPosition");
		}, function(){
			getByIp();
		});
	} else {
		getByIp();
	}

	var requestOptions = {
		repeats: 1,
		simpleRequest: true,
		RetryFunction: function(){
			getByIp();
		},
		ErrorFunction: function(){
		}
	};

	function getByIp(){
		$.ajax({
			cache: false,
			dataType: "json",
			url: "/_api/ipinfo/get/",
			success: function(json){
				tw.ipinfo = json;
				if (json.lat && json.lon) {
					tw.position = {
						lat: json.lat,
						lng: json.lon,
						countryCode: json.countryCode,
						iddCode: json.iddCode,
						region: json.region
					};
					$(document).trigger("getPosition");
					if(document.location.protocol == 'http:' && tw.root) {
						var kmqOpt = {
							Country: 'NoInfo',
							City: 'NoInfo',
							Provider: 'NoInfo',
							domainName: 'NoInfo',
							ip: 'NoInfo',
							mobileBrand: 'NoInfo'
						};
						if(json.countryName && json.countryName.length>1) {kmqOpt.Country = json.countryName;}
						if(json.city && json.city.length>1) {kmqOpt.City = json.city;}
						if(json.ispName && json.ispName.length>1) {kmqOpt.Provider = json.ispName;}
						if(json.domainName && json.domainName.length>1) {kmqOpt.domainName = json.domainName;}
						if(json.ip && json.ip.length>1) {kmqOpt.ip = json.ip;}
						if(json.mobileBrand && json.mobileBrand.length>1) {kmqOpt.mobileBrand = json.mobileBrand;}
						_kmq.push(['set', kmqOpt]);
					}
				}
			},
			complete: function(xhr){
				xhr.url = this.url;
				checkAjaxError(xhr, requestOptions);
			}
		});
	}
}
function getNearCity(){
	var cities = AirportFinder(tw.position.lat, tw.position.lng);
	if (cities) tw.position.nearCityWithAirport = cities[0];
}

function appendLoader(options){
	options = options || {};
	removeLoader();
	tw.metaReturn && tw.metaReturn.reset();
	appendTo = options.appendTo || document.body;
	var elLoader = $.tmpl('<div class="loader" id="loader"><div class="l_background"></div><div class="l_shadow"></div><div class="l_arrows"></div><div class="content">{{html text}}</div></div>', options)[0];
	var elArrows = $('.l_arrows', elLoader)[0];
	if(options.className) $(elLoader).addClass(options.className);
	$(appendTo).append(elLoader);

	if (options.overlayIsVisible) {
		var elOverlay = $.tmpl('<div class="loader-disable-overlay"></div>');
		$('body')
			.addClass('loader-disable-overlay--is-visible')
			.append(elOverlay);
	}

	var pos = 0;
	(function rotate(){
		if (elArrows) {
			pos -= 76;
			if (pos == -684) pos = 0;
			elArrows.style.backgroundPosition = pos + "px";
			setTimeout(rotate, 100);
		}
	})();
}
function removeLoader() {
	$("#loader").remove();
	$("#tw-loader").remove();

	$('.loader-disable-overlay').remove();
	$('body').removeClass('loader-disable-overlay--is-visible')
}

function appendTWLoader(options){
	options = options || {};
	removeLoader();
	appendTo = options.appendTo || document.body;
	options.content = options.content || "";
	$(appendTo).append('<div id="tw-loader"><div id="tw-loader-arrows"></div><div id="tw-loader-content">'+options.content+'</div></div>');
	if (options.className) $("#tw-loader").addClass(options.className);
}

$('input:radio')
	.on('click', function(){
		if (this.form) {
			$(this.form[this.name]).each(function(){
				var radio = this;
				var labels = $.merge($(radio).parent("label"), $('label[for][for="' + radio.id + '"]'));
				if (radio.checked) $(labels).addClass("checked");
				else $(labels).removeClass("checked");
			});
		}
});

$('input:radio')
	.on('focus', function(){
		$.merge($(this).parent("label"), $('label[for][for="' + this.id + '"]')).addClass("focus");
	})
	.on('blur', function(){
		$.merge($(this).parent("label"), $('label[for][for="' + this.id + '"]')).removeClass("focus");
	});

function setLogo(){
	var hours = new Date().getHours();
	if(hours > 20 || hours < 7) {
		$('#logo img').attr('src','/images/logo_night.png');
	}
}

function fadeInBlock(el, callback){
	$(el).removeClass('invisible');
	$(el).fadeIn(300, function(){
		try {callback();} catch (e) {}
	});
}


function fadeOutBlock(el, callback){
	$(el).fadeOut(300, function(){
		try {callback();} catch (e) {}
	});
}


function fadeIn(options){
	options = options || {};
	var div = document.getElementById("fadeBlock");
	if (!div) {
		div = document.createElement('div');
		div.id = "fadeBlock";
		if (options.opacity) {
			$(div).css({
				"opacity": opacity,
				"filter": "alpha(opacity=" + opacity * 100 + ")"
			});
		}
		document.body.appendChild(div);
	}

	div.className = options.className || "";
	$(div).show();
	return div;
}


function fadeOut() {
	$('#fadeBlock').remove();
}

var simpleCloseButton = '<button type="button" class="removePopupButton"><div class="button small green">'+l10n.popup.close+'<div class="bg"></div></div></button>';


function addPopup(options){
	options = options || {};
	appendTo = options.appendTo || document.body;
	$('.popup').remove();
	fadeIn();
	var template = options.template || "tmpl_Popup";
	var $elPopup = $.tmpl(template, options);
	if(options.dom){
		$(document.createElement('div'))
			.addClass(options.domClass)
			.prependTo($elPopup)
			.append(options.dom);
	}

	var height = $elPopup.height();
	$elPopup.addClass(options.className);
	appendTo.appendChild($elPopup[0]);
	if (height === 0) {
		$elPopup[0].style.height = $elPopup[0].offsetHeight + "px";
	}
	setPosition();
	$elPopup[0].style.visibility = "visible";

	function setPosition(){
		if(($elPopup[0].offsetHeight + 40) > document.documentElement.clientHeight){
			$elPopup.css({
				"position": "absolute",
				"bottom": "auto",
				"top": $(window).scrollTop() + 20
			});
		} else {
			$elPopup[0].style.position = "fixed";
		}
	}

	$elPopup.resize(setPosition);


	if (options.actionButton) {
		$('.actionButton, .errorActionButton', $elPopup).click(options.actionButton);
	}

	if (options.cancelButtonAction) {
		$('.cancelButtonAction', $elPopup).click(options.cancelButtonAction);
	}

	$('.close_button', $elPopup).click(function(){
		removePopup();
		options.onPopupRemove && options.onPopupRemove();
	});

	setTimeout(function () {
		var content = $elPopup.find('.content');

		if (content.length) {
			var hasScrollBar = content[0].offsetHeight < content[0].scrollHeight;
			$elPopup.find('.overflow-shadow')[hasScrollBar ? 'show' : 'hide']();
		} else {
			$elPopup.find('.overflow-shadow').hide();
		}
	}, 1);

	return $elPopup[0];
}


function removePopup(el){
	fadeOut();
	el = el || $('.popup');
	$(el).remove();
}


function showPopup(el){
	fadeIn();
	el = el||$('.popup');
	$(el).removeClass('invisible');
}


function hidePopup(){
	fadeOut();
	var el = el||$('.popup');
	$(el).addClass('invisible');
}

$.fn.tooltip = function(options) {
	var defaults = {
		showBody: "| ",
		contentId: false,
		rounded: true,
		padding: 15
	};

	var settings = $.extend(defaults, options);

	var WindowHeight =  window.innerHeight || document.body.clientHeight;
	var WindowWidth =  window.innerWidth || document.body.clientWidth;
	$(window).resize(ScreenSize);

	function ScreenSize() {
		WindowHeight =  window.innerHeight || document.body.clientHeight;
		WindowWidth = window.innerWidth || document.body.clientWidth;
		$('#win').html(' width: ' + WindowWidth + '   height: ' + WindowHeight);
	}

	this.each(function() {
		var $this = $(this);
		var title;
		if (settings.contentId) {
			title = $("#"+settings.contentId).html();
		} else if (settings.dom) {
			title = settings.dom;
			settings.showBody = false;
		} else {
			title = this.title;
		}
		if (title === '') return;

		this.title = '';
		if (settings.showBody) {
			var parts = title.split(settings.showBody);
			temp = '';
			for (i = 0, partsLength = parts.length; i < partsLength; i++) {
				temp += parts[i];
				if (i + 1 < partsLength) {
					temp += '<br/>';
				}
			}
			title = temp;
		}

		$this.hover(function(e) {
			$('#tooltip').remove();
			$('<div/>', {
				id: "tooltip",
				"class": "TitleStyle",
				html: title,
				css:{
					"top": e.pageY + 10,
					"left": e.pageX + 15
				}
			})
				.appendTo('body')
				.hide()
				.fadeIn(150);

			if (settings.rounded) {
				$('#tooltip').css({
					"-webkit-border-radius": "10px",
					"-moz-border-radius": "10px",
					"border-radius": "10px"
				});
			}
		}, function() {
			$('#tooltip').remove();
		});

		$this.mousemove(function(e) {
			var $ttip = $('#tooltip');
			titleHeight = $ttip.height() + 2 * settings.padding;
			titleWidth = $ttip.width() + 2 * settings.padding;
			focusTop = e.pageY + 10;
			focusLeft = e.pageX + 15;
			if (WindowHeight - e.clientY - titleHeight < 10) {
				focusTop = e.pageY - titleHeight;
			}
			if (WindowWidth - e.clientX < titleWidth + 40) {
				focusLeft = e.pageX - titleWidth;
			}

			$('#tooltip').css({
				top: focusTop,
				left: focusLeft
			});
		});

	});
	return this;
};

function setSortCountriesArray(){
	ref.arrCountries = [];
	for (var c in ref.Countries) {
		ref.Countries[c].code = c;
		if (ref.Countries[c].citizenship) ref.arrCountries.push(ref.Countries[c]);
	}
	ref.arrCountries.sort(function(a, b){
		if (a.Name > b.Name) return 1;
		if (a.Name < b.Name) return -1;
		return 0;
	});
	if(tw.language == "tr") {
		var alph = {"A":1, "B":1, "C":3, "Ç":4, "D":5, "E":6, "F":7, "G":8, "Ğ":9, "H":10, "I":11, "İ":12, "J":13, "K":14, "L":15, "M":16, "N":17, "O":18, "Ö":19, "P":20, "R":21, "S":22, "Ş":23, "T":24, "U":25, "Ü":26, "V":27, "Y":28, "Z":29};
		ref.arrCountries.sort(function(a, b){
			if (alph[a.Name.substring(0,1).toUpperCase()] > alph[b.Name.substring(0,1).toUpperCase()]) return 1;
			if (alph[a.Name.substring(0,1).toUpperCase()] < alph[b.Name.substring(0,1).toUpperCase()]) return -1;
			return 0;
		});
	}
}


function createCountrySelect(){
	var elSelect = document.createElement("select");
	for (var i = 0, length = ref.arrCountries.length; i < length; i++) {
		var country = ref.arrCountries[i];
		var elOption = document.createElement("option");
			elOption.innerHTML = country.Name;
			elOption.value = country.code;
		elSelect.appendChild(elOption);
	}
	return elSelect;
}


function CountrySelect(options){
	var self = this;
	this.options = options || {};
	this.changed = false;
	this.elLink = document.createElement("span");
	this.elLink.className = "link dashed";
	$(this.elLink).appendTo(this.options.appendTo);

	this.elSelect = createCountrySelect();
	this.getValue();
	$(this.elSelect)
		.on("keydown keypress keyup change", function(event){
			if (event.type == "change") {
				self.setValue();
			}
		})
		.appendTo(this.options.appendTo);
	return this.elSelect;
}

CountrySelect.prototype.getValue = function(){
	var self = this;
	if (this.options.value) {
		this.elSelect.value = this.options.value;
		this.setValue();
	} else if (tw.position) {
		onGetPosition();
	} else {
		$(document).one("getPosition", function(){
			onGetPosition();
		});
		this.setValue();
		this.changed = false;
	}
	function onGetPosition(){
		if (tw.position.countryCode && !self.changed) {
			if (ref.Countries[tw.position.countryCode]) {
				self.elSelect.value = tw.position.countryCode;
			}
			self.setValue();
		}
	}
};


CountrySelect.prototype.setValue = function(){
	var self = this;
	this.changed = true;
	if(this.elSelect.selectedIndex < 0) {
		$(this.options.appendTo).parent().remove();
		return;
	}
	var str = this.elSelect.options[this.elSelect.selectedIndex].text;
	this.elLink.innerHTML = str;
	this.title = str;
	if(this.options.onChange) this.options.onChange(this);
};

function convertCurrency(num, curFrom, curTo){
	curTo = curTo || tw.currency;
	return (curFrom == curTo) ? num : num * tw.currencyRates[curFrom + '' + curTo];
}

function CurrencyString(num, cur){
	cur = cur || tw.currency;
	num += '';
	if(num.indexOf('.')>-1){
		num = num.substring(0,num.indexOf('.'));
	}
	num = num.replace((/\s/g), "");
	if (num.length == 1) {
		num = "0" + num;
	}
	var last = parseInt(num.substr(num.length - 1, 1), 10);
	var prelast = parseInt(num.substr(num.length - 2, 1), 10);
	var text = "";

	if (last == 1 && (num.length == 1 || tw.language == "ru" || tw.language.indexOf("ua")>-1) ) {
		text = l10n.currency[cur].Nominative;
	} else if (0 < last && last < 5) {
		text = l10n.currency[cur].Genitive;
	} else {
		text = l10n.currency[cur].Genitive_Plural;
	}
	if (prelast == 1) {
		text = l10n.currency[cur].Genitive_Plural;
	}
	return text;
}


$(function(){
	initLanguage();
	updateSelectedLanguageInfo();
});
function initLanguage(){
	var $block = $('.localeSelect');

	if ($('#railway_search').length || readCookie('referrer') === "aviasales") {
		$('body').addClass('hideLocaleSelect');
		return;
	}

	$(document.body)
		.on('click', function(e){
			var $block = $('.localeSelect');
			var el = $block
				.toArray()
				.filter(function ($el) { return $.contains($el, e.target) });
			var contains = !!el[0];

			var currentParent = $(e.target).parent().is(".currentLocale");
			if (contains) {
				var $list = $(el[0]).find('ul');
				if (currentParent) {
					$list.stop(true, true).fadeToggle();
				} else if (e.target.tagName === 'A') {
					$list.stop(true, true).hide();
				}
			} else {
				var $list = $('ul', $block);
				if (!currentParent && $list.is(":visible")) {
					$list.stop(true,true).fadeOut();
				}
			}
		})
		.on('click', '[data-language]', function (e) {
			var langTo = $(this).data('language');
			if (!langTo) {
				return;
			}

			e && e.preventDefault();

			if (langTo === tw.language) {
				return;
			}

			$(document.body).trigger("removeUnloadReservation");
			$(document.body).trigger("changeLanguage");
			var re1 = new RegExp("^/[a-z][a-z]/.*");
			var re2 = new RegExp("^/[a-z][a-z]-[a-z][a-z]/.*");

			var loc = document.location;
			var locProtocol = loc.protocol;
			var locHostname = loc.hostname;
			var locPathname = loc.pathname;
			var locSearch = loc.search;

			if (!~locSearch.indexOf('utm_source=affiliate')) {
				locSearch = locSearch
					.replace(/(utm_source|(\?|&)t)=[^&]+/g, '')
					.replace(/&+/g, '&')
					.replace(/&$/g, '')
					.replace(/^\?&/g, '?');
			}

			if (locSearch) {
				var params = locSearch.trim().substr(1).split('&');

				params = params.filter(function (param) {
					return !(/^scp=/i.test(param));
				});

				if (params.length) {
					locSearch = '?' + params.join('&');
				} else {
					locSearch = '';
				}
			}

			var locHash = loc.hash;

			if (re1.test(locPathname) || re2.test(locPathname)) {
				locPathname = locPathname.substring(1, locPathname.length);
				locPathname = locPathname.substring(locPathname.indexOf('/'), locPathname.length);
			}

			locPathname = locPathname.replace(l10n.url.flights, l10n.url[langTo]);

			loc.href = locProtocol + "//" + locHostname + "/" + langTo + locPathname + locSearch + locHash;
		});
}

function updateSelectedLanguageInfo() {
	$('.localeSelect .checkIcon').remove();
	$('.localeSelect [data-language="' + tw.language +'"]')
		.append($('<span class="checkIcon"/>'));
}

function initOnlineCall(parent) {
	var parent = parent || document.body;
	$(document).on('click', '.online_call', function(){
		var widgetNum = "6e1655b5a3cc6179bf39245898984ab1";
		if(tw.language == "es"){
			widgetNum = "92fb70c45a58c07ced6bb942addd8144";
		}

		var newwindow = window.open('http://zingaya.com/widget/' + widgetNum + '?referrer='+escape(window.location.href), 'zingaya', 'width=236,height=220,resizable=no,toolbar=no,menubar=no,location=no,status=no');

		setTimeout(function(){
			newwindow.focus();
		},500);
	});
}

$(function(){
	initOnlineCall();
});

function showContacts(){
	removePopup();
	var contactPopup = addPopup({
		className: "Contacts",
		dom: $.tmpl($("#tmpl_Contacts").trim()),
		domClass: 'c_info',
		close_button: true
	});

	var mail = document.createElement("a");
	mail.href = "javascript:void(0)";
	mail.title = l10n.topMenu.contacts.write;

	var domain = tw.position.countryCode == "AZ" ? '.az' : '.com';
	var eHost = 'onetwotrip';

	var emailNames = [
		'copyright',
		'media',
		'info',
		'adv',
		'b2b'
	].map(function(emailName){
		return emailName + '@' + eHost + domain;
	})

	emailNames.forEach( function(emailName, index){
		$('#email' + (index + 1))
			.html(
				$(mail)
					.clone()
					.html( emailName.split("").reverse().join(""))
					.attr('data-host', emailName)
			);
	});

	$('.Contacts .email a').on('mouseover', function(){
		var mTo = $(this).attr('data-host');
		$(this).attr("href",'mailto:'+mTo);
		if (browser.msie) {
			$(this)
				.html((mTo).split("").reverse().join(""))
				.attr("style", "unicode-bidi:bidi-override; direction: rtl");
		}
	});

	initOnlineCall(contactPopup);
}

function clearExtraElements(){
	try{
		$('.hint').remove();
		$('#tooltip').remove();
		removeInfoBaloon();
	} catch(e){}
}

function kmqRecord(options){
	if(document.location.host.indexOf('onetwotrip') < 0 && !tw.params.allowKiss) return;
	options = $.extend(true,{},options);
	options.obj = options.obj || {};

	if(options.prefix){
		for(var i in options.obj){
			options.obj[options.prefix+'_'+i] = options.obj[i];
			delete options.obj[i];
		}
	}

	if(options.text || options.url){
		var text = '';
		if(options.text) {
			text+= options.text;
		}
		if(options.url) {
			text+= (text ? '  ' : '') + options.url;
		}
		options.obj.EventInfo = text;
	}
	options.obj['Language'] = tw.language;
	options.obj['EventHour'] = new Date().getUTCHours()+3;
	options.obj['accept_language'] = readCookie("accept_language");
    options.obj['vid'] = readCookie("vid");
    options.obj['referrer'] = readCookie("referrer");
	_kmq.push(['record', options.name, options.obj]);
}

function kmqRouteType(route){
	var fType = "multiway";
	if(route.length == 10){
		fType = "oneway";
	} else if(route.length == 14) {
		fType = "round";
	}
	return fType;
}

function removeInfoBaloon(){
	try{
		var infoBlock = $('.stars_baloon');
		fadeOutBlock(infoBlock,function(){ $(infoBlock).remove() });
		infoBaloonHidden = true;
	} catch(e){}
}

function ShowAircraftYears(num){
	var t ='';
	if(num == 1) {
		t = l10n.searchResult.baloon.aircraftyears[0];
	} else if(num > 1 && num < 5) {
		t = l10n.searchResult.baloon.aircraftyears[1];
	} else {
		t = l10n.searchResult.baloon.aircraftyears[2];
	}
	return [ num, t, l10n.searchResult.baloon.aircraft ].join(' ');
}


function MakeDateFlightInfo(DirDate){
	var curDate = DirDate;
	var formText = '{day} {month}';
	if(tw.language == 'az' || tw.language =='en-us'){
		formText = '{month} {day}';
	}

	if (isValidDate(curDate)) {
		return formText.replaceByHash({
			day: curDate.getDate(),
			month: l10n.calendar.months_D[curDate.getMonth()].toLowerCase()
		});
	} else {
		curDate = new Date.parseAPI(DirDate);
		if(isValidDate(curDate)){
			return formText.replaceByHash({
				day: curDate.getDate(),
				month: l10n.calendar.months_D[curDate.getMonth()].toLowerCase()
			});
		} else {
			return "";
		}
	}
}


function adfoxInitComBlock(paramsObj, options) {
	options || (options = {});

	var keywordArr = options.keyword || [],
		referrer = readCookie('referrer');

	if (referrer && options.needMeta) {
		var metaChannels = [
				'aviasales',
				'aviasales_cu',
				'skyscanner',
				'skyscanner_ua',
				'skyscanner_cu',
				'skyscanner_de',
				'skyscanner_ie',
				'skyscanner_uk_pc',
				'skyscanner_kz',
				'momondo',
				'momondo_de',
				'momondo_es',
				'momondo_ie',
				'momondo_uk',
				'momondo_us',
				'yandex',
				'yandex_ua',
				'kayak'
			],
			contextChannels = ['yandex_direct_brand', 'google_adwords_brand'];

		if (~metaChannels.indexOf(referrer)) {
			keywordArr.push('channel_meta');
		} else {
			keywordArr.push('channel_nonmeta');
		}

		if (~contextChannels.indexOf(referrer)) {
			keywordArr.push('channel_context');
		}
	}

	if (options.needMeta) {
		keywordArr.push('source_' + (referrer || 'direct'));
	}

	keywordArr.push('lang_' + tw.language);

	options.keywords = keywordArr.join(' ');

	try {
		if (~window.location.href.indexOf('www.onetwotrip')) {
			window.Ya.adfoxCode.create({
				ownerId: paramsObj.ownerId,
				containerId: paramsObj.containerId,
				params: {
					pp: paramsObj.pp,
					ps: paramsObj.ps,
					p2: paramsObj.p2,
					pk: options.keywords
				},
				onRender: function () {
					if (options.onload) {
						options.onload();
					}
				}
			});
		} else if (options.partnerAdfox) {
			window.Ya.adfoxCode.create({
				ownerId: paramsObj.ownerId,
				containerId: paramsObj.containerId,
				params: {
					pp: paramsObj.pp,
					ps: paramsObj.ps,
					p2: paramsObj.p2,
					pk: paramsObj.pk,
					pke: '1'
				},
				onRender: function () {
					if (options.onload) {
						options.onload();
					}
				}
			});
		}
	} catch(e) {
		console.warn('adfox error -->', e);
	}
}

function initComBlock(options){
	options || (options = {});
	var bannerParamsByPlacenames = window.isSales ? {
		personalCabinetBanner: {
			size: '865x100',
			setID: 214691,
		},
		deals: {
			size: '240x224',
			setID: 184166
		},
		passengerSelect: {
			size: '600x235',
			setID: 184176
		},
		resultsOneWay: {
			size: '230x179',
			setID: 205090
		},
		results: {
			size: '230x253',
			setID: 205089
		},
		search: {
			size: '600x235',
			setID: 184169
		},
		passengerSelectTopBanner720: {
			size: '720x70',
			setID: 204200
		},
		passengerSelectTopBanner800: {
			size: '800x70',
			setID: 204201
		},
		passengerSelectTopBanner820: {
			size: '820x70',
			setID: 204202
		},
		passengerSelectTopBanner900: {
			size: '900x70',
			setID: 204203
		},

		passengerSelectBottomBanner720: {
			size: '720x100',
			setID: 204214
		},
		passengerSelectBottomBanner800: {
			size: '800x100',
			setID: 204215
		},
		passengerSelectBottomBanner820: {
			size: '820x100',
			setID: 204217
		},
		passengerSelectBottomBanner900: {
			size: '900x100',
			setID: 204216
		},
		profileBannerSmall: {
			size: '195x210',
			setID: 207445,
		},
	} : {
		personalCabinetBanner: {
			size: '865x100',
			setID: 214691,
		},
		deals: {
			size: '240x224',
			setID: 181913
		},
		passengerSelect: {
			size: '600x235',
			setID: 179105
		},
		resultsOneWay: {
			size: '230x179',
			setID: 205090
		},
		results: {
			size: '230x253',
			setID: 205089
		},
		search: {
			size: '600x235',
			setID: 179094
		},
		passengerSelectTopBanner720: {
			size: '720x70',
			setID: 204200
		},
		passengerSelectTopBanner800: {
			size: '800x70',
			setID: 204201
		},
		passengerSelectTopBanner820: {
			size: '820x70',
			setID: 204202
		},
		passengerSelectTopBanner900: {
			size: '900x70',
			setID: 204203
		},

		passengerSelectBottomBanner720: {
			size: '720x100',
			setID: 204214
		},
		passengerSelectBottomBanner800: {
			size: '800x100',
			setID: 204215
		},
		passengerSelectBottomBanner820: {
			size: '820x100',
			setID: 204217
		},
		passengerSelectBottomBanner900: {
			size: '900x100',
			setID: 204216
		},
		profileBannerSmall: {
			size: '195x210',
			setID: 207445,
		},
	};
	var elParent = options.id && document.getElementById(options.id);
	var bannerParams = bannerParamsByPlacenames[options.banner];
	if(elParent && bannerParams) {
		$(elParent).empty();
		var keyword = options.keyword || [];
		var referrer = readCookie('referrer');
		if (referrer) {
			var metaChannels = {
				aviasales: true,
				aviasales_cu: true,
				skyscanner: true,
				skyscanner_ua: true,
				skyscanner_cu: true,
				skyscanner_de: true,
				skyscanner_ie: true,
				skyscanner_uk_pc: true,
				skyscanner_kz: true,
				momondo: true,
				momondo_de: true,
				momondo_es: true,
				momondo_ie: true,
				momondo_uk: true,
				momondo_us: true,
				yandex: true,
				yandex_ua: true,
				kayak: true,
			};
			var contextChannels = {
				yandex_direct_brand:  true,
				google_adwords_brand: true
			};
			metaChannels[referrer] ? keyword.push('channel_meta') : keyword.push('channel_nonmeta');
			contextChannels[referrer] && keyword.push('channel_context');
		}
		keyword.push('LANG_' + tw.language.replace('-',''));
		keyword.push('source_' + (referrer && referrer!=='' ? referrer : 'direct'));
		var url = '//servedbyadbutler.com/adserve/;ID=166328;size=' + bannerParams.size + ';setID=' + bannerParams.setID + ';type=json;kw=' + keyword.join(',');
		$.ajax({
			dataType: 'json',
			url: url,
			timeout: 5000,
			success: function(json){
				json = json || {};

				if(json.status === 'SUCCESS' && json.placements) {
					var placement_1 = json.placements.placement_1;
					var target = placement_1.target || '_blank';
					var trackingPixel = placement_1.tracking_pixel;
					var bannerContent = (placement_1.body + '' || '').trim();

					if (trackingPixel) {
						$('body').append('<img src="' + trackingPixel + '" alt="" width="1" height="1" class="invisible"/>');
					}

					if (bannerContent) {
						var linkUrl = placement_1.redirect_url || '#';

						elParent.insertAdjacentHTML('afterbegin', bannerContent);
						var bannerLink = elParent.querySelector('a');

						if (target !== 'noclick') {
							bannerLink.href = linkUrl;
							bannerLink.target = target;
						}
					} else {
						var wrapper = '';
						var img = document.createElement('img');
						$(img).attr({
							"src":    placement_1.image_url,
							"alt":    placement_1.alt_text,
							"width":  placement_1.width,
							"height": placement_1.height,
							"class": "invisible"
						});

						var redirectUrl = placement_1.redirect_url || '';
						if (target !== 'noclick') {
							wrapper = '<a href="' + redirectUrl + '" target="' + target + '" class="comib invisible"></a>';
						}
						$(elParent).append( img );
						$(img).wrap( wrapper );

						$(img).on('load', function() {
							$("*", elParent).removeClass('invisible');
							if (options.onload) {
								options.onload();
							}
						});
					}
				} else if ( json.status === 'NO_ADS' ) {

				} else {
					options.onload();
				}
			}
		});
	}
}

function getAdButlerKeyWordByRoutes(config){
	var departure = config.departure;
	var arrival = config.arrival;
	var promo = config.promo;
	var destination = departure + arrival;
	var isDepartRu = departure === 'RU';
	var isArriveRu = arrival === 'RU';
	var isLangRu = tw.language === 'ru';

	var promos = {
		rzd: function () {
			var destList = ['MOWGOJ', 'MOWLED', 'MOWKZN', 'KZNSVX', 'MOWVOG', 'LEDHEL', 'LEDPES', 'MOWPES', 'GOJMOW', 'LEDMOW', 'KZNMOW', 'SVXKZN', 'VOGMOW', 'HELLED', 'PESLED', 'PESMOW'];

			if (isLangRu && ~destList.indexOf(destination)) {
				return departure + '_' + arrival;
			}
		},
		finAir: function () {
			var destList = ['LEDSIN', 'LEDBKK', 'LEDMIA', 'SVXPRG', 'SVXMUC', 'SVXMIL', 'SVXZRH', 'KZNPAR', 'KZNMIL', 'KZNBCN', 'KZNMUC', 'KUFBUD', 'KUFMIL', 'KUFBCN', 'KUFMUC', 'MOWNYC', 'MOWMIA', 'MOWPAR', 'MOWZRH'];

			if (isLangRu && ~destList.indexOf(destination)) {
				return destination
			}
		},
		airEurope: function () {
			var destArr = ['MOWBOG', 'BOGMOW', 'MOWSGD', 'SGDMOW', 'MOWSRZ', 'SRZMOW', 'MOWPUJ', 'PUJMOW', 'MOWMVD', 'MVDMOW', 'MOWASU', 'ASUMOW', 'MOWCOR', 'CORMOW', 'MOWALC', 'ALCMOW', 'MOWIBZ', 'IBZMOW'];
			var matchIndex = destArr.indexOf(destination);

			if (isLangRu && ~matchIndex) {
				return destArr[matchIndex]
			}
		},
		tapPortugal: function () {
			var destList = ['MOWFNC', 'MOWLIS', 'MOWOPO', 'MOWFAO', 'MOWSAO', 'LEDFNC', 'LEDLIS', 'LEDOPO', 'LEDFAO', 'LEDSAO'];

			if (isLangRu && ~destList.indexOf(destination)) {
				return (departure + '_' + arrival).toLowerCase();
			}
		},
		emirates: function () {
			var destArr = ['MOWDXB', 'MOWDPS', 'MOWCMB', 'MOWBKK', 'MOWMLE', 'MOWHKT', 'MOWSGN', 'MOWSEZ', 'MOWPRI', 'LEDDPS', 'LEDCMB', 'LEDBKK', 'LEDMLE', 'LEDHKT', 'LEDSGN', 'LEDSEZ', 'LEDPRI', 'MOWHAN', 'MOWUSM', 'MOWKUL', 'MOWJNB', 'MOWPNH', 'LEDHAN', 'LEDUSM', 'LEDKUL', 'LEDJNB', 'LEDPNH', 'LEDDXB'];

			if (isLangRu && ~destArr.indexOf(destination)) {
				return 'emirates_' + departure + '_' + arrival;
			}
		},
		airFrance: function () {
			var destArr = ['ROM', 'BER', 'PAR', 'BCN', 'TIV', 'TLV', 'IST', 'LON', 'MIL', 'NYC', 'MUC', 'HKT', 'RIX', 'AMS', 'TLL', 'VIE', 'BKK', 'AYT', 'TBS', 'EVN', 'BAK', 'LIS', 'SKG', 'ATH', 'STO', 'DXB', 'AUH', 'LAX', 'DBV', 'KIV', 'MOW'];
			var matchIndex = destArr.indexOf(arrival);

			if (isDepartRu && isLangRu && ~matchIndex) {
				return 'travel_' + destArr[matchIndex].toLowerCase();
			}
		},
		rzdCountry: function () {
			if (isLangRu && isDepartRu && isArriveRu) {
				return 'travel_rzd';
			}
		},
		rzdCity: function () {
			var destArr = ['MOWLED', 'MOWGOJ', 'MOWKZN', 'LEDMOW', 'GOJMOW', 'KZNMOW'];

			if (isLangRu && ~destArr.indexOf(destination)) {
				return 'travel_rzd_' + destination
			}
		}
	};

	if (promos[promo]) {
		return promos[promo]();
	}
}

function getAdButlerKeywords(promoName, departure, arrival) {
	return getAdButlerKeyWordByRoutes({
		promo: promoName,
		departure: departure,
		arrival: arrival
	})
}

function cacheAirportInfo(code, data) {
	var date = new Date(),
			dateStamp = date.format('ddmmyyyy');

	tw.AirportInfoCache = tw.AirportInfoCache || {};
	tw.AirportInfoCache[dateStamp] = tw.AirportInfoCache[dateStamp] || {};
	tw.AirportInfoCache[dateStamp][code] = tw.AirportInfoCache[dateStamp][code] || data;
}


function getAirportInfoFromCache(code) {
	var date = new Date(),
			dateStamp = date.format('ddmmyyyy'),
			data = null;

	if (tw.AirportInfoCache && tw.AirportInfoCache[dateStamp] && tw.AirportInfoCache[dateStamp][code]) {
		data = tw.AirportInfoCache[dateStamp][code];
	}
	return data;
}


function calculateAirportTime(data) {
	var now = new Date(),
	date = null,
	curDiff;
	if(data.localTime){
		date = new Date(data.localTime.valueOf() + now.valueOf() - data.dateAtMoment.valueOf());
	} else if (data.gmt) {
		date = new Date();
		curDiff = now.getTimezoneOffset();
		date.setMinutes(now.getMinutes() + curDiff + data.gmt);
	}
	return date;
}


function parseAirportContentTemplate(data) {
	var content,
	templateId = 'tmpl_AirportTooltipContent';

	if (!$.template[templateId]) {
		$.template(templateId, $('#' + templateId).trim());
	}
	if(!data.fullUrl){
		data.fullUrl = data.site || '';
		data.shortUrl = (data.site || '').replace('http://', '').replace(/^www\./, '').replace(/\/$/, '');
	}

	data.airportTime = calculateAirportTime(data);
	content = $('<div/>').append($.tmpl(templateId, data));
	return content.html();
}


function adjustAirportBaloonPosition($airport, $baloon) {
	var airportOffset = $airport.offset(),
			airportWidth = $airport.width(),
			leftExtra = Math.round(airportWidth / 2) - 35,
			top = airportOffset.top - $baloon.height() - 50;

	$baloon.css({
		left: airportOffset.left + leftExtra,
		top: top,
		position: 'absolute'
	});

	if (top < $(window).scrollTop() + 10) {
		$baloon.addClass('bottom').css({top: airportOffset.top + 42});
	}
}


function fetchAirportContent($airport, $baloon) {
	var code = $airport.data('code'),
			data = getAirportInfoFromCache(code),
			content;

	if (data) content = parseAirportContentTemplate(data);
	else {
		var params = {
			iata: code
		};
		var sign = "\u2103";
		if(tw.language === "en-us") {
			params.f = 1;
			sign = "\u2109";
		}
		$.ajax({
			dataType: "json",
			data: params,
			url: "/_api/flightstats/portinfo/",
			timeout: 40000,
			cache: false,
			success: function(json){
				var content, data, localTime;
				if(!json.error && !json.err) {
					localTime = json.localTime? new Date(Date.parseISO8601(json.localTime)) : new Date();
					data = {
						temperature: ~~json.temperature,
						temperatureSign: sign,
						site: json.site,
						lat: json.lat,
						lon: json.lon,
						phone: json.phone,
						gmt: json.gmt,
						localTime: isValidDate(localTime) ? localTime : null,
						dateAtMoment: new Date()
					};
					cacheAirportInfo(code, data);

					content = parseAirportContentTemplate(data);
				} else {
					content = '<div>' + l10n.searchResult.baloon.unableToGetAirportInfo + '</div>';
				}
				$baloon.find('.content').html(content);
				adjustAirportBaloonPosition($airport, $baloon);
			},
			complete: function() {
				$baloon.find('.smallLoader').remove();
			},
			error: function() {
				content = '<div>' + l10n.popup.problem + '</div>';
				$baloon.find('.content').html(content);
				adjustAirportBaloonPosition($airport, $baloon);
			}
		});
		content = '<span class="smallLoader"></span>';
	}
	return content;
}
function showAirportBaloon($airport) {
	var code = $airport.data('code'),
				content,
				$baloon,
				template = $("#tmpl_AirportTooltip");

	removeInfoBaloon();

	$.template('tmpl_AirportTooltip', template.trim());
	$baloon = $.tmpl('tmpl_AirportTooltip', {});
	$baloon.appendTo('body');
	content = fetchAirportContent($airport, $baloon);
	$baloon.find('.content').html(content);

	adjustAirportBaloonPosition($airport, $baloon);

	fadeInBlock($baloon[0]);
	infoBaloonHidden = false;
	kmqRecord({name: 'show_airport_info'});
}


function MakeAirportTooltips() {
	$(document.body).on('mouseenter click','.airport',function(e){
		var $airport = $(this),
		code = $airport.data('code');

		if (e.type == "click") {
			if (infoBaloonHidden) {
				try {
					showAirportBaloon($airport);
					infoBaloonHidden = false;
				} catch(e) {}
			}
		} else {
			setTimeout(function() {
				if (infoBaloonHidden) {
					var $mouseTarget = $(mouseEvent.target);
					if (($mouseTarget.hasClass('airport') && $mouseTarget.data('code') == code)
							  || ($mouseTarget.closest('.airport').length && $mouseTarget.closest('.airport').data('code') == code)) {
						try {
							showAirportBaloon($airport);
						} catch(e) {}
					}
				}
			}, 300);
		}
	});
}

function WelcomeBonusText(el){
	var bonusMap = {
		"EUR":25,
		"USD":30,
		"UAH":260,
		"AZN":25,
		"TRY":60,
		"GBP":20
	};
	var welcomeBonus = bonusMap[tw.bonus.currency] || 1000;
	el.innerHTML += [
		'<div>',
			l10n.makeorder.bonus.welcome[0] + ' ',
			'<span class="nowrap">',
				'<span class="strong">',
					welcomeBonus, ' ', l10n.makeorder.bonus.welcome[1], ' ≈ ',
				'</span>',
				'<span class="money-formatted-bold">',
					formatMoney(welcomeBonus),
				'</span>',
			'</span>',
		'</div>'
	].join('');
}

function fakePlaceholder() {
	var active = document.activeElement;
	var $this = $(this);
	var clearPlaceholderValues = function() {
		$(this)
			.find('input[placeholder]')
				.filter('.placeholder').val('');
  };

	if (!jQuery.support.placeholder) {
		$this
			.focus(function () {
				var $this = $(this);
				if ($this.attr('placeholder') != '' && $this.val() == $this.attr('placeholder')) {
					$this.val('').removeClass('placeholder');
				}
			})
			.blur(function () {
				var $this = $(this);
				if ($this.attr('placeholder') != '' && ($this.val() == '' || $this.val() == $this.attr('placeholder'))) {
					$this.val($this.attr('placeholder')).addClass('placeholder');
				}
			});

		$this.closest('form')
			.off('submit.placeholder')
			.on('submit.placeholder', clearPlaceholderValues);

		$this.blur();
		$(active).focus();
	}
}

function initStat(arrScr) {
	var d = document,
	    w = window,
	    n = document.getElementsByTagName("script")[0];

	for(var scrIndex=0, srcLength = arrScr.length; scrIndex<srcLength; scrIndex++) {
		var curScr = arrScr[scrIndex];
		switch (curScr) {
			case "yandex":
				break;
			case "segmento":
				break;
			case "sift":
				var _sift = window._sift = window._sift || [];
				$(document).on('visitormanager_complete', function(event) {
					var _user_id = readCookie('bidh')||'';
					var _session_id = readCookie('sid')||'';
					if(!window.tw || !window.tw.provider) {
						_user_id = '';
					}
					_sift.push(['_setUserId', _user_id]);
					_sift.push(['_setSessionId', _session_id]);
					_sift.push(['_setAccount', 'f5ed803222']);
					_sift.push(['_trackPageview']);
				});
				break;
			case "cityads":
				break;
			case "criteo":
				var referrer = readCookie('referrer');
				if(tw.language == "ru" && referrer) {
					var isMeta = ~$.inArray(referrer, ["aviasales", "aviasales_cu", "skyscanner", "skyscanner_cu", "momondo", "yandex"]);
					var isContext = ~$.inArray(referrer,["yandex_direct", "google_adwords", "criteo"]);

					var expireDate = new Date(parseInt(readCookie('cr-expire'), 10));
					var curDate = new Date();
					var isMetaNotExpired = isMeta && isValidDate(expireDate) && curDate < expireDate;

					if (isMetaNotExpired || isContext) {
						var s = d.createElement("script");
						s.async=true;
						s.src = "https://static.criteo.net/js/ld/ld.js",
						n.parentNode.insertBefore(s,n);
						if(tw.params.utm_source && tw.params.utm_source == "criteo") {
							setCookie({
								name: "criteo",
								value: 1
							});
						}
					}
				}
				break;
			case "olark":
				if (!readCookie('referrer') && !browser.mobile && tw.language === "ru") {
					window.olark||(function(c){var f=window,d=document,l=f.location.protocol=="https:"?"https:":"http:",z=c.name,r="load";var nt=function(){
					f[z]=function(){
					(a.s=a.s||[]).push(arguments)};var a=f[z]._={
					},q=c.methods.length;while(q--){(function(n){f[z][n]=function(){
					f[z]("call",n,arguments)}})(c.methods[q])}a.l=c.loader;a.i=nt;a.p={
					0:+new Date};a.P=function(u){
					a.p[u]=new Date-a.p[0]};function s(){
					a.P(r);f[z](r)}f.addEventListener?f.addEventListener(r,s,false):f.attachEvent("on"+r,s);var ld=function(){function p(hd){
					hd="head";return["<",hd,"></",hd,"><",i,' onl' + 'oad="var d=',g,";d.getElementsByTagName('head')[0].",j,"(d.",h,"('script')).",k,"='",l,"//",a.l,"'",'"',"></",i,">"].join("")}var i="body",m=d[i];if(!m){
					return setTimeout(ld,100)}a.P(1);var j="appendChild",h="createElement",k="src",n=d[h]("div"),v=n[j](d[h](z)),b=d[h]("iframe"),g="document",e="domain",o;n.style.display="none";m.insertBefore(n,m.firstChild).id=z;b.frameBorder="0";b.id=z+"-loader";if(/MSIE[ ]+6/.test(navigator.userAgent)){
					b.src="javascript:false"}b.allowTransparency="true";v[j](b);try{
					b.contentWindow[g].open()}catch(w){
					c[e]=d[e];o="javascript:var d="+g+".open();d.domain='"+d.domain+"';";b[k]=o+"void(0);"}try{
					var t=b.contentWindow[g];t.write(p());t.close()}catch(x){
					b[k]=o+'d.write("'+p().replace(/"/g,String.fromCharCode(92)+'"')+'");d.close();'}a.P(2)};ld()};nt()})({
					loader: "static.olark.com/jsclient/loader0.js",name:"olark",methods:["configure","extend","declare","identify"]});
					olark.identify('2422-578-10-8972');
				}
				break;
			case "skyscanner":
				if(tw.params.skyscanner_redirectid || readCookie('skyscanner_redirectid')) {
					var s = d.createElement("script");
					s.async=true;
					s.src = '//t.skyscnr.com/userorchestration/resources/scripts/skyscanner.user.track.min.js';
					n.parentNode.insertBefore(s,n);
					if(!readCookie('skyscanner_redirectid')) {
						setCookie({
							name: "skyscanner_redirectid",
							value: tw.params.skyscanner_redirectid,
							days: 10
						});
					}
				}
				break;
			case "optimizely":
				break;
		}
	}
}

function getPassengerTypesFromParams(requestPassengerTypes){
	var passengerTypesToRequest = {
		ad: 1,
		cn: 0,
		'in': 0
	};

	try{
		var passengerTypes = requestPassengerTypes.split(',');
		passengerTypesToRequest.ad = parseInt(passengerTypes[0], 10);

		if(passengerTypes[1]){
			passengerTypesToRequest.cn = parseInt(passengerTypes[1], 10);
		}

		if(passengerTypes[2]){
			passengerTypesToRequest['in'] = parseInt(passengerTypes[2], 10);
		}
	}
	catch(ex) {}

	return passengerTypesToRequest;
}

function showMenu() {
	$('.mainMenu').animate({'opacity': 1});
}

function updateOverlayMenu(counter) {
	var animationTime = 0;

	if (updateOverlayMenu.inProgress) {
		clearTimeout(updateOverlayMenu.timeout);
		updateOverlayMenu.timeout = setTimeout(updateOverlayMenu, 2 * animationTime);
		return;
	}

	updateOverlayMenu.inProgress = true;
	var $mainMenu = $('.mainMenu'),
		allMenuItems = $('.mainMenu>a.menu-item'),
		currentVisibleMenuItems =  $('.mainMenu>a.menu-item:not(.menu-item--hide)'),
		menuToggleBtnWidth = Number($('#menu-toggle').outerWidth()),
		menuWrapWidth = $mainMenu.width() - menuToggleBtnWidth,
		shouldMoveToOverlay = [],
		shouldKeepVisible = [],
		summaryWidth = 0,
		needRender = false;

	allMenuItems.each(function () {
		summaryWidth += $(this).outerWidth(true);
		if (summaryWidth > menuWrapWidth) {
			shouldMoveToOverlay.push($(this));
		} else {
			shouldKeepVisible.push($(this));
		}
	});


	needRender = currentVisibleMenuItems.length !== shouldKeepVisible.length;

	if (needRender) {
		$mainMenu.fadeOut(animationTime, function () {
			renderMenu();
			updateOverlayMenu.inProgress = false;
			$mainMenu.fadeIn(animationTime);
		});
	} else {
		updateOverlayMenu.inProgress = false;
	}

	function renderMenu() {
		shouldKeepVisible.forEach(function ($item) {
			$item.removeClass('menu-item--hide');
		});
		shouldMoveToOverlay.forEach(function ($item) {
			$item.removeClass('menu-item--hide');
		});

		$('#menu-toggle').remove();

		if (shouldMoveToOverlay.length) {
			var $menuOverlayTmpl = $.tmpl($("#tmpl_HeaderMenuOverlay").trim()),
				$toggleMenuOverlay,
				$menuOverlay;

			shouldMoveToOverlay[0].before($menuOverlayTmpl);

			$toggleMenuOverlay = $('#menu-toggle');
			$menuOverlay = $('#menu-overlay');
			$menuOverlay.empty();

			shouldMoveToOverlay.forEach(function ($item) {
				$menuOverlay.append($item.clone());
				$item.addClass('menu-item--hide');
			});

			$toggleMenuOverlay.on('click', function (e) {
				e && e.preventDefault();
				$menuOverlay.css({left: $toggleMenuOverlay.position().left + $toggleMenuOverlay.width() / 2 + 'px'});
				$menuOverlay.stop(true, true).fadeToggle();
			});

			$(document.body).on('click', function (e) {
				var isToggle = $('.mainMenu').find(e.target).length || $(e.target).is("#menu-toggle");
				if ($menuOverlay[0] && !$.contains($menuOverlay[0], e.target) && $menuOverlay.is(':visible') && !isToggle) {
					$menuOverlay.stop(true, true).fadeOut();
				}
			});

			$menuOverlay.find('.menu-item').on('click', function (e) {
				e.stopPropagation();
				$menuOverlay.stop(true, true).hide();
			});
		}
	}
}

function getUrlVars() {
	var vars = {};
	var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
		vars[key] = value;
	});
	return vars;
}

$(document).ready(function(){
	if(browser.msie) {
		$('body').addClass('fontsymb');
	}

	if (document.getElementById('tmpl_Popup')) {
		$.template('tmpl_Popup', $("#tmpl_Popup").trim());
	}

	new FormSwitcher();

	if (tw.language == 'de' || tw.language == 'az') {
		$('#topSocialIn').addClass('invisible');
	}

	$(document.body)
		.on('mousemove',function(e){
			mouseEvent = e;
		})
		.on("showRating", function(event){
			kmqRecord({name: 'show_rating', obj: {type: event.view}});
		});

	$(document).on('authTrue', function(){
		if (objSocialAuth.checkAuthorized() && tw.language === "ru") {
			$('#railways_bar').remove();
		}
	});
    $('#topMenu_hotels a').on('click', function (e) {
        var href = this.href,
            params = getURLParams(),
            qs = [],
            param;
        e.stopPropagation();
        for (param in params) {
            qs.push(param + '=' + params[param])
        }
        href = href + '?' + qs.join('&');
		if (this.href.indexOf('hotels/') > -1) {
			setCookie({
				name: "hotel_track_pos",
				value: "navtab",
				days: 0.02
			});
		}
        this.href = href;
	});

	$('#topMenu_railways a').on('click', function(){
		try {
			ga('send', 'event', 'railway', 'MenuClick');
		} catch (e) {}
	});

	$(document).on('click', '.whatsapp_contact', function() {
		addPopup({
			dom: $.tmpl($("#tmpl_whatsapp_popup").trim()),
			className: "whatsapp_popup",
			close_button: true
		});
	});

});

tw.deferred.getPartner = $.Deferred();
$(function(){
	var ottDomainRegExp = /^local$|^alpha|^beta|^dev-linode|^staging|^sandbox|^production|^www|^12trip/i;
	var localNetworkRegExp = /^192/;

	function ottDomain(){
		var hostname = window.location.hostname;
		var domain3 = hostname.split('.').reverse()[2];

		var isInLocalNetwork = localNetworkRegExp.test(hostname);

		if (ottDomainRegExp.test(domain3) || isInLocalNetwork) {
			tw.deferred.getPartner.resolve();

			$('body').css({
				display: 'block'
			});


			updateOverlayMenu();

			showMenu();
		}
		else {
			deleteCookie({ name: 'referrer' });
			getResellerInfo(domain3);
			disableAppleAppBanner();
		}
	}

	ottDomain();

	function disableAppleAppBanner() {
		var appMeta = document.getElementsByName('apple-itunes-app')[0];

		if (appMeta) {
			appMeta.parentNode.removeChild(appMeta);
		}
	}

	function getResellerInfo(source){
		var hostname = window.location.hostname;
		$('body').addClass('partner_loading');

		$.ajax({
			dataType: "json",
			url: "/_api/mt/settings",
			data: {
				url: source
			},
			timeout: 60000,
			success: function(json){
				if (json.notFound) {
					console.log('партнер не найдет');
				}
				$('body').removeClass('partner_loading');
				if (json) {
					if (json.enabledMenuItems) {
						var allFooterItems = ['hotels', 'avia', 'railways', 'tours', 'avto', 'buses', 'bonuses', 'gifts', 'loyalty', 'activities'];
						var disabledMenuItems = [];
						for (var i = 0; i < allFooterItems.length; i++) {
							var include = true;
							for(var j = 0; j < json.enabledMenuItems.length; j++) {
								if(json.enabledMenuItems[j] === allFooterItems[i]) {
									include = false;
								}
							}
							if(include) {
								disabledMenuItems.push(allFooterItems[i]);
							}
						}
						json.disabledMenuItems = disabledMenuItems;
						json.sections = disabledMenuItems;
					}
					json.source = source;
					saveReferrerInfo(json.resellerId, undefined, undefined, hostname);

					tw.partner = json;
					setReseller(json);

					updateOverlayMenu();
					showMenu();
				}

			},
			complete: function(xhr, errorMessage){
				tw.deferred.getPartner.resolve();

				$('body').css({
					display: 'block'
				});
			}
		});
	}

	function initPartnerGA(partner) {
		var partnerObj = {
			'aktivno': 'UA-21448683-18',
			'astanabank': 'UA-21448683-17',
			'halva': 'UA-21448683-15',
			'nskbl': 'UA-21448683-16',
			'rgs': 'UA-21448683-11',
			'rocketbank': 'UA-21448683-12',
			'sberbank': 'UA-21448683-13',
			'sovest': 'UA-21448683-14'
		};
		var counterCodeByPartnerName = partnerObj[partner.source];

		window.ga = window.ga || function () {
			(ga.q = ga.q || []).push(arguments)
		};

		if (typeof(_gaq) == 'undefined') {
			console.error("Google Analytics is not installed");
		}

		ga("remove");
		ga("create", counterCodeByPartnerName, "auto");
		ga("send", "pageview");
	}

	function setReseller(partner){
		tw.partnerName = '';

		initPartnerGA(partner);

		if (typeof objAvia !== 'undefined' && !objAvia.startSearch) {
			setResellerCustomHeader(partner);
		} else {
			setResellerCommonHeader(partner);
		}

		$('body').addClass('hideLocaleSelect');
		if (partner.copyright) {
			$("#copyright").append('<p style="margin-bottom: 0">' + partner.copyright + '</p>');
		}

		if (partner.enabledMenuItems) {
			$('.mainMenu .menu-item').addClass('wl-elem-for-remove');
			$('.searchFormABControl .searchFormABControlItem').addClass('wl-elem-for-remove');
			var allFooterItems = ['avia', 'railways', 'hotels', 'tours', 'cars', 'buses', 'bonuses', 'hc'];
			for (var i = 0; i < allFooterItems.length; i++) {
				$('#footerMenu_' + allFooterItems[i] ).addClass('wl-elem-for-remove');
			}
			for (var i = 0; i < partner.enabledMenuItems.length; i++) {
				var enableItem = partner.enabledMenuItems[i];
				$('#topMenu_' + enableItem ).removeClass('wl-elem-for-remove');
				$('#footerMenu_' + enableItem ).removeClass('wl-elem-for-remove');
				$('#' + enableItem  + 'LinkFormAB').removeClass('wl-elem-for-remove');
			}
			$('.wl-elem-for-remove').remove();
		} else if (partner.disabledMenuItems) {
			for (var i = 0; i < partner.disabledMenuItems.length; i++) {
				var menuItemForRemove = partner.disabledMenuItems[i];
				$('#topMenu_' + menuItemForRemove ).remove();
				$('#footerMenu_' + menuItemForRemove ).remove();
				$('#' + menuItemForRemove  + 'LinkFormAB').remove();
			}
		}


		$('#footer .apps').remove();
		$('.tripcoins_info.advise').remove();
		$('#downloadApp').remove();
		$('#adfox_149451050978071889').remove();
		$('#adfox_151316243215369951').remove();

		if (partner.seoDisabled) {
			$('#seo_up').remove();
			$('#seo_footer').remove();
		}
	}

	function setResellerCommonHeader(partner) {

		if (!$.template.tmpl_headerPartner) {
			$("#tmpl_HeaderPartner").template('tmpl_headerPartner');
		}

		var $header = $('.layoutHeader');
		var $aside = $header.find('.aside.loggedin').detach();
		var $asideLabel = $header.find('.asideLabel').detach();



		var $headerPartner = $.tmpl($.template.tmpl_headerPartner, partner)
			.find('.spreader')
			.append($asideLabel)
			.append($aside)
			.end();

		$header
			.find('.logo').remove().end()
			.addClass('thin')
			.prepend($headerPartner);
	}

	function setResellerCustomHeader(partner){
		if (partner.backgroundImage) {
			$('#form_hotelsSearch').css('background-image', 'url(' + partner.backgroundImage + ')');
			$('.searchFormAB--wrap').css('background-image', 'url(' + partner.backgroundImage + ')');
		}

		if (partner.header) {
			$.ajax({
				url: partner.header,
				type: 'GET',
				success: function(data) {
					$('.layoutHeader')
						.prepend(data);
				}
			});

			return;
		}

		setResellerCommonHeader(partner)
	}
});

var bookingCityId = {
	MOW: "-2960561",
	PAR: "-1456928",
	LED: "-2996338",
	IST: "-755070",
	SAW: "-755070",
	BCN: "-372490",
	PRG: "-553173",
	VIE: "-1995499",
	ROM: "-126693",
	AER: "-3006514",
	NYC: "20088325",
	MIL: "-121726",
	LON: "-2601889",
	BER: "-1746443",
	AMS: "-2140479",
	HKT: "-3253342",
	MUC: "-1829149",
	PYX: "-3242432",
	UTP: "-3242432",
	TLV: "-781545",
	DXB: "-782831",
	HKG: "-1353149",
	BKK: "-3414440",
	IEV: "-1044367",
	SEL: "-716583",
	RIX: "-3212216",
	AYT: "-735347",
	MSQ: "-1946324",
	SIN: "-73635",
	MAD: "-390625",
	USM: "900040609",
	LAX: "37295",
	BUD: "-850553",
	TLL: "-2625660",
	DUS: "-1762397",
	NCE: "-1454990",
	HEL: "-1364995",
	STO: "-2524279",
	KRR: "-2936262",
	FLO: "20116532",
	BJS: "-1898541",
	PEK: "-1898541",
	MIA: "20023182",
	LIS: "-2167973",
	KGD: "-2918852",
	VNC: "20024377",
	SIP: "-1054041",
	LAS: "20079110",
	HKT: "-3253342",
	AER: "-3006514",
	CPH: "-2745636",
	VNO: "-2620663",
	KZN: "-2923066",
	SVX: "-3040171",
	DPS: "-2676772",
	CAN: "-1907161",
	SSH: "-302053",
	TCI: "-401686"
}

/**
* Смена параметров поиска
* @param {obj} event.request Запрос
*/
$(document).on("searchRequest_change", function(event){
	try {tw.oCSSelect.firstClassCheck(event.request);} catch(e){}
});

/**
* Смена параметров запроса
* @param {string} event.requestKey Ключ запроса
*/
$(document).on("changeRequest", function(event){
	try {
		var request = objAvia.parseKey(event.requestKey);
		tw.oCSSelect.firstClassCheck(request);
	} catch(e){}
});

/**
* Выбор класса обслуживания
* @param {string} event.cs Класс обслуживания
*/
$(document).on("cs_change", function(event){
	objSearchForm.setCS(event.cs);
});

/**
* Начало поиска
*/
$(document).on("searchStart", function(event){
	if(tw.searchFlight) {
		//kmq
		kmqRecord({name:"SearchStart", obj:tw.searchFlight, prefix: 'SS'});
		//ya
		try {yaCounter18086416.reachGoal('Search');} catch (e) {}

		//ggl
		//_gaq.push(['_trackPageview','/flightsearch']);
		var gglTypeRoad = 1;
		if(tw.searchFlight.TypeRoute != 'oneway'){
			gglTypeRoad = 2;
		}
		try {
			ga('send', 'event', 'search', 'push', tw.searchFlight.cityFrom+'-'+tw.searchFlight.cityTo, gglTypeRoad);
		} catch (e) {}

		//cityads
			window.xcnt_transport_type = 'air';
			window.xcnt_transport_from = tw.searchFlight.cityFrom;
			window.xcnt_transport_to = tw.searchFlight.cityTo;
			window.xcnt_transport_depart_date = tw.searchFlight.startDate;
			window.xcnt_transport_return_date = tw.searchFlight.endDate? tw.searchFlight.endDate : "";1
			try {xcnttrack();} catch (e) {}
	}
});

/**
* Конец поиска
*/
$(document).on("searchFinish", function(event){
	kmqRecord({name: 'SearchFinish'});
	try {
		var _rutarget = window._rutarget || [];
		var arrDir = objAvia.parseKey(event.searchRoute).directions;
		_rutarget.push({"event": "showOffer", 'sku': arrDir[0].from + "_" +arrDir[0].to});
		if(arrDir.length >1 && kmqRouteType(event.searchRoute) == "multiway"){
			for(var skuInd=1, skuLen= arrDir.length; skuInd<skuLen; skuInd++){
				_rutarget.push({"event": "showOffer", 'sku': arrDir[skuInd].from + "_" +arrDir[skuInd].to});
			}
			_rutarget.push({'event': 'addToSegment', 'name':'ott_combinedTrip'});
		}
	} catch (e) {
		console.error(e);
	}
	try {
		sendCriteoEvents({
			type: 'search',
			searchRoute: event.searchRoute
		});
	} catch (e) {
		console.error(e);
	}
	//ga
	try {
		var arrDir = objAvia.parseKey(event.searchRoute).directions;
		var ga_obj = {
			"dimension1": arrDir[0].to,
			"dimension2": "searchresults",
			"dimension4": arrDir[0].from,
			"dimension5": arrDir[0].date.format('yyyy-mm-dd')
		}
		if(arrDir[1]) {
			ga_obj["dimension6"] = arrDir[1].date.format('yyyy-mm-dd')
		}
		$(document.body).trigger({
			"type": "ga_dynmarket",
			"infoData": ga_obj
		});
	} catch (e) {
		console.error(e);
	}
	//ga
	try {
		var arrDir = objAvia.parseKey(event.searchRoute).directions;
		var ga_obj = {
			"dimension1": arrDir[0].to,
			"dimension2": "searchresults",
			"dimension4": arrDir[0].from,
			"dimension5": arrDir[0].date.format('yyyy-mm-dd')
		}
		if(arrDir[1]) {
			ga_obj["dimension6"] = arrDir[1].date.format('yyyy-mm-dd')
		}
		$(document.body).trigger({
			"type": "ga_dynmarket",
			"infoData": ga_obj
		});
	} catch (e) {
		console.error(e);
	}
});

/**
* Показ результатов
*/
$(document).on("resultsShow", function(event){
	try {
		var _rutarget = window._rutarget || [];
		var arrDir = event.infoData.obj.directions;
		if(arrDir.length == 2 && ref.getCityCode(arrDir[0].from) == ref.getCityCode(arrDir[1].to) && ref.getCityCode(arrDir[0].to) == ref.getCityCode(arrDir[1].from) ) {
			_rutarget.push({'event': 'addToSegment', 'name': 'ott_avia', 'value': [ref.getCity(arrDir[0].from).Name,ref.getCity(arrDir[0].to).Name,ref.getCityCode(arrDir[0].from)+''+ref.getCityCode(arrDir[0].to),Math.ceil(convertCurrency(event.infoData.stat.minPrice, tw.currency, "RUB")),'туда и обратно',arrDir[0].date.format('dd.mm.yyyy')+'-'+arrDir[1].date.format('dd.mm.yyyy')].join(',') });
		} else {
			for(var skuInd=0, skuLen= arrDir.length; skuInd<skuLen; skuInd++){
				_rutarget.push({'event': 'addToSegment', 'name': 'ott_avia', 'value': [ref.getCity(arrDir[skuInd].from).Name,ref.getCity(arrDir[skuInd].to).Name,ref.getCityCode(arrDir[skuInd].from)+''+ref.getCityCode(arrDir[skuInd].to),Math.ceil(convertCurrency(event.infoData.stat.minPrice, tw.currency, "RUB")),'в одну сторону',arrDir[skuInd].date.format('dd.mm.yyyy')].join(',') });
			}
		}
	} catch (e) {}
});

/**
* Выбор билета - форма бронирования
*/
$(document).on("selectFare", function(event){
	if (event.selectedFlight) {
		kmqRecord({name: 'SELECT_FARE', obj: event.selectedFlight, prefix: 'SF'});
	}
	try {yaCounter18086416.reachGoal('PriceButton');} catch (e) {}
	try {ga('send', 'pageview', '/pricebuttonclick');} catch (e) {}
	//ga
	try {
		var arrDir = objAvia.parseKey(event.searchRoute).directions;
		var ga_obj = {
			"dimension1": arrDir[0].to,
			"dimension2": "offerdetail",
			"dimension4": arrDir[0].from,
			"dimension5": arrDir[0].date.format('yyyy-mm-dd')
		}
		if(arrDir[1]) {
			ga_obj["dimension6"] = arrDir[1].date.format('yyyy-mm-dd')
		}
		$(document.body).trigger({
			"type": "ga_dynmarket",
			"infoData": ga_obj
		});
	} catch (e) {}
	//ga
	try {
		var arrDir = objAvia.parseKey(event.searchRoute).directions;
		var ga_obj = {
			"dimension1": arrDir[0].to,
			"dimension2": "offerdetail",
			"dimension4": arrDir[0].from,
			"dimension5": arrDir[0].date.format('yyyy-mm-dd')
		}
		if(arrDir[1]) {
			ga_obj["dimension6"] = arrDir[1].date.format('yyyy-mm-dd')
		}
		$(document.body).trigger({
			"type": "ga_dynmarket",
			"infoData": ga_obj
		});
	} catch (e) {}
});

/**
* Успешное бронирование авиа
*/
$(document).on("successBookingAvia", function(event){
	var data = event.bookingData;
	var params = event.bookingParams;
	var Flight = event.selectedFlight;
	var kmqFlight = event.kmqFlight;

	kmqRecord({name: 'RedirectMakeOrder', obj: {"BookWithPromoCode": params.promo?1:0} });
	try {yaCounter18086416.reachGoal('Pay');} catch (e) {};
	try {ga('send', 'pageview', '/gopay');} catch (e) {}

	if(!data || !params || !Flight || !kmqFlight) return;

	//mixpanel
		try {
			var mx_routeType = "OW";
			if(data.params.routeKey.length == 14) {
				mx_routeType = "RT";
			} else if(data.params.routeKey.length > 14) {
				mx_routeType = "OTH";
			}
			var mx_srvCls = "E";
			mx_objServiceClass = {}, mx_ClassCount = 0;
			for (var i = 0, TripsL = data.params.trips.length; i < TripsL; i++) {
				if (!mx_objServiceClass[data.params.trips[i].serviceClass]) {
					mx_objServiceClass[data.params.trips[i].serviceClass] = 1;
					mx_ClassCount++;
				}
			}
			if (mx_ClassCount > 1) {
				mx_srvCls = "M";
			} else {
				if (mx_objServiceClass.F) {
					mx_srvCls = "F";
				} else if (mx_objServiceClass.B) {
					mx_srvCls = "B";
				} else if (mx_objServiceClass.W) {
					mx_srvCls = "W";
				}
			}
			var mx_dirs = tw.oResult.obj.directions.length;
			var mx_dep = new Date(Date.parseAPI(Flight.html_tmpl.StartDate[0]));
			mx_dep.setAPITime(Flight.html_tmpl.StartTime[0].replace(':',''));
			var mx_return = new Date(Date.parseAPI(Flight.html_tmpl.EndDate[ mx_dirs-1 ]));
			mx_return.setAPITime(Flight.html_tmpl.EndTime[ mx_dirs-1 ].replace(':',''));
			var mx_adt = 0;
			var mx_cnn = 0;
			var mx_inf = 0;
			var mx_arrp = [];
			for(var pi = 0, pl = params.passengers.length; pi < pl; pi++) {
				var curp = params.passengers[pi];
				mx_arrp.push(curp.lastName + " " + curp.firstName);
				if(curp.ageType == "INF") {
					mx_inf++;
				} else if(curp.ageType == "CNN") {
					mx_cnn++;
				} else {
					mx_adt++
				};
			}
			var maxJourneyTime = 0;
			var maxStops = 0;
			for(var ti = 0, tl = Flight.TripIds.length; ti < tl; ti++) {
				var curD = Flight.TripIds;
				curJourneyTime = DurationAPIToMinutes(Flight.JourneyTime[ti]);
				if(curJourneyTime > maxJourneyTime) {
					maxJourneyTime = curJourneyTime;
				}
				if(curD.length - 1 > maxStops) {
					maxStops = curD.length - 1;
				}
			}
			var mx_amt = 0;
			var ccFee = data.fare.prcInf.ccFee || 0; //lowCostDuty
			var markupFee = data.fare.prcInf.markupFee || 0; //markup on order
			var mx_amt =  convertCurrency(mx_adt * data.fare.amt + ccFee + markupFee, data.fare.cur, "USD");
			if (data.fare.childPrices) {
				if(data.fare.childPrices.cnnPriceInfo){
					var cnnPriceInfo = data.fare.childPrices.cnnPriceInfo;
					mx_amt += mx_cnn * convertCurrency(cnnPriceInfo.amount, cnnPriceInfo.currency, "USD");
				}
				if (data.fare.childPrices.infPriceInfo) {
					var infPriceInfo = data.fare.childPrices.infPriceInfo;
					mx_amt += mx_inf * convertCurrency(infPriceInfo.amount, infPriceInfo.currency, "USD");
				}
			}
			var mxData = {
				"ID": event.request.id,
				"Key": document.location.hash.substr(1),
				"SearchKey": data.params.routeKey,
				"URL": document.location.href,
				"Created": event.request.createdAt,
				"Email": params.email||"NoInfo",
				"FromCity": kmqFlight.cityFrom,
				"ToCity": kmqFlight.cityTo,
				"FromCountry": kmqFlight.countryFrom,
				"ToCountry": kmqFlight.countryTo,
				"Type": mx_routeType,
				"FromCityName": ref.Cities[kmqFlight.cityFrom].Name,
				"ToCityName": ref.Cities[kmqFlight.cityTo].Name,
				"FromCountryName": ref.Countries[kmqFlight.countryFrom].Name,
				"ToCountryName": ref.Countries[kmqFlight.countryTo].Name,
				"cls": mx_srvCls,
				"Depth": kmqFlight.DepthSearch,
				"Durations": kmqFlight.Duration,
				"Departure": mx_dep.format("isoDateTime"),
				"DepartureMonth": mx_calendar[mx_dep.format("m")-1]+""+mx_dep.format("yyyy"),
				"Return": mx_return.format("isoDateTime"),
				"UserIsAuthorized": (tw.provider) ? "true" : "false",
				"ValidatedAirline": data.fare.pltCrr,
				"ValidatedAirlineName": ref.Airlines[data.fare.pltCrr]||data.fare.pltCrr,
				"OperatedAirlines": String(data.params.Operating).split(','),
				"Stops": maxStops,
				"Segments": String(Flight.TripIds).split(',').length,
				"FarePrice": Math.round(convertCurrency(data.fare.amt,data.fare.cur,"USD")),
				"FlightsTime": maxJourneyTime,
				"FlightsStarPoints": Flight.stars,
				"TotalPassengers": mx_arrp.length,
				"ADT": mx_adt,
				"CHD": mx_cnn,
				"INF": mx_inf,
				"TotalPrice": Math.round(mx_amt),
				"Passengers": mx_arrp,
				"BookWithPromoCode": params.promo?1:0
			};
			MPSaveBookInfo(mxData);
		}
		catch (e) {}


	//cityads
		try {
			window.xcnt_transport_type = 'air';
			window.xcnt_transport_company = data.fare.pltCrr;
			window.xcnt_transport_from = kmqFlight.cityFrom;
			window.xcnt_transport_to = kmqFlight.cityTo;

			var xcnt_dirs = tw.oResult.obj.directions.length;
			var xcnt_dep = new Date(Date.parseAPI(Flight.html_tmpl.StartDate[0]));
			var xcnt_return = new Date(Date.parseAPI(Flight.html_tmpl.EndDate[ xcnt_dirs-1 ]));
			window.xcnt_transport_depart_date = xcnt_dep.format("yyyymmdd");
			window.xcnt_transport_return_date = xcnt_return.format("yyyymmdd");

			window.xcnt_transport_adults = mx_adt;
			window.xcnt_transport_children = mx_cnn+mx_inf;
			var xcnt_cls = "economy";
			switch(mx_srvCls) {
				case "B":
					xcnt_cls = "business";
					break;
				case "F":
					xcnt_cls = "first";
					break;
				case "W":
					xcnt_cls = "premium";
					break;
			}
			window.xcnt_transport_class = xcnt_cls;
			xcnttrack();
		}
		catch (e) {}

	//ga
	try {
		var dirs = tw.oResult.obj.directions.length;
		var ga_dep = new Date(Date.parseAPI(Flight.html_tmpl.StartDate[0]));
		var ga_obj = {
			"dimension1": kmqFlight.cityTo,
			"dimension2": "cart",
			"dimension4": kmqFlight.cityFrom,
			"dimension5": ga_dep.format('yyyy-mm-dd')
		}
		if(dirs == 2) {
			var ga_return = new Date(Date.parseAPI(Flight.html_tmpl.EndDate[ dirs-1 ]));
			ga_obj["dimension6"] = ga_return.format('yyyy-mm-dd')
		}
		$(document.body).trigger({
			"type": "ga_dynmarket",
			"infoData": ga_obj
		});
	} catch (e) {
		console.error(e);
	}
});

$(document).on("visitormanager_auth_complete", function(event) {

});

$(document).on("ga_dynmarket", function(event) {
	try {
		ga('set', event.infoData);
	}
	catch (e) {}
});

$(document).on("ReservationSuccess", function(event) {
});


/**
 * По завершении каждого запроса, в случае ошибки —
 * отправлять запрос в киссметрикс
 *
 * @param {Object} event — jQuery event
 * @param {Object} jqXhr — jQuery xhr
 * @param {Object} settings — ajax settings
 */
$(document).on("ajaxComplete", function(event, jqXhr, settings){
	var status = jqXhr.status;
	var statusText = jqXhr.statusText;
	var url = settings.url;
	if (
		(url.indexOf('/') === 0 || /^https?:\/\/([^/]+\.|)(onetwotrip|twiket)\.(com|ru)($|\/)/ig.test(url))
		&& jqXhr.readyState == 4
		&& +status > 399
	) {
		kmqRecord({
			name: 'ERROR_' + status,
			url: url,
			text: statusText
		});
	}
});

var ref={Languages:["en"],
Countries:{M1:"|Mars",ON:"|Moon",SH:"|Ascension Island/St. Helena",NE:"|Niger",HR:"1|Croatia|45.10|15.20",NR:"|Nauru",CM:"1|Cameroon, United Republic Of",SD:"1|Sudan",HK:"1|Hong Kong",SB:"|Solomon Islands",BE:"1|Belgium",KR:"1|Korea, Republic Of",AL:"1|Albania",MW:"|Malawi",ML:"1|Mali",GN:"1|Guinea",BB:"|Barbados",PK:"1|Pakistan",JO:"1|Jordan",KG:"1|Kyrgyzstan",GL:"|Greenland",VI:"|Virgin Islands U.S.",GA:"1|Gabon",MV:"|Maldives",CZ:"1|Czech Republic|49.82|15.47",GH:"1|Ghana",TV:"|Tuvalu",PL:"1|Poland",MM:"1|Myanmar",TJ:"1|Tajikistan|38.86|71.28",LS:"|Lesotho",DM:"1|Dominica",RO:"1|Romania",KZ:"1|Kazakhstan|48.02|66.92",LR:"1|Liberia",MN:"1|Mongolia",EE:"1|Estonia",CH:"1|Switzerland|46.82|8.23",BW:"1|Botswana",SX:"|Sint Maarten",CW:"|Curacao",MU:"1|Mauritius",AE:"1|United Arab Emirates|24.24|54.88",GW:"1|Guinea Bissau",BI:"1|Burundi",AI:"|Anguilla",MO:"1|Macau",SI:"1|Slovenia",US:"1|United States|37.09|-95.71",NF:"|Norfolk Island","DO":"1|Dominican Republic",RS:"1|Serbia",AW:"|Aruba","IN":"1|India|20.59|78.96",LK:"1|Sri Lanka",CA:"1|Canada|56.13|-106.35",GT:"1|Guatemala",MK:"1|Macedonia",VU:"1|Vanuatu",ER:"1|Eritrea",BF:"1|Burkina Faso",IE:"1|Ireland, Republic Of",BD:"1|Bangladesh",TZ:"1|Tanzania",PM:"|St. Pierre and Miquelon",MC:"1|Monaco",MG:"1|Madagascar (Malagasy)",CG:"1|Congo Republic",UA:"1|Ukraine|48.38|31.17",TT:"1|Trinidad and Tobago",CN:"1|China|35.86|104.20",NC:"|New Caledonia",LY:"1|Libyan Arab Jamahiriya",GR:"1|Greece|39.07|21.82",ZA:"1|South Africa Republic|-30.79|22.94",BQ:"|Bonaire, Saint Eustatius and Saba",RE:"|Reunion",ST:"|Sao Tome and Principe",WF:"|Wallis and Futuna Islands",AB:"|Abkhazia",LT:"1|Lithuania|55.17|23.88",RW:"1|Rwanda",BG:"1|Bulgaria|42.73|25.49",MA:"1|Morocco|31.79|-7.09",AG:"1|Antigua And Barbuda",FK:"|Falkland Islands",MQ:"|Martinique",DK:"1|Denmark|56.26|9.50",ES:"1|Spain|40.46|-3.75",IQ:"1|Iraq",MD:"1|Moldova|47.41|28.37",UG:"1|Uganda",GY:"1|Guyana",TO:"|Tonga",UY:"1|Uruguay",CO:"1|Colombia|4.57|-74.30",CR:"1|Costa Rica",NO:"1|Norway|60.47|8.47",LA:"1|Lao, People's Dem. Rep.",BZ:"|Belize",BJ:"1|Benin",EC:"1|Ecuador",GP:"|Guadeloupe",PR:"1|Puerto Rico",FI:"1|Finland",AM:"1|Armenia|40.07|45.04",PF:"|French Polynesia",MS:"|Montserrat",ME:"1|Montenegro|48.02|66.92",SV:"1|El Salvador",YT:"|Mayotte",PH:"1|Philippines",PT:"1|Portugal|39.40|-8.22",VN:"1|Vietnam|14.06|108.28",LC:"|Saint Lucia",CI:"1|Cote d'Ivoire",PA:"1|Panama",SL:"1|Sierra Leone",MZ:"1|Mozambique",BS:"|Bahamas",BM:"|Bermuda",PY:"1|Paraguay",BN:"|Brunei",OM:"1|Oman, Sultanate Of",WS:"|Samoa, Independent State Of",KP:"1|Korea, Democratic Peoples Republic",TM:"1|Turkmenistan",KI:"|Kiribati",ID:"1|Indonesia|-0.79|113.92",IR:"1|Iran",KH:"1|Cambodia",RU:"1|Russia|55.08|38.80",MT:"1|Malta",MX:"1|Mexico|23.63|-102.55",UZ:"1|Uzbekistan|41.38|64.59",MF:"|Saint Martin",CL:"1|Chile",SC:"|Seychelles Islands",TN:"1|Tunisia",CK:"|Cook Islands",EG:"1|Egypt|26.82|30.80",AK:"|Republic of Crimea|55.08|38.80",QA:"1|Qatar",PW:"|Palau",SA:"1|Saudi Arabia",DJ:"|Djibouti",BH:"1|Bahrain",NG:"1|Nigeria",ZW:"1|Zimbabwe",HT:"1|Haiti","IS":"1|Iceland",YE:"1|Yemen, Republic Of",CC:"|Cocos Islands",NA:"1|Namibia",MP:"|Marianna Islands",TW:"1|Taiwan, Republic of China",SR:"|Suriname",CV:"1|Cape Verde, Republic Of",AZ:"1|Azerbaijan|40.14|47.58",CX:"|Christmas Island",CU:"1|Cuba|21.52|-77.78",PG:"|Papua New Guinea (Niugini)",NI:"1|Nicaragua",BR:"1|Brazil|-14.24|-51.93",GM:"1|Gambia",NU:"|Niue",LB:"1|Lebanon",SO:"|Somalia",BT:"|Bhutan",FO:"|Faeroe Islands",TD:"1|Chad",GI:"|Gibraltar",IL:"1|Israel|31.05|34.85",AR:"1|Argen",NP:"1|Nepal",DZ:"1|Algeria",BA:"1|Bosnia Herzegovina",PS:"1|Occupied Palestinian Territory",FR:"1|France|46.23|2.21",VE:"1|Venezuela",KE:"1|Kenya",KY:"|Cayman Islands","IT":"1|Italy|41.87|12.57",MY:"1|Malaysia",NZ:"1|New Zealand|-40.90|174.89",VC:"1|Saint Vincent And The Grenadines",TG:"1|Togo",PE:"1|Peru",AO:"1|Angola",SG:"1|Singapore",TH:"1|Thailand|15.87|100.99",KM:"1|Comoros",GD:"|Grenada",SN:"1|Senegal",AU:"1|Australia|-25.27|133.78",LV:"1|Latvia",VG:"|British Virgin Islands",BO:"1|Bolivia",GQ:"1|Equatorial Guinea",BL:"|Saint Barthelemy",NL:"1|Netherlands",SE:"1|Sweden",GF:"|French Guiana",GB:"1|United Kingdom|55.38|-3.44",HN:"1|Honduras",CY:"1|Cyprus|35.13|33.43",KN:"1|St. Kitts - Nevis","AS":"|Samoa, American",CD:"1|Congo Democratic Republic Of",GE:"1|Georgia|42.32|43.36",ET:"1|Ethiopia",CF:"|Central African Republic",SK:"1|Slovakia",SZ:"|Swaziland",AF:"1|Afghanistan",JP:"1|Japan|36.20|138.25",FJ:"1|Fiji Islands",DE:"1|Germany|51.17|10.45",SY:"1|Syrian Arab Rep.|34.80|39.00",MR:"|Mauritania",KW:"1|Kuwait",JM:"1|Jamaica|18.11|-77.30",TL:"|Timor Leste",FM:"|Micronesia",GU:"|Guam",ZM:"1|Zambia",TR:"1|Turkey|38.96|35.24",MH:"|Marshall Islands",TC:"|Turks And Caicos Islands",AT:"1|Austria|47.52|14.55",BY:"1|Belarus",LU:"1|Luxembourg",HU:"1|Hungary"},
Cities:{LOP:"Praya|ID|-8.75|116.27|144",GBB:"Gabala|AZ|40.98|47.85|143",OHO:"|RU|59.42|143.05|142",MOW:"Moscow|RU|55.75|37.62|142",GZP:"Alanya|TR|36.30|32.30|141",LON:"London|GB|51.51|-0.13|140",PAR:"Paris|FR|48.85|2.35|139",MAD:"Madrid|ES|40.42|-3.70|138",IEV:"Kiev|UA|50.43|30.52|137",NYC:"New York|US|40.71|-74.01|136",AMS:"Amsterdam|NL|52.37|4.90|135",LED:"St Petersburg|RU|59.89|30.26|134",NCE:"Nice|FR|43.70|7.25|133",GVA:"Geneva|CH|46.20|6.15|132",PRG:"Prague|CZ|50.09|14.42|131",ACE:"Lanzarote|ES|29.00|-13.67|130",MUC:"Munich|DE|48.35|11.78|129",BER:"Berlin|DE|52.52|13.40|128",IST:"Istanbul|TR|41.01|28.95|127",ROV:"Rostov-on-Don|RU|47.23|39.72|126",BCN:"Barcelona|ES|41.39|2.16|125",PKC:"Petropavlovsk Kamchatskiy|RU|53.02|158.65|124",CLJ:"Cluj|RO|46.77|23.60|123",TLV:"Tel Aviv|IL|32.07|34.76|122",KIV:"Chisinau|MD|47.01|28.86|121",VIE:"Vienna|AT|48.11|16.56|120",BEG:"Belgrade|RS|44.82|20.47|119",ZRH:"Zurich|CH|47.37|8.55|118",LIS:"Lisbon|PT|38.72|-9.13|117",FRA:"Frankfurt am Main|DE|50.12|8.68|116",HEL:"Helsinki|FI|60.18|24.93|115",DUS:"Dusseldorf|DE|51.22|6.78|114",OSL:"Oslo|NO|59.91|10.74|113",PMI:"Palma Mallorca|ES|39.55|2.73|112",LCA:"Larnaca|CY|34.92|33.63|112",LAX:"Los Angeles|US|34.05|-118.24|111",BRU:"Brussels|BE|50.85|4.35|111",BUD:"Budapest|HU|47.50|19.08|110",RIX:"Riga|LV|56.95|24.10|109",ZAG:"Zagreb|HR|45.80|16.00|108",WAW:"Warsaw|PL|52.25|21.00|107",ODS:"Odessa|UA|46.48|30.73|106",NUE:"Nuremberg|DE|49.45|11.07|105",LJU:"Ljubljana|SI|46.06|14.51|103",CPH:"Copenhagen|DK|55.68|12.57|104",BKK:"Bangkok|TH|13.75|100.52|102",HAV:"Havana|CU|23.13|-82.36|101",LUX:"Luxembourg|LU|49.61|6.13|100",DUB:"Dublin|IE|53.33|-6.25|98",SFO:"San Francisco|US|37.77|-122.42|99",AER:"Sochi|RU|43.60|39.73|97",LDY:"Londonderry|GB|55.04|-7.15|96",ROM:"Rome|IT|41.90|12.48|95",BUH:"Bucharest|RO|44.43|26.10|94",CBR:"Canberra|AU|-35.28|149.13|93",CAI:"Cairo|EG|30.05|31.25|92",MAN:"Manchester|GB|53.48|-2.24|91",KUF:"Samara|RU|53.20|50.15|90",AYT:"Antalya|TR|36.91|30.69|89",ATH:"Athens|GR|37.98|23.73|89",FAO:"Faro|PT|37.02|-7.93|87",SIP:"Simferopol|AK|44.95|34.10|88",SVX:"Ekaterinburg|RU|56.86|60.61|86",MQJ:"Khonuu|RU|66.27|143.13|85",SCL:"Santiago|CL|-33.45|-70.67|84",STO:"Stockholm|SE|59.33|18.06|84",PIZ:"Point Lay|US|69.76|-163.05|84",SYD:"Sydney|AU|-33.87|151.21|83",HOU:"Houston|US|29.76|-95.36|82",DEL:"Delhi|IN|28.67|77.22|81",DXB:"Dubai|AE|25.25|55.28|79",DPS:"Denpasar Bali|ID|-8.75|115.17|80",ALG:"Algiers|DZ|36.76|3.05|79",BPN:"Balikpapan|ID|-1.27|116.83|78",BOM:"Mumbai|IN|19.01|72.85|77",UTP:"Pattaya|TH|12.68|101.02|76",HKG:"Hong Kong|HK|22.32|113.92|75",MRS:"Marseille|FR|43.30|5.40|74",ALA:"Almaty|KZ|43.25|76.95|74",VCE:"Venice|IT|45.44|12.33|72",KGD:"Kaliningrad|RU|54.71|20.51|73",VLC:"Valencia|ES|39.47|-0.38|72",SSH:"Sharm El Sheik|EG|27.86|34.29|71",ORN:"Oran|DZ|35.69|-0.64|69",OPO:"Porto|PT|41.15|-8.62|70",TIP:"Tripoli|LY|32.89|13.18|68",OVB:"Novosibirsk|RU|55.04|82.93|67",CHI:"Chicago|US|41.85|-87.65|66",MJV:"Murcia|ES|37.98|-1.12|65",GOI:"Goa|IN|15.38|73.83|65",SIN:"Singapore|SG|1.29|103.86|64",TIV:"Tivat|ME|42.44|18.70|64",OMS:"Omsk|RU|55.00|73.40|64",VNO:"Vilnius|LT|54.68|25.32|62",TGD:"Podgorica|ME|42.44|19.26|62",CUN:"Cancun|MX|21.17|-86.85|63",MIA:"Miami|US|25.77|-80.19|63",VVO:"Vladivostok|RU|43.11|131.87|63",EDI:"Edinburgh|GB|55.95|-3.20|61",NQZ:"Nur-Sultan|KZ|51.18|71.43|60",MLA:"Malta|MT|35.90|14.52|59",TYO:"Tokyo|JP|35.69|139.69|58",DOK:"Donetsk|UA|48.00|37.80|57",MIL:"Milan|IT|45.46|9.19|56",KLV:"Karlovy Vary|CZ|50.23|12.87|55",MEX:"Mexico City|MX|19.43|-99.14|55",HAM:"Hamburg|DE|53.55|10.00|55",HRG:"Hurghada|EG|27.26|33.81|53",CEK:"Chelyabinsk|RU|55.15|61.43|54",KRR:"Krasnodar|RU|45.03|38.98|54",LIM:"Lima|PE|-12.05|-77.05|52",UFA:"Ufa|RU|54.73|55.93|52",SKG:"Thessaloniki|GR|40.64|22.94|50",UIO:"Quito|EC|-0.22|-78.50|50",BOS:"Boston|US|42.36|-71.06|51",MSQ:"Minsk|BY|53.90|27.57|49",JKT:"Jakarta|ID|-6.17|106.83|48",CAS:"Casablanca|MA|33.59|-7.61|47",GLA:"Glasgow|GB|55.83|-4.25|47",ATL:"Atlanta|US|33.75|-84.39|47",KZN:"Kazan|RU|55.75|49.13|47",LAS:"Las Vegas|US|35.97|-115.12|47",HNL:"Honolulu|US|21.31|-157.86|45",GOJ:"Nizhniy Novgorod|RU|56.33|44.00|45",CGN:"Cologne|DE|50.93|6.95|45",PEE:"Perm|RU|58.03|56.27|46",BEY:"Beirut|LB|33.87|35.51|44",PHL:"Philadelphia|US|39.95|-75.16|44",BLQ:"Bologna|IT|44.49|11.34|44",LYS:"Lyon|FR|45.75|4.85|42",VOG:"Volgograd|RU|48.80|44.59|43",ETH:"Elat|IL|29.56|34.95|41",NAS:"Nassau|BS|25.08|-77.35|40",CMB:"Colombo|LK|6.93|79.85|39",MNL:"Manila|PH|14.60|120.98|39",MLE:"Male|MV|4.18|73.51|39",KUL:"Kuala Lumpur|MY|3.17|101.70|39",BJS:"Beijing|CN|39.91|116.40|39",YTO:"Toronto|CA|43.70|-79.42|38",CLT:"Charlotte|US|35.23|-80.84|36",CVG:"Cincinnati|US|39.16|-84.46|36",CLE:"Cleveland|US|41.50|-81.70|36",MEM:"Memphis|US|35.15|-90.05|36",MKE:"Milwaukee|US|43.04|-87.91|36",MBJ:"Montego Bay|JM|18.47|-77.92|37",RDU:"Raleigh|US|35.77|-78.64|36",ORK:"Cork|IE|51.90|-8.50|36",BWI:"Baltimore|US|39.29|-76.61|37",BFS:"Belfast|GB|54.58|-5.93|36",STL:"St Louis|US|38.63|-90.20|36",ABZ:"Aberdeen|GB|57.13|-2.10|36",WAS:"Washington|US|38.89|-77.01|35",TAS:"Tashkent|UZ|41.32|69.25|34",NCL:"Newcastle|GB|54.97|-1.61|34",PFO:"Paphos|CY|34.77|32.42|34",REK:"Reykjavik|IS|64.15|-21.95|33",ARH:"Arkhangelsk|RU|64.54|40.54|32",LWO:"Lvov|UA|49.84|24.02|31",AUH:"Abu Dhabi|AE|24.47|54.37|29",MSY:"New Orleans|US|29.95|-90.08|30",ADL:"Adelaide|AU|-34.93|138.60|30",BTS:"Bratislava|SK|48.15|17.12|28",VRN:"Verona|IT|45.43|11.00|28",SOF:"Sofia|BG|42.70|23.32|28",HAN:"Hanoi|VN|21.03|105.85|28",MEL:"Melbourne|AU|-37.81|144.96|27",FRU:"Bishkek|KG|42.87|74.60|27",CAG:"Cagliari|IT|39.21|9.13|27",TJM:"Tyumen|RU|57.15|65.53|27",PWQ:"Pavlodar|KZ|52.30|76.95|26",KEJ:"Kemerovo|RU|55.33|86.08|24",WLG:"Wellington|NZ|-41.28|174.78|24",HKT:"Phuket|TH|7.88|98.40|24",IKT:"Irkutsk|RU|52.30|104.30|24",KIN:"Kingston|JM|18.00|-76.79|24",RIO:"Rio De Janeiro|BR|-22.90|-43.21|24",MTY:"Monterrey|MX|25.67|-100.32|24",ANK:"Ankara|TR|39.93|32.86|25",YMQ:"Montreal|CA|45.52|-73.65|22",BRI:"Bari|IT|41.12|16.85|23",SEZ:"Mahe Island|SC|-4.67|55.52|23",MRV:"Mineralnye Vody|RU|44.21|43.14|22",CYS:"Cheyenne|US|41.14|-104.82|22",ALC:"Alicante|ES|38.35|-0.48|23",DTT:"Detroit|US|42.33|-83.05|22",ANC:"Anchorage|US|61.22|-149.90|22",TRN:"Turin|IT|45.08|7.68|22",SDQ:"Santo Domingo|DO|18.47|-69.90|22",MRU:"Mauritius|MU|-20.30|57.58|22",IBZ:"Ibiza|ES|38.91|1.43|22",SEL:"Seoul|KR|37.57|127.00|21",UBN:"Ulaanbaatar|MN|47.92|106.92|19",MJF:"Mosjoen|NO|65.83|13.20|20",OMO:"Mostar|BA|43.34|17.81|19",RMF:"Marsa Alam|EG|25.63|34.57|20",SKP:"Skopje|MK|42.00|21.43|19",BHX:"Birmingham|GB|52.47|-1.92|20",RTW:"Saratov|RU|51.57|46.03|19",NBO:"Nairobi|KE|-1.28|36.82|20",TBS:"Tbilisi|GE|41.73|44.79|20",DEN:"Denver|US|39.74|-104.98|20",HER:"Heraklion|GR|35.33|25.13|19",IPC:"Easter Island|CL|-27.12|-109.37|17",TLN:"Toulon|FR|43.12|5.93|18",IXL:"Leh IN|IN|34.17|77.58|18",OLB:"Olbia|IT|40.92|9.49|17",FNC:"Funchal|PT|32.63|-16.90|17",HFA:"Haifa|IL|32.82|34.99|17",YVR:"Vancouver|CA|49.25|-123.12|17",PSG:"Petersburg|US|56.80|-132.94|18",SCU:"Santiago|CU|19.97|-75.84|18",TCI:"Tenerife|ES|28.47|-16.25|18",KTT:"Kittila|FI|67.67|24.90|18",BNE:"Brisbane|AU|-27.47|153.03|17",HRK:"Kharkov|UA|50.00|36.25|15",DLM:"Dalaman|TR|36.77|28.80|16",VRA:"Varadero|CU|23.15|-81.25|15",ASF:"Astrakhan|RU|46.34|48.04|15",ADK:"Adak Island|US|51.78|-176.64|15",DFW:"Dallas|US|32.78|-97.30|15",BOD:"Bordeaux|FR|44.83|-0.57|16",KJA:"Krasnoyarsk|RU|56.01|92.79|15",SHA:"Shanghai|CN|31.22|121.46|15",MIR:"Monastir|TN|35.78|10.83|15",TOF:"Tomsk|RU|56.50|84.97|16",YXU:"London|CA|42.98|-81.23|15",CIX:"Chiclayo|PE|-6.77|-79.84|15",RTM:"Rotterdam|NL|51.92|4.48|15",PES:"Petrozavodsk|RU|61.78|34.35|15",TLL:"Tallinn|EE|59.43|24.73|16","VAR":"Varna|BG|43.22|27.92|15",CCS:"Caracas|VE|10.50|-66.92|15",BGI:"Bridgetown|BB|13.10|-59.62|15",INN:"Innsbruck|AT|47.27|11.40|16",KXK:"Komsomolsk Na Amure|RU|50.55|137.01|15",NLI:"Nikolayevsk-on-Amur|RU|16",NTE:"Nantes|FR|47.22|-1.55|13",RNS:"Rennes|FR|48.08|-1.68|13",BTK:"Bratsk|RU|56.13|101.61|13",USM:"Ko Samui|TH|9.50|100.00|14",SZG:"Salzburg|AT|47.80|13.03|13",SPU:"Split|HR|43.51|16.44|13",HAJ:"Hannover|DE|52.37|9.73|14",KGF:"Karaganda|KZ|49.80|73.10|14",NJC:"Nizhnevartovsk|RU|60.93|76.57|14",LXA:"Lhasa|CN|29.65|91.10|13",DBV:"Dubrovnik|HR|42.65|18.09|13",AAR:"Aarhus|DK|56.16|10.21|13",UUD:"Ulan Ude|RU|51.83|107.62|13",VSG:"Lugansk|UA|48.57|39.33|13",BOJ:"Bourgas|BG|42.50|27.47|13",PUJ:"Punta Cana|DO|18.80|-71.57|13",PRN:"Pristina|RS|42.67|21.17|14",SEA:"Seattle|US|47.61|-122.33|13",KTM:"Kathmandu|NP|27.72|85.32|13",SVQ:"Sevilla|ES|37.38|-5.99|13",MCM:"Monte Carlo|MC|43.73|7.42|14",BJV:"Bodrum|TR|37.04|27.43|13",LTT:"St Tropez|FR|43.28|6.63|14",TIA:"Tirana|AL|41.33|19.82|13",EBB:"Entebbe|UG|0.06|32.45|13",AKL:"Auckland|NZ|-36.87|174.77|13",SID:"Sal Island|CV|16.75|-22.95|13",BXN:"Bodrum|TR|37.04|27.43|14",KHV:"Khabarovsk|RU|48.48|135.09|11",STR:"Stuttgart|DE|48.77|9.18|11",JKH:"Chios|GR|38.41|26.02|11",MSN:"Madison|US|43.08|-89.37|11",BRN:"Berne|CH|46.95|7.45|11",PUY:"Pula|HR|44.87|13.85|11",HTA:"Chita|RU|52.03|113.55|11",ASU:"Asuncion|PY|-25.27|-57.67|12",ASP:"Alice Springs|AU|-23.70|133.88|12",DAC:"Dhaka|BD|23.72|90.41|11",EVN:"Yerevan|AM|40.18|44.51|11",RAK:"Marrakech|MA|31.63|-8.00|11",HMO:"Hermosillo|MX|29.07|-110.97|11",ABJ:"Abidjan|CI|5.34|-4.03|11",MSP:"Minneapolis|US|44.98|-93.26|11",OHD:"Ohrid|MK|41.12|20.80|11",RMI:"Rimini|IT|44.06|12.58|11",ASE:"Aspen|US|39.19|-106.82|11",MKC:"Kansas City|US|39.29|-94.73|11",EGS:"Egilsstadir|IS|65.27|-14.39|12",CPO:"Copiapo|CL|-27.37|-70.33|12",DOM:"Dominica|DM|15.54|-61.31|10",APW:"Apia|WS|-13.83|-171.73|8",CUE:"Cuenca|EC|-2.88|-78.98|8",BAH:"Muharraq|BH|26.27|50.64|8",LHE:"Lahore|PK|31.55|74.34|8",RUH:"Riyadh|SA|24.64|46.77|8",BLR:"Bangalore|IN|12.98|77.60|8",LEH:"Le Havre|FR|49.49|0.11|8",AAQ:"Anapa|RU|44.89|37.32|9",MCT:"Muscat|OM|23.61|58.59|9",MGA:"Managua|NI|12.15|-86.27|8",BUS:"Batumi|GE|41.64|41.63|8",SBH:"St Barthelemy|BL|17.90|-62.85|8",KUN:"Kaunas|LT|54.90|23.90|8",IPH:"Ipoh|MY|4.58|101.08|8",KHI:"Karachi|PK|24.87|67.05|8",TOB:"Tobruk|LY|32.08|23.98|8",JMK:"Mykonos|GR|37.45|25.38|8",HOG:"Holguin|CU|20.89|-76.26|9",BIO:"Bilbao|ES|43.26|-2.93|8",KBR:"Kota Bharu|MY|6.13|102.25|8",PIT:"Pittsburgh|US|40.44|-80.00|8",STI:"Santiago|DO|19.47|-70.70|8",ORL:"Orlando|US|28.54|-81.38|9",SFT:"Skelleftea|SE|64.77|20.95|8",LEI:"Almeria|ES|36.83|-2.45|8",CHQ:"Chania|GR|35.51|24.02|8",ARM:"Armidale|AU|-30.52|151.65|8",NAP:"Naples|IT|40.83|14.25|8",DNK:"Dnepropetrovsk|UA|48.45|34.98|8",PTG:"Pietersburg|ZA|-23.90|29.45|8",LPA:"Las Palmas|ES|27.93|-15.38|8",CPT:"Cape Town|ZA|-33.92|18.42|8",ZQN:"Queenstown|NZ|-45.02|168.74|8",DTM:"Dortmund|DE|51.52|7.45|8",MXS:"Maota|WS|-13.72|-172.23|9",MBA:"Mombasa|KE|-4.05|39.67|8",MQF:"Magnitogorsk|RU|53.42|59.05|8",CTA:"Catania|IT|37.50|15.09|8",AUA:"Aruba|AW|12.50|-69.97|8",ZTH:"Zakinthos|GR|37.79|20.90|8",CFG:"Cienfuegos|CU|22.15|-80.44|8",DMM:"Dammam|SA|26.43|50.11|8",LXR:"Luxor|EG|25.70|32.64|9",PSA:"Pisa|IT|43.72|10.40|8",DOH:"Doha|QA|25.29|51.53|8",FLN:"Florianopolis|BR|-27.60|-48.55|9",HUY:"Humberside|GB|53.58|-0.35|8",ITO:"Hilo|US|19.73|-155.09|8",ECN:"Ercan|CY|35.16|33.49|8",ASB:"Ashgabat|TM|37.95|58.38|9",BOB:"Bora Bora|PF|-16.50|-151.75|8",KRK:"Krakow|PL|50.08|19.92|9",LUG:"Lugano|CH|46.01|8.96|8",ISB:"Islamabad|PK|33.61|73.10|8",JED:"Jeddah|SA|21.52|39.22|9",SAO:"Sao Paulo|BR|-23.55|-46.64|9",BOG:"Bogota|CO|4.60|-74.08|8",KWI:"Kuwait|KW|29.37|47.98|8",IZM:"Izmir|TR|38.41|27.15|9",AMM:"Amman|JO|31.95|35.93|8",PRI:"Praslin Island|SC|-4.32|55.73|8",TRV:"Thiruvananthapuram|IN|8.48|76.92|9",CFU:"Kerkyra|GR|39.62|19.92|9",DAM:"Damascus|SY|33.50|36.30|8",DHN:"Dothan|US|31.22|-85.39|8",MOV:"Moranbah|AU|-22.00|148.05|8",OSA:"Osaka|JP|34.69|135.50|6",IKU:"Tamchy|KG|42.58|76.71|7",IND:"Indianapolis|US|39.77|-86.16|4",MOD:"Modesto|US|37.64|-121.00|5",YQB:"Quebec|CA|46.81|-71.21|4",ZAD:"Zadar|HR|44.12|15.24|5",PWM:"Portland|US|43.64|-70.30|4",PPL:"Phaplu|NP|27.52|86.58|4",PPG:"Pago Pago|AS|-14.28|-170.70|4",REP:"Siem Reap|KH|13.37|103.85|4",MPW:"Mariupol|UA|47.07|37.50|5",SGN:"Ho Chi Minh City|VN|10.75|106.67|4",LUZ:"Lublin|PL|51.14|22.34|5",BSB:"Brasilia|BR|-15.78|-47.93|5",PEZ:"Penza|RU|53.20|45.00|4",PZB:"Pietermaritzburg|ZA|-29.62|30.38|4",SGC:"Surgut|RU|61.25|73.42|4",FKL:"Franklin|US|35.93|-86.87|4",ETZ:"Metz Nancy|FR|48.98|6.25|4",IXB:"Bagdogra|IN|26.70|88.32|4",PZE:"Penzance|GB|50.12|-5.54|4",DYR:"Anadyr|RU|64.75|177.48|4",AEY:"Akureyri|IS|65.67|-18.10|4",CGP:"Chittagong|BD|22.33|91.84|5",PNQ:"Pune|IN|18.31|73.55|4",CHC:"Christchurch|NZ|-43.53|172.63|5",JTY:"Astypalaia Island|GR|36.57|26.37|4",BAK:"Baku|AZ|40.40|49.88|4",SMI:"Samos|GR|37.75|26.80|4",OSR:"Ostrava|CZ|49.83|18.28|4",PDX:"Portland|US|45.59|-122.59|4",TAL:"Tanana|US|65.17|-152.08|4",HUN:"Hualien|TW|23.98|121.60|4",AUX:"Araguaina|BR|-7.19|-48.21|4",VXE:"Sao Vicente|CV|16.85|-24.97|4",CNM:"Carlsbad|US|32.34|-104.26|4",DAV:"David|PA|8.43|-82.43|5",YOW:"Ottawa|CA|45.42|-75.69|4",NGO:"Nagoya|JP|35.18|136.91|4",JAI:"Jaipur|IN|26.92|75.82|4",PKV:"Pskov|RU|57.83|28.33|5",YEK:"Arviat|CA|61.11|-94.06|5",SQO:"Storuman|SE|65.10|17.10|4",KLO:"Kalibo|PH|6.35|124.82|4",SUV:"Suva|FJ|-18.13|178.42|4",PUW:"Pullman|US|46.73|-117.18|4",SDY:"Sidney|US|47.71|-104.19|4",TPE:"Taipei|TW|25.04|121.53|4",SJO:"San Jose|CR|9.93|-84.08|4",MAG:"Madang|PG|-5.22|145.80|4",MSS:"Massena|US|44.93|-74.89|4",PNH:"Phnom Penh|KH|11.55|104.92|4",FMN:"Farmington|US|36.73|-108.22|4",MSU:"Maseru|LS|-29.32|27.48|4",CMI:"Champaign|US|40.12|-88.24|4",BUE:"Buenos Aires|AR|-34.58|-58.41|5",DNZ:"Denizli|TR|37.77|29.09|5",AQJ:"Aqaba|JO|29.53|35.01|4",ASR:"Kayseri|TR|38.73|35.49|5",SDF:"Louisville|US|38.27|-85.75|4",FLW:"Santa Cruz Flores|PT|39.45|-31.12|4",MMK:"Murmansk|RU|68.97|33.08|4",MMA:"Malmo|SE|55.60|13.00|5",PTY:"Panama City|PA|8.97|-79.53|4",UUS:"Yuzhno Sakhalinsk|RU|46.95|142.74|5",MFM:"Macau|MO|22.20|113.55|4",USH:"Ushuaia|AR|-54.80|-68.30|5",DAD:"Da Nang|VN|16.07|108.22|5",IXM:"Madurai|IN|9.93|78.12|4",FKB:"Karlsruhe Baden Baden|DE|48.78|8.08|4",ZNE:"Newman|AU|-23.37|119.73|5",NQT:"Nottingham Uk|GB|52.97|-1.17|3",BAX:"Barnaul|RU|53.36|83.76|3",BJU:"Bajura|NP|29.37|81.33|",CKS:"Carajas|BR|-2.95|-51.87|0",HSV:"Huntsville|US|34.64|-86.78|1",OWB:"Owensboro|US|37.77|-87.11|0",TBT:"Tabatinga|BR|-4.25|-69.94|1",NPL:"New Plymouth|NZ|-39.07|174.08|1",AVP:"Scranton|US|41.41|-75.66|1",AFL:"Alta Floresta|BR|-9.90|-55.90|0",BZV:"Brazzaville|CG|-4.26|15.28|1",CCC:"Cayo Coco|CU|23.04|-80.32|1",UIP:"Quimper|FR|48.00|-4.10|1",NKG:"Nanjing|CN|32.06|118.78|0",RSJ:"Rosario|US|48.63|-122.85|",YJT:"Stephenville|CA|48.55|-58.58|0",BZN:"Bozeman|US|45.68|-111.04|1",PHW:"Phalaborwa|ZA|-23.95|31.12|1",OGZ:"Vladikavkaz|RU|43.02|44.67|0",LLF:"Ling Ling|CN|26.70|111.96|0",AIA:"Alliance|US|40.92|-81.11|1",KRQ:"Kramatorsk|UA|48.72|37.62|0",ERM:"Erechim|BR|-27.64|-52.28|",FUK:"Fukuoka|JP|33.58|130.40|0",HRO:"Harrison|US|40.97|-73.71|0",CGQ:"Changchun|CN|43.88|125.32|1",GYS:"Guang Yuan|CN|32.40|105.70|1",MCG:"Mcgrath|US|62.96|-155.60|1",YPL:"Pickle Lake|CA|51.21|-90.21|0",HRI:"Hambantota|LK|6.28|81.12|2",PIE:"St Petersburg|US|27.92|-82.68|0",KEW:"Keewaywin|CA|52.99|-92.84|2",AZR:"Adrar|DZ|36.82|4.30|1",MLX:"Malatya|TR|38.35|38.31|0",BQG:"Bogorodskoe|RU|1",LYR:"Longyearbyen|NO|78.21|15.80|1",KPV:"Perryville|US|37.72|-89.86|1",SJI:"San Jose|PH|12.45|121.15|1",MSR:"Mus|TR|38.73|41.63|0",IOA:"Ioannina|GR|39.67|20.85|0",ZFN:"Tulita/Fort Norman|CA|64.92|-125.57|",SWT:"Strzhewoi|RU|60.50|77.00|0",BEN:"Benghazi|LY|32.12|20.07|1",UAS:"Samburu|KE|-3.77|39.28|1",LBB:"Lubbock|US|33.58|-101.86|1",BHB:"Bar Harbor|US|44.39|-68.20|1",DCG:"|AE|1",WUH:"Wuhan|CN|30.58|114.27|1",LNZ:"Linz|AT|48.31|14.29|1",LPS:"Lopez Island|US|48.48|-122.89|1",KDM:"Kaadedhdhoo|MV|0.49|73.00|2",BFQ:"Bahia Pinas|PA|7.58|-78.17|",KZR:"Kutahya|TR|39.11|30.13|0",GNA:"Grodna|BY|53.68|23.81|1",JPA:"Joao Pessoa|BR|-7.12|-34.86|1",PVU:"Provo|US|40.23|-111.66|1",BZO:"Bolzano|IT|46.49|11.33|1",UTS:"Ust-Tsilma|RU|0.00|0.00|2",ZBR:"Chah-Bahar|IR|25.44|60.38|",MZO:"Manzanillo|CU|20.34|-77.12|1",WNS:"Nawabshah|PK|26.25|68.42|1",AEI:"Algeciras|ES|36.13|-5.45|1",FRE:"Fera Island|SB|-8.10|159.58|1",SUL:"Sui PK|PK|28.65|69.17|1",JMJ:"Lancang Lahu Autonomous County|CN|22.53|99.93|0",PGF:"Perpignan|FR|42.70|2.90|1",BWK:"Bol|HR|43.28|16.68|",COU:"Columbia|US|38.81|-92.22|1",KLU:"Klagenfurt|AT|46.62|14.31|1",JSI:"Skiathos|GR|39.17|23.48|0",BDA:"Bermuda|BM|32.30|-64.75|1",CME:"Ciudad Del Carmen|MX|18.63|-91.83|1",BUX:"Bunia|CD|1.57|30.25|1",UPG:"Ujung Pandang|ID|-5.07|119.55|1",AKU:"Aksu|CN|41.12|80.26|1",MST:"Maastricht|NL|50.85|5.69|1",IBE:"Ibague|CO|4.44|-75.23|0",YMU:"|CA|",HUW:"Kirmington|BR|53.58|-0.35|1",NIN:"Ninilchik|US|60.07|-151.73|1",QYI:"Hilversum|NL|52.22|5.18|0",VCL:"Tamky|VN|15.42|108.70|1",TLH:"Tallahassee|US|30.44|-84.28|0",USN:"Ulsan|KR|35.54|129.32|1",GTS:"Granites|AU|-26.97|133.62|",BLK:"Blackpool|GB|53.82|-3.05|0",LRH:"La Rochelle|FR|46.17|-1.15|1",YCO:"Kugluktuk Coppermine|CA|67.83|-115.08|1",VDB:"Fagernes|NO|60.98|9.25|1",NBC:"Naberezhnye Chelny|RU|55.76|52.43|0",ERH:"Errachidia|MA|31.95|-4.40|",BKM:"Bakalalan|MY|3.97|115.62|1",AVL:"Asheville|US|35.60|-82.55|1",PLQ:"Palanga|LT|55.92|21.07|1",PDB:"Pedro Bay|US|59.78|-154.12|",JDF:"Juiz De Fora|BR|-21.76|-43.35|1",TCQ:"Tacna|PE|-18.01|-70.25|1",LGQ:"Lago Agrio|EC|0.08|-76.88|1",DOY:"Dongying|CN|37.52|118.79|",KDV:"Kandavu|FJ|-19.03|178.38|1",WLS:"Wallis Island|WF|-13.23|-176.17|1",SUX:"Sioux City|US|42.50|-96.40|1",BTM:"Butte|US|46.00|-112.53|1",LAE:"Lae Pg|PG|-6.74|147.00|1",CLQ:"Colima|MX|19.23|-103.72|1",GCI:"Guernsey|GB|49.44|-2.60|1",TMR:"Tamenghest|DZ|22.81|5.46|",AOI:"Ancona|IT|43.60|13.51|1",GAM:"Gambell|US|63.78|-171.74|1",BHY:"Beihai|CN|21.48|109.10|1",ZYI:"Zunyi|CN|27.68|106.90|0",FUG:"Fuyang|CN|32.90|115.82|1",PBD:"Porbandar|IN|21.64|69.61|1",NQU:"Nuqui|CO|5.70|-77.28|1",RST:"Rochester|US|43.91|-92.50|1",BIL:"Billings|US|45.78|-108.50|1",KLL:"Levelock|US|59.11|-156.86|1",PCP:"Príncipe|ST|2",SUG:"Surigao|PH|9.78|125.49|1",SKT:"Sialkot|PK|32.50|74.52|0",HOE:"Houeisay|LA|20.50|103.75|",PKP:"Puka-Puka|PF|-14.75|-138.97|0",YAA:"Anahim Lake|CA|52.45|-125.30|",LQN:"Qala Nau|AF|34.95|63.67|",MRO:"Masterton|NZ|-40.96|175.66|1",STT:"Saint Thomas|VI|18.34|-64.97|0",WNR:"Windorah|AU|-32.37|148.93|1",VDZ:"Valdez|US|61.13|-146.24|1",PVR:"Puerto Vallarta|MX|20.62|-105.23|1",VHZ:"Vahitahi|PF|-18.58|-138.83|",AES:"Alesund|NO|62.47|6.15|0",NYI:"Sunyani|GH|7.33|-2.33|1",TTQ:"Tortuquero|CR|10.57|-83.52|1",YZF:"Yellowknife|CA|62.46|-114.35|1",BUR:"Burbank|US|34.18|-118.31|1",RKD:"Rockland|US|42.13|-70.92|1",QRW:"Warri|NG|5.60|5.82|",NAH:"Naha|ID|3.72|125.37|1",OZH:"Zaporozhe|UA|47.82|35.18|1",PDT:"Pendleton|US|45.67|-118.79|1",BZK:"Briansk|RU|53.27|34.33|0",MTM:"Metlakatla|US|55.13|-131.57|0",PLN:"Pellston|US|45.55|-84.78|0",TWF:"Twin Falls|US|42.56|-114.46|1",CAP:"Cap Haitien|HT|19.76|-72.20|1",ATT:"Atmautluak|US|60.87|-162.27|",SAC:"Sacramento|US|38.58|-121.49|1",TBG:"Tububil|PG|-5.38|141.32|1",YIW:"Yiwu|CN|29.31|120.07|1",NNB:"Santa Ana|SB|-10.83|162.50|1",BJI:"Bemidji|US|47.47|-94.88|1",ZAH:"Zahedan|IR|29.48|60.90|",LSH:"Lashio|MM|22.93|97.75|0",VPG:"Vipingo|KE|1",KSL:"Kassala|SD|15.46|36.40|1",BEM:"Beni Mellal|MA|32.40|-6.32|0",MWZ:"Mwanza|TZ|-2.52|32.90|1",JNS:"Narsaq|GL|77.30|-68.84|1",KOA:"Kona|US|19.73|-156.05|1",AZS:"Samana|DO|19.27|-69.74|",TBN:"Ft Leonard Wood|US|37.74|-92.14|1",TOD:"Tioman|MY|2.75|104.17|0",SQG:"Sintang|ID|0.08|111.58|1",ZBL:"Biloela|AU|-24.42|150.50|0",ABX:"Albury|AU|-36.08|146.92|1",VIS:"Visalia|US|36.33|-119.29|1",MOA:"Moa CU|CU|20.50|-74.88|1",MKY:"Mackay|AU|-21.15|149.20|1",KVK:"Kirovsk|RU|67.58|33.58|",GMO:"|NG|",BCM:"Bacau|RO|46.57|26.90|1",AGM:"Tasiilaq|GL|65.60|-37.68|",YKS:"Yakutsk|RU|62.03|129.73|1",BLZ:"Blantyre|MW|-15.78|35.00|0",LNS:"Lancaster|US|40.12|-76.30|1",ACV:"Eureka|US|40.80|-124.16|1",YKG:"Kangirsuk|CA|60.02|-70.03|0",STM:"Santarem|BR|-2.44|-54.71|0",JIJ:"Jijiga|ET|9.37|42.77|",LXG:"Luang Namtha|LA|21.05|101.47|",MXL:"Mexicali|MX|32.65|-115.47|1",COL:"Coll Island|GB|56.62|-6.62|",NOI:"Novorossiysk|RU|44.72|37.77|0",WWK:"Wewak|PG|-3.55|143.63|1",SIT:"Sitka|US|57.05|-135.33|0",AAT:"Altay|CN|47.87|88.12|1",ILY:"Islay|GB|55.80|-6.20|1",GFK:"Grand Forks|US|47.93|-97.03|1",PCE:"Painter Creek|US|57.16|-157.43|",TIN:"Tindouf|DZ|27.65|-8.21|0",DEF:"Dezful|IR|32.44|48.38|",HRL:"Harlingen|US|26.19|-97.70|1",BKQ:"Blackall|AU|-24.42|145.47|1",PXM:"Puerto Escondido|MX|15.85|-97.07|1",RGI:"Rangiroa Island|PF|-14.97|-147.67|1",SLI:"Solwezi|ZM|-12.17|26.37|",HET:"Hohhot|CN|40.81|111.65|0",EJA:"Barrancabermeja|CO|7.07|-73.85|1",NUS:"Norsup|VU|-16.07|167.38|1",UIH:"Qui Nhon|VN|13.77|109.23|1",MOB:"Mobile|US|30.69|-88.04|1",DAB:"Daytona Beach|US|29.21|-81.02|1",CPE:"Campeche|MX|19.85|-90.53|1",TUE:"Tupile|PA|9.57|-79.49|",TGK:"Taganrog|RU|47.23|38.88|1",AKK:"Akhiok|US|56.95|-154.17|1",PZI:"Panzhihua|CN|26.55|101.73|1",DEB:"Debrecen|HU|47.53|21.63|0",YYQ:"Churchill|CA|58.77|-94.17|1",YGQ:"Geraldton|CA|49.73|-86.95|1",PIP:"Pilot Point|US|33.40|-96.96|1",SLL:"Salalah|OM|17.02|54.08|1",SOY:"Stronsay|GB|59.13|-2.63|1",HUE:"Humera|ET|14.25|36.58|1",ILM:"Wilmington|US|34.27|-77.90|1",YCD:"Nanaimo|CA|49.17|-123.94|0",GEG:"Spokane|US|47.66|-117.43|1",BKW:"Beckley|US|37.78|-81.19|1",KHC:"Kerch|AK|45.37|36.45|0",LRD:"Laredo|US|27.51|-99.51|1",OGS:"Ogdensburg|US|44.69|-75.49|1",SKO:"Sokoto|NG|13.05|5.23|1",LDS:"|CN|",HCN:"Hengchun|TW|22.00|120.74|1",MRA:"Misurata|LY|32.38|15.09|1",PIH:"Pocatello|US|42.87|-112.45|0",GTA:"Gatokae|SB|-8.77|158.18|",VIT:"Vitoria|ES|42.83|-2.50|0",BTR:"Baton Rouge|US|30.45|-91.15|1","FOR":"Fortaleza|BR|-3.72|-38.54|1",TUR:"Tucurui|BR|-3.77|-49.67|1",BCD:"Bacolod|PH|8.12|123.92|1",LYC:"Lycksele|SE|64.60|18.67|1",CZH:"Corozal|BZ|18.38|-88.38|1",BQN:"Aguadilla|PR|18.50|-67.13|1",QBC:"Bella Coola|CA|52.33|-126.67|1",BMY:"Belep Island|NC|-19.75|163.67|1",MEI:"Meridian|US|43.61|-116.39|0",SWJ:"South West Bay|VU|-16.25|167.17|",RCM:"Richmond|AU|-42.74|147.44|1",NAA:"Narrabri|AU|-30.32|149.78|1",CZL:"Constantine|DZ|36.37|6.61|1",YXL:"Sioux Lookout|CA|50.07|-91.98|1",JXA:"|CN|",ORI:"Port Lions|US|57.87|-152.88|1",SXP:"Sheldon Point|US|62.53|-164.83|1",ELD:"El Dorado|US|33.21|-92.67|0",TDK:"Taldy Kurgan|KZ|45.15|78.43|0",EWN:"New Bern|US|35.11|-77.04|1",KHY:"Khoy|IR|38.55|44.95|1",YTH:"Thompson|CA|55.74|-97.86|1",UET:"Quetta|PK|30.19|67.01|1",BDU:"Bardufoss|NO|69.04|18.59|1",SBA:"Santa Barbara|US|34.42|-119.70|1",AUG:"Augusta|US|44.32|-69.80|1",SPN:"Saipan|MP|15.19|145.75|1",SJJ:"Sarajevo|BA|43.85|18.38|1",LUN:"Lusaka|ZM|-15.42|28.28|1",AGH:"Angelholm|SE|56.25|12.87|1",COQ:"Choibalsan|MN|48.13|114.90|",FLS:"Flinder Island|AU|-40.09|148.00|1",RDZ:"Rodez|FR|44.35|2.58|1",HGU:"Mt Hagen|PG|-5.83|144.29|1",LWB:"Lewisburg|US|35.45|-86.79|1",SFJ:"Kangerlussuaq|GL|72.63|-55.63|1",FTE:"El Calafate|AR|-50.28|-72.05|1",SUF:"Lamezia Terme|IT|38.97|16.31|0",DOG:"Dongola|SD|19.18|30.45|1",UNG:"Kiunga|PG|-6.12|141.30|1",LCH:"Lake Charles|US|30.21|-93.20|0",RAE:"Arar|SA|30.90|41.14|",VAG:"Varginha|BR|-21.55|-45.43|1",JGO:"Qeqertarsuaq|GL|62.12|-49.78|1",UUA:"Bugulma|RU|54.62|52.82|0",WWP:"Whale Pass|US|56.67|-133.83|",HMB:"|EG|",FNA:"Freetown|SL|8.49|-13.23|1",PPK:"Petropavlovsk|KZ|54.88|69.16|0",AEH:"Abecher|TD|13.85|20.85|1",CPQ:"Campinas|BR|-22.91|-47.06|1",AAE:"Annaba|DZ|36.90|7.77|1",PFB:"Passo Fundo|BR|-28.26|-52.41|1",KID:"Kristianstad|SE|56.03|14.13|1",RAJ:"Rajkot|IN|22.30|70.78|0",RBV:"Ramata|SB|-8.17|157.64|",KNH:"Kinmen|TW|24.44|118.32|1",HSG:"Saga|JP|33.25|130.30|1",AZD:"Yazd|IR|31.90|54.37|1",DUJ:"Dubois|US|43.53|-109.63|1",ACI:"Alderney|GB|49.73|-2.25|1",DRW:"Darwin|AU|-12.46|130.84|1",WGP:"Waingapu|ID|-9.65|120.27|1",JWN:"Zanjan|IR|36.67|48.48|1",BGM:"Binghamton|US|42.10|-75.92|1",ZOS:"Osorno|CL|-40.57|-73.15|1",GET:"Geraldton|AU|-28.77|114.60|1",TTT:"Taitung|TW|22.75|121.10|1",DEE:"|RU|0.00|0.00|2",SJW:"Shijiazhuang|CN|38.04|114.48|0",MTT:"Minatitlan|MX|17.98|-94.52|1",TMP:"Tampere|FI|61.50|23.79|1",MDE:"Medellin|CO|6.29|-75.54|0",BHO:"Bhopal|IN|23.27|77.40|1",LKN:"Leknes|NO|61.47|5.42|1",VGZ:"Villagarzon|CO|1.07|-76.72|",GUA:"Guatemala City|GT|14.62|-90.53|1",AOS:"Amook Bay|US|57.45|-153.82|1",KCL:"Chignik Lagoon|US|56.32|-158.55|1",RIY:"Riyan|YE|14.65|49.33|1",CBH:"Bechar|DZ|31.62|-2.22|1",NNL:"Nondalton|US|59.98|-154.84|",TRW:"Tarawa|KI|-0.87|169.54|1",TUB:"Tubuai|PF|-23.35|-149.47|",TQL:"|RU|",KUA:"Kuantan|MY|3.80|103.33|0",SUB:"Surabaya|ID|-7.25|112.75|1",TOY:"Toyama|JP|36.68|137.22|1",UKX:"Ust-Kut|RU|56.85|105.73|1",MBE:"Monbetsu|JP|44.35|143.35|1",CIH:"Changzhi|CN|35.21|111.74|1",BNA:"Nashville|US|36.17|-86.78|1",AUW:"Wausau|US|44.96|-89.63|0",ZTB:"Tete A La Baleine|CA|50.72|-59.33|1",MOG:"Mong Hsat|MM|20.53|99.27|",UBS:"Columbus|US|33.47|-88.38|",BIS:"Bismarck|US|46.81|-100.78|1",CJB:"Coimbatore|IN|11.00|76.97|1",YXE:"Saskatoon|CA|52.12|-106.64|1",CFA:"Coffee Point|US|58.22|-157.50|1",ABS:"Abu Simbel|EG|22.37|31.63|1",YGL:"La Grande|CA|53.63|-77.71|1",SAP:"San Pedro Sula|HN|15.50|-88.03|1",BEW:"Beira|MZ|-19.84|34.84|0",SNE:"Sao Nicolau|CV|16.59|-24.29|1",OAZ:"Zaranj|AF|31.10|61.98|",MES:"Medan|ID|3.58|98.67|1",PHS:"Phitsanulok|TH|16.83|100.25|0",DEA:"Dera Ghazi Khan|PK|29.96|70.49|",RJH:"Rajshahi|BD|24.37|88.60|0",NCU:"Nukus|UZ|42.48|59.63|1",YBR:"Brandon|CA|49.90|-99.95|0",BAV:"Baotou|CN|40.65|109.82|1",TII:"Tarinkot|AF|32.87|65.63|2",HHH:"Hilton Head|US|32.22|-80.68|1",KKH:"Kongiganak|US|59.97|-162.75|1",AUR:"Aurillac|FR|44.92|2.45|1",FSP:"St Pierre|PM|46.92|-56.17|1",PYC:"Playon Chico|PA|9.57|-79.61|",WNH:"|CN|",PNV:"Panevezys|LT|55.73|24.38|0",YQL:"Lethbridge|CA|49.70|-112.82|1",BNI:"Benin City|NG|6.33|5.63|1",KTA:"Karratha|AU|-20.73|116.86|1",VVC:"Villavicencio|CO|4.08|-73.57|",CGB:"Cuiaba|BR|-15.60|-56.10|1",JCH:"Qasigiannguit|GL|68.82|-51.18|0",ZKE:"Kaschechewan|CA|52.33|-81.33|",RNA:"Arona|SB|-9.86|161.98|",MWQ:"Magwe|MM|20.15|94.92|1",CMG:"Corumba|BR|-19.01|-57.65|1",AGT:"Ciudad Del Este|PY|-25.52|-54.62|1",MOF:"Maumere|ID|-8.62|122.23|1",BHQ:"Broken Hill|AU|-31.95|141.43|0",RZS:"Sawan|PK|26.97|68.87|",KUU:"Kulu|IN|31.98|77.10|1",SJK:"Sao Jose dos Campos|BR|-23.18|-45.89|0",MVD:"Montevideo|UY|-34.86|-56.17|0",RYK:"Rahim Yar Khan|PK|28.39|70.29|",CMH:"Columbus|US|39.99|-82.88|1",YXS:"Prince George|CA|53.92|-122.75|1",WNZ:"Wenzhou|CN|28.02|120.65|1",BKI:"Kota Kinabalu|MY|5.98|116.07|1",UII:"Utila|HN|16.09|-86.89|",BBA:"Balmaceda|CL|-45.92|-71.68|1",BEV:"Beersheba|IL|31.23|34.78|0",AUS:"Austin|US|30.27|-97.74|1",HCR:"Holy Cross|US|42.60|-91.22|1",SCZ:"Santa Cruz Island|SB|-11.62|166.85|0",AJA:"Ajaccio|FR|41.92|8.73|0",APO:"Apartado|CO|7.89|-76.63|1",BAJ:"Bali|PG|-4.83|149.13|0",OUZ:"Zouerate|MR|22.69|-12.46|1",GUW:"Atyrau|KZ|47.12|51.88|0",KAO:"Kuusamo|FI|65.97|29.18|1",GUM:"Guam|GU|13.44|144.74|1",MAB:"Maraba|BR|-5.37|-49.12|1",JLN:"Joplin|US|37.08|-94.51|1",SCK:"Stockton|US|37.96|-121.29|0",OUK:"Outer Skerries|GB|60.42|-0.75|",AGR:"Agra|IN|27.18|78.02|0",ZAJ:"Zaranj|AF|31.10|61.98|2",GVN:"Sovetskaya Gavan|RU|2",SEB:"Sebha|LY|27.02|14.46|",VIX:"Vitoria|BR|-20.32|-40.34|1",MEA:"Macae|BR|-22.37|-41.79|1",ROS:"Rosario|AR|-32.95|-60.67|1",KMV:"Kalemyo|MM|23.18|94.07|0",SCE:"State College|US|40.79|-77.86|1",GOV:"Gove|AU|-12.23|136.77|1",LLW:"Lilongwe|MW|-13.98|33.78|1",LPI:"Linkoping|SE|58.42|15.62|1",SYX:"Sanya|CN|18.24|109.50|1",KME:"Kamembe|RW|-2.47|28.92|",OLZ:"Olyokminsk|RU|60.39|120.52|0",FUJ:"Fukue|JP|32.69|128.84|1",NQN:"Neuquen|AR|-38.95|-68.07|1",SNS:"Salinas|EC|-2.22|-80.95|0",UKS:"Sevastopol|AK|44.69|33.58|0",ALH:"Albany|AU|-35.02|117.89|0",GUR:"Alotau|PG|-10.30|150.42|0",NVI:"Navoi|UZ|40.08|65.38|1",TUP:"Tupelo|US|34.26|-88.70|1",BXH:"Balhash|KZ|46.88|75.02|0",KWF:"Waterfall|US|55.30|-133.24|",MKZ:"Malacca|MY|2.20|102.25|1",IRZ:"Santa Isabel Rio Negro|BR|-0.38|-65.00|1",AHO:"Alghero|IT|40.56|8.32|1",MZT:"Mazatlan|MX|23.22|-106.42|1",HVG:"Honningsvag|NO|70.98|25.98|1",GLN:"Goulimime|MA|29.02|-10.07|",ESD:"East Sound|US|48.60|-122.84|1",TMM:"Tamatave|MG|-18.17|49.38|1",LMM:"Los Mochis|MX|25.77|-108.97|0",OER:"Ornskoldsvik|SE|63.30|18.72|0",PGA:"Page|US|36.91|-111.46|0",VLN:"Valencia|VE|10.18|-68.00|0",NDJ:"N Djamena|TD|12.11|15.05|1",CAN:"Guangzhou|CN|23.12|113.25|1",POL:"Pemba|MZ|-12.96|40.51|1",USR:"Ust-Nera|RU|64.54|143.17|0",KEB:"Nanwalek|US|59.35|-151.92|",TEX:"Telluride|US|37.94|-107.81|1",JYV:"Jyvaskyla|FI|62.23|25.73|0",MAU:"Maupiti|PF|-16.45|-152.25|1",JIU:"Jiujiang|CN|29.73|115.98|1",KTG:"Ketapang|ID|-6.12|106.95|1",YBE:"Uranium City|CA|59.57|-108.62|1",YAP:"Yap FM|FM|9.48|138.08|1",ZPB:"Sachigo Lake|CA|53.89|-92.20|",WRG:"Wrangell|US|56.47|-132.38|1",ENH:"Enshi|CN|30.32|109.48|",MEE:"Mare|NC|-21.57|168.00|1",YHP:"Poplar Hill|CA|52.08|-94.30|",JOS:"Jos NG|NG|9.87|8.89|1",MZG:"Makung|TW|23.57|119.62|0",YAM:"Sault Ste Marie|CA|46.48|-84.51|1",YNC:"Wemindji|CA|53.00|-78.82|",YKF:"Kitchener|CA|43.45|-80.48|1",OZG:"Zagora|MA|30.27|-5.85|1",CRM:"Catarman|PH|12.48|124.58|2",MDZ:"Mendoza|AR|-32.88|-68.82|1",GIZ:"Gizan|SA|16.87|42.58|1",MQP:"Nelspruit|ZA|-25.38|31.10|",BYF:"Albert|FR|1",ISU:"Sulaimaniyah|IQ|35.56|45.31|",CBT:"Catumbela|AO|-12.48|13.48|",YTM:"Mont-Tremblant|CA|46.25|-74.58|0",GER:"Nueva Gerona|CU|21.88|-82.80|1",CPA:"Cape Palmas|LR|4.38|-7.70|",GNM:"Guanambi|BR|-14.30|-42.78|1",VPS:"Valparaiso|US|30.49|-86.53|1",JJU:"Qaqortoq|GL|60.72|-46.03|1",KCK:"Kirensk|RU|0",BSX:"Bassein|MM|16.80|94.78|",JPR:"Ji Parana|BR|-10.89|-61.95|1",KOV:"Kokshetau|KZ|53.32|69.40|1",PHO:"Point Hope|US|68.35|-166.81|1",GCW:"|US|",FOG:"Foggia|IT|41.46|15.55|1",BNK:"Ballina|AU|-28.87|153.57|0",STD:"Santo Domingo|VE|7.58|-72.07|1",JQA:"Qaarsut|GL|70.73|-52.65|1",CHT:"Chatham Island|NZ|-43.80|-176.35|1",SJU:"San Juan|PR|18.44|-66.00|1",GXF:"Seiyun|YE|15.96|48.79|",REN:"Orenburg|RU|51.78|55.12|1",KAC:"Kameshli|SY|37.03|41.20|1",KRY:"Karamay|CN|45.58|84.89|0",CRA:"Craiova|RO|44.32|23.80|1",ASJ:"Amami O Shima|JP|28.42|129.70|1",MZV:"Mulu|MY|4.03|114.80|0",WSX:"Westsound|US|48.67|-122.88|",KCZ:"Kochi|JP|33.54|133.68|1",OMR:"Oradea|RO|47.07|21.93|1",LEC:"Lencois|BR|-13.82|-41.72|1",SXR:"Srinagar|IN|34.08|74.82|1",ODE:"Odense|DK|55.40|10.38|0",KNK:"Kakhonak|US|59.43|-154.85|",IMP:"Imperatriz|BR|-5.53|-47.49|1",AMQ:"Ambon|ID|-3.72|128.20|0",CRI:"Crooked Island|BS|22.75|-74.22|1",CEJ:"Chernigov|UA|51.50|31.30|0",SFG:"Saint Martin|MF|18.05|-63.12|0",YQK:"Kenora|CA|49.82|-94.43|1",SGY:"Skagway|US|59.46|-135.31|1",ZSE:"St Pierre Dela Reunion|RE|-21.33|55.48|1",YEV:"Inuvik|CA|68.35|-133.72|1",KVD:"GANJA|AZ|40.74|46.32|0",OVS:"SOVETSKY|RU|43.26|-90.74|2",YTY:"Yangzhou|CN|32.40|119.42|0",SEY:"Selibaby|MR|15.18|-12.21|1",BRM:"Barquisimeto|VE|10.07|-69.32|1",PMC:"Puerto Montt|CL|-41.47|-72.94|1",KSM:"St Marys|US|62.06|-163.30|1",TOU:"Touho|NC|-20.80|165.25|",YWB:"Kangiqsujuaq|CA|61.60|-71.96|0",GKA:"Goroka|PG|-6.08|145.38|1",BAZ:"Barcelos|BR|-0.97|-62.93|2",RES:"Resistencia|AR|-27.45|-58.98|1",VUS:"Velikij Ustyug|RU|60.77|46.32|0",IPI:"Ipiales|CO|0.83|-77.64|1",PMV:"Porlamar|VE|10.95|-63.85|0",JTC:"Bauru|BR|0.00|0.00|2",NTG:"Nantong|CN|32.03|120.88|1",HJR:"Khajuraho|IN|24.85|79.93|1",GRB:"Green Bay|US|44.52|-88.02|1",YNA:"Natashquan|CA|50.17|-61.75|1",MLO:"Milos|GR|36.75|24.43|1",YZR:"Sarnia|CA|42.97|-82.38|1",DDC:"Dodge City|US|37.75|-100.02|1",BWW:"|CU|",LEJ:"Leipzig|DE|51.34|12.37|1",ABD:"Abadan|IR|30.35|48.30|1",BXU:"Butuan|PH|8.95|125.54|1",KLF:"Kaluga|RU|54.50|36.27|0",ASV:"Amboseli|KE|-2.63|37.25|",LOO:"Laghouat|DZ|33.83|2.98|2",BIA:"Bastia|FR|42.70|9.45|1",NLG:"Nelson Lagoon|US|56.00|161.15|",SJP:"Sao Jose Do Rio Preto|BR|-20.82|-49.38|1",BEU:"Bedourie|AU|-24.35|139.47|1",KZB:"Zachar Bay|US|57.56|-153.77|1",KLR:"Kalmar|SE|56.67|16.37|1",HBA:"Hobart|AU|-42.92|147.33|1",DNR:"Dinard|FR|48.63|-2.07|1",KAL:"Kaltag|US|64.33|-158.72|0",YKA:"Kamloops|CA|50.67|-120.32|1",SKZ:"Sukkur|PK|27.70|68.87|1",EZV:"Beryozovo|RU|0.00|0.00|2",JJN:"Jinjiang|CN|24.88|118.60|1",AIT:"Aitutaki|CK|-18.86|-159.79|1",SIC:"Sinop|TR|42.02|35.07|",GCM:"Grand Cayman Island|KY|19.29|-81.36|0",KMY:"Moser Bay|US|56.99|-154.15|1",COD:"Cody|US|44.53|-109.06|1",ACU:"Achutupo|PA|9.58|-79.72|",TWA:"Twin Hills|US|59.08|-160.28|0",JOG:"Yogjakarta|ID|-7.79|110.43|1",PDV:"Plovdiv|BG|42.15|24.75|0",BRO:"Brownsville|US|25.90|-97.50|1",JUJ:"Jujuy|AR|-24.18|-65.30|1",CCJ:"Kozhikode|IN|11.25|75.77|1",SKU:"Skiros|GR|38.88|24.53|1",YHI:"Holman Island|CA|70.65|-117.73|1",LAN:"Lansing|US|42.73|-84.56|1",YRC:"|CA|",NLT:"|CN|",THX:"Turukhansk|RU|2",ZCO:"Temuco|CL|-38.73|-72.60|0",SNU:"Santa Clara|CU|22.40|-79.97|1",BSO:"Basco|PH|20.45|121.98|",PNS:"Pensacola|US|30.42|-87.22|0",YFC:"Fredericton|CA|45.95|-66.67|1",FON:"Fortuna|CR|10.40|84.48|",MAF:"Midland|US|32.00|-102.08|1",YQD:"The Pas|CA|53.83|-101.25|1",PIX:"Pico Island|PT|38.47|-28.33|1",SRZ:"Santa Cruz|BO|-17.80|-63.17|1",BDJ:"Banjarmasin|ID|-3.33|114.58|1",CYB:"Cayman Brac|KY|19.72|-79.82|1",PPP:"Proserpine|AU|-20.42|148.58|1",SWA:"Shantou|CN|23.36|116.68|1",TRO:"Taree|AU|-31.90|152.47|1",AOR:"Alor Setar|MY|6.12|100.37|1",KIJ:"Niigata|JP|37.92|139.05|1",DBQ:"Dubuque|US|42.50|-90.66|1",RWN:"Rovno|UA|50.60|26.15|0",IXD:"Allahabad|IN|25.45|81.85|1",OSS:"Osh|KG|40.62|72.82|1",RIB:"Riberalta|BO|-10.98|-66.10|1",YSM:"Ft Smith|CA|60.02|-111.97|1",FRO:"Floro|NO|61.60|5.00|0",BJA:"Bejaia|DZ|36.75|5.08|1",MPI:"Mamitupo|PA|9.58|-79.84|",IGD:"Igdir|TR|39.92|44.04|0",NER:"Neryungri|RU|56.65|124.60|1",MRY:"Monterey|US|36.60|-121.89|1",MOZ:"Moorea|PF|-17.53|-149.83|1",PER:"Perth|AU|-31.93|115.83|1",PHX:"Phoenix|US|33.45|-112.07|1",TYS:"Knoxville|US|35.96|-83.92|1",DGE:"Mudgee|AU|-32.43|149.58|1",ADZ:"San Andres|CO|12.58|-81.70|1",OOL:"Gold Coast|AU|-28.00|153.43|1",YTL:"Big Trout|CA|53.82|-89.89|",BOY:"Bobo Dioulasso|BF|11.20|-4.30|0",ELV:"Elfin Cove|US|58.19|-136.34|1",LBL:"Liberal|US|37.04|-100.92|1",VLL:"Valladolid|ES|41.65|-4.72|1",PGV:"Greenville|US|35.63|-77.39|0",MAM:"Matamoros|MX|25.88|-97.50|1",ROW:"Roswell|US|34.02|-84.36|1",CRV:"Crotone|IT|39.09|17.12|1",LOD:"Longana|VU|-15.32|167.97|1",OLF:"Wolf Point|US|48.09|-105.64|0",PVA:"Providencia|CO|13.35|-81.35|",JST:"Johnstown|US|40.33|-78.92|0",LOH:"Loja|EC|-3.99|-79.20|1",XGR:"Kangiqsualujjuaq|CA|58.69|-65.95|1",ZKP:"Zyryanka|RU|65.75|150.90|0",SOG:"Sogndal|NO|58.33|6.30|1",VOL:"Volos|GR|39.37|22.95|0",GZO:"Gizo|SB|-8.12|156.83|0",KNG:"Kaimana|ID|-3.65|133.75|1",VER:"Veracruz|MX|19.20|-96.13|1",YBL:"Campbell River|CA|50.02|-125.25|1",KYP:"Kyaukpyu|MM|22.87|96.43|1",PKR:"Pokhara|NP|28.23|83.98|1",PND:"Punta Gorda|BZ|16.10|-88.80|0",MDU:"Mendi|PG|-6.15|143.65|1",BAL:"Batman|TR|37.92|41.08|2",FYV:"Fayetteville|US|36.00|-94.17|1",ROC:"Rochester|US|43.12|-77.67|1",TRG:"Tauranga|NZ|-37.69|176.17|1",SSR:"Sara|VU|-15.50|168.30|",PLW:"Palu|ID|-0.90|119.86|1",EYW:"Key West|US|24.56|-81.78|1",CSH:"Solovetsky|RU|65.03|35.73|2",NME:"Nightmute|US|60.48|-164.72|1",FAH:"Farah|AF|32.37|62.12|2",SRP:"Stord|NO|59.88|5.42|1",EDO:"Edremit|TR|39.58|27.03|2",XKH:"Xieng Khouang|LA|19.20|102.72|1",MKP:"Makemo|PF|-16.45|-143.67|1",TLS:"Toulouse|FR|43.60|1.44|1",HYD:"Hyderabad|IN|17.38|78.47|1",MUH:"Mersa Matruh|EG|31.35|27.25|",DJB:"Jambi|ID|-1.60|103.62|1",PEW:"Peshawar|PK|34.01|71.57|1",MCV:"McArthur River|AU|-16.47|136.09|",LRM:"La Romana|DO|18.42|-68.97|1",MMH:"Mammoth Lakes|US|37.65|-118.97|1",ALO:"Waterloo|US|42.56|-92.40|1",RSD:"Rock Sound|BS|24.90|-76.20|1",TIZ:"Tari|PG|-5.86|142.94|1",VSA:"Villahermosa|MX|17.98|-92.92|1",DYU:"Dushanbe|TJ|38.56|68.77|1",SHX:"Shageluk|US|62.68|-159.56|1",ICT:"Wichita|US|37.69|-97.34|1",OIM:"Oshima|JP|37.12|138.50|1",HUS:"Hughes|US|34.95|-90.47|1",YHZ:"Halifax|CA|44.65|-63.60|1",RAB:"Rabaul|PG|-4.20|152.18|1",IZO:"Izumo|JP|35.37|132.77|1",TGJ:"Tiga|NC|-21.10|167.80|",JBQ:"Higuero|DO|",NLA:"N Dola|ZM|-12.97|28.63|1",HWN:"Hwange|ZW|-18.37|26.48|0",CKG:"Chongqing|CN|29.56|106.55|0",ART:"Watertown|US|43.99|-76.02|1",CYF:"Chefornak|US|60.16|-164.27|1",SAX:"Sambu|PA|8.03|-78.08|",UTN:"Upington|ZA|-28.45|21.25|0",NSN:"Nelson|NZ|-41.30|173.22|1",VRL:"Vila Real|PT|41.30|-7.75|1",WNP:"Naga|PH|13.59|123.27|",BRQ:"Brno|CZ|49.20|16.61|1",BUF:"Buffalo|US|42.89|-78.88|1",SDD:"Lubango|AO|-14.92|13.50|1",GFN:"Grafton|AU|-29.68|152.93|1",DVO:"Davao|PH|7.07|125.61|1",CFN:"Donegal|IE|54.65|-8.12|1",MLI:"Moline|US|41.51|-90.52|1",TMC:"Tambolaka|ID|-9.34|119.18|",NNG:"Nanning|CN|22.82|108.32|1",KOJ:"Kagoshima|JP|31.60|130.55|0",NAL:"Nalchik|RU|43.50|43.61|1",UND:"Kunduz|AF|36.66|68.91|",CID:"Cedar Rapids|US|42.01|-91.64|1",YSO:"Postville|CA|54.92|-59.97|1",CNQ:"Corrientes|AR|-27.47|-58.83|1",FRS:"Flores|GT|16.92|-89.88|1",SGD:"Sonderborg|DK|54.92|9.78|1",BKO:"Bamako|ML|12.65|-8.00|1",GYU:"Guyuan|CN|36.02|106.25|0",KNU:"Kanpur|IN|26.47|80.35|1",CEM:"Central|US|65.57|-144.78|1",YKH:"Yingkou|CN|40.67|122.23|0",NIB:"Nikolai|US|63.01|-154.38|1",GSO:"Greensboro|US|36.07|-79.79|0",LRR:"Lar|IR|27.67|54.38|",BJT:"Bentota River|LK|6.48|79.98|1",RVT:"Ravensthorpe|AU|-33.58|120.03|1",YBB:"Pelly Bay|CA|68.88|-90.08|1",GNY:"Sanliurfa|TR|40.17|-105.92|2",TLK:"Talakan|RU|2",AKS:"Akui|SB|-8.70|160.68|1",NGQ:"|CN|",RMT:"Rimatara|PF|0.00|0.00|2",UDJ:"Uzhgorod|UA|48.62|22.28|0",EKO:"Elko|US|40.83|-115.76|1",NHV:"Nuku Hiva|PF|-8.90|-140.10|1",BLE:"Borlange|SE|60.48|15.42|1",TAG:"Tagbilaran|PH|9.65|123.86|0",GMA:"Gemena|CD|3.25|19.77|1",LEA:"Learmonth|AU|-37.42|143.73|1",UNN:"Ranong|TH|9.97|98.63|1",VCA:"Can Tho|VN|10.03|105.78|1",ABL:"Ambler|US|40.15|-75.22|1",NAK:"Nakhon Ratchasima|TH|14.97|102.10|1",EVG:"Sveg|SE|62.03|14.35|1",COK:"Kochi|IN|9.97|76.23|1",YPX:"Puvirnituq|CA|60.03|-77.28|1",DLZ:"Dalanzadgad|MN|43.97|104.68|",DAR:"Dar Es Salaam|TZ|-6.80|39.28|1",KLX:"Kalamata|GR|37.04|22.11|0",VHV:"Verkhnevilyuysk|RU|63.45|120.30|0",YWL:"Williams Lake|CA|52.14|-122.14|1",AWD:"Aniwa|VU|-19.25|169.50|1",CBG:"Cambridge|GB|52.20|0.12|0",CDT:"Castellón de la Plana|ES|39.98|-0.03|0",PKB:"Parkersburg|US|39.27|-81.56|1",KVX:"Kirov|RU|58.50|49.35|",PIN:"Parintins|BR|-2.63|-56.74|1",LOK:"Lodwar|KE|3.15|35.60|",ZAL:"Valdivia|CL|-39.81|-73.25|1",KWT:"Kwethluk|US|60.81|-161.44|1",CFS:"Coffs Harbour|AU|-30.30|153.13|1",KHN:"Nanchang|CN|28.68|115.88|1",NZE:"Nzerekore|GN|7.81|-8.70|",TOS:"Tromso|NO|69.67|18.97|1",CKX:"Chicken|US|64.07|-141.94|1",AGF:"Agen|FR|44.20|0.63|1",FYJ:"Fuyuan|CN|48.35|134.28|0",VPY:"Chimoio|MZ|-19.13|33.48|",ERZ:"Erzurum|TR|39.91|41.28|0",KIM:"Kimberley|ZA|-28.73|24.77|1",KXU:"Katiu|PF|-16.34|-144.40|",UMD:"Uummannaq|GL|70.67|-52.12|",GEV:"Gallivare|SE|67.13|20.70|1",SMS:"Saint Marie|MG|-17.08|49.82|1",BZE:"Belize City|BZ|17.50|-88.20|1",BWE:"Braunschweig|DE|52.27|10.53|1",ATD:"Atoifi|SB|-8.87|161.03|2",JKL:"Kalymnos Island|GR|37.69|-83.32|1",AJR:"Arvidsjaur|SE|65.58|19.17|1",JOK:"Joshkar-Ola|RU|56.72|47.90|1",CEB:"Cebu|PH|10.31|123.89|1",PBI:"West Palm Beach|US|26.72|-80.05|1",RVV:"Rairua|PF|-25.88|-147.65|",ZTA:"Tureira|PF|-20.82|-138.50|",BVG:"Berlevag|NO|70.85|29.10|1",IHR:"Iran Shahr|IR|27.23|60.72|",MMZ:"Maimana|AF|35.92|64.73|",SML:"Stella Maris|BS|23.60|-75.30|1",LMY:"Lake Murray|PG|-6.80|141.43|1",JAC:"Jackson|US|43.61|-110.74|1",YMH:"Mary's Harbour|CA|52.30|-55.83|2",ABY:"Albany|US|31.53|-84.20|1",YOP:"Rainbow Lake|CA|58.50|-119.39|1",BTH:"Batam|ID|1.08|104.05|1",INC:"Yinchuan|CN|38.47|106.27|1",TNN:"Tainan|TW|22.95|120.20|0",CDR:"Chadron|US|42.83|-103.00|1",SHW:"Sharurah|SA|17.42|47.10|1",KRG:"Karasabai|GY|4.02|-59.52|1",KGE:"Kagau|SB|-8.16|157.59|",TSJ:"Tsushima|JP|35.17|136.72|1",OSM:"Mosul|IQ|36.34|43.12|1",MNG:"Maningrida|AU|-12.05|134.23|",NUX:"Novy Urengoy|RU|66.08|76.52|1",PMA:"Pemba|TZ|-5.24|39.80|1",HTN:"Hotan|CN|37.10|79.93|1",GBD:"Great Bend|US|38.36|-98.76|1",MOQ:"Morondava|MG|-20.28|44.28|1",ASA:"Assab|ER|13.01|42.74|1",TAT:"Poprad|SK|49.07|20.24|0",PKA:"Napaskiak|US|60.71|-161.77|1",DJG:"Djanet|DZ|24.55|9.48|1",JGN:"Jiayuguan|CN|39.82|98.30|1",SAN:"San Diego|US|32.72|-117.16|1",YCK:"Colville|CA|67.17|-126.00|1",FMY:"Fort Myers|US|26.62|-81.84|1",CCM:"Criciuma|BR|-28.68|-49.37|1",RAO:"Ribeirao Preto|BR|-21.18|-47.81|1",WAE:"Wadi Ad Dawasir|SA|20.50|45.20|",QPA:"Padova|IT|45.42|11.88|0",SJL:"Sao Gabriel|BR|-30.33|-54.33|",BES:"Brest|FR|48.45|-4.42|1",CTL:"Charleville|AU|-26.40|146.25|1",CKH:"Chokurdah|RU|70.63|147.88|1",WJU:"WonJu|KR|37.43|37.43|",NST:"Nakhon Si Tham|TH|8.47|99.95|1",YTE:"Cape Dorset|CA|64.23|-76.54|1",FOC:"Fuzhou|CN|26.06|119.31|1",SVA:"Savoonga|US|63.69|-170.48|1",VXC:"Lichinga|MZ|-13.28|35.25|",YOC:"Old Crow|CA|67.58|-139.83|1",BKC:"Buckland|US|42.59|-72.79|1",INA:"Inta|RU|66.07|60.10|0",KSN:"Kostanay|KZ|53.17|63.58|0",SXB:"Strasbourg|FR|48.58|7.75|1",AJL:"Aizawl|IN|23.73|92.72|0",ZHA:"Zhangjiang|CN|28.90|111.48|1",JGA:"Jamnagar|IN|22.47|70.07|1",ATK:"Atqasuk|US|70.47|-157.40|1",LEN:"Leon|ES|42.60|-5.57|0",TMI:"Tumling Tar|NP|27.30|87.20|",POZ:"Poznan|PL|52.42|16.97|1",NBS:"|CN|",JHS:"Sisimiut|GL|66.93|-53.68|1",POA:"Porto Alegre|BR|-30.03|-51.23|1",SSA:"Salvador|BR|-12.97|-38.51|1",EWB:"New Bedford|US|41.64|-70.93|1",WST:"Westerly|US|41.38|-71.83|0",MMY:"Miyako Jima|JP|24.78|125.30|1",MAR:"Maracaibo|VE|10.63|-71.64|1",HIJ:"Hiroshima|JP|34.40|132.45|1",WRY:"Westray|GB|59.30|-3.00|0",ELM:"Elmira|US|42.09|-76.81|1",HLN:"Helena|US|46.59|-112.04|1",IRJ:"La Rioja|AR|-29.43|-66.85|1",CKC:"Cherkassy|UA|49.42|32.00|0",ISC:"Scilly, Isles Of|GB|49.90|-6.40|1",YXN:"Whale Cove|CA|62.17|-92.58|1",AZO:"Kalamazoo|US|42.29|-85.59|0",AUK:"Alakanuk|US|62.69|-164.62|1",NDE:"Mandera|KE|3.93|41.85|1",KOK:"Kokkola|FI|63.83|23.12|1",URC:"Urumqi|CN|43.80|87.58|0",TGM:"Tirgu Mures|RO|46.53|24.53|1",YNO:"North Spirit Lake|CA|52.50|-92.42|2",YSJ:"St John|CA|45.32|-65.88|1",GST:"Glacier Bay|US|58.43|-135.71|1",GIB:"Gibraltar|GI|36.13|-5.35|1",BQL:"Boulia|AU|-22.90|139.90|1",DLI:"Dalat|VN|11.75|108.38|1",KTL:"Kitale|KE|0.97|34.96|",AXD:"Alexandroupolis|GR|40.85|25.87|0",PML:"Port Moller|US|55.99|-160.58|1",RSA:"Santa Rosa|AR|-36.57|-64.27|1",VAW:"Vardoe|NO|70.35|31.05|1",JUB:"Juba|SD|4.87|31.60|",CZX:"Changzhou|CN|31.78|119.97|1",NAV:"Nevsehir|TR|38.63|34.71|0",CAE:"Columbia|US|33.94|-81.12|1",NRD:"Norderney|DE|53.70|7.15|1",TCT:"Takotna|US|62.99|-156.06|1",JER:"Jersey|GB|49.21|-2.22|0",KTW:"Katowice|PL|50.27|19.02|1",ZGU:"Gaua|VU|-14.22|167.59|",YAK:"Yakutat|US|59.55|-139.73|1",MBT:"Masbate|PH|12.37|123.07|2",EUN:"El Aaiun|MA|27.13|-13.22|0",NVK:"Narvik|NO|68.44|17.44|1",DHB:"|US|",ADA:"Adana|TR|37.00|35.33|0",RZP:"Taytay Sandoval|PH|11.05|121.94|1",THS:"Sukhothai|TH|17.01|99.79|1",VNX:"Vilanculos|MZ|-22.60|35.11|0",AUU:"Aurukun Mission|AU|-13.17|142.25|1",HAU:"Haugesund|NO|59.41|5.28|1",JIQ:"Zhoubai Town|CN|29.52|29.52|1",VAS:"Sivas|TR|39.75|37.02|1",KYA:"Konya|TR|37.87|32.48|0",ADE:"Aden|YE|12.78|45.04|1",WAG:"Wanganui|NZ|-39.93|175.05|1",WKK:"Aleknagik|US|59.27|-158.62|1",KWJ:"Gwangju|KR|35.15|126.92|0",ERF:"Erfurt|DE|50.98|11.03|1",GIL:"Gilgit|PK|35.92|74.30|1",UGI:"Uganik|US|57.88|-153.50|0",YWK:"Wabush|CA|52.90|-66.87|1",PMR:"Palmerston|NZ|-40.32|175.62|1",GRO:"Gerona|ES|41.98|2.82|0",GLT:"Gladstone|AU|-23.85|151.25|1",STX:"St Croix|VI|17.70|-64.80|1",MVR:"Maroua|CM|10.60|14.32|1",CYO:"Cayo Largo del Sur|CU|21.62|-81.52|0",EIE:"Eniseysk|RU|58.47|92.12|0",LBU:"Labuan|MY|5.28|115.24|0",LMC:"Lamacarena|CO|3.32|-73.90|",BJW:"Bajawa|ID|-8.78|120.98|0",BRC:"San Carlos Bariloche|AR|-41.15|-71.16|1",SVD:"St Vincent|VC|13.25|-61.20|1",YOJ:"High Level|CA|58.52|-117.14|1",PGU:"|IR|",UCT:"Ukhta|RU|63.57|53.80|1",TGG:"Kuala Terengganu|MY|5.33|103.13|1",KGA:"Kananga|CD|-5.90|22.42|1",EGM:"Sege|SB|-8.55|157.85|1",OKC:"Oklahoma City|US|35.47|-97.52|1",PPS:"Puerto Princesa|PH|9.74|118.73|0",YWG:"Winnipeg|CA|49.88|-97.15|1",YYD:"Smithers|CA|54.78|-127.17|1",BQS:"Blagoveshchensk|RU|50.27|127.53|0",BSR:"Basra|IQ|30.49|47.82|1",FSD:"Sioux Falls|US|43.55|-96.70|1",SHE:"Shenyang|CN|41.79|123.43|0",LPY:"Le Puy|FR|45.03|3.88|1",ALS:"Alamosa|US|37.47|-105.87|1",KOS:"Sihanoukville|KH|2",BFD:"Bradford|US|41.80|-78.64|1",RDO:"Radom|PL|51.40|21.15|2",SKH:"Surkhet|NP|28.33|82.51|",ELS:"East London|ZA|-33.02|27.91|1",YUX:"Hall Beach|CA|68.79|-81.24|1",YCB:"Cambridge Bay|CA|69.05|-105.12|1",FLR:"Florence|IT|43.77|11.25|1",CSY:"Cheboksary|RU|56.13|47.27|0",GAN:"Gan Island|MV|-0.69|73.16|",YXC:"Cranbrook|CA|49.50|-115.77|1",HNH:"Hoonah|US|58.11|-135.44|0",OSD:"Ostersund|SE|63.18|14.65|1",RAP:"Rapid City|US|44.08|-103.23|1",BWT:"Burnie|AU|-41.07|145.92|0",LKO:"Lucknow|IN|26.85|80.92|0",KRT:"Khartoum|SD|15.59|32.53|1",KTE:"Kerteh|MY|4.52|103.45|1",AGX:"Agatti Island|IN|10.83|72.18|",LIH:"Lihue|US|21.98|-159.37|1",NUK:"Nukutavake|PF|-19.28|-138.83|1",KKI:"Akiachak|US|60.91|-161.43|1",CIC:"Chico|US|39.73|-121.84|0",CKD:"Crooked Creek|US|61.87|-158.10|",LZC:"Lazaro Cardenas Michoacan|MX|18.00|-102.22|1",AIU:"Atiu Island|CK|-19.99|-158.12|1",LBP:"Long Banga|MY|3.20|115.38|1",NOS:"Nossi Be|MG|-13.31|48.31|1",BJF:"Batsfjord|NO|70.63|29.70|0",ASM:"Asmara|ER|15.33|38.93|1",ZHY:"|CN|",FSM:"Ft Smith|US|35.34|-94.37|1",TMJ:"Termez|UZ|37.27|67.29|1",MIU:"Maiduguri|NG|11.85|13.16|1",ASO:"Asosa|ET|10.07|34.53|1",CEC:"Crescent City|US|41.76|-124.20|1",XTG:"Thargomindah|AU|-28.00|143.82|1",HOM:"Homer|US|59.64|-151.55|1",DIU:"Diu In|IN|20.72|70.92|1",KUM:"Yakushima|JP|30.33|130.50|0",VLS:"Valesdir|VU|-16.80|168.20|2",IQT:"Iquitos|PE|-3.75|-73.25|1",DEC:"Decatur|US|39.83|-88.87|1",NYT:"Nay Pye Taw|MM|1",VXO:"Vaxjo|SE|56.88|14.82|1",AMA:"Amarillo|US|35.22|-101.83|1",MZL:"Manizales|CO|5.07|-75.52|1",GOA:"Genoa|IT|44.41|8.93|1",YVZ:"Deer Lake|CA|52.67|-94.50|1",SSJ:"Sandnessjoen|NO|66.02|12.63|0",TAB:"Tobago|TT|11.25|-60.67|1",NGB:"Ningbo|CN|29.88|121.54|1",IPT:"Williamsport|US|41.24|-77.00|1",SAL:"San Salvador|SV|13.71|-89.20|1",KBL:"Kabul|AF|34.52|69.18|1",BXR:"Bam|IR|29.08|58.45|",AKX:"Aqtobe|KZ|50.28|57.21|0",NOJ:"Nojabrxsk|RU|63.17|75.62|1",BKG:"Branson|US|36.53|-93.20|",MVT:"Mataiva|PF|-17.75|-149.18|1",OTH:"North Bend|US|43.41|-124.22|1",YSB:"Sudbury|CA|46.49|-80.99|1",OGG:"Maui|US|20.90|-156.43|1",JOL:"Jolo|PH|6.06|121.01|1",ARD:"Alor Island|ID|-8.68|124.53|1",CEN:"Ciudad Obregon|MX|27.48|-109.93|0",AMH:"Arba Mintch|ET|6.03|37.55|1",CTG:"Cartagena|CO|10.40|-75.51|1",MPA:"Mpacha|NA|-17.50|24.27|1",KCM:"Kahramanmaras|TR|37.53|36.95|2",SMR:"Santa Marta|CO|11.25|-74.20|1",NYU:"Nyaung|MM|21.65|94.17|1",GCC:"Gillette|US|44.29|-105.50|0",LCE:"La Ceiba|HN|15.78|-86.80|0",BAQ:"Barranquilla|CO|10.96|-74.80|0",SDL:"Sundsvall|SE|62.38|17.30|1",NAN:"Nadi|FJ|-17.80|177.42|1",LMT:"Klamath Falls|US|42.22|-121.78|1",RGA:"Rio Grande|AR|-53.78|-67.70|1",TKK:"Truk|FM|7.42|151.78|1",PTA:"Port Alsworth|US|60.20|-145.33|",REX:"Reynosa|MX|26.08|-98.28|1",ELH:"North Eleuthera|BS|25.47|-76.69|1",DEZ:"Deirezzor|SY|35.33|40.15|1",MKG:"Muskegon|US|43.23|-86.25|1",LIL:"Lille|FR|50.63|3.07|1",KLW:"Klawock|US|55.55|-133.10|1",SGF:"Springfield|US|37.24|-93.39|1",CNS:"Cairns|AU|-16.92|145.77|1",IQQ:"Iquique|CL|-20.22|-70.17|1",TVU:"Taveuni|FJ|-16.69|179.87|1",WYA:"Whyalla|AU|-33.03|137.58|1",NQY:"Newquay|GB|50.41|-5.08|1",ISA:"Mount Isa|AU|-20.73|139.50|0",VAK:"Chevak|US|61.53|-165.59|1",FKI:"Kisangani|CD|0.52|25.20|1",YFX:"Fox Harbour|CA|52.37|-55.68|2",AXU:"Axum|ET|14.13|38.72|1",HZH:"Liping City|CN|26.34|109.15|",MKK:"Hoolehua|US|21.15|-157.10|1",SKB:"St Kitts|KN|17.31|-62.72|1",LLA:"Lulea|SE|65.58|22.15|1",GAO:"Guantanamo|CU|20.14|-75.21|1",FLL:"Ft Lauderdale|US|26.07|-80.15|1",IVC:"Invercargill|NZ|-46.40|168.35|0",EAT:"Wenatchee|US|47.42|-120.31|1",EWD:"Wildman Lake|US|56.46|-159.76|",JCU:"Ceuta|ES|35.89|-5.32|1",SLZ:"Sao Luiz|BR|-2.53|-44.30|1",LAD:"Luanda|AO|-8.84|13.23|1",PLD:"Playa Samara|CR|10.25|-85.42|1",GOU:"Garoua|CM|9.30|13.40|1",HSL:"Huslia|US|65.70|-156.40|0",BWO:"Balakovo|RU|51.87|47.75|0",ABT:"Al Baha|SA|20.29|41.63|1",MCX:"Makhachkala|RU|43.00|47.50|1",BME:"Broome|AU|-17.97|122.23|1",GWY:"Galway|IE|53.27|-9.05|1",NNM:"Naryan-Mar|RU|67.62|53.15|1",MYG:"Mayaguana|BS|22.38|-72.95|1",RMP:"Rampart|US|65.50|-150.17|1",LKY:"Lake Manyara|TZ|-3.50|36.42|",TLT:"Tuluksak|US|61.10|-160.96|1",MKQ:"Merauke|ID|-8.47|140.33|1",RBH:"Brooks Lodge|US|58.55|-155.80|",TUI:"Turaif|SA|31.68|38.65|1",KND:"Kindu|CD|-2.95|25.95|1",APF:"Naples|US|26.15|-81.78|1",GGT:"George Town|BS|23.47|-75.78|1",CHG:"Chaoyang|CN|41.55|120.44|",MQM:"Mardin|TR|37.31|40.74|0",FBM:"Lubumbashi|CD|-11.67|27.47|1",EAM:"Nejran|SA|17.61|44.43|1",EAU:"Eau Claire|US|44.81|-91.50|1",KKB:"Kitoi Bay|US|58.19|-152.35|1",TIF:"Taif|SA|21.27|40.42|1",SVU:"Savusavu|FJ|-16.78|179.33|1",AKY:"Akyab|MM|20.15|92.90|1",KGT:"|CN|",XBE:"Bearskin Lake|CA|53.95|-90.98|",DPO:"Devonport|AU|-41.17|146.35|1",ANR:"Antwerp|BE|51.19|4.45|",KGI:"Kalgoorlie|AU|-30.75|121.47|1",UAP:"Ua Pou|PF|-9.34|-140.08|",BID:"Block Island|US|41.17|-71.58|1",LAU:"Lamu|KE|-2.28|40.90|1",AVA:"Anshun|CN|26.25|105.93|0",KEP:"Nepalganj|NP|28.13|81.58|",YER:"Fort Severn|CA|56.03|-87.83|",UME:"Umea|SE|63.83|20.25|1",JIB:"Djibouti|DJ|11.60|43.15|0",CUU:"Chihuahua|MX|28.63|-106.08|1",UYL:"Nyala|SD|12.07|24.89|",TER:"Terceira|PT|38.72|-27.22|1",YBK:"Baker Lake|CA|64.32|-96.02|1",ALW:"Walla Walla|US|46.06|-118.34|1",JUL:"Juliaca|PE|-15.50|-70.13|1",BDQ:"Vadodara|IN|22.30|73.20|1",JKG:"Jonkoping|SE|57.78|14.18|1",VTE:"Vientiane|LA|17.97|102.60|0",ANI:"Aniak|US|61.58|-159.52|1",VAI:"Vanimo|PG|-2.68|141.30|1",FJR:"Al Fujairah|AE|25.11|56.33|0",DZA:"Dzaoudzi|YT|-12.78|45.25|0",APN:"Alpena|US|45.06|-83.43|1",MTJ:"Montrose|US|38.48|-107.88|0",PUM:"Pomala|ID|-4.18|121.62|1",TKP:"Takapoto|PF|-15.45|-145.14|",YQZ:"Quesnel|CA|53.00|-122.50|1",KAZ:"Au ID|ID|1.17|127.87|1",YKM:"Yakima|US|46.60|-120.51|1",NTQ:"Wajima|JP|37.29|136.96|",BYO:"Bonito|BR|-21.23|-56.46|",SMX:"Santa Maria|US|34.91|-120.46|1",BNS:"Barinas|VE|8.62|-70.22|1",AEX:"Alexandria|US|31.33|-92.55|1",LVI:"Livingstone|ZM|-17.85|25.87|1",BYC:"Yacuiba|BO|-22.03|-63.68|1",NIU:"|PF|",RLG:"Rostock Laage|DE|53.92|12.27|1",AOO:"Altoona|US|40.52|-78.39|0",FBD:"Faizabad|AF|0.00|0.00|2",LQM:"Puerto Leguizamo|CO|-0.30|-74.58|",AUQ:"Atuona|PF|-9.80|-139.03|1",REA:"Reao|PF|-18.50|-136.40|1",GOQ:"Golmud|CN|36.40|94.79|",LNX:"Smolensk|RU|54.78|32.04|0",ENE:"Ende|ID|-8.83|121.65|1",LLV:"Lüliang|CN|37.52|111.15|0",PBO:"Paraburdoo|AU|-23.17|117.75|1",BJM:"Bujumbura|BI|-3.38|29.36|1",BIQ:"Biarritz|FR|43.48|-1.57|1",NUL:"Nulato|US|64.72|-158.10|1",ADQ:"Kodiak|US|57.79|-152.41|1",SHM:"Nanki Shirahama|JP|33.66|135.36|1",KPR:"Port Williams|US|39.46|-95.03|1",MXV:"Moron|MN|49.63|100.17|",YZP:"Sandspit|CA|53.25|-131.81|1",KUT:"Kutaisi|GE|42.25|42.70|",LPQ:"Louangphrabang|LA|19.89|102.14|1",WRL:"Worland|US|44.02|-107.95|1",YIN:"Yining|CN|29.03|114.57|1",PCL:"Pucallpa|PE|-8.38|-74.55|1",SFA:"Sfax|TN|34.74|10.76|1",YHA:"Port Hope Simpson|CA|52.55|-56.30|1",YDQ:"Dawson Creek|CA|55.77|-120.24|1",KKU:"Ekuk|US|58.81|-158.56|1",PGD:"Punta Gorda|US|26.93|-82.05|1",CYI:"Chiayi|TW|23.47|120.38|0",SDN:"Sandane|NO|61.77|6.22|1",JDO:"Juazeiro Do Norte|BR|-7.21|-39.32|1",GTZ:"Grumeti|TZ|0.00|0.00|0",XMH:"Manihi|PF|-14.44|-146.07|",KWA:"Kwajalein|MH|8.72|167.73|1",PQS:"Pilot Station|US|61.94|-162.88|1",GAE:"Gabes|TN|33.88|10.12|1",HGN:"Mae Hongson|TH|19.30|97.98|1",MGF:"Maringa|BR|-23.43|-51.94|0",CJL:"Chitral|PK|34.21|71.83|1",BSK:"Biskra|DZ|34.85|5.73|1",JSU:"Maniitsoq|GL|65.42|-52.90|0",DOL:"Deauville|FR|49.36|0.07|1",EGN:"Geneina|SD|13.45|22.45|1",EXT:"Exeter|GB|50.72|-3.53|1",IJK:"Izhevsk|RU|56.85|53.23|1",KWM:"Kowanyama|AU|-14.92|141.60|1",CCP:"Concepcion|CL|-36.83|-73.05|0",HIA:"Huaian|CN|35.95|-80.18|2",NCY:"Annecy|FR|45.90|6.12|1",LHA:"Lahr|DE|48.35|7.87|0",NBE:"Enfidha|TN|36.08|10.44|2",SNW:"Sandoway|MM|18.47|94.37|1",TRC:"Torreon|MX|25.55|-103.43|1",SHB:"Nakashibetsu|JP|43.57|144.97|1",HUQ:"Houn|LY|29.50|15.50|",LIW:"Loikaw|MM|19.69|97.22|",FRW:"Francistown|BW|-21.17|27.52|1",AWA:"Awasa|ET|7.05|38.47|0",VPE:"Ongiva|AO|-17.05|15.07|",SLN:"Salina|US|38.79|-97.65|0",TRU:"Trujillo|PE|-8.12|-79.03|1",SAF:"Santa Fe|US|35.62|-106.09|1",MNS:"Mansa|ZM|-11.13|28.87|1",KEK:"Ekwok|US|59.35|-157.47|1",UDI:"Uberlandia|BR|-18.92|-48.28|0",LPM:"Lamap|VU|-16.43|167.80|1",VEE:"Venetie|US|67.01|-146.42|0",SMQ:"Sampit|ID|-3.08|113.05|1",URT:"Surat Thani|TH|9.13|99.32|0",ONK:"Olenyok|RU|68.50|112.47|0",ABI:"Abilene|US|32.45|-99.73|1",HGR:"Hagerstown|US|39.64|-77.72|1",IGT:"Magas|RU|2",KMI:"Miyazaki|JP|31.90|131.43|1",BBK:"Kasane|BW|-17.82|25.15|1",LSE:"La Crosse|US|43.80|-91.24|1",WSN:"South Naknek|US|58.72|-157.00|1",YQY:"Sydney|CA|46.17|-60.05|1",HUX:"Santa Cruz Huatulco|MX|15.75|-96.13|1",RUN:"Reunion Island|RE|-20.88|55.52|1",KPN:"Kipnuk|US|59.94|-164.04|1",YQR:"Regina|CA|50.45|-104.62|1",HTI:"Hamilton Island|AU|-20.37|148.95|1",WJR:"Wajir|KE|1.77|40.60|2",HPH:"Haiphong|VN|20.86|106.68|0",BRR:"Barra|GB|57.02|-7.44|1",UTH:"Udon Thani|TH|17.41|102.79|1",TVS:"Tangshan|CN|0.00|0.00|2",MOU:"Mountain Village|US|37.93|-107.86|1",STS:"Santa Rosa|US|38.51|-122.81|0",ERL:"Erldunda|CN|-25.25|133.20|",GSP:"Greenville|US|34.85|-82.38|1",AWZ:"Ahwaz|IR|31.33|48.69|0",LBR:"Labrea|BR|-7.25|-64.85|",TNF:"Toussus Le Noble|FR|48.75|2.11|0",HTY:"Antakya|TR|0.00|0.00|2",KIT:"Kithira|GR|36.25|23.02|1",REL:"Trelew|AR|-43.25|-65.31|1",JMU:"Jiamusi|CN|46.83|130.35|1",IIL:"Ilaam|IR|33.59|46.40|",YZY:"Zhangye|CN|38.93|100.45|0",ULO:"Ulaangom|MN|49.98|92.07|",ADF:"Adiyaman|TR|37.75|38.27|2",VGA:"Vijayawada|IN|16.53|80.80|",RSU:"Yeosu|KR|37.02|126.96|1",GPI:"Guapi|CO|2.56|-77.86|1",CED:"Ceduna|AU|-32.12|133.67|1",TBH:"Tablas|PH|12.32|122.08|",SPK:"Sapporo|JP|43.05|141.35|1",WMO:"White Mountain|US|64.68|-163.41|1",GNU:"Goodnews Bay|US|59.12|-161.59|1",HAA:"Hasvik|NO|70.48|22.15|1",JSH:"Sitia|GR|35.22|26.12|1",WNN:"Wunnummin Lake|CA|52.92|-89.17|",ANE:"Angers|FR|47.47|-0.55|1",HKB:"Healy Lake|US|63.87|-148.97|0",HOD:"Hodeidah|YE|14.75|42.98|1",KWG:"Krivoy Rog|UA|48.05|33.22|1",KXA:"Kasaan|US|55.54|-132.40|0",MFR:"Medford|US|42.37|-122.87|1",ZWL:"Wollaston Lake|CA|58.10|-103.18|1",BEJ:"Berau|ID|2.17|117.70|1",SVC:"Silver City|US|32.77|-108.28|1",OMH:"Urmieh|IR|37.62|45.08|1",EKS:"Shakhtyorsk|RU|0.00|0.00|2",TBZ:"Tabriz|IR|38.08|46.29|1",EMD:"Emerald|AU|-23.53|148.17|1",SLM:"Salamanca|ES|40.97|-5.65|1",AXK:"Ataq|YE|13.87|46.30|1",LEX:"Lexington|US|38.04|-84.60|1",GYI:"Gisenyi|RW|-1.70|29.26|1",PPV:"Port Protection|US|56.33|-133.67|",WUA:"Wuhai|CN|39.66|106.81|0",HAR:"Harrisburg|US|40.27|-76.88|1",LYH:"Lynchburg|US|37.41|-79.14|1",DWD:"|SA|",WTB:"Toowoomba|AU|-27.57|151.95|0",TJN:"Takume|PF|-15.85|-142.27|",EAE:"Emae|VU|-17.17|168.42|",ASD:"Andros Town|BS|24.70|-77.77|1",EZS:"Elazig|TR|38.68|39.22|0",SRJ:"San Borja|BO|-14.82|-66.83|",YFO:"Flin Flon|CA|54.77|-101.86|1",YUS:"|CN|",KHE:"Kherson|UA|46.68|32.63|0",GMR:"Gambier Island|PF|-23.17|-135.00|1",MAO:"Manaus|BR|-3.10|-60.02|1",ISG:"Ishigaki|JP|24.33|124.15|1",YMO:"Moosonee|CA|51.32|-80.72|1",CMU:"Kundiawa|PG|-6.02|144.97|1",YQT:"Thunder Bay|CA|48.40|-89.32|1",EFL:"Kefalonia|GR|38.12|20.51|1",YHR:"Chevery|CA|50.50|-59.50|1",CAB:"Cabinda|AO|-5.55|12.20|1",YIO:"Pond Inlet|CA|72.68|-78.00|",EEK:"Eek|US|60.22|-162.02|",TGO:"Tongliao|CN|43.56|122.20|",YHY:"Hay River|CA|60.82|-115.80|1",UKG:"Ust-Kuyga|RU|70.00|135.58|0",TMS:"Sao Tome|ST|0.38|6.72|1",BNC:"Beni|CD|0.57|29.47|2",MAQ:"Mae Sot|TH|16.72|98.57|1",YKU:"Chisasibi|CA|53.67|-78.33|1",YQC:"Quaqtaq|CA|61.03|-69.61|1",IWA:"Ivanovo|RU|56.99|40.99|0",RUR:"Rurutu|PF|-22.43|-151.33|1",SJT:"San Angelo|US|31.46|-100.44|1",THL:"Tachilek|MM|20.45|99.95|",IXJ:"Jammu|IN|32.73|74.87|1",BIK:"Biak|ID|-0.93|122.88|1",CHO:"Charlottesville|US|38.03|-78.48|1",YMM:"Ft McMurray|CA|56.68|-111.27|1",SGS:"Sanga Sanga|PH|5.23|121.15|0",BIC:"Big Creek|US|58.30|-157.52|1",KNX:"Kununurra|AU|-15.77|128.73|0",WEH:"Weihai|CN|37.50|122.11|1",JBB:"Jember Regency|ID|-8.17|113.70|0",TUW:"Tubala|PA|8.83|-77.67|",ZLO:"Manzanillo|MX|19.11|-104.35|1",KUO:"Kuopio|FI|62.90|27.68|0",CIT:"Shimkent|KZ|42.30|69.60|0",YDF:"Deer Lake|CA|49.22|-57.40|1",IRM:"Igrim|RU|0.00|0.00|2",ILR:"Ilorin|NG|8.50|4.55|1",EYP:"El Yopal|CO|5.32|-72.39|",PKN:"Pangkalanbun|ID|-2.68|111.62|1",OGN:"Yonaguni|JP|24.45|123.00|1",CPC:"San Martin de los Andes|AR|-40.12|-71.22|0",TRK:"Tarakan|ID|3.30|117.63|1",MMB:"Memambetsu|JP|43.91|144.17|1",DRT:"Del Rio|US|29.36|-100.90|1",KSH:"Kermanshah|IR|34.31|47.06|1",HLZ:"Hamilton|NZ|-37.78|175.28|1",BUZ:"Bushehr|IR|28.97|50.84|1",KIS:"Kisumu|KE|-0.10|34.75|1",UKA:"Ukunda|KE|-4.30|39.57|",TBW:"Tambov|RU|52.72|41.43|1",ZLT:"La Tabatiere|CA|51.00|-59.00|1",MUB:"Maun|BW|-19.98|23.42|0",YVM:"Qikiqtarjuaq|CA|67.58|-63.83|",EPR:"Esperance|AU|-33.87|121.90|1",KCA:"Kuqa|CN|41.73|82.94|1",KYZ:"Kyzyl|RU|51.70|94.47|0",KAD:"Kaduna|NG|10.52|7.44|0",KGL:"Kigali|RW|-1.95|30.06|1",AHE:"Ahe|PF|-14.43|-146.26|2",EKT:"Eskilstuna|SE|59.37|16.50|0",BNY:"Bellona|SB|-11.30|159.82|1",VLD:"Valdosta|US|30.83|-83.28|1",ELQ:"Gassim|SA|26.30|43.77|0",HID:"Horn Island|AU|-10.62|142.28|1",JMO:"Jomsom|NP|28.78|83.73|",ARI:"Arica|CL|-18.48|-70.33|1",KRP:"Karup|DK|56.31|9.17|1",YHK:"Gjoa Haven|CA|68.63|-95.88|1",YIK:"Ivujivik|CA|62.42|-77.92|0",SUK:"Batagay-Alyta|RU|67.80|130.40|0",MQN:"Mo I Rana|NO|66.32|14.17|1",SRQ:"Sarasota|US|27.34|-82.53|1",AYQ:"Ayers Rock|AU|-25.38|131.08|1",PKU:"Pekanbaru|ID|0.53|101.45|1",GMB:"Gambela|ET|8.25|34.58|1",PQI:"Presque Isle|US|46.68|-68.02|1",NEF:"Neftekamsk|RU|56.10|54.35|0",HYG:"Hydaburg|US|55.21|-132.83|1",ESR:"El Salvador|CL|-26.25|-69.62|1",IGR:"Iguazu|AR|-25.74|-54.47|1",ZFM:"Fort Mcpherson|CA|67.48|-134.95|",HGA:"Hargeisa|SO|9.56|44.06|1",NFG:"Nefteyugansk|RU|61.08|72.70|0",GGM:"Kakamega|KE|0.00|0.00|2",THN:"Trollhattan|SE|58.27|12.30|1",CMA:"Cunnamulla|AU|-28.07|145.68|0",MHK:"Manhattan|US|39.18|-96.57|1",PNR:"Pointe Noire|CG|1.56|15.78|1",SKD:"Samarkand|UZ|39.65|66.96|0",RNB:"Ronneby|SE|56.20|15.30|0",SOB:"Hévíz|HU|46.71|17.24|0",DAY:"Dayton|US|39.76|-84.19|1",IWK:"Iwakuni|JP|34.15|132.18|0",HDG:"|CN|",SLW:"Saltillo|MX|25.42|-101.00|1",WBB:"Stebbins|US|63.52|-162.29|1",TIU:"Timaru|NZ|-44.40|171.25|1",YWJ:"Deline|CA|65.17|123.50|",LPD:"La Pedrera|CO|-1.30|-69.72|",SPC:"Santa Cruz|ES|28.62|-17.75|1",CXB:"Coxs Bazaar|BD|21.45|91.97|1",MNT:"Minto|US|48.29|-97.37|1",IAN:"Kiana|US|66.97|-160.42|1",YAC:"Cat Lake|CA|51.72|-91.82|",CQD:"Shahre Kord|IR|32.30|50.84|1",IPN:"Ipatinga|BR|-19.47|-42.54|1",LMP:"Lampedusa|IT|35.50|12.60|1",PKZ:"Pakse|LA|15.13|105.78|1",DIL:"Dili|TL|-8.56|125.57|1",MFF:"Moanda|GA|-1.57|13.20|1",VBV:"Vanuabalavu|FJ|-17.23|-178.95|1",YKO:"Yuksekova|TR|37.57|44.28|0",MBL:"Manistee|US|44.24|-86.32|1",LWE:"Lewoleba|ID|-8.50|123.37|",BMV:"Banmethuot|VN|12.67|108.05|1",DSM:"Des Moines|US|41.60|-93.61|1",PKK:"Pakokku|MM|21.34|95.11|",PPT:"Papeete|PF|-17.53|-149.57|1",CQM:"Ciudad Real|ES|38.98|-3.92|2",DGT:"Dumaguete|PH|9.31|123.31|0",YGZ:"Grise Fiord|CA|76.42|-82.96|",WTK:"Noatak|US|67.57|-162.97|1",YRG:"Rigolet|CA|54.33|-58.42|",TNH:"Tonghua|CN|41.73|125.93|0",SEU:"Seronera|TZ|-2.38|34.82|",NTL:"Newcastle|AU|-32.93|151.78|1",DDG:"Dandong|CN|40.13|124.39|1",KRC:"Kerinci|ID|-1.72|101.25|",COO:"Cotonou|BJ|6.35|2.43|1",KVG:"Kavieng|PG|-2.57|150.80|1",MIM:"Merimbula|AU|-36.90|149.90|1",ALP:"Aleppo|SY|36.20|37.16|1",GLV:"Golovin|US|64.54|-163.04|0",GLK:"Galcaio|SO|6.77|47.43|",TLA:"Teller|US|65.26|-166.36|0",LTO:"Loreto|MX|22.27|-101.97|0",AGP:"Malaga|ES|36.72|-4.42|0",AYP:"Ayacucho|PE|-13.16|-74.22|1",LZN:"Nangan|TW|26.16|119.96|",CEI:"Chiang Rai|TH|19.90|99.83|1",DLG:"Dillingham|US|59.04|-158.46|0",MRX:"Bandar Mahshahr|IR|30.54|49.17|",GTF:"Great Falls|US|47.50|-111.30|0",OTZ:"Kotzebue|US|66.90|-162.60|1",KWK:"Kwigillingok|US|59.86|-163.13|1",CRW:"Charleston|US|38.37|-81.59|1",SPI:"Springfield|US|39.84|-89.68|1",SLK:"Saranac Lake|US|44.33|-74.13|1",IFN:"Isfahan|IR|32.66|51.67|1",UGT:"Umnugobitour|MN|43.75|104.13|1",CFB:"Cabo Frio|BR|-22.88|-42.02|1",INV:"Inverness|GB|57.47|-4.23|1",TOG:"Togiak|US|59.06|-160.38|1",TPS:"Trapani|IT|38.02|12.51|1",ATA:"Anta|PE|-9.35|-77.60|",FKQ:"Fak Fak|ID|-2.93|132.30|1",AGA:"Agadir|MA|30.40|-9.60|0",YGX:"Gillam|CA|56.46|-94.21|1",JKR:"Janakpur|NP|26.71|85.92|",YGG:"Ganges Harbor|CA|48.85|-123.50|",RRS:"Roros|NO|62.58|11.40|0",SAH:"Sanaa|YE|15.35|44.21|1",LMA:"Lake Minchumina|US|63.88|-152.31|1",BGA:"Bucaramanga|CO|7.13|-73.13|1",SLC:"Salt Lake City|US|40.76|-111.89|1",NDG:"Qiqihar|CN|47.34|123.97|0",EOI:"Eday|GB|59.18|-2.78|1",ABK:"Kabri Dar|ET|6.73|44.27|2",NRA:"Narrandera|AU|-34.75|146.55|1",KOE:"Kupang|ID|-10.17|123.58|1",KDU:"Skardu|PK|35.30|75.62|1",CLV:"Caldas Novas|BR|-17.75|-48.63|0",PVO:"Portoviejo|EC|-1.05|-80.45|1",HAC:"Hachijo Jima|JP|33.11|139.79|1",SZA:"Soyo|AO|-6.03|12.42|1",JSJ:"Jiansanjiang|CN|47.26|132.63|0",RKZ:"Rikaze|CN|1",TWT:"Tawitawi|PH|5.04|119.74|1",BMI:"Bloomington|US|40.48|-88.93|1",SCQ:"Santiago De Compostela|ES|42.88|-8.55|1",YXT:"Terrace|CA|54.52|-128.60|1",MKL:"Jackson|US|35.60|-88.92|0",DSS:"Ndiass|SN|14.64|-17.09|0",TUL:"Tulsa|US|36.15|-95.99|0",DAU:"Daru|PG|-9.09|143.19|0",IRG:"Lockhart|AU|-35.23|146.72|1",ELI:"Elim|US|40.30|-78.94|1",SCN:"Saarbruecken|DE|49.23|7.00|1",PPB:"Presidente Prudente|BR|-22.13|-51.39|1",BAS:"Balalae|SB|-6.98|155.88|1",HMI:"Hami|CN|42.92|93.42|",CGY:"Cagayan|PH|6.98|118.51|1",GBE:"Gaborone|BW|-24.65|25.91|1",ADD:"Addis Ababa|ET|9.03|38.70|1",KSR:"Sandy River|US|56.23|-160.23|0",GZT:"Gaziantep|TR|37.06|37.38|0",BHK:"Bukhara|UZ|39.77|64.43|1",GND:"Grenada|GD|12.15|-61.62|1",JTR:"Thira|GR|36.40|25.48|0",AJI:"Agri|TR|39.65|43.02|0",EIN:"Eindhoven|NL|51.44|5.48|0",CNN:"Chulman|RU|56.90|124.88|0",HLH:"Ulanhot|CN|46.19|122.00|",SBW:"Sibu|MY|2.30|111.82|1",YBX:"Blanc Sablon|CA|51.43|-57.22|1",BHR:"Bharatpur|NP|27.68|84.43|2",GRZ:"Graz|AT|47.07|15.45|1",SVI:"San Vincent|CO|2.15|-74.77|",SFQ:"Sanli Urfa|TR|37.09|38.85|0",BTZ:"Bursa|TR|40.19|29.06|0",KPY:"Port Bailey|US|57.93|-153.03|1",PYY:"Pai City|TH|",OBU:"Kobuk|US|66.91|-156.88|1",USK:"Usinsk|RU|65.99|57.53|1",MTV:"Mota Lava|VU|-13.67|167.67|1",QUO:"Uyo|NG|4.88|8.09|1",TNR:"Antananarivo|MG|-18.92|47.52|0",BHM:"Birmingham|US|33.56|-86.76|1",PET:"Pelotas|BR|-31.77|-52.34|1",FDE:"Forde|NO|61.45|5.84|1",JSR:"Jessore|BD|23.17|89.22|1",BHV:"Bahawalpur|PK|29.40|71.68|1",MCN:"Macon|US|32.84|-83.63|0",GGW:"Glasgow|US|48.21|-106.62|1",MJD:"Mohenjodaro|PK|27.34|68.14|1",AGN:"Angoon|US|57.50|-134.58|1",HGL:"Helgoland|DE|54.18|7.89|1",HMA:"Khanty Mansiysk|RU|61.00|69.00|1",KNO:"Medan|ID|0",DKR:"Dakar|SN|14.70|-17.44|0",MOT:"Minot|US|48.23|-101.30|1",KUH:"Kushiro|JP|42.98|144.38|1",PUU:"Puerto Asis|CO|0.52|-76.50|1",PDS:"Piedras Negras|MX|28.70|-100.52|1",ZAM:"Zamboanga|PH|6.91|122.07|1",YKL:"Schefferville|CA|54.80|-66.83|1",VHC:"Saurimo|AO|-9.75|20.55|2",MYA:"Moruya|AU|-35.92|150.08|1",YZT:"Port Hardy|CA|50.70|-127.42|1",KYK:"Karluk|US|57.57|-154.46|1",SCM:"Scammon Bay|US|61.84|-165.58|1",UIK:"Ust-Ilimsk|RU|58.13|102.55|0",CND:"Constanta|RO|44.18|28.65|1",LTK:"Latakia|SY|35.52|35.78|1",MOL:"Molde|NO|62.73|7.18|1",YYY:"Mont Joli|CA|50.08|-61.68|1",BVH:"Vilhena|BR|-12.74|-60.15|1",MGQ:"Mogadishu|SO|2.07|45.37|1",FUT:"Futuna|WF|-14.25|-178.15|1",KYS:"Kayes|ML|14.43|-11.44|",YQM:"Moncton|CA|46.12|-64.80|1",CEE:"Cherepovets|RU|59.28|38.07|1",TRD:"Trondheim|NO|63.42|10.42|1",SLU:"St Lucia|LC|13.92|-60.98|1",CHU:"Chuathbaluk|US|61.58|-159.24|",HIN:"Chinju|KR|35.19|128.09|1",YPM:"St Pierre|CA|51.82|-94.00|1",BYN:"Bayankhongor|MN|46.10|100.68|",SOU:"Southampton|GB|50.90|-1.40|1",YQQ:"Comox|CA|49.68|-124.94|0",PTH:"Port Heiden|US|56.95|-158.63|1",UMY:"Sumy|UA|50.92|34.78|0",JHM:"Kapalua|US|21.00|-156.66|1",LKA:"Larantuka|ID|-8.35|122.98|1",MMO:"Maio|CV|15.13|-23.22|1",PIU:"Piura|PE|-5.20|-80.63|1",OPU:"Balimo|PG|-8.05|142.95|1",ONT:"Ontario|US|34.06|-117.61|1",COR:"Cordoba|AR|-31.40|-64.18|1",WGA:"Wagga Wagga|AU|-35.12|147.37|1",FBS:"Friday Harbor|US|48.54|-123.01|",STV:"Surat|IN|21.17|72.83|0",VNS:"Varanasi|IN|25.33|83.00|1",LFT:"Lafayette|US|30.20|-91.99|1",BPS:"Porto Seguro|BR|-16.45|-39.06|1",HAD:"Halmstad|SE|56.67|12.86|1",QOW:"|NG|",XSC:"South Caicos|TC|21.52|-71.50|1",SUN:"Sun Valley|US|39.60|-119.78|1",MCE:"Merced|US|37.30|-120.48|1",IMK:"Simikot|NP|29.97|81.82|",MDQ:"Mar Del Plata|AR|-38.00|-57.55|1",CJU:"Jeju City|KR|33.51|126.52|1",LNJ:"Lincang|CN|23.74|100.03|",KQT:"Qurghonteppa|TJ|37.87|68.86|2",YYR:"Goose Bay|CA|53.40|-60.16|1",NAT:"Natal|BR|-5.79|-35.21|1",GTE:"Grte Eylandt|AU|-13.97|136.45|1",DCY:"Daocheng County|CN|28.77|100.32|0",BHS:"Bathurst|AU|-33.41|149.65|1",YNJ:"Yanji|CN|42.91|129.51|1",PNI:"Pohnpei|FM|6.91|158.23|1",BOH:"Bournemouth|GB|50.72|-1.88|1",CNJ:"Cloncurry|AU|-20.70|140.50|1",HUI:"Hu PG|VN|16.40|107.70|1",OLC:"Sao Paulo de Olivenca|BR|-3.47|-68.96|0",KKA:"Koyuk|US|64.93|-161.16|1",YHD:"Dryden|CA|49.78|-92.75|1",TJU:"Kulob|TJ|0.00|0.00|2",PLM:"Palembang|ID|-2.92|104.75|1",IPL:"El Centro|US|32.79|-115.56|1",HVB:"Hervey Bay|AU|-25.28|152.83|1",YFJ:"Snare Lake|CA|64.19|-114.08|",HOF:"Hofuf|SA|25.50|49.83|1",MSA:"Muskrat Dam|CA|53.82|-91.98|",HUU:"Huanuco|PE|-9.92|-76.23|1",VTB:"Vitebsk|BY|55.19|30.19|0",RFP:"Raiatea|PF|-16.83|-151.42|1",CJS:"Ciudad Juarez|MX|31.73|-106.48|1",TUS:"Tucson|US|32.22|-110.93|1",RDD:"Redding|US|40.59|-122.39|1",SCX:"Salina Cruz|MX|16.17|-95.20|1",NUI:"Nuiqsut|US|70.22|-150.98|1",DAX:"Daxian|CN|31.14|107.43|2",KKE:"Kerikeri|NZ|-35.22|173.97|1",WBM:"Wapenamanda|PG|-5.63|143.92|1",BTU:"Bintulu|MY|3.17|113.03|1",JJD:"Jijoca de Jericoacoara|BR|-2.79|-40.51|0",PSR:"Pescara|IT|42.46|14.21|0",FAY:"Fayetteville|US|34.99|-78.88|1",YNP:"Natuashish|CA|55.91|-61.18|1",YVO:"Val D Or|CA|48.05|-77.78|1",ARC:"Arctic Village|US|68.14|-145.52|",OLH:"Old Harbor|US|57.20|-153.30|1",VBY:"Visby|SE|57.63|18.30|1",AFT:"Afutara Aerodrome|SB|-9.20|160.85|",KMW:"Kostroma|RU|57.77|40.93|0",PQC:"Phu Quoc|VN|10.22|103.97|0",NLK:"Norfolk Island|NF|-29.04|167.94|1",ACX:"Xingyi|CN|25.05|104.98|1",GUC:"Gunnison|US|38.55|-106.92|1",DLU:"Dali City|CN|25.67|100.32|1",ODB:"Cordoba|ES|37.88|-4.77|0",BHZ:"Belo Horizonte|BR|-19.92|-43.94|1",ATQ:"Amritsar|IN|31.63|74.87|0",DAT:"Datong|CN|40.09|113.29|0",GSM:"Gheshm|IR|26.76|55.89|",UTM:"Tunica|US|34.67|-90.37|",CKB:"Clarksburg|US|39.28|-80.34|1",KAW:"Kawthaung|MM|10.05|98.52|",URE:"Kuressaare|EE|58.25|22.50|1",MYT:"Myitkyina|MM|25.38|97.40|0",XQP:"Quepos|CR|9.45|-84.15|1",ZUM:"Churchhill Falls|CA|53.56|-64.11|1",LIX:"Likoma Island|MW|-12.08|34.73|1",AKN:"King Salmon|US|58.69|-156.66|1",PGX:"Perigueux|FR|45.18|0.72|1",OGU:"Ordu|TR|40.98|37.88|2",BTI:"Barter Island|US|70.12|-143.67|1",KDI:"Kendari|ID|-3.94|122.50|1",ETR:"Etrepagny|EC|49.36|1.68|",HKD:"Hakodate|JP|41.78|140.74|1",YCF:"Cortes Bay|CA|50.07|-124.93|",RTB:"Roatan|HN|16.30|-86.55|1",SPD:"Saidpur|BD|25.78|88.90|0",TDD:"Trinidad|BO|-14.83|-64.90|1",MJU:"Mamuju|ID|-2.68|118.89|1",OKI:"Oki Island|JP|36.17|133.32|1",UGC:"Urgench|UZ|41.55|60.63|1",BLL:"Billund|DK|55.73|9.12|1",TNG:"Tangier|MA|35.78|-5.81|1",PZH:"Zhob|PK|31.34|69.45|1",PMO:"Palermo|IT|38.12|13.37|1",LUM:"Luxi|CN|24.41|98.53|",OSI:"Osijek|HR|45.55|18.69|1",LET:"Leticia|CO|-4.22|-69.94|1",TUN:"Tunis|TN|36.80|10.18|1",KBC:"Birch Creek|US|45.20|-87.61|1",PIS:"Poitiers|FR|46.58|0.33|1",KRS:"Kristiansand|NO|58.20|8.08|0",CVM:"Ciudad Victoria|MX|23.73|-99.13|1",YBD:"New Westminster|CA|49.21|-122.91|0",KCH:"Kuching|MY|1.55|110.33|1",YPA:"Prince Albert|CA|53.20|-105.77|1",UDR:"Udaipur|IN|24.58|73.68|1",ALY:"Alexandria|EG|31.20|29.92|0",MCZ:"Maceio|BR|-9.67|-35.74|1",NOC:"Knock|IE|53.92|-8.82|1",ELY:"Ely NV|US|39.30|-114.84|1",IXE:"Mangalore|IN|12.87|74.88|0",RIA:"Santa Maria|BR|-29.71|-53.69|1",RSH:"Russian Mission|US|61.78|-161.32|1",BEL:"Belem|BR|-1.46|-48.50|1",NVA:"Neiva|CO|2.93|-75.33|0",ACK:"Nantucket|US|41.28|-70.10|1",FGU:"Fangatau|PF|-16.05|-141.83|1",CTM:"Chetumal|MX|18.50|-88.30|1",KBU:"Kotabaru|ID|-3.33|116.33|2",MAH:"Menorca|ES|40.00|4.00|1",KEH:"Kenmore|US|47.76|-122.26|",CAC:"Cascavel|BR|-24.96|-53.46|1",NLV:"Nikolaev|UA|47.05|31.92|1",TLJ:"Tatalina|US|62.89|-155.97|1",PEM:"Puerto Maldonado|PE|-12.60|-69.18|1",IQM:"Qiemo|CN|38.13|85.53|1",HYN:"Huangyan|CN|28.65|121.26|1",RMA:"Roma|AU|-26.58|148.78|1",LIR:"Liberia|CR|10.63|-85.43|1",YCG:"Castlegar|CA|49.30|-117.67|1",MHH:"Marsh Harbour|BS|26.55|-77.05|1",PIR:"Pierre|US|44.37|-100.35|1",MZI:"Mopti|ML|14.49|-4.19|1",RXS:"Roxas City|PH|11.59|122.75|1",TAC:"Tacloban|PH|9.22|123.55|1",ORU:"Oruro|BO|-17.97|-67.12|0",MXX:"Mora|SE|61.00|14.55|1",ROO:"Rondonopolis|BR|-16.47|-54.64|1",MLW:"Monrovia|LR|6.31|-10.80|1",MUA:"Munda|SB|-8.33|157.27|1",SLY:"Salehard|RU|66.58|66.60|1",CYP:"Calbayog|PH|12.08|124.54|2",LWS:"Lewiston|US|46.37|-117.01|1",SAT:"San Antonio|US|29.42|-98.49|0",EQS:"Esquel|AR|-42.90|-71.32|1",KSZ:"Kotlas|RU|61.23|46.70|0",SQD:"Shangrao|CN|28.44|117.96|0",TRI:"Bristol|US|36.55|-82.47|1",WIC:"Wick|GB|58.43|-3.08|1",YUM:"Yuma|US|32.73|-114.62|1",LNV:"Lihir Island|PG|-3.08|152.58|1",TIH:"Tikehau|PF|-15.00|-147.75|1",PPQ:"Paraparaumu|NZ|-40.92|175.02|1",MJZ:"Mirnyj|RU|62.53|114.03|1",YMP:"Port McNeil|CA|50.61|-127.10|2",TRE:"Tiree|GB|56.50|-6.92|0",BCI:"Barcaldine|AU|-23.57|145.28|0",UEL:"Quelimane|MZ|-17.88|36.89|1",SPY:"San Pedro|CI|4.75|-6.66|0",MBS:"Saginaw|US|43.42|-83.95|1",BPE:"Qinhuangdao Beidaihe|CN|39.93|119.60|0",CLL:"College Station|US|30.63|-96.33|1",OIT:"Oita|JP|33.24|131.60|0",YWP:"Webequie|CA|52.96|-87.37|",RET:"Rost|NO|67.48|12.08|1",AGU:"Aguascalientes|MX|21.88|-102.30|1",TTJ:"Tottori|JP|35.50|134.23|1",TWU:"Tawau|MY|4.25|117.90|1",FIH:"Kinshasa|CD|-4.33|15.31|1",VRC:"Virac|PH|13.58|124.20|2",SNP:"St Paul Island|US|57.15|-170.22|1",RHI:"Rhinelander|US|45.64|-89.41|1",PFQ:"Parsabad|IR|39.61|47.88|",NRL:"North Ronaldsay|GB|59.37|-2.43|1",CTD:"Chitre|PA|7.97|-80.43|1",CAY:"Cayenne|GF|4.93|-52.33|1",XMS:"Macas|EC|-2.32|-78.13|1","INT":"Winston-Salem|US|36.10|-80.24|0",CKY:"Conakry|GN|9.51|-13.71|1",LDE:"Lourdes|FR|43.10|-0.05|1",KUS:"Kulusuk|GL|65.57|-37.18|1",AHU:"Al Hoceima|MA|35.24|-3.93|1",GYE:"Guayaquil|EC|-2.17|-79.90|1",PVS:"Provideniya|RU|64.38|173.30|0",ENI:"El Nido|PH|11.21|119.41|",MKM:"Mukah|MY|2.90|112.10|1",CSG:"Columbus|US|32.51|-84.94|1",MIG:"Mian Yang|CN|31.43|104.74|1",HLE:"Saint Helena|GB|15.95|-5.72|0",TWB:"Toowoomba|AU|-27.55|151.97|1",AKF:"Kufrah|LY|24.20|23.33|1",MGS:"Mangaia Island|CK|-21.93|-157.93|0",ONG:"Mornington|AU|-38.22|145.03|0",LDG:"Leshukonskoye|RU|64.90|45.75|",IMF:"Imphal|IN|24.82|93.95|0",AAA:"Anaa|PF|-17.05|-145.42|1",AQI:"Qaisumah|SA|28.31|46.13|1",PZO:"Puerto Ordaz|VE|8.30|-62.72|1",KMA:"Kerema|PG|-7.97|145.77|0",MNU:"Moulmein|MM|16.49|97.63|1",BQB:"Busselton|AU|-33.65|115.33|1",MEH:"Mehamn|NO|71.03|27.85|1",HNS:"Haines|US|59.24|-135.44|1",KSJ:"Kasos Island|GR|35.42|26.92|1",ZRJ:"Round Lake|CA|52.95|-91.32|",KFS:"Kastamonu|TR|41.37|33.77|0",IAA:"Igarka|RU|67.43|86.63|0",CAL:"Campbelltown|GB|55.44|-5.69|1",PBP:"Punta Islita|CR|10.42|-85.17|2",BKZ:"Bukoba|TZ|-1.33|31.81|1",ENA:"Kenai|US|60.55|-151.26|1",SHR:"Sheridan|US|44.80|-106.96|1",ONJ:"Odate Noshiro|JP|40.19|140.38|1",BNN:"Bronnoysund|NO|65.47|12.22|1",POM:"Port Moresby|PG|-9.46|147.19|1",CAJ:"Canaima|VE|6.25|-62.83|1",AKB:"Atka|US|52.22|-174.20|2",GRR:"Grand Rapids|US|42.88|-85.52|1",NEG:"Negril|JM|18.27|-78.35|1",NNY:"Nanyang|CN|32.99|112.53|1",YRB:"Resolute|CA|74.72|-94.97|",NUP:"Nunapitchuk|US|60.90|-162.46|1",KNW:"New Stuyahok|US|59.45|-157.31|1",TNC:"Tin City|US|35.56|-121.08|1",AEG:"Aek Godang|ID|1.40|99.42|",SUJ:"Satu Mare|RO|47.80|22.88|1",TCB:"Treasure Cay|BS|26.73|-77.37|1",BWA:"Bhairawa|NP|27.50|83.42|",ERD:"Berdyansk|UA|46.73|36.78|0",VEL:"Vernal|US|40.46|-109.53|1",XMN:"Xiamen|CN|24.47|118.09|0",ZIX:"Zhigansk|RU|66.77|123.38|0",OAX:"Oaxaca|MX|17.05|-96.72|1",DSA:"Doncaster|GB|53.53|-1.12|1",VKT:"Vorkuta|RU|67.48|63.98|0",LEB:"Lebanon|US|40.34|-76.41|1",BRL:"Burlington|US|40.79|-91.12|1",TNL:"Ternopol|UA|49.55|25.58|0",BSC:"Bahia Solano|CO|6.33|-77.43|1",UTT:"Umtata|ZA|-31.58|28.78|1",PYX:"Pattaya|TH|12.68|101.02|0",PVH:"Porto Velho|BR|-8.76|-63.90|1",KHD:"Khorramabad|IR|33.49|48.36|0",LSC:"La Serena|CL|-29.91|-71.25|0",SBZ:"Sibiu|RO|45.80|24.15|1",LAR:"Laramie|US|41.31|-105.59|1",KCF:"Kadanwari|PK|27.20|69.15|",CAZ:"Cobar|AU|-31.50|145.82|1",USQ:"Usak|TR|38.68|29.41|0",RDN:"Redang|MY|5.77|103.01|1",AFA:"San Rafael|AR|-34.60|-68.33|0",YGP:"Gaspe|CA|48.83|-64.48|1",JGD:"Jiagedaqi District|CN|50.42|124.07|0",PFN:"Panama City|US|30.21|-85.68|1",HON:"Huron|US|44.36|-98.21|0",THR:"Tehran|IR|2",TKG:"Bandar Lampung|ID|-5.45|105.27|0",GJA:"Guanaja|HN|16.40|-85.90|1",HDS:"Hoedspruit|ZA|-24.35|30.97|1",PUS:"Busan|KR|35.10|129.04|0",BRT:"Bathurst Isl|AU|-11.77|130.63|1",TNJ:"Tanjung Pinang|ID|0.92|104.54|1",NOP:"Sinop|TR|42.02|35.07|0",ZGS:"Gethsemanie|CA|50.33|-60.67|0",RAR:"Rarotonga|CK|-21.23|-159.78|1",OBX:"Obo|PG|-7.58|141.32|",SFL:"Sao Filipe|CV|14.90|-24.52|1",TJA:"Tarija|BO|-21.54|-64.73|1",XFN:"Xiangfan|CN|32.04|112.14|1",AKV:"Akulivik|CA|60.80|-78.20|1",YQU:"Grande Prairie|CA|55.17|-118.80|1",GJT:"Grand Junction|US|39.06|-108.55|1",FIE:"Fair Isle|GB|59.53|-1.65|1",VDC:"Vitoria Da Conquista|BR|-14.87|-40.84|1",MSZ:"Namibe|AO|-15.20|12.15|1",ASW:"Aswan|EG|24.09|32.90|1",YZG:"Salluit|CA|62.20|-75.63|1",URA:"Uralsk|KZ|51.23|51.37|1",SVL:"Savonlinna|FI|61.87|28.88|0",VAN:"Van|TR|38.46|43.33|0",GRX:"Granada|ES|37.19|-3.61|1",KLD:"Tver|RU|56.86|35.89|0",NAO:"Nanchong|CN|30.80|106.07|",TXK:"Texarkana|US|33.43|-94.05|1",GTO:"Gorontalo|ID|0.53|123.06|1",RIC:"Richmond|US|37.51|-77.32|1",BRS:"Bristol|GB|51.45|-2.58|1",AOJ:"Aomori|JP|40.82|140.75|1",POG:"Port Gentil|GA|-0.72|8.78|1",RHP:"Ramechhap|NP|27.33|86.08|",ERN:"Eirunepe|BR|-6.58|-69.88|",DHM:"Dharamsala|IN|32.22|76.32|0",FMM:"Memmingen|DE|47.99|10.24|",XKS:"Kasabonika|CA|53.52|-88.65|",IDR:"Indore|IN|22.72|75.83|0",CNY:"Moab|US|38.57|-109.55|1",LTI:"Altai|MN|46.65|96.42|",ROK:"Rockhampton|AU|-23.38|150.50|1",GLF:"Golfito|CR|8.65|-83.15|1",SJD:"San Jose Cabo|MX|23.17|-109.70|1",PEC:"Pelican|US|57.96|-136.23|1",KAA:"Kazama|ZM|-10.22|31.13|1",DRS:"Dresden|DE|51.05|13.74|1",YGW:"Poste De La Baleine|CA|55.28|-77.77|1",HEH:"Heho|MM|20.72|96.82|1",EBD:"El Obeid|SD|13.18|30.22|1",RCB:"Richards Bay|ZA|-28.80|32.10|1",LBV:"Libreville|GA|0.38|9.45|1",XNN:"Xining|CN|36.62|101.77|1",DBA:"Dalbandin|PK|28.88|64.42|",JEG:"Aasiaat|GL|68.72|-52.87|1",BTT:"Bettles|US|66.92|-151.52|1",SJC:"San Jose|US|37.34|-121.89|1",VUP:"Valleduper|CO|10.44|-73.25|",GME:"Gomel|BY|52.44|30.98|1",MXM:"Morombe|MG|-21.73|43.35|1",TAO:"Qingdao|CN|36.10|120.37|0",YGK:"Kingston|CA|44.23|-76.48|1",YGH:"Fort Good Hope|CA|66.27|-128.65|",ANM:"Antalaha|MG|-14.88|50.28|1",SKN:"Stokmarknes|NO|68.56|14.91|1",SKE:"Skien|NO|59.20|9.60|1",LGL:"Long Lellang|MY|3.42|115.13|1",LBJ:"Labuan Bajo|ID|-8.48|119.87|1",RZE:"Rzeszow|PL|50.05|22.00|1",YGJ:"Yonago|JP|35.43|133.33|1",RGK:"Gorno-Altaisk|RU|51.95|85.95|0",YBP:"Yibin|CN|28.77|104.57|1",TCX:"Tabas|IR|33.68|56.90|",KLN:"Larsen Bay|US|57.54|-153.98|1",URS:"Kursk|RU|51.73|36.19|0",MED:"Madinah|SA|24.47|39.61|0",KOI:"Kirkwall|GB|58.97|-2.95|1",KOC:"Koumac|NC|-20.57|164.28|1",PSC:"Pasco|US|46.24|-119.10|1",BIR:"Biratnagar|NP|26.48|87.28|1",MUN:"Maturin|VE|9.75|-63.18|1",PPW:"Papa Westray|GB|59.35|-2.90|0",BTJ:"Banda Aceh|ID|5.56|95.33|1",KGK:"Koliganek|US|59.73|-157.28|1",NRK:"Norrkoping|SE|58.60|16.18|0",RUM:"Rumjatar|NP|27.32|86.53|",LUP:"Kalaupapa|US|21.19|-156.99|0",BZL:"Barisal|BD|22.70|90.37|0",TMU:"Tambor|CR|9.73|-85.02|1",CAH:"Ca Mau|VN|9.18|105.18|",SZZ:"Szczecin|PL|53.43|14.55|1",RUE:"|CD|",PMY:"Puerto Madryn|AR|-42.77|-65.05|1",SHY:"Shinyanga|TZ|-3.67|33.43|1",SDG:"Sanandaj|IR|35.25|47.01|",LAK:"Aklavik|CA|68.22|-134.99|",SLX:"Salt Cay|TC|21.33|-71.20|1",FSC:"Figari|FR|41.49|9.13|1",YLW:"Kelowna|CA|49.88|-119.49|1",YRT:"Rankin Inlet|CA|62.82|-92.08|1",ODN:"Long Seridan|MY|3.98|115.07|1",PLX:"Semipalatinsk|KZ|50.33|80.25|1",SDR:"Santander|ES|43.46|-3.80|0",EYK:"Beloyarsky|RU|63.70|66.70|2",ISN:"Williston|US|48.15|-103.62|1",HAQ:"Hanimaadhoo|MV|6.75|73.17|",EBL:"Erbil|IQ|36.19|44.01|1",BZY:"Beltsy|RU|47.75|27.93|0",SOJ:"Sorkjosen|NO|69.80|20.93|1",TKQ:"Kigoma|TZ|-4.88|29.67|",SDK:"Sandakan|MY|5.83|118.12|1",BFE:"Bielefeld|DE|52.03|8.53|0",INL:"International Falls|US|48.60|-93.41|1",AGS:"Augusta|US|33.37|-81.97|1",OUD:"Oujda|MA|34.68|-1.91|0",AMV:"Amderma|RU|69.77|61.55|1",MPL:"Montpellier|FR|43.60|3.88|1",GDX:"Magadan|RU|59.57|150.80|0",ORF:"Norfolk|US|36.90|-76.20|1",BRD:"Brainerd|US|46.36|-94.20|1",CXJ:"Caxias Do Sul|BR|-29.17|-51.18|1",TQR:"San Domino Island|IT|42.12|15.48|1",IXR:"Ranchi|IN|23.35|85.33|1",PKY:"Palangkaraya|ID|-2.20|113.83|1",DGA:"Dangriga|BZ|16.97|-88.22|1",MPM:"Maputo|MZ|-25.97|32.59|1",CHA:"Chattanooga|US|35.05|-85.31|0",ARU:"Aracatuba|BR|-21.21|-50.43|1",LBF:"North Platte|US|41.12|-100.77|0",IOS:"Ilheus|BR|-14.79|-39.05|1",SUY:"Suntar|RU|62.15|117.70|0",GPA:"Patras|GR|38.24|21.73|1",TIM:"Timika|ID|-4.78|136.53|1",YPR:"Prince Rupert|CA|54.32|-130.32|0",CHS:"Charleston|US|32.90|-80.04|1",AOK:"Karpathos|GR|35.50|27.23|1",RNO:"Reno|US|39.53|-119.81|1",DCM:"Castres|FR|43.60|2.25|1",VTZ:"Vishakhapatanam|IN|17.72|83.22|1",PMZ:"Palmar|CR|8.95|-83.47|",EAA:"Eagle|US|64.78|-141.15|1",LAO:"Laoag|PH|18.20|120.59|1",PUF:"Pau Fr|FR|43.38|-0.42|1",CJC:"Calama|CL|-22.47|-68.93|1",ABA:"Abakan|RU|53.71|91.42|1",OAG:"Orange|AU|-33.38|149.12|1",GFF:"Griffith|AU|-34.28|146.03|1",HDN:"Hayden|US|47.77|-116.79|0",HLT:"Hamilton|AU|-37.75|142.03|1",OKJ:"Okayama|JP|34.65|133.92|1",WLH:"Walaha|VU|-15.42|167.70|",GWT:"Westerland|DE|54.91|8.30|0",KMC:"King Khalid Military City|SA|27.90|45.52|1",DSK:"Dera Ismail Khan|PK|31.83|70.90|1",PNK:"Pontianak|ID|-0.03|109.33|0",KRN:"Kiruna|SE|67.85|20.22|1",NGK:"|RU|0.00|0.00|2",BVV:"|RU|",NKC:"Nouakchott|MR|18.12|-16.04|1",YFS:"Fort Simpson|CA|61.86|-121.35|1",BDB:"Bundaberg|AU|-24.85|152.35|1",ATY:"Watertown|US|44.91|-97.15|1",JNN:"Nanortalik|GL|60.12|-45.22|1",PAZ:"Poza Rica|MX|28.78|-111.60|1",ELU:"El Oued|DZ|33.33|6.88|1",ULY:"Ulyanovsk|RU|54.33|48.40|0",OBO:"Obihiro|JP|42.92|143.20|1",MDG:"Mudanjiang|CN|44.58|129.60|1",KLG:"Kalskag|US|61.54|-160.31|1",HSN:"Zhoushan|CN|30.02|122.10|1",YGN:"Greenway Sound|CA|50.85|-126.85|",LAW:"Lawton|US|34.61|-98.39|1",CZU:"Corozal|CO|9.34|-75.28|2",MLG:"Malang|ID|-7.98|112.63|1",TCZ:"Tengchong|CN|0.00|0.00|2",MUE:"Kamuela|US|20.01|-155.67|1",KDH:"Kandahar|AF|31.51|65.85|1",YQJ:"|CA|",ABC:"Albacete|ES|38.98|-1.85|1",NWI:"Norwich|GB|52.63|1.30|1",MYW:"Mtwara|TZ|-10.27|40.18|1",DKS:"Dikson|RU|73.52|80.37|0",CYZ:"Cauayan|PH|16.93|121.76|",PHG:"Port Harcourt|NG|5.03|6.83|",UKK:"Ust Kamenogorsk|KZ|49.98|82.61|1",RRG:"Rodrigues Island|MU|-19.75|63.35|1",SLP:"San Luis Potosi|MX|22.15|-100.98|1",KCT:"Koggala|LK|5.98|80.33|1",RGN:"Yangon|MM|16.81|96.16|1",SWF:"Newburgh|US|41.50|-74.01|1",CRD:"Comodoro Rivadavia|AR|-45.87|-67.50|1",LGP:"Legaspi|PH|13.15|123.76|1",ALB:"Albany|US|42.75|-73.81|1",LPB:"La Paz|BO|-16.50|-68.15|1",SEK:"Srednekolymsk|RU|67.47|153.72|0",SRX:"Sert|LY|31.06|16.61|",AKR:"Akure|NG|7.25|5.20|1",TYR:"Tyler|US|32.35|-95.30|1",SMA:"Santa Maria|PT|36.97|-25.10|1",NSH:"Now Shahr|IR|36.67|51.50|2",SGO:"St George|AU|-28.05|148.59|1",AVN:"Avignon|FR|43.95|4.82|1",TAY:"Tartu|EE|58.37|26.74|1",YZS:"Coral Harbour|CA|64.13|-83.17|1",PNZ:"Petrolina|BR|-9.40|-40.50|0",DUR:"Durban|ZA|-29.85|31.02|0",YYJ:"Victoria|CA|48.43|-123.37|1",CSX:"Changsha|CN|28.20|112.97|1",SGU:"St George|US|37.09|-113.59|1",WUS:"Wuyishan|CN|27.76|118.04|1",SZE:"Semera|ET|11.79|41.01|0",PAT:"Patna|IN|25.60|85.12|1",KVA:"Kavalla|GR|40.97|24.34|1",RVN:"Rovaniemi|FI|66.50|25.72|1",JCB:"Joacaba|BR|-27.17|-51.52|0",EGC:"Bergerac|FR|44.85|0.48|1",RCH:"Riohacha|CO|11.54|-72.91|1",EXI:"Excursion Inlet|US|58.42|-135.43|1",RBA:"Rabat|MA|34.02|-6.83|1",DLE:"Dole|FR|47.10|5.50|1",HVN:"New Haven|US|41.31|-72.93|1",CBO:"Cotabato|PH|7.22|124.25|1",PLZ:"Port Elizabeth|ZA|-33.97|25.58|1",CIK:"Chalkyitsik|US|66.65|-143.72|1",LUR:"Cape Lisburne|US|68.88|-166.11|1",LCX:"Longyan|CN|25.68|117.03|",PWE:"Pevek|RU|69.78|170.60|1",ELF:"El Fasher|SD|13.62|25.32|1",PLO:"Port Lincoln|AU|-34.73|135.87|1",SKC:"Suki|PG|-8.08|141.80|1",EUX:"St Eustatius|BQ|17.49|-62.98|1",YTS:"Timmins|CA|48.47|-81.33|1",JHB:"Johor Bahru|MY|1.47|103.75|1",ANU:"Antigua|AG|17.05|-61.80|1",VAO:"Suavanao|SB|-7.57|158.67|",VIL:"Dakhla|MA|23.71|-15.94|1",FTA:"Futuna Island|VU|-19.42|170.25|",YES:"Yasouj|IR|30.70|51.55|",JNU:"Juneau|US|58.30|-134.42|1",PVE:"El Porvenir|PA|9.00|-81.00|",OHH:"Okha|RU|0.00|0.00|2",PXO:"Porto Santo|PT|33.05|-16.33|1",PAG:"Pagadian|PH|7.83|123.46|",BGG:"Bingol|TR|38.89|40.50|0",SCW:"Syktyvkar|RU|61.67|50.81|1",BBN:"Bario|MY|3.75|115.45|1",SRV:"Stony River|US|61.78|-156.59|1",TOL:"Toledo|US|41.66|-83.56|1",LUL:"Laurel|US|39.10|-76.85|1",SUR:"Summer Beaver|CA|52.72|-88.55|1",FOA:"Foula|GB|60.17|-2.08|",UNA:"Una BR|BR|-15.35|-39.00|1",TKV:"Tatakoto|PF|-17.28|-138.33|2",ROR:"Koror|PW|7.34|134.48|0",BOI:"Boise|US|43.61|-116.20|1",CMF:"Chambery|FR|45.57|5.93|1",AXT:"Akita|JP|39.72|140.12|1",STG:"St George Island|US|56.60|-169.55|0",KVR:"KAVALEROVO |RU|27.65|-80.41|2",JDR:"|BR|",YYB:"North Bay|CA|46.32|-79.47|1",VDA:"Ovda|IL|29.93|34.95|1",KKQ:"|RU|",KDO:"Kadhdhoo|MV|1.88|73.52|",EVE:"Harstad Narvik|NO|68.50|16.68|1",DLH:"Duluth|US|46.78|-92.11|1",SRA:"Santa Rosa|BR|-27.87|-54.48|2",PSO:"Pasto|CO|1.21|-77.28|1",ABQ:"Albuquerque|US|35.08|-106.65|1",APL:"Nampula|MZ|-15.12|39.26|1",UAH:"Ua Huka|PF|-8.93|-139.55|2",MVP:"Mitu|CO|1.13|-70.05|2",TML:"Tamale|GH|9.40|-0.83|1",KBV:"Krabi|TH|8.07|98.92|1",HVD:"Khovd|MN|48.02|91.65|",QRO:"Queretaro|MX|20.60|-100.38|1",MGW:"Morgantown|US|39.63|-79.96|1",HNM:"Hana|US|20.76|-155.99|1",AUY:"Aneityum|VU|-20.33|169.67|",BDS:"Brindisi|IT|40.63|17.94|1",HFT:"Hammerfest|NO|70.66|23.69|1",DSN:"Dongsheng|CN|39.85|110.03|",YLH:"Lansdowne|CA|60.26|-134.77|1",VIG:"El Vigia|VE|8.62|-71.65|1",MEY:"Meghauli|NP|27.58|84.23|0",BTV:"Burlington|US|44.47|-73.15|1",WUX:"Wuxi|CN|31.58|120.29|1",LOS:"Lagos|NG|6.45|3.40|1",BMO:"Bhamo|MM|24.27|97.23|0",KQA:"Akutan|US|54.14|-165.77|1",KPB:"Point Baker|US|56.33|-133.58|",CZS:"Cruzeiro Do Sul|BR|-7.58|-72.78|1",PBH:"Paro|BT|27.43|89.42|1",WMN:"Maroantsetra|MG|-15.43|49.73|1",SYR:"Syracuse|US|43.05|-76.15|1",PKE:"Parkes|AU|-33.13|148.18|1",SSI:"St Simons Is|US|31.17|-81.46|1",LGG:"Liege|BE|50.64|5.57|1",YSG:"Lutselke/Snowdrift|CA|62.42|-110.08|",PLJ:"Placencia|BZ|16.52|-88.37|1",FAR:"Fargo|US|46.88|-96.79|1",MZR:"Mazar I Sharif|AF|36.71|67.21|",YGT:"Igloolik|CA|69.38|-81.80|1",FEG:"Fergana|UZ|40.39|71.78|1",JOE:"Joensuu|FI|62.60|29.77|1",TMT:"Trombetas|BR|-7.40|-72.42|1",FBA:"Fonte Boa|BR|-2.53|-66.08|1",UYN:"Yulin|CN|38.27|109.73|",NGS:"Nagasaki|JP|32.76|129.87|1",LGB:"Long Beach|US|33.77|-118.19|1",UYU:"Uyuni|BO|-20.46|-66.82|2",KSA:"Kosrae|FM|5.35|162.96|",DRO:"Durango|US|37.15|-107.75|1",OAI:"|AF|",OGL:"Ogle|GY|6.80|-58.11|1",YPY:"Fort Chipewyan|CA|58.76|-111.12|1",LWT:"Lewistown|US|40.60|-77.57|1",KMQ:"Komatsu|JP|36.40|136.45|1",CLM:"Port Angeles|US|48.12|-123.43|1",ZUH:"Zhuhai|CN|22.28|113.57|1",ROA:"Roanoke|US|37.27|-79.94|1",LFM:"Lamerd|IR|27.37|53.19|",SHC:"Shire Indaselassie|ET|12.98|39.13|1",PBU:"Putao|MM|27.33|97.42|",TVF:"Thief River Falls|US|48.12|-96.18|1",XIC:"Xichang|CN|27.98|102.19|",BRA:"Barreiras|BR|-12.15|-44.99|0",KCO:"Izmit|TR|40.77|29.92|0",VAP:"Valparaiso|CL|-33.05|-71.60|0",BST:"Bost|AF|31.55|64.37|2",CTC:"Catamarca|AR|-28.47|-65.78|1",KWL:"Guilin|CN|25.28|110.29|0",EBJ:"Esbjerg|DK|55.47|8.45|1",MYD:"Malindi|KE|-3.22|40.12|1",ANX:"Andenes|NO|69.32|16.13|1",HGD:"Hughenden|AU|-20.85|144.20|1",MHG:"Mannheim|DE|49.50|8.47|0",YNT:"Yantai|CN|37.53|121.40|1",HME:"Hassi Messaoud|DZ|31.70|6.05|1",EVV:"Evansville|US|37.97|-87.56|0",NEV:"Nevis|KN|17.15|-62.58|1",GAJ:"Yamagata|JP|38.25|140.34|0",FRL:"Forli|IT|44.22|12.05|1",JIC:"Jinchang|CN|38.50|102.17|0",EGE:"Eagle|US|39.65|-106.91|1",HMJ:"Khmelnitskiy|UA|49.42|27.00|0",CZM:"Cozumel|MX|20.51|-86.95|1",VDS:"Vadso|NO|70.07|29.77|1",PJM:"Puerto Jimenez|CR|8.58|-83.33|",BGY:"Bergamo|IT|45.70|9.67|0",KHG:"Kashi|CN|39.45|75.98|1",GDT:"Grand Turk|TC|21.47|-71.13|1",KOW:"Ganzhou|CN|38.93|100.45|0",RGS:"Burgos|ES|",GRQ:"Groningen|NL|53.22|6.57|1",DBO:"Dubbo|AU|-32.25|148.62|1",LLK:"Lankaran|AZ|38.76|48.84|",ACZ:"Zabol|IR|31.09|61.54|",TBU:"Nuku Alofa|TO|-21.13|-175.20|1",SGK:"Sangapi|PG|-5.08|144.77|",CVN:"Clovis|US|36.83|-119.70|0",JJM:"Meru-Kinna|KE|1",YAG:"Fort Frances|CA|48.60|-93.40|1",SDZ:"Shetland Islands Area|GB|60.13|-1.13|1",SHJ:"Sharjah|AE|25.36|55.39|1",KRF:"Kramfors|SE|62.93|17.79|1",EUG:"Eugene|US|44.05|-123.09|1",SVB:"Sambava|MG|-14.27|50.17|1",YXX:"Abbotsford|CA|49.06|-122.25|0",PCR:"Puerto Carreno|CO|6.18|-67.63|",CLY:"Calvi|FR|42.57|8.75|1",SMK:"St Michael|US|63.48|-162.03|1",CUQ:"Coen|AU|-13.93|143.20|1",SLQ:"Sleetmute|US|61.70|-157.17|0",BJB:"Bojnord|IR|37.49|57.31|",BDH:"Bandar Lengeh|IR|26.55|54.88|1",TKX:"Takaroa|PF|-14.46|-145.03|",RZR:"Ramsar|IR|36.90|50.68|",NAG:"Nagpur|IN|21.15|79.10|1",TKE:"Tenakee|US|57.78|-135.22|1",PGK:"Pangkalpinang|ID|-2.13|106.13|1",CBB:"Cochabamba|BO|-17.38|-66.15|1",CPR:"Casper|US|42.87|-106.31|1",TEZ:"Tezpur|IN|26.71|92.80|",SSM:"Sault Ste Marie|US|46.50|-84.35|1",TMW:"Tamworth|AU|-31.10|150.93|1",FNJ:"Pyongyang|KP|39.02|125.75|1",YTQ:"Tasiujaq|CA|58.70|-69.93|1",KIR:"Kerry County|IE|52.05|-9.50|1",JCK:"Julia Creek|AU|-20.65|141.73|1",AQP:"Arequipa|PE|-16.40|-71.53|1",LYB:"Little Cayman|KY|19.68|-80.05|1",PSZ:"Puerto Suarez|BO|-18.95|-57.80|1",LLI:"Lalibela|ET|12.02|39.07|",TPA:"Tampa|US|27.95|-82.46|1",MIS:"Misima|PG|-10.67|152.75|1",DCN:"Derby|AU|0.00|0.00|2",WLK:"Selawik|US|66.60|-160.01|1",TKU:"Turku|FI|60.45|22.28|1",BPX:"Bangda|CN|30.56|97.11|",BGF:"Bangui|CF|4.37|18.58|1",ULK:"Lensk|RU|60.72|114.83|0",ROP:"Rota|MP|14.17|145.25|1",TMX:"Timimoun|DZ|29.23|0.28|",SXM:"Sint Maarten|SX|18.04|-63.11|0",BOO:"Bodo|NO|67.28|14.38|1",PTU:"Platinum|US|59.01|-161.82|1",QUB:"Ubari|LY|26.60|12.77|2",SNA:"Santa Ana|US|33.75|-117.87|1",PLS:"Providenciales|TC|21.77|-72.27|1",KAE:"Kake|US|56.98|-133.95|1",SVJ:"Svolvaer|NO|68.23|14.57|1",TGR:"Touggourt|DZ|33.10|6.07|1",KER:"Kerman|IR|30.29|57.08|1",SHH:"Shismaref|US|66.26|-166.06|1",PEG:"Perugia|IT|43.10|12.38|1",LAI:"Lannion|FR|48.73|-3.47|1",KSY:"Kars|TR|40.61|43.10|0",GOH:"Nuuk|GL|64.18|-51.75|1",LKL:"Lakselv|NO|70.05|24.93|1",BGC:"Braganca|PT|41.82|-6.75|1",TEE:"Tbessa|DZ|35.47|8.15|1",AUC:"Arauca|CO|7.09|-70.76|1",VRK:"Varkaus|FI|62.32|27.92|0",KTS:"Brevig Mission|US|65.33|-166.49|1",BMU:"Bima|ID|-8.47|118.72|1",RGL:"Rio Gallegos|AR|-51.63|-69.22|1",KRL:"Korla|CN|41.76|86.15|1",IAO:"Del Carmin|PH|9.86|126.01|",OUA:"Ouagadougou|BF|12.37|-1.52|1",GRW:"Graciosa Island|PT|39.05|-28.05|0",LKH:"Long Akah|MY|3.32|114.78|1",YRJ:"Roberval|CA|48.52|-72.23|1",YBW:"Bedwell Harbor|CA|48.75|-123.23|1",WEI:"Weipa|AU|-12.67|141.87|1",SKX:"Saransk|RU|54.17|45.17|0",IYK:"Inyokern|US|35.65|-117.81|1",KWN:"Quinhagak|US|59.75|-161.92|1",KXF:"Koro|FJ|-17.33|179.83|1",EMK:"Emmonak|US|62.78|-164.52|0",DQA:"Daqing|CN|0.00|0.00|2",MDK:"Mbandaka|CD|0.07|18.27|1",TOM:"Tombouctou|ML|16.77|-3.01|1",JAV:"Ilulissat|GL|69.22|-51.10|1",KSU:"Kristiansund|NO|63.11|7.84|0",AOE:"Eskişehir|TR|39.81|30.52|2",GWD:"Gwadar|PK|25.12|62.33|1",BJX:"Leon|MX|21.12|-101.67|0",SPP:"Menongue|AO|-14.64|17.73|",RVD:"Rio Verde|BR|-5.43|-40.43|0",JHW:"Jamestown|US|42.15|-79.26|1",EDR:"Edward River|AU|-14.90|141.62|1",TTE:"Ternate|ID|0.80|127.40|1",ENY:"Yanan|CN|22.20|113.09|1",PHM:"Boeblingen|DE|48.68|9.02|0",ELC:"Elcho|AU|-12.02|135.57|1",MLM:"Morelia|MX|19.70|-101.18|1",DIB:"Dibrugarh|IN|27.48|94.90|1",LSA:"Losuia|PG|-8.53|151.07|1",NIM:"Niamey|NE|13.52|2.12|1",TLE:"Tulear|MG|-23.35|43.67|1",CFC:"Cacador|BR|-26.78|-51.02|0",INI:"Nis RS|RS|43.33|21.85|0",TNA:"Jinan|CN|36.67|117.00|1",FLA:"Florencia|CO|1.59|-75.56|1",IGU:"Iguassu Falls|BR|-25.60|-54.48|1",MWX:"Gwangju Muan|KR|34.99|126.38|2",ILO:"Iloilo|PH|10.70|122.56|1",BHE:"Blenheim|NZ|-41.52|173.95|1",ANA:"Anaheim|US|33.84|-117.92|0",ZAT:"Zhaotong|CN|27.33|103.76|",RBQ:"Rurrenabaque|BO|-14.44|-67.53|1",SIF:"Simara|NP|27.16|84.98|",DOU:"Dourados|BR|-22.22|-54.81|1",UAK:"Narsarsuaq|GL|61.17|-45.42|1",WIN:"Winton|AU|-36.52|146.08|1",HYS:"Hays|US|38.88|-99.33|1",JIK:"Ikaria Island|GR|37.67|26.33|1",OZZ:"Ourzazate|MA|30.92|-6.92|1",UIN:"Quincy|US|42.25|-71.00|1",PLH:"Plymouth|GB|50.37|-4.14|1",GYL:"Argyle|AU|-16.33|128.67|",GOP:"Gorakhpur|IN|29.45|75.68|1",YMF:"Montagne Harbor|CA|48.82|-123.20|",ZCL:"Zacatecas|MX|22.78|-102.57|1",YDS:"Desolation Sound|CA|49.97|-124.73|",FUE:"Puerto Del Rosario|ES|28.50|-13.87|1",BNX:"Banja Luka|BA|44.78|17.19|1",IXI:"Lilabari|IN|27.29|94.09|1",PHC:"Port Harcourt|NG|4.79|7.00|1",NDB:"Nouadhibou|MR|20.90|-17.04|1",KVL:"Kivalina|US|67.73|-164.53|1",GJL:"Jijel|DZ|36.82|5.77|1",ZIH:"Zihuatanejo|MX|17.63|-101.55|1",NNT:"Nan Th|TH|18.80|100.78|1",NYA:"Nyagan|RU|",TUK:"Turbat|PK|26.00|63.05|1",CJA:"Cajamarca|PE|-7.16|-78.50|1",TYD:"Tynda|RU|55.28|124.73|0",PMQ:"Perito Moreno|AR|-41.12|-71.42|0",SCY:"San Cristobal|EC|-0.83|-89.43|1",GDL:"Guadalajara|MX|20.67|-103.33|1",CUZ:"Cuzco|PE|-13.52|-71.98|0",MYR:"Myrtle Beach|US|33.69|-78.89|1",SDE:"Santiago Del Estero|AR|-27.78|-64.27|1",RBX:"|SD|",AJF:"Al Jouf|SA|29.98|40.20|1",OST:"Ostende|BE|51.22|2.92|0",MLL:"Marshall|US|32.54|-94.37|1",KHH:"Kaohsiung|TW|22.63|120.32|1",TOH:"Torres|VU|-13.17|166.75|",CCU:"Kolkata|IN|22.57|88.37|1",TAP:"Tapachula|MX|14.90|-92.28|1",IUE:"Niue|NU|-19.03|-169.87|1",TKD:"Takoradi|GH|4.89|-1.77|",AAL:"Aalborg|DK|57.05|9.93|1",TGU:"Tegucigalpa|HN|14.10|-87.22|1",ZMT:"Masset|CA|54.02|-132.10|0",JRS:"Jerusalem|IL|31.77|35.23|0",PAD:"Paderborn|DE|51.72|8.75|1",FLO:"Florence|US|34.19|-79.72|1",YXY:"Whitehorse|CA|60.72|-135.05|1",YEI:"Bursa|TR|40.23|29.55|",PUK:"Pukarua|PF|-18.27|-137.00|1",PIA:"Peoria|US|40.69|-89.59|1",ABR:"Aberdeen|US|45.45|-98.43|1",WBQ:"Beaver|US|40.70|-80.30|1",POJ:"Patos De Minas|BR|-18.58|-46.52|1",AET:"Allakaket|US|66.57|-152.65|0",RUT:"Rutland|US|43.61|-72.97|1",TAM:"Tampico|MX|22.22|-97.85|1",CIJ:"Cobija|BO|-11.03|-68.73|1",BUQ:"Bulawayo|ZW|-20.15|28.58|1",TGZ:"Tuxtla Gutierrez|MX|16.75|-93.12|1",LIT:"Little Rock|US|34.75|-92.29|1",YMK:"Mys Kamenny|RU|0.00|0.00|2",UBJ:"Ube Jp|JP|33.93|131.27|1",GYM:"Guaymas|MX|27.93|-110.90|1",CGR:"Campogrande|BR|-20.46|-54.67|1",HHZ:"Hikueru|PF|-17.53|-142.53|",YSF:"Stony Rapids|CA|59.25|-105.83|0",YSQ:"Songyuan|CN|45.15|124.83|0",ANS:"Andahuaylas|PE|-13.66|-73.39|1",BBI:"Bhubaneswar|IN|20.23|85.83|1",BOC:"Bocas Del Toro|PA|9.33|-82.25|1",FKS:"Fukushima|JP|37.75|140.47|1",WUT:"Dingxiang County|CN|38.52|113.00|0",VOZ:"Voronezh|RU|51.67|39.17|1",YQI:"Yarmouth|CA|43.83|-66.12|1",SCC:"Prudhoe Bay Deadhorse|US|70.20|-148.47|1",ILP:"Ile des Pins|NC|-22.62|167.50|0",CFR:"Caen|FR|49.18|-0.37|1",UTU:"Ustupo|PA|9.67|-78.83|",LHW:"Lanzhou|CN|36.06|103.79|1",RRR:"|PF|",PDG:"Padang|ID|-0.95|100.35|1",SBN:"South Bend|US|41.68|-86.25|1",WTL:"Tuntatuliak|US|60.35|-162.63|1",BJZ:"Badajoz|ES|38.88|-6.97|1",TBO:"Tabora|TZ|-5.07|32.84|",QSR:"Salerno|IT|40.66|14.80|1",TEN:"Tongren|CN|27.72|109.19|1",DIK:"Dickinson|US|29.46|-95.05|1",GAL:"Galena|US|42.42|-90.43|1",VIN:"Vinnitsa|UA|49.23|28.48|0",GEL:"Santo Angelo|BR|-28.30|-54.26|1",MHD:"Mashad|IR|36.30|59.61|1",ERI:"Erie|US|42.13|-80.09|1",LUH:"Ludhiana|IN|30.90|75.85|1",ORV:"Noorvik|US|66.84|-161.03|0",LJG:"Lijiang City|CN|26.87|100.22|1",DUM:"Dumai|ID|1.58|101.47|",YVA:"Moroni|KM|-11.70|43.24|1",GCK:"Garden City|US|37.93|-100.73|1",PDL:"Ponta Delgada|PT|37.73|-25.67|1",ABV:"Abuja|NG|9.08|7.53|1",SCT:"Socotra|YE|12.50|54.00|0",GAF:"Gafsa|TN|34.42|8.82|",KDZ:"Katugastota|LK|0.00|0.00|0",LNY:"Lanai|US|20.78|-156.95|1",ZNZ:"Zanzibar|TZ|-6.16|39.20|0",TKJ:"Tok Ak|US|63.30|-143.00|1",IKS:"Tiksi|RU|71.70|128.90|1",SVP:"Kuito|AO|-12.40|16.96|2",VFA:"Victoria Falls|ZW|-17.93|25.83|1",IWD:"Ironwood|US|46.45|-90.17|1",DED:"Dehra Dun|IN|30.32|78.03|1",LXS:"Limnos|GR|39.92|25.25|1",OOM:"Cooma|AU|-36.23|149.13|1",XBJ:"Birjand|IR|32.90|59.25|",SEN:"Southend|GB|51.54|0.71|0",TZX:"Trabzon|TR|41.01|39.73|0",ARK:"Arusha|TZ|-3.37|36.68|1",KSQ:"Karshi|UZ|38.80|65.77|1",OAJ:"Jacksonville|US|34.83|-77.61|1",MOC:"Montes Claros|BR|-16.73|-43.86|1",WXN:"Wanxian|CN|30.80|108.39|1",TUU:"Tabuk|SA|28.38|36.58|0",YWM:"Williams Harbour|CA|52.34|-56.01|",BDP:"Bhadrapur|NP|26.53|88.08|",GES:"General Santos|PH|6.11|125.17|0",LLB:"|CN|",KMS:"Kumasi|GH|6.68|-1.62|1",JNB:"Johannesburg|ZA|-26.20|28.08|1",OGX:"Ouargla|DZ|31.95|5.33|1",EDA:"Edna Bay|US|55.95|-133.67|",VHM:"Vilhelmina|SE|64.62|16.65|1",VTG:"Vung Tau|VN|10.35|107.07|0",KIH:"Kish Island|IR|26.54|53.98|1",CXR:"Cam Ranh|VN|11.92|109.16|0",KNS:"King Island|AU|-39.88|143.88|1",MJM:"Mbuji Mayi|CD|-6.15|23.63|0",ODY:"Oudomxay|LA|20.58|104.17|",CBI:"Cape Barren Island TAS|AU|-40.33|148.17|1",CCN:"Chakcharan|AF|34.53|65.27|",SIA:"Xi An|CN|34.26|108.93|1",AKI:"Akiak|US|60.91|-161.21|1",NLD:"Nuevo Laredo|MX|27.50|-99.52|0",ZAZ:"Zaragoza|ES|41.66|-0.88|1",TNO:"Tamarindo|CR|10.92|-85.45|1",TYN:"Taiyuan|CN|37.87|112.56|1",YPT:"Pender Harbor|CA|49.49|-123.98|",DPT:"Deputatsky|RU|69.31|140.04|0",APK:"Apataki|PF|-15.42|-146.08|1",NYR:"Nyurba|RU|63.28|118.35|2",PSV:"Papa Stour|GB|60.32|-1.70|2",MEQ:"Meulaboh|ID|4.15|96.12|",PNP:"Popondetta|PG|-8.77|148.23|1",HOQ:"Hof De|DE|50.29|11.86|1",SKK:"Shaktoolik|US|64.32|-161.14|",IRI:"Iringa|TZ|-7.77|35.70|1",SLE:"Salem|US|44.94|-123.03|1",JHG:"Jinghong|CN|21.98|100.82|1",EBU:"St Etienne|FR|45.43|4.40|1",TPI:"Tapini|PG|-8.37|146.98|1",MFK:"Matsu|TW|26.17|119.92|1",INH:"Inhambane|MZ|-23.87|35.41|",FOD:"Fort Dodge|US|42.50|-94.17|1",AMD:"Ahmedabad|IN|23.03|72.62|1",KAN:"Kano|NG|12.00|8.52|0",LFW:"Lome|TG|6.13|1.22|1",FUO:"Fuoshan|CN|23.13|113.28|",MNA:"Melangguane|ID|4.05|126.70|1",LPT:"Lampang|TH|18.30|99.51|1",ULG:"Ulgit|MN|48.97|89.97|1",MME:"Teesside|GB|54.52|-1.42|1",CUC:"Cucuta|CO|7.88|-72.51|1",PDA:"Puerto Inirida|CO|3.88|-67.88|",COS:"Colorado Springs|US|38.83|-104.82|1",PHF:"Newport News|US|36.98|-76.43|1",NPE:"Napier Hastings|NZ|-39.47|176.87|1",URY:"Gurayat|SA|31.33|37.33|1",BHJ:"Bhuj|IN|23.27|69.67|1",TFI:"Tufi|PG|-9.08|149.32|1",KYU:"Koyukuk|US|64.88|-157.70|1",IMT:"Iron Mountain|US|45.82|-88.07|1",HGH:"Hangzhou|CN|30.26|120.17|1",XRY:"Jerez De La Frontera|ES|36.68|-6.13|1",KHZ:"Kauehi|PF|-15.77|-145.12|1",RTA:"Rotuma Island|FJ|-12.50|177.08|1",KGS:"Kos Gr|GR|36.79|27.10|0",RAI:"Praia|CV|14.92|-23.52|1",LIG:"Limoges|FR|45.85|1.25|1",NAU:"Napuka Island|PF|-14.20|-141.25|1",HUH:"Huahine|PF|-16.75|-151.00|0",CYX:"Cherskiy|RU|68.75|161.35|1",UNK:"Unalakleet|US|63.87|-160.79|0",HOT:"Hot Springs|US|34.48|-93.10|0",KFP:"False Pass|US|54.85|-163.41|1",CPV:"Campina Grande|BR|-7.23|-35.88|0",ACR:"Araracuara|CO|-0.38|-72.30|",YGV:"Havre St Pierre|CA|50.25|-63.58|1",JGS:"Ji an|CN|26.90|114.74|",NDU:"Runda|NA|-17.95|19.72|1",KMJ:"Kumamoto|JP|32.80|130.72|1",STW:"Stavropol|RU|45.04|41.97|1",SNR:"St Nazaire|FR|47.29|-2.18|1",YQG:"Windsor|CA|42.30|-83.02|1",YPJ:"Aupaluk|CA|59.30|-69.60|1",BPF:"Batuna|SB|-8.55|158.12|",UBA:"Uberaba|BR|-19.75|-47.93|1",CMW:"Camaguey|CU|21.38|-77.92|0",RUA:"Arua|UG|3.02|30.93|1",CSA:"Colonsay Island|GB|56.08|-6.20|1",TRS:"Trieste|IT|45.65|13.78|1",SNN:"Shannon|IE|52.70|-8.86|1",HOI:"Hao Island|PF|-18.15|-140.95|1",LKB:"Lakeba|FJ|-18.22|-178.78|1",INZ:"In Salah|DZ|27.25|2.52|1",SOW:"Show Low|US|34.25|-110.03|1",FAV:"Fakarava|PF|-16.32|-145.62|1",ICI:"Cicia|FJ|-17.75|-179.30|0",TBP:"Tumbes|PE|-3.57|-80.44|0",CMX:"Houghton|US|47.12|-88.57|1",MZH:"Merzifon|TR|40.88|35.53|2",IDA:"Idaho Falls|US|43.47|-112.03|1",RCE:"Roche Harbor|US|48.61|-123.17|1",GOM:"Goma|CD|-1.68|29.22|0",NAJ:"Nakhichevan|AZ|39.19|45.46|1",OSK:"Oskarshamn|SE|57.27|16.43|1",AIN:"Wainwright|US|70.63|-160.03|1",MFU:"Mfuwe|ZM|-12.89|31.92|1",OLA:"Orland|NO|63.70|9.62|1",TOX:"Tobolsk|RU|58.20|68.27|0",UMS:"Ust-Maya|RU|60.42|134.55|0",GIS:"Gisborne|NZ|-38.65|178.00|1",FNI:"Nimes|FR|43.83|4.35|1",HOB:"Hobbs|US|32.70|-103.14|1",HFE:"Hefei|CN|31.86|117.28|1",PHE:"Port Hedland|AU|-20.32|118.57|1",MGZ:"Myeik|MM|12.45|98.62|2",URG:"Uruguaina|BR|-5.81|-37.44|1",IKI:"Iki Jp|JP|33.75|129.79|1",TPQ:"Tepic|MX|21.50|-104.90|1",BCX:"Beloreck|RU|53.93|58.33|0",AMI:"Mataram|ID|-8.58|116.12|1",CCV:"Craig Cove|VU|-16.20|167.50|",MWA:"Marion|US|37.75|-89.02|1",DLC:"Dalian|CN|38.91|121.60|0",TUO:"Taupo|NZ|-38.68|176.08|1",MQX:"Makale|ET|13.50|39.48|1",MUR:"Marudi|MY|4.18|114.32|0",VDH:"Dong Hoi|VN|17.52|106.59|",YYL:"Lynn Lake|CA|56.83|-101.08|1",MGT:"Milingimbi|AU|-12.09|134.89|",SFN:"Santa Fe|AR|-31.63|-60.70|1",YPW:"Powell River|CA|49.85|-124.54|1",IWJ:"Iwami|JP|34.78|134.53|1",HAK:"Haikou|CN|20.05|110.34|0",YQX:"Gander|CA|48.97|-54.59|1",VKG:"Rach Gia|VN|10.02|105.08|1",NYM:"Nadym|RU|65.48|72.72|1",KGX:"Grayling|US|44.66|-84.71|1",VCT:"Victoria|US|28.85|-96.91|1",CGD:"Changde|CN|29.03|111.68|1",PUG:"Port Augusta|AU|-32.50|137.77|1",BLJ:"Batna|DZ|35.57|6.18|2",WRO:"Wroclaw|PL|51.10|17.03|1",MLS:"Miles City|US|46.41|-105.84|1",KDL:"Kardla|EE|58.98|22.80|",SYO:"Shonai|JP|38.81|139.79|1",JUV:"Upernavik|GL|72.78|-56.17|1",YVQ:"Norman Wells|CA|65.28|-126.83|1",HNA:"Morioka|JP|39.70|141.15|0",YUB:"Tuktoyaktuk|CA|69.44|-133.03|",MYJ:"Matsuyama|JP|35.33|139.85|1",MVB:"Franceville Mvengue|GA|-1.65|13.43|1",GRJ:"George|ZA|-33.97|22.45|1",HTS:"Huntington|US|38.42|-82.45|1",YRA:"Rae Lakes|CA|64.12|-117.35|",WPM:"Wipim|PG|-8.78|142.87|1",BQT:"Brest|BY|52.10|23.70|1",MCP:"Macapa|BR|0.04|-51.07|1",TJQ:"Tanjung Pandan|ID|-2.75|107.65|0",GDQ:"Gondar|ET|12.60|37.47|1",BMD:"Belo|MG|-19.70|44.55|1",TIJ:"Tijuana|MX|32.53|-117.02|1",HOV:"Orsta Volda|NO|62.18|6.15|1",TXN:"Tunxi|CN|29.71|118.31|1",BVI:"Birdsville|AU|-25.90|139.37|1",VCS:"Con Dao|VN|10.37|106.63|",IRA:"Kirakira|SB|-10.45|161.92|1",NCP:"Luzon Island|PH|16.00|121.00|2",FMA:"Formosa|AR|-26.18|-58.18|0",BON:"Bonaire|BQ|12.20|-68.25|1",MRZ:"Moree|AU|-29.47|149.85|1",MSE:"Manston|GB|50.95|-2.27|1",JOI:"Joinville|BR|-26.30|-48.85|1",MXH:"Moro|PG|-6.35|143.25|",YYF:"Penticton|CA|49.50|-119.59|0",OKA:"Okinawa|JP|26.34|127.80|1",VDM:"Viedma|AR|-40.80|-63.00|1",OZC:"Ozamis City|PH|8.18|123.85|2",MJN:"Majunga|MG|-15.72|46.32|1",SRY:"Sary|IR|36.64|53.20|",WVB:"Walvis Bay|NA|-22.96|14.51|1",FHZ:"Fakahina|PF|-15.99|-140.16|",SVG:"Stavanger|NO|58.97|5.75|1",TAI:"Taiz|YE|13.57|44.03|1",MUX:"Multan|PK|30.20|71.48|1",KAJ:"Kajaani|FI|64.23|27.73|1",JNZ:"Jinzhou|CN|41.11|121.14|1",SHP:"Qinhuangdao|CN|39.93|119.59|1",LSW:"Lhoksumawe|ID|5.17|97.17|",DIG:"Diqing|CN|26.13|109.31|1",SFE:"San Fernando|PH|15.03|120.69|1",JAN:"Jackson|US|32.30|-90.20|1",LPL:"Liverpool|GB|53.42|-3.00|1",YAX:"Angling Lake|CA|53.25|-89.56|",LMN:"Limbang|MY|4.75|115.00|1",ILE:"Killeen|US|31.12|-97.73|1",GYA:"Guayaramerin|BO|-10.80|-65.38|1",MCK:"McCook|US|40.20|-100.63|1",CNX:"Chiang Mai|TH|18.79|98.98|0",IXS:"Silchar|IN|24.82|92.80|1",LDN:"Lamidanda|NP|27.25|86.72|",TAK:"Takamatsu|JP|34.33|134.05|1",YRR:"Stuart Island|CA|50.42|-125.17|",MDL:"Mandalay|MM|22.00|96.08|1",ESM:"Esmeraldas|EC|0.97|-79.63|1",JUM:"Jumla|NP|29.27|82.19|",BMW:"Bordj Badji Mokhtar|DZ|21.32|1.03|1",ADU:"Ardabil|IR|38.25|48.30|1",BZG:"Bydgoszcz|PL|53.15|18.00|1",BBO:"Berbera|SO|10.44|45.02|1",KKN:"Kirkenes|NO|69.72|30.05|1",MYU:"Mekoryuk|US|60.39|-166.19|1",YRL:"Red Lake|CA|51.05|-93.82|0",DIW:"Dikwella|LK|5.99|80.73|1",LRS:"Leros|GR|37.52|26.78|1",KOY:"Olga Bay|US|57.08|-154.42|1",RKA:"|PF|",LPP:"Lappeenranta|FI|61.07|28.18|0",TST:"Trang|TH|7.56|99.61|1",LUQ:"San Luis|AR|-33.30|-66.35|1",NVT:"Navegantes|BR|-26.90|-48.65|1",KPO:"Pohang|KR|35.99|129.42|1",LCR:"La Chorrera|CO|-0.73|-73.02|",TYL:"Talara|PE|-4.58|-81.27|1",MRE:"Mara Lodges|KE|-1.18|35.08|1",KTN:"Ketchikan|US|55.34|-131.65|1",HTG:"Hatanga|RU|71.97|102.50|0",PEN:"Penang|MY|5.42|100.33|1",PMW:"Palmas|BR|-10.24|-48.35|1",YYG:"Charlottetown|CA|46.29|-63.13|1",OAK:"Oakland|US|37.80|-122.27|1",VIJ:"Virgin Gorda|VG|18.50|-64.40|1",XAP:"Chapeco|BR|-27.10|-52.62|1",FSZ:"Shizuoka|JP|34.80|138.19|",CUF:"Cuneo|IT|44.40|7.54|1",MYY:"Miri|MY|4.38|113.98|1",AHB:"Abha|SA|18.22|42.51|1",USU:"Busuanga|PH|12.10|120.17|2",DOP:"Dolpa|NP|29.00|82.82|",PVK:"Preveza|GR|38.95|20.75|1",MUK:"Mauke|CK|-20.16|-157.34|0",KZI:"Kozani|GR|40.30|21.79|0",BUW:"Baubau|ID|-4.38|123.05|1",BUA:"Buka Island|PG|-5.25|154.63|1",MHU:"Mount Hotham|AU|-36.97|147.12|1",TNK:"Tununak|US|60.59|-165.26|1",TDX:"Trat|TH|12.24|102.52|1",MQT:"Marquette|US|46.54|-87.40|1",SCO:"Aktau|KZ|48.03|72.83|0",AEB:"Baise|CN|23.72|106.97|0",NDR:"Nador|MA|35.17|-2.93|1",YOG:"Ogoki|CA|51.67|51.67|",TYF:"Torsby|SE|60.15|13.00|2",JMS:"Jamestown|US|46.93|-98.68|1",MLN:"Melilla|ES|35.29|-2.94|1",TCG:"Tacheng|CN|46.67|83.33|",LEQ:"Lands End|GB|50.05|-5.73|1",PJA:"Pajala|SE|67.20|23.37|1",ATZ:"Assiut|EG|27.03|31.00|",SHV:"Shreveport|US|32.53|-93.75|1",YGR:"Iles De Madeleine|CA|47.37|-61.90|1",MJT:"Mytilene|GR|39.11|26.55|1",VQS:"Vieques|PR|18.11|-65.42|1",YIH:"Yichang|CN|30.71|111.28|0",GDV:"Glendive|US|47.11|-104.71|1",YHG:"Charlottetown|CA|52.77|-56.10|1",BPL:"|CN|",KGP:"Kogalym|RU|62.20|74.53|1",GHA:"Ghardaia|DZ|32.49|3.67|0",NOU:"Noumea|NC|-22.27|166.45|0",TSN:"Tianjin|CN|39.14|117.18|0",TKS:"Tokushima|JP|34.07|134.57|1",ABE:"Allentown|US|40.61|-75.49|1",MGM:"Montgomery|US|32.30|-86.39|1",JRH:"Jorhat|IN|26.75|94.22|0",MTR:"Monteria|CO|8.76|-75.89|1",BHH:"Bisha|SA|20.00|42.60|1",CHY:"Choiseul Bay|SB|-6.70|156.43|0",ALM:"Alamogordo|US|32.90|-105.96|1",DIN:"Dien Bien Phu|VN|21.38|103.02|1",KNQ:"Kone|NC|-20.52|164.82|",MWF:"Maewo|VU|-15.17|168.17|1",PZU:"Port Sudan|SD|19.62|37.22|1",HPB:"Hooper Bay|US|61.53|-166.10|1",YFA:"Fort Albany|CA|52.24|-81.59|",SDJ:"Sendai|JP|38.25|140.88|1",PQQ:"Pt Macquarie|AU|-31.43|152.87|1",DIE:"Diegosuarez|MG|-12.35|49.29|1",DZN:"Zhezkazgan|KZ|47.70|67.73|1",NOZ:"Novokuznetsk|RU|53.75|87.17|1",SHF:"Shihezi|CN|44.30|86.03|0",MFE:"McAllen|US|26.20|-98.23|1",HMV:"Hemavan|SE|65.82|15.09|1",ACP:"Sahand|IR|37.35|46.15|",YYE:"Fort Nelson|CA|58.81|-122.70|1",YUT:"|CA|",TCO:"Tumaco|CO|1.82|-78.77|",ISE:"Isparta|TR|37.76|30.55|0",WTP:"Woitape|PG|-8.55|147.25|1",JDH:"Jodhpur|IN|26.29|73.03|1",SRG:"Semarang|ID|-6.97|110.42|1",PSP:"Palm Springs|US|33.83|-116.55|1",BSD:"Baoshan|CN|48.10|123.95|1",SON:"Espiritu Santo|VU|-15.52|167.22|1",BWN:"Bandar Seri Bagawan|BN|4.88|114.93|1",JUZ:"Juzhou|CN|28.97|118.83|",RAH:"Rafha|SA|29.64|43.50|1",LBS:"Labasa|FJ|-16.42|179.38|1",ACT:"Waco|US|31.55|-97.15|1",ROT:"Rotorua|NZ|-38.14|176.25|1",NSK:"|RU|69.33|88.22|1",DIJ:"Dijon|FR|47.32|5.02|1",CBQ:"Calabar|NG|4.95|8.32|1",EBA:"Elba Island|IT|42.77|10.28|1",TOE:"Tozeur|TN|33.92|8.13|1",CLO:"Cali|CO|3.44|-76.52|1",RAS:"Rasht|IR|37.28|49.59|1",RJL:"Logroño|ES|42.47|-2.45|0",RHO:"Rhodes|GR|36.44|28.22|1",CFK:"Chlef|DZ|36.21|1.33|",BDT:"Bado Lite|CD|4.08|22.45|1",FAT:"Fresno|US|36.75|-119.77|1",HFD:"Hartford|US|41.76|-72.69|1",RCP:"Cinder Park|US|57.08|-157.81|",OME:"Nome|US|64.50|-165.41|0",LNE:"Lonorore|VU|-15.86|168.17|",MKW:"Manokwari|ID|-0.87|134.08|0",HKN:"Hoskins|PG|-5.45|150.40|1",KUV:"Kunsan|KR|35.98|126.71|1",REC:"Recife|BR|-8.05|-34.88|1",KOZ:"Ouzinkie|US|57.92|-152.50|1",ITH:"Ithaca|US|42.44|-76.50|1",ATM:"Altamira|BR|-15.45|-47.61|1",IGG:"Igiugig|US|59.33|-155.90|1",KSC:"Kosice|SK|48.72|21.25|0",SXL:"Sligo|IE|54.27|-8.48|1",HEA:"Herat|AF|34.21|62.23|",YPO:"Peawanuck|CA|54.98|-85.43|",PED:"Pardubice|CZ|50.04|15.78|1",ESL:"Elista|RU|46.31|44.26|1",YFH:"Fort Hope|CA|66.53|-86.70|1",VBM:"|US|",GRV:"Groznyj|RU|43.33|45.75|1",PLP:"La Palma|PA|8.33|-78.13|",ALZ:"Alitak|US|56.90|-154.25|1",TSV:"Townsville|AU|-19.25|146.80|1",AST:"Astoria|US|46.19|-123.83|1",OPS:"Sinop|BR|-11.86|-55.50|1",LTD:"Ghadames|LY|30.13|9.50|1",TTB:"Tortoli|IT|39.93|9.66|0",ESC:"Escanaba|US|45.75|-87.06|1",KKJ:"Kitakyushu|JP|33.83|130.95|0",MII:"Marilia|BR|-22.21|-49.95|1",TTA:"Tan Tan|MA|28.45|-11.08|1",ZEM:"East Main|CA|52.25|-78.52|",TVC:"Traverse City|US|44.76|-85.62|1",MPN:"Mount Pleasant|FK|-51.82|-58.45|1",RIZ:"Rizhao|CN|35.42|119.53|0",RKT:"Ras Al Khaimah|AE|25.79|55.94|1",FYU:"Ft Yukon|US|66.58|-145.21|1",HYA:"Hyannis|US|41.65|-70.28|1",CWC:"Chernovtsy|UA|48.27|25.97|1",TBI:"The Bight|BS|24.32|-75.45|",ACA:"Acapulco|MX|16.86|-99.89|1",BJL:"Banjul|GM|13.46|-16.58|1",AQG:"Anqing|CN|30.51|117.05|1",IGM:"Kingman|US|35.19|-114.05|1",CGI:"Cape Girardeau|US|37.31|-89.52|0",AAN:"Al Ain|AE|24.19|55.76|0",AJU:"Aracaju|BR|-10.91|-37.07|1",YNZ:"Yancheng|CN|33.43|120.20|",LDH:"Lord Howe Island|AU|-31.55|159.08|1",AOC:"Altenburg|DE|50.98|12.45|0",MYE:"Miyakejima|JP|34.07|139.56|1",PEX:"|RU|65.12|57.13|0",LCJ:"Lodz|PL|51.75|19.47|0",GGG:"Longview|US|32.39|-94.72|1",MEG:"Malange|AO|-9.54|16.35|1",VAA:"Vaasa|FI|63.10|21.62|1",WKJ:"Wakkanai|JP|45.41|141.67|1",JNG:"Jining|CN|35.42|116.53|",PGM:"Port Graham|US|59.35|-151.83|",GPS:"Galapagos Is|EC|-0.43|-90.28|1",ELP:"El Paso|US|31.76|-106.49|1",BUC:"Burketown|AU|-17.72|139.57|1",HAS:"Hail|SA|27.55|41.38|1",DGP:"Daugavpils|LV|55.88|26.53|0",IGA:"Inagua|BS|21.08|-73.30|1",YBG:"Bagotville|CA|48.32|-70.99|0",AKP:"Anaktuvuk Pass|US|68.14|-151.74|1",SHD:"Staunton|US|38.15|-79.07|1",PBC:"Puebla|MX|19.05|-98.20|1",CVU:"Corvo Island|PT|39.70|-31.10|1",PBM:"Paramaribo|SR|5.83|-55.17|1",BFN:"Bloemfontein|ZA|-29.13|26.20|1",WDS:"Shiyan|CN|32.63|110.80|0",YYU:"Kapuskasing|CA|49.42|-82.43|1",ODO:"Bodaybo|RU|57.85|114.19|0",KMO:"Manokotak|US|58.98|-159.06|1",WWT:"Newtok|US|60.94|-164.63|0",MEC:"Manta|EC|-0.95|-80.73|1",OBN:"Oban|GB|56.42|-5.47|1",RUD:"|IR|",HKK:"Hokitika|NZ|-42.72|170.97|1",GPT:"Gulfport|US|30.37|-89.09|1",YNL:"Points North Landing|CA|58.27|-104.08|1",SRI:"Samarinda|ID|-0.50|117.15|0",HJJ:"Zhijiang|CN|30.42|111.75|2",FWA:"Ft Wayne|US|40.98|-85.19|1",MAA:"Chennai|IN|13.09|80.28|1",ANF:"Antofagasta|CL|-23.65|-70.40|1",EAS:"San Sebastian|ES|43.31|-1.97|1",YLE:"Wha Ti/Lac La Martre|CA|63.15|-117.27|",YIF:"Pakuashipi|CA|51.22|-58.67|0",FAI:"Fairbanks|US|64.84|-147.72|1",NKI:"Naukiti|US|55.37|-133.22|",PVC:"Provincetown|US|42.06|-70.18|1",FTU:"Fort Dauphin|MG|-25.03|47.00|1",EAR:"Kearney|US|40.70|-99.08|1",YXJ:"Ft St John|CA|56.23|-120.73|1",PVD:"Providence|US|41.82|-71.41|1",SOM:"San Tome|VE|8.95|-64.15|1",AJN:"Anjouan|KM|-12.25|44.42|1",CLP:"Clarks Point|US|58.84|-158.55|0",ZSA:"San Salvador|BS|24.03|-74.47|1",TIQ:"Tinian|MP|15.00|145.63|1",IOM:"Isle Of Man|GB|54.08|-4.63|1",LYG:"Lianyungang|CN|34.60|119.16|1",LNB:"Lamen Bay|VU|-16.58|168.18|1",ALF:"Alta|NO|69.97|23.24|1",SVS:"Stevens Village|US|66.01|-149.09|1",RDM:"Redmond|US|47.67|-122.12|1",YCU:"Yun Cheng|CN|35.02|110.99|",MXZ:"Meixian|CN|24.30|116.12|1",YPC:"Paulatuk|CA|69.36|-124.07|",SYS:"Saskylakh|RU|71.97|114.09|0",LDU:"Lahad Datu|MY|5.03|118.32|1",MAK:"Malakal|SD|9.56|31.64|2",MUZ:"Musoma|TZ|-1.50|33.80|0",FUN:"Funafuti|TV|-8.52|179.22|0",YZZ:"Trail|CA|49.10|-117.70|1",WEF:"Weifang|CN|36.71|119.10|1",ZBF:"Bathurst|CA|47.63|-65.74|1",DMU:"Dimapur|IN|25.90|93.73|1",YFB:"Iqaluit|CA|63.75|-68.51|1",BRE:"Bremen|DE|53.08|8.81|1",VGO:"Vigo|ES|42.23|-8.72|1",LCG:"La Coruna|ES|43.37|-8.40|0",RIG:"Rio Grande|BR|-32.03|-52.10|1",UEO:"Kume Jima|JP|26.37|126.72|1",RKS:"Rock Springs|US|41.59|-109.20|1",DHI:"Dhangarhi|NP|28.68|80.63|",BPT:"Beaumont|US|30.09|-94.10|1",YSK:"Sanikiluaq|CA|56.53|-79.23|1",LOE:"Loei|TH|17.48|101.72|1",JQE:"Jaque|PA|7.50|-78.17|",FCA:"Kalispell|US|48.20|-114.31|1",SYM:"Simao|CN|22.83|101.00|1",PXU:"Pleiku|VN|13.98|108.00|1",HDF:"Heringsdorf|DE|53.97|14.17|1",KIF:"Kingfisher Lake|CA|53.01|-89.85|",EDL:"Eldoret|KE|0.52|35.28|1",AXM:"Armenia|CO|4.53|-75.68|1",KVC:"King Cove|US|55.06|-162.31|0",RMQ:"Taichung|TW|24.25|120.60|2",GMZ:"San Sebastian De La Gomera|ES|28.10|-17.10|1",IRC:"Circle|US|65.83|-144.06|",HFS:"Hagfors|SE|60.02|13.57|",VLI:"Port Vila|VU|-17.73|168.32|1",PUB:"Pueblo|US|38.25|-104.61|1",LZO:"Luzhou|CN|31.28|118.13|1",ATC:"Arthurs Town|BS|24.63|-75.67|1",PIF:"Pingtung|TW|22.71|120.49|",MSJ:"Misawa|JP|40.68|141.36|1",MAS:"Manus Island|PG|-5.56|154.62|1",SOQ:"Sorong|ID|-0.88|131.25|1",DND:"Dundee|GB|56.50|-2.97|1",KUD:"Kudat|MY|6.88|116.83|1",LME:"Le Mans|FR|48.00|0.20|0",LAZ:"Bom Jesus Da Lapa|BR|-13.26|-43.41|1",AHN:"Athens|US|33.95|-83.33|1",HYL:"Hollis|US|55.48|-132.65|",ERC:"Erzincan|TR|39.75|39.49|0",LZY:"|CN|",MSW:"Massawa|ER|15.61|39.45|1",ENU:"Enugu|NG|6.43|7.48|1",KTB:"Thorne Bay|US|55.69|-132.52|1",OKT:"Oktiabrskij|RU|54.43|53.38|0",PAS:"Paros|GR|37.08|25.15|1",MHT:"Manchester|US|42.94|-71.44|1",RLK:"Bayannur|CN|40.77|107.40|0",ONP:"Newport|US|44.63|-124.05|1",OSY:"Namsos|NO|64.48|11.50|1",NZH:"Manzhouli|CN|49.57|117.33|",GLH:"Greenville|US|33.48|-90.98|1",RJA:"Rajahmundry|IN|16.98|81.78|1",YAB:"Arctic Bay|CA|73.03|-85.18|1",GAU:"Guwahati|IN|26.19|91.75|1",MWK:"Matak|ID|3.30|106.27|",DNH:"Dunhuang|CN|40.17|94.68|0",NDY:"Sanday|GB|59.25|-2.58|1",POS:"Port Of Spain|TT|10.65|-61.52|1",YLL:"Lloydminster|CA|53.28|-110.00|1",BAY:"Baia Mare|RO|47.65|23.58|1",CEZ:"Cortez|US|37.35|-108.59|1",KHU:"Kremenchug|UA|49.10|33.45|0",ACC:"Accra|GH|5.55|-0.22|0",YYC:"Calgary|CA|51.05|-114.08|1",IXA:"Agartala|IN|23.84|91.28|1",PDP:"Punta Del Este|UY|-34.97|-54.95|1",ZYL:"Sylhet|BD|24.90|91.87|1",CJJ:"Cheongju|KR|36.64|127.49|1",BGR:"Bangor|US|44.81|-68.83|1",CPD:"Coober Pedy|AU|-29.02|134.72|1",SAV:"Savannah|US|32.08|-81.10|1",BZR:"Beziers|FR|43.35|3.25|1",YOL:"Yola|NG|9.20|12.48|1",KZD:"Krakor|KH|12.53|104.20|",BUN:"Buenaventura|CO|3.83|-77.00|",DIY:"Diyarbakir|TR|37.92|40.21|0",WAT:"Waterford|IE|52.20|-7.09|1",GCN:"Grand Canyon|US|36.05|-112.14|0",BFF:"Scottsbluff|US|41.87|-103.67|1",FPO:"Freeport|BS|26.53|-78.70|1",INU:"Nauru Island|NR|-0.55|166.92|1",GWL:"Gwalior|IN|26.22|78.18|1",KMG:"Kunming|CN|25.04|102.72|0",MNI:"Montserrat|MS|16.75|-62.23|1",RIS:"Rishiri|JP|45.18|141.25|1",PYJ:"Polyarnyj|RU|66.42|112.05|0",KWE:"Guiyang|CN|26.58|106.72|1",PAH:"Paducah|US|37.08|-88.60|1",DUT:"Dutch Harbor|US|48.01|-120.25|1",CGA:"Craig|US|55.48|-133.15|1",NOB:"Nosara Beach|CR|9.80|-85.53|",WUZ:"Wuzhou|CN|23.46|111.25|",TAH:"Tanna|VU|-19.33|169.25|1",YNB:"Yanbu|SA|24.12|38.07|0",ATW:"Appleton|US|44.26|-88.42|1",GHT:"Ghat|LY|24.96|10.17|1",DLA:"Douala|CM|4.05|9.70|1",CRP:"Corpus Christi|US|27.80|-97.40|0",DGO:"Durango|MX|24.03|-104.67|1",SZX:"Shenzhen|CN|22.55|114.07|1",DLY:"Dillons Bay|VU|-18.70|169.15|1",JNX:"Naxos|GR|37.05|25.48|1",RJK:"Rijeka|HR|45.34|14.41|1",TIR:"Tirupati|IN|13.65|79.42|1",GYN:"Goiania|BR|-16.68|-49.25|0",YTG:"Sullivan Bay|CA|50.88|-126.80|",BGO:"Bergen|NO|60.39|5.32|1",DPL:"Dipolog|PH|8.59|123.34|1",MBI:"Mbeya|TZ|-8.90|33.45|1",ELG:"El Golea|DZ|30.57|2.86|",FEZ:"Fez Ma|MA|34.05|-4.98|1",GNS:"Gunungsitoli|ID|1.28|97.62|1",MCY:"Maroochydore|AU|-26.65|153.10|1",FEN:"Fernando De Noronha|BR|-3.85|-32.42|1",VII:"Vinh City|VN|18.70|105.63|1",DJJ:"Jayapura|ID|-2.53|140.70|0",PTP:"Pointe-a-Pitre|GP|16.27|-61.53|0",WDH:"Windhoek|NA|-22.57|17.08|1",NCA:"North Caicos|TC|21.93|-71.98|1",ZVK:"Savannakhet|LA|104.76|16.56|",SAG:"Shirdi|IN|19.77|74.48|0",BGN:"Belaya Gora|RU|68.55|146.18|0",KZO:"Kyzylorda|KZ|44.83|65.83|0",YUD:"Umiujaq|CA|56.56|-76.55|1",BYM:"Bayamo|CU|20.38|-76.64|1",BSG:"Bata|GQ|1.91|9.80|",LBD:"Khujand|TJ|40.22|69.70|0",SHG:"Shungnak|US|66.89|-157.14|1",LAP:"La Paz|MX|24.13|-110.30|1",PUQ:"Punta Arenas|CL|-53.15|-70.92|1",IXC:"Chandigarh|IN|30.74|76.79|0",ACS:"Achinsk|RU|56.27|90.57|0",SYB:"Seal Bay|US|58.17|-152.50|1",MVY:"Martha S Vineyard|US|41.39|-70.62|1",FDH:"Friedrichshafen|DE|47.65|9.48|1",NBX:"Nabire|ID|-3.37|135.48|1",KZS:"Kastelorizo|GR|36.15|29.59|1",DOD:"Dodoma|TZ|-6.18|35.75|1",GNV:"Gainesville|US|29.69|-82.28|1",BHI:"Bahia Blanca|AR|-38.72|-62.28|1",JBR:"Jonesboro|US|35.84|-90.70|0",AXP:"Spring Point|BS|22.45|-74.00|0",SRE:"Sucre|BO|-19.04|-65.26|1",PNA:"Pamplona|ES|42.82|-1.64|1",CUR:"Curacao|CW|12.17|-69.00|1",TLY:"|RU|",CWL:"Cardiff|GB|51.50|-3.20|1",MCW:"Mason City|US|43.15|-93.20|1",LWY:"Lawas|MY|4.85|115.40|1",SLA:"Salta|AR|-24.78|-65.42|1",AFZ:"Sabzevar|IR|36.17|57.60|",IXZ:"Port Blair|IN|11.67|92.75|1",BSZ:"Bartletts|US|58.23|-157.35|1",GEO:"Georgetown|GY|6.80|-58.17|1",ISP:"Islip|US|40.73|-73.21|1",BJR:"Bahar Dar|ET|11.60|37.38|1",YDP:"Nain|CA|56.53|-61.67|0",MMJ:"Matsumoto|JP|36.23|137.97|1",CXI:"Christmas Island|KI|1.97|-157.45|1",KHM:"Khamtis|MM|25.99|95.68|",BDO:"Bandung|ID|-6.91|107.62|1",ACH:"Altenrhein|CH|47.48|9.55|1",JIM:"Jimma|ET|7.67|36.83|1",LII:"Mulia|ID|-2.33|106.27|0",IAS:"Iasi|RO|47.17|27.60|1",MDC:"Manado|ID|1.50|124.84|1",DUD:"Dunedin|NZ|-45.87|170.50|1",DJE:"Djerba|TN|33.87|10.86|1",RBR:"Rio Branco|BR|-9.97|-67.81|1",TVY:"Tavoy|MM|14.08|98.20|1",LKG:"Lokichoggio|KE|4.20|34.35|1",PBG:"Plattsburgh|US|44.70|-73.48|",PLV:"Poltava|UA|49.58|34.57|0",SDP:"Sand Point|US|55.34|-160.50|1",ZEL:"Bella Bella|CA|52.17|-128.10|",HIB:"Hibbing|US|47.43|-92.94|1",TSR:"Timisoara|RO|45.75|21.23|1",MID:"Merida|MX|20.97|-89.62|1",BVC:"Boa Vista|CV|16.08|-22.83|1",OVD:"Asturias|ES|43.57|-6.03|1",PEI:"Pereira|CO|4.81|-75.70|1",MOI:"Mitiaro Island|CK|-19.50|-158.00|1",KKR:"Kaukura|PF|-15.78|-146.67|1",SOV:"Seldovia|US|59.44|-151.71|0",VGD:"Vologda|RU|59.22|39.90|0",RTG:"Ruteng|ID|-8.60|120.45|1",LRT:"Lorient|FR|47.75|-3.37|0",ULP:"Quilpie|AU|-26.62|144.25|1",LZH:"Liuzhou|CN|29.85|118.18|1",LYA:"Luoyang|CN|34.68|112.45|1",WMK:"Meyers Chuck|US|55.73|-132.18|",IKO:"Nikolski|US|52.94|-168.85|",OXB:"Bissau|GW|11.85|-15.58|1",SIQ:"Singkep|ID|-0.50|104.42|",FAC:"Faaite|PF|-16.68|-145.33|",CUL:"Culiacan|MX|24.80|-107.39|1",IRK:"Kirksville|US|40.19|-92.58|1",EGO:"Belgorod|RU|50.61|36.58|0",WKA:"Wanaka|NZ|-44.70|169.15|1",IXU:"Aurangabad|IN|19.88|75.33|0",YDA:"Dawson City|CA|64.04|-139.12|1",NAW:"Narathiwat|TH|6.42|101.82|1",CIZ:"Coari|BR|-4.08|-63.13|",RVE:"Saravena|CO|6.92|-71.90|",BEB:"Benbecula|GB|57.43|-7.35|0",ITU:"Kurilsk|RU|45.26|147.96|2",WRE:"Whangarei|NZ|-35.73|174.32|1",XIL:"Xilinhot|CN|43.97|116.07|1",TUC:"Tucuman|AR|-26.82|-65.22|1",HIR:"Honiara|SB|-9.43|159.95|1",OSW:"Orsk|RU|51.20|58.57|1",SCV:"Suceava|RO|47.63|26.25|1",SLH:"Sola|VU|-13.88|167.55|",DRG:"Deering|US|43.07|-71.84|1",YAT:"Attawapiskat|CA|52.94|-82.40|1",PRC:"Prescott|US|34.65|-112.42|1",JAU:"Jauja|PE|-11.75|-75.25|",BND:"Bandar Abbas|IR|27.19|56.28|1",WNA:"Napakiak|US|60.70|-161.95|1",PTJ:"Portland|AU|-38.33|141.60|1",URJ:"Uraj|RU|60.12|64.83|1",SZV:"Suzhou|CN|31.31|120.62|0",FRD:"Friday Harbor|US|48.53|-123.02|1",ULZ:"Uliastai|MN|47.75|96.85|",LAQ:"Beida|LY|32.82|21.75|1",LRE:"Longreach|AU|-23.45|144.25|0",YCY:"Clyde River|CA|70.47|-68.59|1",NUA:"Nuwara Eliya|LK|6.97|80.77|1",WSZ:"Westport|NZ|-41.74|171.58|0",HDY:"Hat Yai|TH|7.02|100.47|1",LUO:"Luena|AO|-11.78|19.92|1",HLD:"Hailar|CN|49.20|119.70|1",OUL:"Oulu|FI|65.02|25.47|1",FNT:"Flint|US|43.01|-83.69|1",TBB:"Tuy Hoa|VN|13.08|109.30|1",YEA:"Edmonton|CA|53.55|-113.47|1",DRK:"Drake Bay|CR|0.00|0.00|2",NIC:"Nicosia|CY|35.17|33.37|0",HOR:"Horta|PT|38.53|-28.63|1",GOT:"Gothenburg|SE|57.71|11.97|0",TGH:"Tongoa|VU|-16.90|168.55|",GRI:"Grand Island|US|40.92|-98.34|1",FMO:"Muenster|DE|51.96|7.63|1",SJZ:"Sao Jorge Island|PT|38.65|-28.23|1",OTD:"Contadora|PA|8.67|-79.57|0",MPH:"Caticlan|PH|11.93|121.96|1",KSD:"Karlstad|SE|59.38|13.50|1",BLA:"Barcelona|VE|10.11|-64.69|1",IPA:"Ipota|VU|-18.75|169.18|1",YYT:"St Johns|CA|47.62|-52.75|1",CIF:"Chifeng|CN|42.27|118.96|1",CTU:"Chengdu|CN|30.67|104.07|0",TPP:"Tarapoto|PE|-2.18|-74.10|1",LBA:"Leeds|GB|53.80|-1.55|1",ZFD:"Fond Du Lac|CA|59.32|-107.17|1",GVR:"Governador Valadares|BR|-18.85|-41.95|1",SYY:"Stornoway|GB|58.22|-6.37|1",LYP:"Faisalabad|PK|31.42|73.08|1",OMA:"Omaha|US|41.26|-95.94|1",YLC:"Kimmirut Lake Harbour|CA|62.85|-69.88|1",OND:"Ondangwa|NA|-17.92|15.95|1",YYH:"Taloyoak|CA|69.54|-93.52|1",PPN:"Popayan|CO|8.67|-76.21|1",LUA:"Lukla|NP|27.70|86.72|1",RNN:"Bornholm|DK|55.13|14.91|1",MRQ:"Marinduque|PH|13.36|121.82|",PSS:"Posadas|AR|-27.38|-55.88|1",UIB:"Quibdo|CO|5.69|-76.64|",KUK:"Kasigluk|US|60.88|-162.52|",AAX:"Araxa|BR|-19.59|-46.94|1",JAX:"Jacksonville|US|30.50|-81.67|1",YAY:"St Anthony|CA|51.37|-55.58|1",SHL:"Shillong|IN|25.57|91.88|1",LGI:"Deadmans Cay|BS|23.23|-75.23|1",LEV:"Levuka|FJ|-17.65|177.27|1",IAM:"In Amenas|DZ|28.05|9.64|1",EIS:"Beef Island|VG|18.44|-64.54|1",OOK:"Toksook Bay|US|60.53|-165.10|1",LWN:"Gyumri|AM|40.72|43.83|0",JUI:"Juist|DE|53.68|7.00|1",IAR:"Yaroslavl|RU|57.63|39.87|0",BLI:"Bellingham|US|48.76|-122.49|1",UAQ:"San Juan|AR|-31.54|-68.54|1",JAE:"Jaén|PE|5.71|-78.81|0",CGO:"Zhengzhou|CN|34.76|113.65|0",LIF:"Lifou|NC|-20.88|167.22|1",NTN:"Normanton|AU|-17.67|141.08|1",PNL:"Pantelleria|IT|36.83|11.95|1",KHS:"Khasab|OM|26.19|56.24|1",TGC:"Trenton|MY|36.07|-88.99|",RVK:"Roervik|NO|64.88|11.23|1",HDD:"Hyderabad|PK|25.32|68.36|1",HRB:"Harbin|CN|45.75|126.65|1",ULB:"Ulei|VU|-16.42|168.33|2",MAZ:"Mayaguez|PR|18.26|-67.15|1",BIM:"Bimini|BS|25.73|-79.25|1",PBJ:"Paama|VU|-16.43|168.22|2",DTI:"Diamantina|BR|-18.23|-43.65|1",BWX:"Banyuwangi Regency|ID|-8.22|114.37|0",UVE:"Ouvea|NC|-20.64|166.57|",HHQ:"Hua Hin|TH|12.57|99.96|0",OCC:"Coca|EC|-0.47|-76.93|1",SZF:"Samsun|TR|41.26|36.56|0",ANV:"Anvik|US|62.66|-160.21|1",BCA:"Baracoa|CU|20.35|-74.50|1",WYS:"West Yellowstone|US|44.66|-111.10|1",JAL:"Jalapa|MX|19.53|-96.92|1",BVB:"Boa Vista|BR|2.82|-60.67|1",RDV:"Red Devil|US|61.76|-157.31|0",KOT:"Kotlik|US|63.03|-163.55|1",KGO:"Kirovograd|UA|48.55|32.30|0",CFE:"Clermont-Ferrand|FR|45.78|3.08|0",PJG:"Panjgur|PK|26.97|64.10|1",KGC:"Kingscote|AU|-35.67|137.63|1",CDC:"Cedar City|US|37.68|-113.06|1",GAY:"Gaya|IN|24.78|85.00|1",JZH:"Songpan|CN|32.60|103.60|1",LUV:"Langgur|ID|-5.67|132.72|1",ZSJ:"Sandy Lake|CA|56.98|-107.28|1",FAE:"Faeroe Islands|FO|62.07|-7.27|1",LPK:"Lipetsk|RU|52.62|39.60|1",TUG:"Tuguegarao|PH|17.64|121.73|",BVE:"Brive La Gaill|FR|45.17|1.53|1",JUH:"Chizhou|CN|30.63|117.47|0",YKQ:"Waskaganish|CA|51.20|-78.77|1",YXH:"Medicine Hat|CA|50.05|-110.67|1",TCD:"Tarapaca|CO|-2.93|-69.77|",ZTU:"Zaqatala|AZ|41.56|46.66|0",RBY:"Ruby|US|34.75|-80.18|1",YAO:"Yaounde|CM|3.87|11.52|0",LNK:"Lincoln|US|40.80|-96.67|1",MSO:"Missoula|US|46.87|-113.99|1",LSP:"Las Piedras|VE|11.72|-70.19|1",YZV:"Sept Iles|CA|50.20|-66.38|1",KCC:"Coffman Cove|US|56.01|-132.83|1",BFJ:"Ba|FJ|-17.55|177.68|0",YBC:"Baie Comeau|CA|46.30|-73.38|1",NMA:"Namangan|UZ|40.98|71.56|1",LST:"Launceston|AU|-41.45|147.17|1",THD:"Sao Vang|VN|19.90|105.47|0",SAB:"Saba Island|BQ|17.65|-63.22|1",ZQZ:"Zhangjiakou|CN|40.77|114.88|0",NTX:"Natuna Ranai|ID|3.95|108.38|",HPN:"White Plains|US|41.03|-73.76|1",FDF:"Ft De France|MQ|14.59|-61.01|1",LYI:"Linyi|CN|35.06|118.34|0",YVB:"Bonaventure|CA|48.05|-65.48|1",KRO:"Kurgan|RU|55.43|65.30|1",DQM:"Duqm|OM|19.66|57.70|0",YVP:"Kuujjuaq|CA|58.10|-68.40|1",DMB:"Taraz|KZ|42.90|71.37|0",HRE:"Harare|ZW|-17.86|31.03|1",GDE:"Gode|ET|5.90|43.63|1",SJE:"San Jose Guaviare|CO|2.58|-72.67|1",MQL:"Mildura|AU|-34.20|142.15|1",JDZ:"Jingdezhen|CN|29.29|117.20|1",DKA:"|NG|",EAP:"Mulhouse Basel|CH|0.00|0.00|0",LGK:"Langkawi|MY|6.32|99.85|1",AAY:"Al Ghaydah|YE|16.22|52.18|1",YMT:"Chibougamau|CA|49.92|-74.37|1",GDZ:"Gelendzik|RU|44.57|38.02|1",SPS:"Wichita Falls|US|33.91|-98.49|1",LSY:"Lismore|AU|-28.81|153.28|1",NYK:"Nanyuki|KE|0.02|37.07|1",YUY:"Rouyn Noranda|CA|48.21|-78.83|1",JRO:"Kilimanjaro|TZ|-3.07|37.37|1",RUI:"Ruidoso|US|33.33|-105.67|0",VDE:"Valverde|ES|27.81|-17.89|1",CCZ:"Chub Cay|BS|25.42|-77.88|",LDB:"Londrina|BR|-23.31|-51.16|1",JFR:"Paamiut|GL|62.00|-49.75|1",IBR:"Omitami Iba|JP|36.18|140.41|2",YHO:"Hopedale|CA|55.47|-60.20|1",DYG:"Dayong|CN|29.13|110.48|1",TET:"Tete|MZ|-16.16|33.59|1",ORB:"Orebro Bofors|SE|59.28|15.22|1",UBP:"Ubon Ratchathani|TH|15.25|104.87|0",CDB:"Cold Bay|US|55.19|-162.72|1",TFF:"Tefe|BR|-3.35|-64.71|1",ADH:"Aldan|RU|58.60|125.40|0",WAA:"Wales|US|65.62|-168.09|1",CSL:"San Luis Obispo|US|35.28|-120.66|0",KAT:"Kaitaia|NZ|-35.10|173.24|1",CDV:"Cordova|US|60.49|-145.47|0",NVR:"Novgorod|RU|58.52|31.28|0",EJH:"Wedjh|SA|26.20|36.48|1",MAJ:"Majuro|MH|7.10|171.38|1",CHX:"Changuinola|PA|9.43|-82.52|1",MTS:"Manzini|SZ|-26.48|31.37|1",CIP:"Chipata|ZM|-13.63|32.65|1",IFO:"Ivano-Frankivsk|UA|48.92|24.71|0",SOC:"Solo|ID|-7.56|110.83|1",VVZ:"Illizi|DZ|26.53|8.55|",MLU:"Monroe|US|32.51|-92.12|1",TEB:"Teterboro|US|40.86|-74.06|1",POP:"Puerto Plata|DO|19.80|-70.68|1",MLB:"Melbourne|US|28.10|-80.63|1",NNX:"Nunukan|ID|4.15|117.65|1",RCL:"Redcliffe|VU|-27.21|153.07|",DVL:"Devils Lake|US|48.11|-98.87|1",KKC:"Khon Kaen|TH|16.43|102.83|0",MLY:"Manley Hot Springs|US|65.00|-150.63|0",AXR:"Arutua|PF|-15.25|-146.75|1",YNS:"Nemiscau|CA|49.74|49.74|2",LPX:"Liepaja|LV|56.52|21.02|0",VLK:"Volgodonsk|RU|47.68|42.08|0",CAK:"Akron|US|41.08|-81.52|1",GHB:"Governor S Harbour|BS|25.28|-76.33|1",TRZ:"Tiruchirappali|IN|10.77|78.71|1",YKT:"Klemtu|CA|52.60|-128.52|",CWB:"Curitiba|BR|-25.43|-49.27|1",BFL:"Bakersfield|US|35.37|-119.02|1",SYJ:"Sirjan|IR|29.55|55.66|",QSF:"Setif|DZ|36.18|5.33|",BRW:"Barrow|US|71.29|-156.79|1",YCS:"Chesterfield Inlet|CA|63.34|-90.70|1",RUS:"Marau|SB|-10.53|161.48|0",BUG:"Benguela|AO|-12.58|13.41|1",BET:"Bethel|US|41.37|-73.41|0",ILI:"Iliamna|US|59.75|-154.91|1",THQ:"|CN|",YPH:"Inukjuak|CA|58.45|-78.10|1",BGW:"Baghdad|IQ|33.34|44.39|1",MGB:"Mt Gambier|AU|-37.75|140.78|1",WHK:"Whakatane|NZ|-37.98|177.00|1",HEK:"Heihe|CN|50.22|127.43|",EGX:"Egegik|US|58.22|-157.38|1",YTF:"Alma|CA|48.53|-71.67|1",THE:"Teresina|BR|-5.09|-42.80|1",CGM:"Mambajao|PH|9.25|124.72|0",KET:"Kengtung|MM|21.28|99.60|1",NJF:"Al Najaf|IQ|0.00|0.00|2",JLR:"Jabalpur|IN|23.17|79.95|1",ZKG:"Kegaska|CA|50.19|-61.29|1",MSL:"Muscle Shoals|US|34.74|-87.67|1",BKS:"Bengkulu|ID|-3.80|102.27|1",ESU:"Essaouira|MA|31.51|-9.76|1",RIW:"Riverton|US|40.52|-111.94|1",YMN:"Makkovik|CA|55.17|-59.17|0",ILD:"Lleida|ES|41.73|0.54|2",JSY:"Syros Island|GR|37.42|24.95|1",AXA:"Anguilla|AI|18.22|-63.05|1",RPR:"Raipur|IN|21.23|81.63|1",PAP:"Port Au Prince|HT|18.54|-72.33|1",REG:"Reggio Calabria|IT|38.11|15.66|0",ILZ:"Zilina|SK|49.22|18.74|0",GDN:"Gdansk|PL|54.35|18.67|1",SYZ:"Shiraz|IR|29.61|52.54|1",TLM:"Tlemcen|DZ|35.02|-1.45|",IVL:"Ivalo|FI|68.65|27.60|1",XUZ:"Xuzhou|CN|34.27|117.19|1",OHE:"|CN|",DMD:"Doomadgee|AU|-18.00|138.83|1",SPR:"San Pedro|BZ|17.91|-87.97|1",SSG:"Malabo|GQ|3.75|8.78|1",ABM:"Bamaga|AU|-10.89|142.39|1",KJI:"Burqin|CN|0.00|0.00|2",YXP:"Pangnirtung|CA|66.15|-65.71|1",AZN:"Andizhan|UZ|40.73|72.30|1",YSY:"Sachs Harbour|CA|71.99|-125.24|",BSA:"Bossaso|SO|11.28|49.15|2",HVR:"Havre|US|48.54|-109.76|1",AKJ:"Asahikawa|JP|43.77|142.37|1",TAE:"Daegu|KR|35.87|128.59|1",BUL:"Bulolo|PG|-7.20|146.65|1",TME:"Tame|CO|6.50|-71.77|",GBT:"Gorgon|IR|36.91|54.41|",SBY:"Salisbury Ocean City|US|38.34|-75.51|1",REU:"Reus|ES|41.16|1.11|1",DIR:"Dire Dawa|ET|9.59|41.87|1",PEU:"Puerto Lempira|HN|15.22|-83.77|",OLP:"Olympic Dam|AU|-31.00|136.00|1",RNL:"Rennell|SB|-11.67|160.30|1",BHU:"Bhavnagar|IN|21.77|72.15|1",VLU:"Velikiye Luki|RU|56.38|30.62|0",NHA:"Nha Trang|VN|12.25|109.18|0",TGP:"Bor|RU|2",USJ:"Usharal|KZ|2",RZH:"Preobrazheniye|RU|2",KPW:"Keperveyem|RU|2",M0N:"Moon|ON|2",HSA:"Turkistan|KZ|2",MS1:"Mars|M1|2"},
Airports:{GZP:"Gazipasa||36.30|32.30|0|138",BQJ:"Batagay||67.65|134.69||137",DME:"Domodedovo|MOW|55.40|37.88|0|136",LCY:"London City|LON|51.50|0.05|0|135",SVO:"Sheremetyevo|MOW|55.98|37.42|0|134",ORY:"Orly|PAR|48.73|2.36|0|133",MAD:"Barajas||40.47|-3.56|0|132",JFK:"John F Kennedy|NYC|40.64|-73.78|0|131",AMS:"Schiphol||52.31|4.77|0|130",RVI:"||47.26|39.80|0|129",IEV:"Zhulhany||50.40|30.45|0|128",LED:"Pulkovo||59.80|30.26|0|127",NLI:"Nikolayevsk-on-Amur||0|126",NCE:"Cote D Azur||43.66|7.22|0|125",GVA:"Geneve Cointrin||46.24|6.11|0|124",PRG:"Ruzyne||50.10|14.27|0|123",TYD:"Tynda||55.28|124.73||122",ACE:"Lanzarote||28.94|-13.60|0|121",MUC:"Munich||48.35|11.78|0|120",ISL:"Havalimani|IST|41.28|28.75|0|119",IST:"Istanbul Airport||41.16|28.45|0|119",ROV:"Platov||47.49|39.93|0|118",BCN:"Barcelona||41.30|2.09|0|117",PKC:"Petropavlovsk Kamchatskiy||53.17|158.43|0|116",CLJ:"Napoca||46.78|23.68|0|115",LHR:"Heathrow|LON|51.47|-0.45|0|114",KIV:"Chisinau||46.92|28.93|0|113",TLV:"Ben Gurion||32.01|34.88|0|113",KBP:"Borispol|IEV|50.35|30.92|0|112",TXL:"Tegel|BER|52.56|13.30|0|111",BER:"Berlin Brandenburg||52.36|13.50|0|111",VIE:"Vienna||48.11|16.56|0|110",BEG:"Belgrade Beograd||44.82|20.31|0|109",ZRH:"Zurich||47.46|8.55|0|108",LIS:"Lisboa||38.78|-9.13|0|107",FRA:"Frankfurt||50.04|8.57|0|106",HEL:"Helsinki||60.33|24.97|0|105",CDG:"Charles De Gaulle|PAR|49.01|2.55|0|104",DUS:"Dusseldorf||51.28|6.75|0|103",OSL:"Oslo||60.20|11.08|0|102",PMI:"Palma Mallorca||39.55|2.73|0|100",LCA:"Larnaca||34.88|33.63|0|101",LAX:"Los Angeles||33.94|-118.41|0|99",BRU:"Brussels National||50.90|4.49|0|99",OTP:"Otopeni|BUH|44.57|26.10|0|98",BUD:"Ferihegy||47.43|19.23|0|97",RIX:"Riga||56.92|23.97|0|96",ZAG:"Zagreb||45.74|16.07|0|95",WAW:"Warsaw||52.17|20.97|0|94",ODS:"Central||46.43|30.68|0|93",NUE:"Nuremberg||49.50|11.08|0|92",LJU:"Brnik||46.22|14.46|0|91",CPH:"Copenhagen||55.61|12.63|0|90",BKK:"Suvarnabhumi||13.69|100.74|0|89",HAV:"Jose Marti||22.99|-82.41|0|88",LUX:"Luxembourg||49.63|6.21|0|87",DUB:"Dublin||53.43|-6.25|0|86",SFO:"San Francisco||37.62|-122.38|0|86",AER:"Adler||43.45|39.93|0|85",LGW:"Gatwick|LON|51.15|-0.20|0|84",LDY:"Eglinton||55.04|-7.15|0|83",ARN:"Arlanda|STO|59.66|17.93|0|82",CBR:"Canberra||-35.31|149.19|0|81",CAI:"Cairo||30.14|31.41|0|80",MAN:"Manchester||53.35|-2.28|0|79",KUF:"Samara||53.50|50.15|0|78",AYT:"Antalya||36.91|30.79|0|76",ATH:"Eleftherios Venizelos||37.94|23.94|0|77",FAO:"Faro||37.01|-7.97|0|74",SIP:"Simferopol||45.02|34.00|0|75",SVX:"Koltsovo||56.85|60.60|0|73",SCL:"Arturo Merino Benitez||-33.38|-70.78|0|72",SYD:"Sydney Kingsford Smith||-33.94|151.18|0|71",HOU:"Houston Hobby||29.64|-95.28|0|70",DEL:"Delhi Indira Gandhi||28.57|77.10|0|69",DXB:"Dubai||25.25|55.36|0|67",DPS:"Ngurah Rai||-8.75|115.17|0|67",ALG:"Houari Boumedienne||36.69|3.22|0|68",BPN:"Sepingan||-1.28|116.83|0|66",BOM:"Chhatrapati Shivaji||19.09|72.85|0|65",ZIA:"Zhukovsky|MOW|55.55|38.15|0|64",HKG:"Hong Kong||22.32|113.92|0|63",MRS:"Marseille Provence||43.44|5.22|0|62",ALA:"Almaty||43.35|77.03|0|62",VCE:"Marco Polo||45.50|12.35|0|60",KGD:"Kaliningrad||54.89|20.59|0|61",VLC:"Valencia||39.49|-0.48|0|60",CMN:"Mohamed V|CAS|33.37|-7.59|0|59",SSH:"Ophira||27.85|34.27|0|58",ORN:"Es Senia||35.63|-0.61|0|56",OPO:"Francisco Sa Carneiro||41.17|-8.67|0|57",TIP:"Tripoli||32.91|13.28|0|55",OVB:"Tolmachevo||55.02|82.62|0|54",MJV:"San Javier||37.77|-0.81|0|53",GOI:"Dabolim||15.38|73.83|0|53",SIN:"Changi||1.36|103.91|0|51",TIV:"Tivat||42.40|18.73|0|51",OMS:"Omsk||54.97|73.30|0|52",VNO:"Vilnius||54.63|25.28|0|50",TGD:"Golubovci||42.36|19.25|0|50",CUN:"Cancun Aeropuerto Internacional||21.03|-86.87|0|50",MIA:"Miami||25.79|-80.29|0|50",VVO:"Vladivostok||43.40|132.15|0|50",EDI:"Edinburgh||55.95|-3.37|0|49",NQZ:"Nursultan Nazarbayev International Airport||51.17|71.50|0|48",MLA:"Luqa||35.90|14.52|0|47",DOK:"Donetsk||48.08|37.75|0|46",KLV:"Karlovy Vary||50.20|12.92|0|45",MEX:"Juarez||19.44|-99.07|0|45",HAM:"Fuhlsbuettel||53.63|9.99|0|45",HRG:"Hurghada||27.20|33.87|0|43",CEK:"Chelyabinsk||55.30|61.50|0|44",KRR:"Krasnodar||45.03|39.14|0|44",LIM:"Jorge Chavez||-12.03|-77.12|0|42",UFA:"Ufa||54.73|55.93|0|42",SKG:"Makedonia Airport||40.52|22.97|0|40",UIO:"Mariscal||-0.14|-78.49|0|41",BOS:"Logan||42.37|-71.01|0|41",GLA:"Glasgow||55.87|-4.43|0|39",ATL:"Hartsfield Jackson||33.64|-84.43|0|39",KZN:"Kazan||55.78|49.22|0|39",LAS:"McCarran||36.08|-115.15|0|39",HNL:"Honolulu||21.33|-157.92|0|37",GOJ:"Nizhniy Novgorod||56.00|44.00|0|37",CGN:"Koeln Bonn||50.87|7.14|0|37",PEE:"Perm||57.92|56.01|0|38",BEY:"Beirut||33.81|35.49|0|36",PHL:"Philadelphia||39.87|-75.24|0|36",BLQ:"Guglielmo Marconi||44.53|11.29|0|36",SWT:"Strezhevoy||60.71|77.66|0|34",KLF:"Grabtsevo||54.55|36.37|0|34",LYS:"Lyon Saint Exupery||45.73|5.08|0|35",ORD:"O'Hare|CHI|41.98|-87.91|0|35",KYZ:"Kyzyl||51.67|94.40|0|34",VOG:"Volgograd||48.75|44.50|0|34",VGD:"Vologda||59.28|39.94|0|34",IAR:"Tunoshna||57.56|40.16|0|34",ETH:"Elat||29.56|34.96|0|32",ETM:"Ramon Airport|ETH|29.75|35.00|0|33",ESB:"Esenboga|ANK|40.13|33.00|0|32",IAD:"Washington Dulles|WAS|38.95|-77.45|0|30",CMB:"Bandaranaike||7.17|79.88|0|30",MNL:"Ninoy Aquino||14.51|121.02|0|30",MLE:"Male||4.20|73.52|0|30",KUL:"Kuala Lumpur||2.74|101.69|0|31",EWR:"Newark Liberty|NYC|40.70|-74.17|0|30",CLT:"Charlotte Douglas||35.22|-80.94|0|28",CVG:"Cincinnati No Kentucky||39.05|-84.67|0|28",CLE:"Hopkins||41.41|-81.85|0|28",YUL:"Pierre Elliott Trudeau|YMQ|45.46|-73.75|0|28",MEM:"Memphis||35.05|-89.98|0|28",YYZ:"Lester B Pearson|YTO|43.68|-79.63|0|28",MKE:"General Mitchell||42.95|-87.90|0|28",MBJ:"Sangster||18.50|-77.91|0|29",DTW:"Detroit Metro Wayne City|DTT|42.22|-83.35|0|29",RDU:"Raleigh Durham||35.88|-78.78|0|28",ORK:"Cork||51.84|-8.49|0|28",MDW:"Midway|CHI|41.78|-87.75|0|28",BWI:"Baltimore Washington||39.18|-76.67|0|28",BFS:"Belfast||54.65|-6.22|0|28",KEF:"Keflavik|REK|63.98|-22.61|0|29",STL:"Lambert St Louis||38.75|-90.36|0|28",NAS:"Nassau||25.04|-77.47|0|28",ABZ:"Dyce||57.20|-2.20|0|28",TAS:"Islam Karimov Tashkent International Airport||41.25|69.28|0|26",NCL:"Newcastle||55.04|-1.69|0|27",PFO:"Paphos Intl||34.72|32.48|0|27",ARH:"Arkhangelsk||64.63|40.60|0|25",LWO:"Sknilow||49.82|23.85|0|24",AUH:"Abu Dhabi||24.43|54.65|0|23",MSY:"Louis Armstrong||29.99|-90.25|0|23",ADL:"Adelaide||-34.95|138.53|0|23",BTS:"Ivanka||48.17|17.22|0|22",VRN:"Verona||45.47|10.93|0|22",SOF:"Sofia Vrazhdebna||42.70|23.40|0|22",HAN:"Noibai||21.04|105.89|0|22",WMI:"Modlin|WAW|52.44|20.64|0|20",MEL:"Tullamarine||-37.66|144.83|0|21",FRU:"Bishkek||42.83|74.57|0|21",CAG:"Elmas||39.25|9.06|0|21",VKO:"Vnukovo|MOW|55.58|37.27|0|20",TJM:"Tyumen||57.18|65.48|0|20",KEJ:"Kemerovo||55.33|86.08|0|19",WLG:"Wellington||-41.32|174.80|0|19",HKT:"Phuket Intl||8.11|98.31|0|19",IKT:"Irkutsk||52.27|104.42|0|19",KIN:"Norman Manly||17.95|-76.73|0|19",FCO:"Fiumicino|ROM|41.80|12.24|0|19",MTY:"Escobedo||25.77|-100.10|0|19",BRI:"Bari||41.14|16.79|0|17",SEZ:"Seychelles||-4.67|55.52|0|18",MRV:"Mineralnye Vody||44.22|43.10|0|17",CYS:"Cheyenne||41.16|-104.82|0|17",ALC:"Alicante||38.28|-0.57|0|17",ANC:"Anchorage||61.17|-149.99|0|17",TRN:"Citta Di Torino||45.20|7.65|0|17",SDQ:"Las Americas||18.43|-69.67|0|17",MRU:"Plaisancet||-20.43|57.68|0|17",IBZ:"Ibiza||38.87|1.37|0|17",ULN:"Buyant Uhaa||47.90|106.87|0|15",MJF:"Kjaerstad||65.83|13.20|0|15",RMF:"Marsa Alam||25.63|34.57|0|15",SKP:"Skopje||41.97|21.63|0|16",BHX:"Birmingham||52.45|-1.75|0|15",NBO:"Jomo Kenyatta||-1.32|36.93|0|15",TBS:"Tbilisi International Airport||41.67|44.95|0|16",DEN:"Denver||39.85|-104.72|0|15",HER:"N Kazantzakis||35.34|25.18|0|15",IPC:"Mataveri||-27.12|-109.37|0|13",TLN:"Le Palyvestre||43.10|6.15|0|13",IXL:"Leh||34.17|77.58|0|13",OLB:"Costa Smeralda||40.87|9.50|0|14",FNC:"Madeira||32.69|-16.78|0|13",RTW:"Saratov||51.57|46.07|0|13",YVR:"Vancouver||49.19|-123.19|0|13",PSG:"Petersburg||56.80|-132.94|0|13",SCU:"Antonio Maceo||19.97|-75.84|0|13",PWQ:"Pavlodar||52.18|77.07|0|13",KTT:"Kittila||67.67|24.90|0|13",BNE:"Brisbane||-27.43|153.09|0|13",HRK:"Kharkov||49.93|36.28|0|11",DLM:"Dalaman||36.72|28.78|0|12",VRA:"Juan Gualberto Gomez||23.17|-81.27|0|11",ASF:"Astrakhan||46.42|48.08|0|11",ADK:"Adak Island Ns||51.88|-176.65|0|11",DFW:"Dallas Ft Worth||32.89|-97.03|0|11",BOD:"Bordeaux||44.83|-0.71|0|11",KJA:"Krasnojarsk||56.02|92.83|0|11",SHA:"Hongqiao||31.20|121.33|0|11",MIR:"Habib Bourguiba||35.76|10.75|0|11",TOF:"Tomsk||56.50|84.97|0|11",YXU:"London||43.03|-81.15|0|11",CIX:"Cornel Ruiz||-6.79|-79.83|0|11",RTM:"Rotterdam||51.96|4.44|0|11",TLL:"Ulemiste||59.42|24.75|0|11","VAR":"Varna||43.23|27.83|0|11",CCS:"Simon Bolivar||10.61|-66.99|0|11",BGI:"Grantley Adams||13.07|-59.49|0|11",PEK:"Beijing Capital|BJS|40.07|116.60|0|11",INN:"Kranebitten||47.26|11.35|0|11",KXK:"Komsomolsk Na Amure||50.40|136.95|0|11",NTE:"Nantes Atlantique||47.16|-1.61|0|9",TFN:"Tenerife Norte Los Rodeos|TCI|28.47|-16.33|0|9",RNS:"Saint Jacques||48.07|-1.73|0|9",BTK:"Bratsk||56.37|101.82|0|9",USM:"Ko Samui||9.55|100.07|0|10",SZG:"W A Mozart||47.79|13.01|0|9",SPU:"Split||43.52|16.29|0|9",HAJ:"Hanover||52.46|9.68|0|9",KGF:"Karaganda||49.83|73.17|0|9",NJC:"Nizhnevartovsk||60.95|76.48|0|9",LXA:"Lhasa||29.67|91.15|0|9",DBV:"Dubrovnik||42.56|18.27|0|9",AAR:"Tirstrup||56.31|10.62|0|9",UUD:"Ulan Ude||51.83|107.50|0|10",VSG:"Lugansk||48.57|39.33|0|9",BOJ:"Bourgas||42.42|27.28|0|9",PUJ:"Punta Cana||18.57|-68.38|0|9",PRN:"Pristina||42.57|21.04|0|9",NRT:"Narita|TYO|35.76|140.39|0|9",SEA:"Seattle Tacoma||47.45|-122.31|0|9",KTM:"Tribuvan||27.70|85.36|0|9",SVQ:"San Pablo||37.41|-5.90|0|9",TIA:"Rinas||41.42|19.72|0|9",EBB:"Entebbe||0.04|32.44|0|9",AKL:"Auckland||-37.01|174.80|0|9",SID:"Amilcar Cabral||16.75|-22.95|0|9",KHV:"Novyy||48.52|135.18|0|7",JKH:"Chios||38.34|26.14|0|7",STR:"Echterdingen||48.69|9.21|0|7",MSN:"Dane County Regional||43.08|-89.37|0|7",BRN:"Belp||46.92|7.50|0|7",PUY:"Pula||44.89|13.92|0|7",HTA:"Chita||52.03|113.30|0|8",ASU:"Salvio Pettirosse||-25.24|-57.52|0|7",ASP:"Alice Springs||-23.80|133.88|0|7",DAC:"Zia Intl||23.78|90.39|0|7",EVN:"Yerevan||40.15|44.40|0|7",RAK:"Menara||31.61|-8.04|0|7",HMO:"Gen Ignacio Pesqueira Garcia||29.10|-111.05|0|7",ABJ:"Felix Houphouet Boigny||5.26|-3.93|0|7",IKU:"Issyk-Kul||42.58|76.71|0|8",MSP:"Minneapolis St Paul||44.89|-93.22|0|7",RMI:"Miramare||44.02|12.61|0|7",ASE:"Pitkin Ctyt Sardy Fld||39.22|-106.87|0|7",EGS:"Egilsstadir||65.28|-14.40|0|8",CPO:"Chamonate||-27.42|-70.54|0|7",APW:"Apia||-13.83|-172.00|0|5",CUE:"Cuenca||-2.87|-78.98|0|5",CGK:"Soekarno Hatta|JKT|-6.12|106.65|0|5",BAH:"Bahrain||26.27|50.64|0|5",LHE:"Lahore||31.52|74.40|0|5",RUH:"King Khaled||24.97|46.70|0|5",BLR:"Bengaluru||13.20|77.71|0|6",LEH:"Octeville||49.54|0.09|0|5",AAQ:"Anapa||44.90|37.32|0|5",MCT:"Seeb||23.59|58.28|0|5",LUZ:"Lublin Airport||51.14|22.42|0|6",MGA:"Augusto C Sandino||12.14|-86.17|0|5",BUS:"Batumi||41.61|41.60|0|5",SBH:"St Jean||17.90|-62.85|0|5",DOM:"Melville Hall||15.54|-61.31|0|5",KUN:"Kaunas||54.90|23.92|0|5",KHI:"Quaid E Azam||24.91|67.16|0|5",JMK:"Mykonos Greece||37.44|25.34|0|5",HOG:"Frank Pias||20.79|-76.31|0|5",BIO:"Bilbao||43.30|-2.92|0|5",KBR:"Pengkalan Chepa||6.17|102.29|0|5",PIT:"Pittsburgh||40.50|-80.24|0|5",STI:"Santiago||19.47|-70.70|0|5",SFT:"Skelleftea||64.63|21.08|0|5",LEI:"Almeria||36.84|-2.37|0|5",CHQ:"Souda||35.53|24.15|0|5",ARM:"Armidale||-30.53|151.62|0|5",NAP:"Capodichino||40.89|14.29|0|5",DNK:"Dnepropetrovsk||48.45|34.98|0|5",PTG:"Pietersburg||-23.92|29.97|0|5",LPA:"Aeropuerto De Gran Canaria||27.93|-15.38|0|5",CPT:"Cape Town||-33.96|18.60|0|5",ZQN:"Frankton||-45.02|168.74|0|5",DTM:"Wickede Dortmund||51.52|7.60|0|5",MBA:"Moi||-4.03|39.59|0|5",MQF:"Magnitogorsk||53.45|59.07|0|5",CTA:"Fontanarossa||37.40|15.10|0|5",AUA:"Reina Beatrix||12.50|-70.01|0|5",ZTH:"Zakinthos||37.76|20.89|0|5",CFG:"Cienfuegos||22.15|-80.41|0|5",DMM:"King Fahad||26.47|49.80|0|5",LXR:"Luxor||25.67|32.71|0|5",PSA:"Gal Galilei||43.68|10.39|0|5",DOH:"Doha||25.26|51.57|0|5",FLN:"Hercilio Luz||-27.67|-48.55|0|5",HUY:"Humberside||53.58|-0.35|0|5",ITO:"Hilo Hawaii||19.72|-155.06|0|5",ECN:"Ercan||35.16|33.49|0|5",ASB:"Ashgabat||37.98|58.36|0|5",BJV:"Milas|BXN|37.25|27.68|0|6",BOB:"Motu Mute||-16.44|-151.75|0|5",KRK:"John Paul 11 Balice||50.18|19.80|0|5",LUG:"Agno||46.02|8.97|0|5",ISB:"Islamabad||33.61|73.10|0|5",JED:"King Abdulaziz||21.68|39.15|0|6",BOG:"Eldorado||4.70|-74.15|0|5",KWI:"Kuwait||29.23|47.98|0|5",AMM:"Queen Alia||31.72|36.00|0|5",PRI:"Praslin Island||-4.32|55.69|0|5",TRV:"Thiruvananthapuram||8.48|76.92|0|6",CFU:"I Kapodistrias||39.60|19.91|0|5",DAM:"Damascus||33.41|36.52|0|5",DHN:"Dothan||31.32|-85.45|0|5",MOV:"Moranbah||-22.12|149.53|0|5",IND:"Indianapolis||39.73|-86.28|0|3",MOD:"Harry Sham Fld||37.63|-120.95|0|3",YQB:"Quebec||46.79|-71.40|0|3",ZAD:"Zadar||44.10|15.36|0|3",PWM:"Portland Jetport||43.64|-70.30|0|3",PPL:"Phaplu||27.52|86.60|0|3",PPG:"Pago Pago||-14.33|-170.70|0|3",REP:"Siem Reap||13.40|103.82|0|3",IAH:"George Bush Intercontinental|HOU|29.98|-95.34|0|3",SGN:"Tan Son Nhut||10.82|106.66|0|3",BSB:"Brasilia||-15.86|-47.92|0|3",PEZ:"Penza||53.22|45.00|0|3",RWN:"||50.61|26.14||4",PZB:"Pietermaritzburg||-29.65|30.40|0|3",SGC:"Surgut||61.23|73.33|0|3",TLK:"Talakan||59.88|111.05||4",FKL:"Chess Lamberton||41.38|-79.86|0|3",ETZ:"Metz Nancy Lorraine||48.98|6.25|0|3",IXB:"Bagdogra||26.68|88.33|0|3",PZE:"Penzance||50.11|-5.52|0|3",DYR:"Anadyr||64.73|177.75|0|3",AEY:"Akureyri||65.66|-18.07|0|3",CGP:"Patenga||22.26|91.83|0|3",PNQ:"Lohegaon||18.58|73.92|0|3",CHC:"Christchurch||-43.49|172.53|0|4",JTY:"Astypalaia||36.57|26.37|0|3",SMI:"Samos||37.69|26.91|0|3",OSR:"Mosnov||49.70|18.13|0|3",PDX:"Portland||45.59|-122.59|0|3",TAL:"Ralph Calhoun||65.17|-152.11|0|3",HUN:"Hualien||24.02|121.61|0|3",VXE:"San Pedro||16.85|-24.97|0|3",CNM:"Carlsbad||32.34|-104.26|0|3",YOW:"Ottawa||45.32|-75.67|0|3",NGO:"Nagoya Chubu Centrair||35.30|136.99|0|3",JAI:"Sanganeer||26.82|75.81|0|3",PKV:"Pskov||57.82|28.30|0|4",YEK:"Arviat||61.12|-94.05|0|4",BSL:"Basel EuroAirport Swiss|EAP|47.66|7.65|0|3",SQO:"Gunnarn||64.96|17.80|0|3",KLO:"Kalibo||11.68|122.38|0|3",SUV:"Nausori||-18.03|178.55|0|3",PUW:"Pullman Moscow||46.74|-117.11|0|3",SDY:"Sindey Richland||47.71|-104.19|0|3",TPE:"Chiang Kai Shek||25.08|121.23|0|3",GYD:"Heydar Aliyev|BAK|40.50|49.98|0|4",SJO:"Juan Santa Maria||10.00|-84.20|0|3",MAG:"Madang||-5.21|145.78|0|3",MSS:"Richards Field||44.94|-74.85|0|3",PNH:"Pochentong||11.55|104.85|0|3",FMN:"Four Corners Regional||36.74|-108.23|0|3",MSU:"Moshoeshoe||-29.30|27.51|0|3",CMI:"Univ Of Illinois Willard||40.04|-88.28|0|3",DNZ:"Cardak||37.79|29.70|0|3",AQJ:"Aqaba||29.62|35.02|0|3",DCF:"Canefield|DOM|15.50|-61.33|0|3",ASR:"Kayseri||38.70|35.51|0|3",SDF:"Louisville||38.18|-85.74|0|3",FLW:"Aerodromo Das Flores||39.47|-31.15|0|3",MMK:"Murmansk||68.97|33.37|0|3",PTY:"Tocumen||9.08|-79.38|0|3",UUS:"Yuzhno Sakhalinsk||46.97|142.75|0|3",EMA:"East Midlands|NQT|52.83|-1.33|0|3",MFM:"Macau||22.23|113.58|0|3",USH:"Islas Malvinas||-54.80|-68.33|0|3",DAD:"Da Nang||16.04|108.20|0|4",IXM:"Madurai||9.83|78.09|0|3",FKB:"Soellingen||48.78|8.08|0|3",ZNE:"Newman||-23.42|119.80|0|3",BJU:"||0|0",CKS:"Carajas Arpt||0|0",HSV:"Huntsville||34.64|-86.78|0|0",OWB:"Daviess County Arpt||0|0",XWC:"|VIE||1",TBT:"Tabatinga Intl Arpt||0|0",NPL:"New Plymouth||-39.01|174.18|0|0",AVP:"Wilkes Barre Scranton||41.34|-75.73|0|0",AFL:"Alta Floresta||-10.00|-56.00|0|0",BZV:"Maya Maya||-4.25|15.25|0|0",CCC:"Cayo Coco (Jardines del Rey)||22.51|-78.51|0|2",UIP:"Pluguffan||47.97|-4.17|0|0",NKG:"Nanjing||32.00|118.81|0|0",RSJ:"Rosario Seaplane Base||0|0",YJT:"Stephenville||48.53|-58.55|0|0",BZN:"Gallatin Field||45.78|-111.16|0|0",PHW:"Phalaborwa||-23.93|31.16|0|0",OGZ:"Vladikavkaz||43.20|44.60|0|0",LLF:"Ling Ling||26.70|111.96|0|0",AIA:"Alliance||42.05|-102.81|0|0",FUK:"Itazuke||33.58|130.45|0|0",ERM:"||0|0",HRO:"Boone County||36.26|-93.16|0|0",CGQ:"Changchun||43.88|125.32|0|0",GYS:"Guang Yuan Arpt||0|0",MCG:"||0|0",YPL:"Provincial||51.21|-90.21|0|0",HRI:"Hambantota Mattala Rajapaksa||6.28|81.12|0|1",PIE:"St Petersburg Clearwater|TPA|27.92|-82.68|0|0",KEW:"||0|0",AZR:"||0|0",MLX:"Malatya||38.35|38.25|0|0",LYR:"Svalbard||78.21|15.80|0|0",KPV:"||0|0",SJI:"||0|0",MSR:"Mus||38.73|41.63|0|0",IOA:"Ioannina||39.70|20.83|0|0",ZFN:"||0|0",BEN:"Benina||32.10|20.27|0|0",UAS:"Samburu Airstrip||0.47|37.55|0|0",LBB:"Lubbock Preston Smith||33.66|-101.82|0|0",BHB:"Hancock County||44.45|-68.36|0|0",WUH:"Wuhan||30.50|114.32|0|0",LNZ:"Hoersching||48.23|14.19|0|0",LPS:"Lopez Island||48.48|-122.94|0|0",KDM:"Kaadedhdhoo||0.00|0.00|0|2",BFQ:"||0|0",GNA:"Grodna Arpt||0|0",JPA:"Castro Pinto||-7.15|-34.95|0|0",PVU:"Provo Arpt||0|0",BZO:"Bolzano||46.52|11.37|0|0",SDU:"Santos Dumont|RIO|-22.90|-43.17|0|0",UTS:"Ust-Tsilma||0.00|0.00|0|2",ZBR:"||0|0",LGA:"La Guardia|NYC|40.78|-73.88|0|0",WNS:"Nawabshah||26.22|68.39|0|0",MZO:"Sierra Maestra||20.32|-77.13|0|0",FRE:"||0|0",AEI:"Algeciras Arpt||0|0",SUL:"||0|0",PGF:"Llabanere||42.74|2.87|0|0",BWK:"||0|0",COU:"Columbia Regional||38.81|-92.22|0|0",KLU:"Klagenfurt||46.64|14.34|0|0",JSI:"Skiathos||39.18|23.51|0|0",BDA:"Bermuda||32.37|-64.69|0|0",CME:"Ciudad Del Carmen||18.65|-91.80|0|0",BUX:"||0|0",UPG:"Hasanudin||-5.07|119.55|0|0",AKU:"||0|0",MST:"Maastricht Aachen||50.91|5.77|0|0",IBE:"Ibague Arpt||0|0",SAW:"Sabiha Gokcen|IST|40.90|29.31|0|0",YMU:"||0|0",VCL:"Chulai||15.42|108.70|0|0",TLH:"Tallahassee||30.40|-84.35|0|0",USN:"Ulsan||32.58|129.35|0|0",GTS:"||0|0",BLK:"Blackpool||53.77|-3.04|0|0",LRH:"Laleu||46.18|-1.19|0|0",YCO:"Kugluktuk||67.83|-115.08|0|0",VDB:"Valdres||61.08|9.33|0|0",NBC:"Nijnekamsk||55.57|52.10|0|0",ERH:"Errachidia Arpt||0|0",BKM:"Bakalalan Arpt||0|0",AVL:"Asheville||35.44|-82.54|0|0",PLQ:"Palanga||55.95|21.08|0|0",PDB:"||0|0",JDF:"Francisco De Assis||-21.75|-43.33|0|0",TCQ:"||0|0",LGQ:"||0|0",DOY:"||0|0",KDV:"||0|0",WLS:"||0|0",SUX:"Sioux Gateway||42.40|-96.38|0|0",LAE:"Nadzab||-6.74|147.00|0|0",BTM:"Bert Mooney||45.95|-112.49|0|0",CLQ:"Colima||19.30|-103.65|0|0",GCI:"Guernsey||49.44|-2.60|0|0",TMR:"||0|0",AOI:"Falconara||43.62|13.52|0|0",GAM:"||0|0",BHY:"Beihai||21.48|109.08|0|0",FUG:"||0|0",PBD:"Porbandar||21.65|69.66|0|0",NQU:"Nuqui Arpt||0|0",RST:"Rochester||43.91|-92.50|0|0",BIL:"Logan Field||45.81|-108.54|0|0",TZA:"Belize City|BZE|17.53|-88.30|0|0",KLL:"||0|0",SUG:"||0|0",PCP:"Príncipe Airport Aeroporto de Príncipe||0.00|0.00|0|2",MCI:"Kansas City|MKC|39.29|-94.73|0|0",SKT:"Sialkot||32.53|74.50|0|0",HOE:"||0|0",PKP:"||0|0",YAA:"||0|0",SFB:"Orlando Sanford|ORL|28.80|-81.27|0|0",LQN:"||0|0",MRO:"Masterton||-40.95|175.65|0|0",STT:"Cyril E King||18.34|-64.97|0|0",VDZ:"Valdez||61.13|-146.24|0|0",WNR:"Windorah||-25.42|142.67|0|0",PVR:"Ordaz||20.69|-105.27|0|0",VHZ:"||0|0",AES:"Vigra||62.56|6.11|0|0",NYI:"||0|0",TTQ:"Tortuquero||10.57|-83.52|0|0",BUR:"Burbank Glendale Pasadena||34.20|-118.36|0|0",YZF:"Yellowknife||62.47|-114.44|0|0",RKD:"Rockland||44.06|-69.10|0|0",QRW:"||0|0",PDT:"Pendleton||45.70|-118.84|0|0",OZH:"Zaporozhye||47.87|35.32|0|0",NAH:"||0|0",PLN:"Emmet Cty||45.57|-84.79|0|0",MTM:"||0|0",BZK:"Bryansk Airport||0.00|0.00|0|2",TWF:"Twin Falls City County||42.48|-114.49|0|0",CAP:"Cap Haitien||19.73|-72.19|0|0",ATT:"||0|0",TBG:"Tabubil||-5.38|141.32|0|0",YIW:"Yiwu||29.27|120.05|0|0",NNB:"||0|0",BJI:"Bemidji||47.51|-94.93|0|0",ZAH:"||0|0",LSH:"||0|0",KSL:"||0|0",MWZ:"Mwanza||-2.44|32.93|0|0",JNS:"Narsaq Heleport||60.92|-46.05|0|0",KOA:"Keahole||19.73|-156.05|0|0",AZS:"Samana International Arpt||0|0",TBN:"Forney Field||37.74|-92.14|0|0",TOD:"Tioman||2.75|104.17|0|0",ZBL:"Biloela||-24.40|150.52|0|0",ABX:"Albury||-36.07|146.98|0|0",VIS:"Visalia||36.32|-119.39|0|0",MOA:"||0|0",MKY:"Mackay||-21.17|149.18|0|0",KVK:"Khibiny||0.00|0.00|0|2",GMO:"||0|0",BCM:"Bacau||46.60|26.88|0|0",AGM:"||0|0",YKS:"Yakutsk||62.08|129.77|0|0",BLZ:"Chileka||-15.67|34.97|0|0",LNS:"Lancaster Arpt||0|0",ACV:"Arcata Eureka||40.98|-124.11|0|0",YKG:"Kangirsuk||60.00|-70.00|0|0",STM:"Eduardo Gomes||-2.43|-54.70|0|0",JIJ:"||0|0",LXG:"||0|0",MXL:"Rodolfg Sachez Taboada||32.63|-115.23|0|0",COL:"||0|0",WWK:"Boram||-3.59|143.67|0|0",SIT:"Sitka||57.05|-135.23|0|0",AAT:"||0|0",ILY:"Islay||55.68|-6.25|0|0",GFK:"Grand Forks Mark Andrews||47.95|-97.18|0|0",PCE:"||0|0",TIN:"||0|0",DEF:"||0|0",BKQ:"Blackall||-24.43|145.43|0|0",HRL:"Rio Grande Valley||26.23|-97.65|0|0",PXM:"Puerto Escondido||15.85|-97.08|0|0",RGI:"Rangiroa||-14.97|-147.67|0|0",SLI:"||0|0",HET:"Hohhot||40.85|111.82|0|0",EJA:"Variguies||7.02|-73.80|0|0",NUS:"||0|0",UIH:"Qui Nhon||13.77|109.23|0|0",MOB:"Mobile||30.69|-88.24|0|0",DAB:"Daytona Beach Regional||29.18|-81.05|0|0",CPE:"Campeche||19.84|-90.51|0|0",TUE:"||0|0",TGK:"Yuzhny||47.24|38.84|0|0",AKK:"||0|0",PZI:"Pan Zhi Hua Bao An Ying Arpt||0|0",AVV:"Melbourne Avalon|MEL|-38.09|144.49|0|0",DEB:"Debrecen Arpt||0.00|0.00|0|2",YYQ:"Churchill||58.77|-94.17|0|0",PIP:"Pilot Point Airport||0|0",SLL:"Salalah||17.04|54.10|0|0",SOY:"Stronsay||59.13|-2.63|0|0",HUE:"||0|0",ILM:"New Hanover Cty||34.27|-77.90|0|0",YCD:"Nanaimo||49.05|-123.87|0|0",GEG:"Spokane||47.62|-117.54|0|0",BKW:"Raleigh Cty Memorial||37.78|-81.12|0|0",LRD:"Laredo||27.54|-99.46|0|0",SKO:"||0|0",OGS:"Ogdensburg||44.68|-75.47|0|0",LDS:"||0|0",HCN:"Hengchun||21.93|120.83|0|0",MRA:"||0|0",PIH:"Pocatello||42.91|-112.59|0|0",GTA:"||0|0",BTR:"Ryan||30.53|-91.15|0|0","FOR":"Pinto Martines||-3.78|-38.53|0|0",TUR:"Tucurui Arpt||0|0",BCD:"Bacolod||10.64|122.93|0|0",LYC:"Hedlunda||64.53|18.72|0|0",BQN:"Borinquen||18.50|-67.13|0|0",QBC:"Bella Colla||52.33|-126.67|0|0",BMY:"||0|0",MEI:"Key Field||32.34|-88.75|0|0",SWJ:"||0|0",RCM:"Richmond Arpt||0|0",NAA:"Narrabri||-30.30|149.83|0|0",CZL:"Ain El Bey||36.28|6.63|0|0",YXL:"Sioux Lookout||50.12|-91.90|0|0",ORI:"||0|0",JXA:"||0|0",TSA:"Sung Shan|TPE|25.06|121.55|0|0",SXP:"||0|0",ELD:"Goodwin Field||0|0",EWN:"Simmons Nott||35.07|-77.04|0|0",KHY:"||0|0",YTH:"Thompson||55.80|-97.87|0|0",UET:"||0|0",BDU:"Bardufoss||69.06|18.54|0|0",SBA:"Santa Barbara||34.43|-119.84|0|0",AUG:"Maine State||44.32|-69.80|0|0",SPN:"Saipan||15.12|145.71|0|0",SJJ:"Butmir||43.82|18.34|0|0",FGI:"Fagali|APW|-13.83|-171.73|0|0",LUN:"Lusaka||-15.33|28.45|0|0",AGH:"Angelholm Helsingborg||56.29|12.86|0|0",COQ:"||0|0",FLS:"||0|0",EOH:"Enrique Olaya Herrara|MDE|6.22|-75.58|0|0",RDZ:"Marcillac||44.37|2.52|0|0",HGU:"Kagamuga||-5.83|144.29|0|0",LWB:"Greenbrier Valley||37.86|-80.40|0|0",SFJ:"Sondre Stromfjord||67.01|-50.72|0|0",FTE:"El Calafate||-50.28|-72.05|0|0",SUF:"S Eufemia||38.90|16.25|0|0",UNG:"||0|0",LCH:"Lake Charles||30.13|-93.23|0|0",RAE:"||0|0",JGO:"||0|0",UUA:"Bugulma||0.00|0.00|0|2",WWP:"Whale Pass Arpt||0|0",HMB:"||0|0",FNA:"Lungi||8.62|-13.20|0|0",PPK:"Petropavlovsk||54.78|69.18|0|0",CPQ:"International Campinas||-22.94|-47.18|0|0",AAE:"Les Salines||36.82|7.81|0|0",PFB:"Passo Fundo||-28.25|-52.33|0|0",KID:"Kristianstad||55.92|14.09|0|0",RAJ:"Rajkot Civil||22.31|70.78|0|0",ECP:"Northwest Florida Beaches Intl|PFN|0|0",RBV:"||0|0",KNH:"Shang Yi||24.42|118.34|0|0",HSG:"Saga||33.15|130.30|0|0",AZD:"Yazd||31.90|54.28|0|0",DUJ:"Dubois Jefferson Cty||41.18|-78.90|0|0",ACI:"The Blaye||49.71|-2.22|0|0",DRW:"Darwin||-12.42|130.87|0|0",WGP:"||0|0",JWN:"Zanjan||36.77|48.36|0|0",BGM:"Edwin A Link Field||42.20|-75.97|0|0",ZOS:"Canal Balo||-40.61|-73.06|0|0",TTT:"Taitung||22.75|121.10|0|0",GET:"Geraldton||-28.79|114.70|0|0",DEE:"||0.00|0.00|0|2",SJW:"Daguocun||38.05|114.47|0|0",MTT:"Minatitlan||17.98|-94.52|0|0",TMP:"Tampere Pirkkala||61.46|23.74|0|0",MDE:"Jose Marie Cordova||6.22|-75.59|0|0",LKN:"Leknes||68.15|13.61|0|0",BHO:"Bhopal||23.28|77.34|0|0",VGZ:"Villagarzon Arpt||0|0",GUA:"La Aurora||14.58|-90.53|0|0",AOS:"||0|0",KCL:"Chignik Lagoon Arpt||0|0",RIY:"Riyan Mukalla||14.65|49.32|0|0",CBH:"||0|0",NNL:"Nondalton Arpt||0|0",TRW:"Bairiki||1.36|172.94|0|0",TUB:"||0|0",TQL:"Tarko-Sale||0.00|0.00|0|2",KUA:"Kuantan||3.77|103.21|0|0",SUB:"Juanda||-7.22|112.72|0|0",TOY:"Toyama||36.64|137.19|0|0",UKX:"||0|0",MBE:"||0|0",CIH:"||0|0",BNA:"Nashville||36.13|-86.68|0|0",ZTB:"Tete A La Baleine||50.72|-59.33|0|0",MOG:"||0|0",BIS:"Bismarck||46.77|-100.75|0|0",CJB:"Peelamedu||11.03|77.04|0|0",YXE:"Saskatoon||52.17|-106.68|0|0",ABS:"Abu Simbel||22.37|31.62|0|0",YGL:"La Grande||53.63|-77.71|0|0",SAP:"Ramon Villeda Morales||15.40|-86.93|0|0",BEW:"Beira||-19.79|34.91|0|0",OAZ:"||0|0",SNE:"Preguica||16.59|-24.29|0|0",MES:"Polonia||3.56|98.67|0|0",PHS:"Phitsanulok||16.79|100.28|0|0",DEA:"||0|0",NCU:"||0|0",BAV:"Baotou||40.67|109.98|0|0",TII:"||0|0",HHH:"Hilton Head||32.22|-80.68|0|0",KKH:"||0|0",AUR:"Tronquieres||44.90|2.42|0|0",FSP:"St Pierre||46.92|-56.17|0|0",PYC:"||0|0",WNH:"||0|0",YQL:"Lethbridge||49.63|-112.79|0|0",BNI:"||0|0",KTA:"Karratha||-20.71|116.77|0|0",VVC:"La Vanguardia Arpt||0|0",CGB:"Marechal Rondon||-15.65|-56.12|0|0",JCH:"||0|0",ZKE:"||0|0",RNA:"||0|0",MWQ:"||0|0",CMG:"Internacional Corumba||0|0",AGT:"Alejo Garcia||-25.50|-54.83|0|0",MOF:"||0|0",BHQ:"Broken Hill||-32.00|141.47|0|0",RZS:"||0|0",KUU:"Bhuntar||31.98|77.10|0|0",SJK:"Sao Jose Dos Campos Arpt||0|0",MVD:"Carrasco||-34.83|-56.03|0|0",RYK:"||0|0",CMH:"Port Columbus||39.99|-82.88|0|0",YXS:"Prince George||53.89|-122.67|0|0",WNZ:"Wenzhou||27.95|120.63|0|0",BKI:"Kota Kinabalu||5.94|116.05|0|0",UII:"||0|0",BBA:"Teniente Vidal||-45.92|-71.69|0|0",AUS:"Bergstrom||30.20|-97.67|0|0",HCR:"||0|0",SBP:"San Luis Obispo County|CSL|35.24|-120.64|0|0",SCZ:"||0|0",AJA:"Campo Dell Oro||41.92|8.80|0|0",APO:"Apartado||7.03|-77.20|0|0",OUZ:"Zouerate||22.73|-12.35|0|0",GUW:"Atyrau||47.12|51.90|0|0",KAO:"Kuusamo||65.99|29.23|0|0",GUM:"Antonio B Won Pat||13.48|144.79|0|0",MAB:"Maraba||-5.37|-49.17|0|0",JLN:"Joplin||37.15|-94.50|0|0",OUK:"||0|0",ZAJ:"||0|0",YHH:"Harbor Airport|YBL|0|0",GVN:"Sovetskaya Gavan|||1",SEB:"||0|0",VIX:"Eurico Sales||-20.26|-40.29|0|0",ROS:"Fisherton||-32.93|-60.78|0|0",KMV:"||0|0",SCE:"University Park||40.77|-77.88|0|0",LLW:"Lilongwe||-13.78|33.78|0|0",LPI:"Saab||58.40|15.52|0|0",GOV:"Nhulunbuy||-12.28|136.82|0|0",SYX:"Sanya||18.30|109.40|0|0",KME:"||0|0",FUJ:"Fukue||32.67|128.83|0|0",NQN:"Neuquen||-38.95|-68.15|0|0",BDL:"Bradley|HFD|41.94|-72.68|0|0",UKS:"Belbek||44.69|33.58|0|2",ALH:"Albany||-34.95|117.81|0|0",GUR:"Gurney||-10.31|150.34|0|0",NVI:"||0|0",TUP:"C D Lemons||34.26|-88.77|0|0",KWF:"Waterfall Spb||0|0",MKZ:"Batu Berendum Arpt||0|0",AHO:"Fertilia||40.63|8.29|0|0",MZT:"Buelina||23.15|-106.25|0|0",HVG:"Valan||70.98|25.83|0|0",GLN:"||0|0",ESD:"Eastsound Orcas Is||48.71|-122.91|0|0",TMM:"Tamatave||-18.11|49.39|0|0",LMM:"Federal Los Mochis||25.82|-108.98|0|2",OER:"Ornskoldsvik||63.41|18.99|0|0",PGA:"Page||36.93|-111.45|0|0",CAN:"Baiyun||23.39|113.30|0|0",NDJ:"N Djamena||12.13|15.04|0|0",VLN:"Valenica||10.18|-68.00|0|0",POL:"Pemba Arpt||0|0",TEX:"Telluride||37.93|-107.82|0|0",KEB:"Nanwalek Arpt||0|0",JYV:"Jyvaskyla||62.40|25.68|0|0",MAU:"||0|0",JIU:"Jiujiang||29.70|115.97|0|0",KTG:"||0|0",YAP:"Yap||9.48|138.08|0|0",WRG:"Wrangell Seaplane Base||56.48|-132.37|0|0",ZPB:"||0|0",ENH:"||0|0",MEE:"||0|0",YHP:"||0|0",JOS:"||0|0",MZG:"Makung||23.57|119.62|0|0",YAM:"Sault Ste Marie||46.48|-84.51|0|0",LWK:"Tingwall Arpt|SDZ|0|0",YNC:"||0|0",YKF:"Kitchener Waterloo Regional||43.45|-80.48|0|0",CRM:"||0|0",MDZ:"El Plumerillo||-32.83|-68.78|0|0",GIZ:"Gizan Aprt||16.87|42.58|0|0",MQP:"Kruger Mpumalanga||-25.39|31.10|0|0",ISU:"||0|0",ERS:"Eros|WDH|-22.62|17.08|0|0",CBT:"||0|0",YTM:"International||46.52|-74.76|0|0",GER:"Rafael Cabrera||21.84|-82.78|0|0",CPA:"||0|0",VPS:"Ft Walton Beach||30.49|-86.53|0|0",JJU:"Qaqortoq||60.72|-46.03|0|0",KCK:"Kirensk|||1",BSX:"||0|0",JPR:"Ji Parana||-8.05|-62.87|0|0",KOV:"||0|0",PHO:"||0|0",GCW:"||0|0",FOG:"Gino Lisa||41.43|15.54|0|0",BNK:"Ballina||-28.83|153.55|0|0",STD:"Mayor Humberto Vivas Guerrero||7.58|-72.07|0|0",JQA:"Qaarsut||70.73|-52.70|0|0",CHT:"||0|0",SJU:"Luiz Munoz Marin||18.44|-66.00|0|0",GXF:"||0|0",REN:"Orenburg||51.80|55.46|0|0",KAC:"||0|0",KRY:"||0|0",CRA:"Craiova||44.32|23.89|0|0",ASJ:"Amami O Shima||28.42|129.70|0|0",WSX:"Westsound Seaplane Base||0|0",MZV:"Mulu Arpt||0|0",OMR:"Oradea||47.03|21.90|0|0",KCZ:"Kochi||33.54|133.68|0|0",LEC:"Chapada Diamantina Arpt||0|0",SXR:"Srinagar||33.99|74.78|0|0",KNK:"Kakhonak Arpt||0|0",IMP:"Imperatriz||-5.53|-47.48|0|0",AMQ:"Pattimura||-2.30|128.08|0|0",CRI:"||0|0",SFG:"Esperance Airport||0|0",YQK:"Kenora||49.79|-94.36|0|0",SGY:"Skagway Minicipal||59.46|-135.32|0|0",ZSE:"St Pierre Dela Reunion||-21.33|55.48|0|0",YEV:"Inuvik Mike Zubko||68.30|-133.48|0|0",KVD:"GANJA||40.74|46.32|0|2",OVS:"Sovetsky||0.00|0.00|0|2",BRM:"Airport Barquisimeto||10.05|-69.36|0|0",SEY:"Selibaby Arpt||0|0",PMC:"Tepual||-41.43|-73.10|0|0",KSM:"||0|0",TOU:"||0|0",YWB:"Kangiqsujuaq||61.60|-71.95|0|0",GKA:"Goroka||-6.08|145.40|0|0",BAZ:"||0|0",RES:"Resistencia||-27.45|-59.05|0|0",IPI:"San Luis||0.87|-77.71|0|0",PMV:"Delcaribe Gen S Marino||11.06|-64.10|0|0",JTC:"Arealva Airport||0|0",NTG:"Nantong||32.07|120.97|0|0",HJR:"Khajuraho||24.82|79.92|0|0",GRB:"Austin Straubel Fld||44.49|-88.13|0|0",YNA:"Natashquan||50.18|-61.80|0|0",MLO:"||0|0",YZR:"Sarnia||43.00|-82.31|0|0",DDC:"Dodge City||37.76|-99.97|0|0",BWW:"||0|0",LEJ:"Leipzig||51.42|12.23|0|0",ABD:"Abadan||30.37|48.23|0|0",BXU:"Butuan||8.95|125.48|0|0",LOO:"||0|0",BIA:"Poretta||42.55|9.49|0|0",ASV:"||0|0",NLG:"Nelson Lagoon Arpt||0|0",SJP:"Sao Jose Do Rio Preto||-20.82|-49.42|0|0",BEU:"Bedourie||-24.23|139.44|0|0",KZB:"||0|0",KLR:"Kalmar||56.69|16.29|0|0",BQK:"Gylnco Jet Port|SSI|31.17|-81.48|0|0",HBA:"Hobart||-42.83|147.48|0|0",DNR:"Pleurtuit||48.59|-2.08|0|0",KAL:"||0|0",YKA:"Davie Fulton||50.70|-120.44|0|0",SKZ:"||0|0",EZV:"Beryozovo||0.00|0.00|0|2",JJN:"Jinjiang||24.88|118.60|0|0",AIT:"Aitutaki||-18.85|-159.75|0|0",SIC:"Sinop Arpt||0|0",GCM:"Owen Roberts||19.29|-81.36|0|0",KMY:"||0|0",COD:"Yellowstone Regional||44.52|-109.03|0|0",ACU:"||0|0",TWA:"Twin Hills||59.17|-159.99|0|0",JOG:"Adisutjipto||-7.79|110.43|0|0",PDV:"Plovdiv||42.30|24.72|0|0",JUJ:"El Cadillal||-24.40|-65.08|0|0",BRO:"South Padre Island||25.91|-97.42|0|0",CCJ:"Kozhikode||11.13|75.95|0|0",SKU:"Skiros Arpt||0|0",XNA:"Northwest Arkansas Regional|FYV|36.28|-94.31|0|0",YHI:"||0|0",LAN:"Lansing||42.78|-84.59|0|0",YRC:"||0|0",NLT:"||0|0",THX:"Turukhansk Airport|||1",ZCO:"Manquehue||-38.76|-72.64|0|0",SNU:"Santa Clara||22.49|-79.94|0|0",BSO:"||0|0",PNS:"Pensacola Regional||30.47|-87.19|0|0",YFC:"Fredericton||45.87|-66.53|0|0",FON:"Fortuna Arpt||0|0",MAF:"Midland||31.94|-102.20|0|0",YQD:"The Pas||53.97|-101.10|0|0",SRZ:"El Trompillo||-17.80|-63.17|0|0",PIX:"Pico||38.47|-28.30|0|0",BDJ:"Sjamsudin Noor||-3.47|114.75|0|0",CYB:"Gerrard Smith||19.69|-79.89|0|0",PPP:"Whitsunday Coast||-20.50|148.56|0|0",TRO:"Taree||-31.82|152.65|0|0",SWA:"Shantou||23.38|116.68|0|0",AOR:"Sultan Abdul Hamlin||6.19|100.40|0|0",KIJ:"Niigata||37.95|139.12|0|0",DBQ:"Dubuque||42.41|-90.71|0|0",CTS:"Chitose|SPK|42.80|141.67|0|0",IXD:"Bamrauli||25.44|81.74|0|0",OSS:"Osh||40.61|72.79|0|0",RIB:"||0|0",YSM:"Ft Smith||60.02|-111.97|0|0",FRO:"Flora||61.58|5.01|0|0",BJA:"Bejaia||36.75|5.08|0|0",MPI:"||0|0",NER:"Neryungri||56.65|124.60|0|0",MRY:"Monterey Peninsula||36.59|-121.85|0|0",PER:"Perth||-31.93|115.97|0|0",MOZ:"Temae||-17.48|-149.77|0|0",PHX:"Sky Harbor||33.44|-112.01|0|0",TYS:"McGhee Tyson||35.81|-83.99|0|0",DGE:"Mudgee Arpt||0|0",ADZ:"San Andres Island||12.58|-81.70|0|0",OOL:"Gold Coast||-28.16|153.50|0|0",PMF:"Parma|MIL|44.80|10.33|0|0",YTL:"Big Trout Arpt||0|0",BOY:"Borgo||11.16|-4.32|0|0",ELV:"||0|0",LBL:"Liberal||37.04|-100.96|0|0",PGV:"Pitt Greenville||35.63|-77.39|0|0",VLL:"Valladolid||41.70|-4.85|0|0",ROW:"Industrial Aircenter||33.30|-104.53|0|0",MAM:"Servando Canales||25.77|-97.52|0|0",CRV:"Crotone Arpt||0|0",LOD:"||0|0",OLF:"||0|0",PVA:"Providencia Arpt||0|0",JST:"Johnstown Cambria||40.32|-78.83|0|2",XGR:"Kangiqsualujjuaq||58.50|-65.98|0|0",LOH:"Aeropuerto Camilo Enriquez||0|0",SOG:"Haukasen||61.16|7.14|0|0",VOL:"Nea Anchialos Arpt||0|0",GZO:"Gizo||-8.12|156.83|0|0",KNG:"||0|0",VER:"Las Bajadas General Heriberto Jara||19.15|-96.18|0|0",YBL:"Campbell River||49.95|-125.27|0|0",KYP:"||0|0",PKR:"Pokhara||28.20|83.99|0|0",PND:"||0|0",MDU:"Mendi||-6.16|143.65|0|0",BAL:"Batman Arpt||0|0",ROC:"Monroe Cty New York||43.12|-77.67|0|0",TRG:"Tauranga||-37.67|176.19|0|0",SSR:"||0|0",PLW:"Mutiara Arpt||0|0",EYW:"Key West||24.56|-81.76|0|0",CSH:"Solovki||0.00|0.00|0|2",NME:"||0|0",FAH:"||0|0",SRP:"Stord||59.83|5.42|0|0",EDO:"Edremit Korfez||0|0",XKH:"Xieng Khouang||19.30|103.37|0|0",MKP:"||0|0",TLS:"Blagnac||43.63|1.36|0|0",HYD:"Rajiv Gandhi International Airport||17.25|78.42|0|2",MUH:"||0|0",DJB:"Sultan Taha Syarifudin||-1.63|103.64|0|0",PEW:"Peshawar||34.00|71.50|0|0",MCV:"McArthur River Arpt||0|0",LRM:"La Romana||18.42|-68.90|0|0",MMH:"Mammoth Lakes||37.63|-118.85|0|0",ALO:"Livingston Betsworth Fld||42.56|-92.40|0|0",RSD:"S Eleuthera||24.89|-76.18|0|0",TIZ:"Tari||-5.86|142.94|0|0",VSA:"Capt Carlos Rovirosa Perez||17.97|-92.93|0|0",DYU:"Dushanbe||38.55|68.82|0|0",SHX:"||0|0",ICT:"Mid Continent||37.65|-97.43|0|0",HUS:"Hughes||66.04|-154.26|0|0",OIM:"Oshima||34.78|139.37|0|0",YHZ:"Halifax||44.88|-63.52|0|0",RAB:"Lakunai||-4.33|152.37|0|0",IZO:"Izumo||35.41|132.89|0|0",TGJ:"||0|0",JBQ:"Dr Joaquin Balaguer||0|0",NLA:"Ndola||-13.00|28.66|0|0",VVI:"Viru Viru|SRZ|-17.63|-63.13|0|0",CKG:"Chongqing||29.50|106.35|0|0",ART:"Watertown||43.99|-76.02|0|0",CYF:"||0|0",SAX:"||0|0",UTN:"Upington||-28.40|21.25|0|0",NSN:"Nelson||-41.30|173.22|0|0",VRL:"Vila Real Arpt||0|0",WNP:"Naga Arpt||0|0",BRQ:"Turnay||49.15|16.70|0|0",BUF:"Greater Buffalo||42.94|-78.74|0|0",SDD:"||0|0",GFN:"Grafton||-29.76|153.03|0|0",DVO:"FRANCISCO BANGOY INTL. ||7.13|125.65|0|2",CFN:"Donegal||55.04|-8.34|0|0",MLI:"Quad City||41.45|-90.50|0|0",TMC:"||0|0",KOJ:"Kagoshima||31.80|130.72|0|0",NNG:"Nanning||22.58|108.13|0|0",CID:"Cedar Rapids||41.88|-91.71|0|0",UND:"||0|0",NAL:"Nalchik||43.53|43.70|0|0",CNQ:"Camba Punta||-27.45|-58.76|0|0",YSO:"Postville||54.92|-59.97|0|0",FRS:"Flores||16.92|-89.88|0|0",SGD:"Sonderborg||54.93|9.79|0|0",BKO:"Senou||12.63|-8.03|0|0",KNU:"Chakeri Arpt||0|0",CEM:"||0|0",NIB:"||0|0",GSO:"Piedmont Triad||36.09|-79.94|0|0",LRR:"||0|0",RVT:"Ravensthorpe||-33.79|120.20|0|0",YBB:"Townsite||68.88|-89.85|0|0",GNY:"Guney Anadolu||40.17|-105.92|0|2",AKS:"||0|0",NGQ:"||0|0",CLD:"Carlsbad|SAN|33.12|-117.27|0|0",RMT:"Rimatara||0.00|0.00|0|2",YHM:"Civic|YTO|43.17|-79.93|0|0",EKO:"J C Harris Field||40.82|-115.79|0|0",NHV:"||0|0",YHU:"St Hubert|YMQ|45.50|-73.60|0|0",TAG:"Tagbilaran Arpt||0|0",BLE:"Dala||60.42|15.52|0|0",GMA:"||0|0",LEA:"Learmonth||-22.23|114.08|0|0",UNN:"Ranong||9.85|98.63|0|0",VCA:"Can Tho||10.05|105.77|0|0",ABL:"Ambler||67.09|-157.85|0|0",EVG:"Sveg||62.03|14.35|0|0",COK:"Kochi||9.94|76.27|0|0",ROB:"Roberts|MLW|6.24|-10.36|0|0",YPX:"Povungnituk||60.03|-77.17|0|0",DLZ:"||0|0",DAR:"Es Salaam||-6.88|39.20|0|0",KLX:"Kalamata||37.07|22.03|0|0",SZB:"Sultan Abdul Aziz Shah|KUL|3.13|101.55|0|0",YWL:"Williams Lake||52.18|-122.04|0|0",AWD:"||0|0",PKB:"Wood County||39.35|-81.44|0|0",KVX:"Kirov||0.00|0.00|0|2",PIN:"||0|0",LOK:"||0|0",ZAL:"Pichoy||0|0",KWT:"||0|0",CFS:"Coffs Harbour||-30.32|153.12|0|0",KHN:"Nanchang||28.68|115.88|0|0",NZE:"||0|0",TOS:"Tromso Langnes||69.68|18.92|0|0",CKX:"||0|0",AGF:"La Garenne||44.17|0.60|0|0",VPY:"||0|0",ERZ:"Erzurum||39.96|41.17|0|0",KIM:"Kimberley||-28.81|24.77|0|0",KXU:"||0|0",UMD:"||0|0",GEV:"Gallivare||67.13|20.82|0|0",SMS:"St Marie||-17.08|49.82|0|0",BZE:"Belize||17.54|-88.31|0|0",BWE:"Braunschweig||52.27|10.53|0|0",ATD:"||0|0",JKL:"Kalymnos Arpt||0|0",AJR:"Arvidsjaur||65.59|19.29|0|0",CEB:"Cebu||10.33|123.91|0|0",PBI:"Palm Beach||26.68|-80.09|0|0",RVV:"||0|0",ZTA:"||0|0",BVG:"||0|0",IHR:"||0|0",MMZ:"||0|0",SML:"Stella Maris||23.58|-75.27|0|0",LMY:"||0|0",JAC:"Jackson Hole||43.61|-110.74|0|0",YOP:"Rainbow Lake||58.50|-119.40|0|0",YMH:"Marys Harbour Arpt||0|0",ABY:"Dougherty Cty||31.53|-84.20|0|0",BTH:"Hang Nadim||1.07|104.13|0|0",INC:"Yinchuan||38.35|106.35|0|0",TNN:"Tainan||22.95|120.20|0|0",CDR:"Chadron||42.84|-103.10|0|0",SHW:"Sharurah||17.42|47.10|0|0",KGE:"||0|0",TSJ:"Tsushima||34.28|129.32|0|0",OSM:"||0|0",MNG:"||0|0",NUX:"Novy Urengoy||66.07|76.52|0|0",PMA:"||0|0",HTN:"||0|0",GBD:"Greate Bend||38.35|-98.86|0|0",MOQ:"Morondava||-20.28|44.32|0|0",TAT:"Poprad–Tatry||49.07|20.24|0|2",PKA:"||0|0",DJG:"||0|0",JGN:"Jiayuguan||39.83|98.42|0|0",SAN:"Lindbergh||32.73|-117.19|0|0",YCK:"Colville||67.17|-126.00|0|0",CCM:"Criciuma Arpt||0|0",RAO:"Leite Lopes||-21.14|-47.77|0|0",WAE:"||0|0",SJL:"||0|0",BES:"Guipavas||48.45|-4.42|0|0",CTL:"Charleville||-26.41|146.26|0|0",CKH:"||0|0",WJU:"||0|0",NST:"Nakhon Si Thammarat||8.47|99.95|0|0",YTE:"Cape Dorset||64.23|-76.53|0|0",FOC:"Fuzhou||26.10|119.28|0|0",SVA:"||0|0",VXC:"||0|0",YOC:"||0|0",BKC:"||0|0",KSN:"Kostanay||53.20|63.55|0|0",SXB:"Enzheim||48.53|7.63|0|0",AJL:"Lengpui Airport||0|0",UTP:"U Tapao||12.68|101.02|0|2",ZHA:"Zhanjiang||21.27|110.47|0|0",JGA:"Govardhanpur||22.46|70.01|0|0",CRL:"Brussels South Charleroi|BRU|50.42|4.43|0|2",ATK:"||0|0",LEN:"Leon||42.58|-5.65|0|0",XIK:"Milan Central|MIL|45.50|9.50|1|2",TMI:"||0|0",POZ:"Lawica||52.42|16.88|0|0",NBS:"||0|0",JHS:"Sisimiut||66.94|-53.70|0|0",POA:"Porto Alegre||-29.99|-51.17|0|0",SSA:"Luis E Magalhaes||-12.92|-38.33|0|0",EWB:"New Bedford||41.68|-70.96|0|0",WST:"Westerly||41.35|-71.80|0|0",MAR:"La Chinita||10.57|-71.73|0|0",MMY:"Hirara||24.78|125.30|0|0",HIJ:"Hiroshima||34.43|132.93|0|0",WRY:"Westray||59.35|-2.95|0|0",ELM:"Elmira Corning Regional||42.16|-76.90|0|0",HLN:"Helena||46.61|-111.98|0|0",IRJ:"La Rioja||-29.38|-66.78|0|0",ISC:"St Marys||49.90|-6.40|0|0",YXN:"Whale Cove||62.23|-92.60|0|0",AZO:"Kalamazoo Cty||42.24|-85.55|0|0",AUK:"||0|0",KOK:"Kokkola||63.72|23.15|0|0",URC:"Urumqi||43.90|87.48|0|0",TGM:"Tirgu Mures||46.53|24.53|0|0",YNO:"||0|0",YSJ:"St John||45.32|-65.88|0|0",GST:"Gustavus||58.43|-135.71|0|0",GIB:"North Front||36.15|-5.35|0|0",BQL:"Boulia||-22.90|139.90|0|0",DLI:"Lienkhang||11.75|108.38|0|0",KTL:"||0|0",AXD:"Dhmokritos||40.86|25.95|0|0",PML:"||0|0",RSA:"Santa Rosa Arpt||0|0",VAW:"Vardoe Luftan||70.35|31.05|0|0",NAV:"Nevsehir||38.63|34.72|0|0",CZX:"Changzhou||31.70|119.97|0|0",JUB:"Juba Arpt||0|0",CAE:"Columbia Metro||33.94|-81.12|0|0",IPH:"Ipoh Arpt||0|0",TCT:"||0|0",JER:"States||49.21|-2.22|0|0",KTW:"Pyrzowice||50.48|19.08|0|0",ZGU:"||0|0",YAK:"Yakutat||59.51|-139.66|0|0",MBT:"Murfreesboro Municipal Arpt||0|0",EUN:"Hassan I||27.13|-13.22|0|0",NVK:"Framnes||68.42|17.43|0|0",DHB:"||0|0",ADA:"Adana||36.98|35.28|0|0",THS:"Sukhothai||17.22|99.82|0|0",AUU:"Aurukin Arpt||0|0",VNX:"Vilanculos||-22.02|35.28|0|0",HAU:"Karmoy||59.41|5.28|0|0",VAS:"Sivas||39.81|36.90|0|0",KYA:"Konya||37.98|32.56|0|0",ADE:"Yemen||12.83|45.03|0|0",WAG:"Wanganui||-39.97|175.02|0|0",WKK:"||0|0",VCP:"Viracopos|SAO|-23.00|-47.13|0|0",KWJ:"Gwangju Airport||35.12|126.81|0|2",ERF:"Erfurt||50.98|10.97|0|0",GIL:"Gilgit||35.92|74.34|0|0",UGI:"||0|0",YWK:"Wabush||52.95|-66.90|0|0",PMR:"Palmerston North||-40.32|175.62|0|0",GRO:"Costa Brava||41.91|2.76|0|0",GLT:"Gladstone||-23.83|151.25|0|0",STX:"Alexander Hamilton||17.70|-64.80|0|0",CYO:"Cayo Largo Del Sur||21.62|-81.52|0|0",LBU:"Labuan||5.30|115.25|0|0",LMC:"Lamacarena Arpt||0|0",BJW:"||0|0",BRC:"San Carlos De Bariloche||-41.15|-71.16|0|0",YOJ:"Footner Lake||58.62|-117.17|0|0",PGU:"||0|0",SVD:"Arnos Vale||13.13|-61.20|0|0",UCT:"||0|0",TGG:"Sultan Mahmood||5.38|103.11|0|0",KGA:"||0|0",EGM:"Sege||-8.55|157.85|0|0",OKC:"Will Rogers World||35.39|-97.60|0|0",PPS:"Puerto Princesa||9.74|118.75|0|2",YWG:"Winnipeg||49.90|-97.23|0|0",YYD:"Smithers||54.83|-127.18|0|0",BQS:"Blagoveshchensk||50.42|127.40|0|0",BSR:"Basra||30.56|47.79|0|0",FSD:"Joe Foss Field||43.58|-96.74|0|0",SHE:"Shenyang||41.82|123.50|0|0",LPY:"Loudes||45.08|3.77|0|0",ALS:"Alamosa||37.44|-105.87|0|0",KOS:"Sihanoukville|||1",BFD:"Bradford Regional||41.80|-78.64|0|0",RDO:"Radom||51.39|21.21||1",SKH:"||0|0",ELS:"East London||-33.04|27.82|0|0",YUX:"Hall Beach||68.78|-81.25|0|0",YCB:"Cambridge Bay||69.10|-105.13|0|0",FLR:"Amerigo Vespucci||43.81|11.20|0|0",STN:"Stansted|LON|51.88|0.23|0|0",CSY:"||0.00|0.00|0|2",GAN:"Gan International Arpt||0|0",HNH:"Hoonah||58.10|-135.40|0|0",YXC:"Cranbrook||49.61|-115.78|0|0",OSD:"Froesoe||63.20|14.49|0|0",RAP:"Rapid City Regional||44.04|-103.06|0|0",BWT:"Burnie Wynyard||-41.00|145.73|0|0",LKO:"Amausi||26.76|80.88|0|0",KRT:"Civil||15.60|32.56|0|0",KTE:"Kertech||4.54|103.43|0|0",AGX:"Agatti Aerodrome||0|0",LIH:"Lihue||21.98|-159.35|0|0",NUK:"||0|0",CIC:"Chico||39.80|-121.86|0|0",KKI:"||0|0",CKD:"Crooked Creek Arpt||0|0",LZC:"Lazaro Cardenas||18.00|-102.22|0|0",AIU:"||0|0",LBP:"Long Banga Airfield Arpt||0|0",NOS:"Fascene||-13.31|48.31|0|0",ASM:"Asmara||15.29|38.91|0|0",BJF:"Batsfjord||70.60|29.67|0|0",FSM:"Ft Smith||35.34|-94.37|0|0",TMJ:"||0|0",ASO:"||0|0",CEC:"Crescent City||41.78|-124.24|0|0",XTG:"Thargomindah||-27.97|143.77|0|0",HOM:"Homer||59.65|-151.48|0|0",DIU:"Diu||20.72|70.92|0|0",VLS:"||0|0",IQT:"C F Secada||-3.75|-73.20|0|0",DEC:"Decatur||39.83|-88.87|0|0",VXO:"Vaxjo||56.93|14.73|0|0",AMA:"Amarillo||35.23|-101.72|0|0",MZL:"Santaguida||5.09|-75.68|0|0",MEB:"Essendon Arpt|MEL|0|0",KCG:"Chignik Fisheries Arpt|KCL|0|0",GOA:"Christoforo Colombo||44.41|8.84|0|0",YVZ:"Deer Lake||52.67|-94.50|0|0",TAB:"Crown Point||11.15|-60.84|0|0",SSJ:"Stokka||65.96|12.47|0|0",NGB:"Ningbo||29.87|121.52|0|0",IPT:"Williamsport Lycoming||41.24|-76.92|0|0",SAL:"Comalapa||13.69|-89.12|0|0",BXR:"||0|0",KBL:"Khwaja Rawash||34.56|69.21|0|0",NOJ:"Nojabrxsk||63.50|75.00|0|0",AKX:"Aqtobe||50.25|57.22|0|0",BKG:"Branson Regional Arpt||0|0",MVT:"||0|0",OTH:"North Bend||43.42|-124.24|0|0",YSB:"Sudbury||46.63|-80.80|0|0",OGG:"Kahului||20.90|-156.43|0|0",ARD:"||0|0",CEN:"Ciudad Obregon||27.39|-109.84|0|0",AMH:"||0|0",CTG:"Rafael Nunez||10.45|-75.51|0|0",MPA:"||0|0",SMR:"Simon Bolivar||11.12|-74.23|0|0",KCM:"Kahramanmaras aRPT||0|0",NYU:"Nyaung U||21.18|94.93|0|0",GCC:"Campbell Cty||44.35|-105.53|0|0",LCE:"Goloson||15.74|-86.86|0|0",BAQ:"E Cortissoz||10.90|-74.78|0|0",SDL:"Sundsvall||62.53|17.45|0|0",NAN:"Nadi||-17.75|177.45|0|0",LMT:"Kingsley Field||42.16|-121.74|0|0",RGA:"Rio Grande||-53.78|-67.75|0|0",TKK:"Truk||7.47|151.85|0|0",PTA:"||0|0",REX:"General Lucio Blanco||26.01|-98.23|0|0",ELH:"North Eleuthera||25.47|-76.69|0|0",DEZ:"Al Jafrah||35.33|40.15|0|0",MKG:"Muskegon Cty||43.17|-86.24|0|0",LIL:"Lesquin||50.56|3.09|0|0",KLW:"Klawock||55.55|-133.10|0|0",SGF:"Springfield Branson Regional||37.24|-93.39|0|0",CNS:"Cairns||-16.88|145.75|0|0",IQQ:"Cavancha Chucumata||-20.22|-70.15|0|0",TVU:"Matei||-16.69|179.87|0|0",WYA:"Whyalla||-33.06|137.51|0|0",NQY:"Newquay Civil||50.44|-4.99|0|0",ISA:"Mount Isa||-20.66|139.48|0|0",VAK:"||0|0",TOB:"Tobruk Arpt||0|0",FKI:"||0|0",YFX:"Fox Harbour Arpt||0|0",AXU:"||0|0",HZH:"||0|0",MKK:"Molokai||21.15|-157.10|0|0",SKB:"Robert L Bradshaw||17.31|-62.72|0|0",LLA:"Kallax||65.54|22.13|0|0",GAO:"Guantanamo Airport||0|0",FLL:"Ft Lauderdale Hollywood||26.07|-80.15|0|0",IVC:"Invercargill||-46.41|168.32|0|0",EAT:"Pangborn Memorial Fld||47.40|-120.21|0|0",JCU:"||0|0",EWD:"Wildman Lake Arpt||0|0",SLZ:"Mal Cunha Machado||-2.58|-44.23|0|0",LAD:"Four De Fevereiro||-8.85|13.24|0|0",HSL:"Huslia||65.70|-156.38|0|0",PLD:"||0|0",ABT:"Al Aqiq||20.29|41.63|0|0",MCX:"Uytash||42.82|47.66|0|2",BME:"Broome||-17.95|122.23|0|0",GWY:"Carnmore||53.28|-9.03|0|0",NNM:"Naryan-Mar||0.00|0.00|0|2",MYG:"||0|0",RMP:"||0|0",LKY:"||0|0",TLT:"||0|0",MKQ:"||0|0",RBH:"||0|0",TUI:"Turaif||31.70|38.63|0|0",KND:"||0|0",APF:"Naples||26.15|-81.78|0|0",CHG:"||0|0",GGT:"George Town||23.47|-75.78|0|0",MQM:"Mardin||40.62|37.22|0|0",FBM:"Luano||-11.59|27.53|0|0",EAM:"Nejran||17.61|44.43|0|0",EAU:"Claire Airport||44.86|-91.49|0|0",KKB:"||0|0",SVU:"Savusavu||-16.80|179.34|0|0",TIF:"Taif||21.49|40.54|0|0",AKY:"||0|0",KGT:"||0|0",XBE:"||0|0",DPO:"Devonport||-41.17|146.43|0|0",ANR:"Brussels North||51.19|4.46|0|0",KGI:"Kalgoorlie||-30.77|121.47|0|0",UAP:"||0|0",BID:"Block Island||41.17|-71.58|0|0",LAU:"Lamu||-2.25|40.91|0|0",KEP:"||0|0",YER:"Fort Severn Arpt||0|0",UME:"Umea||63.79|20.28|0|0",CUU:"Chihuahua||28.65|-106.09|0|0",JIB:"Ambouli||11.55|43.16|0|0",UYL:"||0|0",TER:"Lajes||38.76|-27.09|0|0",YBK:"Baker Lake||64.30|-96.08|0|0",ALW:"Walla Walla City County||46.09|-118.29|0|0",JUL:"Juliaca||-15.46|-70.15|0|0",BDQ:"Vadodara||22.33|73.22|0|0",JKG:"Axamo||57.76|14.07|0|0",VTE:"Wattay||17.98|102.57|0|2",ANI:"Aniak||61.57|-159.53|0|0",FJR:"Fujairah Intl Arpt||0|0",VAI:"Vanimo||-2.69|141.30|0|0",DZA:"Dzaoudzi||-12.78|45.28|0|0",APN:"Phelps Collins||45.08|-83.56|0|0",MTJ:"Montrose County||38.50|-107.89|0|0",PUM:"||0|0",YWH:"Inner Harbor Sea Plane|YYJ|48.42|-123.37|0|0",TKP:"||0|0",YQZ:"Quesnel||53.03|-122.51|0|0",YKM:"Yakima Terminal||46.57|-120.54|0|0",KAZ:"||0|0",NTQ:"||0|0",BYO:"||0|0",SMX:"Santa Maria Public||34.91|-120.46|0|0",BNS:"||0|0",LVI:"Livingstone||-17.82|25.82|0|0",AEX:"Alexandria||31.33|-92.55|0|0",BYC:"||0|0",NIU:"||0|0",RLG:"Laage||53.92|12.27|0|0",AOO:"Blair Cty||40.30|-78.32|0|0",BFI:"Seattle Boeing Field|SEA|47.53|-122.30|0|0",FBD:"Faizabad Arpt||0|0",LQM:"Puerto Leguizamo Arpt||0|0",AUQ:"Atuona||-9.77|-139.02|0|0",REA:"||0|0",GOQ:"||0|0",ENE:"||0|0",PBO:"Paraburdoo||-23.17|117.75|0|0",BJM:"Bujumbura||-3.38|29.37|0|0",BIQ:"Bayonne Anglet||43.47|-1.52|0|0",NUL:"Nulato||64.73|-158.08|0|0",ADQ:"Kodiak||57.75|-152.48|0|0",SHM:"||0|0",KPR:"||0|0",MXV:"||0|0",YZP:"Federal||53.25|-131.81|0|0",KUT:"||0|0",LPQ:"Louangphrabang||19.90|102.16|0|0",WRL:"Worland||43.97|-107.95|0|0",YIN:"Yining Arpt||0|0",PCL:"Capitan Rolden||-8.33|-74.63|0|0",SFA:"El Maou||34.72|10.68|0|0",YHA:"Port Hope Simpson||52.53|-56.30|0|0",YDQ:"Dawson Creek||55.73|-120.18|0|0",KKU:"||0|0",CYI:"Chia Yi Airport||0|0",SDN:"Anda||61.77|6.22|0|0",JDO:"Regional Do Cariri||-7.20|-39.32|0|0",XMH:"||0|0",KWA:"Kwajalein||8.72|167.73|0|0",GAE:"||0|0",PQS:"||0|0",HGN:"Mae Hong Son||19.30|97.98|0|0",MGF:"Regional De Maringa||-23.38|-51.93|0|0",CJL:"||0|0",BSK:"Biskra||34.79|5.74|0|0",JSU:"Maniitsoq Heleport||65.42|-52.90|0|0",DOL:"Saint Gatien Arpt||0|0",EGN:"||0|0",EXT:"Exeter||50.73|-3.42|0|0",IJK:"Izhevsk||56.49|53.27|0|1",KWM:"||0|0",CCP:"Carriel Sur||-36.77|-73.06|0|0",HIA:"||0|0",NCY:"Annecy Meythet||45.93|6.10|0|0",NBE:"Zine El Abidine Ben Ali||0.00|0.00|0|2",SNW:"||0|0",TRC:"Francisco Sarabia||25.57|-103.41|0|0",SHB:"Nakashibetsu||43.57|144.97|0|0",HUQ:"||0|0",UKB:"Kobe|OSA|34.75|135.17|0|0",LIW:"||0|0",FRW:"Francistown||-21.16|27.48|0|0",VPE:"||0|0",SLN:"Salina||38.79|-97.65|0|0",TRU:"Trujillo||-8.09|-79.11|0|0",SAF:"Santa Fe Municipal||0|0",MNS:"||0|0",KEK:"||0|0",UDI:"Eduardo Gomes Airprt||-18.90|-48.23|0|0",LPM:"||0|0",VEE:"||0|0",URT:"Surat Thani||9.13|99.32|0|0",ABI:"Abilene||32.41|-99.68|0|0",HGR:"Washington Cty Regional||0|0",IGT:"Magas||43.32|45.01||1",KMI:"Miyazaki||31.87|131.44|0|0",BBK:"Kasane||-17.82|25.15|0|0",LSE:"La Crosse||43.88|-91.26|0|0",WSN:"||0|0",YQY:"Sydney||46.17|-60.05|0|0",HUX:"Bahia De Huatulco||15.77|-96.24|0|0",RUN:"Gillot||-20.88|55.52|0|0",KPN:"||0|0",YQR:"Regina||50.43|-104.65|0|0",HTI:"Hamilton Island||-20.35|148.97|0|0",WJR:"||0|0",BRR:"North Bay||57.02|-7.44|0|0",HPH:"Cat Bi||20.82|106.57|0|2",UTH:"Udon Thani||17.39|102.79|0|0",TVS:"||0|0",MOU:"Mountain Village||62.09|-163.72|0|0",STS:"Sonoma Cty||38.51|-122.81|0|0",ERL:"||0|0",ZQW:"Zweibruecken|SCN|0|0",GSP:"Greenville Spartanburg||34.91|-82.21|0|0",AWZ:"||0|0",LBR:"||0|0",KIT:"Kithira||36.29|23.02|0|0",HTY:"||0|0",REL:"Trelew||-43.23|-65.32|0|0",JMU:"||0|0",IIL:"||0|0",KIX:"Kansai|OSA|34.42|135.25|0|0",ULO:"||0|0",ADF:"||0|0",VGA:"||0|0",RSU:"Yeosu||34.74|127.73|0|0",GPI:"Guapi Arpt||0|0",CED:"Ceduna||-32.13|133.71|0|0",TBH:"||0|0",WMO:"||0|0",DCA:"Ronald Reagan National|WAS|38.85|-77.04|0|0",GNU:"||0|0",HAA:"||0|0",JSH:"Sitia Municipal Airport||0|0",XMB:"Marina Mall Dubai|DXB|1|0",WNN:"||0|0",HKB:"Healy Lake||63.87|-148.97|0|0",ANE:"Marce||47.47|-0.55|0|0",KWG:"Krivoy Rog||48.05|32.22|0|0",HOD:"Hodeidah||14.75|42.98|0|0",MFR:"Medford Jackson Cty||42.37|-122.87|0|0",KXA:"||0|0",BEJ:"||0|0",SVC:"Grant County||32.63|-108.15|0|0",OMH:"||0|0",EKS:"Shakhtyorsk||0.00|0.00|0|2",TBZ:"Tabriz International Arpt||0|0",EMD:"Emerald||-23.57|148.18|0|0",SLM:"Matacan||40.97|-5.65|0|0",AXK:"||0|0",LEX:"Blue Grass Field||38.04|-84.60|0|0",GYI:"Gisenyi||-1.68|29.25|0|0",PPV:"Port Protection Arpt||0|0",WUA:"||0|0",LYH:"Lynchburg||37.33|-79.20|0|0",DWD:"||0|0",TJN:"||0|0",EAE:"||0|0",KPW:"Keperveem||67.85|166.14||1",ASD:"Andros Town||24.70|-77.80|0|0",EZS:"Elazig||38.61|39.29|0|0",SRJ:"||0|0",YFO:"Flin Flon||54.68|-101.68|0|0",MDT:"Harrisburg|HAR|40.19|-76.76|0|0",YUS:"||0|0",ICN:"Incheon|SEL|37.42|126.38|0|0",GMR:"Gambier Island Arpt||0|0",MAO:"Intl Eduardo Gomes||-3.03|-60.05|0|0",ISG:"Ishigaki||24.34|124.17|0|0",YMO:"Moosonee||51.29|-80.60|0|0",CMU:"||0|0",YQT:"Thunder Bay||48.38|-89.25|0|0",EFL:"Argostoli||38.12|20.51|0|0",YHR:"Chevery||50.50|-59.50|0|0",CAB:"||0|0",YIO:"Pond Inlet Arpt||0|0",EEK:"Eek Arpt||0|0",TGO:"Tongliao Arpt||0|0",YHY:"Hay River||60.85|-115.78|0|0",TMS:"São Tomé International Airport||0.00|0.00|0|2",BNC:"||0|0",AUX:"Araguaina Arpt||0|0",YKU:"Chisasibi||53.83|-79.00|0|0",RUR:"||0|0",YQC:"Quaqtaq||61.33|-69.63|0|0",IXJ:"Satwari||32.69|74.84|0|0",SJT:"Mathis Field||31.36|-100.49|0|0",THL:"||0|0",BIK:"Mokmer||-1.19|136.09|0|0",CHO:"Charlottesville Albemarle||38.14|-78.45|0|0",YMM:"Ft McMurray||56.68|-111.27|0|0",KNX:"Kununurra||-15.79|128.71|0|0",WEH:"Weihai Arpu||37.50|122.08|0|0",ZLO:"Manzanillo||19.11|-104.35|0|0",TUW:"||0|0",KUO:"Kuopio||63.01|27.80|0|0",CIT:"Shimkent||42.30|69.60|0|0",IRM:"Igrim||0.00|0.00|0|2",YDF:"Deer Lake||49.22|-57.40|0|0",EYP:"El Yopal Arpt||0|0",PKN:"||0|0",CPC:"Chapelco||-40.07|-71.13|0|0",OGN:"Yonaguni Jima Airport||0|0",MMB:"Memanbetsu||43.90|144.17|0|0",TRK:"Tarakan||3.33|117.56|0|0",DRT:"International Del Rio||29.33|-100.98|0|0",KSH:"Kermanshah||34.35|47.15|0|0",HHN:"Hahn|FRA|49.95|7.27|0|0",HLZ:"Hamilton||-37.86|175.33|0|0",KIS:"Kisumu||-0.09|34.73|0|0",BUZ:"Bushehr||28.95|50.83|0|0",UKA:"||0|0",TBW:"Donskoye||0.00|0.00|0|2",ZLT:"La Tabatiere||51.00|-59.00|0|0",MUB:"Maun||-19.97|23.43|0|0",YVM:"Qikiqtarjuaq Arpt||0|0",EPR:"Esperance||-33.69|121.82|0|0",KCA:"||0|0",XIY:"Xianyang|SIA|34.43|108.75|0|0",MMX:"Sturup|MMA|55.53|13.37|0|0",KAD:"||0|0",KGL:"Kayibanda||-1.97|30.14|0|0",AHE:"||0|0",BNY:"||0|0",VLD:"Valdosta Regional||30.78|-83.28|0|0",ELQ:"Gassim||26.30|43.77|0|0",HID:"Horn Island||-10.58|142.28|0|0",JMO:"||0|0",ARI:"Chacalluta||-18.35|-70.35|0|0",KRP:"Karup||56.30|9.12|0|0",YHK:"Gjoa Haven||68.63|-95.95|0|0",YIK:"Ivujivik||62.42|-76.08|0|0",MQN:"Rossvoll||66.37|14.30|0|0",SRQ:"Sarasota Bradenton||27.39|-82.55|0|0",AYQ:"Connellan||-25.33|131.05|0|0",PKU:"Simpang Tiga||0.47|101.45|0|0",GMB:"Gambela Airport||0|0",PQI:"Northern Maine Regional||46.69|-68.05|0|0",HYG:"||0|0",ESR:"El Salvador||-26.32|-69.77|0|0",IGR:"Iguazu||-25.74|-54.47|0|0",ZFM:"||0|0",HGA:"Hargeisa Arpt||0|0",DAV:"Enrique Malek Arpt||0|0",GGM:"||0|0",THN:"Trollhattan||58.27|12.30|0|0",CMA:"Cunnamulla||-28.03|145.62|0|0",MHK:"Manhattan||39.14|-96.67|0|0",PNR:"Pointe Noire||-4.81|11.89|0|0",SKD:"Samarkand||39.70|67.00|0|0",RNB:"Kallinge||56.26|15.26|0|0",SOB:"Hévíz–Balaton||0.00|0.00|0|2",DAY:"Dayton International||39.90|-84.22|0|0",HDG:"||0|0",SLW:"Saltillo||25.55|-100.92|0|0",TIU:"Timaru||-44.30|171.22|0|0",WBB:"||0|0",YWJ:"||0|0",LPD:"La Pedrera Arpt||0|0",SPC:"La Palma||28.62|-17.75|0|0",CXB:"||0|0",MNT:"||0|0",IAN:"||0|0",YAC:"||0|0",CQD:"Shahre Kord||32.30|50.84|0|0",IPN:"Usiminas Arpt||0|0",PKZ:"Pakse Arpt||0|0",LMP:"Lampedusa||35.50|12.62|0|0",DIL:"Comoro||-8.53|125.58|0|0",VBV:"||0|0",MBL:"Manistee||44.27|-86.25|0|0",LWE:"||0|0",BMV:"Phung Duc||12.67|108.05|0|0",PKK:"||0|0",DSM:"Des Moines Airport||41.53|-93.66|0|0",PPT:"Intl Tahiti Faaa||-17.55|-149.61|0|0",CQM:"Ciudad Real Central Arpt||0|0",YGZ:"||0|0",DGT:"Dumaguete Arpt||0|0",WTK:"||0|0",YRG:"Rigolet Arpt||0|0",SEU:"||0|0",NTL:"Williamtown||-32.80|151.83|0|0",DDG:"Dandong||40.00|125.00|0|0",KRC:"||0|0",COO:"Cotonou||6.35|2.39|0|0",KVG:"Kavieng||-2.58|150.82|0|0",MIM:"Merimbula||-36.91|149.92|0|0",ALP:"Nejrab||36.18|37.23|0|0",GLV:"||0|0",GLK:"||0|0",TLA:"||0|0",LTO:"Loreto||25.98|-111.35|0|0",AGP:"Malaga||36.67|-4.50|0|0",AYP:"Yanamilla Arpt||0|0",LZN:"||0|0",CEI:"Chaing Rai||19.89|99.83|0|0",GTF:"Great Falls||47.49|-111.37|0|0",DLG:"Dillingham||59.05|-158.50|0|0",MRX:"||0|0",KWK:"||0|0",OTZ:"Ralph Wien Memorial||66.89|-162.61|0|0",CRW:"Yeager||38.37|-81.59|0|0",SPI:"Capital||39.84|-89.68|0|0",SLK:"Adirondack||44.38|-74.21|0|0",IFN:"Isfahan||32.75|51.85|0|0",CFB:"Cabo Frio||-22.93|-42.08|0|0",INV:"Inverness||57.54|-4.05|0|0",TOG:"Togiak Village||59.06|-160.38|0|0",TPS:"Birgi||37.91|12.49|0|0",ATA:"||0|0",FKQ:"||0|0",AGA:"Agadir Almassira||30.38|-9.55|0|0",JKR:"||0|0",YGG:"||0|0",RRS:"Roros||62.58|11.35|0|0",SAH:"Sanaa Intl||15.48|44.22|0|0",LMA:"||0|0",GMP:"Gimpo|SEL|37.55|126.78|0|0",BGA:"Palo Negro||7.11|-73.13|0|0",SLC:"Salt Lake City||40.78|-111.97|0|0",NDG:"Qiqihar||47.32|123.92|0|0",EOI:"Eday||59.18|-2.78|0|0",ABK:"||0|0",NRA:"Narrandera||-34.70|146.53|0|0",KOE:"||0|0",KDU:"Skardu Airport||0|0",HAC:"Hachijo Jima||33.11|139.79|0|0",BMI:"Normal||40.48|-88.93|0|0",BVA:"Beauvais Tille|PAR|49.46|2.11|0|2",SCQ:"Santiago||42.90|-8.42|0|0",YXT:"Terrace||54.47|-128.57|0|0",MKL:"McKellar Fld||0|0",TUL:"Tulsa||36.20|-95.89|0|0",WIL:"Wilson|NBO|-1.32|36.82|0|0",DAU:"||0|0",IRG:"Lockhart River Arpt||0|0",ELI:"||0|0",SCN:"Ensheim||49.23|6.98|0|0",PPB:"A De Barros||-22.10|-51.45|0|0",BAS:"Balalae||-6.98|155.88|0|0",HBE:"Borg El Arab|ALY|30.90|29.68|0|0",CGY:"Lumbia||8.42|124.61|0|0",HMI:"Hami Airport||0|0",GBE:"Gaborone||-24.55|25.92|0|0",ADD:"Bole||8.98|38.80|0|0",GZT:"Gaziantep||37.07|37.33|0|0",BHK:"Bukhara||39.77|64.48|0|0",GND:"Port Saline||12.15|-61.62|0|0",JTR:"Santorin||36.40|25.48|0|2",EIN:"Welschap||51.45|5.39|0|0",HLH:"||0|0",SBW:"Sibu||2.34|111.84|0|0",YBX:"Blanc Sablon||51.43|-57.22|0|0",GRZ:"Thalerhof||46.99|15.44|0|0",BHR:"||0|0",SFQ:"SANLIURFA|GNY||1",SVI:"San Vincente Del Caguan||0|0",BLD:"|LAS|0|0",KPY:"||0|0",PYY:"Pai Arpt||0|0",XNB:"Chelsea Tower Dubai|DXB|1|0",OBU:"||0|0",USK:"Usinsk||65.95|57.40|0|0",MTV:"||0|0",PLU:"Pampulha Arpt|BHZ|0|0",TNR:"Ivato||-18.80|47.48|0|0",TSF:"Treviso|VCE|45.67|12.25|0|0",BHM:"Birmingham||33.56|-86.76|0|0",PET:"Pelotas Federal Arpt||0|0",FDE:"Bringeland||61.46|5.85|0|0",JSR:"||0|0",BHV:"||0|0",MCN:"Lewis B Wilson||32.70|-83.65|0|0",GGW:"International Glasgow||48.21|-106.62|0|0",MJD:"Mohenjodaro||27.34|68.14|0|0",AGN:"Angoon||57.50|-134.58|0|0",HGL:"Helgoland Arpt||0|0",HMA:"Khanty Mansiysk||61.02|69.08|0|0",KNO:"Kualanamu International Airport|||1",DKR:"Leopold Sedar Senghor||14.74|-17.49|0|2",MOT:"Minot||48.26|-101.28|0|0",KUH:"Kushiro||43.04|144.20|0|0",ZAM:"||0|0",PUU:"Puerto Asis Arpt||0|0",VHC:"||0|0",YKL:"Schefferville||54.78|-64.82|0|0",MYA:"Moruya||-35.90|150.15|0|0",YZT:"Port Hardy||50.68|-127.36|0|0",KYK:"||0|0",SCM:"||0|0",CND:"Kogalniceanu||44.35|28.48|0|0",LTK:"Hmelmin||35.52|35.78|0|0",MOL:"Aro||62.75|7.27|0|0",BVH:"Vilhena Arpt||0|0",MGQ:"||0|0",YYY:"Mont Joli||48.60|-68.20|0|0",FUT:"||0|0",KYS:"||0|0",YQM:"Moncton||46.12|-64.68|0|0",CEE:"Cherepovets||59.27|38.02|0|0",TRD:"Trondheim Vaernes||63.45|10.93|0|0",SLU:"Vigie Field||14.02|-60.99|0|0",CHU:"Chuathbaluk Arpt||0|0",HIN:"Sacheon||35.09|128.08|0|0",YPM:"Pikangikum||51.82|-94.00|0|0",BYN:"||0|0",SOU:"Southampton||50.95|-1.35|0|0",PTH:"||0|0",JHM:"Kapalua||20.96|-156.68|0|0",LKA:"||0|0",PIU:"Piura||-5.20|-80.61|0|0",MMO:"Vila Do Maio||15.25|-23.17|0|0",OPU:"||0|0",ONT:"Ontario||34.06|-117.61|0|0",COR:"Pajas Blanco||-31.31|-64.20|0|0",WGA:"Forrest Hill||-35.17|147.46|0|0",FBS:"||0|0",ITM:"Itami|OSA|34.78|135.44|0|0",STV:"Surat Airport||0|0",VNS:"Babatpur||25.45|82.86|0|0",LFT:"Lafayette||30.20|-91.99|0|0",BPS:"Porto Seguro||-16.53|-39.08|0|0",HAD:"Halmstad||56.68|12.82|0|0",QOW:"||0|0",XSC:"South Caicos Intl Arpt||0|0",SUN:"Friedman Memorial||43.50|-114.31|0|0",MCE:"Merced||37.28|-120.51|0|0",IMK:"||0|0",CJU:"Jeju||33.51|126.50|0|0",MDQ:"Mar Del Plata||-37.93|-57.57|0|0",LNJ:"||0|0",KQT:"Qurghonteppa||37.87|68.86|0|2",YYR:"Municipal Goose Bay||53.32|-60.40|0|0",GTE:"Alyangula Arpt||0|0",NAT:"Augusto Severo||-5.91|-35.24|0|0",PNI:"Pohnpei||7.02|158.24|0|0",YNJ:"Yanji||42.65|129.50|0|0",BHS:"Raglan||-33.41|149.65|0|0",BOH:"Bournemouth||50.78|-1.84|0|0",HUI:"Phu Bai||16.40|107.70|0|0",CNJ:"Cloncurry||-20.67|140.50|0|0",KKA:"||0|0",YHD:"Dryden||49.78|-92.83|0|0",TJU:"||0|0",PLM:"Mahmud Badaruddin Li||-2.90|104.70|0|0",IPL:"Imperial County||32.84|-115.58|0|0",HVB:"Hervey Bay||-25.00|153.00|0|0",YFJ:"||0|0",MSA:"||0|0",HOF:"Alahsa||25.50|49.83|0|0",GSE:"Saeve|GOT|57.77|11.87|0|0",HUU:"Huanuco Arpt||0|0",RFP:"Raiatea||-16.72|-151.47|0|0",CJS:"Intl Abraham Gonzalez||31.64|-106.43|0|0",TUS:"Tucson||32.13|-110.95|0|0",RDD:"Redding||40.51|-122.29|0|0",SCX:"Salina Cruz||16.17|-95.20|0|0",NUI:"||0|0",KKE:"Kerikeri||-35.22|173.95|0|0",WBM:"||0|0",DAX:"||0|0",BTU:"Bintulu||3.17|113.04|0|0",PSR:"Liberi||42.43|14.18|0|0",FAY:"Fayetteville||34.99|-78.88|0|0",YNP:"Natuashish||55.91|-61.18|0|0",YVO:"Val d Or||48.05|-77.78|0|0",ARC:"Arctic Village Arpt||0|0",OLH:"||0|0",VBY:"Visby||57.66|18.35|0|0",AFT:"||0|0",PQC:"Duong Dang||10.23|103.97|0|0",NLK:"Norfolk Island||-29.04|167.94|0|0",GUC:"Gunnison Cty||38.53|-106.94|0|0",ACX:"Xingyi||25.09|104.96|0|0",DLU:"Dali||25.67|100.32|0|0",ATQ:"Raja Sansi||31.71|74.80|0|0",DAT:"Datong||30.80|117.73|0|0",GSM:"||0|0",UTM:"Tunica Municipal Arpt||0|0",CKB:"Clarksburg Benedum||39.30|-80.23|0|0",KAW:"||0|0",URE:"Kuressaare||58.22|22.50|0|0",MYT:"||0|0",XQP:"Quepos||9.45|-84.15|0|0",ZUM:"Churchhill Falls||53.56|-64.11|0|0",AKN:"King Salmon||58.67|-156.64|0|0",PGX:"Perigueux||45.18|0.72|0|0",BTI:"||0|0",KDI:"||0|0",ETR:"||0|0",YTZ:"Toronto City Centre|YTO|43.65|-79.38|0|0",YCF:"||0|0",HKD:"Hakodate||41.77|140.82|0|0",SMF:"Sacramento|SAC|38.70|-121.60|0|0",RTB:"Roatan||16.32|-86.52|0|0",TDD:"Trinidad||-14.68|-64.83|0|0",MJU:"||0|0",UGC:"Urgench||41.65|60.53|0|0",OKI:"||0|0",BLL:"Billund||55.74|9.15|0|0",TNG:"Boukhalef||35.72|-5.92|0|0",PZH:"||0|0",PMO:"Punta Raisi||38.17|13.10|0|0",LUM:"||0|0",OSI:"Osijek Arpt||0|0",LET:"General A V Cobo||-4.20|-69.94|0|0",TUN:"Carthage||36.85|10.23|0|0",PIS:"Biard||46.59|0.31|0|0",KBC:"||0|0",KRS:"Kjevik||58.20|8.08|0|0",CVM:"Ciudad Victoria||23.71|-98.97|0|0",KCH:"Kuching||1.48|110.34|0|0",UDR:"Dabok||24.61|73.90|0|0",ALY:"El Nouzha||31.20|29.90|0|0",MCZ:"Palmeres||-9.52|-35.80|0|0",NOC:"Knock||53.92|-8.82|0|0",ELY:"Yelland Field||39.30|-114.84|0|0",IXE:"Bajpe||12.96|74.89|0|2",RSH:"Russian Seaplane Base||61.78|-161.32|0|0",BEL:"Val De Cans||-1.45|-48.48|0|0",RIA:"Base Aerea Arpt||0|0",NVA:"Aeropuerto Benito Sales||0|0",ACK:"Nantucket Memorial||41.26|-70.06|0|0",CTM:"Chetumal||18.48|-88.33|0|0",FGU:"||0|0",KBU:"||0|0",MAH:"Aerop De Menorca||39.86|4.22|0|0",KEH:"Kenmore Air Harbor||0|0",CAC:"Cascavel Arpt||0|0",NLV:"Nikolaev||47.05|31.92|0|0",TLJ:"||0|0",FLG:"Flagstaff|GCN|35.14|-111.67|0|0",PEM:"Puerto Maldonado||-12.58|-69.23|0|0",IQM:"||0|0",HYN:"Huangyan||28.42|122.37|0|0",RMA:"Roma||-26.55|148.77|0|0",LIR:"Liberia||10.59|-85.55|0|0",YCG:"Ralph West||49.30|-117.63|0|0",MHH:"Marsh Harbour||26.51|-77.08|0|0",PIR:"Pierre||44.38|-100.28|0|0",MZI:"Mopti||14.51|-4.08|0|0",RXS:"Roxas City||11.60|122.75|0|0",TAC:"D Z Romualdez||11.23|125.02|0|0",MXX:"Mora||61.00|14.55|0|0",ROO:"Rondonopolis Arpt||0|0",MLW:"Sprigg Payne Arpt||0|0",MUA:"Munda Arpt||0|0",CYP:"||0|0",SLY:"Salekhard||66.58|66.60|0|0",LWS:"Lewiston Nez Pierce||46.37|-117.01|0|0",SAT:"San Antonio||29.54|-98.47|0|0",EQS:"Esquel||-42.91|-71.14|0|0",KSZ:"KOTLAS|||1",TRI:"Tri City Regional||36.55|-82.47|0|0",WIC:"Wick||58.46|-3.09|0|0",LNV:"Lihir Island||-3.07|152.62|0|0",YUM:"Yuma||32.65|-114.61|0|0",TIH:"Tikehau||-15.00|-147.75|0|0",MJZ:"||0|0",YMP:"||0|0",TRE:"Tiree||56.50|-6.87|0|0",BCI:"Barcaldine||-23.56|145.30|0|0",UEL:"Quelimane Arpt||0|0",MBS:"Saginaw||43.53|-84.08|0|0",BPE:"Qinhuangdao Beidaihe|||1",CLL:"Easterwood Field||30.59|-96.36|0|0",OIT:"Oita||33.48|131.73|0|0",YWP:"||0|0",RET:"||0|0",AGU:"Aguascalientes||21.70|-102.32|0|0",TTJ:"Tottori||35.53|134.17|0|0",FIH:"Kinshasa||-4.38|15.43|0|0",TWU:"Tawau||4.26|117.89|0|0",VRC:"||0|0",SNP:"||0|0",RHI:"Oneida County||45.63|-89.46|0|0",PFQ:"||0|0",NRL:"North Ronaldsay||59.37|-2.43|0|0",CTD:"Chitre Airfield||0|0",CAY:"Rochambeau||4.82|-52.37|0|0",CKY:"Conakry||9.58|-13.61|0|0",LDE:"Tarbes||43.18|-0.00|0|0",KUS:"Kulusuk||65.57|-37.12|0|0",AHU:"Charif Al Idrissi Arpt||0|0",GYE:"Simon Bolivar||-2.15|-79.88|0|0",ENI:"||0|0",MKM:"Mukah Arpt||0|0",CSG:"Columbus Metro Ft Benning||32.51|-84.94|0|0",MIG:"Mian Yang||31.43|104.74|0|0",TWB:"Toowoomba Arpt||0|0",AKF:"||0|0",MGS:"||0|0",ONG:"Mornington||-16.58|139.30|0|0",LDG:"||0|0",IMF:"Tulihal Arpt||0|0",AAA:"Anaa Arpt||0|0",AQI:"Qaisumah||28.33|46.13|0|0",PZO:"Puerto Ordaz||8.30|-62.73|0|0",KMA:"||0|0",MNU:"||0|0",MEH:"Mehamn||71.03|27.83|0|0",HNS:"Haines||59.25|-135.52|0|0",KSJ:"||0|0",ZRJ:"||0|0",IAA:"Igarka||0.00|0.00|0|2",CAL:"Machrihanish||55.44|-5.69|0|0",PBP:"||0|0",ENA:"Kenai||60.57|-151.25|0|0",SHR:"Sheridan Cty||44.77|-106.98|0|0",ONJ:"Odate Noshiro||40.19|140.38|0|0",BNN:"Bronnoy||65.46|12.21|0|0",POM:"Jackson Field||-9.45|147.21|0|0",AKB:"Atka Arpt||0|0",GRR:"Kent County||42.88|-85.52|0|0",NNY:"||0|0",YRB:"Resolute Arpt||0|0",NUP:"||0|0",KNW:"||0|0",TNC:"||0|0",AEG:"||0|0",SUJ:"Satu Mare Arpt||0|0",TCB:"Treasure Cay||26.73|-77.37|0|0",BWA:"||0|0",VEL:"Vernal||40.44|-109.51|0|0",XMN:"Xiamen Intl||24.47|118.12|0|0",OAX:"Xoxocotlan||17.00|-96.73|0|0",DSA:"Finningley||53.48|-1.00|0|0",VKT:"Vorkuta|||1",LEB:"Lebanon Regional||43.63|-72.31|0|0",BRL:"Burlington||40.79|-91.12|0|0",BSC:"Aeropuerto Jose Celestino Mutis||0|0",UTT:"K D Matanzima||-31.58|28.78|0|0",PVH:"Belmonte||-8.73|-63.90|0|0",KHD:"Khorramabad Arpt||0|0",LSC:"La Florida||-29.91|-71.20|0|0",SBZ:"Sibiu||45.78|24.08|0|0",LAR:"General Brees Fld||41.31|-105.67|0|0",KCF:"||0|0",CAZ:"Cobar Arpt||0|0",USQ:"||0|0",RDN:"Lts Pulau Redang||5.77|103.01|0|0",AFA:"San Rafael||-34.59|-68.40|0|0",YGP:"Gaspe||48.77|-64.48|0|0",HON:"Huron||44.38|-98.23|0|0",THR:"Mehrabad||35.69|51.32|0|0",LOP:"Lombok International Airport|||1",TKG:"Bandar Lampung||-5.53|105.12|0|0",GJA:"||0|0",HDS:"Hoedspruit Arpt||0|0",PUS:"Kimhae||35.17|129.13|0|2",BRT:"Bathurst Island Arpt||0|0",TNJ:"||0|0",ZGS:"Gethsemanie||50.33|-60.67|0|0",RAR:"Rarotonga||-21.20|-159.80|0|0",OBX:"||0|0",SFL:"Sao Filipe||14.90|-24.52|0|0",TJA:"Tarija||-21.55|-64.75|0|0",XFN:"Xiangfan||32.05|112.00|0|0",AKV:"Akulivik||60.73|-78.58|0|0",YQU:"Grande Prairie||55.18|-118.89|0|0",GJT:"Walker Field||39.12|-108.53|0|0",FIE:"Fair Isle Arpt||0|0",VDC:"Vitoria Da Conquista Arpt||0|0",MSZ:"||0|0",ASW:"Daraw||23.96|32.82|0|0",YZG:"Salluit||62.20|-75.63|0|0",URA:"Uralsk||51.15|51.55|0|0",VAN:"Van||38.46|43.33|0|0",GRX:"Granada||37.19|-3.78|0|0",TXK:"Texarkana||33.46|-93.99|0|0",NAO:"||0|0",GTO:"||0|0",RIC:"Richmond||37.51|-77.32|0|0",BRS:"Bristol||51.38|-2.71|0|0",AOJ:"Aomori||40.73|140.70|0|0",POG:"Port Gentil||-0.71|8.76|0|0",RHP:"||0|0",ERN:"||0|0",DHM:"Kangra Airport, Gaggal||32.30|76.27|0|2",FMM:"Memmingen|MUC|0.00|0.00|0|2",XKS:"||0|0",IDR:"Indore||22.72|75.81|0|0",GTR:"Golden|UBS|33.45|-88.60|0|0",CNY:"Moab||38.76|-109.75|0|0",LTI:"||0|0",NKM:"Nagoya Komaki|NGO|35.26|136.92|0|0",ROK:"Rockhampton||-23.38|150.47|0|0",GLF:"||0|0",SJD:"Los Cabos||23.17|-109.70|0|0",PEC:"||0|0",KAA:"||0|0",DRS:"Dresden||51.13|13.77|0|0",YGW:"Kuujjuaraapik||55.28|-77.77|0|0",HEH:"Heho||20.74|96.79|0|0",RCB:"Richards Bay Arpt||0|0",EBD:"||0|0",LBV:"Libreville||0.46|9.42|0|0",XNN:"Xining||36.55|101.75|0|0",DBA:"||0|0",JEG:"Aasiaat||68.70|-52.75|0|0",BTT:"||0|0",SJC:"San Jose||37.36|-121.93|0|0",VUP:"Valledupar Arpt||0|0",MXM:"||0|0",TAO:"Liuting||36.10|120.32|0|0",YGK:"Norman Rodgers||44.22|-76.61|0|0",YGH:"||0|0",ANM:"||0|0",SKN:"Skagen||68.58|15.03|0|0",SKE:"Skien||59.18|9.56|0|0",LGL:"Long Lellang Arpt||0|0",LBJ:"||0|0",RZE:"Jasionka||50.12|22.02|0|0",YGJ:"Miho||35.49|133.24|0|0",RGK:"Gorno-Altaisk||51.95|85.95|0|0",YBP:"Yibin||28.82|104.53|0|0",TCX:"||0|0",KLN:"||0|0",MED:"Prince Mohammad Bin Abdulaziz||24.55|39.72|0|0",KOI:"Kirkwall||58.96|-2.97|0|0",KOC:"Koumac||-20.50|164.42|0|0",PSC:"Tri Cities||46.26|-119.11|0|0",BIR:"||0|0",MUN:"Quiriquire||9.75|-63.15|0|0",PPW:"Papa Westray||59.42|-2.90|0|0",BTJ:"Blang Bintang||5.52|95.42|0|0",KGK:"||0|0",NRK:"Kungsangen||58.58|16.25|0|0",RUM:"||0|0",LUP:"Kalaupapa||21.21|-156.97|0|0",TMU:"Tambor||9.73|-85.02|0|0",CAH:"||0|0",SZZ:"Goleniow||53.58|14.90|0|0",RUE:"||0|0",PMY:"El Tehuelche||-42.73|-65.07|0|0",NAY:"Nanyuan|BJS|40.07|116.61|0|0",SHY:"Shinyanga Arpt||0|0",SDG:"||0|0",LAK:"||0|0",SLX:"||0|0",FSC:"Sud Corse||41.50|9.10|0|0",YLW:"Ellison Field||49.88|-119.48|0|0",ODN:"Long Seridan Arpt||0|0",YRT:"Rankin Inlet||62.81|-92.12|0|0",PLX:"||0|0",SDR:"Santander||43.43|-3.83|0|0",EYK:"Beloyarsky||63.68|66.68|0|0",ISN:"Sloulin Field||48.18|-103.64|0|0",HAQ:"||0|0",EBL:"Erbil||36.24|43.96|0|0",SOJ:"||0|0",TKQ:"Kigoma Arpt||0|0",SDK:"Sandakan||5.90|118.06|0|0",KCQ:"Chignik Airport|KCL|0|0",INL:"Intl Falls||48.56|-93.40|0|0",AGS:"Bush Field||33.37|-81.97|0|0",OUD:"Les Angades||34.78|-1.93|0|0",MPL:"Frejorgues||43.58|3.97|0|0",GDX:"Magadan||59.92|150.72|0|0",ORF:"Norfolk||36.90|-76.20|0|0",BRD:"Crowwing Cty||46.40|-94.14|0|0",CXJ:"Campo Dos Bugres||-29.17|-51.18|0|0",IXR:"Ranchi||23.31|85.32|0|0",TQR:"San Domino Island||42.12|15.48|0|0",DGA:"||0|0",PKY:"||0|0",CHA:"Chattanooga Lovell Fld||35.04|-85.20|0|0",MPM:"Maputo||-25.92|32.57|0|0",ARU:"Aracatuba||-21.14|-50.43|0|0",LBF:"Lee Bird Field||41.13|-100.70|0|0",IOS:"Eduardo Gomes||-14.81|-39.03|0|0",GPA:"Araxos Arpt||0|0",TIM:"Timika||-4.53|136.92|0|0",YPR:"Digby Island||54.29|-130.44|0|0",CHS:"Charleston||32.90|-80.04|0|0",AOK:"Karpathos||34.42|27.15|0|0",MLH:"Mulhouse EuroAirport French|EAP|47.65|7.64|0|2",RNO:"Reno Tahoe||39.50|-119.77|0|0",DCM:"Mazamet||43.56|2.28|0|0",VTZ:"Vishakhapatnam||17.72|83.22|0|0",PMZ:"||0|0",EAA:"Eagle||64.78|-141.15|0|0",LAO:"Laoag||18.18|120.53|0|0",PUF:"Uzein||43.38|-0.42|0|0",CJC:"El Loa||-22.49|-68.92|0|0",ABA:"Abakan||53.72|91.50|0|0",OAG:"Springhill||-33.38|149.12|0|0",GFF:"Griffith||-34.25|146.07|0|0",HDN:"Hayden||40.48|-107.22|0|0",WLH:"||0|0",OKJ:"Okayama||34.59|133.94|0|0",GWT:"Westerland||54.92|8.34|0|0",KMC:"King Khalid Military||27.90|45.52|0|0",DSK:"||0|0",PNK:"Supadio Arpt||0|0",KRN:"Kiruna||67.82|20.35|0|0",NGK:"||0.00|0.00|0|2",NKC:"Nouakchott||18.09|-15.95|0|0",BVV:"||0|0",YFS:"||0|0",BDB:"Bundaberg||-24.91|152.32|0|0",ATY:"Watertown||44.91|-97.15|0|0",JNN:"Nanortalik||60.13|-45.23|0|0",PAZ:"Tajin||20.52|-97.47|0|0",ELU:"||0|0",ULY:"Vostochny||54.40|48.80|0|0",MDG:"Mudanjiang||44.58|129.60|0|0",OBO:"Obihiro||42.89|143.16|0|0",HSN:"Zhoushan||28.08|122.37|0|0",KLG:"Kalskag||61.54|-160.32|0|0",YGN:"||0|0",LAW:"Lawton||34.57|-98.42|0|0",CZU:"Corozal Arpt||0|0",MLG:"||0|0",TCZ:"||0|0",KDH:"||0|0",MUE:"Waimea||20.01|-155.67|0|0",MXS:"Maota Arpt||0|0",YQJ:"||0|0",ABC:"Los Llanos||38.95|-1.86|0|0",MYW:"Mtwara||-10.34|40.19|0|0",NWI:"Norwich||52.68|1.28|0|0",CYZ:"||0|0",PHG:"Port Harcourt City||5.03|6.83|0|0",UKK:"Ust Kamenogorsk||50.03|82.50|0|0",SLP:"San Luis Potosi||22.18|-100.99|0|0",RRG:"Rodrigues Island||-19.75|63.35|0|0",RGN:"Yangon||16.91|96.14|0|2",SWF:"Stewart||41.51|-74.10|0|0",CRD:"Comodoro Rivadavia||-45.79|-67.46|0|0",ALB:"Albany Cty||42.75|-73.81|0|0",LGP:"Legaspi||13.16|123.73|0|0",LPB:"El Alto||-16.51|-68.20|0|0",SRX:"||0|0",AKR:"||0|0",TYR:"Pounds Field||32.35|-95.40|0|0",SMA:"Vilo Do Porto||36.97|-25.10|0|0",NSH:"||0|0",SGO:"St George||-28.05|148.59|0|0",AVN:"Avignon Caumont||43.90|4.90|0|0",TAY:"Tartu Arpt||0|0",YZS:"Coral Harbour||64.20|-83.37|0|0",PNZ:"Petrolina Internacional||-9.39|-40.49|0|0",DUR:"Durban||-29.97|30.96|0|0",YYJ:"Victoria||48.65|-123.42|0|0",DMK:"Don Muang|BKK|13.91|100.61|0|0",CSX:"Changsha||28.19|113.22|0|0",SGU:"Saint George||37.09|-113.59|0|0",WUS:"Wuyishan||27.72|117.97|0|0",PAT:"Patna||25.59|85.09|0|0",KVA:"Megas Alexandros||40.97|24.34|0|0",RVN:"Rovaniemi||66.56|25.83|0|0",JCB:"Joacaba Arpt||0|0",EGC:"Roumaniere||44.85|0.48|0|0",RCH:"||0|0",EXI:"Excursion Inlet||58.42|-135.45|0|0",RBA:"Sale||34.05|-6.76|0|0",CBO:"Awang||7.20|124.17|0|0",HVN:"Tweed New Haven||41.27|-72.89|0|0",PLZ:"Port Elizabeth||-33.99|25.61|0|0",LCX:"||0|0",CIK:"||0|0",LUR:"||0|0",PWE:"||0|0",ELF:"||0|0",PLO:"Port Lincoln||-34.61|135.88|0|0",EUX:"Roosevelt Field||17.49|-62.98|0|0",SKC:"||0|0",YTS:"Timmins||48.57|-81.37|0|0",JHB:"Sultan Ismail||1.64|103.67|0|0",ANU:"V C Bird||17.11|-61.76|0|0",VAO:"||0|0",VIL:"Dakhla||23.71|-15.94|0|0",FTA:"||0|0",YES:"||0|0",JNU:"Juneau||58.36|-134.57|0|0",PVE:"||0|0",OHH:"Okha||0.00|0.00|0|2",PXO:"Porto Santo||33.07|-16.35|0|0",PAG:"||0|0",BBN:"Bario Arpt||0|0",SCW:"Syktyvkar||61.67|50.77|0|0",SRV:"||0|0",TOL:"Toledo Express||41.59|-83.80|0|0",SUR:"||0|0",FOA:"||0|0",UNA:"Una Airport||0|0",GRU:"Guarulhos|SAO|-23.43|-46.48|0|2",TKV:"||0|0",ROR:"Airai||7.36|134.55|0|0",BOI:"Boise Gowen Field||43.57|-116.22|0|0",CMF:"Chambery Aix Les Bains||43.55|6.95|0|0",AXT:"Akita||39.62|140.32|0|0",STG:"St George Island Arpt||0.00|0.00|0|2",JDR:"||0|0",KVR:"||0|0",YYB:"North Bay||46.37|-79.42|0|0",VDA:"Ovda||29.93|34.95|0|0",KKQ:"||0|0",KDO:"||0|0",DLH:"Duluth||46.84|-92.19|0|0",EVE:"Evenes||68.50|16.68|0|0",SRA:"||0|0",PSO:"Cano||1.47|-77.25|0|0",ABQ:"Albuquerque||35.04|-106.61|0|0",APL:"Nampula||-15.10|39.29|0|0",UAH:"||0|0",MVP:"Mitu Arpt||0|0",TML:"Tamale Arpt||0|0",KBV:"Krabi||8.03|98.80|0|0",HVD:"||0|0",QRO:"Queretaro||20.60|-100.38|0|0",MGW:"Morgantown||39.64|-79.92|0|0",HNM:"Hana||20.80|-156.02|0|0",AUY:"||0|0",BDS:"Papola Casale||40.66|17.95|0|0",HFT:"Hammerfest||70.68|23.67|0|0",DSN:"||0|0",VIG:"El Vigia||8.63|-71.65|0|0",YLH:"||0|0",MEY:"||0|0",WUX:"Wuxi||31.58|120.32|0|0",BTV:"Burlington||44.47|-73.15|0|0",LOS:"Murtala Muhammed||6.59|3.33|0|0",BMO:"||0|0",KQA:"||0|0",KPB:"Point Baker Arpt||0|0",CZS:"Campo||-7.58|-72.78|0|0",WMN:"||0|0",PBH:"Paro||27.43|89.42|0|0",SYR:"Hancock||43.11|-76.10|0|0",CKZ:"Canakkale Arpt||0.00|0.00|0|2",PKE:"Parkes||-33.13|148.24|0|0",YSG:"||0|0",LGG:"Bierset||50.64|5.44|0|0",PLJ:"Placencia||16.53|-88.35|0|0",FAR:"Hector||46.92|-96.81|0|0",MZR:"Mazar I Sharif Arpt||0|0",YGT:"Igloolik||69.40|-81.82|0|0",FEG:"||0|0",PIB:"Hattiesburg Laurel Regional|LUL|31.47|-89.34|0|0",JOE:"Joensuu||62.66|29.61|0|0",TMT:"Trombetas Arpt||0|0",UYN:"Yulin Airport||0|0",NGS:"Nagasaki||32.91|129.92|0|0",LGB:"Long Beach||33.82|-118.15|0|0",UYU:"Joya Andina||-20.47|-66.83||1",KSA:"||0|0",DRO:"Durango La Plata Cty||37.15|-107.75|0|0",SDV:"Dov Hoz|TLV|32.11|34.78|0|2",OAI:"||0|0",LWT:"Lewistown||47.05|-109.47|0|0",KMQ:"Komatsu||36.39|136.42|0|0",CLM:"William Fairchild||48.12|-123.49|0|0",ROA:"Roanoke Regional||37.32|-79.98|0|0",ZUH:"Zhuhai||22.25|113.50|0|0",LFM:"||0|0",SHC:"||0|0",PBU:"||0|0",TVF:"Thief River Falls||48.07|-96.19|0|0",BRA:"Barreiras Arpt||0|0",XIC:"||0|0",BST:"||0|0",CTC:"Choya||-28.45|-65.78|0|0",KWL:"Guilin||25.13|110.32|0|0",EBJ:"Esbjerg||55.53|8.55|0|0",MYD:"Malindi||-3.23|40.10|0|0",ANX:"Andenes||69.29|16.14|0|0",HGD:"Hughenden||-20.82|144.22|0|0",MHG:"Mannheim Neuostheim||49.50|8.47|0|0",YNT:"Yantai Penglai||37.55|121.33|0|2",HME:"Oued Irara||31.67|6.14|0|0",EVV:"Evansville Regional||38.04|-87.53|0|0",NEV:"Nevis||17.20|-62.59|0|0",GAJ:"Yamagata||38.40|140.38|0|0",FRL:"Luigi Ridolfi||44.20|12.07|0|0",EGE:"Eagle County||39.65|-106.91|0|0",VDS:"Vadso||70.06|29.85|0|0",CZM:"Aeropuerto De Cozumel||20.52|-86.93|0|0",PJM:"||0|0",BGY:"Orio Al Serio|MIL|45.67|9.70|0|0",KHG:"Kashi Arpt||0|0",GDT:"Grand Turk Is||21.47|-71.13|0|0",TLC:"Toluca International Airport|MEX|19.28|-99.67|0|2",KOW:"Ganzhou||25.90|114.92|0|0",RGS:"Burgos Arpt||0|0",GRQ:"Eelde||53.12|6.58|0|0",DBO:"Dubbo||-32.22|148.58|0|0",LLK:"||0|0",ACZ:"||0|0",PES:"Petrozavodsk||0.00|0.00|0|2",TBU:"Tongatapu||-21.25|-175.15|0|0",HLP:"Halim Perdana Kusuma Arpt|JKT|0|0",SGK:"||0|0",CVN:"Clovis||34.43|-103.08|0|0",YAG:"Fort Frances||48.65|-93.45|0|0",SHJ:"Sharjah||25.35|55.40|0|0",KRF:"Kramfors||63.05|17.77|0|0",EUG:"Eugene||44.12|-123.22|0|0",SVB:"Sambava||-14.28|50.17|0|0",YXX:"Abbotsford||49.03|-122.36|0|0",CLY:"Ste Catherine||42.53|8.79|0|0",PCR:"Puerto Carreno Arpt||0|0",SMK:"||0|0",CUQ:"Coen Arpt||0|0",SLQ:"||0|0",BJB:"||0|0",BDH:"||0|0",TKX:"||0|0",RZR:"||0|0",NAG:"Sonegaon||21.09|79.05|0|0",TKE:"||0|0",PGK:"||0|0",CBB:"J Wilsterman||-17.43|-66.17|0|0",CPR:"Natrona Cty||42.91|-106.46|0|0",TEZ:"Salonibari Airport||0|0",TMW:"Tamworth||-31.08|150.85|0|0",FNJ:"Sunan||39.20|125.67|0|0",YTQ:"Tasiujaq||53.67|-69.92|0|0",KIR:"Kerry County||52.05|-9.50|0|0",JCK:"Julia Creek||-20.58|141.70|0|0",AQP:"Rodriguez Ballon||-16.34|-71.56|0|0",LYB:"Little Cayman||19.67|-80.08|0|0",PSZ:"||0|0",LLI:"||0|0",TPA:"Tampa||27.97|-82.54|0|0",MIS:"||0|0",DCN:"||0|0",WLK:"Selawik||66.60|-159.98|0|0",TKU:"Turku||60.51|22.27|0|0",BPX:"||0|0",BGF:"Bangui||4.40|18.52|0|0",ROP:"Rota||14.17|145.25|0|0",TMX:"||0|0",SXM:"Princess Juliana||18.04|-63.11|0|2",BOO:"Bodo||67.27|14.37|0|0",PTU:"||0|0",QUB:"||0|0",SNA:"John Wayne||33.68|-117.87|0|0",KAE:"Kake||56.97|-133.95|0|0",PLS:"Providenciales||21.77|-72.27|0|0",MCO:"Orlando|ORL|28.43|-81.32|0|0",SVJ:"Helle||68.24|14.67|0|0",TGR:"||0|0",KER:"Kerman||30.26|56.96|0|0",SHH:"||0|0",PEG:"Sant Egidio||43.13|12.37|0|0",LAI:"Servel||48.75|-3.48|0|0",KSY:"Kars||40.55|43.09|0|0",GOH:"Nuuk||64.18|-51.73|0|0",LKL:"Banak||70.07|24.97|0|0",BGC:"||0|0",TEE:"||0|0",AUC:"Arauca Arpt||0|0",KTS:"Brevig Mission||65.33|-166.47|0|0",BMU:"Bima Airport||0|0",HND:"Haneda|TYO|35.55|139.77|0|0",RGL:"Rio Gallegos Internacional||-51.62|-69.28|0|0",KRL:"||0|0",IAO:"||0|0",OUA:"Ouagadougou||12.35|-1.51|0|0",GRW:"Graciosa||39.05|-28.05|0|0",LKH:"Long Akah Arpt||0|0",YRJ:"Roberval||48.52|-72.22|0|0",YBW:"Bedwell Harbor||48.75|-123.23|0|0",WEI:"Weipa||-12.68|141.88|0|0",IYK:"Kern Cty||35.66|-117.83|0|0",KWN:"||0|0",DQA:"Saertu Airport||0|0",MDK:"||0|0",EMK:"||0|0",TOM:"||0|0",JAV:"Ilulissat||69.23|-51.05|0|0",KSU:"Kvernberget||63.11|7.84|0|0",GWD:"||0|0",AOE:"Anadolu Airport||0.00|0.00|0|2",BJX:"Del Bajio||21.00|-102.48|0|0",SPP:"||0|0",RVD:"||0|0",EDR:"Edward River||-14.90|141.62|0|0",JHW:"Chautauqua Cty||42.15|-79.26|0|0",TTE:"||0|0",ENY:"Yanan||36.00|109.33|0|0",TSO:"Tresco|ISC|48.95|-6.25|0|0",MLM:"Michoacan||19.85|-101.02|0|0",ELC:"||0|0",GIG:"Rio Internacional|RIO|-22.90|-43.26|0|0",DIB:"Chabua||27.48|95.02|0|0",LSA:"||0|0",NIM:"Niamey||13.48|2.17|0|0",TLE:"Tulear||-23.39|43.72|0|0",CFC:"||0|0",INI:"Nis||43.33|21.85|0|0",TNA:"Jinan||36.75|116.97|0|0",FLA:"||0|0",IGU:"Cataratas||-25.60|-54.48|0|0",MWX:"Muan International Airport||0.00|0.00|0|2",ILO:"Mandurriao||10.71|122.54|0|0",BHE:"Woodbourne||-41.52|173.87|0|0",ZAT:"||0|0",RBQ:"||0|0",SIF:"||0|0",UAK:"Narsarsuaq||61.17|-45.32|0|0",DOU:"Dourados Airport||0|0",WIN:"||0|0",JIK:"Ikaria||37.67|26.33|0|0",HYS:"Hays||38.85|-99.27|0|0",UIN:"Baldwin Field||39.94|-91.20|0|0",OZZ:"Ourzazate||30.92|-6.92|0|0",PLH:"Roborough||50.42|-4.12|0|0",GYL:"||0|0",GOP:"Gorakhpur Arpt||0|0",ZCL:"Zacatecas||22.80|-102.55|0|0",YDS:"||0|0",YMF:"||0|0",EZE:"Ministro Pistarini|BUE|-34.82|-58.53|0|0",FUE:"Fuerteventura||28.48|-13.99|0|0",BNX:"Banja Luka||44.93|17.30|0|0",IXI:"Lilabari||27.29|94.09|0|0",PHC:"Port Harcourt||5.02|6.95|0|0",NDB:"Nouadhibou||20.93|-17.03|0|0",KVL:"||0|0",GJL:"||0|0",ZIH:"Zihuatanejo||17.64|-101.56|0|0",NNT:"Nan||18.80|100.78|0|0",NYA:"Nyagan||0|0",TUK:"Turbat||25.98|63.07|0|0",CJA:"||0|0",PMQ:"||0|0",SCY:"San Cristobal||-0.83|-89.43|0|0",GDL:"Miguel Hidalgo||20.52|-103.31|0|0",CUZ:"Tte Velazco Astete||-13.53|-71.96|0|0",SDE:"Santiago Des Estero||-27.77|-64.32|0|0",MYR:"Myrtle Beach Jetway||33.68|-78.93|0|0",RBX:"||0|0",AJF:"||0|0",MLL:"||0|0",OST:"Ostend||51.20|2.86|0|2",NBW:"Guantanamo NAS|GAO|0|0",KHH:"Kaohsiung||22.57|120.34|0|0",CCU:"Netaji Subhas Chandra Bose||22.65|88.45|0|0",TOH:"Torres Airstrip||0|0",GEA:"Magenta|NOU|-22.26|166.47|0|0",TAP:"Tapachula||14.91|-92.25|0|0",IUE:"Hanan||-19.08|-169.93|0|0",AAL:"Aalborg||57.09|9.85|0|0",TKD:"||0|0",LBC:"Blankensee|HAM|53.81|10.72|0|0",TGU:"Toncontin||14.06|-87.22|0|0",ZMT:"||0|0",PAD:"Paderborn||51.62|8.62|0|0",FLO:"Gilbert Field||34.19|-79.72|0|0",YEI:"Yenisehir||40.23|29.55|0|0",YXY:"Whitehorse||60.72|-135.07|0|0",PUK:"||0|0",PIA:"Greater Peoria||40.66|-89.69|0|0",ABR:"Aberdeen||45.45|-98.43|0|0",WBQ:"||0|0",POJ:"||0|0",AET:"||0|0",BMA:"Bromma|STO|59.35|17.95|0|0",RUT:"Rutland||43.53|-72.95|0|0",TAM:"General F Javier Mina||22.27|-97.80|0|0",CIJ:"||0|0",BUQ:"Bulawayo||-20.02|28.62|0|0",TGZ:"Llano San Juan||16.73|-93.18|0|0",LIT:"Little Rock Regional||34.73|-92.23|0|0",YMK:"||0|0",UBJ:"Ube||33.93|131.27|0|0",GYM:"Gen Jose M Yanez||27.96|-110.93|0|0",CGR:"Internacional||-20.46|-54.67|0|0",HHZ:"||0|0",BBI:"Bhubaneswar||20.24|85.82|0|0",ANS:"||0|0",FKS:"Fukushima||37.23|140.43|0|0",BOC:"Bocas Del Toro||9.34|-82.25|0|0",VOZ:"Voronezh||51.67|39.22|0|0",YQI:"Municipal Yarmouth||43.83|-66.08|0|0",SCC:"Prudhoe Bay Deadhorse||70.20|-148.47|0|0",ILP:"Ile Des Pins||-22.59|167.45|0|0",RFD:"Chicago Rockford|CHI|42.30|-89.22|0|0",CFR:"Carpiquet||49.17|-0.45|0|0",LTN:"Luton|LON|51.88|-0.35|0|2",UTU:"||0|0",LHW:"Lanzhou||36.03|103.87|0|0",RRR:"Raroia||0.00|0.00|0|2",PDG:"Tabing||-0.88|100.35|0|0",SBN:"Michiana Regional||41.70|-86.31|0|0",WTL:"||0|0",BJZ:"Talaveral La Real||38.89|-6.82|0|0",TBO:"Tabora Arpt||0|0",BHD:"Belfast City|BFS|54.62|-5.88|0|0",TEN:"Tongren||27.63|109.05|0|0",DIK:"Dickinson||46.83|-102.90|0|0",GAL:"Galena||64.74|-156.93|0|0",GEL:"||0|0",MHD:"Mashad||36.24|59.64|0|0",ERI:"Erie||42.08|-80.18|0|0",LUH:"Ludhiana Arpt||0|0",ORV:"||0|0",LJG:"Lijiang||26.68|100.25|0|0",ADJ:"Civil Marka|AMM|31.95|35.98|0|0",OHD:"Ohrid Arpt||0|0",DUM:"||0|0",GCK:"Garden City||37.93|-100.73|0|0",BAX:"Barnaul||53.36|83.54|0|2",PDL:"Nordela||37.75|-25.68|0|0",ABV:"Abuja||9.00|7.27|0|0",SCT:"||0|0",GAF:"||0|0",LNY:"Lanai||20.78|-156.95|0|0",ZNZ:"Kisauni||-6.22|39.22|0|0",TKJ:"Tok||63.30|-143.00|0|0",IKS:"||0|0",SVP:"||0|0",VFA:"Victoria Falls||-18.09|25.84|0|0",IWD:"Ironwood||46.53|-90.13|0|0",DED:"Jolly Grant||30.32|78.03|0|0",LXS:"Limnos||39.92|25.25|0|0",OOM:"Cooma Airport||0|0",XBJ:"||0|0",SEN:"Southend Municipal Arpt||0|0",TZX:"Trabzon||41.00|39.78|0|0",ARK:"Arusha||-3.37|36.68|0|0",KSQ:"||0|0",DAL:"Love Field|DFW|32.85|-96.85|0|0",OAJ:"Albert J Ellis||34.83|-77.61|0|0",MOC:"Montes Claros Arpt||0|0",WXN:"Wanxian||30.90|103.47|0|0",TUU:"Tabuk||28.37|36.63|0|0",YWM:"||0|0",CIA:"Ciampino|ROM|41.80|12.59|0|0",BDP:"||0|0",GES:"Buayan||6.11|125.23|0|0",LLB:"||0|0",KMS:"||0|0",JNB:"O R Tambo||-26.13|28.25|0|0",OGX:"||0|0",PAC:"Paitilla Arpt|PTY|0|0",EDA:"Edna Bay Arpt||0|0",VHM:"Vilhelmina||64.62|16.65|0|0",CIU:"Chippewa Cnty|SSM|46.50|-84.35|0|0",UVF:"Hewanorra|SLU|13.74|-60.95|0|0",KIH:"||0|0",KNS:"King Island||-39.88|143.88|0|0",MJM:"||0|0",ODY:"||0|0",CCN:"||0|0",AKI:"||0|0",NLD:"Quetzalcoatl||27.43|-99.57|0|0",TNO:"Tamarindo||10.92|-85.45|0|0",ZAZ:"Zaragoza||41.67|-1.04|0|0",YPT:"||0|0",TYN:"Taiyuan||37.75|112.62|0|0",APK:"||0|0",NYR:"NYURBA|||1",CRK:"Clark Field|NCP|15.18|120.55|0|0",PSV:"||0|0",MEQ:"||0|0",PNP:"Girua Arpt||0|0",HOQ:"Hof Pirk||50.29|11.86|0|0",SKK:"Shaktoolik Arpt||0|0",SLE:"McNary Field||45.00|-123.03|0|0",JHG:"Jinghong||22.02|100.80|0|0",EBU:"Boutheon Arpt||0|0",MFK:"Matsu||26.17|119.92|0|0",TPI:"||0|0",DWC:"Al Maktoum|DXB|24.89|55.17||1",GSV:"Gagarin|RTW|51.73|46.13||1",INH:"||0|0",FOD:"Ft Dodge||42.55|-94.19|0|0",AMD:"Ahmedabad||23.07|72.62|0|0",KAN:"Aminu Kano||12.05|8.52|0|0",LFW:"Lome||6.16|1.25|0|0",LSI:"Sumburgh|SDZ|59.88|-1.29|0|0",FUO:"Fuoshan Arpt||0|0",MNA:"||0|0",LPT:"Lampang||18.27|99.51|0|0",ULG:"||0|0",MME:"Durham Tees Valley||54.52|-1.42|0|0",CUC:"Camilo Dazo||7.93|-72.51|0|0",PDA:"Puerto Inirida Arpt||0|0",COS:"Colorado Springs||38.81|-104.71|0|0",PHF:"Williamsburg||37.13|-76.49|0|0",NPE:"Hawkes Bay||-39.47|176.87|0|0",URY:"Gurayat||31.33|37.33|0|0",BHJ:"Rudra Mata||23.29|69.67|0|0",TFI:"||0|0",KYU:"||0|0",IMT:"Ford||45.82|-88.11|0|0",HGH:"Hangzhou||30.33|120.23|0|0",XRY:"La Parra||36.75|-6.06|0|0",KHZ:"||0|0",KGS:"Kos||36.79|27.10|0|0",RAI:"Francisco Mendes||14.93|-23.50|0|0",LIG:"Bellegarde||45.86|1.18|0|0",NAU:"||0|0",HUH:"Huahine||-16.72|-151.05|0|0",CYX:"||0|0",UNK:"Unalakleet||63.88|-160.79|0|0",HOT:"Memorial Field||0|0",KFP:"||0|0",CPV:"Joao Suassuana||-7.27|-35.90|0|0",ACR:"Araracuara Arpt||0|0",YGV:"Havre St Pierre||50.25|-63.58|0|0",JGS:"||0|0",KMJ:"Kumamoto||32.83|130.85|0|0",STW:"Stavropol||45.33|42.01|0|0",SNR:"Montoir||47.29|-2.18|0|0",YQG:"Windsor||42.27|-82.96|0|0",YPJ:"Aupaluk||59.30|-69.67|0|0",ZNA:"Harbour Seaplane Base|YCD|49.17|-123.93|0|0",UBA:"Uberaba||-19.78|-47.96|0|0",BPF:"||0|0",CMW:"Ign Agramonte||21.42|-77.85|0|0",RUA:"||0|0",TRS:"Ronchi Dei Legionari||45.83|13.47|0|0",CSA:"||0|0",SNN:"Shannon||52.70|-8.92|0|0",HOI:"Hao Island Arpt||0|0",LKB:"||0|0",INZ:"||0|0",SOW:"Show Low||34.26|-110.00|0|0",FAV:"||0|0",TBP:"Tumbes||-3.57|-80.42|0|0",CMX:"Houghton Cty Memorial||47.17|-88.49|0|0",MZH:"||0|0",IDA:"Fanning Field||43.52|-112.06|0|0",RCE:"Roche Harbor||48.58|-123.17|0|0",GOM:"||0|0",NAJ:"||0|0",OSK:"Oskarshamn||57.27|16.43|0|0",AIN:"Wainwright||70.63|-160.03|0|0",MFU:"||0|0",OLA:"||0|0",IKA:"Imam Khomeini|THR|35.41|51.15|0|0",GIS:"Gisborne||-38.66|177.97|0|0",FNI:"Nimes||43.75|4.42|0|0",HOB:"Lea County||32.69|-103.22|0|0",HFE:"Hefei||31.85|117.28|0|0",PHE:"Port Hedland ||-20.38|118.63|0|0",MGZ:"||0|0",URG:"Ruben Berta Arpt||0|0",IKI:"||0|0",TPQ:"Tepic||21.50|-104.90|0|0",AMI:"Selaparang||-8.56|116.10|0|0",CCV:"Craig Cove Arpt||0|0",MWA:"Williamson County||37.75|-89.02|0|0",DLC:"Dalian||38.97|121.55|0|0",TUO:"Taupo||-38.74|176.08|0|0",MQX:"||0|0",MUR:"Marudi Arpt||0|0",VDH:"||0|0",MGT:"||0|0",SFN:"Santa Fe||-31.72|-60.82|0|0",YPW:"Westview||49.82|-124.50|0|0",IWJ:"Iwami||34.67|131.79|0|0",HAK:"Haikou||20.10|110.35|0|0",YQX:"Gander||48.95|-54.56|0|0",RYG:"Rygge|OSL|0.00|0.00|0|2",VKG:"Rach Gia||10.08|105.08|0|0",RSW:"Regional Southwest|FMY|26.54|-81.76|0|0",NYM:"||0|0",KGX:"||0|0",VCT:"Victoria Regional||28.85|-96.91|0|0",CGD:"Changde||29.07|111.58|0|0",PUG:"Port Augusta Arpt||0|0",BLJ:"Batna Arpt||0|0",WRO:"Strachowice||51.10|16.88|0|0",MLS:"Miles City||46.43|-105.88|0|0",KDL:"||0|0",SYO:"Shonai||38.81|139.79|0|0",JUV:"||0|0",YVQ:"Norman Wells||65.28|-126.80|0|0",HNA:"Hanamaki||39.73|141.12|0|0",YUB:"Tuktoyaktuk Airport||0|0",MYJ:"Matsuyama||33.82|132.70|0|0",GRJ:"George||-33.97|22.42|0|0",MVB:"Franceville Mvengue||-1.65|13.43|0|0",HTS:"Tri State Milton||38.37|-82.56|0|0",YRA:"||0|0",WPM:"||0|0",BQT:"Brest Arpt||0|0",MCP:"Macapa||0.05|-51.07|0|0",TJQ:"Bulutumbang||-2.75|107.65|0|0",GDQ:"||0|0",BMD:"||0|0",TIJ:"Gen Abelardo Rodriguez||32.54|-116.97|0|0",HOV:"Hovden||62.18|6.15|0|0",TXN:"Tunxi||29.73|118.30|0|0",BVI:"Birdsville||-25.90|139.34|0|0",VCS:"||0|0",IRA:"||0|0",FMA:"El Pucu||-26.21|-58.23|0|0",BON:"Flamingo Field||12.13|-68.27|0|0",MRZ:"Moree||-29.50|149.85|0|0",MSE:"Kent||51.35|1.35|0|0",JOI:"Cubatao||-26.23|-48.78|0|0",MXH:"||0|0",YYF:"Penticton||49.46|-119.60|0|0",OKA:"Naha Field||26.20|127.65|0|0",OZC:"Labo Airport||0|0",VDM:"Viedma||-40.85|-63.02|0|0",MJN:"Amborovy||-15.67|46.35|0|0",SRY:"||0|0",WVB:"Rooikop||-22.98|14.52|0|0",FHZ:"||0|0",SVG:"Sola||58.88|5.63|0|0",TAI:"||0|0",MUX:"||0|0",KAJ:"Kajaani||64.28|27.69|0|0",JNZ:"Jinzhou||41.12|121.02|0|0",SHP:"Qinhuangdao||39.93|119.50|0|0",LSW:"||0|0",DIG:"Diging||27.79|99.68|0|0",JAN:"Jackson Evers||32.41|-90.16|0|0",LPL:"Liverpool||53.34|-2.87|0|0",LMN:"Limbang Arpt||0|0",YAX:"||0|0",GYA:"||0|0",MCK:"McCook||40.26|-100.67|0|0",CNX:"Chiang Mai||18.77|98.97|0|2",IXS:"Kumbhigram Arpt||0|0",LDN:"||0|0",TAK:"Takamatsu||34.29|134.07|0|0",YRR:"||0|0",MDL:"Annisaton||21.94|96.09|0|0",ESM:"||0|0",JUM:"||0|0",BMW:"||0|0",ADU:"Ardabil||38.25|48.30|0|0",BZG:"Bydgoszcz||53.10|17.98|0|0",BBO:"||0|0",KKN:"Hoeybuktmoen||69.72|29.89|0|0",MYU:"||0|0",YRL:"Federal Red Lake||51.05|-93.82|0|0",LRS:"Leros||37.52|26.78|0|0",TRF:"Sandefjord|OSL|59.18|10.27|0|0",KOY:"||0|0",RKA:"||0|0",LPP:"Lappeenranta||61.05|28.16|0|0",TST:"Trang||7.50|99.62|0|0",LUQ:"San Luis Cty||-33.27|-66.36|0|0",NVT:"Navegantes||-26.87|-48.63|0|0",KPO:"Pohang||35.99|129.42|0|0",LCR:"La Chorrera Arpt||0|0",MRE:"Mara Lodges||-1.18|35.08|0|0",KTN:"Ketchikan||55.35|-131.58|0|0",PEN:"Penang||5.29|100.27|0|0",PMW:"Palmas||-10.24|-48.35|0|0",YYG:"Charlottetown||46.29|-63.13|0|0",VIJ:"Virgin Gorda||18.50|-64.50|0|0",OAK:"Metro Oakland||37.72|-122.22|0|0",XAP:"Chapeco||-27.09|-52.63|0|0",FSZ:"Mount Fuhji Shizuoka Arpt||0|0",CUF:"Levaldigi||44.54|7.62|0|0",MYY:"Miri||4.46|114.00|0|0",AHB:"Abha||18.23|42.65|0|0",USU:"Francisco B. Reyes Airport||0.00|0.00|0|2",ADB:"Adnan Menderes|IZM|38.28|27.15|0|0",DOP:"||0|0",PVK:"Aktion||38.93|20.77|0|0",MUK:"||0|0",BUW:"||0|0",BUA:"||0|0",MHU:"Mount Hotham Arpt||0|0",TNK:"||0|0",TDX:"Trat||12.27|102.32|0|0",MQT:"Sawyer Intl||46.53|-87.56|0|0",SCO:"Aktau||43.87|51.10|0|0",NDR:"Nador||35.15|-2.92|0|0",YOG:"||0|0",TYF:"Torsby Airport||0|0",JMS:"Jamestown||46.93|-98.68|0|0",MLN:"Melilla||35.28|-2.96|0|0",TCG:"||0|0",LEQ:"St Just Arpt||0|0",PJA:"Pajala||67.25|23.07|0|0",ATZ:"||0|0",SHV:"Shreveport Regional||32.45|-93.75|0|0",YGR:"House Harbour||47.37|-61.90|0|0",MJT:"Mytilene||39.06|26.60|0|0",VQS:"Vieques||18.11|-65.42|0|0",YIH:"Yichang||30.70|111.18|0|0",GDV:"Dawson Community Arpt||0|0",YHG:"Charlottetown||52.77|-56.10|0|0",BPL:"||0|0",KGP:"||0|0",NOU:"Tontouta||-22.02|166.21|0|0",GHA:"Noumerate||32.38|3.80|0|0",TSN:"Tianjin||39.12|117.35|0|0",ABE:"Lehigh Valley||40.65|-75.44|0|0",TKS:"Tokushima||34.13|134.60|0|0",MGM:"Dannelly Field||32.30|-86.39|0|0",JRH:"Rowriah Arpt||0|0",MTR:"S Jeronimo||8.75|-75.88|0|0",BHH:"||0|0",CHY:"||0|0",ALM:"Alamogordo||32.85|-105.98|0|0",KNQ:"||0|0",DIN:"Gialam||21.38|103.00|0|0",MWF:"||0|0",PZU:"Port Sudan New intl Arpt||0|0",HPB:"||0|0",YFA:"||0|0",SDJ:"Sendai||38.14|140.92|0|0",PQQ:"Port Macquarie||-31.43|152.87|0|0",DIE:"Antsiranana Arrachart||-12.35|49.29|0|0",DZN:"||0|0",NOZ:"Novokuznetsk||53.75|87.17|0|0",MFE:"Miller||26.26|-98.29|0|0",HMV:"Hemavan Flyg||65.73|15.27|0|0",ACP:"||0|0",YYE:"Ft Nelson||58.83|-122.58|0|0",YUT:"||0|0",TCO:"||0|0",ISE:"||0|0",WTP:"||0|0",JDH:"Jodhpur||26.26|73.05|0|0",PSP:"Palm Springs||33.83|-116.50|0|0",BSD:"Baoshan||25.15|99.15|0|0",SRG:"Achmad Uani||-6.98|110.38|0|0",SON:"Pekoa||-15.52|167.22|0|0",BWN:"Brunei||4.92|114.93|0|0",JUZ:"Juzhou Arpt||0|0",RAH:"||0|0",LBS:"Labasa||-16.46|179.34|0|0",PKX:"Beijing Daxing International Airport|BJS|0|1",ACT:"Madison Cooper||31.61|-97.23|0|0",ROT:"Rotorua||-38.11|176.32|0|0",NSK:"Alykel||69.32|87.32|0|0",CBQ:"CALABAR ARPT||0|0",EBA:"Marina Di Campo Arpt||0|0",TOE:"Tozeur||33.92|8.13|0|0",CLO:"Alfonso Bonella Aragon||3.55|-76.39|0|0",RAS:"||0|0",RJL:"Agoncillo||42.46|-2.32|0|0",ДЕП:"DEPUTATSKIY|DPT||1",RHO:"Diagoras||36.38|28.12|0|0",CFK:"Chlef Arpt||0|0",BDT:"||0|0",FAT:"Fresno Air Terminal||36.77|-119.71|0|0",OME:"Nome||64.51|-165.44|0|0",RCP:"||0|0",LNE:"||0|0",MKW:"Rendani Arpt||0|0",HKN:"Hoskins||-5.48|150.42|0|0",KUV:"Kunsan||35.98|126.75|0|0",REC:"Recife||-8.13|-34.92|0|0",ATM:"Altamira Arpt||0|0",KOZ:"||0|0",ITH:"Tomkins County||42.49|-76.46|0|0",IGG:"||0|0",SXL:"Collooney||54.28|-8.47|0|0",KSC:"Barca||48.67|21.25|0|0",HEA:"Herat Arpt||0|0",YPO:"||0|0",PED:"Pardubice Arpt||0|0",ESL:"Elista|||1",YFH:"||0|0",VBM:"||0|0",PLP:"||0|0",GRV:"Grozny||0.00|0.00|0|2",ALZ:"||0|0",TSV:"Townsville||-19.25|146.77|0|0",AST:"Astoria||46.16|-123.88|0|0",OPS:"||0|0",LTD:"||0|0",TFS:"Reina Sofia|TCI|28.05|-16.57|0|0",ESC:"Delta County||45.72|-87.09|0|0",KKJ:"Kokura||33.83|130.95|0|0",MII:"Dr Gastao Vidigal||-22.20|-49.93|0|0",TTA:"||0|0",ZEM:"Eastmain River Airport||0.00|0.00|0|2",TVC:"Cherry Capital||44.74|-85.59|0|0",MPN:"Mount Pleasant||-51.82|-58.45|0|0",RKT:"Ras Al Khaimah||25.75|56.00|0|0",HYA:"Barnstable Cty||41.67|-70.28|0|0",FYU:"||0|0",CWC:"Chernovtsy Arpt||0|0",TBI:"||0|0",ACA:"Alvarez||16.76|-99.77|0|0",GRK:"Gray AAF|ILE|31.07|-97.83|0|0",BJL:"Yundum||13.35|-16.67|0|0",AQG:"Anqing||30.52|117.03|0|0",IGM:"Mohave County||35.26|-113.94|0|0",CGI:"Cape Girardeau||37.22|-89.57|0|0",AAN:"Al Ain||24.25|55.75|0|0",AJU:"Santa Maria||-10.98|-37.05|0|0",YNZ:"||0|0",LDH:"Lord Howe Island||-31.54|159.08|0|0",MYE:"||0|0",PEX:"PECHORA|||1",SYQ:"Tobias Bolanos Intl|SJO|0|0",GGG:"Greg County||32.39|-94.72|0|0",WKJ:"Hokkaido||45.42|141.67|0|0",VAA:"Vaasa||63.05|21.76|0|0",JNG:"||0|0",PGM:"Port Graham Arpt||0|0",GPS:"Baltra||-0.43|-90.28|0|0",ELP:"El Paso||31.80|-106.40|0|0",BUC:"Burketown||-17.75|139.53|0|0",BBU:"Baneasa|BUH|44.50|26.10|0|0",HAS:"Hail||27.55|41.38|0|0",IGA:"||0|0",YBG:"Bagotville||48.32|-70.99|0|0",AKP:"||0|0",SHD:"Shenandoah Valley||38.26|-78.90|0|0",PBC:"Huejostingo||19.14|-98.37|0|0",CVU:"Corvo||39.70|-31.10|0|0",PBM:"Zanderij||5.45|-55.19|0|0",BFN:"Bloemfontein||-29.10|26.30|0|0",WDS:"Shiyan Wudangshan|||1",YYU:"Japuskasing||49.41|-82.47|0|0",KMO:"||0|0",MEC:"Manta||-0.95|-80.68|0|0",OBN:"Connel Airport||0|0",WWT:"||0|0",RUD:"||0|0",HKK:"Hokitika||-42.72|170.99|0|0",GPT:"Biloxi Regional||30.41|-89.07|0|0",HJJ:"||0|0",FWA:"Baer Field||40.98|-85.19|0|0",MAA:"Chennai||12.99|80.18|0|0",ANF:"Cerro Moreno||-23.44|-70.44|0|0",EAS:"San Sebastian||43.36|-1.79|0|0",YLE:"||0|0",YIF:"Pakuashipi||51.22|-58.67|0|0",FAI:"Fairbanks||64.81|-147.86|0|0",NKI:"||0|0",PVC:"Provincetown||42.07|-70.22|0|0",FTU:"Marillac Arpt||0|0",EAR:"Kearney Arrpt||40.73|-99.00|0|0",YXJ:"Ft St John||56.23|-120.73|0|0",PVD:"T F Green St||41.73|-71.43|0|0",SOM:"El Tigre||8.95|-64.15|0|0",ZSA:"San Salvador||24.06|-74.53|0|0",CLP:"||0|0",TIQ:"Tinian||15.00|145.63|0|0",IOM:"Ronaldsway||54.08|-4.63|0|0",LYG:"Lianyungang||34.67|119.18|0|0",LNB:"||0|0",ALF:"Elvebakken||69.98|23.38|0|0",SVS:"||0|0",RDM:"Roberts Field||44.25|-121.15|0|0",YCU:"||0|0",MXZ:"Meixian||24.35|116.13|0|0",YPC:"||0|0",LDU:"Lahad Datu Arpt||0|0",MAK:"Malakal Arpt||0|0",MUZ:"Musoma Arpt||0|0",YZZ:"Trail||0|0",FUN:"Funafuti||-8.52|179.21|0|0",WEF:"Weifang||36.75|119.22|0|0",DMU:"Dimapur Airport||0|0",ZBF:"Bathurst||47.63|-65.74|0|0",YFB:"Iqaluit||63.75|-68.56|0|0",BRE:"Bremen||53.05|8.79|0|0",VGO:"Vigo||42.23|-8.63|0|0",LCG:"La Coruna||43.30|-8.38|0|0",UEO:"Kumejima||26.37|126.72|0|0",RIG:"Rio Grande Airport||0|0",RKS:"Rock Springs||41.60|-109.07|0|0",DHI:"||0|0",BPT:"Jefferson Cty||29.95|-94.02|0|0",YSK:"Sanikiluaq||56.55|-79.22|0|0",NSI:"Nsimalen|YAO|3.70|11.55|0|0",JQE:"||0|0",FCA:"Glacier Park||48.31|-114.25|0|0",SYM:"||0|0",PXU:"Pleiku||14.00|108.02|0|0",HDF:"Heringsdorf Arpt||0|0",KIF:"||0|0",EDL:"Eldoret||0.52|35.28|0|0",KVC:"||0|0",AXM:"El Eden||4.45|-75.77|0|0",RMQ:"Ching Chuan Kang||24.27|120.62|0|0",IRC:"Circle City Arpt||0|0",HFS:"||0|0",GMZ:"La Gomera||28.02|-17.20|0|0",VLI:"Bauerfield||-17.67|168.24|0|0",PUB:"Pueblo||38.29|-104.50|0|0",LZO:"Luzhou||28.88|105.35|0|0",ATC:"Arthurs Town||24.63|-75.67|0|0",MSJ:"Misawa||40.70|141.37|0|0",PIF:"||0|0",MAS:"Momote||-2.06|147.42|0|0",LIN:"Linate|MIL|45.44|9.28|0|0",SOQ:"Jefman||-0.93|131.12|0|0",DND:"Riverside Park||56.45|-3.01|0|0",KUD:"Kudat Arpt||0|0",AHN:"Athens||33.95|-83.33|0|0",HYL:"Sea Plane Base||0|0",ERC:"Erzincan||39.71|39.52|0|0",LZY:"||0|0",MSW:"||0|0",ENU:"||0|0",KTB:"||0|0",PAS:"Paros Community||37.07|25.10|0|0",MHT:"Manchester||42.94|-71.44|0|0",ONP:"Newport||44.63|-124.05|0|0",OSY:"Namsos||64.47|11.60|0|0",NZH:"Manzhouliarpt||0|0",GLH:"Greenville||33.48|-90.98|0|0",RJA:"Rajahmundry Arpt||0|0",GAU:"Borjhar||26.10|91.59|0|0",DNH:"Dunhuang||40.20|94.68|0|0",MWK:"||0|0",AEP:"Jorge Newbery|BUE|-34.56|-58.42|0|0",NDY:"Sanday||59.25|-2.58|0|0",POS:"Piarco||10.60|-61.35|0|0",YLL:"Lloydminster||53.30|-110.00|0|0",BAY:"Baia Mare||47.65|23.47|0|0",CEZ:"Montezuma County||37.30|-108.63|0|0",ACC:"Kotoka||5.60|-0.17|0|0",YYC:"Calgary||51.11|-114.02|0|0",IXA:"Singerbhil Arpt||0|0",ZYL:"Sylhet Osmany||24.96|91.87|0|0",PDP:"Cap Curbelo||-34.91|-54.92|0|0",CJJ:"Cheongju||36.72|127.51|0|0",BGR:"Bangor||44.81|-68.83|0|0",SAV:"Savannah||32.13|-81.20|0|0",CPD:"Coober Pedy||-29.04|134.75|0|0",BZR:"Beziers Vias||43.32|3.35|0|0",KZD:"||0|0",BUN:"Buenaventura Arpt||0|0",DIY:"Diyarbakir||37.90|40.20|0|2",WAT:"Waterford||52.20|-7.09|0|0",GCN:"Grand Canyon Natl Park Arpt||0|0",BFF:"Scottsbluff||41.88|-103.60|0|0",FPO:"Grand Bahama||26.56|-78.70|0|0",GWL:"Gwalior Airport||0|0",INU:"Nauru||-0.53|166.92|0|0",KMG:"Kunming||25.02|102.68|0|0",MNI:"Bramble Arpt||0|0",RIS:"||0|0",KWE:"Guiyang||26.58|106.72|0|0",OHO:"Okhotsk||NaN|NaN|0|1",PAH:"Barkley Regional||37.06|-88.77|0|0",DUT:"Emergency Field||53.90|-166.54|0|0",CGA:"Craig Seaplane Base||55.48|-133.15|0|0",NOB:"||0|0",WUZ:"||0|0",TAH:"Tanna||-19.33|169.25|0|0",RKV:"Reykjavik Domestic|REK|64.13|-21.95|0|0",YNB:"Yanbo||24.12|38.07|0|0",GHT:"||0|0",ATW:"Outagamie Cty||44.26|-88.52|0|0",DLA:"Douala||4.01|9.71|0|0",CRP:"Corpus Christi||27.77|-97.50|0|0",DGO:"Guadalupe Victoria||24.13|-104.53|0|0",SZX:"Shenzhen||22.57|113.93|0|0",DLY:"||0|0",JNX:"Naxos||37.10|25.38|0|0",RJK:"Rijeka Arpt||0|0",TIR:"Tirupati||13.63|79.55|0|0",GYN:"Santa Genoveva||-16.64|-49.21|0|0",YTG:"||0|0",DPL:"Dipolog||8.60|123.35|0|0",BGO:"Flesland||60.29|5.22|0|0",MBI:"||0|0",FEZ:"Fez||33.93|-4.97|0|0",ELG:"||0|0",GNS:"Gunungsitoli Arpt||0|0",MCY:"Maroochydore||-26.60|153.09|0|0",FEN:"Fernando De Noronha||-3.85|-32.42|0|0",VII:"Vinh City||18.70|105.63|0|0",DJJ:"Sentani Arpt||0|0",PTP:"Le Raizet||16.27|-61.53|0|0",WDH:"Hosea Kutako||-22.48|17.47|0|0",NCA:"North Caicos||21.93|-71.98|0|0",ZVK:"||0|0",KZO:"Kzyl Orda||44.83|65.83|0|0",YUD:"Umiujaq||56.55|-76.55|0|0",LKE:"Lake Union Seaplane Base|SEA|47.63|-122.33|0|0",BYM:"||0|0",BSG:"||0|0",LBD:"Khudzhand||40.22|69.69|0|0",SHG:"||0|0",LAP:"Aeropuerto Gen Marquez De Leon||24.13|-110.30|0|0",PUQ:"Presidente Ibanez||-53.13|-70.88|0|0",IXC:"Chandigarh||30.67|76.79|0|0",MVY:"Dukes County||41.39|-70.62|0|0",SYB:"||0|0",FDH:"Friedrichshafen Lowenthal||47.67|9.51|0|0",NBX:"||0|0",KZS:"Kastelorizo||36.08|29.33|0|0",DOD:"||0|0",GNV:"Gainesville Regional||29.69|-82.28|0|0",BHI:"Commandante||-38.73|-62.15|0|0",JBR:"Jonesboro Municipal||0|0",AXP:"||0|0",SRE:"Sucre||-19.01|-65.30|0|0",PNA:"Pamplona Noain||42.77|-1.64|0|0",CUR:"Areopuerto Hato||12.19|-68.96|0|0",TLY:"||0|0",CWL:"Cardiff Wales||51.40|-3.35|0|0",MCW:"Mason City||43.16|-93.33|0|0",SLA:"General Belgrano||-24.86|-65.47|0|0",LWY:"Lawas Arpt||0|0",AFZ:"||0|0",IXZ:"Port Blair||11.65|92.74|0|0",GEO:"Cheddi Jagan||6.50|-58.25|0|0",ISP:"Long Island Macarthur||40.90|-73.10|0|0",YDP:"Nain||56.53|-61.67|0|0",MMJ:"Matsumoto Arpt||0|0",BJR:"Bahar Dar||11.59|37.38|0|0",CXI:"Cassidy||0|0",KHM:"||0|0",BDO:"Husein Sastranegara||-6.90|107.58|0|0",ACH:"Altenrhein||47.48|9.57|0|0",JIM:"Jimma||7.65|36.82|0|0",MDC:"Samratulang||1.48|124.85|0|0",IAS:"Iasi||47.18|27.60|0|0",DUD:"Momona||-45.92|170.20|0|0",DJE:"Melita||33.87|10.78|0|0",RBR:"Pres Medici||-9.97|-67.80|0|0",TVY:"||0|0",LKG:"Lokichoggio||4.23|34.35|0|0",PBG:"||0|0",SDP:"Sand Point||55.32|-160.51|0|0",ZEL:"||0|0",HIB:"Hibbing Chisolm||47.39|-92.84|0|0",CNF:"Tancredo Neves|BHZ|-19.63|-43.97|0|0",TSR:"Timisoara||45.82|21.33|0|0",MID:"Merida||20.93|-89.65|0|0",BVC:"Rabil||16.08|-22.83|0|0",OVD:"Asturias||43.57|-6.03|0|0",PEI:"Matecana||4.82|-75.74|0|0",MOI:"Mitiaro Island||-19.50|-158.00|0|0",KKR:"||0|0",SOV:"Seldovia||59.45|-151.72|0|0",HLA:"Lanseria|JNB|-26.08|27.58|0|0",RTG:"||0|0",LRT:"Lann Bihoue||47.76|-3.44|0|0",ULP:"Quilpie||-26.63|144.30|0|0",LZH:"Liuzhou||24.37|109.53|0|0",LYA:"Luoyang||34.68|112.47|0|0",WMK:"||0|0",IKO:"Nikolski Afs||0|0",SIQ:"||0|0",OXB:"Airport Osvaldo Viera||11.89|-15.66|0|0",FAC:"||0|0",CUL:"Fedl De Bachigualato||24.76|-107.47|0|0",IRK:"Kirksville Municipal||0|0",EGO:"Belgorod||50.63|36.65|0|0",WKA:"Wanaka||-44.73|169.25|0|0",NRN:"Niederrhein|DUS|51.61|6.15|0|0",IXU:"Chikkalthana||19.86|75.40|0|0",YDA:"Dawson City||64.04|-139.12|0|0",NAW:"Narathiwat||6.52|101.75|0|0",CIZ:"||0|0",RVE:"Saravena Arpt||0|0",BEB:"Benbecula||57.48|-7.36|0|0",ITU:"Iturup||45.26|147.96||1",WRE:"Whangarei||-35.77|174.36|0|0",XIL:"||0|0",TUC:"Benjamin Matienzo||-26.83|-65.20|0|0",HIR:"Henderson||-9.43|160.05|0|0",OSW:"Orsk||0.00|0.00|0|2",SCV:"Salcea||47.69|26.36|0|0",SLH:"||0|0",DRG:"||0|0",CGH:"Congonhas|SAO|-23.63|-46.66|0|2",YAT:"Attawapiskat||52.94|-82.40|0|0",PRC:"Prescott||34.65|-112.42|0|0",JAU:"||0|0",BND:"||0|0",WNA:"||0|0",PTJ:"Portland Arpt||0|0",URJ:"||0|0",FRD:"Friday Harbor||48.53|-123.02|0|0",ULZ:"||0|0",LAQ:"||0|0",LRE:"Longreach||-23.44|144.28|0|0",YCY:"Clyde River||70.42|-68.50|0|0",HDY:"Hat Yai||6.93|100.42|0|0",WSZ:"Westport||-41.74|171.58|0|0",LUO:"||0|0",HLD:"Hailer||49.20|119.70|0|0",OUL:"Oulu||64.93|25.36|0|0",FNT:"Bishop||42.97|-83.74|0|0",TBB:"Tuy Hoa||13.04|109.34|0|0",DRK:"||0|0",HOR:"Horta||38.52|-28.72|0|0",GOT:"Landvetter||57.67|12.28|0|2",TGH:"||0|0",GRI:"Hall Cty Regional||40.97|-98.31|0|0",FMO:"Muenster||52.13|7.68|0|0",SJZ:"Sao Jorge||38.65|-28.23|0|0",OTD:"||0|0",KSD:"Karlstad||59.36|13.47|0|0",MPH:"Malay||11.93|121.95|0|2",BLA:"Gen J A Anzoategui||10.11|-64.69|0|0",IPA:"||0|0",CIF:"||0|0",YYT:"St Johns||47.62|-52.75|0|0",CTU:"Chengdu||30.70|103.95|0|0",TPP:"||0|0",LBA:"Leeds Bradford||53.87|-1.65|0|0",GVR:"Governador Valadares Arpt||0|0",PVG:"Pu Dong|SHA|31.15|121.78|0|0",YLC:"Kimmirut Lake Harbour||62.85|-69.88|0|0",OMA:"Eppley Airfield||41.30|-95.89|0|0",LYP:"Faisalabad International Arpt||0|0",SYY:"Stornoway||58.22|-6.33|0|0",YYH:"Taloyoak||69.53|-93.52|0|0",OND:"Ondangwa Arpt||0|0",PPN:"Machangara||2.45|-76.61|0|0",LUA:"||0|0",NYO:"Skavsta|STO|58.75|17.00|0|0",RNN:"Bornholm||55.07|14.76|0|0",CWA:"Central Wisconsin|AUW|44.78|-89.66|0|0",MRQ:"||0|0",UIB:"Quibdo Arpt||0|0",PSS:"Posadas||-27.38|-55.97|0|0",KUK:"Kasigluk Arpt||0|0",AAX:"||0|0",JAX:"Jacksonville||30.49|-81.69|0|0",SHL:"Shillong Airport||0|0",YAY:"St Anthony||51.37|-55.58|0|0",LGI:"Deadmans Cay||23.18|-75.09|0|0",LEV:"||0|0",EIS:"Beef Island||18.44|-64.54|0|0",IAM:"||0|0",OOK:"||0|0",HAH:"Prince Said Ibrahim In|YVA|-11.53|43.27|0|0",JUI:"Juist Arpt||0|0",LWN:"Shirak||0.00|0.00|0|2",ULV:"Central|ULY|54.27|48.22|0|0",BLI:"Bellingham||48.79|-122.53|0|0",UAQ:"San Juan||-31.55|-68.52|0|0",CGO:"Zhengzhou||34.80|113.65|0|0",LIF:"Lifou||-20.77|167.25|0|0",NTN:"Normanton||-17.69|141.07|0|0",PNL:"Pantelleria Airport||0|0",KHS:"||0|0",TGC:"||0|0",RVK:"Ryumsjoen||64.88|11.23|0|0",HDD:"Hyderabad||25.32|68.36|0|0",HRB:"Harbin||45.75|126.67|0|0",ULB:"||0|0",MAZ:"Eugenio M De Hostos||18.26|-67.15|0|0",BIM:"Bimini||25.70|-79.28|0|0",PBJ:"||0|0",UVE:"||0|0",OCC:"Aeropuerto Francisco De Orellana||0|0",SZF:"Carsamba||41.25|36.55|0|0",ANV:"||0|0",BCA:"||0|0",JAL:"Jalapa||19.47|-96.78|0|0",WYS:"West Yellowstone Arpt||0|0",BVB:"Boa Vista||2.83|-60.67|0|0",RDV:"||0|0",KOT:"||0|0",CFE:"Aulnat||45.79|3.17|0|0",PJG:"||0|0",KGC:"Kingscote||-35.00|137.17|0|0",CDC:"Cedar City||37.70|-113.10|0|0",GAY:"Gaya||24.75|84.95|0|0",JZH:"Jiu Zhai Huang Long||32.86|103.68|0|0",LUV:"||0|0",ZSJ:"Sandy Lake||53.03|-93.23|0|0",BPM:"Begumpet Airport|HYD|0|0",FAE:"Faeroe||62.07|-7.27|0|0",LPK:"Lipetsk Arpt||52.70|39.52|0|2",TUG:"Tuguegarao Arpt||0|0",BVE:"Laroche||45.17|1.53|0|0",YKQ:"Waskaganish||51.49|-78.75|0|0",YXH:"Medicine Hat||50.02|-110.72|0|0",TCD:"Tarapaca Arpt||0|0",RBY:"||0|0",LNK:"Lincoln||40.85|-96.76|0|0",MSO:"Missoula||46.92|-114.09|0|0",LSP:"Josefa Camejo||11.72|-70.19|0|0",YZV:"Sept Iles||50.20|-66.38|0|0",MSQ:"Minsk||53.88|28.03|0|0",KCC:"||0|0",YBC:"Baie Comeau||49.20|-68.27|0|0",NMA:"Namangan||40.98|71.56|0|2",LST:"Launceston||-41.55|147.21|0|0",SAB:"Juancho Yraus Quinl||17.65|-63.22|0|0",NTX:"||0|0",HPN:"Westchester County||41.07|-73.71|0|0",FDF:"Lamentin||14.59|-61.01|0|0",LYI:"Linyi||35.07|118.37|0|0",YVB:"Municipal Bonaventure||48.05|-65.48|0|0",KRO:"Kurgan||55.48|65.42|0|0",YVP:"Kuujjuaq||58.10|-68.41|0|0",DMB:"Taraz||42.90|71.37|0|1",HRE:"Harare||-17.92|31.10|0|0",GDE:"||0|0",SJE:"San Jose Del Guaviaro Arpt||0|0",MQL:"Mildura||-34.23|142.09|0|0",JDZ:"Jingdezhen||29.27|117.18|0|0",DKA:"||0|0",LGK:"Langkawi||6.33|99.73|0|0",AAY:"Al Ghaydah||16.20|52.18|0|0",YMT:"Chibougamau||49.92|-74.37|0|0",GDZ:"Gelendzik||44.57|38.01|0|0",MXP:"Malpensa|MIL|45.63|8.72|0|0",SPS:"Wichita Falls||33.99|-98.49|0|0",LSY:"Lismore||-28.83|153.27|0|0",NYK:"Nanyuki||0.02|37.07|0|0",YUY:"Rouyn Noranda||48.21|-78.83|0|0",JRO:"Kilimanjaro||-3.43|37.07|0|0",VDE:"Hierro||27.81|-17.89|0|0",CCZ:"||0|0",LDB:"Londrina||-23.33|-51.13|0|0",JFR:"||0|0",IBR:"||0|0",YHO:"Hopedale||55.45|-60.23|0|0",TET:"Matunda||-16.10|33.64|0|0",DYG:"Dayong||29.13|110.48|0|2",ORB:"Orebro Bofors||59.28|15.22|0|0",UBP:"Muang Ubon||15.25|104.87|0|0",CDB:"||0|0",SXF:"Schoenefeld|BER|52.37|13.50|0|0",TFF:"Tefe Arpt||0|0",WAA:"||0|0",KAT:"Kaitaia||-35.07|173.28|0|0",CDV:"Mudhole Smith||60.49|-145.47|0|0",EJH:"||0|0",MAJ:"Amata Kabua||7.06|171.27|0|0",CHX:"Changuinola Arpt||0|0",MTS:"Matsapha||-26.52|31.31|0|0",CIP:"||0|0",YEG:"Edmonton|YEA|53.30|-113.59|0|0",UGB:"Ugashik Bay|PIP|0|0",IFO:"Ivano Frankovsk||48.88|24.68|0|0",SOC:"Adi Sumarno||-7.50|110.00|0|0",VVZ:"||0|0",MLU:"Monroe Regional||32.51|-92.04|0|0",TEB:"Teterboro||40.85|-74.06|0|0",MLB:"Melbourne Regional||28.10|-80.63|0|0",POP:"La Union||19.80|-70.67|0|0",RCL:"||0|0",DVL:"Devils Lake||48.11|-98.91|0|0",KKC:"Khon Kaen||16.46|102.79|0|0",MLY:"||0|0",AXR:"||0|0",YNS:"||0|0",CAK:"Akron Canton Regional||40.91|-81.44|0|0",TRZ:"Tiruchirapally Civil||10.77|78.71|0|0",GHB:"Governors Harbour||25.28|-76.33|0|0",YKT:"||0|0",CWB:"Afonso Pena||-25.53|-49.18|0|0",SYJ:"||0|0",BFL:"Meadows Field||35.43|-119.05|0|0",BRW:"Barrow WBAS||71.28|-156.77|0|0",QSF:"Setif Arpt||0|0",YCS:"Chesterfield Inlet||63.33|-90.72|0|0",RUS:"||0|0",BET:"Bethel||60.78|-161.83|0|0",ILI:"||0|0",THQ:"||0|0",YPH:"Inukjuak||58.43|-78.17|0|0",BGW:"Baghdad International Airport||33.26|44.23|0|2",MGB:"Mount Gambier||-37.75|140.78|0|0",WHK:"Whakatane||-37.92|176.91|0|0",HEK:"||0|0",EGX:"||0|0",YTF:"Alma Municipal Arpt||0|0",THE:"Teresina||-5.07|-42.82|0|0",KET:"||0|0",NJF:"Najaf International Arpt||0|0",JLR:"Jabalpur Airport||0|0",MSL:"Muscle Shoals||34.75|-87.62|0|0",ZKG:"Kegaska||50.19|-61.29|0|0",BKS:"Padangkemiling||-3.77|102.30|0|0",ESU:"Essaouira||31.53|-9.70|0|0",RIW:"Riverton||43.06|-108.46|0|0",YMN:"Makkovik||55.17|-59.17|0|0",ILD:"Lleida–Alguaire||0.00|0.00|0|2",JSY:"Syros Island||37.42|24.95|0|0",AXA:"Wallblake||18.22|-63.07|0|0",RPR:"Raipur||21.17|82.01|0|0",PAP:"Mais Gate||18.56|-72.33|0|0",REG:"Tito Menniti||38.08|15.65|0|0",ILZ:"Zilina||49.23|18.77|0|0",GDN:"Rebiechowo||54.37|18.65|0|0",SYZ:"Shiraz||29.54|52.59|0|0",TLM:"||0|0",IVL:"Ivalo||68.61|27.42|0|0",XUZ:"Xuzhou||34.27|117.18|0|0",OHE:"||0|0",DMD:"Doomadgee||-18.00|138.83|0|0",SPR:"San Pedro||17.91|-87.97|0|0",SSG:"Santa Isabel||3.75|8.71|0|0",ABM:"Bamaga||-10.87|142.40|0|0",KJI:"||0|0",YXP:"Pangnirtung||66.13|-65.73|0|0",AZN:"||0|0",YSY:"||0|0",BSA:"||0|0",HVR:"City County||48.54|-109.76|0|0",AKJ:"Asahikawa||43.67|142.45|0|0",TAE:"Daegu International Airport ||35.88|128.67|0|2",BUL:"||0|0",TME:"||0|0",GBT:"||0|0",SBY:"Wicomico Regional||38.34|-75.51|0|0",REU:"Reus||41.15|1.17|0|0",DIR:"Aba Tenna D Yilma||9.62|41.85|0|0",PEU:"||0|0",OLP:"Olympic Dam||-31.00|136.00|0|0",RNL:"||0|0",BHU:"Bhavnagar Arpt||0|0",NHA:"Nha Trang||12.23|109.19|0|0",DKS:"Dikson|||1",USJ:"Usharal||0|1",MQJ:"Moma||66.45|143.25|0|1",MS1:"Mars|||1",TGP:"Podkamennaya Tunguska||0|1",BQG:"Bogorodskoye|||1",KMW:"Kostroma Airport|||1",RMZ:"Remezov|TOX|58.20|68.27|0|1",UBN:"Chinggis Khaan|ULN|47.65|106.82||1",M0N:"Moon|||1",RZH:"Preobrazheniye|||1",GNJ:"Ganja|KVD|40.74|46.32||1",HSA:"Hazret Sultan||0|1",EPA:"El Palomar Airport|BUE||1"},
Airlines:{NE:"Nesma Airlines|0",E9:"Evelop Airlines|0",QX:"Horizon Air|0",JD:"Beijing Capital Airlines|1",JE:"Mango|0",XF:"Vladivostok Air|1",BE:"Flybe|0","4D":"Air Sinai|0",G2:"Alianza Glancelot C.A.|0",GK:"Jetstar Japan|0",ML:"Air Mediterranee|0",QN:"Air Armenia|0",VA:"Virgin Australia|0","5M":"Montserrat Airways|0",OY:"Omni Air International|0",KG:"Key Lime Air|0",TK:"Turkish Airlines|1",GH:"Globus|0",YX:"Republic Airlines|0","5B":"Euro-Asia Air|0",DM:"Asian Air Company Limited|0",YU:"EuroAtlantic Airways|0",UP:"Bahamasair|0",KZ:"Nippon Cargo Airlines|0",B7:"UNI Air|0",LR:"LINEAS AEREAS COSTARRICENSES S.A.|0",E3:"Sabaidee Airways|0",A8:"Ameriflight|0",AY:"Finnair|1",YV:"Mesa Airlines|0","2N":"NextJet|0","7H":"Ravn Alaska|0",O7:"Оренбуржье|0",L9:"BELLE AIR EUROPE|1",BI:"Royal Brunei Airlines|0",NW:"Northwest Airlines Inc|0","3Q":"Carib Aviation|0",NF:"Air Vanuatu|0",DC:"Braathens Regional|0","9P":"Air Arabia Jordan|0",PN:"China West Air|0",DO:"Discovery Air|0",VT:"Air Tahiti|0",Y4:"Volaris|0",YZ:"Alas Uruguay - Dyrus S.A.|0",ДЖ:"Tez Jet|0",JC:"Japan Air Commuter|0",OF:"Air Finland|0",UD:"Hex Air|0",I7:"Paramount Airways|0",T1:"Tik Systems (Thailand)|0",ST:"Germania|0",RW:"RAS Fluggesellschaft|0",MA:"Malev|1",AG:"Aruba Airlines|0",UC:"LAN Cargo|0",QB:"Qeshm Airlines|0",VP:"FlyMe|0",CR:"UBM Aviation - OAG|0",HE:"Luftfahrtgesellschaft Walter|0",LH:"Lufthansa|0",OR:"TUIFLY NETHERLANDS|0",DS:"EasyJet Switzerland|0",PD:"Porter Airlines|0",LC:"Equatorial Congo Airlines (ECAIR)|0","4V":"Birdy Airlinesce|0",PA:"AirBlue|0",QK:"Jazz Air|0",BM:"BMI Regional|0","7M":"Mistral Air|0",W8:"Cargojet Airways|0","3X":"Premier Trans Aire|0",MT:"Thomas Cook Airlines|0",GG:"Sky Lease I|0",GZ:"Air Rarotonga|0","7E":"Sylt Air|0","4U":"Germanwings|0",J0:"Jetlink Express|0",C3:"Trade Air|0",BH:"Hawkair Aviation Services|0",I5:"AirAsia India|0","4E":"Stabo Air Limited|0",I9:"Air Italy|0",NA:"North American Airlines|0",R2:"Orenair|0",NS:"Hebei Airlines|0",J9:"Jazeera Airways|0",RV:"Air Canada rouge|0",FL:"AirTran|0",WN:"Southwest Airlines|1",XC:"Corendon Airlines|0","1V":"Galileo International|0",XN:"Express Air|0",D4:"Alidaunia|0",BC:"Skymark Airlines|0","6I":"Air Alsie|0",PO:"Polar Air Cargo|0",AD:"Azul Brazilian Airlines|1",W9:"Wizz Air UK|0",LB:"Bul Air|1","4Q":"Safi Airways|0",BR:"EVA Air|0","8T":"Air Tindi|0","0D":"Darwin Airlines|0",JY:"interCaribbean Airways|0",VF:"Valuair|0",FO:"Flybondi|0","1F":"INFINI Travel Information|0",Y7:"NordStar|0",G0:"Ghana Intl|0",RK:"Skyview Airways Company Limited|0",P8:"P.L.A.S. S/A|0",ZS:"Sama Airlines|0",M6:"Amerijet International|0",SN:"Brussels Airlines|1",X9:"Avion Express|0",WZ:"Red Wings|0",OK:"Czech Airlines|1",OJ:"Fly Jamaica|0",HV:"Transavia|0",OA:"Olympic Air|0",GE:"TransAsia Airways|0","1Y":"Electronic Data Systems Corporation|0",JB:"Helijet International|0",HC:"Air Senegal|0",RZ:"Sansa Airlines|0",D9:"Donavia|0",C6:"Canjet Airlines|0","9Q":"Caicos Express Airways|0",G3:"VRG Linhas Aereas S.A.|0",DE:"Condor|0",XK:"Air Corsica|0",JA:"JetSmart|0",IB:"Iberia|1",AV:"Avianca|0",A9:"Georgian Airways|1",EQ:"TAME|0","2B":"Ak Bars Aero|0",BY:"Thomson Airways|1",SH:"Sharp Aviation Pty.|0","3K":"Jetstar Asia|0",TA:"TACA Airlines|0","5C":"Nature Air|0",WK:"Edelweiss Air|0","2A":"Deutsche Bahn AG|0",EB:"Wamos Air|0",DY:"Norwegian|0",AQ:"9 Air|0","9H":"Dutch Antilles Express|0","0A":"Amber Air|0",GA:"Garuda Indonesia|1",HJ:"Tasman Cargo Airlines PTY|0",P4:"Air Peace|0",W5:"Mahan Air|0",A6:"Air Alps|0",MM:"Peach Aviation|0",Q5:"40-Mile Air|0",JG:"Jetgo Australia Holdings Pty|0","1K":"Sutra|0",RG:"Rotana Jet Aviation|0",MN:"Kulula.com|0",C5:"Champlain Enterprises|0",HY:"Uzbekistan Airways|1",LE:"Norwegian Air Sweden AB|0",OQ:"Chongqing Airlines|0",MK:"Air Mauritius|1",VR:"TACV Cape Verde Airlines|0",LP:"LAN Peru|0","8O":"West Coast Air|0",HW:"North-Wright Airways|0",YO:"Heli Air Monaco|0",ZV:"V Air|0",VS:"Virgin Atlantic Airways|1","2F":"Frontier Flying Service|0",DB:"Brit Air|0","2Q":"AviTrans|0",EA:"Eastern Air Lines|0",KFG:"Kullaflyg|0",Z8:"Compania de Servicios de Transporte|0",ZA:"Sky Angkor Airlines|0",BQ:"Aeromar Airlines|0",ZK:"Great Lakes Aviation|0",J2:"Azerbaijan Airlines|1",Y1:"Travel Technology Interactive SA|0",R3:"Yakutia Airlines|0",IZ:"Arkia Israeli Airlines|1",T4:"Trip Linhas Aereas|0",UL:"SriLankan Airlines|1",UG:"Tunisair Express|0",LI:"LIAT|0",JK:"Spanair|1",MS:"EgyptAir|1",PV:"Privatair SA|0",DP:"Pobeda|0",QJ:"Jet Airways|0","9M":"Central Mountain Air|0",OT:"Aeropelican|0","5P":"SkyEurope Airlines Hungary|0",ZL:"Regional Express|0",Y3:"Driessen Services|0",T9:"Trans Meridian Airlines|0",ID:"Batik Air|0",ZJ:"Zambezi Airlines|0",H9:"Himalaya Airlines Pvt.|0",UM:"Air Zimbabwe|0","9G":"9G Rail Limited|0",JI:"Meraj Air|0","5J":"CEBU Pacific Air|0",S3:"SBA Airlines|0",NK:"Spirit Airlines|0",G4:"Allegiant Air|0",QZ:"Indonesia AirAsia|0","8L":"Lucky Air|0",QO:"Quikjet Cargo Airlines Pvt.|0",M9:"Motor Sich Airlines|0","2I":"Star Peru|0",S2:"JetLite|0",TB:"Jetairfly|0",J6:"Larry's Flying Service|0",X5:"Ten Airways|0","2M":"Moldavian Airlines|0",QG:"Citilink|0",YE:"YanAir|0",JZ:"Skyways AB|0",YF:"Department of National Defence|0",YM:"Montenegro Airlines|1","1I":"NetJets|0",G8:"Go Air|0",IH:"Irtysh-Air|0",FT:"FlyEgypt|0",BA:"British Airways|1",OC:"Omni|0",FB:"Bulgaria Air|1",WU:"Wizz Air Ukraine|0",EH:"ANA Wings|0",CE:"Chalair Aviation|0",CP:"Compass Airlines|0",SF:"Tassili Airlines|0","8V":"Astral Aviation|0",MY:"Maya Island Air|0",TG:"Thai Airways|1",GO:"ULS Airlines Cargo|0",LN:"Libyan Airlines|0",DT:"TAAG Angola Airlines|0",ИГ:"Komiaviatrans|1",GB:"ABX Air|0",HN:"Afghan Jet International|0",KN:"China United Airlines|0",CY:"Cyprus Airways|1",SM:"Air Cairo|0",CD:"Dutch Corendon Airlines|0",T0:"Trans American Airlines S.A. TACA PERU|0",IA:"Iraqi Airways|0",HB:"Asia Atlantic Airlines|0",Q6:"Skytrans|0",EIW:"Aer Lingus|0","4B":"Boutique Air|0",WW:"WOW air|0","1N":"Navitaire|0",E6:"Bringer Air Cargo Taxi Aereo|0",N3:"Aerolineas Mas|0",CB:"Caribbean Air Export Import|0",AT:"Royal Air Maroc|1",LF:"FlyNordic|0",P7:"Small Planet Airlines Polska|0",LU:"Lan Express|0","3F":"FLYONE Armenia|0",S6:"Sunrise Airways|0",N7:"Nordic Regional Airlines|0",L5:"Lufttransport|0",VY:"Vueling|1",SD:"Sudan Airways|0",D5:"DHL Aero Expreso S.A.|0",XB:"International Air Transport Association.|0","1D":"Radixx Solutions International|0","5W":"Wizz Air Abu Dhabi|0","5L":"Aerosur|0",NY:"Air Iceland|0",GL:"Air Greenland|0",CZ:"China Southern Airlines|1",PL:"Southern Air Charter Limited|0",D6:"Interair South Africa|0",VX:"Virgin America|0",YJ:"Asian Wings Airways|0",RI:"PT. Mandella Airlines|0","9C":"Spring Airlines|0",NTJ:"Nextjet|0",EE:"Regional Jet|0",EZ:"Sun-Air|0","7K":"Kolavia|0",YH:"Sunsplash Aviation .|0","9T":"ACT Airlines|0",TI:"Tailwind Airlines|0",RR:"Royal Air Force|0",HM:"Air Seychelles|0",MU:"China Eastern Airlines|1",AE:"Mandarin Airlines|0",NH:"All Nippon Airways|1",IV:"Caspian Airlines|0",AEU:"Iceland Express|0",Z9:"Bek Air|0",A2:"Astra Airlines|0","8Z":"Wizz Air Bulgaria|0",VH:"Aeropostal Alas de Venezuela C.A.|0",FHE:"Iceland Express|0",NB:"Skypower Express Airways|0",EP:"Iran Aseman Airlines|0",ZQ:"Caribbean Sun Airlines|0",AW:"Venezolana|0","8H":"BH Air|0",WI:"White|0",D2:"Severstal|0",B0:"La Compagnie|0","7L":"Silk Way West Airlines|0","9K":"Cape Air|0","1B":"Abacus International Pte.|0",CG:"Airlines of PNG|0",QU:"UTair Ukraine|0",DI:"Norwegian Air UK|0","6S":"Kato Airline|0",LY:"El Al|1",EK:"Emirates|1",ЭК:"KrasAvia|0","8K":"K-Mile Air|0",YIN:"Yining Arpt|0",V7:"Volotea|0",WR:"WestJet Encore|0",IQ:"Qazaq Air|0",M8:"Trans Maldivian Airways|0",HL:"Hotels/Motels|0",TO:"Transavia France|0",EU:"Chengdu Airlines|0",GP:"APG Airlines|0",EC:"Open Skies|0",U3:"Avies|0",FS:"Syphax Airlines|0",E4:"Enter Air|0",PT:"West Air Sweden|0",SL:"Thai Lion Air|0",BS:"British Intl|0",DEW:"Condor|0","4N":"Air North|0",H7:"Taron Avia|0",KD:"KalStar Aviation|0","8J":"Linea Aerea Eco Jet S.A.|0",FX:"FedEx|0","9F":"Eurostar International Limited|0","2U":"Sun d'Or International Airlines|0",MF:"Xiamen Airlines|0",OL:"OLT Ostfriesische Luftransport|0",QT:"Avianca Cargo|0","5O":"Europe Airpost|0",V6:"Clairmont Holdings|0",PW:"Precision Air|0",DJ:"Virgin Blue|1",PQ:"SkyUp Airlines|1",EXT:"Kalmarflyg|0",F5:"Aerotranscargo|0",UU:"Air Austral|0",VK:"Air Vallee S.p.A.|0","7I":"Insel Air|0",FW:"Ibex Airlines|0","4X":"Romavia|0",N5:"Skagway Air Service|0",OI:"Hinterland Aviation Pty|0",Y9:"Kish Airlines|0","8I":"MyAir|0","9W":"Jet Airways|0",IL:"Trigana Air Service|0","1T":"Bulgarian Air Charter|0",M3:"North Flying|0",U7:"Air Uganda|0",A5:"HOP!|0",EN:"Air Dolomiti|0",B2:"Belavia|1","7Z":"Ameristar Jet Charter|0",VC:"Charter Air Transport.|0",PE:"People's Viennaline|0",I3:"ATA Airlines|0",QW:"Qingdao Airlines|0",BU:"Compagnie Africaine d'Aviation|0",OX:"Orient Thai Airlines|0",ZB:"Monarch Airlines|0",KM:"Air Malta|1",UE:"Ultimate Jetcharters|0",RL:"Royal Flight|0",Y0:"Yellow Air Taxi|0",ZP:"Paranair|1",ZG:"Grozny Avia|0",BL:"Pacific Airlines|0",SE:"XL Airways France|0",R4:"RUS Aviation|0",L3:"DHL de Guatemala S.A.|0",OD:"Malindo Air|0",OZ:"Asiana Airlines|1","5Y":"Skybus|0",ET:"Ethiopian Airlines|0",GFG:"Gotlandsflyg|0",OE:"Laudamotion|0","4I":"IHY Izmir Havayollari A.S.|0",JF:"Jet Asia Airways|0",HZ:"Aurora|0","1R":"Bird Information Systems Private Li|0",SZ:"Somon Air|0",AF:"Air France|1",QY:"EAT Leipzig|0",T2:"Nakina Air Service|0",KS:"Penair|0","3Y":"Baseops International|0","8R":"Sol Lineas Aereas|0",FM:"Shanghai Airlines|1","1Z":"Sabre Pacific|0",G6:"Angkor Airways Corporation|0",QV:"Lao Airlines|0","6Q":"Slovak Airlines|0","4F":"Air City|0",M7:"Aerotransportes Mas de Carga|0",VIL:"Vildanden|0","9D":"Toumai Air Tchad|0",CM:"Copa Airlines|0",EW:"Eurowings|0",U8:"Armavia|1",K9:"KrasAvia|1",L7:"Linea Aerea Carguera de Colombia S.A.|0",TP:"TAP Portugal|1",ZX:"Air Georgian|0",XV:"MR Lines|0",TS:"Air Transat|0",JV:"Bearskin Airlines|0",TF:"Malmo Aviation|0",B4:"ZanAir Limited|0",MV:"Maldivian Air Taxi|0","9A":"Eaglexpress Air Charter Sdn.Bhd.|0",QE:"Crossair Europe|0",QS:"Smart Wings|1",QM:"Air Malawi Limited|0",FV:"Rossiya|1",K8:"Kannithi Aviation Company Limited d|0",BW:"Caribbean Airlines|0","8M":"Myanmar Airways International|0",CJ:"BA CityFlyer|0",DN:"Norwegian Air Argentina|0","5R":"Rutas Aereas C.A.|0","2D":"Dynamic Airways|0",HS:"Direktflyg|0","5I":"Alsa Grupo SLU|0",GX:"Guangxi Beibu Gulf Airlines|0",O6:"Avianca Brasil|0",RS:"Air Seoul|0",TU:"Tunisair|0",Q4:"Qatar Airways Amiri Flight|0","6Z":"Euro-Asia Air|0",ER:"Astar Air Cargo|0",FC:"Fast Colombia S.A.S|0",BF:"French Bee|0","6T":"Air Mandalay|0","3U":"Sichuan Airlines|0","7G":"Starflyer|0",XI:"Aeronautical Telecommunications|0","3M":"Silver Airways|0",GR:"Aurigny Air Services|0",ZY:"Ada Air|0",TY:"Air Caledonie|0","9X":"Executive Express Aviation|0",H5:"I-Fly|0",FA:"Safair|0",M2:"Sunrise Airlines|0",SS:"Corsair|0",WX:"Cityjet|0",C8:"Cronos Airlines|0",IX:"Air India Express|0",E7:"Estafeta Carga Aerea|0",CT:"Alitalia CityLiner|0",UX:"Air Europa|1","9V":"Avior Airlines|0",J5:"Alaska Seaplane Service L.L.C.|0",O8:"Siam Air Transport|0",AM:"Aeromexico|1",FI:"Icelandair|1",U6:"Ural Airlines|1",Z5:"GMG Airlines|0",PH:"PHOENIX AIR GROUP|0","3L":"InterSky|0",ED:"AirExplore|0",CI:"China Airlines|0",HG:"Niki|1",QH:"Air Kyrgyzstan|0",GJ:"Zhejiang Loong Airlines|0",A4:"Azimut|0",WS:"WestJet|1",RA:"Royal Nepal Airlines|0",U5:"United Nigeria Airlines|0",UF:"Ukrainian Mediterranean Airlines|0",PI:"Polar Airlines OJSC|0",OS:"Austrian Airlines|1","6A":"Armenia Airways|0",N2:"Trans-Mediterranean Airways|0",F9:"Frontier Airlines|0",MI:"SilkAir|1","4L":"Georgian Int. Airlines|0",EG:"Ernest Airlines|1","3W":"Malawian Airlines|0","2Y":"PT. My Indo Airlines|0",DG:"Cebgo|0",SA:"South African Airways|1",OV:"Salam Air|1",H3:"Hermes Airlines|0",HI:"Papillon Airways|0",IS:"AIS Airlines|0",HT:"Ningxia Cargo Airlines|0",ZW:"Air Wisconsin Airlines Corporation|0",S4:"SATA International|1",AJT:"AnadoluJet|0",CV:"Cargolux|0",M4:"Smart Aviation|0","7R":"Rusline|0",CU:"Cubana|0",AJA:"AnadoluJet|0",NU:"Japan Transocean Air|0",SO:"Apex Airline Public Company Limited|0",UT:"Utair|1",TD:"Atlantis European Airways|0",GI:"Itek Air|0",K3:"Venture Travel|0",DF:"Condor Berlin|0",LM:"Loganair|0",U4:"Buddha Air|0",DZ:"Donghai Airlines|0",ZC:"Korongo Airlines|0",KC:"Air Astana|1",Q2:"Maldivian|0","7N":"Pan American World Airways|0","7V":"Pelican Air|0",VE:"Volare Spa|0",NZ:"Air New Zealand|1",TH:"Raya Airways|0",I4:"Scott Air|0",V3:"Carpatair|0","3Z":"Travel Service Polska Sp. z.o.o.|0",XP:"TEM Enterprises|0","5U":"Transportes Aereos Guatemaltecos S.|0","4H":"HiSky|0",AS:"Alaska Airlines|0",V5:"Danube Wings|0","4Z":"Airlink|0",YL:"Libyan Wings|0","4K":"Kenn Borek Air|0","1G":"Travelport Global Distribution System|0",JW:"Vanilla Air|0",XO:"South East Asian Airlines (SEAIR)|0",SK:"SAS|1",A0:"L Avion Elysair|0","3O":"Air Arabia Maroc|0","4S":"Solar Cargo C.A.|0",VO:"Voyage Air|1",JM:"Jambojet|0",W4:"LC Peru|0",Z7:"NU-Aero (Pvt)|0",V8:"Atran|0",F2:"Safarilink Aviation Limited|0",NR:"Al-Naser Airlines|0",RB:"Syrian Air|0",Z3:"Avient Aviation|0",XX:"Aerodynamics|0","1U":"ITA Software|0",J1:"One Jet|0",M5:"Kenmore Air|0",JOR:"Blue Air|0",W7:"Wings of Lebanon S.a.l|0",OU:"Croatia Airlines|1",LS:"Jet2|0",XH:"Special Ground Handling Service -XH|0",CH:"Bemidji Aviation Services|0","4P":"Viking Airlines|0","6P":"Clubair Sixgo|0",ZT:"Titan Airways|0",V0:"Conviasa|0",WE:"Thai Smile|0",B6:"JetBlue Airways|0",I2:"Iberia Express|0",V4:"Vieques Air Link Inc|0","1M":"JSC Transport Automated Information|0",MO:"Calm Air|0",SI:"Blue Islands|0",ZN:"Naysa|0",US:"US Airways|1",FF:"Airshop B.V.|0",E0:"Eos Airlines|0",ЛП:"Pskovavia|1","6V":"MRK Airlines|0",IN:"PT. Nam Air|0",XA:"ARINC|0",GT:"GB Airways|0",S8:"Skywise Airlines|0",F3:"FAI rent-a-jet Aktiengesellschaft|0",OH:"Comair|0",K4:"Kalitta Air|0",JN:"Excel Airways|0","8F":"STP Airways|0",MC:"Air Mobility Command|0",DV:"SCAT|0",YD:"Mauritania Airways|0",MG:"Midex Airlines|0",NC:"Northern Air Cargo|0",D3:"Daallo Airlines|0",B9:"Iran Air Tours|0",K7:"Air KBZ|0",ЮГ:"Pioneer|1",AB:"Air Berlin|1",Q7:"Swift Air|0",OP:"Air Pegasus Pvt.|0",W2:"Flex Flight|0",MQ:"American Eagle|1",XM:"Alitalia Express|1",S1:"Lufthansa Systems AG|0",GV:"Sky Gabon S.A.|0",LA:"LATAM Airlines|1",NO:"Neos|0",EUP:"OnAir|0",BZ:"Bluebird Airways|0",T6:"AirSWIFT|0","2K":"Avianca Ecuador|0",PF:"Primera Air|0","6U":"Unique Air|0",SV:"Saudi Arabian Airlines|0",HA:"Hawaiian Airlines|0",AA:"American Airlines|1","7P":"Air Panama|0","4Y":"Flight Alaska|0",R8:"Kyrgyzstan Airlines|0",IK:"Ikar|0",J8:"Berjaya Air|0",VW:"Aeromar|0",FOG:"FlyOeger|0",IR:"Iran Air|0",KH:"Aloha Air Cargo|0","9L":"Colgan Air|0",HH:"Taban Air|0",CL:"Lufthansa CityLine|0","8N":"Aerodynamics|0",SC:"Shandong Airlines|0","3G":"Gading Sari Aviation Sdn Bhd.|0",CK:"China Cargo Airlines|0","4O":"Interjet|0",GS:"Tianjin Airlines|0",E8:"City Airways Company Limited|0","8A":"Atlas Blue|0",JH:"Fuji Dream Airlines|0",F1:"Farelogix|0",BK:"Okay Airways|0",NG:"Aero Contractors|0","6E":"IndiGo Airlines|0","7Y":"Mann Yadanarpon Airlines|0",UJ:"Almasria Universal Airlines|0",C1:"Tectimes Sudamericana S.A.|0",FY:"Firefly|0",R1:"Zapways|0","9R":"Satena|0",LW:"Pacific Wings L.L.C.|0",WH:"Webjet|0",SFG:"SundsvallsFlyg|0",H4:"HiSky|0","7B":"Bees Airline|0",AR:"Aerolineas Argentinas|0",VIK:"Viking Airlines|0",D7:"AirAsia X|1","6F":"Falcon Air Express|0","2L":"Helvetic Airways|0",EX:"Thai Express Air|0",KX:"Cayman Airways|0",PS:"Ukraine Int. Airlines|1",FR:"Ryanair|1",Y8:"Yangtze River Express|0",KY:"Kunming Airlines|0",EM:"Empire Airlines|0",AO:"Air One Aviation Pvt|0",SG:"SpiceJet|0",J3:"Northwestern Air|0","5H":"Fly540|0","4W":"Allied Air|0",TCW:"Thomas Cook|0",H8:"Dalavia Far East Airways|0",NL:"Shaheen Air International|0",A3:"Aegean Airlines|1","5F":"Fly One|0","5A":"Alpine Air Express|0","3A":"Kenosha Aero|0",C4:"Conquest Air|0",ND:"FMI Air|0","4G":"Gazpromavia|0",KF:"Blue1|1",F4:"Air Charter|0","3R":"Moskovia Airlines|0",JP:"Adria Airways|1",LYD:"Lydd Air|0",K2:"EuroLot S.A.|0",GC:"Global Feeder Services|0",MH:"Malaysia Airlines|1","8C":"Air Transport International|0",HU:"Hainan Airlines|1",ISK:"Istanbul|0",LL:"Miami Air International|0",UI:"Auric Air Services Limited|0",HR:"Hahn Air Lines|0",BV:"Blue Panorama Airlines|0","3E":"Multi-Aero|0","4C":"LAN Colombia|0",VV:"Aerosvit Airlines|1",AL:"Air Leisure|0","6Y":"SmartLynx Airlines Estonia|0",JR:"Joy Air|0",XJ:"Thai AirAsia X|0",BB:"Seaborne Airlines|0",LJ:"Jin Air|0",JO:"Jet Time OY|0",ON:"Our Airline|0",IM:"Mint Airways|0",TJ:"Tradewind Aviation|0",Q3:"Anguilla Air Services|0",RO:"Tarom|0","5Q":"LOS CIPRESES S.A.|0",YG:"South Airlines|0",XU:"African Express Airways|0","3D":"Denim Air|0",CW:"Air Marshall Islands|0","7O":"Travel Service Hungary|0",L2:"Lynden Air Cargo|0",RY:"Royal Wings|0","4T":"Belair Airlines|0",WT:"Wasaya Airways|0",GW:"Skygreece Airlines|0",JS:"Air Koryo|0","9I":"Airline Allied Services Limited|0",IF:"Islas Airways|0",A7:"Air Comet|0",QQ:"Alliance Airlines|0",EL:"Ellinair|0",OO:"SkyWest Airlines|0",WB:"RwandAir|0",TOM:"Thomson fly|0",AJ:"Aztec Worldwide Airlines|0",LK:"Kyrgyz Airlines|0",OG:"Air Onix|0",IE:"Solomon Airlines|0",N8:"National Air Cargo Group|0",MB:"MNG Airlines|0","3N":"Air Urga|0",BD:"Cambodia Bayon Airlines Limited|1","7D":"Donbassaero Airlines|0",LZ:"SWISS GLOBAL AIR LINES|0",UA:"United Airlines|1",CN:"Grand China Air|0",NV:"Naft Airlines|0","6N":"Al-Naser Airlines|0",X8:"Airmax S.A.|0","8D":"FitsAir|0",WF:"Wideroe|0",LT:"JSC Air Lituanica|0",RM:"Armenia Aircompany|1",BG:"Biman Bangladesh Airlines|0",ES:"DHL International|0",DK:"Thomas Cook Airlines Scandinavia|0",WM:"Winair|0",MD:"Air Madagascar|0","9E":"Endeavor Air|0",GY:"Gabon Airlines|0","7S":"Arctic Transportation Services|0",YB:"Borajet|0",II:"IBC Airways|0",RH:"Robin Hood Aviation|0",R6:"DOT - Danu oro transportas|0",VZ:"Thai Vietjet|0",N6:"Nomad Aviation (PTY)|0",XZ:"South African Express|0","7Q":"Elite Airways|0",PY:"Surinam Airways|0",ZD:"EWA Air|0",C9:"Cirrus Airlines|0",KP:"PT. Asialink Cargo Express|0",TM:"LAM Mozambique Airlines|0",HX:"Hong Kong Airlines|1",KI:"KrasAvia|0",XY:"Flynas|0",Z2:"Philippines AirAsia|1",I6:"Air Indus|0",UR:"Utair - Express Limited Company|1",AK:"AirAsia|0",UO:"Hong Kong Express|1",PP:"Jet Aviation Business Jets AG|0","2W":"Welcome Air|0",EO:"Pegas Fly|1",CC:"Air Atlanta Icelandic|0",UB:"Myanmar National Airlines|0",EY:"Etihad Airways|1",HP:"Amapola Flyg AB|0",K1:"Topas|0",FE:"Far Eastern Air Transport|0","7W":"WINDROSE airlines|0",HQ:"Thomas Cook Airlines Belgium|0",TW:"T'way Air|0",G9:"Air Arabia|0",DU:"Hemus Air|0","7T":"Aero Express del Ecuador - Trans AM|0",CX:"Cathay Pacific|1",JU:"AirSERBIA|1",TQ:"Tandem Aero|0",PG:"Bangkok Airways|1",S0:"Slok Air Intl|0",NQ:"Air Japan Company|0","9B":"AccesRail and Partner Railways|0",NP:"Nile Air|0","1P":"Worldspan|0","6K":"Sky King|0",B8:"Eritrean Airlines|0",УТ:"Турухан|0",EI:"Aer Lingus|0",XL:"LAN Ecuador|0",WP:"Island Air (USA)|0",PJ:"Air Saint-Pierre|0",NT:"Binter Canarias|0",IT:"Tigerair Taiwan|0","3V":"TNT Airways|0",ЮВ:"UVT aero|1",U2:"EasyJet|0",LV:"Mega Maldives|0",T8:"Telair International|0",GQ:"Sky Express (Greece)|0",IY:"Yemenia|0",FD:"Thai AirAsia|0","4A":"Royal Bengal Airlines|0",L6:"Mauritania Airlines International|0",P1:"Aviation Technologies|0",IC:"Indian Airlines|0","7A":"Air Jet|0",CF:"China Postal Airlines|0","6R":"Alrosa|0",DX:"Danish Air Transport|0",MR:"Hunnu Air|0",KW:"Kharkiv Airlines|0","0V":"Vietnam Air Services Company|0","3H":"Air Inuit|0",H6:"Bulgarian Air Charter|0","7C":"Jeju Air|0",SQ:"Singapore Airlines|1",YI:"Yunnan Yingan Airline|0","5S":"Servicios Aereos Profesionales S.A.|0",JQ:"Jetstar Airways|0",SB:"Aircalin|0",BGT:"Bergen Air|0",KR:"Cambodia Airways|0",EV:"ExpressJet|0",IP:"Apsara International Air|0",AP:"Air One|0",O4:"Antrak Air|0","1A":"Amadeus IT Group SA|0",PU:"Plus Ultra Líneas Aéreas|0","5V":"Everts Air Alaska|0",X4:"Vanair Limited|0",TV:"Tibet Airlines|0",QC:"Camair-Co|0",FN:"Fastjet|0","1H":"Sirena-Travel|0",ZH:"Shenzhen Airlines|0",L8:"Afric Aviation|0",WA:"KLM cityhopper|0","2X":"XEROX|0",PC:"Pegasus Airlines|0",VQ:"Novoair Limited|0",SX:"SkyWork Airlines|0",DD:"Nok Air|0","2V":"Amtrak|0",QL:"Laser Airlines|0",LQ:"Air Guinea Cargo|0",RC:"Atlantic Airways|0",M0:"Aero Mongolia|0",T5:"Turkmenistan Airlines|0",K6:"Cambodia Angkor Air|1","2G":"Angara Airlines|0",ZR:"Aviacon Zitotrans|0",BP:"Air Botswana|0",AX:"Trans States Airlines|0",JL:"Japan Airlines|1","6W":"FlyBosnia|0",CA:"Air China|1",VIV:"Vivaaerobus|0",UW:"Uni-Top Airlines|0",UH:"AtlasGlobal UA|0","6O":"Orbest|0",E5:"Air Arabia Egypt|0",I8:"Izhavia|1",HO:"Juneyao Airlines|0",X7:"Exec Air of Naples|0",TZ:"Scoot|0",XT:"Indonesia AirAsia X|0",T3:"Eastern Airways|0",TT:"Tigerair Australia|0",S7:"S7 Airlines|1",RE:"Stobart Air|0",DL:"Delta Air Lines|1",VM:"Viaggio Air|0","4R":"Royal Flight|0",KJ:"Air Incheon Co|0",CO:"Cobalt Air|1",P6:"Pascan Aviation|0",ZE:"Eastar Jet|0",BJ:"Nouvelair Tunisie|0",DR:"Ruili Airlines|0",ME:"Middle East Airlines|0",YT:"Yeti Airlines|0",TE:"Skytaxi|0",OB:"Boliviana de Aviacion|0",B3:"Bhutan Airlines|0","4M":"LAN Argentina|0","1S":"Sabre|0",RU:"AirBridgeCargo Airlines|0",RP:"Chautauqua Airlines|0",IU:"SW Italia s.p.a.|0",FU:"Fuzhou Airlines|0",JAF:"TUI Airlines|0",H2:"Sky Airline|0",MX:"Mexicana|0",UZ:"Buraq Air|0",J7:"Centre-Avia Airlines|0",QF:"Qantas|1",YR:"Grand Canyon Airlines|0","5Z":"CemAir|0",TN:"Air Tahiti Nui|0","3C":"Corporate Express Airlines|0",LX:"Swiss|1",WOW:"Air Southwest|0","6L":"Aklak|0",WG:"Sunwing Airlines|0","1E":"Travelsky Technology Limited|0",WY:"Oman Air|0",XD:"Universal Air Travel Plan (UATP)|0",H1:"Hahn Air Systems|0",AZ:"ITA Airways|1",KL:"KLM|1","1J":"Axess International Network|0",RQ:"Kam-Air|0",KV:"Asian Express Airline|0",GSM:"flyglobespan|0",BT:"Air Baltic|1",S9:"Starbow Airlines|0",PZ:"TAM - Transportes Aereos del|0",KQ:"Kenya Airways|0","6B":"TUIfly Nordic|0",O9:"Nova Airways|0",KU:"Kuwait Airways|0",KE:"Korean Air|1",DH:"Norwegian Air Norway AS|0",QP:"Starlight Airline|0",V2:"Avialeasing Aviation Company|0","0B":"Blue Air|0",C7:"Saffron Aviation (Pvt)|0","8W":"Private Wings|0",RF:"Florida West International Airways|0",AU:"Austral|0","1X":"Fly Branson Travel|0","2C":"SNCF|0",VG:"VLM Airlines N.V|0","6M":"EuroAir|0","2J":"Air Burkina|0",YN:"Air Creebec|0",YS:"Regional|0","8S":"Shun Tak-China Travel Ship Mgmt.|0",RJ:"Royal Jordanian|1",GF:"Gulf Air|0","4J":"Flydamas Airlines|0",XQ:"SunExpress|0",NM:"Mount Cook Airline|0",V9:"Van Air Europe a.s.|0",O3:"SF Airlines|0",Q1:"PT. Sqiva Sistem|0",NJ:"Nordic Global Airlines|0",W6:"Wizz Air|0",YK:"Avia Traffic|0","8P":"Pacific Coastal Airlines|0",PX:"Air Niugini|0",KA:"Hong Kong Dragon Airlines|0",W3:"Arik Air|0",C2:"Ceiba Intercontinental|0",ZM:"Pegasus Asia|0",GU:"Aviateca|0",TC:"Air Tanzania|0",UK:"Vistara|0",XR:"Virgin Australia Regional|0","9U":"Air Moldova|0",P9:"Peruvian Airlines|0",KT:"Katmai Air|0",HK:"Hamburg Airways|0",EJ:"European Cargo Services BV|0",KK:"AtlasGlobal|1",SW:"Air Namibia|0",R5:"Jordan Aviation|0",MW:"Mokulele Flight Service|0",RX:"Regent Airways|0",LD:"Air Hong Kong|0",WJ:"Jetsmart Airlines|0",PK:"Pakistan Int. Airlines|0",B5:"East African Safari Air Express|0",VI:"Volga-Dnepr Airlines|0",RT:"ЮВТ Аэро|0",KNE:"Nas Air|0",HD:"Air Do|0","8Q":"Onur Air|0",WV:"Aero Vip|0",IG:"Air Italy|1",CQ:"Charterlines|0","3B":"Central Connect Airlines|0",NN:"VIM Airlines|1",S5:"Small Planet Airlines|0",AI:"Air India|1",CS:"Continental Micronesia|0",V1:"IBS Software Services Americas|0",IO:"IrAero|0",W1:"WDL Aviation|0",Z4:"ZagrosJet|0","8E":"Bering Air|0","9S":"Southern Air|0","2Z":"Passaredo Linhas Aereas|0","2P":"Air Philippines Corporation|0",J4:"BADR AIRLINES|0",IW:"Wings Air|0",G7:"KAPO Avia|0",QR:"Qatar Airways|1",VU:"Vuelos Economicos Centroamericanos|0",MJ:"Myway Airlines|0",G5:"China Express Airlines|0","9J":"Dana Air|0",PM:"CanaryFly|0",ZU:"Helios Airways|0",FP:"TAG Aviation|0",F6:"Faroe Jet|0",K5:"SeaPort Airlines|0","8B":"Business Air|0",UFG:"Umeaflyg|0",B1:"Bravo Passenger Solution Pte.|0",FH:"Freebird Airlines|0",YP:"Perimeter Aviation|0",D8:"Norwegian Air International|0",F8:"Flair Airlines|0","9N":"Tropic Air Limited|0",VJ:"VietJetAir|0",FK:"Keewatin Air|0",BX:"Air Busan|0",R9:"Camai Air|0",SJ:"Sriwijaya Air|0",UY:"Air Caucasus|0","3T":"Tarco Airlines|0",AH:"Air Algerie|0",LO:"LOT|1",SP:"SATA Air Acores|0",FQ:"Fenix Airways of Florida Inc|0",PR:"Philippine Airlines|0",Y5:"Golden Myanmar Airlines|0",WC:"Islena Airlines|0","0Y":"FlyYeti|0",D0:"DHL Air|0","5K":"Hi Fly Transportes Aereos S.A.|0",VN:"Vietnam Airlines|0",VL:"Med-View Airline|0","6H":"Israir Airlines|0",QI:"Cimber Sterling|0",WD:"Dairo Air Services|0",КФ:"Тувинские авиационные линии|0",MZ:"Merpati|0",CAI:"Corendon|0","5T":"Canadian North|0",T7:"Twin Jet|0",U9:"Tatarstan Air|1","6C":"Air Timor S.A.|0",OM:"MIAT Mongolian Airlines|1",JT:"Lion Airlines|0",IJ:"Spring Airlines Japan|0","3S":"Air Antilles Express|0",N4:"Nordwind Airlines|1","5D":"Aeroméxico Connect|0",XG:"SunExpress Deutschland|0",FG:"Ariana Afghan Airlines|0",XS:"SITA - Airlines Worldwide|0",NX:"Air Macau|0","6D":"Travel Service Slovakia|0",BCI:"Blue Islands|0",UN:"Transaero Airlines|1",PB:"Provincial Airlines|0",DQ:"Air Direct Connect|0","2H":"Thalys International|0",QA:"Cimber|0",AVR:"Avro Flights|0",Q8:"Trans Air Congo|0",LG:"Luxair|0","9O":"National Airways Cameroon|0","5X":"UPS Airlines|0",MP:"Martinair Holland|1","8U":"Afriqiyah Airways|0","7U":"Aviaenergo|0",XE:"ExpressJet Airlines|0",Z6:"Dniproavia|1",R7:"Aserca Airlines|0",EF:"Eznis Airways|0",YQ:"TAR Aerolineas|0",P0:"Proflight Air Services|0",DW:"Aero-Charter Airlines|0","2E":"AVE.com|0",GM:"Chair Airlines|1",ZF:"Azur Air|0","5E":"Siam General Aviation|0",C0:"Centralwings|0",NI:"Portugalia|0","2O":"Island Air Service|0","5N":"Smartavia|0",P5:"Wingo|0",F7:"I fly|0",SU:"Aeroflot|1","1C":"Hewlett-Packard (Schweiz)|0","0J":"Jetclub|0","6G":"Sun Air Express|0",TX:"Air Caraibes|0",XW:"NokScoot Airlines Company Limited|1",UQ:"Urumqi Airlines|0",ZI:"Aigle Azur|0",Q0:"Quebecair Express|0","7F":"First Air|0",RZD:"РЖД|0","7J":"Tajik Air|0",KO:"Komiaviatrans|0",OW:"Executive Airlines|0",L4:"Wings of Lebanon|0",N9:"Novair|0","5G":"Skyservice Airlines|0",X3:"TUIfly|0",P2:"AirKenya Express|0",YW:"Air Nostrum|0",HF:"Air Cote d'Ivoire|0",JJ:"TAM Linhas Aereas|0",WO:"World Airways|0","3J":"Jubba Airways|0",KB:"Druk Air|0",FJ:"Fiji Airways|0",SY:"Sun Country Airlines|0",VB:"VivaAerobus|0",TL:"Airnorth|0",O2:"Jet Air|0",RE2:"Aer Arann|0",TR:"Scoot|0",AC:"Air Canada|0",YC:"Yamal Airlines|0","6J":"Solaseed Air|0",FZ:"FlyDubai|0",FLZ:"Flightlink|0"},
Alliances:{"OneWorld":{"AB":1,"AA":1,"BA":1,"CX":1,"AY":1,"IB":1,"JL":1,"LA":1,"MH":1,"QF":1,"QR":1,"RJ":1,"S7":1,"UL":1,"JJ":1},"StarAlliance":{"JP":1,"A3":1,"AC":1,"CA":1,"AI":1,"NZ":1,"NH":1,"OZ":1,"OS":1,"AV":1,"SN":1,"CM":1,"OU":1,"MS":1,"ET":1,"BR":1,"LO":1,"LH":1,"SK":1,"ZH":1,"SQ":1,"SA":1,"LX":1,"TP":1,"TG":1,"TK":1,"UA":1},"SkyTeam":{"SU":1,"AR":1,"AM":1,"UX":1,"AF":1,"AZ":1,"CI":1,"MU":1,"CZ":1,"OK":1,"DL":1,"GA":1,"KQ":1,"KL":1,"KE":1,"ME":1,"SV":1,"RO":1,"VN":1,"MF":1}}};
function isValidDate(d){
	return Object.prototype.toString.call(d) === "[object Date]" && !isNaN(d.getTime());
}

Date.parseISO8601 = function(s){
	var re = /(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d):(\d\d)(\.\d+)?(Z|([+-])(\d\d):(\d\d))?/;
	var d = s.match(re);
	if (!d) {
		console.trace()
		throw "Couldn't parse ISO 8601 date string '" + s + "'";
	}
	var a = [1, 2, 3, 4, 5, 6, 10, 11];
	for (var i in a) {
		d[a[i]] = parseInt(d[a[i]], 10);
	}
	d[7] = parseFloat(d[7]);
	var ms = null;
	if(d[8]){
		ms = Date.UTC(d[1], d[2] - 1, d[3], d[4], d[5], d[6]);
		if (d[8] != "Z" && d[10]) {
			var offset = d[10] * 60 * 60 * 1000;
			if (d[11]) {
				offset += d[11] * 60 * 1000;
			}
			if (d[9] == "-") {
				ms -= offset;
			} else {
				ms += offset;
			}
		}
	} else {
		ms = (new Date(d[1], d[2] - 1, d[3], d[4], d[5], d[6])).getTime();
	}
	if (d[7] > 0) {
		ms += Math.round(d[7] * 1000);
	}
	return ms;
};


Date.prototype.cutTime = function(){
	this.setHours(0, 0, 0, 0);
	return this;
};


Date.parseAPI = function(str){
	if (!str)return null;

	var strLength = String(str).length;
	var Day, Month, Year, newDate;

	if (strLength == 4) {
		var today = (new Date()).cutTime();
		var yesterday = (new Date(today.getTime())).setDate(today.getDate() - 1);

		Day = str.substring(0, 2);
		Month = str.substring(2, 4);
		Year = today.getFullYear();

		newDate = new Date(Year, Month - 1, Day);
		if (newDate < yesterday) {
			newDate = new Date(Year + 1, Month - 1, Day);
		}
	} else if (strLength == 8) {
		Day = str.substring(6);
		Month = str.substring(4, 6);
		Year = str.substring(0, 4);
		newDate = new Date(Year, Month - 1, Day);
	} else {
		return null;
	}

	if (newDate.getTime()) {
		return newDate;
	} else {
		return null;
	}

};


Date.prototype.setAPITime = function(str) {
	var strLength = String(str).length;
	if (strLength == 4) this.setHours(str.substring(0, 2), str.substring(2, 4));
	return this;
};


Date.prototype.stringifyAPI = function(){
	var date = this.getDate();
	if(date < 10) date = 0 + date.toString();
	var month = this.getMonth() + 1;
	if(month < 10) month = 0 + month.toString();
	return date.toString() + month.toString();
};

/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */
var dateFormat = function(){
	var token = /d{1,4}|Dd{1,3}|m{1,4}|Mm{1,3}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g, timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g, timezoneClip = /[^-+\dA-Z]/g, pad = function(val, len){
		val = String(val);
		len = len || 2;
		while (val.length < len)
			val = "0" + val;
		return val;
	};

	// Regexes and supporting functions are cached through closure
	return function(caseControl, date, mask, utc){
		var dF = dateFormat;

		// You can't provide utc if you skip other args (use the "UTC:" mask prefix)
		if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
			mask = date;
			date = undefined;
		}

		// Passing date through Date applies Date.parse, if necessary
		date = date ? new Date(date) : new Date;
		if (isNaN(date)) console.error("invalid date");

		mask = String(dF.masks[mask] || mask || dF.masks["default"]);

		// Allow setting the utc argument via the mask
		if (mask.slice(0, 4) == "UTC:") {
			mask = mask.slice(4);
			utc = true;
		}

		var _ = utc ? "getUTC" : "get",
			d = date[_ + "Date"](),
			D = date[_ + "Day"](),
			m = date[_ + "Month"](),
			y = date[_ + "FullYear"](),
			H = date[_ + "Hours"](),
			M = date[_ + "Minutes"](),
			s = date[_ + "Seconds"](),
			L = date[_ + "Milliseconds"](),
			o = utc ? 0 : date.getTimezoneOffset(),
			flags = {
				d: d,
				dd: pad(d),
				ddd: caseControl ? l10n.calendar.days_S[D].toLowerCase() : l10n.calendar.days_S[D],
				Ddd: l10n.calendar.days_S[D],
				dddd: caseControl ? l10n.calendar.days_N[D].toLowerCase() : l10n.calendar.days_N[D],
				Dddd: l10n.calendar.days_N[D],
				m: m + 1,
				mm: pad(m + 1),
				mmm: caseControl ? l10n.calendar.months_S[m].toLowerCase() : l10n.calendar.months_S[m],
				Mmm: l10n.calendar.months_S[m],
				mmmm: caseControl ? l10n.calendar.months_D[m].toLowerCase() : l10n.calendar.months_D[m],
				Mmmm: l10n.calendar.months_D[m],
				yy: String(y).slice(2),
				yyyy: y,
				h: H % 12 || 12,
				hh: pad(H % 12 || 12),
				H: H,
				HH: pad(H),
				M: M,
				MM: pad(M),
				s: s,
				ss: pad(s),
				l: pad(L, 3),
				L: pad(L > 99 ? Math.round(L / 10) : L),
				t: H < 12 ? "a" : "p",
				tt: H < 12 ? "am" : "pm",
				T: H < 12 ? "A" : "P",
				TT: H < 12 ? "AM" : "PM",
				Z: utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
				o: (o > 0 ? "−" : "+") + pad(Math.floor(Math.abs(o) / 60), 2) + ":" + pad(Math.abs(o) % 60, 2),
				S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
			};
		return mask.replace(token, function($0){
			return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
		});
	};
}();
// Some common format strings
dateFormat.masks = {
	"default":      "ddd mmm dd yyyy HH:MM:ss",
	shortDate:      "m/d/yy",
	mediumDate:     "mmm d, yyyy",
	longDate:       "mmmm d, yyyy",
	fullDate:       "dddd, mmmm d, yyyy",
	shortTime:      "h:MM TT",
	mediumTime:     "h:MM:ss TT",
	longTime:       "h:MM:ss TT Z",
	isoDate:        "yyyy-mm-dd",
	isoTime:        "HH:MM:ss",
	isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
	isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",
	normalDate: 'd mmmm, yyyy Z' //10 марта, 2016 GMT+0300
};
// Some common format strings form l10n
if (l10n.dateMasks) {
	for (var i in l10n.dateMasks) {
		dateFormat.masks[i] = l10n.dateMasks[i];
	}
}
Date.prototype.format = function (mask, utc) {
	return dateFormat(false, this, mask, utc);
};
Date.prototype.format1 = function (mask, utc) {
	return dateFormat(true, this, mask, utc);
};

function DurationAPIToMinutes(str){
	function pad(val, length){
		val = String(val);
		while (val.length < length)
			val = "0" + val;
		return val;
	}
	str = pad(str, 4);
	var h = parseInt(str.substring(0,2), 10);
	var m = parseInt(str.substring(2,4), 10);
	return (h * 60) + m;
}


function DurationAPIFromMinutes(minutes) {
	var h = Math.floor(minutes/60);
	var m = minutes%60;
		h = h<10?'0'+h:h;
		m = m<10?'0'+m:m;
	return h + ''+ m;
}


function DurationTimeStringFromMinutes(minutes,letterType){
	if(letterType) {
		return DurationTimeString(DurationAPIFromMinutes(minutes), true, true);
	} else return DurationTimeString(DurationAPIFromMinutes(minutes), true);
}
function DurationTimeString(DateAPIString,shortType,letterType){
	function pad(val, length){
		val = String(val);
		while (val.length < length)
			val = "0" + val;
		return val;
	}
	DateAPIString = pad(DateAPIString, 4).split('.')[0];
	if(!parseFloat(DateAPIString) > 0) {
		return "";
	}
	var h = DateAPIString.substring(0, DateAPIString.length - 2);
	var m = DateAPIString.substring(2,4);
	var hours,minutes,prelast,last;
	var str='';
	last = parseInt( String(h).substring(1), 10);
	if (last == 1) {
		hours = l10n.hours[0];
	} else if (0 < last && last < 5) {
		hours = l10n.hours[1];
	} else {
		hours = l10n.hours[2];
	}
	prelast = parseInt( String(h).substring(0,1), 10);
	if (prelast == 1 && String(h).length > 1) {
		hours = l10n.hours[2];
	}
	last = parseInt( String(m).substring(1), 10);
	if (last == 1) {
		minutes = l10n.minutes[0];
	} else if (0 < last && last < 5) {
		minutes = l10n.minutes[1];
	} else {
		minutes = l10n.minutes[2];
	}
	prelast = parseInt( String(m).substring(0,1), 10);
	if (prelast == 1 && String(m).length > 1) {
		minutes = l10n.minutes[2];
	}
	if (shortType) {
		hours = l10n.h;
		minutes = l10n.m;
	}
	if (letterType) {
		hours = l10n.h;
		minutes = l10n.m_letter;
	}
	h = parseInt(h, 10);
	m = parseInt(m, 10);
	if (h !== 0) {
		str += h + "&nbsp;" + hours;
	}
	if (m !== 0 && h !== 0) {
		str += "&nbsp;";
	}
	if (m !== 0) {
		str += m + "&nbsp;" + minutes;
	}
	return str;
}
function DurationTimeStringPartFull(DateAPIString, isGenetive){
	var h = DateAPIString.substring(0,2);
	var m = DateAPIString.substring(2,4);
	var hours,minutes,prelast,last;
	var str = '';
	last = parseInt( String(h).substring(1), 10);
	if (last == 1) {
		hours = l10n.hours[0];
	} else if (0 < last && last < 5) {
		hours = l10n.hours[1];
	} else {
		hours = l10n.hours[2];
	}
	prelast = parseInt( String(h).substring(0,1), 10);
	if (prelast == 1 && String(h).length > 1) {
		hours = l10n.hours[2];
	}
	last = parseInt( String(m).substring(1), 10);
	if (last == 1) {
		minutes = l10n.minutes[0];
		if(isGenetive) {minutes = l10n.minutes[3];}
	} else if (0 < last && last < 5) {
		minutes = l10n.minutes[1];
	} else {
		minutes = l10n.minutes[2];
	}
	prelast = parseInt( String(m).substring(0,1), 10);
	if (prelast == 1 && String(m).length > 1) {
		minutes = l10n.minutes[2];
	}
	h = parseInt(h, 10);
	m = parseInt(m, 10);
	if (m !== 0 && h !== 0) {
		hours = l10n.h;
		minutes = l10n.m;
	}
	if (h !== 0) {
		str += h;
		if(!m) str += "&thinsp;";
		str += hours;
	}
	if (m !== 0 && h !== 0) {
		str += "&nbsp;";
	}
	if (m !== 0) {
		str += m;
		if(!h) str += "&thinsp;";
		str += minutes;
	}
	return str;
}

function declOfNum(number, titles) {
	var cases = [2, 0, 1, 1, 1, 2];
	return titles[ (number%100>4 && number%100<20) ? 2 : cases[(number%10<5)?number%10:5] ];
}


window.tw = window.tw || {};
tw.today = (new Date()).cutTime();
tw.yesterday = new Date(tw.today.getTime());
tw.yesterday.setDate(tw.yesterday.getDate() - 1);

function SuggestField(options){
	var self = this;
	/* До создания шаблона */
	this.options = options || {};
	this.value = this.options.value || null;
	this.options.value = ref.getPointName(this.value);
	this.focus = false;
	this.link_setHintOffset = function(){
		self.setHintOffset();
	};

	/* Создание шаблона */
	this.setField();
	if (this.value) this.placeholder.value = ref.getPointVsCountryString(this.value);

	$(this.input)
		.focus(function(){
			self.focus = true;
			$(self.elField).addClass('focus');
			self.setHint();
			this.select();
		})
		.blur(function(){
			self.focus = false;
			$(self.elField).removeClass('focus');
			self.setHint();
		});

	$(this.input).on("input keyup paste", function(event){
		if (event.type == "input" || event.type == "keyup" && IEVersion) handler();
		function handler(){
			self.setPlaceholder();
			self.setHint();
		}
	});
	if(this.options.appendTo) $(this.elField).appendTo(this.options.appendTo);
}


SuggestField.prototype.setField = function(){
	this.elField = $.tmpl('SuggestField', this.options)[0];
	this.input = $("input:not([disabled])", this.elField)[0];
	this.input.field = this;
	this.placeholder = $("input[readonly]", this.elField)[0];
};


SuggestField.prototype.setPlaceholder = function(){
	if (this.placeholder) {
		if (!this.input.value || this.input.value == "\n") {/* При отмене ввода в FF7.0.1 value == "\n" */
			this.placeholder.value = this.placeholder.defaultValue;
		} else {
			this.placeholder.value = "";
		}
	}
};


SuggestField.prototype.setHint = function(){
	if (this.options.needHint) {
		if (this.focus && !this.input.value) {
			this.drawHint();
		} else {
			this.removeHint();
		}
	}
};
SuggestField.prototype.drawHint = function(){
	var self = this;
	if (!this.hint) {
		this.hint = $.tmpl(tmpl_Hint)[0];
		var content = document.createElement("div");
		content.innerHTML += l10n.hint.forExample;

		var getCityWithAirport = function(){
			getNearCity();
			if (tw.position.nearCityWithAirport) {
				self.removeHint();
				self.setHint();
			}
		};

		if (this.input.id == "to0") {
			content.innerHTML += l10n.hint.suggestValues[0];
			if(objSearchForm.data.directions[0].from){
				/*popular*/
				//content.innerHTML += l10n.hint.suggestValues[2];
			}
		} else if (tw.position && tw.position.nearCityWithAirport) {
			content.innerHTML += [
					'<span value="' + tw.position.nearCityWithAirport + '" class="dashed link code">',
						ref.getCityName(tw.position.nearCityWithAirport),
					'</span>'
			].join('');
		} else {
			content.innerHTML += l10n.hint.suggestValues[1];
			if (!tw.position) {
				$(document).one("getPosition", function(){
					getCityWithAirport();
					return;
				});
			} else if (tw.position && !tw.position.nearCityWithAirport) {
				//случай когда ответ раньше инициирования формы и событие не повесилось
				getCityWithAirport();
				return;
			}
		}


		$("span", content).on("mousedown", function(event){
			event.preventDefault();
			self.input.blur();
			if ($(this).hasClass("code")) {
				self.suggest.setByCode($(this).attr("value"));
			} else if ($(this).hasClass("google")) {
				self.placeholder.value = "";
				self.input.value = $(this).attr("value");
				self.suggest.makeSuggest();
			} else {
				/*popular*/
				if (isResults()) {
					$(document.body).one("resultsHide", function(){
						objMap.clearMap();
						ClearPolylineFlights();
						objMap.show();
					});
					hideResults();
				} else {
					objMap.show();
				}
				initPopularDirection(objSearchForm.data.directions[0].from);
			}
		});
		this.hint.appendChild(content);
		document.body.appendChild(this.hint);
		this.setHintOffset();
		$(window).on("resize", this.link_setHintOffset);
	}
};


SuggestField.prototype.setHintOffset = function(){
	var pos = $(this.elField).offset();
	$(this.hint).css({
		left: pos.left + this.elField.offsetWidth / 2 - this.hint.offsetWidth / 2,
		top: pos.top + this.elField.offsetHeight + 14
	});
};


SuggestField.prototype.removeHint = function(){
	$(window).off("resize", this.link_setHintOffset);
	$(this.hint).remove();
	this.hint = null;
};


SuggestField.prototype.setDisabled = function(){
	this.input.disabled = true;
	this.removeHint();
	$(this.elField).addClass("disabled");
};


SuggestField.prototype.setEnabled = function(){
	this.input.disabled = false;
	$(this.elField).removeClass("disabled");
};

$(document).ready(function(){
	$.template('SuggestField', $("#tmpl_SuggestField").trim());
});

ref.setRefs = function(){
	var self = this;

	for (var lang in tw.refData) {
		if (!tw.refData[lang].Synonyms) {
			tw.refData[lang].Synonyms = {
				LED: "Петербург|Питер|Sank-Piterburg|Saint Petersburg",
				DMB: "Аулие|Аулие Ата|Аулийе|Аулийе Ата|Джамбул|Джамбыл|Жамбул|Жамбыл|Тараза|Aulie|Aulie Ata|Auliye|Auliye Ata|Taraz|Taraza",
				DXB: "Дубай"
			};
		}
	}

	try{
		for(var i in tw.refData){
			self.Languages.push(i);
		}
	} catch(e){}

	this.LangLength = this.Languages.length;

	var tempRefCountries = {};
	for (var c in this.Countries) {tempRefCountries[c] = this.setRef(this.Countries[c],c,'Countries');}
	this.Countries = tempRefCountries;

	var tempRefCities = {};
	for (var ci in this.Cities) {tempRefCities[ci] = this.setRef(this.Cities[ci], ci, 'Cities');}
	this.Cities = tempRefCities;

	var tempRefAirports = {};
	for (var a in this.Airports) {
		tempRefAirports[a] = this.setRef(this.Airports[a], a, 'Airports');
		if (!tempRefAirports[a].Parent) tempRefAirports[a].Parent = a;
	}
	this.Airports = tempRefAirports;

	var tempRefAirlines = {};
	var tempRefLogos = {};
	for (var l in this.Airlines) {
		var curData = this.Airlines[l].split("|");
		tempRefAirlines[l] = curData[0];
		tempRefLogos[l] = curData[1];
	}
	this.Airlines = tempRefAirlines;
	this.AirlineLogos = tempRefLogos;
};
ref.setRef = function(s, c, type){
	var a = s.split("|");
	var l = 0;
	var r = {};

	if (type == "Countries") r.citizenship = Number(a[l++]);
		r.en = a[l++];
	if (r.en === "") r.en = c;
	if (type != "Countries" && a[l]) r.Parent = a[l++];
	if (a[l] && a[l + 1]) {
		r.lat = a[l++];
		r.lng = a[l++];
	}
	if (type == "Airports") {
		if (a[l]) r.Railway = a[l++];
		if (a[l]) r.Popularity = parseInt(a[l++], 10);
	} else {
		if (a[l]) r.Popularity = parseInt(a[l++], 10);
	}

	try {
		for (var i in tw.refData) {
			r[i] = tw.refData[i][type][c];
			if (r[i] === ""||!r[i]) r[i] = r.en;
			if (type == "Cities") {
				for (var syn in tw.refData[i].Synonyms) {
					if(!tw.refData[i].Synonyms[c] || r.Synonyms){
						continue;
					}
					r.Synonyms = tw.refData[i].Synonyms[c].split('|');
					r.Popularity += 100;
				}
			}
		}
	} catch (e) {}

	r.Name = r[tw.language]||r.en;

	return r;
};
ref.testPoint = function(c){
	return this.Cities[c] || this.Airports[c] ? true : false;
};
ref.getPoint = function(c){
	return this.Cities[c] ? this.Cities[c] : this.Airports[c] ? this.Airports[c] : c;
};
ref.getPointName = function(c){
	return this.Cities[c] ? this.Cities[c].Name : this.Airports[c] ? this.Airports[c].Name : c;
};
ref.getCountryCode = function(c){
	return this.Cities[c] ? this.Cities[c].Parent : this.Airports[c] ? this.Cities[this.Airports[c].Parent].Parent : null;
};
ref.getCity = function(c){
	return this.Cities[c] ? this.Cities[c] : this.Airports[c] ? this.Cities[this.Airports[c].Parent] : c;
};
ref.getCityCode = function(c){
	return this.Airports[c] ? this.Airports[c].Parent : c;
};
ref.getCityName = function(c){
	var cityName = c;

	var cityObj = this.Cities[c] || {};
	if (cityObj.Name) {
		cityName = cityObj.Name;
	} else {
		var airportObj = this.Airports[c] || {};
		if (airportObj.Parent) {
			cityObj = this.Cities[airportObj.Parent] || {};
			if (cityObj.Name) {
				cityName = cityObj.Name;
			}
		}
	}

	return cityName;
};
ref.getCityNameByCode = function(c){
	c = this.getCityCode(c);
	return this.getCityName(c) || this.getAirportName(c);
};
ref.getAirportName = function(c){
	return this.Airports[c] ? this.Airports[c].Name : c;
};
ref.getAirlineName = function(c){
	return this.Airlines[c] ? this.Airlines[c] : c;
};
ref.getAirportString = function(c){
	return this.Cities[c] ? this.Cities[c].Name : this.Airports[c] ? this.Airports[c].Name + ", " + this.Cities[this.Airports[c].Parent].Name : c;
};
ref.getPointVsCountryString = function(c){
	return this.Cities[c] ? this.Cities[c].Name + ", " + this.Countries[this.Cities[c].Parent].Name : this.Airports[c] ? this.Airports[c].Name + ", " + this.Cities[this.Airports[c].Parent].Name + ", " + this.Countries[this.Cities[this.Airports[c].Parent].Parent].Name : c;
};
ref.setRefs();

window.ref = window.ref || {};
ref.translit = {
	"Á": "A", "À": "A", "Â": "A", "Ä": "AE", "Ã": "A", "Ă": "A", "Å": "AA", "Ā": "A", "Ą": "A",
	//"Ǎ": "A", "Ǻ": "A", "Ǽ": "A",
	"Ć": "C", "Ĉ": "C", "Č": "C", "Ċ": "C", "Ç": "C",
	"Ð": "D", "Ď": "D",
	"É": "E", "È": "E", "Ê": "E", "Ë": "E", "Ĕ": "E", "Ė": "E", "Ē": "E", "Ę": "E", "Ě": "E",
	"Ĝ": "G", "Ğ": "G", "Ġ": "G", "Ģ": "G",
	"Ħ": "Н", "Ĥ": "H",
	"Í": "I", "Ì": "I", "Î": "I", "Ï": "I", "Ĩ": "I", "İ": "I", "Ī": "I", "Į": "I", "Ĭ": "I",
	//"Ǐ": "I",
	"Ĵ": "J",
	"Ķ": "K",
	"Ł": "L", "Ĺ": "L", "Ľ": "L", "Ļ": "L", "Ŀ": "L",
	"Ń": "N", "Ñ": "N", "Ň": "N", "Ņ": "N",
	"Ƞ": "N",
	"Ø": "OE", "Ó": "O", "Ò": "O", "Ô": "O", "Ö": "OE", "Õ": "O", "Ő": "O", "Ō": "O", "Ŏ": "O",
	//"Ơ": "O", "Ǒ": "O", "Ǿ": "OE",
	"Ŕ": "R", "Ř": "R", "Ŗ": "R",
	"Ś": "S", "Ŝ": "S", "Š": "S", "Ş": "S",
	"Ŧ": "T", "Ť": "T", "Ţ": "T",
	"Ú": "U", "Ù": "U", "Û": "U", "Ü": "UE", "Ũ": "U", "Ŭ": "U", "Ű": "U", "Ů": "U", "Ū": "U", "Ų": "U",
	//"Ư": "U", "Ǔ": "U", "Ǖ": "U", "Ǘ": "U", "Ǚ": "U", "Ǜ": "U",
	"Ŵ": "W",
	"Ý": "Y", "Ŷ": "Y", "Ÿ": "Y",
	"Ź": "Z", "Ž": "Z", "Ż": "Z",
	"Þ": "TH",
	"Æ": "AE",
	"Ĳ": "IJ",
	"Œ": "OE",
	"ß": "SS",
	//Cyrillic
	"А": "A", "Б": "B", "В": "V", "Г": "G", "Д": "D", "Е": "E", "Ё": "E", "Ж": "ZH", "З": "Z", "И": "I", "Й": "Y", "К": "K", "Л": "L", "М": "M", "Н": "N", "О": "O", "П": "P", "Р": "R", "С": "S", "Т": "T", "У": "U", "Ф": "F", "Х": "KH", "Ц": "TS", "Ч": "CH", "Ш": "SH", "Щ": "SHCH", "Ь": "", "Ы": "Y", "Ъ": "", "Э": "E", "Ю": "YU", "Я": "YA",
	"І": "I",
	"Ґ": "G",
	"Ў": "U",
	"Ѫ": "U",
	"ƒ": "G",
	"Ћ": "D",
	"Ѕ": "DZ",
	"Ј": "J",
	"Ќ": "K",
	"Љ": "LJ",
	"Њ": "NJ",
	"Һ": "C",
	"Џ": "DZ",
	"Є": "IE",
	"Ї": "I"
};

var reTestMacOS = new RegExp("Mac OS X","ig");
var _isMac = reTestMacOS.test(navigator.userAgent.toLowerCase());
var reLatin = new RegExp("^[a-z\.\\-\\s]+$", "i");
var reEmail = new RegExp("^[a-z0-9\\+\\._%+\\-]+@[a-z0-9\\.\\-]+\\.[a-z]{2,6}$", "i");

var today = new Date();
var nowUTCYear = today.getUTCFullYear();
var nowUTCMonth = today.getUTCMonth();
var nowUTCDate = today.getUTCDate();

var arTranslit = {};
var arUpper = { "А": "A", "Б": "B", "В": "V", "Г": "G", "Д": "D", "Е": "E", "Ё": "YE", "Ж": "ZH", "З": "Z", "И": "I", "Й": "Y", "К": "K", "Л": "L", "М": "M", "Н": "N", "О": "O", "П": "P", "Р": "R", "С": "S", "Т": "T", "У": "U", "Ф": "F", "Х": "KH", "Ц": "TS", "Ч": "CH", "Ш": "SH", "Щ": "SHCH", "Ь": "", "Ы": "Y", "Ъ": "", "Э": "E", "Ю": "YU", "Я": "YA" };
for (l in arUpper) { arTranslit[l] = arUpper[l]; arTranslit[l.toLowerCase()] = arUpper[l].toLowerCase(); }
var enToRu = { 'q': 'й', 'w': 'ц', 'e': 'у', 'r': 'к', 't': 'е', 'y': 'н', 'u': 'г', 'i': 'ш', 'o': 'щ', 'p': 'з', '[': 'х', '{': 'х', ']': 'ъ', '}': 'ъ', 'a': 'ф', 's': 'ы', 'd': 'в', 'f': 'а', 'g': 'п', 'h': 'р', 'j': 'о', 'k': 'л', 'l': 'д', ';': 'ж', ':': 'ж', "'": 'э', '"': 'э', '`': 'ё', '~': 'ё', 'z': 'я', 'x': 'ч', 'c': 'с', 'v': 'м', 'b': 'и', 'n': 'т', 'm': 'ь', ',': 'б', '<': 'б', '.': 'ю', '>': 'ю' };
var ruToEn = {}; for (var i in enToRu) { ruToEn[enToRu[i]] = i; }
function getRuByEn(str) { if(enToRu[str]) return enToRu[str]; else return str; }
function getEnByRu(str) { if(ruToEn[str]) return ruToEn[str]; else return str; }

String.prototype.changeEnToRu = function() {
	var newStr = "";
	for(var i = 0, length = this.length; i < length; i++){
		newStr += getRuByEn(this.charAt(i));
	}
	return newStr;
};

String.prototype.changeRuToEn = function() {
	var newStr = "";
	for(var i = 0, length = this.length; i < length; i++){
		newStr += getEnByRu(this.charAt(i));
	}
	return newStr;
};

function checkNames(passengers, callback, errorCallback){
	var setNames = function(){
		var names = '';
		for (var i = 0, length = passengers.length; i < length; i++) {
			var passenger = passengers[i];
			if (i > 0) names += ';';
			names += passenger.lastName + ';' + passenger.firstName;
		}
		return names;
	};

	var dataType = 'json';
	var url = '/_api/name_validator/validate/';
	var makeRequest = function(){
		$.ajax({
			dataType: dataType,
			url: url,
			beforeSend: function(xhr){
				tw.ajaxCheckNames = xhr;
			},
			data: {
				'names': setNames()
			},
			success: function(json){
				if (json && json.result && $.isArray(json.result)) {
					checkResult(json.result);
				} else {
					callback();
				}
			},
			complete: function(){
				delete tw.ajaxCheckNames;
			},
			error: function () {
				callback();
			}
		});
	};

	var checkResult = function(result){
		var warnPassengers = [];
		for (var i = 0, length = passengers.length; i < length; i++) {
			if (result[i * 2] === true && result[i * 2 + 1] === false) {
				warnPassengers.push(passengers[i]);
			}
		}
		if (warnPassengers.length > 0) {
			showPopup(warnPassengers);
		} else {
			callback();
		}
	};

	var showPopup = function(warnPassengers){
		var content = $.tmpl($("#tmpl_WarnNamesPopup").trim(), {
			passengers: warnPassengers
		})[0];
		$('button.continue', content).click(function(){
			removePopup();
			callback();
		});
		$('button.improve', content).click(function(){
			removePopup();
			//errorCallback(warnPassengers);
		});
		addPopup({
			className: "commonPopup",
			dom: content
		});
		$('button.improve', content).focus();
	};

	makeRequest();
}

function Field(options) {
	var self = this;
	this.options = options || {};
	this.value = this.options.value || null;
	this.focus = false;

	/* До создания шаблона */
	if (this.options.type == "name") {
		this.options.reTyping = new RegExp("^[A-Z\\-\\s]+$");
		this.options.textCase = "upper";
		this.options.maxlength = this.options.maxlength || 80;
	}
	if (this.options.type == "name1") {
		this.options.reTyping = new RegExp("^[A-Z\\-\\s]+$");
		this.options.textCase = "upper";
		this.options.maxlength = this.options.maxlength || 80;
	}
	if (this.options.type == "cyrAndLatinName") {
		this.options.reTyping = new RegExp("^[A-ZА-ЯЁ\\-\\s]+$");
		this.options.textCase = "upper";
		this.options.maxlength = this.options.maxlength || 100;
	}
	if (this.options.type == "cyrname") {
		this.options.reTyping = new RegExp("^[А-ЯЁё\\-\\s]+$");
		this.options.textCase = "upper";
		this.options.maxlength = this.options.maxlength || 100;
	}
	if (this.options.type == "email") {
		this.options.reTyping = new RegExp("^[\\w\\+\\-\.@]+$", "i");
		this.options.maxlength = this.options.maxlength || 50;
	}
	if (this.options.type == "passport") {
		this.options.reTyping = new RegExp("^[\\dA-ZА-ЯЁё\\s]+$");
		this.options.textCase = "upper";
		this.options.maxlength = this.options.maxlength || 20;
	}
	if (this.options.type == "numberAndLatin") {
		this.options.reTyping = new RegExp("^[\\dA-Z]+$");
		this.options.textCase = "upper";
		this.options.maxlength = this.options.maxlength || 50;
	}

	if (this.options.type == "number") {
		this.options.reTyping = new RegExp("^[\\d]+$");
		this.options.maxlength = this.options.maxlength || 30;
	}

	if (this.options.type == "phone") this.options.maxlength = this.options.maxlength || 20;

	if (this.options.type == "float") {
		this.options.reTyping = new RegExp("^([\\d]+)?((\\.|,)([\\d]+)?)?$");
		this.options.maxlength = this.options.maxlength || 30;
	}

	if (this.options.type == "birthDate") {
		if(this.value && isValidDate(this.value)){
			this.options.value = this.value.format(l10n.dateMasks.fieldBlur);
			this.options.value = this.options.value.toLowerCase();
		}
		this.options.maxlength = this.options.maxlength || 50;
	}

	if (this.options.type == "expDate") {
		if(this.value && isValidDate(this.value)){
			this.options.value = this.value.format(l10n.dateMasks.fieldFocus);
		}
		this.options.maxlength = this.options.maxlength || 50;
	}


	var list = ['phone', 'name', 'birthDate', 'expDate', 'passport', 'cyrAndLatinName'];
	if ( $.inArray(this.options.type, list) > -1 || this.options.hintType) {
		this.needHint = true;
	}

	/* Создание шаблона */
	this.setField();

	/* После создания шаблона */
	$(this.input).focus(function(event){
		if(self.options.type != "phone") {
			event.preventDefault();
		}
		if (!self.focus) {
			self.focus = true;
			$(self.elFocus).fadeIn();
			self.drawHint();
			self.removeWarn();
			self.removeError();
			if (self.options.type == "birthDate" || self.options.type == "expDate") {
				if (self.options.type == "birthDate" && self.value) {
					this.value = self.value.format(l10n.dateMasks.fieldFocus);
				}
				$(this).mask(l10n.dateMasks.fieldFormat);
			}
			$(this).on('blur', onBlur);
		}
	});
	if(this.options.type == "phone") {
		$(this.input).intlTelInput({
			defaultCountry: (tw.ipinfo && tw.ipinfo.countryCode) ? tw.ipinfo.countryCode.toLowerCase() : "auto",
			nationalMode: false,
			autoPlaceholder: false,
			preferredCountries: ['ru','gb','us','es', 'de', 'ua'],
			preventInvalidNumbers: true,
			utilsScript: "/js/intlTelInputUtils.js"
		});
		try{
			$(this.input).intlTelInput("setNumber",this.input.value);
		} catch(e) {
			console.log(e);
		}
		setTimeout(function(){
			$('.selected-flag').off('click');
		},1000);
	}

	function onBlur() {
		if (self.focus) {
			$(this).off('blur', onBlur);
			self.focus = false;
			$(self.elFocus).fadeOut();
			self.removeHint();
			if (self.options.type == "birthDate" || self.options.type == "expDate") {
				$(this).unmask();
			}
		}
		self.update();
		if (self.error) {
			self.drawHintError();
		}
	}
	if (this.options.reTyping) {

		$(this.input)
			.on("keydown", function(event) {
				self.getCode(event);
			})
			.on("keypress", function(event) {
				self.testTyping(event);
			});

		if (self.options.type == 'name1') {
			$(this.input)
				.on("keypress", function(event) {
					if(browser.safari && (event.ctrlKey || event.altKey || event.metaKey)) {
						return;
					}
					self.filterString(event);
				})
				.on("keyup", function() {
					self.setTranslit();
				});
		}

		$(this.input).on("paste", function(){
			setTimeout(function(){
				self.filterString();
			});
		});
	}


	// $(this.input).on("input keyup paste", function(event){
		/*if (event.type == "input" || event.type == "keyup" && IEVersion) handler();
		function handler(){
			self.setPlaceholder();
			self.drawHint();
		}*/
	// });

	if(this.options.appendTo) $(this.elField).appendTo(this.options.appendTo);

	(function() {
		setTimeout(function () {
			self.error = true;
			self.update();
			if (self.error) {
				self.errorType = 'passportEarlierExpired';
				self.drawHintError();
			}
		}, 1000);
	})()

}


Field.prototype.setField = function(){
	var self = this;
	this.options.autocomplete = this.options.autocomplete || "off";
	this.options.inputType = this.options.inputType || "text";

	this.elField = $.tmpl(tmpl_Field, this.options)[0];

	if (this.options.type == "name1") {
		this.translitLabel = document.createElement("div");
		this.translitLabel.className = 'correctionLabel';
		this.elField.appendChild(this.translitLabel);
	}

	this.input = $('input[type="' + this.options.inputType + '"]:not(.placeholder)', this.elField)[0];
	this.input.field = this;
	this.elFocus = $(".focus", this.elField);
	if (this.options.checkbox) {
		this.checkbox = $('input[type="checkbox"]', this.elField)
			.click(function(){
				if (this.checked) {
					self.setEnabled();
				} else {
					self.setDisabled();
				}
			})[0];
	}

	if (this.options.disabled) this.setDisabled();
};


Field.prototype.update = function(validationCallback){
	this.error = false;
	if (this.options.reTyping) {
		this.filterString();
		if (this.options.type == 'name1') {
			this.value = this.translitValue;
		} else {
			this.value = $(this.input).val();
		}
	} else if (this.options.type == "birthDate" || this.options.type == "expDate") {

	} else {
		this.value = $(this.input).val();
	}
	//for IE9
	if (window.Placeholders) {
		Placeholders.enable(this.input);
	}
	this.checkFieldByType();
	if (validationCallback)
		validationCallback(this);

	if (this.error && !this.input.disabled) {
		this.addError();
	} else {
		this.removeError();
	}
};


Field.prototype.setEnabled = function(){
	this.input.disabled = false;
	if (this.options.checkbox) {
		this.checkbox.checked = true;
	}
	$(this.elField).removeClass("disabled");
	this.update();
};


Field.prototype.setDisabled = function(){
	this.input.disabled = true;
	if (this.options.checkbox) {
		this.checkbox.checked = false;
	}
	this.removeHint();
	this.removeError();
	$(this.elField).addClass("disabled");
};


Field.prototype.addError = function(type) {
	this.removeWarn();
	this.error = true;
	if (type) {
		this.errorType = type;
	}
	this.input.blur();
	$(this.elField).addClass('error');
};


Field.prototype.removeError = function() {
	this.error = false;
	this.errorType = null;
	$(this.elField).removeClass('error');
};


Field.prototype.addWarn = function(type){
	this.warn = true;
	if (type) {
		this.warnType = type;
	}
	$(this.elField).addClass('warn');
};


Field.prototype.removeWarn = function(){
	this.warn = false;
	this.warnType = null;
	$(this.elField).removeClass('warn');
};


Field.prototype.drawHint = function(type){
	var self = this;
	this.removeHint();
	if ($(this.input).is(':visible') && (this.needHint || this.error || this.warn)) {
	//if ($(this.input).is(':visible') && (this.needHint && this.input.value === "" || this.error || this.warn)) {
		var data = {
			type: this.options.type,
			className: "",
			error: false,
			errorType: null,
		};

		if (self.customErrorMessage)
			data.customErrorMessage = self.customErrorMessage.slice();


		if(this.error){
			data.className = "error";
			data.error = true;
			if(this.errorType){
				data.errorType = this.errorType;
			} else if(!this.value){
				data.errorType = "required";
			}
		} else if(this.warn) {
			data.className = "warn";
			data.warn = true;
			if(this.warnType){
				data.warnType = this.warnType;
			}
		}

		data.hintType = this.options.hintType||"";
		this.elHint = $.tmpl('tmpl_hint', data)[0];

		if (this.error) {
			setTimeout(function(){
				$(self.elHint).fadeOut(1000, function(){
					if (self.focus) {
						self.drawHint();
					} else {
						self.removeHint();
					}
				});
			}, 3000);
		} else if(this.warn){
			setTimeout(function(){
				$(self.elHint).fadeOut(1000, function(){
					if (self.focus) {
						self.drawHint();
					} else {
						self.removeHint();
					}
				});
			}, 6000);
		}
		document.body.appendChild(this.elHint);
		var pos = $(this.input).offset();
		$(this.elHint).css({
			top: pos.top + self.input.offsetHeight + 5,
			left: pos.left + self.input.offsetWidth / 2 - self.elHint.offsetWidth / 2
		});
	}
};


Field.prototype.drawHintError = function() {
	this.drawHint();
};


Field.prototype.removeHint = function(){
	$(this.elHint).remove();
	this.elHint = null;
};


Field.prototype.checkFieldByType = function(){
	switch (this.options.type) {
		case "email":
			this.checkEmail();
			break;
		case "phone":
			this.checkPhone();
			break;
		case "birthDate":
			this.checkBirthDate();
			break;
		case "expDate":
			this.checkExpDate();
			break;
		case "passport":
			this.value = $(this.input).val().replace(/\s*/g, '');
			break;
	}
};


Field.prototype.checkEmail = function(){
	var self = this;
	if (this.input.value !== "" && !$(this.input).is('.placeholder')) {
		this.input.value = this.input.value.replace(/\s*/g,'');
		var isEmail = reEmail.test(this.input.value);
		if (!isEmail) {
			this.addError();
		} else if (this.options.validate) {
			this.value = this.input.value;
			var tempValue = this.input.value;
			if (self.iframeId != "social") {
				var dataType = 'json';
				var url = '/_api/emailvalidator/validate/';
				$.ajax({
					dataType: dataType,
					url: url,
					data: {
						"email": self.input.value
					},
					success: function(json){
						if (json.isValid !== true && tempValue == self.input.value) {
							self.addWarn();
							self.drawHint();
						} else if(json.isValid === true){
							//mixpanel
							try {
								MPUpdateUserID(self.input.value);
							} catch (e) {}
						}
					}
				});
			}
		}
	} else {
		this.value = "";
	}
};


Field.prototype.checkPhone = function(){
	var self = this;
	if (this.input.value.length >= 7) {
		this.value = this.input.value;
		var tempValue = this.input.value;
		var dataType = 'json';
		var url = '/_api/phonevalidator/validate/';
		$.ajax({
			dataType: dataType,
			url: url,
			data: {
				"phone": self.input.value.replace(/[\s\-\+()]*/g,'')
			},
			success: function(json){
				if (json.result !== true && tempValue == self.input.value) {
					self.addWarn();
					self.drawHint();
				}
			}
		});
	} else {
		this.value = "";
	}
};


Field.prototype.parseDateString = function(str){
	if(str.indexOf('/') > -1) {
		var arrDate = str.split('/');
		return {
			date: arrDate[1],
			month: arrDate[0],
			year: arrDate[2]
		};
	} else {
		var arrDate = str.split('.');
		return {
			date: arrDate[0],
			month: arrDate[1],
			year: arrDate[2]
		};
	}
};


Field.prototype.getDayCountInMonth = function(month, year){
	var leapParam1 = year % 4 == 0 ? 1 : 0;
	var leapParam2 = (year % 100 == 0 && year % 400 != 0) ? 1 : 0;
	var param1 = month > 7 ? 1 : 0;
	var param2 = (month - param1) % 2 != 0 ? 1 : 0;
	var param3 = month == 2 ? 1 : 0;
	var param4 = !(leapParam1 && !leapParam2) ? 1 : 0;
	var totalDays = 30 + param2 - param3 - param3 * param4;
	return totalDays;
};


Field.prototype.checkBirthDate = function() {
	var self = this;
	if (this.input.value !== "") {
		var oDate;
		if (this.value && (this.value.format(l10n.dateMasks.fieldBlur).toLowerCase() === this.input.value || this.value.format(l10n.dateMasks.fieldBlur) === this.input.value)) {
			oDate = this.parseDateString(this.value.format(l10n.dateMasks.fieldFocus));
		} else {
			oDate = this.parseDateString(this.input.value);
		}

		if (oDate.month > 12) {
			this.addError("Wrong");
		} else if (this.getDayCountInMonth(oDate.month, oDate.year) < oDate.date) {
			this.addError("Wrong");
		} else {
			this.value = new Date(oDate.year, oDate.month - 1, oDate.date);
			if (this.value) {
				if (this.options.min && !(this.options.min <= this.value)) {
					this.addError("Age");
				} else if (this.options.max && !(this.value < this.options.max)) {
					this.addError("Age");
				}
			}
		}
	} else {
		this.value = null;
	}


	if (this.error) this.value = null;
	if (this.value && !self.focus) {
		self.input.value = self.value.format(l10n.dateMasks.fieldBlur).toLowerCase();
	}
};


Field.prototype.checkExpDate = function() {
	if (this.input.value !== "") {

		var oDate = this.parseDateString(this.input.value);
		var currentDate = new Date();
		var pasExpDate = new Date(oDate.year, oDate.month - 1, oDate.date, currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds(), currentDate.getMilliseconds());
		var dateDiff = pasExpDate - currentDate;
		var oneDay = 1000 * 60 * 60 * 24;

		if (oDate.month > 12) {
			this.addError("Wrong");
		} else if (this.getDayCountInMonth(oDate.month, oDate.year) < oDate.date) {
			this.addError("Wrong");
		} else if (oDate.date === '00' || oDate.month === '00') {
			this.addError("Wrong");
		} else if (dateDiff < 0) {
			this.addError("passportExpired");
		} else {
			this.value = new Date(oDate.year, oDate.month - 1, oDate.date);
			if(dateDiff >= 0 && dateDiff <= 30 * oneDay) {
				this.addWarn("passportSoonExpired");
				this.drawHint();
			} else if (this.value && this.options.min && !(this.options.min <= this.value)) {
				this.addError("Expired");
			}
		}
	} else {
		this.value = null;
	}
	if (this.error) this.value = null;
};


Field.prototype.testTyping = function(event) {
	var charCode = event.charCode || event.keyCode;
	var charCodeStr = String.fromCharCode(charCode);

	if (event.ctrlKey || event.altKey || event.metaKey || (0 < this.keyCode && this.keyCode < 47 && this.keyCode != 32)) {
		return;
	} else if (this.options.maxlength > 0 && this.input.value.length >= this.options.maxlength) {
		return false;
	} else if (this.options.reTyping.test(charCodeStr)) {
		return;
	} else {
		var charCodeStrInCase = this.toTextCase(charCodeStr);
		var ruToEn = this.toTextCase(charCodeStr.toLowerCase().changeRuToEn());
		var enToRu = this.toTextCase(charCodeStr.toLowerCase().changeEnToRu());
		if (this.options.reTyping.test(charCodeStrInCase)) {
			this.pasteString(charCodeStrInCase);
		} else if (this.options.reTyping.test(ruToEn) && this.options.type != 'name1') {
			this.pasteString(ruToEn);
		} else if (this.options.type == 'name1' && ref.translit[charCodeStrInCase] != undefined) {
			this.pasteString(charCodeStrInCase);
		} else if (this.options.type == 'cyrname' && this.options.reTyping.test(enToRu)) {
			this.pasteString(enToRu);
		}

		if (this.options.type == "email") {
			if (event.shiftKey && (this.keyCode == 50 || this.keyCode == 222)) {
				this.pasteString("@");
			}
			if (!event.shiftKey && this.keyCode == 190 || (browser.mac && charCodeStr == "ю")) {
				this.pasteString(".");
			}
			//if (charCodeStr == "ю") {this.pasteString(".");}
		}

		event.preventDefault ? event.preventDefault() : event.returnValue = false;
	}
};

Field.prototype.getCaretPos = function() {
	var r, rc, re;
	if (!this.input.createTextRange) {
		return this.input.selectionStart;
	} else if(document.getSelection) {
		var pos;
		try {
			pos = document.activeElement.selectionStart;
		} catch (e) {
			pos = 0;
		}
		return pos;
	} else {
		this.input.focus();
		r = document.selection.createRange();
		re = this.input.createTextRange();
		rc = re.duplicate();
		re.moveToBookmark(r.getBookmark());
		rc.setEndPoint('EndToStart', re);
		return rc.text.length;
	}
};

Field.prototype.filterString = function(event){
	var str;
	var maxlength = this.options.maxlength;
	var reTyping  = this.options.reTyping;
	var type      = this.options.type;
	var input     = this.input;
	if(type === "name1") {
		str = this.toTextCase($(input).val());
	} else {
		str = $.trim( this.toTextCase($(input).val())  );
	}
	var newStr = "";
	for (var i = 0, textLength = str.length; i < textLength; i++) {
		var iChar = str.charAt(i);
		if (type === "email") {
			newStr += iChar;
		} else if (type === "name1") {
			if (reTyping.test(iChar) || ref.translit[iChar] != undefined) {
				newStr += iChar;
			}
		} else if (reTyping && reTyping.test(iChar)) {
			newStr += iChar;
		} else if (type === "name" && arTranslit[iChar]) {
			if (reTyping.test(arTranslit[iChar])) {
				newStr += arTranslit[iChar];
			}
		}
	}
	var cursor = this.getCaretPos();

	input.value = newStr;
	if (maxlength > 0 && input.value.length >= maxlength) {
		input.value = input.value.substr(0, maxlength);
	}
	if (type === 'name1') {
		this.setTranslit();
		if (cursor && event && event.type !== 'change') {
			input.setSelectionRange(cursor, cursor);
		}
	}
};


Field.prototype.toTextCase = function(str){
	if ( this.options.textCase == "upper" ) {
		return str.toUpperCase();
	} else if ( this.options.textCase == "lower" ) {
		return str.toLowerCase();
	} else {
		return str;
	}
};


Field.prototype.setTranslit = function() {
	var label = '';
	var needCorrection = false;
	//this.input.value = this.toTextCase(this.input.value);
	for (var i = 0, length = this.input.value.length; i < length; i++) {
		var letter = this.input.value.charAt(i);
		if (this.options.reTyping.test(letter)) {
			label += letter;
		} else if (ref.translit[letter] != undefined) {
			label += ref.translit[letter];
			needCorrection = true;
		}
	}


	if (needCorrection) {
		$(this.elField).addClass('correction');
		this.translitLabel.innerHTML = label;
	} else {
		$(this.elField).removeClass('correction');
		this.translitLabel.innerHTML = '';
	}


	if (label.length > 12) {
		this.translitLabel.title = label;
		this.translitLabel.style.cursor = 'help';
	} else {
		this.translitLabel.title = '';
		this.translitLabel.style.cursor = 'default';
	}
	this.translitValue = label;
};


Field.prototype.pasteString = function(strNew) {
	this.getSelection();
	var strStart = this.input.value.substring(0, this.selectionStart);
	var strEnd = this.input.value.substr(this.selectionEnd, this.input.value.length);
	this.input.value = strStart + strNew + strEnd;

	if (this.input.setSelectionRange) {
		this.input.setSelectionRange(this.selectionStart + 1, this.selectionStart + 1);
	} else {
		var SelectionRange = this.input.createTextRange();
		SelectionRange.move("character", this.selectionStart + 1);
		SelectionRange.select();
	}
};


Field.prototype.getCode = function(event) {
	this.keyCode = event.keyCode;
};


Field.prototype.getSelection = function() {
	this.selectionStart = this.getSelectionStart() || 0;
	this.selectionEnd = this.getSelectionEnd();
};


Field.prototype.getSelectionStart = function() {
	if (!this.input.createTextRange) {
		return this.input.selectionStart;
	} else if(document.getSelection) {
		return document.activeElement.selectionStart;
	} else {
		var SelectionRange = document.selection.createRange().duplicate();
		SelectionRange.moveEnd('character', this.input.value.length);
		return this.input.value.lastIndexOf(SelectionRange.text);
	}
};


Field.prototype.getSelectionEnd = function() {
	if (!this.input.createTextRange) {
		return this.input.selectionEnd;
	} else if(document.getSelection) {
		return document.activeElement.selectionEnd;
	} else {
		var SelectionRange = document.selection.createRange().duplicate();
		SelectionRange.moveStart('character', -this.input.value.length);
		return SelectionRange.text.length;
	}
};

Field.prototype.setPlaceholder = function(){
	if(this.placeholder) {
		if(!this.input.value && !this.focus){
			this.placeholder.value = this.placeholder.defaultValue;
		} else if (this.focus) {
			this.placeholder.value = "";
		}
	}
};

var tmpl_Field;
$(document).ready(function(){
	tmpl_Field = $("#tmpl_Field").trim();
	if ($('#tmpl_hint').length > 0) {
		$.template('tmpl_hint', $("#tmpl_hint").trim());
	}
});

(function() {
  var layout, form;

  $(document).on('visitormanager_auth_complete', function(event) {
    var params = getHashParams();
    if (params.ff_reg === '1') {
      var email = (tw.visitor && tw.visitor.email) || '';
	  if (email) {
		modalInit();
		formInit();

	    $('.efw__f__confirm').attr('title', email);
	    $('.efw__f__confirm__text__email').text(email);

	    $(document).off('visitormanager_auth_complete');
	  }
    }
  });

  function modalInit() {
    $('#efw_modal_close, #efw_layout').click(close);
	$('.efw__container-wrapper').click(function (e) {
	  e.stopPropagation();
	});

	layout = $('#efw_layout');
	layout.removeClass('invisible');
  }

  function close(event) {
  	layout.addClass('invisible');
	form.off();

    updateHash({
	  ff_reg: 0
	});
  }

  var data = {
    name: '',
    surname: '',
    city: ''
  };

  var formInputs = {};

  function formInit() {
    form = $('#efw_form');

    formInputs.name = document.getElementById('efw_form_name');
    formInputs.surname = document.getElementById('efw_form_surname');
    formInputs.city = document.getElementById('efw_form_city');

	form.on('submit', function(event) {
      event.preventDefault();

      var submit = true;
      submit = fieldEmpty('name') && submit;
      submit = fieldEmpty('surname') && submit;
      submit = fieldEmpty('city') && submit;

      if (submit) {
        var email = (tw.visitor && tw.visitor.email) || '';
        var params = {
          email: email,
          firstName: data.name,
          lastName: data.surname,
          city: data.city,
		  country: null,
		  cityCode: null,
        };

        $.ajax({
          type: "post",
          dataType: "json",
          data: {
            params: JSON.stringify(params)
          },
          url: "/_api/buyermanager/setUserInfo/",
          complete: function() {
		  	objSocialAuth.initVisitor();
          }
        });

        close();
      }
    });


    form.on('input', function(event) {
      if (event.target.tagName == "INPUT")
        $(event.target).parent().removeClass('efw__form__field--has-error');
    });
  }

  function fieldEmpty(name) {
    if (!formInputs[name].value) {
      data[name] = '';
      $(formInputs[name]).parent().addClass('efw__form__field--has-error');
      return false;
    }
    data[name] = formInputs[name].value;
    return true;
  }
}());

var objSocialAuth;
var isSocialRedirect = (window.location.pathname.indexOf("/auth/") > -1);
var isToTwitterRedirect = (window.location.pathname.indexOf("/auth/") > -1 && tw.params.provider == "toTwitter");
var isSecurePart = (window.location.pathname.indexOf("/p/") > -1) || (window.location.pathname.indexOf("/p_old/") > -1);

function makeBonusCurrencyToViewCur(cur){
	if(tw.provider){ return;};
	try{RewriteBonus(cur);} catch(e){}
}
function RewriteBonus(currency){
	tw.bonus = tw.bonus||{};
	if(!currency){
		if(tw.language == 'de' || tw.language == 'es' || tw.language == 'en-ie') {
			currency = 'EUR';
		} else if(tw.language == 'az'){
			currency = 'AZN';
		} else if(tw.language.indexOf('ua')>-1){
			currency = 'UAH';
		} else if(tw.language == 'en-gb'){
			currency = 'GBP';
		} else if(tw.language == 'en-us'){
			currency = 'USD';
		} else if(tw.language == 'tr'){
			currency = 'TRY';
		} else if(tw.language == 'pl'){
			currency = 'PLN';
		} else {
			currency = 'RUB';
		}
	}
	tw.bonus.currency = currency;

	var bonusFirst = '1500';
	var bonusSecond = 500;
	var regBonus = '1000';
	var leadBonus = 500;
	var leadDiscount = 500;
	var leadBonusHotel = 500;
	var maxLeadBonus = 50000;
	var bonusCurrency = l10n.currency[tw.bonus.currency].Genitive_Plural

	switch (tw.bonus.currency) {
		case "EUR":
			bonusFirst = 38;
			bonusSecond = 13;
			regBonus = 25;
			leadBonus = 10;
			leadDiscount = 10;
			leadBonusHotel = 10;
			maxLeadBonus = 1170;
			break;
		case "USD":
			bonusFirst = 50;
			bonusSecond = 20;
			regBonus = 30;
			leadBonus = 10;
			leadDiscount = 10;
			leadBonusHotel = 10;
			maxLeadBonus = 1550;
			break;
		case "UAH":
			bonusFirst = 400;
			bonusSecond = 140;
			regBonus = 260;
			leadBonus = 250;
			leadDiscount = 250;
			leadBonusHotel = 10;
			maxLeadBonus = 11700;
			break;
		case "AZN":
			bonusFirst = 38;
			bonusSecond = 13;
			regBonus = 25;
			leadBonus = 6;
			leadDiscount = 6;
			leadBonusHotel = 10;
			maxLeadBonus = 95;
			break;
		case "TRY":
			bonusFirst = 90;
			bonusSecond = 30;
			regBonus = 60;
			leadBonus = 15;
			leadDiscount = 15;
			leadBonusHotel = 10;
			maxLeadBonus = 2800;
			break;
		case "GBP":
			bonusFirst = 30;
			bonusSecond = 13;
			regBonus = 20;
			leadBonus = 5;
			leadDiscount = 5;
			leadBonusHotel = 10;
			maxLeadBonus = 1000;
			break;
		case "PLN":
			bonusFirst = 50;
			bonusSecond = 20;
			regBonus = 30;
			leadBonus = 10;
			leadDiscount = 10;
			leadBonusHotel = 10;
			maxLeadBonus = 1550;
			break;
	}

	tw.bonusinfo = {
		bonusCurrency: l10n.currency[tw.bonus.currency].Genitive_Plural,
		bonusFirst: formatMoney(bonusFirst),
		bonusSecond: formatMoney(bonusSecond),
		regBonus: formatMoney(regBonus),
		leadBonus: formatMoney(leadBonus),
		leadDiscount: formatMoney(leadDiscount),
		leadBonusHotel: formatMoney(leadBonusHotel),
		maxLeadBonus: formatMoney(maxLeadBonus)
	};
}

function SocialAuth(json){
	tw.visitor = {};
	if (!$.template.tmpl_aside) $("#tmpl_Aside").template('tmpl_aside');
	if (isToTwitterRedirect) {//Получаем twitter url и редиректим
		this.getTwitterLink();
		return;
	}
	this.salesValue = readCookie('sales');
	this.dfd = $.Deferred();
	this.json = json || {};
	if (!isSocialRedirect) {
		this.formVisible = false;
		this.initOptions();
		this.setAuthInProgress();
	}
	this.scrollPosition = null;
	this.onlyRedraw = null;
	this.userGroups = [];
	this.initVisitor();
	this.initUserStatus();
}

tw.deferred.visitormanagerGet = $.Deferred();
SocialAuth.prototype.initVisitor = function(isFromSocialRedirect){
	var self = this;
	var showForm = false;
	tw.params.referrer =  (document.referrer && document.referrer !== "") ? document.referrer : "empty";
	if(tw.params.lid && !readCookie("vid") && !readCookie("lid")){
		showForm = true;
	}
	if (window.location.pathname.indexOf("/p/") >- 1) {
		tw.params.hb = true;
	}
	$.ajax({
		type: "get",
		cache: false,
		url: "/_api/visitormanager/get/",
		dataType: "json",
		data: tw.params,
		timeout: 60000,
		success: function(json){
			//mixpanel

			function waitAfterMPLoaded(){
				try {
					MPCheckSaveVisit();
				} catch (e) {}
			}
			// wait for mixpanel loaded fully
			setTimeout(waitAfterMPLoaded, 1000);

			$(document).trigger({
				type: "visitormanager_get_success",
				json: json
			});

			if (isSocialRedirect) {
				var data = tw.params;
					data.protocol = window.location.protocol;
				$.ajax({
					type: "get",
					cache: false,
					url: "/_auth/authenticate/oauth-callback/",
					data: data,
					timeout: 10000,
					complete: function(){
						if (window.opener) {
							try {
								window.opener.objSocialAuth.initVisitor(true);
							} catch (e) {}
							window.close();
						} else {
							window.location.href = '/';
						}
					}
				});
				self.dfd.reject();
			} else {
				self.json = json;
				if(!self.json.providers){
					self.defaultVid = self.json.vid;
				}
				self.updateUserData();
				if (isFromSocialRedirect) {
					if (self.onlyRedraw) {
						self.redraw();
					} else {
						self.reloadOrRedraw();
					}
				} else {
					self.redraw();
					if (isSecurePart && !self.checkAuthorized()) {
						self.show(self.regauthForm);
						self.authEmail.input.focus();
						self.RedirectFirst();
					}
					if (showForm) {
						self.show(self.regauthForm);
						self.regEmail.input.focus();
					}
				}
				$(document).trigger({ type: "visitormanager_auth_complete" });
				self.dfd.resolve();
			}
		},
		error: function(){
			RewriteBonus();
			self.dfd.reject();
		},
		complete: function(){
			tw.deferred.visitormanagerGet.resolve();
			$(document).trigger({type: "visitormanager_complete"});

			//update trackJs userId
			var _trackJs = window._trackJs || {};
			_trackJs.userId = readCookie('vid') || '';
		}
	});
};

SocialAuth.prototype.checkUserStatus = function () {
	$.ajax({
		type: 'get',
		dataType: 'json',
		url: '/_api/buyermanager/getUserStatus/',
	})
	.then(function (res) {
		if (!window.tw) {
			window.tw = {};
		}
		window.tw.isPremiumUser = res && res.authorized && res.guestMode !== null && !res.guestMode && (res.type === 'premium');
		if (window.tw.isPremiumUser && window.tw.language == "ru") {
			$('#topMenu_travelExpert').removeClass('invisible');
		}
	})
	.fail(function (res) {
		console.error('Something went wront: ', res.statusText)
	});
};

SocialAuth.prototype.fetchUserGroups = function() {
	var self = this;
	$.ajax({
		type: 'get',
		dataType: 'json',
		url: '/_mark/buyerGroups/',
	})
	.then(function (res) {
		if (res && res.result) {
			self.userGroups = res.result;
			self.ensureHotelOrderStatus();
		}
	})
	.fail(function (res) {
		console.error('Something went wront: ', res.statusText)
	});
};

SocialAuth.prototype.ensureHotelOrderStatus = function() {
	if (this.userGroups.length) {
		for (var i = 0, length = this.userGroups.length; i < length; i++) {
			if (this.userGroups[i] === 'HAD_HOTEL_ORDER') {
				$('#hotelBonusContainer').hide();
			}
		}
	}
};

SocialAuth.prototype.initUserStatus = function () {
	var self = this;
	$(document).on('authTrue', function (event) {
		self.checkUserStatus();
		self.fetchUserGroups();
	});
};
SocialAuth.prototype.setScrollPosition = function (scrollPosition) {
	this.scrollPosition = scrollPosition;
};
SocialAuth.prototype.setOnlyRedraw = function (redraw) {
	this.onlyRedraw = redraw;
};
SocialAuth.prototype.updateUserData = function(){
	if (this.json.redirect) {
		window.location = this.json.redirect;
		return;
	}
	tw.bonus = this.json.bonus||{};
	tw.visitor = this.json;
	if (this.json.providers && this.json.providers.length > 0) {
		tw.provider = this.json.providers[0].provider;
	}
	RewriteBonus(tw.bonus.currency);
};
SocialAuth.prototype.RedirectFirst = function(){
	var self = this;
	if (isSecurePart && !self.checkAuthorized()){
		if(this.formVisible){
			setTimeout(function(){
				self.RedirectFirst();
			},3000);
		} else {
			window.document.location.href = "/";
		}
	}
};


SocialAuth.prototype.checkAuthorized = function(){
	return !!(this.json && (this.json.name || this.json.email));
};


SocialAuth.prototype.initOptions = function(){
	var self = this;
	this.regauthForm = $.tmpl($('#tmpl_SocialRegAuth'))[0];
	this.regauthForm.id = 'SocialRegAuth';
	this.authForm = $('#SocialAuth',this.regauthForm)[0];
	this.authForm.id = "SocialAuth";
	this.regForm = $('#SocialReg',this.regauthForm)[0];
	this.regForm.id = "SocialReg";
	this.remindForm = $.tmpl($('#tmpl_RemindAuth'))[0];
	this.remindForm.id = "RemindAuth";

	this.authEmail = new Field({
		appendTo: $('.pf_email', this.authForm),
		name: "auth_email",
		value: self.salesValue || "",
		autocomplete: 'on',
		type: "email"
	});

	this.authPas = new Field({
		appendTo: $('.pf_pas', this.authForm),
		name: "auth_pas",
		value: "",
		maxlength: 30,
		autocomplete: 'on',
		inputType: "password"
	});

	this.authForm.fields = [this.authEmail,this.authPas];

	this.regEmail = new Field({
		appendTo: $('.pf_email', this.regForm),
		name: "reg_email",
		validate: true,
		value: "",
		type: "email"
	});

	this.regPas = new Field({
		appendTo: $('.pf_pas', this.regForm),
		name: "reg_pas",
		value: "",
		maxlength: 30,
		hintType: "regPas",
		inputType: "password"
	});

	this.repeatPas = new Field({
		appendTo: $('.pf_repeatPas', this.regForm),
		name: "confirmreg_pas",
		value: "",
		maxlength: 30,
		hintType: "regPas",
		inputType: "password"
	});

	this.regForm.fields = [this.regEmail,this.regPas,this.repeatPas];
	this.regauthForm.fields = this.authForm.fields.concat(this.regForm.fields);

	this.remindEmail = new Field({
		appendTo: $('.remind_email', this.remindForm),
		name: "remind_email",
		value: "",
		type: "email"
	});

	$('.getNewPas', this.authForm).click(function(){
		self.hide(self.regauthForm);
		$('.hint').remove();
		self.show(self.remindForm);
	});

	this.regErrorBlock = $('.Error',this.regForm);
	this.authErrorBlock = $('.Error',this.authForm);
	this.remindErrorBlock = $('.Error',this.remindForm);

	$(this.regForm).submit(function(event){
		event.preventDefault();
		$(self.regErrorBlock).addClass('invisible');
		self.getRegData();
		if (self.checkRegForm()) {
			self.makeRegistration();
		}
	});

	$(this.authForm).submit(function(event){
		event.preventDefault();
		self.getAuthData();
		$(self.authErrorBlock).addClass('invisible');

		if (self.needCaptcha) {
			var captcha = new CaptchaPopup({
				email: self.request.email,
				sucessType: 'authList'
			});

			captcha.show(function captchaHandler(err, res) {
				if (err || !res) {
					captcha.show(captchaHandler);
				} else {
					captcha.destroy();
					removePopup();

					$(self.authErrorBlock).addClass('invisible');

					if (self.checkAuthForm()) {
						self.makeAuthorization();
					}
				}
			});
		} else {
			if (self.checkAuthForm()) {
				self.makeAuthorization();
			}
		}
	});

	$(this.remindForm).submit(function(event){
		event.preventDefault();
		$(self.remindErrorBlock).addClass('invisible');
		self.getRemindData();
		if (self.checkRemindForm()) {
			self.makeReminder();
		}
	});

	$('body').append('<div id="tmp_SocialLinks" class="invisible"></div>');
	this.tmpl_sLinks = $('#tmp_SocialLinks')[0];
	$(this.tmpl_sLinks).append($.tmpl($('#tmpl_LoginSocials')));

	$('body').on('click', '.SocialForm .social_list a', function(e){
		e.preventDefault();
		var socialAuthWin = window.open($(this).attr('href'), 'sharer_' + new Date().valueOf(), 'toolbar=no,width=980,height=500,modal=yes');
		if (socialAuthWin && window.location.hostname.indexOf('onetwotrip.com') == -1) {
			function checkWindow(){
				if (socialAuthWin.closed) {
					self.initVisitor(true);
				} else {
					setTimeout(function(){
						checkWindow();
					}, 1000);
				}
			}
			checkWindow();
		}
	});
};
SocialAuth.prototype.reloadOrRedraw = function(){
	if (window.document.location.pathname.indexOf("/lead/") >-1) {
		window.document.location.href = 'p/';
	} else if (tw.root || isSecurePart) {
		this.redraw();
	} else {
		try{
			$(document.body).trigger("removeUnloadReservation");
		} catch(e){}
		window.document.location.reload();
	}
	kmqRecord({name: 'Authorize'});
};
SocialAuth.prototype.setAuthInProgress = function() {
	$('.socialAuthProfile').remove();
	$.tmpl($.template.tmpl_aside, { loading: true }).appendTo($('.header-partner>.spreader')[0] || $('.layoutHeader>.spreader')[0]);
	updateSelectedLanguageInfo();
};
SocialAuth.prototype.redraw = function(showRemindForm, showRegauthForm){
	var self = this;
	$('.socialAuthProfile').remove();
	var appendTo = $('.header-partner>.spreader')[0] || $('.layoutHeader>.spreader')[0];

	if (this.checkAuthorized()) {
		$.tmpl($.template.tmpl_aside, {
			auth: true,
			name: this.getProfileName()
		})
			.find('.logout').click(function(){
				$.ajax({
					iframeId: "pm",
					type: "post",
					dataType: "json",
					url: "/_api/visitormanager/exit/",
					success: function(json){
						if (json) {
							window.document.location.href = "/";
						}
					},
					complete: function(){
						_kmq.push(['clearIdentity']);
					}
				});
			}).end()
			.appendTo(appendTo);
		this.initProfileMenu();
		$(document).trigger("authTrue");
	} else {
		$.tmpl($.template.tmpl_aside, {
			auth: false
		})
			.find('.login').click(function(e){
				self.show(self.regauthForm);
				if(!self.salesValue) {
					self.authEmail.input.focus();
				} else {
					self.authPas.input.focus();
				}
				var id = e.target && e.target.id;
				kmqRecord({name:"topMenuClick", obj: { auth: tw.visitor && tw.visitor.auth, id: id }, prefix: 'mainForm'});
			}).end()
			.appendTo(appendTo);
		updateSelectedLanguageInfo();
	}

	//расширяем область под меню
	var profileContainerWidth = $('.profileContainer').width();
	$('.mainMenu').css({right: profileContainerWidth + 'px'});

	updateOverlayMenu();

	var userVid = self.defaultVid||self.json.vid;
	this.userName = self.json.email||self.json.name;

	if(!this.userName && this.salesValue) {
		this.userName = this.salesValue;
	}
	_kmq.push(['alias', userVid, this.userName]);


	if(this.formVisible) {
		if (!showRemindForm) {
			try{this.hide(this.remindForm);} catch(e){}
		}
		if (!showRegauthForm) {
			try{this.hide(this.regauthForm);} catch(e){}
		}
	}
};
SocialAuth.prototype.initProfileMenu = function(){
	updateSelectedLanguageInfo();
	var $aside = $('.aside.loggedin'),
		$toggle = $('.profileContainer .asideLabel');
	if (!$aside.length) return;
	$toggle.on('click', function(e){
		$aside.stop(true,true).fadeToggle();
	});
	$(document.body).on('click', function(e){
		var isToggle = $toggle.find(e.target).length || $(e.target).is(".asideLabel");
		if(!$.contains($aside[0], e.target) && $aside.is(':visible') && !isToggle){
			$aside.stop(true,true).fadeOut();
		}
	});
	$aside.find('.menu-item').on('click', function(e){
		$aside.stop(true,true).hide();

		var id = e.target && e.target.id;
		kmqRecord({name:"topMenuClick", obj: { auth: tw.visitor && tw.visitor.auth, id: id }, prefix: 'mainForm'});
	});
};
SocialAuth.prototype.getProfileName = function(){
	var name = '';
	if (this.json.firstName || this.json.lastName) {
		name = this.json.firstName;
		if (this.json.firstName && this.json.lastName) {
			name += ' ';
		}
		name += this.json.lastName;
	} else if (this.json.name) {
		name = this.json.name;
	} else {
		name = this.json.email.split('@')[0];
	}
	return name;
};
SocialAuth.prototype.rewriteSocialLinks = function(){
	var self = this;
	var redirect_uri = encodeURIComponent(window.location.protocol + '//' + window.location.host + "/auth/?provider=");
	if (!this.links_done) {
		$('.social_list a.fb').attr('href', 'https://www.facebook.com/dialog/oauth?client_id=116448151756930&scope=email&redirect_uri=' + redirect_uri + 'facebook');
		$('.social_list a.vk').attr('href', 'http://api.vk.com/oauth/authorize?client_id=5037664&scope=;&response_type=code&redirect_uri=' + redirect_uri + 'vkontakte');
		$('.social_list a.mr').attr('href', 'https://connect.mail.ru/oauth/authorize?client_id=640456&response_type=code&redirect_uri=' + redirect_uri + 'mailru');
		$('.social_list a.ok').attr('href', 'http://www.odnoklassniki.ru/oauth/authorize?client_id=5213440&response_type=code&redirect_uri=' + redirect_uri + 'odnoklassniki');
	}
	if (tw.language == 'az') {
		$('.social_list a[class!="fb"]').parent().remove();
	}
	this.links_done = true;
};
SocialAuth.prototype.getTwitterLink = function(form){
	var self = this;
	$.ajax({
		type: "post",
		dataType: "json",
		url: "/_api/visitormanager/getProviderURL/",
		timeout: 20000,
		success: function(json){
			if (json.twitter && json.twitter !== '') {
				window.location.href = json.twitter;
			} else {
				window.close();
				$('.social_list a.tw').addClass("invisible");
			}
		}
	});
};
SocialAuth.prototype.show = function(form){
	var self = this;
	clearExtraElements();
	if(form.id != 'RemindAuth'){
		this.rewriteSocialLinks();
	}
	if ($('#' + form.id).length === 0) {
		$(".close_button", form).click(function(){
			self.hide(form);
			$('body').trigger('closeAuthPopup');
		});
		$('body').append(form);
	}
	if(form.fields){
		for(var i = 0, length= form.fields.length; i< length; i++){
			if(form.fields[i].options.inputType == 'password' && !form.savePass){
				form.fields[i].input.value = '';
			}
			form.fields[i].removeWarn();
			form.fields[i].removeError();
		}
	}
	if($('.sLinks_inside',form).length && $('.sLinks_inside',form).children().length === 0) {
		$('.sLinks_inside',form).html( $(this.tmpl_sLinks).html() );
	}
	var elFade = fadeIn();
	$(elFade).one("click", function(){
		self.hide(form);
		$('body').trigger('closeAuthPopup');
	});

	if (!this.scrollPosition) {
		$("html,body").animate({
			scrollTop: 0
		});
	} else {
		$(form).css('top', this.scrollPosition);
	}

	$(form).removeClass("invisible");
	this.formVisible = true;
	$('body').trigger('openAuthPopup');
};
SocialAuth.prototype.hide = function(form){
	$('.hint').remove();
	fadeOut();
	$(form).addClass("invisible");
	this.isReg = false;
	this.formVisible = false;
};
SocialAuth.prototype.getRegData = function(){
	this.request = {};
	this.regEmail.update();
	this.regPas.update();
	this.repeatPas.update();
	this.request.email = this.regEmail.value;
	this.request.pwd = this.regPas.value;
	this.request.confirmPwd = this.repeatPas.value;
};
SocialAuth.prototype.checkRegForm = function(){
	var self = this;
	var errors = 0;
	var errorField = null;

	if (!this.request.email || this.regEmail.error) {
		errors++;
		this.regEmail.addError();
		if (!errorField) {
			errorField = this.regEmail;
		}
	}
	if (!this.request.pwd || this.regPas.error) {
		errors++;
		this.regPas.addError();
		if (!errorField) {
			errorField = this.regPas;
		}
	}
	if (this.request.pwd && !PasswordValidator.validate(this.request.pwd).res) {
		errors++;
		this.regPas.addError("weakPas");
		if (!errorField) {
			errorField = this.regPas;
		}
	}
	if (!this.request.confirmPwd || this.repeatPas.error) {
		errors++;
		this.repeatPas.addError();
		if (!errorField) {
			errorField = this.repeatPas;
		}
	}
	if (this.request.pwd && this.request.confirmPwd && this.request.pwd != this.request.confirmPwd) {
		errors++;
		this.repeatPas.addError("passwordMatch");
		if (!errorField) {
			errorField = this.repeatPas;
		}
	}

	if (errors) {
		setTimeout(function(){
			errorField.input.focus();
		},100);
		return false;
	} else {
		$('.hint').remove();
		if(this.regForm.fields){
			for(var i = 0, length= this.regForm.fields.length; i< length; i++){
				$(this.regForm.fields[i].input).blur();
			}
		}
		return true;
	}
};
SocialAuth.prototype.makeRegistration = function(){
	var self = this;
	$('input', this.regForm).each(function(){
		$(this).attr('disabled', true);
		this.disabled = true;
	});
	this.isReg = true;
	$.ajax({
		iframeId: "pm",
		type: "post",
		dataType: "json",
		data: self.request,
		url: "/_api/visitormanager/register/",
		timeout: 30000,
		beforeSend: function(){
			self.setAuthInProgress();
			self.hide(self.regauthForm);
		},
		success: function(json){
			self.json = json;
			if (json.error) {
				self.parseError(json);
			} else {
				var obj = {email:self.request.email};
				var div = document.createElement('div');
				$.tmpl($("#tmpl_RegConfirm").trim(), obj).appendTo(div);
				addPopup({
					dom: div,
					className: "commonPopup regConfirm",
					close_button: true
				});
				kmqRecord({name: 'Registration'});
			}
		},
		error: function(xhr){
			self.connectionError(xhr,self.regauthForm);
		},
		complete: function(){
			$('input', self.regForm).each(function(){
				$(this).removeAttr('disabled');
				this.disabled = false;
			});

			var showRemindForm = !$(self.remindForm).hasClass('invisible');
			var showRegauthForm = !$(self.regauthForm).hasClass('invisible');
			self.redraw(showRemindForm, showRegauthForm);
		}
	});
};
SocialAuth.prototype.getAuthData = function(){
	this.request = {};
	this.authEmail.update();
	this.authPas.update();
	this.request.email = this.authEmail.value;
	this.request.pwd = this.authPas.value;
};
SocialAuth.prototype.checkAuthForm = function(){
	var self = this;
	var errors = 0;
	var errorField = null;

	if (!this.request.email || this.authEmail.error) {
		errors++;
		this.authEmail.addError();
		if (!errorField) {
			errorField = this.authEmail;
		}
	}
	if (!this.request.pwd || this.authPas.error) {
		errors++;
		this.authPas.addError();
		if (!errorField) {
			errorField = this.authPas;
		}
	}

	if (errors) {
		$("html,body").animate({
			scrollTop: $(errorField.elField).offset().top - 80
		}, "fast");
		errorField.input.focus();
		return false;
	} else {
		$('.hint').remove();
		if(this.authForm.fields){
			for(var i = 0, length= this.authForm.fields.length; i< length; i++){
				$(this.authForm.fields[i].input).blur();
			}
		}
		return true;
	}
};
SocialAuth.prototype.makeAuthorization = function(){
	var self = this;
	$('input', this.authForm).each(function(){
		$(this).attr('disabled', true);
		this.disabled = true;
	});
	$.ajax({
		iframeId: "pm",
		type: "post",
		dataType: "json",
		data: self.request,
		url: "/_api/visitormanager/auth/",
		timeout: 40000,
		beforeSend: function(){
			self.setAuthInProgress();
			self.hide(self.regauthForm);
		},
		success: function(json){
			self.json = json;
			self.processAuth(json);
		},
		error: function(xhr){
			self.connectionError(xhr,self.regauthForm);
		},
		complete: function(){
			$('input', self.authForm).each(function(){
				$(this).removeAttr('disabled');
				this.disabled = false;
			});
		}
	});
};
SocialAuth.prototype.getRemindData = function(){
	this.request = {};
	this.remindEmail.update();
	this.request.email = this.remindEmail.value;
};
SocialAuth.prototype.checkRemindForm = function(){
	var self = this;
	var errors = 0;
	var errorField = null;

	if (!this.request.email || this.remindEmail.error) {
		errors++;
		this.remindEmail.addError();
		if (!errorField) {
			errorField = this.remindEmail;
		}
	}

	if (errors) {
		$("html,body").animate({
			scrollTop: $(errorField.elField).offset().top - 80
		}, "fast");
		errorField.input.focus();
		return false;
	} else {
		$('.hint').remove();
		return true;
	}
};
SocialAuth.prototype.makeReminder = function(){
	var self = this;
	$('input', this.remindForm).each(function(){
		$(this).attr('disabled', true);
		this.disabled = true;
	});
	$.ajax({
		iframeId: "pm",
		type: "post",
		dataType: "json",
		data: self.request,
		url: "/_api/visitormanager/generatePassword/",
		timeout: 20000,
		beforeSend: function(){
			self.hide(self.remindForm);
		},
		success: function(json){
			self.json = json;
			$('input', self.remindForm).each(function(){
				$(this).removeAttr('disabled');
				this.disabled = false;
			});
			if (json.error) {
				self.parseError(json);
			} else {
				var div = document.createElement('div');
				$.tmpl($("#tmpl_PasChangedEmailSend").trim(), {
					email: self.remindEmail.value
				}).appendTo(div);
				addPopup({
					dom: div,
					className: "sendPasPopup",
					close_button: true
				});
			}
		},
		error: function(xhr){
			self.connectionError(xhr,self.remindForm);
		},
		complete: function(){
			var error = self.json && self.json.error;
			var showRemindForm = error === "NOT_REGISTERED";
			self.redraw(showRemindForm);
		}
	});
};
SocialAuth.prototype.connectionError = function(xhr,form){
	if (this.formVisible) {
		try{this.hide(this.remindForm);} catch(e){}
		try{this.hide(this.regauthForm);} catch(e){}
	}
	checkAjaxError(xhr);
};
SocialAuth.prototype.parseError = function(json){
	var self = this;
	var err = json.error;
	switch (err) {
		case "EMAIL_NOT_VALID":
			if (self.isReg) {
				self.regEmail.addError();
				self.regEmail.input.focus();
			} else {
				self.authEmail.addError();
				self.authEmail.input.focus();
			}
			break;
		case "PWD_NOT_CONFIRMED":
			self.show(self.regauthForm);
			self.repeatPas.addError("passwordMatch");
			self.repeatPas.input.focus();
			break;
		case "PWD_TOO_SHORT":
			self.show(self.regauthForm);
			self.regPas.addError("lowRegPas");
			self.regPas.input.focus();
			break;
		case "USER_ALREADY_EXIST":
			addPopup({
				error: true,
				reason: l10n.popup.warning,
				comment: l10n.auth.popup.mailExist[0] + self.regEmail.value + l10n.auth.popup.mailExist[1],
				button: l10n.auth.popup.change,
				actionButton: function () { removePopup(); objSocialAuth.show(objSocialAuth.regauthForm); objSocialAuth.regEmail.input.focus(); }
			});
			break;
		case "PWD_EMPTY_OR_TOO_SMALL":
			self.show(self.regauthForm);
			self.authPas.addError("lowRegPas");
			self.authPas.input.focus();
			break;
		case "WEAK_PASSWORD":
			self.show(self.regauthForm);
			addPopup({
				error: true,
				reason: l10n.auth.popup.authError,
				comment: l10n.auth.popup.weakPassword,
				close_button: true,
				button: "Закрыть",
				removeOnAction: true
			});
			break;
		case "WRONG_PWD_OR_EMAIL":
			self.show(self.regauthForm);
			$(self.authErrorBlock).removeClass('invisible');
			break;
		case "REQUEST_LIMIT_REACHED":
			self.needCaptcha = true;
			self.show(self.regauthForm);
			$(self.authErrorBlock).removeClass('invisible');
			break;
		case "NOT_REGISTERED":
			self.show(self.remindForm);
			$(self.remindErrorBlock).removeClass('invisible');
			break;
		case "LIMIT_REACHED":
			addPopup({
				error: true,
				reason: l10n.auth.popup.authError,
				comment: l10n.auth.popup.limit,
				close_button: true,
				button: "Закрыть",
				removeOnAction: true
			});
			break;
		case "TOO_MANY_TRIES":
			addPopup({
				error: true,
				reason: l10n.auth.popup.authError,
				comment: l10n.auth.popup.tries,
				close_button: true,
				button: l10n.popup.close,
				removeOnAction: true
			});
			break;
		case "AUTH_WITH_PIN":
			window.pinAuth.showPinPopup();
			break;
		default:
			/*INTERNAL_ERROR etc*/
			addPopup({
				error: true,
				reason: l10n.auth.popup.authError,
				comment: l10n.popup.systemComment,
				close_button: true,
				button: l10n.popup.close,
				removeOnAction: true
			});
			break;
	}
};

SocialAuth.prototype.processAuth = function (json, errorParser) {
	var self = this;
	if (json.error) {
		self.redraw();
		if (errorParser)
			errorParser(json);
		else
			self.parseError(json);
	} else {
		self.updateUserData();
		if (self.onlyRedraw) {
			self.redraw();
		} else {
			self.reloadOrRedraw();
		}
		$(document).trigger({type: "visitormanager_auth_complete"});
		updateOverlayMenu();
	}
}

$(document).ready(function(){
	objSocialAuth = new SocialAuth();
});

function WelcomeRegister() {
	var self = this;
/*			  attempts = 0,
			  maxAttempts = 10,
			  timeout = 300,
			  show = function() {
				  attempts ++;
				  if (self.isNecessaryDataFetched()) {
					  self.showIfRequired();
				  }
				  else if (attempts <= maxAttempts) {
					  setTimeout(function() {
							show();
					  }, timeout);
				  }
			  };*/

	this.cityCode = null;
	this.cityName = null;
	this.cityField = null;
	this.emailField = null;
	this.formVisible = false;
	this.$emailField = null;
	this.$form = null;
	this.$modal = null;

    l10n.welcomeRegister = {
        "emailPlaceholder": "Ваша эл. почта",
        "cityPlaceholder": "Ваш город:",
        "change": "Изменить"
    };

/*	if (this.isNecessaryDataFetched()) {
		this.showIfRequired();
	}
	else if (!this.isPositionFetched()) {
		$(document).on("getPosition", show);
	}
	else if (!this.isAuthFetched()) {
		$(document).on("visitormanager_complete", show);
	}*/

	var removehints = function() {
		$('.hint').remove();
	};
	$(window).on('scroll', function(){
		removehints();
	});
	$(document).on("visitormanager_complete", function(){
		if(!window.tw.provider && !readCookie('welcome_reg') && tw.showWS) {
			self.show();
		}
	});
	$(document).on("searchStart", function(event){
		self.remove();
	});
}
/*WelcomeRegister.prototype.isAuthFetched = function() {
	return tw && tw.visitor && (tw.visitor.vid || tw.visitor.auth);
};
WelcomeRegister.prototype.isPositionFetched = function() {
	return tw && tw.position && tw.position.lat;
};
WelcomeRegister.prototype.isNecessaryDataFetched = function() {
	return this.isAuthFetched() && this.isPositionFetched();
};*/
/*WelcomeRegister.prototype.isRequired = function() {
	var params = tw.params,
			isGoogle = params.adwords,
			isBrandCampaign = params.adwords && params.adwords == 'Brand',
			isYandex = params.utm_campaign,
			isBrandRfCampaign = params.utm_campaign && params.utm_campaign == 'brand_RF',
			isNewsLetter = document.location.href.indexOf('_newsletter') > -1,
			isPayedAds = (isGoogle && !isBrandCampaign) || (isYandex && !isBrandRfCampaign),
			// TODO Пока только для русской аудитории
			isRussianLanguage = tw && tw.language && tw.language == 'ru',
			isLoggedIn = tw && tw.visitor && tw.visitor.auth;
	// Если заход с платного контекста
	// Весь платный трафик от Google, кроме кампании Brand
	// И весь платный трафик от Яндекса, кроме кампании brand_RF
	// Не для рассылок по почте
	return !isLoggedIn && isPayedAds && isRussianLanguage && isNewsLetter;
};*/
/*WelcomeRegister.prototype.showIfRequired = function() {
	if (this.isRequired()) {
		this.show();
	}
};*/
WelcomeRegister.prototype.show = function() {
	var data = {},
		modalId = 'WelcomeRegister',
		self = this,
		$modal = $('#' + modalId);

	if (!$modal.length) {
		if(browser.mobile) {
			this.$form = this.initializeModalHtml("tmpl_WelcomeBlock");
			 $('#layout_body').append(this.$form);
			 this.$modal = $('#WelcomeRegister');

			//$('<div class="wsMobile"></div>').appendTo( $('#layout_body') );
			//this.$form = this.initializeModalHtml("tmpl_wsWelcomeSprite");
			//$('.wsMobile').append( this.$form );
		} else {
			this.$form = this.initializeModalHtml("tmpl_WelcomePopup");
			this.$modal = $(this.addWelcomePopup(this.$form));
		}
	} else {
		if( !$(this.$modal).parent().is('#layout_body') ) {
			var elFade = fadeIn();
			$(elFade).one("click", function(){
				self.hide();
			});
			this.$modal.addClass("popup");
		}
		this.$modal.removeClass("invisible");
	}
	this.formVisible = true;

	kmqRecord({name: 'WelcomeScreen_Show'});
	try {
		ga('send', 'event', 'WelcomeScreen', 'push', 'show');
	} catch (e) {}

	setCookie({
		name: 'welcome_reg',
		value: 1,
		days: 180
	});
};

WelcomeRegister.prototype.addWelcomePopup = function(form) {
	appendTo = document.body;
	$('.popup').remove();
	fadeIn();
	$('#fadeBlock').css('opacity', 0.7);
	var $elPopup = form;

	var height = $elPopup.height();

	appendTo.appendChild($elPopup[0]);
	if (height === 0) {
		$elPopup[0].style.height = $elPopup[0].offsetHeight + "px";
	}
	setPosition();
	$elPopup[0].style.visibility = "visible";

	function setPosition(){
		if(($elPopup[0].offsetHeight + 40) > document.documentElement.clientHeight){
			$elPopup.css({
				"position": "absolute",
				"bottom": "auto",
				"top": $(window).scrollTop() + 20
			});
		} else {
			$elPopup[0].style.position = "fixed";
		}
	}
	$elPopup.resize(setPosition);

	$('.nthx span', $elPopup).on('click', function(){
		kmqRecord({name: 'WelcomeScreen_Close'});
		try {
			ga('send', 'event', 'WelcomeScreen', 'click', 'close');
		} catch (e) {}
		removePopup();
	});
	var tlink = document.createElement('label');
	$(tlink).addClass('change').attr('for','city').html( l10n.welcomeRegister.change );
	$('.suggestField', $elPopup).append(tlink);

	$('.close_button',$elPopup)
		.click(function(){
			kmqRecord({name: 'WelcomeScreen_Close'});
			try {
				ga('send', 'event', 'WelcomeScreen', 'click', 'close');
			} catch (e) {}
			removePopup();
		});

	return $elPopup[0];
};

WelcomeRegister.prototype.hide = function() {
	if (this.formVisible) {
		$('.hint').remove();
		fadeOut();
		this.$modal.removeClass("popup");
		this.$modal.addClass("invisible");
		this.formVisible = false;
	}
};
WelcomeRegister.prototype.remove = function() {
	removePopup();
	$('#WelcomeRegister').remove();
};
WelcomeRegister.prototype.initializeModalHtml = function(Id) {
	var self = this;
	var form,
		templateId = Id,
		$cityFieldContainer,
		$emailFieldContainer;

	if (!this.cityCode) {
		this.initializeCity();
	}

	form = $.tmpl($('#' + templateId).trim(), null)[0];

	$cityFieldContainer = $('.city-helper', form);
	$emailFieldContainer = $('.email-helper', form);

	this.cityField = new SuggestField({
		appendTo: $cityFieldContainer[0],
		name: "city",
		value: null,
		defaultValue: ""
	});
	$(this.cityField.input).on('focus', function(){
		$('.change', form).remove();
	});

	this.cityField.suggest = new Suggest(this.cityField, this, 99, {
		className: 'welcome-city-suggest',
		container: $cityFieldContainer[0],
		calculatePosition: false,
		maxItems: 5
	});
	if(this.cityName) {
		this.cityField.suggest.currentResult = this.cityCode;
		this.cityField.suggest.setCurrentResult();
		this.cityField.placeholder.value = "";
		this.cityField.suggest.placeholder.defaultValue = ref.getCityName(this.cityField.suggest.currentResult);
	}
	$(this.cityField.elField).append('<span class="city-label">'+ l10n.welcomeRegister.cityPlaceholder +'</span>')

	$(this.cityField.suggest).on("suggest-apply", function(event){
		try {
			if(self.cityField.suggest.currentResult) {
				self.cityCode = self.cityField.suggest.currentResult;
				self.cityField.suggest.placeholder.defaultValue = ref.getCityName(self.cityCode);
				self.cityField.placeholder.value = "";
			}
		} catch(e) {}
	});

	this.emailField = new Field({
		appendTo: $emailFieldContainer[0],
		autocomplete: 'on',
		name: "email",
		validate: true,
		type: "email"
	});
	this.$emailField = $('[name="email"]', form);
	this.$emailField.attr({placeholder: l10n.welcomeRegister.emailPlaceholder});
	this.$emailField.each(fakePlaceholder);

	$(form).submit(function(event) {
		event.preventDefault();
		self.register();
	});

	$('.already-registered', form).click(function(event) {
		event.preventDefault();
		self.hide();
	});

	return $(form);
};
WelcomeRegister.prototype.initializeCity = function() {
	var clientLatitude = tw.position.lat,
			  clientLongitude = tw.position.lng,
			  cities = ref.Cities,
			  cityData,
			  cityLatitude,
			  cityLongitude,
			  nearestCode,
			  shortestDistance,
			  distance;
	for (var code in cities) {
		cityData = cities[code];
		cityLatitude = cityData.lat;
		cityLongitude = cityData.lng;
		distance = this.getDistance(clientLatitude, clientLongitude, cityLatitude, cityLongitude);
		if (distance && (!shortestDistance || shortestDistance > distance)) {
			shortestDistance = distance;
			nearestCode = code;
		}
	}
	this.cityCode = nearestCode;
	this.cityName = nearestCode ? ref.getCityName(nearestCode) : null;
};
WelcomeRegister.prototype.getDistance = function(lat1, lon1, lat2, lon2) {
	var toRad = function(value) {
		return value ? value * Math.PI / 180 : value;
	},
		// km
			  R = 6371,
			  dLat = toRad(lat2 - lat1),
			  dLon = toRad(lon2 - lon1),
			  a,
			  c,
			  d;
	lat1 = toRad(lat1);
	lat2 = toRad(lat2);

	a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			  Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
	c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	d = R * c;
	return d;
};
// Метод, который вызывается саджестом
WelcomeRegister.prototype.update = function() {};
WelcomeRegister.prototype.register = function() {
	var self = this,
		email = this.$emailField.val(),
		data = {
			cityFrom: this.cityField.value || this.cityField.input.value || this.cityCode,
			email: email,
			generatePwd: true,
			source: "context_popup"
		};

	if (!this.checkRegForm()) {
		return;
	}

	$('input', this.$form).each(function(){
		$(this).attr('disabled', true);
		this.disabled = true;
	});

	$.ajax({
		iframeId: "pm",
		type: "post",
		dataType: "json",
		data: data,
		url: "/_api/visitormanager/register/",
		timeout: 10000,
		beforeSend: function(){
			kmqRecord({name: 'WelcomeScreen_Register'});
			try {
				ga('send', 'event', 'WelcomeScreen', 'click', 'register');
			} catch (e) {}

			self.startRequest();
			self.hide();
		},
		success: function(response){
			if (response.error) {
				self.parseError(response);
			} else {
				var obj = {email: email},
						  div = document.createElement('div');
				$.tmpl($("#tmpl_RegConfirm").trim(), obj).appendTo(div);
				addPopup({
					dom: div,
					className: "commonPopup regConfirm",
					close_button: true
				});
				self.remove();
			}
		},
		error: function(xhr){
			self.connectionError(xhr);
		},
		complete: function(){
			$('input', self.$form).each(function(){
				$(this).removeAttr('disabled');
				this.disabled = false;
			});
		}
	});
};
WelcomeRegister.prototype.startRequest = function(){
	$('.aside.loggedoff').addClass('invisible');
	//$('.loginLoader').removeClass('invisible');
};
WelcomeRegister.prototype.connectionError = function(xhr){
	if (this.formVisible) {
		try {
			this.hide();
		}
		catch(e) {
		}
	}
	checkAjaxError(xhr);
};
WelcomeRegister.prototype.checkRegForm = function() {
	var errors = 0;
	var errorField = null;

	if (!this.$emailField.val() || this.emailField.error) {
		errors++;
		this.emailField.addError();
		if (!errorField) {
			errorField = this.emailField;
		}
	}
	if (errors) {
		errorField.input.focus();
		return false;
	} else {
		$('.hint').remove();
		$('input', this.$form).each(function() {
			$(this).blur();
		});
		return true;
	}
};
WelcomeRegister.prototype.parseError = function(json){
	var self = this;
	var err = json.error;

	kmqRecord({name: 'WelcomeScreen_Error'});
	try {
		ga('send', 'event', 'WelcomeScreen', 'push', err);
	} catch (e) {}

	switch (err) {
		case "EMAIL_NOT_VALID":
			self.emailField.addError();
			self.emailField.input.focus();
			break;
		case "USER_ALREADY_EXIST":
			addPopup({
				error: true,
				reason: l10n.popup.warning,
				comment: "<p>Пользователь с почтой <b>" + self.emailField.value + "</b> уже существует.<br/>Введите другой email.</p>",
				close_button: true,
				button: "Указать другой email",
				actionButton: function () { removePopup(); objWelcomeRegister.show(); objWelcomeRegister.emailField.input.focus(); }
			});
			break;
		case "LIMIT_REACHED":
			addPopup({
				error: true,
				reason: l10n.auth.popup.authError,
				comment: l10n.auth.popup.limit,
				close_button: true,
				button: "Закрыть",
				removeOnAction: true
			});
			break;
		case "TOO_MANY_TRIES":
			addPopup({
				error: true,
				reason: l10n.auth.popup.authError,
				comment: l10n.auth.popup.tries,
				close_button: true,
				button: l10n.popup.close,
				removeOnAction: true
			});
			break;
		default:
			/*INTERNAL_ERROR etc*/
			addPopup({
				error: true,
				reason: l10n.auth.popup.authError,
				comment: l10n.popup.systemComment,
				close_button: true,
				button: l10n.popup.close,
				removeOnAction: true
			});
			break;
	}
};

$(function () {
	window.recaptcha = null;

	if ($.cachedScript) {
		$.cachedScript = function (url, options) {
			'use strict';
			// allow user to set any option except for dataType, cache, and url
			options = $.extend(options || {}, {
				dataType: "script",
				cache: true,
				url: url
			});

			// Use $.ajax() since it is more flexible than $.getScript
			// Return the jqXHR object so we can chain callbacks
			return jQuery.ajax(options);
		};
	}


	$.cachedScript('https://g.otthyper.com/recaptcha/api/js/recaptcha_ajax.js');
	$.cachedScript('https://www.google.com/recaptcha/api.js?hl=' + tw.language).done(function(script, textStatus ) {
		if (textStatus === 'success') {
			window.recaptchaInitialize = true;
		}
	});
});

function getCaptchaMethods(version){
	if(!version){
		return {
			create: function(key, popUp, params){
				return Recaptcha.create(key, popUp, params);
			},
			reset: function(option){
				return Recaptcha.reload(option);
			},
			getChallenge: function(option){
				return Recaptcha.get_challenge(option);
			},
			getResponce: function(option){
				return Recaptcha.get_response(option)
			},
			createData: function (challange, response) {
				return  {
					recaptcha_challenge_field: challange,
					recaptcha_response_field: response
				}
			},
			newVersion: false
		}
	}
	else{
		return {
			create: function(key, popUp, params){
				params.sitekey = key;
				return grecaptcha.render(popUp, params);
			},
			reset: function(){
				return grecaptcha.reset(this.captchaWidgetId);
			},
			getChallenge: function(option){
				return null;
			},
			getResponce: function(option){
				return grecaptcha.getResponse(option);
			},
			createData: function (challange, response) {
				return  {
					'g-recaptcha-response': response,
				}
			},
			newVersion: true
		}
	}
}

function CaptchaPopup (additionalData) {
	var newVersion = true;
	if(newVersion){
		this.RECAPTCHA_KEY = '6LePmCITAAAAAOMx5rQ7P-Ycs6rygGMBFxyxYLSS';
	}
	else{
		this.RECAPTCHA_KEY = '6LfU0eoSAAAAADwP8DZQB2TNu7dMTGUhUDQYCAsT';
	}
	this.additionalData = additionalData;
	this.CAPTCHA_URL = '/_api/captcha/check/';
	this.captcha = getCaptchaMethods(newVersion);
	this.tmp = $.tmpl($('#tmpl_captcha_form').trim());
}


CaptchaPopup.prototype.destroy = function(){

	if( this.$popup ) {
		this.$popup.remove()
	};

	if( !this.captcha.newVersion && Recaptcha ) {
		Recaptcha.destroy()
	};

	if (this.captcha.newVersion) {
		this.captcha.reset();
	}

	this.$popup = null;
};

CaptchaPopup.prototype._showLoading = function(){
	if(!this.$popup.find('.loadingOverlay')[0]){
		this.$popup.append($('<div/>',{class:'loadingOverlay'}));
	}
};

CaptchaPopup.prototype._hideLoading = function(){
	this.$popup.find('.loadingOverlay').remove();
};


CaptchaPopup.prototype.show = function(cb){
	var self = this;

	if (!recaptcha) {
		setTimeout( function() {
			if (!!window.recaptcha) {
				self._show(cb);
			} else {
				removeLoader();
				addPopup({
					error: true,
					reason: l10n.popup.warning,
					comment: l10n.popup.serverText,
					close_button: true,
					button: l10n.popup.close,
					actionButton: function () { window.location.href = '/'; }
				});
			}
		}, 10000 );
	} else {
		this._show(cb);
	}
};

CaptchaPopup.prototype._show = function (cb) {
	var self = this;
	if (window.recaptchaInitialize && typeof grecaptcha !== 'undefined') {
		if( !this.$popup ) self._draw();
		if( this.$popup.is(':visible') )return this.captcha.reset();

		this.$popup
			.fadeIn(500)
			.find('form')
			.on('submit',function(e){
				self._onSubmit(e,cb);
			})
			.end()
			.find('button')
			.on('click',function(e){
				self._onSubmit(e,cb);
			});
	} else {
		setTimeout(function() {
			self._show();
		}, 500);
	}
};

CaptchaPopup.prototype._onSubmit = function(e,cb){
	var self = this;
	e.preventDefault();
	this._showLoading();
	this._submit(self.captcha.getChallenge(), self.captcha.getResponce(self.captcha.captchaWidgetId), function(err,res){
		$.proxy(self._hideLoading(),self);
		cb(err,res);
	});
}

CaptchaPopup.prototype._draw = function(){
	if(this.$popup) this.destroy();

	var captchaParams = {
		theme: "white",
		lang : tw.language
	};

	this.$popup = $(addPopup({
		error: true,
		domClass: 'popup_content',
		close_button: false,
		reason: l10n.popup.warning,
		comment: this.tmp.html()
	})).hide();

	this.captcha.captchaWidgetId = this.captcha.create(this.RECAPTCHA_KEY, this.$popup.find('#recaptcha')[0], captchaParams);
};


CaptchaPopup.prototype._submit = function(challange, response, cb){
	var self = this;
	if((!self.captcha.newVersion && (!challange || !response)) || self.captcha.newVersion && !response){
		return cb('error');
	}

	var data = self.captcha.createData(challange, response);

	if (self.additionalData) {
		Object.keys(self.additionalData).forEach(function(key) {
			data[key] = self.additionalData[key];
		});
	}

	$.ajax({
		cache: false,
		dataType: "json",
		type: "POST",
		url: self.CAPTCHA_URL,
		data: data,
		timeout: 10000,
		success: function(json){
			cb(json.error,json.result);
		},
		error: function(){
			cb('error');
		}
	});
};

(function (window, document, location) {

    window['aviaAndHotelsSearch'] = Object.create(Object.prototype, {
        /**
         * PROPERTIES
         */

        /**
         * @private
         */
        _directions: {
            value: [],
            writable: true
        },
        /**
         * @private
         */
        _adults: {
            value: 1,
            writable: true
        },
        /**
         * @private
         */
        _children: {
            value: 0,
            writable: true
        },
        /**
         * @private
         */
        _isNewTab: {
            get: function () { return !!window.opener }
        },
        /**
         * @private
         */
        _isActivated: {
            get: function () {
                try {
                    return localStorage.isPopunderForHotelsActive === 'true';
                } catch (e) {}
                return false;
            }
        },
        /**
         * @private
         */
        _opener: {
            get: function () { return window.opener; }
        },


        /**
         * METHODS
         */

        /**
         * @public
         */
        updateData: {
            value: function (dataArg) {
                var data = dataArg || {};
                this._directions = this._getDirections(data.directions || []);
                this._adults = data.adults;
                this._children = data.children;

                if (this._opener) {
                    this._sendMessage();
                }
            }
        },
        /**
         * @public
         */
        openTabs: {
            value: function (dataArg) {
                var data = dataArg || {};
                var aviaLink =  data.aviaLink;

                if (this.isHotelsReadyToOpen()) {
                    window.open(aviaLink);

                    this._openHotelsInCurrentTab();
                } else {
                    location.href = aviaLink;
                }
            }
        },
		/**
		 * @public
		 */
		isHotelsReadyToOpen: {
			value: function () {
				return !this._isNewTab && this._isActivated;
			}
		},
        /**
         * @private
         */
        _getDirections: {
            value: function (data) {
                var self = this;
                return data.map(function (direction) {
                    return {
                        date: direction.date ? self._dateToStr(direction.date) : self._dateToStr(direction.startDate),
                        to: direction.to,
                        from: direction.from
                    };
                });
            }
        },
        /**
         * @private
         */
        _openHotelsInCurrentTab: {
            value: function () {
                location.href = this._getHotelsLink();
            }
        },
        /**
         * @private
         */
        _getHotelsLink: {
            value: function () {
                var path = this._getHotelsPath();
                var directions = this._directions || [];
                var firstDirection = directions[0] || {};
                var secondDirection = directions[1] || {};
                var search = [
                    'source=avia-search',
                    'type=iata',
                    'id=' + firstDirection.to,
                    'date_start=' + firstDirection.date,
					'adults=' + this._adults,
					'children=' + this._children

                ];
                if (directions.length !== 1) {
                    search.push('date_end=' + secondDirection.date);
                }
                return location.protocol + '//' + location.hostname + path + '?' + search.join('&');
            }
        },
        /**
         * @private
         */
        _getHotelsPath: {
            value: function () {
                var lang = location.pathname.split('/').reduce(function (lang, partOfPath) {
                    if (lang) {
                        return lang;
                    }
                    return partOfPath;
                }, '') || 'ru';
                return '/' + lang + '/hotels/';
            }
        },
        /**
         * @private
         */
        _dateToStr: {
            value: function (dateObj) {
                var date = new Date(+dateObj || +new Date(0)),
                    day = date.getDate(),
                    month = date.getMonth() + 1,
                    year = date.getFullYear();
                month = month < 10 ? '0' + month : month;
                day = day < 10 ? '0' + day : day;
                return year + '-' + month + '-' + day;
            }
        },
        /**
         * @private
         */
        _sendMessage: {
            value: function () {
                var origin = location.protocol + '//' + location.hostname;
                try {
                    this._opener.postMessage(JSON.stringify({
                        action: 'AVIA_SEARCH_UPDATE',
                        data: {
                            directions: this._directions,
                            adults: this._adults,
                            children: this._children
                        }
                    }), origin);
                } catch (e) {}
            }
        }
    });

}(window, document, location));

window.tw = window.tw || {};
tw.aviaSearchesCount=0;
var tmpl_FlightTypeButtons = '<div class="flightTypeButtons"><span class="oneway"></span><span class="round"></span><span class="multiway"></span></div>';
var tmpl_CalendarButton = '<div class="calendarButton"><div class="lineSpreader"> </div><div class="text">{{if date}}<div class="date">${date}</div><div class="month">${month}</div>{{else}}?{{/if}}</div></div>';
var tmpl_Hint = '<div class="hint ${$data.className}"><div class="abs"><div class="tl"></div><div class="tr"></div><div class="bl"></div><div class="br"></div><div class="t"></div><div class="r"></div><div class="b"></div><div class="l"></div><div class="c"></div><div class="arrUp"></div></div></div>';

tw.Footer = function(){
	this.layout = document.getElementById('layout_footer');
	this.init();
	this.show();
};
tw.Footer.prototype.init = function(){
	/*if (tw.language=='en') {
		this.initBanners();
		this.initLanguageSelect();
	}*/
	/*if (tw.language=='en') {
		this.initFooterMenu();
	}*/
};
tw.Footer.prototype.initBanners = function(){
	$('#layout_footer').prepend('<div id="layout_banners"><div class="spreader"><div class="banner_210x250"><a target="_blank" href="https://www.onetwotrip.co.uk/news/deals/solo-flyers-would-you-pay-extra-£-pick-your-seat-neighbour"><img src="/media/banner210x250-1.png" alt=""/></a></div><div class="banner_210x250"><a target="_blank" href="http://www.surveymonkey.com/s/X6SJBK6"><img src="/media/banner210x250-2.png" alt=""/></a></div><div id="banner_cheapTrips"><a target="_blank" href="http://www.booking.com/?aid=358564&label=Onetwotrip-Navtab-Text&lang=en&selected_currency=GBP"><img src="/media/banner210x250-hotels.png" alt=""/></a></div><div class="banner_300x250"><a target="_blank" href="/loyalty/rules/"><img src="/media/banner300x250.png" alt="OneTwoTrip Bonuses!"/></a></div></div></div>');
};
tw.Footer.prototype.initFooterMenu = function(){
	$('#layout_footerMenu').removeClass('invisible');
};
tw.Footer.prototype.initLanguageSelect = function(){
	$('#layout_language').removeClass('invisible');
};
tw.Footer.prototype.show = function(){
	$(this.layout).removeClass('invisible');
};

function initTicker(){
	tickerFrame = document.createElement("iframe");
	tickerFrame.id = 'ticker';
	tickerFrame.src = '/ticker.html?L=' + tw.language;
	tickerFrame.frameBorder = 'no';
	$(tickerFrame).css({'width': 0, 'height': 0});
	if(!browser.opera) {
		$(tickerFrame).css({'border-radius': 10});
	}
	document.body.appendChild(tickerFrame);
	$(document.body)
		.on("mapShow", function(){
			if(tickerFrame.contentWindow.objTicker && !tickerFrame.contentWindow.objTicker.close) {
				$(tickerFrame).removeClass('invisible');
			}
		})
		.on("changeRequest", function(){
			$(tickerFrame).addClass('invisible');
		});
}


function loadMapFiles() {
	var mapUrls = [
		"/js/extendedApi.js",
		"/js/map.js"
	];

	$('head').append($('<link rel="stylesheet"/>').attr('href', '/css/map.css'));

	for (var i in mapUrls) {
		$.ajax({
			dataType: "script",
			url: mapUrls[i],
			success: function(){
				mapUrls.shift();
				if (!mapUrls.length) {
					objMap = new Map();
					if( !objAvia.startSearch && !$('#layout_direction')[0] ) objMap.show();
				}
			}
		});
	}
}

function AirportFinder(lat, lng) {
	var kilometersPerGrad = 112.2;
	var citiesWithAirports = [];
	var radiusStep = 50;
	var i  = 1;
	while (citiesWithAirports.length < 1) {
		var currentRadius = i == 1 ? 200 : i * radiusStep;
		var gradSearchDelta = currentRadius / kilometersPerGrad;
		var latFrom = lat - gradSearchDelta;
		var latTo = lat + gradSearchDelta;
		var lngFrom = lng - gradSearchDelta;
		var lngTo = lng + gradSearchDelta;
		citiesWithAirports = getCloserCities(latFrom, latTo, lngFrom, lngTo);
		i++;
	}
	if(citiesWithAirports.length > 0){
		return citiesWithAirports;
	} else {
		return false;
	}
}
function getCloserCities(latFrom, latTo, lngFrom, lngTo){
	return getCloserPoint("Cities", latFrom, latTo, lngFrom, lngTo);
}
function getCloserAirports(latFrom, latTo, lngFrom, lngTo){
	return getCloserPoint("Airports", latFrom, latTo, lngFrom, lngTo);
}
function getCloserPoint(PointType, latFrom, latTo, lngFrom, lngTo) {
	var closerPoints = [];
	var curRef = ref[PointType];
	for(var i in curRef){
		var curPoint = curRef[i];
		if(curPoint.lat >= latFrom && curPoint.lat <= latTo && curPoint.lng >= lngFrom && curPoint.lng <= lngTo) {
			closerPoints.push(i);
		}
	}
	return closerPoints;
}

function RequestData(options){
	options = options || {};
	this.directions = [];
	this.cs = options.cs || "E";
}
RequestData.prototype.getRoute = function(){
	route = "";
	for (var i = 0, length = this.directions.length; i < length; i++) {
		var curDir = this.directions[i];
		if (curDir.from && curDir.to && curDir.date) {
			if (i == 1 && this.getFlightType() == "round") {
				route += curDir.date.stringifyAPI();
			} else {
				route += curDir.date.stringifyAPI() + curDir.from + curDir.to;
			}
		}
	}
	return route;
};
RequestData.prototype.getFullRoute = function(){
	route = "";
	for (var i = 0, length = this.directions.length; i < length; i++) {
		var curDir = this.directions[i];
		if (curDir.from && curDir.to && curDir.date) {
			if (i == 1 && this.getFlightType() == "round") {
				route += curDir.date.format('yyyymmdd');
			} else {
				route += curDir.date.format('yyyymmdd') + curDir.from + curDir.to;
			}
		}
	}
	return route;
};


RequestData.prototype.getKey = function(){
	key = this.getRoute();
	if(this.cs != "E"){
		key += "&" + this.cs;
	}
	return key;
};


RequestData.prototype.getFullKey = function(){
	key = this.getFullRoute();
	if(this.cs != "E"){
		key += "&" + this.cs;
	}
	return key;
};


RequestData.prototype.getFlightType = function(){
	var dirsCount = 0;
	for (var i = 0, length = this.directions.length; i < length; i++) {
		var curDir = this.directions[i];
		if (curDir.from && curDir.to && curDir.date) {
			dirsCount++;
		}
	}
	var fType = "multiway";
	if(dirsCount == 1){
		fType = "oneway";
	} else if(dirsCount == 2 && this.directions[0].from == this.directions[1].to && this.directions[0].to == this.directions[1].from) {
		fType = "round";
	}
	return fType;
};
function Direction(options){
	options = options || {};
	this.from = options.from || null;
	this.to = options.to || null;
	this.date = options.date || null;
}

tw.CSSelect = function(requestData){
	var self = this;
	this.el = document.getElementById("serviceClass");
	if(window.isSales) {
		$(this.el).remove();
	}
	if(!this.el) {
		return;
	}
	this.elLabel = document.getElementById("serviceClassLabel");
	this.elUl = document.getElementById("serviceClassList");
	this.init();
	this.firstClassCheck(requestData);
	this.clicked = false;

	$(this.el).click(function(event){
		if (self.visible) {
			self.hide();
		} else {
			kmqRecord({name:"serviceClassClick", obj: { auth: tw.visitor.auth, data: 'open' }, prefix: 'mainForm'});
			self.show();
		}
	});

	$(document.body).on('click', function(event){
		if (self.visible) self.hide();
	});
}

tw.CSSelect.prototype.init = function(){
	var self = this;
	$('li', this.elUl).on('click', function(){

		if (self.clicked) return;
		self.clicked = true;

		var data = $(this).data('cs');
		self.draw(data);

		kmqRecord({name:"serviceClassClick", obj: { auth: tw.visitor.auth, data: data }, prefix: 'mainForm'});

		$(document).trigger({
			type: 'cs_change',
			cs: data
		});
	});
};


tw.CSSelect.prototype.draw = function(cs){
	if ($(this.elCurClass).data('cs') != cs) {
		$(this.elCurClass).removeClass('invisible');
		this.elCurClass = $(this.elUl).find('li[data-cs="' + cs + '"]')[0];
		$(this.elCurClass).addClass('invisible');
		$(this.elLabel).html( $(this.elCurClass).text() );
	}
};


tw.CSSelect.prototype.show = function(){
	var self = this;

	$(this.el).addClass('isOpen');

	$(this.elUl).fadeIn(function(){
		self.visible = true;
	});
};


tw.CSSelect.prototype.hide = function(){
	var self = this;

	$(this.el).removeClass('isOpen');

	$(this.elUl).fadeOut(function(){
		self.visible = false;
		self.clicked = false;
	}, 0);
};


tw.CSSelect.prototype.firstClassCheck = function(requestData){
	var firstClassPointsArray = ['TH','US','AE','CA'];
	var showFirst = false;
	if(requestData) {
		this.cs = requestData.cs;
		for(var i=0, l = requestData.directions.length; i<l; i++) {
			var curDir = requestData.directions[i];
			var codeFrom = ref.getCountryCode(curDir.from);
			var codeTo = ref.getCountryCode(curDir.to);
			if($.inArray(codeFrom,firstClassPointsArray) > -1 || $.inArray(codeTo,firstClassPointsArray) > -1) {
				showFirst = true;
				break;
			}
		}
	} else {
		this.cs = "E";
	}
	if(this.cs == "F") {
		showFirst = true;
	}
	if(showFirst && this.cs != "F") {
		$(this.elUl).find('li[data-cs="F"]').removeClass('invisible');
	} else {
		$(this.elUl).find('li[data-cs="F"]').addClass('invisible');
	}
	this.draw(this.cs);
};


function recentSearches() {
	var self = this;
	this.el = document.getElementById("recentSearches");
	this.elLabel = document.getElementById("recentSearchesLabel");
	this.elUl = document.getElementById("recentSearchesList");
	this.draw();
	this.clicked = false;

	$(document.body)
		.on("changeRequest", function(){
			self.draw();
		})
		.on('click', function(event){
			if (self.visible) {
				self.hide();
			}
		});

	$(this.el).click(function(event){
		if (self.visible) {
			self.hide();
		} else {
			event.stopPropagation();
			self.show();
		}
	});
}

recentSearches.prototype.draw = function(){
	var self = this;
	this.elUl.innerHTML = '';
	var count = 0;
	var searchRoute = "";
	if(objSearchForm && objSearchForm.lastRequest) {
		searchRoute = objSearchForm.lastRequest.split('&')[0];
		searchRoute += objSearchForm.data.cs; //в ластреквест эконом класс не пишется, в отличие от остальных, потому и сплитуем изначально
	}

	for (var i = 0, n = 0, length = tw.requestsList.length; i < length && n < 5; i++) {
		var data = tw.requestsList[i];
		if(data && data.searchKey && (data.searchKey + data.cs != searchRoute) && data.getFlightType() != "multiway") {
			count++;
			dataKey = data.getKey();
			var elLi = document.createElement("li");
			elLi.className = data.cs + ' item';
			if (objAvia.currentRequestKey === dataKey) {
				$(elLi).addClass("selected");
			} else {
				elLi.style.zIndex = length - i;
			}
			var elA = document.createElement("a");
			elA.href = "#" + dataKey;
			this.drawItem(elA, data);
			$(elA).click({
				objData: data
			}, function(event){
				if(self.clicked){ return; }
				self.clicked = true;
				objAvia.changeRequest(objAvia.addDataToRequestsList(event.data.objData));
			});
			elLi.appendChild(elA);
			var elClose = document.createElement("span");
			elClose.className = "close";
			$(elClose).click({
				objData: data
			}, function(event){
				event.stopPropagation();
				objAvia.removeDataFromRequestsList(event.data.objData);
				self.draw();
			});
			elLi.appendChild(elClose);
			this.elUl.appendChild(elLi);
			n++;
		}
	}

	if (count> 0) {
		$(this.el).removeClass('invisible');
	} else {
		$(this.el).addClass('invisible');
		return;
	}
};

recentSearches.prototype.drawItem = function(appendTo, data){
	var elRoute = document.createElement("span");
		elRoute.className = "route";
		/*if(length < 4)*/ elRoute.innerHTML = ref.getPointName(data.directions[0].from);
		//else elRoute.innerHTML = data.directions[0].from;
		if (data.getFlightType() == "oneway") elRoute.innerHTML += " → ";
		else elRoute.innerHTML += " ⇄ ";
		/*if(length < 4)*/ elRoute.innerHTML += ref.getPointName(data.directions[0].to);
		//else elRoute.innerHTML += data.directions[0].to;
	var elDate = document.createElement("span");
		elDate.className = "date";

	var innerHTML;

	if (tw.language === 'en-us') {
		if ( data.getFlightType() === "oneway" ) {
			innerHTML = l10n.calendar.months_S[data.directions[0].date.getMonth()] + '&nbsp;' + data.directions[0].date.getDate();
		} else if ( data.directions[0].date.getMonth() == data.directions[1].date.getMonth() ) {
			innerHTML =
				l10n.calendar.months_S[data.directions[1].date.getMonth()]
				+ '&nbsp;'
				+  data.directions[0].date.getDate() + '&#8239&ndash;&#8239;' + data.directions[1].date.getDate();

		} else {
			innerHTML =
				l10n.calendar.months_S[data.directions[0].date.getMonth()] + '&nbsp;' + data.directions[0].date.getDate()
				+ "&#8239&ndash;&#8239;"
				+ l10n.calendar.months_S[data.directions[1].date.getMonth()] + '&nbsp;' + data.directions[1].date.getDate();
		}
	} else {
		if ( data.getFlightType() === "oneway" ) {
			innerHTML = data.directions[0].date.getDate() + '&nbsp;' + l10n.calendar.months_S[data.directions[0].date.getMonth()];
		} else if ( data.directions[0].date.getMonth() == data.directions[1].date.getMonth() ) {
			innerHTML =
				data.directions[0].date.getDate()
				+ '&#8239&mdash;&#8239;'
				+ data.directions[1].date.getDate() + "&nbsp;" + l10n.calendar.months_S[data.directions[1].date.getMonth()];
		} else {
			innerHTML =
				data.directions[0].date.getDate() + '&nbsp;' + l10n.calendar.months_S[data.directions[0].date.getMonth()]
				+ "&#8239&ndash;&#8239;"
				+ data.directions[1].date.getDate()+ '&nbsp;' + l10n.calendar.months_S[data.directions[1].date.getMonth()];
		}
	}

	if(['ru', 'ru-ua', 'uk-ua'].indexOf(tw.language) > -1) {
		innerHTML = innerHTML.toLowerCase();
	}

	elDate.innerHTML = innerHTML;

	appendTo.appendChild(elRoute);
	if(data.cs !== "E") {
		appendTo.appendChild(document.createTextNode(", " + l10n.index.search.cls[data.cs]));
	}
	appendTo.appendChild(document.createTextNode(", "));
	appendTo.appendChild(elDate);
};

recentSearches.prototype.show = function(){
	var self = this;

	$(this.el).addClass('isOpen');

	$(this.elUl).fadeIn(function(){
		self.visible = true;
	});
};

recentSearches.prototype.hide = function(){
	var self = this;

	$(this.el).removeClass('isOpen');

	$(this.elUl).fadeOut(function(){
		self.visible = false;
		self.clicked = false;
	});
};

function isResults(){
	var layoutResults = document.getElementById("layout_results");
	return layoutResults && !!layoutResults.getElementsByTagName('*').length;
}


function hideResults(){
	var layoutResults = document.getElementById("layout_results");
	if(isResults()){
		$(layoutResults).animate({
			opacity: '0'
		}, 500, function(){
			$(this).empty();
			$(document.body).trigger("resultsHide");
		});
	}
}
function clearBody(callback){
	var elLayoutBody = document.getElementById("layout_body");
	if (window.objMap) objMap.hide();
	$('#layout_results').empty();
	$('#layout_footer').remove();
	var comparePrice = function(){
		appendLoader({
			appendTo: elLayoutBody,
			text: l10n.loaders.moment
		});
		//commercial
			try {
				$(document.body).trigger("removeMiddleSearchRotation");

				var data = objAvia.parseKey(objAvia.currentRequestKey);
				var from = data.directions[0].from;
				var to = data.directions[0].to;
				var targets = {
					countryFrom: ref.getCountryCode(from),
					cityFrom: ref.getCityCode(from),
					countryTo: ref.getCountryCode(to),
					cityTo: ref.getCityCode(to)
				};
				var keyword = [
					'O_CNT_' + targets.countryFrom,
					'O_CITY_' + targets.cityFrom,
					'D_CNT_' + targets.countryTo,
					'D_CITY_' + targets.cityTo
				];
				switch(data.cs) {
					case 'B':
						keyword.push('CS_BUSINESS');
						break;
					case 'F':
						keyword.push('CS_FIRST');
						break;
					case 'W':
						keyword.push('CS_PREMIUM');
						break;
					default:
						keyword.push('CS_ECONOMY');
						break;
				}

				var airFranceKeyWord = getAdButlerKeywords('airFrance', targets.countryFrom, targets.cityTo);
				pushSearchPromoKeyword(airFranceKeyWord);

				var tapPortugalKeyWord = getAdButlerKeywords('tapPortugal', targets.cityFrom, targets.cityTo);
				pushSearchPromoKeyword(tapPortugalKeyWord);

				var airEuropeKeyWord = getAdButlerKeywords('airEurope', targets.cityFrom, targets.cityTo);
				pushSearchPromoKeyword(airEuropeKeyWord);

				function pushSearchPromoKeyword(KeyWord) {
					if (KeyWord) {
						keyword.push(KeyWord);
					}
				}

				var config = {
					banerId: 'adfox_15131626581234573',
					pp: 'h',
					ps: 'cprr',
					p2: 'fpbh',
					partnerAdfox: true,
				}
				if (~window.location.href.indexOf('www.onetwotrip')) {
					config.banerId = 'adfox_149216737788628611';
					config.ps = 'cmck';
					config.partnerAdfox = false;
				}

				$('#layout_body').append('<div id='+ config.banerId +'></div>');

				var options = {
					keyword: keyword,
					onload: function() {
						$('#loader').animate({
							"margin-top": -15
						});
					},
					needMeta: false,
					partnerAdfox: config.partnerAdfox,
				};

				adfoxInitComBlock({
					ownerId: 255389,
					containerId: config.banerId,
					pp: config.pp,
					ps: config.ps,
					p2: config.p2,
					pk: tw.partner ? tw.partner.partnerId : ''
				}, options);
			} catch(e) {}
	};

	if (isResults()) {
		$(document.getElementById("layout_results"))
			.animate({
				opacity: '0'
			}, 500, function(){

				$(this).empty();
				if (callback) {
					callback();
				} else {
					comparePrice();
				}
			});

	} else if (callback) {
		callback();
	} else {
		comparePrice();
	}
}

tw.deferred.getAviaSerpVersion = $.Deferred();
function Avia(){
	var self = this;

	this.today = (new Date()).cutTime();
	this.yesterday = new Date(this.today);
	this.yesterday.setDate(this.yesterday.getDate() - 1);

	this.min = new Date(this.yesterday);
	this.max = new Date();
	this.max.setDate(this.max.getDate() + 360);
	tw.requestsList = [];
	this.getAviaSerpVersion();
	this.loadRoutes();
	this.getURLData();
}


Avia.prototype.saveRoutes = function(){
	var routes = [];
	for(var i = 0, n = 0, length = tw.requestsList.length; i < length && n < 5; i++){
		if (tw.requestsList[i].getFlightType() != "multiway") {
			var key = tw.requestsList[i].getFullKey();
			routes[n] = key;
			n++;
		}
	}
	makeCookie("routes", JSON.stringify(routes), 90);
};


Avia.prototype.loadRoutes = function(){
	var routesCookieValue = readCookie("routes");

	if(routesCookieValue && routesCookieValue != ''){
		try {
			var routes = JSON.parse(routesCookieValue);
		}
		catch(ex){

		}

		if (routes) {
			for (var i = 0, length = routes.length; i < length; i++) {
				var data = this.parseFullKey(routes[i]);
				if(data){
					tw.requestsList.push(data);
				}
			}
		}
	}
};


Avia.prototype.getURLData = function (h) {
	var params = tw.params;
	var fullHashString = decodeURI(h || document.location.hash).substr(1);
	if(params.sr_readquery && params.r) {
		fullHashString = params.r + fullHashString;
	};
	fullHashString = this.extendHashWithQueryParameters(fullHashString);
	var fullhash = fullHashString.split('?')[0].split('|');
	var hash = fullhash[0];
	 /*
	 var searchHash = hash.split('&');
	 if($.inArray("s", searchHash) > -1) {
	 searchHash.splice($.inArray("s", searchHash),1);
	 hash = searchHash.join('&');
	 params.s = true;
	 alert(1)
	 }
	 */
	params.s = true;

	if (fullhash.length > 1) {
		tw.source = {
			fullhash: "|" + fullhash.slice(1).join('|'),
			route: fullhash[0],
			ak: fullhash[1],
			dir: fullhash[2],
			p: tw.params.p || "1,0,0",
			hrefsearch: true
		};

		for (var HashInd = 3, HashL = fullhash.length; HashInd < HashL; HashInd++) {
			var curHash = fullhash[HashInd];
			var hashStr = curHash.split("=");
			tw.source[hashStr[0]] = hashStr[1];
			if (HashInd == HashL - 1 && hashStr.length == 1 && !tw.source.marker) {
				tw.source.marker = hashStr[0];
			}
		}

		if (tw.source.amup) {
			setCookie({
				name: "amup",
				value: tw.source.amup
			});
		}

		if (tw.source.tag) {
			tw.isRedirector = true;

			if (tw.source.tag == 'aviasales') {
				setCookie({
					name: 'ppm',
					value: fullHashString,
					days: 1
				});
			}

			if (tw.source.tag === '__direct') {
				delete tw.source.tag;
			}

			this.lastSourceMarker = tw.source.marker;
			saveReferrerInfo(tw.source.tag, tw.source.marker);
		} else {
			deleteCookie({
				name: 'source'
			});
		}
	} else {
		// inform seo project in case of moving processReferrerVisit
		processReferrerVisit();
	}

	if (!hash) {
		var directions = location.pathname.match(/([A-Z]{3}\-[A-Z]{3})\/?$/);
		if (directions) {
			hash = directions[1].replace('-', '');
		}
	}

	var data = this.parseKey(hash, true);
	if (data) {
		if (data.directions[0] && data.directions[0].from && data.directions[0].to && !data.directions[0].date) {
			this.noDataDirection = data.directions[0];
		} else {
			this.noDataDirection = false;
			//this.addDataToRequestsList(data);
			this.currentRequestKey = data.getKey();
			window.location.hash = this.currentRequestKey;
			if (params.s || fullhash.length > 1) {
				this.startSearch = true;
			}
		}
	}

	return data;
};

Avia.prototype.extendHashWithQueryParameters = function(hashString) {
	var hash = hashString.split('|');

	if (getParameterByName('r') && !hash.length) {
    	hash.push(getParameterByName('r'));
	}

	if (getParameterByName('a') && hash.length === 1) {
		hash.push(getParameterByName('a'));
	}

	if (getParameterByName('d') && hash.length === 2) {
		hash.push(getParameterByName('d'));
	}

	extendedWithParameter(hash, 'f', 'fn');
	extendedWithParameter(hash, 't', 'tag');
	extendedWithParameter(hash, 'p', 'pas');
	extendedWithParameter(hash, 'mrk', 'marker');

	return hash.join('|');
};


Avia.prototype.parseKey = function(key, directionWithoutDate){
	if (key.length >= 10 || directionWithoutDate) {
		var arrKey = key.split("&");
		var route = arrKey[0];
		var data = new RequestData();
		var length = Math.ceil(route.length / 10);
		for (var i = 0; i < length; i++) {
			var dirStr = route.substr((i * 10), 10);

			if (dirStr.length == 10) {
				var date = Date.parseAPI(dirStr.substr(0, 4));
				var from = dirStr.substr(4, 3);
				var to = dirStr.substr(7);
			} else if (dirStr.length == 4) {
				var date = Date.parseAPI(dirStr.substr(0, 4));
				var from = data.directions[(i - 1)].to;
				var to = data.directions[(i - 1)].from;
			} else if(directionWithoutDate && dirStr.length == 6) {
				var date = null;
				var from = dirStr.substr(0, 3);
				var to = dirStr.substr(3, 6);
			} else {
				return null;
			}

			if (date && !(this.min.getTime() <= date.getTime() && date.getTime() <= this.max.getTime())) {
				return null;
			}
			if(i > 0 && date && date.getTime() < data.directions[i - 1].date.getTime()){
				return null;
			}
			if (ref.testPoint(from) && ref.testPoint(to) && (date || (directionWithoutDate && dirStr.length == 6)) ) {
				if(tw.source && tw.source.tag){
					from = ref.getCityCode(from);
					to = ref.getCityCode(to);
				}
				data.directions.push(new Direction({
					from: from,
					to: to,
					date: date
				}));
			} else {
				return null;
			}
		}
		if (arrKey[1] && ~['E','B','F','W'].indexOf(arrKey[1])){
			data.cs = arrKey[1];
		}
		if (data.directions.length > 0){
			return data;
		} else {
			return null;
		}
	} else {
		return null;
	}
};


Avia.prototype.parseFullKey = function(key){
	if (key.length >= 14) {
		var arrKey = key.split("&");
		var route = arrKey[0];
		var data = new RequestData();
		var length = Math.ceil(route.length / 14);
		for (var i = 0; i < length; i++) {
			var dirStr = route.substr((i * 14), 14);
			if (dirStr.length == 14) {
				var date = Date.parseAPI(dirStr.substr(0, 8));
				var from = dirStr.substr(8, 3);
				var to = dirStr.substr(11);
			} else if (dirStr.length == 8) {
				var date = Date.parseAPI(dirStr);
				var from = data.directions[(i - 1)].to;
				var to = data.directions[(i - 1)].from;
			} else {
				return null;
			}
			if (date && !(this.min.getTime() <= date.getTime() && date.getTime() <= this.max.getTime())) {
				return null;
			}
			if(i > 0 && date && date.getTime() < data.directions[i - 1].date.getTime()){
				return null;
			}
			if (ref.testPoint(from) && ref.testPoint(to)) {
				if(data.searchKey) {
					data.searchKey += date.format('ddmm');
				} else {
					data.searchKey = date.format('ddmm') + from + to;
				}
				data.directions.push(new Direction({
					from: from,
					to: to,
					date: date
				}));
			} else {
				return null;
			}
		}
		if (arrKey[1]){
			data.cs = arrKey[1];
		}
		return data;
	} else {
		return null;
	}
};


Avia.prototype.addDataToRequestsList = function(data){
	var key = data.getKey();
	for (var i = (tw.requestsList.length - 1); i >= 0; i--) {
		var item = tw.requestsList[i];
		if (item.getKey() == key) {
			data = item;
			tw.requestsList.splice(i, 1);
		}
	}
	//в tw.request мы добавляем ключи только при загрузки страницы, если у нас остаётся направление но меняется класс или даты (страница не перегружается), приходится добавлять ключ тут (
	if(!data.searchKey) {
		data.searchKey = key.split('&')[0];
	}
	tw.requestsList.unshift(data);
	if (data.getFlightType() != "multiway") {
		this.saveRoutes();
	}
	return data;
};


Avia.prototype.removeDataFromRequestsList = function(data){
	var key = data.getKey();
	for (var i = (tw.requestsList.length - 1); i >= 0; i--) {
		var item = tw.requestsList[i];
		if (item.getKey() == key) {
			tw.requestsList.splice(i, 1);
		}
	}
	this.saveRoutes();
};

Avia.prototype.getAviaSerpVersion = function () {
	var self = this;
	$.when(tw.deferred.visitormanagerGet, tw.deferred.getPartner).then(function() {
		var referrer = readCookie('referrer') || '';
		var url = '/_api/searching/serpVersion?source=' +  referrer;

		$.ajax({
			cache: true,
			dataType: "json",
			timeout: 2000,
			url: url,
			success: function(json) {
				self.serpVersionLoad = true;
				self.serpVersionData = json;
			},
			complete: function() {
				self.serpVersionLoad = true;
				tw.deferred.getAviaSerpVersion.resolve();
			}
		});
	});
};

Avia.prototype.goToNewSerp = function(data) {
	var url = '/' + this.getSEOPath(data, true) + '#/search/' + data.searchKey + '?sc=' + data.cs;

	var passengers = tw.passengers || {};

	var adultsCount = passengers.adult || 1;
	var childrenCount = passengers.children || 0;
	var infantsCount = passengers.infants || 0;

	var childrenAges = [];

	for (var c = 0; c < childrenCount; c++) {
		// 2 - возраст ребнка
		childrenAges.push(2)
	}

	for (var i = 0; i < infantsCount; i++) {
		// 0 - возраст младенца
		childrenAges.push(0);
	}

	url += '&ac=' + adultsCount;

	if (childrenAges.length > 0) {
		url += '&ca=' + childrenAges.join('_');
	}
	if (tw.params.srcmarker) {
		url += '&srcmarker=' + tw.params.srcmarker;
	}
	location.href = url;
};

Avia.prototype.getSEOPath = function(data, newSerp){
	var direction = data.directions[0],
	    from = direction.from,
	    to = direction.to,
	    newSerpPath = newSerp ? '/f' : '',
	    mainPath = [tw.language + newSerpPath, (l10n && l10n.url && l10n.url.flights) || 'flights'],
	    citiesPath = [ref.getCity(from).en.toLowerCase(), ref.getCity(to).en.toLowerCase()],
	    directionsPath = [ref.getCityCode(from), ref.getCityCode(to)],
        path = mainPath.join('/') + '/' + citiesPath.join('-') + '_' + directionsPath.join('-') + '/';
    return path.replace(/\s/g, '-');
};
Avia.prototype.changeRequest = function(data, SearchForm, isKey){
	var self = this;
	if (checkVilniusAirportWarning(data)) {
		return;
	}

	if (this.serpVersionData && this.serpVersionData.serpVersion >= 200) {
		try {
			this.goToNewSerp(data);
			return;
		} catch (e) {
			if (typeof trackJs !== 'undefined') {
				trackJs.track('Go to new serp error: ' + e.message);
			}
		}
	}

	this.startSearch = true;
	this.currentRequestKey = data.getKey();

	$(document.body).trigger({
		type: 'changeRequest',
		requestKey: this.currentRequestKey
	});

	var path = this.getSEOPath(data),
        searchParams = location.search
			.replace(/&mrk=[^#&]+/, '')
			//если есть заменяем на всякий на адекватное значение

			.replace(/([?&])p=[^&#]*/g, '\$1p=' + tw.passengers.getStrCountPassenger())
			.replace(/&sr_readquery=\w+/, ''),
		primaryPath = location.hostname + '/' + path,
		passengers = tw.passengers || {};

	searchParams = addGetParam(searchParams, (/([?&])p=/).test(searchParams) ? null : getPassengersSrcMarker());
	searchParams = addGetParam(searchParams, this.lastSourceMarker ? 'mrk=' + this.lastSourceMarker : null);

	var isSameUrl = !!~location.href.indexOf(primaryPath + searchParams),
		hasSearchGetParametr = (/([?&])s[=&]/).test(searchParams) || (/([?&])s$/).test(searchParams);
	appSessionStorage.setItem('openLastSearchResult', 'avia');

	try { // safe change data
		aviaAndHotelsSearch.updateData({
			directions: data.directions,
			adults: passengers.adult,
			children: passengers.children + passengers.infants
		});
	} catch (e) {}

	if (isSameUrl) {
		this.drawResults(data);
		//страница загружена на поиске и нет параметра s
		if (!hasSearchGetParametr) {
			searchParams = addGetParam(searchParams, 's=true');
			if (history.pushState) {
				history.pushState(null, '', searchParams + '#' + this.currentRequestKey);
			} else {
				//for IE9
				searchParams = addGetParam(searchParams, 's=true');
				location.href = location.protocol + '//' + primaryPath + searchParams + '#' + this.currentRequestKey;
			}
		} else {
			location.hash = this.currentRequestKey;
		}
	} else {
		if (!hasSearchGetParametr) {
			searchParams = addGetParam(searchParams, 's=true');
		}
		var aviaLink = location.protocol + '//' + primaryPath + searchParams + '#' + this.currentRequestKey;
		try { // safe open
			// off
			throw new Error("off hotels tab for search");
			if (isKey === 'link') { // check if it is native click on button
				aviaAndHotelsSearch.openTabs({
					aviaLink: aviaLink
				});
			} else {
				location.href = aviaLink;
			}
		} catch (e) {
			location.href = aviaLink;
		}
	}

	function getPassengersSrcMarker () {
		if (isKey === 'deals') {
			//пользователь пришел воспользовавшись готовыми предложениями
			//отдаем ему только 1 взрослого (пересоздаем со стандартным значением)
			tw.passengers = new Passengers();
		}
		var needUrlPassengersParams = !getURLParams().p && ('1,0,0' !== tw.passengers.getStrCountPassenger());
		return needUrlPassengersParams ? 'p=' + tw.passengers.getStrCountPassenger() : '';
	}

	function addGetParam(searchParams, param) {
		if (!param || (typeof param !== "string")) {
			return searchParams;
		}
		return searchParams + (searchParams && searchParams.length !== 0 ? '&' : '?') + param;
	}
};
Avia.prototype.drawResults = function(data){
	var self = this;
	clearExtraElements();
	if (data.json) {
		clearBody(function(){
			DrawFares(data);
		});
	} else {
		clearBody();
		this.getFares(data);
	}
};

// need for hotels tab (for fast open)
Avia.prototype.getFromCache = function (callback) {
	var data = {};
	var hasData = false;
	try {
		data = JSON.parse(localStorage.lastAviaSearchingResults) || {};
		localStorage.lastAviaSearchingResults = "";
		delete localStorage.lastAviaSearchingResults;
		hasData = !!data.id;
		$(function () {
			$('#layout_body, #form_aviaSearch').hide();
			callback(data);
		});
	} catch (e) {

	}
	return hasData;
};

Avia.prototype.getFares = function(data){
	if (checkVilniusAirportWarning(data)) {
		removeLoader();
		return;
	}

	var self = this;
	var params = tw.params.twiket ? tw.params : {};

	var passengerTypesToRequest = getPassengerTypesFromParams(tw.params.p);

	params.ad = passengerTypesToRequest.ad;
	params.cn = passengerTypesToRequest.cn;
	params['in'] = passengerTypesToRequest['in'];

	params.cs = data.cs;
	params.route = data.getRoute();

	params.serpVersion = 100;

	if (tw.isRedirector) {
		params.isRedirector = true;
		delete tw.isRedirector;
	}

	if(tw.source && tw.source.ak && tw.source.hrefsearch){
		params.redirect_ac = tw.source.ak;
	}

	if (tw.source && params.route != tw.source.route.split('&')[0] && tw.aviaSearchesCount>0) {
		delete tw.source;
	}

	tw.bookingParams = {};
	try {
		var portalReferrerCookieData = readReferrerInfo();
		if(portalReferrerCookieData.tag){
			params.source = portalReferrerCookieData.tag;
			tw.bookingParams.source = params.source;
		}

		if(portalReferrerCookieData.marker){
			params.srcmarker = portalReferrerCookieData.marker;
			tw.bookingParams.srcmarker = params.srcmarker;
		}
	} catch(e){}

	if(tw.params.srcmarker){
		params.srcmarker = tw.params.srcmarker;
	}

	if (tw.params.is2ow4rt){
		params['2ow'] = tw.params.is2ow4rt;
	}
	if (tw.params.promocode){
		params.promocode = tw.params.promocode;
	}

	if (tw.params.restoreSearchSession){
		params.restoreSearchSession = tw.params.restoreSearchSession;
	}

	if (tw.params.dumpSearchSession){
		params.dumpSearchSession = tw.params.dumpSearchSession;
	}

	if (tw.currency){
		params.currency = tw.currency;
	}

	var requestParams = getRequestParams(false);
	$.extend(params, requestParams);

	//noseats param
	params.ott4862 = true;

	//kmqStats
	var today = new Date(),
		startDate = Date.parseAPI(params.route.substring(0,4)),
		endDate,
		DepthSearch = parseInt( Math.floor( (startDate.valueOf() - today.valueOf())/(86400000) ), 10),
		StartMonth = startDate.getMonth()+1,
		Duration = 0;

	if(params.route.length == 14) {
		endDate = Date.parseAPI(params.route.substring(10,14));
		Duration = parseInt( Math.floor( ( endDate - startDate ) / 86400000 ) );
	}
	var pointFrom = params.route.substring(4,7),
		pointTo = params.route.substring(7,10),
		countryFrom = ref.getCountryCode(pointFrom),
		cityFrom = ref.getCityCode(pointFrom),
		countryTo = ref.getCountryCode(pointTo),
		cityTo = ref.getCityCode(pointTo),
		TypeRoute = kmqRouteType(params.route),
		FlightType = (countryFrom==countryTo)?'DOM':'INT';

	tw.searchFlight = {
		"startDate": startDate.format('yyyymmdd'),
		"endDate": endDate ? endDate.format('yyyymmdd') : "",
		"DepthSearch": DepthSearch,
		"StartMonth": StartMonth,
		"pointFrom": pointFrom,
		"cityFrom": cityFrom,
		"countryFrom": countryFrom,
		"pointTo": pointTo,
		"cityTo": cityTo,
		"countryTo": countryTo,
		"TypeRoute": TypeRoute,
		"FlightType": FlightType,
		"Duration": Duration
	};

	if(tw.source && tw.source.tag) {
		tw.searchFlight.source = tw.source.tag;
	}

	$(document).trigger({
		"type": "searchStart"
	});

	tw.aviaSearchesCount++;
	var requestOptions = {
		repeats: 2,
		backupRepeats: true,
		RetryFunction: function(){
			MakeRequest();
		},
		ErrorFunction: function(){
			removeLoader();
			if (window.objMap) objMap.show();
			objSearchForm.update();
		}
	};
	window.replaceLocation();
	params.ad = tw.passengers.adult;
	params.cn = tw.passengers.children;
	params.in = tw.passengers.infants;

	function searchResultSuccess(json) {
		self.rawJSON = json;
		if (json.error == 'REQUEST_LIMIT_REACHED') {
			var captcha = new CaptchaPopup();
			captcha.show(function captchaHandler(err, res) {
				if (err || !res) {
					captcha.show(captchaHandler);
				} else {
					captcha.destroy();
					removePopup();
					self.getFares(data);
				}
			});
			return;
		}

		$(document).trigger({
			"type": "searchFinish",
			"searchRoute": params.route
		});
		data.json = json;
		tw.currencyRates = json.rates;
		tw.env = json.env;

		var kmqParams = {};
		if (self.currentRequestKey == data.getKey()) {
			self.drawResults(data);
			if (tw.oResult) {
				kmqParams = {
					"avia_TotalFlightsCount": tw.oResult.DefaultAllFlights.length,
					"avia_FilteredFlightsCount": tw.oResult.allFlights.length,
					"avia_AirlinesCount": tw.oResult.AKlist.count,
					"avia_DirectFlights": tw.oResult.DirectFlightArrayIndex.length
				};
			}
		}

		if (json.timings && json.timings.timings) {
			kmqParams["avia_SearchTime"] = json.timings.timings[json.timings.timings.length - 1];
		}
		_kmq.push(['set', kmqParams]);
	}

	var gettedFromCache = self.getFromCache(searchResultSuccess);
	if (!gettedFromCache) {
		MakeRequest();
	}
	function MakeRequest(){
		tw.deferred.getAviaSerpVersion.always(function() {
			if (self.serpVersionData && self.serpVersionData.serpVersion >= 200) {
				try {
					self.goToNewSerp(data);
					return;
				} catch (e) {
					if (typeof trackJs !== 'undefined') {
						trackJs.track('Go to new serp error: ' + e.message);
					}
				}
			}
			$.ajax({
				type: "get",
				cache: false,
				dataType: "json",
				url: "/_api/searching/startSync2/",
				data: params,
				timeout: 70000,
				success: searchResultSuccess,
				complete: function(xhr, errorMessage){
					xhr.url = this.url;
					checkAjaxError(xhr, requestOptions, errorMessage);
					//mixpanel
					try {
						MPSaveSearchInfo();
					} catch (e) {}
				}
			});
		});
	}
};

function SearchForm1(callback) {
	var self = this;
	var requestKey;

	tw.passengers = new Passengers( window.getURLParams().p );
	this.lastRequest = null;
	if (requestKey) {
		this.data = objAvia.parseKey(requestKey);
		this.data.flightType = this.data.getFlightType();
		if (this.data.flightType == "multiway" && this.data.directions.length < 4) {
			this.data.directions.push(new Direction());
		}
	} else if (objAvia.currentRequestKey) {
		this.data = objAvia.parseKey(objAvia.currentRequestKey);
		this.data.flightType = this.data.getFlightType();
		if (this.data.flightType == "multiway" && this.data.directions.length < 4) {
			this.data.directions.push(new Direction());
		}
	} else {
		this.data = new RequestData();
		this.data.directions[0] = new Direction();
		if(tw.params.ow) {
			this.data.flightType = "oneway";
		} else {
			this.data.directions[1] = new Direction();
			this.data.flightType = "round";
		}
		if (objAvia.noDataDirection) {
			this.data.directions[0].from = objAvia.noDataDirection.from;
			this.data.directions[0].to = objAvia.noDataDirection.to;
			if(!tw.params.ow) {
				this.data.directions[1].from = this.data.directions[0].to;
				this.data.directions[1].to = this.data.directions[0].from;
			}
		}
	}

	this.initialize.call(this, callback);
}

SearchForm1.prototype.initialize = function (callback) {
	var self = this;

	this.el_topPanel2 = document.getElementById('topPanel2');

	var preparedPathname = location.pathname.replace(/\//g, '');

	this.formABTest = (!preparedPathname.length || preparedPathname === tw.language) && window.isFormABTest;

	if (this.formABTest) {
		$(document.documentElement).addClass('formABTest');
	}

	this.elForm = this.formABTest ? $.tmpl($('#tmpl_FormAviaABTest').trim())[0] : $.tmpl($('#tmpl_FormAvia').trim())[0];

	this.elDirTongueFTRS = $('#dirTongueFTRS', this.elForm)[0];
	this.elDirTongue = $('#dirTongue', this.elForm)[0];

	this.$elFlightLabel = $.tmpl($('#tmpl_RouteLabel').trim());
	this.$elFlightLabel.click( function(event){
		event.stopPropagation();
		self.hideFlightLabel();
	}).prependTo(this.elForm);

	this.link_clickOutsideFlightLabel = function(e){
		var layoutDirection = document.getElementById("layout_direction");
		if(!$(e.target).closest('#form_aviaSearch')[0] && isResults() && !layoutDirection && !$(e.target).closest('.passengerChooser__chooser')[0] ) {
			self.showFlightLabel();
		}
	};

	$(this.elForm).submit(function(event) {
		event.preventDefault();
		kmqRecord({name:"submit", obj: { auth: tw.visitor.auth }, prefix: 'mainForm'});
	});

	try {
		if (this.formABTest) {
			if (window.isFormAviaHotels) {
				this.loadHotelsSearchForm();
			} else {
				throw 'Load old form';
			}
		} else {
			ga('send', 'event', 'error', 'hotels_avia_form_with_tabs', 'load_fail', {
				nonInteraction: true
			});
			throw 'Load old form';
		}
	} catch (e) {
		$(this.elForm).on('click', '#hotelsLinkFormAB', function (e) {
			e.preventDefault();
			ga('send', 'event', 'all_main', 'click', 'search');
			location.href = e.currentTarget.href;
		});
	}

	//Dm.Loskutov 2DEL?
	// Loskutov to Andy: do not delete
	this.link_submit = function(){
		self.onSubmit('link');
	};

	this.initFlightTypeLinks();
	this.setForm();
	this.link_changeRequest = function() {
		self.changeRequest();
	};

	$(document.body).on("changeRequest.regenForm", this.link_changeRequest);
	this.el_topPanel2.appendChild(this.elForm);
	this.show();

	//Dm.Loskutov 2DEL or !2DEL
	// Loskutov to Andy: do not delete
	if (objAvia.currentRequestKey && objAvia.startSearch) {
		this.onSubmit('startSearch');
	} else {
		//метод вызываетя уже в this.show() пару строк выше
		//this.update();
	}

	//Dm.Loskutov 2DEL?
	// Loskutov to Andy: do not delete
	if (this.checkData()) {
		this.onSubmit('dates');
	}

	if(!objAvia.startSearch) {
		$('#layout_direction').fadeIn(1500);
	}
	this.chooserPassengers = new ChooserPassengers();
	$('.passengerChooser__changer').click(function(){
		//чтобы перехватить в момент всплытие события (т.е. после изменения счетчика)
		setTimeout(function(){
			self.checkCountPassengers();
		}, 10);
	});

	callback && callback();
};

SearchForm1.prototype.changeRequest = function(){
	this.stopUpdate = true;
	this.lastRequest = objAvia.currentRequestKey;
	this.data = objAvia.parseKey(objAvia.currentRequestKey);
	this.data.flightType = this.data.getFlightType();
	this.setFlightType(this.data.flightType);
	this.setForm();
	this.fillForm();
	this.stopUpdate = false;
	this.update();
	this.setFlightLabel();
	this.showFlightLabel();
};

SearchForm1.prototype.loadHotelsSearchForm = function () {
	var isFlightActive = false;
	var isPackagesActive = false;
	var isRoomsShow = false;
	var cleanedParams = function () {
		var params = app.tools.getURLParams(),
			clean = [
				'checkin',
				'checkout',
				'id',
				'type',
				'name',
				'children',
				'childrenAges',
				'adults'
			];
		clean.forEach(function (val) {
			delete params[val];
		});
		return params;
	};

	var checkBackgroundHeight = function () {
		var className = '';
		if ((isFlightActive && !isPackagesActive) || isRoomsShow) {
			className = 'high';
		}
		if (isFlightActive && !isPackagesActive && isRoomsShow) {
			className = 'veryHigh';
		}
		$('#form_hotelsSearch').removeClass('high veryHigh').addClass(className);
	};

	var elem = document.querySelector('#form_hotelsSearch .hotelsContainer'),
		params = cleanedParams();
	ReactDOM.render(React.createElement(window.app.appSearch, {
		searchHotels: false
	}), elem);

	Backbone.on('formWithTabs', function (opts) {
		var form_hotelsSearch = document.getElementById('form_hotelsSearch'),
			form_aviaSearch = document.getElementById('form_aviaSearch'),
			options = opts || {},
			type = options.type || '',
			init = !!options.init;
		isPackagesActive = false;
		if (init) {
			ga('send', 'event', 'all_main', 'show', 'search_' + type, {
				nonInteraction: true
			});
		}
		switch (type) {
			case 'hotels':
				form_aviaSearch.style.display = 'none';
				form_hotelsSearch.style.display = 'block';
				break;
			case 'tours':
				// form_aviaSearch.style.display = 'none';
				// form_hotelsSearch.style.display = 'block';
				// break;
			case 'railways':
			case 'avto':
			case 'buses':
			case 'activities':
				break;
			case 'avia':
			default:
				form_aviaSearch.style.display = 'block';
				form_hotelsSearch.style.display = 'none';
				break;
		}
		checkBackgroundHeight();
	});

	Backbone.on('payload', function (opts) {
		var options = opts || {},
			action = options.action || '',
			data = options.data || {};
		switch (action) {
			case 'clickOnFlightCheckbox':
				isFlightActive = !data.isActive;
				break;
			default:
				return true;
		}
		checkBackgroundHeight();
	});

	Backbone.on('appRooms.show', function () {
		isRoomsShow = true;
		checkBackgroundHeight();
	});

	Backbone.on('openHotelsSearch', function () {
		appSessionStorage.setItem('openLastSearchResult', 'hotels');
	});

	$(this.elForm).on('click', '#hotelsLinkFormAB', function(e) {
		e.preventDefault();
		ga('send', 'event', 'all_main', 'click', 'search_hotels');
		Backbone.trigger('formWithTabs', {
			type: 'hotels',
			skipEvent: true
		});
	});
	$(this.elForm).on('click', '#aviaLinkFormAB', function(e) {
		e.preventDefault();
		ga('send', 'event', 'all_main', 'click', 'search_avia');
		Backbone.trigger('formWithTabs', {
			type: 'avia',
			skipEvent: true
		});
	});
	$(this.elForm).on('click', '#railwaysLinkFormAB', function(e) {
		var href = this.href;
		e.preventDefault();
		ga('send', 'event', 'all_main', 'click', 'search_railways');
		setTimeout(function () {
			location.href = href;
		}, 500);
	});
	$(this.elForm).on('click', '#carsLinkFormAB', function(e) {
		var href = this.href;
		e.preventDefault();
		ga('send', 'event', 'all_main', 'click', 'search_avto');
		setTimeout(function () {
			location.href = href;
		}, 500);
	});
	$(this.elForm).on('click', '#activitiesLinkFormAB', function(e) {
		var href = this.href;
		e.preventDefault();
		ga('send', 'event', 'all_main', 'click', 'search_activities');
		setTimeout(function () {
			location.href = href;
		}, 500);
	});
	$(this.elForm).on('click', '#busesLinkFormAB', function(e) {
		var href = this.href;
		e.preventDefault();
		ga('send', 'event', 'all_main', 'click', 'search_buses');
		setTimeout(function () {
			location.href = href;
		}, 500);
	});
	$(this.elForm).on('click', '#toursLinkFormAB', function(e) {
		var href = this.href;
		e.preventDefault();
		ga('send', 'event', 'all_main', 'click', 'search_tours');
		// Backbone.trigger('formWithTabs', {
		// 	type: 'tours',
		// 	skipEvent: true,
		// });
		setTimeout(function () {
			location.href = href;
		}, 500);
	});

	var triggerDefaultDate = function (opts) {
        var self = this,
            options = opts || {},
            today = new Date(),
            currentDayOfWeek = today.getDay(),
            startDateFromURL = options.hasStartDate,
            endDateFromURL = options.hasEndDate,
            year,
            month,
            day,
            startDate,
            endDate,
            startDateFromStorage = app.appStorage.getItem({
                name: 'lastSearchDateIn'
            }),
            endDateFromStorage = app.appStorage.getItem({
                name: 'lastSearchDateOut'
            }),
            startDateStorage = app.tools.toDate(startDateFromStorage),
            endDateStorage = app.tools.toDate(endDateFromStorage),
            isStartDateNotExpired = +today < +startDateStorage && !!startDateStorage,
            isEndDateNotExpired = +today < +endDateStorage && !!endDateStorage && +startDateStorage < +endDateStorage,
            isNotExpired = isStartDateNotExpired && isEndDateNotExpired;
        if (startDateFromURL && !endDateFromURL && +today < +startDateFromURL) {
            endDateFromURL = new Date(+startDateFromURL);
            endDateFromURL.setDate(endDateFromURL.getDate() + 1);
            Backbone.trigger('calendar.date.update', {
                type: 'dateIn',
                date: startDateFromURL
            });
            Backbone.trigger('calendar.date.update', {
                type: 'dateOut',
                date: endDateFromURL
            });
        } else if (!startDateFromURL || !endDateFromURL) {
            if (currentDayOfWeek === 4 || currentDayOfWeek === 5 || currentDayOfWeek === 6 || currentDayOfWeek === 0) {
                today.setDate(today.getDate() + 4);
            }
            while (!(today.getDay() === 0 || today.getDay() === 6)) {
                today.setDate(today.getDate() + 1);
            }
            year = today.getFullYear();
            month = today.getMonth();
            day = today.getDate();
            startDate = new Date(year, month, day);
            endDate = new Date(year, month, day + 1);
            Backbone.trigger('calendar.date.update', {
                type: 'dateIn',
                date: isNotExpired ? startDateStorage : startDate
            });
            Backbone.trigger('calendar.date.update', {
                type: 'dateOut',
                date: isNotExpired ? endDateStorage : endDate
            });
        }
    };

	triggerDefaultDate();
	Backbone.trigger('appInit.show');

	$(function () {
		var isReferrerEmpty = !document.referrer;
		var isBackFromAviaSearch = appSessionStorage.getItem('openLastSearchResult') === 'avia';
		var tab = params.tab || (!isReferrerEmpty || isBackFromAviaSearch ? 'avia' : 'hotels');
		Backbone.trigger('formWithTabs', {
			type: tab, // to switch tab to avia change to 'avia',
			init: true
		});
		$('#topMenu_avia').removeClass('selected');
	});
};

SearchForm1.prototype.fillForm = function() {
	for (var i = 0, length = this.data.directions.length; i < length; i++) {
		var dirRow = this.dirRows[i];
			dirRow.fromField.suggest.setByCode(this.data.directions[i].from);
			dirRow.toField.suggest.setByCode(this.data.directions[i].to);
			dirRow.dateFrom.setDate(this.data.directions[i].date);
		if (this.data.flightType == "round") {
			dirRow.dateTo.setDate(this.data.directions[1].date);
			break;
		}
	}
};


SearchForm1.prototype.setForm = function() {
	this.dirRows = this.dirRows || [];
	for (var i = 0, length = this.data.directions.length; i < length; i++) {
		if (!this.dirRows[i]) this.dirRows[i] = this.addDirectionRow(i);
		if (this.data.flightType == "round") break;
	}
	if (this.dirRows.length > this.data.directions.length || this.data.flightType == "round" && this.dirRows.length > 1) {
		$(this.dirRows[this.dirRows.length - 1].layout).remove();
		this.dirRows.pop();
		this.setForm();
	}
};


SearchForm1.prototype.addDirectionRow = function(n){
	var self = this;
	var dataDirection = this.data.directions[n];
	var dirRow = {};

	if (n === 0) {
		dirRow.layout = $(".dirRow1", this.elForm)[0];

		this.elSubmitButton = this.elForm.submit;

		dirRow.dateTo = new DateField({
			appendTo: $(".dateTo", dirRow.layout)[0],
			name: "date" + 1,
			directionNumber: 1,
			value: this.data.directions[1] ? this.data.directions[1].date : '',
			defaultValue: l10n.index.search.returnDate,
			oForm: this
		});

		var $dateTo = $(dirRow.dateTo.input);
		$dateTo
			.parent('.suggestField')
				.click(function(){
					setTimeout(function(){
						$dateTo.focus();
					}, 0);
				});

		if (this.data.flightType === 'round') {
			$(dirRow.layout).addClass('round');
			$('td.dateTo', dirRow.layout).removeClass('invisible');
		}
	} else {
		dirRow.layout = ( this.formABTest ? $.tmpl($('#tmpl_Direction_formABTest').trim())[0] : $.tmpl($('#tmpl_Direction').trim())[0]);
	}

	dirRow.fromField = new SuggestField({
		appendTo: $(".directionFrom", dirRow.layout)[0],
		name: "from" + n,
		value: dataDirection.from,
		defaultValue: l10n.index.search.from
	});

	dirRow.fromField.suggest = new Suggest(dirRow.fromField, this, n);
	$(dirRow.fromField.input).focus(function(){
		self.checkGeodata();
	});

	dirRow.toField = new SuggestField({
		appendTo: $(".directionTo", dirRow.layout)[0],
		name: "to" + n,
		value: dataDirection.to,
		defaultValue:  l10n.index.search.to
	});

	dirRow.toField.suggest = new Suggest(dirRow.toField, this, n);
	$(dirRow.toField.input).focus(function(){
		self.checkGeodata();
	});

	dirRow.dateFrom = new DateField({
		appendTo: $(".dateFrom", dirRow.layout)[0],
		name: "date" + n,
		directionNumber: n,
		value: dataDirection.date,
		defaultValue: this.data.flightType == "round" ? l10n.index.search.departDate : l10n.index.search.whenDate,
		oForm: this
	});

	var $dateFrom = $(dirRow.dateFrom.input)
	$dateFrom.focus(function(){
		self.checkGeodata();
	})
	.parent('.suggestField')
		.click(function(){
			setTimeout(function(){
				$dateFrom.focus()
			}, 0);
		});

	if (n != 0) {
		this.elDirTongue.appendChild(dirRow.layout);
	}
	return dirRow;
};


SearchForm1.prototype.initFlightTypeLinks = function() {
	var self = this;
	this.flightType = $('#flightType', this.elForm);
	this.flightTypeLinks = $('#flightTypeLinks li', this.flightType);
	$('#flightTypeLinks', this.flightType).on('click', 'li:not(.selected)', function(){
		var type = '';
		if ($(this).hasClass("oneway")) {
			type = 'oneway';
		} else if ($(this).hasClass("round")) {
			type = 'round';
		} else {
			type = 'multiway';
		}
		self.setFlightType(type);

		kmqRecord({name:"flightType", obj: { auth: tw.visitor.auth, type: type }, prefix: 'mainForm'});
	});
	$(this.flightTypeLinks).filter("." + this.data.flightType).addClass("selected");
};

SearchForm1.prototype.setClassForForm = function(flightType) {
	var arrPossible = ['round', 'oneway', 'multiway'],
		elem = $(".dirRow1"),
		i;
	for (i = 0; i < arrPossible.length; i++) {
		if (arrPossible[i] == flightType) {
			elem.addClass(arrPossible[i]);
		} else {
			elem.removeClass(arrPossible[i]);
		}
	}
};
SearchForm1.prototype.setFlightType = function(flightType) {
	var selected = $(this.flightTypeLinks).filter('.selected');
	if (!$(selected).hasClass(flightType)) {
		$(selected).removeClass('selected');
		$(this.flightTypeLinks).filter("." + flightType).addClass('selected');
		this.formABTest && this.setClassForForm(flightType);
		if (this.data.flightType != flightType) {
			var length = this.data.directions.length;
			this.data.directions.splice(1, length - 1);
			if (flightType != "oneway") this.data.directions[1] = new Direction();
			this.data.flightType = flightType;
		}

		if (this.data.flightType === 'round') {
			this.formABTest || $(this.dirRows[0].layout).addClass('round');
			this.formABTest || $('td.dateTo', this.dirRows[0].layout).removeClass('invisible');
			this.dirRows[0].dateTo.dropDate();
			this.dirRows[0].dateFrom.placeholder.defaultValue = l10n.index.search.departDate;
		} else {
			this.formABTest || $(this.dirRows[0].layout).removeClass('round');
			this.formABTest || $('td.dateTo', this.dirRows[0].layout).addClass('invisible');
			this.dirRows[0].dateFrom.placeholder.defaultValue = l10n.index.search.whenDate;
		}
		this.dirRows[0].dateFrom.setPlaceholder();
		this.setForm();
		this.update(true);
	}
};


SearchForm1.prototype.setCS = function(cs) {
	if (this.data.cs != cs) {
		this.data.cs = cs;
		this.update();
	}
};


SearchForm1.prototype.update = function(needFocus) {
	if (this.stopUpdate) return;
	this.updateFields(needFocus);
	this.checkData();
	$(document).trigger({
		type: 'searchRequest_change',
		request: this.data
	});
	if (window.objMap && window.objMap.visible) {
		objMap.setData(this.data);
		if (this.data.flightType != "multiway") { //polylines
			var showPoly = true;
			for (var i = 0, DirLength = this.data.directions.length; i < DirLength; i++) {
				if(!this.data.directions[i].date) {
					showPoly = false;
				}
			}
			if (!showPoly) return;
			var from1 = this.dirRows[0].fromField;
			var to1 = this.dirRows[0].toField;
			if (this.tempStartPoint != from1.value) {
				ClearPolylineFlights();
				if (ref.testPoint(from1.value) && to1.value && to1.value != '') {
					initPolylineRoutes(from1.value + '' + to1.value);
				}
				this.tempStartPoint = from1.value;
			}
			if (this.tempEndPoint != to1.value) {
				ClearPolylineFlights();
				if (ref.testPoint(to1.value) && from1.value && from1.value != '') {
					initPolylineRoutes(from1.value+''+to1.value);
				}
				this.tempEndPoint = to1.value;
			}
			if (!from1.value || !to1.value) {
				ClearPolylineFlights();
				this.tempStartPoint = null;
				this.tempEndPoint = null;
			}
		} else {
			ClearPolylineFlights();
			this.tempStartPoint = null;
			this.tempEndPoint = null;
		}
	}
};


SearchForm1.prototype.updateFields = function(needFocus){
	var focus = null;
	for (var i = 0, length = this.dirRows.length; i < length; i++) {
		var dirRow = this.dirRows[i];
		var dataDir = this.data.directions[i];

		if (dataDir.from != dirRow.fromField.value && dirRow.fromField.value) needFocus = true;
		dataDir.from = dirRow.fromField.value;
		if (this.data.flightType == "round") {
			this.data.directions[1].to = dataDir.from;
		}

		if (dataDir.to != dirRow.toField.value && dirRow.toField.value) needFocus = true;
		dataDir.to = dirRow.toField.value;
		if (this.data.flightType == "round") {
			this.data.directions[1].from = dataDir.to;
		}

		if (dataDir.date != dirRow.dateFrom.date && dirRow.dateFrom.date) needFocus = true;
		dataDir.date = dirRow.dateFrom.date;
		if (this.data.flightType == "round") {
			this.data.directions[1].date = dirRow.dateTo.date;
		}

		if (needFocus) {
			if (!dataDir.from && !focus) {
				focus = dirRow.fromField.input;
			}
			if (!dataDir.to && !focus) {
				focus = dirRow.toField.input;
			}
			if (dataDir.from && dataDir.to) {
				if (!dataDir.date && !focus) {
					focus = dirRow.dateFrom.input;
				}
				/*if (this.data.flightType == "round" && !this.data.directions[1].date && !focus) {
					focus = dirRow.dateTo.input;
				}*/
			}
		}

		if (this.data.flightType == "multiway") {
			if (i == (length - 1)) {
				if (length < 4) {
					if (dataDir.from || dataDir.to) {
						this.data.directions.push(new Direction());
						this.setForm();
						this.update();
						break;
					}
				}
				if (length > 2) {
					if (!dataDir.from && !dataDir.to && !this.data.directions[i - 1].from && !this.data.directions[i - 1].to) {
						this.data.directions.pop();
						this.setForm();
						this.update();
						break;
					}
				}
			}
		}

		if (focus && !focus.field.focus && !$('#fadeBlock')[0]) {
		  setTimeout(function(){
		    $(focus).focus();
		  }, 5);
		}
	}
};


SearchForm1.prototype.checkGeodata = function() {
	for (var i = 0, length = this.dirRows.length; i < length; i++) {
		if (this.data.flightType == "round" && i == 1) break;

		var dirRow = this.dirRows[i];

		var fromField = dirRow.fromField;
		if (!fromField.value && fromField.geocodeValue && !fromField.focus) {
			fromField.input.value = null;
			fromField.suggest.currentResult = null;
			fromField.suggest.setCurrentResult();
			fromField.suggest.setPlaceholder();
		}

		var toField = dirRow.toField;
		if (!toField.value && toField.geocodeValue && !toField.focus) {
			toField.input.value = null;
			toField.suggest.currentResult = null;
			toField.suggest.setCurrentResult();
			toField.suggest.setPlaceholder();
		}
	}
};

SearchForm1.prototype.checkCountPassengers = function () {
	if (tw.passengers.getStrCountPassenger() != getURLParams().p) {
		$(this.elForm).off("submit", this.link_submit);
		this.elSubmitButton.disabled = false;
		$(this.elSubmitButton).removeClass('disabled');
		$(this.elForm).on("submit", this.link_submit);
	} else {
		$(this.elForm).off("submit", this.link_submit);
		this.elSubmitButton.disabled = true;
		$(this.elSubmitButton).addClass('disabled');
	}
};
SearchForm1.prototype.checkData = function() {
	var dataFilled = this.wrongDates = this.wrongRoute = false;

	for (var i = 0, length = this.data.directions.length; i < length; i++) {
		var dataDir = this.data.directions[i];
		if (this.data.flightType == "round" && i == 1 && dataFilled && !dataDir.date) {
			break;
		}
		if (dataDir.date || dataDir.from || dataDir.to) {
			if (!dataDir.date || !dataDir.from || !dataDir.to) {
				dataFilled = false;
				break;
			} else {
				if(this.data.directions[i - 1]){
					if (dataDir.date < this.data.directions[i - 1].date) {
						this.wrongDates = true;
					}
				}
				if(dataDir.from == dataDir.to){
					this.wrongRoute = true;
				}
				dataFilled = true;
			}
		}
	}
	if (dataFilled && this.lastRequest != this.data.getKey()) {
		$(this.elForm).off("submit", this.link_submit);
		this.elSubmitButton.disabled = false;
		$(this.elSubmitButton).removeClass('disabled');
		$(this.elForm).on("submit", this.link_submit);
		return true;
	} else {
		$(this.elForm).off("submit", this.link_submit);
		this.elSubmitButton.disabled = true;
		$(this.elSubmitButton).addClass('disabled');
	}

	return false;
};

SearchForm1.prototype.prepareData = function () {
	var data = this.data.getKey();
	data = objAvia.parseKey(data);
	data = objAvia.addDataToRequestsList(data);

	return data;
};

SearchForm1.prototype.onSubmit = function(isKey) {
	if (this.wrongRoute) {
		addPopup({
			error: true,
			reason: l10n.popup.warning,
			comment: l10n.index.search.popup.checkDirections,
			close_button: true,
			button: l10n.popup.close,
			removeOnAction: true
		});
		return;
	}
	if (this.wrongDates) {
		addPopup({
			error: true,
			reason: l10n.popup.warning,
			comment: l10n.index.search.popup.checkDates,
			close_button: true,
			button: l10n.popup.close,
			removeOnAction: true
		});
		return;
	}

	$(this.elForm).off("submit", this.link_submit);
	this.elSubmitButton.disabled = true;
	$(this.elSubmitButton).addClass('disabled');

	var data = this.prepareData();

    objAvia.changeRequest(data, this, isKey);
};

SearchForm1.prototype.buildLinkData = function (data) {
	var checkinDate = data.directions[0].date;
	var checkoutDate = data.directions[1] ? data.directions[1].date : checkinDate;
	var duration = ( checkoutDate - checkinDate ) / 86400000;

	if(duration > 21){
		checkoutDate = new Date( +checkinDate + 22 * 86400000 );
	} else if(duration < 1){
		checkoutDate = new Date( +checkinDate + 1 * 86400000 );
	}

	return {
		checkinDate: checkinDate,
		checkoutDate: checkoutDate,
		city: data.directions[0].to,
		adults: 2,
		children: 0,
		flightClass: data.cs
	};
};
SearchForm1.prototype.showFlightLabel = function(){
	var self = this;
	this.setFlightLabel();
	if (!this.formABTest) {
		$(this.elDirTongue).addClass("invisible");
		$(this.flightType).addClass("invisible");
		$(this.dirRows[0].layout).addClass('invisible');
		this.$elFlightLabel.removeClass("invisible");
	}
};


SearchForm1.prototype.hideFlightLabel = function(){
	var self = this;
	this.$elFlightLabel.addClass("invisible");
	$(this.dirRows[0].layout).removeClass('invisible');
	$(this.elDirTongue).removeClass("invisible");
	$(this.flightType).removeClass("invisible");
};


SearchForm1.prototype.setFlightLabel = function() {
	var elContent = $(".content", this.$elFlightLabel)[0];
		elContent.innerHTML = "";
	var letterCount = 0;
	var max = 52;
	for (var i = 0, length = this.data.directions.length; i < length; i++) {
		var dir = this.data.directions[i];

		if (dir.from) {
			letterCount += ref.getPointName(dir.from).length;
		} else {
			letterCount += 1;
		}

		if (dir.to) {
			letterCount += ref.getPointName(dir.to).length;
		} else {
			letterCount += 1;
		}

		if (dir.date) {
			if (dir.date.getDate() < 10) letterCount += 5; else letterCount += 6;
		} else {
			letterCount += 1;
		}

		if (this.data.getFlightType() == 'round') {
			if (this.data.directions[i + 1].date) {
				if (this.data.directions[i + 1].date.getDate() < 10) letterCount += 5; else letterCount += 6;
			} else letterCount += 1;
			break;
		}
	}

	var _dir = this.data.directions[3];
	if (_dir && (_dir.from || _dir.to || _dir.date)) {
		$(elContent).addClass('content--smallText');
	} else {
		$(elContent).removeClass('content--smallText');
	}

	for (var i = 0, length = this.data.directions.length; i < length; i++) {
		var dir = this.data.directions[i];
		if (dir.from || dir.to || dir.date) {
			if (elContent.innerHTML != "") {
				//elContent.innerHTML += '<span class="date">,</span> ';
				elContent.innerHTML += ', ';
			}

			var elFlight = document.createElement("span");
					elFlight.className = "flight";

			if (dir.from) {
				if (letterCount < max) {
					elFlight.innerHTML += ref.getPointName(dir.from);
				} else {
					elFlight.innerHTML += dir.from;
				}
			} else {
				elFlight.innerHTML += "…";
			}

			if (this.data.getFlightType() == 'round') {
				elFlight.innerHTML += ' ⇄ ';
			} else {
				elFlight.innerHTML += ' → ';
			}

			if (dir.to) {
				if (letterCount < max) {
					elFlight.innerHTML += ref.getPointName(dir.to);
				} else {
					elFlight.innerHTML += dir.to;
				}
			} else {
				elFlight.innerHTML += "…";
			}
			elContent.appendChild(elFlight);

			var dateFormates = {
				'en-us': 'mmm d'
			};
			var dateFormat = dateFormates[ tw.language ] || 'd mmm';

			if (this.data.getFlightType() == 'round') {
				if ( dir.date && this.data.directions[i + 1].date && dir.date.getMonth() == this.data.directions[i + 1].date.getMonth() ){
					if( tw.language === 'en-us' ) {
						elContent.innerHTML += ' <span class="date">' + dir.date.format(dateFormat) + " — " + this.data.directions[i + 1].date.getDate() + '</span>';
					} else {
						elContent.innerHTML += ' <span class="date">' + dir.date.getDate() + " — " + this.data.directions[i + 1].date.format(dateFormat) + '</span>';
					}
				} else {
					elContent.innerHTML += ' <span class="date">' + (dir.date ? dir.date.format(dateFormat) : '?') + " — " + (this.data.directions[i + 1].date ? this.data.directions[i + 1].date.format(dateFormat) : '?') + '</span>';
				}
				break;
			} else {
				if (dir.date) {
					elContent.innerHTML += ' <span class="date">' + dir.date.format(dateFormat) + '</span>';
				} else {
					elContent.innerHTML += ' <span class="date">?</span>';
				}
			}

		}
	}
	elContent.innerHTML += ', <span class="passengers">' + tw.passengers.getStatus() + '</span>';
	elContent.innerHTML += ', <span class="cls">' + l10n.index.search.cls[this.data.cs]+ '</span>';
};

SearchForm1.prototype.show = function(shouldShowFlightLabel){
	if( !shouldShowFlightLabel ) this.hideFlightLabel();
	$(document).on("click", this.link_clickOutsideFlightLabel);
	this.lastRequest = null;
	this.update(true);
	fadeInBlock(this.elForm);
};

SearchForm1.prototype.hide = function(callback){
	fadeOutBlock(this.elForm, callback);
};

DateField = function(options) {
	var self = this;
	this.focus = false;
	/* До создания шаблона */
	this.options = options;
	this.oForm = this.options.oForm;
	this.date = this.options.value || null;
	this.lastDate = this.date;

	this.setField();

	this.min = new Date();
	this.min.setDate(this.min.getDate() - 1);
	this.min.setHours(0, 0, 0, 0);

	this.max = new Date();
	this.max.setDate(this.max.getDate() + 360);
	if (this.date) this.setDate(this.date, true);

	$(this.input)
		.one('focus', function(){
			if (self.options.calendarClass) {
				self.calendar = new self.options.calendarClass(this, self.oForm);
			} else {
				self.calendar = new Calendar1(this, self.oForm);
			}
		})
		.on('focus click', function(event) {
			var dirRows = self.oForm.dirRows;
			var directionNumber = self.options.directionNumber;

			if (directionNumber > 0) {
				var minDateFrom = dirRows[directionNumber - 1].dateFrom;
				if (minDateFrom && minDateFrom.date) {
					self.min = minDateFrom.date;
				}
			}

			$(self.elField).addClass("focus");
			self.calendar.show();
		})
		.keydown(function(event){
			if (self.date) {
				var tempDate = new Date(self.date.getTime());
				var setDate = function(){
					if (self.min <= tempDate && tempDate <= self.max) {
						self.setDate(tempDate);
						/*if (self.calendar) self.calendar.hide();
						self.calendar = new Calendar1({
							parent: self.oForm,
							field: self,
							directionNumber: self.options.directionNumber
						});
						//self.calendar.draw(self.date);*/
					} else if (tempDate < self.min) {
						tempDate.setTime(self.min.getTime());
						setDate();
					} else if (tempDate > self.max) {
						tempDate.setTime(self.max.getTime());
						setDate();
					}
				};
		}

		switch (event.keyCode) {
			case 9: // <Tab>
				self.calendar.hide();
				break;
			/*case 37: // <Left>
				event.preventDefault();
				if (self.date) {
					tempDate.setDate(tempDate.getDate() - 1);
					setDate();
				}
			break;
			case 39: // <Right>
				event.preventDefault();
				if (self.date) {
					tempDate.setDate(tempDate.getDate() + 1);
					setDate();
				}
			break;
			case 38: // <Up>
				event.preventDefault();
				if (self.date) {
					tempDate.setMonth(tempDate.getMonth() + 1);
					setDate();
				}
			break;
			case 40: // <Down>
				event.preventDefault();
				if (self.date) {
					tempDate.setMonth(tempDate.getMonth() - 1);
					setDate();
				}
			break;*/
		}
	});


	// this.tempKeypress = '';
	// $(this.input).on('keypress', function(event){
	// 	var charCode = event.charCode ? event.charCode : event.keyCode;
	// 	var charCodeStr = String.fromCharCode(charCode);
		/*var setDate = function(){
			var tempDate = new Date(self.date.getTime());
				tempDate.setDate(self.tempKeypress);
			if (tempDate.getMonth() == self.date.getMonth() && self.min <= tempDate) {
				self.setDate(tempDate);
				self.calendar.draw(self.date);
			}
		};
		if (charCodeStr.match(/\d/)) {
			if(self.tempKeypress.match(/[1-3]/)) {
				self.tempKeypress += charCodeStr;
				setDate();
				self.tempKeypress = '';
			} else if (charCodeStr.match(/[1-3]/)) {
				self.tempKeypress = charCodeStr;
				setDate();
				setTimeout(function(){
					self.tempKeypress = '';
				}, 3000);
			} else {
				self.tempKeypress = charCodeStr;
				setDate();
				self.tempKeypress = '';
			}
		}*/
	// });

	if (this.options.appendTo) $(this.elField).appendTo(this.options.appendTo);
};


DateField.prototype.setField = function() {
	this.elField = $.tmpl('SuggestField', this.options)[0];
	this.input = $("input:not([disabled])", this.elField)[0];
	this.input.readOnly = true;
	this.input.field = this;
	this.placeholder = $("input[tabindex]", this.elField)[0];
};


DateField.prototype.setDate = function(date, notUpdate) {
	this.date = date ? new Date(date) : this.date;

	if (this.date && this.date < this.min) {
		this.date = this.min;
	}

	if (this.date && this.date > this.max) {
		this.date = this.max;
	}

	if (this.date && this.date != this.lastDate) {
		this.lastDate = new Date(this.date);
		var dateString = this.date.format('dd mmmm, ddd');
		if(tw.language == "en-us") {
			dateString = l10n.calendar.days_S[this.date.getDay()] + ", "  + l10n.calendar.months_S[this.date.getMonth()] + " " + this.date.getDate();
		} else if (tw.language != "ru") {
			dateString = this.date.getDate() + " " + l10n.calendar.months_S[this.date.getMonth()] + ", " + l10n.calendar.days_S[this.date.getDay()];
		}
		this.input.value = dateString;

		this.setPlaceholder();

		if (!notUpdate) {
			this.oForm.update();
		}
	}

	if (this.input.name == 'dateCheckIn' && this.date) {
		this.oForm.fieldCheckOut.min = new Date(this.date);
		this.oForm.fieldCheckOut.min.setDate(this.oForm.fieldCheckOut.min.getDate() + 1);
		if (this.oForm.fieldCheckOut.date) {
			this.oForm.fieldCheckOut.setDate();
		}
	}
};


DateField.prototype.dropDate = function() {
	this.date = null;
	this.lastDate = null;
	this.input.value = '';
	this.setPlaceholder();
};


DateField.prototype.setPlaceholder = function() {
	if (!this.input.value || this.input.value == "\n") {/* При отмене ввода в FF7.0.1 value == "\n" */
		this.placeholder.value = this.placeholder.defaultValue;
	} else {
		this.placeholder.value = "";
	}
};


DateField.prototype.setEnabled = function() {
	this.setDate();
	this.input.disabled = false;
	$(this.fade).addClass('invisible');
	$(this.prevNext).removeClass('invisible');
};


DateField.prototype.setDisabled = function() {
	this.input.disabled = true;
	this.input.value = l10n.setReturnDate;
	$(this.fade).removeClass('tw-invisible');
	$(this.prevNext).addClass('tw-invisible');
};


function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};

function extendedWithParameter (hash, key, keyHash) {
	if (getParameterByName(key)) {
		var extended,
		    value = keyHash + '=' + getParameterByName(key);

		$.each(hash, function (i, part) {
			if (part.indexOf(keyHash + '=') === 0) {
				hash[i] = value;
				extended = true;
			}
		});

		if (!extended) {
			hash.push(value);
		}
	}
	return hash;
};


function SearchForm() {
	var self = this;
	if (objAvia.currentRequestKey) {
		this.data = objAvia.parseKey(objAvia.currentRequestKey);
		this.data.flightType = this.data.getFlightType();
		if(this.data.flightType == "multiway" && this.data.directions.length < 4){
			this.data.directions.push(new Direction());
		}
	} else {
		this.data = new RequestData();
		this.data.directions[0] = new Direction();
		this.data.directions[1] = new Direction();
		this.data.flightType = "round";
		if(objAvia.noDataDirection){
			this.data.directions[0].from = objAvia.noDataDirection.from;
			this.data.directions[0].to = objAvia.noDataDirection.to;
			this.data.directions[1].from = this.data.directions[0].to;
			this.data.directions[1].to = this.data.directions[0].from;
		}
	}

	this.elForm = document.getElementById("form_search");
	this.elSubmitButton = $("input[type='submit']",this.elForm)[0];
	$(this.elSubmitButton).click(function(event){
		event.stopPropagation();
	});
	$(this.elForm).submit(function(event){
		event.preventDefault();
	});
	this.link_submit = function(){
		self.onSubmit();
	};
	this.link_clickOutsideMultiway = function(event){
		self.hideMultiwayForm();
	};

	this.elFirstRowContainer = document.getElementById("topPanel2spreader");
	this.elDirTongue = document.getElementById("dirTongue");
	$(this.elDirTongue).click(function(event){
		event.stopPropagation();
	});
	this.elSearchButtonTongue = document.getElementById("searchButtonTongue");
	$('input', this.elSearchButtonTongue).val(l10n.index.search.find);
	this.setForm();
	if (objAvia.currentRequestKey && objAvia.startSearch) {
		this.onSubmit('startSearch');
	} else {
		this.update();
	}
	this.link_changeRequest = function(){
		self.changeRequest();
	};
	$(document.body).on("changeRequest.regenForm", this.link_changeRequest);
}
SearchForm.prototype.changeRequest = function(){
	this.data = objAvia.parseKey(objAvia.currentRequestKey);
	this.data.flightType = this.data.getFlightType();
	this.setForm();
};
SearchForm.prototype.setForm = function(){
	$(this.elForm).off("submit", this.link_submit);
	$(this.elSearchButtonTongue).hide();
	$("input").blur();
	$(this.elFirstRowContainer).empty();
	$(this.elDirTongue).empty().addClass("invisible");
	this.setDirectionRows();
	this.setFlightTypeButtons();
};
SearchForm.prototype.setDirectionRows = function(){
	this.dirRows = [];
	for (var i = 0, length = this.data.directions.length; i < length; i++) {
		if(!(this.data.flightType == "round" && i == 1)){
			this.dirRows[i] = this.setDirectionRow(i);
		}
		if(this.data.directions[i].date){
			this.setDate(i);
		}
	}
};
SearchForm.prototype.setDirectionRow = function(n){
	var self = this;
	var dataDirection = this.data.directions[n];
	var dirRow = {};
	dirRow.layout = $.tmpl(tmpl_Direction)[0];

	var elDirectionFrom = $(".directionFrom", dirRow.layout)[0];
	var elDirectionTo = $(".directionTo", dirRow.layout)[0];
	var needHint = (n === 0 && tw.requestsList.length === 0);

	dirRow.fromField = new SuggestField({
		appendTo: elDirectionFrom,
		name: "from" + n,
		value: dataDirection.from,
		defaultValue: l10n.index.search.from,
		type: "search",
		needHint: needHint
	});
	dirRow.fromField.suggest = new Suggest(dirRow.fromField, this, n);

	dirRow.toField = new SuggestField({
		appendTo: elDirectionTo,
		name: "to" + n,
		value: dataDirection.to,
		defaultValue:  l10n.index.search.to,
		type: "search",
		needHint: needHint
	});

	dirRow.toField.suggest = new Suggest(dirRow.toField, this, n);
	if(n === 0){
		if (this.data.flightType == "multiway") {
			this.elMultiway = $.tmpl(tmpl_Multiway)[0];
			dirRow.layout.appendChild(this.elMultiway);
			$(dirRow.layout).click(function(event){
				event.stopPropagation();
			});
			$(this.elMultiway).click(function(event){
				self.showMultiwayForm();
			});
		}
		this.elFirstRowContainer.appendChild(dirRow.layout);
	} else {
		this.elDirTongue.appendChild(dirRow.layout);
		this.showMultiwayForm();
	}
	return dirRow;
};


SearchForm.prototype.showMultiwayForm = function(){
	var self = this;
	$(this.elMultiway).addClass("invisible");
	$(this.elDirTongue).removeClass("invisible").slideDown("fast");
	$(document).on("click", self.link_clickOutsideMultiway);
};


SearchForm.prototype.hideMultiwayForm = function(){
	var self = this;
	this.setMultiwayLabel();
	$(document).off("click", self.link_clickOutsideMultiway);
	$(this.elDirTongue).slideUp("fast", function(){
		$(this).addClass("invisible");
	});
	$(this.elMultiway).removeClass("invisible");
};
SearchForm.prototype.setMultiwayLabel = function(){
	var elContent = $("div.content", this.elMultiway)[0];
		elContent.innerHTML = "";
	var letterCount = 0;
	for (var i = 0, length = this.data.directions.length; i < length; i++) {
		var dir = this.data.directions[i];
		if (dir.from || dir.to || dir.date) {
			if (dir.from) letterCount += ref.getPointName(dir.from).length; else letterCount += 1;
			if (dir.to) letterCount += ref.getPointName(dir.to).length; else letterCount += 1;
			if (dir.date) {
				if (dir.date.getDate() < 10) letterCount += 5; else letterCount += 6;
			} else letterCount += 1;
		}
	}
	for (var i = 0, length = this.data.directions.length; i < length; i++) {
		var dir = this.data.directions[i];
		if (dir.from || dir.to || dir.date) {
			if (elContent.innerHTML != "") {
				elContent.innerHTML += '<span class="date">,</span> ';
			}
			var elFlight = document.createElement("span");
				elFlight.className = "flight";
			if (dir.from) {
				if (letterCount < 50) {
					elFlight.innerHTML += ref.getPointName(dir.from);
				} else {
					elFlight.innerHTML += dir.from;
				}
			} else {
				elFlight.innerHTML += "…";
			}
				elFlight.innerHTML += ' → ';
			if (dir.to) {
				if (letterCount < 50) {
					elFlight.innerHTML += ref.getPointName(dir.to);
				} else {
					elFlight.innerHTML += dir.to;
				}
			} else {
				elFlight.innerHTML += "…";
			}
			elContent.appendChild(elFlight);
			if (dir.date) {
				elContent.innerHTML += ' <span class="date">' + dir.date.format('d mmm') + '</span>';
			} else {
				elContent.innerHTML += ' <span class="date">?</span>';
			}
		}
	}
};
SearchForm.prototype.setFlightTypeButtons = function(){
	var self = this;
	this.flightTypeButtons = $.tmpl(tmpl_FlightTypeButtons)[0];
	$("span", this.flightTypeButtons).click(function(event){
		event.stopPropagation();
		self.hideCalendar();
		if ($(this).hasClass("oneway")) {
			self.setFlightType("oneway");
		} else if ($(this).hasClass("round")) {
			self.setFlightType("round");
		} else {
			self.setFlightType("multiway");
		}
	});
	$("span", this.flightTypeButtons).mouseover(function(){
		var button = this;
		this.hint = $.tmpl(tmpl_Hint, {
			className: "flightType"
		})[0];
		if ($(this).hasClass("oneway")) {
			this.hint.appendChild(document.createTextNode(l10n.index.search.oneway));
		} else if ($(this).hasClass("round")) {
			this.hint.appendChild(document.createTextNode(l10n.index.search.round));
		} else {
			this.hint.appendChild(document.createTextNode(l10n.index.search.custom));
		}
		document.body.appendChild(this.hint);
		var pos = $(button).offset();
		$(this.hint).css({
			left: pos.left + button.offsetWidth / 2 - this.hint.offsetWidth / 2,
			top: pos.top + button.offsetHeight + 14
		});
	});

	$("span", this.flightTypeButtons).on("mouseout click", function(){
		$(".hint.flightType").remove();
		this.hint = null;
	});

	var betweenFromTo = $(".betweenFromTo", this.dirRows[0].layout)[0];
		betweenFromTo.appendChild(this.flightTypeButtons);
	$("span." + this.data.flightType, this.flightTypeButtons).addClass("selected");
};


SearchForm.prototype.setFlightType = function(flightType){
	var selectedButton = $("span.selected", this.flightTypeButtons);
	if (!$(selectedButton).hasClass(flightType)) {
		$("span.selected", this.flightTypeButtons).removeClass("selected");
		$("span." + flightType, this.flightTypeButtons).addClass("selected");
		this.data.flightType = flightType;
		var length = this.data.directions.length;
		this.data.directions.splice(1, length - 1);
		if (this.data.flightType === "oneway") {
			$(this.elDirTongue).addClass("invisible");
		} else if (this.data.flightType === "round") {
			this.data.directions[1] = new Direction();
			$(this.elDirTongue).addClass("invisible");
		} else if (this.data.flightType === "multiway") {
			this.data.directions[1] = new Direction();
			$(this.elDirTongue).removeClass("invisible");
		}
		this.setForm();
		this.update();
	}
};


SearchForm.prototype.update = function(){
	this.updateFields();
	this.checkData();
	if (window.objMap && window.objMap.visible) {
		objMap.setData(this.data);
		if (this.data.flightType != "multiway") {	//polylines
			var showPoly = true;
			for(var i=0,DirLength=this.data.directions.length;i<DirLength;i++) {
				if(!this.data.directions[i].date) {
					showPoly = false;
				}
			}
			try {
				if(!this.tempStartPoint || this.tempStartPoint != from1.value){
					var tik = $('#ticker')[0];
					tik.contentWindow.objTicker.getData(true);
				}
			}
			catch (e) {}

			if(!showPoly) { return;}
			var from1 = this.dirRows[0].fromField;
			var to1 = this.dirRows[0].toField;
			if (this.tempStartPoint != from1.value) {
				ClearPolylineFlights();
				// if (ref.testPoint(from1.value)) {
					if (ref.testPoint(from1.value) && to1.value && to1.value != '') {
						initPolylineRoutes(from1.value + '' + to1.value);
					}
					// try {
					//initPopularDirection(from1.value);
					// }
					// catch (e) {
					// }
				// }
				this.tempStartPoint = from1.value;
			}
			if(this.tempEndPoint != to1.value) {
				ClearPolylineFlights();
				if (ref.testPoint(to1.value) && from1.value && from1.value != '') {
					initPolylineRoutes(from1.value+''+to1.value);
				}
				this.tempEndPoint = to1.value;
			}
			if(!from1.value || !to1.value) {
				ClearPolylineFlights();
				this.tempStartPoint = null;
				this.tempEndPoint = null;
			}
		} else {
			ClearPolylineFlights();
			this.tempStartPoint = null;
			this.tempEndPoint = null;
		}
	}
};
SearchForm.prototype.updateFields = function(){
	var focus = null;
	for(var i = 0, length = this.dirRows.length; i < length; i++){
		var dirRow = this.dirRows[i];
		var dataDir = this.data.directions[i];

		dataDir.from = dirRow.fromField.value;
		if(this.data.flightType == "round"){
			this.data.directions[1].to = dataDir.from;
		}
		dataDir.to = dirRow.toField.value;
		if(this.data.flightType == "round"){
			this.data.directions[1].from = dataDir.to;
		}

		if (dataDir.from && dataDir.to) {
			if (!dataDir.date) {
				this.showCalendar(i);
				break;
			} else if (this.data.flightType == "round" && !this.data.directions[1].date) {
				this.showCalendar(1);
				break;
			}
		} else if (!dataDir.from && !dataDir.to) {
			if (dataDir.date) {
				dataDir.date = null;
				this.setDate(i);
				if (this.data.flightType == "round") {
					this.data.directions[1].date = null;
					this.setDate(1);
					break;
				}
			}
		}

		if (!dataDir.from && !focus) {
			focus = this.dirRows[i].fromField.input;
			focus.focus();
		}
		if (!dataDir.to && !focus) {
			focus = this.dirRows[i].toField.input;
			focus.focus();
		}

		if (this.data.flightType == "multiway") {
			if (i == (length - 1)) {
				if (length < 4) {
					if (dataDir.from || dataDir.to) {
						this.data.directions.push(new Direction());
						this.setForm();
						this.update();
						break;
					}
				}
				if (length > 2) {
					if (!dataDir.from && !dataDir.to && !this.data.directions[i - 1].from && !this.data.directions[i - 1].to) {
						this.data.directions.pop();
						this.setForm();
						this.update();
						break;
					}
				}
			}
		}
	}
};
SearchForm.prototype.updateDates = function(){
	for (var i = 0, length = this.data.directions.length; i < length; i++) {
		var dataDir = this.data.directions[i];
		if(!dataDir.date){
			this.showCalendar(i);
			break;
		}
	}
};
SearchForm.prototype.showCalendar = function(n){
	$('input[type="text"]:focus').blur();
	this.hideCalendar();
	var options = {
		parent: this,
		directionNumber: n
	};
	this.calendar = new Calendar(options);
};
SearchForm.prototype.hideCalendar = function(){
	if (this.calendar) {
		if (this.calendar.elCalendar.offsetHeight > 0) {
			this.calendar.hide();
		}
		this.calendar = null;
	}
};
SearchForm.prototype.setDate = function(n){
	var self = this;
	var $elButton;
	if (n === 1 && this.data.flightType === "round") {
		 $elButton = $(".directionTo .calendarButton", this.dirRows[0].layout);
	} else {
		$elButton = $(".calendarButton", this.dirRows[n].layout);
	}

	$elButton.remove();

	if (this.data.directions[n].from || this.data.directions[n].to) {
		if (this.data.directions[n].date) {
			var data = {
				date: this.data.directions[n].date.getDate(),
				month: (l10n.calendar.months_S[this.data.directions[n].date.getMonth()]).toLowerCase()
			};
		}
		$elButton = $.tmpl(tmpl_CalendarButton, data);
		$elButton.click(function(event){
			event.stopPropagation();
			self.showCalendar(n);
		});
		if (n === 1 && this.data.flightType === "round") {
			this.dirRows[0].toField.elField.appendChild($elButton[0]);
		} else {
			this.dirRows[n].fromField.elField.appendChild($elButton[0]);
		}
	}
};
SearchForm.prototype.checkData = function(){
	var dataFilled = false;
	this.wrongDates = false;
	this.wrongRoute = false;
	for (var i = 0, length = this.data.directions.length; i < length; i++) {
		var dataDir = this.data.directions[i];
		if (dataDir.date || dataDir.from || dataDir.to) {
			if (!dataDir.date || !dataDir.from || !dataDir.to) {
				dataFilled = false;
				break;
			} else {
				if(this.data.directions[i - 1]){
					if (dataDir.date < this.data.directions[i - 1].date) {
						this.wrongDates = true;
					}
				}
				if(dataDir.from == dataDir.to){
					this.wrongRoute = true;
				}
				dataFilled = true;
			}
		}
	}
	if(dataFilled){
		$(this.elForm).off("submit", this.link_submit);
		$(this.elSearchButtonTongue).slideDown("fast");
		$(this.elForm).on("submit", this.link_submit);
	} else {
		$(this.elForm).off("submit", this.link_submit);
		$(this.elSearchButtonTongue).hide();
	}
};
SearchForm.prototype.onSubmit = function(isKey){
	if(this.wrongRoute){
		addPopup({
			error: true,
			reason: l10n.popup.warning,
			comment: l10n.index.search.popup.checkDirections,
			close_button: true,
			button: l10n.popup.close,
			removeOnAction: true
		});
		return;
	}
	if(this.wrongDates){
		addPopup({
			error: true,
			reason: l10n.popup.warning,
			comment: l10n.index.search.popup.checkDates,
			close_button: true,
			button: l10n.popup.close,
			removeOnAction: true
		});
		return;
	}
	$(this.elForm).off("submit", this.link_submit);
	$(this.elSearchButtonTongue).slideUp("fast");
	if(this.data.getFlightType() == this.data.flightType){
		$(document.body).off("changeRequest.regenForm", this.link_changeRequest);
	}
	if (this.data.getFlightType() == "multiway") {
		this.hideMultiwayForm();
	}
	var data = objAvia.parseKey(this.data.getKey());
	if(!isKey){
		data.cs = "E";
	}
	objAvia.changeRequest(objAvia.addDataToRequestsList(data));
	if (this.data.getFlightType() == this.data.flightType) {
		$(document.body).on("changeRequest.regenForm", this.link_changeRequest);
	}
};
SearchForm.prototype.show = function(callback){
	fadeInBlock(this.elForm, callback);
};
SearchForm.prototype.hide = function(callback){
	fadeOutBlock(this.elForm, callback);
};



//////////////
if (tw.language == 'ru') {
	$(document).one('visitormanager_get_success', function(event) {
		if (event.json.promo) {
			new PromoCodePopup({
				serverTime: event.json.serverTime,
				toTime: event.json.promo.toTime,
				code: event.json.promo.codeNum,
				amount: event.json.promo.amount,
				currency: event.json.promo.currency
			});
		}
	});
}
function PromoCodePopup(options){
	this.options = options;
	this.init();
	this.show();
}
PromoCodePopup.prototype.init = function(){
	var self = this;
	this.elContent = $.tmpl($("#tmpl_PromoCodePopup").trim(), self.options)[0];
	this.emailField = new Field({
		appendTo: $(".emailRow>td", this.elContent)[0],
		name: "promoCodeEmail",
		type: "email"
	});
  	$(this.emailField.input).focus(function(){
  		$(self.elStatus).addClass('invisible');
  	});
  	$('.timeRow button', this.elContent).click(function(event){
  		event.preventDefault();
  		self.hide();
  	});
	this.elForm = $('form', this.elContent)[0];
	this.elStatus = $('.status', this.elContent)[0];
	$(this.elForm).submit(function(event){
		event.preventDefault();
		if (self.checkData()) {
			self.submitForm();
		}
	});
};
PromoCodePopup.prototype.setToDate = function(){
	var self = this;
	this.toDate = this.toDate || new Date(this.options.toTime);
	this.clientServerDelta = this.clientServerDelta || (new Date(this.options.serverTime) - new Date()) / 60000;
	var durationSeconds = ((this.toDate - new Date()) / 1000) - this.clientServerDelta;
	if (durationSeconds > 0) {
		function pad(val, length){
			val = String(val);
			while (val.length < length)
				val = "0" + val;
			return val;
		}
		var h = Math.floor(durationSeconds/3600);
		var m = pad(Math.floor((durationSeconds - h * 3600)/60), 2);
		var s = pad(parseInt(durationSeconds - h * 3600 - m * 60), 2);

		$('.counter', this.elContent)
			.html( '<span>' + h + '<span>' + declOfNum(h, l10n.hours) + '</span></span>:<span>' + m + '<span>' + declOfNum(m, l10n.minutes) + '</span></span>:<span>' + s + '<span>' + declOfNum(s, l10n.second) + '</span></span>' );
	} else {
		this.hide();
	}
	return durationSeconds;
};


PromoCodePopup.prototype.checkData = function(){
	this.emailField.input.blur();
	if (!this.emailField.value || this.emailField.error) {
		this.emailField.addError();
		this.emailField.input.focus();
		return false;
	}
	return true;
};


PromoCodePopup.prototype.submitForm = function(){
	var self = this;
	if (!this.inProcess) {
		$.ajax({
			dataType: "json",
			url: "/_api/visitormanager/sendPromoEmail/",
			data: {
				"email":  this.elForm.promoCodeEmail.value
			},
			beforeSend: function(){
				self.setInProcess();
			},
			success: function(json){
				if (json.result == 'OK') {
					var status = 'Промокод отправлен';
					$(self.elStatus).removeClass('error');
				} else {
					var status = 'Ошибка отправки';
					if (json.error == 'WRONG_PARAMS') {
						status = 'Ошибка отправки. Проверьте email.';
					} else if (json.error == 'ALREADY_SEND') {
						status = 'На этот email промокод уже высылался';
					} else if (json.error == 'ERROR_SEND') {

					}
					$(self.elStatus).addClass('error');
				}
				self.elStatus.innerHTML = status;
				$(self.elStatus).removeClass('invisible');
			},
			complete: function(xhr){
				checkAjaxError(xhr);
				self.removeInProcess();
			}
		});
	}
};
PromoCodePopup.prototype.setInProcess = function(){
	$('button', this.elForm)[0].disabled = true;
	this.inProcess = true;
};
PromoCodePopup.prototype.removeInProcess = function(){
	$('button', this.elForm)[0].disabled = false;
	this.inProcess = false;
};
PromoCodePopup.prototype.addStat = function(){
	kmqRecord({name: "PromoCodePopup", obj: {"initOnPage": "before search", "PromoCurrency": this.options.currency, "PromoValue": this.options.amount} });
};
PromoCodePopup.prototype.show = function(){
	var self = this;
	if (this.setToDate() > 500) {
		this.dateChange = setInterval(function(){
			self.setToDate();
		}, 1000);
		this.elPopup = addPopup({
			close_button: true,
			dom: this.elContent,
			id: 'promoCodePopup'
		});
		this.emailField.input.focus();
		this.addStat();
	}
};
PromoCodePopup.prototype.hide = function(){
	clearInterval(this.dateChange);
	removePopup();
};


if (tw.language == 'ru' && (tw.params.awdbonuses || tw.params.newuser) && !tw.params.s) {
	$(document).on("changeRequest", function(){
		tw.changeRequest = true;
	});
}

function MyHash(){
	this.Hash = {};
	this.Arr = [];
}
MyHash.prototype.Add = function(key, obj) {
	this.Arr.push(key);
	this.Hash[key] = obj || 1;
};
MyHash.prototype.GetLength = function() {
	return this.Arr.length;
};

function Suggest(field, parentObj, dirNumber, options){
	var self = this;

	options = $.extend({
		id: 'suggest',
		className: '',
		container: document.body,
		calculatePosition: true,
		maxItems: 10
	}, options);

	this.field = field;
	this.field.value = this.field.value || null;

	this.field.setPlaceholder = function(){
		self.setPlaceholder();
	};

	this.lastResult = this.field.value;
	this.field.geocodeValue = null;
	this.input = this.field.input;
	this.placeholder = this.field.placeholder;
	this.parentObj = parentObj;
	this.dirNumber = dirNumber;

	this.suggestId = options.id;
	this.suggestClassName = 'suggest invisible' + (options.className ? ' ' + options.className : '');
	this.suggestContainer = options.container;
	this.calculatePosition = options.calculatePosition;
	this.maxItems = options.maxItems;

	this.tempValue = this.input.value.toLowerCase();

	this.suggestType = null;

	this.linkSetOffset = function(event){
		self.setOffset(event);
	};
	this.link_clickOutside = function(event){
		self.clickOutside(event);
	};
	this.link_onKeyDown = function(event){
		self.onKeyDown(event);
	};

	$(this.input).on("input keyup paste", function(event){
		if (event.type == "input" && !IEVersion || event.type == "keyup" && IEVersion) handler();
		function handler(){
			if (self.input.value.toLowerCase() != self.tempValue) {
				self.currentResult = null;
				self.setCurrentResult();
				if (self.input.value.length >= 3 || self.input.value.toLowerCase() == "ош") {
					if (self.suggestTimeout) {
						clearTimeout(self.suggestTimeout);
					}
					self.suggestTimeout = setTimeout(function(){
						self.makeSuggest();
					}, 500);
				} else {
					self.hide();
					self.tempValue = self.input.value.toLowerCase();
				}
			}
		}
	});
	this.selectedRow = null;
	//this.makeSuggest();
}


Suggest.prototype.setByCode = function(code){
	this.currentResult = code;
	this.input.value = ref.getPointName(this.currentResult);
	this.tempValue = this.input.value.toLowerCase();
	this.setPlaceholder();
	this.field.value = this.currentResult;
	this.lastResult = this.currentResult;
	this.parentObj.update();
};

Suggest.prototype.makeSuggest = function() {
	var self = this;
	this.suggestType = null;
	this.tempValue = this.input.value.toLowerCase();
	var queryString = this.tempValue.trim();
	//var queryString = this.tempValue;
	if (queryString.length >= 3 || self.input.value.toLowerCase() == "ош") {
		this.results = new MyHash();
		this.currentResult = null;
		this.getResult(queryString);

		if (this.results.GetLength() > 1) {
			if (this.field.focus === true) {
				this.draw();
			} else {
				this.currentResult = this.results.Arr[0];
				this.setCurrentResult();
			}
		} else if (this.results.GetLength() == 1) {
			var temp = this.input.value.toLowerCase();
			setTimeout(function(){
				if (temp == self.input.value.toLowerCase()) {
					self.currentResult = self.results.Arr[0];
					self.setCurrentResult();
					self.hide();
				}
			}, 400);
		} else {
			$.ajax({
				type:     "get",
				cache:    false,
				dataType: "json",
				url:      "/_api/suggest/bestMatch/",
				data:     {
					query: queryString,
					locale: tw.language
				},
				timeout:  3000,
				success:  function (json) {
					var variants = json || [];
					var variant = variants[0] || {};
					var airports = variant.airports || [];
					var al = airports.length;
					if (al) {
						self.results = new MyHash();
						self.currentResult = null;
						var airport;
						for(var i = 0; i < al; i++) {
							airport = airports[i].airport;
							self.GetCityByCode(airport);
							self.GetAirportByCode(airport);
							self.GetCities(airport);
							self.GetAirports(airport);
						}
						self.draw();
					} else {
						self.hide();
					}
				},
				complete: function() {
					if(!self.results.GetLength()) {
						self.hide();
					}
				},
				error: function() {
					self.hide();
				}
			});
		}
	}
	//all cities on map
	$('.infoOverlay').remove();
};


Suggest.prototype.setPlaceholder = function(){
	var code;
	if (!this.input.value || this.input.value == "\n") {/* При отмене ввода в FF7.0.1 value == "\n" */
		this.placeholder.value = this.placeholder.defaultValue;
	} else if (this.currentResult) {
		if (this.currentResult.AddressStr && this.currentResult.refCode) {
			code = this.currentResult.refCode;
		} else if (!this.currentResult.AddressStr) {
			code = this.currentResult;
		}
		if (code && this.tempValue === ref.getPointName(code).substring(0, this.input.value.length).toLowerCase()) {
			this.placeholder.value = ref.getPointVsCountryString(code);
		} else if (!code && this.currentResult.AddressStr.indexOf(this.input.value) === 0) {
			this.placeholder.value = this.currentResult.AddressStr;
			if ($.inArray("country", this.currentResult.types) === -1) {
				if(this.currentResult.country){
					this.placeholder.value += ', ' + this.currentResult.country;
				} else if ($.inArray("natural_feature", this.currentResult.types) > -1) {
					if (this.currentResult.NearCities && this.currentResult.NearCities.length==1 && ref.testPoint(this.currentResult.NearCities[0])) {
						if(ref.Countries[ref.getPoint(this.currentResult.NearCities[0]).Parent]) {
							this.placeholder.value += ', ' + ref.Countries[ref.getPoint(this.currentResult.NearCities[0]).Parent].Name;
						}
					}
				}
			}
		} else {
			this.placeholder.value = "";
		}
	} else {
		this.placeholder.value = "";
	}
};


Suggest.prototype.getResult = function(queryString){
	var self = this;
	get(queryString);
	get(queryString.changeEnToRu());
	get(queryString.changeRuToEn());

	function get(string){
		if (string.length >= 3 || queryString.toLowerCase() == "ош") {
			if (string.length === 3) {
				self.GetCityByCode(string);
				self.GetAirportByCode(string);
			}
			self.GetCities(string);
			self.GetAirports(string);
		}
	}

	//сортировка
	var sorted = [], tempArr = [];

	for(var i=0, l = this.results.Arr.length; i<l; i++) {
		var code = this.results.Arr[i];
		var curR = {
			code: code,
			name: ref.getPointName(code),
			popularity: 0
		};

		if (ref.Cities[code]){
			curR.popularity = ref.Cities[code].Popularity || 0;
		}

		if (curR.name.toLowerCase().indexOf(queryString) > -1) {
			curR.popularity += 10;
		}

		if (curR.name.toLowerCase().indexOf(queryString) === 0) {
			curR.popularity += 90;
		}

		if (queryString === code.toLowerCase()) {
			curR.popularity += 1000;
		}

		sorted.push(curR);
	}

	var sortCodes = function(a,b){
		return b.popularity - a.popularity;
	}

	sorted.sort(sortCodes);

	for(var i=0, l = sorted.length; i<l; i++) {
		tempArr.push(sorted[i].code);
	}

	this.results.Arr = tempArr;

	//TODO удалить старый функционал с картой window.objMap
	if(!this.results.GetLength() && window.objMap){
		this.suggestType = "geocode";
		this.geocode(queryString);
	}
};


Suggest.prototype.GetCityByCode = function(queryString){
	var CityCode = queryString.toUpperCase();
	if (ref.Cities[CityCode] && !this.results.Hash[CityCode]) {
		this.results.Add(CityCode);
	}
};


Suggest.prototype.GetAirportByCode = function(queryString){
	var AirportCode = queryString.toUpperCase();
	if (ref.Airports[AirportCode] && !this.results.Hash[AirportCode]) {
		this.results.Add(AirportCode);
	}
};


Suggest.prototype.GetCities = function(queryString) {
	var expr = new RegExp(('(^|-|\\s|\\u00A0|\\u2011)' + queryString), 'ig');
	for (var l = 0; l < ref.LangLength; l++) {
		var lang = ref.Languages[l];
		for (var CityCode in ref.Cities) {
			if (!this.results.Hash[CityCode] && ref.Cities[CityCode][lang]) {
				var refCity = ref.Cities[CityCode];
				//синонимы городов
				if(refCity.Synonyms) {
					for(var syn = 0, synL = refCity.Synonyms.length; syn < synL; syn ++) {
						var curSyn = refCity.Synonyms[syn];
						if (~curSyn.search(expr)) {
							this.results.Add(CityCode);
							break;
						}
					}
				}
				if (~refCity[lang].search(expr)) {
					this.results.Add(CityCode);
				}

			}
		}
	}
};

Suggest.prototype.GetAirports = function(queryString) {
	var expr = new RegExp(('(^|-|\\s|\\u00A0|\\u2011)' + queryString), 'ig');
	for (var l = 0; l < ref.LangLength; l++) {
		var lang = ref.Languages[l];
		for (var AirportCode in ref.Airports) {
			if (!this.results.Hash[AirportCode] && ref.Airports[AirportCode][lang]) {
				var refAirport = ref.Airports[AirportCode];
				if (~refAirport[lang].search(expr)) {
					this.results.Add(AirportCode);
				}

			}
		}
	}
};


Suggest.prototype.create = function(){
	this.$el = $(document.getElementById("suggest"));

	if (!this.$el[0]) {
		this.$el = $('<div/>',{
			id: this.suggestId,
			class: this.suggestClassName
		})
			.click(function(event) {
				event.stopPropagation();
			})
			.appendTo(this.suggestContainer);
	} else {
		this.$el.html('');
	}
};


Suggest.prototype.draw = function() {
	var self = this;
	this.create();
	var elList = document.createElement("ul");

	var ResultsCount = this.results.GetLength() < this.maxItems ? this.results.GetLength() : this.maxItems;
	for(var i = 0;  i < ResultsCount; i++){
		var Code = this.results.Arr[i];
		var elLi = document.createElement("li");
				elLi.Code = Code;
				elLi.appendChild(this.drawRefItem(Code));

				elLi.onmouseover = function() {
					self.setRowHover(this);
				};
				elLi.onclick = function() {
					self.setCurrentResult();
					self.hide();
				};
		elList.appendChild(elLi);
	}
	this.setRowHover(elList.firstChild);
	this.$el
		.on('mouseout', function() {
			self.setRowHover(self.selectedRow);
		})
		.append(elList);
	this.show();
};


Suggest.prototype.drawRefItem = function(code,currentResult){
	var PointVsCountryString = ref.getPointVsCountryString(code);
	var elTable = document.createElement("table");
		var elRow = elTable.insertRow(-1);
		var elNameCell = elRow.insertCell(0);
			var state = "", sublocality = "";
			if(currentResult) {
				if(currentResult.state) state = ', ' + currentResult.state;
				if(currentResult.sublocality) sublocality = currentResult.sublocality + ', ';
			}
			elNameCell.innerHTML = sublocality + PointVsCountryString.split(',')[0] + state + ',<span>' + PointVsCountryString.substr(PointVsCountryString.indexOf(',')+1) + '</span>';
		var elCodeCell = elRow.insertCell(1);
				elCodeCell.className = "code";
				elCodeCell.innerHTML = code;
	return elTable;
};


Suggest.prototype.drawGeocode = function(){
	var self = this;
	this.create();
	var elList = document.createElement("ul");

	var ResultsCount = this.geocodeResults.length < 500 ? this.geocodeResults.length : 5;
	for(var i = 0; i < ResultsCount; i++){
		var currentResult = this.geocodeResults[i];
		var elLi = document.createElement("li");
		if (currentResult.refCode) {
			elLi.Code = currentResult.refCode;
			elLi.appendChild(this.drawRefItem(currentResult.refCode,currentResult));
		} else {
			elLi.Geocode = currentResult;
			elLi.innerHTML = currentResult.AddressStr;
			if ($.inArray("country", currentResult.types) === -1) {
				if(currentResult.state){
					elLi.innerHTML += ', ' + currentResult.state;
				}
				if(currentResult.country){
					elLi.innerHTML += ', <span>' + currentResult.country + '</span>';
				} else if ($.inArray("natural_feature", currentResult.types) > -1) {
					if (currentResult.NearCities && currentResult.NearCities.length==1 && ref.testPoint(currentResult.NearCities[0])) {
						if(ref.Countries[ref.getPoint(currentResult.NearCities[0]).Parent]) {
							elLi.innerHTML += ', <span>' + ref.Countries[ref.getPoint(currentResult.NearCities[0]).Parent].Name + '</span>';
						}
					}
				}
			}
		}
			elLi.onmouseover = function() {
				self.setRowHover(this);
			};
			elLi.onclick = function() {
				self.setCurrentResult();
				self.hide();
			};
		elList.appendChild(elLi);
	}
	this.setRowHover(elList.firstChild);
	this.$el
		.on('mouseout', function() {
			self.setRowHover(self.selectedRow);
		})
		.append(elList);
	this.show();
};


Suggest.prototype.geocode = function(queryString){
	var self = this;
	var geocoder = new google.maps.Geocoder();
	var myTypes = ["country", "locality", "natural_feature", "administrative_area_level_1", "administrative_area_level_2", "administrative_area_level_3", "sublocality", "neighborhood"];
	geocoder.geocode({
		'address': queryString
	}, function(results, status){
		if (status == google.maps.GeocoderStatus.OK && queryString == self.tempValue) {
			self.geocodeResults = [];
			var dublicates = {
				ad: [],
				codes: []
			}
			for (var i = 0, length_i = results.length; i < length_i; i++) {
				var currentResult = results[i];
					currentResult.NearCities = AirportFinder(currentResult.geometry.location.lat(), currentResult.geometry.location.lng());
				if (currentResult.NearCities) {
					for (var t = 0, length_t = myTypes.length; t < length_t; t++) {
						var type = myTypes[t];
						if ($.inArray(type, currentResult.types) > -1) {
							self.setGeocodeAddress(currentResult, type);
							if($.inArray(currentResult.formatted_address, dublicates.ad) == -1) {
								if(currentResult.refCode) {
									if($.inArray(currentResult.refCode, dublicates.codes) == -1) {
										self.geocodeResults.push(currentResult);
										dublicates.ad.push(currentResult.formatted_address);
										dublicates.codes.push(currentResult.refCode);
									}
								} else {
									self.geocodeResults.push(currentResult);
									dublicates.ad.push(currentResult.formatted_address);
								}
							}
							break;
						}
					}
				}
			}

			for (var j = 0, length_j = self.geocodeResults.length; j < length_j; j++) {
				var currentResult = self.geocodeResults[j];
				if (currentResult.AddressStr_long) {
					var SetAddressStr_long = false;
					for (var k = (k+ j); k < length_j; k++) {
						var CompareItem = self.geocodeResults[k];
						if (CompareItem.AddressStr_long && currentResult.AddressStr == CompareItem.AddressStr) {
							CompareItem.AddressStr = CompareItem.AddressStr_long;
							SetAddressStr_long = true;
						}
					}
					if (SetAddressStr_long) {
						currentResult.AddressStr = currentResult.AddressStr_long;
					}
				}
			}
			if (self.geocodeResults.length > 0 && self.field.focus) {
				self.drawGeocode();
			} else if(self.geocodeResults.length > 0 && !self.field.focus) {
				self.currentResult = self.geocodeResults[0];
				self.setCurrentResult();
			}
		}
	});
};
Suggest.prototype.setGeocodeAddress = function(geocode, type){
	var AddressStr = "";
	var AddressStr_long = "";
	var country = "";
	var refCode = null;
	for (var i = 0, length = geocode.address_components.length; i < length; i++) {
		var address_component = geocode.address_components[i];
		switch (type) {
			case "country":
				if ($.inArray("country", address_component.types) > -1) {
					AddressStr += getCountryName(address_component);
				}
				break;
			case "locality":
				if ($.inArray("locality", address_component.types) > -1) {
					refCode = this.searchCityCodeByGeoName(geocode, address_component.long_name);
					AddressStr += address_component.long_name;
					AddressStr_long += address_component.long_name;
				} else if ($.inArray("administrative_area_level_1", address_component.types) > -1) {
					AddressStr_long += ", " + address_component.long_name;
				} else if ($.inArray("country", address_component.types) > -1) {
					if(address_component.short_name == "US") {
						geocode.countryCode = address_component.short_name;
						//делаем сплит по пробелу для случая new ark - в результате New York 14513
						geocode.state = geocode.formatted_address.split(',')[1].trim().split(' ')[0];
					}
					geocode.country = getCountryName(address_component);
				}
				break;
			case "natural_feature":
				if ($.inArray("natural_feature", address_component.types) > -1) {
					AddressStr += address_component.long_name;
					AddressStr_long += address_component.long_name;
				} else if ($.inArray("administrative_area_level_1", address_component.types) > -1) {
					AddressStr_long += ", " + address_component.long_name;
				} else if ($.inArray("country", address_component.types) > -1) {
					geocode.country = getCountryName(address_component);
				}
				break;
			case "administrative_area_level_1":
				if ($.inArray("administrative_area_level_1", address_component.types) > -1) {
					refCode = this.searchCityCodeByGeoName(geocode, address_component.long_name);
					AddressStr += address_component.long_name;
				} else if ($.inArray("country", address_component.types) > -1) {
					geocode.country = getCountryName(address_component);
				}
				break;
			case "administrative_area_level_2":
				if ($.inArray("administrative_area_level_2", address_component.types) > -1) {
					refCode = this.searchCityCodeByGeoName(geocode, address_component.long_name);
					AddressStr += address_component.long_name;
				} else if ($.inArray("administrative_area_level_1", address_component.types) > -1) {
					AddressStr += ", " + address_component.long_name;
				} else if ($.inArray("country", address_component.types) > -1) {
					geocode.country = getCountryName(address_component);
				}
				break;
			case "administrative_area_level_3":
				if ($.inArray("administrative_area_level_3", address_component.types) > -1) {
					refCode = this.searchCityCodeByGeoName(geocode, address_component.long_name);
					AddressStr += address_component.long_name;
				} else if ($.inArray("administrative_area_level_1", address_component.types) > -1) {
					AddressStr += ", " + address_component.long_name;
				} else if ($.inArray("country", address_component.types) > -1) {
					geocode.country = getCountryName(address_component);
				}
				break;
			case "sublocality":
				if ($.inArray("sublocality", address_component.types) > -1) {
					refCode = this.searchCityCodeByGeoName(geocode, address_component.long_name);
					if(AddressStr.length >0) {
						geocode.sublocality = AddressStr;
						AddressStr += ', ';
					}
					AddressStr += address_component.long_name;
				} else if ($.inArray("administrative_area_level_1", address_component.types) > -1) {
					AddressStr += ", " + address_component.long_name;
				} else if ($.inArray("country", address_component.types) > -1) {
					geocode.country = getCountryName(address_component);
				}
				break;
			case "neighborhood":
				if ($.inArray("neighborhood", address_component.types) > -1) {
					AddressStr += address_component.long_name;
				} else if ($.inArray("administrative_area_level_1", address_component.types) > -1) {
					AddressStr += ", " + address_component.long_name;
				} else if ($.inArray("country", address_component.types) > -1) {
					geocode.country = getCountryName(address_component);
				}
				break;
			case "park":
				if ($.inArray("park", address_component.types) > -1) {
					AddressStr += address_component.long_name;
				} else if ($.inArray("administrative_area_level_1", address_component.types) > -1) {
					AddressStr += ", " + address_component.long_name;
				} else if ($.inArray("country", address_component.types) > -1) {
					geocode.country = getCountryName(address_component);
				}
				break;
			case "point_of_interest":
				if ($.inArray("point_of_interest", address_component.types) > -1) {
					AddressStr += address_component.long_name;
				} else if ($.inArray("administrative_area_level_1", address_component.types) > -1) {
					AddressStr += ", " + address_component.long_name;
				} else if ($.inArray("country", address_component.types) > -1) {
					geocode.country = getCountryName(address_component);
				}
				break;
		}
	}
	function getCountryName(address_component){
		if(ref.Countries[address_component.short_name]){
			return ref.Countries[address_component.short_name].Name;
		} else {
			return address_component.long_name;
		}
	}
	if (refCode) {
		geocode.refCode = refCode;
	}
	geocode.AddressStr = AddressStr;
	if(AddressStr_long !== ""){
		geocode.AddressStr_long = AddressStr_long;
	}
};
Suggest.prototype.searchCityCodeByGeoName = function(geocode, geoName){
	for (var j = 0; j < geocode.NearCities.length; j++) {
		var cityName = ref.getCityName(geocode.NearCities[j]);
		if (geoName.indexOf(cityName) > -1) {
			return geocode.NearCities[j];
		}
	}
	return null;
};


Suggest.prototype.show = function() {
	var self = this;
	this.setOffset();
	$(window).on('resize', self.linkSetOffset);

	$(document)
		.off("click", self.link_clickOutside)
		.on("click", self.link_clickOutside);

	$(this.input)
		.off("keydown", self.link_onKeyDown)
		.on("keydown", self.link_onKeyDown);

	this.$el.removeClass("invisible");
	this.setOffset();
};


Suggest.prototype.setOffset = function(){
	var offset = $(this.input).offset();
	if (this.calculatePosition) {
		this.$el.css({
			"top": offset.top + this.input.offsetHeight + "px",
			"left": offset.left + "px",
			"min-width": this.input.offsetWidth - 2 + "px"
		});

	}
};


Suggest.prototype.hide = function() {
	var self = this;
	$(window).off('resize', self.linkSetOffset);
	$(document).off("click", self.link_clickOutside);
	$(this.input).off("keydown", self.link_onKeyDown);
	this.currentResult = null;
	var elSuggest = document.getElementById("suggest");
	if (elSuggest) {
		this.suggestContainer.removeChild(elSuggest);
	}
};


Suggest.prototype.clickOutside = function(event) {
	if (event.target != this.input) {
		if (this.currentResult.AddressStr) {
			this.input.value = null;
			this.setPlaceholder();
			this.currentResult = null;
		}
		this.setCurrentResult();
		this.hide();
	}
};


Suggest.prototype.onKeyDown = function(event) {
	switch (event.keyCode) {
		case 9: // <Tab>
			event.preventDefault();
			this.setCurrentResult();
			this.hide();
			break;
		case 27: // <Esc>
			this.hide();
			break;
		case 38: // <Up>
			event.preventDefault();
			this.setPrevRowHover();
			break;
		case 40: // <Down>
			event.preventDefault();
			this.setNextRowHover();
			break;
		case 13: // <Enter>
			event.preventDefault();
			this.setCurrentResult();
			this.hide();
			break;
	}
};


Suggest.prototype.setPrevRowHover = function() {
	if (this.selectedRow) {
		var PrewRow = this.selectedRow.previousSibling;
		if (PrewRow) {
			this.setRowHover(PrewRow);
			this.selectedRow = PrewRow;
		}
	}
};


Suggest.prototype.setNextRowHover = function() {
	if (this.selectedRow) {
		var NextRow = this.selectedRow.nextSibling;
		if (NextRow) {
			this.setRowHover(NextRow);
			this.selectedRow = NextRow;
		}
	}
};
Suggest.prototype.setRowHover = function(elRow){
	if (this.selectedRow) {
		if (this.selectedRow == elRow) {
			return;
		}
		this.dropRowHover(this.selectedRow);
	}
	$(elRow).addClass("hover");
	this.selectedRow = elRow;
	if (elRow.Code) {
		this.currentResult = elRow.Code;
		if (this.tempValue === ref.getPointName(this.currentResult).substring(0, this.input.value.length).toLowerCase()) {
			this.input.value = ref.getPointName(this.currentResult).substring(0, this.input.value.length);
		}
	} else if (elRow.Geocode) {
		this.currentResult = elRow.Geocode;
	}
	this.setPlaceholder();
};


Suggest.prototype.dropRowHover = function(elRow){
	$(elRow).removeClass("hover");
};


Suggest.prototype.setCurrentResult = function() {
	var self = this;
	if (this.lastResult != this.currentResult) {
		if (this.currentResult) {
			if (this.tempValue == this.input.value.toLowerCase()) {
				if(this.currentResult.AddressStr){
					if(this.currentResult.refCode){
						this.currentResult = this.currentResult.refCode;
						this.setCurrentResult();
						return;
					}
					this.input.value = this.currentResult.AddressStr;
					this.tempValue = this.input.value.toLowerCase();
					this.field.geocodeValue = this.currentResult;
					if(isResults()){
						$(document.body).one("resultsHide", function(){
							objMap.setGeocode(self.field, self.parentObj, self.dirNumber);
						});
						hideResults();
					} else {
						objMap.setGeocode(this.field, this.parentObj, this.dirNumber);
					}
					this.setPlaceholder();
				} else {
					this.input.value = ref.getPointName(this.currentResult);
					this.tempValue = this.input.value.toLowerCase();
					this.setPlaceholder();
					this.field.value = this.currentResult;
					this.parentObj.update();
				}
			}
			this.lastResult = this.currentResult;
		} else {
			this.field.value = this.currentResult;
			this.field.geocodeValue = this.currentResult;
			this.parentObj.update();
			this.lastResult = this.currentResult;
		}
		$(document).trigger("tw-suggest-apply");
		$(self).trigger("suggest-apply");
	}
};

var nonstopSchedule = {};
var firstSelectedStraightDirIndex = null; //Индекс дирекшена на котором была первый выбрана дата для прямого перелёта
function Calendar1(input, oForm){
	var self = this;

	this.input = input;
	this.field = this.input.field;
	this.oForm = oForm;
	this.init();

	this.rollConstant = 316;

	this.today = (new Date()).cutTime();
	var yesterday = new Date(this.today);
			yesterday.setDate(yesterday.getDate() - 1);
	this.calendarStart = new Date(yesterday);
	this.calendarEnd = new Date(this.today);
	this.calendarEnd.setDate(this.calendarEnd.getDate() + 360);


	this.date = new Date(this.calendarStart);
	this.createStructure();
	this.initDaysClick();

	this.link_clickOutside = function(event){
		self.clickOutside(event);
	};
	this.link_setOffset = function(event){
		self.setOffset(event);
	};
}


Calendar1.prototype.init = function(){
	this.dirNumber = +this.input.name.substring(4);
	this.dataDir = this.oForm.data.directions[this.dirNumber];
	this.schedule = null;
};


Calendar1.prototype.reInit = function(){
	this.dataDir = this.oForm.data.directions[this.dirNumber];
	this.checkSchedule();
};


Calendar1.prototype.createStructure = function(){
	var self = this;
	this.getWeekdays();
	this.$elCalendar = $.tmpl($('#tmpl_Calendar1').trim(), {
		weekdays: this.arrWeekdays,
		weekends: this.arrWeekends
	});

	this.$elCalendar.click(function(event){
		event.stopPropagation();
	});

	var elNavigation = this.$elCalendar.find('table.navigation')[0];
	this.$elRollLeft = $('td.roll.left>span', elNavigation);
	this.$elRollLeft.click(function(){
		self.rollLeft();
	});

	this.$elRollRight = $('td.roll.right>span', elNavigation);
	this.$elRollRight.click(function(){
		self.rollRight();
	});

	this.elMonth = $('td.month', elNavigation)[0];

	this.elRollTable = this.$elCalendar.find("div.body table.roll")[0];
	this.elRollRow = this.elRollTable.rows[0];

	this.drawBody();
	this.$elBody = this.$elCalendar.find("div.body");
	this.$elDates = this.$elBody.find("table.calendar td.currentMonth");
	this.$elCalendar.appendTo(this.appendTo);
};


Calendar1.prototype.getWeekdays = function() {
	this.arrWeekdays = [];
	this.arrWeekends = [];
	for (var wd = 0; wd < 7; wd++) {
		var n = wd + parseInt(l10n.calendar.weekstart, 10);
		if (n > 6) n = n - 7;
		this.arrWeekdays.push(l10n.calendar.days_S[n].toUpperCase());

		var weekend = false;
		for (var we = 0, length = l10n.calendar.weekend.length; we < length; we++) {
			var weDayNumber = parseInt(l10n.calendar.weekend[we], 10);
			if(n == weDayNumber){
				weekend = true;
				break;
			}
		}
		this.arrWeekends.push(weekend);
	}
	return this.arrWeekdays;
};


Calendar1.prototype.rollLeft = function(){
	this.currentMonthIndex--;
	this.$elBody
		.stop(true)
		.animate({
			scrollLeft: this.currentMonthIndex * this.rollConstant
		});
	this.drawNavigation();
};


Calendar1.prototype.rollRight = function(){
	this.currentMonthIndex++;
	this.$elBody
		.stop(true)
		.animate({
			scrollLeft: this.currentMonthIndex * this.rollConstant
		});
	this.drawNavigation();
};


Calendar1.prototype.drawBody = function(){
	var tempDate = new Date(this.calendarStart);
	tempDate.setDate(1);
	var i = 0;
	while (tempDate.getTime() <= this.calendarEnd.getTime()) {
		this.elRollRow.insertCell(i).appendChild(this.drawMonth(i));
		tempDate.setMonth(tempDate.getMonth() + 1);
		i++;
	}
};


Calendar1.prototype.drawMonth = function(i){
	var table = document.createElement("table");
	table.className = "calendar";
	this.drawDays(table, i);
	return table;
};


Calendar1.prototype.drawDays = function(table, n){
	var self = this;

	var tempDate = new Date(this.date);
		tempDate.setDate(1);
		tempDate.setMonth(tempDate.getMonth() + n);

	var month = tempDate.getMonth();
	var dayShift = (tempDate.getDay() - parseInt(l10n.calendar.weekstart, 10)) % 7;

	if (dayShift < 0) dayShift += 7;
		tempDate.setDate(tempDate.getDate() - dayShift);

	for (var w = 0; w < 6; w++) {
		var row = table.insertRow(-1);
		for (var i = 0; i < 7; i++) {
			var cell = row.insertCell(-1);
			if (tempDate.getMonth() == month) {
				cell.className = 'currentMonth';
				cell.className += ' ' + tempDate.getTime();
				var elDay = document.createElement("div");
					elDay.className = 'day';
				var elDate = document.createElement("div");
					elDate.className = "date";
					elDate.appendChild(document.createTextNode(tempDate.getDate()));
					elDay.appendChild(elDate);
					var elStroke = document.createElement("div");
						elStroke.className = "stroke";
					elDay.appendChild(elStroke);
				cell.date = new Date(tempDate);
				cell.appendChild(elDay);
			}
			var chromeWinBug = tempDate.getDay();
			tempDate.setDate(tempDate.getDate() + 1);
			if (chromeWinBug === tempDate.getDay()) {
				tempDate.setDate(tempDate.getDate() + 1);
			}
		}
	}
};

Calendar1.prototype.initDaysClick = function(){
	var self = this;
	this.$elCalendar
		.on('click', 'td.enabled', function(event){
			event.stopPropagation();
			if (self.dirNumber && firstSelectedStraightDirIndex === null && $(self).hasClass("straight")) {
				firstSelectedStraightDirIndex = self.dirNumber;
			}
			self.onclickDay(event, this.date);
		})
		.on('mouseover', 'td.enabled', function(){
			$(this).addClass('hover');
			self.drawPeriod();
		})
		.on('mouseout', 'td.enabled', function(){
			$(this).removeClass('hover');
			self.drawPeriod();
		});
};

Calendar1.prototype.initDays = function(){
	var self = this;
	this.$elDates.each(function(i){
		var tempDate = this.date;
		if (tempDate < self.field.min || tempDate > self.field.max) {
			$(this)
				.removeClass('enabled')
				.addClass('disabled');
		} else {
			$(this)
				.removeClass('disabled')
				.addClass('enabled');
		}
	});
};

Calendar1.prototype.onclickDay = function(event, date){
	this.input.field.setDate(date);
	$(this.input).trigger("date-selected");
	this.hide();
};

Calendar1.prototype.checkSchedule = function(){
	this.schedule = null;
	$(".withStopLegend", this.$elCalendar).addClass("invisible");
	$(".withoutStopLegend", this.$elCalendar).addClass("invisible");
	if (this.dataDir.from && this.dataDir.to) {
		var key = this.dataDir.from + this.dataDir.to + firstSelectedStraightDirIndex;
		if (nonstopSchedule[key]) {
			this.schedule = nonstopSchedule[key];
			this.setSchedule();
		} else {
			var dateFrom = new Date(this.calendarStart);
			var dateTo = new Date(this.calendarEnd);
			this.getSchedule([dateFrom, dateTo]);
		}
	}
};


Calendar1.prototype.getSchedule = function(period){
	var self = this;
	var key = this.dataDir.from + this.dataDir.to + firstSelectedStraightDirIndex;
	var dirs = [];
	for(var i = 0, length = this.oForm.data.directions.length; i < length; i++){
		var dir = new Direction(this.oForm.data.directions[i]);
		if(dir.date) dir.date = dir.date.format("yyyy/mm/dd");
		dirs.push(dir);
	}
	var params = {
		period: period[0].stringifyAPI() + period[1].stringifyAPI(),
		directions: dirs,
		dirIndex: this.dirNumber,
		firstSelected: firstSelectedStraightDirIndex
	};
	var requestOptions = {
		repeats: 2,
		retryTime: 2000,
		RetryFunction: function(){
			MakeRequest();
		}
	};
	MakeRequest();
	function MakeRequest() {
		$.ajax({
			type: "get",
			dataType: "json",
			data: {
				params: JSON.stringify(params)
			},
			timeout: 10000,
			url: "/_api/schedule/getNonstopDates1/",
			success: function(json) {
				if(json){
					if (json.days) {
						json.key = key;
						json.period = period;
						self.parseSchedule(json);
					}
				}
			},
			complete: function(xhr){
				xhr.url = 'schedule/getNonstopDates1/?'+JSON.stringify(params);
				checkAjaxError(xhr,requestOptions);
			}
		});
	}
};


Calendar1.prototype.parseSchedule = function(json){
	var schedule = {};
		schedule.withStops = json.days.indexOf("0") >= 0;
	var lenght = json.days.length;
	var tempDate = new Date(json.period[0]);
	for (var i = 0; i < lenght; i++) {
		var flag = json.days.substr(i, 1);
		schedule[tempDate.getTime()] = flag;
		tempDate.setDate(tempDate.getDate() + 1);
	}
	this.schedule = schedule;
	nonstopSchedule[json.key] = this.schedule;
	if (this.$elCalendar[0].offsetHeight > 0) this.setSchedule();
};


Calendar1.prototype.setSchedule = function(){
	var self = this;
	if(this.schedule.withStops){
		$(".withStopLegend", this.$elCalendar).removeClass("invisible");
	} else {
		$(".withoutStopLegend", this.$elCalendar).removeClass("invisible");
	}
	this.$elCalendar
		.find("table.calendar td.enabled")
		.each( function(){
			var $this = $(this);
			$this.removeClass('withStop straight prevdoStraight');
			if (self.schedule[this.date.getTime()] == 0) {
				$this.addClass('withStop');
			} else if (self.schedule[this.date.getTime()] == 1) {
				$this.addClass('straight');
			} else if (self.schedule[this.date.getTime()] == 2) {
				$this.addClass('prevdoStraight');
			}
		});

};


Calendar1.prototype.getCurrentMonthIndex = function() {
	this.currentMonthIndex = 0;
	var date = new Date(this.today);
	if (this.field.date) {
		date = new Date(this.field.date);
	} else {
		for (var i = 0, length = this.oForm.data.directions.length; i < length; i++) {
			var dir = this.oForm.data.directions[i];
			if (dir.date) {
				date = new Date(dir.date);
				break;
			}
		}
	}
	this.currentMonthIndex = date.getFullYear() * 12 + date.getMonth() - this.calendarStart.getFullYear() * 12 - this.calendarStart.getMonth();
	return this.currentMonthIndex;
};


Calendar1.prototype.drawNavigation = function() {
	this.$elRollLeft.toggleClass('invisible', this.currentMonthIndex === 0);

	var tempDate = new Date(this.calendarStart);
			tempDate.setDate(1);
			tempDate.setMonth(tempDate.getMonth() + this.currentMonthIndex);
	this.elMonth.innerHTML = l10n.calendar.months_N[tempDate.getMonth()];
	this.setHeight(tempDate);
			tempDate.setMonth(tempDate.getMonth() + 1);

	this.$elRollRight.toggleClass('invisible', tempDate.getTime() > this.calendarEnd.getTime() );
};


Calendar1.prototype.setHeight = function(date){
	var tempDate = new Date(date);
		tempDate.setDate(1);
	var month = tempDate.getMonth();
	var dayShift = (tempDate.getDay() - parseInt(l10n.calendar.weekstart, 10)) % 7;
	if (dayShift < 0) dayShift += 7;
	var dayCount = new Date(tempDate.getFullYear(), tempDate.getMonth() + 1, 0).getDate();
	if (dayCount + dayShift <= 35) {
		this.$elBody.height(200);
	} else {
		this.$elBody.height(240);
	}
};


Calendar1.prototype.drawPeriod = function() {
	var $elDates = this.$elDates;
	var hover = $elDates.filter('.hover:first')[0];

	$elDates
		.removeClass('flight returnFlight')
		.filter(this.field.date ? '.' + this.field.date.getTime() : null )
		.toggleClass('current', !hover);

	for (var i = this.oForm.data.directions.length - 1; i >= 0; i--) {
		var dataDir = this.oForm.data.directions[i];
		var time = dataDir.date && dataDir.date.getTime();
		if (time) {
			$elDates.filter('.' + time).addClass('flight');
			if (this.oForm.data.flightType === "round" && i === 1) {
				$elDates.filter('.' + time).addClass('returnFlight');
			}
		}
	}
};

Calendar1.prototype.show = function() {
	if (this.$elCalendar[0].offsetHeight === 0) {
		try {
			Backbone.trigger('formWithTabs', {
				type: 'avia'
			});
		} catch (e) {
			ga('send', 'event', 'error', 'open_avia_form_before_calendar_show');
		}

		var self = this;
		this.reInit();
		this.initDays();
		this.getCurrentMonthIndex();
		this.drawNavigation();
		this.drawPeriod();
		document.body.appendChild(this.$elCalendar[0]);
		this.$elBody.scrollLeft(this.rollConstant * this.currentMonthIndex);
		this.setOffset();
		$(document)
			.on("tw-suggest-apply", function(){
				self.checkSchedule();
			});
		$(window).on('resize', self.link_setOffset);
		setTimeout(function(){
			$(document).on("click", self.link_clickOutside);
		}, 4);
		this.$elCalendar.removeClass("invisible");
		this.setOffset();
	}
};


Calendar1.prototype.setOffset = function() {
	var offset = $(this.input).offset();
	this.$elCalendar[0].style.top = offset.top + this.input.offsetHeight + 5 + "px";
	this.$elCalendar[0].style.left = offset.left + (this.input.offsetWidth / 2) + "px";
};


Calendar1.prototype.hide = function() {
	var self = this;
	$(window).off('resize', self.link_setOffset);
	$(document)
		.off("click", self.link_clickOutside)
		.off('tw-suggest-apply');
	$(this.input.field.elField).removeClass("focus");
	this.$elCalendar
		.detach()
		.find('.hover')
			.removeClass('hover');
};


Calendar1.prototype.clickOutside = function(event) {
	if (event.target != this.input) {
		this.hide();
	}
};


HotelsCalendar = function(input, oForm) {
	HotelsCalendar.parent.constructor.apply(this, arguments);
};

inherits(HotelsCalendar, Calendar1);

HotelsCalendar.prototype.init = function(){
	if (this.input.name == 'dateCheckIn') {
		this.field2 = this.oForm.fieldCheckOut;
	} else {
		this.field2 = this.oForm.fieldCheckIn;
	}
	this.input2 = this.field2.input;
};


HotelsCalendar.prototype.reInit = function(){
};


HotelsCalendar.prototype.getCurrentMonthIndex = function() {
	this.currentMonthIndex = 0;
	var date = new Date(this.today);
	if (this.field.date) {
		date = new Date(this.field.date);
	} else if (this.field2.date) {
		date = new Date(this.field2.date);
	}
	this.currentMonthIndex = date.getFullYear() * 12 + date.getMonth() - this.calendarStart.getFullYear() * 12 - this.calendarStart.getMonth();
	return this.currentMonthIndex;
};


HotelsCalendar.prototype.drawPeriod = function() {
	var self = this;
	var checkIn = this.oForm.fieldCheckIn.date && this.oForm.fieldCheckIn.date.getTime();
	var checkOut = this.oForm.fieldCheckOut.date && this.oForm.fieldCheckOut.date.getTime();

	var $elDates = this.$elBody.find("td.enabled");
	var currentDate = this.field.date && this.field.date.getTime();
	var $current = $elDates.filter('.' + currentDate);
	var $hover = $elDates.filter('.hover');
	if ($hover[0]) currentDate = $hover[0].date.getTime();

	if (this.input.name == 'dateCheckIn') {
		if ($hover[0]) {
			$current.removeClass('checkIn');
			$hover.addClass('checkIn');
		} else {
			this.$elDates.filter('.checkIn').removeClass('checkIn');
			$current.addClass('checkIn');
		}
		if (checkOut) {
			this.$elDates.filter('.checkOut').removeClass('checkOut');
			if (currentDate < checkOut) {
				$elDates.filter('.' + checkOut).addClass('checkOut');
			}
			this.$elDates.each(function(i){
				var tempDate = this.date.getTime();
				if (tempDate >= currentDate && tempDate <= checkOut) {
					$(this).addClass('range');
				} else {
					$(this).removeClass('range');
				}
			});
		}
	}
	if (this.input.name == 'dateCheckOut') {
		if ($hover[0]) {
			$current.removeClass('checkOut');
			$hover.addClass('checkOut');
		} else {
			this.$elDates.removeClass('checkOut');
			$current.addClass('checkOut');
		}
		if (checkIn) {
			this.$elDates.removeClass('checkIn');
			this.$elDates.filter('.' + checkIn).addClass('checkIn');
			this.$elDates.each(function(i){
				var tempDate = this.date.getTime();
				if (tempDate <= currentDate && tempDate >= checkIn) {
					$(this).addClass('range');
				} else {
					$(this).removeClass('range');
				}
			});
		}
	}
};

$(document).ready(function() {
	try{
		setTimeout(function(){
			if(window.objAvia) {
				if(!window.objAvia.startSearch && !tw.testResult) {
					new initDeals();
				} else {
					$('#deals').remove();
				}
			} else if(!tw.testResult) {
				new initDeals();
			} else {
				$('#deals').remove();
			}
		}, 0);
	} catch(e){}
});

function initDeals() {
	var self = this;

	this.Block = $('#deals')[0];

	if (!this.Block) return;

	this.Filter = $('#d_filter',this.Block)[0];
	this.Result = $('#d_result',this.Block)[0];

	this.recommend = tw.recommendDeals||false;

	$.template( 'tmpl_deals', $("#tmpl_deals").trim());
	$.template( 'tmpl_item', $("#tmpl_dealitem").trim());
	$.template( 'tmpl_emptyitem', $("#tmpl_emptyitem").trim());

	this.paramsByUrl = {
		from: tw.hashParams.deals_from||"",
		to: tw.hashParams.deals_to||"",
		when: tw.hashParams.deals_when||"",
		stay: tw.hashParams.deals_stay||""
	};
	for(var i in this.paramsByUrl) {
		if(i != "when") {
			this.paramsByUrl[i] = this.paramsByUrl[i].toUpperCase();
		}
	}

	$(document.body).on("changeLanguage", function() {
		if(typeof(Storage)!=="undefined") {
			try {
				(storage || localStorage).removeItem('deals');
			} catch(e) {}
		}
	});

	this.initDefaultCities = function(json) {
		if(this.filterClicked) {
			$(l10n.deals.noresult).insertAfter(self.Filter);
		}
		$('#want_deal').on('click', function(){
			self.getDeals();
		});

		var defArray = ["NYC", "LON", "BKK", "TYO", "AMS", "RIO"];

		if(self.defaultFilterDestinations){
			defArray = self.defaultFilterDestinations;
		}

		var startPoint = self.defaultKmqData.from ? self.defaultKmqData.from : (tw.ipinfo && tw.ipinfo.nearCityCode) ? tw.ipinfo.nearCityCode : "MOW";

		for(var i=0, l=defArray.length; i<l; i++) {
/*			if(tw.language == "ru") {
				var from = ref.getCity(startPoint).en.toLowerCase().replace(/\s/g, '_');
				var	to = ref.getCity(defArray[i]).en.toLowerCase().replace(/\s/g, '_');
				var	City = {
					"to": defArray[i],
					"searchkey": [
						'',
						tw.language,
						l10n.url.flights,
						from + '-' + to + '_' + startPoint + '-' + defArray[i], ''
					].join('/')
				};
				self.assignDefaultPicture(City);
				$($.tmpl('tmpl_emptyitem', City)).appendTo(self.Result);
			} else {*/
				var from = startPoint;
				var to = defArray[i];
				var City = {
					"to": defArray[i],
					"searchkey": '#'+startPoint+defArray[i]
				};

				self.assignDefaultPicture(City);
				$($.tmpl('tmpl_emptyitem', City)).appendTo(self.Result);
			//}
		}
		$('.deal-item', self.Result).on('click', function(){
			objAvia.getURLData( this.href.substring(this.href.indexOf('#')) );
			var firstDirRow = objSearchForm.dirRows[0];
			firstDirRow.fromField.suggest.setByCode( objAvia.noDataDirection.from );
			firstDirRow.toField.suggest.setByCode( objAvia.noDataDirection.to );
			objSearchForm.update(true);
		});
		kmqRecord({name:"errorDeals", obj: self.defaultKmqData, prefix: 'deals'});
	};

	this.getFilterData = function() {
		var self = this;
		var requestOptions = {
			repeats: 2,
			backupRepeats: true,
			RetryFunction: function(){
				MakeRequest();
			},
			ErrorFunction: function(){
				removeLoader();
			}
		};

		var getFiltersParams = {
			locale: tw.language,
			whenMode: 'byMonths'
		};

		if(getFiltersParams.locale && getFiltersParams.locale.indexOf('ua') > -1){
			getFiltersParams.locale = 'ua';
		}

		MakeRequest();
		function MakeRequest() {
			$.ajax({
				cache: false,
				dataType: "json",
				url: "/_api/deals/getFilters/?options=" + JSON.stringify(getFiltersParams),
				timeout: 70000,
				success: function(json) {
					self.filterData = {
						from: {
							name: l10n.deals.from.name,
							items: {}
						},
						to: {
							name: l10n.deals.to.name,
							value: "ANYWHERE",
							items: {}
						},
						when: {
							name: l10n.deals.when.name,
							value: "CHEAPEST",
							items: {}
						},
						stay: {
							name: l10n.deals.stay.name,
							value: "ANY_STAY",
							items: {}
						}
					};

					for(var i in json) {
						if(i == "from") {
							$(json[i]).each(function(k) {
								var code = json[i][k];
								if(k===0) {
									self.filterData[i].value = code;
								}

								self.filterData[i].items[code] = {
									"value": ref.getCityName(code)
								};
								if(l10n.deals.from[code]) {
									self.filterData[i].items[code] = {
										"value": l10n.deals.from[code]
									};
								}
							});
						}
						else if(i == "to") {
							$(json[i]).each(function(k) {
								var code = json[i][k].name;

								if(code === 'ANYWHERE'
									&& json[i][k].points
									&& json[i][k].points.length > 0){
									self.defaultFilterDestinations = json[i][k].points;
								}

								if(l10n.deals.to[code]) {
									self.filterData[i].items[code] = {
										"value": l10n.deals.to[code]
									};
								} else {
									var valueToUse = code;

									if(json[i][k].locale
										&& typeof json[i][k].locale === 'object'
										&& json[i][k].locale[tw.language]){
										valueToUse = json[i][k].locale[tw.language];
									}
									else if(json[i][k].locale){
										valueToUse = json[i][k].locale;
									}

									self.filterData[i].items[code] = {
										"value": valueToUse
									};
								}
							});
						}
						else if(i == "when") {
							var localmonth = l10n.calendar.months_N;

							if(tw.language == "ru") {
								localmonth = l10n.calendar.months_P;
							}

							$(json[i]).each(function(k) {
								var code = json[i][k];

								if(code.indexOf('_') > -1){
									var month = code.split('_')[1];
									self.filterData[i].items[code] = {
										"value": l10n.deals.when.month.replaceByHash({
											"month": localmonth[month]
										})
									}
								}
								else{
									self.filterData[i].items[code] = {
										"value": l10n.deals.when[code] || code
									}
								}
							});
						}
						else if(i == "stay") {
							$(json[i]).each(function(k) {
								var code = json[i][k];
								if(l10n.deals.stay[code]) {
									self.filterData[i].items[code] = {
										"value": l10n.deals.stay[code]
									};
								} else {
									self.filterData[i].items[code] = {
										"value": code
									}
								}
							});
						}
					}

					$($.tmpl('tmpl_deals', self.filterData)).appendTo(self.Filter);

					self.initSuggest();
					self.initParams();
					self.initGoups();
				}
			});
		}
	};

	this.initSuggest =  function() {
		var $cityFieldContainer = $('.deal-suggest', self.Filter);

		self.cityField = new SuggestField({
			appendTo: $cityFieldContainer[0],
			name: "deal-city",
			value: null,
			defaultValue: ""
		});
		self.cityField.suggest = new Suggest(self.cityField, self, 100, {
			className: 'deal-city-suggest',
			container: $cityFieldContainer[0],
			calculatePosition: false,
			maxItems: 5
		});

		self.cityCode = self.filterData.from.value;
		if(tw.ipinfo && tw.ipinfo.nearCityCode) {
			self.cityCode = tw.ipinfo.nearCityCode;
		}
		var localParams = self.getStorage();
		if(localParams && localParams['from'] && ref.getCity(localParams['from']).Name && !self.paramsByUrl['from'] && !self.filterData.from[localParams['from']]) {
			self.cityCode = localParams['from'];
		}

		self.cityField.suggest.currentResult = self.cityCode;
		self.cityField.suggest.setCurrentResult();

		$(self.cityField.suggest).on("suggest-apply", function(event){
			try {
				if(self.cityField.suggest.currentResult && self.cityField.suggest.currentResult != self.cityCode) {
					self.cityCode = self.cityField.suggest.currentResult;
					self.cityField.suggest.placeholder.defaultValue = ref.getCityName(self.cityCode);
					self.cityField.placeholder.value = "";
					self.getDeals();
				}
			} catch(e) {}
		});
	};
	//для саджест поля
	this.update = function() {};

	this.initParams =  function() {
		for(var i in self.filterData) {
			if(self.paramsByUrl[i]) {
				if(i == "from") {
					if(ref.getCity(self.paramsByUrl[i]).Name) {
						self.cityField.suggest.currentResult = self.paramsByUrl[i];
						self.cityField.suggest.setCurrentResult();
					}
				} else if(self.filterData[i].items[self.paramsByUrl[i]] || self.filterData[i].items[self.paramsByUrl[i]]){
					self.filterData[i].value = self.paramsByUrl[i];
				}
			}
		}
	};

/*	this.addFrom = function(code) {
		if(ref.Cities[code]) {
			self.filterData.from.items[code] = {"value":ref.getCityName(code)};
			self.filterData.from.value = code;
		}
	};*/

	this.initGoups = function() {
		self.Groups = $('.button-group', self.Filter);
		var localParams = self.getStorage();

		var selectOption = function(listItem, group){
			var currentSpanText = $('span:not([class*="selection-carret"])', group)[0];
			var itemText = $(listItem).html();
			$('li', group).removeClass('invisible');
			$(listItem).addClass('invisible');
			$(currentSpanText).html(itemText);
			var dealCode = $(listItem).data('dealcode');
			$('button', group).val( dealCode );
		}

		$(self.Groups).each(function(){
			var currentGroup = this;
//			var currentText = $('span:not([class*="selection-carret"])', currentGroup)[0];
			$('li', currentGroup).on('click choose', function() {
				selectOption(this,currentGroup);
				/*var itemText = $(this).html();
				 $('li', currentGroup).removeClass('invisible');
				 $(this).addClass('invisible');
				 $(currentText).html(itemText);
				 var dealCode = $(this).data('dealcode');
				 $('button', currentGroup).val( dealCode );*/

				self.getDeals();
			});

			var type = $(this).data('group');
			if(localParams && localParams[type] && !self.paramsByUrl[type]) {
				if(type == "from") {
					self.filterData[type].value = localParams[type];
				} else if(self.filterData[type].items[localParams[type]]) {
					self.filterData[type].value = localParams[type];
				}
			}
			if(self.filterData[type].value) {
				$($('li[data-dealcode="' + self.filterData[type].value + '"]', currentGroup)[0]).click();
			}
			if($('li', currentGroup).length < 2) {
				$(currentGroup).addClass('disable');
			}

			$(currentGroup)
				.hover( function(e){
					if( $(this).parents('td').hasClass('disabled') ) {
						return;
					}
					$(this).addClass('open');
				}, function(e){
					$(this).removeClass('open');
				})
				.on('click', function(e) {
					if( $(this).parents('td').hasClass('disabled') ) {
						return;
					}
					$(this).toggleClass('open');
				});
		});
	};

	this.getDeals = function() {
		var params = {
			"to":       $('button', self.Groups[0]).val(),
			"when":     $('button', self.Groups[1]).val(),
			"stay":     $('button', self.Groups[2]).val(),
			"lang":     tw.language,
			"currency": tw.currency,
			"limit":    18,
			"ver":      3
		};
		params.from = this.cityField.value;
		if(this.recommend) {
			params.to   = "ANYWHERE";
			params.when = "CHEAPEST";
			params.stay = "ANY_STAY";
		}

		if(params.lang && params.lang.indexOf('ua') > -1){
			params.lang = 'ua';
		}

		var referrerInfo = readReferrerInfo();

		if(referrerInfo.tag){
			params.source = referrerInfo.tag;
		}

		var err;
		for(var i in params) {
			if(!params[i]) {
				err = true;
				break;
			}
		}

		if(err) {
			return;
		}

		self.writeStorage(params);

		var disableFilter = false;

		if( params.stay == "ANY_STAY" && params.when == "CHEAPEST" && params.to == "ANYWHERE" ) {
			disableFilter = true;
		}

		var showTimeLabels = false;

		if( params.stay == "ANY_STAY" ) {
			showTimeLabels = true;
		}

		var requests = tw.requestsList || [];
		var requestIndex = requests.length;
		if (requestIndex) {
			var destinations = [];
			var directionTo;
			while ( requestIndex-- ) {
				directionTo = requests[requestIndex].directions[0].to;
				if (destinations.indexOf(directionTo) === -1) {
					destinations[destinations.length] = directionTo;
				}
			}
			params.preferredDestinations = JSON.stringify(destinations);
		}

		self.defaultKmqData = {
			"vid": readCookie('vid'),
			"timestamp": new Date().format('isoDateTime'),
			"ip": tw.ipinfo ? tw.ipinfo.ip : "",
			"from": params.from,
			"to": params.to,
			"when": params.when,
			"stay": params.stay,
			"currency": tw.currency
		};


		if(self.dealRequest) {
			self.dealRequest.abort();
		}
		clearTimeout(this.DefaultDrawInterval);

		$.ajax({
			cache: false,
			dataType: "json",
			url: "/_api/deals/getDeals/",
			beforeSend: function(xhr) {
				$('.nodeals').remove();
				self.dealRequest = xhr;
				$(self.Result).empty();
				var hashParams = {
					"deals_from": params.from,
					"deals_to": params.to,
					"deals_when": params.when,
					"deals_stay": params.stay
				};
				updateHash(hashParams);
				appendTWLoader({appendTo: self.Block });
			},
			data: params,
			timeout: 25000,
			success: function(json) {
				if (!json.error && json.length && json.length > 0) {
					self.recommendCount = 0;
					if (self.recommend) {
						$('.recommend').show();
						var searches = tw.requestsList;
						for (var ri = 0, rl = searches.length; ri < rl; ri++) {
							var curSearch = searches[ri];
							var dirs      = curSearch.directions;
							var firstDir  = dirs[0];
							var newFlight = {
								"from":        firstDir.from,
								"to":          firstDir.to,
								"oDepartDate": new Date(firstDir.date),
								"searchkey":   curSearch.searchKey,
								"recommend":   true
							};
							if (dirs.length === 2) {
								newFlight.oReturnDate = new Date(dirs[1].date);
							}
							self.makeTimeLabels(newFlight);
							self.assignDefaultPicture(newFlight);
							$($.tmpl('tmpl_item', newFlight)).appendTo(self.Result);
							self.recommendCount++;
						}
					}

					var countPrice   = 0;
					var countNoPrice = 0;
					var minPrice     = 1000000000, maxPrice = 0, curDate = new Date(), stamp = curDate.format('isoDateTime'), oFlights = {};
					for (var i = 0, l = json.length; i < l; i++) {
						if (i > params.limit - 1) {
							break;
						}
						if (self.recommend) {
							if (self.recommendCount > 7) {
								break;
							} else {
								self.recommendCount++;
							}
						}
						if (json.length < 4 && disableFilter) {
							$('td:nth-child(n+2)', self.Filter).addClass('disabled');
						} else {
							$('td', self.Filter).removeClass('disabled');
						}

						var flight = json[i];

						var from = ref.getCityCode(flight.from),
							to   = ref.getCityCode(flight.to);

						if (flight.price && !flight.returnDate) {
							continue;
						}

						/*var refFrom = ref.getCity(from),
						 refTo = ref.getCity(to),
						 seoFrom = from,
						 seoTo = to;
						 if(refFrom.en){
						 seoFrom = refFrom.en.toLowerCase().replace(/\s/g, '_');
						 }
						 if(refTo.en){
						 seoTo = refTo.en.toLowerCase().replace(/\s/g, '_');
						 }
						 flight.seokey = ['', tw.language, l10n.url.flights, seoFrom+'-'+seoTo+'_'+from+'-'+to, ''].join('/');*/

						if (flight.price) {
							countPrice++;
							if (flight.price > maxPrice) {
								maxPrice = flight.price;
							}
							if (flight.price < minPrice) {
								minPrice = flight.price;
							}

							flight.oDepartDate = new Date.parseAPI(flight.departDate);

							flight.searchkey   = flight.oDepartDate.format('ddmm') + from + to;
							flight.oReturnDate = new Date.parseAPI(flight.returnDate);
							flight.searchkey += flight.oReturnDate.format('ddmm');
							flight.AK          = flight.directions[0][0].airCompany;

							if (params.stay == "ANY_STAY") {
								self.makeTimeLabels(flight);
							}
						} else {
							countNoPrice++;
							/*flight.searchkey = [
							 '',
							 tw.language,
							 l10n.url.flights,
							 seoFrom + '-' + seoTo + '_' + flight.from + '-' + flight.to,
							 ''].join('/');*/
							flight.searchkey = '#' + from + to;
						}

						self.assignDefaultPicture(flight);

						flight.found = Math.ceil((curDate.valueOf() - flight.dateCreated) / 3600000);
						flight.id    = i;
						if (self.recommend) {
							flight.recommend = true;
						}

						oFlights[i] = flight;

						if (flight.price) {
							$($.tmpl('tmpl_item', flight)).appendTo(self.Result);
						} else {
							$($.tmpl('tmpl_emptyitem', flight)).appendTo(self.Result);
						}
					}

					$(self.Block).slideDown();

					$('.deal-item', self.Result).on('click', function () {
						kmqRecord({name:"dealClick", obj: { auth: tw.visitor.auth }, prefix: 'mainForm'});

						if (this.href) {
							if (self.recommend) {
								//ggl
								try {
									ga('send', 'event', 'recommendation', 'best');
								} catch (e) {
								}
							}
							var data           = objAvia.getURLData(this.href.substring(this.href.indexOf('#')));
							var firstDirection = data.directions[0];
							var firstDirRow    = objSearchForm.dirRows[0];
							firstDirRow.fromField.suggest.setByCode(firstDirection.from);
							firstDirRow.toField.suggest.setByCode(firstDirection.to);
							/*							var secondDirection = data.directions[1];
							 if(firstDirection.date) {
							 firstDirRow.dateFrom.setDate(firstDirection.date);
							 }
							 if(secondDirection && secondDirection.date) {
							 firstDirRow.dateTo.setDate(secondDirection.date);
							 }*/
							objSearchForm.update(true);
						} else {
							var searchKey = $(this).data('searchkey');
							if (self.recommend) {
								if ($(this).hasClass('empty')) {
									//ggl
									try {
										ga('send', 'event', 'recommendation', 'user');
									} catch (e) {
									}
								} else {
									//ggl
									try {
										ga('send', 'event', 'recommendation', 'best');
									} catch (e) {
									}
								}
							} else {
								var curFlight     = oFlights[$(this).data('flightid')];
								var singleKmqData = {
									"vid":         readCookie('vid'),
									"timestamp":   stamp,
									"ip":          tw.ipinfo ? tw.ipinfo.ip : "",
									"currency":    tw.currency,
									"price":       curFlight.price,
									"is2OW4RT":    curFlight.is2OW4RT,
									"isCharter":   curFlight.isCharter,
									"fareType":    curFlight.fareType,
									"source":      curFlight.source,
									"dateCreated": curFlight.dateCreated,
									"departDate":  curFlight.departDate,
									"from":        curFlight.from,
									"to":          curFlight.to,
									"returnDate":  curFlight.returnDate
								};
								kmqRecord({name: "chooseDeal", obj: singleKmqData, prefix: 'deals'});
							}
							var data = objAvia.parseKey(searchKey);
							objAvia.changeRequest(objAvia.addDataToRequestsList(data), null, 'deals');
						}
					});
					if (!self.recommend) {
						var kmqData = {
							"vid":         readCookie('vid'),
							"timestamp":   stamp,
							"ip":          tw.ipinfo ? tw.ipinfo.ip : "",
							"from":        params.from,
							"to":          params.to,
							"when":        params.when,
							"stay":        params.stay,
							"offers":      json.length,
							"minPrice":    minPrice,
							"maxPrice":    maxPrice,
							"currency":    tw.currency,
							"offersA":     countPrice,
							"offersB":     countNoPrice,
							"offersApart": Math.ceil(countPrice / (countPrice + countNoPrice) * 100)
						};
						kmqRecord({name: "getDeals", obj: kmqData, prefix: 'deals'});
					}
				} else {
					self.initDefaultCities(json);
				}

				$(document).trigger("deals-loaded");
			},
			complete: function() {
				removeLoader();
				self.filterClicked = true;
				self.checkAdvBlock();
			},
			error: function(xhr) {
				/*if (xhr.status === 0 && xhr.statusText != "abort") { //проверяем отсутствие инета
					addPopup({
						error: true,
						reason: l10n.popup.noConnection,
						comment: l10n.popup.noConnectionComment,
						close_button: true,
						button: l10n.popup.close,
						removeOnAction: true
					});
				}*/
				self.DefaultDrawInterval = setTimeout(function() {
					self.initDefaultCities();
				}, 1000);
			}
		});
	};

	this.assignDefaultPicture = function(flight){
		var wing = Math.floor(Math.random() * (12 - 1)) + 1;

		// funny hack here, hopefully random generator will never break :)
		if(self.lastPictureAssigned && wing === self.lastPictureAssigned){
			wing = Math.floor(Math.random() * (12 - 1)) + 1;
		}

		self.lastPictureAssigned = wing;
		flight.def = "background-image: url('/images/deals_cities/default/flight"+ wing +".jpg');";
	};

	this.checkAdvBlock = function(){
		if(self.recommend) {
			return;
		}
		// if (tw.partner) {
		// 	return;
		// }
		var config = {
			bannerId: 'adfox_151316243215369951',
			pp: 'h',
			ps: 'cprp',
			p2: 'fpbh',
			partnerAdfox: true,
		}
		if (~window.location.href.indexOf('www.onetwotrip')) {
			config.bannerId = 'adfox_149451050978071889';
			config.ps = 'cmje';
			config.partnerAdfox = false;
		}
		if(!self.commercialLoaded) {
			try {
				$('.rotationBlock').remove();
				var tempCommercial = document.createElement('div');
				$(tempCommercial).addClass('invisible rotationBlock').attr('id', config.bannerId);
				$('body').append(tempCommercial);

				var options = {
					onload: function() {
						self.commercialLoaded = true;
						self.checkAdvBlock();
					},
					needMeta: false,
					keywords: '',
					partnerAdfox: config.partnerAdfox,
				};

				adfoxInitComBlock({
					ownerId: 255389,
					containerId: config.bannerId,
					pp: config.pp,
					ps: config.ps,
					p2: config.p2,
					pk: tw.partner ? tw.partner.partnerId : ''
				}, options);
			} catch(e) {
				console.warn('adfox error -->', e);
			}
		} else {
			var deals = $('.deal-item');
			var position = (deals.length > 4) ? 3 : deals.length;
			var dealRotation = document.createElement('div');
			$(dealRotation).attr({"id": config.bannerId, "class": "deal-promo"});
			$(dealRotation).html( $('.rotationBlock').html() );
			$(dealRotation).insertAfter( deals[position] );
		}
	};

	this.makeTimeLabels = function(flight) {
		if(!flight.oReturnDate) {
			return;
		}
		flight.label = "";
		flight.labelcls = "";

		var first = flight.oDepartDate,
			second = flight.oReturnDate,
			fDay = first.getUTCDay(),
			sDay = second.getUTCDay(),
			fMonth = first.getMonth(),
			sMonth = second.getMonth(),
			diff = Math.floor( (second.valueOf() - first.valueOf())/86400000 ),
			diffStr = String(diff),
			diffLength = diffStr.length,
			last = parseInt( diffStr.substring( diffLength-1 ), 10),
			prelast = parseInt( diffStr.substring( diffLength-2,1 ), 10),
			labels = l10n.deals.labels;

		if(fMonth === sMonth && fDay === 4 && sDay === 6) {
			flight.label = labels["weekend"];
			flight.labelcls = "weekend";
		} else if(diff === 7) {
			flight.label =labels["week"];
			flight.labelcls = "week";
		} else if(diff === 10) {
			flight.label = labels["ten"];
			flight.labelcls = "ten";
		} else if(diff === 14) {
			flight.label = labels["fewweek"];
			flight.labelcls = "fewweek";
		} else if (prelast === 1 && diffLength > 1) {
			flight.label = diff + ' ' + labels["moredays"];
		} else if (last === 1 || !diff) {
			if(!diff) {
				diff = 1;
			}
			flight.label = diff + ' ' + labels["day"];
		} else if (0 < last && last < 5) {
			flight.label = diff + ' ' + labels["days"];
		} else {
			flight.label = diff + ' ' + labels["moredays"];
		}
	};

	this.writeStorage = function(storageParams) {
		try {
			(storage || localStorage).setItem('deals', JSON.stringify(storageParams));
		} catch(e) {}
	};

	this.getStorage = function() {
		return $.parseJSON((storage || localStorage).getItem('deals')) || false;
	};

	this.getFilterData();
}

$(document).ready(function() {
	try{
        setTimeout(function(){
            if(window.objAvia) {
                if(!window.objAvia.startSearch && !tw.testResult && !tw.partner) {
                    new InitDowloadAppBlock();
                } else {
                    $('#downloadApp').remove();
                }
            } else if(!tw.testResult && !tw.partner) {
                new InitDowloadAppBlock();
            } else {
                $('#downloadApp').remove();
            }
        }, 0);
	} catch(e){}

	if (tw.language === 'ru') {
		var options = {
			keyword: [],
			needMeta: false
		};

		adfoxInitComBlock({
			ownerId: 255389,
			containerId: 'adfox_149260982148182978',
			pp: 'h',
			ps: 'cmdr',
			p2: 'fpbh',
			pk: options.keywords
		}, options);
	}
});


function InitDowloadAppBlock() {
	var self = this;
	var block = $('#downloadApp');
	if (!block) return;

	var showInfoBlocks = tw.language.indexOf('ru') !== -1;
	if (showInfoBlocks) {
		block.append($.tmpl($('#tmpl_infoBlocks').trim()));
	} else {
		block.append($.tmpl($('#tmpl_downloadApp').trim()));
	}

	var form = $('#downloadApp__form', block);
	var button = $('.downloadApp__btn', form);

	if (form) {

		this.phoneInput = $('#downloadApp__phone-number', block);
		this.messageBox = $('.downloadApp__message-box', block);

		//из-за того что в глобальных стилях есть !important
		//в библиотеке поля стоит z-index:6 !important
		this.phoneInput.css("cssText", "z-index: 1 !important; padding-left: 10px !important" );

		this.tmplMessages = l10n.index.downloadApp.messages;

		$(self.phoneInput).intlTelInput({
			customPlaceholder: function () {
				return l10n.index.downloadApp.placeholder
			},
			utilsScript: "/js/intlTelInputUtils.js"
		});

		$(self.phoneInput).val(l10n.index.downloadApp.placeholder);

		this.phoneInput.on('keyup', function (e) {
			if ($(e.target).val()[0] !== '+') {
		 		self.phoneInput.intlTelInput('setNumber', '+' + $(e.target).val());
		 	}
			self.setStatusForm('clearStatus');
		 	if (showInfoBlocks) {
				if (self.phoneInput.intlTelInput("isValidNumber")) {
					button.addClass('isValid');
				} else {
					button.removeClass('isValid');
				}
			}
		});

		this.phoneInput.on('focus', function (e) {
			if ($(e.target).val() === "") {
				self.phoneInput.intlTelInput('setNumber', '+')
			}
			self.setStatusForm('focusPhoneInput');
		});

		this.phoneInput.on('blur', function (e) {
			if ($(e.target).val() === "+") {
				self.phoneInput.intlTelInput('setNumber', '')
			}
			self.setStatusForm('blurPhoneInput');
		});

		form.on('submit', function (e) {
			e.preventDefault();

			kmqRecord({name:"downloadApp", obj: { auth: tw.visitor.auth }, prefix: 'mainForm'});

			if (self.phoneInput.intlTelInput("isValidNumber")) {
				self.sendMessage(self.phoneInput.intlTelInput("getNumber"), self.phoneInput.val());
			} else {
			 	if (!$(e.target.elements[0]).val()) {
			 		self.setStatusForm('error', 'emptyField');
			 	} else {
			 		self.setStatusForm('error', 'shortValue');
			 	}
			}
		});
	}
};
InitDowloadAppBlock.prototype.sendMessage = function (phoneNumber, formattedPhoneNumber) {
	var self = this;
	if (this.request) {
		this.request.abort();
	}

	var marketingCampaign = readCookie('marketingCampaign');

	this.request = $.ajax({
		type: 'GET',
		url: '/_api/landings/sendApplicationLink',
		data: {
			phoneNumber: phoneNumber,
			source: 'mainpage',
			language: tw.language,
			marketingCampaign: marketingCampaign,
		},
		beforeSend: function () {
			self.setStatusForm('loading');
		},
		success: function (response) {
			if (response.success) {
				self.setStatusForm('success', formattedPhoneNumber);
				self.setStatusForm('clearPhoneInput');
				self.setStatusForm('blurPhoneInput');
			} else {
				self.setStatusForm('error', 'serverError');
			}
		},
		error: function () {
			self.setStatusForm('error', 'serverError');
		},
	});
};
InitDowloadAppBlock.prototype.setStatusForm = function (typeState, data) {
	var hasErrorClassName = 'hasError',
		isFocusedClassName = 'isFocused',
		successMessageClassName = 'downloadApp__message--success',
		errorMessageClassName = 'downloadApp__message--error',
		phoneInput = $('.downloadApp__input-label');
	switch (typeState) {
		case 'error':
			this.messageBox.removeClass(successMessageClassName);
			this.messageBox.addClass(errorMessageClassName);
			this.messageBox.text(this.tmplMessages.error[data]);
			if (data === 'emptyField' || data === 'shortValue') {
				phoneInput.addClass(hasErrorClassName);
			}
			break;
		case 'success':
			this.messageBox.addClass(successMessageClassName);
			this.messageBox.removeClass(errorMessageClassName);
			this.messageBox.text(this.tmplMessages.success.replaceByHash({
				phoneNumber: data,
			}));
			break;
		case 'loading':
			this.messageBox.removeClass(successMessageClassName);
			this.messageBox.removeClass(errorMessageClassName);
			this.messageBox.text(this.tmplMessages.loading);
			break;
		case 'blurPhoneInput':
			phoneInput.removeClass(isFocusedClassName);
			break;
		case 'focusPhoneInput':
			phoneInput.addClass(isFocusedClassName);
			phoneInput.removeClass(hasErrorClassName);
			break;
		case 'clearStatus':
			this.messageBox.removeClass(successMessageClassName);
			this.messageBox.removeClass(errorMessageClassName);
			this.messageBox.text('');
			break;
		case 'clearPhoneInput':
			this.phoneInput.val('');
			break;
	}
};

var objAvia, objSearchForm, objRecentSearches, objWelcomeRegister;

function initSalesPanel() {
	if(tw.language === "ru") {
		if (window.isSales) {
			var isNeedInfo = readCookie('sales_info');
			var elBlock = $.tmpl($("#tmpl_economy").trim(), {enabled: true})[0];

			if(isNeedInfo) {
				$('.economy-information', elBlock).css('display', "none");
			} else {
				$('.economy-status', elBlock).css('display', "none");
			}
			$(elBlock).insertBefore($('#topPanel'));

			$('.more-economy-info').on('click', function(){
				$('.economy-information').slideDown();
				$('.economy-status').slideUp();
			});
			$('.close-economy-info').on('click', function(){
				$('.economy-information').slideUp();
				$('.economy-status').slideDown();
				setCookie({
					name: "sales_info",
					value: 1,
					days: 360
				});
			});
		} else {
			$(document).on('visitormanager_get_success', function (event) {
				if (event.json.showSalesPopup) {
					$.tmpl($("#tmpl_economy").trim(), {enabled: false}).insertBefore($('#topPanel'));
					$('.economy-type').slideDown();
				}
			});
		}
	}
}

function initPriceReward() {
	if(window.location.hostname.indexOf("onetwotrip") < 0) {
		$('#pricereward').remove();
		return;
	}
	$('#pricereward').fadeIn();
	$(document).on("searchStart searchFinish", function(event){
		$('#pricereward').fadeOut(function(){
			$(this).remove();
		});
	});

	var $block = $('.pr-info');
	var $mainContainer = $('.pr-content');
	var $rewardsContainer1 = $('#pr1');
	var $rewardsContainer2 = $('#pr2');
	var viewPortWidth = $(window).width();

	$.ajax({
		cache: false,
		dataType: "json",
		url: "/_api/pricereward/getwinners/",
		timeout: 10000
	})
	.done(function(json){
		if( !$.isArray(json) || json.length === 0 ) return $block.fadeOut();
		//randomizing array
		var elements = json
			.sort(function(){
				return Math.random() - .5;
			})
			.map( function(rewardObj){
				var rewarDate = rewardObj.date && new Date(rewardObj.date).format('d mmmm').toLowerCase();

				var $el = $(
					'<span class="pr-info-element">' +
					'     |     ' +
					(rewarDate || '') +
					' ' +
					rewardObj.name +
					' вернули ' +
					'<span class="cur">' +
						formatMoney(rewardObj.amount) +
					' руб.</span>' +
					'<span>'
				);

				var width = $el.appendTo( document.body ).width();
				$el
					.detach()
					.data('width',width);
				return $el;
			});

			var currentPos = 0;
			function preparContainer($container){
				var sumWidth = 0;
				var i = currentPos;
				$container.children().detach();
				while( sumWidth < viewPortWidth ){
					i++;
					i%=elements.length
					var $el = elements[i];
					$container.append($el);
					sumWidth += $el.data('width');
				}
				$container.data('width',sumWidth);
				currentPos = i;
			}

			preparContainer($rewardsContainer1);
			preparContainer($rewardsContainer2);

			$rewardsContainer1.css( 'left', 0 );
			$rewardsContainer2.css( 'left', $rewardsContainer1.data('width') );

			var $currentCont = $rewardsContainer1;
			var $nextCont = $rewardsContainer2;

			function startAnimation(){
				$mainContainer.animate({
					left: -$currentCont.data('width')
				}, 40000, 'linear', function(){
					$currentCont.detach();
					$nextCont.css('left',0);
					$mainContainer.css('left',0);
					if( $currentCont[0].id === $rewardsContainer1[0].id ){
						$currentCont = $rewardsContainer2;
						$nextCont = $rewardsContainer1;
					} else {
						$currentCont = $rewardsContainer1;
						$nextCont = $rewardsContainer2;
					}
					preparContainer( $nextCont );
					$nextCont.css('left', $currentCont.data('width'));
					$mainContainer.append( $nextCont );
					startAnimation();
				});
			}
			startAnimation();

		$block.fadeIn();
	})
	.fail(function(){
		$block.fadeOut();
	})
};

function unSubscribePopup() {
	var checkI10n = (l10n.profile && l10n.profile.subscribes && l10n.profile.subscribes.types["email"+tw.params.id]) ? l10n.profile.subscribes.types["email"+tw.params.id] : "";
	if(tw.params.vid && tw.params.id && tw.params.email) {
		if(!(checkI10n && checkI10n.length > 1)) {
			window.location.href = '/p/';
			return;
		}
	} else {
		return;
	}
	var popup = addPopup({
		className: "subscribes",
		template: $("#tmpl_subscribesPopup").trim(),
		close_button: true,
		email: tw.params.email,
		init: true
	});

	var errorResult = function(){
		addPopup({
			error: true,
			reason: l10n.popup.systemError,
			comment: l10n.popup.systemComment,
			close_button: true,
			button: l10n.popup.close,
			removeOnAction: true
		});
	};

	$('.submit').on('click', function(){
		var data = {
			vid: tw.params.vid,
			id: tw.params.id,
			email: tw.params.email
		};
		$.ajax({
			type: "POST",
			dataType: "json",
			data: data,
			url: "/_api/buyermanager/updateMailListsFromLetter/",
			timeout: 10000,
			beforeSend: function(){
				$('.subscription', popup).empty();
				appendLoader({appendTo: $('.subscription', popup) });
				$('.close_button', popup).addClass('invisible');
			},
			success: function(json){
				if(json.status === "OK") {
					ga('send', 'event', 'unsubscribe', 'utm_campaign', getURLParams().utm_campaign);
					removePopup();
					popup = addPopup({
						className: "subscribes",
						template: $("#tmpl_subscribesPopup").trim(),
						close_button: true,
						email: tw.params.email,
						success: true
					});
					window.replaceLocation({
						hash: document.location.hash,
						url: document.location.pathname
					});
				} else {
					errorResult();
				}
			},
			error: function(){
				errorResult();
			}
		});
	});
}

function unSubscribeDeals(remove) {
	if(tw.language !== 'ru') {
		return;
	}
	var p = tw.params,
		from = p.from,
		to = p.to,
		email = p.email,
		fromDate = p.fromDate,
		toDate = p.toDate,
		remove = !p.deal || remove;

	if(!(from && to && fromDate && email && remove)) {
		return;
	}

	$.ajax({
		type: "get",
		cache: false,
		data: tw.params,
		url: "/_api/deals/unsubscribeFromDeals",
		timeout: 10000
	});

	var popup = addPopup({
		className: "subscribes",
		template: $("#tmpl_unsubscribesDealPopup").trim(),
		id: "unsubscribeDealSuccess",
		close_button: true,
		email: email,
		from: from,
		to: to
	});
	$('.submit',popup).on('click', function(){
		removePopup();
	});
}

function subscribeDeals() {
	if(tw.language !== 'ru') {
		return;
	}
	var p = tw.params,
		from = p.from,
		to = p.to,
		email = p.email,
		fromDate = p.fromDate,
		toDate = p.toDate,
		isSubscribe = (p.deal === 'subscribe');

	if(!(from && to && fromDate && email && isSubscribe)) {
		return;
	}
	var params = {
			email:    email,
			from:     from,
			to:       to,
			fromDate: fromDate
	};
	if(toDate) {
		params.toDate = toDate;
	}

	$.ajax({
		type: "get",
		cache: false,
		dataType: 'json',
		url: "/_api/deals/subscribeToDeals",
		data: params,
		timeout: 5000,
		success: function(json){
			var popup = addPopup({
				className: "subscribes",
				template: $("#tmpl_subscribesDealPopup").trim(),
				id: "unsubscribeDealSuccess",
				close_button: true,
				email: email,
				from: from,
				to: to,
				fromDate: Date.parseAPI(fromDate).format('d mmmm').toLowerCase(),
				toDate: toDate ? Date.parseAPI(toDate).format('d mmmm').toLowerCase() : null
			});
			$('.submit',popup).on('click', function(){
				appendLoader({appendTo: $('.subscription', popup) });
				unSubscribeDeals(true);
			});
		}
	});
}

function scrollEventListener() {
	if (document.body.scrollTop > 150) {
		window.removeEventListener('scroll', scrollEventListener);
		kmqRecord({name:"scroll", obj: { auth: tw.visitor.auth }, prefix: 'mainForm'});
	}
}
$(document).ready(function(){
	tw.notificationMessages = new NotificationsContainer({
		container: document.getElementById('layout_panels'),
		maxElements: 5,
	});

	if(tw.params.ticker){
		initTicker();
	}

	objAvia = new Avia();
	objSearchForm = new SearchForm1(function () {
		objRecentSearches = new recentSearches();
	});
	if(tw.language.indexOf('ru') > -1 && !objAvia.startSearch) {
		objWelcomeRegister = new WelcomeRegister();
	}

	if(!objAvia.startSearch && (!objWelcomeRegister || (objWelcomeRegister && !objWelcomeRegister.objWelcomeRegister))) {
		unSubscribePopup();
		unSubscribeDeals();
		subscribeDeals();
		try {
			sendCriteoEvents({ type: 'index' });
		} catch (e) {

		}
	}

	tw.oCSSelect = new tw.CSSelect(objSearchForm.data);
	objFooter = new tw.Footer();

//	initSalesPanel();

	$(document).on('click', '.layoutHeader .menu-item', function (event) {
		var id = event.target && event.target.id;
		kmqRecord({name:"topMenuClick", obj: { auth: tw.visitor.auth, id: id }, prefix: 'mainForm'});
	});

	$(document).on('click', '.searchFormABControl .searchFormABControlItem', function (event) {
		var id = event.currentTarget && event.currentTarget.id;
		kmqRecord({name:"mainFormClick", obj: { auth: tw.visitor.auth, id: id }, prefix: 'mainForm'});
	});

	window.addEventListener('scroll', scrollEventListener);

	initStat(["yandex","segmento","sift","cityads", "criteo", /*"optimizely", "olark",*/ "skyscanner"]);
});

tw.PopularFilter = null;
ajaxPointsPoly = [];
ajaxPointsInfo = [];
ajaxPointsStops = [];
tw.Polyline = {
	Flights: [],
	Points:[],
	PointsList: {}
};

function initPopularDirection(code){
	if(!ref.Cities[code] && ref.Airports[code] && ref.Airports[code].Parent) {
		code = ref.Airports[code].Parent;
	};

	$.ajax({
		type: "get",
		cache: false,
		dataType: "json",
		data: {code: code},
		url: "/_api/popular/getInfo/",
		beforeSend: function(xhr){
			abortAjax(ajaxPointsInfo);
			clearAjax(ajaxPointsInfo);
			ajaxPointsInfo.push(xhr);
		},
		success: function(json){
			$('.FilterWrapper').remove();
			ClearPopularDirectionMarkers();
			setTimeout(function(){
				if(objMap) {
					tw.PopularFilter = new PopularDirection(json);
				}
			},2000);
		},
		complete: function(){
			clearAjax(ajaxPointsInfo);
		}
	});
}
function ClearPopularDirectionMarkers(){
	if(tw.PopularFilter){
		for(var i in tw.PopularFilter.Markers){
			var curMarker =  tw.PopularFilter.Markers[i];
			curMarker.setMap(null);
		}
		if(tw.PopularFilter && tw.PopularFilter.BluePoints) {
			for(var j=0,ML=tw.PopularFilter.BluePoints.length;j<ML;j++){
				var curMarker =  tw.PopularFilter.BluePoints[j];
				curMarker.setMap(null);
			}
		}
	}
	tw.PopularFilter = null;
}


function PopularDirection(json){
	var self= this;
	this.json = json;
	this.code = this.json.target;
	if(!this.code) {return;}
	this.map = objMap.map;
	this.BluePoints = [];
	if(!json.error) {
		this.month = new Date().getMonth();
		this.initDefaultSliderValues();
		this.time = this.json.timings;
		this.price = this.json.costs;
		this.climate = this.json.climate;

		this.Points = [];
		this.Markers = {};
		this.makePointsArray();
		this.initFilters();
		this.makeNatureArrays();
	}

	$('.f_directions',this.filter).delegate('.f_top_ico','click', function() {
		if(self.filtering) {
			return;
		}
		if( $(this).hasClass('selected')) {
			$(this).removeClass('selected');
			self.selectedNatue = null;
		} else {
			$(this).addClass('selected').siblings().removeClass('selected');
			self.selectedNatue = $(this).hasClass('sea_point')?'sea':'mountain';
		}
		self.FilterPopular();
	});
	/*if(this.code) {
		this.initDirectPoints();
	}*/
}


PopularDirection.prototype.initDefaultSliderValues = function(){
	this.MinAirTemp = 100;
	this.MaxAirTemp = -100;
	//this.MinWaterTemp = 100;
	//this.MaxWaterTemp = -100;
	this.MinPrice = 1000000;
	this.MaxPrice = 0;
	this.MinTime = 1000000;
	this.MaxTime = 0;
};


PopularDirection.prototype.makePointsArray = function(){
	var self =this;
	for(var j in this.price) {
		var codePoint = j;
		var curPoint = self.price[j];
		if(!ref.Cities[codePoint] || !ref.Cities[codePoint].lat || !ref.Cities[codePoint].lat) {
			continue;
		}
		if(self.climate[codePoint] && self.time[codePoint] >0){
			var curDir = self.climate[codePoint];
			newP = {
				code: codePoint,
				Price: curPoint.split('|')[0],
				lat: ref.Cities[codePoint].lat,
				lng: ref.Cities[codePoint].lng,
				Name: ref.Cities[codePoint].Name,
				DayTemperature: curDir.MD ? curDir.MD[self.month] : null,
				SeaTemperature: curDir.ST ? curDir.ST[self.month] : null,
				Time: parseInt(self.time[codePoint]),
				Elev: parseInt(curDir.Info.Elev,10)
			};
			if(self.MinAirTemp > parseInt(newP.DayTemperature,10)) {
				self.MinAirTemp = parseInt(newP.DayTemperature,10);
			}
			if(self.MaxAirTemp < parseInt(newP.DayTemperature,10)) {
				self.MaxAirTemp = parseInt(newP.DayTemperature,10);
			}
			if(newP.SeaTemperature) {
				if(self.MinWaterTemp > parseInt(newP.SeaTemperature,10)) {
					self.MinWaterTemp = parseInt(newP.SeaTemperature,10);
				}
				if(self.MaxWaterTemp < parseInt(newP.SeaTemperature,10)) {
					self.MaxWaterTemp = parseInt(newP.SeaTemperature,10);
				}
			}
			if(self.MinPrice > parseInt(newP.Price,10)) {
				self.MinPrice = parseInt(newP.Price,10);
			}
			if(self.MaxPrice < parseInt(newP.Price,10)) {
				self.MaxPrice = parseInt(newP.Price,10);
			}
			if(self.MinTime > parseInt(newP.Time,10)) {
				self.MinTime = parseInt(newP.Time,10);
			}
			if(self.MaxTime < parseInt(newP.Time,10)) {
				self.MaxTime = parseInt(newP.Time,10);
			}
			self.Points.push(newP);
		}
	}
	for(var i=0,PL=this.Points.length;i<PL;i++) {
		var curPoint = this.Points[i];
		cityLoc = new google.maps.LatLng(curPoint.lat, curPoint.lng);
		this.addMarker(cityLoc,curPoint.code);

		/*if (ref.testPoint(curPoint.code)) {
			var curCity = ref.getPoint(curPoint.code);
			cityLoc = new google.maps.LatLng(curCity.lat, curCity.lng);
			this.addMarker(cityLoc,curPoint.code);
		} else {
			cityLoc = new google.maps.LatLng(curPoint.lat, curPoint.lng);
			this.addMarker(cityLoc,curPoint.code);
		}*/
	}
};


PopularDirection.prototype.makeNatureArrays = function(){
	var self = this;
	this.selectedNatue = null;
	this.SeaPoints = [];
	this.MountainPoints = [];
	this.NoSeaNoMountainPoints = [];

	for(var i =0, PL=this.Points.length;i<PL;i++){
		var curPoint = this.Points[i];
		//if(curPoint.Elev ===0) {
		if(curPoint.SeaTemperature) {
			this.SeaPoints.push(curPoint);
		} else if (curPoint.Elev >300) {
			this.MountainPoints.push(curPoint);
		} else {
			this.NoSeaNoMountainPoints.push(curPoint);
		}
	}
};


PopularDirection.prototype.initFilters = function(){
	var self = this;
	$.tmpl( $('#tmpl_FilterFlight').trim()).appendTo( $('#map') );

	/*this.PriceSlider = $('#filter_price')[0];
	$(this.PriceSlider).slider({
		value: self.MinPrice,
		min: self.MinPrice,
		max: self.MaxPrice,
		step: 10,
		slide: function( event, ui ) {
			//log(ui.value)
		},
		stop: function(event,ui){
			if(self.PriceSliderValue != ui.value) {
				self.PriceSliderValue = ui.value;
				self.FilterPopular();
			}
		}
	});
	this.PriceSliderValue = $(this.PriceSlider).slider("value");*/

	/*this.WaterSlider = $('#filter_water')[0];
	$(this.WaterSlider).slider({
		value: self.MaxWaterTemp,
		min: self.MinWaterTemp,
		max: self.MaxWaterTemp,
		step: 1,
		slide: function( event, ui ) {
			//log(ui.value)
		},
		stop: function(event,ui){
			if(self.WaterSliderValue != ui.value) {
				self.WaterSliderValue = ui.value;
				self.FilterPopular();
			}
		}
	});
	this.WaterSliderValue = $(this.WaterSlider).slider("value");*/

	this.AirSlider = $('#filter_air')[0];
	$(this.AirSlider).slider({
		value: self.MinAirTemp,
		min: -40,
		max: 50,
		step: 1,
		slide: function( event, ui ) {
			if(self.filtering) {
				return;
			}
			if(ui.value>0){
				$('.slider_value',self.AirSlider).html('+'+ui.value);
			} else {
				$('.slider_value',self.AirSlider).html(ui.value);
			}
			//log(ui.value)
		},
		stop: function(event,ui){
			if(self.AirSliderValue != ui.value) {
				self.AirSliderValue = ui.value;
				self.FilterPopular();
			}
		}
	});
	this.AirSliderValue = $(this.AirSlider).slider("value");

	if(this.AirSliderValue>0){
		$('.slider_value',self.AirSlider).html('+'+self.AirSliderValue);
	} else {
		$('.slider_value',self.AirSlider).html(self.AirSliderValue);
	}

	this.$TimeSlider = $('#filter_time');
	this.$TimeSlider.slider({
		value: self.MaxTime,
		min: self.MinTime,
		max: self.MaxTime,
		step: 10,
		slide: function( event, ui ) {
			if(self.filtering) {
				return;
			}
			$('.slider_value',self.$TimeSlider).html( DurationTimeStringPartFull(DurationAPIFromMinutes(ui.value)) );
			//log(ui.value)
		},
		stop: function(event,ui){
			if(self.TimeSliderValue != ui.value) {
				self.TimeSliderValue = ui.value;
				self.FilterPopular();
			}
		}
	});
	this.TimeSliderValue = this.$TimeSlider.slider("value");
	$('.slider_value', self.$TimeSlider)
		.html( DurationTimeStringPartFull(DurationAPIFromMinutes(this.TimeSliderValue)) );
};


PopularDirection.prototype.addMarker = function(location, code){
	var self = this;
	var image = new google.maps.MarkerImage(
			'/images/map/pin_red.png',
			new google.maps.Size(15, 15),
			new google.maps.Point(0,0),
			new google.maps.Point(6, 6)
	);

	marker = new google.maps.Marker({
		position: location,
		icon: image,
		code: code,
		zIndex: 2,
		map: this.map
	});


	this.Markers[code] = {};
	this.Markers[code] = marker;
	var elContent = document.createElement("div");
		elContent.innerHTML = ref.getCityName(code);
	marker.infoOverlay = new InfoOverlay({
		latlng: marker.getPosition(),
		pinAnchor: {
			y: 25
		},
		content: elContent
	});
	google.maps.event.addListener(marker, 'mouseover', function(){
		this.infoOverlay.setMap(self.map);
	});
	google.maps.event.addListener(marker, 'mouseout', function(){
		this.infoOverlay.setMap(null);
	});
	google.maps.event.addListener(marker, 'click', function(){
		this.infoOverlay.setMap(null);
		objSearchForm.dirRows[0].toField.suggest.input.value = this.code;
		objSearchForm.dirRows[0].toField.suggest.makeSuggest();
	});
};
PopularDirection.prototype.FilterPopular = function(){
	var self = this;
	this.filtering = true;

	this.deleteArray = {};

	var SortedPoints =[];
	var ModifiedPoints = this.Points;
	if (this.selectedNatue == 'sea') {
		ModifiedPoints = this.SeaPoints;
		for(i=0,PL=this.MountainPoints.length;i<PL;i++){
			this.deleteArray[self.MountainPoints[i].code]={};
		}
		for(i=0,PL=this.NoSeaNoMountainPoints.length;i<PL;i++){
			this.deleteArray[self.NoSeaNoMountainPoints[i].code]={};
		}
	} else if (this.selectedNatue == 'mountain') {
		ModifiedPoints = this.MountainPoints;
		for(i=0,PL=this.SeaPoints.length;i<PL;i++){
			this.deleteArray[self.SeaPoints[i].code]={};
		}
		for(i=0,PL=this.NoSeaNoMountainPoints.length;i<PL;i++){
			this.deleteArray[self.NoSeaNoMountainPoints[i].code]={};
		}
	}
	for(var i=0,PL=ModifiedPoints.length;i<PL;i++){
		var curPoint = ModifiedPoints[i];
		if(curPoint.DayTemperature < this.AirSliderValue) {
			this.deleteArray[curPoint.code] = {};
			continue;
		}
		/*if(curPoint.SeaTemperature > this.WaterSliderValue) {
			this.deleteArray[curPoint.code] = {};
			continue;
		}*/
		/*if(curPoint.Price < this.PriceSliderValue) {
			this.deleteArray[curPoint.code] = {};
			continue;
		}*/
		if(curPoint.Time > this.TimeSliderValue) {
			this.deleteArray[curPoint.code] = {};
			continue;
		}
		SortedPoints.push(curPoint);
	}

	for(var i in this.deleteArray) {
		if(self.Markers[i]){
			self.Markers[i].setMap(null);
			delete self.Markers[i];
		}
	}

	for(var i=0,SP=SortedPoints.length;i<SP;i++){
		var curPoint = SortedPoints[i];
		if(!self.Markers[curPoint.code]) {
			cityLoc = new google.maps.LatLng(curPoint.lat, curPoint.lng);
			this.addMarker(cityLoc,curPoint.code);
		}
	}

	this.filtering = false;
};
PopularDirection.prototype.initDirectPoints = function(){
	var self =this;
	$.ajax({
		cache: false,
		type: "get",
		dataType: "json",
		data: {point: self.code},
		url: "/_api/schedule/getByPoint/",
		beforeSend: function(xhr){
			abortAjax(ajaxPointsStops);
			clearAjax(ajaxPointsStops);
			ajaxPointsStops.push(xhr);
		},
		success: function(json) {
			if(json.cities) {
				CL= json.cities.length;
				if (CL > 0) {
					for(var i=0;i<CL;i++){
						var curCity = ref.Cities[json.cities[i].code];
						if(curCity && curCity.lat && curCity.lng){
								cityLoc = new google.maps.LatLng(curCity.lat, curCity.lng);
								self.addBlueMarker(cityLoc, curCity.Name);
						}
					}
				}
			}
		},
		complete: function(){
			clearAjax(ajaxPointsStops);
		}
	});
};
PopularDirection.prototype.addBlueMarker = function(location, Name){
	var self = this;
	var image = new google.maps.MarkerImage(
		'/images/map/pin_blue.png',
		new google.maps.Size(15, 15),
		new google.maps.Point(0,0),
		new google.maps.Point(6, 6)
	);

	marker = new google.maps.Marker({
		position: location,
		icon: image,
		name: Name,
		zIndex: 1,
		map: this.map
	});

	var elContent = document.createElement("div");
			elContent.innerHTML = Name;
	marker.infoOverlay = new InfoOverlay({
		latlng: marker.getPosition(),
		pinAnchor: {
			y: 25
		},
		content: elContent
	});
	google.maps.event.addListener(marker, 'mouseover', function(){
		this.infoOverlay.setMap(self.map);
	});
	google.maps.event.addListener(marker, 'mouseout', function(){
		this.infoOverlay.setMap(null);
	});
	this.BluePoints.push(marker);
};
/*
var allCitiesShown = false;
function initAllCities( options ) {
	var self = this;
	this.setValues( options );
	this.markerLayer = $('<div />').addClass('PointsOverlay');
	this.hoverLayer = $('<div />').addClass('HoversOverlay');
	this.Cities= tw.AllCitiesArray||[];
	if(!tw.AllCitiesArray){
		var oCities={};
		for(var i in ref.Airports) {
			var curPoint = ref.Airports[i];
			if (!curPoint.Railway) {
				var curCity = ref.Cities[curPoint.Parent];
				if(!oCities[curPoint.Parent]) {
					if(curCity && curCity.lat && curCity.lng) {
						curCity.cityLoc = new google.maps.LatLng(curCity.lat, curCity.lng);
						curCity.code = i;
						self.Cities.push(curCity);
					}
					oCities[curPoint.Parent] =1;
				}
			}
		}
		oCities=null;
		tw.AllCitiesArray = this.Cities;
	}
}
initAllCities.prototype = new google.maps.OverlayView;
initAllCities.prototype.onAdd = function() {
	var PointsPane = $(this.getPanes().overlayImage); // Pane 3
	var HoversPane = $(this.getPanes().overlayMouseTarget); // Pane 5
	PointsPane.append( this.markerLayer );
	HoversPane.append( this.hoverLayer );
};
initAllCities.prototype.onRemove = function() {
	this.markerLayer.remove();
	this.hoverLayer.remove();
	allCitiesShown = false;
};
initAllCities.prototype.draw = function() {
	var self = this;
	var projection = this.getProjection();
	var zoom = this.getMap().getZoom();
	var fragment = document.createDocumentFragment();
	var HoverFragment = document.createDocumentFragment();
	this.markerLayer.empty(); // Empty any previous rendered markers
	this.hoverLayer.empty();

	for(var i=0, CL= this.Cities.length;i<CL;i++) {
		var curCity = this.Cities[i];
		var pixPosition = projection.fromLatLngToDivPixel( curCity.cityLoc );
		var $point = $('<div '
							+'style="'
								+'width:4px; '
								+'height:4px; '
								+'left:'+pixPosition.x+'px; '
								+'top:'+pixPosition.y+'px; '
								+'position:absolute; '
						+'">'
							+'<img '
								+'src="/images/map/pin_blue_small.png" '
								+'style="position: absolute; top: -2px; left: -2px" '
							+'/>'
						+'</div>');
		var $HoverPoint = $('<div '
							+'class="map-point" '
							+'id="p_'+curCity.code+'" '
							+'name="'+curCity.Name+'" '
							+'style="'
								+'width:4px; '
								+'height:4px; '
								+'left:'+pixPosition.x+'px; '
								+'top:'+pixPosition.y+'px; '
								+'position:absolute; '
								+'cursor:pointer; '
						+'"></div>');
		$HoverPoint.mouseover(function(){
			var p = this;
			var elContent = document.createElement("div");
				elContent.innerHTML = $(p).attr('name');
			var div = document.createElement('div');
			div.className = "infoOverlay";
			div.innerHTML = '<div class="abs"><div class="tl"></div><div class="t"></div><div class="tr"></div><div class="r"></div><div class="br"></div><div class="b"></div><div class="bl"></div><div class="l"></div><div class="c"></div><div class="leg"></div></div>';
			div.appendChild(elContent);
			$('#map').append(div);
			$(div).css({
				"top": $(p).offset().top - $(div).height() -32,
				"left": $(p).offset().left - $(div).width()/2 -20
			});
		});
		$HoverPoint.mouseout(function(){
			$('.infoOverlay').remove();
		});
		fragment.appendChild( $point.get(0) );
		HoverFragment.appendChild( $HoverPoint.get(0) );
	}

	// Now append the entire fragment from memory onto the DOM
	this.markerLayer.append(fragment);
	this.hoverLayer.append(HoverFragment);
	allCitiesShown = true;
};*/

allCitiesShown = false;
function initAllCities(){
	if(!allCitiesShown) {
		this.map = objMap.map;
		this.init();
		allCitiesShown = true;
	}
}
initAllCities.prototype.init = function(){
	var self =this;
	this.image = new google.maps.MarkerImage(
		'/images/map/pin_blue_small.png',
		new google.maps.Size(4, 4),
		new google.maps.Point(0,0),
		new google.maps.Point(2,0)
	);
	var oCities={};
	var g =0;
	for(var i in ref.Airports) {
		var curPoint = ref.Airports[i];
		if (!curPoint.Railway) {
			var curCity = ref.Cities[curPoint.Parent];
			if(!oCities[curPoint.Parent]) {
				if(curCity && curCity.lat && curCity.lng) {
					cityLoc = new google.maps.LatLng(curCity.lat, curCity.lng);
					self.addSmallBlueMarker(cityLoc, curCity.Name);
					g++;
				}
				oCities[curPoint.Parent] =1;
			}
		}
	}
	this.text="";
	oCities=null;
};
initAllCities.prototype.addSmallBlueMarker = function(location, Name){
	var self = this;
	marker = new google.maps.Marker({
		position: location,
		icon: self.image,
		name: Name,
		zIndex: 0,
		map: this.map
	});

	//this.text+= '<Placemark><name>' + curCity.Name + '</name><description><![CDATA[Описание]]></description><Point><coordinates>' +location.lat +',' + location.lon + '</coordinates></Point></Placemark>';

	var elContent = document.createElement("div");
		elContent.innerHTML = Name;
	marker.infoOverlay = new InfoOverlay({
		latlng: marker.getPosition(),
		pinAnchor: {
			y: 17
		},
		content: elContent
	});
	google.maps.event.addListener(marker, 'mouseover', function(){
		this.infoOverlay.setMap(self.map);
	});
	google.maps.event.addListener(marker, 'mouseout', function(){
		this.infoOverlay.setMap(null);
	});
};

function initPolylineRoutes(route) {
	if(objMap && !objMap.visible) {
		return;
	}
	var self = this;
	this.route = route;
	this.fromCode = this.route.substr(0,3);
	this.toCode = this.route.substr(3,3);
	this.from = ref.Cities[this.fromCode];
	this.to = ref.Cities[this.toCode];
	this.map = objMap.map;
	ClearPolylineFlights();
	var requestOptions = {
		repeats: 1,
		RetryFunction: function(){
			MakeRequest();
		},
		ErrorFunction: function(){
		}
	};
	function MakeRequest(){
		$.ajax({
			type: "get",
			cache: false,
			data: {route: self.route},
			url: "/_api/schedule/getStops/",
			dataType: "json",
			beforeSend: function(xhr){
				abortAjax(ajaxPointsPoly);
				clearAjax(ajaxPointsPoly);
				ajaxPointsPoly.push(xhr);
			},
			success: function(json){
				self.array = json;
				//если ответ пришёл после того как быстро удалили пункт
				if(objSearchForm.dirRows[0].fromField.suggest.input.value != "" && objSearchForm.dirRows[0].toField.suggest.input.value != ""){
					self.draw();
				}
			},
			complete: function(xhr){
				clearAjax(ajaxPointsPoly);
				xhr.url = this.url;
				checkAjaxError(xhr,requestOptions);
			}
		});
	}
	this.draw = function(){
		for(var i=0, AL =this.array.length;i<AL;i++){
			var curRoute = this.array[i];
			for(var j=0,RL=curRoute.length;j<RL;j++){
				var curPoint = curRoute[j];
				if(curPoint != this.fromCode) {
					try {
						var comment = "";
						if(j===0){
							if(curRoute[j+1] && curRoute[j+1]!=this.fromCode && ref.Cities[curRoute[j+1]]){
								comment = l10n.prefered.stops[3] + ref.Cities[curRoute[j+1]].Name;
							} else {
								comment = l10n.prefered.stops[0];
							}
							this.initMarker(curPoint,comment);
							this.drawPoly(this.from,ref.Cities[curPoint]);
						} else {
							comment = l10n.prefered.stops[1];
							if(j==2) {
								comment = l10n.prefered.stops[2];
							}
							if(curRoute[j+1] && curRoute[j+1]!=this.fromCode && ref.Cities[curRoute[j+1]]){
								comment = l10n.prefered.stops[3] + ref.Cities[curRoute[j+1]].Name;
							}
							this.initMarker(curPoint,comment);
							this.drawPoly(ref.Cities[curRoute[j-1]],ref.Cities[curPoint]);
						}
						if (j == curRoute.length-1) {
							this.drawPoly(ref.Cities[curRoute[j]], this.to);
						}

					} catch (e) {}
				}
			}
		}
	};
	this.drawPoly = function(from,to){
		if(!from.lat || !from.lng || !to.lat || !to.lng) {
			return
		}
		var PolyFlight = new google.maps.Polyline({
			path: [
				new google.maps.LatLng(from.lat,from.lng),
				new google.maps.LatLng(to.lat,to.lng)
			],
			strokeColor: "#FF7000",
			strokeOpacity: 0.4,
			strokeWeight: 1,
			geodesic: true
		});
		PolyFlight.setMap(this.map);
		tw.Polyline.Flights.push(PolyFlight);
	};

	this.initMarker = function(point,comment){
		if(!ref.Cities[point].lat || !ref.Cities[point].lng || tw.Polyline.PointsList[point]) {
			return
		}
		tw.Polyline.PointsList[point] = 1;
		var cityLoc = new google.maps.LatLng(ref.Cities[point].lat, ref.Cities[point].lng);
		var html = '<div>'+String(ref.Cities[point].Name)+', <span class="small silver">' +String(ref.Countries[ref.Cities[point].Parent].Name)+'</span></div>';
		if (comment) {
			html += '<div class="small silver">' + comment + '</div>';
		}
		self.addOrangeMarker(cityLoc, html);
	}
	this.addOrangeMarker = function(location, Name){
		var image = new google.maps.MarkerImage(
			'/images/map/pin_orange.png',
			new google.maps.Size(15, 15),
			new google.maps.Point(0,0),
			new google.maps.Point(6, 6)
		);

		marker = new google.maps.Marker({
			position: location,
			icon: image,
			name: Name,
			zIndex: 1,
			map: this.map
		});

		var elContent = document.createElement("div");
			elContent.innerHTML = Name;
		marker.infoOverlay = new InfoOverlay({
			latlng: marker.getPosition(),
			pinAnchor: {
				y: 20
			},
			content: elContent
		});
		google.maps.event.addListener(marker, 'mouseover', function(){
			this.infoOverlay.setMap(self.map);
		});
		google.maps.event.addListener(marker, 'mouseout', function(){
			this.infoOverlay.setMap(null);
		});
		tw.Polyline.Points.push(marker);
	};
}
function ClearPolylineFlights(){
	if(!tw.Polyline) {
		return;
	}
	for(var i=0, FL = tw.Polyline.Flights.length; i<FL;i++){
		tw.Polyline.Flights[i].setMap(null);
	}
	for(var i=0, PL = tw.Polyline.Points.length; i<PL;i++){
		tw.Polyline.Points[i].setMap(null);
	}
	tw.Polyline = {
		Flights: [],
		Points:[],
		PointsList: {}
	};
};


$(document).ready(function(){
	$(document.body).on("mapHide", function(){
		abortAjax(ajaxPointsPoly.concat(ajaxPointsInfo,ajaxPointsStops));
		//ClearPolylineFlights();
		tw.PopularFilter = null;
	});
	//В случае всех городов, навешиваем клик
	/*$('.map-point').live('click',function(e){
		objSearchForm.dirRows[0].toField.suggest.input.value = this.id.split('_')[1];
		objSearchForm.dirRows[0].toField.suggest.makeSuggest();
	});*/
});

(function(){function n(p,m){var q=this,r=document,o;q.wrapper=typeof p=="object"?p:r.getElementById(p);q.wrapper.style.overflow="hidden";q.scroller=q.wrapper.children[0];q.scroller.style.cssText+="-webkit-transition-property:-webkit-transform;-webkit-transform-origin:0 0;-webkit-transform:"+a+"0,0"+g;q.scroller.style.cssText+="-webkit-transition-timing-function:cubic-bezier(0.33,0.66,0.66,1);-webkit-transition-duration:0;";q.options={hScroll:true,vScroll:true,bounce:i,bounceLock:false,momentum:i,lockDirection:true,hScrollbar:true,vScrollbar:true,fixedScrollbar:k,fadeScrollbar:(l&&i)||!h,hideScrollbar:l||!h,scrollbarClass:"",onScrollStart:null,onScrollEnd:null};for(o in m){q.options[o]=m[o]}q.options.hScrollbar=q.options.hScroll&&q.options.hScrollbar;q.options.vScrollbar=q.options.vScroll&&q.options.vScrollbar;q.refresh();q._bind(j,window);q._bind(e)}n.prototype={x:0,y:0,handleEvent:function(o){var m=this;switch(o.type){case e:m._start(o);break;case d:m._move(o);break;case f:case b:m._end(o);break;case"webkitTransitionEnd":m._transitionEnd(o);break;case j:m._resize();break}},_scrollbar:function(m){var p=this,q=document,o;if(!p[m+"Scrollbar"]){if(p[m+"ScrollbarWrapper"]){p[m+"ScrollbarIndicator"].style.webkitTransform="";p[m+"ScrollbarWrapper"].parentNode.removeChild(p[m+"ScrollbarWrapper"]);p[m+"ScrollbarWrapper"]=null;p[m+"ScrollbarIndicator"]=null}return}if(!p[m+"ScrollbarWrapper"]){o=q.createElement("div");if(p.options.scrollbarClass){o.className=p.options.scrollbarClass+m.toUpperCase()}else{o.style.cssText="position:absolute;z-index:100;"+(m=="h"?"height:7px;bottom:1px;left:2px;right:7px":"width:7px;bottom:7px;top:2px;right:1px")}o.style.cssText+="pointer-events:none;-webkit-transition-property:opacity;-webkit-transition-duration:"+(p.options.fadeScrollbar?"350ms":"0")+";overflow:hidden;opacity:"+(p.options.hideScrollbar?"0":"1");p.wrapper.appendChild(o);p[m+"ScrollbarWrapper"]=o;o=q.createElement("div");if(!p.options.scrollbarClass){o.style.cssText="position:absolute;z-index:100;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);-webkit-background-clip:padding-box;-webkit-box-sizing:border-box;"+(m=="h"?"height:100%;-webkit-border-radius:4px 3px;":"width:100%;-webkit-border-radius:3px 4px;")}o.style.cssText+="pointer-events:none;-webkit-transition-property:-webkit-transform;-webkit-transition-timing-function:cubic-bezier(0.33,0.66,0.66,1);-webkit-transition-duration:0;-webkit-transform:"+a+"0,0"+g;p[m+"ScrollbarWrapper"].appendChild(o);p[m+"ScrollbarIndicator"]=o}if(m=="h"){p.hScrollbarSize=p.hScrollbarWrapper.clientWidth;p.hScrollbarIndicatorSize=c.max(c.round(p.hScrollbarSize*p.hScrollbarSize/p.scrollerW),8);p.hScrollbarIndicator.style.width=p.hScrollbarIndicatorSize+"px";p.hScrollbarMaxScroll=p.hScrollbarSize-p.hScrollbarIndicatorSize;p.hScrollbarProp=p.hScrollbarMaxScroll/p.maxScrollX}else{p.vScrollbarSize=p.vScrollbarWrapper.clientHeight;p.vScrollbarIndicatorSize=c.max(c.round(p.vScrollbarSize*p.vScrollbarSize/p.scrollerH),8);p.vScrollbarIndicator.style.height=p.vScrollbarIndicatorSize+"px";p.vScrollbarMaxScroll=p.vScrollbarSize-p.vScrollbarIndicatorSize;p.vScrollbarProp=p.vScrollbarMaxScroll/p.maxScrollY}p._indicatorPos(m,true)},_resize:function(){var m=this;setTimeout(function(){m.refresh()},0)},_pos:function(m,p){var o=this;o.x=o.hScroll?m:0;o.y=o.vScroll?p:0;o.scroller.style.webkitTransform=a+o.x+"px,"+o.y+"px"+g;o._indicatorPos("h");o._indicatorPos("v")},_indicatorPos:function(m,p){var o=this,q=m=="h"?o.x:o.y;if(!o[m+"Scrollbar"]){return}q=o[m+"ScrollbarProp"]*q;if(q<0){q=o.options.fixedScrollbar?0:q+q*3;if(o[m+"ScrollbarIndicatorSize"]+q<9){q=-o[m+"ScrollbarIndicatorSize"]+8}}else{if(q>o[m+"ScrollbarMaxScroll"]){q=o.options.fixedScrollbar?o[m+"ScrollbarMaxScroll"]:q+(q-o[m+"ScrollbarMaxScroll"])*3;if(o[m+"ScrollbarIndicatorSize"]+o[m+"ScrollbarMaxScroll"]-q<9){q=o[m+"ScrollbarIndicatorSize"]+o[m+"ScrollbarMaxScroll"]-8}}}o[m+"ScrollbarWrapper"].style.webkitTransitionDelay="0";o[m+"ScrollbarWrapper"].style.opacity=p&&o.options.hideScrollbar?"0":"1";o[m+"ScrollbarIndicator"].style.webkitTransform=a+(m=="h"?q+"px,0":"0,"+q+"px")+g},_transitionTime:function(o){var m=this;o+="ms";m.scroller.style.webkitTransitionDuration=o;if(m.hScrollbar){m.hScrollbarIndicator.style.webkitTransitionDuration=o}if(m.vScrollbar){m.vScrollbarIndicator.style.webkitTransitionDuration=o}},_start:function(q){var p=this,m=h?q.changedTouches[0]:q,o;p.moved=false;q.preventDefault();p.moved=false;p.distX=0;p.distY=0;p.absDistX=0;p.absDistY=0;p.dirX=0;p.dirY=0;p.returnTime=0;p._transitionTime(0);if(p.options.momentum){o=new WebKitCSSMatrix(window.getComputedStyle(p.scroller,null).webkitTransform);if(o.m41!=p.x||o.m42!=p.y){p._unbind("webkitTransitionEnd");p._pos(o.m41,o.m42)}}p.scroller.style.webkitTransitionTimingFunction="cubic-bezier(0.33,0.66,0.66,1)";if(p.hScrollbar){p.hScrollbarIndicator.style.webkitTransitionTimingFunction="cubic-bezier(0.33,0.66,0.66,1)"}if(p.vScrollbar){p.vScrollbarIndicator.style.webkitTransitionTimingFunction="cubic-bezier(0.33,0.66,0.66,1)"}p.startX=p.x;p.startY=p.y;p.pointX=m.pageX;p.pointY=m.pageY;p.startTime=q.timeStamp;if(p.options.onScrollStart){p.options.onScrollStart.call(p)}p._bind(d);p._bind(f);p._bind(b)},_move:function(s){if(h&&s.touches.length>1){return}var q=this,o=h?s.changedTouches[0]:s,p=o.pageX-q.pointX,m=o.pageY-q.pointY,t=q.x+p,r=q.y+m;s.preventDefault();q.pointX=o.pageX;q.pointY=o.pageY;if(t>0||t<q.maxScrollX){t=q.options.bounce?q.x+(p/2.4):t>=0||q.maxScrollX>=0?0:q.maxScrollX}if(r>0||r<q.maxScrollY){r=q.options.bounce?q.y+(m/2.4):r>=0||q.maxScrollY>=0?0:q.maxScrollY}if(q.absDistX<4&&q.absDistY<4){q.distX+=p;q.distY+=m;q.absDistX=c.abs(q.distX);q.absDistY=c.abs(q.distY);return}if(q.options.lockDirection){if(q.absDistX>q.absDistY+3){r=q.y;m=0}else{if(q.absDistY>q.absDistX+3){t=q.x;p=0}}}q.moved=true;q._pos(t,r);q.dirX=p>0?-1:p<0?1:0;q.dirY=m>0?-1:m<0?1:0;if(s.timeStamp-q.startTime>300){q.startTime=s.timeStamp;q.startX=q.x;q.startY=q.y}},_end:function(t){if(h&&t.touches.length!=0){return}var r=this,x=h?t.changedTouches[0]:t,u,w,p={dist:0,time:0},m={dist:0,time:0},q=t.timeStamp-r.startTime,v=r.x,s=r.y,o;r._unbind(d);r._unbind(f);r._unbind(b);if(!r.moved){if(h){r.doubleTapTimer=null;u=x.target;while(u.nodeType!=1){u=u.parentNode}w=document.createEvent("MouseEvents");w.initMouseEvent("click",true,true,t.view,1,x.screenX,x.screenY,x.clientX,x.clientY,t.ctrlKey,t.altKey,t.shiftKey,t.metaKey,0,null);w._fake=true;u.dispatchEvent(w)}r._resetPos();return}if(q<300&&r.options.momentum){p=v?r._momentum(v-r.startX,q,-r.x,r.scrollerW-r.wrapperW+r.x,r.options.bounce?r.wrapperW:0):p;m=s?r._momentum(s-r.startY,q,-r.y,(r.maxScrollY<0?r.scrollerH-r.wrapperH+r.y:0),r.options.bounce?r.wrapperH:0):m;v=r.x+p.dist;s=r.y+m.dist;if((r.x>0&&v>0)||(r.x<r.maxScrollX&&v<r.maxScrollX)){p={dist:0,time:0}}if((r.y>0&&s>0)||(r.y<r.maxScrollY&&s<r.maxScrollY)){m={dist:0,time:0}}}if(p.dist||m.dist){o=c.max(c.max(p.time,m.time),10);r.scrollTo(v,s,o);return}r._resetPos(200)},_resetPos:function(p){var m=this,q=m.x,o=m.y;if(m.x>=0){q=0}else{if(m.x<m.maxScrollX){q=m.maxScrollX}}if(m.y>=0||m.maxScrollY>0){o=0}else{if(m.y<m.maxScrollY){o=m.maxScrollY}}if(q==m.x&&o==m.y){if(m.moved){if(m.options.onScrollEnd){m.options.onScrollEnd.call(m)}m.moved=false}if(m.hScrollbar&&m.options.hideScrollbar){m.hScrollbarWrapper.style.webkitTransitionDelay="300ms";m.hScrollbarWrapper.style.opacity="0"}if(m.vScrollbar&&m.options.hideScrollbar){m.vScrollbarWrapper.style.webkitTransitionDelay="300ms";m.vScrollbarWrapper.style.opacity="0"}return}if(p){m.scroller.style.webkitTransitionTimingFunction="cubic-bezier(0.33,0.0,0.33,1)";if(m.hScrollbar){m.hScrollbarIndicator.style.webkitTransitionTimingFunction="cubic-bezier(0.33,0.0,0.33,1)"}if(m.vScrollbar){m.vScrollbarIndicator.style.webkitTransitionTimingFunction="cubic-bezier(0.33,0.0,0.33,1)"}}m.scrollTo(q,o,p||0)},_transitionEnd:function(o){var m=this;if(o){o.stopPropagation()}m._unbind("webkitTransitionEnd");m._resetPos(m.returnTime);m.returnTime=0},_momentum:function(v,p,t,m,x){var s=this,u=0.0006,q=c.abs(v)/p,o=(q*q)/(2*u),w=0,r=0;if(v>0&&o>t){r=x/(6/(o/q*u));t=t+r;s.returnTime=800/x*r+100;q=q*t/o;o=t}else{if(v<0&&o>m){r=x/(6/(o/q*u));m=m+r;s.returnTime=800/x*r+100;q=q*m/o;o=m}}o=o*(v<0?-1:1);w=q/u;return{dist:o,time:c.round(w)}},_offset:function(o,m){var q=-o.offsetLeft,p=-o.offsetTop;if(!m){return{x:q,y:p}}while(o=o.offsetParent){q-=o.offsetLeft;p-=o.offsetTop}return{x:q,y:p}},_bind:function(o,m){(m||this.scroller).addEventListener(o,this,false)},_unbind:function(o,m){(m||this.scroller).removeEventListener(o,this,false)},destroy:function(){var m=this;m.hScrollbar=false;m.vScrollbar=false;m._scrollbar("h");m._scrollbar("v");m.scroller.style.webkitTransform="";m._unbind("webkitTransitionEnd");m._unbind(j);m._unbind(e);m._unbind(d);m._unbind(f);m._unbind(b)},refresh:function(){var m=this;m.wrapperW=m.wrapper.clientWidth;m.wrapperH=m.wrapper.clientHeight;m.scrollerW=m.scroller.offsetWidth;m.scrollerH=m.scroller.offsetHeight;m.maxScrollX=m.wrapperW-m.scrollerW;m.maxScrollY=m.wrapperH-m.scrollerH;m.dirX=0;m.dirY=0;m._transitionTime(0);m.hScroll=m.options.hScroll&&m.maxScrollX<0;m.vScroll=m.options.vScroll&&(!m.options.bounceLock&&!m.hScroll||m.scrollerH>m.wrapperH);m.hScrollbar=m.hScroll&&m.options.hScrollbar;m.vScrollbar=m.vScroll&&m.options.vScrollbar&&m.scrollerH>m.wrapperH;m._scrollbar("h");m._scrollbar("v");m._resetPos()},scrollTo:function(m,r,q,p){var o=this;if(p){m=o.x-m;r=o.y-r}q=!q||(c.round(o.x)==c.round(m)&&c.round(o.y)==c.round(r))?0:q;o.moved=true;if(q){o._bind("webkitTransitionEnd")}o._transitionTime(q);o._pos(m,r);if(!q){setTimeout(function(){o._transitionEnd()},0)}},scrollToElement:function(m,p){var o=this,q;m=m.nodeType?m:o.scroller.querySelector(m);if(!m){return}q=o._offset(m);q.x=q.x>0?0:q.x<o.maxScrollX?o.maxScrollX:q.x;q.y=q.y>0?0:q.y<o.maxScrollY?o.maxScrollY:q.y;p=p===undefined?c.max(c.abs(q.x)*2,c.abs(q.y)*2):p;o.scrollTo(q.x,q.y,p)}};var i="WebKitCSSMatrix" in window&&"m11" in new WebKitCSSMatrix(),h="ontouchstart" in window,l=(/iphone|ipad/gi).test(navigator.appVersion),k=(/android/gi).test(navigator.appVersion),j="onorientationchange" in window?"orientationchange":"resize",e=h?"touchstart":"mousedown",d=h?"touchmove":"mousemove",f=h?"touchend":"mouseup",b=h?"touchcancel":"mouseup",a="translate"+(i?"3d(":"("),g=i?",0)":")",c=Math;if(typeof exports!=="undefined"){exports.iScroll=n}else{window.iScroll=n}})();
var chat_messages = 0;
var tmpl_QuestionField;

function showFAQ(q){
	var self = this;
	var popup = addPopup({
		id: "LearnFAQ",
		className: "yellow",
		close_button: true
	});
	this.elContent = document.createElement("div");
	this.elContent.className = "content questions";
	$(popup).append(this.elContent);
	appendLoader({
		appendTo: this.elContent,
		text: l10n.loaders.loading
	});
	$.ajax({
		type: "get",
		dataType: "html",
		data: {
			popup: true
		},
		url: "/"+tw.language+"/faq/",
		timeout: 120000,
		beforeSend: function(){
			$("<link/>", {
				rel: "stylesheet",
				type: "text/css",
				href: "/css/faq.css"
			}).appendTo("head");
		},
		success: function(data){
			$(self.elContent).html(data);
			if (browser.mobile) {
				$.getScript('/js/iscroll.js', function(){
					startQuestions();
				});
			} else {
				startQuestions();
			}
		},
		error: function(){
			removePopup();
			addPopup({
				error: true,
				reason: l10n.popup.problem,
				comment: l10n.popup.problemComment,
				close_button: true
			});
		}
	});
	startQuestions = function(){
		setTimeout(function(){
			if (q) {
				new Question("q" + q);
			} else {
				new Question();
			}
		}, 200);
	};
}

function Question(questionId){
	var self = this;
	if(browser.mobile){
		new iScroll('QuestionList');
	}
	this.tags = l10n.faq;

	tmpl_QuestionField = $("#tmpl_QuestionField").trim();
	this.field = new QuestionField({
		appendTo: $('.Fieldpanel')[0],
		name: "SearchQuestion",
		value: "",
		defaultValue: l10n.faqDefault
	});
	this.input = this.field.input;
	this.input.focus();
	this.listBody = $('.FAQlist')[0];
	this.ListWrapper = $('.listWrapper', this.listBody)[0];

	this.linkSetOffset = function(event){
		self.setOffset(event);
	};
	this.link_clickOutside = function(event){
		self.clickOutside(event);
	};
	this.link_onKeyDown = function(event){
		self.onKeyDown(event);
	};

	$(this.input).on("input keyup paste", function(event){
		if (event.type == "input" && !IEVersion || event.type == "keyup" && IEVersion) handler();
		function handler(){
			if (self.input.value.toLowerCase() != self.tempValue) {
				self.currentResult = null;
				if (self.input.value.length >= 3) {
					self.makeSuggest();
				} else {
					self.hide();
					self.tempValue = self.input.value.toLowerCase();
				}
			}
		}
	});
	this.selectedRow = null;
	if(questionId) {
		this.currentResult = questionId;
		this.setCurrentResult();
	}
}


Question.prototype.makeSuggest = function() {
	this.tempValue = this.input.value.toLowerCase();
	var queryString = this.tempValue;
	if (queryString.length >= 3) {
		this.getResult(queryString);
		if(this.results.length>0) {
			this.draw();
		} else {
			this.hide();
		}
	}
};


Question.prototype.getResult = function(queryString){
	var self = this;
	this.results = [];
	queryString = queryString.replace(/^\s*/, "").replace(/\s{2,}/g, " ");
	var Qstring = queryString.split(" ");
	for (var i in this.tags) {
		var curTag = self.tags[i];
		for (var j = 0, QL = Qstring.length; j < QL; j++) {
			if (Qstring[j] != "" && Qstring[j].length > 2 && curTag.indexOf(Qstring[j]) != -1) {
				self.results.push(i);
			}
		}
	}

};


Question.prototype.create = function(){
	this.elSuggest = document.getElementById("helpSuggest");
	if (!this.elSuggest) {
		this.elSuggest = document.createElement("div");
		this.elSuggest.id = "helpSuggest";
		this.elSuggest.className = "suggest invisible";
		$(this.elSuggest).click(function(event) {
			event.stopPropagation();
		});
		$(this.listBody).append(this.elSuggest);
	} else {
		this.elSuggest.innerHTML = "";
	}
};


Question.prototype.draw = function() {
	var self = this;
	this.create();

	var elList = document.createElement("ul");
	for(var i = 0, ResultsCount = this.results.length; i < ResultsCount; i++){
		var qid = this.results[i];
		var elLi = document.createElement("li");
			elLi.Code = qid;
			var elTable = document.createElement("table");
			var elRow = elTable.insertRow(-1);
			var elNameCell = elRow.insertCell(0);
				elNameCell.innerHTML = $('#'+qid).text();
			elLi.appendChild(elTable);
			elLi.onmouseover = function() {
				self.setRowHover(this);
			};
			elLi.onclick = function() {
				self.setCurrentResult();
				self.hide();
			};
		elList.appendChild(elLi);
	}
	this.setRowHover(elList.firstChild);
	this.elSuggest.onmouseout = function() {
		self.setRowHover(self.selectedRow);
	};
	this.elSuggest.appendChild(elList);
	this.show();
};


Question.prototype.show = function() {
	var self = this;
	this.setOffset();
	$(window).on('resize', self.linkSetOffset);

	$(document)
		.off("click", self.link_clickOutside)
		.on("click", self.link_clickOutside);

	$(this.input)
		.off("keydown", self.link_onKeyDown)
		.on("keydown", self.link_onKeyDown);

	$(this.elSuggest).removeClass("invisible");
	this.setOffset();
};


Question.prototype.setOffset = function(){
	var offset = $(this.input).offset();
	this.elSuggest.style.top = this.input.offsetHeight + "px";
	this.elSuggest.style.left = "25px";
	this.elSuggest.style.minWidth = this.input.offsetWidth - 2 + "px";
};


Question.prototype.hide = function() {
	var self = this;
	$(window).off('resize', self.linkSetOffset);
	$(document).off("click", self.link_clickOutside);
	$(this.input).off("keydown", self.link_onKeyDown);
	this.currentResult = null;
	$(document.getElementById("helpSuggest")).remove();
};


Question.prototype.clickOutside = function(event){
	if (event.target != this.input) {
		this.hide();
	}
};


Question.prototype.onKeyDown = function(event) {
	switch (event.keyCode) {
		case 27: // <Esc>
			this.hide();
			break;
		case 38: // <Up>
			event.preventDefault();
			this.setPrevRowHover();
			break;
		case 40: // <Down>
			event.preventDefault();
			this.setNextRowHover();
			break;
		case 13: // <Enter>
			event.preventDefault();
			this.setCurrentResult();
			this.hide();
			break;
	}
};


Question.prototype.setPrevRowHover = function() {
	if (this.selectedRow) {
		var PrewRow = this.selectedRow.previousSibling;
		if (PrewRow) {
			this.setRowHover(PrewRow);
			this.selectedRow = PrewRow;
		}
	}
};


Question.prototype.setNextRowHover = function() {
	if (this.selectedRow) {
		var NextRow = this.selectedRow.nextSibling;
		if (NextRow) {
			this.setRowHover(NextRow);
			this.selectedRow = NextRow;
		}
	}
};


Question.prototype.setRowHover = function(elRow){
	if (this.selectedRow) {
		if (this.selectedRow == elRow) {
			return;
		}
		this.dropRowHover(this.selectedRow);
	}
	$(elRow).addClass("hover");
	this.selectedRow = elRow;
	this.currentResult = elRow.Code;
};


Question.prototype.dropRowHover = function(elRow){
	$(elRow).removeClass("hover");
};


Question.prototype.setCurrentResult = function(){
	var self = this;
	$(this.ListWrapper).scrollTo($('#' + self.currentResult)[0], 500);
	this.input.value = "";
	this.field.setPlaceholder();
};


function QuestionField(options){
	var self = this;
	/* До создания шаблона */
	this.options = options || {};
	this.value = this.options.value || null;

	/* Создание шаблона */
	this.setField();

	$(this.input).on("input keyup paste", function(event){
		if (event.type == "input" || event.type == "keyup" && IEVersion) handler();
		function handler(){
			self.setPlaceholder();
		}
	});
	this.setGlow();

	if (this.options.appendTo) $(this.elField).appendTo(this.options.appendTo);
}


QuestionField.prototype.setField = function(){
	this.elField = $.tmpl(tmpl_QuestionField, this.options)[0];
	this.input = $("input:not([disabled])", this.elField)[0];
	this.placeholder = $("input[readonly]", this.elField)[0];
};


QuestionField.prototype.setGlow = function(){
	var self = this;
	this.$elGlow = $(".glow", this.elField);

	$(this.input)
		.focus(function(){
			self.$elGlow.fadeIn();
		})
		.blur(function(){
			self.$elGlow.fadeOut();
		});
};

QuestionField.prototype.setPlaceholder = function(){
	if (this.placeholder) {
		if (!this.input.value || this.input.value == "\n") {/* При отмене ввода в FF7.0.1 value == "\n" */
			this.placeholder.value = this.placeholder.defaultValue;
		} else {
			this.placeholder.value = "";
		}
	}
};

$(document).ready(function(){
	function CheckChat(){
		if (!window.$) return;
		var current_messages = $('p[id*="habla_msg_"]');
		setTimeout(function(){
			if(current_messages.length>0 && !chat_messages) {
				chat_messages = current_messages.length;
			}
			if(chat_messages && chat_messages != current_messages.length) {
				chat_messages = current_messages.length;
				var mes = $(current_messages).last().find('span')[1];
				var mes_text = $(mes).text();
				if (mes_text.indexOf('[Q') > -1 && mes_text.indexOf(']') > -1) {
					var mes_q = parseInt(mes_text.substring(2, mes_text.indexOf(']')), 10);
					/*$('#habla_window_div').removeClass('olrk-state-expanded').addClass('olrk-state-compressed');
					$('#habla_expanded_div').hide();
					$('#habla_compressed_div').show();*/
					if(document.getElementById('LearnFAQ')){
						removePopup();
					}
					showFAQ(mes_q);
				}
				if (mes_text.indexOf('[R') > -1 && mes_text.indexOf(']') > -1) {
					var mes_q = mes_text.substring(2, mes_text.indexOf(']'));
					/*$('#habla_window_div').removeClass('olrk-state-expanded').addClass('olrk-state-compressed');
					$('#habla_expanded_div').hide();
					$('#habla_compressed_div').show();*/
					var data = objAvia.parseKey(mes_q);
					if(data) {removePopup();objAvia.changeRequest(data);}
				}
			}
			CheckChat();
		}, 1000);
	}
	CheckChat();
});

function makeTripStars(){
	$('.TripStars').live('mouseenter click',function(e){
		var el = this;
		var tripinfo = $(el).attr('tripinfo').split(',');
		var dir = tripinfo[0];
		var tripIndex = 0;
		if(!tw.TripsForStars){
			tw.TripsForStars = {
				arrDirections:objOrder.arrDirections,
				trps:objOrder.json.trps
			};
		}

		for(var i =0, TL= tw.TripsForStars.arrDirections.length; i < dir; i++){
			tripIndex += tw.TripsForStars.arrDirections[i].trips.length;
		}

		tripIndex+= parseInt(tripinfo[1],10);
		if(e.type == "click") {
			if(infoBaloonHidden){
				try{
					showBaloon();
					infoBaloonHidden=false;
				} catch(e){}
			}
		} else {
			setTimeout( function(){
				if(infoBaloonHidden){
					var $mouseTarget = $(mouseEvent.target);
					$mouseTarget = ($mouseTarget.hasClass('stars_block')|| !$mouseTarget.parents('.stars_block')[0]) ? $mouseTarget[0] : $mouseTarget.parents('.stars_block')[0];

					if($mouseTarget.attr('tripinfo') == tripinfo ){
						try{
							showBaloon();
						}catch(e){}
					}
				}
			},300);
		}
		showBaloon = function(){
			if( document.getElementById("stars_"+String(tripinfo)) ){
				return;
			}
			removeInfoBaloon();
			resultFlight = {
				flightInfo: MakeFlightInfos(String(tripIndex)),
				TripIds: tripIndex
			};

			var $baloon = $.tmpl('tmpl_BaloonFlightStars', resultFlight);
			$baloon.attr('id',"stars_"+tripinfo).appendTo('body');

			var target = $(e.target).hasClass('stars_block') ? e.target : $(e.target).parents('.stars_block')[0];
			var baloon_pos = $(target).offset();
			//var parentInfo = $(target).parents('.TripsInfo')[0];
			var top = baloon_pos.top - $baloon.height() - 27;
			$baloon.css({
				left: baloon_pos.left,
				top: top,
				position: 'absolute'
			});

			if(top < 0) {
				$baloon
					.addClass('bottom')
					.css({ top: baloon_pos.top + 44 });
			}

			fadeInBlock($baloon[0]);
			infoBaloonHidden = false;
			$(document.body).trigger({
				type: "showRating",
				view: "flight"
			});
			//
			$baloon = null;
			target = null;
			baloon_pos = null;
			FlightInfos=null;
		};
	});

	$('.TripStars')
		.die('mouseleave')
		.live('mouseleave',function(e){
			HideBaloonInfo();
		});

	$('.stars_baloon')
		.die('mouseleave')
		.live('mouseleave',function(e){
			HideBaloonInfo();
		});


	function HideBaloonInfo(){
		setTimeout(function(){
			var $mouseTarget = $(mouseEvent.target);
			if($mouseTarget.hasClass('stars_baloon') || $mouseTarget.parents('.stars_baloon')[0]){
				return;
			} else if($mouseTarget.hasClass('stars_block') || $mouseTarget.parents('.stars_block')[0]){
				var $el = $mouseTarget.hasClass('stars_block')? $mouseTarget : $mouseTarget.parents('.stars_block');
				if( $('#stars_'+ $el.attr('tripinfo')).length > 0 ){
					return;
				} else {
					removeInfoBaloon();
				}
			} else {
				removeInfoBaloon();
			}
		},300);
	}
}


MakeFlightInfos = function(TripIds, options){
	var FlightInfos=[];
	var ageAbs = true;
	if(tw.TripsForStars) {
		var tripNumbers = TripIds.split(',');
		for(var i=0,TL=tripNumbers.length;i<TL;i++){
			if(!!tripNumbers[i] && tw.TripsForStars.trps[tripNumbers[i]].flightInfo) {
				FlightInfos.push(tw.TripsForStars.trps[tripNumbers[i]].flightInfo);
				if(!tw.TripsForStars.trps[tripNumbers[i]].ageAbs) {
					ageAbs = false;
				}
			}
		}
	} else if(TripIds.flightInfo) {
		FlightInfos.push(TripIds.flightInfo);
	}

	var html_tmpl = {};
	html_tmpl.flightInfo = {
		count: {
			ages: 0,
			delay: 0,
			delay15:0,
			delay30:0,
			late: 0,
			cancelled: 0,
			seatPitchE: 0,
			seatPitchB: 0,
			seatsmaxPE: 0,
			seatsminPE: 0,
			seatsmaxPB: 0,
			seatsminPB: 0
		}
	};


	if (FlightInfos.length > 0) {
		var tempAgeAbs, curProperty;
		for (var j = 0, FL = FlightInfos.length; j < FL; j++) {
			var curFlightInfo = FlightInfos[j];
			for (var i in curFlightInfo) {
				curProperty = curFlightInfo[i];
				if (!html_tmpl.flightInfo[i]) {
					html_tmpl.flightInfo[i] = {
						stars: 0,
						value: 0
					};
				}
				html_tmpl.flightInfo.count[i]++;
				html_tmpl.flightInfo[i].stars += parseInt(curProperty.stars,10);
				html_tmpl.flightInfo[i].value += parseInt(curProperty.value,10);
				if(i=="ages"){
					if(!tempAgeAbs) {
						tempAgeAbs = html_tmpl.flightInfo[i].value;
					} else if(tempAgeAbs != html_tmpl.flightInfo[i].value){
						ageAbs = false;
					}
				}
			}
		}

		var oCount = html_tmpl.flightInfo.count;
		for (var j in html_tmpl.flightInfo) {
			curProperty = html_tmpl.flightInfo[j];
			if (j != "count") {
				var curStars = String(curProperty.stars / (oCount[j] * 2)).split('.');
				curProperty.value = curProperty.value / oCount[j];

				var stars = curStars[0];
				var halfstars = curStars[1] ? 1 : 0;
				curProperty.width = {
					stars : stars * 14,
					halfstar : halfstars * 14,
					emptystars : (5 - stars - halfstars) * 14
				};

				curStars = null;
				stars = null;
				halfstars = null;
			}
		}
	} else {
		html_tmpl.flightInfo.noInfo =true;
	}
	html_tmpl.flightInfo.ageAbs = ageAbs;
	if((options && options.economy) || (tw.oResult && tw.oResult.obj.cs == "E")){
		delete html_tmpl.flightInfo.seatPitchB;
		delete html_tmpl.flightInfo.seatsmaxPB;
		delete html_tmpl.flightInfo.seatsminPB;
	}
	if((options && !options.economy) || (tw.oResult && tw.oResult.obj.cs == "B")){
		delete html_tmpl.flightInfo.seatPitchE;
		delete html_tmpl.flightInfo.seatsmaxPE;
		delete html_tmpl.flightInfo.seatsminPE;
	}
	return html_tmpl.flightInfo;
};

function makeStarsBlock(trip){
//звездатость
	if(!( (trip.flightInfo && trip.flightInfo.stars>=0) || trip.stars )){
		return;
	}
	var defStars = trip.stars ? parseInt(trip.stars, 10) : parseInt(trip.flightInfo.stars, 10);
	if(!trip.html_tmpl) {
		trip.html_tmpl = {};
	}
	trip.html_tmpl.stars = (defStars/2).toFixed(1);
	trip.html_tmpl.halfstar= 0;
	var stars = trip.html_tmpl.stars;
	trip.html_tmpl.stars = Math.floor(stars.split('.')[0]);
	if(stars.split('.')[1]>=3 && stars.split('.')[1]<7) {
		trip.html_tmpl.halfstar= 1;
	}
	if(stars.split('.')[1]>7) {
		trip.html_tmpl.stars+= 1;
	}
	trip.html_tmpl.emptystars = (5-trip.html_tmpl.stars - trip.html_tmpl.halfstar)*14;
	trip.html_tmpl.stars = trip.html_tmpl.stars*14;
};

$(document).ready(function(){
	$.template( 'tmpl_TripStars', $("#tmpl_TripStars").trim());
	$.template( 'tmpl_TripInfo', $("#tmpl_TripInfo").trim());
	$.template( 'tmpl_BaloonFlightStars', $("#tmpl_BaloonFlightStars").trim());
	makeTripStars();
});

FlightsBookAndPay = {
	hasLegacyMessage: function (messages) {
		return messages && messages.some(function (msg) {
			return msg.cd === 'LEGACY_BNP';
		});
	},
	showPassengerSelect: function(fareParams, autoChoose) {
		var tw           = window.tw         || (window.tw         = {});
		var oResult      = tw.oResult        || (tw.oResult        = {});
		var oFlights     = oResult.oFlights  || (oResult.oFlights  = []);
		var fare         = fareParams.fare   || (fareParams.fare   = {});
		var params       = fareParams.params || (fareParams.params = {});

		var oResultObj     = oResult.obj     || (oResult.obj     = {});
		var oResultObjJson = oResultObj.json || (oResultObj.json = {});
		var searchResultMessages = oResultObjJson.searchResultMessages || (oResultObjJson.searchResultMessages = {});

		var twParams = tw.params;
		var backLink = fareParams.backLink;
		var oFlightsData = oFlights[params.FlightIndex];
		var sourceFare = oFlightsData.sourceFare || {};

		if (params.searchId == null){
			params.searchId = oResultObjJson.srid;
		}

		var shouldOpenLegacy = this.hasLegacyMessage(sourceFare.infMsgs) || window.LEGACY_BNP;

		var bookPageVer = 100;
		if (!shouldOpenLegacy) {
			bookPageVer = 200;

			params.allowDesignSwitch = '0';
			params.backLink = backLink;
			params.autoChoose = autoChoose;
			params.p = twParams.p || '1,0,0';
			params.srcmarker = twParams.srcmarker || (tw.bookingParams && tw.bookingParams.srcmarker);
			params.utmMarker = twParams.utm_source;
			params.utmMedium = twParams.utm_medium;
			params.linkId = oResult.obj.json.linkId;
			params.serviceClass = oResult.obj.cs;
			params.promoCode = twParams.promocode;
			params.promoAmount = oFlightsData.PromoAmount;
			params.promoPercent = oFlightsData.PromoPercent;
			params.promoMaxPercent = parseInt(oFlightsData.PromoMaxPercent) || undefined; //NaN or 0
		}

		window.chooseFare({
			seatsAvl: fare.stAvl,
			params: params,
			bookPageVer: bookPageVer,
			autoChoose: autoChoose
		});

		if (!shouldOpenLegacy) {
			oResult._fareConfirm = null; // for prevent hashchange

			var path = '/book/' + cryptoTrips.encode(fareParams);

			window.chooseFare({
				seatsAvl: fare.stAvl,
				params: params,
				bookPageVer: path == null ? 103 : 102,
				autoChoose: autoChoose
			});

			window.open('//' + location.host + '/' + tw.language + (tw.env ? ('/f/?env=' + tw.env + '&sv=100#') : '/f/?sv=100#') + path, '_blank');
		} else {
			oResult._fareConfirm = fareParams; //for hashchange
			window.location.hash = window.location.hash.split('|')[0] + '|' + fareParams.resultFlight.AK + '|' + fareParams.resultFlight.direct + '_' + fareParams.resultFlight.combined + '|fn=' + fareParams.resultFlight.FlightNumbers.join('-');

			if (!objPassengerSelect) {
				objPassengerSelect = new PassengerSelect($.extend({ searchResultMessages: searchResultMessages }, fareParams));
			} else {
				objPassengerSelect.show(fareParams);
			}
		}
	}
};

window.chooseFare = function(data) {
	var chooseParams = {
		seatsAvl:    data.seatsAvl,
		bookPageVer: data.bookPageVer || 100,
		autoChoose:  data.autoChoose  || 0
	};
	var mergedParams = {};
	var params = data.params;
	var keys = Object.keys(params);
	var key;
	var k = 0;
	var kl = keys.length;
	while (k !== kl) {
		key = keys[k++];
		mergedParams[key] = params[key];
	}
	keys = Object.keys(chooseParams);
	k = 0;
	kl = keys.length;
	while (k !== kl) {
		key = keys[k++];
		mergedParams[key] = chooseParams[key];
	}
	chooseParams.params = JSON.stringify(mergedParams);
	$.ajax({
		iframeId: "pm",
		type: "post",
		dataType: "json",
		url: '/_api/confirmation/choosefare/',
		data: chooseParams
	});
};

/**
 * Created by vlad on 11/07/16.
 */
'use strict';

// Singleton
var NotificationsContainer = (function () {
	var instance;

	function NotificationsContainer(config) {
		if (!instance) {
			instance = this;
		} else {
			return instance;
		}

		this.container = config.container;
		this.viewStore = [];
		this.viewYPosition = 0;
		this.maxElements = config.maxElements || 12;

		this._init();
	}

	NotificationsContainer.prototype._init = function () {
		pubSub(this);

		this._createContainer();
		this._subscribeForViewEvents();
		// this._setEvents();
	};

	NotificationsContainer.prototype.createNotification = function (config) {
		if (this.viewStore.length <= this.maxElements) {
			config = config || {};
			config.container = this.el;
			config.parent = this;
			config.yPosition = this.viewYPosition;

			var notification = new NotificationView(config);
			notification.index = this.viewStore.push(notification) - 1;

			return notification;
		}
	};

	NotificationsContainer.prototype._createContainer = function () {
		var notificationsContainer = document.createElement('aside');
		notificationsContainer.className = 'NotificationsWrapper';

		this.el = notificationsContainer;
		this.container.appendChild(notificationsContainer);
	};

	NotificationsContainer.prototype._removeFromStore = function (index) {
		var store = this.viewStore;
		store.splice(index, 1);

		for (var i = index; i < store.length; ++i) {
			store[i].index = i;
		}
	};

	NotificationsContainer.prototype._subscribeForViewEvents = function () {
		var self = this;
		var subscribe = this.subscribe;

		subscribe('view:init', function (topic, data) {
			// console.log(topic);
		});

		subscribe('view:render', function (topic, data) {
			self.viewYPosition += data.height;
		});

		subscribe('view:show', function (topic, data) {
			var store = self.viewStore;
			if (store.length >= self.maxElements) {
				store[0].hide();
			}
		});

		subscribe('view:hide', function (topic, data) {
			// console.log(topic);
		});

		subscribe('view:remove', function (topic, data) {
			var index = data.index;
			var deletedViewHeight = data.height;

			self.viewYPosition -= deletedViewHeight;

			self._removeFromStore(index);
			self._updateChildViewsPosition(index, deletedViewHeight);
		});
	};

	NotificationsContainer.prototype._setEvents = function () {
		var el = this.el;
		var marginTop = parseInt(getComputedStyle(el).marginTop, 10);

		window.onscroll = function () {
			var scrolled = window.pageYOffset || document.documentElement.scrollTop;
			var elTopPos = this.elTopPos ? this.elTopPos : (el.offsetTop - marginTop);

			if (!this.elTopPos) {
				this.elTopPos = elTopPos;
			}

			if (scrolled >= elTopPos) {
				el.classList.add('NotificationsWrapper--isFixed');
			} else {
				el.classList.remove('NotificationsWrapper--isFixed');
			}
		}
	};

	NotificationsContainer.prototype._updateChildViewsPosition = function (index, positionDifference) {
		var store = this.viewStore;

		for (var i = index; i < store.length; ++i) {
			store[i]._changePosition(positionDifference);
		}
	};

	NotificationsContainer.prototype.closeAll = function () {
		this.viewStore.forEach(function (item) {
			item.hide();
		});
	};

	return NotificationsContainer;

	function pubSub(store) {
		/**
		 * Storage for topics that can be broadcast or listened to
		 * @type {{}}
		 */
		var topics = {};

		// An topic identifier
		var subUid = -1;

		/**
		 * Publish or broadcast events of interest with a specific topic name and arguments such as the data to pass along
		 * @param topic
		 * @param args
		 * @returns {*}
		 */
		store.publish = function (topic, args) {
			if (!topics[topic]) {
				return false;
			}

			var subscribers = topics[topic];
			var length = subscribers ? subscribers.length : 0;

			while (length--) {
				subscribers[length].func(topic, args);
			}

			return this;
		};

		/**
		 * Subscribe to events of interest with a specific topic name and a callback function, to be executed when the topic/event is observed
		 * @param topic
		 * @param func
		 * @returns {string}
		 */
		store.subscribe = function (topic, func) {
			if (!topics[topic]) {
				topics[topic] = [];
			}

			var token = ( ++subUid ).toString();
			topics[topic].push({
				token: token,
				func: func
			});
			return token;
		};

		/**
		 * Unsubscribe from a specific topic, based on a tokenized reference to the subscription
		 * @param token
		 * @returns {*}
		 */
		store.unsubscribe = function (token) {
			for (var m in topics) {
				if (topics.hasOwnProperty(m)) {
					for (var i = 0, l = topics[m].length; i < l; i++) {
						if (topics[m][i].token === token) {
							topics[m].splice(i, 1);
							return token;
						}
					}
				}
			}

			return this;
		};
	}
})();

/**
 * Custom Notification View
 * events: { onInit, beforeRender, afterRender, beforeShow, afterShow, beforeClose, afterClose }
 * @param config: content - DOM element;
 * @constructor
 */
function NotificationView(config) {
	this.config = config || {};
	this.container = config.container;
	this.parent = config.parent;

	this.content = config.content;

	this.lifeTime = config.lifeTime;

	var transitionDuration = config.transitionDuration;
	if (transitionDuration < 0 || transitionDuration > 1) {
		throw new RangeError('Value must be less than 1 and greater than 0');
	}
	this.transitionDuration = transitionDuration || 0.15;

	this.yPosition = config.yPosition;
	this.xPosition = config.xPosition || 30;

	this.events = config.events;

	this.type = config.type || 'default';

	this._init();
}

NotificationView.prototype._init = function () {
	var events = this.events;
	var onInit = events && events.onInit;

	this.parent.publish('view:init', {
		view: this,
		index: this.index,
	});

	onInit && onInit();

	this._createElement();
	this._setEvents();

	this._render();
	this.show();
};

NotificationView.prototype._createElement = function () {
	var duration = this.transitionDuration;
	var yPosition = this.yPosition;
	var xPosition = this.xPosition;

	var content = this.content || null;
	var notification = document.createElement('div');
	var notificationContainer = notification.cloneNode(false);
	var btn = document.createElement('button');

	notification.className = this._setTypeOfNotification();
	notificationContainer.className = 'NotificationView__Container';
	btn.className = 'NotificationView__Btn';

	if (content) {
		var nodeType = content.nodeType;
		if (nodeType && nodeType === 3 || nodeType === 1) {
			notificationContainer.appendChild(content)
		} else if (typeof content === 'string') {
			notificationContainer.insertAdjacentHTML('afterbegin', content);
		}
	}
	notification.appendChild(btn);
	notification.appendChild(notificationContainer);

	this.el = notification;
	this.closeBtn = btn;

	this._setStyles({
		opacity: 0,
		webkitTransition: duration + 's transform, ' + duration + 's opacity',
		mozTransition: duration + 's transform, ' + duration + 's opacity',
		msTransition: duration + 's transform, ' + duration + 's opacity',
		oTransition: duration + 's transform, ' + duration + 's opacity',
		transition: duration + 's transform, ' + duration + 's opacity',
	});
	this._updatePosition(xPosition, yPosition);
};

NotificationView.prototype._setTypeOfNotification = function () {
	var notificationClassName = 'NotificationView';

	switch (this.type) {
		case 'success':
			notificationClassName += ' NotificationView--Success';
			break;

		case 'info':
			notificationClassName += ' NotificationView--Info';
			break;

		case 'warning':
			notificationClassName += ' NotificationView--Warning';
			break;

		case 'error':
			notificationClassName += ' NotificationView--Error';
			break;

		default:
			notificationClassName += ' NotificationView--Default';
			break;
	}

	return notificationClassName;
};

NotificationView.prototype._render = function () {
	var events = this.events;
	var beforeRender = events && events.beforeRender;
	var afterRender = events && events.afterRender;

	beforeRender && beforeRender();

	this.container.appendChild(this.el);

	this.parent.publish('view:render', {
		view: this,
		height: this._getOuterHeight(),
	});

	afterRender && afterRender.call(this);
};

NotificationView.prototype.show = function () {
	var self = this;
	var yPosition = this.yPosition;
	var xPosition = this.xPosition = 0;

	var lifeTime = this.lifeTime;

	var events = this.events;
	var beforeShow = events && events.beforeShow;
	var afterShow = events && events.afterShow;

	beforeShow && beforeShow.call(this);

	this.parent.publish('view:show', {
		view: this,
		height: this._getOuterHeight(),
	});

	this._setStyles({
		opacity: 1,
	});
	this._updatePosition(xPosition, yPosition);

	afterShow && afterShow.call(this);

	if (lifeTime) {
		this.autoCloseTimeoutID = setTimeout(function () {
			self.hide();
		}, lifeTime);
	}
};

NotificationView.prototype.hide = function () {
	var autoCloseTimeOut = this.autoCloseTimeoutID;
	autoCloseTimeOut && clearTimeout(autoCloseTimeOut);

	var events = this.events;
	var beforeClose = events && events.beforeClose;
	var afterClose = events && events.afterClose;

	var xPosition = this.xPosition = 30;
	var yPosition = this.yPosition;

	beforeClose && beforeClose.call(this);

	this._setStyles({
		opacity: 0,
	});
	this._updatePosition(xPosition, yPosition);

	this.parent.publish('view:hide', {
		view: this,
		height: this._getOuterHeight(),
		index: this.index,
	});

	afterClose && afterClose.call(this);

	this._destroy();
};

NotificationView.prototype._destroy = function () {
	var self = this;
	var timeOut = this.transitionDuration;
	var height = this._getOuterHeight();

	var parentContainer = this.container;
	var notificationElement = this.el;

	setTimeout(function () {
		if (parentContainer.contains(notificationElement)) {
			parentContainer.removeChild(notificationElement);
		}
		self.parent.publish('view:remove', {
			view: self,
			height: height,
			index: self.index,
		});
	}, timeOut * 1000);
};

NotificationView.prototype._setEvents = function () {
	var self = this;

	this.closeBtn.addEventListener('click', function () {
		self.hide();
	});
};

NotificationView.prototype._getOuterHeight = function () {
	var height = this.el.offsetHeight;
	var styles = getComputedStyle(this.el);
	return height + parseInt(styles.marginTop, 10) + parseInt(styles.marginBottom, 10);
};

NotificationView.prototype._setStyles = function (styles) {
	var el = this.el;

	for (var i in styles) {
		if (styles.hasOwnProperty(i)) {
			el.style[i] = styles[i];
		}
	}
};

NotificationView.prototype._changePosition = function (diff) {
	var newYPos = this.yPosition - diff;

	this._updatePosition(this.xPosition, newYPos);

	this.yPosition = newYPos;
};

NotificationView.prototype._updatePosition = function (x, y) {
	this._setStyles({
		webkitTransform: 'translateX(' + x + 'px) translateY(' + y + 'px)',
		mozTransform: 'translateX(' + x + 'px) translateY(' + y + 'px)',
		msTransform: 'translateX(' + x + 'px) translateY(' + y + 'px)',
		oTransform: 'translateX(' + x + 'px) translateY(' + y + 'px)',
		transform: 'translateX(' + x + 'px) translateY(' + y + 'px)',
	});
};

tw.layout_results = null;
tw.oResult = null;
tw.ticketParams={};
var allVariants = false;
tw.socialShare = false;
//if(tw.language == 'ru') {tw.socialShare = true;}

var jokes = {
	'Новосибирск-Владивосток': [
		'40% пассажиров заранее подготовили 2000 купюры, чтобы проверить их подлинность',
		'8% получили заказы на красную икру',
		'12% скачали в полет альбом «Мумий Тролль. Лучшее»'
	],
	'Санкт-Петербург-Москва': [
		'50% пассажиров не помнят, как выглядит солнце',
		'24% летят в сине-голубых шарфах',
		'5% знают, что делать в Питере — «пить» (с)'
	],
	'Новосибирск-Токио': [
		'5% пассажиров — роботы',
		'5% рассчитывают встретить Сейлор Мун. «Лунная Призма, дай мне силу!»',
		'1 пассажир косплеит Тоторо, а 97% делают с ним селфи'
	],
	'Москва-Рим': [
		'7% пассажиров сделали классный маникюр для той самой фотки джелато на фоне Испанской лестницы',
		'12% are typing #travel #rome #holidays #vacation #triptoitaly #путешествия #отпуск',
		'5% думают, что водопроводчик Марио и его брат Луиджи из этих мест'
	],
	'Москва-Вена': [
		'23% пассажиров не видят лишнее слово в ряду: шницель, Захер, опера, карета',
		'1% все еще рассчитывают встретить кенгуру',
		'5% знают наверняка: темный фон и страдания — Тициан, кошмарный сон — Босх'
	],
	'Москва-Сочи': [
		'14% пассажиров искренне скучают по: «Кукуруза, пахлава медовая!»',
		'15% готовы подвезти других пассажиров до дома недорого',
		'15% летят домой, поскольку знали прикуп'
	],
	'Москва-Мурманск': [
		'100% пассажиров рейса Москва — Мурманск летят на море',
		'1% уверены, что летят в Муром',
		'100% знают, что зима близко'
	]
};

$(document).ready(function(){
	addMutationObjserver();

	if((tw.source && tw.source.tag) || tw.params.allVariants){ allVariants = true; }
	tw.layout_results = document.getElementById('layout_results');
	$.template( 'tmpl_FlightBlock', $("#tmpl_FlightBlock").trim());
	$.template( 'tmpl_FlightTooltip', $("#tmpl_FlightTooltip").trim());
	$.template( 'tmpl_BaloonFlightStars', $("#tmpl_BaloonFlightStars").trim());
	$.template( 'tmpl_newAirlineFlights', $("#tmpl_newAirlineFlights").trim());
	$.template( 'tmpl_AirlineFlights', $("#tmpl_AirlineFlights").trim());
	$.template( 'tmpl_AirlineDirectionFlight', $("#tmpl_AirlineDirectionFlight").trim());
	$.template( 'tmpl_Stars', $("#tmpl_Stars").trim());
	$.template( 'tmpl_TripsStars', $("#tmpl_TripsStars").trim());
	$.template( 'tmpl_FlightsByAK', $("#tmpl_FlightsByAK").trim());
	$.template( 'tmpl_FlightsByAKarray', $("#tmpl_FlightsByAKarray").trim());
	$.template( 'tmpl_dealSubscribes', $("#tmpl_dealSubscribes").trim());
	$.template( 'tmpl_dealSubscribesBounce', $("#tmpl_dealSubscribesBounce").trim());


	if(tw.socialShare){
		$.template( 'tmpl_SocialShare', $("#tmpl_SocialShare").trim());
	}
	$.template( 'tmpl_Ticket', $("#tmpl_Ticket").trim());

	if (tw.testResult) {
		tw.currencyRates = tw.testResult.rates;
		RequestList = [];
		RequestList[0] = new RequestData();
		RequestList[0].directions[0] = new Direction({
			from: 'MOW',
			to: 'PAR',
			date: new Date()
		});
		RequestList[0].directions[1] = new Direction({
			from: 'PAR',
			to: 'MOW',
			date: new Date()
		});
		/*RequestList[0].directions[2] = new Direction({
			from: 'LON',
			to: 'LED',
			date: new Date()
		});*/
		/*RequestList[0].directions[3] = new Direction({
			from: 'PAR',
			to: 'MOW',
			date: new Date()
		});*/
		RequestList[0].json = tw.testResult;
		objAvia.drawResults(RequestList[0]);
	}
	//при клике-скроле убираем балун с инфой звездатости по перелету
		$('div:not([class*="stars_baloon"])').click(function(){
			removeInfoBaloon();
		});
		$(window).scroll(function(){
			removeInfoBaloon();
		});

	$(document).on('mouseenter mouseleave', '.price_button--with-tooltip', function(e) {
		var block = $(this).closest('.FlightTicket');

		block.css({
			'z-index': e.type === 'mouseenter' ? 12 : 11
		})
	});

	$('body').delegate('.ResultTable .price_button', 'mouseover mouseout mousedown mouseup', function(e){
		if (e.type == 'mouseover' ) {
			$(this).addClass('hover');
		} else if (e.type == 'mousedown' ) {
			$(this).addClass('down');
		} else if (e.type == 'mouseup' ) {
			$(this).removeClass('down');
		} else {
			$(this).removeClass('hover down');
		}
	}).on('click', '.ResultTable .price_button', function() {
		FareConfirmation({FlightIndex: $(this).attr('data-flightIndex')});
	});

//	if (tw.language === 'ru' && readCookie('referrer') === 'aviasales') {
//		tw.metaReturn = new MetaReturn();
//	}

	$(document).on('resultsShow', function(ev) {
		function getRandomNumberBetween(min, max) {
			return Math.floor(Math.random() * (max - min + 1)) + min;
		}

		var obj = (ev.infoData && ev.infoData.obj) || {};
		var searchResultsMessages = obj.json && obj.json.searchResultMessages;

 		if (searchResultsMessages) {
		    if (searchResultsMessages['SHOW_NOTICE_1']) {
			    setTimeout(function(){
				    var notification1 = tw.notificationMessages.createNotification({
					    content: $.tmpl($('#tmpl_NotificationView'), {
						    counter: getRandomNumberBetween(25, 30),
						    notifyText: l10n.searchResult.notifications.views,
					    })[0],
					    lifeTime: 7000,
				    });
			    }, 3000);
		    }

		    if (searchResultsMessages['SHOW_NOTICE_2']) {
			    setTimeout(function(){
				    var notification2 = tw.notificationMessages.createNotification({
					    content: $.tmpl($('#tmpl_NotificationView'), {
						    counter: getRandomNumberBetween(105, 110),
						    notifyText: l10n.searchResult.notifications.sales,
					    })[0],
					    lifeTime: 7000,
				    });
			    },3000)
		    }
	    }
	});

	$(document.body)
		.on("changeRequest", function(){
			tw.oResult=null;
		})
		.on("removeMiddleSearchRotation", function(){
			$('#adfox_149216737788628611').remove();
			$('#adfox_15131626581234573').remove();
		});

	$('.manyCompanies').livequery(function(){
		$(this).tooltip();
	});

	$('.infotitle').livequery(function(){
		$(this).tooltip();
	});

	TicketFlightStars();
	MakeAirportTooltips();
	/*$(window).scroll(function() {
		PlanePositioning();
	});
	$(window).resize(function() {
		PlanePositioning();
	});*/
	if(tw.socialShare) {
		SocialOptions();
	}
	$('.showTripInfo').live('click',function(e){
		e.preventDefault();
		var info = String($(this).data('info')).split(',');
		var FlightIndex = info[0];
		var DirNum = (info[1] && info[1]!="")?info[1]:null;
		ShowTrip(FlightIndex,DirNum);
	});

	$(window).on('hashchange', function(){
		if(tw.oResult) {
			try {
				var l = document.location.hash.split('|').length;
				if(l === 3 && tw.oResult._selectedAK && !tw.oResult.AKinProcess) {
					if(objPassengerSelect && objPassengerSelect.visible && !objPassengerSelect.inProcess) {
						//log('go ak list after booking form @history back')
						objPassengerSelect.hideBack();
					} else {
						//log('go AK list from search result @history forward')
						tw.oResult.selectedAK = tw.oResult._selectedAK;
						tw.oResult.DrawSelectedAK();
					}
				} else if(l === 4 && tw.oResult._fareConfirm && !objPassengerSelect.inProcess) {
					if(tw.metaReturn) {
						tw.metaReturn.newSearch();
					}
					objPassengerSelect.show(tw.oResult._fareConfirm);
				} else if(tw.oResult._fareConfirm || tw.oResult._selectedAK) {
					if(objPassengerSelect && objPassengerSelect.visible && !objPassengerSelect.inProcess) {
						if(tw.metaReturn) {
							tw.metaReturn.newSearch();
						}
						//log('hide booking form if not inProcess open-close @history back')
						objPassengerSelect.hideBack();
					} else if(tw.oResult.isAKVisible) {
	 					if (!objPassengerSelect || (objPassengerSelect && !objPassengerSelect.inProcess)) {
	 						//log('show search result from AK list @history back')
							tw.oResult.DestroyAKFlights();
							tw.oResult.isAKVisible = false;
							if(tw.oResult.ClickedAKBlock) {
								tw.oResult.ClickedAKBlock = null;
							}
							if(tw.oResult.ShowRefundable) {
								tw.oResult.ShowRefundable = false;
								//log('redraw')
								tw.oResult.RedrawResults();
							}
						}
					}
				}
			} catch(e) {}
		}
	});

	var pixel = document.createElement('img');
	pixel.src = "/images/blank.gif?rand=" + Math.random();
});

function MetaReturn() {
	this.timer = null;
	this.redirectForCurrentFlight = null;
	this.timerMinutes = 15;
}

MetaReturn.prototype.getRosturizmik = function() {
	if (!this.rosturizmikDfd) {
		var rosturizmikDfd = this.rosturizmikDfd = $.Deferred();
		$.ajax({
			url: 'https://rosturizmik.ru/__mr/create-anchor.js',
			dataType: 'script',
			success: function() {
				rosturizmikDfd.resolve(window.rosturizmik);
			},
		});
	}
	return this.rosturizmikDfd;
};

MetaReturn.prototype.getRoute = function() {
	return (/(\d{4}|[a-z]{3}){3,99}/ig.exec(location.hash) || [])[0] || 'anywhere';
};

MetaReturn.prototype.addBanner = function(errorType) {
	var metaReturn = this;
	this.getRosturizmik().done(function(rosturizmik) {
		$('.mr-content').remove();
		var containerNode = $.tmpl($("#tmpl_metaReturn").trim(), {errorType: errorType})[0];
		$(containerNode).appendTo($('#layout_body'));

		var route = metaReturn.getRoute();

		var anchorNode = rosturizmik.createAnchor({
			lang: tw.language.split('-')[0],
			route: route,
		});
		containerNode.appendChild(anchorNode);

		kmqRecord({
			name: 'showMetaReturn',
		});
		$(anchorNode).on('click', function() {
			kmqRecord({
				name: 'goMetaReturn',
				obj: {
					route: route,
					type: errorType,
					time: metaReturn.timerMinutes,
				},
				prefix: 'MR',
			});
		})
	});
};

MetaReturn.prototype.addBannerByTimer = function(errorType) {
	if (!window.needSSBannerByTimer) {
		return false;
	} // disable logic by timer
	clearTimeout(this.timer);

	var metaReturn = this;
	var time;
	if (window.needSSBannerByTimer) {
		time = 0;
	} else {
		time = this.timerMinutes * 60 * 1000;
	}
	this.timer = setTimeout(function() {
		metaReturn.addBanner(errorType);
		metaReturn.bannerOnPasSelect = true;
	}, time);
};

MetaReturn.prototype.reset = function() {
	clearTimeout(this.timer);
	this.timer = null;
	$('.mr-content').remove();
};

MetaReturn.prototype.newSearch = function() {
	location.href = location.origin + location.pathname + '#' + tw.oResult.obj.searchKey;
};

function SocialOptions(){
	$('.shareable').live('click',function(e){
		e.preventDefault();
		window.open($(this).attr('href'), 'sharer_' + new Date().valueOf(), 'toolbar=no,width=625,height=435,modal=yes');
	});
}
function RewriteSocialOptions(){
	if(!tw.socialShare) {
		return;
	}
	try{
		var href = encodeURIComponent("http://" + document.location.host + "/?s" + document.location.hash);
		var text="";

		if(objSearchForm.data.flightType == "multiway") {
			for (var j = 0; j < tw.oResult.allDirectionsLength; j++) {
				var date = tw.oResult.obj.directions[j].date;
				if (ref.Cities[tw.oResult.obj.directions[j].from]) {
					text += ref.getCityName(tw.oResult.obj.directions[j].from);
				} else if (ref.Airports[tw.oResult.obj.directions[j].from]) {
					text += ref.getCityName(ref.Airports[tw.oResult.obj.directions[j].from].Parent);
				}
				text += "→";
				if (ref.Cities[tw.oResult.obj.directions[j].to]) {
					text += ref.getCityName(tw.oResult.obj.directions[j].to);
				} else if (ref.Airports[tw.oResult.obj.directions[j].to]) {
					text += ref.getCityName(ref.Airports[tw.oResult.obj.directions[j].to].Parent);
				}
				text += ' ' + date.getDate() + ' ' + l10n.calendar.months_D[date.getMonth()].toLowerCase();

				if (j != tw.oResult.allDirectionsLength - 1) {
					text += ", ";
				}
			}
		} else {
			var date = tw.oResult.obj.directions[0].date;
			if (ref.Cities[tw.oResult.obj.directions[0].from]) {
				text += ref.getCityName(tw.oResult.obj.directions[0].from);
			} else if (ref.Airports[tw.oResult.obj.directions[0].from]) {
				text += ref.getCityName(ref.Airports[tw.oResult.obj.directions[0].from].Parent);
			}

			if(objSearchForm.data.flightType == "oneway") {
				text += "→";
			} else {
				text += "⇄";
			}

			if (ref.Cities[tw.oResult.obj.directions[0].to]) {
				text += ref.getCityName(tw.oResult.obj.directions[0].to);
			} else if (ref.Airports[tw.oResult.obj.directions[0].to]) {
				text += ref.getCityName(ref.Airports[tw.oResult.obj.directions[0].to].Parent);
			}

			text += ' ' + date.getDate();
			if(tw.oResult.allDirectionsLength==2) {
				var date2 = tw.oResult.obj.directions[1].date;
				if(date.getMonth() != date2.getMonth()) {
					text+=l10n.calendar.months_D[date.getMonth()].toLowerCase();
				}
				text += '–' + date2.getDate() + ' ' + l10n.calendar.months_D[date2.getMonth()].toLowerCase();
			} else {
				text+= ' ' + l10n.calendar.months_D[date.getMonth()].toLowerCase();
			}
		}
		text+= ', ' + formatMoney(tw.oResult.stat.minPrice);
		text = encodeURIComponent(text);
		var additionaText= encodeURIComponent(l10n.social.text);
		$('.Social .tw').attr('href','http://twitter.com/share?url=' + href + '&text=' + text);
		$('.Social .vk').attr('href','http://vkontakte.ru/share.php?url='+href+'&title='+text+'&image=http%3A%2F%2Fonetwotrip.com%2Fimages%2Flogo.png&description='+additionaText);
		$('.Social .jj').attr('href','http://www.livejournal.com/update.bml?subject=OneTwoTrip!&event=' + '<a href="' +href+ '">' +text+ '</a>' );
		$('.Social .fb').attr('href','http://www.facebook.com/share.php?u=' +href);
	} catch(e){}
}

function PlanePositioning(){
/*	if(document.getElementById('SeatsSelection')){
		var coordLeft = $('#SeatsSelection').offset().left;
		var coordTop = $(window).scrollTop();
		$('#SeatsPlane').css({
			"position": "fixed",
			"top": -coordTop+38,
			"left": coordLeft-55
		});
	}*/
}
function CloneArray(arr) {
	var arr1 = [];
	for(var i in arr) {
		arr1.push(arr[i]);
	}
	return arr1;
}

function getIntersect(arr1, arr2){
	var r = [], o = {}, l = arr2.length, i, v;
	for (i = 0; i < l; i++) {
		o[arr2[i]] = true;
	}
	l = arr1.length;
	for (i = 0; i < l; i++) {
		v = arr1[i];
		if (v in o) {
			r.push(v);
		}
	}
	return r;
}

function MakeStartDateFlightInfo(DirDate){
	var curDate = DirDate;
	var dateFormats = {
		'az': ', {month} {day}, {weekday}',
		'en-us': ' {weekday}, {month} {day}'
	};
	var formText =  dateFormats[tw.language] || ', {day} {month}, {weekday}';


	if (isValidDate(curDate)) {
		return draw(curDate);
	} else {
		curDate = new Date.parseAPI(DirDate);
		if(isValidDate(curDate)){
			return draw(curDate);
		} else {
			return "";
		}
	}

	function draw(dateToDraw){
		var dd = dateToDraw.getDate();
		var mm = l10n.calendar.months_D[dateToDraw.getMonth()];
		var wd = l10n.calendar.days_N[dateToDraw.getDay()];
		if( tw.language != 'de' && tw.language.indexOf('en') < 0 ) {
			mm = mm.toLowerCase();
		} else if( tw.language === 'en-us' ){
			var mm = l10n.calendar.months_S[dateToDraw.getMonth()];
			var wd = l10n.calendar.days_S[dateToDraw.getDay()];
		}
		return formText.replaceByHash({day: dd,  month: mm,  weekday: wd});
	}
}

function MakeArrivalDateFlightInfo(DirDate){
	var curDate = new Date.parseAPI(DirDate);
	if(isValidDate(curDate)){
		if(tw.language == "en-us") {
			return curDate.format(' (mmm d)')
		} else {
			return curDate.format(' (d mmm)').toLowerCase();
		}
	} else {
		return "";
	}
}

function ChangeLastLetterTranfer(Point){
	if(tw.language == 'ru') {
		Point = Point.split('');
		var Length = Point.length;
		if(Point[Length-1] =="а") {
			Point[Length-1] = "у";
		}
		if(Point[Length-1] =="я") {
			Point[Length-1] = "ю";
		}
		return String(Point).replace(new RegExp(",",'g'),"");
	} else {
		return Point;
	}
}
function ChangeLastLetterFrom(Point){
	if (tw.language == 'ru') {
		Point = Point.split('');
		var Length = Point.length;
		if(Point[Length-1] =="к") {
			Point[Length-1] = "ка";
		}
		return String(Point).replace(new RegExp(",",'g'),"");
	} else {
		return Point;
	}
}


/*function ShortenName(name){
	name = String(name);
	var words = name.split(" ");
	if(words.length >2) {
		var tempName = words[0]+ " " + words[1];
		return tempName + '...';
	} else {
		if(name.length <16) {
			return name;
		}
		return name.substring(0,16) + '...';
	}
}*/

function formatPointStringFromTo(pointName, fromto){
	var shortPoint = pointName;
	/*if(pointName.length > 16) {
		shortPoint = ShortenName(pointName);
	}*/
	if(tw.language == 'az') {
		return shortPoint;
	} else {
		return fromto + ' ' + shortPoint;
	}
}

function formatFilterPrice(price){
	if(tw.language == 'az') {
		return '<span  class="money-formatted">' + formatMoney(price.toFixed(2)) + '</span><span class="min_priceword">' + l10n.searchResult.filters.priceFrom + '</span>';
	} else {
		return '<span class="min_priceword">' + l10n.searchResult.filters.priceFrom + '</span> <span  class="money-formatted">' + formatMoney(price) + '</span>';
	}
}


function MinSeatsAvl(arr){
	if(arr.length<1) return "";
	arr = String(arr).split(',');
	var newArr = [];
	for(i=0,AL=arr.length;i<AL;i++){
		if(arr[i]!='') {
			newArr.push(arr[i]);
		}
	}
	return Math.min.apply( null, newArr );
}

function checkVilniusAirportWarning(obj) {
	var directions = obj.directions || [];

	var from = Date.parse('2017/07/14');
	var to = Date.parse('2017/08/17');

	var VNO = directions.some(function (dir) {
		var VNO = dir.from === 'VNO' || dir.to === 'VNO';
		var time = dir.date.getTime();
		return VNO && time >= from && to >= time;
	});

	if (VNO) {
		var key = obj.searchKey.replace(/VNO/g, 'KUN');
		var link = 'https://' + window.location.host + '//?s#'+ key;

		addPopup({
			error: true,
			className: "noResults",
			reason: l10n.popup.warning,
			comment: l10n.searchResult.popup.noVilniusFlights.replaceByHash({
				link: link
			}),
			close_button: true,
			button: l10n.popup.close,
			removeOnAction: true
		});

		return true;
	}

	return false;
}
function DrawFares(obj){
	tw.oResult = null;
	if($('.ResultTable')[0]) {
		$('.ResultTable').remove();
	}
	tw.avia = tw.avia||{};
	tw.avia.popup = {
		airline: function(){
			if(ref.Airlines[tw.source.ak]){
				addPopup({
					error: true,
					className: "noResults",
					reason: l10n.popup.warning,
					comment: l10n.searchResult.popup.airline[0] + ref.Airlines[tw.source.ak] + l10n.searchResult.popup.airline[1],
					close_button: true,
					button: l10n.popup.close,
					removeOnAction: true
				});
			}
		},
		time: function(){
			if(tw.source.time && String(parseInt(tw.source.time,10)).length==4){
				addPopup({
					error: true,
					className: "noResults",
					reason: l10n.popup.warning,
					comment: l10n.searchResult.popup.time[0]+ref.Airlines[tw.source.ak]+l10n.searchResult.popup.time[1]+ DurationTimeString(tw.source.time,1,1) +l10n.searchResult.popup.time[2],
					close_button: true,
					button: l10n.popup.close,
					removeOnAction: true
				});
			}
		}
	};

	$(document.body).trigger("removeMiddleSearchRotation");
	removeLoader();
	if(obj.hide){
		if (window.objMap) objMap.show();
	} else if (obj.json.frsCnt > 0) {
		tw.oResult = new DrawResults(obj);
		$(document).trigger({
			"type": "resultsShow",
			"infoData": tw.oResult
		});
		RewriteSocialOptions();
		$('body').css({"overflow-y": "scroll"});
		$(tw.layout_results).animate({
			opacity: '1'
		}, 300, function(){
			$(this).removeAttr('style');
		});
	} else {
		kmqRecord({name:"FaresNotFound", obj:tw.searchFlight, prefix: 'FNF'});
		if (window.objMap) objMap.show();
		objSearchForm.update();
		var data = objAvia.parseKey(obj.getKey());

		if(tw.metaReturn) {
			tw.metaReturn.addBanner('searchError');
		} else
		if(data.cs == "W") {
			var popup = addPopup({
				error: true,
				className: "noCSresult",
				reason: l10n.popup.warning,
				comment: l10n.searchResult.popup.noCSresult,
				close_button: true
			});
			$('#b_search', popup).on('click', function(){
				data.cs = "B";
				removePopup();
				objAvia.changeRequest(objAvia.addDataToRequestsList(data));
			});
			$('#e_search', popup).on('click', function(){
				data.cs = "E";
				removePopup();
				objAvia.changeRequest(objAvia.addDataToRequestsList(data));
			});
		} else if (obj.json.errors && obj.json.errors[0] == 'DATE_PASSED') {
			addPopup({
				error: true,
				className: "noResults",
				reason: l10n.popup.warning,
				comment: l10n.searchResult.popup.date_passed,
				close_button: true,
				button: l10n.popup.close,
				removeOnAction: true
			});
		} else {
			if (!checkVilniusAirportWarning(obj)) {
				addPopup({
					error: true,
					className: "noResults",
					reason: l10n.popup.warning,
					comment: l10n.searchResult.popup.noFlights,
					close_button: true,
					button: l10n.popup.close,
					removeOnAction: true
				});
			}
			objSearchForm.showFlightLabel();
		}
		delete obj.json;
	}
}


function DrawResults(obj){
	var self = this;
	this.obj = obj;
	this.obj.DateCreated = new Date();
	this.OneWay = true;
	this.TwoWays = false;
	this.allDirections = {};
	this.allDirectionsLength = 0;
	this.initDefaultStates();
	this.initDefaultFlights();
	this.DefaultParamsForTicket();
	this.initStructure();
	// информация по тарифам для тултипов и Тикетов
	try {
		this.flightTariffDetails = new FlightTariffDetails('results');
	} catch (err) {
		console.log('TariffDetails init problem', err);
	}
}
DrawResults.prototype.initDefaultStates = function(){
	var self = this;

	this.isPromoSearch = this.obj.json.proc||false;
	this.oFares = {
		max:0
	};
	var passengerTypesToRequest = getPassengerTypesFromParams(tw.params.p);
	for(var fareIndex=0, FaresLength=this.obj.json.frs.length; fareIndex < FaresLength; fareIndex++ ) {

		var curFare = this.obj.json.frs[fareIndex];

		if (curFare.prcInf && !curFare.prcInf.adtAmountWC && curFare.gdsType !== 'SCH') {
			if (typeof trackJs !== 'undefined') {
				trackJs.track('Fare has not adtAmountWC (no SCH); checkAllFares; referrer=' + window.readCookie('referrer') + '; url=' + window.location.pathname + window.location.hash);
			}
		}

		if(!this.oFares[curFare.id]) {
			// patch priceinfo to add commission for different amount types
			if(passengerTypesToRequest.ad > 1 || passengerTypesToRequest.cn > 0 || passengerTypesToRequest['in'] > 0){
				var totalADTPGCommission = 0;
				var totalCnnPGCommission = 0;
				var totalInfPGCommission = 0;

				if(curFare.pmtVrnts && curFare.pmtVrnts.transactions) {
					for(var transIdx = 0; transIdx < curFare.pmtVrnts.transactions.length; transIdx++){
						var curTransaction = curFare.pmtVrnts.transactions[transIdx];
						var rate = 1;

						if(curTransaction.cur != curFare.prcInf.cur){
							rate = this.obj.json.rates[curTransaction.cur + curFare.prcInf.cur];
						}

						if(curTransaction.adtC !== 0){
							totalADTPGCommission += curTransaction.adtC * rate;
						}

						if(curTransaction.cnnC !== 0){
							totalCnnPGCommission += curTransaction.cnnC * rate;
						}

						if(curTransaction.infC !== 0){
							totalInfPGCommission += curTransaction.infC * rate;
						}
					}
				}

				if (curFare.prcInf.adtAmountWC){
					curFare.prcInf.adtA = curFare.prcInf.adtAmountWC;
				}
				else {
					if (curFare.gdsType !== 'SCH') {
						if (typeof trackJs !== 'undefined') {
							trackJs.track('Fare has not adtAmountWC (no SCH); referrer=' + window.readCookie('referrer') + '; url=' + window.location.pathname + window.location.hash);
						}
					}
					curFare.prcInf.adtA += totalADTPGCommission;
				}

				if(passengerTypesToRequest.cn > 0){
					if(curFare.prcInf.cnnAmountWC){
						curFare.prcInf.cnnA = curFare.prcInf.cnnAmountWC;
					}
					else{
						curFare.prcInf.cnnA += totalCnnPGCommission;
					}
				}

				if(passengerTypesToRequest['in'] > 0){
					if(curFare.prcInf.infAmountWC){
						curFare.prcInf.infA = curFare.prcInf.infAmountWC;
					}
					else {
						curFare.prcInf.infA += totalInfPGCommission;
					}
				}

				//curFare.prcInf.amt = curFare.prcInf.adtA;
			}
			this.oFares[curFare.id] = {
				frKey: curFare.frKey,
				gdsInf: curFare.gdsInf,
				cur: !(curFare.prcInf && curFare.prcInf.cur) ? "RUB" : curFare.prcInf.cur,
				amt: !(curFare.prcInf && curFare.prcInf.amt) ? 0 : curFare.prcInf.amt,
				refund: true,
				gdsType: curFare.gdsType||'Empty',
				pltCrr: curFare.pltCrr||'Empty',
				agCnt: curFare.agCnt||'Empty',
				priceFreeze: curFare.priceFreeze,
				isLowcost: curFare.isLowcost,
				messages: curFare.infMsgs,
				ccFee: !(curFare.prcInf && curFare.prcInf.ccFee) ? 0 : curFare.prcInf.ccFee,
				markupFee: !(curFare.prcInf && curFare.prcInf.markupFee) ? 0 : curFare.prcInf.markupFee,
				isCharter: curFare.isCharter,
				prcInf: curFare.prcInf,
				adtTripcoins: curFare.adtTripcoins,
				cnnTripcoins: curFare.cnnTripcoins,
				infTripcoins: curFare.infTripcoins,

			};
			//sirena
			if(curFare.extId) {
				this.oFares[curFare.id].extId = curFare.extId;
			}
			if(curFare.frKeyRT){
				this.oFares[curFare.id].frKeyRT = curFare.frKeyRT;
			}
			if(curFare.infMsgs) { //случай с безместными перелётами
				for(var infMsgsIndex=0, infMsgsL = curFare.infMsgs.length; infMsgsIndex< infMsgsL; infMsgsIndex++) {
					if(curFare.infMsgs[infMsgsIndex].cd === "NO_REFUND") {
						this.oFares[curFare.id].refund = false;
					}
				}
			}
			//if reservation lock is available, put it into an encrypted link;
			if (curFare.rlk) {
				this.oFares[curFare.id].rlk = curFare.rlk;
			}
			//для начисления бонусов и использования промо
			this.oFares[curFare.id].noBonus = curFare.noBonus||false;
			this.oFares[curFare.id].denyPromoCodeUse = curFare.denyPromoCodeUse||false;
			//для конфирма
			if(this.oFares.max < curFare.id){
				this.oFares.max = curFare.id;
			}
		}
		for(var directionIndex=0, DirectionsLength=curFare.dirs.length ; directionIndex < DirectionsLength; directionIndex++ ){
			var curDirection = curFare.dirs[directionIndex];
			if(!curDirection.jrnTm && !curFare.noseats) {
				continue; //OTT-6533 баг с отсутствием времени перелёта в лоукостах которые можно купить (т.е. с местами) - не отображаем такие варианты
			}
			var directionInfo = {
				FareId: curFare.id,
				TripIds: [[]],
				FlightNumbers: [[]],
				Classes: [[]],
				Fics: [[]],
				TripsSeatAvl: [[]],
				ServiceClasses: [[]],
				StopTimes:[[]],
				JourneyTime:[],
				stars: 0,
				starsInfoCount: 0,
				sourceFare: curFare
			};
			directionInfo.JourneyTime.push(curDirection.jrnTm||0); //возможно будет в вариантах без мест
			var minStars = -2;
			for( var i = 0, TripsLength = curDirection.trps.length; i < TripsLength; i++ ){
				var curTripIndex = curDirection.trps[i];
				var curTrip = this.obj.json.trps[curTripIndex.id];
				if (curTrip.stars) {
					if (minStars === -2) {
						directionInfo.stars = minStars = curTrip.stars;
					} else if ( directionInfo.stars > curTrip.stars ) {
						directionInfo.stars = curTrip.stars;
					}
					directionInfo.starsInfoCount++;
				}
				/*if (curTrip.oprdBy) {
				 directionInfo.OperatedBy[0] =curTrip.oprdBy;
				 }*/
				if (i === 0) {
					directionInfo.AK = curTrip.airCmp;
					if (directionInfo.AK === 'SU') {
						directionInfo.OPAK = ref.Airlines[curTrip.oprdBy];
					}
				} else {
					directionInfo.StopTimes[0].push(curTripIndex.stpTm);
				}

				if(curFare.noseats) { //перезаписываем класс (некоорые безместные отдают пустой объект, а не строковое значение класса)
					curTripIndex.srvCls = ""; //this.obj.cs
					curTripIndex.cls = "";
				}

				directionInfo.TripIds[0].push(curTripIndex.id);
				directionInfo.FlightNumbers[0].push(curTrip.fltNm);
				directionInfo.Classes[0].push(curTripIndex.cls);
				directionInfo.Fics[0].push(curTripIndex.fic);
				if(typeof curTripIndex.stAvl == "number") {
					directionInfo.TripsSeatAvl[0].push(curTripIndex.stAvl);
				} else {
					directionInfo.TripsSeatAvl[0].push(0);
				}
				directionInfo.ServiceClasses[0].push(curTripIndex.srvCls||"");
			}
			if (!this.allDirections[curDirection.id]) {
				this.allDirections[curDirection.id] = [];
				this.allDirectionsLength++;
			}
			this.allDirections[curDirection.id].push(directionInfo);
			//}
			//free
			curDirection=null;
			directionInfo=null;
		}
	}
	this.allFlights =[];
	for (var i = 0, FirstL = this.allDirections[0].length; i < FirstL; i++) {
		var Fare = this.allDirections[0][i];
		var FareId = Fare.FareId;
		if (this.allDirections[1]) {
			//проверка на бонусный трип
				var bonus = true;
			for (var j = 0, SecondL = this.allDirections[1].length; j < SecondL; j++) {
				var SecondFare = this.allDirections[1][j];
				if (SecondFare.FareId != FareId) {
					continue;
				}
				bonus = false;
				 //дополняем второй перелёт
				var objFare = self.CloneFare( Fare, SecondFare, 1 );

				if (this.allDirections[2]) {
					for (var k = 0, ThirdL = this.allDirections[2].length; k < ThirdL; k++) {
						var ThirdFare = this.allDirections[2][k];
						if (ThirdFare.FareId != FareId) {
							continue;
						}
						 // дополняем третий перелёт
						var objFare2 = self.CloneFare( objFare, ThirdFare, 2 );

						if (this.allDirections[3]) {
							for (var t = 0, FourthL = this.allDirections[3].length; t < FourthL; t++) {
								var FourthFare = this.allDirections[3][t];
								if (FourthFare.FareId != FareId) {
									continue;
								}
								 //дополняем четвертый перелёт
								var objFare3 = self.CloneFare( objFare2, FourthFare, 3 );
								//this.AddFlightField(objFare3);
								this.allFlights.push(objFare3);
							}
						} else {
							//this.AddFlightField(objFare2);
							this.allFlights.push(objFare2);
						}
					}
				} else {
					//this.AddFlightField(objFare);
					this.allFlights.push(objFare);
				}
			}
			if(bonus){
				this.allFlights.push(Fare);
			}
		} else {
			this.allFlights.push(Fare);
		}
	}
	//если есть бонусные направления, уменьшаем кол-во дирекшинов
	if(this.allDirectionsLength > this.obj.directions.length) {
		this.allDirectionsLength = this.obj.directions.length;
	}
	if (this.allDirectionsLength>1) {
		this.OneWay = false;
	}
	if(this.allDirectionsLength==2){
		this.TwoWays = true;
	}
	this.DefaultAllFlights = this.allFlights;
	this.initEmptyArrays();
};
DrawResults.prototype.CloneFare = function(Fare1, Fare2, iIndex){
	var objFare = {};
	objFare.AK = Fare1.AK;
	objFare.OPAK = Fare1.OPAK;
	//objFare.AmountFare =Fare1.AmountFare;
	objFare.FareId         = Fare1.FareId;
	objFare.TripIds        = CloneArray(Fare1.TripIds);
	objFare.FlightNumbers  = CloneArray(Fare1.FlightNumbers);
	objFare.Classes        = CloneArray(Fare1.Classes);
	objFare.Fics        = CloneArray(Fare1.Fics);
	objFare.TripsSeatAvl   = CloneArray(Fare1.TripsSeatAvl);
	objFare.ServiceClasses = CloneArray(Fare1.ServiceClasses);
	objFare.StopTimes      = CloneArray(Fare1.StopTimes);
	objFare.JourneyTime    = CloneArray(Fare1.JourneyTime);
	objFare.stars          = Fare1.stars;
	objFare.starsInfoCount = Fare1.starsInfoCount;

	objFare.TripIds[iIndex]        = Fare2.TripIds[0];
	objFare.FlightNumbers[iIndex]  = Fare2.FlightNumbers[0];
	objFare.Classes[iIndex]        = Fare2.Classes[0];
	objFare.Fics[iIndex]           = Fare2.Fics[0];
	objFare.TripsSeatAvl[iIndex]   = Fare2.TripsSeatAvl[0];
	objFare.ServiceClasses[iIndex] = Fare2.ServiceClasses[0];

	/*не добавляем данные если это бонусные направления, для отображения и правильного подсчета, сортировок*/
	/*еслинет бонусных направлений*/
	if (this.allDirectionsLength == this.obj.directions.length) {
		objFare.StopTimes[iIndex]   = Fare2.StopTimes[0];
		objFare.JourneyTime[iIndex] = Fare2.JourneyTime[0];
		objFare.stars               = Fare2.stars;
		objFare.starsInfoCount      = Fare2.starsInfoCount;
	}
	objFare.sourceFare = Fare1.sourceFare;

	return objFare;
};
/*DrawResults.prototype.AddFlightField = function(Flight){
	Flight.direct =1;
	for(var j=0, TL = Flight.TripIds.length;j<TL;j++){
		if(Flight.TripIds[j].length >1){
			Flight.direct=0;
		}
	}
	//для подсчета АК с прямыми рейсами
		if(Boolean(Flight.direct) && !AKDirectFlightsCount[Flight.AK]) {
			AKDirectFlightsCount[Flight.AK] = {};
			AKDirectCount++;
		}
	//время в пути (flight time + stops time)
	var time=0;
	for(var j=0,TL=Flight.JourneyTime.length;j<TL;j++){
		time+= DurationAPIToMinutes(Flight.JourneyTime[j]);
	}
	Flight.totalJourneyTime = time;

	//нахождение мин-макc времени и цены
		if (Flight.totalJourneyTime < this.MinTime) {
			this.MinTime = Flight.totalJourneyTime;
		}
		if (Flight.AmountFare < this.MinPrice) {
			this.MinPrice = Flight.AmountFare;
		}
};*/
DrawResults.prototype.initDefaultFlights = function(){
	var self = this;
	this.stat = {
		"minPrice":          1e9,
		"maxPrice":          0,
		"minTime":           1e9,
		"maxTime":           0,
		"minStars":          100,
		"maxStars":          0,
		"directMinPrice":    1e9,
		"refundFlightCount": 0
	};

	//для подсчета АК с прямыми рейсами
		var AKDirectFlightsCount = {};
		var AKDirectCount = 0;
		var MaxDirectPriceCoef=0;

	var tempArray = [];
	for (var i = 0, FL = this.allFlights.length; i < FL; i++) {
		var curFlight = this.allFlights[i];

		/*if(curFlight.AK === "SU" && tw.params.promocode === "VISA2015") {
			curFlight.removePromo = true; //https://onetwotripdev.atlassian.net/browse/OTT-4758 remove or allow promocode for SU
		}*/

		//мин кол-во мест на весь путь
		curFlight.SeatAvl = MinSeatsAvl(curFlight.TripsSeatAvl);
		//мин мест для каждого направления
		curFlight.minDirSeatAvl=[];
		for (Sindex = 0, Slength = curFlight.TripsSeatAvl.length; Sindex < Slength; Sindex++) {
			curFlight.minDirSeatAvl[Sindex] = MinSeatsAvl(curFlight.TripsSeatAvl[Sindex]);
		}
		//сразу выбрасываем
		//если выбрано кол-во мест
		if(this.selectedSeats && curFlight.SeatAvl < this.selectedSeats) {
			continue;
		}
		//если выбраны только возвратные - выкидываем, считаем кол-во рефандов
		if (this.oFares[curFlight.FareId].refund) {
			this.stat.refundFlightCount++;
		}

		if(this.ShowRefundable && !this.oFares[curFlight.FareId].refund) {
			continue;
		}

		var curFlightPrice = this.oFares[curFlight.FareId].amt;

		if(this.oFares[curFlight.FareId].ccFee){
			curFlightPrice += this.oFares[curFlight.FareId].ccFee;
		}
		if(this.oFares[curFlight.FareId].markupFee){
			curFlightPrice += this.oFares[curFlight.FareId].markupFee;
		}
		curFlight.denyPromoCodeUse = this.oFares[curFlight.FareId].denyPromoCodeUse;
		curFlight.AmountFare = (this.oFares[curFlight.FareId].cur==tw.currency)? curFlightPrice : curFlightPrice * this.obj.json.rates[this.oFares[curFlight.FareId].cur+''+tw.currency];
		if(this.isPromoSearch && !curFlight.removePromo) {
			if(this.obj.json.proc.cur!=tw.currency){
				if(parseInt(this.obj.json.proc.maxPercent)){
					this.obj.json.proc.maxPercent = this.obj.json.proc.maxPercent * this.obj.json.rates[this.obj.json.proc.cur+''+tw.currency];
				}
				if(this.obj.json.proc.amt){
					this.obj.json.proc.amt = this.obj.json.proc.amt * this.obj.json.rates[this.obj.json.proc.cur+''+tw.currency];
				}
			}

			if(this.obj.json.proc.percent){
				curFlight.PromoAmount = curFlight.AmountFare * this.obj.json.proc.percent / 100;
				curFlight.PromoPercent = this.obj.json.proc.percent;
				curFlight.PromoMaxPercent = this.obj.json.proc.maxPercent;
				if(parseInt(this.obj.json.proc.maxPercent) && curFlight.PromoAmount > this.obj.json.proc.maxPercent){
					curFlight.PromoAmount = this.obj.json.proc.maxPercent;
				}
			}
			else{
				curFlight.PromoAmount = this.obj.json.proc.amt;
			}

			if(curFlight.PromoAmount > curFlight.AmountFare){
				curFlight.PromoAmount = curFlight.AmountFare;
			}


			if (!curFlight.denyPromoCodeUse) {
				curFlight.PromoAmountFare = curFlight.AmountFare - curFlight.PromoAmount;
			}
		}

		//прямой перелёт
			curFlight.direct =1;
			for(var j=0, TL = this.allDirectionsLength;j<TL;j++){
				//проверяем или кол-во трипов >1 или есть ли остановки на 1 трипе и на 2 трипе если он есть
				if(curFlight.TripIds[j].length > 1 || this.obj.json.trps[curFlight.TripIds[j][0]].stps || (curFlight.TripIds[j][1] && this.obj.json.trps[curFlight.TripIds[j][1]].stps) ){
					curFlight.direct=0;
					break;
				}
				/*if(curFlight.TripIds[j].length >1){
					curFlight.direct=0;
					break;
				}*/
			}
		//безместный вариант
		if(curFlight.sourceFare.noseats) {
			curFlight.noseats = true;
		}
		//комбинированный перелёт
			curFlight.combined = (curFlight.sourceFare.frKeyRT)? 1 : 0;
		//чартер и лоукост
		curFlight.isCharter = curFlight.sourceFare.isCharter;
		curFlight.isLowcost = curFlight.sourceFare.isLowcost;


		//для подсчета АК с прямыми рейсами
			if(curFlight.direct && !AKDirectFlightsCount[curFlight.AK]) {
				//лоукост не считаем
				if(curFlight.AK != "VY" && curFlight.AK != "4U" && curFlight.AK != "JK"){ //Vueling Airlines-Germanwings-Spanair
					AKDirectFlightsCount[curFlight.AK] = {};
					AKDirectCount++;
				}
			}
		//не учитываем безместные варианты в статистике и пишем им макс стоимость и время в пути для дальнейшей установки максимальных коэффициентов, чтобы сортировались всегда последние
		if(curFlight.noseats) {
			curFlight.AmountFare = 1e9;
			curFlight.totalJourneyTime = 1e9;
		} else {
			//время в пути (flight time + stops time)
			var time=0;
			for(var j=0,TL=curFlight.JourneyTime.length;j<TL;j++){
				time+= DurationAPIToMinutes(curFlight.JourneyTime[j]);
			}
			curFlight.totalJourneyTime = time;
			var timeInAir = 0, stoptimes = String(curFlight.StopTimes).split(',');
			for(var si=0,SL=stoptimes.length;si<SL;si++){
				timeInAir+= DurationAPIToMinutes(stoptimes[si]);
			}
			curFlight.totalJourneyTimeInAir = timeInAir;

			//нахождение мин-макc времени, цены, звездатости (для фильтров-слайдера и статистики)
				if (curFlight.totalJourneyTime < self.stat.minTime) {
					self.stat.minTime = curFlight.totalJourneyTime;
				}
				if (curFlight.totalJourneyTime > self.stat.maxTime) {
					self.stat.maxTime = curFlight.totalJourneyTime;
				}
				if (curFlight.AmountFare < self.stat.minPrice) {
					self.stat.minPrice = curFlight.AmountFare;
					self.stat.minSourceFare = curFlight.sourceFare;
				}
				if (curFlight.AmountFare > self.stat.maxPrice) {
					self.stat.maxPrice = curFlight.AmountFare;
				}
				if (curFlight.AmountFare < self.stat.directMinPrice && curFlight.direct) {
					self.stat.directMinPrice = curFlight.AmountFare;
				}
			//звездатость flight
				//if(curFlight.starsInfoCount){
					curFlight.stars = parseFloat(curFlight.stars);
				//}
				delete curFlight.starsInfoCount;
				if (curFlight.stars < self.stat.minStars) {
					self.stat.minStars = curFlight.stars;
				}
				if (curFlight.stars > self.stat.maxStars) {
					self.stat.maxStars = curFlight.stars;
				}
		}

		tempArray.push(curFlight);
	}
	this.allFlights = tempArray;
	var noseatFlightCount = 0;

	//mark1
	//для фильтрации АК с пересадками если у них есть прямые и дешевле
	var DirectAKFlights = {};
	tempArray = [];
		for(var i=0,FL=this.allFlights.length;i<FL;i++) {
			var curFlight = this.allFlights[i];
			 //пишем коэф-нты для фаре
				//if(!curFlight.noseats) {
					var coefP = parseFloat( (this.stat.minPrice/curFlight.AmountFare).toFixed(5) );

					curFlight.coefP = isNaN(coefP) ? 0 : coefP;

					curFlight.coefT = parseFloat( (this.stat.minTime/curFlight.totalJourneyTime + this.stat.minPrice/curFlight.AmountFare*0.07).toFixed(5) );
					//curFlight.coefM = ((Number(curFlight.coefP) + Number(curFlight.coefT))/2).toFixed(5);
			/*	} else { //для безместных вариантов
					curFlight.coefP = 0.001; //переписывая коэффициенты эти варианты в выборку prefered не попадают
					curFlight.coefT = 0.001;
				}*/

			if (!allVariants) {
				//убираем из выборки если коэф ниже ХХ суммарный/2 - незачем дальше бегать и проверять что-то
				/*if (curFlight.coefM < 0.35) {
					continue;
				}*/

				//для фильтрации перелетов see: mark1
				//находим максимальный PriceCoef прямых перелётов АК и макс коеф для всех прямых перелётов
				if (Boolean(curFlight.direct)) {
					if (!DirectAKFlights[curFlight.AK]) {
						DirectAKFlights[curFlight.AK] = {
							coefP: curFlight.coefP
						};
					}
					if (DirectAKFlights[curFlight.AK].coefP < curFlight.coefP) {
						DirectAKFlights[curFlight.AK].coefP = curFlight.coefP;
					}
					//лоукост не учитываем для подсчета макс коэф для прямых
					if (curFlight.AK != "VY" && curFlight.AK != "4U" && curFlight.AK != "JK") { //Vueling Airlines-Germanwings-Spanair
						if (curFlight.coefP > MaxDirectPriceCoef) {
							MaxDirectPriceCoef = curFlight.coefP;
						}
					}
				}
			}
			tempArray.push(curFlight);
		}

	this.allFlights = tempArray;
		//удаляем перелёты
		tempArray = [];
		for(var i=0,FL=this.allFlights.length;i<FL;i++) {
			var curFlight = this.allFlights[i];

			if (!allVariants) {
				//убираем дорогие с пересадками если есть минимум две АК с прямыми перелётами
				/*if (!Boolean(curFlight.direct) && AKDirectCount > 1 && curFlight.coefP < MaxDirectPriceCoef) {
					continue;
				}*/
				//mark1
				//удаляем дорогие пересадочные перелёты если есть дешевые той же АК
				if (!Boolean(curFlight.direct) && DirectAKFlights[curFlight.AK] && DirectAKFlights[curFlight.AK].coefP > curFlight.coefP) {
					continue;
				}

				//для нахождения макс сидений и их отрисовки
				if (this.minSeats < curFlight.SeatAvl) {
					this.minSeats = curFlight.SeatAvl;
				}
			}

			//безместный вариант
			if(curFlight.noseats) {
				noseatFlightCount++;
			}

			//создаем объект перелетов с индексами
			//curFlight.FlightIndex = i;
			this.oFlights[curFlight.FlightIndex] = curFlight;

			//кол-во АК, участвующих  в перелёте
				curFlight.TripsAK = [];
				curFlight.TripsAKFilter = [];
				curFlight.EveryDirectionAK = [];
			//конкретные АК в трипе
				curFlight.EveryTripAK = [];
				var AKCount = 0;
				var trpsCount =0;
				var AirlinesList = {};
				var AirlinesListFilter = {};
				AirlinesListFilter[curFlight.AK] =1;
				curFlight.TripsAKFilter.push(curFlight.AK);
				for(var j=0, TL = this.allDirectionsLength; j<TL;j++){
					var curTripArr = curFlight.TripIds[j];
					curFlight.EveryDirectionAK.push(this.obj.json.trps[curTripArr[0]].airCmp);
					curFlight.EveryTripAK[j] = [];

					for(var k=0, subTL = curTripArr.length;k<subTL;k++){
						trpsCount++;
						var curTrip = this.obj.json.trps[curTripArr[k]];
						//в раных трипах могут быть разные АК и oprtBy
						if(curTrip.airCmp != curFlight.AK && !curTrip.oprdBy) {
							AKCount++;
							//повторные АК не добавляем
							if (!AirlinesList[curTrip.airCmp]) {
								curFlight.TripsAK.push(curTrip.airCmp);
								AirlinesList[curTrip.airCmp] = 1;
							}
						}
						if(curTrip.oprdBy && curTrip.oprdBy != curFlight.AK) {
							//считаем кол-во ак вообще на перелёте, неважно была такая oprdBy или нет
							AKCount++;
							//повторные АК не добавляем
							if (!AirlinesList[curTrip.oprdBy]) {
								curFlight.TripsAK.push(curTrip.oprdBy);
								AirlinesList[curTrip.oprdBy] = 1;
							}
						}
						if(curTrip.oprdBy) {
							curFlight.EveryTripAK[j].push(curTrip.oprdBy);
						} else {
							curFlight.EveryTripAK[j].push(curTrip.airCmp);
						}
						//for filter
						if(!AirlinesListFilter[curTrip.airCmp]) {
							curFlight.TripsAKFilter.push(curTrip.airCmp);
							AirlinesListFilter[curTrip.airCmp] = 1;
						}
					}
				}
				//если меньше - чем трипов значит есть перелеты которые осуществляет сам продавец, т.е. первая АК - добавляем её
				if(AKCount < trpsCount) {
					curFlight.TripsAK.push(curFlight.AK);
				}
			//end
			this.initFilterIndexes(curFlight);
			tempArray.push(curFlight);
		}
	this.allFlights = tempArray;

	//no flights to buy - only no seat schedule
	if(noseatFlightCount === this.allFlights.length) {
		kmqRecord({name:"FaresNoSeats", obj:tw.searchFlight, prefix: 'FNS'});
		addPopup({
			error: true,
			className: "noResults",
			reason: l10n.popup.warning,
			comment: l10n.searchResult.popup.noSeats,
			close_button: true,
			button: l10n.popup.close,
			removeOnAction: true
		});
	}
	//free
		tempArray = null;
		DirectAKFlights=null;
		tempObj=null;
		AKDirectFlightsCount=null;
		AKDirectCount=null;
		MaxDirectPriceCoef=null;
};
DrawResults.prototype.initEmptyArrays = function(){
	var self = this;
	this.FDirections=[];
	for(var DirectionIndex=0;DirectionIndex<this.allDirectionsLength;DirectionIndex++){
		this.FDirections[DirectionIndex] = {
			DepPoints: {},
			DepTimes: {
				morningday: {list:[]},
				eveningnight: {list:[]},
				morning: {list:[]},
				day: {list:[]},
				evening: {list:[]},
				night: {list:[]}
			},
			ArrPoints: {},
			ArrTimes: {
				morningday: {list:[]},
				eveningnight: {list:[]},
				morning: {list:[]},
				day: {list:[]},
				evening: {list:[]},
				night: {list:[]}
			}
		};
	}
	this.allFlightArrayIndex = [];
	this.DirectFlightArrayIndex = [];
	this.oFlights = {};
	this.AKlist = {count:0, list: {}};
	this.currentViewDirectFlightsCount = 0;
	this.currentViewTransportFlightsCount = 0;
	this.minSeats = 1;
	this.SelectedDirectRoutes = false;
	this.ShowRefundable = this.ShowRefundable||false;
	//переписываем индексы изначальной выборки - например после удаления определенного тарифа
	for(var i=0,FL=this.DefaultAllFlights.length;i<FL;i++){
		this.DefaultAllFlights[i].FlightIndex = i;
	}
	this.allFlights = CloneArray(this.DefaultAllFlights);
};
DrawResults.prototype.ReloadSearchResult = function(){
	var self = this;
	var data = objAvia.parseKey(self.obj.getKey());
	data = objAvia.addDataToRequestsList(data);
	delete data.json;
	objAvia.changeRequest(data);
};
DrawResults.prototype.initFilterIndexes = function(Flight){
	var self = this;
	//считаем кол-во АК + для статистики смотрим звезды мин-макс
		if(!this.AKlist.list[Flight.AK]) {
			this.AKlist.list[Flight.AK] = 1;
			this.AKlist.count++;
		}
		if(Boolean(Flight.direct)){
			this.DirectFlightArrayIndex.push(Flight.FlightIndex);
			this.currentViewDirectFlightsCount++;
		} else {
			this.currentViewTransportFlightsCount++;
		}
	this.allFlightArrayIndex.push(Flight.FlightIndex);

	for(var i=0,DL=this.FDirections.length;i<DL;i++) {
		var curFDir = this.FDirections[i];
		var FirstDirectionTrip = Flight.TripIds[i][0];
		var FDtrip = this.obj.json.trps[FirstDirectionTrip];
		var LastDirectionTrip = Flight.TripIds[i][Flight.TripIds[i].length - 1];
		var LDtrip = this.obj.json.trps[LastDirectionTrip];

		//departure
		if(!curFDir.DepPoints[FDtrip.from]) {
			curFDir.DepPoints[FDtrip.from] = {list:[]};
		}
		curFDir.DepPoints[FDtrip.from].list.push(Flight.FlightIndex);

		//arrival
		if(!curFDir.ArrPoints[LDtrip.to]) {
			curFDir.ArrPoints[LDtrip.to] = {list:[]};
		}
		curFDir.ArrPoints[LDtrip.to].list.push(Flight.FlightIndex);

		var DepartureHours = parseInt(FDtrip.stTm.substring(0,2),10);
		var ArrivalHours = parseInt(LDtrip.endTm.substring(0,2),10);
		if (5 <= DepartureHours && DepartureHours < 16) {
			curFDir.DepTimes['morningday'].list.push(Flight.FlightIndex);
		} else if (16 <= DepartureHours || DepartureHours < 5) {
			curFDir.DepTimes['eveningnight'].list.push(Flight.FlightIndex);
		}
		if (5 <= ArrivalHours && ArrivalHours < 16) {
			curFDir.ArrTimes['morningday'].list.push(Flight.FlightIndex);
		} else if (16 <= ArrivalHours || ArrivalHours < 5) {
			curFDir.ArrTimes['eveningnight'].list.push(Flight.FlightIndex);
		}

		if (5 <= DepartureHours && DepartureHours < 9) {
			curFDir.DepTimes['morning'].list.push(Flight.FlightIndex);
		} else if (9 <= DepartureHours && DepartureHours < 16) {
			curFDir.DepTimes['day'].list.push(Flight.FlightIndex);
		} else if (16 <= DepartureHours && DepartureHours < 21) {
			curFDir.DepTimes['evening'].list.push(Flight.FlightIndex);
		} else if (21 <= DepartureHours || DepartureHours < 5) {
			curFDir.DepTimes['night'].list.push(Flight.FlightIndex);
		}

		if (5 <= ArrivalHours && ArrivalHours < 9) {
			curFDir.ArrTimes['morning'].list.push(Flight.FlightIndex);
		} else if (9 <= ArrivalHours && ArrivalHours < 16) {
			curFDir.ArrTimes['day'].list.push(Flight.FlightIndex);
		} else if (16 <= ArrivalHours && ArrivalHours < 21) {
			curFDir.ArrTimes['evening'].list.push(Flight.FlightIndex);
		} else if (21 <= ArrivalHours || ArrivalHours < 5) {
			curFDir.ArrTimes['night'].list.push(Flight.FlightIndex);
		}
	}
};
DrawResults.prototype.initStructure = function(){

	tw.layout_results = $('#layout_results')[0];

	$("#avia_structure",tw.layout_results).remove();
	$(tw.layout_results).css({"display":"block"}).removeClass('invisible');

	//currencySwitch
		var oCurList = [];
	/*
		var defCur;
		switch(tw.language){
			case "uk-ua":
				defCur = "UAH";
				break;
			case "ru-ua":
				defCur = "UAH";
				break;
			case "az":
				defCur = "AZN";
				break;
			case "tr":
				defCur = "TRY";
				break;
			default:
				defCur = "RUB";
				break;
		}
		if(tw.language == 'en-gb') {
			oCurList = ["GBP"];
		} else if(tw.language == 'en-us') {
			oCurList = ["USD"];
		} else if(tw.language == 'es' || tw.language == 'de' || tw.language == 'en-ie') {
			oCurList = ["EUR"];
		} else if(tw.language == "ru" || tw.language.indexOf('ua') > -1){
			oCurList = [defCur];
		} else {
			oCurList = [defCur,"USD","EUR"];
		}
	*/

	var isSales = window.isSales || false;
	$.tmpl($("#tmpl_ResultStructure").trim(), {"currencyList": oCurList, "isSales": isSales, "cs": this.obj.cs}).prependTo( tw.layout_results );
	if(!isSales) {
		this.FlightPriceInformation = $('.FlightPriceInformation', tw.layout_results)[0];
		//выбор первого класса
		this.FlightClassBlock = $('.classSearch_wrapper', this.FlightPriceInformation)[0];
		var needFirst = false;
		if(this.obj.cs == "F") {
			needFirst = true;
		} else {
			var firstClassPointsArray = ['TH','US','AE','CA'];
			for(var i=0, DL = this.obj.directions.length; i<DL; i++) {
				var curDir = this.obj.directions[i];
				var codeFrom = ref.getCountryCode(curDir.from);
				var codeTo = ref.getCountryCode(curDir.to);
				if($.inArray(codeFrom,firstClassPointsArray) > -1 || $.inArray(codeTo,firstClassPointsArray) > -1) {
					needFirst = true;
					break;
				}
			}
		}
		if(!needFirst) {
			$('div[cs="F"]', this.FlightClassBlock).addClass('invisible');
			$('div[cs="B"]', this.FlightClassBlock).removeClass('d_middle').addClass('d_last').append('<div class="button_shadow_lr"></div>');
		} else {
			$('.tTcom', this.FlightPriceInformation).empty().addClass('wide');
		}
	}

	PlanePositioning();
	this.filter = $('#LuckyMe')[0];

	//this.initRefundSelection();
	this.initCurrencySelection();
	this.initFilterObject();
	this.initFilter();
	this.initOperatedAKList();
	//this.initSeats();

	this.ResultTable = $('.ResultTableWrapper')[0];
	this.FilterResult = $('.FilterResult')[0];
	this.FlightsBlock = $('ul',this.FilterResult)[0];
	this.AKFlightInformation = $('.FlightsByAKBlock')[0];
	this.QuickSandBlock = $('#QuickSandBlock')[0];

	this.initSlider();
	this.initFlightsDifficulties();
	//если есть и прямые и с пересадками
		/*if(this.allFlightArrayIndex.length != this.DirectFlightArrayIndex.length){
			tw.ticketParams.different = 1;
		}*/

	//если 1 АК и только прямые или с пересадками, то выводим сразу развернутый билет и не показываем фильтр
	var madeClickEvent = false;
	this.singleAK = false;
	if (this.AKlist.count>1 || (this.AKlist.count==1 && this.currentViewTransportFlightsCount !==0 && this.currentViewDirectFlightsCount !==0) ) {
		$(this.filter).removeClass('invisible');
		this.initDrawPreferedFlights();
		this.FlightsToShowIndex = this.allFlightArrayIndex;
		this.FilterClicked = true;
		this.GetFlightsToShow();
	} else {
		this.singleAK = true;
		//error1-refact with tw data while fade->MakeClickEvent
		$(this.ResultTable).css({'visibility':'hidden'});
		this.FlightsToShow = this.allFlights;
		madeClickEvent = true;
		this.MakeClickEvent();
	}
	if(!this.noseatresult) {
		this.initDealSubscribes();
		this.initAdviser();
		this.addNewDesignLink();
	}

	if(tw.source && !this.redraw) {
		if(this.AKlist.list[tw.source.ak]){
			this.FlightsToShow = this.allFlights;
			//сразу конфирм
			if (tw.source.fn) {
				var flightsDir = tw.source.fn.split("-");
				var FlightsNumbersArray = [];
				for (var FlightsDirectionIndex = 0, FDlength = flightsDir.length; FlightsDirectionIndex < FDlength; FlightsDirectionIndex++) {
					FlightsNumbersArray[FlightsDirectionIndex] = [];
					var flightsNum = flightsDir[FlightsDirectionIndex].split(",");
					for( var FlightsIndex =0, FlightsLength = flightsNum.length;FlightsIndex<FlightsLength;FlightsIndex++){
						var curFlightNum = flightsNum[FlightsIndex];
						FlightsNumbersArray[FlightsDirectionIndex].push( curFlightNum );
					}
				}
				var ConfirmFlight;
				for (var FlightIndex = 0, FlightsLength = this.allFlights.length; FlightIndex < FlightsLength; FlightIndex++) {
					var curFlight = this.allFlights[FlightIndex];
					if( String(curFlight.FlightNumbers) == String(FlightsNumbersArray) && curFlight.AK == tw.source.ak) {
						ConfirmFlight = curFlight;
						break;
					}
				}
				if(ConfirmFlight){
					setTimeout(function(){
						FareConfirmation({
							FlightIndex: ConfirmFlight.FlightIndex,
							passengerCount: tw.source.pas,
							autoChoose: 1
						});
					},700)
				}
			} else if (!madeClickEvent) {
				madeClickEvent = true;
				this.MakeClickEvent();
			}
		} else {
			tw.avia.popup.airline();
			window.location.hash = window.location.hash.split('|')[0];
			delete tw.source;
		}
	}

	if (tw.partner) {
		$('.tripcoins_info.advise').remove();
	}
};
DrawResults.prototype.RedrawResults = function(redraw){
	$(document.body).trigger("redrawResults");
	this.redraw = (redraw!=null)?redraw:true;
	this.commercialShown = false;
	this.initEmptyArrays();
	this.initDefaultFlights();
	if(this.allFlights.length>0){
		this.initStructure();
	}
};

DrawResults.prototype.toggleSliderState = function(){
	if (this.FilteredFlightsToShow) {
		this.sliderIsHidden = Boolean(this.FilteredFlightsToShow.length);
	}
};

DrawResults.prototype.initSlider = function(){
	var self = this;
	this.$FlightSliderBlock = $('.FlightSliderWrapper');
	//если только прямые перелёты или только 1 АК
	if(this.AKlist.count==1 || this.allFlightArrayIndex.length == this.DirectFlightArrayIndex.length) {
		this.hideSlider = true;
	} else {
		this.hideSlider = false;
	}
	if(this.hideSlider) this.$FlightSliderBlock.addClass('invisible');

	this.$FlightSlider = $('#slide_filter');
	//sliderInfo
	this.showSliderValues = !(this.allFlights.length>500)
	this.$FlightSlider.slider({
		value:100,
		min: 1,
		max: 100,
		step: 1,
		slide: function( event, ui ) {
			self.currentSliderTime = ui.value;
			self.initSliderValues();
		},
		stop: function(event,ui){
			if(self.QuickSandProcess){
				//$(self.FlightSlider).slider({value:self.sliderTime});
			} else if(self.sliderTime != ui.value) {
				self.sliderTime = ui.value;
				self.WriteCoefs();
				self.SortFlightsBlock();
				self.initSliderValues(1);
				kmqRecord({name: 'use_slider_timemoney'});
			}
		}
	});
	this.sliderTime = this.$FlightSlider.slider("value");
	this.currentSliderTime = this.sliderTime;
	this.$FlightSlider.slider("enable");
	if(browser.mobile && !this.hideSlider) {
		this.$FlightSlider.slider({step:25});
		$('.steps',this.$FlightSliderBlock).removeClass('invisible');
	}
	//двигаем в середину если только на выдаче не все прямые
		/*if(this.allFlightArrayIndex.length != this.DirectFlightArrayIndex.length) {
			this.$FlightSlider.slider( "option", "value", 50 );
			this.sliderTime = this.$FlightSlider.slider("value");
		}*/
	//init sliderInfo
		if(this.showSliderValues){
			this.sliderArrayValues = [];
			var tempValues = false;
			var diffValues = false;

			for(var SliderIndex = 1; SliderIndex <= 100;SliderIndex++ ) {
				var TimeonDirect = -1;
				for(var i=0,FL=this.allFlights.length;i<FL;i++) {
					var curFlight = this.allFlights[i];
					if(!!curFlight.direct && !curFlight.noseats) { //второе условие для безместных вариантов - макс коефициент ставим
						if(TimeonDirect === -1) {
							TimeonDirect = curFlight.coefT;
						}
						curFlight.coefS = parseFloat( (curFlight.coefP*SliderIndex/100 + TimeonDirect*(100-SliderIndex)/100).toFixed(5) ) ;
					} else {
						curFlight.coefS = parseFloat( (curFlight.coefP*SliderIndex/100 + curFlight.coefT*(100-SliderIndex)/100).toFixed(5) );
					}
				}
				var bestFlight = this.allFlights.sort(self.SortBySlider)[0];
				var flightData = {amount: bestFlight.AmountFare, timeto: bestFlight.JourneyTime[0], FlightIndex: bestFlight.FlightIndex};
				if(!tempValues) {
					tempValues = flightData;
				}
				if(tempValues.amount != flightData.amount || tempValues.timeto != flightData.timeto || (flightData.timefrom && tempValues.timefrom != flightData.timefrom)){
					diffValues = true;
				}
				if(tw.ticketParams.round) {
					flightData.timefrom = bestFlight.JourneyTime[1];
				}
				this.sliderArrayValues.push(flightData);
			}
			this.showSliderValues = !!diffValues;
			this.initSliderValues(1);
		}
};
DrawResults.prototype.initSliderValues = function(refresTooltipValue){
	if(this.showSliderValues) {
		var curEl = this.sliderArrayValues[this.currentSliderTime-1];
		var timeto = DurationTimeStringPartFull(curEl.timeto);
		var price = l10n.searchResult.filters.priceFrom + ' ' + formatMoney(curEl.amount);
		if(tw.language == 'az') {
			price = formatMoney(curEl.amount) + l10n.searchResult.filters.priceFrom + "&thinsp;" + l10n.currency[tw.currency].Symbol;
		}
		if(curEl.timefrom) {
			var timefrom = DurationTimeStringPartFull(curEl.timefrom);
		}
		var text = l10n.searchResult.block.titles[4] + ' ' + l10n.searchResult.block.there.toLowerCase() + ' ' + timeto;
		if(timefrom) {
			text+= '| ' + l10n.searchResult.block.titles[4] + ' ' + l10n.searchResult.block.back.toLowerCase() + ' ' + timefrom;
		}
		text+= '| <div class="money-formatted numbers">' + price + '</div>';
		if(refresTooltipValue){
			$('.ui-slider-handle', this.$FlightSliderBlock)
				.attr('title', text)
				.tooltip();
		} else {
			text = text.replace(new RegExp("\\| ",'g'),"<br/>");
			$('#tooltip').html(text);
		}

	}
};
DrawResults.prototype.SortByPrice = function(a,b){
	return b.coefP-a.coefP;
};
DrawResults.prototype.SortByTime = function(a,b){
	return b.coefT-a.coefT;
};
DrawResults.prototype.SortByFareId = function(a,b){
	return a.FareId - b.FareId;
};
DrawResults.prototype.SortBySlider = function(a,b){
	//return b.coefS - a.coefS;
    if(a.coefS == b.coefS){
        if(a.stars == b.stars){
            return b.FlightIndex - a.FlightIndex;
        }
		return b.stars - a.stars;
    }
    return b.coefS - a.coefS;
};
DrawResults.prototype.SortByAmountFareAsc = function(a,b){
	if(a.AmountFare === b.AmountFare){
		return a.FareId - b.FareId;
	}
	return a.AmountFare- b.AmountFare;
};
DrawResults.prototype.SortByStars = function(a,b){
	return b.stars - a.stars;
};
DrawResults.prototype.initDrawPreferedFlights = function(){
	//this.preferedBlock = $('#preferedBlock')[0];
	this.firstP = $('#FirstPrefered')[0];
	this.secondP = $('#SecondPrefered')[0];
	this.firstQS = $('#QuickSandFirstPrefered')[0];
	this.secondQS = $('#QuickSandSecondPrefered')[0];
};
DrawResults.prototype.GetPreferedFlights = function(){
	var self = this;
	var PreferedFlights = [];
	var PreferedFlightsIndex = [];
	var curFlight;
	var i;
	var FL;
	//1st always low price
		var LowPriceArray = this.FlightsToShow.sort(self.SortByPrice);
		var selectedFlight=LowPriceArray[0];
		var arr = [];
		for (i = 0, FL=LowPriceArray.length; i < FL; i++) {
			curFlight = LowPriceArray[i];
			if(curFlight.coefP == selectedFlight.coefP) {
				arr.push(curFlight);
			} else {
				break;
			}
		}

		arr.sort(self.SortByTime);
		selectedFlight=arr[0];
		for (i = 0, FL = arr.length; i < FL; i++) {
			curFlight = arr[i];
			if(curFlight.coefT == selectedFlight.coefT && curFlight.stars >= selectedFlight.stars){
				selectedFlight = curFlight;
			} else if(curFlight.coefT != selectedFlight.coefT) {
				break;
			}
		}
		PreferedFlights.push(selectedFlight);
		PreferedFlightsIndex.push(selectedFlight.FlightIndex);

	//если есть прямые и с пересадками
	if(this.currentViewDirectFlightsCount>0 && this.currentViewTransportFlightsCount>0) {
		selectedFlight=null;
		for (i = 0, FL=LowPriceArray.length; i < FL; i++) {
			curFlight = LowPriceArray[i];
			if(Boolean(curFlight.direct)) {
				if(!selectedFlight) {
					selectedFlight = curFlight;
				}
				if(curFlight.coefP == selectedFlight.coefP && curFlight.stars >= selectedFlight.stars) {
					selectedFlight = curFlight;
				} else if(curFlight.coefP != selectedFlight.coefP){
					break;
				}
			}
		}
		PreferedFlights.push(selectedFlight);
		if(PreferedFlightsIndex[0] != selectedFlight.FlightIndex) {
			PreferedFlightsIndex.push(selectedFlight.FlightIndex);
		}
	} else if(this.currentViewDirectFlightsCount>0 && this.currentViewTransportFlightsCount===0) { // если только прямые
		var StarsArray = this.FlightsToShow.sort(self.SortByStars);
		selectedFlight=StarsArray[0];
		var deltaStars = this.allDirectionsLength;
		for (i = 0, FL = StarsArray.length; i < FL; i++) {
			curFlight = StarsArray[i];
			if( curFlight.coefP <= selectedFlight.coefP ) {continue};
			if( selectedFlight.stars - curFlight.stars <= deltaStars ){
				selectedFlight = curFlight;
			}
		}
		PreferedFlights.push(selectedFlight);
		if(PreferedFlightsIndex[0] != selectedFlight.FlightIndex) {
			PreferedFlightsIndex.push(selectedFlight.FlightIndex);
		}
	} else { // если только с пересадками
		var LowTimeArray = this.FlightsToShow.sort(self.SortByTime);
		selectedFlight=LowTimeArray[0];
		arr = [];
		//OTT-1978
		if(!this.currentViewDirectFlightsCount) {
			// FE-1854 больше не учитываем перелёты с разницей меньше 3-х часов, а сортируем по времени честно
			//выборка по перелётам с разницей общего времени в воздухе меньше 3часов с самым быстрым в LowTimeArray
			// for (i = 0, FL=LowTimeArray.length; i < FL; i++) {
			// 	curFlight = LowTimeArray[i];
			// 	if(curFlight.totalJourneyTimeInAir - selectedFlight.totalJourneyTimeInAir <= 180) {
			// 		arr.push(curFlight);
			// 	} else {
			// 		break;
			// 	}
			// }

			//выборка тех, где пересадки меньше 3часов
			var newArr = [];
			for (var ai = 0, AL=arr.length; ai < AL; ai++) {
				var addFare = true;
				curFlight = arr[ai];
				var stopTimes = String(curFlight.StopTimes).split(',');
				for(var si=0, sl = stopTimes.length; si< sl; si++) {
					if(DurationAPIToMinutes(stopTimes[si]) >= 180) {
						addFare = false;
						break;
					}
				}
				if(addFare) newArr.push(curFlight);
			}
			arr = newArr;
			//исключаем ситуацию где все пересадки больше 3 часов
			if(!arr.length) arr.push(selectedFlight);

			arr.sort(self.SortByPrice);
			selectedFlight=arr[0];
			for (i = 0, FL = arr.length; i < FL; i++) {
				curFlight = arr[i];
				if(curFlight.coefP >= selectedFlight.coefP && curFlight.coefT >= selectedFlight.coefT){
					selectedFlight = curFlight;
				} else {
					break;
				}
			}
		} else {
			for (i = 0, FL=LowTimeArray.length; i < FL; i++) {
				curFlight = LowTimeArray[i];
				if(curFlight.coefT == selectedFlight.coefT) {
					arr.push(curFlight);
				} else {
					break;
				}
			}
			arr.sort(self.SortByPrice);
			selectedFlight=arr[0];
			for (i = 0, FL = arr.length; i < FL; i++) {
				curFlight = arr[i];
				if(curFlight.coefP >= selectedFlight.coefP){
					selectedFlight = curFlight;
				} else {
					break;
				}
			}
		}
		PreferedFlights.push(selectedFlight);
		if(PreferedFlightsIndex[0] != selectedFlight.FlightIndex) {
			PreferedFlightsIndex.push(selectedFlight.FlightIndex);
		}
	}
	//безместные варианты - обнуляем префереды для правильного пересечения flights в показе
	if(PreferedFlights[0].noseats || (PreferedFlights[1] && PreferedFlights[1].noseats)) {
		this.noseatresult = true;
		PreferedFlights = [];
		PreferedFlightsIndex = [];
	} else {
		delete this.noseatresult;
	}
	this.PreferedFlights = PreferedFlights;
	this.PreferedFlightsIndex = PreferedFlightsIndex;

	LowPriceArray=null;
	LowTimeArray=null;
	StarsArray=null;
	arr=null;
	selectedFlight=null;
};
DrawResults.prototype.DrawPreferedFlights = function(){
	var self = this;
	var PreferedFlights = this.PreferedFlights;
	if(this.noseatresult) {
		//если хоть 1 из преферед - безместный, то скрываем блоки с преферед
		$('#preferedBlock').addClass('invisible');
		$('.AdditionalFilterOptions').addClass('invisible');
		return;
	}
	var selectedFlight, mClass,dataId;
	var tempFirst = document.createElement('div');
	var tempSecond = document.createElement('div');
	//если есть прямые и с пересадками
	if(this.currentViewDirectFlightsCount>0 && this.currentViewTransportFlightsCount>0) {
		mClass = "price";
		selectedFlight = PreferedFlights[0];
		dataId = selectedFlight.AK+'_'+selectedFlight.direct+'_'+selectedFlight.combined;
		$(tempFirst).attr('data-id',dataId+'_'+selectedFlight.FlightIndex);
		this.ShowFlight(tempFirst,selectedFlight,{
			AK: self.VisibleAK[dataId],
			markClass: mClass
		});

		mClass = "price_direct";
		selectedFlight = PreferedFlights[1];
		dataId = selectedFlight.AK+'_'+selectedFlight.direct+'_'+selectedFlight.combined;
		$(tempSecond).attr('data-id',dataId+'_'+selectedFlight.FlightIndex);
		this.ShowFlight(tempSecond,selectedFlight,{
			AK: self.VisibleAK[dataId],
			markClass: mClass
		});
	} else if(this.currentViewDirectFlightsCount>0 && this.currentViewTransportFlightsCount===0) { // если только прямые
		mClass = "price";
		selectedFlight = PreferedFlights[0];
		dataId = selectedFlight.AK+'_'+selectedFlight.direct+'_'+selectedFlight.combined;
		$(tempFirst).attr('data-id',dataId+'_'+selectedFlight.FlightIndex);
		this.ShowFlight(tempFirst,selectedFlight,{
			AK: self.VisibleAK[dataId],
			markClass: mClass
		});

		mClass = "reliable";
		selectedFlight = PreferedFlights[1];
		dataId = selectedFlight.AK+'_'+selectedFlight.direct+'_'+selectedFlight.combined;
		$(tempSecond).attr('data-id',dataId+'_'+selectedFlight.FlightIndex);
		this.ShowFlight(tempSecond,selectedFlight,{
			AK: self.VisibleAK[dataId],
			markClass: mClass
		});
	} else { // если только с пересадками
		mClass = "price";
		selectedFlight = PreferedFlights[0];
		dataId = selectedFlight.AK+'_'+selectedFlight.direct+'_'+selectedFlight.combined;
		$(tempFirst).attr('data-id',dataId+'_'+selectedFlight.FlightIndex);
		this.ShowFlight(tempFirst,selectedFlight,{
			AK: self.VisibleAK[dataId],
			markClass: mClass
		});

		mClass = "time";
		selectedFlight = PreferedFlights[1];
		dataId = selectedFlight.AK+'_'+selectedFlight.direct+'_'+selectedFlight.combined;
		$(tempSecond).attr('data-id',dataId+'_'+selectedFlight.FlightIndex);
		this.ShowFlight(tempSecond,selectedFlight,{
			AK: self.VisibleAK[dataId],
			markClass: mClass
		});
	}

	$(this.firstQS).append(tempFirst);
	$(this.firstP).quicksand( $(self.firstQS).find('div')[0], function(){
		$(tempFirst).remove();
		self.initAKvariants(self.firstP);
	});

	$(this.secondQS).append(tempSecond);
	$(this.secondP).quicksand( $(self.secondQS).find('div')[0], function(){
		$(tempSecond).remove();
		self.initAKvariants(self.secondP);
	});
	//different height in content make equal
		$('.content',this.firstP).each(function(i){
			var c1 = $(this);
			var h1 = $(c1).height();
			var c2 = $('.content',self.secondP)[i];
			var h2 = $(c2).height();
			var equalH = h1>h2? h1 : h2;
			$(c1).height(equalH);
			$(c2).height(equalH);
		});
	//
	selectedFlight=null;
	mClass = null;
};
DrawResults.prototype.DefaultParamsForTicket = function(){
	tw.ticketParams={};
	//если есть и прямые и с пересадками
	//tw.ticketParams.different= 0;
	if(this.allDirectionsLength>2){tw.ticketParams.multi = true;}
	if(this.allDirectionsLength==2){
		if(this.obj.directions[0].from == this.obj.directions[1].to && this.obj.directions[1].from == this.obj.directions[0].to) {
			tw.ticketParams.round = true;
		} else {
			tw.ticketParams.multi = true;
		}
	}
	if(tw.ticketParams.round || this.allDirectionsLength==1){
		this.showAdviser = true;
	}
	var singleFrom = [0,0,0,0];
	var singleTo = [0,0,0,0];
	//считаем кол-во аэропортов в городе для выводе в шаблоне в виде вместо "из Домодедово в Пулково" - "Из домодедово"
	var pointFromCode = [];
	var pointToCode = [];
	for(var DirectionIndex=0;DirectionIndex<this.allDirectionsLength;DirectionIndex++){
		if(ref.Cities[this.obj.directions[DirectionIndex].from]){
			pointFromCode.push(this.obj.directions[DirectionIndex].from);
		} else {
			pointFromCode.push(ref.Airports[this.obj.directions[DirectionIndex].from].Parent);
		}
		if(ref.Cities[this.obj.directions[DirectionIndex].to]){
			pointToCode.push(this.obj.directions[DirectionIndex].to);
		} else {
			pointToCode.push(ref.Airports[this.obj.directions[DirectionIndex].to].Parent);
		}
	}
	for(var i in ref.Airports) {
		var curAirp = ref.Airports[i];
		if(curAirp.Railway!=1) {
			if(curAirp.Parent == pointFromCode[0]) {
				singleFrom[0]++;
			}
			if(curAirp.Parent == pointToCode[0]) {
				singleTo[0]++;
			}

			if(this.obj.directions[1]){
				if(curAirp.Parent == pointFromCode[1]) {
					singleFrom[1]++;
				}
				if(curAirp.Parent == pointToCode[1]) {
					singleTo[1]++;
				}
			}
			if(this.obj.directions[2]){
				if(curAirp.Parent == pointFromCode[2]) {
					singleFrom[2]++;
				}
				if(curAirp.Parent == pointToCode[2]) {
					singleTo[2]++;
				}
			}
			if(this.obj.directions[3]){
				if(curAirp.Parent == pointFromCode[3]) {
					singleFrom[3]++;
				}
				if(curAirp.Parent == pointToCode[3]) {
					singleTo[3]++;
				}
			}
		}
	}
	//если мульти то по умолчанию много аэропортов в пунтке в1-2 направления
	if(tw.ticketParams.multi){
		singleFrom = [2,2,2,2];
		singleTo = [2,2,2,2];
	}
	tw.ticketParams.singleFrom= singleFrom;
	tw.ticketParams.singleTo= singleTo;
};

DrawResults.prototype.ShowFlight = function(block,Flight, params){
	if (!params) {params = {};}
	//Доп поля для шаблонизатора
	if(!params.commercial){
		this.addTemplateInformation(Flight);
	}

	var $FlightCard = $($.tmpl('tmpl_FlightBlock', Flight, params));
	$FlightCard.find('.price_button').attr('data-flightIndex', Flight.FlightIndex);
	$FlightCard.appendTo(block);

	/*if(params.markClass) {
		delete Flight.html_tmpl;
	}*/
	//
};




DrawResults.prototype.addTemplateInformation = function(Flight){
	if(!Flight.html_tmpl) {
		Flight.html_tmpl = {};
		Flight.html_tmpl.flightInfo = [];
		Flight.html_tmpl.Airline = ref.getAirlineName(Flight.AK);
		Flight.html_tmpl.From = [];
		Flight.html_tmpl.To = [];
		Flight.html_tmpl.AirportByCodeFrom = [];
		Flight.html_tmpl.AirportByCodeTo = [];
		Flight.html_tmpl.shortAirportByCodeFrom = [];
		Flight.html_tmpl.shortAirportByCodeTo = [];
		Flight.html_tmpl.longAirportByCodeFrom = [];
		Flight.html_tmpl.longAirportByCodeTo = [];
		Flight.html_tmpl.StartTime = [];
		Flight.html_tmpl.StartSortTime = [];
		Flight.html_tmpl.EndTime = [];
		Flight.html_tmpl.StopPoints = [];
		Flight.html_tmpl.ChangeBoardPoints = [];
		Flight.html_tmpl.Planes = [];
		Flight.html_tmpl.FlightNumber = [];

		Flight.html_tmpl.DurationStopTime = [];
		Flight.html_tmpl.DurationJourneyTime = [];
		Flight.html_tmpl.StartDate = [];
		Flight.html_tmpl.EndDate = [];
		Flight.html_tmpl.TransferTitle = [];
		Flight.html_tmpl.TransferNight = [];
		Flight.html_tmpl.TransferAirport = [];
		Flight.html_tmpl.arrMiles = [];
		/*var directFlights = 0;
		var transportFlights = 0;*/
		for(var Dindex=0;Dindex<this.allDirectionsLength;Dindex++){
			var FirstDirectionTrip = Flight.TripIds[Dindex][0];
			var LastDirectionTrip = Flight.TripIds[Dindex][ Flight.TripIds[Dindex].length-1 ];
			var FDtrip = this.obj.json.trps[FirstDirectionTrip];
			var LDtrip = this.obj.json.trps[LastDirectionTrip];

			Flight.html_tmpl.From.push(ref.getCityName(FDtrip.from).toUpperCase() );
			Flight.html_tmpl.To.push(ref.getCityName(LDtrip.to).toUpperCase() );

			Flight.html_tmpl.AirportByCodeFrom.push( FDtrip.from );
			Flight.html_tmpl.AirportByCodeTo.push( LDtrip.to );

			var changedFrom = ChangeLastLetterFrom(ref.getAirportName(FDtrip.from));
			var changedTo = ref.getAirportName(LDtrip.to);
			Flight.html_tmpl.longAirportByCodeFrom.push( changedFrom );
			Flight.html_tmpl.longAirportByCodeTo.push( changedTo );
			changedFrom = formatPointStringFromTo(changedFrom, l10n.searchResult.block.inout[1]);
			changedTo = formatPointStringFromTo(changedTo, l10n.searchResult.block.inout[0]);
			Flight.html_tmpl.shortAirportByCodeFrom.push( changedFrom );
			Flight.html_tmpl.shortAirportByCodeTo.push( changedTo );


			var tempStartDate = tempEndDate = new Date.parseAPI(FDtrip.stDt);
			tempStartDate.setHours(FDtrip.stTm.substring(0,2), FDtrip.stTm.substring(2), 0, 0);
			Flight.html_tmpl.StartTime.push( tempStartDate.format("localShortTime") );
			Flight.html_tmpl.StartSortTime.push( tempStartDate.format("HHMM") );
			tempEndDate.setHours(LDtrip.endTm.substring(0,2), LDtrip.endTm.substring(2), 0, 0);
			Flight.html_tmpl.EndTime.push( tempEndDate.format("localShortTime") );
			//Flight.html_tmpl.StartTime.push(FDtrip.stTm.substring(0,2)+':'+FDtrip.stTm.substring(2));
			//Flight.html_tmpl.EndTime.push(LDtrip.endTm.substring(0,2)+':'+LDtrip.endTm.substring(2));

			if(Flight.StopTimes[Dindex].length>0){
				Flight.html_tmpl.DurationStopTime[Dindex] = 0;
				for (var i= 0, SL = Flight.StopTimes[Dindex].length; i < SL; i++) {
					Flight.html_tmpl.DurationStopTime[Dindex] += DurationAPIToMinutes(Flight.StopTimes[Dindex][i]);
				}
				Flight.html_tmpl.DurationStopTime[Dindex] = DurationTimeStringPartFull(DurationAPIFromMinutes(Flight.html_tmpl.DurationStopTime[Dindex]));
			} else {
				//Flight.html_tmpl.DurationStopTime[Dindex] = "смена борта";
				Flight.html_tmpl.DurationStopTime[Dindex] = "";
			}

			Flight.html_tmpl.DurationJourneyTime[Dindex] = DurationAPIToMinutes(Flight.JourneyTime[Dindex]);
			Flight.html_tmpl.AK = Flight.AK;
			Flight.html_tmpl.OPAK = Flight.OPAK;

			Flight.html_tmpl.StopPoints[Dindex] = [];
			Flight.html_tmpl.ChangeBoardPoints[Dindex] = [];

			//transfers tooltip
				Flight.html_tmpl.TransferTitle[Dindex] = "";
				Flight.html_tmpl.TransferNight[Dindex] = 0;
				Flight.html_tmpl.TransferAirport[Dindex] = 0;
				var tempStopDate = FDtrip.stDt;
				if(FDtrip.dayChg) {
					var FDtripDate = new Date.parseAPI(tempStopDate);
					FDtripDate.setDate(FDtripDate.getDate() + FDtrip.dayChg);
					tempStopDate = FDtripDate.format('yyyymmdd');
				}
				var nightStops = 0;
				var dayStops = 0;
			for (var i= 0, FL = Flight.TripIds[Dindex].length; i < FL; i++) {
				//проверка есть ли инфа по звездам
					var curTrip =this.obj.json.trps[Flight.TripIds[Dindex][i]];
					if(curTrip.flightInfo) {
						Flight.html_tmpl.flightInfo.push(Flight.TripIds[Dindex][i]);
					}
					if(curTrip.miles) {
						Flight.html_tmpl.arrMiles.push(curTrip.miles);
					}

					if(i>0){
						var prevTrip = this.obj.json.trps[Flight.TripIds[Dindex][i-1]];
						Flight.html_tmpl.StopPoints[Dindex].push(curTrip.from);

						//transfers tooltip
						var duration = DurationTimeString(Flight.StopTimes[Dindex][i-1],0,0)
						if(Flight.html_tmpl.TransferTitle[Dindex] != '') {
							Flight.html_tmpl.TransferTitle[Dindex] += '| ';	 //добавили разделения в тултипе на новую строку
						}
						if(tempStopDate != curTrip.stDt){
							Flight.html_tmpl.TransferTitle[Dindex] += l10n.searchResult.baloon.transfers[0] + ref.getCity(curTrip.from).Name + ', ';
							if(ref.getCity(curTrip.from).Name != ref.getAirportName(curTrip.from)) {
								Flight.html_tmpl.TransferTitle[Dindex] += ref.getAirportName(curTrip.from);
							}
							Flight.html_tmpl.TransferTitle[Dindex] += ' ' + duration;
							if(prevTrip.to != curTrip.from) {
								Flight.html_tmpl.TransferTitle[Dindex] += ',| ' + l10n.searchResult.baloon.transfers[3] + ' ' + ref.getAirportName(prevTrip.to) + '&rarr;' + ref.getAirportName(curTrip.from);
								Flight.html_tmpl.TransferAirport[Dindex] = 1;
							}
							Flight.html_tmpl.TransferNight[Dindex] = 1;
							var tempStopDate=curTrip.stDt;
							if(curTrip.dayChg) {
								var curTripDate = new Date.parseAPI(tempStopDate);
								curTripDate.setDate(curTripDate.getDate() + curTrip.dayChg);
								tempStopDate = curTripDate.format('yyyymmdd');
							}
							nightStops++;
						} else {
							dayStops++;
							if(dayStops==1 && nightStops===0){
								if(prevTrip.to != curTrip.from && Flight.TripIds[Dindex].length>1) {
									Flight.html_tmpl.TransferTitle[Dindex] += l10n.searchResult.baloon.transfers[1] + ref.getCity(curTrip.from).Name + ' ' + duration + ',| ' + l10n.searchResult.baloon.transfers[3] + ' ' + ref.getAirportName(prevTrip.to) + '&rarr;' + ref.getAirportName(curTrip.from);
									Flight.html_tmpl.TransferAirport[Dindex] = 1;
								} else {
									Flight.html_tmpl.TransferTitle[Dindex] += l10n.searchResult.baloon.transfers[2]
										+ ' '
										+ ref.getAirportName(curTrip.from)
										+ ' '
										+ duration;
								}
							} else {
								Flight.html_tmpl.TransferTitle[Dindex] += l10n.searchResult.baloon.transfers[1] + ref.getCity(curTrip.from).Name + ', ' + ref.getAirportName(curTrip.from) + ' ' + duration;
								if(prevTrip.to != curTrip.from) {
									Flight.html_tmpl.TransferTitle[Dindex] += ',| ' + l10n.searchResult.baloon.transfers[3] + ' ' + ref.getAirportName(prevTrip.to) + '&rarr;' + ref.getAirportName(curTrip.from);
									Flight.html_tmpl.TransferAirport[Dindex] = 1;
								}
							}
						}
					}
					//остановки
					if(curTrip.stps) {
						for(var k=0, StopLength=curTrip.stps.length;k<StopLength; k++){
							//Flight.html_tmpl.StopPoints[Dindex].push(curTrip.stps[k]);
							Flight.html_tmpl.ChangeBoardPoints[Dindex].push(curTrip.stps[k]);

							if(Flight.html_tmpl.TransferTitle[Dindex] != '') {
								Flight.html_tmpl.TransferTitle[Dindex] += '| ';	 //добавили разделения в тултипе на новую строку
							}
							Flight.html_tmpl.TransferTitle[Dindex] += l10n.searchResult.baloon.transfers[4] + ' ' + ref.getAirportName(curTrip.stps[k]);
						}
					}

			}
			if(Flight.html_tmpl.DurationStopTime[Dindex] == "" && Flight.html_tmpl.ChangeBoardPoints[Dindex].length>0) {
				Flight.html_tmpl.DurationStopTime[Dindex] = l10n.searchResult.baloon.transfers[5];
			}

			Flight.html_tmpl.DurationJourneyTime[Dindex] = DurationTimeStringPartFull(DurationAPIFromMinutes(Flight.html_tmpl.DurationJourneyTime[Dindex]));
			Flight.html_tmpl.OPAK = Flight.OPAK;

			//Flight.html_tmpl.DurationJourneyTime[Dindex] = DurationTimeStringFromMinutes(DurationAPIToMinutes(Flight.JourneyTime[Dindex]) - Flight.html_tmpl.DurationStopTime[Dindex]);
			Flight.html_tmpl.Planes.push(this.obj.json.planes[FDtrip.plane]||""); //случай с безместными перелётами
			Flight.html_tmpl.FlightNumber.push(FDtrip.airCmp +"-"+FDtrip.fltNm);
			/*if(Flight.html_tmpl.StopPoints[Dindex].length>0){
				transportFlights++;
			} else {
				directFlights++;
			}*/
			Flight.html_tmpl.StartDate.push(this.obj.json.trps[Flight.TripIds[Dindex][0]].stDt);
			var tempEndDate=LDtrip.stDt;
			if(LDtrip.dayChg) {
				var curTripDate = new Date.parseAPI(tempEndDate);
				curTripDate.setDate(curTripDate.getDate() + LDtrip.dayChg);
				tempEndDate = curTripDate.format('yyyymmdd');
			}
			Flight.html_tmpl.EndDate.push(tempEndDate);
			//
			FirstDirectionTrip = LastDirectionTrip = FDtrip = LDtrip=null;
		}
		Flight.html_tmpl.MultiAKFlight = "";
		for(var AKindex=0, AKL=Flight.TripsAK.length;AKindex<AKL;AKindex++){
			if(Flight.html_tmpl.MultiAKFlight != "") {
				Flight.html_tmpl.MultiAKFlight+= ", ";
			}
			Flight.html_tmpl.MultiAKFlight+= ref.getAirlineName(Flight.TripsAK[AKindex]);
		}
		if(Flight.combined){
			Flight.html_tmpl.MultiAKFlight = ref.getAirlineName(Flight.AK) + " " + l10n.searchResult.baloon.airline[2];
		} else if(Flight.TripsAK.length>1) {
			Flight.html_tmpl.MultiAKFlight = l10n.searchResult.baloon.airline[0] + " " + Flight.html_tmpl.MultiAKFlight;
		} else if(Flight.TripsAK != Flight.AK){
			Flight.html_tmpl.MultiAKFlight = l10n.searchResult.baloon.airline[1] + " " + Flight.html_tmpl.MultiAKFlight;
		} else {Flight.html_tmpl.MultiAKFlight = "";}

		//звездатость
			Flight.html_tmpl.stars = (Flight.stars/2).toFixed(1);
			Flight.html_tmpl.halfstar= 0;
			var stars = Flight.html_tmpl.stars;
			Flight.html_tmpl.stars = Math.floor(stars.split('.')[0]);
			if(stars.split('.')[1]>=3 && stars.split('.')[1]<7) {
				Flight.html_tmpl.halfstar= 1;
			}
			if(stars.split('.')[1]>7) {
				Flight.html_tmpl.stars+= 1;
			}
			Flight.html_tmpl.emptystars = (5-Flight.html_tmpl.stars - Flight.html_tmpl.halfstar)*14;
			Flight.html_tmpl.stars = Flight.html_tmpl.stars*14;

		//если >1 направления и есть и с пересадками и без, то там где без пересадок пишем "прямой" (есть разные перелёты) на всём маршруте
			/*Flight.html_tmpl.isDifferentFlights=0;
			if(transportFlights>0 && directFlights>0) {
				Flight.html_tmpl.isDifferentFlights=1;
			}*/
	}
	Flight.html_tmpl.Price = formatMoney(Flight.AmountFare);
	if(Flight.PromoAmountFare) {
		Flight.html_tmpl.PromoPrice = formatMoney(Flight.PromoAmountFare);
	}
};
DrawResults.prototype.initFilterObject = function(){
	var self = this;
	this.FilterObject = [];
	for (var j=0;j<this.allDirectionsLength;j++) {
		direction = {Id: '',
			Direction: {From: {Name:'',Code:''},To: {Name:'',Code:''}},
			Departure: {time: [], pointCount:0, pointArray:[], pointPrice:[]},
			Arrival: {time: [], pointCount:0, pointArray:[], pointPrice:[]}
		};

		//для заголовка фильтра направления откуда-куда
		if(ref.Cities[self.obj.directions[j].from]) {
			direction.Direction.From.Code = self.obj.directions[j].from;
			direction.Direction.From.Name = ref.getCityName(direction.Direction.From.Code);
		} else if(ref.Airports[self.obj.directions[j].from]) {
			direction.Direction.From.Code = ref.Airports[self.obj.directions[j].from].Parent;
			direction.Direction.From.Name = ref.getCityName(direction.Direction.From.Code);
		}
		if(ref.Cities[self.obj.directions[j].to]) {
			direction.Direction.To.Code = self.obj.directions[j].to;
			direction.Direction.To.Name = ref.getCityName(direction.Direction.To.Code);
		} else if(ref.Airports[self.obj.directions[j].to]) {
			direction.Direction.To.Code = ref.Airports[self.obj.directions[j].to].Parent;
			direction.Direction.To.Name = ref.getCityName(direction.Direction.To.Code);
		}
		//для шаблонизатора
		direction.Id = j;
		self.FilterObject.push(direction);
	}

	//getMinFlightPrices

	var minPrice = 1e9;
	for(var i=0,DL=this.FDirections.length;i<DL;i++){
		var curDir =  this.FDirections[i];
		for(var j in curDir) {
			var curVariant = curDir[j];

			//смотрим нужно ли разделять время более детально - для шаблона
			var exact = false;
			if(j == "DepTimes" || j =="ArrTimes") {
				if(curVariant.morningday.list.length ===0 || curVariant.eveningnight.list.length ===0){
					exact=true;
				}
			}
			for(var k in curVariant) {
				//calculate price
				var curOption = curVariant[k];
				curOption.minPrice = minPrice;
				for(var m=0,FL=curOption.list.length;m<FL;m++){
					var curFlight =self.oFlights[curOption.list[m]];
					if( curFlight.AmountFare < curOption.minPrice) {
						curOption.minPrice = curFlight.AmountFare;
					}
				}

				//для шаблона
				//var price = formatMoney(curOption.minPrice);
				var price = curOption.minPrice;
				switch(j){
					case 'DepPoints':
						self.FilterObject[i].Departure.pointArray.push(k);
						self.FilterObject[i].Departure.pointPrice.push(price);
						self.FilterObject[i].Departure.pointCount++;
						break;
					case 'ArrPoints':
						self.FilterObject[i].Arrival.pointArray.push(k);
						self.FilterObject[i].Arrival.pointPrice.push(price);
						self.FilterObject[i].Arrival.pointCount++;
						break;
					case 'DepTimes':
						if(curOption.list.length >0) {
							if(exact && k != 'morningday' && k !='eveningnight' ) {
								var objTime = self.FormTimePeriod(k);
								objTime.minPrice = price;
								self.FilterObject[i].Departure.time.push(objTime);
							} else if(k == 'morningday' || k =='eveningnight'){
								var objTime = self.FormTimePeriod(k);
								objTime.minPrice = price;
								self.FilterObject[i].Departure.time.push(objTime);
							}
						}
						break;
					case 'ArrTimes':
						if(curOption.list.length >0) {
							if(exact && k != 'morningday' && k !='eveningnight' ) {
								var objTime = self.FormTimePeriod(k);
								objTime.minPrice = price;
								self.FilterObject[i].Arrival.time.push(objTime);
							} else if(k == 'morningday' || k =='eveningnight'){
								var objTime = self.FormTimePeriod(k);
								objTime.minPrice = price;
								self.FilterObject[i].Arrival.time.push(objTime);
							}
						}
						break;
				}
			}
		}
	}

	/**
	 * сортировка для фильтра в шаблонизаторе
	 */
	var DayIndexSort = function(a,b){
		if( a.id > b.id ) return 1;
		if( a.id < b.id ) return -1;
		return 0;
	}
	//сортируем периоды времени для фильтра в шаблонизаторе
	for(var i in this.FilterObject) {
		var timeArr = [];
		for(var j in self.FilterObject[i].Departure.time) {
			var obj = self.FilterObject[i].Departure.time[j];
			timeArr.push(obj);
		}
		self.FilterObject[i].Departure.time = timeArr.sort(DayIndexSort);
		timeArr = [];
		for(var j in self.FilterObject[i].Arrival.time) {
			var obj = self.FilterObject[i].Arrival.time[j];
			timeArr.push(obj);
		}
		self.FilterObject[i].Arrival.time = timeArr.sort(DayIndexSort);
	}
	//free
	DayIndexSort = null;
};
DrawResults.prototype.FormTimePeriod = function(String){
	var objTime = {};
	objTime.sys = String;
	switch(String){
		case 'morning':
			objTime.name = l10n.searchResult.filters.time[0];
			objTime.id = '1';
			objTime.clock = '05:00-08:59';
			if(tw.language == "en-us") {
				objTime.clock = '05:00a-08:59a';
			}
			break;
		case 'day':
			objTime.name = l10n.searchResult.filters.time[1];
			objTime.id = '2';
			objTime.clock = '09:00-15:59';
			if(tw.language == "en-us") {
				objTime.clock = '09:00a-03:59p';
			}
			break;
		case 'evening':
			objTime.name = l10n.searchResult.filters.time[2];
			objTime.id = '3';
			objTime.clock = '16:00-20:59';
			if(tw.language == "en-us") {
				objTime.clock = '04:00p-08:59p';
			}
			break;
		case 'night':
			objTime.name = l10n.searchResult.filters.time[3];
			objTime.id = '4';
			objTime.clock = '21:00-04:59';
			if(tw.language == "en-us") {
				objTime.clock = '09:00p-04:59a';
			}
			break;
		case 'morningday':
			objTime.name = l10n.searchResult.filters.time[4];
			objTime.id = '5';
			objTime.clock = '05:00-15:59';
			if(tw.language == "en-us") {
				objTime.clock = '05:00a-03:59p';
			}
			break;
		case 'eveningnight':
			objTime.name = l10n.searchResult.filters.time[5];
			objTime.id = '6';
			objTime.clock = '16:00-04:59';
			if(tw.language == "en-us") {
				objTime.clock = '04:00p-04:59a';
			}
			break;
	}
	return objTime;
};
DrawResults.prototype.initRefundSelection = function(){
	var self = this;
	this.RefundSelection = $('#RefundSelection')[0];
	if(this.stat.refundFlightCount>0) {
		$(this.RefundSelection).removeClass('invisible');
	} else {
		return;
	}
	if(this.ShowRefundable) {
		$('.d_last',this.RefundSelection).addClass('selected');
	} else {
		$('.d_first',this.RefundSelection).addClass('selected');
	}
	$('.d_option', this.RefundSelection).delegate('div[class*="d_direction"]:not(.selected):not(.disabled)', 'click', function(){
		if(self.QuickSandProcess) {return;}
		$(this).addClass('selected').siblings().removeClass('selected');
		if( $(this).hasClass('d_first') ) {
			self.ShowRefundable = false;
		} else {
			self.ShowRefundable = true;
		}
		self.RedrawResults();
	});
};
DrawResults.prototype.initCurrencySelection = function(){
	var self = this;
	this.CurrenciesBlock = $('#CurrenciesBlock')[0];

	if (this.CurrenciesBlock) {
		$('.d_direction', this.CurrenciesBlock).each(function(){
			if( $(this).attr('data-cur') == tw.currency) {
				$(this).addClass('selected');
			}
		});
		$('.d_option', this.CurrenciesBlock).delegate('div[class*="d_direction"]:not(.selected):not(.disabled)', 'click', function(){
			if(self.QuickSandProcess) {return;}
			$(this).addClass('selected').siblings().removeClass('selected');
			tw.currency = $(this).attr('data-cur');
			setCookie({
				name: "currency",
				value: tw.currency,
				days: 180,
				xdm: true
			});
			makeBonusCurrencyToViewCur(tw.currency);
			window.location.hash = window.location.hash.split('|')[0];
			self.RedrawResults(false);
		});
		makeBonusCurrencyToViewCur(tw.currency);
	}
};
DrawResults.prototype.initFilter = function(){
	var self= this;
	//$('#DirectionsFilter').empty();
	$.tmpl($("#tmpl_PreferedFlightFilter").trim(), self.FilterObject ).appendTo( $('#DirectionsFilter') ) ;

	//бизнес - эконом
		if(this.obj.cs == "F") {
			$('div[cs="F"]',this.FlightClassBlock).addClass('selected');
		} else if(this.obj.cs == "B"){
			$('div[cs="B"]',this.FlightClassBlock).addClass('selected');
		} else if(this.obj.cs == "W"){
			$('div[cs="W"]',this.FlightClassBlock).addClass('selected');
		} else {
			$('div[cs="E"]',this.FlightClassBlock).addClass('selected');
		}
		$('.d_option', this.FlightClassBlock).delegate('div[class*="d_direction"]:not(.selected)', 'click', function(){
			$(this).addClass('selected').siblings().removeClass('selected');
			var data = objAvia.parseKey(self.obj.getKey());
			data.cs = $(this).attr('cs');
			objAvia.changeRequest(objAvia.addDataToRequestsList(data));
		});

	// спаны вылет-прилёт
	$('.d_option', this.filter).delegate('div[class*="d_direction"]:not(.selected)', 'click', function() {
		$(this).addClass('selected').siblings().removeClass('selected');
		var doptions = $(this).parents('.direction_body').find('div.direction_option');
		$(doptions).hide();
		if( $(this).hasClass('d_first') ) {
			$(doptions[0]).fadeIn(300);
		} else {
			$(doptions[1]).fadeIn(300);
		}
	});

	// чекбоксы - radio
	FilterRadioButtons = $('input[type="radio"]', this.filter);
	$(FilterRadioButtons).click(function(){
		if(self.QuickSandProcess){
			return
		}
		var option_row = $(this).parents('.option_row')[0];
		if ($(option_row).hasClass('selected')) {
			return
		};
		var fType = $(this).parents('ul').data('filtertype');
		if(fType == 'time'){
			kmqRecord({name: 'use_filter_time'});
		}
		if(fType == 'airport'){
			kmqRecord({name: 'use_filter_airport'});
		}
		self.FilterFareSorting(this);
	});
};
DrawResults.prototype.initOperatedAKList = function(){
	var self = this;
	this.FlightsByAKListBlock = document.getElementById('FlightsByAKList');
	this.FlightsByAKList = $('.list',this.FlightsByAKListBlock)[0];
	this.showAKfilter = (this.AKlist.count < 5)?false:true;
	if(!this.showAKfilter) {
		$(this.FlightsByAKListBlock).remove();
		return;
	}
	$('input[type="radio"]', this.FlightsByAKList).live('click',function(){
		//если сыпучка в процессе или уже выбранный вариант - ретурн
			if(self.QuickSandProcess){return}
			var option_row = $(this).parents('.option_row')[0];
			if ($(option_row).hasClass('selected')) {return};

		$('input[name="' + this.name + '"]').each(function(){
			$(this).parents('div.option_row').removeClass('selected');
		});
		$(option_row).addClass('selected');
		self.AKListClicked = true;
		self.getOperatedAKFlightsToShow( this.value );
		kmqRecord({name: 'use_filter_ak'});
	});
};
DrawResults.prototype.refreshOperatedAK = function(){
	this.OperatedAKarray=null;
	this.defaultFlightsToShowIndex = this.FlightsToShowIndex;
	this.OperatedAK = {};
	for (var i in ref.Alliances) {
		this.OperatedAK[i] = {list:[], minStars: 10000, minFlight: {}, maxStars: -1, maxFlight: {}, group: true};
	}
};
DrawResults.prototype.updateOperatedAK = function(Flight){
	var self = this;
	//ходим по всем АК участвующим в перелете и проверяем (считаем) относятся ли они к одному альянсу или к нескольким
	var alliances = {count:0, outsideCount: 0};
	//все ак в трипсАК   только валидирующие в TripsAKFilter
	for(var i =0, AKL = Flight.TripsAKFilter.length;i<AKL;i++){
		var AKcode = Flight.TripsAKFilter[i];
		var outsideAlliance = true;
		for (var j in ref.Alliances) {
			var curAL =	ref.Alliances[j];
			if(curAL[AKcode] && !alliances[j]) {
				alliances[j]=1;
				alliances.count++;
				outsideAlliance = false;
			}
		}
		if(outsideAlliance) {
			alliances.outsideCount++;
		}
	}
	//если все АК в 1 альянсе и нет других АК вне его
	if(alliances.count==1 && alliances.outsideCount ===0) {
		for (var i in ref.Alliances) {
			var curAL =	ref.Alliances[i];
			if(curAL[Flight.AK]) {
				self.OperatedAK[i].list.push(Flight.FlightIndex);
				// подсчет звездатости
				if(Flight.stars < self.OperatedAK[i].minStars) {
					self.OperatedAK[i].minStars = parseFloat(Flight.stars);
					self.OperatedAK[i].minFlight = Flight;
				}
				if(Flight.stars > self.OperatedAK[i].maxStars) {
					self.OperatedAK[i].maxStars = parseFloat(Flight.stars);
					self.OperatedAK[i].maxFlight = Flight;
				}
				break;
			}
		}
	}
	//если одна АК
	if(Flight.TripsAK.length==1) {
		var curAK = Flight.TripsAK[0];
		if(!this.OperatedAK[curAK]){
			this.OperatedAK[curAK] = {list:[], minStars: 10000, minFlight: {}, maxStars: -1, maxFlight: {}};
		}
		this.OperatedAK[curAK].list.push(Flight.FlightIndex);
		// подсчет звездатости
		if(Flight.stars < this.OperatedAK[curAK].minStars) {
			this.OperatedAK[curAK].minStars = parseFloat(Flight.stars);
			this.OperatedAK[curAK].minFlight = Flight;
		}
		if(Flight.stars > this.OperatedAK[curAK].maxStars) {
			this.OperatedAK[curAK].maxStars = parseFloat(Flight.stars);
			this.OperatedAK[curAK].maxFlight = Flight;
		}
	}
};
DrawResults.prototype.drawOperatedAK = function(){
	var self = this;
	$(this.FlightsByAKList).empty();
	this.OperatedAKlist = [];
	this.OperatedAlliances = [];
	for(var i in this.OperatedAK) {
		var curAK = this.OperatedAK[i];
		//если нет инфы по перелетам - пропускаем АК
		if(curAK.list.length>0 && curAK.maxStars>0) {
			curAK.AK = i;
			curAK.Name = ref.getAirlineName(i);
			curAK.stars = ((curAK.maxStars + curAK.minStars)/2).toFixed(1);
			if(curAK.group){
				self.OperatedAlliances.push(curAK);
			} else {
				self.OperatedAKlist.push(curAK);
			}
		}
	}
	if(this.OperatedAKlist.length>0 || this.OperatedAlliances.length>0) {
		this.OperatedAlliances.sort(self.SortByStars);
		this.OperatedAlliances =  this.makeOperatedAKstars(this.OperatedAlliances);
		this.OperatedAKlist.sort(self.SortByStars);
		this.OperatedAKlist =  this.makeOperatedAKstars(this.OperatedAKlist);
		$.tmpl('tmpl_FlightsByAK').appendTo(this.FlightsByAKList);
		$.tmpl('tmpl_FlightsByAKarray',{AKlist: this.OperatedAlliances}).appendTo( $('ul',this.FlightsByAKList) );
		$.tmpl('tmpl_FlightsByAKarray',{AKlist: this.OperatedAKlist}).appendTo( $('ul',this.FlightsByAKList) );
		$(this.FlightsByAKListBlock).removeClass('invisible');
	} else {
		$(this.FlightsByAKListBlock).addClass('invisible');
	}
};


DrawResults.prototype.makeOperatedAKstars = function(array){
	//принимаем макс значение звезд и пишем остальные относительно данного значения
	if(array.length ===0) {return;}
	var maxStarsValue = array[0].stars;
	for(var i=0, AL=array.length;i<AL;i++) {
		var curAK = array[i];
		//звездатость
		curAK.html_tmpl = {};
		curAK.html_tmpl.halfstar= 0;
		if (i === 0 || curAK.stars == maxStarsValue) {
			curAK.html_tmpl.emptystars = 0;
			curAK.html_tmpl.stars = 70;
		} else {
			curAK.html_tmpl.stars = (curAK.stars/2).toFixed(1);
			var stars = curAK.html_tmpl.stars;
			curAK.html_tmpl.stars = Math.floor(stars.split('.')[0]);
			if(stars.split('.')[1]>=3 && stars.split('.')[1]<7) {
				curAK.html_tmpl.halfstar= 1;
			}
			if(stars.split('.')[1]>7) {
				curAK.html_tmpl.stars+= 1;
			}
			curAK.html_tmpl.emptystars = (5-curAK.html_tmpl.stars - curAK.html_tmpl.halfstar)*14;
			curAK.html_tmpl.stars = curAK.html_tmpl.stars*14;
		}
		//для срабатывания условия в шаблоне звёзд, тут главное показать что есть инфа
			curAK.html_tmpl.flightInfo =["Fly me to The Moon"];
		//пишем все трипы мин-макс (могут быть и одинаковыми )
		curAK.TripIds = curAK.minFlight.TripIds.concat(curAK.maxFlight.TripIds);
	}
	return array;
};


DrawResults.prototype.getOperatedAKFlightsToShow = function(value){
	if(this.OperatedAK[value]){
		this.OperatedAKarray = this.OperatedAK[value].list;
	} else {
		this.OperatedAKarray = this.defaultFlightsToShowIndex;
	}
	this.$FlightSliderBlock.toggleClass('invisible',this.OperatedAKarray.length < 3);
	this.GetFlightsToShow();
};


DrawResults.prototype.initSeats = function(){
	var self = this;
	this.SeatBlock = document.getElementById('SeatsSelection');
	this.SeatBlockList = document.createElement('ul');
	$(this.SeatBlockList).attr('title','Отобразить тарифы с выбранным количеством мест');
	for(var i=0;i<this.minSeats;i++){
		var li = document.createElement('li');
		if(i===0) {
			li.className = "selected";
		}
		$(this.SeatBlockList).append(li);
	}

	$(this.SeatBlock).append(this.SeatBlockList);
	this.seats = $('li',this.SeatBlockList);
	this.selectedSeats = this.selectedSeats||1;
	$(this.seats).mouseover(function(){
		$(this).addClass('selected').prevAll().addClass('selected');
		$(this).nextAll().removeClass('selected');
		var curSeatHover = $(this).prevAll().length+1;
		var curSeatText = " мест";
		if(curSeatHover==1) {curSeatText=" место"}
		if(curSeatHover==2 || curSeatHover==3 || curSeatHover==4) {curSeatText=" места"}
		$('#tooltip').html('Отобразить варианты с наличием '+ curSeatHover +curSeatText);
	});
	$(this.SeatBlockList).mouseleave(function(){
		self.updateSeats();
	}).tooltip();

	$(this.seats).click(function(){
		if(self.QuickSandProcess || self.selectedSeats == $(this).prevAll().length+1) {
			return;
		}
		$(this).addClass('selected').prevAll().addClass('selected');
		self.selectedSeats = $(this).prevAll().length+1;
		$('#tooltip').remove();
		self.ShowRefundable = false;
		self.RedrawResults();
	});
	this.updateSeats();
};
DrawResults.prototype.updateSeats = function(){
	$(this.seats)
		.removeClass('selected')
		.slice(0,this.selectedSeats).addClass('selected');
};
DrawResults.prototype.FilterFareSorting = function(el){

	if(el){
		var option_row = $(el).parents('div.option_row')[0];
		$('input[name="' + el.name + '"]').each(function(){
			$(this).parents('div.option_row').removeClass('selected');
		});
		$(option_row).addClass('selected');

		var group = $(el).attr('group');
		if (group) {
			if (group == "00") {
				$('li[name="01"] .option_row').removeClass('selected');
				$('input[value="any"][group="01"]', this.filter).each(function(){
					$(this).attr('checked', 'checked');
					$(this).parents('div.option_row').addClass('selected');
				});
			}
			if (group == "01") {
				$('li[name="00"] .option_row').removeClass('selected');
				$('input[value="any"][group="00"]', this.filter).each(function(){
					$(this).attr('checked', 'checked');
					$(this).parents('div.option_row').addClass('selected');
				});
			}
			if (group == "10") {
				$('li[name="11"] .option_row').removeClass('selected');
				$('input[value="any"][group="11"]', this.filter).each(function(){
					$(this).attr('checked', 'checked');
					$(this).parents('div.option_row').addClass('selected');
				});
			}
			if (group == "11") {
				$('li[name="10"] .option_row').removeClass('selected');
				$('input[value="any"][group="10"]', this.filter).each(function(){
					$(this).attr('checked', 'checked');
					$(this).parents('div.option_row').addClass('selected');
				});
			}
			if (group == "20") {
				$('li[name="21"] .option_row').removeClass('selected');
				$('input[value="any"][group="21"]', this.filter).each(function(){
					$(this).attr('checked', 'checked');
					$(this).parents('div.option_row').addClass('selected');
				});
			}
			if (group == "21") {
				$('li[name="20"] .option_row').removeClass('selected');
				$('input[value="any"][group="20"]', this.filter).each(function(){
					$(this).attr('checked', 'checked');
					$(this).parents('div.option_row').addClass('selected');
				});
			}
			if (group == "30") {
				$('li[name="31"] .option_row').removeClass('selected');
				$('input[value="any"][group="31"]', this.filter).each(function(){
					$(this).attr('checked', 'checked');
					$(this).parents('div.option_row').addClass('selected');
				});
			}
			if (group == "31") {
				$('li[name="30"] .option_row').removeClass('selected');
				$('input[value="any"][group="30"]', this.filter).each(function(){
					$(this).attr('checked', 'checked');
					$(this).parents('div.option_row').addClass('selected');
				});
			}
		}
	}


	var newArrays = this.MakeNewArray();
	var resultArray= newArrays[0];
	if(newArrays.length>1) {
		for(var i=1,AL=newArrays.length;i<AL;i++){
			resultArray = getIntersect(resultArray,newArrays[i]);
		}
		//если кликнули на дизебнутый вариант - обнуляем все выбранные на "любой"
		if(resultArray.length===0 && el) {
			var inputs = $('input[value="any"]:not([name="'+el.name+'"])',this.filter);
			$(inputs).attr('checked', 'checked');
			$(inputs).each(function(){
				$(this).parents('ul').find('div[class*="option_row selected"]').removeClass('selected');
				$(this).parents('div.option_row').addClass('selected');
			});
			newArrays = this.MakeNewArray();
			resultArray= newArrays[0];
		}
	}
	this.FilterClicked = true;
	this.GetFlightsToShow(resultArray);

};
DrawResults.prototype.MakeNewArray = function(){
	var inputs = $(this.filter).find('input:not([value="any"]):checked');
	var newArrays = [];
	for(var i=0,EL=inputs.length;i<EL;i++) {
		var curInput = inputs[i];
		var curGroup = $(curInput).attr('group');
		var dirNumber = parseInt(curGroup.substring(0,1),10);
		var dirType = parseInt(curGroup.substring(1),10);
		var FlightType = (dirType===0)?"Dep":"Arr";
		if(String(curInput.name).indexOf('from_') !=-1 || String(curInput.name).indexOf('to_') !=-1 ) {
			newArrays.push( this.FDirections[dirNumber][FlightType + "Points"][curInput.value].list );
		} else {
			newArrays.push( this.FDirections[dirNumber][FlightType + "Times"][curInput.value].list );
		}
	}
	return newArrays;
};


DrawResults.prototype.initFlightsDifficulties = function(){
	var self = this;
	this.$FlightsDifficulties = $('.FlightsDifficulties');

	if(this.DirectFlightArrayIndex.length==this.allFlightArrayIndex.length){
		this.$FlightsDifficulties.addClass('invisible');
		this.$FlightSliderBlock.addClass('invisible');
		this.showFlightsDifficulties = false;
	} else {
		this.showFlightsDifficulties = true;
	}

	$('.d_option', this.$FlightsDifficulties).delegate('div[class*="d_direction"]:not(.selected):not(.disabled)', 'click', function() {
		if(self.QuickSandProcess) {return;}
		$(this).addClass('selected').siblings().removeClass('selected');
		self.SelectedDirectRoutes = $(this).hasClass('d_last');

		if( self.SelectedDirectRoutes ) {
			fadeOutBlock(self.$FlightSliderBlock);
			self.FilterFareSorting();
		} else {
			if(!self.hideSlider) fadeInBlock(self.$FlightSliderBlock);
			self.FilterFareSorting();
		}
	});

};


DrawResults.prototype.GetFlightsToShow = function(arr){
	var self = this;
	if(this.SelectedDirectRoutes) {
		this.FlightsToShowIndex = this.DirectFlightArrayIndex;
	} else {
		 this.FlightsToShowIndex = this.allFlightArrayIndex;
	}

	if( arr && arr.length ){
		this.FlightsToShowIndex = getIntersect(this.FlightsToShowIndex,arr);
	}

	//если клик про списку АК и альянсов
	if(this.AKListClicked) {
		this.FlightsToShowIndex = getIntersect(this.FlightsToShowIndex,this.OperatedAKarray);
	}

	//если выбраны прямые и выбрано что-то в фильтре и в результате нет пересечений
	if(this.FlightsToShowIndex.length===0){
		this.SelectedDirectRoutes = false;
		this.FlightsToShowIndex = getIntersect(this.allFlightArrayIndex,arr);
	}

	this.currentViewDirectFlightsCount = 0;
	this.currentViewTransportFlightsCount = 0;
	this.FlightsToShow=[];
	//первичные коэф
	var TimeonDirect = -1;
	for(var i=0,FL=this.FlightsToShowIndex.length;i<FL;i++){
		var curFlight = this.oFlights[this.FlightsToShowIndex[i]];
		if(curFlight.direct && curFlight.SeatAvl) { //второе условие для безместных вариантов - макс коефициент ставим
			if(TimeonDirect === -1) {
				TimeonDirect = curFlight.coefT;
			}
			curFlight.coefS = parseFloat( (curFlight.coefP*this.sliderTime/100 + TimeonDirect*(100-this.sliderTime)/100).toFixed(5) );
			this.currentViewDirectFlightsCount++;
		} else {
			curFlight.coefS = parseFloat( (curFlight.coefP*this.sliderTime/100 + curFlight.coefT*(100-this.sliderTime)/100).toFixed(5) );
			this.currentViewTransportFlightsCount++;
		}

		if (curFlight.AmountFare > 0) {
			this.FlightsToShow.push(curFlight);
		}
	}

	if(this.currentViewDirectFlightsCount===0) {
		$('.d_last',this.$FlightsDifficulties).addClass('disabled').removeClass('selected');
		$('.d_first',this.$FlightsDifficulties).addClass('selected');
		//fadeInBlock(this.FlightSliderBlock);
		this.$FlightsDifficulties.removeClass('invisible');
		this.showFlightsDifficulties = true;
	} else {
		$('.d_last',this.$FlightsDifficulties).removeClass('disabled');
	}

	if(!this.AKListClicked && this.showAKfilter) {
		this.refreshOperatedAK();
		for(var i =0, FL= this.FlightsToShow.length;i<FL;i++){
			var curFlight = this.FlightsToShow[i];
			this.updateOperatedAK(curFlight);
		}
		this.drawOperatedAK();
	}
	this.GetPreferedFlights();
	this.SortFlightsBlock();
	if(this.FilterClicked || this.AKListClicked) {
		this.DrawPreferedFlights();
	}
	this.AKListClicked = false;
	this.FilterClicked = false;
};
DrawResults.prototype.WriteCoefs = function(){
	var self = this;
	var TimeonDirect = -1;
	for(var i=0,FL=this.FlightsToShow.length;i<FL;i++){
		var curFlight = this.FlightsToShow[i];
		if(!!curFlight.direct && curFlight.SeatAvl) { //второе условие для безместных вариантов - макс коефициент ставим
			if(TimeonDirect === -1) {
				TimeonDirect = curFlight.coefT;
			}
			curFlight.coefS = parseFloat( (curFlight.coefP*this.sliderTime/100 + TimeonDirect*(100-this.sliderTime)/100).toFixed(5) );
		} else {
			curFlight.coefS = parseFloat( (curFlight.coefP*this.sliderTime/100 + curFlight.coefT*(100-this.sliderTime)/100).toFixed(5) );
		}
	}
};
DrawResults.prototype.ResortAKFlights = function(){
	var self = this;
	//сортировка для selection1 ниже
	this.FlightsToShow.sort(self.SortBySlider);
	this.VisibleAK = {};
	this.FilteredFlightsToShow = [];
	for(var i=0,FL=this.FlightsToShow.length;i<FL;i++){
		var curFlight = this.FlightsToShow[i];
		if(!this.VisibleAK[curFlight.AK+'_'+curFlight.direct+'_'+curFlight.combined]) {
			this.VisibleAK[curFlight.AK+'_'+curFlight.direct+'_'+curFlight.combined] = {counter:0, list:[]};
			//this.FilteredFlightsToShow.push(curFlight); //убрано для selection1
		}
		this.VisibleAK[curFlight.AK+'_'+curFlight.direct+'_'+curFlight.combined].counter++;
		this.VisibleAK[curFlight.AK+'_'+curFlight.direct+'_'+curFlight.combined].list.push(curFlight);
	}
	//selection1 - выбираем перелёты с самым ранним вылетом туда и поздним вылетом обратно
	for(var i in this.VisibleAK){
		var curAKList = self.VisibleAK[i].list;
		//if(curAKList.length>0) {
			/*убираем из выборки префереды*/
				if(self.PreferedFlightsIndex && $.inArray(curAKList[0].FlightIndex,self.PreferedFlightsIndex) > -1) {
					self.VisibleAK[i].counter--;
					curAKList.splice(0,1);
					self.VisibleAK[i].prefered = true;
				} else {
					self.VisibleAK[i].prefered = false;
				}
				if(self.VisibleAK[i].counter === 0) {
					continue;
				}

			// neededFlight - перелёт который будет отображаться на карточке
			var neededFlight = curAKList[0];
			var sliderCoef = neededFlight.coefS;
			var priceCoef = neededFlight.coefP;

			for(var j=1, TL = curAKList.length; j<TL; j++){
				var curFlight = curAKList[j];
				if(sliderCoef == curFlight.coefS) {
					var f_firstFlightTrips = neededFlight.TripIds;
					var f_startTrip = f_firstFlightTrips[0][0];
					var f_lastTrip = f_firstFlightTrips[f_firstFlightTrips.length-1][0];
					var f_startTimeTrip = self.obj.json.trps[f_startTrip].stTm;
					var f_lastTimeTrip = self.obj.json.trps[f_lastTrip].stTm;

					var firstFlightTrips = curFlight.TripIds;
					var startTrip = firstFlightTrips[0][0];
					var lastTrip = firstFlightTrips[firstFlightTrips.length-1][0];
					var startTimeTrip = self.obj.json.trps[startTrip].stTm;
					var lastTimeTrip = self.obj.json.trps[lastTrip].stTm;

					// если перелёт подходит нам по цене
					if (priceCoef <= curFlight.coefP) {
						if (curFlight.totalJourneyTime < neededFlight.totalJourneyTime) {
							// перелёт короче = лучше
							neededFlight = curFlight;
						} else if (curFlight.totalJourneyTime == neededFlight.totalJourneyTime) {
							// перелёт такой же по длительности,
							// смотрим может быть вылет туда пораньше,
							// или вылет обратно попозже.
							// обратно = последний перелёт, если наборный

							if(parseInt(startTimeTrip,10) < parseInt(f_startTimeTrip,10) ) {
								// туда пораньше = лучше
								neededFlight = curFlight;
							} else if( parseInt(f_startTimeTrip,10) == parseInt(startTimeTrip,10) ){
								// туда - так же, может быть обратно попозже?
								if (parseInt(lastTimeTrip, 10) > parseInt(f_lastTimeTrip, 10)) {
									neededFlight = curFlight;
								}
							} else {
								break;
							}
						}
					}
				} else {
					break;
				}
			}
			if (neededFlight.AmountFare > 0) {
				self.FilteredFlightsToShow.push(neededFlight);
			}
		/*} else {
			self.FilteredFlightsToShow.push(curAKList[0]);
		}*/
	}
	//после удаления префередов и selection1 - пересортировка, если не удалять и не ставить условия, сортировку можно не делать
	this.FilteredFlightsToShow.sort(self.SortBySlider);
};
DrawResults.prototype.SortFlightsBlock = function(){
	var self = this;
	this.ResortAKFlights();

	/*если мелких =0 и то прячем слайдер и выставляем флаг для предотвращения загрузки баннера */
		if(this.FilteredFlightsToShow.length === 0) {
			this.$FlightSliderBlock.fadeOut(600);
			this.sliderIsHidden = true;
			$('#adfox_149338202293756741').fadeOut(600);
			$('#adfox_149372426490853653').fadeOut(600);
			$('#adfox_151316275269946661').fadeOut(600);
			$('#adfox_151316283859067709').fadeOut(600);
		} else {
			this.$FlightSliderBlock.fadeIn(600);
			this.sliderIsHidden = false;
			$('#adfox_149338202293756741').fadeIn(600);
			$('#adfox_149372426490853653').fadeIn(600);
			$('#adfox_151316275269946661').fadeIn(600);
			$('#adfox_151316283859067709').fadeIn(600);
		}
	//commercial
		if(this.commercialLoaded){
			var adFlight = {commercial: true, direct: 0, AK:'commercial', combined: 0, FlightIndex: 111111};
			this.VisibleAK["commercial_0_0"] = {counter: 0};
			var secondPart = this.FilteredFlightsToShow.splice(1,this.FilteredFlightsToShow.length);
			this.FilteredFlightsToShow.push(adFlight);
			this.FilteredFlightsToShow = this.FilteredFlightsToShow.concat(secondPart);
		}

	this.Quicksand();
	this.checkCommercialTicket();
};
DrawResults.prototype.Quicksand = function(){
	var self = this;
	var temp_list = document.createElement('ul');
	for(i=0,FL=this.FilteredFlightsToShow.length;i<FL;i++) {
		var curFlight = this.FilteredFlightsToShow[i];
		var block = document.createElement('li');
		var dataId = curFlight.AK+'_'+curFlight.direct+'_'+curFlight.combined;
		block.id = curFlight.FlightIndex;
		$(block).attr('data-id',curFlight.FlightIndex);
		$(temp_list).append(block);
		this.ShowFlight(block,curFlight,{AK: this.VisibleAK[dataId], mini: true, commercial: curFlight.commercial});
	}
	$(this.QuickSandBlock).append(temp_list);
	this.QuickSandProcess=true;
	this.$FlightSlider.slider("disable");

	if(window.isSales === true && this.obj.json.primarySource === "skyscanner" && !$('.ss_link').length) {
		var ssImgName = "ss_img" + Math.round( Math.random() );
		$(this.FilterResult).prepend( '<a href="http://www.skyscanner.ru/" target="_blank" class="ss_link"><div class="' +ssImgName+ '"></div></a>' );
	}

	$(this.FlightsBlock).quicksand( $(temp_list).find('li'), function(){
		self.QuickSandProcess = false;

		self.$FlightSlider.slider("enable");
		$(temp_list).remove();
		self.initAKvariants(self.FlightsBlock);
	});
};
DrawResults.prototype.checkCommercialTicket = function(){
	var self = this;
	if(this.sliderIsHidden || this.commercialShown || this.FlightsToShow.length < 4) {
		return;
	}
	var oneWayConfig = {
		containerId: 'adfox_151316283859067709',
		pp: 'h',
		ps: 'cprt',
		p2: 'fpbh',
	};
	var twoWaysConfig = {
		containerId: 'adfox_151316275269946661',
		pp: 'h',
		ps: 'cprt',
		p2: 'fpbh',
	}
	if (~window.location.href.indexOf('www.onetwotrip')) {
		oneWayConfig.containerId = 'adfox_149338202293756741';
		oneWayConfig.ps = 'cmgk';

		twoWaysConfig.containerId = 'adfox_149372426490853653';
		twoWaysConfig.ps = 'cmgk';
	}

	//promocode banner
	if(this.obj.json.searchResultMessages && this.obj.json.searchResultMessages.BANNER_PROMO_CENTER) {
		if(!this.commercialLoaded) {
			//добавление контейнера для промо
			this.commercialLoaded = true;
			this.SortFlightsBlock();
		} else if(!this.commercialShown) {
			//показ промо
			var image = '<img src="/images/promo/500code.png" alt="" title="Введите промокод на форме| бронирования перелёта"/>';
			$(this.OneWay ? '#' + oneWayConfig.containerId : '#' + twoWaysConfig.containerId).html( image ).find('img').tooltip();
			this.commercialShown = true;
		}
	} else {

		if(this.TwoWays || this.OneWay){
			var bannerId;

			if (this.OneWay) {
				bannerId = oneWayConfig.containerId;
			} else if (this.TwoWays) {
				bannerId = twoWaysConfig.containerId;
			}

			if(!this.commercialLoaded){
				try {
					$('.rotationBlock').remove();
					var tempCommercial = document.createElement('div');
					$(tempCommercial).addClass('invisible rotationBlock').attr('id', bannerId);
					$('body').append(tempCommercial);

					var from = this.obj.directions[0].from;
					var to = this.obj.directions[0].to;
					var targets = {
						countryFrom: ref.getCountryCode(from),
						cityFrom: ref.getCityCode(from),
						countryTo: ref.getCountryCode(to),
						cityTo: ref.getCityCode(to)
					};
					var keyword = [
						'O_CNT_' + targets.countryFrom,
						'O_CITY_' + targets.cityFrom,
						'D_CNT_' + targets.countryTo,
						'D_CITY_' + targets.cityTo
					];
					switch(this.obj.cs) {
						case 'B':
							keyword.push('CS_BUSINESS');
							break;
						case 'F':
							keyword.push('CS_FIRST');
							break;
						case 'W':
							keyword.push('CS_PREMIUM');
							break;
						default:
							keyword.push('CS_ECONOMY');
							break;
					}

					// Получение ключевого слова по направлению
					var tapPortugalKeyWord = getAdButlerKeywords('tapPortugal', targets.cityFrom, targets.cityTo);
					pushResultPromoKeyword(tapPortugalKeyWord);

					var emiratesKeyWord = getAdButlerKeywords('emirates', targets.cityFrom, targets.cityTo);
					pushResultPromoKeyword(emiratesKeyWord);

					var airFranceKeyWord = getAdButlerKeywords('airFrance', targets.countryFrom, targets.cityTo);
					pushResultPromoKeyword(airFranceKeyWord);

					var rzdCityKeyWord = getAdButlerKeywords('rzdCity', targets.cityFrom, targets.cityTo);
					pushResultPromoKeyword(rzdCityKeyWord);

					var rzdCountryKeyWord = getAdButlerKeywords('rzdCountry', targets.countryFrom, targets.countryTo);
					pushResultPromoKeyword(rzdCountryKeyWord);

					var rzdKeyWord = getAdButlerKeywords('rzd', targets.cityFrom, targets.cityTo);
					pushResultPromoKeyword(rzdKeyWord);

					var airEuropeKeyWord = getAdButlerKeywords('airEurope', targets.cityFrom, targets.cityTo);
					pushResultPromoKeyword(airEuropeKeyWord);

					var finAirKeyWord = getAdButlerKeywords('finAir', targets.cityFrom, targets.cityTo);
					pushResultPromoKeyword(finAirKeyWord);

					function pushResultPromoKeyword(KeyWord) {
						if (KeyWord) {
							keyword.push(KeyWord);
						}
					}

					try {
						var railwayKmqObj = {
							'avia_AirlinesQuantity': this.AKlist.count,
							'referrer': document.referrer
						};

						if (rzdCityKeyWord || rzdCountryKeyWord) {
							kmqRecord({name: "railways__promo__rotate", obj: railwayKmqObj});
						}
					} catch(e){}

					var options = {
						keyword: keyword,
						onload: function() {
							self.commercialLoaded = true;
							setTimeout(function(){
								self.SortFlightsBlock();
							},100);
						},
						needMeta: false,
						partnerAdfox: true,
					};

					if (this.OneWay) {
						adfoxInitComBlock({
							ownerId: 255389,
							containerId: oneWayConfig.containerId,
							pp: oneWayConfig.pp,
							ps: oneWayConfig.ps,
							p2: oneWayConfig.p2,
							pk: tw.partner ? tw.partner.partnerId : ''
						}, options);
					} else if (this.TwoWays) {
						adfoxInitComBlock({
							ownerId: 255389,
							containerId: twoWaysConfig.containerId,
							pp: twoWaysConfig.pp,
							ps: twoWaysConfig.ps,
							p2: twoWaysConfig.p2,
							pk: tw.partner ? tw.partner.partnerId : ''
						}, options);
					}
				} catch(e) {
					console.log('adFox banner error-->', e);
				}
			} else {
				if(!this.commercialShown){
					var railwayDeal = $('#' + bannerId);

					var railwayKismxObj = {
						'avia_AirlinesQuantity': this.AKlist.count,
						'referrer': document.referrer
					};
					railwayDeal.html( $('.rotationBlock').html() );
					this.commercialShown = true;
					railwayDeal[0].onclick = function () {
						kmqRecord({name: 'click__railways__promo__rotate', obj: railwayKismxObj});
					};
				}
			}
		}

	}
};
DrawResults.prototype.initAKvariants = function(ListBlock){
	var self = this;
	/*$('.showAKvariants').live('click',function(){
		self.MakeClickEvent(this);
	});*/
	$('.showAKvariants',ListBlock).each(function(){
		$(this).off('click').on('click',function(){
			self.MakeClickEvent(this);
			kmqRecord({name: 'show_more_variants'});
		});
	});
};
DrawResults.prototype.MakeClickEvent = function(div){
	var self = this;
	clearExtraElements();
	//т.к. фейд у нас 0.5 сек - убираем возможность повторного нажатия на элемент и в конце снова биндим клик
	if(div) {
		$(div).off('click');
		var opt = $(div).attr('opt').split('_');
		var AKcode = opt[0];
		var direct = parseInt(opt[1],10);
		var combined = parseInt(opt[2],10);
		this.selectedAK = {
			AK: AKcode,
			direct: direct,
			combined: combined
		};
	} else {
		//т.к. АК у нас одна то можем непосредственно из выборки брать необходимые значения
		this.selectedAK = {
			AK: self.allFlights[0].AK,
			direct: parseInt(self.allFlights[0].direct,10),
			combined: parseInt(self.allFlights[0].combined,10)
		};
	}
	//если по ссылке откуда-либо перешли сразу в АК
	if(tw.source){
		if(this.AKlist.list[tw.source.ak]){
/*			this.selectedAK = {
				AK: tw.source.ak,
				direct: (String(tw.source.dir) === 1) ? parseInt(tw.source.dir,10) : 0,
				combined: (String(tw.source.combined) === 1) ? parseInt(tw.source.combined,10) : 0
			};*/

			var src_ak = tw.source.ak;
			var src_direct = (String(tw.source.dir).length === 1) ? parseInt(tw.source.dir,10) : 0;
			var src_combined = (String(tw.source.comb).length === 1) ? parseInt(tw.source.comb,10) : 0;
			this.selectedAK = {
				AK: src_ak,
				direct: src_direct,
				combined: src_combined
			};

			this.ResortAKFlights();

			if(src_direct){
				//проверка если в source требуется директ, но нет ни некомбинированного директа ни комбинированного директа
				if (!this.VisibleAK[src_ak + "_1_0"] && !this.VisibleAK[src_ak + "_1_1"]) {
					this.selectedAK.direct = 0;
				}
				tw.source.dir = this.selectedAK.direct;
			} else {
				//проверка если в source требуется пересадочные, но нет ни некомбинированного пересадочного ни комбинированного пересадочного
				if(!this.VisibleAK[src_ak +"_0_0"] && !this.VisibleAK[src_ak +"_0_1"]) {
					this.selectedAK.direct = 1;
				}
				tw.source.dir = this.selectedAK.direct;
			}
			if(src_combined) {
				//проверка если требуется прямые рейсы и обязательно комбинированные, но нету такого и есть некомбинированный
				if(this.selectedAK.direct && !this.VisibleAK[src_ak + "_1_1"] && this.VisibleAK[src_ak + "_1_0"]) {
					this.selectedAK.combined = 0;
				}
				//проверка если требуется пересадочные рейсы и обязательно комбинированные, но нету такого и есть некомбинированный
				if(!this.selectedAK.direct && !this.VisibleAK[src_ak + "_0_1"] && this.VisibleAK[src_ak + "_0_0"]) {
					this.selectedAK.combined = 0;
				}
				tw.source.comb = this.selectedAK.combined;
			} else {
				//проверка если требуется прямые рейсы и обязательно НЕкомбинированные, но нету такого и есть комбинированный
				if(this.selectedAK.direct && !this.VisibleAK[src_ak + "_1_0"] && this.VisibleAK[src_ak + "_1_1"]) {
					this.selectedAK.combined = 1;
				}
				//проверка если требуется пересадочные рейсы и обязательно НЕкомбинированные, но нету такого и есть комбинированный
				if(!this.selectedAK.direct && !this.VisibleAK[src_ak + "_0_0"] && this.VisibleAK[src_ak + "_0_1"]) {
					this.selectedAK.combined = 1;
				}
				tw.source.comb = this.selectedAK.combined;
			}
		} else { //если только 1 АК в результате и != переходу
			tw.avia.popup.airline();
			tw.source = {
				route: window.location.hash.split('|')[0],
				ak: this.selectedAK.AK,
				dir: this.selectedAK.direct,
				comb: this.selectedAK.combined,
			};
		}
	} else {
		tw.source = {
			route: window.location.hash.split('|')[0],
			ak: self.selectedAK.AK,
			dir: self.selectedAK.direct,
			comb: self.selectedAK.combined
		};
	}
	this.selectedAK.tmpl={};
	this.selectedAK.Flights={};
	this.selectedAK.single = this.singleAK;
	//для случая когда есть разные перелёты но возвратный только 1 АК
		if(this.ShowRefundable) {
			this.selectedAK.single = false;
		}

	window.location.hash = tw.source.route + '|'+ tw.source.ak + '|' + tw.source.dir + "_" + tw.source.comb;
	if(this.FDirections.length<3){
		this.PrepareSimpleAKFlights();
	} else {
		this.PrepareAKFlights();
	}
	this.ClickedAKBlock = div;
	this.DrawSelectedAK();
};

DrawResults.prototype.DrawSelectedAK = function(){
	var self = this;
	this.AKinProcess = true; //for hashchange event

	$(this.AKFlightInformation).empty();
	this.$FlightsDifficulties.addClass('invisible');
		this._selectedAK = this.selectedAK; //for hashchange
		fadeOutBlock(this.ResultTable, function(){

			try{$("html,body").animate({scrollTop: 0});}catch(e){};/*xp+yachrome*/
			//$(self.AKFlightInformation).append('<div class="innerInfo"></div>');
			if(self.FDirections.length<3){
				$.tmpl('tmpl_newAirlineFlights', self.selectedAK, {directions: self.obj.directions}).prependTo( self.AKFlightInformation );
				//$('tr:odd',self.AKFlightInformation).addClass('odd');
				self.initSimpleAKEvents();
				if (self.selectedAK.showSort) {
					self.initSorting();
				}
				/*if(self.selectedAK.unavailable) {
					$('.opt6, .opt7',self.AKFlightInformation).addClass('invisible');
				} else if(!MinSeatsAvl(self.selectedAK.add.AKFlights[0].minDirSeatAvl)) {
					$('.opt6',self.AKFlightInformation).addClass('invisible');
				}*/
			} else {

				$.tmpl('tmpl_AirlineFlights', self.selectedAK, {directions: self.obj.directions}).prependTo( self.AKFlightInformation );
				self.initAKEvents();
			}
			if(!self.ClickedAKBlock) {
				if(self.selectedSeats==1) {
					$('.ReturnToResult',self.AKFlightInformation).addClass('invisible');
				}
			}
			fadeInBlock(self.AKFlightInformation,function() {
				self.isAKVisible = true;
				self.AKinProcess = false;
				self.setSimilarPriceButtonWidth();

				$('.ReturnToResult', self.AKFlightInformation).click(function(){
					self.toggleSliderState();
				});

				// перешли по клику в список вариантов
				if(self.ClickedAKBlock){
					$(self.ClickedAKBlock)
						.off('click')
						.on('click', function(){
							self.MakeClickEvent(this);
						});
					$('.ReturnToResult',self.AKFlightInformation).click(function(){
						self.DestroyAKFlights();
						self.isAKVisible = false;
						self.ClickedAKBlock = null;
						//$('.FlightsDifficulties').removeClass('invisible');
					});
				} else if(self.selectedSeats>1){
					$('.ReturnToResult',self.AKFlightInformation).click(function(){
						self.selectedSeats = 1;
						self.ClickedAKBlock = null;
						self.RedrawResults();
					});
				} else { // Открыли по ссылке напрямую
					$('.ReturnToResult',self.AKFlightInformation).click(function(){
						self.DestroyAKFlights();
						self.isAKVisible = false;
						self.ClickedAKBlock = null;
						//для случая когда есть разные перелёты но возвратный только 1 АК
							if(self.ShowRefundable){
								self.ShowRefundable = false;
								self.RedrawResults();
							}
					});
				}
			});
		});
}
DrawResults.prototype.MakeOnTimeDirectionInfo = function(curFlight, DirNum){
	var flightLate = "";
	var trip = this.obj.json.trps[curFlight.html_tmpl.flightInfo[DirNum]];
	if(trip) {
		var flightInfo = trip.flightInfo;
		if( flightInfo.delay && flightInfo.late && flightInfo.cancelled ) {
			flightLate= Math.round(100-flightInfo.delay.value-flightInfo.late.value-flightInfo.cancelled.value) + l10n.searchResult.block.ontime;
		}
	}
	return flightLate;
};
DrawResults.prototype.PrepareSimpleAKFlights = function(){
	var self = this;
	this.selectedAK.add = {
		startTime1:     {},
		startTime1type: "mixed",
		startTime2:     {},
		startTime2type: "mixed",
		rowsCount:      [],
		AKFlights:      {}
	};
	var selectedAK           = this.selectedAK;
	var selectedAKadditional = selectedAK.add;
	var curFlight;
	var curFlightTripIds;
	//выделяем лишь самые дешевые наборы
		for (var i = 0, FL = this.FlightsToShow.length; i < FL; i++) {
			curFlight = this.FlightsToShow[i];
			curFlightTripIds = curFlight.TripIds;
			if(curFlight.AK === selectedAK.AK && curFlight.direct === selectedAK.direct  && curFlight.combined === selectedAK.combined) {
				if(!selectedAKadditional.AKFlights[curFlightTripIds]) {
					selectedAKadditional.AKFlights[curFlightTripIds] = curFlight;
				}
				if(curFlight.AmountFare < selectedAKadditional.AKFlights[curFlightTripIds].AmountFare) {
					selectedAKadditional.AKFlights[curFlightTripIds] = curFlight;
				}
			}
		}
		var tempArr = [];
		for(var i in selectedAKadditional.AKFlights) {
			tempArr.push(selectedAKadditional.AKFlights[i]);
		}
		selectedAKadditional.AKFlights = tempArr;

	//noseat condition
	var noseatCount = 0;
	for(var seat_fi = 0, seat_fl = tempArr.length; seat_fi < seat_fl; seat_fi++) {
		if(tempArr[seat_fi].noseats) {
			noseatCount++;
		}
	}
	if(noseatCount === tempArr.length) {
		selectedAK.unavailable = true;
	}

	//для заголовка
	var directCount1 = 0;
	var directCount2 = 0;
	var curItem;
	var minSeatsTrips;
	var curFlightHtml;
	var start1Count = 0;
	var start2Count = 0;
	for (var i = 0, FL = selectedAKadditional.AKFlights.length; i < FL; i++) {
		curFlight = selectedAKadditional.AKFlights[i];
		this.addTemplateInformation(curFlight);
		curFlightHtml = curFlight.html_tmpl;
		minSeatsTrips = MinSeatsAvl(curFlight.TripsSeatAvl);
		curItem = {
			flight:      curFlight,
			time:        curFlightHtml.StartTime[0].replace(":", ""),
			sortTime:    curFlightHtml.StartSortTime[0],
			journeyTime: curFlight.JourneyTime[0],
			minPrice:    curFlight.AmountFare,
			minSeats:    minSeatsTrips,
			plus:        "",
			oList:       {},
			flightCount: 0,
			flightLate:  self.MakeOnTimeDirectionInfo(curFlight, 0)
		};

		if(!selectedAKadditional.startTime1[ curFlightHtml.StartTime[0] ]) {
			selectedAKadditional.startTime1[ curFlightHtml.StartTime[0] ] = {};
		}
		//группируем по трипам в 1 сегменте (с пересадкой перелеты могут быть разными)
			if(!selectedAKadditional.startTime1[ curFlightHtml.StartTime[0] ][ curFlight.TripIds[0] ]) {
				selectedAKadditional.startTime1[ curFlightHtml.StartTime[0] ][ curFlight.TripIds[0] ] = curItem;
				start1Count++;
				if(curFlight.TripIds[0].length==1) {
					directCount1++;
				}
			}
		//тк мы уже выбрали только самые дешевые, то тут можно не проверять на стоимость и смело пихать в массив
			if(!selectedAKadditional.startTime1[ curFlightHtml.StartTime[0] ][ curFlight.TripIds[0] ].oList[curFlight.TripIds]){
				selectedAKadditional.startTime1[ curFlightHtml.StartTime[0] ][ curFlight.TripIds[0] ].oList[curFlight.TripIds] = curFlight;
				selectedAKadditional.startTime1[ curFlightHtml.StartTime[0] ][ curFlight.TripIds[0] ].flightCount++;
			}

		//minPrice by first trips
			if(curFlight.AmountFare < selectedAKadditional.startTime1[ curFlightHtml.StartTime[0] ][ curFlight.TripIds[0] ].minPrice) {
				selectedAKadditional.startTime1[curFlightHtml.StartTime[0]][curFlight.TripIds[0]].flight     = curFlight;
				selectedAKadditional.startTime1[curFlightHtml.StartTime[0]][curFlight.TripIds[0]].minPrice   = curFlight.AmountFare;
				selectedAKadditional.startTime1[curFlightHtml.StartTime[0]][curFlight.TripIds[0]].flightLate = self.MakeOnTimeDirectionInfo(curFlight, 0);
			}
		//minSeats by all trips
			/*if(minSeatsTrips != selectedAKadditional.startTime1[ curFlightHtml.StartTime[0] ][ curFlight.TripIds[0] ].minSeats){
				selectedAKadditional.startTime1[ curFlightHtml.StartTime[0] ][ curFlight.TripIds[0] ].plus = "+";
			}*/
			if(minSeatsTrips !== 0 && minSeatsTrips < selectedAKadditional.startTime1[ curFlightHtml.StartTime[0] ][ curFlight.TripIds[0] ].minSeats) {
				selectedAKadditional.startTime1[ curFlightHtml.StartTime[0] ][ curFlight.TripIds[0] ].minSeats = minSeatsTrips;
			}

		if(self.TwoWays){
			var curSecondItem = {
				flight:      curFlight,
				time:        curFlightHtml.StartTime[1].replace(":", ""),
				sortTime:    curFlightHtml.StartSortTime[1],
				journeyTime: curFlight.JourneyTime[1],
				minPrice:    curFlight.AmountFare,
				firstTrips:  curFlight.TripIds[0],
				minSeats:    minSeatsTrips,
				plus:        "",
				oList:       {},
				flightLate:  self.MakeOnTimeDirectionInfo(curFlight, 1)
			};
			if(!selectedAKadditional.startTime2[ curFlightHtml.StartTime[1] ]) {
				selectedAKadditional.startTime2[ curFlightHtml.StartTime[1] ] = {};
			}
			if(!selectedAKadditional.startTime2[ curFlightHtml.StartTime[1] ][ curFlight.TripIds[1] ]) {
				selectedAKadditional.startTime2[ curFlightHtml.StartTime[1] ][ curFlight.TripIds[1] ] = curSecondItem;
				start2Count++;
				if(curFlight.TripIds[1].length==1) {
					directCount2++;
				}
			}
			if(!selectedAKadditional.startTime2[ curFlightHtml.StartTime[1] ][ curFlight.TripIds[1] ].oList[curFlight.TripIds]){
				selectedAKadditional.startTime2[ curFlightHtml.StartTime[1] ][ curFlight.TripIds[1] ].oList[curFlight.TripIds] = curFlight;
			}
			//minPrice by second trips
				if(curFlight.AmountFare < selectedAKadditional.startTime2[ curFlightHtml.StartTime[1] ][ curFlight.TripIds[1] ].minPrice) {
					selectedAKadditional.startTime2[curFlightHtml.StartTime[1]][curFlight.TripIds[1]].flight     = curFlight;
					selectedAKadditional.startTime2[curFlightHtml.StartTime[1]][curFlight.TripIds[1]].minPrice   = curFlight.AmountFare;
					selectedAKadditional.startTime2[curFlightHtml.StartTime[1]][curFlight.TripIds[1]].firstTrips = curFlight.TripIds[0];
					selectedAKadditional.startTime2[curFlightHtml.StartTime[1]][curFlight.TripIds[1]].flightLate = self.MakeOnTimeDirectionInfo(curFlight, 1);
				}
			//minSeats by second trips
				/*if(minSeatsTrips != selectedAKadditional.startTime2[ curFlightHtml.StartTime[1] ][ curFlight.TripIds[1] ].minSeats) {
					selectedAKadditional.startTime2[ curFlightHtml.StartTime[1] ][ curFlight.TripIds[1] ].plus = "+";
				}*/
				if(minSeatsTrips !== 0 && minSeatsTrips < selectedAKadditional.startTime2[ curFlightHtml.StartTime[1] ][ curFlight.TripIds[1] ].minSeats) {
					selectedAKadditional.startTime2[ curFlightHtml.StartTime[1] ][ curFlight.TripIds[1] ].minSeats = minSeatsTrips;
				}

		}
	}
	//для заголовка в таблице
		if(start1Count === directCount1) {
			selectedAKadditional.startTime1type = "direct";
		} else if(directCount1===0){
			selectedAKadditional.startTime1type = "stops";
		}
		if(start2Count === directCount2) {
			selectedAKadditional.startTime2type = "direct";
		} else if(directCount2===0){
			selectedAKadditional.startTime2type = "stops";
		}
	//для шаблонизатора - кол-во строк
		var rows = (start1Count>start2Count)?start1Count:start2Count;
		while(rows >0){
			selectedAKadditional.rowsCount.push(1);
			rows--;
		}

	var tempStart1 = [];
	var tempStart2 = [];
	var curItems;
	for (var i in selectedAKadditional.startTime1) {
		curItems = selectedAKadditional.startTime1[i];
		for(var j in curItems){
			tempStart1.push(curItems[j]);
		}
	}
	for (var i in selectedAKadditional.startTime2) {
		curItems = selectedAKadditional.startTime2[i];
		for(var j in curItems){
			tempStart2.push(curItems[j]);
		}
	}
	selectedAK.showSort = !!((tempStart1.length > 1 || tempStart2.length > 1) && !selectedAK.unavailable);
	selectedAKadditional.startTime1 = tempStart1;
	selectedAKadditional.startTime2 = tempStart2;
	if(selectedAK.showSort){
		//кука сортировка вариантов одной АК
		/*		var cookieAKsort = readCookie('AKsort');
		 this.selectSortBlock = (cookieAKsort && cookieAKsort!=="")?cookieAKsort:"ByPrice";
		 if(this.selectSortBlock =="ByPrice") {
		 self.AKsortByPrice();
		 } else if(this.selectSortBlock =="ByDeparture") {
		 self.AKsortByDeparture();
		 } else {
		 self.AKsortByTimeFlight();
		 }*/
		self.AKsortByPrice();
	} else {
		self.AKsortByTimeFlight();
	}

	for(var i=0, SL = selectedAKadditional.startTime1.length; i<SL; i++) {
		curItem = selectedAKadditional.startTime1[i];
		addProperties(curItem);
	}
	for(var i=0, SL = selectedAKadditional.startTime2.length; i<SL; i++) {
		curItem = selectedAKadditional.startTime2[i];
		addProperties(curItem);
	}
	function addProperties(currentItem){
		currentItem.DiffPriceCount=0;
		var Prices = {};
		for(var j in currentItem.oList) {
			var curFlight = currentItem.oList[j];
			if(!Prices[curFlight.AmountFare]) {
				Prices[curFlight.AmountFare] = 1;
				currentItem.DiffPriceCount++;
			}
		}
		if(currentItem.DiffPriceCount>1) {
			if(tw.language == 'az') {
				currentItem.DiffPriceText = formatMoney(currentItem.minPrice) + l10n.searchResult.filters.priceFrom + "&thinsp;" + l10n.currency[tw.currency].Symbol;
			} else {
				currentItem.DiffPriceText = l10n.searchResult.filters.priceFrom + " " + formatMoney(currentItem.minPrice);
			}
		} else {
			currentItem.DiffPriceText = formatMoney(currentItem.minPrice);
		}
	}
};
DrawResults.prototype.PrepareAKFlights = function(){
	var self = this;
	for (var i = 0, FL = this.FlightsToShow.length; i < FL; i++) {
		var curFlight = this.FlightsToShow[i];
		if(curFlight.AK == this.selectedAK.AK && curFlight.direct == this.selectedAK.direct ) {
			this.addTemplateInformation(curFlight);
			if(!self.selectedAK.tmpl[curFlight.FareId]) {
				self.selectedAK.tmpl[curFlight.FareId] = {AmountFare: curFlight.AmountFare, allDirs: [], FareId: curFlight.FareId};
			}
			for(var DirIndex=0,DirLength=self.allDirectionsLength;DirIndex<DirLength;DirIndex++){
				if(!self.selectedAK.tmpl[curFlight.FareId]['dir'+DirIndex]) {self.selectedAK.tmpl[curFlight.FareId]['dir'+DirIndex] = {}}
				if(!self.selectedAK.tmpl[curFlight.FareId]['dir'+DirIndex][curFlight.TripIds[DirIndex]]) {
					//self.selectedAK.tmpl[curFlight.FareId]['dir'+DirIndex][curFlight.TripIds[DirIndex]] = curFlight;
					self.selectedAK.tmpl[curFlight.FareId]['dir'+DirIndex][curFlight.TripIds[DirIndex]] = {};
					if(!self.selectedAK.tmpl[curFlight.FareId].allDirs[DirIndex]) {
						self.selectedAK.tmpl[curFlight.FareId].allDirs[DirIndex] = {DirNum:DirIndex, list:[], column: {
							direct: false,
							stops: false,
							mixed: false
						}};
					}
					if(!curFlight.StartTime) {
						curFlight.StartTime = [];
						for(var Tindex =0, TL=curFlight.TripIds.length;Tindex<TL;Tindex++) {
							curFlight.StartTime.push( self.obj.json.trps[curFlight.TripIds[Tindex][0]].stTm );
						}
					}
					self.selectedAK.tmpl[curFlight.FareId].allDirs[DirIndex].list.push(curFlight);
					//смотрим с пересадкой или прямые или смешаные
						if(!self.selectedAK.tmpl[curFlight.FareId].allDirs[DirIndex].column.mixed) {
							if(curFlight.TripIds[DirIndex].length>1) {
								self.selectedAK.tmpl[curFlight.FareId].allDirs[DirIndex].column.stops = true;
							} else {
								self.selectedAK.tmpl[curFlight.FareId].allDirs[DirIndex].column.direct = true;
							}
							if(self.selectedAK.tmpl[curFlight.FareId].allDirs[DirIndex].column.stops && self.selectedAK.tmpl[curFlight.FareId].allDirs[DirIndex].column.direct) {
								self.selectedAK.tmpl[curFlight.FareId].allDirs[DirIndex].column.mixed = true;
							}
						}
				}
			}
			self.selectedAK.Flights[curFlight.FareId + "_" + curFlight.TripIds] = curFlight;
		}
	}
	var sortIndex = 0;
	var SortByStartTime = function(a,b){
		return a.StartTime[sortIndex] - b.StartTime[sortIndex];
	};
	var arr = [];
	for(var k in this.selectedAK.tmpl) {
		var curVariants = self.selectedAK.tmpl[k];
		for(var j=0,DL=curVariants.allDirs.length;j<DL;j++){
			sortIndex = j;
			curVariants.allDirs[j].list.sort(SortByStartTime);
		}
		arr.push(self.selectedAK.tmpl[k]);
	}
	this.selectedAK.tmpl = arr;
	this.selectedAK.tmpl.sort(self.SortByAmountFareAsc);
	arr = SortByStartTime = sortIndex=null;
};
DrawResults.prototype.initSimpleAKEvents = function(){
	var self = this;
	if(this.FDirections.length == 2) {
		$('input:radio',this.AKFlightInformation).change(function(){
			self.initSimpleAKTripSelectionEvents(this);
			self.setSimilarPriceButtonWidth();
		});
		//для выбора сразу варианта-строки с мин ценой
		var minPriceRoute = 10000000000;
		var minPriceRow = 0; //номер выбранный по умолчанию
		//случай для безместных
		var firstStart = this.selectedAK.add.startTime1;
		var firstCount = 0;
		var firstLength = firstStart.length;
		while( firstCount < firstLength ) {
			if( firstStart[firstCount].minSeats !== 0 ) {
				minPriceRow = firstCount;
				break;
			}
			firstCount++;
		}

		/*for (var i = 0, FL = this.selectedAK.add.startTime1.length; i < FL; i++) {
			if(this.selectedAK.add.startTime1[i].minPrice < minPriceRoute ) {
				minPriceRoute = this.selectedAK.add.startTime1[i].minPrice;
				minPriceRow = i;
			}
		}*/
		/*if (tw.source && tw.source.fn) {
			var flightsDir = tw.source.fn.split("-");
			var FlightsNumbersArray = [];
			for (FlightsDirectionIndex = 0, FDlength = flightsDir.length; FlightsDirectionIndex < FDlength; FlightsDirectionIndex++) {
				FlightsNumbersArray[FlightsDirectionIndex] = [];
				var flightsNum = flightsDir[FlightsDirectionIndex].split(",");
				for( var FlightsIndex =0, FlightsLength = flightsNum.length;FlightsIndex<FlightsLength;FlightsIndex++){
					var curFlightNum = flightsNum[FlightsIndex];
					FlightsNumbersArray[FlightsDirectionIndex].push( curFlightNum );
				}
			}
			var ConfirmFlight;
			for (var FlightIndex = 0, FlightsLength = this.allFlights.length; FlightIndex < FlightsLength; FlightIndex++) {
				var curFlight = this.allFlights[FlightIndex];
				if( String(curFlight.FlightNumbers) == String(FlightsNumbersArray)) {
					ConfirmFlight = curFlight;
					break;
				}
			}
			this.initSimpleAKTripSelectionEvents( $('input:radio',self.AKFlightInformation)[minPriceRow] );
			if(ConfirmFlight){
				FareConfirmation({FlightIndex: ConfirmFlight.FlightIndex, passengerCount: tw.source.pas});
			}
		} else*/
		if(tw.source && tw.source.time && self.AKlist.list[tw.source.ak]){
			var list = $('tr[time]',self.AKFlightInformation);
			var row = $('tr[time="'+tw.source.time+'"]',self.AKFlightInformation);
			if(row.length>0){
				this.initSimpleAKTripSelectionEvents( $('input:radio',self.AKFlightInformation)[$(list).index(row)] );
			} else {
				tw.avia.popup.time();
				delete tw.source;
				this.initSimpleAKTripSelectionEvents( $('input:radio',self.AKFlightInformation)[minPriceRow] );
			}
		} else {
			this.initSimpleAKTripSelectionEvents( $('input:radio',self.AKFlightInformation)[minPriceRow] );
		}
	} else {
		for (var i = 0, FL = this.selectedAK.add.startTime1.length; i < FL; i++) {
			var curFlight = this.selectedAK.add.startTime1[i].flight;
			var selectedTrip = document.getElementById(String(curFlight.TripIds[0]));
			var selectedRow = $(selectedTrip).parents('tr')[0];
			var CellPriceButton = $('.cellButton',selectedRow);
			var $PriceButton = $('.price_button',CellPriceButton);

			$PriceButton.attr('flight',curFlight.FlightIndex);
			if( curFlight.html_tmpl.PromoPrice ) {
				$('.amount', $PriceButton).html(curFlight.html_tmpl.PromoPrice);
			} else {
				$('.amount', $PriceButton).html(curFlight.html_tmpl.Price);
			}
			$PriceButton.off('click').click(function(){
				FareConfirmation({FlightIndex: $(this).attr('flight')});
			});
			self.simpleAKTripStars(curFlight,selectedRow);
			$('.PriceButtonWrapper',CellPriceButton).removeClass('hideButton');
		}
	}
};
DrawResults.prototype.initSorting = function(){
	var self = this;
	this.RedrawOptions = $('.RedrawOptions', this.AKFlightInformation)[0];
	$(this.RedrawOptions).removeClass('invisible');
	if(this.selectSortBlock =="ByPrice") {
		$('span[data-sort="byPrice"]',this.RedrawOptions).addClass('selected');
	} else if(this.selectSortBlock =="ByDeparture") {
		$('span[data-sort="ByDeparture"]',this.RedrawOptions).addClass('selected');
	} else {
		$('span[data-sort="byTravelTime"]',this.RedrawOptions).addClass('selected');
	}
	$(this.RedrawOptions).delegate('span:not(.selected):not(.disabled)', 'click', function(){
		if( $(this).attr('data-sort') == 'byPrice' ) {
			self.AKsortByPrice();
		} else if( $(this).attr('data-sort') == 'ByDeparture' ) {
			self.AKsortByDeparture();
		} else {
			self.AKsortByTimeFlight();
		}
		self.DrawSelectedAK();
		//кука сортировка перелётов одной АК
/*		setCookie({
			name: "AKsort",
			value: self.selectSortBlock,
			days: 180
		});*/
	});
	//delete tw.source;
};
DrawResults.prototype.AKsortByPrice = function(){
	var self = this;
	var ByPrice = function(a,b){
	    if(a.minPrice == b.minPrice){
			return a.sortTime - b.sortTime;
	    }
	    return a.minPrice - b.minPrice;
	};
	this.selectedAK.add.startTime1.sort(ByPrice);
	this.selectedAK.add.startTime2.sort(ByPrice);
	this.selectSortBlock = "ByPrice";
};
DrawResults.prototype.AKsortByTimeFlight = function(){
	var self = this;
	var ByTimeFlight = function(a,b){
	    if(a.journeyTime == b.journeyTime){
			return a.sortTime - b.sortTime;
	    }
	    return a.journeyTime - b.journeyTime;
	};
	this.selectedAK.add.startTime1.sort(ByTimeFlight);
	this.selectedAK.add.startTime2.sort(ByTimeFlight);
	this.selectSortBlock = "ByTimeFlight";
};
DrawResults.prototype.AKsortByDeparture = function(){
	var self = this;
	var ByDeparture = function(a,b){
		return a.sortTime - b.sortTime;
	};
	this.selectedAK.add.startTime1.sort(ByDeparture);
	this.selectedAK.add.startTime2.sort(ByDeparture);
	this.selectSortBlock = "ByDeparture";
};
DrawResults.prototype.setSimilarPriceButtonWidth = function(){
	//устанавливаем одинаковую ширину кнопок по максимальному значению в выборке
	var $priceButtons = $('.cellButton .price_wrapper');
			$priceButtons.css({"width":"auto"});

	$('.alternate').css({"display": "none"});
	var maxWidth = 0;

	$priceButtons
		.each(function(){
			var curWidth = $(this).width();
			if( curWidth > maxWidth ) {
				maxWidth = curWidth;
			}
		})
		.each(function(){
			$(this).css({ width: maxWidth });
			var $priceWrapper = $(this).parents('.PriceButtonWrapper');
			if( $priceWrapper.hasClass('hideButton') ) {
				$priceWrapper.find('.alternate').css({"display": "block"});
			}
		});
};


DrawResults.prototype.initSimpleAKTripSelectionEvents = function(input){
	var LeftList = $('.simpleVariants .variant_direction');
	$(LeftList).removeClass('selected');
	//$('.m_row_item',LeftList).removeClass('selected');
	//$(input).parents('.m_row_item').addClass('selected');
	$(input).parents('td.variant_direction').addClass('selected');
	$('.simpleVariants .PriceButtonWrapper').addClass('hideButton');
	var RightList = $('.variant');
	$(RightList).removeClass('selected');
	$('.opt6',RightList).html('');

	var FirstTripIds = input.id;
	for (var i = 0, FL = this.selectedAK.add.AKFlights.length; i < FL; i++) {
		var curFlight = this.selectedAK.add.AKFlights[i];
		if (curFlight.TripIds[0] == FirstTripIds) {
			var selectedTrip = document.getElementById(String(curFlight.TripIds[1]));
			$(selectedTrip).addClass('selected');
			var CellPriceButton = $(selectedTrip).parents('tr').find('.cellButton');

			var $PriceButton = $('.price_button',CellPriceButton);
			$PriceButton.attr('flight', curFlight.FlightIndex);
			if( curFlight.html_tmpl.PromoPrice ) {
				$('.amount', $PriceButton).html(curFlight.html_tmpl.PromoPrice);
			} else {
				$('.amount', $PriceButton).html(curFlight.html_tmpl.Price);
			}
			if(curFlight.SeatAvl) {
				if(curFlight.SeatAvl === 1) {
					$('.opt6', selectedTrip)
						.html('<span class="red">' + curFlight.SeatAvl + '+</span>');
				} else {
					$('.opt6', selectedTrip)
						.html(curFlight.SeatAvl+"+");
				}
			} else {
					$('.opt6', selectedTrip)
						.html("&ndash;");
			}
			$PriceButton
				.off('click')
				.on('click', function(){
					FareConfirmation({FlightIndex: $(this).attr('flight')});
				});

			$('.PriceButtonWrapper',CellPriceButton).removeClass('hideButton');
			if(curFlight.noseats) {
				$(CellPriceButton).addClass('noSeatCell');
				$(selectedTrip).addClass('noSeatCell');
			} else {
				$(CellPriceButton).removeClass('noSeatCell');
				$(selectedTrip).removeClass('noSeatCell');
			}
		}
	}


	var spline = $(input).parents('td').find('.Vspline');
	var leftTop =-1;
	for(var i =0, LC= LeftList.length; i<LC; i++) {
		if( $(LeftList[i]).hasClass('selected') ){
			leftTop = i;
			break;
		}
	}
	var rightTop =-1;
	var rightBottom =-1;
	var rightSelected =0;
	for(var i =0, LC= RightList.length; i<LC; i++) {
		if( $(RightList[i]).hasClass('selected') ){
			rightSelected++;
			if(rightTop== -1) {
				rightTop = i;
			}
			rightBottom = i;
		}
	}
	var top, bottom;
	//TODO rewrite
	if(leftTop === rightTop || leftTop < rightTop) {
		top = 13;
	} else {
		top = 14 -(leftTop - rightTop)*61;
	}
	if (leftTop === rightBottom || leftTop > rightBottom) {
		bottom = 13;
	} else {
		bottom = 13 -(rightBottom - leftTop)*61;
		if(rightSelected >4) {
			bottom-= Math.floor(rightSelected/4);
		}
	}
	$(spline).css({
		"top": top,
		"bottom": bottom
	});
};


DrawResults.prototype.initAKEvents = function(){
	var self = this;
	/*$('tbody[fr]',this.AKFlightInformation).each(function(){
		var FareId= $(this).attr('fr');
		self.AKTripStars(FareId);
	});*/

	$('.single',this.AKFlightInformation).each(function(){
		var row = this;
		var input = $('input',row)[0];
		if (input) {
			var Findex = $(input).attr('findex').split('_');
			var DirNum = $(row).attr('di');
			var Flight = self.oFlights[Findex];
			var seats = MinSeatsAvl(Flight.TripsSeatAvl[DirNum]);
			var CurTrips = input.id.split('_')[1];
			//для тайтла  рейсы-рейс считаем кол-во трипов по направлению
			var arr = [];
			var trps= CurTrips.split(',');
			for(var j=0,TL=trps.length;j<TL;j++) {
				if(trps[j]!==''){
					arr.push(trps[j]);
				}
			}

			var obj = {
				flightInfo: self.MakeFlightInfos(String(CurTrips)),
				SeatAvl: seats,
				FlightIndex: Flight.FlightIndex,
				TripIds: arr,
				DirNum: DirNum,
				html_tmpl: {}
			};

			obj.html_tmpl.flightInfo = obj.flightInfo.noInfo ? [] : [1] ;
			obj.html_tmpl.stars = (self.obj.json.trps[CurTrips.split(',')[0]].stars/2).toFixed(1);
			obj.html_tmpl.halfstar= 0;

			var stars = obj.html_tmpl.stars;
			obj.html_tmpl.stars = Math.floor(stars.split('.')[0]);
			if(stars.split('.')[1] >= 3 && stars.split('.')[1] < 7) {
				obj.html_tmpl.halfstar= 1;
			}
			if(stars.split('.')[1]>7) {
				obj.html_tmpl.stars+= 1;
			}
			obj.html_tmpl.emptystars = (5-obj.html_tmpl.stars - obj.html_tmpl.halfstar)*14;
			obj.html_tmpl.stars = obj.html_tmpl.stars*14;

			var TripsStars= $('.TripsStars',row)[0];
			$.tmpl('tmpl_TripsStars', obj).prependTo(TripsStars);
		}
	});

	$('input:radio',this.AKFlightInformation).change(function(){
		var tbody = $(this).parents('tbody');
		$('.m_row_item',tbody).removeClass('selected');
		$(this).parents('div.m_row_item').addClass('selected');
		var FareId = this.id.split('_')[0];
		//self.AKTripStars(FareId);
	});

	$('.price_button', this.AKFlightInformation).each(function(){
		var $priceButton = $(this);
		$priceButton.off('click').click(function(){
			FareConfirmation({ FareId: $priceButton.attr('data-fareid'), AKflight: true });
		});
	});
	//MakeFlightInfos(String(curFlight.TripIds));
};


DrawResults.prototype.simpleAKTripStars = function(curFlight,row){
	var TripsStars= $('.TripsStars',row)[0];
	$(TripsStars).empty();
	$.tmpl('tmpl_TripsStars', curFlight).prependTo(TripsStars);
	TripsStars=null;
};
/*DrawResults.prototype.AKTripStars = function(id){
	var FareId = id;
	var inputs = $(this.AKFlightInformation).find('.content input[id^="'+FareId+'_"]:checked');
	var selectedTrips = "";
	for(var i=0,IL=inputs.length;i<IL;i++){
		var curTrips = inputs[i].id.split('_')[1];
		if(i!==0) {selectedTrips+=",";}
		selectedTrips+=curTrips;
	}
	var resultSelectedFare = this.selectedAK.Flights[FareId+"_"+selectedTrips];
	var StarsContent = $('#fareCell_'+FareId)[0];
	var TripsStars= $('.TripsStars',StarsContent)[0];
	$(TripsStars).empty();
	$.tmpl('tmpl_TripsStars', resultSelectedFare).prependTo(TripsStars);
	//
	FareId=null;
	inputs=null;
	selectedTrips=null;
	StarsContent=null;
	TripsStars=null;
	resultSelectedFare=null;
};*/


DrawResults.prototype.DestroyAKFlights = function(){
	var self = this;
	//если подробные билеты выбраны
	clearExtraElements();
	if(this.selectedAK) {
		this.AKinProcess = true;
		/*$(self.AKFlightInformation).fadeOut(500, function(){
			$('.innerInfo',self.AKFlightInformation).remove();
			self.selectedAK = null;
			//$(self.FlightSliderBlock).fadeIn(500);
			//$(self.FlightsDifficulties).fadeIn(500);
			//$(self.ResultTable).fadeIn(500);
				fadeInBlock(self.FlightSliderBlock);
				fadeInBlock(self.FlightsDifficulties);
				fadeInBlock(self.ResultTable);
		});*/
		delete tw.source;
		window.location.hash = window.location.hash.split('|')[0];
		fadeOutBlock(self.AKFlightInformation, function(){
			self.AKinProcess = false;
			self.selectedAK = null;

			$('.multivariants',self.AKFlightInformation).remove();
			if(!self.SelectedDirectRoutes && !self.hideSlider && !self.sliderIsHidden){
				fadeInBlock(self.$FlightSliderBlock);
			}
			//fadeInBlock(self.FlightsDifficulties);
			if(self.showFlightsDifficulties){
				self.$FlightsDifficulties.removeClass('invisible');
			}
			fadeInBlock(self.ResultTable);
			PlanePositioning();
		});
	}
};


DrawResults.prototype.MakeFlightInfos = function(TripIds, isAKinfo){
	var tripNumbers = TripIds.split(',');
	var FlightInfos=[];
	var ageAbs = true;
	for(var i=0,TL=tripNumbers.length;i<TL;i++){
		if(!!tripNumbers[i] && this.obj.json.trps[tripNumbers[i]].flightInfo) {
			FlightInfos.push(this.obj.json.trps[tripNumbers[i]].flightInfo);
			if(!this.obj.json.trps[tripNumbers[i]].ageAbs) {
				ageAbs=false;
			}
		}
	}
	var html_tmpl = {};
	html_tmpl.flightInfo = {
		count: {
			ages: 0,
			delay: 0,
			delay15:0,
			delay30:0,
			late: 0,
			cancelled: 0,
			seatPitchE: 0,
			seatPitchB: 0,
			seatsmaxPE: 0,
			seatsminPE: 0,
			seatsmaxPB: 0,
			seatsminPB: 0
		}
	};
	var curFlightInfo;
	var curProperty;
	var curStars;
	var stars;
	var halfstars;
	var seat = {
		seatPitchE: true,
		seatPitchB: true,
		seatsmaxPE: true,
		seatsminPE: true,
		seatsmaxPB: true,
		seatsminPB: true
	};
	if (FlightInfos.length > 0) {
		var tempAgeAbs;
		for (var j = 0, FL = FlightInfos.length; j < FL; j++) {
			curFlightInfo = FlightInfos[j];
			for (var i in curFlightInfo) {
				curProperty = curFlightInfo[i];
				//html_tmpl.flightInfo.count[i] =1;
				if (!html_tmpl.flightInfo[i]) {
					html_tmpl.flightInfo[i] = {
						stars: parseInt(curProperty.stars,10),
						value: parseInt(curProperty.value,10)
					};
				} else {
					if ( html_tmpl.flightInfo[i].stars < parseInt(curProperty.stars,10) ) {
						html_tmpl.flightInfo[i].stars = parseInt(curProperty.stars,10);
					}
					if ( html_tmpl.flightInfo[i].value < parseInt(curProperty.value,10) ) {
						html_tmpl.flightInfo[i].value = parseInt(curProperty.value,10);
					}
				}

				if(i==="ages"){
					if(!tempAgeAbs) {
						tempAgeAbs = html_tmpl.flightInfo[i].value;
					} else if(tempAgeAbs != html_tmpl.flightInfo[i].value){
						ageAbs = false;
					}
				}
			}
		}
		for (var j in html_tmpl.flightInfo) {
			curProperty = html_tmpl.flightInfo[j];
			if (j !== "count") {
				curStars = String(curProperty.stars / 2).split('.');
				stars = curStars[0];
				halfstars = curStars[1] ? 1 : 0;
				curProperty.width = {};
				curProperty.width.stars = stars * 14;
				curProperty.width.halfstar = halfstars * 14;
				curProperty.width.emptystars = (5 - stars - halfstars) * 14;
			}
		}
	} else {
		html_tmpl.flightInfo.noInfo =true;
	}
	html_tmpl.flightInfo.ageAbs = ageAbs;
	if(this.obj.cs == "E"){
		delete html_tmpl.flightInfo.seatPitchB;
		delete html_tmpl.flightInfo.seatsmaxPB;
		delete html_tmpl.flightInfo.seatsminPB;
	} else if(this.obj.cs == "B"){
		delete html_tmpl.flightInfo.seatPitchE;
		delete html_tmpl.flightInfo.seatsmaxPE;
		delete html_tmpl.flightInfo.seatsminPE;
	}
	return html_tmpl.flightInfo;
};

DrawResults.prototype.addNewDesignLink = function() {
	var self = this;
	var json = (this.obj && this.obj.json) || {};
	var messages = json.searchResultMessages || {};

	if (!messages.SHOW_NEWSERP_LINK) {
		return;
	}

	$('<button class="newDesignLink">'
		+ l10n.newDesign.text
		+ '<div class="newDesignLinkWrap"><div class="newDesignLinkBadge">NEW</div></div>'
        + '</button>'
	).bind('click', function() {
		kmqRecord({name: 'serp_goto_new_design'});
		setCookie({
			name: 'serpVersion',
			value: '300',
			withoutDomain: true,
			days: 7
		});
		objAvia.goToNewSerp(self.obj);
	}).prependTo( $('.FlightFilter')[0] );
};

DrawResults.prototype.initDealSubscribes = function() {
	var msg,
		show = false,
		fare = this.stat.minSourceFare;
	var infMsgs = fare.infMsgs || [];
	var showPrize = false;
	for(var i = 1, l = infMsgs.length; i < l; i++) {
		msg = infMsgs[i];
		if(msg.cd === "SHOW_PRICE_ALERT_SUBSCRIPTION") {
			show = true;
			break;
		} else if(msg.cd === "SHOW_PRICE_ALERT_SUBSCRIPTION_2") {
			show = true;
			showPrize = true;
			break;
		}
	}

	if (objSearchForm && objSearchForm.data.cs !== 'E') {
		showPrize = false;
		show = false;
	}

	if(show && tw.language === "ru") {
		var minPrice = fare.prcInf.amt;
		var currency = fare.prcInf.cur;
		var oInfo = this.obj.directions;
		var firstDirection = oInfo[0];
		var secondDirection = oInfo[1];
		var route = window.location.hash.replace(/#/, '');
		var adtCount = tw.passengers.adult;
		var cnnCount = tw.passengers.children;
		var infCount = tw.passengers.infants;
		var adtAmountWC = fare.prcInf.adtAmountWC;
		var cnnAmountWC = fare.prcInf.cnnAmountWC;
		var infAmountWC = fare.prcInf.infAmountWC;
		var ccFee = fare.prcInf.ccFee;
		var markupFee = fare.prcInf.markupFee;

		var params = {
			from: firstDirection.from,
			to: firstDirection.to,
			fromDate: firstDirection.date,
			minPrice: minPrice,
			currency: currency,
			isoneway: !!this.OneWay,
			showPrize: showPrize,
			route: route,
			adtCount: adtCount,
			cnnCount: cnnCount,
			infCount: infCount,
			adtAmountWC: adtAmountWC,
			cnnAmountWC: cnnAmountWC,
			infAmountWC: infAmountWC,
			ccFee: ccFee,
			markupFee: markupFee,
		};
		if(!params.isoneway) {
			params.toDate = secondDirection.date;
		}

		this.dealSubscriber = new DealSubscribes(params);
		priceBounce(params);
	}
};

function DealSubscribes(options){
	var self = this;

	var eventName = 'priceAlert';

	if(options.type === "bounce") {
		eventName = 'priceAlertPopup';
		$.tmpl('tmpl_dealSubscribesBounce', options).appendTo( $('body')  );
		this.block = $('#priceBounce')[0];
	} else {
		try {
			ga('send', 'event', 'priceAlert', 'show');
		} catch(e) {
			log('price alert event error - no ggl script');
		}
		$.tmpl('tmpl_dealSubscribes', options).prependTo( $('.FlightFilter')[0] );
		this.block = $('.FlightFilter .dealSubscribes')[0];
	}

	var emailValue = (tw.visitor && tw.visitor.email ) ? tw.visitor.email : "";
	this.emailField = new Field({
		appendTo: $(".email", this.block)[0],
		name: "email",
		validate: false,
		value: emailValue,
		placeholder: "Email",
		type: "email"
	});

	//overwrite legacy
	this.emailField.drawHint = function(type){
		var self = this;
		this.removeHint();
		if ($(this.input).is(':visible') && (this.needHint || this.error || this.warn)) {
			var data = {
				type: this.options.type,
				className: "",
				error: false,
				errorType: null
			};

			if(this.error){
				data.className = "error";
				data.error = true;
				if(this.errorType){
					data.errorType = this.errorType;
				} else if(!this.value){
					data.errorType = "required";
				}
			} else if(this.warn) {
				data.className = "warn";
				data.warn = true;
				if(this.warnType){
					data.warnType = this.warnType;
				}
			}

			data.hintType = this.options.hintType||"";
			this.elHint = $.tmpl('tmpl_hint', data)[0];

			if (this.error) {
				setTimeout(function(){
					$(self.elHint).fadeOut(1000, function(){
						if (self.focus) {
							self.drawHint();
						} else {
							self.removeHint();
						}
					});
				}, 3000);
			} else if(this.warn){
				//overwrite legacy
				var newMsg = '<div class="abs"><div class="tl"></div><div class="tr"></div><div class="bl"></div><div class="br"></div><div class="t"></div><div class="r"></div><div class="b"></div><div class="l"></div><div class="c"></div><div class="arrUp"></div></div>';
				newMsg += 'Мы не смогли в автоматическом режиме<br/>проверить существование данного почтового ящика.';
				$(this.elHint).html( newMsg );

				setTimeout(function(){
					$(self.elHint).fadeOut(1000, function(){
						if (self.focus) {
							self.drawHint();
						} else {
							self.removeHint();
						}
					});
				}, 6000);
			}

			document.body.appendChild(this.elHint);
			var pos = $(this.input).offset();
			$(this.elHint).css({
				top: pos.top + self.input.offsetHeight + 5,
				left: pos.left + self.input.offsetWidth / 2 - self.elHint.offsetWidth / 2
			});
		}
	};

	var params = {
		from:     options.from,
		to:       options.to,
		minPrice: options.minPrice,
		currency: options.currency,
		fromDate: options.fromDate.format('ddmm'),
		route: options.route,
		adtCount: options.adtCount,
		cnnCount: options.cnnCount,
		infCount: options.infCount,
		adtAmountWC: options.adtAmountWC,
		cnnAmountWC: options.cnnAmountWC,
		infAmountWC: options.infAmountWC,
		ccFee: options.ccFee,
		markupFee: options.markupFee
	};
	if(options.toDate) {
		params.toDate = options.toDate.format('ddmm');
	}
	var ref = readCookie('referrer')||'';
	if(ref) {
		params.reseller = ref;
	}

	$('form', this.block).submit(function(e){
		e.preventDefault();
		var field = self.emailField;
		if (!reEmail.test(field.input.value) || field.input.value == "" || field.error) {
			field.addError();
			field.input.focus();
		} else {
			params.email = field.input.value;
			$.ajax({
				type: "get",
				dataType: 'json',
				url: '/_api/emailvalidator/validate/',
				data: {
					"email": params.email
				},
				timeout: 2000,
				success: function(json){
					if (json.isValid && json.isValid !== "UNKNOWN") {
						$.ajax({
							type: "get",
							dataType: 'json',
							url: "/_api/deals/subscribeToDeals",
							data: params,
							timeout: 5000,
							success: function(json) {
								if (json && json.error) {
									$('.dealSubscribes__wrapper__content').html(l10n.popup.systemComment);
									return;
								}
								$('.dealSubscribes__wrapper__content').html('Вы успешно подписались на рассылку лучших цен по данному направлению');
								try {
									ga('send', 'event', eventName, 'subscribe', ref);
								} catch(e) {
									log('price alert event error - no ggl script');
								}
							},
							error: function() {
								$('.dealSubscribes__wrapper__content').html(l10n.popup.systemComment);
							}
						});
					} else {
						self.emailField.addWarn();
						self.emailField.drawHint();
					}
				}
			});


		}
	});

}

function priceBounce(params) {
	if(!tw.pricebounce && tw.language === "ru" && ~['yandex_organic_seo', 'google_organic_seo', 'aviasales', 'momondo', 'biletyplus'].indexOf(readCookie('referrer')) ) {
		params.type = "bounce";
		tw.pricebounce = true;
		new DealSubscribes(params);

		tw.pricebounce = ouibounce( $('#priceBounce')[0], {
			aggressive: true,
			timer: 5000,
			callback: function() {
				try {
					ga('send', 'event', 'priceAlertPopup', 'show');
				} catch(e) {
					log('price alert event error - no ggl script');
				}
				removePopup();
			}
		});
		$('body #priceBounce .close_button').on('click', function() {
			$('#priceBounce').hide();
			tw.pricebounce.turnOff();
		});
	}
}

DrawResults.prototype.initAdviser = function(){
	if(this.showAdviser) {
		this.adviser = new Adviser();
		this.adviser.isoneway = !!this.OneWay;
		this.adviser.iscities = true;
		for(var i = 0, l = this.obj.directions.length; i<l; i++) {
			var curDir = this.obj.directions[i];
			if(!ref.Cities[curDir.from] || !ref.Cities[curDir.to]) {
				this.adviser.iscities = false;
				break;
			}
		}
		this.adviser.from = this.obj.directions[0].from;
		this.adviser.to = this.obj.directions[0].to;
		this.adviser.MinPrice = this.stat.minPrice;
		this.adviser.directMinPrice = this.stat.directMinPrice;
		this.adviser.show();
	}
};


function Adviser(){
	var self = this;
	$.template( 'tmpl_TeaserAdviser', $("#tmpl_TeaserAdviser").trim());
	$.template( 'tmpl_Adviser', $("#tmpl_Adviser").trim());

	this.wrapper = $('#aboutAdviser')[0];
	if(!this.wrapper) {
		return;
	}
	this.loading = false;
}


Adviser.prototype.SortByPrice = function(a,b){
	return a.amountInVewCur-b.amountInVewCur;
};


Adviser.prototype.show = function(){
	var self = this;
	var cityText = "";

	if( this.iscities ){
		if(this.isoneway) {
			cityText = l10n.adviser.filter_html.city1;
			cityText = cityText.replaceByHash({
				from: ref.getCityName(self.from)
			});
		} else {
			cityText = l10n.adviser.filter_html.city2;
			cityText = cityText.replaceByHash({
				from: ref.getCityName(self.from),
				to:  ref.getCityName(self.to)
			});
		}
	}
	$(this.wrapper).empty();
	$.tmpl('tmpl_TeaserAdviser', {clsContent: (this.isoneway)? "small":"", iscities: this.iscities, isoneway: this.isoneway, from: this.from, to: this.to, text: cityText}).appendTo( self.wrapper );

	var hash = (decodeURI(document.location.hash)).substr(1).split("|")[0];
	hash = hash;
	if (hash === '') return;
	$(this.wrapper).slideDown(700);

	function MakeWord(intI, isNom){
		var text;
		var num = String(intI);
		var last = num.substring(num.length-1,num.length);
		last = parseInt(last, 10);
		if(last == 1 && num.length == 1) {
			text = l10n.adviser.nights[0];
		} else if(last == 1) {
			text = l10n.adviser.nights[1];
		} else {
			text = l10n.adviser.nights[2];
		}
		if(isNom) {
			if(last == 1) {
				text = l10n.adviser.nights[0];
			} else if(last >1 && last<5) {
				text = l10n.adviser.nights[1];
			} else {
				text = l10n.adviser.nights[2];
			}
		}
		return text;
	}
	var requestOptions = {
		repeats: 1,
		backupRepeats: true,
		RetryFunction: function(){
			MakeRequest();
		},
		ErrorFunction: function(){
			self.show();
			self.loading=false;
			self.show();
		}
	};
	var force_abort = false;
	var $priceDynamic = $('.priceDynamic',this.wrapper);
	$priceDynamic.on('click', function(){
		MakeRequest();
	});

	function MakeRequest(){
		if (!hash) return;
		var splitHash = hash.split('&');
		var params = {
			route: splitHash.shift(),
			ad: 1,
			cs:  $.inArray('B',splitHash) > -1 ? "B" : $.inArray('F',splitHash) > -1 ? 'F' : 'E'
		};

		var minPricetoShow = self.MinPrice;
		if( $('div[class*="chooseRoutes"]').length > 0 ) {
			if( $('div[class*="chooseRoutes"]:not(.selected)').hasClass('direct') ) {
				params.maxStops = 0;
				minPricetoShow = self.directMinPrice;
			}
		} else if (tw.oResult && tw.oResult.SelectedDirectRoutes) {
			params.maxStops = 0;
			minPricetoShow = self.directMinPrice;
		}
		kmqRecord({name:"ViewDynPrice", obj:tw.searchFlight, prefix: 'DYN'});

		$.ajax({
			type: "get",
			dataType: "json",
			url: "/_api/searching/flexfares/",
			data: params,
			timeout: 40000,
			beforeSend: function(xhr){
				if ( $('.Adviser_preload').length === 0 ) {
					clearExtraElements();
					self.makeJump = false;
					self.loading = true;
					if (!readCookie("dynamic")) {
						setCookie({
							name: "dynamic",
							value: "1",
							days: 360
						});
					}
					addPopup({
						className: "Adviser_preload",
						close_button: true
					});
					appendLoader({
						appendTo: $('.popup')[0],
						text: l10n.adviser.priceSearch
					});
					$('.popup .close_button').click(function(){
						force_abort = true;
						removeLoader();
						xhr.abort();
					});
				}
			},
			success: function(json){
				if(!tw.oResult) {
					removePopup();
					self.loading = false;
					return;
				}
				var flex = json;
				flex.search = hash;
				aviaData = objAvia.parseKey(flex.search);
				flex.isoneway = self.isoneway;
				var route = self.from + '' + self.to;
				var direct = ( params.maxStops || params.maxStops === 0 );
				newdepartures = [];

				for(var di = 0, dl = flex.departures.length; di < dl; di++) {
					var curDep = flex.departures[di];
					if(curDep.prices && curDep.prices.length > 0) {
						newdepartures.push(curDep);
					}
				}

				var firstDep = flex.departures[0];
				var firstDepLength = firstDep && firstDep.prices && firstDep.prices.length;
				if (!firstDepLength || (firstDepLength === 1 && $.isEmptyObject(firstDep.prices[0])) || newdepartures.length === 0) {
					removePopup();
					self.loading = false;

					var div = document.createElement('div');
					$.tmpl('tmpl_Adviser', flex, {direct: true, error: true}).appendTo(div);
					var popup = addPopup({
						dom: div,
						className: "Adviser color",
						domClass: "AdviserContent",
						close_button: true
					});

					if (flex.isoneway) {
						$('div[class*="chooseRoutes"]:not(.selected)',popup).click(function(){
							requestOptions.repeats = 1;
							MakeRequest();
						});
					}

					$('.scrollContent', popup).css("height",$('.scrollContent', popup).height());
					return;
				}
				flex.departures = newdepartures;
				var minDay = flex.departures[0].prices[0].days;
				var maxDay = flex.departures[0].prices[flex.departures[0].prices.length-1].days;

				for(var di = 0, dl = flex.departures.length; di < dl; di++) {
					var curDep = flex.departures[di];
					if(!curDep.prices) { continue; }
					curDep.oDate = new Date.parseAPI( curDep.date );

					for(var pi = 0, pl = curDep.prices.length; pi < pl; pi++){

						var curPrice = curDep.prices[pi];
						curPrice.oDate = new Date( curDep.oDate );
						curPrice.days = parseInt(curPrice.days || 0,10)+1;
						curPrice.daysWord = MakeWord(curPrice.days, 1);
						curPrice.oDate.setDate(curPrice.oDate.getDate() + curPrice.days);
						curPrice.amountInVewCur = Math.round( convertCurrency(curPrice.price, curPrice.cur, tw.currency) );
						if(self.isoneway) {
							curPrice.search = [
								curDep.oDate.format('ddmm'),
								route,
								params.cs != "E" ? '&' + params.cs : ''
							].join('');
						} else {
							curPrice.search = [
								curDep.oDate.format('ddmm'),
								route,
								curPrice.oDate.format('ddmm'),
								params.cs != "E" ? '&' + params.cs : ''
							].join('');
						}
					}

					curDep.prices.sort(self.SortByPrice);
				}


				flex.ow = l10n.adviser.htmlInfo.ow;
				var wayType = (flex.isoneway)? l10n.adviser.ways[1] : l10n.adviser.ways[0]
				flex.ow = flex.ow.replaceByHash({
					cs: l10n.adviser.cls[params.cs],
					way: wayType
				});
				var dateFormats = {
					'en-us': 'mmmm d'
				};
				var dateFormat =  dateFormats[tw.language] || "d mmmm";
				var dateFrom = flex.departures[0].oDate.format(dateFormat);
				var dateTo = flex.departures[flex.departures.length-1].oDate.format(dateFormat);
				if(~['ru', 'ru-ua', 'uk-ua'].indexOf(tw.language)) {
					dateFrom = dateFrom.toLowerCase();
					dateTo = dateTo.toLowerCase();
				}
				if(!flex.isoneway) {
					flex.rt = l10n.adviser.htmlInfo.rt;
					flex.rt = flex.rt.replaceByHash({
						from: dateFrom,
						to: dateTo,
						dayOne: minDay,
						dayTwo: maxDay,
						dayWord: MakeWord( maxDay ),
						city: tw.oResult.FilterObject[0].Direction.To.Name
					});
				}


				var div = document.createElement('div');
				$.tmpl('tmpl_Adviser', flex, {direct: direct, MinPrice: minPricetoShow}).appendTo(div);
				var popup = addPopup({
					dom: div,
					className: "Adviser color",
					domClass: "AdviserContent",
					close_button: true
				});

				var headerColumns = $('.bottomBlock table.head tr:first-child td', popup);
				var contentColumns = $('.bottomBlock .scrollContent table tbody tr:first-child td', popup);

				for (ir = 0, lr = contentColumns.length; ir < lr; ir++) {
					if(ir == lr-1 ) { break; }
					var col = contentColumns[ir];
					var cellwidth = $(col).innerWidth();
					var pad = parseInt($(col).css("padding-left"), 10) + parseInt($(col).css("padding-right"), 10);
					cellwidth = cellwidth - pad;
					$(headerColumns[ir]).css('width', cellwidth)
				}

				$('.adviseMoreDays', popup).on('click', function(){
					var showRow = $(this).data('show');
					$(this).remove();
					$('.bottomBlock tr[data-info="'+showRow+'"]', popup).removeClass('invisible');
				});

				$('div[data-search],button[data-search]', popup).on('click',function() {
					var data = objAvia.parseKey($(this).data('search'));
					objAvia.changeRequest(objAvia.addDataToRequestsList(data));
					removePopup();
					tw.metaReturn && tw.metaReturn.reset();
				});

				if(String(flex.stops).indexOf('0') >-1) {
					$('div[class*="chooseRoutes"]:not(.selected)',popup).click(function(){
						requestOptions.repeats = 1;
						MakeRequest();
					});
				}

				$('.scrollContent', popup).css("height",$('.scrollContent', popup).height());

				self.loading = false;
			},

			complete: function(xhr){
				if(!force_abort){
					xhr.url = this.url;
					checkAjaxError(xhr,requestOptions);
				} else {
					force_abort = false;
				}
			}
		});
	}
};

/////////////////
function TicketFlightStars(){
	$('.fid').live('mouseenter click',function(e){
		var el = this;
		var fid = $(el).attr('fid');
		var id = el.id.split('_');
		var trips = $(el).attr('trips');

		if(e.type == "click") {
			if(infoBaloonHidden){
				try{
					showBaloon();
					infoBaloonHidden=false;
				} catch(e){}
			}
		} else {
			setTimeout( function(){
				if(infoBaloonHidden){
					var mouseTarget = mouseEvent.target;
					mouseTarget = ($(mouseTarget).hasClass('stars_block')|| !$(mouseTarget).parents('.stars_block')[0]) ? mouseTarget : $(mouseTarget).parents('.stars_block')[0];
					if($(mouseTarget).attr('fid') == fid || id){
						try{
							showBaloon();
						} catch(e){}
					}
				}
			},300);
		}
		showBaloon = function(){
			var AKstat = !!id[1];
			var TripsStat = !!trips;

			if(
				document.getElementById("stars_"+String(fid)) ||
				document.getElementById("stars_"+String(id))
			){
				return;
			}

			removeInfoBaloon();
			if( !$(el).hasClass('StarsInformation') && !AKstat){
				return;
			}
			var viewRating = 'flight';

			if(AKstat) {
				viewRating = 'airline';
				if(id[1].length>2){
					viewRating = 'alliance';
				}
				var FlightNumbers = id[2].split('-');
				var curAK = tw.oResult.OperatedAK[id[1]];

				var $baloon;
				if (!curAK.flightInfo) {
					curAK.flightInfo = [];
					for (var FlightIndx = 0, FlightsLength = FlightNumbers.length; FlightIndx < FlightsLength; FlightIndx++) {
						var curFlight = tw.oResult.oFlights[FlightNumbers[FlightIndx]];
						curAK.flightInfo[FlightIndx] = tw.oResult.MakeFlightInfos(String(curFlight.TripIds));
					}
					curAK.AKflightInfo = tw.oResult.MakeFlightInfos(String(curAK.TripIds), true);
				}
				$baloon = $.tmpl('tmpl_BaloonFlightStars', curAK);
				$baloon.attr('id',"stars_"+id).appendTo('body');
				var target = ($(e.target).hasClass('stars_block')|| !$(e.target).parents('.stars_block')[0]) ? e.target : $(e.target).parents('.stars_block')[0];
			} else if(TripsStat) {
				resultFlight = {
					flightInfo: tw.oResult.MakeFlightInfos(String(trips)),
					TripIds: trips
				}
				$baloon = $.tmpl('tmpl_BaloonFlightStars', resultFlight);
				$baloon.attr('id',"stars_"+fid).appendTo('body');
				var target = $(e.target).hasClass('stars_block') ? e.target : $(e.target).parents('.stars_block')[0];
			} else {
				var resultFlight = tw.oResult.oFlights[fid];
				if(!resultFlight.flightInfo) {
					resultFlight.flightInfo = tw.oResult.MakeFlightInfos(String(resultFlight.TripIds));
				}
				$baloon = $.tmpl('tmpl_BaloonFlightStars', resultFlight);
				$baloon.attr('id',"stars_"+fid).appendTo('body');
				var target = $(e.target).hasClass('stars_block') ? e.target : $(e.target).parents('.stars_block')[0];
			}

			//убираем звёзды в раскрытом и заголовок
			if( $(el).parents('.multivariants').length > 0 ){
				$('div[class*="info_"]',$baloon).addClass('invisible');
				$('div[class="ratingInfo"]',$baloon).addClass('invisible');
			}

			var $listContainer = $baloon.find('ul');

			var $agePropertyEl = $listContainer.find('li[data-info-name="ages"]').detach();
			//sorting from worst to best features of flight
			var sortedProps = $listContainer
				.find('li')
				.detach();

			$listContainer.append($agePropertyEl);
			$listContainer.append(sortedProps);

			var baloon_pos = $(target).offset();
			var top = baloon_pos.top - $baloon.height() - 27;
			if($(el).hasClass('revert') || AKstat){
				$baloon
					.addClass('revert')
					.css({
						left: baloon_pos.left - $baloon.width() + 50,
						top: top
					});
			} else {
				$baloon.css({
					left: baloon_pos.left,
					top: top
				});
			}
			if(top < $(window).scrollTop()+10) {
				$baloon.addClass('bottom').css({top: baloon_pos.top + 44});
			}
			fadeInBlock($baloon[0]);
			infoBaloonHidden = false;

			$(document.body).trigger({
				type: "showRating",
				view: viewRating
			});

 			$baloon = target = baloon_pos = FlightInfos = null;
		};
	});

	$('.fid')
		.die('mouseleave')
		.live('mouseleave',function(e){
			HideBaloonInfo();
		});

	$('.airport')
		.die('mouseleave')
		.live('mouseleave', function(e){
			HideBaloonInfo();
		});

	$('.stars_baloon')
		.die('mouseleave')
		.live('mouseleave', function(e){
			HideBaloonInfo();
		});

	function HideBaloonInfo(){
		setTimeout(function(){
			var mouseTarget = mouseEvent.target,
					  airportId,
					  baloonId;
			if($(mouseTarget).hasClass('stars_baloon') || $(mouseTarget).parents('.stars_baloon')[0]){
				return;
			} else if($(mouseTarget).hasClass('stars_block') || $(mouseTarget).parents('.stars_block')[0]){
				var el = $(mouseTarget).hasClass('stars_block')?mouseTarget: $(mouseTarget).parents('.stars_block')[0];
				if( $('#stars_'+ $(el).attr('fid')).length>0 ){
					return;
				} else {removeInfoBaloon();}
			} else if($(mouseTarget).hasClass('airport')) {
				airportId = $(mouseTarget).attr('id');
				baloonId = airportId ? airportId.replace('airport_', 'airportInfo_') : null;
				if (baloonId && $('#' + baloonId).length > 0) {
					return;
				} else {removeInfoBaloon();}
			} else {
				removeInfoBaloon();
			}
		},300);
	}
}

function getFareConfirmationParams(obj){
	var resultFlight;
	if (obj.AKflight) {
		var selectedTrips = "";
		var inputs = $('.FlightsByAKBlock .content input[id^="' + obj.FareId + '_"]:checked');
		for (var i = 0, IL = inputs.length; i < IL; i++) {
			var curTrips = inputs[i].id.split('_')[1];
			if (i !== 0) {
				selectedTrips += ",";
			}
			selectedTrips += curTrips;
		}
		resultFlight = tw.oResult.selectedAK.Flights[obj.FareId + '_' + selectedTrips];
		selectedTrips = null;
		input = null;
	} else if(obj.confirm){
		resultFlight = obj.confirm;
	} else {
		resultFlight = tw.oResult.oFlights[obj.FlightIndex];
	}
	var selectedFare = tw.oResult.oFares[resultFlight.FareId];
	var params = {
		gdsInfo: tw.oResult.obj.json.gdsInfs[selectedFare.gdsInf].hash,
		fareKey: selectedFare.frKey,
		routeKey: tw.oResult.obj.getKey(),
		trips: []
	};
	if(resultFlight.combined) {
		params.fareKeyRT = selectedFare.frKeyRT;
	}
	params.kmqSelection = obj.kmqSelection;
	//sirena
		if(selectedFare.extId) {
			params.extId = selectedFare.extId;
		}

		if(tw.bookingParams && tw.bookingParams.source){
			params.source = tw.bookingParams.source;
		}

		if(tw.bookingParams && tw.bookingParams.srcmarker){
			params.srcmarker = tw.bookingParams.srcmarker;
		}
	var arrTr = String(resultFlight.TripIds).split(',');
	var arrCls = [].concat.apply([], resultFlight.Classes);
	var arrFic = [].concat.apply([], resultFlight.Fics);
	var arrSrvCls = String(resultFlight.ServiceClasses).split(',');
	var arrSeats = String(resultFlight.TripsSeatAvl).split(',');
	for (var i = 0, l = arrTr.length; i < l; i++) {
		if (arrTr[i] === '') {
			break;
		}
		var trip = tw.oResult.obj.json.trps[arrTr[i]]
			trip.reservClass = arrCls[i];
			trip.fic = arrFic[i];
			trip.bg = getBgFieldFromFare(resultFlight, +arrTr[i], arrCls[i], arrSrvCls[i], false);
			trip.cbg = getBgFieldFromFare(resultFlight, +arrTr[i], arrCls[i], arrSrvCls[i], true);
			trip.serviceClass = arrSrvCls[i];
			trip.stAvl = arrSeats[i];
			trip.planeStr = tw.oResult.obj.json.planes[trip.plane];
		params.trips.push(trip);
	}
	selectedFare.stAvl = resultFlight.SeatAvl;
	if (resultFlight.sourceFare) {
		selectedFare.tripcoins = resultFlight.sourceFare.tripcoins;
		selectedFare.tripcoinsCurrency = resultFlight.sourceFare.tripcoinsCurrency;
	}

	params.FlightIndex = resultFlight.FlightIndex;
	params.DateCreated = tw.oResult.obj.DateCreated;
	if(obj.passengerCount) {params.passengerCount = obj.passengerCount;}
	params.Segments = arrTr.length;
	params.Operating = resultFlight.EveryTripAK;
	params.Marketing = resultFlight.EveryDirectionAK;
	params.BookingClass = resultFlight.Classes;
	params.Stops = 0;

	var srcmarker2 = readCookie('srcmarker2');
	if (srcmarker2) {
		params.srcmarker2 = srcmarker2;
	}

	for(var si=0, sl= resultFlight.StopTimes.length; si<sl; si++){
		params.Stops+= resultFlight.StopTimes[si].length;
	}

	var searchResultsHash = window.location.hash.split('|')[0];
	var backLink = window.location.pathname + window.location.search + searchResultsHash;

	return {
		resultFlight: resultFlight,
		params: params,
		fare: selectedFare,
		backLink: backLink
	};
}

function FareConfirmation(obj){
	try{$("html,body").animate({scrollTop: 0});}catch(e){};/*xp+yachrome*/
	//kmq
		var mark = $(obj.element).data('markclass');
		if (mark) {
			switch(mark){
				case 'reliable':
					kmqRecord({name: 'select_reliable_fare'});
					obj.kmqSelection = 'reliable';
					break;
				case 'time':
					kmqRecord({name: 'select_fastest_fare'});
					obj.kmqSelection = 'fastest';
					break;
				case 'price':
					kmqRecord({name: 'select_cheapest_fare'});
					obj.kmqSelection = 'cheapest';
					break;
				case 'price_direct':
					kmqRecord({name: 'select_cheapest_direct_fare'});
					obj.kmqSelection = 'cheapest_direct';
					break;
			}
		} else if(tw.oResult && tw.oResult.isAKVisible){
			kmqRecord({name: 'select_more_fare'});
			obj.kmqSelection = 'airline_more';
		} else {
			kmqRecord({name: 'select_fare_other'});
			obj.kmqSelection = 'other';
		}
		delete obj.element;

	try {
		FlightsBookAndPay.showPassengerSelect(
			getFareConfirmationParams(obj),
			obj.autoChoose
		);
	} catch (e) {
		if (typeof trackJs !== 'undefined') {
			trackJs.track('showPassengerSelect exception: ' + e.message);
		} else {
			console.log('showPassengerSelect exception: ' + e.message)
		}
	}
}


function FlightTariffDetails() {
	this.flightIndex = null;
	this.hasDetailsCash = {};

	var self = this;
	if (!('ontouchstart' in window || navigator.maxTouchPoints)) { // отключить для тачдейвайсов в связи с OTT-8274
		$(document).on({
			mouseenter: function(e) {
				self.handleMouseEnter(e);
			},
			mouseleave: function() {
				self.handleMouseLeave();
			},
			click: function() {
				self.handleMouseLeave();
			}
		}, '.price_button, #popup_passengerSelect .submit');
	}
}

FlightTariffDetails.prototype.getFlightIndex = function($button) {
	var flightIndex = null;
	if ($button.attr('data-flightIndex')) { // для кнопки Купить на основном экране поиска
		flightIndex = $button.attr('data-flightIndex');
	} else if ($button.attr('flight')) { // для кнопки Купить на экране "Ещё"
		flightIndex = tw.oResult.oFlights[$button.attr('flight')].FlightIndex;
	} else { // для кнопки продолжить на экране бронирования
		flightIndex = $button.parents('#popup_passengerSelect').find('.showTripInfo').attr('data-info');
	}

	return flightIndex;
};

FlightTariffDetails.prototype.prepareALRMsgs = function(sourceMsgs, airCmp) {
	var messages = [];

	if (tw.oResult.hideTariffTooltip) { // todo make for concrete
		return messages;
	}

	var skip = false; // temporary hotfix
	sourceMsgs.forEach(function(message) {
		if (message && ~message.indexOf('ALR_' + airCmp) && !~message.indexOf('ALR_AIRCMP_')) {
			if (skip) return;
			var text = '';

			var hasCabbinInfo = ~message.indexOf('CABBIN');
			var hasBaggageInfo = ~message.indexOf('BAGGAGE');
			if (hasCabbinInfo || hasBaggageInfo) {
				if (!~tw.language.indexOf('en')) {
					text += l10n.tariffDetails.baggageNorm + ': ';
				}

				if (hasCabbinInfo) {
					var cabbinInfo = /CABBIN_(\d+)/.exec(message) || [];
					text += l10n.tariffDetails.cabbinDetails.replaceByHash({
						cabbinWeight: cabbinInfo[1]
					});
				}
				if (hasBaggageInfo) {
					if (hasCabbinInfo) text += '. ';
					if (~message.indexOf('BAGGAGE_FEE')) { // платный багаж
						text += l10n.tariffDetails.baggageFee;
					} else {
						var baggageInfo = /BAGGAGE_(\d+)-(\d+)/g.exec(message) || [];
						text += l10n.tariffDetails.baggageDetails.replaceByHash({
							baggageQuantity: baggageInfo[1],
							baggageWeight: baggageInfo[2],
							placeDecled: declOfNum(baggageInfo[1], l10n.tariffDetails.placeDecl)
						});
					}
				}
			} else {  // для всех остальных сообщений
				var key = ~message.indexOf('_CLR') ? message.slice(0, message.indexOf('_CLR')) : message;
				text = l10n.tariffDetails[key.split('_' + airCmp).join('')];
			}

			var newMessage = {
				text: text,
				isHighlighted: ~message.indexOf('_CLR')
			};

			if (hasCabbinInfo || hasBaggageInfo) { // используются, чтобы понять, нужно ли искать инфу по багажу для тарифа
				newMessage.hasBaggageInfo = true;
			}

			messages.push(newMessage);
		} else if (~message.indexOf('ALR_AIRCMP_' + airCmp)) {
			skip = true;
		}
	});

	return messages;
};

FlightTariffDetails.prototype.prepareMsgs = function(rawMsgs) {
	var sourceMsgs = [];
	if (typeof rawMsgs[0] === 'object') {
		sourceMsgs = rawMsgs.map(function(msg) {
			return msg.cd;
		});
	} else if (typeof rawMsgs[0] === 'string') {
		sourceMsgs = rawMsgs;
	}

	return sourceMsgs;
};

// direction используется только для показа в Тикетах
FlightTariffDetails.prototype.getTariffInfo = function(sourceFare, airCmp, direction) {
	var self = this;

	var sourceMsgs = this.prepareMsgs(sourceFare.infMsgs);
	var messages = this.prepareALRMsgs(sourceMsgs, airCmp);

	var hasBaggageInfo = messages.some(function(msg) {
		return msg.hasBaggageInfo;
	});

	// добавление информации о багаже
	if (!hasBaggageInfo) {
		if (direction) { // для тикетов
			var someTripsHasNoBaggage = direction.trips.some(function(trip) {
				return trip.bg && self.isZeroBaggage(trip.bg);
			});

			if (someTripsHasNoBaggage) {
				messages.push(this.getNoBaggageMsg(true));
			}
		} else { // для тултипа на поиске
			var someDirsHasNoBaggage = null;
			var allDirsHasNoBaggage = null;
			sourceFare.dirs.forEach(function(dir) {
				if (dir.bg && self.isZeroBaggage(dir.bg)) {
					someDirsHasNoBaggage = true;
					if (allDirsHasNoBaggage !== false) {
						allDirsHasNoBaggage = true;
					}
				} else {
					allDirsHasNoBaggage = false;
				}
			});

			if (someDirsHasNoBaggage) {
				messages.push(this.getNoBaggageMsg(!allDirsHasNoBaggage));
			}
		}
	}

	return messages;
};

FlightTariffDetails.prototype.addTariffInfoToDirs = function(sourceFare, directions) {
	var tariffSourceMsgs = this.prepareMsgs(sourceFare.infMsgs);

	var tariffAirCmps = [];
	tariffSourceMsgs.forEach(function(msg) {
		if (~msg.indexOf('ALR_AIRCMP_')) {
			tariffAirCmps.push(msg.slice(-2));
		}
	});

	var json = (window.objAvia && window.objAvia.rawJSON) || {};
	var messages = json.searchResultMessages || {};

	// добавить к Дирекшену информацию о тарифе
	var self = this;
	directions.forEach(function(direction) {
		var firstAirCmp = direction.trips[0].airCmp;
		var hasTariffAirCmp = ~tariffAirCmps.indexOf(firstAirCmp) && direction.trips.every(function(trip) {
			return trip.airCmp === firstAirCmp;
		});

		if (hasTariffAirCmp) { // добавить
			direction.tariffMsgs = self.getTariffInfo(sourceFare, firstAirCmp, direction);
		} else {
			var hasNoBaggage = direction.trips.some(function(trip) {
				return trip.bg && self.isZeroBaggage(trip.bg);
			});
			if (hasNoBaggage) {
				direction.tariffMsgs = [self.getNoBaggageMsg()];
			}
		}

		var trip = direction.trips[0];

		var from = ref.getCityName(trip.from);
		var to = ref.getCityName(trip.to);

		if (firstAirCmp === 'S7' && tw.language === 'ru' && messages.S_1ST_A) {
			direction.jokes = jokes[from + '-' + to]
		}
	});
};

FlightTariffDetails.prototype.getNoBaggageMsg = function(someFlightsFlag) {
	return {
		text: someFlightsFlag ? l10n.tariffDetails.hasNoBaggageOnSomeFlights : l10n.tariffDetails.hasNoBaggage,
		isHighlighted: 1
	};
};

FlightTariffDetails.prototype.someDirsHasNoBaggage = function(directions, flight) {
	var self = this;
	var hasNoBaggage = directions.some(function(dir) {
		return dir.trips.some(function(trip) {
			return trip.bg && self.isZeroBaggage(trip.bg);
		});
	});

	if (!hasNoBaggage && flight) {
		var messages = this.prepareMsgs(flight.sourceFare.infMsgs);
		hasNoBaggage = messages.some(function(msg) {
			return ~msg.indexOf('BAGGAGE_FEE');
		});

	}

	return hasNoBaggage;
};

FlightTariffDetails.prototype.isZeroBaggage = function(bg) {
	return !!(bg.match(/^[a-zа-яё]*0+([a-zа-яё]|$)+/i));
};

FlightTariffDetails.prototype.handleMouseEnter = function(e) {
	var self = this;
	if (tw.oResult.hideTariffTooltip) { // todo make for concrete
		return false
	}

	var $button = $(e.currentTarget);
	this.flightIndex = this.getFlightIndex($button);

	if (!this.flightIndex) return;

	var flight = tw.oResult.oFlights[this.flightIndex];

	var singleValidatingAK = flight.EveryDirectionAK.every(function(airCmp, i, airCmps) { // одна валидирующая АК по всем Дирекшинам
		return i < airCmps.length - 1 ? airCmp === airCmps[i + 1] : true;
	});

	var someDirsHasNoBaggage = flight.sourceFare.dirs.some(function(dir) { // хотя бы один безбагажный тариф
		return dir.bg && self.isZeroBaggage(dir.bg);
	});

	if (singleValidatingAK || someDirsHasNoBaggage) {
		var messages = this.hasDetailsCash[this.flightIndex];
		if (!messages) {
			var sourceFare = flight.sourceFare || {};
			messages = this.getTariffInfo(sourceFare, flight.AK);
			this.hasDetailsCash[this.flightIndex] = messages;
		}

		if (messages.length) {
			var $popover = $($.tmpl('tmpl_FlightTooltip', {
				messages: messages,
				flightIndex: this.flightIndex
			}));

			$popover.appendTo('body').fadeIn(200);

			$popover.on('click', function() {
				FareConfirmation({FlightIndex: self.flightIndex});
			});

			var buttonPosition = $button.offset();
			var top = buttonPosition.top + $button.height() + 8;

			if($(window).scrollTop() + $(window).height() < top + $popover.height() + 10) {
				$popover
					.addClass('above')
					.css({
						top: buttonPosition.top - $popover.height() - $button.height() + 10,
						left: buttonPosition.left
					});
			} else {
				$popover
					.css({
						top: buttonPosition.top + $button.height() + 8,
						left: buttonPosition.left
					});
			}
		}
	}
};

FlightTariffDetails.prototype.handleMouseLeave = function() {
	$('.js-flightTooltipId-' + this.flightIndex).fadeOut(200, 'linear', function() {
		$(this).remove();
	});
	this.flightIndex = null;
};

function getBgFieldFromFare(fare, tripId, reservClass, serviceClass, cabinBaggage) {
	var dirs = fare.sourceFare.dirs || [],
		i, j;
	for (i = 0; i < dirs.length; i++) {
		var dir = dirs[i];
		for (j = 0; j < dir.trps.length; j++) {
			var trip = dir.trps[j];
			if ((trip.id === tripId) && (trip.cls === reservClass) && (trip.srvCls === serviceClass)) {
				if (cabinBaggage) {
					return dir.cbg || trip.cbg;
				}
				return dir.bg || trip.bg;
			}
		}
	}
}

function ShowTrip(FlightIndex,DirNum){
	var resultFlight = tw.oResult.oFlights[FlightIndex];
	var arrTrips = [];
	var arrTr = String(resultFlight.TripIds).split(',');
	var arrCls = [].concat.apply([], resultFlight.Classes);
	var arrFic = [].concat.apply([], resultFlight.Fics);
	var arrSrvCls = String(resultFlight.ServiceClasses).split(',');
	for (var i = 0, l = arrTr.length; i < l; i++) {
		if (arrTr[i] === '') {break;}
		var trip = tw.oResult.obj.json.trps[arrTr[i]];
			trip.srvCls = arrSrvCls[i];
			trip.cls = arrCls[i];
			trip.fic = arrFic[i];
			trip.bg = getBgFieldFromFare(resultFlight, +arrTr[i], arrCls[i], arrSrvCls[i], false);
			trip.planeStr = tw.oResult.obj.json.planes[trip.plane];
			arrTrips.push(trip);
	}
	arrDirections = [];
	tw.TripsForStars = {
		trps: arrTrips
	};
	function Direction(){
		this.trips = [];
		this.duration = 0;
	}
	var direction = new Direction();
	//var curDate = new Date().valueOf();
	for (var i = 0, length = arrTrips.length; i < length; i++) {
		var trip = arrTrips[i];
		trip.stDt_Date = Date.parseAPI(trip.stDt);
		trip.endDt_Date = new Date(trip.stDt_Date.getTime());
		if (trip.dayChg) {
			trip.endDt_Date.setDate(trip.endDt_Date.getDate() + trip.dayChg);
		}
		trip.stDt_Date.setAPITime(trip.stTm);
		trip.endDt_Date.setAPITime(trip.endTm);

		if (trip.bg && !resultFlight.lowcost) {
			// пустая строка, 0, 0NO, NO, 0PC => 'Багаж не включён в тариф'
			// 20K ...       => 20 кг
			// 1PC ...       => 1 место
			if (trip.bg.slice(-1) == "K") {
				trip.bgType = "K";
				trip.bg = trip.bg.slice(0, -1);
			}
			if (trip.bg.slice(-2) == "PC") {
				trip.bgType = "PC";
				trip.bg = trip.bg.slice(0, -2);
			}
			if (trip.bg === "0NO" || trip.bg === "NO") {
				trip.bg = "0";
				trip.bgType = "PC";
			}
		}

		try {
			if(!trip.html_tmpl) {
				trip.html_tmpl = {};
			}
			trip.html_tmpl.flightInfo = MakeFlightInfos(String(i));
			makeStarsBlock(trip);
		} catch (e) {}
		direction.trips.push(trip);
		direction.duration += DurationAPIToMinutes(trip.fltTm) * 60000;
		if (direction.trips.length > 1) {
			direction.duration += trip.stDt_Date - direction.trips[direction.trips.length - 2].endDt_Date;
		}
		if (!trip.conx) {
			arrDirections.push(direction);
			direction = new Direction();
		}
	}
	var data = {directions: arrDirections};
	if(DirNum!==null) {
		var singleDir = arrDirections[DirNum];
		//singleDir.trips[0].ticketCmp = arrDirections[0].trips[0].airCmp;
		data = {directions: [singleDir], concreteDir: DirNum};
	}
	if(!resultFlight.combined){
		data.AKform = arrTrips[0].airCmp;
	}
	tw.TripsForStars.arrDirections = arrDirections;

	var msgs = {};
	if(resultFlight.sourceFare) {
		for(var im in resultFlight.sourceFare.infMsgs) {
			msgs[resultFlight.sourceFare.infMsgs[im].msg.toLowerCase()] = true;
		}
	}

	var div = document.createElement('div');

	// add ALR (tariff details configured by BO msgs) info and noBaggage warning
	tw.oResult.flightTariffDetails.addTariffInfoToDirs(resultFlight.sourceFare, arrDirections);

	if(resultFlight.combined && !DirNum && arrDirections[0].trips[0].airCmp != arrDirections[1].trips[0].airCmp){//и если разные АК туда и обратно
		for(var DirIndex=0, DL=arrDirections.length; DirIndex<DL; DirIndex++ ){
			var curDir = arrDirections[DirIndex];
			var showAKbelow = (DirIndex == 1);
			var curData = {directions: [curDir], concreteDir: DirIndex};
			$.tmpl('tmpl_Ticket', curData, {
				"bottomAKpanel": showAKbelow,
				"hideStat":      false,
				"noseats":       resultFlight.noseats || false,
				"messages":      msgs
			}).appendTo(div); // параметром "hideStat" регулируем показ доп инфы в билете
		}
	} else {
		$.tmpl('tmpl_Ticket', data, {
			"hideStat": false,
			"noseats":  resultFlight.noseats || false,
			"messages": msgs
		}).appendTo(div);
	}
	$('.direction:last', div).append(simpleCloseButton);

	fadeIn();
	addPopup({
		dom: div,
		className: "TripsInfo",
		close_button: true
	});
	$('#fadeBlock').one('click',function(){
		removePopup();
		tw.metaReturn && tw.metaReturn.reset();
	});


	$('.trip', div).each(function(){
		if($('.flightInformation ul',this).length > 0 ) {
			var ul = $('.flightInformation ul',this).clone();
			var $fNum = $('.flightNumber span', this);
			$fNum.addClass('link dashed showStat');
			$fNum.tooltip({"dom": ul});
		}
	});

}


function addMutationObjserver() {
	var MutationObserver = (function () {
		var prefixes = ['WebKit', 'Moz', 'O', 'Ms', ''];
		for (var i = 0; i < prefixes.length; i++) {
			if (prefixes[i] + 'MutationObserver' in window) {
				return window[prefixes[i] + 'MutationObserver'];
			}
		}
		return false;
	}());

	if (MutationObserver) {
		var bodyObserver = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				Array.prototype.forEach.call(mutation.addedNodes, function(node) {
					var remove;

					if (!node) {
						return;
					}

					if (node.tagName === 'STYLE') {
						var sheet = node.sheet || {};
						var rules = Array.prototype.slice.call(sheet.rules || sheet.cssRules || []);

						rules.forEach(function (rule) {
							try {
								$(rule.selectorText).hide();
							} catch (e) {}
						});

						remove = true;
					}

					if (/market.yandex.ru/.test(node.innerHTML)) {
						remove = true;
					}

					if (node.style && node.style.position === 'fixed' && node.style.getPropertyPriority('position') === 'important') {
						remove = true;
					}

					if (remove) {
						node.remove();
					}
				});
			});
		});

		var html = document.documentElement;
		var htmlObserver = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				var attribute = mutation.attributeName;
				if (attribute && attribute !== 'lang') {
					html.removeAttribute(attribute);
				}
			});
		});

		bodyObserver.observe(document.body, { childList: true });
		htmlObserver.observe(html, { attributes: true });
	}
}

function Passengers( strCountFromUrl ) {
	this.minPassengers = 1;
	this.maxPassengers = 9;
	this.min = {
		adult: 1,
		children: 0,
		infants: 0
	};
	var countsFromUrl = this.checkPassengersHash(strCountFromUrl);
    this.max = {
        adult: this.maxPassengers,
        children: this.maxPassengers - this.min.adult,
        infants: Math.floor(this.maxPassengers/ 2)
    };
	if (!strCountFromUrl) {
		countsFromUrl = this.min;
	}
	this.adult = countsFromUrl.adult;
	this.children = countsFromUrl.children;
	this.infants = countsFromUrl.infants;
}
Passengers.prototype.checkPassengersHash = function (pasHash) {
	//функция проверки адекватности входных данных
	if (!pasHash) return this.min;
	var pasArray = pasHash.split(','),
		adtCount = parseInt(pasArray[0]||1,10) || this.min.adult,
		cnnCount = parseInt(pasArray[1]||0,10) || this.min.children,
		infCount = parseInt(pasArray[2]||0,10) || this.min.infants,
		sum = adtCount + cnnCount + infCount;
	if (((this.minPassengers > sum) || (sum > this.maxPassengers)) || //проверка на колличество
		(adtCount < this.min.adult) || //проверка на наличие взрослых
		(cnnCount < this.min.children) || //проверка количества детей
		(infCount < this.min.infants) || //проверка количества младенцев
		(infCount > adtCount) //проверка количетсва младенцев
	){
		return this.min;
	}
	return {
		adult: adtCount,
		children: cnnCount,
		infants: infCount
	};
};
Passengers.prototype.change = function (typePassenger, changeValue) {
    this['change' + typePassenger](parseInt(changeValue));
};
Passengers.prototype.changeAdult = function (changeValue) {
    if ((this.adult == this.min.adult) && (changeValue < 0)) return -1;
    if (this.adult + changeValue > this.max.adult) return -1;

    if (this.adult + changeValue < this.infants) {
        this.changeInfants(-1);
    }
    this.adult += changeValue;
    if ((changeValue > 0) && (this.sum() > this.maxPassengers)) {
        this.children = this.maxPassengers - (this.adult + this.infants);
        if (this.children < this.min.children ) {
            this.infants += this.children;
            this.children = this.min.children;
        }
    }
};
Passengers.prototype.changeChildren = function (changeValue) {
    if ((this.children == this.min.children) && (changeValue < 0)) return -1;
    if (this.children + changeValue > this.max.children) return -1;

    this.children += changeValue;
    if ((changeValue > 0) && (this.sum() > this.maxPassengers)) {
        this.infants = this.maxPassengers - (this.adult + this.children);
        if (this.infants < this.min.infants) {
            this.adult += this.infants;
            this.infants = this.min.infants;
        }
    }
};
Passengers.prototype.changeInfants = function (changeValue) {
    if ((this.infants == this.min.infants) && (changeValue < 0)) return -1;
    if (this.infants + changeValue > this.max.infants) return -1;

    this.infants += changeValue;
    if (this.adult < this.infants) {
        this.changeAdult(1);
    }
    if ((changeValue > 0) && (this.sum() > this.maxPassengers)) {
        this.children = this.maxPassengers - (this.adult + this.infants);
        if (this.children < this.min.children ) {
            this.adult += this.children;
            this.children = this.min.children;
        }
    }
};
Passengers.prototype.sum = function () {
    return this.adult + this.children + this.infants;
};
Passengers.prototype.getStatus = function () {
    var sum = this.sum();
	return sum + ' ' + declOfNum(sum, l10n.index.search.chooser.passengers);
};
Passengers.prototype.getStrCountPassenger = function () {
	return this.adult + "," + this.children + "," + this.infants;
};



function ChooserPassengers() {
	this.chooser = $.tmpl($('#passengersChooser').trim())[0];
	this.initialElement = $('#passengerChooser__action');

	this.moveUnderInitialElementWithBind = this.moveUnderInitialElement.bind(this);
	this.clickWithBind = this.clickWhenOpen.bind(this);
	this.showWithBind = this.show.bind(this);

	// if ($('#form_aviaSearch').hasClass('searchFormAB')) {
	// 	на новой форме чузер выскакивает вправо
		// this.nameOpenClassForChooser = "passengerChooser__chooser--openRight";
	// } else {
		//в другом интерфейсе вниз
		this.nameOpenClassForChooser = "passengerChooser__chooser--open";
	// }
	this.nameOpenClassForInitialLabel = "passengerChooser__label--open";
	this.selectorInitialLabel = ".passengerChooser__label";

	this.initChooser();
}
ChooserPassengers.prototype.changePassengers = function (target) {
	tw.passengers.change($(target).data('type-passenger'), $(target).data('change-value'));
	this.update();
};

ChooserPassengers.prototype.update = function () {
	$(this.selectorInitialLabel ,this.initialElement).text(tw.passengers.getStatus());
	for(var typePassangers in tw.passengers) {
		if (tw.passengers.hasOwnProperty(typePassangers)) {
			//light quantity
			if (tw.passengers[typePassangers] === 0) {
				$("#passengerChooser__passenger-type-" + typePassangers + " .passengerChooser__quantity").addClass("passengerChooser__light");
			} else {
				$("#passengerChooser__passenger-type-" + typePassangers + " .passengerChooser__quantity").removeClass("passengerChooser__light");
			}
			//paint if can not be less than
			if (tw.passengers[typePassangers] === tw.passengers.min[typePassangers]) {
				$("#passengerChooser__passenger-type-" + typePassangers + " .passengerChooser__changer:last").addClass("passengerChooser__light");
			} else {
				$("#passengerChooser__passenger-type-" + typePassangers + " .passengerChooser__changer:last").removeClass("passengerChooser__light");
			}
			//paint if can not be longer than
			if (tw.passengers[typePassangers] === tw.passengers.max[typePassangers]) {
				$("#passengerChooser__passenger-type-" + typePassangers + " .passengerChooser__changer:first").addClass("passengerChooser__light");
			} else {
				$("#passengerChooser__passenger-type-" + typePassangers + " .passengerChooser__changer:first").removeClass("passengerChooser__light");
			}
			//refresh count
			$("#passengerChooser__passenger-type-" + typePassangers + " .passengerChooser__quantity").text(tw.passengers[typePassangers]);
		}
	}
};
ChooserPassengers.prototype.initChooser = function () {
	$('body').append(this.chooser);
	this.update();
	this.initialElement.on("click", this.showWithBind);
	$(this.chooser).on("mouseleave", this.hide.bind(this));
};
ChooserPassengers.prototype.clickWhenOpen = function (event) {
	event = event || window.event;
	var target = event.target;
	while (target != null) {
		if ($(target).hasClass("passengerChooser__changer")) {
			this.changePassengers(target);
			return;
		}
		if (target === this.chooser) {
			//empty area
			return;
		}
		target = target.parentNode;
	}
	this.hide();
};
ChooserPassengers.prototype.moveUnderInitialElement = function () {
	if ($('#form_aviaSearch').hasClass('searchFormAB') && $('.dirRow1.multiway').length) {
		console.log($('.passengerChooser__chooser--open').length);
		//форма новая - открываем направо
		this.chooser.style.top  = this.initialElement.offset().top + "px";
		this.chooser.style.left = this.initialElement.offset().left + this.initialElement.outerWidth() + 10 + "px";
	} else {
		//форма старая - открываем вниз
		this.chooser.style.top  = this.initialElement.offset().top + this.initialElement.outerHeight() + 10 + "px";
		this.chooser.style.left = this.initialElement.offset().left - $(this.chooser).outerWidth() / 2 + this.initialElement.outerWidth() / 2 + "px";
	}

};
ChooserPassengers.prototype.show = function (event) {
	var self = this;
	//обернуто в timeOut чтобы не мешало всплытие (иначе он сам себя закрывает)
	//если снизу написать event && event.stopPropagation() - то не будет скрываться календарь при открытии
	setTimeout(function(){
		self.moveUnderInitialElement();
		$(window).on("resize", self.moveUnderInitialElementWithBind);
		$(document).on("click", self.clickWithBind);
		self.initialElement.off("click", self.showWithBind);
		$(self.chooser).addClass("passengerChooser__chooser--open");
		$(self.selectorInitialLabel ,self.initialElement).addClass("passengerChooser__chooser--open");

		if ($('#form_aviaSearch').hasClass('searchFormAB') && $('.dirRow1.multiway').length) {
			$(self.chooser).addClass("passengerChooser__chooser--openRight");
			$(self.selectorInitialLabel ,self.initialElement).addClass("passengerChooser__chooser--openRight");
		}
	},10);
};

ChooserPassengers.prototype.hide = function (event) {
	$(window).off("resize", this.moveUnderInitialElementWithBind);
	$(document).off("click", this.clickWithBind);
	this.initialElement.on("click", this.showWithBind);
	$(this.chooser).removeClass("passengerChooser__chooser--open");
	$(this.chooser).removeClass("passengerChooser__chooser--openRight");
	$(this.selectorInitialLabel ,this.initialElement).removeClass("passengerChooser__chooser--open");
	$(this.selectorInitialLabel ,this.initialElement).removeClass("passengerChooser__chooser--openRight");
	event && event.stopPropagation();
};


!function(e){function t(n){if(r[n])return r[n].exports;var i=r[n]={exports:{},id:n,loaded:!1};return e[n].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var n=window.webpackJsonp;window.webpackJsonp=function(r,o){for(var a,s,u=0,l=[];u<r.length;u++)s=r[u],i[s]&&l.push.apply(l,i[s]),i[s]=0;for(a in o){var c=o[a];switch(typeof c){case"object":e[a]=function(t){var n=t.slice(1),r=t[0];return function(t,i,o){e[r].apply(this,[t,i,o].concat(n))}}(c);break;case"function":e[a]=c;break;default:e[a]=e[c]}}for(n&&n(r,o);l.length;)l.shift().call(null,t)};var r={},i={0:0};return t.e=function(e,n){if(0===i[e])return n.call(null,t);if(void 0!==i[e])i[e].push(n);else{i[e]=[n];var r=document.getElementsByTagName("head")[0],o=document.createElement("script");o.type="text/javascript",o.charset="utf-8",o.async=!0,o.src=t.p+""+e+"."+({1:"fetchPolyfill"}[e]||e)+"-"+{1:"df259dfffb3f90c5f2e7"}[e]+".js",r.appendChild(o)}},t.m=e,t.c=r,t.p="/ru/fareFamily/",t(0)}(function(e){for(var t in e)if(Object.prototype.hasOwnProperty.call(e,t))switch(typeof e[t]){case"function":break;case"object":e[t]=function(t){var n=t.slice(1),r=e[t[0]];return function(e,t,i){r.apply(this,[e,t,i].concat(n))}}(e[t]);break;default:e[t]=e[e[t]]}return e}([function(e,t,n){(function(e){"use strict";var t=n(23).default,r=n(92);!function(){return t.async(function(i){for(var o=this;;)switch(i.prev=i.next){case 0:return i.prev=0,i.next=3,t.awrap(function(){var i,a,s,u;return t.async(function(o){for(;;)switch(o.prev=o.next){case 0:return o.next=2,t.awrap(r());case 2:n(112),i=n(302),a=n(454),s=n(463),u=(window.trackJs||e.trackJs||{}).track,window.store=a,a.sub("initFareFamily",function(e){var t=e.params,n=e.paxInfo,r=e.currentBrandIndex;try{i.render(i.createElement(s,{choosenBrand:r,paxInfo:n,requestParams:t}),document.getElementById("fareFamilyContainer"))}catch(o){u&&u(o)}}),a.sub("unmountFareFamily",function(){try{i.unmountComponentAtNode(document.getElementById("fareFamilyContainer"))}catch(e){u&&u(e)}});case 10:case"end":return o.stop()}},null,o)}());case 3:i.next=8;break;case 5:i.prev=5,i.t0=i.catch(0);case 8:case"end":return i.stop()}},null,this,[[0,5]])}()}).call(t,function(){return this}())},,,,,,,,,,,,,,,,,,,,,,,function(e,t,n){(function(t){var r="object"==typeof t?t:"object"==typeof window?window:"object"==typeof self?self:this,i=r.regeneratorRuntime&&Object.getOwnPropertyNames(r).indexOf("regeneratorRuntime")>=0,o=i&&r.regeneratorRuntime;if(r.regeneratorRuntime=void 0,e.exports=n(24),i)r.regeneratorRuntime=o;else try{delete r.regeneratorRuntime}catch(a){r.regeneratorRuntime=void 0}e.exports={"default":e.exports,__esModule:!0}}).call(t,function(){return this}())},function(e,t,n){(function(t,r){"use strict";var i=n(26).default,o=n(57).default,a=n(69).default,s=n(71).default;!function(t){function n(e,t,n,r){var i=a((t||l).prototype);return i._invoke=v(e,n||null,new m(r||[])),i}function u(e,t,n){try{return{type:"normal",arg:e.call(t,n)}}catch(r){return{type:"throw",arg:r}}}function l(){}function c(){}function d(){}function p(e){["next","throw","return"].forEach(function(t){e[t]=function(e){return this._invoke(t,e)}})}function f(e){this.arg=e}function h(e){function t(t,n){var r=e[t](n),i=r.value;return i instanceof f?s.resolve(i.arg).then(o,a):s.resolve(i).then(function(e){return r.value=e,r})}function n(e,n){var r=i?i.then(function(){return t(e,n)}):new s(function(r){r(t(e,n))});return i=r.catch(function(e){}),r}"object"==typeof r&&r.domain&&(t=r.domain.bind(t));var i,o=t.bind(e,"next"),a=t.bind(e,"throw");t.bind(e,"return");this._invoke=n}function v(e,t,n){var r=E;return function(i,o){if(r===x)throw new Error("Generator is already running");if(r===k){if("throw"===i)throw o;return A()}for(;;){var a=n.delegate;if(a){if("return"===i||"throw"===i&&a.iterator[i]===C){n.delegate=null;var s=a.iterator.return;if(s){var l=u(s,a.iterator,o);if("throw"===l.type){i="throw",o=l.arg;continue}}if("return"===i)continue}var l=u(a.iterator[i],a.iterator,o);if("throw"===l.type){n.delegate=null,i="throw",o=l.arg;continue}i="next",o=C;var c=l.arg;if(!c.done)return r=w,c;n[a.resultName]=c.value,n.next=a.nextLoc,n.delegate=null}if("next"===i)r===w?n.sent=o:n.sent=C;else if("throw"===i){if(r===E)throw r=k,o;n.dispatchException(o)&&(i="next",o=C)}else"return"===i&&n.abrupt("return",o);r=x;var l=u(e,t,n);if("normal"===l.type){r=n.done?k:w;var c={value:l.arg,done:n.done};if(l.arg!==I)return c;n.delegate&&"next"===i&&(o=C)}else"throw"===l.type&&(r=k,i="throw",o=l.arg)}}}function y(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function g(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function m(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(y,this),this.reset(!0)}function _(e){if(e){var t=e[S];if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var n=-1,r=function i(){for(;++n<e.length;)if(b.call(e,n))return i.value=e[n],i.done=!1,i;return i.value=C,i.done=!0,i};return r.next=r}}return{next:A}}function A(){return{value:C,done:!0}}var C,b=Object.prototype.hasOwnProperty,S="function"==typeof i&&o||"@@iterator",M="object"==typeof e,T=t.regeneratorRuntime;if(T)return void(M&&(e.exports=T));T=t.regeneratorRuntime=M?e.exports:{},T.wrap=n;var E="suspendedStart",w="suspendedYield",x="executing",k="completed",I={},P=d.prototype=l.prototype;c.prototype=P.constructor=d,d.constructor=c,c.displayName="GeneratorFunction",T.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return t?t===c||"GeneratorFunction"===(t.displayName||t.name):!1},T.mark=function(e){return e.__proto__=d,e.prototype=a(P),e},T.awrap=function(e){return new f(e)},p(h.prototype),T.async=function(e,t,r,i){var o=new h(n(e,t,r,i));return T.isGeneratorFunction(t)?o:o.next().then(function(e){return e.done?e.value:o.next()})},p(P),P[S]=function(){return this},P.toString=function(){return"[object Generator]"},T.keys=function(e){var t=[];for(var n in e)t.push(n);return t.reverse(),function r(){for(;t.length;){var n=t.pop();if(n in e)return r.value=n,r.done=!1,r}return r.done=!0,r}},T.values=_,m.prototype={constructor:m,reset:function(e){if(this.prev=0,this.next=0,this.sent=C,this.done=!1,this.delegate=null,this.tryEntries.forEach(g),!e)for(var t in this)"t"===t.charAt(0)&&b.call(this,t)&&!isNaN(+t.slice(1))&&(this[t]=C)},stop:function(){this.done=!0;var e=this.tryEntries[0],t=e.completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(e){function t(t,r){return o.type="throw",o.arg=e,n.next=t,!!r}if(this.done)throw e;for(var n=this,r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r],o=i.completion;if("root"===i.tryLoc)return t("end");if(i.tryLoc<=this.prev){var a=b.call(i,"catchLoc"),s=b.call(i,"finallyLoc");if(a&&s){if(this.prev<i.catchLoc)return t(i.catchLoc,!0);if(this.prev<i.finallyLoc)return t(i.finallyLoc)}else if(a){if(this.prev<i.catchLoc)return t(i.catchLoc,!0)}else{if(!s)throw new Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return t(i.finallyLoc)}}}},abrupt:function(e,t){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&b.call(r,"finallyLoc")&&this.prev<r.finallyLoc){var i=r;break}}i&&("break"===e||"continue"===e)&&i.tryLoc<=t&&t<=i.finallyLoc&&(i=null);var o=i?i.completion:{};return o.type=e,o.arg=t,i?this.next=i.finallyLoc:this.complete(o),I},complete:function(e,t){if("throw"===e.type)throw e.arg;"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=e.arg,this.next="end"):"normal"===e.type&&t&&(this.next=t)},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),g(n),I}},"catch":function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var r=n.completion;if("throw"===r.type){var i=r.arg;g(n)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(e,t,n){return this.delegate={iterator:_(e),resultName:t,nextLoc:n},I}}}("object"==typeof t?t:"object"==typeof window?window:"object"==typeof self?self:void 0)}).call(t,function(){return this}(),n(25))},function(e,t){function n(){l&&a&&(l=!1,a.length?u=a.concat(u):c=-1,u.length&&r())}function r(){if(!l){var e=setTimeout(n);l=!0;for(var t=u.length;t;){for(a=u,u=[];++c<t;)a&&a[c].run();c=-1,t=u.length}a=null,l=!1,clearTimeout(e)}}function i(e,t){this.fun=e,this.array=t}function o(){}var a,s=e.exports={},u=[],l=!1,c=-1;s.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];u.push(new i(e,t)),1!==u.length||l||setTimeout(r,0)},i.prototype.run=function(){this.fun.apply(null,this.array)},s.title="browser",s.browser=!0,s.env={},s.argv=[],s.version="",s.versions={},s.on=o,s.addListener=o,s.once=o,s.off=o,s.removeListener=o,s.removeAllListeners=o,s.emit=o,s.binding=function(e){throw new Error("process.binding is not supported")},s.cwd=function(){return"/"},s.chdir=function(e){throw new Error("process.chdir is not supported")},s.umask=function(){return 0}},function(e,t,n){e.exports={"default":n(27),__esModule:!0}},function(e,t,n){n(28),n(56),e.exports=n(35).Symbol},[690,29,30,31,32,34,38,33,41,42,44,43,45,50,51,52,53,46,40,55],function(e,t){var n=Object;e.exports={create:n.create,getProto:n.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:n.getOwnPropertyDescriptor,setDesc:n.defineProperty,setDescs:n.defineProperties,getKeys:n.keys,getNames:n.getOwnPropertyNames,getSymbols:n.getOwnPropertySymbols,each:[].forEach}},function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},[691,33],function(e,t){e.exports=function(e){try{return!!e()}catch(t){return!0}}},function(e,t,n){var r=n(30),i=n(35),o=n(36),a="prototype",s=function(e,t,n){var u,l,c,d=e&s.F,p=e&s.G,f=e&s.S,h=e&s.P,v=e&s.B,y=e&s.W,g=p?i:i[t]||(i[t]={}),m=p?r:f?r[t]:(r[t]||{})[a];p&&(n=t);for(u in n)l=!d&&m&&u in m,l&&u in g||(c=l?m[u]:n[u],g[u]=p&&"function"!=typeof m[u]?n[u]:v&&l?o(c,r):y&&m[u]==c?function(e){var t=function(t){return this instanceof e?new e(t):e(t)};return t[a]=e[a],t}(c):h&&"function"==typeof c?o(Function.call,c):c,h&&((g[a]||(g[a]={}))[u]=c))};s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,e.exports=s},function(e,t){var n=e.exports={version:"1.2.6"};"number"==typeof __e&&(__e=n)},[692,37],function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t,n){e.exports=n(39)},[693,29,40,32],function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},[694,30],[695,29,31,43],[696,41,44,30],function(e,t){var n=0,r=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+r).toString(36))}},[697,29,46],[698,47,49],[699,48],function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},[700,46,29],[701,29],[702,48],[703,54],function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t){e.exports=!0},function(e,t){},function(e,t,n){e.exports={"default":n(58),__esModule:!0}},function(e,t,n){n(59),n(65),e.exports=n(43)("iterator")},[704,60,62],[705,61,49],function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:n)(e)}},[706,55,34,38,39,31,63,64,42,29,43],function(e,t){e.exports={}},[707,29,40,42,39,43],function(e,t,n){n(66);var r=n(63);r.NodeList=r.HTMLCollection=r.Array},[708,67,68,63,46,62],function(e,t){e.exports=function(){}},function(e,t){e.exports=function(e,t){return{value:t,done:!!e}}},function(e,t,n){e.exports={"default":n(70),__esModule:!0}},function(e,t,n){var r=n(29);e.exports=function(e,t){return r.create(e,t)}},function(e,t,n){e.exports={"default":n(72),__esModule:!0}},function(e,t,n){n(56),n(59),n(65),n(73),e.exports=n(35).Promise},[709,29,55,30,36,74,34,54,53,37,75,76,81,82,43,83,84,32,89,42,90,35,91],[710,48,43],function(e,t){e.exports=function(e,t,n){if(!(e instanceof t))throw TypeError(n+": use the 'new' operator!");return e}},[711,36,77,78,53,79,80],[712,53],[713,63,43],[714,61],[715,74,43,63,35],[716,29,54,53,36],function(e,t){e.exports=Object.is||function(e,t){return e===t?0!==e||1/e===1/t:e!=e&&t!=t}},[717,53,37,43],[718,30,85,48],[719,36,86,87,88,30,48],function(e,t){e.exports=function(e,t,n){var r=void 0===n;switch(t.length){case 0:return r?e():e.call(n);case 1:return r?e(t[0]):e.call(n,t[0]);case 2:return r?e(t[0],t[1]):e.call(n,t[0],t[1]);case 3:return r?e(t[0],t[1],t[2]):e.call(n,t[0],t[1],t[2]);case 4:return r?e(t[0],t[1],t[2],t[3]):e.call(n,t[0],t[1],t[2],t[3])}return e.apply(n,t)}},[720,30],[721,54,30],[722,38],function(e,t,n){"use strict";var r=n(35),i=n(29),o=n(32),a=n(43)("species");e.exports=function(e){var t=r[e];o&&t&&!t[a]&&i.setDesc(t,a,{configurable:!0,get:function(){return this}})}},[723,43],function(e,t,n){(function(t){"use strict";var r=n(71).default,i=n(93);e.exports=function(){return r.all(i.keys().filter(function(e){return"./all.js"!==e}).map(function(e){return i(e)()})).catch(function(e){t.trackJs&&t.trackJs.track(e)})}}).call(t,function(){return this}())},function(e,t,n){function r(e){return n(i(e))}function i(e){return o[e]||function(){throw new Error("Cannot find module '"+e+"'.")}()}var o={"./all.js":92,"./fetch.js":94,"./formData.js":96,"./intl.js":98,"./ls.js":102,"./raf.js":109};r.keys=function(){return Object.keys(o)},r.resolve=i,e.exports=r,r.id=93},function(e,t,n){(function(t){"use strict";var r=n(71).default,i=function(e){n(95),e()},o=function(e){return n.e(1,function(){i(e)})},a=function(e){return t.fetch&&"function"==typeof t.fetch?void e():void o(e)};e.exports=function(){return new r(a)}}).call(t,function(){return this}())},function(e,t){!function(e){"use strict";function t(e){if("string"!=typeof e&&(e=String(e)),/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(e))throw new TypeError("Invalid character in header field name");return e.toLowerCase()}function n(e){return"string"!=typeof e&&(e=String(e)),e}function r(e){this.map={},e instanceof r?e.forEach(function(e,t){this.append(t,e)},this):e&&Object.getOwnPropertyNames(e).forEach(function(t){this.append(t,e[t])},this)}function i(e){return e.bodyUsed?Promise.reject(new TypeError("Already read")):void(e.bodyUsed=!0)}function o(e){return new Promise(function(t,n){e.onload=function(){t(e.result)},e.onerror=function(){n(e.error)}})}function a(e){var t=new FileReader;return t.readAsArrayBuffer(e),o(t)}function s(e){var t=new FileReader;return t.readAsText(e),o(t)}function u(){return this.bodyUsed=!1,this._initBody=function(e){if(this._bodyInit=e,"string"==typeof e)this._bodyText=e;else if(h.blob&&Blob.prototype.isPrototypeOf(e))this._bodyBlob=e;else if(h.formData&&FormData.prototype.isPrototypeOf(e))this._bodyFormData=e;else if(e){if(!h.arrayBuffer||!ArrayBuffer.prototype.isPrototypeOf(e))throw new Error("unsupported BodyInit type")}else this._bodyText="";this.headers.get("content-type")||("string"==typeof e?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type&&this.headers.set("content-type",this._bodyBlob.type))},h.blob?(this.blob=function(){var e=i(this);if(e)return e;if(this._bodyBlob)return Promise.resolve(this._bodyBlob);if(this._bodyFormData)throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){return this.blob().then(a)},this.text=function(){var e=i(this);if(e)return e;if(this._bodyBlob)return s(this._bodyBlob);if(this._bodyFormData)throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText)}):this.text=function(){var e=i(this);return e?e:Promise.resolve(this._bodyText)},h.formData&&(this.formData=function(){return this.text().then(d)}),this.json=function(){return this.text().then(JSON.parse)},this}function l(e){var t=e.toUpperCase();return v.indexOf(t)>-1?t:e}function c(e,t){t=t||{};var n=t.body;if(c.prototype.isPrototypeOf(e)){if(e.bodyUsed)throw new TypeError("Already read");this.url=e.url,this.credentials=e.credentials,t.headers||(this.headers=new r(e.headers)),this.method=e.method,this.mode=e.mode,n||(n=e._bodyInit,e.bodyUsed=!0)}else this.url=e;if(this.credentials=t.credentials||this.credentials||"omit",!t.headers&&this.headers||(this.headers=new r(t.headers)),this.method=l(t.method||this.method||"GET"),this.mode=t.mode||this.mode||null,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&n)throw new TypeError("Body not allowed for GET or HEAD requests");this._initBody(n)}function d(e){var t=new FormData;return e.trim().split("&").forEach(function(e){if(e){var n=e.split("="),r=n.shift().replace(/\+/g," "),i=n.join("=").replace(/\+/g," ");t.append(decodeURIComponent(r),decodeURIComponent(i))}}),t}function p(e){var t=new r,n=e.getAllResponseHeaders().trim().split("\n");return n.forEach(function(e){var n=e.trim().split(":"),r=n.shift().trim(),i=n.join(":").trim();t.append(r,i)}),t}function f(e,t){t||(t={}),this.type="default",this.status=t.status,this.ok=this.status>=200&&this.status<300,this.statusText=t.statusText,this.headers=t.headers instanceof r?t.headers:new r(t.headers),this.url=t.url||"",this._initBody(e)}if(!e.fetch){r.prototype.append=function(e,r){e=t(e),r=n(r);var i=this.map[e];i||(i=[],this.map[e]=i),i.push(r)},r.prototype.delete=function(e){delete this.map[t(e)]},r.prototype.get=function(e){var n=this.map[t(e)];return n?n[0]:null},r.prototype.getAll=function(e){return this.map[t(e)]||[]},r.prototype.has=function(e){return this.map.hasOwnProperty(t(e))},r.prototype.set=function(e,r){this.map[t(e)]=[n(r)]},r.prototype.forEach=function(e,t){Object.getOwnPropertyNames(this.map).forEach(function(n){this.map[n].forEach(function(r){e.call(t,r,n,this)},this)},this)};var h={blob:"FileReader"in e&&"Blob"in e&&function(){try{return new Blob,!0}catch(e){return!1}}(),formData:"FormData"in e,arrayBuffer:"ArrayBuffer"in e},v=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];c.prototype.clone=function(){return new c(this)},u.call(c.prototype),u.call(f.prototype),f.prototype.clone=function(){return new f(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new r(this.headers),url:this.url})},f.error=function(){var e=new f(null,{status:0,statusText:""});return e.type="error",e};var y=[301,302,303,307,308];f.redirect=function(e,t){if(-1===y.indexOf(t))throw new RangeError("Invalid status code");return new f(null,{status:t,headers:{location:e}})},e.Headers=r,e.Request=c,e.Response=f,e.fetch=function(e,t){return new Promise(function(n,r){function i(){return"responseURL"in a?a.responseURL:/^X-Request-URL:/m.test(a.getAllResponseHeaders())?a.getResponseHeader("X-Request-URL"):void 0}var o;o=c.prototype.isPrototypeOf(e)&&!t?e:new c(e,t);var a=new XMLHttpRequest;a.onload=function(){var e=1223===a.status?204:a.status;if(100>e||e>599)return void r(new TypeError("Network request failed"));var t={status:e,statusText:a.statusText,headers:p(a),url:i()},o="response"in a?a.response:a.responseText;n(new f(o,t))},a.onerror=function(){r(new TypeError("Network request failed"))},a.open(o.method,o.url,!0),"include"===o.credentials&&(a.withCredentials=!0),"responseType"in a&&h.blob&&(a.responseType="blob"),o.headers.forEach(function(e,t){a.setRequestHeader(t,e)}),a.send("undefined"==typeof o._bodyInit?null:o._bodyInit)})},e.fetch.polyfill=!0}}("undefined"!=typeof self?self:this)},function(e,t,n){"use strict";var r=n(71).default;t.__esModule=!0;var i=function(e){n.e(1,function(){n(97),e()})},o=function(e){window.FormData?e():i(e)};t.default=function(){return new r(o)},e.exports=t.default},,function(e,t,n){(function(t){"use strict";var r=n(71).default,i=function(e){var t=IntlPolyfill;switch(IntlPolyfill={__addLocaleData:function(e){e.number.currencies.RUB="₽",t.__addLocaleData(e)}},e){case"ru":n(99);break;case"en":n(100)}},o=function(e,r){"undefined"==typeof t.Intl?n.e(1,function(){n(101),i(e),r()}):r()};e.exports=function(){var e=arguments.length<=0||void 0===arguments[0]?"ru":arguments[0];return new r(function(t){return o(e,t)})}}).call(t,function(){return this}())},function(e,t){IntlPolyfill.__addLocaleData({locale:"ru",date:{ca:["gregory","buddhist","chinese","coptic","dangi","ethioaa","ethiopic","generic","hebrew","indian","islamic","islamicc","japanese","persian","roc"],hourNo0:!0,hour12:!1,formats:{"short":"{1}, {0}",medium:"{1}, {0}",full:"{1}, {0}","long":"{1}, {0}",availableFormats:{d:"d",E:"ccc",Ed:"ccc, d",Ehm:"E h:mm a",EHm:"E HH:mm",Ehms:"E h:mm:ss a",EHms:"E HH:mm:ss",Gy:"y 'г'. G",GyMMM:"LLL y G",GyMMMd:"d MMM y 'г'. G",GyMMMEd:"E, d MMM y 'г'. G",h:"h a",H:"H",hm:"h:mm a",Hm:"H:mm",hms:"h:mm:ss a",Hms:"H:mm:ss",hmsv:"h:mm:ss a v",Hmsv:"H:mm:ss v",hmv:"h:mm a v",Hmv:"H:mm v",M:"L",Md:"dd.MM",MEd:"E, dd.MM",MMdd:"dd.MM",MMM:"LLL",MMMd:"d MMM",MMMEd:"ccc, d MMM",MMMMd:"d MMMM",ms:"mm:ss",y:"y",yM:"MM.y",yMd:"dd.MM.y",yMEd:"ccc, d.MM.y 'г'.",yMM:"MM.y",yMMM:"LLL y 'г'.",yMMMd:"d MMM y 'г'.",yMMMEd:"E, d MMM y 'г'.",yMMMM:"LLLL y 'г'.",yQQQ:"QQQ y 'г'.",yQQQQ:"QQQQ y 'г'."},dateFormats:{yMMMMEEEEd:"EEEE, d MMMM y 'г'.",yMMMMd:"d MMMM y 'г'.",yMMMd:"d MMM y 'г'.",yMd:"dd.MM.yy"},timeFormats:{hmmsszzzz:"H:mm:ss zzzz",hmsz:"H:mm:ss z",hms:"H:mm:ss",hm:"H:mm"}},calendars:{buddhist:{months:{narrow:["Я","Ф","М","А","М","И","И","А","С","О","Н","Д"],"short":["янв.","февр.","мар.","апр.","мая","июн.","июл.","авг.","сент.","окт.","нояб.","дек."],"long":["января","февраля","марта","апреля","мая","июня","июля","августа","сентября","октября","ноября","декабря"]},days:{narrow:["вс","пн","вт","ср","чт","пт","сб"],"short":["вс","пн","вт","ср","чт","пт","сб"],"long":["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"]},eras:{narrow:["BE"],"short":["BE"],"long":["BE"]},dayPeriods:{am:"ДП",pm:"ПП"}},chinese:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],"short":["1","2","3","4","5","6","7","8","9","10","11","12"],"long":["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["вс","пн","вт","ср","чт","пт","сб"],"short":["вс","пн","вт","ср","чт","пт","сб"],"long":["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"]},dayPeriods:{am:"ДП",pm:"ПП"}},coptic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],"short":["Тот","Бабэ","Хатур","Кихак","Тубэ","Амшир","Барамхат","Бармуда","Башнас","Бауна","Абиб","Мисра","Наси"],"long":["Тот","Бабэ","Хатур","Кихак","Тубэ","Амшир","Барамхат","Бармуда","Башнас","Бауна","Абиб","Мисра","Наси"]},days:{narrow:["вс","пн","вт","ср","чт","пт","сб"],"short":["вс","пн","вт","ср","чт","пт","сб"],"long":["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"]},eras:{narrow:["ERA0","ERA1"],"short":["ERA0","ERA1"],"long":["ERA0","ERA1"]},dayPeriods:{am:"ДП",pm:"ПП"}},dangi:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],"short":["1","2","3","4","5","6","7","8","9","10","11","12"],"long":["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["вс","пн","вт","ср","чт","пт","сб"],"short":["вс","пн","вт","ср","чт","пт","сб"],"long":["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"]},dayPeriods:{am:"ДП",pm:"ПП"}},ethiopic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],"short":["Мескерем","Текемт","Хедар","Тахсас","Тер","Якатит","Магабит","Миазия","Генбот","Сэнэ","Хамлэ","Нахасэ","Эпагомен"],"long":["Мескерем","Текемт","Хедар","Тахсас","Тер","Якатит","Магабит","Миазия","Генбот","Сэнэ","Хамлэ","Нахасэ","Эпагомен"]},days:{narrow:["вс","пн","вт","ср","чт","пт","сб"],"short":["вс","пн","вт","ср","чт","пт","сб"],"long":["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"]},eras:{narrow:["ERA0","ERA1"],"short":["ERA0","ERA1"],"long":["ERA0","ERA1"]},dayPeriods:{am:"ДП",pm:"ПП"}},ethioaa:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],"short":["Мескерем","Текемт","Хедар","Тахсас","Тер","Якатит","Магабит","Миазия","Генбот","Сэнэ","Хамлэ","Нахасэ","Эпагомен"],"long":["Мескерем","Текемт","Хедар","Тахсас","Тер","Якатит","Магабит","Миазия","Генбот","Сэнэ","Хамлэ","Нахасэ","Эпагомен"]},days:{narrow:["вс","пн","вт","ср","чт","пт","сб"],"short":["вс","пн","вт","ср","чт","пт","сб"],"long":["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"]},eras:{narrow:["ERA0"],"short":["ERA0"],"long":["ERA0"]},dayPeriods:{am:"ДП",pm:"ПП"}},generic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],"short":["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"],"long":["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["вс","пн","вт","ср","чт","пт","сб"],"short":["вс","пн","вт","ср","чт","пт","сб"],"long":["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"]},eras:{narrow:["ERA0","ERA1"],"short":["ERA0","ERA1"],"long":["ERA0","ERA1"]},dayPeriods:{am:"ДП",pm:"ПП"}},gregory:{months:{narrow:["Я","Ф","М","А","М","И","И","А","С","О","Н","Д"],"short":["янв.","февр.","мар.","апр.","мая","июн.","июл.","авг.","сент.","окт.","нояб.","дек."],"long":["января","февраля","марта","апреля","мая","июня","июля","августа","сентября","октября","ноября","декабря"]},days:{narrow:["вс","пн","вт","ср","чт","пт","сб"],"short":["вс","пн","вт","ср","чт","пт","сб"],"long":["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"]},eras:{narrow:["до н.э.","н.э.","BCE","CE"],"short":["до н. э.","н. э.","BCE","CE"],"long":["до Рождества Христова","от Рождества Христова","до нашей эры","нашей эры"]},dayPeriods:{am:"ДП",pm:"ПП"}},hebrew:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13","7"],"short":["Тишрей","Хешван","Кислев","Тевет","Шеват","Адар I","Адар","Нисан","Ияр","Сиван","Таммуз","Ав","Элул","Адар II"],"long":["Тишрей","Хешван","Кислев","Тевет","Шеват","Адар I","Адар","Нисан","Ияр","Сиван","Таммуз","Ав","Элул","Адар II"]},days:{narrow:["вс","пн","вт","ср","чт","пт","сб"],"short":["вс","пн","вт","ср","чт","пт","сб"],"long":["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"]},eras:{narrow:["AM"],"short":["AM"],"long":["AM"]},dayPeriods:{am:"ДП",pm:"ПП"}},indian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],"short":["Чайтра","Ваисакха","Джанштха","Асадха","Сравана","Бхадра","Азвина","Картика","Аграхайана","Пауза","Магха","Пхалгуна"],"long":["Чайтра","Ваисакха","Джанштха","Асадха","Сравана","Бхадра","Азвина","Картика","Аграхайана","Пауза","Магха","Пхалгуна"]},days:{narrow:["вс","пн","вт","ср","чт","пт","сб"],"short":["вс","пн","вт","ср","чт","пт","сб"],"long":["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"]},eras:{narrow:["Saka"],"short":["Saka"],"long":["Saka"]},dayPeriods:{am:"ДП",pm:"ПП"}},islamic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],"short":["Мухаррам","Сафар","Раби-уль-авваль","Раби-уль-ахир","Джумад-уль-авваль","Джумад-уль-ахир","Раджаб","Шаабан","Рамадан","Шавваль","Зуль-Каада","Зуль-Хиджжа"],"long":["Мухаррам","Сафар","Раби-уль-авваль","Раби-уль-ахир","Джумад-уль-авваль","Джумад-уль-ахир","Раджаб","Шаабан","Рамадан","Шавваль","Зуль-Каада","Зуль-Хиджжа"]},days:{narrow:["вс","пн","вт","ср","чт","пт","сб"],"short":["вс","пн","вт","ср","чт","пт","сб"],"long":["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"]},eras:{narrow:["AH"],"short":["AH"],"long":["AH"]},dayPeriods:{am:"ДП",pm:"ПП"}},islamicc:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],"short":["Мухаррам","Сафар","Раби-уль-авваль","Раби-уль-ахир","Джумад-уль-авваль","Джумад-уль-ахир","Раджаб","Шаабан","Рамадан","Шавваль","Зуль-Каада","Зуль-Хиджжа"],"long":["Мухаррам","Сафар","Раби-уль-авваль","Раби-уль-ахир","Джумад-уль-авваль","Джумад-уль-ахир","Раджаб","Шаабан","Рамадан","Шавваль","Зуль-Каада","Зуль-Хиджжа"]},days:{narrow:["вс","пн","вт","ср","чт","пт","сб"],"short":["вс","пн","вт","ср","чт","пт","сб"],"long":["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"]},eras:{narrow:["AH"],"short":["AH"],"long":["AH"]},dayPeriods:{am:"ДП",pm:"ПП"}},japanese:{months:{narrow:["Я","Ф","М","А","М","И","И","А","С","О","Н","Д"],"short":["янв.","февр.","мар.","апр.","мая","июн.","июл.","авг.","сент.","окт.","нояб.","дек."],"long":["января","февраля","марта","апреля","мая","июня","июля","августа","сентября","октября","ноября","декабря"]},days:{narrow:["вс","пн","вт","ср","чт","пт","сб"],"short":["вс","пн","вт","ср","чт","пт","сб"],"long":["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"]},eras:{narrow:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","M","T","S","H"],
"short":["Эпоха Тайка (645–650)","Эпоха Хакути (650–671)","Эпоха Хакухо (672–686)","Эпоха Сючё (686–701)","Эпоха Тайхо (701–704)","Эпоха Кёюн (704–708)","Эпоха Вадо (708–715)","Эпоха Рэйки (715–717)","Эпоха Ёро (717–724)","Эпоха Дзинки (724–729)","Эпоха Темпьё (729–749)","Эпоха Темпьё (749–749)","Эпоха Темпьё-Сьохо (749-757)","Эпоха Темпьё-Ходзи (757-765)","Эпоха Темпьё-Ходзи (765-767)","Эпоха Джинго-Кёюн (767-770)","Эпоха Хоки (770–780)","Эпоха Теньё (781–782)","Эпоха Енряку (782–806)","Эпоха Дайдо (806–810)","Эпоха Конин (810–824)","Эпоха Тентьо (824–834)","Эпоха Шова (834–848)","Эпоха Кайо (848–851)","Эпоха Ниндзю (851–854)","Эпоха Сайко (854–857)","Эпоха Теннан (857–859)","Эпоха Йоган (859–877)","Эпоха Генкей (877–885)","Эпоха Нинна (885–889)","Эпоха Кампьё (889–898)","Эпоха Сьотай (898–901)","Эпоха Энги (901–923)","Эпоха Ентьо (923–931)","Эпоха Сьёхэй (931–938)","Эпоха Тенгьо (938–947)","Эпоха Тенрияку (947–957)","Эпоха Тентоку (957–961)","Эпоха Ова (961–964)","Эпоха Кохо (964–968)","Эпоха Анна (968–970)","Эпоха Тенроку (970–973)","Эпоха Теньен (973–976)","Эпоха Дзьоген (976–978)","Эпоха Тенген (978–983)","Эпоха Ейкан (983–985)","Эпоха Канна (985–987)","Эпоха Ейен (987–989)","Эпоха Ейсо (989–990)","Эпоха Сёряку (990–995)","Эпоха Тётоку (995–999)","Эпоха Тёхо (999–1004)","Эпоха Канко (1004–1012)","Эпоха Тёва (1012–1017)","Эпоха Каннин (1017–1021)","Эпоха Дзиан (1021–1024)","Эпоха Мандзю (1024–1028)","Эпоха Тёгэн (1028–1037)","Эпоха Тёряку (1037–1040)","Эпоха Тёкю (1040–1044)","Эпоха Катоку (1044–1046)","Эпоха Эйсо (1046–1053)","Эпоха Тэнги (1053–1058)","Эпоха Кохэй (1058–1065)","Эпоха Дзиряку (1065–1069)","Эпоха Энкю (1069–1074)","Эпоха Сёхо (1074–1077)","Эпоха Сёряку (1077–1081)","Эпоха Эйхо (1081–1084)","Эпоха Отоку (1084–1087)","Эпоха Кандзи (1087–1094)","Эпоха Кахо (1094–1096)","Эпоха Эйтё (1096–1097)","Эпоха Сётоку (1097–1099)","Эпоха Кова (1099–1104)","Эпоха Тёдзи (1104–1106)","Эпоха Касё (1106–1108)","Эпоха Тэннин (1108–1110)","Эпоха Тэнъэй (1110–1113)","Эпоха Эйкю (1113–1118)","Эпоха Гэнъэй (1118–1120)","Эпоха Хоан (1120–1124)","Эпоха Тэндзи (1124–1126)","Эпоха Дайдзи (1126–1131)","Эпоха Тэнсё (1131–1132)","Эпоха Тёсё (1132–1135)","Эпоха Хоэн (1135–1141)","Эпоха Эйдзи (1141–1142)","Эпоха Кодзи (1142–1144)","Эпоха Тэнё (1144–1145)","Эпоха Кюан (1145–1151)","Эпоха Нимпэй (1151–1154)","Эпоха Кюдзю (1154–1156)","Эпоха Хогэн (1156–1159)","Эпоха Хэйдзи (1159–1160)","Эпоха Эйряку (1160–1161)","Эпоха Охо (1161–1163)","Эпоха Тёкан (1163–1165)","Эпоха Эйман (1165–1166)","Эпоха Нинъан (1166–1169)","Эпоха Као (1169–1171)","Эпоха Сёан (1171–1175)","Эпоха Ангэн (1175–1177)","Эпоха Дзисё (1177–1181)","Эпоха Ёва (1181–1182)","Эпоха Дзюэй (1182–1184)","Эпоха Гэнрюку (1184–1185)","Эпоха Бундзи (1185–1190)","Эпоха Кэнкю (1190–1199)","Эпоха Сёдзи (1199–1201)","Эпоха Кэннин (1201–1204)","Эпоха Гэнкю (1204–1206)","Эпоха Кэнъэй (1206–1207)","Эпоха Сёгэн (1207–1211)","Эпоха Кэнряку (1211–1213)","Эпоха Кэмпо (1213–1219)","Эпоха Сёкю (1219–1222)","Эпоха Дзёо (1222–1224)","Эпоха Гэннин (1224–1225)","Эпоха Кароку (1225–1227)","Эпоха Антэй (1227–1229)","Эпоха Канки (1229–1232)","Эпоха Дзёэй (1232–1233)","Эпоха Тэмпуку (1233–1234)","Эпоха Бунряку (1234–1235)","Эпоха Катэй (1235–1238)","Эпоха Рякунин (1238–1239)","Эпоха Энъо (1239–1240)","Эпоха Ниндзи (1240–1243)","Эпоха Кангэн (1243–1247)","Эпоха Ходзи (1247–1249)","Эпоха Кэнтё (1249–1256)","Эпоха Когэн (1256–1257)","Эпоха Сёка (1257–1259)","Эпоха Сёгэн (1259–1260)","Эпоха Бунъо (1260–1261)","Эпоха Котё (1261–1264)","Эпоха Бунъэй (1264–1275)","Эпоха Кэндзи (1275–1278)","Эпоха Коан (1278–1288)","Эпоха Сёо (1288–1293)","Эпоха Эйнин (1293–1299)","Эпоха Сёан (1299–1302)","Эпоха Кэнгэн (1302–1303)","Эпоха Кагэн (1303–1306)","Эпоха Токудзи (1306–1308)","Эпоха Энкэй (1308–1311)","Эпоха Отё (1311–1312)","Эпоха Сёва (1312–1317)","Эпоха Бумпо (1317–1319)","Эпоха Гэно (1319–1321)","Эпоха Гэнкё (1321–1324)","Эпоха Сётю (1324–1326)","Эпоха Карэки (1326–1329)","Эпоха Гэнтоку (1329–1331)","Эпоха Гэнко (1331–1334)","Эпоха Кэмму (1334–1336)","Эпоха Энгэн (1336–1340)","Эпоха Кококу (1340–1346)","Эпоха Сёхэй (1346–1370)","Эпоха Кэнтоку (1370–1372)","Эпоха Бунтю (1372–1375)","Эпоха Иэндзю (1375–1379)","Эпоха Коряку (1379–1381)","Эпоха Кова (1381–1384)","Эпоха Гэнтю (1384–1392)","Эпоха Мэйтоку (1384–1387)","Эпоха Какэй (1387–1389)","Эпоха Коо (1389–1390)","Эпоха Мэйтоку (1390–1394)","Эпоха Оэй (1394–1428)","Эпоха Сётё (1428–1429)","Эпоха Эйкё (1429–1441)","Эпоха Какицу (1441–1444)","Эпоха Банъан (1444–1449)","Эпоха Хотоку (1449–1452)","Эпоха Кётоку (1452–1455)","Эпоха Косё (1455–1457)","Эпоха Тёроку (1457–1460)","Эпоха Кансё (1460–1466)","Эпоха Бунсё (1466–1467)","Эпоха Онин (1467–1469)","Эпоха Буммэй (1469–1487)","Эпоха Тёкё (1487–1489)","Эпоха Энтоку (1489–1492)","Эпоха Мэйо (1492–1501)","Эпоха Бунки (1501–1504)","Эпоха Эйсё (1504–1521)","Эпоха Тайэй (1521–1528)","Эпоха Кёроку (1528–1532)","Эпоха Тэммон (1532–1555)","Эпоха Кодзи (1555–1558)","Эпоха Эйроку (1558–1570)","Эпоха Гэнки (1570–1573)","Эпоха Тэнсё (1573–1592)","Эпоха Бунроку (1592–1596)","Эпоха Кэйтё (1596–1615)","Эпоха Гэнва (1615–1624)","Эпоха Канъэй (1624–1644)","Эпоха Сёхо (1644–1648)","Эпоха Кэйан (1648–1652)","Эпоха Сё (1652–1655)","Эпоха Мэйряку (1655–1658)","Эпоха Мандзи (1658–1661)","Эпоха Камбун (1661–1673)","Эпоха Эмпо (1673–1681)","Эпоха Тэнва (1681–1684)","Эпоха Дзёкё (1684–1688)","Эпоха Гэнроку (1688–1704)","Эпоха Хоэй (1704–1711)","Эпоха Сётоку (1711–1716)","Эпоха Кёхо (1716–1736)","Эпоха Гэмбун (1736–1741)","Эпоха Кампо (1741–1744)","Эпоха Энкё (1744–1748)","Эпоха Канъэн (1748–1751)","Эпоха Хоряку (1751–1764)","Эпоха Мэйва (1764–1772)","Эпоха Анъэй (1772–1781)","Эпоха Тэммэй (1781–1789)","Эпоха Кансэй (1789–1801)","Эпоха Кёва (1801–1804)","Эпоха Бунка (1804–1818)","Эпоха Бунсэй (1818–1830)","Эпоха Тэмпо (1830–1844)","Эпоха Кока (1844–1848)","Эпоха Каэй (1848–1854)","Эпоха Ансэй (1854–1860)","Эпоха Манъэн (1860–1861)","Эпоха Бункю (1861–1864)","Эпоха Гендзи (1864–1865)","Эпоха Кейо (1865–1868)","Эпоха Мэйдзи","Эпоха Тайсьо","Сьова","Эпоха Хэйсэй"],"long":["Эпоха Тайка (645–650)","Эпоха Хакути (650–671)","Эпоха Хакухо (672–686)","Эпоха Сючё (686–701)","Эпоха Тайхо (701–704)","Эпоха Кёюн (704–708)","Эпоха Вадо (708–715)","Эпоха Рэйки (715–717)","Эпоха Ёро (717–724)","Эпоха Дзинки (724–729)","Эпоха Темпьё (729–749)","Эпоха Темпьё (749–749)","Эпоха Темпьё-Сьохо (749-757)","Эпоха Темпьё-Ходзи (757-765)","Эпоха Темпьё-Ходзи (765-767)","Эпоха Джинго-Кёюн (767-770)","Эпоха Хоки (770–780)","Эпоха Теньё (781–782)","Эпоха Енряку (782–806)","Эпоха Дайдо (806–810)","Эпоха Конин (810–824)","Эпоха Тентьо (824–834)","Эпоха Шова (834–848)","Эпоха Кайо (848–851)","Эпоха Ниндзю (851–854)","Эпоха Сайко (854–857)","Эпоха Теннан (857–859)","Эпоха Йоган (859–877)","Эпоха Генкей (877–885)","Эпоха Нинна (885–889)","Эпоха Кампьё (889–898)","Эпоха Сьотай (898–901)","Эпоха Энги (901–923)","Эпоха Ентьо (923–931)","Эпоха Сьёхэй (931–938)","Эпоха Тенгьо (938–947)","Эпоха Тенрияку (947–957)","Эпоха Тентоку (957–961)","Эпоха Ова (961–964)","Эпоха Кохо (964–968)","Эпоха Анна (968–970)","Эпоха Тенроку (970–973)","Эпоха Теньен (973–976)","Эпоха Дзьоген (976–978)","Эпоха Тенген (978–983)","Эпоха Ейкан (983–985)","Эпоха Канна (985–987)","Эпоха Ейен (987–989)","Эпоха Ейсо (989–990)","Эпоха Сёряку (990–995)","Эпоха Тётоку (995–999)","Эпоха Тёхо (999–1004)","Эпоха Канко (1004–1012)","Эпоха Тёва (1012–1017)","Эпоха Каннин (1017–1021)","Эпоха Дзиан (1021–1024)","Эпоха Мандзю (1024–1028)","Эпоха Тёгэн (1028–1037)","Эпоха Тёряку (1037–1040)","Эпоха Тёкю (1040–1044)","Эпоха Катоку (1044–1046)","Эпоха Эйсо (1046–1053)","Эпоха Тэнги (1053–1058)","Эпоха Кохэй (1058–1065)","Эпоха Дзиряку (1065–1069)","Эпоха Энкю (1069–1074)","Эпоха Сёхо (1074–1077)","Эпоха Сёряку (1077–1081)","Эпоха Эйхо (1081–1084)","Эпоха Отоку (1084–1087)","Эпоха Кандзи (1087–1094)","Эпоха Кахо (1094–1096)","Эпоха Эйтё (1096–1097)","Эпоха Сётоку (1097–1099)","Эпоха Кова (1099–1104)","Эпоха Тёдзи (1104–1106)","Эпоха Касё (1106–1108)","Эпоха Тэннин (1108–1110)","Эпоха Тэнъэй (1110–1113)","Эпоха Эйкю (1113–1118)","Эпоха Гэнъэй (1118–1120)","Эпоха Хоан (1120–1124)","Эпоха Тэндзи (1124–1126)","Эпоха Дайдзи (1126–1131)","Эпоха Тэнсё (1131–1132)","Эпоха Тёсё (1132–1135)","Эпоха Хоэн (1135–1141)","Эпоха Эйдзи (1141–1142)","Эпоха Кодзи (1142–1144)","Эпоха Тэнё (1144–1145)","Эпоха Кюан (1145–1151)","Эпоха Нимпэй (1151–1154)","Эпоха Кюдзю (1154–1156)","Эпоха Хогэн (1156–1159)","Эпоха Хэйдзи (1159–1160)","Эпоха Эйряку (1160–1161)","Эпоха Охо (1161–1163)","Эпоха Тёкан (1163–1165)","Эпоха Эйман (1165–1166)","Эпоха Нинъан (1166–1169)","Эпоха Као (1169–1171)","Эпоха Сёан (1171–1175)","Эпоха Ангэн (1175–1177)","Эпоха Дзисё (1177–1181)","Эпоха Ёва (1181–1182)","Эпоха Дзюэй (1182–1184)","Эпоха Гэнрюку (1184–1185)","Эпоха Бундзи (1185–1190)","Эпоха Кэнкю (1190–1199)","Эпоха Сёдзи (1199–1201)","Эпоха Кэннин (1201–1204)","Эпоха Гэнкю (1204–1206)","Эпоха Кэнъэй (1206–1207)","Эпоха Сёгэн (1207–1211)","Эпоха Кэнряку (1211–1213)","Эпоха Кэмпо (1213–1219)","Эпоха Сёкю (1219–1222)","Эпоха Дзёо (1222–1224)","Эпоха Гэннин (1224–1225)","Эпоха Кароку (1225–1227)","Эпоха Антэй (1227–1229)","Эпоха Канки (1229–1232)","Эпоха Дзёэй (1232–1233)","Эпоха Тэмпуку (1233–1234)","Эпоха Бунряку (1234–1235)","Эпоха Катэй (1235–1238)","Эпоха Рякунин (1238–1239)","Эпоха Энъо (1239–1240)","Эпоха Ниндзи (1240–1243)","Эпоха Кангэн (1243–1247)","Эпоха Ходзи (1247–1249)","Эпоха Кэнтё (1249–1256)","Эпоха Когэн (1256–1257)","Эпоха Сёка (1257–1259)","Эпоха Сёгэн (1259–1260)","Эпоха Бунъо (1260–1261)","Эпоха Котё (1261–1264)","Эпоха Бунъэй (1264–1275)","Эпоха Кэндзи (1275–1278)","Эпоха Коан (1278–1288)","Эпоха Сёо (1288–1293)","Эпоха Эйнин (1293–1299)","Эпоха Сёан (1299–1302)","Эпоха Кэнгэн (1302–1303)","Эпоха Кагэн (1303–1306)","Эпоха Токудзи (1306–1308)","Эпоха Энкэй (1308–1311)","Эпоха Отё (1311–1312)","Эпоха Сёва (1312–1317)","Эпоха Бумпо (1317–1319)","Эпоха Гэно (1319–1321)","Эпоха Гэнкё (1321–1324)","Эпоха Сётю (1324–1326)","Эпоха Карэки (1326–1329)","Эпоха Гэнтоку (1329–1331)","Эпоха Гэнко (1331–1334)","Эпоха Кэмму (1334–1336)","Эпоха Энгэн (1336–1340)","Эпоха Кококу (1340–1346)","Эпоха Сёхэй (1346–1370)","Эпоха Кэнтоку (1370–1372)","Эпоха Бунтю (1372–1375)","Эпоха Иэндзю (1375–1379)","Эпоха Коряку (1379–1381)","Эпоха Кова (1381–1384)","Эпоха Гэнтю (1384–1392)","Эпоха Мэйтоку (1384–1387)","Эпоха Какэй (1387–1389)","Эпоха Коо (1389–1390)","Эпоха Мэйтоку (1390–1394)","Эпоха Оэй (1394–1428)","Эпоха Сётё (1428–1429)","Эпоха Эйкё (1429–1441)","Эпоха Какицу (1441–1444)","Эпоха Банъан (1444–1449)","Эпоха Хотоку (1449–1452)","Эпоха Кётоку (1452–1455)","Эпоха Косё (1455–1457)","Эпоха Тёроку (1457–1460)","Эпоха Кансё (1460–1466)","Эпоха Бунсё (1466–1467)","Эпоха Онин (1467–1469)","Эпоха Буммэй (1469–1487)","Эпоха Тёкё (1487–1489)","Эпоха Энтоку (1489–1492)","Эпоха Мэйо (1492–1501)","Эпоха Бунки (1501–1504)","Эпоха Эйсё (1504–1521)","Эпоха Тайэй (1521–1528)","Эпоха Кёроку (1528–1532)","Эпоха Тэммон (1532–1555)","Эпоха Кодзи (1555–1558)","Эпоха Эйроку (1558–1570)","Эпоха Гэнки (1570–1573)","Эпоха Тэнсё (1573–1592)","Эпоха Бунроку (1592–1596)","Эпоха Кэйтё (1596–1615)","Эпоха Гэнва (1615–1624)","Эпоха Канъэй (1624–1644)","Эпоха Сёхо (1644–1648)","Эпоха Кэйан (1648–1652)","Эпоха Сё (1652–1655)","Эпоха Мэйряку (1655–1658)","Эпоха Мандзи (1658–1661)","Эпоха Камбун (1661–1673)","Эпоха Эмпо (1673–1681)","Эпоха Тэнва (1681–1684)","Эпоха Дзёкё (1684–1688)","Эпоха Гэнроку (1688–1704)","Эпоха Хоэй (1704–1711)","Эпоха Сётоку (1711–1716)","Эпоха Кёхо (1716–1736)","Эпоха Гэмбун (1736–1741)","Эпоха Кампо (1741–1744)","Эпоха Энкё (1744–1748)","Эпоха Канъэн (1748–1751)","Эпоха Хоряку (1751–1764)","Эпоха Мэйва (1764–1772)","Эпоха Анъэй (1772–1781)","Эпоха Тэммэй (1781–1789)","Эпоха Кансэй (1789–1801)","Эпоха Кёва (1801–1804)","Эпоха Бунка (1804–1818)","Эпоха Бунсэй (1818–1830)","Эпоха Тэмпо (1830–1844)","Эпоха Кока (1844–1848)","Эпоха Каэй (1848–1854)","Эпоха Ансэй (1854–1860)","Эпоха Манъэн (1860–1861)","Эпоха Бункю (1861–1864)","Эпоха Гендзи (1864–1865)","Эпоха Кейо (1865–1868)","Эпоха Мэйдзи","Эпоха Тайсьо","Сьова","Эпоха Хэйсэй"]},dayPeriods:{am:"ДП",pm:"ПП"}},persian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],"short":["Фарвардин","Ордибехешт","Хордад","Тир","Мордад","Шахривер","Мехр","Абан","Азер","Дей","Бахман","Эсфанд"],"long":["Фарвардин","Ордибехешт","Хордад","Тир","Мордад","Шахривер","Мехр","Абан","Азер","Дей","Бахман","Эсфанд"]},days:{narrow:["вс","пн","вт","ср","чт","пт","сб"],"short":["вс","пн","вт","ср","чт","пт","сб"],"long":["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"]},eras:{narrow:["AP"],"short":["AP"],"long":["AP"]},dayPeriods:{am:"ДП",pm:"ПП"}},roc:{months:{narrow:["Я","Ф","М","А","М","И","И","А","С","О","Н","Д"],"short":["янв.","февр.","мар.","апр.","мая","июн.","июл.","авг.","сент.","окт.","нояб.","дек."],"long":["января","февраля","марта","апреля","мая","июня","июля","августа","сентября","октября","ноября","декабря"]},days:{narrow:["вс","пн","вт","ср","чт","пт","сб"],"short":["вс","пн","вт","ср","чт","пт","сб"],"long":["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"]},eras:{narrow:["Before R.O.C.","Minguo"],"short":["Before R.O.C.","Minguo"],"long":["Before R.O.C.","Minguo"]},dayPeriods:{am:"ДП",pm:"ПП"}}}},number:{nu:["latn"],patterns:{decimal:{positivePattern:"{number}",negativePattern:"-{number}"},currency:{positivePattern:"{number} {currency}",negativePattern:"-{number} {currency}"},percent:{positivePattern:"{number} %",negativePattern:"-{number} %"}},symbols:{latn:{decimal:",",group:" ",nan:"не число",percent:"%",infinity:"∞"}},currencies:{AUD:"A$",BRL:"R$",CAD:"CA$",CNY:"CN¥",EUR:"€",GBP:"£",HKD:"HK$",ILS:"₪",INR:"₹",JPY:"¥",KRW:"₩",MXN:"MX$",NZD:"NZ$",RUB:"₽",RUR:"р.",THB:"฿",TMT:"ТМТ",TWD:"NT$",UAH:"₴",USD:"$",VND:"₫",XAF:"FCFA",XCD:"EC$",XOF:"CFA",XPF:"CFPF",XXX:"XXXX"}}})},function(e,t){IntlPolyfill.__addLocaleData({locale:"en",date:{ca:["gregory","buddhist","chinese","coptic","dangi","ethioaa","ethiopic","generic","hebrew","indian","islamic","islamicc","japanese","persian","roc"],hourNo0:!0,hour12:!0,formats:{"short":"{1}, {0}",medium:"{1}, {0}",full:"{1} 'at' {0}","long":"{1} 'at' {0}",availableFormats:{d:"d",E:"ccc",Ed:"d E",Ehm:"E h:mm a",EHm:"E HH:mm",Ehms:"E h:mm:ss a",EHms:"E HH:mm:ss",Gy:"y G",GyMMM:"MMM y G",GyMMMd:"MMM d, y G",GyMMMEd:"E, MMM d, y G",h:"h a",H:"HH",hm:"h:mm a",Hm:"HH:mm",hms:"h:mm:ss a",Hms:"HH:mm:ss",hmsv:"h:mm:ss a v",Hmsv:"HH:mm:ss v",hmv:"h:mm a v",Hmv:"HH:mm v",M:"L",Md:"M/d",MEd:"E, M/d",MMM:"LLL",MMMd:"MMM d",MMMEd:"E, MMM d",MMMMd:"MMMM d",ms:"mm:ss",y:"y",yM:"M/y",yMd:"M/d/y",yMEd:"E, M/d/y",yMMM:"MMM y",yMMMd:"MMM d, y",yMMMEd:"E, MMM d, y",yMMMM:"MMMM y",yQQQ:"QQQ y",yQQQQ:"QQQQ y"},dateFormats:{yMMMMEEEEd:"EEEE, MMMM d, y",yMMMMd:"MMMM d, y",yMMMd:"MMM d, y",yMd:"M/d/yy"},timeFormats:{hmmsszzzz:"h:mm:ss a zzzz",hmsz:"h:mm:ss a z",hms:"h:mm:ss a",hm:"h:mm a"}},calendars:{buddhist:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],"short":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"long":["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],"short":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"long":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["BE"],"short":["BE"],"long":["BE"]},dayPeriods:{am:"AM",pm:"PM"}},chinese:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],"short":["Mo1","Mo2","Mo3","Mo4","Mo5","Mo6","Mo7","Mo8","Mo9","Mo10","Mo11","Mo12"],"long":["Month1","Month2","Month3","Month4","Month5","Month6","Month7","Month8","Month9","Month10","Month11","Month12"]},days:{narrow:["S","M","T","W","T","F","S"],"short":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"long":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},dayPeriods:{am:"AM",pm:"PM"}},coptic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],"short":["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"],"long":["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"]},days:{narrow:["S","M","T","W","T","F","S"],"short":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"long":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],"short":["ERA0","ERA1"],"long":["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},dangi:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],"short":["Mo1","Mo2","Mo3","Mo4","Mo5","Mo6","Mo7","Mo8","Mo9","Mo10","Mo11","Mo12"],"long":["Month1","Month2","Month3","Month4","Month5","Month6","Month7","Month8","Month9","Month10","Month11","Month12"]},days:{narrow:["S","M","T","W","T","F","S"],"short":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"long":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},dayPeriods:{am:"AM",pm:"PM"}},ethiopic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],"short":["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],"long":["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["S","M","T","W","T","F","S"],"short":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"long":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],"short":["ERA0","ERA1"],"long":["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},ethioaa:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],"short":["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],"long":["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["S","M","T","W","T","F","S"],"short":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"long":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0"],"short":["ERA0"],"long":["ERA0"]},dayPeriods:{am:"AM",pm:"PM"}},generic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],"short":["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"],"long":["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["S","M","T","W","T","F","S"],"short":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"long":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],"short":["ERA0","ERA1"],"long":["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},gregory:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],"short":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"long":["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],"short":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"long":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["B","A","BCE","CE"],"short":["BC","AD","BCE","CE"],"long":["Before Christ","Anno Domini","Before Common Era","Common Era"]},dayPeriods:{am:"AM",pm:"PM"}},hebrew:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13","7"],"short":["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"],"long":["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"]},days:{narrow:["S","M","T","W","T","F","S"],"short":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"long":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AM"],"short":["AM"],"long":["AM"]},dayPeriods:{am:"AM",pm:"PM"}},indian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],"short":["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"],"long":["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"]},days:{narrow:["S","M","T","W","T","F","S"],"short":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"long":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Saka"],"short":["Saka"],"long":["Saka"]},dayPeriods:{am:"AM",pm:"PM"}},islamic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],"short":["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],"long":["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["S","M","T","W","T","F","S"],"short":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"long":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AH"],"short":["AH"],"long":["AH"]},dayPeriods:{am:"AM",pm:"PM"}},islamicc:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],"short":["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],"long":["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["S","M","T","W","T","F","S"],"short":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"long":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AH"],"short":["AH"],"long":["AH"]},dayPeriods:{am:"AM",pm:"PM"}},japanese:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],"short":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"long":["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],"short":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"long":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","M","T","S","H"],"short":["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"],"long":["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"]
},dayPeriods:{am:"AM",pm:"PM"}},persian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],"short":["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"],"long":["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"]},days:{narrow:["S","M","T","W","T","F","S"],"short":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"long":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AP"],"short":["AP"],"long":["AP"]},dayPeriods:{am:"AM",pm:"PM"}},roc:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],"short":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"long":["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],"short":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"long":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Before R.O.C.","Minguo"],"short":["Before R.O.C.","Minguo"],"long":["Before R.O.C.","Minguo"]},dayPeriods:{am:"AM",pm:"PM"}}}},number:{nu:["latn"],patterns:{decimal:{positivePattern:"{number}",negativePattern:"-{number}"},currency:{positivePattern:"{currency}{number}",negativePattern:"-{currency}{number}"},percent:{positivePattern:"{number}%",negativePattern:"-{number}%"}},symbols:{latn:{decimal:".",group:",",nan:"NaN",percent:"%",infinity:"∞"}},currencies:{AUD:"A$",BRL:"R$",CAD:"CA$",CNY:"CN¥",EUR:"€",GBP:"£",HKD:"HK$",ILS:"₪",INR:"₹",JPY:"¥",KRW:"₩",MXN:"MX$",NZD:"NZ$",TWD:"NT$",USD:"$",VND:"₫",XAF:"FCFA",XCD:"EC$",XOF:"CFA",XPF:"CFPF"}}})},,function(e,t,n){"use strict";var r=n(71).default;t.__esModule=!0;var i=function(e){n.e(1,function(){n(103),e()})},o=function(e){if("object"==typeof window.localStorage)try{localStorage.setItem("localStorageTest",1),localStorage.removeItem("localStorageTest"),e()}catch(t){i(e)}else i(e)};t.default=function(){return new r(o)},e.exports=t.default},,function(e,t,n){e.exports={"default":n(105),__esModule:!0}},function(e,t,n){n(106),e.exports=n(35).Object.keys},[729,107,108],[724,49],[728,34,35,33],function(e,t,n){"use strict";var r=n(71).default;t.__esModule=!0;var i=function(e){n(110).polyfill(),e()};t.default=function(){return new r(i)},e.exports=t.default},function(e,t,n){(function(t){for(var r=n(111),i="undefined"==typeof window?t:window,o=["moz","webkit"],a="AnimationFrame",s=i["request"+a],u=i["cancel"+a]||i["cancelRequest"+a],l=0;!s&&l<o.length;l++)s=i[o[l]+"Request"+a],u=i[o[l]+"Cancel"+a]||i[o[l]+"CancelRequest"+a];if(!s||!u){var c=0,d=0,p=[],f=1e3/60;s=function(e){if(0===p.length){var t=r(),n=Math.max(0,f-(t-c));c=n+t,setTimeout(function(){var e=p.slice(0);p.length=0;for(var t=0;t<e.length;t++)if(!e[t].cancelled)try{e[t].callback(c)}catch(n){setTimeout(function(){throw n},0)}},Math.round(n))}return p.push({handle:++d,callback:e,cancelled:!1}),d},u=function(e){for(var t=0;t<p.length;t++)p[t].handle===e&&(p[t].cancelled=!0)}}e.exports=function(e){return s.call(i,e)},e.exports.cancel=function(){u.apply(i,arguments)},e.exports.polyfill=function(){i.requestAnimationFrame=s,i.cancelAnimationFrame=u}}).call(t,function(){return this}())},function(e,t,n){(function(t){(function(){var n,r,i;"undefined"!=typeof performance&&null!==performance&&performance.now?e.exports=function(){return performance.now()}:"undefined"!=typeof t&&null!==t&&t.hrtime?(e.exports=function(){return(n()-i)/1e6},r=t.hrtime,n=function(){var e;return e=r(),1e9*e[0]+e[1]},i=n()):Date.now?(e.exports=function(){return Date.now()-i},i=Date.now()):(e.exports=function(){return(new Date).getTime()-i},i=(new Date).getTime())}).call(this)}).call(t,n(25))},function(e,t,n){e.exports=n(113)},function(e,t,n){(function(e){"use strict";if(n(114),n(301),e._babelPolyfill)throw new Error("only one instance of babel/polyfill is allowed");e._babelPolyfill=!0}).call(t,function(){return this}())},function(e,t,n){n(115),n(148),n(154),n(156),n(158),n(160),n(162),n(164),n(165),n(166),n(167),n(168),n(169),n(170),n(171),n(172),n(173),n(174),n(175),n(178),n(179),n(180),n(182),n(183),n(184),n(185),n(186),n(187),n(188),n(190),n(191),n(192),n(194),n(195),n(196),n(198),n(199),n(200),n(201),n(202),n(203),n(204),n(205),n(206),n(207),n(208),n(209),n(210),n(211),n(216),n(217),n(221),n(222),n(224),n(225),n(230),n(231),n(234),n(236),n(238),n(240),n(241),n(242),n(244),n(245),n(247),n(248),n(249),n(250),n(257),n(260),n(261),n(263),n(264),n(265),n(266),n(267),n(268),n(269),n(270),n(271),n(272),n(273),n(274),n(276),n(277),n(278),n(279),n(280),n(281),n(283),n(284),n(285),n(286),n(288),n(289),n(291),n(292),n(294),n(295),n(296),n(299),n(300),e.exports=n(119)},function(e,t,n){"use strict";var r,i=n(116),o=n(117),a=n(122),s=n(121),u=n(128),l=n(129),c=n(131),d=n(132),p=n(133),f=n(123),h=n(134),v=n(127),y=n(130),g=n(135),m=n(137),_=n(139),A=n(140),C=n(141),b=n(138),S=n(125)("__proto__"),M=n(142),T=n(147)(!1),E=Object.prototype,w=Array.prototype,x=w.slice,k=w.join,I=i.setDesc,P=i.getDesc,D=i.setDescs,N={};a||(r=!f(function(){return 7!=I(l("div"),"a",{get:function(){return 7}}).a}),i.setDesc=function(e,t,n){if(r)try{return I(e,t,n)}catch(i){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(h(e)[t]=n.value),e},i.getDesc=function(e,t){if(r)try{return P(e,t)}catch(n){}return c(e,t)?s(!E.propertyIsEnumerable.call(e,t),e[t]):void 0},i.setDescs=D=function(e,t){h(e);for(var n,r=i.getKeys(t),o=r.length,a=0;o>a;)i.setDesc(e,n=r[a++],t[n]);return e}),o(o.S+o.F*!a,"Object",{getOwnPropertyDescriptor:i.getDesc,defineProperty:i.setDesc,defineProperties:D});var O="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","),R=O.concat("length","prototype"),F=O.length,H=function(){var e,t=l("iframe"),n=F,r=">";for(t.style.display="none",u.appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object</script"+r),e.close(),H=e.F;n--;)delete H.prototype[O[n]];return H()},L=function(e,t){return function(n){var r,i=m(n),o=0,a=[];for(r in i)r!=S&&c(i,r)&&a.push(r);for(;t>o;)c(i,r=e[o++])&&(~T(a,r)||a.push(r));return a}},B=function(){};o(o.S,"Object",{getPrototypeOf:i.getProto=i.getProto||function(e){return e=g(e),c(e,S)?e[S]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?E:null},getOwnPropertyNames:i.getNames=i.getNames||L(R,R.length,!0),create:i.create=i.create||function(e,t){var n;return null!==e?(B.prototype=h(e),n=new B,B.prototype=null,n[S]=e):n=H(),void 0===t?n:D(n,t)},keys:i.getKeys=i.getKeys||L(O,F,!1)});var U=function(e,t,n){if(!(t in N)){for(var r=[],i=0;t>i;i++)r[i]="a["+i+"]";N[t]=Function("F,a","return new F("+r.join(",")+")")}return N[t](e,n)};o(o.P,"Function",{bind:function(e){var t=v(this),n=x.call(arguments,1),r=function(){var i=n.concat(x.call(arguments));return this instanceof r?U(t,i.length,i):p(t,i,e)};return y(t.prototype)&&(r.prototype=t.prototype),r}}),o(o.P+o.F*f(function(){u&&x.call(u)}),"Array",{slice:function(e,t){var n=C(this.length),r=d(this);if(t=void 0===t?n:t,"Array"==r)return x.call(this,e,t);for(var i=A(e,n),o=A(t,n),a=C(o-i),s=Array(a),u=0;a>u;u++)s[u]="String"==r?this.charAt(i+u):this[i+u];return s}}),o(o.P+o.F*(b!=Object),"Array",{join:function(e){return k.call(b(this),void 0===e?",":e)}}),o(o.S,"Array",{isArray:n(144)});var K=function(e){return function(t,n){v(t);var r=b(this),i=C(r.length),o=e?i-1:0,a=e?-1:1;if(arguments.length<2)for(;;){if(o in r){n=r[o],o+=a;break}if(o+=a,e?0>o:o>=i)throw TypeError("Reduce of empty array with no initial value")}for(;e?o>=0:i>o;o+=a)o in r&&(n=t(n,r[o],o,this));return n}},j=function(e){return function(t){return e(this,t,arguments[1])}};o(o.P,"Array",{forEach:i.each=i.each||j(M(0)),map:j(M(1)),filter:j(M(2)),some:j(M(3)),every:j(M(4)),reduce:K(!1),reduceRight:K(!0),indexOf:j(T),lastIndexOf:function(e,t){var n=m(this),r=C(n.length),i=r-1;for(arguments.length>1&&(i=Math.min(i,_(t))),0>i&&(i=C(r+i));i>=0;i--)if(i in n&&n[i]===e)return i;return-1}}),o(o.S,"Date",{now:function(){return+new Date}});var V=function(e){return e>9?e:"0"+e};o(o.P+o.F*(f(function(){return"0385-07-25T07:06:39.999Z"!=new Date(-5e13-1).toISOString()})||!f(function(){new Date(NaN).toISOString()})),"Date",{toISOString:function(){if(!isFinite(this))throw RangeError("Invalid time value");var e=this,t=e.getUTCFullYear(),n=e.getUTCMilliseconds(),r=0>t?"-":t>9999?"+":"";return r+("00000"+Math.abs(t)).slice(r?-6:-4)+"-"+V(e.getUTCMonth()+1)+"-"+V(e.getUTCDate())+"T"+V(e.getUTCHours())+":"+V(e.getUTCMinutes())+":"+V(e.getUTCSeconds())+"."+(n>99?n:"0"+V(n))+"Z"}})},29,function(e,t,n){var r=n(118),i=n(119),o=n(120),a=n(124),s=n(126),u="prototype",l=function(e,t,n){var c,d,p,f,h=e&l.F,v=e&l.G,y=e&l.S,g=e&l.P,m=e&l.B,_=v?r:y?r[t]||(r[t]={}):(r[t]||{})[u],A=v?i:i[t]||(i[t]={}),C=A[u]||(A[u]={});v&&(n=t);for(c in n)d=!h&&_&&c in _,p=(d?_:n)[c],f=m&&d?s(p,r):g&&"function"==typeof p?s(Function.call,p):p,_&&!d&&a(_,c,p),A[c]!=p&&o(A,c,f),g&&C[c]!=p&&(C[c]=p)};r.core=i,l.F=1,l.G=2,l.S=4,l.P=8,l.B=16,l.W=32,e.exports=l},30,35,[693,116,121,122],40,[691,123],33,function(e,t,n){var r=n(118),i=n(120),o=n(125)("src"),a="toString",s=Function[a],u=(""+s).split(a);n(119).inspectSource=function(e){return s.call(e)},(e.exports=function(e,t,n,a){"function"==typeof n&&(n.hasOwnProperty(o)||i(n,o,e[t]?""+e[t]:u.join(String(t))),n.hasOwnProperty("name")||i(n,"name",t)),e===r?e[t]=n:(a||delete e[t],i(e,t,n))})(Function.prototype,a,function(){return"function"==typeof this&&this[o]||s.call(this)})},44,[692,127],37,[720,118],[721,130,118],54,31,48,86,[703,130],[724,136],49,[698,138,136],[699,132],61,function(e,t,n){var r=n(139),i=Math.max,o=Math.min;e.exports=function(e,t){return e=r(e),0>e?i(e+t,0):o(e,t)}},[714,139],function(e,t,n){var r=n(126),i=n(138),o=n(135),a=n(141),s=n(143);e.exports=function(e){var t=1==e,n=2==e,u=3==e,l=4==e,c=6==e,d=5==e||c;return function(p,f,h){for(var v,y,g=o(p),m=i(g),_=r(f,h,3),A=a(m.length),C=0,b=t?s(p,A):n?s(p,0):void 0;A>C;C++)if((d||C in m)&&(v=m[C],y=_(v,C,g),e))if(t)b[C]=y;else if(y)switch(e){case 3:return!0;case 5:return v;case 6:return C;case 2:b.push(v)}else if(l)return!1;return c?-1:u||l?l:b}}},function(e,t,n){var r=n(130),i=n(144),o=n(145)("species");e.exports=function(e,t){var n;return i(e)&&(n=e.constructor,"function"!=typeof n||n!==Array&&!i(n.prototype)||(n=void 0),r(n)&&(n=n[o],null===n&&(n=void 0))),new(void 0===n?Array:n)(t)}},[702,132],[696,146,125,118],[694,118],function(e,t,n){var r=n(137),i=n(141),o=n(140);e.exports=function(e){return function(t,n,a){var s,u=r(t),l=i(u.length),c=o(a,l);if(e&&n!=n){for(;l>c;)if(s=u[c++],s!=s)return!0}else for(;l>c;c++)if((e||c in u)&&u[c]===n)return e||c;return!e&&-1}}},[690,116,118,131,122,117,124,123,146,149,125,145,150,151,152,144,134,137,121,153],[695,116,131,145],[697,116,137],[700,137,116],[701,116],function(e,t){e.exports=!1},[725,117,155],[726,116,135,138,123],function(e,t,n){var r=n(117);r(r.S,"Object",{is:n(157)})},82,[727,117,159],[716,116,130,134,126],function(e,t,n){"use strict";var r=n(161),i={};i[n(145)("toStringTag")]="z",i+""!="[object z]"&&n(124)(Object.prototype,"toString",function(){return"[object "+r(this)+"]"},!0)},[710,132,145],function(e,t,n){var r=n(130);n(163)("freeze",function(e){return function(t){return e&&r(t)?e(t):t}})},[728,117,119,123],function(e,t,n){var r=n(130);n(163)("seal",function(e){return function(t){return e&&r(t)?e(t):t}})},function(e,t,n){var r=n(130);n(163)("preventExtensions",function(e){return function(t){return e&&r(t)?e(t):t}})},function(e,t,n){var r=n(130);n(163)("isFrozen",function(e){return function(t){return r(t)?e?e(t):!1:!0}})},function(e,t,n){var r=n(130);n(163)("isSealed",function(e){return function(t){return r(t)?e?e(t):!1:!0}})},function(e,t,n){var r=n(130);n(163)("isExtensible",function(e){return function(t){return r(t)?e?e(t):!0:!1}})},function(e,t,n){var r=n(137);n(163)("getOwnPropertyDescriptor",function(e){return function(t,n){return e(r(t),n)}})},function(e,t,n){var r=n(135);n(163)("getPrototypeOf",function(e){return function(t){return e(r(t))}})},[729,135,163],function(e,t,n){n(163)("getOwnPropertyNames",function(){return n(151).get})},function(e,t,n){var r=n(116).setDesc,i=n(121),o=n(131),a=Function.prototype,s=/^\s*function ([^ (]*)/,u="name";u in a||n(122)&&r(a,u,{configurable:!0,get:function(){var e=(""+this).match(s),t=e?e[1]:"";return o(this,u)||r(this,u,i(5,t)),t}})},function(e,t,n){"use strict";var r=n(116),i=n(130),o=n(145)("hasInstance"),a=Function.prototype;o in a||r.setDesc(a,o,{value:function(e){if("function"!=typeof this||!i(e))return!1;if(!i(this.prototype))return e instanceof this;for(;e=r.getProto(e);)if(this.prototype===e)return!0;return!1}})},function(e,t,n){"use strict";var r=n(116),i=n(118),o=n(131),a=n(132),s=n(176),u=n(123),l=n(177).trim,c="Number",d=i[c],p=d,f=d.prototype,h=a(r.create(f))==c,v="trim"in String.prototype,y=function(e){var t=s(e,!1);if("string"==typeof t&&t.length>2){t=v?t.trim():l(t,3);var n,r,i,o=t.charCodeAt(0);if(43===o||45===o){if(n=t.charCodeAt(2),88===n||120===n)return NaN}else if(48===o){switch(t.charCodeAt(1)){case 66:case 98:r=2,i=49;break;case 79:case 111:r=8,i=55;break;default:return+t}for(var a,u=t.slice(2),c=0,d=u.length;d>c;c++)if(a=u.charCodeAt(c),48>a||a>i)return NaN;return parseInt(u,r)}}return+t};d(" 0o1")&&d("0b1")&&!d("+0x1")||(d=function(e){var t=arguments.length<1?0:e,n=this;return n instanceof d&&(h?u(function(){f.valueOf.call(n)}):a(n)!=c)?new p(y(t)):y(t)},r.each.call(n(122)?r.getNames(p):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),function(e){o(p,e)&&!o(d,e)&&r.setDesc(d,e,r.getDesc(p,e))}),d.prototype=f,f.constructor=d,n(124)(i,c,d))},function(e,t,n){var r=n(130);e.exports=function(e,t){if(!r(e))return e;var n,i;if(t&&"function"==typeof(n=e.toString)&&!r(i=n.call(e)))return i;if("function"==typeof(n=e.valueOf)&&!r(i=n.call(e)))return i;if(!t&&"function"==typeof(n=e.toString)&&!r(i=n.call(e)))return i;throw TypeError("Can't convert object to primitive value")}},function(e,t,n){var r=n(117),i=n(136),o=n(123),a="	\n\x0B\f\r   ᠎             　\u2028\u2029\ufeff",s="["+a+"]",u="​",l=RegExp("^"+s+s+"*"),c=RegExp(s+s+"*$"),d=function(e,t){var n={};n[e]=t(p),r(r.P+r.F*o(function(){return!!a[e]()||u[e]()!=u}),"String",n)},p=d.trim=function(e,t){return e=String(i(e)),1&t&&(e=e.replace(l,"")),2&t&&(e=e.replace(c,"")),e};e.exports=d},function(e,t,n){var r=n(117);r(r.S,"Number",{EPSILON:Math.pow(2,-52)})},function(e,t,n){var r=n(117),i=n(118).isFinite;r(r.S,"Number",{isFinite:function(e){return"number"==typeof e&&i(e)}})},function(e,t,n){var r=n(117);r(r.S,"Number",{isInteger:n(181)})},function(e,t,n){var r=n(130),i=Math.floor;e.exports=function(e){return!r(e)&&isFinite(e)&&i(e)===e}},function(e,t,n){var r=n(117);r(r.S,"Number",{isNaN:function(e){return e!=e}})},function(e,t,n){var r=n(117),i=n(181),o=Math.abs;r(r.S,"Number",{isSafeInteger:function(e){return i(e)&&o(e)<=9007199254740991}})},function(e,t,n){var r=n(117);r(r.S,"Number",{MAX_SAFE_INTEGER:9007199254740991})},function(e,t,n){var r=n(117);r(r.S,"Number",{MIN_SAFE_INTEGER:-9007199254740991})},function(e,t,n){var r=n(117);r(r.S,"Number",{parseFloat:parseFloat})},function(e,t,n){var r=n(117);r(r.S,"Number",{parseInt:parseInt})},function(e,t,n){var r=n(117),i=n(189),o=Math.sqrt,a=Math.acosh;r(r.S+r.F*!(a&&710==Math.floor(a(Number.MAX_VALUE))),"Math",{acosh:function(e){return(e=+e)<1?NaN:e>94906265.62425156?Math.log(e)+Math.LN2:i(e-1+o(e-1)*o(e+1))}})},function(e,t){e.exports=Math.log1p||function(e){return(e=+e)>-1e-8&&1e-8>e?e-e*e/2:Math.log(1+e)}},function(e,t,n){function r(e){return isFinite(e=+e)&&0!=e?0>e?-r(-e):Math.log(e+Math.sqrt(e*e+1)):e}var i=n(117);i(i.S,"Math",{asinh:r})},function(e,t,n){var r=n(117);r(r.S,"Math",{atanh:function(e){return 0==(e=+e)?e:Math.log((1+e)/(1-e))/2}})},function(e,t,n){var r=n(117),i=n(193);r(r.S,"Math",{cbrt:function(e){return i(e=+e)*Math.pow(Math.abs(e),1/3)}})},function(e,t){e.exports=Math.sign||function(e){return 0==(e=+e)||e!=e?e:0>e?-1:1}},function(e,t,n){var r=n(117);r(r.S,"Math",{clz32:function(e){return(e>>>=0)?31-Math.floor(Math.log(e+.5)*Math.LOG2E):32}})},function(e,t,n){var r=n(117),i=Math.exp;r(r.S,"Math",{cosh:function(e){return(i(e=+e)+i(-e))/2}})},function(e,t,n){var r=n(117);r(r.S,"Math",{expm1:n(197)})},function(e,t){e.exports=Math.expm1||function(e){return 0==(e=+e)?e:e>-1e-6&&1e-6>e?e+e*e/2:Math.exp(e)-1}},function(e,t,n){var r=n(117),i=n(193),o=Math.pow,a=o(2,-52),s=o(2,-23),u=o(2,127)*(2-s),l=o(2,-126),c=function(e){return e+1/a-1/a};r(r.S,"Math",{fround:function(e){var t,n,r=Math.abs(e),o=i(e);return l>r?o*c(r/l/s)*l*s:(t=(1+s/a)*r,n=t-(t-r),n>u||n!=n?o*(1/0):o*n)}})},function(e,t,n){var r=n(117),i=Math.abs;r(r.S,"Math",{hypot:function(e,t){for(var n,r,o=0,a=0,s=arguments,u=s.length,l=0;u>a;)n=i(s[a++]),n>l?(r=l/n,o=o*r*r+1,l=n):n>0?(r=n/l,o+=r*r):o+=n;return l===1/0?1/0:l*Math.sqrt(o)}})},function(e,t,n){var r=n(117),i=Math.imul;r(r.S+r.F*n(123)(function(){return-5!=i(4294967295,5)||2!=i.length}),"Math",{imul:function(e,t){var n=65535,r=+e,i=+t,o=n&r,a=n&i;return 0|o*a+((n&r>>>16)*a+o*(n&i>>>16)<<16>>>0)}})},[730,117],function(e,t,n){var r=n(117);r(r.S,"Math",{log1p:n(189)})},function(e,t,n){var r=n(117);r(r.S,"Math",{log2:function(e){return Math.log(e)/Math.LN2}})},function(e,t,n){var r=n(117);r(r.S,"Math",{sign:n(193)})},function(e,t,n){var r=n(117),i=n(197),o=Math.exp;r(r.S+r.F*n(123)(function(){return-2e-17!=!Math.sinh(-2e-17)}),"Math",{sinh:function(e){return Math.abs(e=+e)<1?(i(e)-i(-e))/2:(o(e-1)-o(-e-1))*(Math.E/2)}})},function(e,t,n){var r=n(117),i=n(197),o=Math.exp;r(r.S,"Math",{tanh:function(e){var t=i(e=+e),n=i(-e);return t==1/0?1:n==1/0?-1:(t-n)/(o(e)+o(-e))}})},function(e,t,n){var r=n(117);r(r.S,"Math",{trunc:function(e){return(e>0?Math.floor:Math.ceil)(e)}})},function(e,t,n){var r=n(117),i=n(140),o=String.fromCharCode,a=String.fromCodePoint;r(r.S+r.F*(!!a&&1!=a.length),"String",{fromCodePoint:function(e){for(var t,n=[],r=arguments,a=r.length,s=0;a>s;){if(t=+r[s++],i(t,1114111)!==t)throw RangeError(t+" is not a valid code point");n.push(65536>t?o(t):o(((t-=65536)>>10)+55296,t%1024+56320))}return n.join("")}})},function(e,t,n){var r=n(117),i=n(137),o=n(141);r(r.S,"String",{raw:function(e){for(var t=i(e.raw),n=o(t.length),r=arguments,a=r.length,s=[],u=0;n>u;)s.push(String(t[u++])),a>u&&s.push(String(r[u]));return s.join("")}})},function(e,t,n){"use strict";n(177)("trim",function(e){return function(){return e(this,3)}})},[704,212,213],[705,139,136],[706,153,117,124,120,131,214,215,149,116,145],63,[707,116,121,149,120,145],function(e,t,n){"use strict";var r=n(117),i=n(212)(!1);r(r.P,"String",{codePointAt:function(e){return i(this,e)}})},function(e,t,n){"use strict";var r=n(117),i=n(141),o=n(218),a="endsWith",s=""[a];r(r.P+r.F*n(220)(a),"String",{endsWith:function(e){var t=o(this,e,a),n=arguments,r=n.length>1?n[1]:void 0,u=i(t.length),l=void 0===r?u:Math.min(i(r),u),c=String(e);return s?s.call(t,c,l):t.slice(l-c.length,l)===c}})},function(e,t,n){var r=n(219),i=n(136);e.exports=function(e,t,n){if(r(t))throw TypeError("String#"+n+" doesn't accept regex!");return String(i(e))}},function(e,t,n){var r=n(130),i=n(132),o=n(145)("match");e.exports=function(e){var t;return r(e)&&(void 0!==(t=e[o])?!!t:"RegExp"==i(e))}},function(e,t,n){var r=n(145)("match");e.exports=function(e){var t=/./;try{"/./"[e](t)}catch(n){try{return t[r]=!1,!"/./"[e](t)}catch(i){}}return!0}},function(e,t,n){"use strict";var r=n(117),i=n(218),o="includes";r(r.P+r.F*n(220)(o),"String",{includes:function(e){return!!~i(this,e,o).indexOf(e,arguments.length>1?arguments[1]:void 0)}})},[731,117,223],[732,139,136],function(e,t,n){"use strict";var r=n(117),i=n(141),o=n(218),a="startsWith",s=""[a];r(r.P+r.F*n(220)(a),"String",{startsWith:function(e){var t=o(this,e,a),n=arguments,r=i(Math.min(n.length>1?n[1]:void 0,t.length)),u=String(e);return s?s.call(t,u,r):t.slice(r,r+u.length)===u}})},[733,126,117,135,226,227,141,228,229],[712,134],[713,214,145],[715,161,145,214,119],[723,145],function(e,t,n){"use strict";var r=n(117);r(r.S+r.F*n(123)(function(){function e(){}return!(Array.of.call(e)instanceof e)}),"Array",{of:function(){for(var e=0,t=arguments,n=t.length,r=new("function"==typeof this?this:Array)(n);n>e;)r[e]=t[e++];return r.length=n,r}})},[708,232,233,214,137,213],function(e,t,n){var r=n(145)("unscopables"),i=Array.prototype;void 0==i[r]&&n(120)(i,r,{}),e.exports=function(e){i[r][e]=!0}},68,function(e,t,n){n(235)("Array")},function(e,t,n){"use strict";var r=n(118),i=n(116),o=n(122),a=n(145)("species");e.exports=function(e){var t=r[e];o&&t&&!t[a]&&i.setDesc(t,a,{configurable:!0,get:function(){return this}})}},function(e,t,n){var r=n(117);r(r.P,"Array",{copyWithin:n(237)}),n(232)("copyWithin")},function(e,t,n){"use strict";var r=n(135),i=n(140),o=n(141);e.exports=[].copyWithin||function(e,t){var n=r(this),a=o(n.length),s=i(e,a),u=i(t,a),l=arguments,c=l.length>2?l[2]:void 0,d=Math.min((void 0===c?a:i(c,a))-u,a-s),p=1;for(s>u&&u+d>s&&(p=-1,u+=d-1,s+=d-1);d-- >0;)u in n?n[s]=n[u]:delete n[s],s+=p,u+=p;return n}},function(e,t,n){var r=n(117);r(r.P,"Array",{fill:n(239)}),n(232)("fill")},function(e,t,n){"use strict";var r=n(135),i=n(140),o=n(141);e.exports=[].fill||function(e){for(var t=r(this),n=o(t.length),a=arguments,s=a.length,u=i(s>1?a[1]:void 0,n),l=s>2?a[2]:void 0,c=void 0===l?n:i(l,n);c>u;)t[u++]=e;return t}},function(e,t,n){"use strict";var r=n(117),i=n(142)(5),o="find",a=!0;o in[]&&Array(1)[o](function(){a=!1}),r(r.P+r.F*a,"Array",{find:function(e){return i(this,e,arguments.length>1?arguments[1]:void 0)}}),n(232)(o)},function(e,t,n){"use strict";var r=n(117),i=n(142)(6),o="findIndex",a=!0;o in[]&&Array(1)[o](function(){a=!1}),r(r.P+r.F*a,"Array",{findIndex:function(e){return i(this,e,arguments.length>1?arguments[1]:void 0)}}),n(232)(o)},function(e,t,n){var r=n(116),i=n(118),o=n(219),a=n(243),s=i.RegExp,u=s,l=s.prototype,c=/a/g,d=/a/g,p=new s(c)!==c;!n(122)||p&&!n(123)(function(){return d[n(145)("match")]=!1,s(c)!=c||s(d)==d||"/a/i"!=s(c,"i")})||(s=function(e,t){var n=o(e),r=void 0===t;return this instanceof s||!n||e.constructor!==s||!r?p?new u(n&&!r?e.source:e,t):u((n=e instanceof s)?e.source:e,n&&r?a.call(e):t):e},r.each.call(r.getNames(u),function(e){e in s||r.setDesc(s,e,{configurable:!0,get:function(){return u[e]},set:function(t){u[e]=t}})}),l.constructor=s,s.prototype=l,n(124)(i,"RegExp",s)),n(235)("RegExp")},function(e,t,n){"use strict";var r=n(134);e.exports=function(){var e=r(this),t="";return e.global&&(t+="g"),e.ignoreCase&&(t+="i"),e.multiline&&(t+="m"),e.unicode&&(t+="u"),e.sticky&&(t+="y"),t}},function(e,t,n){var r=n(116);n(122)&&"g"!=/./g.flags&&r.setDesc(RegExp.prototype,"flags",{configurable:!0,get:n(243)})},function(e,t,n){n(246)("match",1,function(e,t){return function(n){"use strict";var r=e(this),i=void 0==n?void 0:n[t];return void 0!==i?i.call(n,r):new RegExp(n)[t](String(r))}})},function(e,t,n){"use strict";var r=n(120),i=n(124),o=n(123),a=n(136),s=n(145);e.exports=function(e,t,n){var u=s(e),l=""[e];o(function(){var t={};return t[u]=function(){return 7},7!=""[e](t)})&&(i(String.prototype,e,n(a,u,l)),r(RegExp.prototype,u,2==t?function(e,t){return l.call(e,this,t)}:function(e){return l.call(e,this)}))}},function(e,t,n){n(246)("replace",2,function(e,t,n){return function(r,i){"use strict";var o=e(this),a=void 0==r?void 0:r[t];return void 0!==a?a.call(r,o,i):n.call(String(o),r,i)}})},function(e,t,n){n(246)("search",1,function(e,t){return function(n){"use strict";var r=e(this),i=void 0==n?void 0:n[t];return void 0!==i?i.call(n,r):new RegExp(n)[t](String(r))}})},function(e,t,n){n(246)("split",2,function(e,t,n){return function(r,i){"use strict";var o=e(this),a=void 0==r?void 0:r[t];return void 0!==a?a.call(r,o,i):n.call(String(o),r,i)}})},[709,116,153,118,126,161,117,130,134,127,251,252,159,157,145,253,254,122,256,149,235,119,229],75,[711,126,226,227,134,141,228],[717,134,127,145],[718,118,255,132],[719,126,133,128,129,118,132],[722,124],function(e,t,n){"use strict";var r=n(258);n(259)("Map",function(e){return function(){return e(this,arguments.length>0?arguments[0]:void 0)}},{get:function(e){var t=r.getEntry(this,e);return t&&t.v},set:function(e,t){return r.def(this,0===e?0:e,t)}},r,!0)},[734,116,120,256,126,251,136,252,213,233,125,131,130,235,122],function(e,t,n){"use strict";var r=n(118),i=n(117),o=n(124),a=n(256),s=n(252),u=n(251),l=n(130),c=n(123),d=n(229),p=n(149);e.exports=function(e,t,n,f,h,v){var y=r[e],g=y,m=h?"set":"add",_=g&&g.prototype,A={},C=function(e){var t=_[e];o(_,e,"delete"==e?function(e){return v&&!l(e)?!1:t.call(this,0===e?0:e)}:"has"==e?function(e){return v&&!l(e)?!1:t.call(this,0===e?0:e)}:"get"==e?function(e){return v&&!l(e)?void 0:t.call(this,0===e?0:e)}:"add"==e?function(e){return t.call(this,0===e?0:e),this}:function(e,n){return t.call(this,0===e?0:e,n),this})};if("function"==typeof g&&(v||_.forEach&&!c(function(){(new g).entries().next()}))){var b,S=new g,M=S[m](v?{}:-0,1)!=S,T=c(function(){S.has(1)}),E=d(function(e){new g(e)});E||(g=t(function(t,n){u(t,g,e);var r=new y;return void 0!=n&&s(n,h,r[m],r),r}),g.prototype=_,_.constructor=g),v||S.forEach(function(e,t){b=1/t===-(1/0)}),(T||b)&&(C("delete"),C("has"),h&&C("get")),(b||M)&&C(m),v&&_.clear&&delete _.clear}else g=f.getConstructor(t,e,h,m),a(g.prototype,n);return p(g,e),A[e]=g,i(i.G+i.W+i.F*(g!=y),A),v||f.setStrong(g,e,h),g}},[735,258,259],function(e,t,n){"use strict";var r=n(116),i=n(124),o=n(262),a=n(130),s=n(131),u=o.frozenStore,l=o.WEAK,c=Object.isExtensible||a,d={},p=n(259)("WeakMap",function(e){return function(){return e(this,arguments.length>0?arguments[0]:void 0)}},{get:function(e){if(a(e)){if(!c(e))return u(this).get(e);if(s(e,l))return e[l][this._i]}},set:function(e,t){return o.def(this,e,t)}},o,!0,!0);7!=(new p).set((Object.freeze||Object)(d),7).get(d)&&r.each.call(["delete","has","get","set"],function(e){var t=p.prototype,n=t[e];i(t,e,function(t,r){if(a(t)&&!c(t)){var i=u(this)[e](t,r);return"set"==e?this:i}return n.call(this,t,r)})})},function(e,t,n){"use strict";var r=n(120),i=n(256),o=n(134),a=n(130),s=n(251),u=n(252),l=n(142),c=n(131),d=n(125)("weak"),p=Object.isExtensible||a,f=l(5),h=l(6),v=0,y=function(e){return e._l||(e._l=new g)},g=function(){this.a=[]},m=function(e,t){return f(e.a,function(e){return e[0]===t})};g.prototype={get:function(e){var t=m(this,e);return t?t[1]:void 0},has:function(e){return!!m(this,e)},set:function(e,t){var n=m(this,e);n?n[1]=t:this.a.push([e,t])},"delete":function(e){var t=h(this.a,function(t){return t[0]===e});return~t&&this.a.splice(t,1),!!~t}},e.exports={getConstructor:function(e,t,n,r){var o=e(function(e,i){s(e,o,t),e._i=v++,e._l=void 0,void 0!=i&&u(i,n,e[r],e)});return i(o.prototype,{"delete":function(e){return a(e)?p(e)?c(e,d)&&c(e[d],this._i)&&delete e[d][this._i]:y(this).delete(e):!1},has:function(e){return a(e)?p(e)?c(e,d)&&c(e[d],this._i):y(this).has(e):!1}}),o},def:function(e,t,n){return p(o(t))?(c(t,d)||r(t,d,{}),t[d][e._i]=n):y(e).set(t,n),e},frozenStore:y,WEAK:d}},function(e,t,n){"use strict";var r=n(262);n(259)("WeakSet",function(e){return function(){return e(this,arguments.length>0?arguments[0]:void 0)}},{add:function(e){return r.def(this,e,!0)}},r,!1,!0)},function(e,t,n){var r=n(117),i=Function.apply;r(r.S,"Reflect",{apply:function(e,t,n){return i.call(e,t,n)}})},function(e,t,n){var r=n(116),i=n(117),o=n(127),a=n(134),s=n(130),u=Function.bind||n(119).Function.prototype.bind;i(i.S+i.F*n(123)(function(){function e(){}return!(Reflect.construct(function(){},[],e)instanceof e)}),"Reflect",{construct:function(e,t){o(e);var n=arguments.length<3?e:o(arguments[2]);if(e==n){if(void 0!=t)switch(a(t).length){case 0:return new e;case 1:return new e(t[0]);case 2:return new e(t[0],t[1]);case 3:return new e(t[0],t[1],t[2]);case 4:return new e(t[0],t[1],t[2],t[3])}var i=[null];return i.push.apply(i,t),new(u.apply(e,i))}var l=n.prototype,c=r.create(s(l)?l:Object.prototype),d=Function.apply.call(e,c,t);return s(d)?d:c}})},function(e,t,n){var r=n(116),i=n(117),o=n(134);i(i.S+i.F*n(123)(function(){Reflect.defineProperty(r.setDesc({},1,{value:1}),1,{value:2})}),"Reflect",{defineProperty:function(e,t,n){o(e);try{return r.setDesc(e,t,n),!0}catch(i){return!1}}})},function(e,t,n){var r=n(117),i=n(116).getDesc,o=n(134);r(r.S,"Reflect",{deleteProperty:function(e,t){var n=i(o(e),t);return n&&!n.configurable?!1:delete e[t]}})},function(e,t,n){"use strict";var r=n(117),i=n(134),o=function(e){this._t=i(e),this._i=0;var t,n=this._k=[];for(t in e)n.push(t)};n(215)(o,"Object",function(){var e,t=this,n=t._k;do if(t._i>=n.length)return{value:void 0,done:!0};while(!((e=n[t._i++])in t._t));return{value:e,done:!1}}),r(r.S,"Reflect",{enumerate:function(e){return new o(e)}})},function(e,t,n){function r(e,t){var n,a,l=arguments.length<3?e:arguments[2];return u(e)===l?e[t]:(n=i.getDesc(e,t))?o(n,"value")?n.value:void 0!==n.get?n.get.call(l):void 0:s(a=i.getProto(e))?r(a,t,l):void 0}var i=n(116),o=n(131),a=n(117),s=n(130),u=n(134);a(a.S,"Reflect",{get:r})},function(e,t,n){var r=n(116),i=n(117),o=n(134);i(i.S,"Reflect",{getOwnPropertyDescriptor:function(e,t){return r.getDesc(o(e),t)}})},function(e,t,n){var r=n(117),i=n(116).getProto,o=n(134);r(r.S,"Reflect",{getPrototypeOf:function(e){return i(o(e))}})},function(e,t,n){var r=n(117);r(r.S,"Reflect",{has:function(e,t){return t in e}})},function(e,t,n){var r=n(117),i=n(134),o=Object.isExtensible;r(r.S,"Reflect",{isExtensible:function(e){return i(e),o?o(e):!0}})},function(e,t,n){var r=n(117);r(r.S,"Reflect",{ownKeys:n(275)})},function(e,t,n){var r=n(116),i=n(134),o=n(118).Reflect;e.exports=o&&o.ownKeys||function(e){var t=r.getNames(i(e)),n=r.getSymbols;return n?t.concat(n(e)):t}},function(e,t,n){var r=n(117),i=n(134),o=Object.preventExtensions;r(r.S,"Reflect",{preventExtensions:function(e){i(e);try{return o&&o(e),!0}catch(t){return!1}}})},function(e,t,n){function r(e,t,n){var a,c,d=arguments.length<4?e:arguments[3],p=i.getDesc(u(e),t);if(!p){if(l(c=i.getProto(e)))return r(c,t,n,d);p=s(0)}return o(p,"value")?p.writable!==!1&&l(d)?(a=i.getDesc(d,t)||s(0),a.value=n,i.setDesc(d,t,a),!0):!1:void 0===p.set?!1:(p.set.call(d,n),!0)}var i=n(116),o=n(131),a=n(117),s=n(121),u=n(134),l=n(130);a(a.S,"Reflect",{set:r})},function(e,t,n){var r=n(117),i=n(159);i&&r(r.S,"Reflect",{setPrototypeOf:function(e,t){i.check(e,t);try{return i.set(e,t),!0}catch(n){return!1}}})},function(e,t,n){"use strict";var r=n(117),i=n(147)(!0);r(r.P,"Array",{includes:function(e){return i(this,e,arguments.length>1?arguments[1]:void 0)}}),n(232)("includes")},function(e,t,n){"use strict";var r=n(117),i=n(212)(!0);r(r.P,"String",{at:function(e){return i(this,e)}})},function(e,t,n){"use strict";var r=n(117),i=n(282);r(r.P,"String",{padLeft:function(e){return i(this,e,arguments.length>1?arguments[1]:void 0,!0)}})},function(e,t,n){var r=n(141),i=n(223),o=n(136);e.exports=function(e,t,n,a){var s=String(o(e)),u=s.length,l=void 0===n?" ":String(n),c=r(t);if(u>=c)return s;""==l&&(l=" ");var d=c-u,p=i.call(l,Math.ceil(d/l.length));return p.length>d&&(p=p.slice(0,d)),a?p+s:s+p}},function(e,t,n){"use strict";var r=n(117),i=n(282);r(r.P,"String",{padRight:function(e){return i(this,e,arguments.length>1?arguments[1]:void 0,!1)}})},function(e,t,n){"use strict";n(177)("trimLeft",function(e){return function(){return e(this,1)}})},function(e,t,n){"use strict";n(177)("trimRight",function(e){return function(){return e(this,2)}})},function(e,t,n){var r=n(117),i=n(287)(/[\\^$*+?.()|[\]{}]/g,"\\$&");r(r.S,"RegExp",{escape:function(e){return i(e)}})},function(e,t){e.exports=function(e,t){var n=t===Object(t)?function(e){return t[e]}:t;return function(t){return String(t).replace(e,n)}}},function(e,t,n){var r=n(116),i=n(117),o=n(275),a=n(137),s=n(121);i(i.S,"Object",{getOwnPropertyDescriptors:function(e){
for(var t,n,i=a(e),u=r.setDesc,l=r.getDesc,c=o(i),d={},p=0;c.length>p;)n=l(i,t=c[p++]),t in d?u(d,t,s(0,n)):d[t]=n;return d}})},function(e,t,n){var r=n(117),i=n(290)(!1);r(r.S,"Object",{values:function(e){return i(e)}})},function(e,t,n){var r=n(116),i=n(137),o=r.isEnum;e.exports=function(e){return function(t){for(var n,a=i(t),s=r.getKeys(a),u=s.length,l=0,c=[];u>l;)o.call(a,n=s[l++])&&c.push(e?[n,a[n]]:a[n]);return c}}},function(e,t,n){var r=n(117),i=n(290)(!0);r(r.S,"Object",{entries:function(e){return i(e)}})},function(e,t,n){var r=n(117);r(r.P,"Map",{toJSON:n(293)("Map")})},[736,252,161],[737,117,293],function(e,t,n){var r=n(116),i=n(117),o=n(126),a=n(119).Array||Array,s={},u=function(e,t){r.each.call(e.split(","),function(e){void 0==t&&e in a?s[e]=a[e]:e in[]&&(s[e]=o(Function.call,[][e],t))})};u("pop,reverse,shift,keys,values,entries",1),u("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),u("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),i(i.S,"Array",s)},function(e,t,n){var r=n(118),i=n(117),o=n(133),a=n(297),s=r.navigator,u=!!s&&/MSIE .\./.test(s.userAgent),l=function(e){return u?function(t,n){return e(o(a,[].slice.call(arguments,2),"function"==typeof t?t:Function(t)),n)}:e};i(i.G+i.B+i.F*u,{setTimeout:l(r.setTimeout),setInterval:l(r.setInterval)})},function(e,t,n){"use strict";var r=n(298),i=n(133),o=n(127);e.exports=function(){for(var e=o(this),t=arguments.length,n=Array(t),a=0,s=r._,u=!1;t>a;)(n[a]=arguments[a++])===s&&(u=!0);return function(){var r,o=this,a=arguments,l=a.length,c=0,d=0;if(!u&&!l)return i(e,n,o);if(r=n.slice(),u)for(;t>c;c++)r[c]===s&&(r[c]=a[d++]);for(;l>d;)r.push(a[d++]);return i(e,r,o)}}},function(e,t,n){e.exports=n(118)},function(e,t,n){var r=n(117),i=n(255);r(r.G+r.B,{setImmediate:i.set,clearImmediate:i.clear})},function(e,t,n){n(231);var r=n(118),i=n(120),o=n(214),a=n(145)("iterator"),s=r.NodeList,u=r.HTMLCollection,l=s&&s.prototype,c=u&&u.prototype,d=o.NodeList=o.HTMLCollection=o.Array;l&&!l[a]&&i(l,a,d),c&&!c[a]&&i(c,a,d)},function(e,t,n){(function(t,n){!function(t){"use strict";function r(e,t,n,r){var i=Object.create((t||o).prototype);return i._invoke=d(e,n||null,new h(r||[])),i}function i(e,t,n){try{return{type:"normal",arg:e.call(t,n)}}catch(r){return{type:"throw",arg:r}}}function o(){}function a(){}function s(){}function u(e){["next","throw","return"].forEach(function(t){e[t]=function(e){return this._invoke(t,e)}})}function l(e){this.arg=e}function c(e){function t(t,n){var r=e[t](n),i=r.value;return i instanceof l?Promise.resolve(i.arg).then(o,a):Promise.resolve(i).then(function(e){return r.value=e,r})}function r(e,n){var r=i?i.then(function(){return t(e,n)}):new Promise(function(r){r(t(e,n))});return i=r.catch(function(e){}),r}"object"==typeof n&&n.domain&&(t=n.domain.bind(t));var i,o=t.bind(e,"next"),a=t.bind(e,"throw");t.bind(e,"return");this._invoke=r}function d(e,t,n){var r=b;return function(o,a){if(r===M)throw new Error("Generator is already running");if(r===T){if("throw"===o)throw a;return y()}for(;;){var s=n.delegate;if(s){if("return"===o||"throw"===o&&s.iterator[o]===g){n.delegate=null;var u=s.iterator.return;if(u){var l=i(u,s.iterator,a);if("throw"===l.type){o="throw",a=l.arg;continue}}if("return"===o)continue}var l=i(s.iterator[o],s.iterator,a);if("throw"===l.type){n.delegate=null,o="throw",a=l.arg;continue}o="next",a=g;var c=l.arg;if(!c.done)return r=S,c;n[s.resultName]=c.value,n.next=s.nextLoc,n.delegate=null}if("next"===o)r===S?n.sent=a:n.sent=g;else if("throw"===o){if(r===b)throw r=T,a;n.dispatchException(a)&&(o="next",a=g)}else"return"===o&&n.abrupt("return",a);r=M;var l=i(e,t,n);if("normal"===l.type){r=n.done?T:S;var c={value:l.arg,done:n.done};if(l.arg!==E)return c;n.delegate&&"next"===o&&(a=g)}else"throw"===l.type&&(r=T,o="throw",a=l.arg)}}}function p(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function f(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function h(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(p,this),this.reset(!0)}function v(e){if(e){var t=e[_];if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var n=-1,r=function i(){for(;++n<e.length;)if(m.call(e,n))return i.value=e[n],i.done=!1,i;return i.value=g,i.done=!0,i};return r.next=r}}return{next:y}}function y(){return{value:g,done:!0}}var g,m=Object.prototype.hasOwnProperty,_="function"==typeof Symbol&&Symbol.iterator||"@@iterator",A="object"==typeof e,C=t.regeneratorRuntime;if(C)return void(A&&(e.exports=C));C=t.regeneratorRuntime=A?e.exports:{},C.wrap=r;var b="suspendedStart",S="suspendedYield",M="executing",T="completed",E={},w=s.prototype=o.prototype;a.prototype=w.constructor=s,s.constructor=a,a.displayName="GeneratorFunction",C.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return t?t===a||"GeneratorFunction"===(t.displayName||t.name):!1},C.mark=function(e){return e.__proto__=s,e.prototype=Object.create(w),e},C.awrap=function(e){return new l(e)},u(c.prototype),C.async=function(e,t,n,i){var o=new c(r(e,t,n,i));return C.isGeneratorFunction(t)?o:o.next().then(function(e){return e.done?e.value:o.next()})},u(w),w[_]=function(){return this},w.toString=function(){return"[object Generator]"},C.keys=function(e){var t=[];for(var n in e)t.push(n);return t.reverse(),function r(){for(;t.length;){var n=t.pop();if(n in e)return r.value=n,r.done=!1,r}return r.done=!0,r}},C.values=v,h.prototype={constructor:h,reset:function(e){if(this.prev=0,this.next=0,this.sent=g,this.done=!1,this.delegate=null,this.tryEntries.forEach(f),!e)for(var t in this)"t"===t.charAt(0)&&m.call(this,t)&&!isNaN(+t.slice(1))&&(this[t]=g)},stop:function(){this.done=!0;var e=this.tryEntries[0],t=e.completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(e){function t(t,r){return o.type="throw",o.arg=e,n.next=t,!!r}if(this.done)throw e;for(var n=this,r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r],o=i.completion;if("root"===i.tryLoc)return t("end");if(i.tryLoc<=this.prev){var a=m.call(i,"catchLoc"),s=m.call(i,"finallyLoc");if(a&&s){if(this.prev<i.catchLoc)return t(i.catchLoc,!0);if(this.prev<i.finallyLoc)return t(i.finallyLoc)}else if(a){if(this.prev<i.catchLoc)return t(i.catchLoc,!0)}else{if(!s)throw new Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return t(i.finallyLoc)}}}},abrupt:function(e,t){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&m.call(r,"finallyLoc")&&this.prev<r.finallyLoc){var i=r;break}}i&&("break"===e||"continue"===e)&&i.tryLoc<=t&&t<=i.finallyLoc&&(i=null);var o=i?i.completion:{};return o.type=e,o.arg=t,i?this.next=i.finallyLoc:this.complete(o),E},complete:function(e,t){if("throw"===e.type)throw e.arg;"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=e.arg,this.next="end"):"normal"===e.type&&t&&(this.next=t)},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),f(n),E}},"catch":function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var r=n.completion;if("throw"===r.type){var i=r.arg;f(n)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(e,t,n){return this.delegate={iterator:v(e),resultName:t,nextLoc:n},E}}}("object"==typeof t?t:"object"==typeof window?window:"object"==typeof self?self:this)}).call(t,function(){return this}(),n(25))},function(e,t,n){"use strict";e.exports=n(303)},function(e,t,n){"use strict";var r=n(304),i=n(444),o=n(448),a=n(339),s=n(453),u={};a(u,o),a(u,{findDOMNode:s("findDOMNode","ReactDOM","react-dom",r,r.findDOMNode),render:s("render","ReactDOM","react-dom",r,r.render),unmountComponentAtNode:s("unmountComponentAtNode","ReactDOM","react-dom",r,r.unmountComponentAtNode),renderToString:s("renderToString","ReactDOMServer","react-dom/server",i,i.renderToString),renderToStaticMarkup:s("renderToStaticMarkup","ReactDOMServer","react-dom/server",i,i.renderToStaticMarkup)}),u.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=r,u.__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=i,e.exports=u},function(e,t,n){"use strict";var r=n(305),i=n(306),o=n(371),a=n(345),s=n(328),u=n(318),l=n(350),c=n(354),d=n(442),p=n(391),f=n(443);n(325);o.inject();var h=u.measure("React","render",s.render),v={findDOMNode:p,render:h,unmountComponentAtNode:s.unmountComponentAtNode,version:d,unstable_batchedUpdates:c.batchedUpdates,unstable_renderSubtreeIntoContainer:f};"undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject&&__REACT_DEVTOOLS_GLOBAL_HOOK__.inject({CurrentOwner:r,InstanceHandles:a,Mount:s,Reconciler:l,TextComponent:i});e.exports=v},function(e,t){"use strict";var n={current:null};e.exports=n},function(e,t,n){"use strict";var r=n(307),i=n(322),o=n(326),a=n(328),s=n(339),u=n(321),l=n(320),c=(n(370),function(e){});s(c.prototype,{construct:function(e){this._currentElement=e,this._stringText=""+e,this._rootNodeID=null,this._mountIndex=0},mountComponent:function(e,t,n){if(this._rootNodeID=e,t.useCreateElement){var r=n[a.ownerDocumentContextKey],o=r.createElement("span");return i.setAttributeForID(o,e),a.getID(o),l(o,this._stringText),o}var s=u(this._stringText);return t.renderToStaticMarkup?s:"<span "+i.createMarkupForID(e)+">"+s+"</span>"},receiveComponent:function(e,t){if(e!==this._currentElement){this._currentElement=e;var n=""+e;if(n!==this._stringText){this._stringText=n;var i=a.getNode(this._rootNodeID);r.updateTextContent(i,n)}}},unmountComponent:function(){o.unmountIDFromEnvironment(this._rootNodeID)}}),e.exports=c},function(e,t,n){"use strict";function r(e,t,n){var r=n>=e.childNodes.length?null:e.childNodes.item(n);e.insertBefore(t,r)}var i=n(308),o=n(316),a=n(318),s=n(319),u=n(320),l=n(313),c={dangerouslyReplaceNodeWithMarkup:i.dangerouslyReplaceNodeWithMarkup,updateTextContent:u,processUpdates:function(e,t){for(var n,a=null,c=null,d=0;d<e.length;d++)if(n=e[d],n.type===o.MOVE_EXISTING||n.type===o.REMOVE_NODE){var p=n.fromIndex,f=n.parentNode.childNodes[p],h=n.parentID;f?void 0:l(!1),a=a||{},a[h]=a[h]||[],a[h][p]=f,c=c||[],c.push(f)}var v;if(v=t.length&&"string"==typeof t[0]?i.dangerouslyRenderMarkup(t):t,c)for(var y=0;y<c.length;y++)c[y].parentNode.removeChild(c[y]);for(var g=0;g<e.length;g++)switch(n=e[g],n.type){case o.INSERT_MARKUP:r(n.parentNode,v[n.markupIndex],n.toIndex);break;case o.MOVE_EXISTING:r(n.parentNode,a[n.parentID][n.fromIndex],n.toIndex);break;case o.SET_MARKUP:s(n.parentNode,n.content);break;case o.TEXT_CONTENT:u(n.parentNode,n.content);break;case o.REMOVE_NODE:}}};a.measureMethods(c,"DOMChildrenOperations",{updateTextContent:"updateTextContent"}),e.exports=c},function(e,t,n){"use strict";function r(e){return e.substring(1,e.indexOf(" "))}var i=n(309),o=n(310),a=n(315),s=n(314),u=n(313),l=/^(<[^ \/>]+)/,c="data-danger-index",d={dangerouslyRenderMarkup:function(e){i.canUseDOM?void 0:u(!1);for(var t,n={},d=0;d<e.length;d++)e[d]?void 0:u(!1),t=r(e[d]),t=s(t)?t:"*",n[t]=n[t]||[],n[t][d]=e[d];var p=[],f=0;for(t in n)if(n.hasOwnProperty(t)){var h,v=n[t];for(h in v)if(v.hasOwnProperty(h)){var y=v[h];v[h]=y.replace(l,"$1 "+c+'="'+h+'" ')}for(var g=o(v.join(""),a),m=0;m<g.length;++m){var _=g[m];_.hasAttribute&&_.hasAttribute(c)&&(h=+_.getAttribute(c),_.removeAttribute(c),p.hasOwnProperty(h)?u(!1):void 0,p[h]=_,f+=1)}}return f!==p.length?u(!1):void 0,p.length!==e.length?u(!1):void 0,p},dangerouslyReplaceNodeWithMarkup:function(e,t){i.canUseDOM?void 0:u(!1),t?void 0:u(!1),"html"===e.tagName.toLowerCase()?u(!1):void 0;var n;n="string"==typeof t?o(t,a)[0]:t,e.parentNode.replaceChild(n,e)}};e.exports=d},function(e,t){"use strict";var n=!("undefined"==typeof window||!window.document||!window.document.createElement),r={canUseDOM:n,canUseWorkers:"undefined"!=typeof Worker,canUseEventListeners:n&&!(!window.addEventListener&&!window.attachEvent),canUseViewport:n&&!!window.screen,isInWorker:!n};e.exports=r},function(e,t,n){"use strict";function r(e){var t=e.match(c);return t&&t[1].toLowerCase()}function i(e,t){var n=l;l?void 0:u(!1);var i=r(e),o=i&&s(i);if(o){n.innerHTML=o[1]+e+o[2];for(var c=o[0];c--;)n=n.lastChild}else n.innerHTML=e;var d=n.getElementsByTagName("script");d.length&&(t?void 0:u(!1),a(d).forEach(t));for(var p=a(n.childNodes);n.lastChild;)n.removeChild(n.lastChild);return p}var o=n(309),a=n(311),s=n(314),u=n(313),l=o.canUseDOM?document.createElement("div"):null,c=/^\s*<(\w+)/;e.exports=i},function(e,t,n){"use strict";function r(e){return!!e&&("object"==typeof e||"function"==typeof e)&&"length"in e&&!("setInterval"in e)&&"number"!=typeof e.nodeType&&(Array.isArray(e)||"callee"in e||"item"in e)}function i(e){return r(e)?Array.isArray(e)?e.slice():o(e):[e]}var o=n(312);e.exports=i},function(e,t,n){"use strict";function r(e){var t=e.length;if(Array.isArray(e)||"object"!=typeof e&&"function"!=typeof e?i(!1):void 0,"number"!=typeof t?i(!1):void 0,0===t||t-1 in e?void 0:i(!1),e.hasOwnProperty)try{return Array.prototype.slice.call(e)}catch(n){}for(var r=Array(t),o=0;t>o;o++)r[o]=e[o];return r}var i=n(313);e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r,i,o,a,s){if(!e){var u;if(void 0===t)u=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[n,r,i,o,a,s],c=0;u=new Error(t.replace(/%s/g,function(){return l[c++]})),u.name="Invariant Violation"}throw u.framesToPop=1,u}}e.exports=r},function(e,t,n){"use strict";function r(e){return a?void 0:o(!1),p.hasOwnProperty(e)||(e="*"),s.hasOwnProperty(e)||("*"===e?a.innerHTML="<link />":a.innerHTML="<"+e+"></"+e+">",s[e]=!a.firstChild),s[e]?p[e]:null}var i=n(309),o=n(313),a=i.canUseDOM?document.createElement("div"):null,s={},u=[1,'<select multiple="true">',"</select>"],l=[1,"<table>","</table>"],c=[3,"<table><tbody><tr>","</tr></tbody></table>"],d=[1,'<svg xmlns="http://www.w3.org/2000/svg">',"</svg>"],p={"*":[1,"?<div>","</div>"],area:[1,"<map>","</map>"],col:[2,"<table><tbody></tbody><colgroup>","</colgroup></table>"],legend:[1,"<fieldset>","</fieldset>"],param:[1,"<object>","</object>"],tr:[2,"<table><tbody>","</tbody></table>"],optgroup:u,option:u,caption:l,colgroup:l,tbody:l,tfoot:l,thead:l,td:c,th:c},f=["circle","clipPath","defs","ellipse","g","image","line","linearGradient","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","text","tspan"];f.forEach(function(e){p[e]=d,s[e]=!0}),e.exports=r},function(e,t){"use strict";function n(e){return function(){return e}}function r(){}r.thatReturns=n,r.thatReturnsFalse=n(!1),r.thatReturnsTrue=n(!0),r.thatReturnsNull=n(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){"use strict";var r=n(317),i=r({INSERT_MARKUP:null,MOVE_EXISTING:null,REMOVE_NODE:null,SET_MARKUP:null,TEXT_CONTENT:null});e.exports=i},function(e,t,n){"use strict";var r=n(313),i=function(e){var t,n={};e instanceof Object&&!Array.isArray(e)?void 0:r(!1);for(t in e)e.hasOwnProperty(t)&&(n[t]=t);return n};e.exports=i},function(e,t,n){"use strict";function r(e,t,n){return n}var i={enableMeasure:!1,storedMeasure:r,measureMethods:function(e,t,n){},measure:function(e,t,n){return n},injection:{injectMeasure:function(e){i.storedMeasure=e}}};e.exports=i},function(e,t,n){"use strict";var r=n(309),i=/^[ \r\n\t\f]/,o=/<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/,a=function(e,t){e.innerHTML=t};if("undefined"!=typeof MSApp&&MSApp.execUnsafeLocalFunction&&(a=function(e,t){MSApp.execUnsafeLocalFunction(function(){e.innerHTML=t})}),r.canUseDOM){var s=document.createElement("div");s.innerHTML=" ",""===s.innerHTML&&(a=function(e,t){if(e.parentNode&&e.parentNode.replaceChild(e,e),i.test(t)||"<"===t[0]&&o.test(t)){e.innerHTML=String.fromCharCode(65279)+t;var n=e.firstChild;1===n.data.length?e.removeChild(n):n.deleteData(0,1)}else e.innerHTML=t})}e.exports=a},function(e,t,n){"use strict";var r=n(309),i=n(321),o=n(319),a=function(e,t){e.textContent=t};r.canUseDOM&&("textContent"in document.documentElement||(a=function(e,t){o(e,i(t))})),e.exports=a},function(e,t){"use strict";function n(e){return i[e]}function r(e){return(""+e).replace(o,n)}var i={"&":"&amp;",">":"&gt;","<":"&lt;",'"':"&quot;","'":"&#x27;"},o=/[&><"']/g;e.exports=r},function(e,t,n){"use strict";function r(e){return c.hasOwnProperty(e)?!0:l.hasOwnProperty(e)?!1:u.test(e)?(c[e]=!0,!0):(l[e]=!0,!1)}function i(e,t){return null==t||e.hasBooleanValue&&!t||e.hasNumericValue&&isNaN(t)||e.hasPositiveNumericValue&&1>t||e.hasOverloadedBooleanValue&&t===!1}var o=n(323),a=n(318),s=n(324),u=(n(325),/^[a-zA-Z_][\w\.\-]*$/),l={},c={},d={createMarkupForID:function(e){return o.ID_ATTRIBUTE_NAME+"="+s(e)},setAttributeForID:function(e,t){e.setAttribute(o.ID_ATTRIBUTE_NAME,t)},createMarkupForProperty:function(e,t){var n=o.properties.hasOwnProperty(e)?o.properties[e]:null;if(n){if(i(n,t))return"";var r=n.attributeName;return n.hasBooleanValue||n.hasOverloadedBooleanValue&&t===!0?r+'=""':r+"="+s(t)}return o.isCustomAttribute(e)?null==t?"":e+"="+s(t):null},createMarkupForCustomAttribute:function(e,t){return r(e)&&null!=t?e+"="+s(t):""},setValueForProperty:function(e,t,n){var r=o.properties.hasOwnProperty(t)?o.properties[t]:null;if(r){var a=r.mutationMethod;if(a)a(e,n);else if(i(r,n))this.deleteValueForProperty(e,t);else if(r.mustUseAttribute){var s=r.attributeName,u=r.attributeNamespace;u?e.setAttributeNS(u,s,""+n):r.hasBooleanValue||r.hasOverloadedBooleanValue&&n===!0?e.setAttribute(s,""):e.setAttribute(s,""+n)}else{var l=r.propertyName;r.hasSideEffects&&""+e[l]==""+n||(e[l]=n)}}else o.isCustomAttribute(t)&&d.setValueForAttribute(e,t,n)},setValueForAttribute:function(e,t,n){r(t)&&(null==n?e.removeAttribute(t):e.setAttribute(t,""+n))},deleteValueForProperty:function(e,t){var n=o.properties.hasOwnProperty(t)?o.properties[t]:null;if(n){var r=n.mutationMethod;if(r)r(e,void 0);else if(n.mustUseAttribute)e.removeAttribute(n.attributeName);else{var i=n.propertyName,a=o.getDefaultValueForProperty(e.nodeName,i);n.hasSideEffects&&""+e[i]===a||(e[i]=a)}}else o.isCustomAttribute(t)&&e.removeAttribute(t)}};a.measureMethods(d,"DOMPropertyOperations",{setValueForProperty:"setValueForProperty",setValueForAttribute:"setValueForAttribute",deleteValueForProperty:"deleteValueForProperty"}),e.exports=d},function(e,t,n){"use strict";function r(e,t){return(e&t)===t}var i=n(313),o={MUST_USE_ATTRIBUTE:1,MUST_USE_PROPERTY:2,HAS_SIDE_EFFECTS:4,HAS_BOOLEAN_VALUE:8,HAS_NUMERIC_VALUE:16,HAS_POSITIVE_NUMERIC_VALUE:48,HAS_OVERLOADED_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(e){var t=o,n=e.Properties||{},a=e.DOMAttributeNamespaces||{},u=e.DOMAttributeNames||{},l=e.DOMPropertyNames||{},c=e.DOMMutationMethods||{};e.isCustomAttribute&&s._isCustomAttributeFunctions.push(e.isCustomAttribute);for(var d in n){s.properties.hasOwnProperty(d)?i(!1):void 0;var p=d.toLowerCase(),f=n[d],h={attributeName:p,attributeNamespace:null,propertyName:d,mutationMethod:null,mustUseAttribute:r(f,t.MUST_USE_ATTRIBUTE),mustUseProperty:r(f,t.MUST_USE_PROPERTY),hasSideEffects:r(f,t.HAS_SIDE_EFFECTS),hasBooleanValue:r(f,t.HAS_BOOLEAN_VALUE),hasNumericValue:r(f,t.HAS_NUMERIC_VALUE),hasPositiveNumericValue:r(f,t.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:r(f,t.HAS_OVERLOADED_BOOLEAN_VALUE)};if(h.mustUseAttribute&&h.mustUseProperty?i(!1):void 0,!h.mustUseProperty&&h.hasSideEffects?i(!1):void 0,h.hasBooleanValue+h.hasNumericValue+h.hasOverloadedBooleanValue<=1?void 0:i(!1),u.hasOwnProperty(d)){var v=u[d];h.attributeName=v}a.hasOwnProperty(d)&&(h.attributeNamespace=a[d]),l.hasOwnProperty(d)&&(h.propertyName=l[d]),c.hasOwnProperty(d)&&(h.mutationMethod=c[d]),s.properties[d]=h}}},a={},s={ID_ATTRIBUTE_NAME:"data-reactid",properties:{},getPossibleStandardName:null,_isCustomAttributeFunctions:[],isCustomAttribute:function(e){for(var t=0;t<s._isCustomAttributeFunctions.length;t++){var n=s._isCustomAttributeFunctions[t];if(n(e))return!0}return!1},getDefaultValueForProperty:function(e,t){var n,r=a[e];return r||(a[e]=r={}),t in r||(n=document.createElement(e),r[t]=n[t]),r[t]},injection:o};e.exports=s},function(e,t,n){"use strict";function r(e){return'"'+i(e)+'"'}var i=n(321);e.exports=r},function(e,t,n){"use strict";var r=n(315),i=r;e.exports=i},function(e,t,n){"use strict";var r=n(327),i=n(328),o={processChildrenUpdates:r.dangerouslyProcessChildrenUpdates,replaceNodeWithMarkupByID:r.dangerouslyReplaceNodeWithMarkupByID,unmountIDFromEnvironment:function(e){i.purgeID(e)}};e.exports=o},function(e,t,n){"use strict";var r=n(307),i=n(322),o=n(328),a=n(318),s=n(313),u={dangerouslySetInnerHTML:"`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.",style:"`style` must be set using `updateStylesByID()`."},l={updatePropertyByID:function(e,t,n){var r=o.getNode(e);u.hasOwnProperty(t)?s(!1):void 0,null!=n?i.setValueForProperty(r,t,n):i.deleteValueForProperty(r,t)},dangerouslyReplaceNodeWithMarkupByID:function(e,t){var n=o.getNode(e);r.dangerouslyReplaceNodeWithMarkup(n,t)},dangerouslyProcessChildrenUpdates:function(e,t){for(var n=0;n<e.length;n++)e[n].parentNode=o.getNode(e[n].parentID);r.processUpdates(e,t)}};a.measureMethods(l,"ReactDOMIDOperations",{dangerouslyReplaceNodeWithMarkupByID:"dangerouslyReplaceNodeWithMarkupByID",dangerouslyProcessChildrenUpdates:"dangerouslyProcessChildrenUpdates"}),e.exports=l},function(e,t,n){"use strict";function r(e,t){for(var n=Math.min(e.length,t.length),r=0;n>r;r++)if(e.charAt(r)!==t.charAt(r))return r;return e.length===t.length?-1:n}function i(e){return e?e.nodeType===j?e.documentElement:e.firstChild:null}function o(e){var t=i(e);return t&&Q.getID(t)}function a(e){var t=s(e);if(t)if(U.hasOwnProperty(t)){var n=U[t];n!==e&&(d(n,t)?F(!1):void 0,U[t]=e)}else U[t]=e;return t}function s(e){return e&&e.getAttribute&&e.getAttribute(B)||""}function u(e,t){var n=s(e);n!==t&&delete U[n],e.setAttribute(B,t),U[t]=e}function l(e){return U.hasOwnProperty(e)&&d(U[e],e)||(U[e]=Q.findReactNodeByID(e)),U[e]}function c(e){var t=E.get(e)._rootNodeID;return M.isNullComponentID(t)?null:(U.hasOwnProperty(t)&&d(U[t],t)||(U[t]=Q.findReactNodeByID(t)),U[t])}function d(e,t){if(e){s(e)!==t?F(!1):void 0;var n=Q.findReactContainerForID(t);if(n&&O(n,e))return!0}return!1}function p(e){delete U[e]}function f(e){var t=U[e];return t&&d(t,e)?void(z=t):!1}function h(e){z=null,T.traverseAncestors(e,f);var t=z;return z=null,t}function v(e,t,n,r,i,o){b.useCreateElement&&(o=D({},o),n.nodeType===j?o[W]=n:o[W]=n.ownerDocument);var a=k.mountComponent(e,t,r,o);e._renderedComponent._topLevelWrapper=e,Q._mountImageIntoNode(a,n,i,r)}function y(e,t,n,r,i){var o=P.ReactReconcileTransaction.getPooled(r);o.perform(v,null,e,t,n,o,r,i),P.ReactReconcileTransaction.release(o)}function g(e,t){for(k.unmountComponent(e),t.nodeType===j&&(t=t.documentElement);t.lastChild;)t.removeChild(t.lastChild)}function m(e){var t=o(e);return t?t!==T.getReactRootIDFromNodeID(t):!1}function _(e){for(;e&&e.parentNode!==e;e=e.parentNode)if(1===e.nodeType){var t=s(e);if(t){var n,r=T.getReactRootIDFromNodeID(t),i=e;do if(n=s(i),i=i.parentNode,null==i)return null;while(n!==r);if(i===J[r])return e}}return null}var A=n(323),C=n(329),b=(n(305),n(341)),S=n(342),M=n(344),T=n(345),E=n(347),w=n(348),x=n(318),k=n(350),I=n(353),P=n(354),D=n(339),N=n(358),O=n(359),R=n(362),F=n(313),H=n(319),L=n(367),B=(n(370),n(325),A.ID_ATTRIBUTE_NAME),U={},K=1,j=9,V=11,W="__ReactMount_ownerDocument$"+Math.random().toString(36).slice(2),G={},J={},Y=[],z=null,X=function(){};X.prototype.isReactComponent={},X.prototype.render=function(){return this.props};var Q={TopLevelWrapper:X,_instancesByReactRootID:G,scrollMonitor:function(e,t){t()},_updateRootComponent:function(e,t,n,r){return Q.scrollMonitor(n,function(){I.enqueueElementInternal(e,t),r&&I.enqueueCallbackInternal(e,r)}),e},_registerComponent:function(e,t){!t||t.nodeType!==K&&t.nodeType!==j&&t.nodeType!==V?F(!1):void 0,C.ensureScrollValueMonitoring();var n=Q.registerContainer(t);return G[n]=e,n},_renderNewRootComponent:function(e,t,n,r){var i=R(e,null),o=Q._registerComponent(i,t);return P.batchedUpdates(y,i,o,t,n,r),i},renderSubtreeIntoContainer:function(e,t,n,r){return null==e||null==e._reactInternalInstance?F(!1):void 0,Q._renderSubtreeIntoContainer(e,t,n,r)},_renderSubtreeIntoContainer:function(e,t,n,r){S.isValidElement(t)?void 0:F(!1);var a=new S(X,null,null,null,null,null,t),u=G[o(n)];if(u){var l=u._currentElement,c=l.props;if(L(c,t)){var d=u._renderedComponent.getPublicInstance(),p=r&&function(){r.call(d)};return Q._updateRootComponent(u,a,n,p),d}Q.unmountComponentAtNode(n)}var f=i(n),h=f&&!!s(f),v=m(n),y=h&&!u&&!v,g=Q._renderNewRootComponent(a,n,y,null!=e?e._reactInternalInstance._processChildContext(e._reactInternalInstance._context):N)._renderedComponent.getPublicInstance();return r&&r.call(g),g},render:function(e,t,n){return Q._renderSubtreeIntoContainer(null,e,t,n)},registerContainer:function(e){var t=o(e);return t&&(t=T.getReactRootIDFromNodeID(t)),t||(t=T.createReactRootID()),J[t]=e,t},unmountComponentAtNode:function(e){!e||e.nodeType!==K&&e.nodeType!==j&&e.nodeType!==V?F(!1):void 0;var t=o(e),n=G[t];if(!n){var r=(m(e),s(e));r&&r===T.getReactRootIDFromNodeID(r);return!1}return P.batchedUpdates(g,n,e),delete G[t],delete J[t],!0},findReactContainerForID:function(e){var t=T.getReactRootIDFromNodeID(e),n=J[t];return n},findReactNodeByID:function(e){var t=Q.findReactContainerForID(e);return Q.findComponentRoot(t,e)},getFirstReactDOM:function(e){return _(e)},findComponentRoot:function(e,t){var n=Y,r=0,i=h(t)||e;for(n[0]=i.firstChild,n.length=1;r<n.length;){for(var o,a=n[r++];a;){var s=Q.getID(a);s?t===s?o=a:T.isAncestorIDOf(s,t)&&(n.length=r=0,n.push(a.firstChild)):n.push(a.firstChild),a=a.nextSibling}if(o)return n.length=0,o}n.length=0,F(!1)},_mountImageIntoNode:function(e,t,n,o){if(!t||t.nodeType!==K&&t.nodeType!==j&&t.nodeType!==V?F(!1):void 0,n){var a=i(t);if(w.canReuseMarkup(e,a))return;var s=a.getAttribute(w.CHECKSUM_ATTR_NAME);a.removeAttribute(w.CHECKSUM_ATTR_NAME);var u=a.outerHTML;a.setAttribute(w.CHECKSUM_ATTR_NAME,s);var l=e,c=r(l,u);" (client) "+l.substring(c-20,c+20)+"\n (server) "+u.substring(c-20,c+20);t.nodeType===j?F(!1):void 0}if(t.nodeType===j?F(!1):void 0,o.useCreateElement){for(;t.lastChild;)t.removeChild(t.lastChild);t.appendChild(e)}else H(t,e)},ownerDocumentContextKey:W,getReactRootID:o,getID:a,setID:u,getNode:l,getNodeFromInstance:c,isValid:d,purgeID:p};x.measureMethods(Q,"ReactMount",{_renderNewRootComponent:"_renderNewRootComponent",_mountImageIntoNode:"_mountImageIntoNode"}),e.exports=Q},function(e,t,n){"use strict";function r(e){return Object.prototype.hasOwnProperty.call(e,y)||(e[y]=h++,p[e[y]]={}),p[e[y]]}var i=n(330),o=n(331),a=n(332),s=n(337),u=n(318),l=n(338),c=n(339),d=n(340),p={},f=!1,h=0,v={topAbort:"abort",topBlur:"blur",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",topTouchStart:"touchstart",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},y="_reactListenersID"+String(Math.random()).slice(2),g=c({},s,{ReactEventListener:null,injection:{injectReactEventListener:function(e){e.setHandleTopLevel(g.handleTopLevel),g.ReactEventListener=e}},setEnabled:function(e){g.ReactEventListener&&g.ReactEventListener.setEnabled(e)},isEnabled:function(){return!(!g.ReactEventListener||!g.ReactEventListener.isEnabled())},listenTo:function(e,t){for(var n=t,o=r(n),s=a.registrationNameDependencies[e],u=i.topLevelTypes,l=0;l<s.length;l++){var c=s[l];o.hasOwnProperty(c)&&o[c]||(c===u.topWheel?d("wheel")?g.ReactEventListener.trapBubbledEvent(u.topWheel,"wheel",n):d("mousewheel")?g.ReactEventListener.trapBubbledEvent(u.topWheel,"mousewheel",n):g.ReactEventListener.trapBubbledEvent(u.topWheel,"DOMMouseScroll",n):c===u.topScroll?d("scroll",!0)?g.ReactEventListener.trapCapturedEvent(u.topScroll,"scroll",n):g.ReactEventListener.trapBubbledEvent(u.topScroll,"scroll",g.ReactEventListener.WINDOW_HANDLE):c===u.topFocus||c===u.topBlur?(d("focus",!0)?(g.ReactEventListener.trapCapturedEvent(u.topFocus,"focus",n),g.ReactEventListener.trapCapturedEvent(u.topBlur,"blur",n)):d("focusin")&&(g.ReactEventListener.trapBubbledEvent(u.topFocus,"focusin",n),g.ReactEventListener.trapBubbledEvent(u.topBlur,"focusout",n)),o[u.topBlur]=!0,o[u.topFocus]=!0):v.hasOwnProperty(c)&&g.ReactEventListener.trapBubbledEvent(c,v[c],n),o[c]=!0)}},trapBubbledEvent:function(e,t,n){return g.ReactEventListener.trapBubbledEvent(e,t,n)},trapCapturedEvent:function(e,t,n){return g.ReactEventListener.trapCapturedEvent(e,t,n)},ensureScrollValueMonitoring:function(){if(!f){var e=l.refreshScrollValues;g.ReactEventListener.monitorScrollValue(e),f=!0}},eventNameDispatchConfigs:o.eventNameDispatchConfigs,registrationNameModules:o.registrationNameModules,putListener:o.putListener,getListener:o.getListener,deleteListener:o.deleteListener,deleteAllListeners:o.deleteAllListeners});u.measureMethods(g,"ReactBrowserEventEmitter",{putListener:"putListener",deleteListener:"deleteListener"}),e.exports=g},function(e,t,n){"use strict";var r=n(317),i=r({bubbled:null,captured:null}),o=r({topAbort:null,topBlur:null,topCanPlay:null,topCanPlayThrough:null,topChange:null,topClick:null,topCompositionEnd:null,topCompositionStart:null,topCompositionUpdate:null,topContextMenu:null,topCopy:null,topCut:null,topDoubleClick:null,topDrag:null,topDragEnd:null,topDragEnter:null,topDragExit:null,topDragLeave:null,topDragOver:null,topDragStart:null,topDrop:null,topDurationChange:null,topEmptied:null,topEncrypted:null,topEnded:null,topError:null,topFocus:null,topInput:null,topKeyDown:null,topKeyPress:null,topKeyUp:null,topLoad:null,topLoadedData:null,topLoadedMetadata:null,topLoadStart:null,topMouseDown:null,topMouseMove:null,topMouseOut:null,topMouseOver:null,topMouseUp:null,topPaste:null,topPause:null,topPlay:null,topPlaying:null,topProgress:null,topRateChange:null,topReset:null,topScroll:null,topSeeked:null,topSeeking:null,topSelectionChange:null,topStalled:null,topSubmit:null,topSuspend:null,topTextInput:null,topTimeUpdate:null,topTouchCancel:null,topTouchEnd:null,topTouchMove:null,topTouchStart:null,topVolumeChange:null,topWaiting:null,topWheel:null}),a={topLevelTypes:o,PropagationPhases:i};e.exports=a},function(e,t,n){"use strict";var r=n(332),i=n(333),o=n(334),a=n(335),s=n(336),u=n(313),l=(n(325),{}),c=null,d=function(e,t){e&&(i.executeDispatchesInOrder(e,t),e.isPersistent()||e.constructor.release(e))},p=function(e){return d(e,!0)},f=function(e){return d(e,!1)},h=null,v={injection:{injectMount:i.injection.injectMount,injectInstanceHandle:function(e){h=e},getInstanceHandle:function(){return h},injectEventPluginOrder:r.injectEventPluginOrder,
injectEventPluginsByName:r.injectEventPluginsByName},eventNameDispatchConfigs:r.eventNameDispatchConfigs,registrationNameModules:r.registrationNameModules,putListener:function(e,t,n){"function"!=typeof n?u(!1):void 0;var i=l[t]||(l[t]={});i[e]=n;var o=r.registrationNameModules[t];o&&o.didPutListener&&o.didPutListener(e,t,n)},getListener:function(e,t){var n=l[t];return n&&n[e]},deleteListener:function(e,t){var n=r.registrationNameModules[t];n&&n.willDeleteListener&&n.willDeleteListener(e,t);var i=l[t];i&&delete i[e]},deleteAllListeners:function(e){for(var t in l)if(l[t][e]){var n=r.registrationNameModules[t];n&&n.willDeleteListener&&n.willDeleteListener(e,t),delete l[t][e]}},extractEvents:function(e,t,n,i,o){for(var s,u=r.plugins,l=0;l<u.length;l++){var c=u[l];if(c){var d=c.extractEvents(e,t,n,i,o);d&&(s=a(s,d))}}return s},enqueueEvents:function(e){e&&(c=a(c,e))},processEventQueue:function(e){var t=c;c=null,e?s(t,p):s(t,f),c?u(!1):void 0,o.rethrowCaughtError()},__purge:function(){l={}},__getListenerBank:function(){return l}};e.exports=v},function(e,t,n){"use strict";function r(){if(s)for(var e in u){var t=u[e],n=s.indexOf(e);if(n>-1?void 0:a(!1),!l.plugins[n]){t.extractEvents?void 0:a(!1),l.plugins[n]=t;var r=t.eventTypes;for(var o in r)i(r[o],t,o)?void 0:a(!1)}}}function i(e,t,n){l.eventNameDispatchConfigs.hasOwnProperty(n)?a(!1):void 0,l.eventNameDispatchConfigs[n]=e;var r=e.phasedRegistrationNames;if(r){for(var i in r)if(r.hasOwnProperty(i)){var s=r[i];o(s,t,n)}return!0}return e.registrationName?(o(e.registrationName,t,n),!0):!1}function o(e,t,n){l.registrationNameModules[e]?a(!1):void 0,l.registrationNameModules[e]=t,l.registrationNameDependencies[e]=t.eventTypes[n].dependencies}var a=n(313),s=null,u={},l={plugins:[],eventNameDispatchConfigs:{},registrationNameModules:{},registrationNameDependencies:{},injectEventPluginOrder:function(e){s?a(!1):void 0,s=Array.prototype.slice.call(e),r()},injectEventPluginsByName:function(e){var t=!1;for(var n in e)if(e.hasOwnProperty(n)){var i=e[n];u.hasOwnProperty(n)&&u[n]===i||(u[n]?a(!1):void 0,u[n]=i,t=!0)}t&&r()},getPluginModuleForEvent:function(e){var t=e.dispatchConfig;if(t.registrationName)return l.registrationNameModules[t.registrationName]||null;for(var n in t.phasedRegistrationNames)if(t.phasedRegistrationNames.hasOwnProperty(n)){var r=l.registrationNameModules[t.phasedRegistrationNames[n]];if(r)return r}return null},_resetEventPlugins:function(){s=null;for(var e in u)u.hasOwnProperty(e)&&delete u[e];l.plugins.length=0;var t=l.eventNameDispatchConfigs;for(var n in t)t.hasOwnProperty(n)&&delete t[n];var r=l.registrationNameModules;for(var i in r)r.hasOwnProperty(i)&&delete r[i]}};e.exports=l},function(e,t,n){"use strict";function r(e){return e===y.topMouseUp||e===y.topTouchEnd||e===y.topTouchCancel}function i(e){return e===y.topMouseMove||e===y.topTouchMove}function o(e){return e===y.topMouseDown||e===y.topTouchStart}function a(e,t,n,r){var i=e.type||"unknown-event";e.currentTarget=v.Mount.getNode(r),t?f.invokeGuardedCallbackWithCatch(i,n,e,r):f.invokeGuardedCallback(i,n,e,r),e.currentTarget=null}function s(e,t){var n=e._dispatchListeners,r=e._dispatchIDs;if(Array.isArray(n))for(var i=0;i<n.length&&!e.isPropagationStopped();i++)a(e,t,n[i],r[i]);else n&&a(e,t,n,r);e._dispatchListeners=null,e._dispatchIDs=null}function u(e){var t=e._dispatchListeners,n=e._dispatchIDs;if(Array.isArray(t)){for(var r=0;r<t.length&&!e.isPropagationStopped();r++)if(t[r](e,n[r]))return n[r]}else if(t&&t(e,n))return n;return null}function l(e){var t=u(e);return e._dispatchIDs=null,e._dispatchListeners=null,t}function c(e){var t=e._dispatchListeners,n=e._dispatchIDs;Array.isArray(t)?h(!1):void 0;var r=t?t(e,n):null;return e._dispatchListeners=null,e._dispatchIDs=null,r}function d(e){return!!e._dispatchListeners}var p=n(330),f=n(334),h=n(313),v=(n(325),{Mount:null,injectMount:function(e){v.Mount=e}}),y=p.topLevelTypes,g={isEndish:r,isMoveish:i,isStartish:o,executeDirectDispatch:c,executeDispatchesInOrder:s,executeDispatchesInOrderStopAtTrue:l,hasDispatches:d,getNode:function(e){return v.Mount.getNode(e)},getID:function(e){return v.Mount.getID(e)},injection:v};e.exports=g},function(e,t,n){"use strict";function r(e,t,n,r){try{return t(n,r)}catch(o){return void(null===i&&(i=o))}}var i=null,o={invokeGuardedCallback:r,invokeGuardedCallbackWithCatch:r,rethrowCaughtError:function(){if(i){var e=i;throw i=null,e}}};e.exports=o},function(e,t,n){"use strict";function r(e,t){if(null==t?i(!1):void 0,null==e)return t;var n=Array.isArray(e),r=Array.isArray(t);return n&&r?(e.push.apply(e,t),e):n?(e.push(t),e):r?[e].concat(t):[e,t]}var i=n(313);e.exports=r},function(e,t){"use strict";var n=function(e,t,n){Array.isArray(e)?e.forEach(t,n):e&&t.call(n,e)};e.exports=n},function(e,t,n){"use strict";function r(e){i.enqueueEvents(e),i.processEventQueue(!1)}var i=n(331),o={handleTopLevel:function(e,t,n,o,a){var s=i.extractEvents(e,t,n,o,a);r(s)}};e.exports=o},function(e,t){"use strict";var n={currentScrollLeft:0,currentScrollTop:0,refreshScrollValues:function(e){n.currentScrollLeft=e.x,n.currentScrollTop=e.y}};e.exports=n},function(e,t){"use strict";function n(e,t){if(null==e)throw new TypeError("Object.assign target cannot be null or undefined");for(var n=Object(e),r=Object.prototype.hasOwnProperty,i=1;i<arguments.length;i++){var o=arguments[i];if(null!=o){var a=Object(o);for(var s in a)r.call(a,s)&&(n[s]=a[s])}}return n}e.exports=n},function(e,t,n){"use strict";function r(e,t){if(!o.canUseDOM||t&&!("addEventListener"in document))return!1;var n="on"+e,r=n in document;if(!r){var a=document.createElement("div");a.setAttribute(n,"return;"),r="function"==typeof a[n]}return!r&&i&&"wheel"===e&&(r=document.implementation.hasFeature("Events.wheel","3.0")),r}var i,o=n(309);o.canUseDOM&&(i=document.implementation&&document.implementation.hasFeature&&document.implementation.hasFeature("","")!==!0),e.exports=r},function(e,t){"use strict";var n={useCreateElement:!1};e.exports=n},function(e,t,n){"use strict";var r=n(305),i=n(339),o=(n(343),"function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103),a={key:!0,ref:!0,__self:!0,__source:!0},s=function(e,t,n,r,i,a,s){var u={$$typeof:o,type:e,key:t,ref:n,props:s,_owner:a};return u};s.createElement=function(e,t,n){var i,o={},u=null,l=null,c=null,d=null;if(null!=t){l=void 0===t.ref?null:t.ref,u=void 0===t.key?null:""+t.key,c=void 0===t.__self?null:t.__self,d=void 0===t.__source?null:t.__source;for(i in t)t.hasOwnProperty(i)&&!a.hasOwnProperty(i)&&(o[i]=t[i])}var p=arguments.length-2;if(1===p)o.children=n;else if(p>1){for(var f=Array(p),h=0;p>h;h++)f[h]=arguments[h+2];o.children=f}if(e&&e.defaultProps){var v=e.defaultProps;for(i in v)"undefined"==typeof o[i]&&(o[i]=v[i])}return s(e,u,l,c,d,r.current,o)},s.createFactory=function(e){var t=s.createElement.bind(null,e);return t.type=e,t},s.cloneAndReplaceKey=function(e,t){var n=s(e.type,t,e.ref,e._self,e._source,e._owner,e.props);return n},s.cloneAndReplaceProps=function(e,t){var n=s(e.type,e.key,e.ref,e._self,e._source,e._owner,t);return n},s.cloneElement=function(e,t,n){var o,u=i({},e.props),l=e.key,c=e.ref,d=e._self,p=e._source,f=e._owner;if(null!=t){void 0!==t.ref&&(c=t.ref,f=r.current),void 0!==t.key&&(l=""+t.key);for(o in t)t.hasOwnProperty(o)&&!a.hasOwnProperty(o)&&(u[o]=t[o])}var h=arguments.length-2;if(1===h)u.children=n;else if(h>1){for(var v=Array(h),y=0;h>y;y++)v[y]=arguments[y+2];u.children=v}return s(e.type,l,c,d,p,f,u)},s.isValidElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===o},e.exports=s},function(e,t,n){"use strict";var r=!1;e.exports=r},function(e,t){"use strict";function n(e){return!!o[e]}function r(e){o[e]=!0}function i(e){delete o[e]}var o={},a={isNullComponentID:n,registerNullComponentID:r,deregisterNullComponentID:i};e.exports=a},function(e,t,n){"use strict";function r(e){return f+e.toString(36)}function i(e,t){return e.charAt(t)===f||t===e.length}function o(e){return""===e||e.charAt(0)===f&&e.charAt(e.length-1)!==f}function a(e,t){return 0===t.indexOf(e)&&i(t,e.length)}function s(e){return e?e.substr(0,e.lastIndexOf(f)):""}function u(e,t){if(o(e)&&o(t)?void 0:p(!1),a(e,t)?void 0:p(!1),e===t)return e;var n,r=e.length+h;for(n=r;n<t.length&&!i(t,n);n++);return t.substr(0,n)}function l(e,t){var n=Math.min(e.length,t.length);if(0===n)return"";for(var r=0,a=0;n>=a;a++)if(i(e,a)&&i(t,a))r=a;else if(e.charAt(a)!==t.charAt(a))break;var s=e.substr(0,r);return o(s)?void 0:p(!1),s}function c(e,t,n,r,i,o){e=e||"",t=t||"",e===t?p(!1):void 0;var l=a(t,e);l||a(e,t)?void 0:p(!1);for(var c=0,d=l?s:u,f=e;;f=d(f,t)){var h;if(i&&f===e||o&&f===t||(h=n(f,l,r)),h===!1||f===t)break;c++<v?void 0:p(!1)}}var d=n(346),p=n(313),f=".",h=f.length,v=1e4,y={createReactRootID:function(){return r(d.createReactRootIndex())},createReactID:function(e,t){return e+t},getReactRootIDFromNodeID:function(e){if(e&&e.charAt(0)===f&&e.length>1){var t=e.indexOf(f,1);return t>-1?e.substr(0,t):e}return null},traverseEnterLeave:function(e,t,n,r,i){var o=l(e,t);o!==e&&c(e,o,n,r,!1,!0),o!==t&&c(o,t,n,i,!0,!1)},traverseTwoPhase:function(e,t,n){e&&(c("",e,t,n,!0,!1),c(e,"",t,n,!1,!0))},traverseTwoPhaseSkipTarget:function(e,t,n){e&&(c("",e,t,n,!0,!0),c(e,"",t,n,!0,!0))},traverseAncestors:function(e,t,n){c("",e,t,n,!0,!1)},getFirstCommonAncestorID:l,_getNextDescendantID:u,isAncestorIDOf:a,SEPARATOR:f};e.exports=y},function(e,t){"use strict";var n={injectCreateReactRootIndex:function(e){r.createReactRootIndex=e}},r={createReactRootIndex:null,injection:n};e.exports=r},function(e,t){"use strict";var n={remove:function(e){e._reactInternalInstance=void 0},get:function(e){return e._reactInternalInstance},has:function(e){return void 0!==e._reactInternalInstance},set:function(e,t){e._reactInternalInstance=t}};e.exports=n},function(e,t,n){"use strict";var r=n(349),i=/\/?>/,o={CHECKSUM_ATTR_NAME:"data-react-checksum",addChecksumToMarkup:function(e){var t=r(e);return e.replace(i," "+o.CHECKSUM_ATTR_NAME+'="'+t+'"$&')},canReuseMarkup:function(e,t){var n=t.getAttribute(o.CHECKSUM_ATTR_NAME);n=n&&parseInt(n,10);var i=r(e);return i===n}};e.exports=o},function(e,t){"use strict";function n(e){for(var t=1,n=0,i=0,o=e.length,a=-4&o;a>i;){for(;i<Math.min(i+4096,a);i+=4)n+=(t+=e.charCodeAt(i))+(t+=e.charCodeAt(i+1))+(t+=e.charCodeAt(i+2))+(t+=e.charCodeAt(i+3));t%=r,n%=r}for(;o>i;i++)n+=t+=e.charCodeAt(i);return t%=r,n%=r,t|n<<16}var r=65521;e.exports=n},function(e,t,n){"use strict";function r(){i.attachRefs(this,this._currentElement)}var i=n(351),o={mountComponent:function(e,t,n,i){var o=e.mountComponent(t,n,i);return e._currentElement&&null!=e._currentElement.ref&&n.getReactMountReady().enqueue(r,e),o},unmountComponent:function(e){i.detachRefs(e,e._currentElement),e.unmountComponent()},receiveComponent:function(e,t,n,o){var a=e._currentElement;if(t!==a||o!==e._context){var s=i.shouldUpdateRefs(a,t);s&&i.detachRefs(e,a),e.receiveComponent(t,n,o),s&&e._currentElement&&null!=e._currentElement.ref&&n.getReactMountReady().enqueue(r,e)}},performUpdateIfNecessary:function(e,t){e.performUpdateIfNecessary(t)}};e.exports=o},function(e,t,n){"use strict";function r(e,t,n){"function"==typeof e?e(t.getPublicInstance()):o.addComponentAsRefTo(t,e,n)}function i(e,t,n){"function"==typeof e?e(null):o.removeComponentAsRefFrom(t,e,n)}var o=n(352),a={};a.attachRefs=function(e,t){if(null!==t&&t!==!1){var n=t.ref;null!=n&&r(n,e,t._owner)}},a.shouldUpdateRefs=function(e,t){var n=null===e||e===!1,r=null===t||t===!1;return n||r||t._owner!==e._owner||t.ref!==e.ref},a.detachRefs=function(e,t){if(null!==t&&t!==!1){var n=t.ref;null!=n&&i(n,e,t._owner)}},e.exports=a},function(e,t,n){"use strict";var r=n(313),i={isValidOwner:function(e){return!(!e||"function"!=typeof e.attachRef||"function"!=typeof e.detachRef)},addComponentAsRefTo:function(e,t,n){i.isValidOwner(n)?void 0:r(!1),n.attachRef(t,e)},removeComponentAsRefFrom:function(e,t,n){i.isValidOwner(n)?void 0:r(!1),n.getPublicInstance().refs[t]===e.getPublicInstance()&&n.detachRef(t)}};e.exports=i},function(e,t,n){"use strict";function r(e){s.enqueueUpdate(e)}function i(e,t){var n=a.get(e);return n?n:null}var o=(n(305),n(342)),a=n(347),s=n(354),u=n(339),l=n(313),c=(n(325),{isMounted:function(e){var t=a.get(e);return t?!!t._renderedComponent:!1},enqueueCallback:function(e,t){"function"!=typeof t?l(!1):void 0;var n=i(e);return n?(n._pendingCallbacks?n._pendingCallbacks.push(t):n._pendingCallbacks=[t],void r(n)):null},enqueueCallbackInternal:function(e,t){"function"!=typeof t?l(!1):void 0,e._pendingCallbacks?e._pendingCallbacks.push(t):e._pendingCallbacks=[t],r(e)},enqueueForceUpdate:function(e){var t=i(e,"forceUpdate");t&&(t._pendingForceUpdate=!0,r(t))},enqueueReplaceState:function(e,t){var n=i(e,"replaceState");n&&(n._pendingStateQueue=[t],n._pendingReplaceState=!0,r(n))},enqueueSetState:function(e,t){var n=i(e,"setState");if(n){var o=n._pendingStateQueue||(n._pendingStateQueue=[]);o.push(t),r(n)}},enqueueSetProps:function(e,t){var n=i(e,"setProps");n&&c.enqueueSetPropsInternal(n,t)},enqueueSetPropsInternal:function(e,t){var n=e._topLevelWrapper;n?void 0:l(!1);var i=n._pendingElement||n._currentElement,a=i.props,s=u({},a.props,t);n._pendingElement=o.cloneAndReplaceProps(i,o.cloneAndReplaceProps(a,s)),r(n)},enqueueReplaceProps:function(e,t){var n=i(e,"replaceProps");n&&c.enqueueReplacePropsInternal(n,t)},enqueueReplacePropsInternal:function(e,t){var n=e._topLevelWrapper;n?void 0:l(!1);var i=n._pendingElement||n._currentElement,a=i.props;n._pendingElement=o.cloneAndReplaceProps(i,o.cloneAndReplaceProps(a,t)),r(n)},enqueueElementInternal:function(e,t){e._pendingElement=t,r(e)}});e.exports=c},function(e,t,n){"use strict";function r(){E.ReactReconcileTransaction&&A?void 0:y(!1)}function i(){this.reinitializeTransaction(),this.dirtyComponentsLength=null,this.callbackQueue=c.getPooled(),this.reconcileTransaction=E.ReactReconcileTransaction.getPooled(!1)}function o(e,t,n,i,o,a){r(),A.batchedUpdates(e,t,n,i,o,a)}function a(e,t){return e._mountOrder-t._mountOrder}function s(e){var t=e.dirtyComponentsLength;t!==g.length?y(!1):void 0,g.sort(a);for(var n=0;t>n;n++){var r=g[n],i=r._pendingCallbacks;if(r._pendingCallbacks=null,f.performUpdateIfNecessary(r,e.reconcileTransaction),i)for(var o=0;o<i.length;o++)e.callbackQueue.enqueue(i[o],r.getPublicInstance())}}function u(e){return r(),A.isBatchingUpdates?void g.push(e):void A.batchedUpdates(u,e)}function l(e,t){A.isBatchingUpdates?void 0:y(!1),m.enqueue(e,t),_=!0}var c=n(355),d=n(356),p=n(318),f=n(350),h=n(357),v=n(339),y=n(313),g=[],m=c.getPooled(),_=!1,A=null,C={initialize:function(){this.dirtyComponentsLength=g.length},close:function(){this.dirtyComponentsLength!==g.length?(g.splice(0,this.dirtyComponentsLength),M()):g.length=0}},b={initialize:function(){this.callbackQueue.reset()},close:function(){this.callbackQueue.notifyAll()}},S=[C,b];v(i.prototype,h.Mixin,{getTransactionWrappers:function(){return S},destructor:function(){this.dirtyComponentsLength=null,c.release(this.callbackQueue),this.callbackQueue=null,E.ReactReconcileTransaction.release(this.reconcileTransaction),this.reconcileTransaction=null},perform:function(e,t,n){return h.Mixin.perform.call(this,this.reconcileTransaction.perform,this.reconcileTransaction,e,t,n)}}),d.addPoolingTo(i);var M=function(){for(;g.length||_;){if(g.length){var e=i.getPooled();e.perform(s,null,e),i.release(e)}if(_){_=!1;var t=m;m=c.getPooled(),t.notifyAll(),c.release(t)}}};M=p.measure("ReactUpdates","flushBatchedUpdates",M);var T={injectReconcileTransaction:function(e){e?void 0:y(!1),E.ReactReconcileTransaction=e},injectBatchingStrategy:function(e){e?void 0:y(!1),"function"!=typeof e.batchedUpdates?y(!1):void 0,"boolean"!=typeof e.isBatchingUpdates?y(!1):void 0,A=e}},E={ReactReconcileTransaction:null,batchedUpdates:o,enqueueUpdate:u,flushBatchedUpdates:M,injection:T,asap:l};e.exports=E},function(e,t,n){"use strict";function r(){this._callbacks=null,this._contexts=null}var i=n(356),o=n(339),a=n(313);o(r.prototype,{enqueue:function(e,t){this._callbacks=this._callbacks||[],this._contexts=this._contexts||[],this._callbacks.push(e),this._contexts.push(t)},notifyAll:function(){var e=this._callbacks,t=this._contexts;if(e){e.length!==t.length?a(!1):void 0,this._callbacks=null,this._contexts=null;for(var n=0;n<e.length;n++)e[n].call(t[n]);e.length=0,t.length=0}},reset:function(){this._callbacks=null,this._contexts=null},destructor:function(){this.reset()}}),i.addPoolingTo(r),e.exports=r},function(e,t,n){"use strict";var r=n(313),i=function(e){var t=this;if(t.instancePool.length){var n=t.instancePool.pop();return t.call(n,e),n}return new t(e)},o=function(e,t){var n=this;if(n.instancePool.length){var r=n.instancePool.pop();return n.call(r,e,t),r}return new n(e,t)},a=function(e,t,n){var r=this;if(r.instancePool.length){var i=r.instancePool.pop();return r.call(i,e,t,n),i}return new r(e,t,n)},s=function(e,t,n,r){var i=this;if(i.instancePool.length){var o=i.instancePool.pop();return i.call(o,e,t,n,r),o}return new i(e,t,n,r)},u=function(e,t,n,r,i){var o=this;if(o.instancePool.length){var a=o.instancePool.pop();return o.call(a,e,t,n,r,i),a}return new o(e,t,n,r,i)},l=function(e){var t=this;e instanceof t?void 0:r(!1),e.destructor(),t.instancePool.length<t.poolSize&&t.instancePool.push(e)},c=10,d=i,p=function(e,t){var n=e;return n.instancePool=[],n.getPooled=t||d,n.poolSize||(n.poolSize=c),n.release=l,n},f={addPoolingTo:p,oneArgumentPooler:i,twoArgumentPooler:o,threeArgumentPooler:a,fourArgumentPooler:s,fiveArgumentPooler:u};e.exports=f},function(e,t,n){"use strict";var r=n(313),i={reinitializeTransaction:function(){this.transactionWrappers=this.getTransactionWrappers(),this.wrapperInitData?this.wrapperInitData.length=0:this.wrapperInitData=[],this._isInTransaction=!1},_isInTransaction:!1,getTransactionWrappers:null,isInTransaction:function(){return!!this._isInTransaction},perform:function(e,t,n,i,o,a,s,u){this.isInTransaction()?r(!1):void 0;var l,c;try{this._isInTransaction=!0,l=!0,this.initializeAll(0),c=e.call(t,n,i,o,a,s,u),l=!1}finally{try{if(l)try{this.closeAll(0)}catch(d){}else this.closeAll(0)}finally{this._isInTransaction=!1}}return c},initializeAll:function(e){for(var t=this.transactionWrappers,n=e;n<t.length;n++){var r=t[n];try{this.wrapperInitData[n]=o.OBSERVED_ERROR,this.wrapperInitData[n]=r.initialize?r.initialize.call(this):null}finally{if(this.wrapperInitData[n]===o.OBSERVED_ERROR)try{this.initializeAll(n+1)}catch(i){}}}},closeAll:function(e){this.isInTransaction()?void 0:r(!1);for(var t=this.transactionWrappers,n=e;n<t.length;n++){var i,a=t[n],s=this.wrapperInitData[n];try{i=!0,s!==o.OBSERVED_ERROR&&a.close&&a.close.call(this,s),i=!1}finally{if(i)try{this.closeAll(n+1)}catch(u){}}}this.wrapperInitData.length=0}},o={Mixin:i,OBSERVED_ERROR:{}};e.exports=o},function(e,t,n){"use strict";var r={};e.exports=r},function(e,t,n){"use strict";function r(e,t){var n=!0;e:for(;n;){var r=e,o=t;if(n=!1,r&&o){if(r===o)return!0;if(i(r))return!1;if(i(o)){e=r,t=o.parentNode,n=!0;continue e}return r.contains?r.contains(o):r.compareDocumentPosition?!!(16&r.compareDocumentPosition(o)):!1}return!1}}var i=n(360);e.exports=r},function(e,t,n){"use strict";function r(e){return i(e)&&3==e.nodeType}var i=n(361);e.exports=r},function(e,t){"use strict";function n(e){return!(!e||!("function"==typeof Node?e instanceof Node:"object"==typeof e&&"number"==typeof e.nodeType&&"string"==typeof e.nodeName))}e.exports=n},function(e,t,n){"use strict";function r(e){return"function"==typeof e&&"undefined"!=typeof e.prototype&&"function"==typeof e.prototype.mountComponent&&"function"==typeof e.prototype.receiveComponent}function i(e){var t;if(null===e||e===!1)t=new a(i);else if("object"==typeof e){var n=e;!n||"function"!=typeof n.type&&"string"!=typeof n.type?l(!1):void 0,t="string"==typeof n.type?s.createInternalComponent(n):r(n.type)?new n.type(n):new c}else"string"==typeof e||"number"==typeof e?t=s.createInstanceForText(e):l(!1);return t.construct(e),t._mountIndex=0,t._mountImage=null,t}var o=n(363),a=n(368),s=n(369),u=n(339),l=n(313),c=(n(325),function(){});u(c.prototype,o.Mixin,{_instantiateReactComponent:i}),e.exports=i},function(e,t,n){"use strict";function r(e){var t=e._currentElement._owner||null;if(t){var n=t.getName();if(n)return" Check the render method of `"+n+"`."}return""}function i(e){}var o=n(364),a=n(305),s=n(342),u=n(347),l=n(318),c=n(365),d=(n(366),n(350)),p=n(353),f=n(339),h=n(358),v=n(313),y=n(367);n(325);i.prototype.render=function(){var e=u.get(this)._currentElement.type;return e(this.props,this.context,this.updater)};var g=1,m={construct:function(e){this._currentElement=e,this._rootNodeID=null,this._instance=null,this._pendingElement=null,this._pendingStateQueue=null,this._pendingReplaceState=!1,this._pendingForceUpdate=!1,this._renderedComponent=null,this._context=null,this._mountOrder=0,this._topLevelWrapper=null,this._pendingCallbacks=null},mountComponent:function(e,t,n){this._context=n,this._mountOrder=g++,this._rootNodeID=e;var r,o,a=this._processProps(this._currentElement.props),l=this._processContext(n),c=this._currentElement.type,f="prototype"in c;f&&(r=new c(a,l,p)),f&&null!==r&&r!==!1&&!s.isValidElement(r)||(o=r,r=new i(c)),r.props=a,r.context=l,r.refs=h,r.updater=p,this._instance=r,u.set(r,this);var y=r.state;void 0===y&&(r.state=y=null),"object"!=typeof y||Array.isArray(y)?v(!1):void 0,this._pendingStateQueue=null,this._pendingReplaceState=!1,this._pendingForceUpdate=!1,r.componentWillMount&&(r.componentWillMount(),this._pendingStateQueue&&(r.state=this._processPendingState(r.props,r.context))),void 0===o&&(o=this._renderValidatedComponent()),this._renderedComponent=this._instantiateReactComponent(o);var m=d.mountComponent(this._renderedComponent,e,t,this._processChildContext(n));return r.componentDidMount&&t.getReactMountReady().enqueue(r.componentDidMount,r),m},unmountComponent:function(){var e=this._instance;e.componentWillUnmount&&e.componentWillUnmount(),d.unmountComponent(this._renderedComponent),this._renderedComponent=null,this._instance=null,this._pendingStateQueue=null,this._pendingReplaceState=!1,this._pendingForceUpdate=!1,this._pendingCallbacks=null,this._pendingElement=null,this._context=null,this._rootNodeID=null,this._topLevelWrapper=null,u.remove(e)},_maskContext:function(e){var t=null,n=this._currentElement.type,r=n.contextTypes;if(!r)return h;t={};for(var i in r)t[i]=e[i];return t},_processContext:function(e){var t=this._maskContext(e);return t},_processChildContext:function(e){var t=this._currentElement.type,n=this._instance,r=n.getChildContext&&n.getChildContext();if(r){"object"!=typeof t.childContextTypes?v(!1):void 0;for(var i in r)i in t.childContextTypes?void 0:v(!1);return f({},e,r)}return e},_processProps:function(e){return e},_checkPropTypes:function(e,t,n){var i=this.getName();for(var o in e)if(e.hasOwnProperty(o)){var a;try{"function"!=typeof e[o]?v(!1):void 0,a=e[o](t,o,i,n)}catch(s){a=s}if(a instanceof Error){r(this);n===c.prop}}},receiveComponent:function(e,t,n){var r=this._currentElement,i=this._context;this._pendingElement=null,this.updateComponent(t,r,e,i,n)},performUpdateIfNecessary:function(e){null!=this._pendingElement&&d.receiveComponent(this,this._pendingElement||this._currentElement,e,this._context),(null!==this._pendingStateQueue||this._pendingForceUpdate)&&this.updateComponent(e,this._currentElement,this._currentElement,this._context,this._context)},updateComponent:function(e,t,n,r,i){var o,a=this._instance,s=this._context===i?a.context:this._processContext(i);t===n?o=n.props:(o=this._processProps(n.props),a.componentWillReceiveProps&&a.componentWillReceiveProps(o,s));var u=this._processPendingState(o,s),l=this._pendingForceUpdate||!a.shouldComponentUpdate||a.shouldComponentUpdate(o,u,s);l?(this._pendingForceUpdate=!1,this._performComponentUpdate(n,o,u,s,e,i)):(this._currentElement=n,this._context=i,a.props=o,a.state=u,a.context=s)},_processPendingState:function(e,t){var n=this._instance,r=this._pendingStateQueue,i=this._pendingReplaceState;if(this._pendingReplaceState=!1,this._pendingStateQueue=null,!r)return n.state;if(i&&1===r.length)return r[0];for(var o=f({},i?r[0]:n.state),a=i?1:0;a<r.length;a++){var s=r[a];f(o,"function"==typeof s?s.call(n,o,e,t):s)}return o},_performComponentUpdate:function(e,t,n,r,i,o){var a,s,u,l=this._instance,c=Boolean(l.componentDidUpdate);c&&(a=l.props,s=l.state,u=l.context),l.componentWillUpdate&&l.componentWillUpdate(t,n,r),this._currentElement=e,this._context=o,l.props=t,l.state=n,l.context=r,this._updateRenderedComponent(i,o),c&&i.getReactMountReady().enqueue(l.componentDidUpdate.bind(l,a,s,u),l)},_updateRenderedComponent:function(e,t){var n=this._renderedComponent,r=n._currentElement,i=this._renderValidatedComponent();if(y(r,i))d.receiveComponent(n,i,e,this._processChildContext(t));else{var o=this._rootNodeID,a=n._rootNodeID;d.unmountComponent(n),this._renderedComponent=this._instantiateReactComponent(i);var s=d.mountComponent(this._renderedComponent,o,e,this._processChildContext(t));this._replaceNodeWithMarkupByID(a,s)}},_replaceNodeWithMarkupByID:function(e,t){o.replaceNodeWithMarkupByID(e,t)},_renderValidatedComponentWithoutOwnerOrContext:function(){var e=this._instance,t=e.render();return t},_renderValidatedComponent:function(){var e;a.current=this;try{e=this._renderValidatedComponentWithoutOwnerOrContext()}finally{a.current=null}return null===e||e===!1||s.isValidElement(e)?void 0:v(!1),e},attachRef:function(e,t){var n=this.getPublicInstance();null==n?v(!1):void 0;var r=t.getPublicInstance(),i=n.refs===h?n.refs={}:n.refs;i[e]=r},detachRef:function(e){var t=this.getPublicInstance().refs;delete t[e]},getName:function(){var e=this._currentElement.type,t=this._instance&&this._instance.constructor;return e.displayName||t&&t.displayName||e.name||t&&t.name||null},getPublicInstance:function(){var e=this._instance;return e instanceof i?null:e},_instantiateReactComponent:null};l.measureMethods(m,"ReactCompositeComponent",{mountComponent:"mountComponent",updateComponent:"updateComponent",_renderValidatedComponent:"_renderValidatedComponent"});var _={Mixin:m};e.exports=_},function(e,t,n){"use strict";var r=n(313),i=!1,o={unmountIDFromEnvironment:null,replaceNodeWithMarkupByID:null,processChildrenUpdates:null,injection:{injectEnvironment:function(e){i?r(!1):void 0,o.unmountIDFromEnvironment=e.unmountIDFromEnvironment,o.replaceNodeWithMarkupByID=e.replaceNodeWithMarkupByID,o.processChildrenUpdates=e.processChildrenUpdates,i=!0}}};e.exports=o},function(e,t,n){"use strict";var r=n(317),i=r({prop:null,context:null,childContext:null});e.exports=i},function(e,t,n){"use strict";var r={};e.exports=r},function(e,t){"use strict";function n(e,t){var n=null===e||e===!1,r=null===t||t===!1;if(n||r)return n===r;var i=typeof e,o=typeof t;return"string"===i||"number"===i?"string"===o||"number"===o:"object"===o&&e.type===t.type&&e.key===t.key}e.exports=n},function(e,t,n){"use strict";var r,i=n(342),o=n(344),a=n(350),s=n(339),u={injectEmptyComponent:function(e){r=i.createElement(e)}},l=function(e){this._currentElement=null,this._rootNodeID=null,this._renderedComponent=e(r)};s(l.prototype,{construct:function(e){},mountComponent:function(e,t,n){return o.registerNullComponentID(e),this._rootNodeID=e,a.mountComponent(this._renderedComponent,e,t,n)},receiveComponent:function(){},unmountComponent:function(e,t,n){a.unmountComponent(this._renderedComponent),o.deregisterNullComponentID(this._rootNodeID),this._rootNodeID=null,this._renderedComponent=null}}),l.injection=u,e.exports=l},function(e,t,n){"use strict";function r(e){if("function"==typeof e.type)return e.type;var t=e.type,n=d[t];return null==n&&(d[t]=n=l(t)),n}function i(e){return c?void 0:u(!1),new c(e.type,e.props)}function o(e){return new p(e)}function a(e){return e instanceof p}var s=n(339),u=n(313),l=null,c=null,d={},p=null,f={injectGenericComponentClass:function(e){c=e},injectTextComponentClass:function(e){p=e},injectComponentClasses:function(e){s(d,e)}},h={getComponentClassForElement:r,createInternalComponent:i,createInstanceForText:o,isTextComponent:a,injection:f};e.exports=h},function(e,t,n){"use strict";var r=(n(339),n(315)),i=(n(325),r);e.exports=i},function(e,t,n){"use strict";function r(){if(!T){T=!0,g.EventEmitter.injectReactEventListener(y),g.EventPluginHub.injectEventPluginOrder(s),g.EventPluginHub.injectInstanceHandle(m),g.EventPluginHub.injectMount(_),g.EventPluginHub.injectEventPluginsByName({SimpleEventPlugin:S,EnterLeaveEventPlugin:u,ChangeEventPlugin:o,SelectEventPlugin:C,BeforeInputEventPlugin:i}),g.NativeComponent.injectGenericComponentClass(h),g.NativeComponent.injectTextComponentClass(v),g.Class.injectMixin(d),g.DOMProperty.injectDOMPropertyConfig(c),g.DOMProperty.injectDOMPropertyConfig(M),g.EmptyComponent.injectEmptyComponent("noscript"),g.Updates.injectReconcileTransaction(A),g.Updates.injectBatchingStrategy(f),g.RootIndex.injectCreateReactRootIndex(l.canUseDOM?a.createReactRootIndex:b.createReactRootIndex),g.Component.injectEnvironment(p)}}var i=n(372),o=n(380),a=n(383),s=n(384),u=n(385),l=n(309),c=n(389),d=n(390),p=n(326),f=n(392),h=n(393),v=n(306),y=n(418),g=n(421),m=n(345),_=n(328),A=n(425),C=n(430),b=n(431),S=n(432),M=n(441),T=!1;e.exports={inject:r}},function(e,t,n){"use strict";function r(){var e=window.opera;return"object"==typeof e&&"function"==typeof e.version&&parseInt(e.version(),10)<=12}function i(e){return(e.ctrlKey||e.altKey||e.metaKey)&&!(e.ctrlKey&&e.altKey)}function o(e){switch(e){case x.topCompositionStart:return k.compositionStart;case x.topCompositionEnd:return k.compositionEnd;case x.topCompositionUpdate:return k.compositionUpdate}}function a(e,t){return e===x.topKeyDown&&t.keyCode===C}function s(e,t){switch(e){case x.topKeyUp:return-1!==A.indexOf(t.keyCode);case x.topKeyDown:return t.keyCode!==C;case x.topKeyPress:case x.topMouseDown:case x.topBlur:return!0;default:return!1}}function u(e){var t=e.detail;return"object"==typeof t&&"data"in t?t.data:null}function l(e,t,n,r,i){var l,c;if(b?l=o(e):P?s(e,r)&&(l=k.compositionEnd):a(e,r)&&(l=k.compositionStart),!l)return null;T&&(P||l!==k.compositionStart?l===k.compositionEnd&&P&&(c=P.getData()):P=y.getPooled(t));var d=g.getPooled(l,n,r,i);if(c)d.data=c;else{var p=u(r);null!==p&&(d.data=p)}return h.accumulateTwoPhaseDispatches(d),d}function c(e,t){switch(e){case x.topCompositionEnd:return u(t);case x.topKeyPress:var n=t.which;return n!==E?null:(I=!0,w);case x.topTextInput:var r=t.data;return r===w&&I?null:r;default:return null}}function d(e,t){if(P){if(e===x.topCompositionEnd||s(e,t)){var n=P.getData();return y.release(P),P=null,n}return null}switch(e){case x.topPaste:return null;case x.topKeyPress:return t.which&&!i(t)?String.fromCharCode(t.which):null;case x.topCompositionEnd:return T?null:t.data;default:return null}}function p(e,t,n,r,i){var o;if(o=M?c(e,r):d(e,r),!o)return null;var a=m.getPooled(k.beforeInput,n,r,i);return a.data=o,h.accumulateTwoPhaseDispatches(a),a}var f=n(330),h=n(373),v=n(309),y=n(374),g=n(376),m=n(378),_=n(379),A=[9,13,27,32],C=229,b=v.canUseDOM&&"CompositionEvent"in window,S=null;v.canUseDOM&&"documentMode"in document&&(S=document.documentMode);var M=v.canUseDOM&&"TextEvent"in window&&!S&&!r(),T=v.canUseDOM&&(!b||S&&S>8&&11>=S),E=32,w=String.fromCharCode(E),x=f.topLevelTypes,k={beforeInput:{phasedRegistrationNames:{bubbled:_({onBeforeInput:null}),captured:_({onBeforeInputCapture:null})},dependencies:[x.topCompositionEnd,x.topKeyPress,x.topTextInput,x.topPaste]},compositionEnd:{phasedRegistrationNames:{bubbled:_({onCompositionEnd:null}),captured:_({onCompositionEndCapture:null})},dependencies:[x.topBlur,x.topCompositionEnd,x.topKeyDown,x.topKeyPress,x.topKeyUp,x.topMouseDown]},compositionStart:{phasedRegistrationNames:{bubbled:_({onCompositionStart:null}),captured:_({onCompositionStartCapture:null})},dependencies:[x.topBlur,x.topCompositionStart,x.topKeyDown,x.topKeyPress,x.topKeyUp,x.topMouseDown]},compositionUpdate:{phasedRegistrationNames:{bubbled:_({onCompositionUpdate:null}),captured:_({onCompositionUpdateCapture:null
})},dependencies:[x.topBlur,x.topCompositionUpdate,x.topKeyDown,x.topKeyPress,x.topKeyUp,x.topMouseDown]}},I=!1,P=null,D={eventTypes:k,extractEvents:function(e,t,n,r,i){return[l(e,t,n,r,i),p(e,t,n,r,i)]}};e.exports=D},function(e,t,n){"use strict";function r(e,t,n){var r=t.dispatchConfig.phasedRegistrationNames[n];return m(e,r)}function i(e,t,n){var i=t?g.bubbled:g.captured,o=r(e,n,i);o&&(n._dispatchListeners=v(n._dispatchListeners,o),n._dispatchIDs=v(n._dispatchIDs,e))}function o(e){e&&e.dispatchConfig.phasedRegistrationNames&&h.injection.getInstanceHandle().traverseTwoPhase(e.dispatchMarker,i,e)}function a(e){e&&e.dispatchConfig.phasedRegistrationNames&&h.injection.getInstanceHandle().traverseTwoPhaseSkipTarget(e.dispatchMarker,i,e)}function s(e,t,n){if(n&&n.dispatchConfig.registrationName){var r=n.dispatchConfig.registrationName,i=m(e,r);i&&(n._dispatchListeners=v(n._dispatchListeners,i),n._dispatchIDs=v(n._dispatchIDs,e))}}function u(e){e&&e.dispatchConfig.registrationName&&s(e.dispatchMarker,null,e)}function l(e){y(e,o)}function c(e){y(e,a)}function d(e,t,n,r){h.injection.getInstanceHandle().traverseEnterLeave(n,r,s,e,t)}function p(e){y(e,u)}var f=n(330),h=n(331),v=(n(325),n(335)),y=n(336),g=f.PropagationPhases,m=h.getListener,_={accumulateTwoPhaseDispatches:l,accumulateTwoPhaseDispatchesSkipTarget:c,accumulateDirectDispatches:p,accumulateEnterLeaveDispatches:d};e.exports=_},function(e,t,n){"use strict";function r(e){this._root=e,this._startText=this.getText(),this._fallbackText=null}var i=n(356),o=n(339),a=n(375);o(r.prototype,{destructor:function(){this._root=null,this._startText=null,this._fallbackText=null},getText:function(){return"value"in this._root?this._root.value:this._root[a()]},getData:function(){if(this._fallbackText)return this._fallbackText;var e,t,n=this._startText,r=n.length,i=this.getText(),o=i.length;for(e=0;r>e&&n[e]===i[e];e++);var a=r-e;for(t=1;a>=t&&n[r-t]===i[o-t];t++);var s=t>1?1-t:void 0;return this._fallbackText=i.slice(e,s),this._fallbackText}}),i.addPoolingTo(r),e.exports=r},function(e,t,n){"use strict";function r(){return!o&&i.canUseDOM&&(o="textContent"in document.documentElement?"textContent":"innerText"),o}var i=n(309),o=null;e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r){i.call(this,e,t,n,r)}var i=n(377),o={data:null};i.augmentClass(r,o),e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r){this.dispatchConfig=e,this.dispatchMarker=t,this.nativeEvent=n;var i=this.constructor.Interface;for(var o in i)if(i.hasOwnProperty(o)){var s=i[o];s?this[o]=s(n):"target"===o?this.target=r:this[o]=n[o]}var u=null!=n.defaultPrevented?n.defaultPrevented:n.returnValue===!1;u?this.isDefaultPrevented=a.thatReturnsTrue:this.isDefaultPrevented=a.thatReturnsFalse,this.isPropagationStopped=a.thatReturnsFalse}var i=n(356),o=n(339),a=n(315),s=(n(325),{type:null,target:null,currentTarget:a.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(e){return e.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null});o(r.prototype,{preventDefault:function(){this.defaultPrevented=!0;var e=this.nativeEvent;e&&(e.preventDefault?e.preventDefault():e.returnValue=!1,this.isDefaultPrevented=a.thatReturnsTrue)},stopPropagation:function(){var e=this.nativeEvent;e&&(e.stopPropagation?e.stopPropagation():e.cancelBubble=!0,this.isPropagationStopped=a.thatReturnsTrue)},persist:function(){this.isPersistent=a.thatReturnsTrue},isPersistent:a.thatReturnsFalse,destructor:function(){var e=this.constructor.Interface;for(var t in e)this[t]=null;this.dispatchConfig=null,this.dispatchMarker=null,this.nativeEvent=null}}),r.Interface=s,r.augmentClass=function(e,t){var n=this,r=Object.create(n.prototype);o(r,e.prototype),e.prototype=r,e.prototype.constructor=e,e.Interface=o({},n.Interface,t),e.augmentClass=n.augmentClass,i.addPoolingTo(e,i.fourArgumentPooler)},i.addPoolingTo(r,i.fourArgumentPooler),e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r){i.call(this,e,t,n,r)}var i=n(377),o={data:null};i.augmentClass(r,o),e.exports=r},function(e,t){"use strict";var n=function(e){var t;for(t in e)if(e.hasOwnProperty(t))return t;return null};e.exports=n},function(e,t,n){"use strict";function r(e){var t=e.nodeName&&e.nodeName.toLowerCase();return"select"===t||"input"===t&&"file"===e.type}function i(e){var t=S.getPooled(k.change,P,e,M(e));A.accumulateTwoPhaseDispatches(t),b.batchedUpdates(o,t)}function o(e){_.enqueueEvents(e),_.processEventQueue(!1)}function a(e,t){I=e,P=t,I.attachEvent("onchange",i)}function s(){I&&(I.detachEvent("onchange",i),I=null,P=null)}function u(e,t,n){return e===x.topChange?n:void 0}function l(e,t,n){e===x.topFocus?(s(),a(t,n)):e===x.topBlur&&s()}function c(e,t){I=e,P=t,D=e.value,N=Object.getOwnPropertyDescriptor(e.constructor.prototype,"value"),Object.defineProperty(I,"value",F),I.attachEvent("onpropertychange",p)}function d(){I&&(delete I.value,I.detachEvent("onpropertychange",p),I=null,P=null,D=null,N=null)}function p(e){if("value"===e.propertyName){var t=e.srcElement.value;t!==D&&(D=t,i(e))}}function f(e,t,n){return e===x.topInput?n:void 0}function h(e,t,n){e===x.topFocus?(d(),c(t,n)):e===x.topBlur&&d()}function v(e,t,n){return e!==x.topSelectionChange&&e!==x.topKeyUp&&e!==x.topKeyDown||!I||I.value===D?void 0:(D=I.value,P)}function y(e){return e.nodeName&&"input"===e.nodeName.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)}function g(e,t,n){return e===x.topClick?n:void 0}var m=n(330),_=n(331),A=n(373),C=n(309),b=n(354),S=n(377),M=n(381),T=n(340),E=n(382),w=n(379),x=m.topLevelTypes,k={change:{phasedRegistrationNames:{bubbled:w({onChange:null}),captured:w({onChangeCapture:null})},dependencies:[x.topBlur,x.topChange,x.topClick,x.topFocus,x.topInput,x.topKeyDown,x.topKeyUp,x.topSelectionChange]}},I=null,P=null,D=null,N=null,O=!1;C.canUseDOM&&(O=T("change")&&(!("documentMode"in document)||document.documentMode>8));var R=!1;C.canUseDOM&&(R=T("input")&&(!("documentMode"in document)||document.documentMode>9));var F={get:function(){return N.get.call(this)},set:function(e){D=""+e,N.set.call(this,e)}},H={eventTypes:k,extractEvents:function(e,t,n,i,o){var a,s;if(r(t)?O?a=u:s=l:E(t)?R?a=f:(a=v,s=h):y(t)&&(a=g),a){var c=a(e,t,n);if(c){var d=S.getPooled(k.change,c,i,o);return d.type="change",A.accumulateTwoPhaseDispatches(d),d}}s&&s(e,t,n)}};e.exports=H},function(e,t){"use strict";function n(e){var t=e.target||e.srcElement||window;return 3===t.nodeType?t.parentNode:t}e.exports=n},function(e,t){"use strict";function n(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return t&&("input"===t&&r[e.type]||"textarea"===t)}var r={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};e.exports=n},function(e,t){"use strict";var n=0,r={createReactRootIndex:function(){return n++}};e.exports=r},function(e,t,n){"use strict";var r=n(379),i=[r({ResponderEventPlugin:null}),r({SimpleEventPlugin:null}),r({TapEventPlugin:null}),r({EnterLeaveEventPlugin:null}),r({ChangeEventPlugin:null}),r({SelectEventPlugin:null}),r({BeforeInputEventPlugin:null})];e.exports=i},function(e,t,n){"use strict";var r=n(330),i=n(373),o=n(386),a=n(328),s=n(379),u=r.topLevelTypes,l=a.getFirstReactDOM,c={mouseEnter:{registrationName:s({onMouseEnter:null}),dependencies:[u.topMouseOut,u.topMouseOver]},mouseLeave:{registrationName:s({onMouseLeave:null}),dependencies:[u.topMouseOut,u.topMouseOver]}},d=[null,null],p={eventTypes:c,extractEvents:function(e,t,n,r,s){if(e===u.topMouseOver&&(r.relatedTarget||r.fromElement))return null;if(e!==u.topMouseOut&&e!==u.topMouseOver)return null;var p;if(t.window===t)p=t;else{var f=t.ownerDocument;p=f?f.defaultView||f.parentWindow:window}var h,v,y="",g="";if(e===u.topMouseOut?(h=t,y=n,v=l(r.relatedTarget||r.toElement),v?g=a.getID(v):v=p,v=v||p):(h=p,v=t,g=n),h===v)return null;var m=o.getPooled(c.mouseLeave,y,r,s);m.type="mouseleave",m.target=h,m.relatedTarget=v;var _=o.getPooled(c.mouseEnter,g,r,s);return _.type="mouseenter",_.target=v,_.relatedTarget=h,i.accumulateEnterLeaveDispatches(m,_,y,g),d[0]=m,d[1]=_,d}};e.exports=p},function(e,t,n){"use strict";function r(e,t,n,r){i.call(this,e,t,n,r)}var i=n(387),o=n(338),a=n(388),s={screenX:null,screenY:null,clientX:null,clientY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:a,button:function(e){var t=e.button;return"which"in e?t:2===t?2:4===t?1:0},buttons:null,relatedTarget:function(e){return e.relatedTarget||(e.fromElement===e.srcElement?e.toElement:e.fromElement)},pageX:function(e){return"pageX"in e?e.pageX:e.clientX+o.currentScrollLeft},pageY:function(e){return"pageY"in e?e.pageY:e.clientY+o.currentScrollTop}};i.augmentClass(r,s),e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r){i.call(this,e,t,n,r)}var i=n(377),o=n(381),a={view:function(e){if(e.view)return e.view;var t=o(e);if(null!=t&&t.window===t)return t;var n=t.ownerDocument;return n?n.defaultView||n.parentWindow:window},detail:function(e){return e.detail||0}};i.augmentClass(r,a),e.exports=r},function(e,t){"use strict";function n(e){var t=this,n=t.nativeEvent;if(n.getModifierState)return n.getModifierState(e);var r=i[e];return r?!!n[r]:!1}function r(e){return n}var i={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};e.exports=r},function(e,t,n){"use strict";var r,i=n(323),o=n(309),a=i.injection.MUST_USE_ATTRIBUTE,s=i.injection.MUST_USE_PROPERTY,u=i.injection.HAS_BOOLEAN_VALUE,l=i.injection.HAS_SIDE_EFFECTS,c=i.injection.HAS_NUMERIC_VALUE,d=i.injection.HAS_POSITIVE_NUMERIC_VALUE,p=i.injection.HAS_OVERLOADED_BOOLEAN_VALUE;if(o.canUseDOM){var f=document.implementation;r=f&&f.hasFeature&&f.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure","1.1")}var h={isCustomAttribute:RegExp.prototype.test.bind(/^(data|aria)-[a-z_][a-z\d_.\-]*$/),Properties:{accept:null,acceptCharset:null,accessKey:null,action:null,allowFullScreen:a|u,allowTransparency:a,alt:null,async:u,autoComplete:null,autoPlay:u,capture:a|u,cellPadding:null,cellSpacing:null,charSet:a,challenge:a,checked:s|u,classID:a,className:r?a:s,cols:a|d,colSpan:null,content:null,contentEditable:null,contextMenu:a,controls:s|u,coords:null,crossOrigin:null,data:null,dateTime:a,"default":u,defer:u,dir:null,disabled:a|u,download:p,draggable:null,encType:null,form:a,formAction:a,formEncType:a,formMethod:a,formNoValidate:u,formTarget:a,frameBorder:a,headers:null,height:a,hidden:a|u,high:null,href:null,hrefLang:null,htmlFor:null,httpEquiv:null,icon:null,id:s,inputMode:a,integrity:null,is:a,keyParams:a,keyType:a,kind:null,label:null,lang:null,list:a,loop:s|u,low:null,manifest:a,marginHeight:null,marginWidth:null,max:null,maxLength:a,media:a,mediaGroup:null,method:null,min:null,minLength:a,multiple:s|u,muted:s|u,name:null,nonce:a,noValidate:u,open:u,optimum:null,pattern:null,placeholder:null,poster:null,preload:null,radioGroup:null,readOnly:s|u,rel:null,required:u,reversed:u,role:a,rows:a|d,rowSpan:null,sandbox:null,scope:null,scoped:u,scrolling:null,seamless:a|u,selected:s|u,shape:null,size:a|d,sizes:a,span:d,spellCheck:null,src:null,srcDoc:s,srcLang:null,srcSet:a,start:c,step:null,style:null,summary:null,tabIndex:null,target:null,title:null,type:null,useMap:null,value:s|l,width:a,wmode:a,wrap:null,about:a,datatype:a,inlist:a,prefix:a,property:a,resource:a,"typeof":a,vocab:a,autoCapitalize:a,autoCorrect:a,autoSave:null,color:null,itemProp:a,itemScope:a|u,itemType:a,itemID:a,itemRef:a,results:null,security:a,unselectable:a},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMPropertyNames:{autoComplete:"autocomplete",autoFocus:"autofocus",autoPlay:"autoplay",autoSave:"autosave",encType:"encoding",hrefLang:"hreflang",radioGroup:"radiogroup",spellCheck:"spellcheck",srcDoc:"srcdoc",srcSet:"srcset"}};e.exports=h},function(e,t,n){"use strict";var r=(n(347),n(391)),i=(n(325),"_getDOMNodeDidWarn"),o={getDOMNode:function(){return this.constructor[i]=!0,r(this)}};e.exports=o},function(e,t,n){"use strict";function r(e){return null==e?null:1===e.nodeType?e:i.has(e)?o.getNodeFromInstance(e):(null!=e.render&&"function"==typeof e.render?a(!1):void 0,void a(!1))}var i=(n(305),n(347)),o=n(328),a=n(313);n(325);e.exports=r},function(e,t,n){"use strict";function r(){this.reinitializeTransaction()}var i=n(354),o=n(357),a=n(339),s=n(315),u={initialize:s,close:function(){p.isBatchingUpdates=!1}},l={initialize:s,close:i.flushBatchedUpdates.bind(i)},c=[l,u];a(r.prototype,o.Mixin,{getTransactionWrappers:function(){return c}});var d=new r,p={isBatchingUpdates:!1,batchedUpdates:function(e,t,n,r,i,o){var a=p.isBatchingUpdates;p.isBatchingUpdates=!0,a?e(t,n,r,i,o):d.perform(e,null,t,n,r,i,o)}};e.exports=p},function(e,t,n){"use strict";function r(){return this}function i(){var e=this._reactInternalComponent;return!!e}function o(){}function a(e,t){var n=this._reactInternalComponent;n&&(D.enqueueSetPropsInternal(n,e),t&&D.enqueueCallbackInternal(n,t))}function s(e,t){var n=this._reactInternalComponent;n&&(D.enqueueReplacePropsInternal(n,e),t&&D.enqueueCallbackInternal(n,t))}function u(e,t){t&&(null!=t.dangerouslySetInnerHTML&&(null!=t.children?F(!1):void 0,"object"==typeof t.dangerouslySetInnerHTML&&J in t.dangerouslySetInnerHTML?void 0:F(!1)),null!=t.style&&"object"!=typeof t.style?F(!1):void 0)}function l(e,t,n,r){var i=k.findReactContainerForID(e);if(i){var o=i.nodeType===Y?i.ownerDocument:i;K(t,o)}r.getReactMountReady().enqueue(c,{id:e,registrationName:t,listener:n})}function c(){var e=this;b.putListener(e.id,e.registrationName,e.listener)}function d(){var e=this;e._rootNodeID?void 0:F(!1);var t=k.getNode(e._rootNodeID);switch(t?void 0:F(!1),e._tag){case"iframe":e._wrapperState.listeners=[b.trapBubbledEvent(C.topLevelTypes.topLoad,"load",t)];break;case"video":case"audio":e._wrapperState.listeners=[];for(var n in z)z.hasOwnProperty(n)&&e._wrapperState.listeners.push(b.trapBubbledEvent(C.topLevelTypes[n],z[n],t));break;case"img":e._wrapperState.listeners=[b.trapBubbledEvent(C.topLevelTypes.topError,"error",t),b.trapBubbledEvent(C.topLevelTypes.topLoad,"load",t)];break;case"form":e._wrapperState.listeners=[b.trapBubbledEvent(C.topLevelTypes.topReset,"reset",t),b.trapBubbledEvent(C.topLevelTypes.topSubmit,"submit",t)]}}function p(){T.mountReadyWrapper(this)}function f(){w.postUpdateWrapper(this)}function h(e){$.call(q,e)||(Z.test(e)?void 0:F(!1),q[e]=!0)}function v(e,t){return e.indexOf("-")>=0||null!=t.is}function y(e){h(e),this._tag=e.toLowerCase(),this._renderedChildren=null,this._previousStyle=null,this._previousStyleCopy=null,this._rootNodeID=null,this._wrapperState=null,this._topLevelWrapper=null,this._nodeWithLegacyProperties=null}var g=n(394),m=n(396),_=n(323),A=n(322),C=n(330),b=n(329),S=n(326),M=n(404),T=n(405),E=n(409),w=n(412),x=n(413),k=n(328),I=n(414),P=n(318),D=n(353),N=n(339),O=n(343),R=n(321),F=n(313),H=(n(340),n(379)),L=n(319),B=n(320),U=(n(417),n(370),n(325),b.deleteListener),K=b.listenTo,j=b.registrationNameModules,V={string:!0,number:!0},W=H({children:null}),G=H({style:null}),J=H({__html:null}),Y=1,z={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},X={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},Q={listing:!0,pre:!0,textarea:!0},Z=(N({menuitem:!0},X),/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/),q={},$={}.hasOwnProperty;y.displayName="ReactDOMComponent",y.Mixin={construct:function(e){this._currentElement=e},mountComponent:function(e,t,n){this._rootNodeID=e;var r=this._currentElement.props;switch(this._tag){case"iframe":case"img":case"form":case"video":case"audio":this._wrapperState={listeners:null},t.getReactMountReady().enqueue(d,this);break;case"button":r=M.getNativeProps(this,r,n);break;case"input":T.mountWrapper(this,r,n),r=T.getNativeProps(this,r,n);break;case"option":E.mountWrapper(this,r,n),r=E.getNativeProps(this,r,n);break;case"select":w.mountWrapper(this,r,n),r=w.getNativeProps(this,r,n),n=w.processChildContext(this,r,n);break;case"textarea":x.mountWrapper(this,r,n),r=x.getNativeProps(this,r,n)}u(this,r);var i;if(t.useCreateElement){var o=n[k.ownerDocumentContextKey],a=o.createElement(this._currentElement.type);A.setAttributeForID(a,this._rootNodeID),k.getID(a),this._updateDOMProperties({},r,t,a),this._createInitialChildren(t,r,n,a),i=a}else{var s=this._createOpenTagMarkupAndPutListeners(t,r),l=this._createContentMarkup(t,r,n);i=!l&&X[this._tag]?s+"/>":s+">"+l+"</"+this._currentElement.type+">"}switch(this._tag){case"input":t.getReactMountReady().enqueue(p,this);case"button":case"select":case"textarea":r.autoFocus&&t.getReactMountReady().enqueue(g.focusDOMComponent,this)}return i},_createOpenTagMarkupAndPutListeners:function(e,t){var n="<"+this._currentElement.type;for(var r in t)if(t.hasOwnProperty(r)){var i=t[r];if(null!=i)if(j.hasOwnProperty(r))i&&l(this._rootNodeID,r,i,e);else{r===G&&(i&&(i=this._previousStyleCopy=N({},t.style)),i=m.createMarkupForStyles(i));var o=null;null!=this._tag&&v(this._tag,t)?r!==W&&(o=A.createMarkupForCustomAttribute(r,i)):o=A.createMarkupForProperty(r,i),o&&(n+=" "+o)}}if(e.renderToStaticMarkup)return n;var a=A.createMarkupForID(this._rootNodeID);return n+" "+a},_createContentMarkup:function(e,t,n){var r="",i=t.dangerouslySetInnerHTML;if(null!=i)null!=i.__html&&(r=i.__html);else{var o=V[typeof t.children]?t.children:null,a=null!=o?null:t.children;if(null!=o)r=R(o);else if(null!=a){var s=this.mountChildren(a,e,n);r=s.join("")}}return Q[this._tag]&&"\n"===r.charAt(0)?"\n"+r:r},_createInitialChildren:function(e,t,n,r){var i=t.dangerouslySetInnerHTML;if(null!=i)null!=i.__html&&L(r,i.__html);else{var o=V[typeof t.children]?t.children:null,a=null!=o?null:t.children;if(null!=o)B(r,o);else if(null!=a)for(var s=this.mountChildren(a,e,n),u=0;u<s.length;u++)r.appendChild(s[u])}},receiveComponent:function(e,t,n){var r=this._currentElement;this._currentElement=e,this.updateComponent(t,r,e,n)},updateComponent:function(e,t,n,r){var i=t.props,o=this._currentElement.props;switch(this._tag){case"button":i=M.getNativeProps(this,i),o=M.getNativeProps(this,o);break;case"input":T.updateWrapper(this),i=T.getNativeProps(this,i),o=T.getNativeProps(this,o);break;case"option":i=E.getNativeProps(this,i),o=E.getNativeProps(this,o);break;case"select":i=w.getNativeProps(this,i),o=w.getNativeProps(this,o);break;case"textarea":x.updateWrapper(this),i=x.getNativeProps(this,i),o=x.getNativeProps(this,o)}u(this,o),this._updateDOMProperties(i,o,e,null),this._updateDOMChildren(i,o,e,r),!O&&this._nodeWithLegacyProperties&&(this._nodeWithLegacyProperties.props=o),"select"===this._tag&&e.getReactMountReady().enqueue(f,this)},_updateDOMProperties:function(e,t,n,r){var i,o,a;for(i in e)if(!t.hasOwnProperty(i)&&e.hasOwnProperty(i))if(i===G){var s=this._previousStyleCopy;for(o in s)s.hasOwnProperty(o)&&(a=a||{},a[o]="");this._previousStyleCopy=null}else j.hasOwnProperty(i)?e[i]&&U(this._rootNodeID,i):(_.properties[i]||_.isCustomAttribute(i))&&(r||(r=k.getNode(this._rootNodeID)),A.deleteValueForProperty(r,i));for(i in t){var u=t[i],c=i===G?this._previousStyleCopy:e[i];if(t.hasOwnProperty(i)&&u!==c)if(i===G)if(u?u=this._previousStyleCopy=N({},u):this._previousStyleCopy=null,c){for(o in c)!c.hasOwnProperty(o)||u&&u.hasOwnProperty(o)||(a=a||{},a[o]="");for(o in u)u.hasOwnProperty(o)&&c[o]!==u[o]&&(a=a||{},a[o]=u[o])}else a=u;else j.hasOwnProperty(i)?u?l(this._rootNodeID,i,u,n):c&&U(this._rootNodeID,i):v(this._tag,t)?(r||(r=k.getNode(this._rootNodeID)),i===W&&(u=null),A.setValueForAttribute(r,i,u)):(_.properties[i]||_.isCustomAttribute(i))&&(r||(r=k.getNode(this._rootNodeID)),null!=u?A.setValueForProperty(r,i,u):A.deleteValueForProperty(r,i))}a&&(r||(r=k.getNode(this._rootNodeID)),m.setValueForStyles(r,a))},_updateDOMChildren:function(e,t,n,r){var i=V[typeof e.children]?e.children:null,o=V[typeof t.children]?t.children:null,a=e.dangerouslySetInnerHTML&&e.dangerouslySetInnerHTML.__html,s=t.dangerouslySetInnerHTML&&t.dangerouslySetInnerHTML.__html,u=null!=i?null:e.children,l=null!=o?null:t.children,c=null!=i||null!=a,d=null!=o||null!=s;null!=u&&null==l?this.updateChildren(null,n,r):c&&!d&&this.updateTextContent(""),null!=o?i!==o&&this.updateTextContent(""+o):null!=s?a!==s&&this.updateMarkup(""+s):null!=l&&this.updateChildren(l,n,r)},unmountComponent:function(){switch(this._tag){case"iframe":case"img":case"form":case"video":case"audio":var e=this._wrapperState.listeners;if(e)for(var t=0;t<e.length;t++)e[t].remove();break;case"input":T.unmountWrapper(this);break;case"html":case"head":case"body":F(!1)}if(this.unmountChildren(),b.deleteAllListeners(this._rootNodeID),S.unmountIDFromEnvironment(this._rootNodeID),this._rootNodeID=null,this._wrapperState=null,this._nodeWithLegacyProperties){var n=this._nodeWithLegacyProperties;n._reactInternalComponent=null,this._nodeWithLegacyProperties=null}},getPublicInstance:function(){if(!this._nodeWithLegacyProperties){var e=k.getNode(this._rootNodeID);e._reactInternalComponent=this,e.getDOMNode=r,e.isMounted=i,e.setState=o,e.replaceState=o,e.forceUpdate=o,e.setProps=a,e.replaceProps=s,e.props=this._currentElement.props,this._nodeWithLegacyProperties=e}return this._nodeWithLegacyProperties}},P.measureMethods(y,"ReactDOMComponent",{mountComponent:"mountComponent",updateComponent:"updateComponent"}),N(y.prototype,y.Mixin,I.Mixin),e.exports=y},function(e,t,n){"use strict";var r=n(328),i=n(391),o=n(395),a={componentDidMount:function(){this.props.autoFocus&&o(i(this))}},s={Mixin:a,focusDOMComponent:function(){o(r.getNode(this._rootNodeID))}};e.exports=s},function(e,t){"use strict";function n(e){try{e.focus()}catch(t){}}e.exports=n},function(e,t,n){"use strict";var r=n(397),i=n(309),o=n(318),a=(n(398),n(400)),s=n(401),u=n(403),l=(n(325),u(function(e){return s(e)})),c=!1,d="cssFloat";if(i.canUseDOM){var p=document.createElement("div").style;try{p.font=""}catch(f){c=!0}void 0===document.documentElement.style.cssFloat&&(d="styleFloat")}var h={createMarkupForStyles:function(e){var t="";for(var n in e)if(e.hasOwnProperty(n)){var r=e[n];null!=r&&(t+=l(n)+":",t+=a(n,r)+";")}return t||null},setValueForStyles:function(e,t){var n=e.style;for(var i in t)if(t.hasOwnProperty(i)){var o=a(i,t[i]);if("float"===i&&(i=d),o)n[i]=o;else{var s=c&&r.shorthandPropertyExpansions[i];if(s)for(var u in s)n[u]="";else n[i]=""}}}};o.measureMethods(h,"CSSPropertyOperations",{setValueForStyles:"setValueForStyles"}),e.exports=h},function(e,t){"use strict";function n(e,t){return e+t.charAt(0).toUpperCase()+t.substring(1)}var r={animationIterationCount:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,stopOpacity:!0,strokeDashoffset:!0,strokeOpacity:!0,strokeWidth:!0},i=["Webkit","ms","Moz","O"];Object.keys(r).forEach(function(e){i.forEach(function(t){r[n(t,e)]=r[e]})});var o={background:{backgroundAttachment:!0,backgroundColor:!0,backgroundImage:!0,backgroundPositionX:!0,backgroundPositionY:!0,backgroundRepeat:!0},backgroundPosition:{backgroundPositionX:!0,backgroundPositionY:!0},border:{borderWidth:!0,borderStyle:!0,borderColor:!0},borderBottom:{borderBottomWidth:!0,borderBottomStyle:!0,borderBottomColor:!0},borderLeft:{borderLeftWidth:!0,borderLeftStyle:!0,borderLeftColor:!0},borderRight:{borderRightWidth:!0,borderRightStyle:!0,borderRightColor:!0},borderTop:{borderTopWidth:!0,borderTopStyle:!0,borderTopColor:!0},font:{fontStyle:!0,fontVariant:!0,fontWeight:!0,fontSize:!0,lineHeight:!0,fontFamily:!0},outline:{outlineWidth:!0,outlineStyle:!0,outlineColor:!0}},a={isUnitlessNumber:r,shorthandPropertyExpansions:o};e.exports=a},function(e,t,n){"use strict";function r(e){return i(e.replace(o,"ms-"))}var i=n(399),o=/^-ms-/;e.exports=r},function(e,t){"use strict";function n(e){return e.replace(r,function(e,t){return t.toUpperCase()})}var r=/-(.)/g;e.exports=n},function(e,t,n){"use strict";function r(e,t){var n=null==t||"boolean"==typeof t||""===t;if(n)return"";var r=isNaN(t);return r||0===t||o.hasOwnProperty(e)&&o[e]?""+t:("string"==typeof t&&(t=t.trim()),t+"px")}var i=n(397),o=i.isUnitlessNumber;e.exports=r},function(e,t,n){"use strict";function r(e){return i(e).replace(o,"-ms-")}var i=n(402),o=/^ms-/;e.exports=r},function(e,t){"use strict";function n(e){return e.replace(r,"-$1").toLowerCase()}var r=/([A-Z])/g;e.exports=n},function(e,t){"use strict";function n(e){var t={};return function(n){return t.hasOwnProperty(n)||(t[n]=e.call(this,n)),t[n]}}e.exports=n},function(e,t){"use strict";var n={onClick:!0,onDoubleClick:!0,onMouseDown:!0,onMouseMove:!0,onMouseUp:!0,onClickCapture:!0,onDoubleClickCapture:!0,onMouseDownCapture:!0,onMouseMoveCapture:!0,onMouseUpCapture:!0},r={getNativeProps:function(e,t,r){if(!t.disabled)return t;var i={};for(var o in t)t.hasOwnProperty(o)&&!n[o]&&(i[o]=t[o]);return i}};e.exports=r},function(e,t,n){"use strict";function r(){this._rootNodeID&&p.updateWrapper(this)}function i(e){var t=this._currentElement.props,n=a.executeOnChange(t,e);u.asap(r,this);var i=t.name;if("radio"===t.type&&null!=i){for(var o=s.getNode(this._rootNodeID),l=o;l.parentNode;)l=l.parentNode;for(var p=l.querySelectorAll("input[name="+JSON.stringify(""+i)+'][type="radio"]'),f=0;f<p.length;f++){var h=p[f];if(h!==o&&h.form===o.form){var v=s.getID(h);v?void 0:c(!1);var y=d[v];y?void 0:c(!1),u.asap(r,y)}}}return n}var o=n(327),a=n(406),s=n(328),u=n(354),l=n(339),c=n(313),d={},p={getNativeProps:function(e,t,n){var r=a.getValue(t),i=a.getChecked(t),o=l({},t,{defaultChecked:void 0,defaultValue:void 0,value:null!=r?r:e._wrapperState.initialValue,checked:null!=i?i:e._wrapperState.initialChecked,onChange:e._wrapperState.onChange});return o},mountWrapper:function(e,t){var n=t.defaultValue;e._wrapperState={initialChecked:t.defaultChecked||!1,initialValue:null!=n?n:null,onChange:i.bind(e)}},mountReadyWrapper:function(e){d[e._rootNodeID]=e},unmountWrapper:function(e){delete d[e._rootNodeID]},updateWrapper:function(e){var t=e._currentElement.props,n=t.checked;null!=n&&o.updatePropertyByID(e._rootNodeID,"checked",n||!1);var r=a.getValue(t);null!=r&&o.updatePropertyByID(e._rootNodeID,"value",""+r)}};e.exports=p},function(e,t,n){"use strict";function r(e){null!=e.checkedLink&&null!=e.valueLink?l(!1):void 0}function i(e){r(e),null!=e.value||null!=e.onChange?l(!1):void 0}function o(e){r(e),null!=e.checked||null!=e.onChange?l(!1):void 0}function a(e){if(e){var t=e.getName();if(t)return" Check the render method of `"+t+"`."}return""}var s=n(407),u=n(365),l=n(313),c=(n(325),{button:!0,checkbox:!0,image:!0,hidden:!0,radio:!0,reset:!0,submit:!0}),d={value:function(e,t,n){return!e[t]||c[e.type]||e.onChange||e.readOnly||e.disabled?null:new Error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.")},checked:function(e,t,n){return!e[t]||e.onChange||e.readOnly||e.disabled?null:new Error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.")},onChange:s.func},p={},f={checkPropTypes:function(e,t,n){for(var r in d){if(d.hasOwnProperty(r))var i=d[r](t,r,e,u.prop);if(i instanceof Error&&!(i.message in p)){p[i.message]=!0;a(n)}}},getValue:function(e){return e.valueLink?(i(e),e.valueLink.value):e.value},getChecked:function(e){return e.checkedLink?(o(e),e.checkedLink.value):e.checked},executeOnChange:function(e,t){return e.valueLink?(i(e),e.valueLink.requestChange(t.target.value)):e.checkedLink?(o(e),e.checkedLink.requestChange(t.target.checked)):e.onChange?e.onChange.call(void 0,t):void 0}};e.exports=f},function(e,t,n){"use strict";function r(e){function t(t,n,r,i,o,a){if(i=i||b,a=a||r,null==n[r]){var s=_[o];return t?new Error("Required "+s+" `"+a+"` was not specified in "+("`"+i+"`.")):null}return e(n,r,i,o,a)}var n=t.bind(null,!1);return n.isRequired=t.bind(null,!0),n}function i(e){function t(t,n,r,i,o){var a=t[n],s=v(a);if(s!==e){var u=_[i],l=y(a);return new Error("Invalid "+u+" `"+o+"` of type "+("`"+l+"` supplied to `"+r+"`, expected ")+("`"+e+"`."))}return null}return r(t)}function o(){return r(A.thatReturns(null))}function a(e){function t(t,n,r,i,o){var a=t[n];if(!Array.isArray(a)){var s=_[i],u=v(a);return new Error("Invalid "+s+" `"+o+"` of type "+("`"+u+"` supplied to `"+r+"`, expected an array."))}for(var l=0;l<a.length;l++){var c=e(a,l,r,i,o+"["+l+"]");if(c instanceof Error)return c}return null}return r(t)}function s(){function e(e,t,n,r,i){if(!m.isValidElement(e[t])){var o=_[r];return new Error("Invalid "+o+" `"+i+"` supplied to "+("`"+n+"`, expected a single ReactElement."))}return null}return r(e)}function u(e){function t(t,n,r,i,o){if(!(t[n]instanceof e)){var a=_[i],s=e.name||b,u=g(t[n]);return new Error("Invalid "+a+" `"+o+"` of type "+("`"+u+"` supplied to `"+r+"`, expected ")+("instance of `"+s+"`."))}return null}return r(t)}function l(e){function t(t,n,r,i,o){for(var a=t[n],s=0;s<e.length;s++)if(a===e[s])return null;var u=_[i],l=JSON.stringify(e);return new Error("Invalid "+u+" `"+o+"` of value `"+a+"` "+("supplied to `"+r+"`, expected one of "+l+"."))}return r(Array.isArray(e)?t:function(){return new Error("Invalid argument supplied to oneOf, expected an instance of array.")})}function c(e){function t(t,n,r,i,o){var a=t[n],s=v(a);if("object"!==s){var u=_[i];return new Error("Invalid "+u+" `"+o+"` of type "+("`"+s+"` supplied to `"+r+"`, expected an object."))}for(var l in a)if(a.hasOwnProperty(l)){var c=e(a,l,r,i,o+"."+l);if(c instanceof Error)return c}return null}return r(t)}function d(e){function t(t,n,r,i,o){for(var a=0;a<e.length;a++){var s=e[a];if(null==s(t,n,r,i,o))return null}var u=_[i];return new Error("Invalid "+u+" `"+o+"` supplied to "+("`"+r+"`."))}return r(Array.isArray(e)?t:function(){return new Error("Invalid argument supplied to oneOfType, expected an instance of array.")})}function p(){function e(e,t,n,r,i){if(!h(e[t])){var o=_[r];return new Error("Invalid "+o+" `"+i+"` supplied to "+("`"+n+"`, expected a ReactNode."))}return null}return r(e)}function f(e){function t(t,n,r,i,o){var a=t[n],s=v(a);if("object"!==s){var u=_[i];return new Error("Invalid "+u+" `"+o+"` of type `"+s+"` "+("supplied to `"+r+"`, expected `object`."))}for(var l in e){var c=e[l];if(c){var d=c(a,l,r,i,o+"."+l);if(d)return d}}return null}return r(t)}function h(e){switch(typeof e){case"number":case"string":case"undefined":return!0;case"boolean":return!e;case"object":if(Array.isArray(e))return e.every(h);if(null===e||m.isValidElement(e))return!0;var t=C(e);if(!t)return!1;var n,r=t.call(e);if(t!==e.entries){for(;!(n=r.next()).done;)if(!h(n.value))return!1}else for(;!(n=r.next()).done;){var i=n.value;if(i&&!h(i[1]))return!1}return!0;default:return!1}}function v(e){var t=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":t}function y(e){var t=v(e);if("object"===t){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return t}function g(e){return e.constructor&&e.constructor.name?e.constructor.name:"<<anonymous>>"}var m=n(342),_=n(366),A=n(315),C=n(408),b="<<anonymous>>",S={array:i("array"),bool:i("boolean"),func:i("function"),number:i("number"),object:i("object"),string:i("string"),any:o(),arrayOf:a,element:s(),instanceOf:u,node:p(),objectOf:c,oneOf:l,oneOfType:d,
shape:f};e.exports=S},function(e,t){"use strict";function n(e){var t=e&&(r&&e[r]||e[i]);return"function"==typeof t?t:void 0}var r="function"==typeof Symbol&&Symbol.iterator,i="@@iterator";e.exports=n},function(e,t,n){"use strict";var r=n(410),i=n(412),o=n(339),a=(n(325),i.valueContextKey),s={mountWrapper:function(e,t,n){var r=n[a],i=null;if(null!=r)if(i=!1,Array.isArray(r)){for(var o=0;o<r.length;o++)if(""+r[o]==""+t.value){i=!0;break}}else i=""+r==""+t.value;e._wrapperState={selected:i}},getNativeProps:function(e,t,n){var i=o({selected:void 0,children:void 0},t);null!=e._wrapperState.selected&&(i.selected=e._wrapperState.selected);var a="";return r.forEach(t.children,function(e){null!=e&&("string"!=typeof e&&"number"!=typeof e||(a+=e))}),a&&(i.children=a),i}};e.exports=s},function(e,t,n){"use strict";function r(e){return(""+e).replace(A,"//")}function i(e,t){this.func=e,this.context=t,this.count=0}function o(e,t,n){var r=e.func,i=e.context;r.call(i,t,e.count++)}function a(e,t,n){if(null==e)return e;var r=i.getPooled(t,n);g(e,o,r),i.release(r)}function s(e,t,n,r){this.result=e,this.keyPrefix=t,this.func=n,this.context=r,this.count=0}function u(e,t,n){var i=e.result,o=e.keyPrefix,a=e.func,s=e.context,u=a.call(s,t,e.count++);Array.isArray(u)?l(u,i,n,y.thatReturnsArgument):null!=u&&(v.isValidElement(u)&&(u=v.cloneAndReplaceKey(u,o+(u!==t?r(u.key||"")+"/":"")+n)),i.push(u))}function l(e,t,n,i,o){var a="";null!=n&&(a=r(n)+"/");var l=s.getPooled(t,a,i,o);g(e,u,l),s.release(l)}function c(e,t,n){if(null==e)return e;var r=[];return l(e,r,null,t,n),r}function d(e,t,n){return null}function p(e,t){return g(e,d,null)}function f(e){var t=[];return l(e,t,null,y.thatReturnsArgument),t}var h=n(356),v=n(342),y=n(315),g=n(411),m=h.twoArgumentPooler,_=h.fourArgumentPooler,A=/\/(?!\/)/g;i.prototype.destructor=function(){this.func=null,this.context=null,this.count=0},h.addPoolingTo(i,m),s.prototype.destructor=function(){this.result=null,this.keyPrefix=null,this.func=null,this.context=null,this.count=0},h.addPoolingTo(s,_);var C={forEach:a,map:c,mapIntoWithKeyPrefixInternal:l,count:p,toArray:f};e.exports=C},function(e,t,n){"use strict";function r(e){return v[e]}function i(e,t){return e&&null!=e.key?a(e.key):t.toString(36)}function o(e){return(""+e).replace(y,r)}function a(e){return"$"+o(e)}function s(e,t,n,r){var o=typeof e;if("undefined"!==o&&"boolean"!==o||(e=null),null===e||"string"===o||"number"===o||l.isValidElement(e))return n(r,e,""===t?f+i(e,0):t),1;var u,c,v=0,y=""===t?f:t+h;if(Array.isArray(e))for(var g=0;g<e.length;g++)u=e[g],c=y+i(u,g),v+=s(u,c,n,r);else{var m=d(e);if(m){var _,A=m.call(e);if(m!==e.entries)for(var C=0;!(_=A.next()).done;)u=_.value,c=y+i(u,C++),v+=s(u,c,n,r);else for(;!(_=A.next()).done;){var b=_.value;b&&(u=b[1],c=y+a(b[0])+h+i(u,0),v+=s(u,c,n,r))}}else if("object"===o){String(e);p(!1)}}return v}function u(e,t,n){return null==e?0:s(e,"",t,n)}var l=(n(305),n(342)),c=n(345),d=n(408),p=n(313),f=(n(325),c.SEPARATOR),h=":",v={"=":"=0",".":"=1",":":"=2"},y=/[=.:]/g;e.exports=u},function(e,t,n){"use strict";function r(){if(this._rootNodeID&&this._wrapperState.pendingUpdate){this._wrapperState.pendingUpdate=!1;var e=this._currentElement.props,t=a.getValue(e);null!=t&&i(this,Boolean(e.multiple),t)}}function i(e,t,n){var r,i,o=s.getNode(e._rootNodeID).options;if(t){for(r={},i=0;i<n.length;i++)r[""+n[i]]=!0;for(i=0;i<o.length;i++){var a=r.hasOwnProperty(o[i].value);o[i].selected!==a&&(o[i].selected=a)}}else{for(r=""+n,i=0;i<o.length;i++)if(o[i].value===r)return void(o[i].selected=!0);o.length&&(o[0].selected=!0)}}function o(e){var t=this._currentElement.props,n=a.executeOnChange(t,e);return this._wrapperState.pendingUpdate=!0,u.asap(r,this),n}var a=n(406),s=n(328),u=n(354),l=n(339),c=(n(325),"__ReactDOMSelect_value$"+Math.random().toString(36).slice(2)),d={valueContextKey:c,getNativeProps:function(e,t,n){return l({},t,{onChange:e._wrapperState.onChange,value:void 0})},mountWrapper:function(e,t){var n=a.getValue(t);e._wrapperState={pendingUpdate:!1,initialValue:null!=n?n:t.defaultValue,onChange:o.bind(e),wasMultiple:Boolean(t.multiple)}},processChildContext:function(e,t,n){var r=l({},n);return r[c]=e._wrapperState.initialValue,r},postUpdateWrapper:function(e){var t=e._currentElement.props;e._wrapperState.initialValue=void 0;var n=e._wrapperState.wasMultiple;e._wrapperState.wasMultiple=Boolean(t.multiple);var r=a.getValue(t);null!=r?(e._wrapperState.pendingUpdate=!1,i(e,Boolean(t.multiple),r)):n!==Boolean(t.multiple)&&(null!=t.defaultValue?i(e,Boolean(t.multiple),t.defaultValue):i(e,Boolean(t.multiple),t.multiple?[]:""))}};e.exports=d},function(e,t,n){"use strict";function r(){this._rootNodeID&&c.updateWrapper(this)}function i(e){var t=this._currentElement.props,n=o.executeOnChange(t,e);return s.asap(r,this),n}var o=n(406),a=n(327),s=n(354),u=n(339),l=n(313),c=(n(325),{getNativeProps:function(e,t,n){null!=t.dangerouslySetInnerHTML?l(!1):void 0;var r=u({},t,{defaultValue:void 0,value:void 0,children:e._wrapperState.initialValue,onChange:e._wrapperState.onChange});return r},mountWrapper:function(e,t){var n=t.defaultValue,r=t.children;null!=r&&(null!=n?l(!1):void 0,Array.isArray(r)&&(r.length<=1?void 0:l(!1),r=r[0]),n=""+r),null==n&&(n="");var a=o.getValue(t);e._wrapperState={initialValue:""+(null!=a?a:n),onChange:i.bind(e)}},updateWrapper:function(e){var t=e._currentElement.props,n=o.getValue(t);null!=n&&a.updatePropertyByID(e._rootNodeID,"value",""+n)}});e.exports=c},function(e,t,n){"use strict";function r(e,t,n){y.push({parentID:e,parentNode:null,type:d.INSERT_MARKUP,markupIndex:g.push(t)-1,content:null,fromIndex:null,toIndex:n})}function i(e,t,n){y.push({parentID:e,parentNode:null,type:d.MOVE_EXISTING,markupIndex:null,content:null,fromIndex:t,toIndex:n})}function o(e,t){y.push({parentID:e,parentNode:null,type:d.REMOVE_NODE,markupIndex:null,content:null,fromIndex:t,toIndex:null})}function a(e,t){y.push({parentID:e,parentNode:null,type:d.SET_MARKUP,markupIndex:null,content:t,fromIndex:null,toIndex:null})}function s(e,t){y.push({parentID:e,parentNode:null,type:d.TEXT_CONTENT,markupIndex:null,content:t,fromIndex:null,toIndex:null})}function u(){y.length&&(c.processChildrenUpdates(y,g),l())}function l(){y.length=0,g.length=0}var c=n(364),d=n(316),p=(n(305),n(350)),f=n(415),h=n(416),v=0,y=[],g=[],m={Mixin:{_reconcilerInstantiateChildren:function(e,t,n){return f.instantiateChildren(e,t,n)},_reconcilerUpdateChildren:function(e,t,n,r){var i;return i=h(t),f.updateChildren(e,i,n,r)},mountChildren:function(e,t,n){var r=this._reconcilerInstantiateChildren(e,t,n);this._renderedChildren=r;var i=[],o=0;for(var a in r)if(r.hasOwnProperty(a)){var s=r[a],u=this._rootNodeID+a,l=p.mountComponent(s,u,t,n);s._mountIndex=o++,i.push(l)}return i},updateTextContent:function(e){v++;var t=!0;try{var n=this._renderedChildren;f.unmountChildren(n);for(var r in n)n.hasOwnProperty(r)&&this._unmountChild(n[r]);this.setTextContent(e),t=!1}finally{v--,v||(t?l():u())}},updateMarkup:function(e){v++;var t=!0;try{var n=this._renderedChildren;f.unmountChildren(n);for(var r in n)n.hasOwnProperty(r)&&this._unmountChildByName(n[r],r);this.setMarkup(e),t=!1}finally{v--,v||(t?l():u())}},updateChildren:function(e,t,n){v++;var r=!0;try{this._updateChildren(e,t,n),r=!1}finally{v--,v||(r?l():u())}},_updateChildren:function(e,t,n){var r=this._renderedChildren,i=this._reconcilerUpdateChildren(r,e,t,n);if(this._renderedChildren=i,i||r){var o,a=0,s=0;for(o in i)if(i.hasOwnProperty(o)){var u=r&&r[o],l=i[o];u===l?(this.moveChild(u,s,a),a=Math.max(u._mountIndex,a),u._mountIndex=s):(u&&(a=Math.max(u._mountIndex,a),this._unmountChild(u)),this._mountChildByNameAtIndex(l,o,s,t,n)),s++}for(o in r)!r.hasOwnProperty(o)||i&&i.hasOwnProperty(o)||this._unmountChild(r[o])}},unmountChildren:function(){var e=this._renderedChildren;f.unmountChildren(e),this._renderedChildren=null},moveChild:function(e,t,n){e._mountIndex<n&&i(this._rootNodeID,e._mountIndex,t)},createChild:function(e,t){r(this._rootNodeID,t,e._mountIndex)},removeChild:function(e){o(this._rootNodeID,e._mountIndex)},setTextContent:function(e){s(this._rootNodeID,e)},setMarkup:function(e){a(this._rootNodeID,e)},_mountChildByNameAtIndex:function(e,t,n,r,i){var o=this._rootNodeID+t,a=p.mountComponent(e,o,r,i);e._mountIndex=n,this.createChild(e,a)},_unmountChild:function(e){this.removeChild(e),e._mountIndex=null}}};e.exports=m},function(e,t,n){"use strict";function r(e,t,n){var r=void 0===e[n];null!=t&&r&&(e[n]=o(t,null))}var i=n(350),o=n(362),a=n(367),s=n(411),u=(n(325),{instantiateChildren:function(e,t,n){if(null==e)return null;var i={};return s(e,r,i),i},updateChildren:function(e,t,n,r){if(!t&&!e)return null;var s;for(s in t)if(t.hasOwnProperty(s)){var u=e&&e[s],l=u&&u._currentElement,c=t[s];if(null!=u&&a(l,c))i.receiveComponent(u,c,n,r),t[s]=u;else{u&&i.unmountComponent(u,s);var d=o(c,null);t[s]=d}}for(s in e)!e.hasOwnProperty(s)||t&&t.hasOwnProperty(s)||i.unmountComponent(e[s]);return t},unmountChildren:function(e){for(var t in e)if(e.hasOwnProperty(t)){var n=e[t];i.unmountComponent(n)}}});e.exports=u},function(e,t,n){"use strict";function r(e,t,n){var r=e,i=void 0===r[n];i&&null!=t&&(r[n]=t)}function i(e){if(null==e)return e;var t={};return o(e,r,t),t}var o=n(411);n(325);e.exports=i},function(e,t){"use strict";function n(e,t){if(e===t)return!0;if("object"!=typeof e||null===e||"object"!=typeof t||null===t)return!1;var n=Object.keys(e),i=Object.keys(t);if(n.length!==i.length)return!1;for(var o=r.bind(t),a=0;a<n.length;a++)if(!o(n[a])||e[n[a]]!==t[n[a]])return!1;return!0}var r=Object.prototype.hasOwnProperty;e.exports=n},function(e,t,n){"use strict";function r(e){var t=p.getID(e),n=d.getReactRootIDFromNodeID(t),r=p.findReactContainerForID(n),i=p.getFirstReactDOM(r);return i}function i(e,t){this.topLevelType=e,this.nativeEvent=t,this.ancestors=[]}function o(e){a(e)}function a(e){for(var t=p.getFirstReactDOM(v(e.nativeEvent))||window,n=t;n;)e.ancestors.push(n),n=r(n);for(var i=0;i<e.ancestors.length;i++){t=e.ancestors[i];var o=p.getID(t)||"";g._handleTopLevel(e.topLevelType,t,o,e.nativeEvent,v(e.nativeEvent))}}function s(e){var t=y(window);e(t)}var u=n(419),l=n(309),c=n(356),d=n(345),p=n(328),f=n(354),h=n(339),v=n(381),y=n(420);h(i.prototype,{destructor:function(){this.topLevelType=null,this.nativeEvent=null,this.ancestors.length=0}}),c.addPoolingTo(i,c.twoArgumentPooler);var g={_enabled:!0,_handleTopLevel:null,WINDOW_HANDLE:l.canUseDOM?window:null,setHandleTopLevel:function(e){g._handleTopLevel=e},setEnabled:function(e){g._enabled=!!e},isEnabled:function(){return g._enabled},trapBubbledEvent:function(e,t,n){var r=n;return r?u.listen(r,t,g.dispatchEvent.bind(null,e)):null},trapCapturedEvent:function(e,t,n){var r=n;return r?u.capture(r,t,g.dispatchEvent.bind(null,e)):null},monitorScrollValue:function(e){var t=s.bind(null,e);u.listen(window,"scroll",t)},dispatchEvent:function(e,t){if(g._enabled){var n=i.getPooled(e,t);try{f.batchedUpdates(o,n)}finally{i.release(n)}}}};e.exports=g},function(e,t,n){"use strict";var r=n(315),i={listen:function(e,t,n){return e.addEventListener?(e.addEventListener(t,n,!1),{remove:function(){e.removeEventListener(t,n,!1)}}):e.attachEvent?(e.attachEvent("on"+t,n),{remove:function(){e.detachEvent("on"+t,n)}}):void 0},capture:function(e,t,n){return e.addEventListener?(e.addEventListener(t,n,!0),{remove:function(){e.removeEventListener(t,n,!0)}}):{remove:r}},registerDefault:function(){}};e.exports=i},function(e,t){"use strict";function n(e){return e===window?{x:window.pageXOffset||document.documentElement.scrollLeft,y:window.pageYOffset||document.documentElement.scrollTop}:{x:e.scrollLeft,y:e.scrollTop}}e.exports=n},function(e,t,n){"use strict";var r=n(323),i=n(331),o=n(364),a=n(422),s=n(368),u=n(329),l=n(369),c=n(318),d=n(346),p=n(354),f={Component:o.injection,Class:a.injection,DOMProperty:r.injection,EmptyComponent:s.injection,EventPluginHub:i.injection,EventEmitter:u.injection,NativeComponent:l.injection,Perf:c.injection,RootIndex:d.injection,Updates:p.injection};e.exports=f},function(e,t,n){"use strict";function r(e,t){var n=b.hasOwnProperty(t)?b[t]:null;M.hasOwnProperty(t)&&(n!==A.OVERRIDE_BASE?y(!1):void 0),e.hasOwnProperty(t)&&(n!==A.DEFINE_MANY&&n!==A.DEFINE_MANY_MERGED?y(!1):void 0)}function i(e,t){if(t){"function"==typeof t?y(!1):void 0,p.isValidElement(t)?y(!1):void 0;var n=e.prototype;t.hasOwnProperty(_)&&S.mixins(e,t.mixins);for(var i in t)if(t.hasOwnProperty(i)&&i!==_){var o=t[i];if(r(n,i),S.hasOwnProperty(i))S[i](e,o);else{var a=b.hasOwnProperty(i),l=n.hasOwnProperty(i),c="function"==typeof o,d=c&&!a&&!l&&t.autobind!==!1;if(d)n.__reactAutoBindMap||(n.__reactAutoBindMap={}),n.__reactAutoBindMap[i]=o,n[i]=o;else if(l){var f=b[i];!a||f!==A.DEFINE_MANY_MERGED&&f!==A.DEFINE_MANY?y(!1):void 0,f===A.DEFINE_MANY_MERGED?n[i]=s(n[i],o):f===A.DEFINE_MANY&&(n[i]=u(n[i],o))}else n[i]=o}}}}function o(e,t){if(t)for(var n in t){var r=t[n];if(t.hasOwnProperty(n)){var i=n in S;i?y(!1):void 0;var o=n in e;o?y(!1):void 0,e[n]=r}}}function a(e,t){e&&t&&"object"==typeof e&&"object"==typeof t?void 0:y(!1);for(var n in t)t.hasOwnProperty(n)&&(void 0!==e[n]?y(!1):void 0,e[n]=t[n]);return e}function s(e,t){return function(){var n=e.apply(this,arguments),r=t.apply(this,arguments);if(null==n)return r;if(null==r)return n;var i={};return a(i,n),a(i,r),i}}function u(e,t){return function(){e.apply(this,arguments),t.apply(this,arguments)}}function l(e,t){var n=t.bind(e);return n}function c(e){for(var t in e.__reactAutoBindMap)if(e.__reactAutoBindMap.hasOwnProperty(t)){var n=e.__reactAutoBindMap[t];e[t]=l(e,n)}}var d=n(423),p=n(342),f=(n(365),n(366),n(424)),h=n(339),v=n(358),y=n(313),g=n(317),m=n(379),_=(n(325),m({mixins:null})),A=g({DEFINE_ONCE:null,DEFINE_MANY:null,OVERRIDE_BASE:null,DEFINE_MANY_MERGED:null}),C=[],b={mixins:A.DEFINE_MANY,statics:A.DEFINE_MANY,propTypes:A.DEFINE_MANY,contextTypes:A.DEFINE_MANY,childContextTypes:A.DEFINE_MANY,getDefaultProps:A.DEFINE_MANY_MERGED,getInitialState:A.DEFINE_MANY_MERGED,getChildContext:A.DEFINE_MANY_MERGED,render:A.DEFINE_ONCE,componentWillMount:A.DEFINE_MANY,componentDidMount:A.DEFINE_MANY,componentWillReceiveProps:A.DEFINE_MANY,shouldComponentUpdate:A.DEFINE_ONCE,componentWillUpdate:A.DEFINE_MANY,componentDidUpdate:A.DEFINE_MANY,componentWillUnmount:A.DEFINE_MANY,updateComponent:A.OVERRIDE_BASE},S={displayName:function(e,t){e.displayName=t},mixins:function(e,t){if(t)for(var n=0;n<t.length;n++)i(e,t[n])},childContextTypes:function(e,t){e.childContextTypes=h({},e.childContextTypes,t)},contextTypes:function(e,t){e.contextTypes=h({},e.contextTypes,t)},getDefaultProps:function(e,t){e.getDefaultProps?e.getDefaultProps=s(e.getDefaultProps,t):e.getDefaultProps=t},propTypes:function(e,t){e.propTypes=h({},e.propTypes,t)},statics:function(e,t){o(e,t)},autobind:function(){}},M={replaceState:function(e,t){this.updater.enqueueReplaceState(this,e),t&&this.updater.enqueueCallback(this,t)},isMounted:function(){return this.updater.isMounted(this)},setProps:function(e,t){this.updater.enqueueSetProps(this,e),t&&this.updater.enqueueCallback(this,t)},replaceProps:function(e,t){this.updater.enqueueReplaceProps(this,e),t&&this.updater.enqueueCallback(this,t)}},T=function(){};h(T.prototype,d.prototype,M);var E={createClass:function(e){var t=function(e,t,n){this.__reactAutoBindMap&&c(this),this.props=e,this.context=t,this.refs=v,this.updater=n||f,this.state=null;var r=this.getInitialState?this.getInitialState():null;"object"!=typeof r||Array.isArray(r)?y(!1):void 0,this.state=r};t.prototype=new T,t.prototype.constructor=t,C.forEach(i.bind(null,t)),i(t,e),t.getDefaultProps&&(t.defaultProps=t.getDefaultProps()),t.prototype.render?void 0:y(!1);for(var n in b)t.prototype[n]||(t.prototype[n]=null);return t},injection:{injectMixin:function(e){C.push(e)}}};e.exports=E},function(e,t,n){"use strict";function r(e,t,n){this.props=e,this.context=t,this.refs=o,this.updater=n||i}var i=n(424),o=(n(343),n(358)),a=n(313);n(325);r.prototype.isReactComponent={},r.prototype.setState=function(e,t){"object"!=typeof e&&"function"!=typeof e&&null!=e?a(!1):void 0,this.updater.enqueueSetState(this,e),t&&this.updater.enqueueCallback(this,t)},r.prototype.forceUpdate=function(e){this.updater.enqueueForceUpdate(this),e&&this.updater.enqueueCallback(this,e)};e.exports=r},function(e,t,n){"use strict";function r(e,t){}var i=(n(325),{isMounted:function(e){return!1},enqueueCallback:function(e,t){},enqueueForceUpdate:function(e){r(e,"forceUpdate")},enqueueReplaceState:function(e,t){r(e,"replaceState")},enqueueSetState:function(e,t){r(e,"setState")},enqueueSetProps:function(e,t){r(e,"setProps")},enqueueReplaceProps:function(e,t){r(e,"replaceProps")}});e.exports=i},function(e,t,n){"use strict";function r(e){this.reinitializeTransaction(),this.renderToStaticMarkup=!1,this.reactMountReady=i.getPooled(null),this.useCreateElement=!e&&s.useCreateElement}var i=n(355),o=n(356),a=n(329),s=n(341),u=n(426),l=n(357),c=n(339),d={initialize:u.getSelectionInformation,close:u.restoreSelection},p={initialize:function(){var e=a.isEnabled();return a.setEnabled(!1),e},close:function(e){a.setEnabled(e)}},f={initialize:function(){this.reactMountReady.reset()},close:function(){this.reactMountReady.notifyAll()}},h=[d,p,f],v={getTransactionWrappers:function(){return h},getReactMountReady:function(){return this.reactMountReady},destructor:function(){i.release(this.reactMountReady),this.reactMountReady=null}};c(r.prototype,l.Mixin,v),o.addPoolingTo(r),e.exports=r},function(e,t,n){"use strict";function r(e){return o(document.documentElement,e)}var i=n(427),o=n(359),a=n(395),s=n(429),u={hasSelectionCapabilities:function(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return t&&("input"===t&&"text"===e.type||"textarea"===t||"true"===e.contentEditable)},getSelectionInformation:function(){var e=s();return{focusedElem:e,selectionRange:u.hasSelectionCapabilities(e)?u.getSelection(e):null}},restoreSelection:function(e){var t=s(),n=e.focusedElem,i=e.selectionRange;t!==n&&r(n)&&(u.hasSelectionCapabilities(n)&&u.setSelection(n,i),a(n))},getSelection:function(e){var t;if("selectionStart"in e)t={start:e.selectionStart,end:e.selectionEnd};else if(document.selection&&e.nodeName&&"input"===e.nodeName.toLowerCase()){var n=document.selection.createRange();n.parentElement()===e&&(t={start:-n.moveStart("character",-e.value.length),end:-n.moveEnd("character",-e.value.length)})}else t=i.getOffsets(e);return t||{start:0,end:0}},setSelection:function(e,t){var n=t.start,r=t.end;if("undefined"==typeof r&&(r=n),"selectionStart"in e)e.selectionStart=n,e.selectionEnd=Math.min(r,e.value.length);else if(document.selection&&e.nodeName&&"input"===e.nodeName.toLowerCase()){var o=e.createTextRange();o.collapse(!0),o.moveStart("character",n),o.moveEnd("character",r-n),o.select()}else i.setOffsets(e,t)}};e.exports=u},function(e,t,n){"use strict";function r(e,t,n,r){return e===n&&t===r}function i(e){var t=document.selection,n=t.createRange(),r=n.text.length,i=n.duplicate();i.moveToElementText(e),i.setEndPoint("EndToStart",n);var o=i.text.length,a=o+r;return{start:o,end:a}}function o(e){var t=window.getSelection&&window.getSelection();if(!t||0===t.rangeCount)return null;var n=t.anchorNode,i=t.anchorOffset,o=t.focusNode,a=t.focusOffset,s=t.getRangeAt(0);try{s.startContainer.nodeType,s.endContainer.nodeType}catch(u){return null}var l=r(t.anchorNode,t.anchorOffset,t.focusNode,t.focusOffset),c=l?0:s.toString().length,d=s.cloneRange();d.selectNodeContents(e),d.setEnd(s.startContainer,s.startOffset);var p=r(d.startContainer,d.startOffset,d.endContainer,d.endOffset),f=p?0:d.toString().length,h=f+c,v=document.createRange();v.setStart(n,i),v.setEnd(o,a);var y=v.collapsed;return{start:y?h:f,end:y?f:h}}function a(e,t){var n,r,i=document.selection.createRange().duplicate();"undefined"==typeof t.end?(n=t.start,r=n):t.start>t.end?(n=t.end,r=t.start):(n=t.start,r=t.end),i.moveToElementText(e),i.moveStart("character",n),i.setEndPoint("EndToStart",i),i.moveEnd("character",r-n),i.select()}function s(e,t){if(window.getSelection){var n=window.getSelection(),r=e[c()].length,i=Math.min(t.start,r),o="undefined"==typeof t.end?i:Math.min(t.end,r);if(!n.extend&&i>o){var a=o;o=i,i=a}var s=l(e,i),u=l(e,o);if(s&&u){var d=document.createRange();d.setStart(s.node,s.offset),n.removeAllRanges(),i>o?(n.addRange(d),n.extend(u.node,u.offset)):(d.setEnd(u.node,u.offset),n.addRange(d))}}}var u=n(309),l=n(428),c=n(375),d=u.canUseDOM&&"selection"in document&&!("getSelection"in window),p={getOffsets:d?i:o,setOffsets:d?a:s};e.exports=p},function(e,t){"use strict";function n(e){for(;e&&e.firstChild;)e=e.firstChild;return e}function r(e){for(;e;){if(e.nextSibling)return e.nextSibling;e=e.parentNode}}function i(e,t){for(var i=n(e),o=0,a=0;i;){if(3===i.nodeType){if(a=o+i.textContent.length,t>=o&&a>=t)return{node:i,offset:t-o};o=a}i=n(r(i))}}e.exports=i},function(e,t){"use strict";function n(){if("undefined"==typeof document)return null;try{return document.activeElement||document.body}catch(e){return document.body}}e.exports=n},function(e,t,n){"use strict";function r(e){if("selectionStart"in e&&u.hasSelectionCapabilities(e))return{start:e.selectionStart,end:e.selectionEnd};if(window.getSelection){var t=window.getSelection();return{anchorNode:t.anchorNode,anchorOffset:t.anchorOffset,focusNode:t.focusNode,focusOffset:t.focusOffset}}if(document.selection){var n=document.selection.createRange();return{parentElement:n.parentElement(),text:n.text,top:n.boundingTop,left:n.boundingLeft}}}function i(e,t){if(A||null==g||g!==c())return null;var n=r(g);if(!_||!f(_,n)){_=n;var i=l.getPooled(y.select,m,e,t);return i.type="select",i.target=g,a.accumulateTwoPhaseDispatches(i),i}return null}var o=n(330),a=n(373),s=n(309),u=n(426),l=n(377),c=n(429),d=n(382),p=n(379),f=n(417),h=o.topLevelTypes,v=s.canUseDOM&&"documentMode"in document&&document.documentMode<=11,y={select:{phasedRegistrationNames:{bubbled:p({onSelect:null}),captured:p({onSelectCapture:null})},dependencies:[h.topBlur,h.topContextMenu,h.topFocus,h.topKeyDown,h.topMouseDown,h.topMouseUp,h.topSelectionChange]}},g=null,m=null,_=null,A=!1,C=!1,b=p({onSelect:null}),S={eventTypes:y,extractEvents:function(e,t,n,r,o){if(!C)return null;switch(e){case h.topFocus:(d(t)||"true"===t.contentEditable)&&(g=t,m=n,_=null);break;case h.topBlur:g=null,m=null,_=null;break;case h.topMouseDown:A=!0;break;case h.topContextMenu:case h.topMouseUp:return A=!1,i(r,o);case h.topSelectionChange:if(v)break;case h.topKeyDown:case h.topKeyUp:return i(r,o)}return null},didPutListener:function(e,t,n){t===b&&(C=!0)}};e.exports=S},function(e,t){"use strict";var n=Math.pow(2,53),r={createReactRootIndex:function(){return Math.ceil(Math.random()*n)}};e.exports=r},function(e,t,n){"use strict";var r=n(330),i=n(419),o=n(373),a=n(328),s=n(433),u=n(377),l=n(434),c=n(435),d=n(386),p=n(438),f=n(439),h=n(387),v=n(440),y=n(315),g=n(436),m=n(313),_=n(379),A=r.topLevelTypes,C={abort:{phasedRegistrationNames:{bubbled:_({onAbort:!0}),captured:_({onAbortCapture:!0})}},blur:{phasedRegistrationNames:{bubbled:_({onBlur:!0}),captured:_({onBlurCapture:!0})}},canPlay:{phasedRegistrationNames:{bubbled:_({onCanPlay:!0}),captured:_({onCanPlayCapture:!0})}},canPlayThrough:{phasedRegistrationNames:{bubbled:_({onCanPlayThrough:!0}),captured:_({onCanPlayThroughCapture:!0})}},click:{phasedRegistrationNames:{bubbled:_({onClick:!0}),captured:_({onClickCapture:!0})}},contextMenu:{phasedRegistrationNames:{bubbled:_({onContextMenu:!0}),captured:_({onContextMenuCapture:!0})}},copy:{phasedRegistrationNames:{bubbled:_({onCopy:!0}),captured:_({onCopyCapture:!0})}},cut:{phasedRegistrationNames:{bubbled:_({onCut:!0}),captured:_({onCutCapture:!0})}},doubleClick:{phasedRegistrationNames:{bubbled:_({onDoubleClick:!0}),captured:_({onDoubleClickCapture:!0})}},drag:{phasedRegistrationNames:{bubbled:_({onDrag:!0}),captured:_({onDragCapture:!0})}},dragEnd:{phasedRegistrationNames:{bubbled:_({onDragEnd:!0}),captured:_({onDragEndCapture:!0})}},dragEnter:{phasedRegistrationNames:{bubbled:_({onDragEnter:!0}),captured:_({onDragEnterCapture:!0})}},dragExit:{phasedRegistrationNames:{bubbled:_({onDragExit:!0}),captured:_({onDragExitCapture:!0})}},dragLeave:{phasedRegistrationNames:{bubbled:_({onDragLeave:!0}),captured:_({onDragLeaveCapture:!0})}},dragOver:{phasedRegistrationNames:{bubbled:_({onDragOver:!0}),captured:_({onDragOverCapture:!0})}},dragStart:{phasedRegistrationNames:{bubbled:_({onDragStart:!0}),captured:_({onDragStartCapture:!0})}},drop:{phasedRegistrationNames:{bubbled:_({onDrop:!0}),captured:_({onDropCapture:!0})}},durationChange:{phasedRegistrationNames:{bubbled:_({onDurationChange:!0}),captured:_({onDurationChangeCapture:!0})}},emptied:{phasedRegistrationNames:{bubbled:_({onEmptied:!0}),captured:_({onEmptiedCapture:!0})}},encrypted:{phasedRegistrationNames:{bubbled:_({onEncrypted:!0}),captured:_({onEncryptedCapture:!0})}},ended:{phasedRegistrationNames:{bubbled:_({onEnded:!0}),captured:_({onEndedCapture:!0})}},error:{phasedRegistrationNames:{bubbled:_({onError:!0}),captured:_({onErrorCapture:!0})}},focus:{phasedRegistrationNames:{bubbled:_({onFocus:!0}),captured:_({onFocusCapture:!0})}},input:{phasedRegistrationNames:{bubbled:_({onInput:!0}),captured:_({onInputCapture:!0})}},keyDown:{phasedRegistrationNames:{bubbled:_({onKeyDown:!0}),captured:_({onKeyDownCapture:!0})}},keyPress:{phasedRegistrationNames:{bubbled:_({onKeyPress:!0}),captured:_({onKeyPressCapture:!0})}},keyUp:{phasedRegistrationNames:{bubbled:_({onKeyUp:!0}),captured:_({onKeyUpCapture:!0})}},load:{phasedRegistrationNames:{bubbled:_({onLoad:!0}),captured:_({onLoadCapture:!0})}},loadedData:{phasedRegistrationNames:{bubbled:_({onLoadedData:!0}),captured:_({onLoadedDataCapture:!0})}},loadedMetadata:{phasedRegistrationNames:{bubbled:_({onLoadedMetadata:!0}),captured:_({onLoadedMetadataCapture:!0})}},loadStart:{phasedRegistrationNames:{bubbled:_({onLoadStart:!0}),captured:_({onLoadStartCapture:!0})}},mouseDown:{phasedRegistrationNames:{bubbled:_({onMouseDown:!0}),captured:_({onMouseDownCapture:!0})}},mouseMove:{phasedRegistrationNames:{bubbled:_({onMouseMove:!0}),captured:_({onMouseMoveCapture:!0})}},mouseOut:{phasedRegistrationNames:{bubbled:_({onMouseOut:!0}),captured:_({onMouseOutCapture:!0})}},mouseOver:{phasedRegistrationNames:{bubbled:_({onMouseOver:!0}),captured:_({onMouseOverCapture:!0})}},mouseUp:{phasedRegistrationNames:{bubbled:_({onMouseUp:!0}),captured:_({onMouseUpCapture:!0})}},paste:{phasedRegistrationNames:{bubbled:_({onPaste:!0}),captured:_({onPasteCapture:!0})}},pause:{phasedRegistrationNames:{bubbled:_({onPause:!0}),captured:_({onPauseCapture:!0})}},play:{phasedRegistrationNames:{bubbled:_({onPlay:!0}),captured:_({onPlayCapture:!0})}},playing:{phasedRegistrationNames:{bubbled:_({onPlaying:!0}),captured:_({onPlayingCapture:!0})}},progress:{phasedRegistrationNames:{bubbled:_({onProgress:!0}),captured:_({onProgressCapture:!0})}},rateChange:{phasedRegistrationNames:{bubbled:_({onRateChange:!0}),captured:_({onRateChangeCapture:!0})}},reset:{phasedRegistrationNames:{bubbled:_({onReset:!0}),captured:_({onResetCapture:!0})}},scroll:{phasedRegistrationNames:{bubbled:_({onScroll:!0}),captured:_({onScrollCapture:!0})}},seeked:{phasedRegistrationNames:{bubbled:_({onSeeked:!0}),captured:_({onSeekedCapture:!0})}},seeking:{phasedRegistrationNames:{bubbled:_({onSeeking:!0}),captured:_({onSeekingCapture:!0})}},stalled:{phasedRegistrationNames:{bubbled:_({onStalled:!0}),captured:_({onStalledCapture:!0})}},submit:{phasedRegistrationNames:{bubbled:_({onSubmit:!0}),captured:_({onSubmitCapture:!0})}},suspend:{phasedRegistrationNames:{bubbled:_({onSuspend:!0}),captured:_({onSuspendCapture:!0})}},timeUpdate:{phasedRegistrationNames:{bubbled:_({onTimeUpdate:!0}),captured:_({onTimeUpdateCapture:!0})}},touchCancel:{phasedRegistrationNames:{bubbled:_({onTouchCancel:!0}),captured:_({onTouchCancelCapture:!0})}},touchEnd:{phasedRegistrationNames:{bubbled:_({onTouchEnd:!0}),captured:_({onTouchEndCapture:!0})}},touchMove:{phasedRegistrationNames:{bubbled:_({onTouchMove:!0}),captured:_({onTouchMoveCapture:!0})}},touchStart:{phasedRegistrationNames:{bubbled:_({onTouchStart:!0}),captured:_({onTouchStartCapture:!0})}},volumeChange:{phasedRegistrationNames:{bubbled:_({onVolumeChange:!0}),captured:_({onVolumeChangeCapture:!0})}},waiting:{phasedRegistrationNames:{bubbled:_({onWaiting:!0}),captured:_({onWaitingCapture:!0})}},wheel:{phasedRegistrationNames:{bubbled:_({onWheel:!0}),captured:_({onWheelCapture:!0})}}},b={topAbort:C.abort,topBlur:C.blur,topCanPlay:C.canPlay,topCanPlayThrough:C.canPlayThrough,topClick:C.click,topContextMenu:C.contextMenu,topCopy:C.copy,topCut:C.cut,topDoubleClick:C.doubleClick,topDrag:C.drag,topDragEnd:C.dragEnd,topDragEnter:C.dragEnter,topDragExit:C.dragExit,topDragLeave:C.dragLeave,topDragOver:C.dragOver,topDragStart:C.dragStart,topDrop:C.drop,topDurationChange:C.durationChange,topEmptied:C.emptied,topEncrypted:C.encrypted,topEnded:C.ended,topError:C.error,topFocus:C.focus,topInput:C.input,topKeyDown:C.keyDown,topKeyPress:C.keyPress,topKeyUp:C.keyUp,topLoad:C.load,topLoadedData:C.loadedData,topLoadedMetadata:C.loadedMetadata,topLoadStart:C.loadStart,topMouseDown:C.mouseDown,topMouseMove:C.mouseMove,topMouseOut:C.mouseOut,topMouseOver:C.mouseOver,topMouseUp:C.mouseUp,topPaste:C.paste,topPause:C.pause,topPlay:C.play,topPlaying:C.playing,topProgress:C.progress,topRateChange:C.rateChange,topReset:C.reset,topScroll:C.scroll,topSeeked:C.seeked,topSeeking:C.seeking,topStalled:C.stalled,topSubmit:C.submit,topSuspend:C.suspend,topTimeUpdate:C.timeUpdate,topTouchCancel:C.touchCancel,topTouchEnd:C.touchEnd,topTouchMove:C.touchMove,topTouchStart:C.touchStart,topVolumeChange:C.volumeChange,topWaiting:C.waiting,topWheel:C.wheel};for(var S in b)b[S].dependencies=[S];var M=_({onClick:null}),T={},E={eventTypes:C,extractEvents:function(e,t,n,r,i){var a=b[e];if(!a)return null;var y;switch(e){case A.topAbort:case A.topCanPlay:case A.topCanPlayThrough:case A.topDurationChange:case A.topEmptied:case A.topEncrypted:case A.topEnded:case A.topError:case A.topInput:case A.topLoad:case A.topLoadedData:case A.topLoadedMetadata:case A.topLoadStart:case A.topPause:case A.topPlay:case A.topPlaying:case A.topProgress:case A.topRateChange:case A.topReset:case A.topSeeked:case A.topSeeking:case A.topStalled:case A.topSubmit:case A.topSuspend:case A.topTimeUpdate:case A.topVolumeChange:case A.topWaiting:y=u;break;case A.topKeyPress:if(0===g(r))return null;case A.topKeyDown:case A.topKeyUp:y=c;break;case A.topBlur:case A.topFocus:y=l;break;case A.topClick:if(2===r.button)return null;case A.topContextMenu:case A.topDoubleClick:case A.topMouseDown:case A.topMouseMove:case A.topMouseOut:case A.topMouseOver:case A.topMouseUp:y=d;break;case A.topDrag:case A.topDragEnd:case A.topDragEnter:case A.topDragExit:case A.topDragLeave:case A.topDragOver:case A.topDragStart:case A.topDrop:y=p;break;case A.topTouchCancel:case A.topTouchEnd:case A.topTouchMove:case A.topTouchStart:y=f;break;case A.topScroll:y=h;break;case A.topWheel:y=v;break;case A.topCopy:case A.topCut:case A.topPaste:y=s}y?void 0:m(!1);var _=y.getPooled(a,n,r,i);return o.accumulateTwoPhaseDispatches(_),_},didPutListener:function(e,t,n){if(t===M){var r=a.getNode(e);T[e]||(T[e]=i.listen(r,"click",y))}},willDeleteListener:function(e,t){t===M&&(T[e].remove(),delete T[e])}};e.exports=E},function(e,t,n){"use strict";function r(e,t,n,r){i.call(this,e,t,n,r)}var i=n(377),o={clipboardData:function(e){return"clipboardData"in e?e.clipboardData:window.clipboardData}};i.augmentClass(r,o),e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r){i.call(this,e,t,n,r)}var i=n(387),o={relatedTarget:null};i.augmentClass(r,o),e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r){i.call(this,e,t,n,r)}var i=n(387),o=n(436),a=n(437),s=n(388),u={key:a,location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:s,charCode:function(e){return"keypress"===e.type?o(e):0},keyCode:function(e){return"keydown"===e.type||"keyup"===e.type?e.keyCode:0;
},which:function(e){return"keypress"===e.type?o(e):"keydown"===e.type||"keyup"===e.type?e.keyCode:0}};i.augmentClass(r,u),e.exports=r},function(e,t){"use strict";function n(e){var t,n=e.keyCode;return"charCode"in e?(t=e.charCode,0===t&&13===n&&(t=13)):t=n,t>=32||13===t?t:0}e.exports=n},function(e,t,n){"use strict";function r(e){if(e.key){var t=o[e.key]||e.key;if("Unidentified"!==t)return t}if("keypress"===e.type){var n=i(e);return 13===n?"Enter":String.fromCharCode(n)}return"keydown"===e.type||"keyup"===e.type?a[e.keyCode]||"Unidentified":""}var i=n(436),o={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},a={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r){i.call(this,e,t,n,r)}var i=n(386),o={dataTransfer:null};i.augmentClass(r,o),e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r){i.call(this,e,t,n,r)}var i=n(387),o=n(388),a={touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:o};i.augmentClass(r,a),e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r){i.call(this,e,t,n,r)}var i=n(386),o={deltaX:function(e){return"deltaX"in e?e.deltaX:"wheelDeltaX"in e?-e.wheelDeltaX:0},deltaY:function(e){return"deltaY"in e?e.deltaY:"wheelDeltaY"in e?-e.wheelDeltaY:"wheelDelta"in e?-e.wheelDelta:0},deltaZ:null,deltaMode:null};i.augmentClass(r,o),e.exports=r},function(e,t,n){"use strict";var r=n(323),i=r.injection.MUST_USE_ATTRIBUTE,o={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},a={Properties:{clipPath:i,cx:i,cy:i,d:i,dx:i,dy:i,fill:i,fillOpacity:i,fontFamily:i,fontSize:i,fx:i,fy:i,gradientTransform:i,gradientUnits:i,markerEnd:i,markerMid:i,markerStart:i,offset:i,opacity:i,patternContentUnits:i,patternUnits:i,points:i,preserveAspectRatio:i,r:i,rx:i,ry:i,spreadMethod:i,stopColor:i,stopOpacity:i,stroke:i,strokeDasharray:i,strokeLinecap:i,strokeOpacity:i,strokeWidth:i,textAnchor:i,transform:i,version:i,viewBox:i,x1:i,x2:i,x:i,xlinkActuate:i,xlinkArcrole:i,xlinkHref:i,xlinkRole:i,xlinkShow:i,xlinkTitle:i,xlinkType:i,xmlBase:i,xmlLang:i,xmlSpace:i,y1:i,y2:i,y:i},DOMAttributeNamespaces:{xlinkActuate:o.xlink,xlinkArcrole:o.xlink,xlinkHref:o.xlink,xlinkRole:o.xlink,xlinkShow:o.xlink,xlinkTitle:o.xlink,xlinkType:o.xlink,xmlBase:o.xml,xmlLang:o.xml,xmlSpace:o.xml},DOMAttributeNames:{clipPath:"clip-path",fillOpacity:"fill-opacity",fontFamily:"font-family",fontSize:"font-size",gradientTransform:"gradientTransform",gradientUnits:"gradientUnits",markerEnd:"marker-end",markerMid:"marker-mid",markerStart:"marker-start",patternContentUnits:"patternContentUnits",patternUnits:"patternUnits",preserveAspectRatio:"preserveAspectRatio",spreadMethod:"spreadMethod",stopColor:"stop-color",stopOpacity:"stop-opacity",strokeDasharray:"stroke-dasharray",strokeLinecap:"stroke-linecap",strokeOpacity:"stroke-opacity",strokeWidth:"stroke-width",textAnchor:"text-anchor",viewBox:"viewBox",xlinkActuate:"xlink:actuate",xlinkArcrole:"xlink:arcrole",xlinkHref:"xlink:href",xlinkRole:"xlink:role",xlinkShow:"xlink:show",xlinkTitle:"xlink:title",xlinkType:"xlink:type",xmlBase:"xml:base",xmlLang:"xml:lang",xmlSpace:"xml:space"}};e.exports=a},function(e,t){"use strict";e.exports="0.14.7"},function(e,t,n){"use strict";var r=n(328);e.exports=r.renderSubtreeIntoContainer},function(e,t,n){"use strict";var r=n(371),i=n(445),o=n(442);r.inject();var a={renderToString:i.renderToString,renderToStaticMarkup:i.renderToStaticMarkup,version:o};e.exports=a},function(e,t,n){"use strict";function r(e){a.isValidElement(e)?void 0:h(!1);var t;try{d.injection.injectBatchingStrategy(l);var n=s.createReactRootID();return t=c.getPooled(!1),t.perform(function(){var r=f(e,null),i=r.mountComponent(n,t,p);return u.addChecksumToMarkup(i)},null)}finally{c.release(t),d.injection.injectBatchingStrategy(o)}}function i(e){a.isValidElement(e)?void 0:h(!1);var t;try{d.injection.injectBatchingStrategy(l);var n=s.createReactRootID();return t=c.getPooled(!0),t.perform(function(){var r=f(e,null);return r.mountComponent(n,t,p)},null)}finally{c.release(t),d.injection.injectBatchingStrategy(o)}}var o=n(392),a=n(342),s=n(345),u=n(348),l=n(446),c=n(447),d=n(354),p=n(358),f=n(362),h=n(313);e.exports={renderToString:r,renderToStaticMarkup:i}},function(e,t){"use strict";var n={isBatchingUpdates:!1,batchedUpdates:function(e){}};e.exports=n},function(e,t,n){"use strict";function r(e){this.reinitializeTransaction(),this.renderToStaticMarkup=e,this.reactMountReady=o.getPooled(null),this.useCreateElement=!1}var i=n(356),o=n(355),a=n(357),s=n(339),u=n(315),l={initialize:function(){this.reactMountReady.reset()},close:u},c=[l],d={getTransactionWrappers:function(){return c},getReactMountReady:function(){return this.reactMountReady},destructor:function(){o.release(this.reactMountReady),this.reactMountReady=null}};s(r.prototype,a.Mixin,d),i.addPoolingTo(r),e.exports=r},function(e,t,n){"use strict";var r=n(410),i=n(423),o=n(422),a=n(449),s=n(342),u=(n(450),n(407)),l=n(442),c=n(339),d=n(452),p=s.createElement,f=s.createFactory,h=s.cloneElement,v={Children:{map:r.map,forEach:r.forEach,count:r.count,toArray:r.toArray,only:d},Component:i,createElement:p,cloneElement:h,isValidElement:s.isValidElement,PropTypes:u,createClass:o.createClass,createFactory:f,createMixin:function(e){return e},DOM:a,version:l,__spread:c};e.exports=v},function(e,t,n){"use strict";function r(e){return i.createFactory(e)}var i=n(342),o=(n(450),n(451)),a=o({a:"a",abbr:"abbr",address:"address",area:"area",article:"article",aside:"aside",audio:"audio",b:"b",base:"base",bdi:"bdi",bdo:"bdo",big:"big",blockquote:"blockquote",body:"body",br:"br",button:"button",canvas:"canvas",caption:"caption",cite:"cite",code:"code",col:"col",colgroup:"colgroup",data:"data",datalist:"datalist",dd:"dd",del:"del",details:"details",dfn:"dfn",dialog:"dialog",div:"div",dl:"dl",dt:"dt",em:"em",embed:"embed",fieldset:"fieldset",figcaption:"figcaption",figure:"figure",footer:"footer",form:"form",h1:"h1",h2:"h2",h3:"h3",h4:"h4",h5:"h5",h6:"h6",head:"head",header:"header",hgroup:"hgroup",hr:"hr",html:"html",i:"i",iframe:"iframe",img:"img",input:"input",ins:"ins",kbd:"kbd",keygen:"keygen",label:"label",legend:"legend",li:"li",link:"link",main:"main",map:"map",mark:"mark",menu:"menu",menuitem:"menuitem",meta:"meta",meter:"meter",nav:"nav",noscript:"noscript",object:"object",ol:"ol",optgroup:"optgroup",option:"option",output:"output",p:"p",param:"param",picture:"picture",pre:"pre",progress:"progress",q:"q",rp:"rp",rt:"rt",ruby:"ruby",s:"s",samp:"samp",script:"script",section:"section",select:"select",small:"small",source:"source",span:"span",strong:"strong",style:"style",sub:"sub",summary:"summary",sup:"sup",table:"table",tbody:"tbody",td:"td",textarea:"textarea",tfoot:"tfoot",th:"th",thead:"thead",time:"time",title:"title",tr:"tr",track:"track",u:"u",ul:"ul","var":"var",video:"video",wbr:"wbr",circle:"circle",clipPath:"clipPath",defs:"defs",ellipse:"ellipse",g:"g",image:"image",line:"line",linearGradient:"linearGradient",mask:"mask",path:"path",pattern:"pattern",polygon:"polygon",polyline:"polyline",radialGradient:"radialGradient",rect:"rect",stop:"stop",svg:"svg",text:"text",tspan:"tspan"},r);e.exports=a},function(e,t,n){"use strict";function r(){if(d.current){var e=d.current.getName();if(e)return" Check the render method of `"+e+"`."}return""}function i(e,t){if(e._store&&!e._store.validated&&null==e.key){e._store.validated=!0;o("uniqueKey",e,t)}}function o(e,t,n){var i=r();if(!i){var o="string"==typeof n?n:n.displayName||n.name;o&&(i=" Check the top-level render call using <"+o+">.")}var a=h[e]||(h[e]={});if(a[i])return null;a[i]=!0;var s={parentOrOwner:i,url:" See https://fb.me/react-warning-keys for more information.",childOwner:null};return t&&t._owner&&t._owner!==d.current&&(s.childOwner=" It was passed a child from "+t._owner.getName()+"."),s}function a(e,t){if("object"==typeof e)if(Array.isArray(e))for(var n=0;n<e.length;n++){var r=e[n];l.isValidElement(r)&&i(r,t)}else if(l.isValidElement(e))e._store&&(e._store.validated=!0);else if(e){var o=p(e);if(o&&o!==e.entries)for(var a,s=o.call(e);!(a=s.next()).done;)l.isValidElement(a.value)&&i(a.value,t)}}function s(e,t,n,i){for(var o in t)if(t.hasOwnProperty(o)){var a;try{"function"!=typeof t[o]?f(!1):void 0,a=t[o](n,o,e,i)}catch(s){a=s}if(a instanceof Error&&!(a.message in v)){v[a.message]=!0;r()}}}function u(e){var t=e.type;if("function"==typeof t){var n=t.displayName||t.name;t.propTypes&&s(n,t.propTypes,e.props,c.prop),"function"==typeof t.getDefaultProps}}var l=n(342),c=n(365),d=(n(366),n(305)),p=(n(343),n(408)),f=n(313),h=(n(325),{}),v={},y={createElement:function(e,t,n){var r="string"==typeof e||"function"==typeof e,i=l.createElement.apply(this,arguments);if(null==i)return i;if(r)for(var o=2;o<arguments.length;o++)a(arguments[o],e);return u(i),i},createFactory:function(e){var t=y.createElement.bind(null,e);return t.type=e,t},cloneElement:function(e,t,n){for(var r=l.cloneElement.apply(this,arguments),i=2;i<arguments.length;i++)a(arguments[i],r.type);return u(r),r}};e.exports=y},function(e,t){"use strict";function n(e,t,n){if(!e)return null;var i={};for(var o in e)r.call(e,o)&&(i[o]=t.call(n,e[o],o,e));return i}var r=Object.prototype.hasOwnProperty;e.exports=n},function(e,t,n){"use strict";function r(e){return i.isValidElement(e)?void 0:o(!1),e}var i=n(342),o=n(313);e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r,i){return i}n(339),n(325);e.exports=r},function(e,t,n){"use strict";var r=n(455),i=new r;e.exports=i},function(e,t,n){function r(){this.actionsById={},this.argumentsById={},this.propGroupsById={},this.propActionsById={},this.pub=i,this.force=o,this.sub=a,this.unSub=s,this.urn=s,this.out=s,this.get=u,this.set=l,this.def=c}var i=n(456),o=n(457),a=n(458),s=n(459),u=n(460),l=n(461),c=n(462);e.exports=r},function(e,t){var n=Array.prototype.slice;e.exports=function(e){var t=this.argumentsById[e]||[],r=n.call(arguments,1);if(t.length&&t.length===r.length){for(var i=t.length;i--&&t[i]===r[i];);if(-1===i)return}this.force.apply(this,arguments)}},function(e,t){var n=Array.prototype.slice;e.exports=function(e){var t=this.argumentsById[e],r=this.argumentsById[e]=n.call(arguments,1),i=this.propGroupsById[e];if(i&&r&&r.length)for(var o,a,s,u,l=t&&t[0]||{},c=r[0],d=0,p=i.length,f=this.propActionsById[e];d!==p;)if(o=i[d]){for(s=0,u=o.length;s!==u;){if(a=o[s],"undefined"!=typeof c[a]&&l[a]!==c[a]){f[d].apply(null,r);break}s++}d++}else d++;var h=this.actionsById[e]||[];if(h.length)for(var v,y=0,g=h.length;y!==g;)v=h[y],"function"==typeof v&&v.apply(null,r),y++}},function(e,t){e.exports=function(e,t,n){var r,i=e.indexOf(":");if(-1===i){r=this.argumentsById[e];var o=this.actionsById[e]=this.actionsById[e]||[];-1===o.indexOf(t)&&(o[o.length]=t),n||"undefined"==typeof r||t.apply(null,r)}else{var a=e.substr(0,i);r=this.argumentsById[a];for(var s,u=e.substr(i+1),l=u.split(","),c=this.propGroupsById[a]||(this.propGroupsById[a]=[]),d=this.propActionsById[a]||(this.propActionsById[a]=[]),p=0,f=c.length,h=!1;p!==f;){if(s=c[p],s.join(",")===u&&d[p]===t){h=!0;break}p++}if(h||(c[c.length]=l,d[d.length]=t),!n&&"undefined"!=typeof r&&r.length){var v=r[0];for(p=0,f=l.length;p!==f;){if("undefined"!=typeof v[l[p]]){t.apply(null,r);break}p++}}}}},function(e,t){e.exports=function(e,t){var n=e.indexOf(":");if(-1===n){var r=this.actionsById[e]||[];if(r.length){var i=r.indexOf(t);-1===i||r.splice(i,1)}}else{var o=e.substr(0,n),a=e.substr(n+1),s=this.propGroupsById[o];if(s)for(var u=this.propActionsById[o]||(this.propActionsById[o]=[]),l=0,c=s.length;l!==c;)s[l].join(",")===a&&u[l]===t?(s.splice(l,1),u.splice(l,1),c--):l++}}},function(e,t){e.exports=function(e){var t=this.argumentsById[e]||[];return t.length?t[0]:null}},function(e,t){var n=Array.prototype.slice;e.exports=function(e){this.argumentsById[e]=n.call(arguments,1)}},function(e,t){var n=Array.prototype.slice;e.exports=function(e){null===this.get(e)&&(this.argumentsById[e]=n.call(arguments,1))}},function(e,t,n){var r,i=n(464),o=n(465).default,a=n(470).default,s=n(474).default,u=n(104).default,l=n(466).default,c={},d=n(475),p=n(476),f=n(478),h=n(479),v=n(498),y=n(666),g=n(688),m=(n(689),n(549)),_=n(553),A=n(644),C=n(495),b={transparent:!0},S=function(e){var t=[],n=function(e,t){return e.every(function(e){return e.tagName!==t.tagName})};return e.forEach(function(e){e.services.forEach(function(e){n(t,e)&&t.push({tag:e.tag,tagName:e.tagName})})}),t},M=function(e){var t=[],n=e.brandsByAirCompanies,r=e.brands,i=e.trips,a=e.fares;return u(n).forEach(function(e){var s=n[e].map(function(e){var t=r[e];if(t){var n=o({},t,{title:t.tagName||t.tag});return n}}),u=a.filter(function(t){return t.trips.some(function(t){return~n[e].indexOf(t.brandId)})});t.push({aircompany:e,brands:s,availableServices:S(s),trips:i,fares:u})}),t},T=function(e){function t(n,r){s(this,t),e.call(this,n,r),this.onShowModal=this.onShowModal.bind(this),this.onCloseModal=this.onCloseModal.bind(this),this.onChooseFare=this.onChooseFare.bind(this),this.handleChangeFare=this.handleChangeFare.bind(this),this.state={isHoverChooseButton:!1,isLoading:!0}}return a(t,e),t.prototype.componentWillReceiveProps=function(e){var t=e.requestParams,n=e.choosenBrand,r=e.paxInfo,i=e.srcMarker,o=this.state.fareKey;t.fareKey!==o?(this.setState({isLoading:!0,fareFamily:null}),this.getFareFamily(t,r,n,i)):void 0!=n&&this.setState({choosenFare:n})},t.prototype.componentDidMount=function(){var e=this.props,t=e.requestParams,n=e.choosenBrand,r=e.paxInfo,i=e.srcMarker;t&&this.getFareFamily(t,r,n,i)},t.prototype.postChooseFare=function(e){var t=l({seatsAvl:e.stAvl,bookPageVer:e.bookPageVer||200,autoChoose:e.autoChoose||0},e.extra,e.params);fetch("/_api/confirmation/choosefare/",{credentials:"include",method:"post",headers:{"Content-type":"application/x-www-form-urlencoded; charset=UTF-8"},body:g({params:t})})},t.prototype.getPromiseWrapper=function(e){return e.serviceClass=e.trips[0].serviceClass,"undefined"!=typeof store&&store.set("fareFamilyCurrentKey",e.fareKey),{fareKey:e.fareKey,promise:fetch("/_api/confirmation/searchFareFamilies/",{credentials:"include",method:"post",headers:{"Content-type":"application/x-www-form-urlencoded; charset=UTF-8"},body:g({params:e})}).then(function(e){return e.json()})}},t.prototype.getFareFamily=function(e,t,n,r){void 0===t&&(t={adtCount:1,cnnCount:0,infCount:0});var i=this;void 0===n&&(n=0);var a=o({},e,{paxInfo:t});this.setState({fareKey:a.fareKey}),"undefined"!=typeof tw?tw.params&&tw.params.srcmarker&&(a.srcmarker=tw.params.srcmarker):r&&(a.srcmarker=r);var s=this.getPromiseWrapper(a);s.promise.then(function(t){s.fareKey===i.state.fareKey&&(n>=t.fares.length&&(n=0),i.setState({fareFamily:t,choosenFare:n,fare:t.fares[n],isLoading:!1}),t&&t.avail&&t.fares.length>=2?i.postChooseFare({extra:{event:"ff_available",ffSearchId:t.ffSearchId},params:e}):store&&store.pub("SHOW_BAGGAGE_WARNING"))}).catch(function(e){})},t.prototype.onShowModal=function(e){e.preventDefault(),e.stopPropagation(),this.setState({isShowModal:!0}),this.postChooseFare({extra:{event:"ff_click_show",ffSearchId:this.state.fareFamily.ffSearchId},params:this.props.requestParams})},t.prototype.onCloseModal=function(){this.setState({isShowModal:!1})},t.prototype.onChooseFare=function(e){this.setState({choosenFare:e})},t.prototype.handleChangeFare=function(e){var t=this.props.onChangeFare;this.setState({fare:e,choosenFare:e.index}),t&&t(e)},t.prototype.render=function(){var e=this.state,t=e.isShowModal,n=e.fareFamily,o=e.isLoading,a=e.choosenFare,s=e.fare,u=this.props.requestParams,l=void 0,p=void 0,g=void 0;if(o&&(p=i("button",{e:"choose",m:"isDisabled"},"Загрузка...")),!n||!n.avail||n.fares.length<2)return null;var S=M(n);l=i(y,{className:n.brands.length<3?"PortalWindow--Short":"PortalWindow",onClose:this.onCloseModal,isOpen:!0,contentOptions:b},i(v,{postChooseFare:this.postChooseFare,onCloseModal:this.onCloseModal,onChooseFare:this.onChooseFare,choosenFare:a,onChangeFare:this.handleChangeFare,listBrandsByAircompany:S,requestParams:u,fareFamily:n}));var T=n.brands[n.brands.length-1],E=n.brands[m(A(_(s.trips,"brandId")))],w=E.tagName||E.tag,x=S[0].availableServices.slice(0,4),k=x.length+"Cell",I=n.brands.indexOf(E);return g=x.map(function(e,t){return i(h,{key:t,mostExpensiveBrands:T,currentBrand:E,nextBrand:n.brands[I+1],service:e})}),i("div",{b:"FareFamily",style:(r="FareFamily",c[r]||(c[r]=d(r)))},i("div",{e:"widget"},g,i("div",{e:"action",m:{actionM:k},className:"Action"+k,style:(r="FareFamily__widget__action"+(k?" FareFamily__widget__action--actionM-"+k:""),c[r]||(c[r]=d(r)))},i("div",{e:"inner",className:"inner",style:(r="FareFamily__widget__action__inner",c[r]||(c[r]=d(r)))},i("div",{e:"title",className:"title",style:(r="FareFamily__widget__action__inner__title",c[r]||(c[r]=d(r)))},C.fareFamily.selectedFare),i("div",{e:"caption",className:"caption",style:(r="FareFamily__widget__action__inner__caption",c[r]||(c[r]=d(r)))},w),i("div",{onChangeFare:this.handleChangeFare,onClick:this.onShowModal,e:"button",className:"button",style:(r="FareFamily__widget__action__inner__button",c[r]||(c[r]=d(r)))},i("span",{e:"icon",style:(r="FareFamily__widget__action__inner__button__icon",c[r]||(c[r]=d(r)))},i(f,{w:10,isLock:!1})),i("span",{className:"buttonTitle"},C.fareFamily.change)))),i("div",{e:"clear",style:(r="FareFamily__widget__clear",c[r]||(c[r]=d(r)))})),t&&l)},t}(p);T.defaultProps={modal:!1},e.exports=T},function(e,t,n){"use strict";e.exports=n(448).createElement},function(e,t,n){"use strict";var r=n(466).default;t.default=r||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},t.__esModule=!0},function(e,t,n){e.exports={"default":n(467),__esModule:!0}},function(e,t,n){n(468),e.exports=n(35).Object.assign},[725,34,469],[726,29,107,47,33],function(e,t,n){"use strict";var r=n(69).default,i=n(471).default;t.default=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=r(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(i?i(e,t):e.__proto__=t)},t.__esModule=!0},function(e,t,n){e.exports={"default":n(472),__esModule:!0}},function(e,t,n){n(473),e.exports=n(35).Object.setPrototypeOf},[727,34,81],function(e,t){"use strict";t.default=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},t.__esModule=!0},function(e,t){"use strict";var n=["backgroundColor","backgroundClip","backgroundRepeat","backgroundPosition","backgroundSize","color","margin","textAlign","padding","lineHeight","display","marginTop","borderBottom","fontSize","fontWeight","cursor","boxSizing","width","marginRight","height","overflow","verticalAlign","background","transition","textTransform","border","paddingRight","fill","fontFamily","WebkitFontFeatureSettings","MozFontFeatureSettings","fontFeatureSettings","textRendering","position","font","outline","right","top","marginBottom","maxHeight","overflowY","overflowX","boxShadow","zIndex","borderTop","borderRadius","clear","float","borderSpacing","whiteSpace","textOverflow","left","maxWidth"],r=["#283F51","content-box","no-repeat","-95px -58px","196px 174px","#fff","0 1px","#074ea6","rgba(7,78,166,0.5)","#cd1f04","rgba(205,31,4,0.5)","#000964","rgba(0,9,100,0.5)","#06396e","#fac102","rgba(6,57,110,0.5)","#f00001","rgba(240,0,1,0.5)","#791f2b","#d09d06","rgba(121,31,43,0.5)","#47998a","rgba(71,153,138,0.5)","#0427a9","rgba(4,39,169,0.5)","#b8b8b6","#475288","rgba(184,184,182,0.5)","#1b3b6a","rgba(27,59,106,0.85)","#f30100","rgba(243,1,0,0.5)","#ed1b23","rgba(237,27,35,0.5)","#003478","#d2d9e9","rgba(0,52,120,0.85)","#cc1f2f","rgba(204,31,47,0.78)","#0b0e45","#109adb","rgba(11,14,69,0.5)","#cddde9","#051039","rgba(205,221,233,0.7)","#fbf0c8","#b80909","rgba(251,240,200,0.5)","#f60100","rgba(246,1,0,0.5)","#152453","rgba(21,36,83,0.85)","#003190","rgba(0,49,144,0.5)","#f08f00","#cd1e0b","rgba(240,143,0,0.5)","#182c7e","#ededed","rgba(24,44,126,0.85)","#0f6735","rgba(15,103,53,0.85)","#48679e","rgba(72,103,158,0.5)","#1a4b83","rgba(26,75,131,0.5)","#0046a6","rgba(0,70,166,0.85)","#000","#85aad9","rgba(0,0,0,0.85)","#94badf","rgba(148,186,223,0.5)","#006ab8","rgba(0,106,184,0.5)","#cdda32","#152649","rgba(205,218,50,0.6)","#2e5b82","#d3e4f4","rgba(46,91,130,0.5)","#e70803","rgba(231,8,3,0.5)","#fa3139","rgba(250,49,57,0.7)","#039","#fc0","rgba(0,51,153,0.77)","#a0090e","rgba(160,9,14,0.5)","#0b5e64","rgba(11,94,100,0.77)","#2d377d","#ecd35f","rgba(45,55,125,0.5)","#00214f","rgba(0,33,79,0.5)","#cf0000","rgba(207,0,0,0.76)","#a5c94b","rgba(165,201,75,0.5)","#fbc500","rgba(251,197,0,0.5)","#fed008","rgba(254,208,8,0.5)","#a0a09e","rgba(160,160,158,0.76)","#036","rgba(0,51,102,0.77)","#e30b20","rgba(227,11,32,0.5)","#008375","rgba(0,131,117,0.5)","#cbc1b3","#c33","rgba(203,193,179,0.77)","#00bac3","rgba(0,186,195,0.5)","#ddb345","rgba(0,0,0,0.5)","#d5a92e","rgba(213,169,46,0.5)","#00a551","rgba(0,165,81,0.5)","#92d3f1","#014fa4","rgba(146,211,241,0.5)","#00458b","#ff9c00","rgba(0,69,139,0.82)","#0284b6","rgba(2,132,182,0.5)","#e51f3a","rgba(229,31,58,0.76)","#190b7e","#f8f859","rgba(25,11,126,0.75)","#d9d9d9","#e4583d","rgba(217,217,217,0.5)","#f67420","rgba(246,116,32,0.5)","#0065a9","#fa9801","rgba(0,101,169,0.5)","#f3f3f3","#f88e06","rgba(243,243,243,0.5)","#0e1969","rgba(14,25,105,0.5)","#1f99a6","#05285e","rgba(31,153,166,0.77)","#00401e","#f7df00","rgba(0,64,30,0.87)","#d30027","rgba(211,0,39,0.84)","#546bf9","rgba(84,107,249,0.5)","#010042","#fbdf00","rgba(1,0,66,0.5)","#d6040f","#ffdc20","rgba(214,4,15,0.78)","#77b700","rgba(119,183,0,0.5)","#060","rgba(0,102,0,0.8)","#fedf00","#009049","rgba(254,223,0,0.6)","#ce0402","#e6b500","rgba(206,4,2,0.78)","#eb6737","rgba(235,103,55,0.78)","#c70f23","#f99a1e","rgba(199,15,35,0.5)","#e00b37","rgba(224,11,55,0.5)","#ff6b00","rgba(255,107,0,0.7)","#0056a3","rgba(0,86,163,0.78)","#2eb8d2","rgba(46,184,210,0.5)","#102b52","#ef8213","rgba(16,43,82,0.82)","#c00","rgba(204,0,0,0.76)","#27347a","rgba(39,52,122,0.5)","#ef731b","rgba(239,115,27,0.5)","#d41701","rgba(212,23,1,0.5)","#1d398d","rgba(29,57,141,0.8)","#22558a","rgba(34,85,138,0.5)","#fd5040","rgba(253,80,64,0.5)","#a5965d","#304296","rgba(165,150,93,0.78)","#83aa8c","#00529c","rgba(131,170,140,0.67)","#acacb9","#1f7dd5","rgba(172,172,185,0.5)","#e80000","rgba(232,0,0,0.79)","#2597cc","rgba(37,151,204,0.76)","#dfdfdf","#b52118","rgba(223,223,223,0.5)","#21409a","rgba(33,64,154,0.5)","#a1aab1","#073477","rgba(161,170,177,0.79)","#ffb300","#0d1d62","rgba(255,179,0,0.7)","#063177","rgba(6,49,119,0.8)","#e40017","rgba(228,0,23,0.5)","rgba(204,0,0,0.8)","#948771","rgba(148,135,113,0.8)","#cfcecd","#002082","rgba(207,206,205,0.6)","#d4d4d4","#3f58a2","rgba(212,212,212,0.5)","#016259","rgba(1,98,89,0.8)","#c4cb6e","#0f8abe","rgba(196,203,110,0.7)","#b82abe","rgba(184,42,190,0.5)","#d90020","rgba(217,0,32,0.7)","#fe0000","rgba(254,0,0,0.6)","#39c0f3","#052c63","rgba(57,192,243,0.8)","#fed700","#2a5c8f","rgba(254,215,0,0.5)","#da4f0c","rgba(218,79,12,0.8)","#daebf3","#002596","rgba(218,235,243,0.5)","#1254a2","rgba(18,84,162,0.5)","#01baf2","rgba(1,186,242,0.5)","#e5087d","rgba(229,8,125,0.79)","#003e4a","rgba(0,62,74,0.8)","#e4e4de","#dd2c36","rgba(228,228,222,0.5)","#6ed0ff","#00007c","rgba(110,208,255,0.75)","#f60","rgba(255,102,0,0.5)","#b8d8ed","#d21c05","rgba(184,216,237,0.5)","#d5010d","rgba(213,1,13,0.7)","#fdbf00","#001a51","rgba(253,191,0,0.6)","#21227f","#fa2e2d","rgba(33,34,127,0.5)","#9c9080","rgba(156,144,128,0.8)","#de000b","rgba(222,0,11,0.5)","#132853","rgba(19,40,83,0.5)","#dedfe1","#1c3f78","rgba(222,223,225,0.5)","#006fb4","#fed813","rgba(0,111,180,0.77)","#ed1c24","rgba(237,28,36,0.73)","#06a84e","rgba(6,168,78,0.79)","#63003d","rgba(99,0,61,0.77)","#1261a6","#fab50f","rgba(18,97,166,0.5)","#eae9db","#6e6c71","rgba(234,233,219,0.5)","#ebac4f","#316698","rgba(235,172,79,0.76)","#52c5e1","#002856","rgba(82,197,225,0.81)","#bbd506","#d21d3c","rgba(187,213,6,0.5)","#537eb4","rgba(83,126,180,0.5)","#b80022","rgba(184,0,34,0.5)","#e8af00","#323a5e","rgba(232,175,0,0.5)","#040498","rgba(4,4,152,0.76)","#e03700","rgba(224,55,0,0.78)","#7f8996","#fcb130","rgba(127,137,150,0.76)","#228e6c","rgba(34,142,108,0.5)","#0e4274","rgba(14,66,116,0.79)","#554e82","rgba(85,78,130,0.5)","#97caff","#e12229","rgba(151,202,255,0.5)","#3d1a6f","#fbc608","rgba(61,26,111,0.78)","#5d5e60","rgba(93,94,96,0.5)","#ee2e24","rgba(238,46,36,0.75)","#bed732","#333","rgba(190,215,50,0.75)","#1d191a","#bbbcbe","rgba(29,25,26,0.5)","#fb9600","rgba(251,150,0,0.5)","#ea6601","rgba(234,102,1,0.5)","#d31b2b","rgba(211,27,43,0.78)","#f7941d","rgba(247,148,29,0.75)","#2b8aca","#e5d495","rgba(43,138,202,0.77)","#d91340","rgba(217,19,64,0.78)","#62b1e2","#0f4896","rgba(98,177,226,0.73)","#e50011","#fbf032","rgba(229,0,17,0.78)","#1d3068","rgba(29,48,104,0.77)","#0a2b5c","rgba(10,43,92,0.77)","#d6e1ef","#4d83bf","rgba(214,225,239,0.6)","#00845c","rgba(0,132,92,0.5)","#644646","rgba(100,70,70,0.5)","#1a171b","#c30000","rgba(195,0,0,0.78)","#fae01a","#005dab","rgba(250,224,26,0.5)","#d7002c","rgba(215,0,44,0.5)","#969799","rgba(150,151,153,0.65)","#c7007d","rgba(199,0,125,0.5)","#ff6d00","#ffe643","rgba(255,109,0,0.5)","#3f3d40","rgba(63,61,64,0.8)","#00898c","rgba(0,137,140,0.79)","#9b1c8f","rgba(155,28,143,0.5)","#344573","#e71b1e","rgba(52,69,115,0.5)","#e41e1b","rgba(228,30,27,0.5)","#ef633a","rgba(239,99,58,0.51)","#00907f","rgba(0,144,127,0.8)","#c64594","#fcbd38","rgba(198,69,148,0.77)","#005baa","rgba(0,91,170,0.79)","#0062af","rgba(0,98,175,0.78)","#632185","rgba(99,33,133,0.5)","right -32px bottom -95px","280px 248px","left","15px","16px","inline-block","-6px","1px dashed","14px","normal","pointer","border-box","168px","8px","center","19px","bold","128px","124px","hidden","top","#F5F6F7","1px","default","-19px","8px 0","#009ADD","#C6C7CA","100%","4px 0","11px","margin-top .4s","4px","12px","10px","uppercase","0 16px","33px","50%","33.33333%","25%","20%","16.66667%","14.28571%","184px","0 0 0 344px","328px","transparent","238px","16px 24px","1px solid #009ADD","8px 0 0","background .3s,color .3s","none","bottom",'"numbers",Arial,sans-serif','"dlig"','"dlig" 1',"optimizeLegibility","0 8px 0 0","middle","relative","white","normal 13px/16px arial,sans-serif","0","absolute","-24px","1","32px","right","9px","#ECF0F1","normal 13px / 16px arial,sans-serif","70vh","auto","0 2px 6px -3px #999","-8px","1px solid #ECF0F1","0 0 10px 10px","512px","384px","256px","174px","0 auto","4px 0 16px","24px","16px 0 8px","both","1px solid #fff","8px 24px","#7fc44b","nowrap","2px","100px","48px","344px","16px 0 16px 16px","265px","#F1C40F","16px 0","ellipsis","20px","26px","contain","50% 50%","0 0 16px","0 8px","fixed","99900","100000","98%",'"dlig=1"'],i={AirlineHead:[0,0,1,1,2,2,3,3,4,4,5,5,6,6],"AirlineHead--airlineCode-0B":[0,7,5,5],"AirlineHead--airlineCode-0B__inner":[0,8],"AirlineHead--airlineCode-2N":[0,9,5,5],"AirlineHead--airlineCode-2N__inner":[0,10],"AirlineHead--airlineCode-2P":[0,11,5,5],"AirlineHead--airlineCode-2P__inner":[0,12],"AirlineHead--airlineCode-3L":[0,13,5,14],"AirlineHead--airlineCode-3L__inner":[0,15],"AirlineHead--airlineCode-3O":[0,16,5,5],"AirlineHead--airlineCode-3O__inner":[0,17],"AirlineHead--airlineCode-4U":[0,18,5,19],"AirlineHead--airlineCode-4U__inner":[0,20],"AirlineHead--airlineCode-5J":[0,21,5,5],"AirlineHead--airlineCode-5J__inner":[0,22],"AirlineHead--airlineCode-6E":[0,23,5,5],"AirlineHead--airlineCode-6E__inner":[0,24],"AirlineHead--airlineCode-8Q":[0,25,5,26],"AirlineHead--airlineCode-8Q__inner":[0,27],"AirlineHead--airlineCode-A3":[0,28,5,5],"AirlineHead--airlineCode-A3__inner":[0,29],"AirlineHead--airlineCode-A5":[0,30,5,5],"AirlineHead--airlineCode-A5__inner":[0,31],"AirlineHead--airlineCode-A9":[0,32,5,5],"AirlineHead--airlineCode-A9__inner":[0,33],"AirlineHead--airlineCode-AA":[0,34,5,35],"AirlineHead--airlineCode-AA__inner":[0,36],"AirlineHead--airlineCode-AB":[0,37,5,5],"AirlineHead--airlineCode-AB__inner":[0,38],"AirlineHead--airlineCode-AD":[0,39,5,40],"AirlineHead--airlineCode-AD__inner":[0,41],"AirlineHead--airlineCode-AF":[0,42,5,43],"AirlineHead--airlineCode-AF__inner":[0,44],"AirlineHead--airlineCode-AI":[0,45,5,46],"AirlineHead--airlineCode-AI__inner":[0,47],"AirlineHead--airlineCode-AK":[0,48,5,5],"AirlineHead--airlineCode-AK__inner":[0,49],"AirlineHead--airlineCode-AM":[0,50,5,5],"AirlineHead--airlineCode-AM__inner":[0,51],"AirlineHead--airlineCode-AS":[0,52,5,5],"AirlineHead--airlineCode-AS__inner":[0,53],"AirlineHead--airlineCode-AT":[0,54,5,55],"AirlineHead--airlineCode-AT__inner":[0,56],"AirlineHead--airlineCode-AY":[0,57,5,58],"AirlineHead--airlineCode-AY__inner":[0,59],"AirlineHead--airlineCode-AZ":[0,60,5,5],"AirlineHead--airlineCode-AZ__inner":[0,61],"AirlineHead--airlineCode-B2":[0,62,5,5],"AirlineHead--airlineCode-B2__inner":[0,63],"AirlineHead--airlineCode-B6":[0,64,5,5],"AirlineHead--airlineCode-B6__inner":[0,65],"AirlineHead--airlineCode-BA":[0,66,5,5],"AirlineHead--airlineCode-BA__inner":[0,67],"AirlineHead--airlineCode-BD":[0,68,5,69],"AirlineHead--airlineCode-BD__inner":[0,70],"AirlineHead--airlineCode-BE":[0,71,5,5],"AirlineHead--airlineCode-BE__inner":[0,72],"AirlineHead--airlineCode-BM":[0,73,5,5],"AirlineHead--airlineCode-BM__inner":[0,74],"AirlineHead--airlineCode-BT":[0,75,5,76],"AirlineHead--airlineCode-BT__inner":[0,77],"AirlineHead--airlineCode-BV":[0,78,5,79],"AirlineHead--airlineCode-BV__inner":[0,80],"AirlineHead--airlineCode-BY":[0,81,5,5],"AirlineHead--airlineCode-BY__inner":[0,82],"AirlineHead--airlineCode-CA":[0,83,5,68],"AirlineHead--airlineCode-CA__inner":[0,84],"AirlineHead--airlineCode-CO":[0,85,5,86],"AirlineHead--airlineCode-CO__inner":[0,87],"AirlineHead--airlineCode-CR":[0,88,5,5],"AirlineHead--airlineCode-CR__inner":[0,89],"AirlineHead--airlineCode-CX":[0,90,5,5],"AirlineHead--airlineCode-CX__inner":[0,91],"AirlineHead--airlineCode-CY":[0,92,5,93],"AirlineHead--airlineCode-CY__inner":[0,94],"AirlineHead--airlineCode-CZ":[0,95,5,5],"AirlineHead--airlineCode-CZ__inner":[0,96],"AirlineHead--airlineCode-D7":[0,97,5,5],"AirlineHead--airlineCode-D7__inner":[0,98],"AirlineHead--airlineCode-DC":[0,99,5,5],"AirlineHead--airlineCode-DC__inner":[0,100],"AirlineHead--airlineCode-DD":[0,101,5,68],"AirlineHead--airlineCode-DD__inner":[0,102],"AirlineHead--airlineCode-DE":[0,103,5,5],"AirlineHead--airlineCode-DE__inner":[0,104],"AirlineHead--airlineCode-DJ":[0,105,5,5],"AirlineHead--airlineCode-DJ__inner":[0,106],"AirlineHead--airlineCode-DL":[0,107,5,5],"AirlineHead--airlineCode-DL__inner":[0,108],"AirlineHead--airlineCode-DY":[0,109,5,5],"AirlineHead--airlineCode-DY__inner":[0,110],"AirlineHead--airlineCode-EI":[0,111,5,5],"AirlineHead--airlineCode-EI__inner":[0,112],"AirlineHead--airlineCode-EK":[0,113,5,114],"AirlineHead--airlineCode-EK__inner":[0,115],"AirlineHead--airlineCode-EN":[0,116,5,5],"AirlineHead--airlineCode-EN__inner":[0,117],"AirlineHead--airlineCode-EY":[0,68,5,118],"AirlineHead--airlineCode-EY__inner":[0,119],"AirlineHead--airlineCode-F7":[0,120,5,5],"AirlineHead--airlineCode-F7__inner":[0,121],"AirlineHead--airlineCode-FB":[0,122,5,5],"AirlineHead--airlineCode-FB__inner":[0,123],"AirlineHead--airlineCode-FH":[0,124,5,125],"AirlineHead--airlineCode-FH__inner":[0,126],"AirlineHead--airlineCode-FI":[0,127,5,128],"AirlineHead--airlineCode-FI__inner":[0,129],
"AirlineHead--airlineCode-FL":[0,130,5,5],"AirlineHead--airlineCode-FL__inner":[0,131],"AirlineHead--airlineCode-FM":[0,132,5,5],"AirlineHead--airlineCode-FM__inner":[0,133],"AirlineHead--airlineCode-FR":[0,134,5,135],"AirlineHead--airlineCode-FR__inner":[0,136],"AirlineHead--airlineCode-FV":[0,137,5,138],"AirlineHead--airlineCode-FV__inner":[0,139],"AirlineHead--airlineCode-FY":[0,140,5,5],"AirlineHead--airlineCode-FY__inner":[0,141],"AirlineHead--airlineCode-FZ":[0,142,5,143],"AirlineHead--airlineCode-FZ__inner":[0,144],"AirlineHead--airlineCode-G3":[0,145,5,146],"AirlineHead--airlineCode-G3__inner":[0,147],"AirlineHead--airlineCode-G8":[0,148,5,5],"AirlineHead--airlineCode-G8__inner":[0,149],"AirlineHead--airlineCode-GA":[0,150,5,151],"AirlineHead--airlineCode-GA__inner":[0,152],"AirlineHead--airlineCode-GW":[0,153,5,154],"AirlineHead--airlineCode-GW__inner":[0,155],"AirlineHead--airlineCode-HG":[0,156,5,5],"AirlineHead--airlineCode-HG__inner":[0,157],"AirlineHead--airlineCode-HQ":[0,158,5,5],"AirlineHead--airlineCode-HQ__inner":[0,159],"AirlineHead--airlineCode-HS":[0,160,5,161],"AirlineHead--airlineCode-HS__inner":[0,162],"AirlineHead--airlineCode-HU":[0,163,5,164],"AirlineHead--airlineCode-HU__inner":[0,165],"AirlineHead--airlineCode-HV":[0,166,5,5],"AirlineHead--airlineCode-HV__inner":[0,167],"AirlineHead--airlineCode-HX":[0,168,5,5],"AirlineHead--airlineCode-HX__inner":[0,169],"AirlineHead--airlineCode-HY":[0,170,5,171],"AirlineHead--airlineCode-HY__inner":[0,172],"AirlineHead--airlineCode-IB":[0,173,5,174],"AirlineHead--airlineCode-IB__inner":[0,175],"AirlineHead--airlineCode-IG":[0,176,5,68],"AirlineHead--airlineCode-IG__inner":[0,177],"AirlineHead--airlineCode-IT":[0,178,5,179],"AirlineHead--airlineCode-IT__inner":[0,180],"AirlineHead--airlineCode-IX":[0,181,5,5],"AirlineHead--airlineCode-IX__inner":[0,182],"AirlineHead--airlineCode-IZ":[0,183,5,5],"AirlineHead--airlineCode-IZ__inner":[0,184],"AirlineHead--airlineCode-J2":[0,185,5,5],"AirlineHead--airlineCode-J2__inner":[0,186],"AirlineHead--airlineCode-J9":[0,187,5,5],"AirlineHead--airlineCode-J9__inner":[0,188],"AirlineHead--airlineCode-JK":[0,189,5,190],"AirlineHead--airlineCode-JK__inner":[0,191],"AirlineHead--airlineCode-JL":[0,192,5,68],"AirlineHead--airlineCode-JL__inner":[0,193],"AirlineHead--airlineCode-JP":[0,194,5,5],"AirlineHead--airlineCode-JP__inner":[0,195],"AirlineHead--airlineCode-JQ":[0,196,5,68],"AirlineHead--airlineCode-JQ__inner":[0,197],"AirlineHead--airlineCode-JT":[0,198,5,5],"AirlineHead--airlineCode-JT__inner":[0,199],"AirlineHead--airlineCode-JU":[0,200,5,5],"AirlineHead--airlineCode-JU__inner":[0,201],"AirlineHead--airlineCode-K2":[0,202,5,5],"AirlineHead--airlineCode-K2__inner":[0,203],"AirlineHead--airlineCode-KB":[0,204,5,5],"AirlineHead--airlineCode-KB__inner":[0,205],"AirlineHead--airlineCode-KC":[0,206,5,207],"AirlineHead--airlineCode-KC__inner":[0,208],"AirlineHead--airlineCode-KE":[0,209,5,210],"AirlineHead--airlineCode-KE__inner":[0,211],"AirlineHead--airlineCode-KF":[0,212,5,213],"AirlineHead--airlineCode-KF__inner":[0,214],"AirlineHead--airlineCode-KK":[0,215,5,5],"AirlineHead--airlineCode-KK__inner":[0,216],"AirlineHead--airlineCode-KL":[0,217,5,5],"AirlineHead--airlineCode-KL__inner":[0,218],"AirlineHead--airlineCode-KM":[0,219,5,220],"AirlineHead--airlineCode-KM__inner":[0,221],"AirlineHead--airlineCode-KV":[0,222,5,5],"AirlineHead--airlineCode-KV__inner":[0,223],"AirlineHead--airlineCode-LA":[0,224,5,225],"AirlineHead--airlineCode-LA__inner":[0,226],"AirlineHead--airlineCode-LH":[0,227,5,228],"AirlineHead--airlineCode-LH__inner":[0,229],"AirlineHead--airlineCode-LO":[0,230,5,5],"AirlineHead--airlineCode-LO__inner":[0,231],"AirlineHead--airlineCode-LS":[0,232,5,5],"AirlineHead--airlineCode-LS__inner":[0,233],"AirlineHead--airlineCode-LX":[0,192,5,5],"AirlineHead--airlineCode-LX__inner":[0,234],"AirlineHead--airlineCode-LY":[0,235,5,5],"AirlineHead--airlineCode-LY__inner":[0,236],"AirlineHead--airlineCode-MA":[0,237,5,238],"AirlineHead--airlineCode-MA__inner":[0,239],"AirlineHead--airlineCode-MH":[0,240,5,241],"AirlineHead--airlineCode-MH__inner":[0,242],"AirlineHead--airlineCode-MI":[0,243,5,5],"AirlineHead--airlineCode-MI__inner":[0,244],"AirlineHead--airlineCode-MK":[0,245,5,246],"AirlineHead--airlineCode-MK__inner":[0,247],"AirlineHead--airlineCode-MM":[0,248,5,5],"AirlineHead--airlineCode-MM__inner":[0,249],"AirlineHead--airlineCode-MP":[0,250,5,5],"AirlineHead--airlineCode-MP__inner":[0,251],"AirlineHead--airlineCode-MQ":[0,252,5,5],"AirlineHead--airlineCode-MQ__inner":[0,253],"AirlineHead--airlineCode-MS":[0,254,5,255],"AirlineHead--airlineCode-MS__inner":[0,256],"AirlineHead--airlineCode-MT":[0,257,5,258],"AirlineHead--airlineCode-MT__inner":[0,259],"AirlineHead--airlineCode-MU":[0,260,5,5],"AirlineHead--airlineCode-MU__inner":[0,261],"AirlineHead--airlineCode-NH":[0,262,5,263],"AirlineHead--airlineCode-NH__inner":[0,264],"AirlineHead--airlineCode-NK":[0,265,5,5],"AirlineHead--airlineCode-NK__inner":[0,266],"AirlineHead--airlineCode-NM":[0,267,5,5],"AirlineHead--airlineCode-NM__inner":[0,268],"AirlineHead--airlineCode-NN":[0,269,5,5],"AirlineHead--airlineCode-NN__inner":[0,270],"AirlineHead--airlineCode-NZ":[0,271,5,5],"AirlineHead--airlineCode-NZ__inner":[0,272],"AirlineHead--airlineCode-OK":[0,273,5,274],"AirlineHead--airlineCode-OK__inner":[0,275],"AirlineHead--airlineCode-OM":[0,276,5,277],"AirlineHead--airlineCode-OM__inner":[0,278],"AirlineHead--airlineCode-OR":[0,279,5,5],"AirlineHead--airlineCode-OR__inner":[0,280],"AirlineHead--airlineCode-OS":[0,281,5,282],"AirlineHead--airlineCode-OS__inner":[0,283],"AirlineHead--airlineCode-OU":[0,284,5,5],"AirlineHead--airlineCode-OU__inner":[0,285],"AirlineHead--airlineCode-OV":[0,286,5,287],"AirlineHead--airlineCode-OV__inner":[0,288],"AirlineHead--airlineCode-OX":[0,289,5,290],"AirlineHead--airlineCode-OX__inner":[0,291],"AirlineHead--airlineCode-OZ":[0,292,5,5],"AirlineHead--airlineCode-OZ__inner":[0,293],"AirlineHead--airlineCode-PC":[0,294,5,5],"AirlineHead--airlineCode-PC__inner":[0,295],"AirlineHead--airlineCode-PD":[0,296,5,5],"AirlineHead--airlineCode-PD__inner":[0,297],"AirlineHead--airlineCode-PG":[0,298,5,299],"AirlineHead--airlineCode-PG__inner":[0,300],"AirlineHead--airlineCode-PS":[0,301,5,302],"AirlineHead--airlineCode-PS__inner":[0,303],"AirlineHead--airlineCode-QF":[0,304,5,5],"AirlineHead--airlineCode-QF__inner":[0,305],"AirlineHead--airlineCode-QK":[0,306,5,5],"AirlineHead--airlineCode-QK__inner":[0,307],"AirlineHead--airlineCode-QR":[0,308,5,5],"AirlineHead--airlineCode-QR__inner":[0,309],"AirlineHead--airlineCode-QS":[0,310,5,311],"AirlineHead--airlineCode-QS__inner":[0,312],"AirlineHead--airlineCode-RJ":[0,313,5,314],"AirlineHead--airlineCode-RJ__inner":[0,315],"AirlineHead--airlineCode-RM":[0,316,5,317],"AirlineHead--airlineCode-RM__inner":[0,318],"AirlineHead--airlineCode-S4":[0,319,5,320],"AirlineHead--airlineCode-S4__inner":[0,321],"AirlineHead--airlineCode-S7":[0,322,5,323],"AirlineHead--airlineCode-S7__inner":[0,324],"AirlineHead--airlineCode-SA":[0,325,5,5],"AirlineHead--airlineCode-SA__inner":[0,326],"AirlineHead--airlineCode-SG":[0,327,5,5],"AirlineHead--airlineCode-SG__inner":[0,328],"AirlineHead--airlineCode-SI":[0,329,5,330],"AirlineHead--airlineCode-SI__inner":[0,331],"AirlineHead--airlineCode-SK":[0,332,5,5],"AirlineHead--airlineCode-SK__inner":[0,333],"AirlineHead--airlineCode-SN":[0,334,5,5],"AirlineHead--airlineCode-SN__inner":[0,335],"AirlineHead--airlineCode-SQ":[0,336,5,337],"AirlineHead--airlineCode-SQ__inner":[0,338],"AirlineHead--airlineCode-ST":[0,339,5,5],"AirlineHead--airlineCode-ST__inner":[0,340],"AirlineHead--airlineCode-SU":[0,341,5,5],"AirlineHead--airlineCode-SU__inner":[0,342],"AirlineHead--airlineCode-T3":[0,343,5,5],"AirlineHead--airlineCode-T3__inner":[0,344],"AirlineHead--airlineCode-TB":[0,345,5,346],"AirlineHead--airlineCode-TB__inner":[0,347],"AirlineHead--airlineCode-TG":[0,348,5,349],"AirlineHead--airlineCode-TG__inner":[0,350],"AirlineHead--airlineCode-TI":[0,351,5,5],"AirlineHead--airlineCode-TI__inner":[0,352],"AirlineHead--airlineCode-TK":[0,353,5,5],"AirlineHead--airlineCode-TK__inner":[0,354],"AirlineHead--airlineCode-TP":[0,355,5,356],"AirlineHead--airlineCode-TP__inner":[0,357],"AirlineHead--airlineCode-TR":[0,358,5,359],"AirlineHead--airlineCode-TR__inner":[0,360],"AirlineHead--airlineCode-TZ":[0,361,5,5],"AirlineHead--airlineCode-TZ__inner":[0,362],"AirlineHead--airlineCode-U2":[0,363,5,5],"AirlineHead--airlineCode-U2__inner":[0,364],"AirlineHead--airlineCode-U6":[0,365,5,5],"AirlineHead--airlineCode-U6__inner":[0,366],"AirlineHead--airlineCode-U8":[0,367,5,5],"AirlineHead--airlineCode-U8__inner":[0,368],"AirlineHead--airlineCode-U9":[0,369,5,370],"AirlineHead--airlineCode-U9__inner":[0,371],"AirlineHead--airlineCode-UA":[0,85,5,5],"AirlineHead--airlineCode-UA__inner":[0,87],"AirlineHead--airlineCode-UL":[0,372,5,5],"AirlineHead--airlineCode-UL__inner":[0,373],"AirlineHead--airlineCode-UN":[0,374,5,375],"AirlineHead--airlineCode-UN__inner":[0,376],"AirlineHead--airlineCode-UO":[0,377,5,378],"AirlineHead--airlineCode-UO__inner":[0,379],"AirlineHead--airlineCode-UR":[0,380,5,5],"AirlineHead--airlineCode-UR__inner":[0,381],"AirlineHead--airlineCode-US":[0,382,5,5],"AirlineHead--airlineCode-US__inner":[0,383],"AirlineHead--airlineCode-UT":[0,380,5,5],"AirlineHead--airlineCode-UT__inner":[0,381],"AirlineHead--airlineCode-UX":[0,384,5,385],"AirlineHead--airlineCode-UX__inner":[0,386],"AirlineHead--airlineCode-V3":[0,387,5,5],"AirlineHead--airlineCode-V3__inner":[0,388],"AirlineHead--airlineCode-V7":[0,389,5,5],"AirlineHead--airlineCode-V7__inner":[0,390],"AirlineHead--airlineCode-VO":[0,281,5,391],"AirlineHead--airlineCode-VO__inner":[0,283],"AirlineHead--airlineCode-VS":[0,392,5,5],"AirlineHead--airlineCode-VS__inner":[0,393],"AirlineHead--airlineCode-VV":[0,394,5,395],"AirlineHead--airlineCode-VV__inner":[0,396],"AirlineHead--airlineCode-VX":[0,397,5,5],"AirlineHead--airlineCode-VX__inner":[0,398],"AirlineHead--airlineCode-VY":[0,399,5,5],"AirlineHead--airlineCode-VY__inner":[0,400],"AirlineHead--airlineCode-W6":[0,401,5,5],"AirlineHead--airlineCode-W6__inner":[0,402],"AirlineHead--airlineCode-WG":[0,403,5,404],"AirlineHead--airlineCode-WG__inner":[0,405],"AirlineHead--airlineCode-WN":[0,406,5,5],"AirlineHead--airlineCode-WN__inner":[0,407],"AirlineHead--airlineCode-WS":[0,408,5,5],"AirlineHead--airlineCode-WS__inner":[0,409],"AirlineHead--airlineCode-WW":[0,410,5,5],"AirlineHead--airlineCode-WW__inner":[0,411],"AirlineHead--airlineCode-WX":[0,412,5,413],"AirlineHead--airlineCode-WX__inner":[0,414],"AirlineHead--airlineCode-X3":[0,415,5,5],"AirlineHead--airlineCode-X3__inner":[0,416],"AirlineHead--airlineCode-XF":[0,417,5,5],"AirlineHead--airlineCode-XF__inner":[0,418],"AirlineHead--airlineCode-XM":[0,419,5,5],"AirlineHead--airlineCode-XM__inner":[0,420],"AirlineHead--airlineCode-XW":[0,421,5,422],"AirlineHead--airlineCode-XW__inner":[0,423],"AirlineHead--airlineCode-YM":[0,424,5,5],"AirlineHead--airlineCode-YM__inner":[0,425],"AirlineHead--airlineCode-Z6":[0,426,5,86],"AirlineHead--airlineCode-Z6__inner":[0,427],"AirlineHead--airlineCode-ZB":[0,428,5,5],"AirlineHead--airlineCode-ZB__inner":[0,429],"AirlineHead--hasText":[3,430,4,431],"AirlineHead--hasText__inner__content":[7,432],AirlineHead__inner__content:[8,433,9,434],AirlineHead__inner__content__rulesLink:[10,435,11,436,12,437,13,438,14,439,15,440],AirlineHead__inner__content__title:[10,435,16,441,17,442,18,443,7,444,13,445,9,434,14,446],AvailableService:[10,435,17,447,19,448,20,449,21,450],AvailableService__inner:[7,444,0,451,8,452,19,448,1,1,15,453],"AvailableService__inner--isAvalable":[0,5,15,453],"AvailableService__inner--isHover__overlay":[11,454],AvailableService__inner__icon:[8,455,5,456],"AvailableService__inner__icon--isLocked":[5,457],AvailableService__inner__overlay:[22,456,5,5,17,458,8,459,13,460,23,461],AvailableService__inner__signature:[8,462,13,463,5,456],AvailableService__inner__title:[13,464,24,465,8,466,19,467,20,449],ChooseButton:[10,435],"ChooseButton--m-1Cell":[17,458],"ChooseButton--m-2Cell":[17,468],"ChooseButton--m-3Cell":[17,469],"ChooseButton--m-4Cell":[17,470],"ChooseButton--m-5Cell":[17,471],"ChooseButton--m-6Cell":[17,472],"ChooseButton--m-7Cell":[17,473],ChooseButtonShort:[10,435,17,474,7,444],"ChooseButtonShort--isFirstNode":[6,475],"ChooseButtonShort--isOneBrand":[17,476],"ChooseButtonShort--isSelected__inner__btn":[5,456,22,477],"ChooseButtonShort--isSelected__inner__btn__icon":[10,435],"ChooseButtonShort--isTwoBrand":[17,478],ChooseButtonShort__inner:[8,434,22,5,16,441,6,452],ChooseButtonShort__inner__btn:[10,435,8,479,22,456,25,480,5,5,13,434,15,440,6,481,23,482],"ChooseButtonShort__inner__btn--isHover":[5,456,22,477],ChooseButtonShort__inner__btn__icon:[10,483,21,484,26,443,27,456],ChooseButtonShort__inner__price:[17,458,10,435,13,434,15,440,28,485,14,439,29,486,30,487,31,486,32,488],ChooseButton__inner:[8,434,22,5,16,441,6,452],ChooseButton__inner__choose:[10,435,8,479,5,456,25,480,22,477,13,434,15,440,6,481,23,482],"ChooseButton__inner__choose--isHover":[22,456,5,5],ChooseButton__inner__flight:[13,463],ChooseButton__inner__flight__wrap__location:[6,481,5,456],ChooseButton__inner__price:[17,458,10,435,13,434,15,440,28,485,14,439,29,486,30,487,31,486,32,488],ChooseButton__inner__price__radio:[6,489,21,490,27,456,5,456],Content:[33,491,22,492,34,493,35,483],"Content--isTransparent":[22,477],"Content--isTransparent__body":[22,477],"Content--isTransparent__closerWrapper":[19,494,22,477],"Content--isTransparent__closerWrapper__closer":[33,495,36,496,37,494,8,494,15,440],Content__body:[22,492,9,497],Content__closerWrapper:[19,498,22,492,7,499],Content__closerWrapper__closer:[10,435,8,443,15,440],FareFamily:[11,443,38,500],FareFamilyModal:[22,501,16,441,34,502],FareFamilyModal__area:[33,491,39,503,40,504,41,449],FareFamilyModal__buttons:[38,443,42,505],FareFamilyModal__choose:[8,434,7,444,13,434,5,5,22,456,15,440,23,482],FareFamilyModal__shortButton:[22,5,11,506,33,491,43,497,44,507,45,508],FareFamily__widget__action:[10,435,20,449,19,448,7,444,21,450],"FareFamily__widget__action--actionM-2Cell":[17,509],"FareFamily__widget__action--actionM-3Cell":[17,510],"FareFamily__widget__action--actionM-4Cell":[17,511],FareFamily__widget__action__inner:[8,452,22,5,19,448,1,1],FareFamily__widget__action__inner__button:[17,512,8,455,7,444,5,5,6,513,24,465,13,438,22,456,15,440],FareFamily__widget__action__inner__button__icon:[18,443],FareFamily__widget__action__inner__caption:[13,438,24,465,8,514],FareFamily__widget__action__inner__title:[13,515,8,516],FareFamily__widget__clear:[46,517],"FareFamily__widget__side--isLeft":[47,432,6,443,9,439],"FareFamily__widget__side--isRight":[47,499],FareFamily__widget__side__choose:[5,5,22,477,25,518,13,434,8,519,23,482,15,440],"FareFamily__widget__side__choose--isDisabled":[15,453],"FareFamily__widget__side__choose--isHover":[22,5,5,520],FareFamily__widget__side__loader:[5,5,33,495],FareInfo:[13,434,48,494,38,443,42,505],FareInfo__row:[49,521],"FareInfo__row--isButton__cell":[19,458,11,522],"FareInfo__row--isButton__cell__inner__content":[19,523],"FareInfo__row--isHeader":[5,456],"FareInfo__row--isHeader__cell":[19,524],"FareInfo__row--isHeader__cell--isOneBrand":[17,476],"FareInfo__row--isHeader__cell--isTwoBrand":[17,478],FareInfo__row__cell:[10,435,17,474,7,444,49,521,19,524,8,452,16,441],"FareInfo__row__cell--isAircompany":[17,458],"FareInfo__row__cell--isAircompany__inner":[8,494],"FareInfo__row__cell--isCaption":[7,432,17,525],"FareInfo__row__cell--isCaption__inner":[8,526],"FareInfo__row__cell--isCaption__inner__caption":[10,435,17,527],"FareInfo__row__cell--isHeaderSelected__inner":[0,528],"FareInfo__row__cell--isOneBrand":[17,476],"FareInfo__row__cell--isTwoBrand":[17,478],FareInfo__row__cell__inner:[22,5,19,458,10,435,21,490,17,458,8,529,16,441,20,449,50,530],FareInfo__row__cell__inner__choose:[10,435,8,479,5,456,25,480,22,477,13,434,15,440,6,481],FareInfo__row__cell__inner__flight:[13,463],FareInfo__row__cell__inner__flight__location:[6,481,5,456],FareInfo__row__cell__inner__icon:[10,435,21,490,17,531,19,532,4,533,2,2,3,534],FareInfo__row__cell__inner__price:[6,535],FareInfo__row__cell__inner__wrapper:[17,458,20,449,50,530,9,439,8,536,16,441],LayoutOverlay:[33,537,37,494,51,494,43,538,19,458,17,458,0,119],Layout__container:[33,537,37,494,51,494,43,539,19,458,17,458,20,504,7,444],Layout__container__wrapper:[52,540,10,435,21,490],Layout__container__wrapper__body:[10,435,7,432],Modal:[11,443],"Money--isFat__text":[28,485,14,446,29,486,30,541,30,486,30,487,31,486,32,488],Money__text:[28,485,14,439,24,483,29,486,30,541,30,486,30,487,31,486,32,488],Position:[11,443],Tooltip:[11,443]};e.exports=function(e){for(var t,o,a,s,u={},l=e.split(/\s+/),c=0,d=l.length;c!==d;){for(t=l[c],o=i[t]||[],a=0,s=o.length;a!==s;)u[n[o[a++]]]=r[o[a++]];c++}return u}},function(e,t,n){"use strict";var r=n(470).default,i=n(474).default,o=n(423),a=(n(302),n(477)),s=function(e){function t(){i(this,t),e.apply(this,arguments)}return r(t,e),t.prototype.shouldComponentUpdate=function(e,t){return a(this,e,t)},t}(o);e.exports=s},function(e,t,n){"use strict";function r(e,t,n){return!i(e.props,t)||!i(e.state,n)}var i=n(417);e.exports=r},function(e,t,n){function r(e){var t=e.w,n=e.style,r=e.isLock;return i("svg",{style:n,width:t,height:t,viewBox:"0 0 454.62 454.62",preserveAspectRatio:"xMinYMin",xmlns:"http://www.w3.org/2000/svg"},i("path",{fill:"currentColor",d:r?o:a}))}var i=n(464),o="M346.331,195.389h-6.637v-83.006C339.693,50.41,289.281,0,227.31,0S114.927,50.41,114.927,112.383v83.006h-6.637\n              c-23.137,0-41.888,18.752-41.888,41.889v175.455c0,23.137,18.752,41.888,41.888,41.888h238.04\n              c23.137,0,41.888-18.751,41.888-41.888V237.277C388.218,214.141,369.468,195.389,346.331,195.389z M250.297,328.41v30.432\n              c0,12.697-10.289,22.986-22.987,22.986c-12.698,0-22.987-10.289-22.987-22.986v-30.439c-10.019-7.185-16.604-18.865-16.604-32.131\n              c0-21.865,17.72-39.6,39.599-39.6c21.864,0,39.583,17.734,39.583,39.6C266.901,309.545,260.316,321.218,250.297,328.41z\n              M278.395,195.389H176.226v-83.006c0-28.165,22.919-51.084,51.084-51.084s51.085,22.919,51.085,51.084V195.389z",a="M346.33,195.389h-6.637v-83.006C339.693,50.41,289.275,0,227.31,0c-61.965,0-112.383,50.41-112.383,112.383v6.36\n        c0,16.926,13.723,30.649,30.649,30.649c16.926,0,30.649-13.724,30.649-30.649v-6.36c0-28.165,22.92-51.084,51.085-51.084\n        c28.165,0,51.084,22.919,51.084,51.084v83.006H108.29c-23.137,0-41.888,18.752-41.888,41.889v175.455\n        c0,23.137,18.751,41.888,41.888,41.888h238.04c23.137,0,41.888-18.751,41.888-41.888V237.277\n        C388.219,214.141,369.467,195.389,346.33,195.389z M250.297,328.41v30.432c0,12.697-10.289,22.986-22.987,22.986\n        c-12.698,0-22.987-10.289-22.987-22.986v-30.439c-10.019-7.185-16.604-18.865-16.604-32.131c0-21.865,17.72-39.6,39.599-39.6\n        c21.864,0,39.583,17.734,39.583,39.6C266.901,309.545,260.316,321.218,250.297,328.41z";r.defaultProps={w:22,isLock:!0},e.exports=r},function(e,t,n){var r,i=n(464),o=n(470).default,a=n(474).default,s={},u=n(475),l=n(476),c=n(478),d=n(480).capitalize,p=n(495),f=function(e){function t(n,r){a(this,t),e.call(this,n,r),this.handleMouseEnter=this.handleMouseEnter.bind(this),this.handleMouseLeave=this.handleMouseLeave.bind(this),this.state={}}return o(t,e),t.prototype.handleMouseEnter=function(){this.setState({isHover:!0})},t.prototype.handleMouseLeave=function(){this.setState({isHover:!1})},t.prototype.getCaption=function(e){var t=e?e.value:p.fareFamily.notAllowed;return t=e&&e.value&&"boolean"==typeof e.value?p.fareFamily.allowed:t,t=t?t:p.fareFamily.notAllowed},t.prototype.render=function(){var e=this.state.isHover,t=this.props,n=t.currentBrand,o=t.nextBrand,a=t.service,l=t.mostExpensiveBrands,p=void 0,f=n.services.filter(function(e){return e.tag===a.tag})[0],h=o&&o.services.filter(function(e){return e.tag===a.tag})[0],v=l!==n,y=!!f&&f.value;y=h&&f&&h.value!==f.value?!1:y;var g=l.services.filter(function(e){return e.tag===a.tag})[0],m=this.getCaption(g),_=this.getCaption(f);return v&&!y&&(p=i("div",{className:"AvailableServiceOverlay",e:"overlay",style:(r="AvailableService__inner__overlay"+(e?" AvailableService__inner--isHover__overlay":""),s[r]||(s[r]=u(r)))},m)),i("div",{className:"AvailableService",b:"AvailableService",style:(r="AvailableService",s[r]||(s[r]=u(r)))},i("div",{e:"inner",m:{isAvalable:y,isHover:e},onMouseEnter:this.handleMouseEnter,onMouseLeave:this.handleMouseLeave,className:"inner",style:(r="AvailableService__inner"+(y?" AvailableService__inner--isAvalable":""),s[r]||(s[r]=u(r)))},i("div",{e:"icon",m:{isLocked:!y},style:(r="AvailableService__inner__icon"+(y?"":" AvailableService__inner__icon--isLocked"),s[r]||(s[r]=u(r)))},i(c,{w:42,isLock:!y})),i("div",{e:"title",className:"title",style:(r="AvailableService__inner__title",s[r]||(s[r]=u(r)))},d(a.tagName)),i("div",{e:"signature",className:"signature",style:(r="AvailableService__inner__signature",s[r]||(s[r]=u(r)))},_),p))},t}(l);f.defaultProps={},e.exports=f},function(e,t,n){"use strict";var r=n(104).default,i=n(481),o={alpha:{"Á":"A","À":"A","Â":"A","Ä":"AE","Ã":"A","Ă":"A","Å":"AA","Ā":"A","Ą":"A","Ǎ":"A","Ǻ":"A","Ǽ":"A","Ć":"C","Ĉ":"C","Č":"C","Ċ":"C","Ç":"C","Ð":"D","Ď":"D","É":"E","È":"E","Ê":"E","Ë":"E","Ĕ":"E","Ė":"E","Ē":"E","Ę":"E","Ě":"E","Ĝ":"G","Ğ":"G","Ġ":"G","Ģ":"G","Ħ":"Н","Ĥ":"H","Í":"I","Ì":"I","Î":"I","Ï":"I","Ĩ":"I","İ":"I","Ī":"I","Į":"I","Ĭ":"I","Ǐ":"I","Ĵ":"J","Ķ":"K","Ł":"L","Ĺ":"L","Ľ":"L","Ļ":"L","Ŀ":"L","Ń":"N","Ñ":"N","Ň":"N","Ņ":"N","Ƞ":"N","Ø":"OE","Ó":"O","Ò":"O","Ô":"O","Ö":"OE","Õ":"O","Ő":"O","Ō":"O","Ŏ":"O","Ơ":"O","Ǒ":"O","Ǿ":"OE","Ŕ":"R","Ř":"R","Ŗ":"R","Ś":"S","Ŝ":"S","Š":"S","Ş":"S","Ŧ":"T","Ť":"T","Ţ":"T","Ú":"U","Ù":"U","Û":"U","Ü":"UE","Ũ":"U","Ŭ":"U","Ű":"U","Ů":"U","Ū":"U","Ų":"U","Ư":"U","Ǔ":"U","Ǖ":"U","Ǘ":"U","Ǚ":"U","Ǜ":"U","Ŵ":"W","Ý":"Y","Ŷ":"Y","Ÿ":"Y","Ź":"Z","Ž":"Z","Ż":"Z","Þ":"TH","Æ":"AE","Ĳ":"IJ","Œ":"OE","ß":"SS","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ё":"YE","Ж":"ZH","З":"Z","И":"I","Й":"Y","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"KH","Ц":"TS","Ч":"CH","Ш":"SH","Щ":"SHCH","Ь":"","Ы":"Y","Ъ":"","Э":"E","Ю":"YU","Я":"YA","І":"I","Ґ":"G","Ў":"U","Ѫ":"U","ƒ":"G","Ћ":"D","Ѕ":"DZ","Ј":"J","Ќ":"K","Љ":"LJ","Њ":"NJ","Һ":"C","Џ":"DZ","Є":"IE","Ї":"I"},enToRu:{q:"й",w:"ц",e:"у",r:"к",t:"е",y:"н",u:"г",i:"ш",o:"щ",p:"з","[":"х","{":"х","]":"ъ","}":"ъ",a:"ф",s:"ы",d:"в",f:"а",g:"п",h:"р",j:"о",k:"л",l:"д",";":"ж",":":"ж","'":"э",'"':"э","`":"ё","~":"ё",z:"я",x:"ч",c:"с",v:"м",b:"и",n:"т",m:"ь",",":"б","<":"б",".":"ю",">":"ю"},space:{" ":" "," ":" "," ":" "},hyphen:{"-":"-","–":"-","—":"-"},numeric:{0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9"}},a={9:/\d/,A:/[A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]/,"*":/[\dA-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]/},s=/[^a-zA-Zа-яА-ЯёЁ\s\\-]/g,u=/[^A-ZА-Я-Ё|\s]/gim,l="",c=/\s/g,d=r(a),p=/\D/g,f=/[^A-ZА-ЯЁ\d]/g,h=/[^A-Z\d]/g,v=function(){var e=!0,t=0,n=0;return function(r,i,o){void 0===r&&(r="");var s=o,u={},l=this.refs.input;i.split("").forEach(function(e,t){~d.indexOf(e)&&(u[t+1]=a[e])});var c=0,p=0,f="",h=void 0;for(v=0;v<i.length;v++)if(~d.indexOf(i[v])){p=v;break}for(var v=0,y=0;v<i.length;)if(~d.indexOf(i[v])){if(!(h=r.substr(y++,1))){f=f.substr(0,c),f+=s.slice(c);break}u[f.length+1].test(h)&&(f+=h,c=f.length,v++)}else f+=i[v],i[v]===r[y]&&y++,v++;n=l?l.selectionStart:0;var g=t>n;if(c=Math.max(c,p),p>=n)n=p;else if(n>=c)n=c;else if(g)for(var v=n;v>=0&&(n=v,!u[v]||u[v+1])&&!(u[v]&&u[v+1]&&u[v+1].test(f[v]));v--);else for(var v=n;c>=v&&(n=v,u[v+1]||!u[v]);v++)if(u[v+1]&&u[v+1].test(f[v])){u[v]||n++;break}return e=c===p,t=n,{value:f,cursor:t,empty:e}}},y=v(),g=function _(e){return y.call(this,e,_.mask,_.placeholder)};g.placeholder="ДД.MM.ГГГГ",g.mask="99.99.9999";var m=function(e){return e?i(i(e.replace(/\s+/g," "))):e};e.exports={capitalize:function(e){return e?e[0].toUpperCase()+e.substr(1):e},toUpperCase:function(e){return e?e.toUpperCase():e},removeSpaces:function(e){return e?e.replace(c,l):e},phoneNumber:function(e){return e?e.replace(p,l):e},formatPhoneNumber:function(e){var t=e?e.replace(p,l):e;return t=m(t),t&&"+"!==t.substr(0,1)&&(t="+"+t),t},trim:m,formatBirthdate:g,docType:function(e){var t=e?e.toUpperCase().replace(f,l):e;return t},removeNonLetters:function(e){return e?e.replace(u,l):e},removeNonNumbers:function(e){return e.replace(p,l)},translate:function(e){return e?m(e.toUpperCase().replace(/./g,function(e){return"undefined"!=typeof o.alpha[e]?o.alpha[e]:e}).replace(s,l)):e},enToRU:function(e){return e?m(e.toLowerCase().replace(/./g,function(e){return o.enToRu[e]||e}).replace(s,l)):e},passportNumber:function(e){return e?e.toUpperCase().replace(/./g,function(e){return"undefined"!=typeof o.alpha[e]?o.alpha[e]:e}).replace(h,l):e}}},function(e,t,n){function r(e,t,n){if(e=s(e),!e)return e;if(n||void 0===t)return e.replace(u,"");if(!(t+=""))return e;var r=a(e),l=o(r,a(t));return i(r,l).join("")}var i=n(482),o=n(484),a=n(487),s=n(488),u=/^\s+/;e.exports=r},function(e,t,n){function r(e,t,n){var r=e.length;return n=void 0===n?r:n,!t&&n>=r?e:i(e,t,n)}var i=n(483);e.exports=r},function(e,t){function n(e,t,n){var r=-1,i=e.length;0>t&&(t=-t>i?0:i+t),n=n>i?i:n,0>n&&(n+=i),i=t>n?0:n-t>>>0,t>>>=0;for(var o=Array(i);++r<i;)o[r]=e[r+t];return o}e.exports=n},function(e,t,n){function r(e,t){for(var n=-1,r=e.length;++n<r&&i(t,e[n],0)>-1;);return n}var i=n(485);e.exports=r},function(e,t,n){function r(e,t,n){if(t!==t)return i(e,n);for(var r=n-1,o=e.length;++r<o;)if(e[r]===t)return r;return-1}var i=n(486);e.exports=r},function(e,t){function n(e,t,n){for(var r=e.length,i=t+(n?0:-1);n?i--:++i<r;){var o=e[i];if(o!==o)return i}return-1}e.exports=n},function(e,t){function n(e){return e.match(A)}var r="\\ud800-\\udfff",i="\\u0300-\\u036f\\ufe20-\\ufe23",o="\\u20d0-\\u20f0",a="\\ufe0e\\ufe0f",s="["+r+"]",u="["+i+o+"]",l="\\ud83c[\\udffb-\\udfff]",c="(?:"+u+"|"+l+")",d="[^"+r+"]",p="(?:\\ud83c[\\udde6-\\uddff]){2}",f="[\\ud800-\\udbff][\\udc00-\\udfff]",h="\\u200d",v=c+"?",y="["+a+"]?",g="(?:"+h+"(?:"+[d,p,f].join("|")+")"+y+v+")*",m=y+v+g,_="(?:"+[d+u+"?",u,p,f,s].join("|")+")",A=RegExp(l+"(?="+l+")|"+_+m,"g");e.exports=n},function(e,t,n){function r(e){if("string"==typeof e)return e;if(null==e)return"";if(o(e))return u?u.call(e):"";var t=e+"";return"0"==t&&1/e==-a?"-0":t}var i=n(489),o=n(493),a=1/0,s=i?i.prototype:void 0,u=s?s.toString:void 0;e.exports=r},function(e,t,n){var r=n(490),i=r.Symbol;e.exports=i},function(e,t,n){(function(e,r){var i=n(492),o={"function":!0,object:!0},a=o[typeof t]&&t&&!t.nodeType?t:void 0,s=o[typeof e]&&e&&!e.nodeType?e:void 0,u=i(a&&s&&"object"==typeof r&&r),l=i(o[typeof self]&&self),c=i(o[typeof window]&&window),d=i(o[typeof this]&&this),p=u||c!==(d&&d.window)&&c||l||d||Function("return this")();e.exports=p}).call(t,n(491)(e),function(){return this}())},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children=[],e.webpackPolyfill=1),e}},function(e,t){function n(e){return e&&e.Object===Object?e:null}e.exports=n},function(e,t,n){function r(e){return"symbol"==typeof e||i(e)&&s.call(e)==o}var i=n(494),o="[object Symbol]",a=Object.prototype,s=a.toString;e.exports=r},function(e,t){function n(e){return!!e&&"object"==typeof e}e.exports=n},function(e,t,n){(function(t){"use strict";var r=n(104).default,i=n(496).default,o={fareFamily:{brands:{Basic_econom:"Базовый Эконом",Flex_econom:"Гибкий Эконом",Basic_business:"Базовый Бизнес",Flex_business:"Гибкий Бизнес",Light_econom:"Лайт Эконом",Flex_econom_UT:"Промо Эконом",Light_econom_UT:"Лайт Эконом"},services:{refund:"Возврат билета",changes_fee:"Обмен",change:"Изменение тарифа",cabin:"Ручная кладь",baggage:"Багаж",busines_lounge:"Бизнес-зал"},serviceTitles:{"10kg":"10 кг.","15kg":"15 кг.","1pc23kg":"1 место 23 кг.","1pc32kg":"1 место 32 кг.","2pc32kg":"2 место 32 кг."},change:{ru:"Изменить",en:"Change"},select:{ru:"Выбрать",en:"Select"},selected:{ru:"Выбрано",en:"Selected"},enable:{ru:"Разблокировать",en:"Enable"},allowed:{ru:"Разрешен",en:"Allowed"},notAllowed:{ru:"Запрещен",en:"Not Allowed"},allowedWithFee:{ru:"Разрешен со сбором",en:"A separate fee applies"},selectedFare:{ru:"Выбранный тариф:",en:"Your selected fare:"},actionTitle:{ru:"Лучшие условия",en:"The maximum"},actionCaption:{ru:"для комфортного полёта",en:"flight convenience"},chooseFare:{ru:"Выберите тариф {aircompany}",en:"Select an {aircompany} fare"},chooseFareRT:{ru:"Выберите тариф {aircompany} или OneTwoTrip",en:"Select a OneTwoTrip or {aircompany} fare"}},links:{SignIn:{en:"Sign In",ru:"Авторизоваться"},SignOut:{en:"Sign Out",ru:"выйти"},About:{en:"About us",ru:"О компании"},Support:{en:"Help and Support",ru:"Помощь"},Bonus:{en:"Bonus",ru:"Программа лояльности"},Legal:{en:"Customer Agreement",ru:"Соглашение с пользователем"},Privacy:{en:"Privacy",ru:"Конфиденциальность"}},footer:{Copyright:{en:"The contents of this website are subject to copyright. ©2015 OneTwoTrip Ltd. All rights reserved. No contents of this website may be copied, used, distributed or modified. OneTwoTrip shall not be held liable for the content of any external websites.",ru:"Содержимое сайта является объектом авторских прав. ©2015 OneTwoTrip Ltd. Все права защищены. Запрещается копировать, использовать, распространять, модифицировать любое содержимое этого сайта. OneTwoTrip не несет ответственность за контент, предоставленный на внешних сайтах."},PressWritesAboutUs:{en:"Press writes about us",ru:"Пресса пишет о нас"}},buttons:{flightsBook:{prev:{lookAndChoose:{en:"look and choose",ru:"посмотреть и выбрать"},OtherListings:{en:"Other listings",ru:"Другие варианты"}},next:{Book:{en:"Book",ru:"Забронировать"},andProceedToCheckout:{en:"and proceed to checkout",ru:"и перейти к оплате"}}}},ServiceClasses:{Economy:{ru:"Эконом",en:"Economy"},Premium:{ru:"Премиум",en:"Premium"},Business:{ru:"Бизнес",en:"Business"},First:{ru:"Первый",en:"First"},Mixed:{ru:"Смешанный",en:"Mixed"}},FlightsPay:{Passengers:{OrderInfo:{ru:"Билеты забронированы. Оплатите в течение ",en:"Билеты забронированы. Оплатите в течение "},AdditionalOptions:{ru:"Дополнительные опции",en:"Дополнительные опции"}},VAS:{Checkbox:{Title:{ru:"Включить в заказ",en:""},Price:{ru:"за все рейсы",en:"за все рейсы"}},Notification:{Title:{ru:"Ранняя информация о переносе или отмене вашего рейса",en:"Ранняя информация о переносе или отмене вашего рейса"},Description:{ru:"Авиакомпании иногда вносят изменения в расписание задолго до вылета. Воспользуйтесь SMS/E-mail информированием чтобы быть в курсе:",en:"Авиакомпании иногда вносят изменения в расписание задолго до вылета. Воспользуйтесь SMS/E-mail информированием чтобы быть в курсе:"},FlightDateChange:{ru:"Изменения даты вылета рейса",en:"Flight DateFormated Change"},FlightTimeChange:{ru:"Изменения времени вылета рейса",en:"Flight Time Change"},FlightCancellation:{ru:"Отмены рейса",en:"Flight Cancellation"}},Insurance:{Title:{ru:"Страхование стоимости поездки до 40 000 руб",en:"Страхование стоимости поездки до {} на пассажира"},Disease:{ru:"Если вы или член вашей семьи заболеет и не сможете улететь",en:"Если вы или член вашей семьи заболеет и не сможете улететь"},DelayOrCancellation:{ru:"Если авиакомпания задержит или отменит рейс",en:"Если авиакомпания задержит или отменит рейс"},LaggageLost:{ru:"Если в аэропорту будет утерян ваш багаж и тд.",en:"Если в аэропорту будет утерян ваш багаж и тд."},ShowAllOptions:{ru:"посмотреть все условия",en:"посмотреть все условия"}},Compensation:{Title:{ru:"100% компенсация стоимости билетов при смене планов",en:"100% компенсация стоимости билетов при смене планов"},Text:{ru:"Иногда планы меняются. Но по правилам авиакомпании, в случае добровольного возврата, ваши билеты являются невозвратными. Воспользуйтесь услугой компенсации стоимости билетов от OneTwoTrip, чтобы не потерять деньги если ваши планы изменились.",
en:"Иногда планы меняются. Но по правилам авиакомпании, в случае добровольного возврата, ваши билеты являются невозвратными. Воспользуйтесь услугой компенсации стоимости билетов от OneTwoTrip, чтобы не потерять деньги если ваши планы изменились."}},ReservationLock:{Button:{ru:"Продлить ожидание оплаты",en:"Продлить ожидание оплаты"},Title:{ru:"Внимание! Ваши билеты забронированы.",en:"Внимание! Ваши билеты забронированы."}},AllInclusive:{Title:{ru:"Пакет путешествие без забот",en:"Пакет путешествие без забот"},Text:{ru:"«путешествие без забот»",en:"«путешествие без забот»"}}},Payment:{Variants:{card:"Банковской картой",cash:"Оплата наличными",account:"Накопительный счет",gds:"картой Visa или MasterCard напрямую в авиакомпанию",gds2:"картой напрямую в авиакомпанию",payture:"картой Visa или MasterCard в авиакомпанию через OneTwoTrip",payture2:"картой в авиакомпанию через OneTwoTrip",payture_r:"картой Visa или MasterCard в авиакомпанию через OneTwoTrip",payture_r_eur:"картой Visa или MasterCard в авиакомпанию через OneTwoTrip",payu_try:"картой Visa или MasterCard в авиакомпанию через OneTwoTrip",payture_r_rub:"картой Visa или MasterCard в авиакомпанию через OneTwoTrip",payture_r_usd:"картой Visa или MasterCard в авиакомпанию через OneTwoTrip",payture_r_gbp:"картой Visa или MasterCard в авиакомпанию через OneTwoTrip",payture_p:"картой Visa или MasterCard в авиакомпанию через OneTwoTrip",payture_rapida:"картой Visa или MasterCard в авиакомпанию через OneTwoTrip",payture_otk:"картой Visa или MasterCard в авиакомпанию через OneTwoTrip",payture_kz:"картой Visa или MasterCard в авиакомпанию через OneTwoTrip",payture_privat_uah:"картой Visa или MasterCard в авиакомпанию через OneTwoTrip",aviasales_discounted:"картой Visa или MasterCard в ЕВРО",ua_cards:"картой Visa или MasterCard в авиакомпанию через OneTwoTrip",freeze:"первый платёж, остаток необходимо оплатить в течение",ua_cards_pb:"картой Visa или MasterCard в авиакомпанию через OneTwoTrip",ott_amex:"American Express",maestro:"картой Maestro через OneTwoTrip",maestro_eur:"картой Maestro через OneTwoTrip",visa_credit:"кредитной картой Visa через OneTwoTrip",visa_debit:"картой Visa Debit через OneTwoTrip",payture_mv_uk:"Visa or MasterCard UK Debit Card",payture_mv_eu:"Visa or MasterCard UK Credit Card and EU Debit or Credit Card",payture_mv_int:"any other Visa or MasterCard",payture_maestro_uk:"Maestro",payture_vpay:"V PAY",payture_mv_uk_EUR:"Visa or MasterCard IE Debit Card",payture_mv_eu_EUR:"Visa or MasterCard IE Credit Card and EU Debit or Credit Card",payture_mv_int_EUR:"any other Visa or MasterCard",payture_maestro_uk_EUR:"Maestro",payture_vpay_EUR:"V PAY",payture_mv_uk_USD:"Visa or MasterCard US Debit Card",payture_mv_eu_USD:"Visa or MasterCard US Credit Card and EU Debit or Credit Card",payture_mv_int_USD:"any other Visa or MasterCard",payture_maestro_uk_USD:"Maestro",payture_vpay_USD:"V PAY","711ua":"Киев, ул. Димитрова, 5 тел. (044) 393 43 55",account_full:"Оплатить полностью со счёта",refund_account:"Оплатить с накопительного счёта",difference:"в чём разница"}}},ReservationTotal:{tickets:{ru:"Билеты",en:"Билеты"},insurance:{ru:"Защита поездки",en:"Защита поездки"},notification:{ru:"Информирование об изменениях",en:"Информирование об изменениях"},tax:{ru:"Агентское вознаграждение",en:"Агентское вознаграждение"},cabinet:{ru:"Онлайн доступ к заказу",en:"Онлайн доступ к заказу"},email:{ru:"Отправка билета на эл.почту",en:"Отправка билета на эл.почту"},compensation:{ru:"Компенсация стоимости билета при изменении планов",en:"Компенсация стоимости билета при изменении планов"},compensationOttRefund:{ru:"Тариф «OneTwoTrip Возврат»",en:"Тариф «OneTwoTrip Возврат»"},allInclusive:{ru:"Путешествие без забот",en:"Путешествие без забот"},onlineCheckin:{ru:"Электронная регистрация на рейс",en:"Электронная регистрация на рейс"},total:{ru:"Итого",en:"Итого"}},FlightsRoute:{returnRefundConditions:{en:"return/refund conditions",ru:"условия обмена/возврата"},Flight:{flightClass:{Economy:{en:"Economу",ru:"Эконом"},Premium:{en:"Premium",ru:"Премиум"},Business:{en:"Business",ru:"Бизнес"},First:{en:"First",ru:"Первый"},Mixed:{en:"Mixed",ru:"Смешанный"}},BaggageInfo:{en:"Baggage info",ru:"Информация по багажу"},airport:{en:"airport",ru:"аэропорт"},duration:{en:"duration",ru:"в пути"},AdditionalInfo:{statistics:{en:"statistics",ru:"статистика"},operatedBy:{en:"operated by",ru:"выполняет"},transfer:{single:{en:"transfer",ru:"пересадка"},plural:{en:"transfers",ru:"пересадки"}},More:{en:"More",ru:"Подробнее"}}},Transfer:{transferType:{changeTerminal:{ru:"смена терминала"},changeAirport:{ru:"смена аэропорта"},nightTransfer:{ru:"ночная пересадка"},nightTransferAndAirportChange:{ru:"ночная пересадка + смена аэропорта"}},TransferIn:{ru:"Пересадка в г."}}},ToggleButton:{onText:{ru:"Добавить",en:"Добавить"},offText:{ru:"Убрать",en:"Убрать"}},paymentCard:{title:{ru:"Дебетовая или кредитная карта",en:"Дебетовая или кредитная карта"}}};t.___i18n=o;var a=self.document.documentElement.lang.substring(0,2),s=function u(e){for(var t,n,o,s=r(e),l=s.length;l--;)t=s[l],n=e[t],o=typeof n,"object"===o&&(n[a]?i(e,t,{value:n[a]}):u(n))};s(o),e.exports=o}).call(t,function(){return this}())},function(e,t,n){e.exports={"default":n(497),__esModule:!0}},function(e,t,n){var r=n(29);e.exports=function(e,t,n){return r.setDesc(e,t,n)}},function(e,t,n){var r,i=n(464),o=n(465).default,a=n(470).default,s=n(474).default,u=n(104).default,l={},c=n(475),d=n(476),p=n(499),f=n(503),h=n(505),v=n(652),y=n(549),g=n(553),m=n(644),_=n(664),A=n(665),C=function(e,t){if("undefined"!=typeof ref)return ref.getCityNameByCode(e)+" - "+ref.getCityNameByCode(t);var n=function(e){var t=___airports[e].city,n=t?___cities[t].name:___cities[e].name;return n};return n(e)+" - "+n(t)},b=function(e){var t=e.fare,n=e.trips,r=e.brands,i=e.rates,a=n.map(function(e){return o({},e,{fltTm:e.flightTime,stDt:e.startDate,stTm:e.startTime,endTm:e.endTime,conx:e.continued})}),s=v(a),u=m(g(t.trips,"brandId")),l=Math.ceil(A(t.priceInfo.adtAmountWC,t.priceInfo.currency,_,i)),c=s.map(function(e,t){var n=e.segmentsList.length,i=e.segmentsList[0].fromMap.airportCode,o=e.segmentsList[n-1].toMap.airportCode,a=r.filter(function(e){return e.id===(u[t]||y(u))}),s=a[0];s=s?s:r[0];var l=s.tagName;return{location:C(i,o),serviceClass:l}});return o({},t,{price:l,currency:_,tripsInfo:c})},S=function(e){function t(n,r){s(this,t),e.call(this,n,r),this.onToggleHover=this.onToggleHover.bind(this),this.onChooseFare=this.onChooseFare.bind(this),this.onChoose=this.onChoose.bind(this),this.state={}}return a(t,e),t.prototype.onToggleHover=function(){var e=this.state.isHover;this.setState({isHover:!e})},t.prototype.onChooseFare=function(e){var t=e.fare,n=e.idx;t.index=n,this.setState({fare:t}),this.props.onChooseFare(n)},t.prototype.onChoose=function(e){var t=this.props,n=t.fareFamily,r=t.fareFamily.ffSearchId,i=t.onCloseModal,o=t.onChangeFare,a=e&&"undefined"!=typeof e.idx?e.fare:this.state.fare,s=y(m(g(a.trips,"brandId"))),u=e.idx,l=n.brands[s].tag;e&&e.idx&&(a.index=e.idx),"undefined"!=typeof store&&store.pub("fareFamilyChangeFare",a),o(a),i(),this.props.postChooseFare({extra:{event:"ff_click_upgrade",upgradeLevel:u,upgradeName:l,ffSearchId:r},params:this.props.requestParams})},t.prototype.render=function(){var e=this,t=this.props,n=t.listBrandsByAircompany,o=t.fareFamily,a=o.fares,s=o.brands,d=o.trips,v=o.rates,y=o.onCloseModal,g=o.brandsByAirCompanies,m=this.props.choosenFare||0,_=this.state.isHover,A=void 0,C=void 0,S=u(g).length>1,M=n.map(function(t,n){return i(h,{key:n,onCloseModal:y,onChoose:e.onChooseFare,fareFamily:t,choosenFare:m})});S?A=a.map(function(t,n){var r=b({fare:t,trips:d,brands:s,rates:v});return i(f,{key:n,onChoose:e.onChooseFare,isChecked:m===n,idx:n,m:a.length+"Cell",onCloseModal:y,price:r.price,tripsInfo:r.tripsInfo,fare:t})}):C=i("div",{e:"shortButton",style:(r="FareFamilyModal__shortButton",l[r]||(l[r]=c(r)))},a.map(function(t,n){var r=b({fare:t,trips:d,brands:s,rates:v}),o=n===m;return i(p,{key:n,idx:n,onChoose:e.onChoose,countBrands:s.length,price:r.price,currency:r.currency,fare:t,isSelected:o})}));var T=S&&i("div",{className:"FareFamilyModalSubmit",onMouseEnter:this.onToggleHover,onMouseLeave:this.onToggleHover,onClick:this.onChoose,e:"choose",m:{isHover:_},style:(r="FareFamilyModal__choose",l[r]||(l[r]=c(r)))},"Выбрать");return i("div",{b:"FareFamilyModal",className:"FareFamilyModal",style:(r="FareFamilyModal",l[r]||(l[r]=c(r)))},i("div",{e:"buttons",className:"FareFamilyModalBtns",style:(r="FareFamilyModal__buttons",l[r]||(l[r]=c(r)))},S&&A),i("div",{e:"area",className:"FareFamilyModalArea",style:(r="FareFamilyModal__area",l[r]||(l[r]=c(r)))},M,i("div",{e:"fade"})),C,T)},t}(d);S.defaultProps={},e.exports=S},function(e,t,n){var r,i=n(464),o=n(470).default,a=n(474).default,s={},u=n(475),l=n(476),c=n(500),d=n(501),p=n(495),f=function(e){function t(n,r){a(this,t),e.call(this,n,r),this.onChoose=this.onChoose.bind(this),this.onMouseEnter=this.onMouseEnter.bind(this),this.onMouseLeave=this.onMouseLeave.bind(this),this.state={}}return o(t,e),t.prototype.onChoose=function n(){var e=this.props,t=e.fare,n=e.onChoose,r=e.idx;n({fare:t,idx:r})},t.prototype.onMouseEnter=function(){this.setState({isHover:!0})},t.prototype.onMouseLeave=function(){this.setState({isHover:!1})},t.prototype.render=function(){var e=this.props,t=e.price,n=e.currency,o=e.m,a=e.idx,l=e.countBrands,f=e.isSelected,h=this.state.isHover,v=0===a,y=1===l,g=2===l;return i("div",{b:"ChooseButtonShort",m:{isFirstNode:v,isOneBrand:y,isTwoBrand:g,isSelected:f,m:o},style:(r="ChooseButtonShort"+(y?" ChooseButtonShort--isOneBrand":"")+(g?" ChooseButtonShort--isTwoBrand":"")+(v?" ChooseButtonShort--isFirstNode":""),s[r]||(s[r]=u(r)))},i("div",{e:"inner",style:(r="ChooseButtonShort__inner",s[r]||(s[r]=u(r)))},i("div",{e:"price",style:(r="ChooseButtonShort__inner__price",s[r]||(s[r]=u(r)))},i(d,{amount:t,currency:n})),i("div",{onMouseEnter:this.onMouseEnter,onMouseLeave:this.onMouseLeave,onClick:this.onChoose,e:"btn",m:{isHover:h},style:(r="ChooseButtonShort__inner__btn"+(f?" ChooseButtonShort--isSelected__inner__btn":"")+(h?" ChooseButtonShort__inner__btn--isHover":""),s[r]||(s[r]=u(r)))},i(c,{w:16,fill:"#009ADD",e:"icon",style:(r="ChooseButtonShort__inner__btn__icon"+(f?" ChooseButtonShort--isSelected__inner__btn__icon":""),s[r]||(s[r]=u(r)))}),f?p.fareFamily.selected:p.fareFamily.select)))},t}(l);f.defaultProps={},e.exports=f},function(e,t,n){function r(e){var t=e.w,n=e.style;return i("svg",{style:n,width:t,height:t,viewBox:"0 0 17 13",preserveAspectRatio:"xMinYMin",xmlns:"http://www.w3.org/2000/svg"},i("path",{d:"M5.6,10.6L1.4,6.4L0,7.8l5.6,5.6l12-12L16.2,0L5.6,10.6z"}))}var i=n(464);r.defaultProps={w:17,h:13},e.exports=r},function(e,t,n){var r,i=n(464),o=n(470).default,a=n(474).default,s={},u=n(475),l=n(476),c=n(502),d=function(e){function t(n,r){a(this,t),e.call(this,n,r)}return o(t,e),t.prototype.render=function(){var e=this.props,t=e.currency,n=void 0===t?"RUB":t,o=e.amount,a=void 0===o?0:o,l=e.isFat,d=void 0===l?!1:l,p=e.style;return i("span",{b:"Money",m:{isFat:d},style:p},i("span",{e:"text",style:(r="Money__text"+(d?" Money--isFat__text":""),s[r]||(s[r]=u(r)))},c[n](a)))},t}(l);e.exports=d},function(e,t){"use strict";var n="ru",r=Intl.NumberFormat,i={RUB:new r(n,{style:"currency",currencyDisplay:"symbol",minimumFractionDigits:0,maximumFractionDigits:0,currency:"RUB"}).format,UAH:new r(n,{style:"currency",currencyDisplay:"symbol",minimumFractionDigits:0,maximumFractionDigits:0,currency:"UAH"}).format,USD:new r(n,{style:"currency",currencyDisplay:"symbol",minimumFractionDigits:0,maximumFractionDigits:2,currency:"USD"}).format,EUR:new r(n,{style:"currency",currencyDisplay:"symbol",minimumFractionDigits:0,maximumFractionDigits:2,currency:"EUR"}).format,GBP:new r(n,{style:"currency",currencyDisplay:"symbol",minimumFractionDigits:0,maximumFractionDigits:2,currency:"GBP"}).format,KZT:new r(n,{style:"currency",currencyDisplay:"symbol",minimumFractionDigits:0,maximumFractionDigits:2,currency:"KZT"}).format};e.exports=i},function(e,t,n){var r,i=n(464),o=n(470).default,a=n(474).default,s={},u=n(475),l=n(476),c=n(501),d=n(504),p=function(e){function t(n,r){a(this,t),e.call(this,n,r),this.onChoose=this.onChoose.bind(this)}return o(t,e),t.prototype.onChoose=function n(){var e=this.props,t=e.fare,n=e.onChoose,r=e.idx;n({fare:t,idx:r})},t.prototype.render=function(){var e=this.props,t=e.price,n=e.tripsInfo,o=e.isChecked,a=e.m,l=(e.idx,n.map(function(e,t){return i("div",{key:t,e:"wrap"},i("div",{e:"location",style:(r="ChooseButton__inner__flight__wrap__location",s[r]||(s[r]=u(r)))},e.location),i("div",{e:"class"},e.serviceClass))}));return i("div",{b:"ChooseButton",m:{m:a},style:(r="ChooseButton"+(a?" ChooseButton--m-"+a:""),s[r]||(s[r]=u(r)))},i("div",{e:"inner",style:(r="ChooseButton__inner",s[r]||(s[r]=u(r)))},i("div",{onClick:this.onChoose,e:"price",style:(r="ChooseButton__inner__price",s[r]||(s[r]=u(r)))},i("span",{e:"radio",style:(r="ChooseButton__inner__price__radio",s[r]||(s[r]=u(r)))},i(d,{w:16,isChecked:o})),i(c,{amount:t})),i("div",{e:"flight",style:(r="ChooseButton__inner__flight",s[r]||(s[r]=u(r)))},l)))},t}(l);p.defaultProps={},e.exports=p},function(e,t,n){function r(e){var t=e.w,n=e.style,r=e.isChecked;return i("svg",{style:n,width:t,height:t,viewBox:"0 0 24 24",preserveAspectRatio:"xMinYMin",xmlns:"http://www.w3.org/2000/svg"},i("path",{d:r?a:o,fill:"currentColor"}))}var i=n(464),o="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z",a="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z";r.defaultProps={w:22,isChecked:!1},e.exports=r},function(e,t,n){var r,i=n(464),o=n(470).default,a=n(474).default,s={},u=n(475),l=n(476),c=n(506),d=n(509),p=n(510),f=n(548),h=n(500),v=n(480).capitalize,y=n(508),g=n(549),m=n(553),_=n(644),A=n(495),C=function(e){function t(n,r){a(this,t),e.call(this,n,r),this.state={}}return o(t,e),t.prototype.checkIcon=function(e){return e?i(h,{w:16,style:{fill:"#afb42b"}}):i(f,{w:16,style:{fill:"#f05236"}})},t.prototype.checkIconWithTooltip=function(e,t){if(e){var n=this.checkIcon(e);return i("div",{style:{position:"relative"}},n,i("div",{style:{display:"inline-block",position:"absolute",top:"-2px",right:"8px",bottom:"0"}},i(p,{trigger:i("span",null,i(d,null)),container:this,hoverable:!1,placement:"bottom",closeOnOutsideClick:!0},i("div",{style:{position:"absolute",width:300,height:"auto",padding:"16px",background:"white",boxShadow:"0 8px 20px -6px rgba(0,0,0,.2), 0 1px 2px rgba(0,0,0,.1), 0 0 1px rgba(0,0,0,.1)"}},t))))}return this.checkIcon(e)},t.prototype.render=function(){var e=this,t=this.props.fareFamily,n=t.aircompany,o=t.fares,a=t.brands,l=t.availableServices,d=o.map(function(e){return _(m(e.trips,"brandId"))}),p=a.some(function(e){return"Agency Refund"===e.tag}),h=this.props.choosenFare||0,C=1===a.length,b=2===a.length,S=y[n]||n,M=i("td",{e:"cell",m:{isAircompany:!0},style:(r="FareInfo__row__cell FareInfo__row__cell--isAircompany",s[r]||(s[r]=u(r)))},i("div",{e:"inner",style:(r="FareInfo__row__cell__inner FareInfo__row__cell--isAircompany__inner",s[r]||(s[r]=u(r)))},i(c,{text:(p?A.fareFamily.chooseFareRT:A.fareFamily.chooseFare).replace(/{aircompany}/g,S),airlineCode:n}))),T=d.map(function(e,t){var n=a[g(e)],o=t===h;return i("td",{key:t,e:"cell",m:{isOneBrand:C,isTwoBrand:b,isHeaderSelected:o},style:(r="FareInfo__row__cell"+(C?" FareInfo__row__cell--isOneBrand":"")+(b?" FareInfo__row__cell--isTwoBrand":""),s[r]||(s[r]=u(r)))},i("div",{e:"inner",style:(r="FareInfo__row__cell__inner"+(o?" FareInfo__row__cell--isHeaderSelected__inner":""),s[r]||(s[r]=u(r)))},i("div",{e:"wrapper",style:(r="FareInfo__row__cell__inner__wrapper",s[r]||(s[r]=u(r)))},n.tagName)))}),E=l.map(function(t,n){var o=d.map(function(n,o){var l=o===h,c=a[g(n)],d=c.services.filter(function(e){return e.tag===t.tag})[0],v=void 0;if(d)switch(d.valueType){case"string":v=d.value;break;case"tag":v=d.value;break;case"boolean":v=p&&"Refund"===d.tag&&d.shortDescription?e.checkIconWithTooltip(d.value,d.shortDescription):e.checkIcon(d.value)}else v=i(f,{w:16,style:{fill:"#f05236"}});return i("td",{key:o,e:"cell",m:{isOneBrand:C,isTwoBrand:b,isSelected:l},style:(r="FareInfo__row__cell"+(C?" FareInfo__row__cell--isOneBrand":"")+(b?" FareInfo__row__cell--isTwoBrand":""),s[r]||(s[r]=u(r)))},i("div",{e:"inner",style:(r="FareInfo__row__cell__inner",s[r]||(s[r]=u(r)))},v))});return i("tr",{key:n,e:"row",style:(r="FareInfo__row",s[r]||(s[r]=u(r)))},i("td",{e:"cell",m:"isCaption",style:(r="FareInfo__row__cell FareInfo__row__cell--isCaption",s[r]||(s[r]=u(r)))},i("div",{e:"inner",style:(r="FareInfo__row__cell__inner FareInfo__row__cell--isCaption__inner",s[r]||(s[r]=u(r)))},v(t.tagName))),o)});return i("div",null,i("table",{b:"FareInfo",className:"FareFamilyModalList",style:(r="FareInfo",s[r]||(s[r]=u(r)))},i("thead",null,i("tr",{e:"row",style:(r="FareInfo__row",s[r]||(s[r]=u(r)))},M)),i("tbody",null,i("tr",{e:"row",style:(r="FareInfo__row",s[r]||(s[r]=u(r)))},i("td",{e:"cell",m:"isCaption",style:(r="FareInfo__row__cell FareInfo__row__cell--isCaption",s[r]||(s[r]=u(r)))},i("div",{e:"inner",style:(r="FareInfo__row__cell__inner FareInfo__row__cell--isCaption__inner",s[r]||(s[r]=u(r)))})),T),E)))},t}(l);C.defaultProps={},e.exports=C},function(e,t,n){var r,i,o=n(464),a=n(470).default,s=n(474).default,u={},l=n(475),c=n(476),d=n(507),p=function(e){function t(n,r){s(this,t),e.call(this,n,r)}return a(t,e),t.prototype.render=function(){var e=this.props,t=e.text,n=e.airlineCode,a=e.onRulesLinkClick,s=a&&o("div",{e:"rulesLink",onClick:a,style:(r="AirlineHead__inner__content__rulesLink",u[r]||(u[r]=l(r)))},"Правила обмена и возврата"),c=t?o("span",null,t):o(d,{airlineCode:n});return o("div",{b:"AirlineHead",m:{airlineCode:n,hasText:!!t},style:(r="AirlineHead"+(n?" AirlineHead--airlineCode-"+n:"")+(t?" AirlineHead--hasText":""),i=u[r]||(u[r]=l(r)),i.backgroundImage="url(/images/ak/big/"+n+".png)",i)},o("div",{e:"inner",style:(r=n?"AirlineHead--airlineCode-"+n+"__inner":"",u[r]||(u[r]=l(r)))},o("div",{e:"content",style:(r="AirlineHead__inner__content"+(t?" AirlineHead--hasText__inner__content":""),u[r]||(u[r]=l(r)))},o("div",{e:"title",style:(r="AirlineHead__inner__content__title",u[r]||(u[r]=l(r)))},c),s)))},t}(c);e.exports=p},function(e,t,n){var r=n(464),i=n(508);e.exports=function(e){var t=e.style,n=e.airlineCode;return r("span",{style:t},i[n]||n)}},function(e,t){(function(t){var n={"0A":"Amber Air","0B":"Blue Air","0D":"Darwin Airlines","0J":"Jetclub","0V":"Vietnam Air Services Company","0Y":"FlyYeti","1A":"Amadeus IT Group SA","1B":"Abacus International Pte.","1C":"Hewlett-Packard (Schweiz)","1D":"Radixx Solutions International","1E":"Travelsky Technology Limited","1F":"INFINI Travel Information","1G":"Travelport Global Distribution System","1H":"Sirena-Travel","1I":"NetJets","1J":"Axess International Network","1K":"Sutra","1M":"JSC Transport Automated Information","1N":"Navitaire","1P":"Worldspan","1R":"Bird Information Systems Private Li","1S":"Sabre","1T":"Bulgarian Air Charter","1U":"ITA Software","1V":"Galileo International","1X":"Fly Branson Travel","1Y":"Electronic Data Systems Corporation","1Z":"Sabre Pacific","2A":"Deutsche Bahn AG","2B":"Ak Bars Aero","2C":"SNCF","2D":"Dynamic Airways","2E":"AVE.com","2F":"Frontier Flying Service","2G":"Angara Airlines","2H":"Thalys International","2I":"Star Peru","2J":"Air Burkina","2K":"Avianca Ecuador","2L":"Helvetic Airways","2M":"Moldavian Airlines","2N":"NextJet","2O":"Island Air Service","2P":"Air Philippines Corporation","2Q":"AviTrans","2U":"Sun d'Or International Airlines","2V":"Amtrak","2W":"Welcome Air","2X":"XEROX","2Y":"PT. My Indo Airlines","2Z":"Passaredo Linhas Aereas","3A":"Kenosha Aero","3B":"Central Connect Airlines","3C":"Corporate Express Airlines","3D":"Denim Air","3E":"Multi-Aero","3F":"Pacific Airways","3G":"Gading Sari Aviation Sdn Bhd.","3H":"Air Inuit","3J":"Jubba Airways","3K":"Jetstar Asia","3L":"InterSky","3M":"Silver Airways","3N":"Air Urga","3O":"Air Arabia Maroc","3Q":"Carib Aviation","3R":"Moskovia Airlines","3S":"Air Antilles Express","3T":"Tarco Airlines","3U":"Sichuan Airlines","3V":"TNT Airways","3W":"Malawian Airlines","3X":"Premier Trans Aire","3Y":"Baseops International","3Z":"Travel Service Polska Sp. z.o.o.","4A":"Royal Bengal Airlines","4B":"Boutique Air","4C":"LAN Colombia","4D":"Air Sinai","4E":"Stabo Air Limited","4F":"Air City","4G":"Gazpromavia","4H":"United Airways","4I":"IHY Izmir Havayollari A.S.","4J":"Flydamas Airlines","4K":"Kenn Borek Air","4L":"Georgian Int. Airlines","4M":"LAN Argentina","4N":"Air North","4O":"Interjet","4P":"Viking Airlines","4Q":"Safi Airways","4R":"Royal Flight","4S":"Solar Cargo C.A.","4T":"Belair Airlines","4U":"Germanwings","4V":"Birdy Airlinesce","4W":"Allied Air","4X":"Romavia","4Y":"Flight Alaska","4Z":"Airlink","5A":"Alpine Air Express","5B":"Euro-Asia Air","5C":"Nature Air","5D":"Aeroméxico Connect","5E":"Siam General Aviation","5F":"Fly One","5G":"Skyservice Airlines","5H":"Fly540","5I":"Alsa Grupo SLU","5J":"CEBU Pacific Air","5K":"Hi Fly Transportes Aereos S.A.","5L":"Aerosur","5M":"Montserrat Airways","5N":"Nordavia","5O":"Europe Airpost","5P":"SkyEurope Airlines Hungary","5Q":"LOS CIPRESES S.A.","5R":"Rutas Aereas C.A.","5S":"Servicios Aereos Profesionales S.A.","5T":"Canadian North","5U":"Transportes Aereos Guatemaltecos S.","5V":"Everts Air Alaska","5W":"WESTbahn Management","5X":"UPS Airlines","5Y":"Skybus","5Z":"CemAir","6A":"Armenia Airways","6B":"TUIfly Nordic","6C":"Air Timor S.A.","6D":"Travel Service Slovakia","6E":"IndiGo Airlines","6F":"Falcon Air Express","6G":"Sun Air Express","6H":"Israir Airlines","6I":"Air Alsie","6J":"Solaseed Air","6K":"Sky King","6L":"Aklak","6M":"EuroAir","6N":"Al-Naser Airlines","6O":"Orbest","6P":"Clubair Sixgo","6Q":"Slovak Airlines","6R":"Alrosa","6S":"Kato Airline","6T":"Air Mandalay","6U":"Unique Air","6V":"MRK Airlines","6W":"Saravia","6Y":"SmartLynx Airlines Estonia","6Z":"Euro-Asia Air","7A":"Air Jet","7B":"Atlant-Soyuz Airlines","7C":"Jeju Air","7D":"Donbassaero Airlines","7E":"Sylt Air","7F":"First Air","7G":"Starflyer","7H":"Ravn Alaska","7I":"Insel Air","7J":"Tajik Air","7K":"Kolavia","7L":"Silk Way West Airlines","7M":"Mistral Air","7N":"Pan American World Airways","7O":"Travel Service Hungary","7P":"Air Panama","7Q":"Elite Airways","7R":"Rusline","7S":"Arctic Transportation Services","7T":"Aero Express del Ecuador - Trans AM","7U":"Aviaenergo","7V":"Pelican Air","7W":"Windrose Air","7Y":"Mann Yadanarpon Airlines","7Z":"Ameristar Jet Charter","8A":"Atlas Blue","8B":"Business Air","8C":"Air Transport International","8D":"FitsAir","8E":"Bering Air","8F":"STP Airways","8H":"BH Air","8I":"MyAir","8J":"Linea Aerea Eco Jet S.A.","8K":"K-Mile Air","8L":"Lucky Air","8M":"Myanmar Airways International","8N":"Aerodynamics","8O":"West Coast Air","8P":"Pacific Coastal Airlines","8Q":"Onur Air","8R":"Sol Lineas Aereas","8S":"Shun Tak-China Travel Ship Mgmt.","8T":"Air Tindi","8U":"Afriqiyah Airways","8V":"Astral Aviation","8W":"Private Wings","8Z":"Wizz Air Bulgaria","9A":"Eaglexpress Air Charter Sdn.Bhd.","9B":"AccesRail and Partner Railways","9C":"Spring Airlines","9D":"Toumai Air Tchad","9E":"Endeavor Air","9F":"Eurostar International Limited","9G":"9G Rail Limited","9H":"Dutch Antilles Express","9I":"Airline Allied Services Limited","9J":"Dana Air","9K":"Cape Air","9L":"Colgan Air","9M":"Central Mountain Air","9N":"Tropic Air Limited","9O":"National Airways Cameroon","9P":"Air Arabia Jordan","9Q":"Caicos Express Airways","9R":"Satena","9S":"Southern Air","9T":"ACT Airlines","9U":"Air Moldova","9V":"Avior Airlines","9W":"Jet Airways","9X":"Executive Express Aviation",A0:"L Avion Elysair",A2:"Astra Airlines",A3:"Aegean Airlines",A4:"Aerocomercial Oriente Norte",A5:"HOP!",A6:"Air Alps",A7:"Air Comet",A8:"Ameriflight",A9:"Georgian Airways",AA:"American Airlines",AB:"Air Berlin",AC:"Air Canada",AD:"Azul Brazilian Airlines",AE:"Mandarin Airlines",AEU:"Iceland Express",AF:"Air France",AG:"Air Contractors",AH:"Air Algerie",AI:"Air India",AJ:"Aztec Worldwide Airlines",AJA:"AnadoluJet",AK:"AirAsia",AL:"Air Leisure",AM:"Aeromexico",AO:"Air One Aviation Pvt",AP:"Air One",AQ:"9 Air",AR:"Aerolineas Argentinas",AS:"Alaska Airlines",AT:"Royal Air Maroc",AU:"Austral",AV:"Avianca",AVR:"Avro Flights",AW:"Venezolana",AX:"Trans States Airlines",AY:"Finnair",AZ:"Alitalia",B0:"La Compagnie",B1:"Bravo Passenger Solution Pte.",B2:"Belavia",B3:"Bhutan Airlines",B4:"ZanAir Limited",B5:"East African Safari Air Express",B6:"JetBlue Airways",B7:"UNI Air",B8:"Eritrean Airlines",B9:"Iran Air Tours",BA:"British Airways",BB:"Seaborne Airlines",BC:"Skymark Airlines",BCI:"Blue Islands",BD:"Cambodia Bayon Airlines Limited",BE:"Flybe",BF:"Bluebird Cargo",BG:"Biman Bangladesh Airlines",BGT:"Bergen Air",BH:"Hawkair Aviation Services",BI:"Royal Brunei Airlines",BJ:"Nouvelair Tunisie",BK:"Okay Airways",BL:"Pacific Airlines",BM:"BMI Regional",BP:"Air Botswana",BQ:"Aeromar Airlines",BR:"EVA Air",BS:"British Intl",BT:"Air Baltic",BU:"Compagnie Africaine d'Aviation",BV:"Blue Panorama Airlines",BW:"Caribbean Airlines",BX:"Air Busan",BY:"Thomson Airways",BZ:"Bluebird Airways",C0:"Centralwings",C1:"Tectimes Sudamericana S.A.",C2:"Ceiba Intercontinental",C3:"Trade Air",C4:"Conquest Air",C5:"Champlain Enterprises",C6:"Canjet Airlines",C7:"Saffron Aviation (Pvt)",C8:"Cronos Airlines",C9:"Cirrus Airlines",CA:"Air China",CAI:"Corendon",CB:"Caribbean Air Export Import",CC:"Air Atlanta Icelandic",CD:"Dutch Corendon Airlines",CE:"Chalair Aviation",CF:"China Postal Airlines",CG:"Airlines of PNG",CH:"Bemidji Aviation Services",CI:"China Airlines",CJ:"BA CityFlyer",CK:"China Cargo Airlines",CL:"Lufthansa CityLine",CM:"Copa Airlines",CN:"Grand China Air",CO:"Continental Airlines",CP:"Compass Airlines",CQ:"Charterlines",CR:"UBM Aviation - OAG",CS:"Continental Micronesia",CT:"Alitalia CityLiner",CU:"Cubana",CV:"Cargolux",CW:"Air Marshall Islands",CX:"Cathay Pacific",CY:"Cyprus Airways",CZ:"China Southern Airlines",D0:"DHL Air",D2:"Severstal",D3:"Daallo Airlines",D4:"Alidaunia",D5:"DHL Aero Expreso S.A.",D6:"Interair South Africa",D7:"AirAsia X",D8:"Norwegian Air International",D9:"Donavia",DB:"Brit Air",DC:"Braathens Regional",DD:"Nok Air",DE:"Condor",DEW:"Condor",DF:"Condor Berlin",DG:"Tigerair Philippines",DH:"Norwegian Air Norway AS",DI:"DBA Luftfahrtgesellschaft",DJ:"Virgin Blue",DK:"Thomas Cook Airlines Scandinavia",DL:"Delta Air Lines",DM:"Asian Air Company Limited",DN:"Senegal Airlines",DO:"Discovery Air",DP:"Pobeda",DQ:"Air Direct Connect",DR:"Ruili Airlines",DS:"EasyJet Switzerland",DT:"TAAG Angola Airlines",DU:"Hemus Air",DV:"SCAT",DW:"Aero-Charter Airlines",DX:"Danish Air Transport",DY:"Norwegian",DZ:"Donghai Airlines",E:"",E0:"Eos Airlines",E3:"Sabaidee Airways",E4:"Enter Air",E5:"Air Arabia Egypt",E6:"Bringer Air Cargo Taxi Aereo",E7:"Estafeta Carga Aerea",E8:"City Airways Company Limited",E9:"Evelop Airlines",EA:"Eastern Air Lines",EB:"Wamos Air",EC:"Open Skies",ED:"AirExplore",EE:"Eastern SkyJets",EF:"Eznis Airways",EG:"East Air",EH:"ANA Wings",EI:"Aer Lingus",EIW:"Aer Lingus",EJ:"European Cargo Services BV",EK:"Emirates",EL:"Ellinair",EM:"Empire Airlines",EN:"Air Dolomiti",EO:"Air Go Egypt",EP:"Iran Aseman Airlines",EQ:"TAME",ER:"Astar Air Cargo",ES:"DHL International",ET:"Ethiopian Airlines",EU:"Chengdu Airlines",EUP:"OnAir",EV:"ExpressJet",EW:"Eurowings",EX:"Thai Express Air",EXT:"Kalmarflyg",EY:"Etihad Airways",EZ:"Sun-Air",F1:"Farelogix",F2:"Safarilink Aviation Limited",F3:"FAI rent-a-jet Aktiengesellschaft",F4:"Air Charter",F5:"Aerotranscargo",F6:"Faroe Jet",F7:"Darwin Airline",F8:"Flair Airlines",F9:"Frontier Airlines",FA:"Safair",FB:"Bulgaria Air",FC:"Fast Colombia S.A.S",FD:"Thai AirAsia",FE:"Far Eastern Air Transport",FF:"Airshop B.V.",FG:"Ariana Afghan Airlines",FH:"Freebird Airlines",FHE:"Iceland Express",FI:"Icelandair",FJ:"Fiji Airways",FK:"Keewatin Air",FL:"AirTran",FM:"Shanghai Airlines",FN:"Fastjet",FO:"Felix Airways",FOG:"FlyOeger",FP:"TAG Aviation",FQ:"Fenix Airways of Florida Inc",FR:"Ryanair",FS:"Syphax Airlines",FT:"FlyEgypt",FU:"Fuzhou Airlines",FV:"Rossiya",FW:"Ibex Airlines",FX:"FedEx",FY:"Firefly",FZ:"FlyDubai",G0:"Ghana Intl",G2:"Alianza Glancelot C.A.",G3:"VRG Linhas Aereas S.A.",G4:"Allegiant Air",G5:"China Express Airlines",G6:"Angkor Airways Corporation",G7:"KAPO Avia",G8:"Go Air",G9:"Air Arabia",GA:"Garuda Indonesia",GB:"ABX Air",GC:"Global Feeder Services",GE:"TransAsia Airways",GF:"Gulf Air",GFG:"Gotlandsflyg",GG:"Sky Lease I",GH:"Globus",GI:"Itek Air",GJ:"Zhejiang Loong Airlines",GK:"Jetstar Japan",GL:"Air Greenland",GM:"Germania Flug",GO:"ULS Airlines Cargo",GP:"Gadair",GQ:"Sky Express (Greece)",GR:"Aurigny Air Services",GS:"Tianjin Airlines",GSM:"flyglobespan",GT:"GB Airways",GU:"Aviateca",GV:"Sky Gabon S.A.",GW:"Skygreece Airlines",GX:"Guangxi Beibu Gulf Airlines",GY:"Gabon Airlines",GZ:"Air Rarotonga",H1:"Hahn Air Systems",H2:"Sky Airline",H3:"Hermes Airlines",H4:"Aero4M d.o.o",H5:"I-Fly",H6:"Bulgarian Air Charter",H7:"Eagle Aviation Uganda",H8:"Dalavia Far East Airways",H9:"Himalaya Airlines Pvt.",HA:"Hawaiian Airlines",HB:"Asia Atlantic Airlines",HC:"Aero Tropics Air Service",HD:"Air Do",HE:"Luftfahrtgesellschaft Walter",HF:"Air Cote d'Ivoire",HG:"Niki",HH:"Taban Air",HI:"Papillon Airways",HJ:"Tasman Cargo Airlines PTY",HK:"Hamburg Airways",HL:"Hotels/Motels",HM:"Air Seychelles",HN:"Afghan Jet International",HO:"Juneyao Airlines",HP:"Amapola Flyg AB",HQ:"Thomas Cook Airlines Belgium",HR:"Hahn Air Lines",HS:"Direktflyg",HT:"Ningxia Cargo Airlines",HU:"Hainan Airlines",HV:"Transavia",HW:"North-Wright Airways",HX:"Hong Kong Airlines",HY:"Uzbekistan Airways",HZ:"Aurora",I2:"Iberia Express",I3:"ATA Airlines",I4:"Scott Air",I5:"AirAsia India",I6:"Air Indus",I7:"Paramount Airways",I8:"Izhavia",I9:"Air Italy",IA:"Iraqi Airways",IB:"Iberia",IC:"Indian Airlines",ID:"Batik Air",IE:"Solomon Airlines",IF:"Islas Airways",IG:"Meridiana",IH:"Irtysh-Air",II:"IBC Airways",IJ:"Spring Airlines Japan",IK:"Ikar",IL:"Trigana Air Service",IM:"Mint Airways",IN:"PT. Nam Air",IO:"IrAero",IP:"Apsara International Air",IQ:"Augsburg Airways",IR:"Iran Air",IS:"AIS Airlines",ISK:"Istanbul",IT:"Tigerair Taiwan",IU:"SW Italia s.p.a.",IV:"Caspian Airlines",IW:"Wings Air",IX:"Air India Express",IY:"Yemenia",IZ:"Arkia Israeli Airlines",J0:"Jetlink Express",J1:"One Jet",J2:"Azerbaijan Airlines",J3:"Northwestern Air",J4:"BADR AIRLINES",J5:"Alaska Seaplane Service L.L.C.",J6:"Larry's Flying Service",J7:"Centre-Avia Airlines",J8:"Berjaya Air",J9:"Jazeera Airways",JA:"B&H Airlines",JAF:"TUI Airlines",JB:"Helijet International",JC:"Japan Air Commuter",JD:"Capital Airlines",JE:"Mango",JF:"Jet Asia Airways",JG:"Jetgo Australia Holdings Pty",JH:"Fuji Dream Airlines",JI:"Meraj Air",JJ:"TAM Linhas Aereas",JK:"Spanair",JL:"Japan Airlines",JM:"Air Jamaica",JN:"Excel Airways",JO:"Jet Time OY",JOR:"Blue Air",JP:"Adria Airways",JQ:"Jetstar Airways",JR:"Joy Air",JS:"Air Koryo",JT:"Lion Airlines",JU:"AirSERBIA",JV:"Bearskin Airlines",JW:"Vanilla Air",JY:"interCaribbean Airways",JZ:"Skyways AB",K1:"Topas",K2:"EuroLot S.A.",K3:"Venture Travel",K4:"Kalitta Air",K5:"SeaPort Airlines",K6:"Kosmos Airlines",K7:"Air KBZ",K8:"Kannithi Aviation Company Limited d",K9:"KrasAvia",KA:"Hong Kong Dragon Airlines",KB:"Druk Air",KC:"Air Astana",KD:"KalStar Aviation",KE:"Korean Air",KF:"Blue1",KFG:"Kullaflyg",KG:"Key Lime Air",KH:"Aloha Air Cargo",KI:"KrasAvia",KJ:"Air Incheon Co",KK:"Atlasjet",KL:"KLM",KM:"Air Malta",KN:"China United Airlines",KNE:"Nas Air",KO:"Komiaviatrans",KP:"PT. Asialink Cargo Express",KQ:"Kenya Airways",KR:"Air Bishkek",KS:"Penair",KT:"Katmai Air",KU:"Kuwait Airways",KV:"Asian Express Airline",KW:"Kharkiv Airlines",KX:"Cayman Airways",KY:"Kunming Airlines",KZ:"Nippon Cargo Airlines",L2:"Lynden Air Cargo",L3:"DHL de Guatemala S.A.",
L4:"Wings of Lebanon",L5:"Lufttransport",L6:"Mauritania Airlines International",L7:"Linea Aerea Carguera de Colombia S.A.",L8:"Afric Aviation",L9:"Bristow U.S.",LA:"LAN Airlines",LB:"Air Costa",LC:"Equatorial Congo Airlines (ECAIR)",LD:"Air Hong Kong",LE:"Lugansk Airlines",LF:"FlyNordic",LG:"Luxair",LH:"Lufthansa",LI:"LIAT",LJ:"Jin Air",LK:"Kyrgyz Airlines",LL:"Miami Air International",LM:"Loganair",LN:"Libyan Airlines",LO:"LOT",LP:"LAN Peru",LQ:"Air Guinea Cargo",LR:"LINEAS AEREAS COSTARRICENSES S.A.",LS:"Jet2",LT:"JSC Air Lituanica",LU:"Lan Express",LV:"Mega Maldives",LW:"Pacific Wings L.L.C.",LX:"Swiss",LY:"El Al",LYD:"Lydd Air",LZ:"Belle Air",M0:"Aero Mongolia",M2:"Sunrise Airlines",M3:"North Flying",M4:"Smart Aviation",M5:"Kenmore Air",M6:"Amerijet International",M7:"Aerotransportes Mas de Carga",M8:"Trans Maldivian Airways",M9:"Motor Sich Airlines",MA:"Malev",MB:"MNG Airlines",MC:"Air Mobility Command",MD:"Air Madagascar",ME:"Middle East Airlines",MF:"Xiamen Airlines",MG:"Midex Airlines",MH:"Malaysia Airlines",MI:"SilkAir",MJ:"Mihin Lanka",MK:"Air Mauritius",ML:"Air Mediterranee",MM:"Peach Aviation",MN:"Kulula.com",MO:"Calm Air",MP:"Martinair Holland",MQ:"American Eagle",MR:"Hunnu Air",MS:"EgyptAir",MT:"Thomas Cook Airlines",MU:"China Eastern Airlines",MV:"Maldivian Air Taxi",MW:"Mokulele Flight Service",MX:"Mexicana",MY:"Maya Island Air",MZ:"Merpati",N2:"Trans-Mediterranean Airways",N3:"Aerolineas Mas",N4:"Nordwind Airlines",N5:"Skagway Air Service",N6:"Nomad Aviation (PTY)",N7:"Neptune Air Sdn Bhd",N8:"National Air Cargo Group",N9:"Novair",NA:"North American Airlines",NB:"Skypower Express Airways",NC:"Northern Air Cargo",ND:"FMI Air",NE:"Nesma Airlines",NF:"Air Vanuatu",NG:"Aero Contractors",NH:"All Nippon Airways",NI:"Portugalia",NJ:"Nordic Global Airlines",NK:"Spirit Airlines",NL:"Shaheen Air International",NM:"Mount Cook Airline",NN:"VIM Airlines",NO:"Neos",NP:"Nile Air",NQ:"Air Japan Company",NR:"Al-Naser Airlines",NS:"Hebei Airlines",NT:"Binter Canarias",NTJ:"Nextjet",NU:"Japan Transocean Air",NV:"Naft Airlines",NW:"Northwest Airlines Inc",NX:"Air Macau",NY:"Air Iceland",NZ:"Air New Zealand",O2:"Jet Air",O3:"SF Airlines",O4:"Antrak Air",O6:"Avianca Brasil",O7:"SUE Orenburg Region Int Airport",O8:"Siam Air Transport",O9:"Nova Airways",OA:"Olympic Air",OB:"Boliviana de Aviacion",OC:"Omni",OD:"Malindo Air",OE:"Cairo Aviation",OF:"Air Finland",OG:"Air Onix",OH:"Comair",OI:"Hinterland Aviation Pty",OJ:"Fly Jamaica",OK:"Czech Airlines",OL:"OLT Ostfriesische Luftransport",OM:"MIAT Mongolian Airlines",ON:"Our Airline",OO:"SkyWest Airlines",OP:"Air Pegasus Pvt.",OQ:"Chongqing Airlines",OR:"TUIFLY NETHERLANDS",OS:"Austrian Airlines",OT:"Aeropelican",OU:"Croatia Airlines",OV:"Estonian Air",OW:"Executive Airlines",OX:"Orient Thai Airlines",OY:"Omni Air International",OZ:"Asiana Airlines",P0:"Proflight Air Services",P1:"Aviation Technologies",P2:"AirKenya Express",P4:"Air Charter Africa",P5:"Copa Airlines Colombia",P6:"Pascan Aviation",P7:"Small Planet Airlines Polska",P8:"P.L.A.S. S/A",P9:"Peruvian Airlines",PA:"AirBlue",PB:"Provincial Airlines",PC:"Pegasus Airlines",PD:"Porter Airlines",PE:"People's Viennaline",PF:"Primera Air",PG:"Bangkok Airways",PH:"PHOENIX AIR GROUP",PI:"Polar Airlines OJSC",PJ:"Air Saint-Pierre",PK:"Pakistan Int. Airlines",PL:"Southern Air Charter Limited",PM:"CanaryFly",PN:"China West Air",PO:"Polar Air Cargo",PP:"Jet Aviation Business Jets AG",PQ:"Philippines AirAsia",PR:"Philippine Airlines",PS:"Ukraine Int. Airlines",PT:"West Air Sweden",PU:"Pluna",PV:"Privatair SA",PW:"Precision Air",PX:"Air Niugini",PY:"Surinam Airways",PZ:"TAM - Transportes Aereos del",Q0:"Quebecair Express",Q1:"PT. Sqiva Sistem",Q2:"Maldivian",Q3:"Anguilla Air Services",Q4:"Qatar Airways Amiri Flight",Q5:"40-Mile Air",Q6:"Skytrans",Q7:"Swift Air",Q8:"Trans Air Congo",QA:"Cimber",QB:"Qeshm Airlines",QC:"Camair-Co",QE:"Crossair Europe",QF:"Qantas",QG:"Citilink",QH:"Air Kyrgyzstan",QI:"Cimber Sterling",QJ:"Jet Airways",QK:"Jazz Air",QL:"Laser Airlines",QM:"Air Malawi Limited",QN:"Air Armenia",QO:"Quikjet Cargo Airlines Pvt.",QP:"Starlight Airline",QQ:"Alliance Airlines",QR:"Qatar Airways",QS:"Travel Service",QT:"Avianca Cargo",QU:"UTair Ukraine",QV:"Lao Airlines",QW:"Qingdao Airlines",QX:"Horizon Air",QY:"EAT Leipzig",QZ:"Indonesia AirAsia",R1:"Zapways",R2:"Orenair",R3:"Yakutia Airlines",R4:"RUS Aviation",R5:"Jordan Aviation",R6:"DOT - Danu oro transportas",R7:"Aserca Airlines",R8:"Kyrgyzstan Airlines",R9:"Camai Air",RA:"Royal Nepal Airlines",RB:"Syrian Air",RC:"Atlantic Airways",RE:"Stobart Air",RE2:"Aer Arann",RF:"Florida West International Airways",RG:"Rotana Jet Aviation",RH:"Robin Hood Aviation",RI:"PT. Mandella Airlines",RJ:"Royal Jordanian",RK:"Skyview Airways Company Limited",RL:"Royal Falcon",RM:"Regional Air",RO:"Tarom",RP:"Chautauqua Airlines",RQ:"Kam-Air",RR:"Royal Air Force",RS:"Sky Regional Airlines",RT:"RAK Airways",RU:"AirBridgeCargo Airlines",RV:"Air Canada rouge",RW:"RAS Fluggesellschaft",RX:"Regent Airways",RY:"Royal Wings",RZ:"Sansa Airlines",S0:"Slok Air Intl",S1:"Lufthansa Systems AG",S2:"JetLite",S3:"SBA Airlines",S4:"SATA International",S5:"Small Planet Airlines",S6:"Sunrise Airways",S7:"S7 Airlines",S8:"Skywise Airlines",S9:"Starbow Airlines",SA:"South African Airways",SB:"Aircalin",SC:"Shandong Airlines",SD:"Sudan Airways",SE:"XL Airways France",SF:"Tassili Airlines",SFG:"SundsvallsFlyg",SG:"SpiceJet",SH:"Sharp Aviation Pty.",SI:"Blue Islands",SJ:"Sriwijaya Air",SK:"SAS",SL:"Thai Lion Air",SM:"Air Cairo",SN:"Brussels Airlines",SO:"Apex Airline Public Company Limited",SP:"SATA Air Acores",SQ:"Singapore Airlines",SS:"Corsair",ST:"Germania",SU:"Aeroflot",SV:"Saudi Arabian Airlines",SW:"Air Namibia",SX:"SkyWork Airlines",SY:"Sun Country Airlines",SZ:"Somon Air",T0:"Trans American Airlines S.A. TACA PERU",T1:"Tik Systems (Thailand)",T2:"Nakina Air Service",T3:"Eastern Airways",T4:"Trip Linhas Aereas",T5:"Turkmenistan Airlines",T6:"1Time",T7:"Twin Jet",T8:"Telair International",T9:"Trans Meridian Airlines",TA:"TACA Airlines",TB:"Jetairfly",TC:"Air Tanzania",TCW:"Thomas Cook",TD:"Atlantis European Airways",TE:"Skytaxi",TF:"Malmo Aviation",TG:"Thai Airways",TH:"Raya Airways",TI:"Tailwind Airlines",TJ:"Tradewind Aviation",TK:"Turkish Airlines",TL:"Airnorth",TM:"LAM Mozambique Airlines",TN:"Air Tahiti Nui",TO:"Transavia France",TOM:"Thomson fly",TP:"TAP Portugal",TQ:"Tandem Aero",TR:"Tigerair",TS:"Air Transat",TT:"Tigerair Australia",TU:"Tunisair",TV:"Tibet Airlines",TW:"T'way Air",TX:"Air Caraibes",TY:"Air Caledonie",TZ:"Scoot",U2:"EasyJet",U3:"Avies",U4:"Buddha Air",U5:"USA 3000 Airlines",U6:"Ural Airlines",U7:"Air Uganda",U8:"Armavia",U9:"Tatarstan Air",UA:"United Airlines",UB:"Myanmar National Airlines",UC:"LAN Cargo",UD:"Hex Air",UE:"Ultimate Jetcharters",UF:"Ukrainian Mediterranean Airlines",UFG:"Umeaflyg",UG:"Tunisair Express",UH:"AtlasGlobal UA",UI:"Auric Air Services Limited",UJ:"Almasria Universal Airlines",UK:"Vistara",UL:"SriLankan Airlines",UM:"Air Zimbabwe",UN:"Transaero Airlines",UO:"Hong Kong Express",UP:"Bahamasair",UQ:"Urumqi Airlines",UR:"Utair - Express Limited Company",US:"US Airways",UT:"UTair",UU:"Air Austral",UW:"Uni-Top Airlines",UX:"Air Europa",UY:"Air Caucasus",UZ:"Buraq Air",V0:"Conviasa",V1:"IBS Software Services Americas",V2:"Avialeasing Aviation Company",V3:"Carpatair",V4:"Vieques Air Link Inc",V5:"Danube Wings",V6:"Clairmont Holdings",V7:"Volotea",V8:"Atran",V9:"Van Air Europe a.s.",VA:"Virgin Australia",VB:"VivaAerobus",VC:"Charter Air Transport.",VE:"Volare Spa",VF:"Valuair",VG:"VLM Airlines N.V",VH:"Aeropostal Alas de Venezuela C.A.",VI:"Volga-Dnepr Airlines",VIK:"Viking Airlines",VIL:"Vildanden",VIV:"Vivaaerobus",VJ:"VietJetAir",VK:"Air Vallee S.p.A.",VL:"Med-View Airline",VM:"Viaggio Air",VN:"Vietnam Airlines",VO:"Tyrolean Airways",VP:"FlyMe",VQ:"Novoair Limited",VR:"TACV Cape Verde Airlines",VS:"Virgin Atlantic Airways",VT:"Air Tahiti",VU:"Vuelos Economicos Centroamericanos",VV:"Aerosvit Airlines",VW:"Aeromar",VX:"Virgin America",VY:"Vueling",VZ:"MyTravel Airways",W1:"WDL Aviation",W2:"Flex Flight",W3:"Arik Air",W4:"LC Peru",W5:"Mahan Air",W6:"Wizz Air",W7:"Wings of Lebanon S.a.l",W8:"Cargojet Airways",W9:"Air Bagan",WA:"KLM cityhopper",WB:"RwandAir",WC:"Islena Airlines",WD:"Dairo Air Services",WE:"Thai Smile",WF:"Wideroe",WG:"Sunwing Airlines",WH:"Webjet",WI:"White",WJ:"Air Labrador",WK:"Edelweiss Air",WM:"Winair",WN:"Southwest Airlines",WO:"World Airways",WOW:"Air Southwest",WP:"Island Air (USA)",WR:"WestJet Encore",WS:"WestJet",WT:"Wasaya Airways",WU:"Wizz Air Ukraine",WV:"Aero Vip",WW:"WOW air",WX:"Cityjet",WY:"Oman Air",WZ:"Red Wings",X3:"TUIfly",X4:"Vanair Limited",X5:"Ten Airways",X7:"Exec Air of Naples",X8:"Airmax S.A.",X9:"Avion Express",XA:"ARINC",XB:"International Air Transport Association.",XC:"Corendon Airlines",XD:"Universal Air Travel Plan (UATP)",XE:"ExpressJet Airlines",XF:"Vladivostok Air",XG:"SunExpress Deutschland",XH:"Special Ground Handling Service -XH",XI:"Aeronautical Telecommunications",XJ:"Thai AirAsia X",XK:"Air Corsica",XL:"LAN Ecuador",XM:"Alitalia Express",XN:"Express Air",XO:"South East Asian Airlines (SEAIR)",XP:"TEM Enterprises",XQ:"SunExpress",XR:"Virgin Australia Regional",XS:"SITA - Airlines Worldwide",XT:"Indonesia AirAsia X",XU:"African Express Airways",XV:"MR Lines",XW:"NokScoot Airlines Company Limited",XY:"Flynas",XZ:"South African Express",Y0:"Yellow Air Taxi",Y1:"Travel Technology Interactive SA",Y3:"Driessen Services",Y4:"Volaris",Y5:"Golden Myanmar Airlines",Y7:"NordStar",Y8:"Yangtze River Express",Y9:"Kish Airlines",YB:"Borajet",YC:"Yamal Airlines",YD:"Mauritania Airways",YE:"YanAir",YF:"Department of National Defence",YG:"South Airlines",YH:"Sunsplash Aviation .",YI:"Yunnan Yingan Airline",YIN:"Yining Arpt",YJ:"Asian Wings Airways",YK:"Avia Traffic",YL:"Libyan Wings",YM:"Montenegro Airlines",YN:"Air Creebec",YO:"Heli Air Monaco",YP:"Perimeter Aviation",YQ:"Polet Airlines",YR:"Grand Canyon Airlines",YS:"Regional",YT:"Yeti Airlines",YU:"EuroAtlantic Airways",YV:"Mesa Airlines",YW:"Air Nostrum",YX:"Republic Airlines",YZ:"Alas Uruguay - Dyrus S.A.",Z2:"AirAsia Zest",Z3:"Avient Aviation",Z4:"ZagrosJet",Z5:"GMG Airlines",Z6:"Dniproavia",Z7:"NU-Aero (Pvt)",Z8:"Compania de Servicios de Transporte",Z9:"Bek Air",ZA:"Sky Angkor Airlines",ZB:"Monarch Airlines",ZC:"Korongo Airlines",ZD:"EWA Air",ZE:"Eastar Jet",ZF:"Azur Air",ZG:"Grozny Avia",ZH:"Shenzhen Airlines",ZI:"Aigle Azur",ZJ:"Zambezi Airlines",ZK:"Great Lakes Aviation",ZL:"Regional Express",ZM:"Pegasus Asia",ZN:"Naysa",ZP:"Silk Way Airlines",ZQ:"Caribbean Sun Airlines",ZR:"Aviacon Zitotrans",ZS:"Sama Airlines",ZT:"Titan Airways",ZU:"Helios Airways",ZV:"V Air",ZW:"Air Wisconsin Airlines Corporation",ZX:"Air Georgian",ZY:"Ada Air",xx:"Aerodynamics","ДЖ":"Tez Jet","ИГ":"Komiaviatrans","ЛП":"Pskovavia","ЭК":"KrasAvia"};t.___airlines=n;var r=self.document.documentElement.lang,i=function(e){for(var t,n,o,a=Object.keys(e),s=a.length;s--;)t=a[s],n=e[t],n.$code=t,n.$type="airline",o=typeof n,"object"===o&&(n[r]?(Object.defineProperty(e,t,{value:n[r]}),Object.defineProperty(e,t+"En",{value:n.en,enumerable:!0})):i(n))};i(n),e.exports=n}).call(t,function(){return this}())},function(e,t,n){var r=n(464),i=n(465).default,o="M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0 M11,15H9V9h2V15z M11,7H9V5h2V7z";e.exports=function(e){return r("svg",i({width:"20px",height:"20px",viewBox:"0 0 20 20",fill:"#BCC3C7",preserveAspectRatio:"xMinYMin",xmlns:"http://www.w3.org/2000/svg"},e),r("path",{d:o}))}},function(e,t,n){var r=n(464),i=n(470).default,o=n(474).default,a=n(465).default,s=n(511).default,u=n(476),l=n(512),c=n(302),d=(c.Children,c.cloneElement),p=n(525),f=p.findDOMNode,h=function(e){function t(n,r){o(this,t),e.call(this,n,r),this.handleTriggerClick=this.handleTriggerClick.bind(this),this.handleMouseEnter=this.handleMouseEnter.bind(this),this.handleMouseLeave=this.handleMouseLeave.bind(this),this.handleChildrenClick=this.handleChildrenClick.bind(this),this.handlePreventBubble=this.handlePreventBubble.bind(this),this.state={active:n.isOpen}}return i(t,e),t.prototype.componentWillReceiveProps=function(e){this.props.isOpen!==e.isOpen&&(e.isOpen===!0&&this.show(),e.isOpen===!1&&this.hide()),e.showForSeconds?e.showForSeconds!==this.props.showForSeconds&&this.hideAsync(e):clearTimeout(this._hideTO)},t.prototype.childOf=function(e,t){for(;(e=e.parentNode)&&e!==t;);return!!e},t.prototype.componentDidMount=function(){var e=this;this.props.closeOnOutsideClick&&(this._hideListener=function(t){e.childOf(t.target,f(e.refs.trigger))||e.hide()},document.addEventListener("click",this._hideListener)),this.state.active&&this.props.showForSeconds&&this.hideAsync()},t.prototype.componentWillUnmount=function(){clearTimeout(this._hideTO),document.removeEventListener("click",this._hideListener)},t.prototype.show=function(){clearTimeout(this._hideTO),this.setState({active:!0}),this.props.showForSeconds&&this.hideAsync()},t.prototype.hide=function(){clearTimeout(this._hideTO),this.setState({active:!1})},t.prototype.hideAsync=function(){var e=this,t=arguments.length<=0||void 0===arguments[0]?this.props:arguments[0];this._hideTO=setTimeout(function(){return e.hide()},1e3*t.showForSeconds)},t.prototype.handleTriggerClick=function(e){this.setState({active:!this.state.active}),this.props.trigger.props.onClick&&this.props.trigger.props.onClick(e)},t.prototype.handleMouseEnter=function(){this.show()},t.prototype.handleMouseLeave=function(e){this.props.showForSeconds?this.hideAsync():this.props.hoverable&&this.hide()},t.prototype.handleChildrenClick=function(e){this.handlePreventBubble(e),this.props.children.onClick&&this.props.children.onClick(e)},t.prototype.handlePreventBubble=function(e){},t.prototype.render=function(){var e=this,t=this.props,n=t.trigger,i=t.children,o=t.hoverable,u=t.targetFn,c=s(t,["trigger","children","hoverable","targetFn"]),p=o?{onMouseEnter:this.handleMouseEnter,onMouseLeave:this.handleMouseLeave}:{};return n=n?d(n,a({ref:"trigger",onClick:this.handleTriggerClick},p)):null,i=d(i,a({},c,p,{onClick:this.handleChildrenClick})),u=u?u:function(){return e.refs.trigger},r("div",{onClick:this.handlePreventBubble,ref:"trigger"},n,r(l,a({},this.props,{show:this.state.active,children:i,targetFn:u})))},t}(u);h.defaultProps={clickable:!0,closeOnOutsideClick:!0,hoverable:!0,showForSeconds:2},e.exports=h},function(e,t){"use strict";t.default=function(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n},t.__esModule=!0},function(e,t,n){var r=(n(448),n(464)),i=n(470).default,o=n(474).default,a=n(465).default,s=n(511).default,u=n(476),l=n(513),c=n(530),d=n(527),p=function(e){function t(n,r){o(this,t),e.call(this,n,r),this.handleHidden=this.handleHidden.bind(this),this.state={exited:!n.show}}return i(t,e),t.prototype.componentDidMount=function(){this.updateContainers()},t.prototype.componentWillReceiveProps=function(e){this._needsFlush=!0,e.show?this.setState({exited:!1}):e.transition||this.setState({exited:!0})},t.prototype.componentDidUpdate=function(){this._needsFlush&&(this._needsFlush=!1,this.updateContainers())},t.prototype.updateContainers=function(){var e=this,t=this.props,n=t.container,r=t.content;null==r&&(r=n),this.setState({container:d(n,document.body),content:d(r,document.body)},function(){if(!e.state.container&&!e.state.content){if(e._once)return;e._once=!0,setTimeout(e.updateContainers.bind(e),0)}})},t.prototype.handleHidden=function(){if(this.setState({exited:!0}),this.props.onExited){var e;(e=this.props).onExited.apply(e,arguments)}},t.prototype.render=function(){var e=this.props,t=e.children,n=e.containerPadding,i=e.targetFn,o=e.placement,u=e.transition,d=s(e,["children","containerPadding","targetFn","placement","transition"]),p=d.show||u&&!this.state.exited;if(!p||!this.state.container||!this.state.content)return null;var f=t;if(f=r(c,a({containerPadding:n,targetFn:i,placement:o},{container:this.state.content}),f),u){var h=d.onExit,v=d.onExiting,y=d.onEnter,g=d.onEntering,m=d.onEntered;f=r("compTransition",{"in":d.show,transitionAppear:!0,onExit:h,onExiting:v,onExited:this.handleHidden,onEnter:y,onEntering:g,onEntered:m},f)}return r(l,{container:this.state.container,isOpen:!0,onClose:d.onHide,style:{position:"static"}},f)},t}(u);p.defaultProps={},e.exports=p},function(e,t,n){var r=n(448),i=n(464),o=n(470).default,a=n(514).default,s=n(474).default,u=n(465).default,l=n(515).default,c=n(522).default,d=n(476),r=n(302),p=n(525),f=n(526),h=n(527),v=n(528),y={position:"relative",zIndex:1e5},g=function(e){function t(n,r){s(this,t),e.call(this,n,r),this.handleTriggerClick=this.handleTriggerClick.bind(this),this.handleKeyDown=this.handleKeyDown.bind(this),this.handleClose=this.handleClose.bind(this),this.handleOpen=this.handleOpen.bind(this),this.state={active:!1},this.node=null,this.portal=null,this._eventsBound={close:!1}}return o(t,e),a(t,null,[{key:"INSTANCES",value:new l,enumerable:!0}]),t.prototype.shouldComponentUpdate=function(){return!1},t.prototype.componentDidMount=function(){var e=this;this._mounted=!0,setTimeout(function(){e.props.isOpen&&!e.state.active&&e.handleOpen(e.props)},0)},t.prototype.componentWillReceiveProps=function(e){var t=this.state.active;e.isOpen||null==e.isOpen&&t?this.handleOpen(u({},e,{isOpen:!0})):t&&this.handleClose()},t.prototype.componentWillUnmount=function(){this.handleClose(),this._mounted=!1},t.prototype.handleTriggerClick=function(){var e=this;setTimeout(function(){return e.handleOpen(e.props)},0)},t.prototype.handleKeyDown=function(e){var n=t.INSTANCES;n.has(this.portal)&&c(n.values()).pop()===this.portal&&27===e.keyCode&&this.handleClose()},t.prototype.handleClose=function(){this._closing||(this._closing=!0,this._removePortal())},t.prototype.handleOpen=function(){var e=this,t=arguments.length<=0||void 0===arguments[0]?this.props:arguments[0];this._mounted&&this.setState({active:!0},function(){e.renderPortal(t),e.props.onOpen()})},t.prototype._saveGetContainer=function(){var e=(arguments.length<=0||void 0===arguments[0]?this.props:arguments[0],h(this.props.container,v(this).body));if(!e||!e.appendChild){var t=p.findDOMNode(e);if(t)return t;throw new Error("DOM node must be provided as container prop")}return e},t.prototype._appendPortalContainer=function(){if(!this.node){var e=this._saveGetContainer();this.node=document.createElement("div"),e.appendChild(this.node),this.props.closeOnEsc&&!this._eventsBound.close&&(this._eventsBound.close=!0,document.addEventListener("keydown",this.handleKeyDown))}},t.prototype._removePortal=function(){this.node&&(this._mounted&&this.setState({active:!1}),this.props.closeOnEsc&&this._eventsBound.close&&(this._eventsBound.close=!1,document.removeEventListener("keydown",this.handleKeyDown)),this.props.onClose(),t.INSTANCES.delete(this.portal),setTimeout(this._unmount.bind(this),0))},t.prototype._unmount=function(){this.node&&(p.unmountComponentAtNode(this.node),this.props.container&&this.props.container.removeChild(this.node)),this.node=null,this.portal=null,this._closing=!1},t.prototype.renderPortal=function(e){if(e&&e.children){this._appendPortalContainer(),this.portal&&t.INSTANCES.delete(this.portal);var n=e.isStatic?{}:y;this.portal=p.unstable_renderSubtreeIntoContainer(this,i("div",{style:u({},n,this.props.style,{zIndex:null==e.zIndex?n.zIndex:e.zIndex})},r.cloneElement(e.children,{closePortal:this.handleClose,isOpen:this.state.active})),this.node),t.INSTANCES.add(this.portal)}},t.prototype.render=function(){var e=this.props.trigger;return e?r.cloneElement(e,{ref:"trigger",onClick:this.handleTriggerClick.bind(this,e.props.onClick)}):null},t}(d);g.defaultProps={closeOnEsc:!0,onClose:f,onOpen:f,isStatic:!1,container:document.body},e.exports=g},function(e,t,n){"use strict";var r=n(496).default;t.default=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),r(e,i.key,i)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),t.__esModule=!0},function(e,t,n){e.exports={"default":n(516),__esModule:!0}},function(e,t,n){n(56),n(59),n(65),n(517),n(520),e.exports=n(35).Set},[735,518,519],[734,29,39,89,36,75,49,76,62,68,44,31,54,90,32],function(e,t,n){"use strict";var r=n(29),i=n(30),o=n(34),a=n(33),s=n(39),u=n(89),l=n(76),c=n(75),d=n(54),p=n(42),f=n(32);e.exports=function(e,t,n,h,v,y){var g=i[e],m=g,_=v?"set":"add",A=m&&m.prototype,C={};return f&&"function"==typeof m&&(y||A.forEach&&!a(function(){(new m).entries().next()}))?(m=t(function(t,n){c(t,m,e),t._c=new g,void 0!=n&&l(n,v,t[_],t)}),r.each.call("add,clear,delete,forEach,get,has,set,keys,values,entries".split(","),function(e){var t="add"==e||"set"==e;e in A&&(!y||"clear"!=e)&&s(m.prototype,e,function(n,r){if(!t&&y&&!d(n))return"get"==e?void 0:!1;var i=this._c[e](0===n?0:n,r);return t?this:i})}),"size"in A&&r.setDesc(m.prototype,"size",{get:function(){return this._c.size}})):(m=h.getConstructor(t,e,v,_),u(m.prototype,n)),p(m,e),C[e]=m,o(o.G+o.W+o.F,C),y||h.setStrong(m,e,v),m}},[737,34,521],[736,76,74],function(e,t,n){e.exports={"default":n(523),__esModule:!0}},function(e,t,n){n(59),n(524),e.exports=n(35).Array.from},[733,36,34,107,77,78,79,80,91],function(e,t,n){"use strict";e.exports=n(304)},function(e,t){function n(){}e.exports=n},function(e,t,n){"use strict";var r=n(525);e.exports=function(e,t){return e="function"==typeof e?e():e,r.findDOMNode(e)||t}},function(e,t,n){"use strict";var r=n(525),i=n(529);e.exports=function(e){return i(r.findDOMNode(e))}},function(e,t){"use strict";function n(e){return e&&e.ownerDocument||document}t.__esModule=!0,t.default=n,e.exports=t.default},function(e,t,n){"use strict";var r=n(470).default,i=n(474).default,o=n(465).default,a=n(511).default,s=n(476),u=n(302),l=u.Children,c=u.cloneElement,d=n(531),p=n(528),f=n(527),h=n(304),v=n(110),y=function(e){function t(n,r){i(this,t),e.call(this,n,r),this.state={positionLeft:null,positionTop:null,arrowOffsetLeft:null,arrowOffsetTop:null},this._needsFlush=!1,this._lastTarget=null}return r(t,e),t.prototype.componentWillReceiveProps=function(){this._needsFlush=!0},t.prototype.componentDidMount=function(){var e=this;this.updatePosition(),this._updateOnResize=function(){v(function(){e.updatePosition(!0)})},window.addEventListener("resize",this._updateOnResize)},t.prototype.componentDidUpdate=function(e){this._needsFlush&&(this._needsFlush=!1,this.updatePosition(e.placement!==this.props.placement))},t.prototype.componentWillUnmount=function(){window.removeEventListener("resize",this._updateOnResize)},t.prototype.updatePosition=function(e){var t=this.getTargetSafe();if(t!==this._lastTarget||e){if(this._lastTarget=t,!t)return void this.setState({positionLeft:null,positionTop:null,arrowOffsetLeft:null,arrowOffsetTop:null});var n=h.findDOMNode(this),r=f(this.props.container,p(this).body),i=d.calcOverlayPosition(this.props.placement,n,t,r,this.props.containerPadding);this.setState(i)}},t.prototype.getTargetSafe=function(){if(!this.props.targetFn)return null;var e=this.props.targetFn(this.props);return e?e:null},t.prototype.render=function(){var e=this.props,t=e.children,n=a(e,["children"]),r=this.state,i=r.positionLeft,s=r.positionTop,u=a(r,["positionLeft","positionTop"]),d=l.only(t);return c(d,o({},n,u,{positionLeft:i,positionTop:s,style:o({},d.props.style,{left:i,top:s})}))},t}(s);y.defaultProps={containerPadding:0,placement:"right"},e.exports=y,e.exports=y},function(e,t,n){"use strict";function r(e,t,n,r){var i=l.getContainerDimensions(n),o=i.scroll,a=i.height,s=e-r-o,u=e+r-o+t;return 0>s?-s:u>a?a-u:0}function i(e,t,n,r){var i=l.getContainerDimensions(n),o=i.width,a=e-r,s=e+r+t;return 0>a?-a:s>o?o-s:0}var o=n(528),a=n(532),s=n(536),u=n(546),l={getContainerDimensions:function(e){var t=void 0,n=void 0,r=void 0;if("BODY"===e.tagName)t=window.innerWidth,n=window.innerHeight,r=u(o(e).documentElement)||u(e);else{var i=a(e);t=i.width,n=i.height,r=u(e)}return{width:t,height:n,scroll:r}},getPosition:function(e,t){return"BODY"===t.tagName?a(e):s(e,t)},calcOverlayPosition:function(e,t,n,o,s){var u=this.getPosition(n,o),l=a(t),c=l.height,d=l.width,p=void 0,f=void 0,h=void 0,v=void 0;if("left"===e||"right"===e){f=u.top+(u.height-c)/2,p="left"===e?u.left-d:u.left+u.width;var y=r(f,c,o,s);f+=y,v=50*(1-2*y/c)+"%",h=void 0}else{if("top"!==e&&"bottom"!==e)throw new Error('calcOverlayPosition(): No such placement of "'+e+'" found.');p=u.left+(u.width-d)/2,f="top"===e?u.top-c:u.top+u.height;var g=i(p,d,o,s);p+=g,h=50*(1-2*g/d)+"%",v=void 0}return{positionLeft:p,positionTop:f,arrowOffsetLeft:h,arrowOffsetTop:v}}};e.exports=l},function(e,t,n){"use strict";var r=n(533),i=n(535),o=n(529);e.exports=function(e){var t=o(e),n=i(t),a=t&&t.documentElement,s={top:0,left:0,height:0,width:0};if(t)return r(a,e)?(void 0!==e.getBoundingClientRect&&(s=e.getBoundingClientRect()),(s.width||s.height)&&(s={top:s.top+(n.pageYOffset||a.scrollTop)-(a.clientTop||0),left:s.left+(n.pageXOffset||a.scrollLeft)-(a.clientLeft||0),width:(null==s.width?e.offsetWidth:s.width)||0,height:(null==s.height?e.offsetHeight:s.height)||0}),s):s}},function(e,t,n){"use strict";var r=n(534),i=function(){var e=r&&document.documentElement;return e&&e.contains?function(e,t){return e.contains(t)}:e&&e.compareDocumentPosition?function(e,t){return e===t||!!(16&e.compareDocumentPosition(t))}:function(e,t){if(t)do if(t===e)return!0;while(t=t.parentNode);return!1}}();e.exports=i},function(e,t){"use strict";e.exports=!("undefined"==typeof window||!window.document||!window.document.createElement)},function(e,t){"use strict";e.exports=function(e){return e===e.window?e:9===e.nodeType?e.defaultView||e.parentWindow:!1}},function(e,t,n){"use strict";function r(e){return e.nodeName&&e.nodeName.toLowerCase()}function i(e,t){var n,i={top:0,left:0};return"fixed"===(0,v.default)(e,"position")?n=e.getBoundingClientRect():(t=t||(0,l.default)(e),n=(0,s.default)(e),"html"!==r(t)&&(i=(0,s.default)(t)),i.top+=parseInt((0,v.default)(t,"borderTopWidth"),10)-(0,d.default)(t)||0,i.left+=parseInt((0,v.default)(t,"borderLeftWidth"),10)-(0,f.default)(t)||0),o._extends({},n,{top:n.top-i.top-(parseInt((0,v.default)(e,"marginTop"),10)||0),left:n.left-i.left-(parseInt((0,v.default)(e,"marginLeft"),10)||0)})}var o=n(537);t.__esModule=!0,t.default=i;var a=n(532),s=o.interopRequireDefault(a),u=n(538),l=o.interopRequireDefault(u),c=n(546),d=o.interopRequireDefault(c),p=n(547),f=o.interopRequireDefault(p),h=n(539),v=o.interopRequireDefault(h);e.exports=t.default},function(e,t,n){var r,i,o;!function(n,a){i=[t],r=a,o="function"==typeof r?r.apply(t,i):r,!(void 0!==o&&(e.exports=o))}(this,function(e){var t=e;t.interopRequireDefault=function(e){return e&&e.__esModule?e:{"default":e}},t._extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}})},function(e,t,n){"use strict";function r(e){return e.nodeName&&e.nodeName.toLowerCase()}function i(e){for(var t=(0,s.default)(e),n=e&&e.offsetParent;n&&"html"!==r(e)&&"static"===(0,l.default)(n,"position");)n=n.offsetParent;return n||t.documentElement}var o=n(537);t.__esModule=!0,t.default=i;var a=n(529),s=o.interopRequireDefault(a),u=n(539),l=o.interopRequireDefault(u);e.exports=t.default},function(e,t,n){"use strict";var r=n(540),i=n(542),o=n(544),a=n(545),s=Object.prototype.hasOwnProperty;e.exports=function(e,t,n){var u="",l=t;if("string"==typeof t){if(void 0===n)return e.style[r(t)]||o(e).getPropertyValue(i(t));(l={})[t]=n}for(var c in l)s.call(l,c)&&(l[c]||0===l[c]?u+=i(c)+":"+l[c]+";":a(e,i(c)));e.style.cssText+=";"+u}},function(e,t,n){"use strict";var r=n(541),i=/^-ms-/;e.exports=function(e){return r(e.replace(i,"ms-"))}},function(e,t){"use strict";var n=/-(.)/g;e.exports=function(e){return e.replace(n,function(e,t){return t.toUpperCase()})}},function(e,t,n){"use strict";var r=n(543),i=/^ms-/;e.exports=function(e){return r(e).replace(i,"-ms-")}},function(e,t){"use strict";var n=/([A-Z])/g;e.exports=function(e){return e.replace(n,"-$1").toLowerCase()}},function(e,t,n){"use strict";var r=n(537),i=n(540),o=r.interopRequireDefault(i),a=/^(top|right|bottom|left)$/,s=/^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;e.exports=function(e){if(!e)throw new TypeError("No Element passed to `getComputedStyle()`");var t=e.ownerDocument;return"defaultView"in t?t.defaultView.opener?e.ownerDocument.defaultView.getComputedStyle(e,null):window.getComputedStyle(e,null):{getPropertyValue:function(t){var n=e.style;t=(0,o.default)(t),"float"==t&&(t="styleFloat");var r=e.currentStyle[t]||null;if(null==r&&n&&n[t]&&(r=n[t]),s.test(r)&&!a.test(t)){var i=n.left,u=e.runtimeStyle,l=u&&u.left;l&&(u.left=e.currentStyle.left),n.left="fontSize"===t?"1em":r,r=n.pixelLeft+"px",n.left=i,l&&(u.left=l)}return r}}}},function(e,t){"use strict";e.exports=function(e,t){return"removeProperty"in e.style?e.style.removeProperty(t):e.style.removeAttribute(t)}},function(e,t,n){"use strict";var r=n(535);e.exports=function(e,t){var n=r(e);return void 0===t?n?"pageYOffset"in n?n.pageYOffset:n.document.documentElement.scrollTop:e.scrollTop:void(n?n.scrollTo("pageXOffset"in n?n.pageXOffset:n.document.documentElement.scrollLeft,t):e.scrollTop=t)}},function(e,t,n){"use strict";var r=n(535);e.exports=function(e,t){var n=r(e);return void 0===t?n?"pageXOffset"in n?n.pageXOffset:n.document.documentElement.scrollLeft:e.scrollLeft:void(n?n.scrollTo(t,"pageYOffset"in n?n.pageYOffset:n.document.documentElement.scrollTop):e.scrollLeft=t)}},function(e,t,n){function r(e){var t=e.w,n=e.style;return i("svg",{style:n,width:t,height:t,viewBox:"0 0 21 21",preserveAspectRatio:"xMinYMin",xmlns:"http://www.w3.org/2000/svg"},i("polygon",{points:"21,2.1 18.9,0 10.5,8.4 2.1,0 0,2.1 8.4,10.5 0,18.9 2.1,21 10.5,12.6 18.9,21 21,18.9 12.6,10.5 "}))}var i=n(464);r.defaultProps={w:21},e.exports=r},function(e,t,n){function r(e){return e&&e.length?i(e,o,a):void 0}var i=n(550),o=n(551),a=n(552);e.exports=r},function(e,t){function n(e,t,n){for(var r=-1,i=e.length;++r<i;){var o=e[r],a=t(o);if(null!=a&&(void 0===s?a===a:n(a,s)))var s=a,u=o}return u}e.exports=n},function(e,t){function n(e){return e}e.exports=n},function(e,t){function n(e,t){return t>e}e.exports=n},function(e,t,n){function r(e,t){var n=s(e)?i:a;return n(e,o(t,3))}var i=n(554),o=n(555),a=n(638),s=n(611);e.exports=r},function(e,t){function n(e,t){for(var n=-1,r=e.length,i=Array(r);++n<r;)i[n]=t(e[n],n,e);return i}e.exports=n},function(e,t,n){function r(e){return"function"==typeof e?e:null==e?a:"object"==typeof e?s(e)?o(e[0],e[1]):i(e):u(e)}var i=n(556),o=n(626),a=n(551),s=n(611),u=n(636);e.exports=r},function(e,t,n){function r(e){var t=o(e);return 1==t.length&&t[0][2]?a(t[0][0],t[0][1]):function(n){return n===e||i(n,e,t)}}var i=n(557),o=n(621),a=n(625);e.exports=r},function(e,t,n){function r(e,t,n,r){var u=n.length,l=u,c=!r;if(null==e)return!l;for(e=Object(e);u--;){var d=n[u];if(c&&d[2]?d[1]!==e[d[0]]:!(d[0]in e))return!1}for(;++u<l;){d=n[u];var p=d[0],f=e[p],h=d[1];if(c&&d[2]){if(void 0===f&&!(p in e))return!1}else{var v=new i;if(r)var y=r(f,h,p,e,t,v);if(!(void 0===y?o(h,f,r,a|s,v):y))return!1}}return!0}var i=n(558),o=n(590),a=1,s=2;e.exports=r},function(e,t,n){function r(e){var t=-1,n=e?e.length:0;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}var i=n(559),o=n(560),a=n(564),s=n(566),u=n(568);r.prototype.clear=i,r.prototype.delete=o,r.prototype.get=a,r.prototype.has=s,r.prototype.set=u,e.exports=r},function(e,t){function n(){this.__data__={array:[],map:null}}e.exports=n},function(e,t,n){function r(e){var t=this.__data__,n=t.array;return n?i(n,e):t.map.delete(e)}var i=n(561);e.exports=r},function(e,t,n){function r(e,t){var n=i(e,t);if(0>n)return!1;var r=e.length-1;return n==r?e.pop():a.call(e,n,1),!0}var i=n(562),o=Array.prototype,a=o.splice;e.exports=r},function(e,t,n){function r(e,t){for(var n=e.length;n--;)if(i(e[n][0],t))return n;return-1}var i=n(563);e.exports=r},function(e,t){
function n(e,t){return e===t||e!==e&&t!==t}e.exports=n},function(e,t,n){function r(e){var t=this.__data__,n=t.array;return n?i(n,e):t.map.get(e)}var i=n(565);e.exports=r},function(e,t,n){function r(e,t){var n=i(e,t);return 0>n?void 0:e[n][1]}var i=n(562);e.exports=r},function(e,t,n){function r(e){var t=this.__data__,n=t.array;return n?i(n,e):t.map.has(e)}var i=n(567);e.exports=r},function(e,t,n){function r(e,t){return i(e,t)>-1}var i=n(562);e.exports=r},function(e,t,n){function r(e,t){var n=this.__data__,r=n.array;r&&(r.length<a-1?o(r,e,t):(n.array=null,n.map=new i(r)));var s=n.map;return s&&s.set(e,t),this}var i=n(569),o=n(588),a=200;e.exports=r},function(e,t,n){function r(e){var t=-1,n=e?e.length:0;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1])}}var i=n(570),o=n(580),a=n(584),s=n(586),u=n(587);r.prototype.clear=i,r.prototype.delete=o,r.prototype.get=a,r.prototype.has=s,r.prototype.set=u,e.exports=r},function(e,t,n){function r(){this.__data__={hash:new i,map:o?new o:[],string:new i}}var i=n(571),o=n(579);e.exports=r},function(e,t,n){function r(){}var i=n(572),o=Object.prototype;r.prototype=i?i(null):o,e.exports=r},function(e,t,n){var r=n(573),i=r(Object,"create");e.exports=i},function(e,t,n){function r(e,t){var n=e[t];return i(n)?n:void 0}var i=n(574);e.exports=r},function(e,t,n){function r(e){if(!a(e))return!1;var t=i(e)||o(e)?f:l;return t.test(s(e))}var i=n(575),o=n(577),a=n(576),s=n(578),u=/[\\^$.*+?()[\]{}|]/g,l=/^\[object .+?Constructor\]$/,c=Object.prototype,d=Function.prototype.toString,p=c.hasOwnProperty,f=RegExp("^"+d.call(p).replace(u,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");e.exports=r},function(e,t,n){function r(e){var t=i(e)?u.call(e):"";return t==o||t==a}var i=n(576),o="[object Function]",a="[object GeneratorFunction]",s=Object.prototype,u=s.toString;e.exports=r},function(e,t){function n(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}e.exports=n},function(e,t){function n(e){var t=!1;if(null!=e&&"function"!=typeof e.toString)try{t=!!(e+"")}catch(n){}return t}e.exports=n},function(e,t){function n(e){if(null!=e){try{return r.call(e)}catch(t){}try{return e+""}catch(t){}}return""}var r=Function.prototype.toString;e.exports=n},function(e,t,n){var r=n(573),i=n(490),o=r(i,"Map");e.exports=o},function(e,t,n){function r(e){var t=this.__data__;return s(e)?a("string"==typeof e?t.string:t.hash,e):i?t.map.delete(e):o(t.map,e)}var i=n(579),o=n(561),a=n(581),s=n(583);e.exports=r},function(e,t,n){function r(e,t){return i(e,t)&&delete e[t]}var i=n(582);e.exports=r},function(e,t,n){function r(e,t){return i?void 0!==e[t]:a.call(e,t)}var i=n(572),o=Object.prototype,a=o.hasOwnProperty;e.exports=r},function(e,t){function n(e){var t=typeof e;return"number"==t||"boolean"==t||"string"==t&&"__proto__"!=e||null==e}e.exports=n},function(e,t,n){function r(e){var t=this.__data__;return s(e)?a("string"==typeof e?t.string:t.hash,e):i?t.map.get(e):o(t.map,e)}var i=n(579),o=n(565),a=n(585),s=n(583);e.exports=r},function(e,t,n){function r(e,t){if(i){var n=e[t];return n===o?void 0:n}return s.call(e,t)?e[t]:void 0}var i=n(572),o="__lodash_hash_undefined__",a=Object.prototype,s=a.hasOwnProperty;e.exports=r},function(e,t,n){function r(e){var t=this.__data__;return s(e)?a("string"==typeof e?t.string:t.hash,e):i?t.map.has(e):o(t.map,e)}var i=n(579),o=n(567),a=n(582),s=n(583);e.exports=r},function(e,t,n){function r(e,t){var n=this.__data__;return s(e)?a("string"==typeof e?n.string:n.hash,e,t):i?n.map.set(e,t):o(n.map,e,t),this}var i=n(579),o=n(588),a=n(589),s=n(583);e.exports=r},function(e,t,n){function r(e,t,n){var r=i(e,t);0>r?e.push([t,n]):e[r][1]=n}var i=n(562);e.exports=r},function(e,t,n){function r(e,t,n){e[t]=i&&void 0===n?o:n}var i=n(572),o="__lodash_hash_undefined__";e.exports=r},function(e,t,n){function r(e,t,n,s,u){return e===t?!0:null==e||null==t||!o(e)&&!a(t)?e!==e&&t!==t:i(e,t,r,n,s,u)}var i=n(591),o=n(576),a=n(494);e.exports=r},function(e,t,n){function r(e,t,n,r,y,m){var _=l(e),A=l(t),C=h,b=h;_||(C=u(e),C=C==f?v:C),A||(b=u(t),b=b==f?v:b);var S=C==v&&!c(e),M=b==v&&!c(t),T=C==b;if(T&&!S)return m||(m=new i),_||d(e)?o(e,t,n,r,y,m):a(e,t,C,n,r,y,m);if(!(y&p)){var E=S&&g.call(e,"__wrapped__"),w=M&&g.call(t,"__wrapped__");if(E||w){var x=E?e.value():e,k=w?t.value():t;return m||(m=new i),n(x,k,r,y,m)}}return T?(m||(m=new i),s(e,t,n,r,y,m)):!1}var i=n(558),o=n(592),a=n(594),s=n(598),u=n(615),l=n(611),c=n(577),d=n(620),p=2,f="[object Arguments]",h="[object Array]",v="[object Object]",y=Object.prototype,g=y.hasOwnProperty;e.exports=r},function(e,t,n){function r(e,t,n,r,s,u){var l=-1,c=s&a,d=s&o,p=e.length,f=t.length;if(p!=f&&!(c&&f>p))return!1;var h=u.get(e);if(h)return h==t;var v=!0;for(u.set(e,t);++l<p;){var y=e[l],g=t[l];if(r)var m=c?r(g,y,l,t,e,u):r(y,g,l,e,t,u);if(void 0!==m){if(m)continue;v=!1;break}if(d){if(!i(t,function(e){return y===e||n(y,e,r,s,u)})){v=!1;break}}else if(y!==g&&!n(y,g,r,s,u)){v=!1;break}}return u.delete(e),v}var i=n(593),o=1,a=2;e.exports=r},function(e,t){function n(e,t){for(var n=-1,r=e.length;++n<r;)if(t(e[n],n,e))return!0;return!1}e.exports=n},function(e,t,n){function r(e,t,n,r,i,b,M){switch(n){case C:if(e.byteLength!=t.byteLength||e.byteOffset!=t.byteOffset)return!1;e=e.buffer,t=t.buffer;case A:return!(e.byteLength!=t.byteLength||!r(new o(e),new o(t)));case d:case p:return+e==+t;case f:return e.name==t.name&&e.message==t.message;case v:return e!=+e?t!=+t:e==+t;case y:case m:return e==t+"";case h:var T=s;case g:var E=b&c;if(T||(T=u),e.size!=t.size&&!E)return!1;var w=M.get(e);return w?w==t:(b|=l,M.set(e,t),a(T(e),T(t),r,i,b,M));case _:if(S)return S.call(e)==S.call(t)}return!1}var i=n(489),o=n(595),a=n(592),s=n(596),u=n(597),l=1,c=2,d="[object Boolean]",p="[object Date]",f="[object Error]",h="[object Map]",v="[object Number]",y="[object RegExp]",g="[object Set]",m="[object String]",_="[object Symbol]",A="[object ArrayBuffer]",C="[object DataView]",b=i?i.prototype:void 0,S=b?b.valueOf:void 0;e.exports=r},function(e,t,n){var r=n(490),i=r.Uint8Array;e.exports=i},function(e,t){function n(e){var t=-1,n=Array(e.size);return e.forEach(function(e,r){n[++t]=[r,e]}),n}e.exports=n},function(e,t){function n(e){var t=-1,n=Array(e.size);return e.forEach(function(e){n[++t]=e}),n}e.exports=n},function(e,t,n){function r(e,t,n,r,s,u){var l=s&a,c=o(e),d=c.length,p=o(t),f=p.length;if(d!=f&&!l)return!1;for(var h=d;h--;){var v=c[h];if(!(l?v in t:i(t,v)))return!1}var y=u.get(e);if(y)return y==t;var g=!0;u.set(e,t);for(var m=l;++h<d;){v=c[h];var _=e[v],A=t[v];if(r)var C=l?r(A,_,v,t,e,u):r(_,A,v,e,t,u);if(!(void 0===C?_===A||n(_,A,r,s,u):C)){g=!1;break}m||(m="constructor"==v)}if(g&&!m){var b=e.constructor,S=t.constructor;b!=S&&"constructor"in e&&"constructor"in t&&!("function"==typeof b&&b instanceof b&&"function"==typeof S&&S instanceof S)&&(g=!1)}return u.delete(e),g}var i=n(599),o=n(601),a=2;e.exports=r},function(e,t,n){function r(e,t){return a.call(e,t)||"object"==typeof e&&t in e&&null===i(e)}var i=n(600),o=Object.prototype,a=o.hasOwnProperty;e.exports=r},function(e,t){function n(e){return r(Object(e))}var r=Object.getPrototypeOf;e.exports=n},function(e,t,n){function r(e){var t=l(e);if(!t&&!s(e))return o(e);var n=a(e),r=!!n,c=n||[],d=c.length;for(var p in e)!i(e,p)||r&&("length"==p||u(p,d))||t&&"constructor"==p||c.push(p);return c}var i=n(599),o=n(602),a=n(603),s=n(607),u=n(613),l=n(614);e.exports=r},function(e,t){function n(e){return r(Object(e))}var r=Object.keys;e.exports=n},function(e,t,n){function r(e){var t=e?e.length:void 0;return s(t)&&(a(e)||u(e)||o(e))?i(t,String):null}var i=n(604),o=n(605),a=n(611),s=n(610),u=n(612);e.exports=r},function(e,t){function n(e,t){for(var n=-1,r=Array(e);++n<e;)r[n]=t(n);return r}e.exports=n},function(e,t,n){function r(e){return i(e)&&s.call(e,"callee")&&(!l.call(e,"callee")||u.call(e)==o)}var i=n(606),o="[object Arguments]",a=Object.prototype,s=a.hasOwnProperty,u=a.toString,l=a.propertyIsEnumerable;e.exports=r},function(e,t,n){function r(e){return o(e)&&i(e)}var i=n(607),o=n(494);e.exports=r},function(e,t,n){function r(e){return null!=e&&a(i(e))&&!o(e)}var i=n(608),o=n(575),a=n(610);e.exports=r},function(e,t,n){var r=n(609),i=r("length");e.exports=i},function(e,t){function n(e){return function(t){return null==t?void 0:t[e]}}e.exports=n},function(e,t){function n(e){return"number"==typeof e&&e>-1&&e%1==0&&r>=e}var r=9007199254740991;e.exports=n},function(e,t){var n=Array.isArray;e.exports=n},function(e,t,n){function r(e){return"string"==typeof e||!i(e)&&o(e)&&u.call(e)==a}var i=n(611),o=n(494),a="[object String]",s=Object.prototype,u=s.toString;e.exports=r},function(e,t){function n(e,t){return e="number"==typeof e||i.test(e)?+e:-1,t=null==t?r:t,e>-1&&e%1==0&&t>e}var r=9007199254740991,i=/^(?:0|[1-9]\d*)$/;e.exports=n},function(e,t){function n(e){var t=e&&e.constructor,n="function"==typeof t&&t.prototype||r;return e===n}var r=Object.prototype;e.exports=n},function(e,t,n){function r(e){return g.call(e)}var i=n(616),o=n(579),a=n(617),s=n(618),u=n(619),l=n(578),c="[object Map]",d="[object Object]",p="[object Promise]",f="[object Set]",h="[object WeakMap]",v="[object DataView]",y=Object.prototype,g=y.toString,m=l(i),_=l(o),A=l(a),C=l(s),b=l(u);(i&&r(new i(new ArrayBuffer(1)))!=v||o&&r(new o)!=c||a&&r(a.resolve())!=p||s&&r(new s)!=f||u&&r(new u)!=h)&&(r=function(e){var t=g.call(e),n=t==d?e.constructor:void 0,r=n?l(n):void 0;if(r)switch(r){case m:return v;case _:return c;case A:return p;case C:return f;case b:return h}return t}),e.exports=r},function(e,t,n){var r=n(573),i=n(490),o=r(i,"DataView");e.exports=o},function(e,t,n){var r=n(573),i=n(490),o=r(i,"Promise");e.exports=o},function(e,t,n){var r=n(573),i=n(490),o=r(i,"Set");e.exports=o},function(e,t,n){var r=n(573),i=n(490),o=r(i,"WeakMap");e.exports=o},function(e,t,n){function r(e){return o(e)&&i(e.length)&&!!I[D.call(e)]}var i=n(610),o=n(494),a="[object Arguments]",s="[object Array]",u="[object Boolean]",l="[object Date]",c="[object Error]",d="[object Function]",p="[object Map]",f="[object Number]",h="[object Object]",v="[object RegExp]",y="[object Set]",g="[object String]",m="[object WeakMap]",_="[object ArrayBuffer]",A="[object DataView]",C="[object Float32Array]",b="[object Float64Array]",S="[object Int8Array]",M="[object Int16Array]",T="[object Int32Array]",E="[object Uint8Array]",w="[object Uint8ClampedArray]",x="[object Uint16Array]",k="[object Uint32Array]",I={};I[C]=I[b]=I[S]=I[M]=I[T]=I[E]=I[w]=I[x]=I[k]=!0,I[a]=I[s]=I[_]=I[u]=I[A]=I[l]=I[c]=I[d]=I[p]=I[f]=I[h]=I[v]=I[y]=I[g]=I[m]=!1;var P=Object.prototype,D=P.toString;e.exports=r},function(e,t,n){function r(e){for(var t=o(e),n=t.length;n--;)t[n][2]=i(t[n][1]);return t}var i=n(622),o=n(623);e.exports=r},function(e,t,n){function r(e){return e===e&&!i(e)}var i=n(576);e.exports=r},function(e,t,n){function r(e){return i(e,o(e))}var i=n(624),o=n(601);e.exports=r},function(e,t,n){function r(e,t){return i(t,function(t){return[t,e[t]]})}var i=n(554);e.exports=r},function(e,t){function n(e,t){return function(n){return null==n?!1:n[e]===t&&(void 0!==t||e in Object(n))}}e.exports=n},function(e,t,n){function r(e,t){return s(e)&&u(t)?l(e,t):function(n){var r=o(n,e);return void 0===r&&r===t?a(n,e):i(t,r,void 0,c|d)}}var i=n(590),o=n(627),a=n(633),s=n(632),u=n(622),l=n(625),c=1,d=2;e.exports=r},function(e,t,n){function r(e,t,n){var r=null==e?void 0:i(e,t);return void 0===r?n:r}var i=n(628);e.exports=r},function(e,t,n){function r(e,t){t=o(t,e)?[t]:i(t);for(var n=0,r=t.length;null!=e&&r>n;)e=e[t[n++]];return n&&n==r?e:void 0}var i=n(629),o=n(632);e.exports=r},function(e,t,n){function r(e){return i(e)?e:o(e)}var i=n(611),o=n(630);e.exports=r},function(e,t,n){var r=n(631),i=n(488),o=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]/g,a=/\\(\\)?/g,s=r(function(e){var t=[];return i(e).replace(o,function(e,n,r,i){t.push(r?i.replace(a,"$1"):n||e)}),t});e.exports=s},function(e,t,n){function r(e,t){if("function"!=typeof e||t&&"function"!=typeof t)throw new TypeError(o);var n=function(){var r=arguments,i=t?t.apply(this,r):r[0],o=n.cache;if(o.has(i))return o.get(i);var a=e.apply(this,r);return n.cache=o.set(i,a),a};return n.cache=new(r.Cache||i),n}var i=n(569),o="Expected a function";r.Cache=i,e.exports=r},function(e,t,n){function r(e,t){var n=typeof e;return"number"==n||"symbol"==n?!0:!i(e)&&(o(e)||s.test(e)||!a.test(e)||null!=t&&e in Object(t))}var i=n(611),o=n(493),a=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,s=/^\w*$/;e.exports=r},function(e,t,n){function r(e,t){return null!=e&&o(e,t,i)}var i=n(634),o=n(635);e.exports=r},function(e,t){function n(e,t){return t in Object(e)}e.exports=n},function(e,t,n){function r(e,t,n){t=u(t,e)?[t]:i(t);for(var r,d=-1,p=t.length;++d<p;){var f=t[d];if(!(r=null!=e&&n(e,f)))break;e=e[f]}if(r)return r;var p=e?e.length:0;return!!p&&l(p)&&s(f,p)&&(a(e)||c(e)||o(e))}var i=n(629),o=n(605),a=n(611),s=n(613),u=n(632),l=n(610),c=n(612);e.exports=r},function(e,t,n){function r(e){return a(e)?i(e):o(e)}var i=n(609),o=n(637),a=n(632);e.exports=r},function(e,t,n){function r(e){return function(t){return i(t,e)}}var i=n(628);e.exports=r},function(e,t,n){function r(e,t){var n=-1,r=o(e)?Array(e.length):[];return i(e,function(e,i,o){r[++n]=t(e,i,o)}),r}var i=n(639),o=n(607);e.exports=r},function(e,t,n){var r=n(640),i=n(643),o=i(r);e.exports=o},function(e,t,n){function r(e,t){return e&&i(e,t,o)}var i=n(641),o=n(601);e.exports=r},function(e,t,n){var r=n(642),i=r();e.exports=i},function(e,t){function n(e){return function(t,n,r){for(var i=-1,o=Object(t),a=r(t),s=a.length;s--;){var u=a[e?s:++i];if(n(o[u],u,o)===!1)break}return t}}e.exports=n},function(e,t,n){function r(e,t){return function(n,r){if(null==n)return n;if(!i(n))return e(n,r);for(var o=n.length,a=t?o:-1,s=Object(n);(t?a--:++a<o)&&r(s[a],a,s)!==!1;);return n}}var i=n(607);e.exports=r},function(e,t,n){function r(e){return e&&e.length?i(e):[]}var i=n(645);e.exports=r},function(e,t,n){function r(e,t,n){var r=-1,d=o,p=e.length,f=!0,h=[],v=h;if(n)f=!1,d=a;else if(p>=c){var y=t?null:u(e);if(y)return l(y);f=!1,d=s,v=new i}else v=t?[]:h;e:for(;++r<p;){var g=e[r],m=t?t(g):g;if(f&&m===m){for(var _=v.length;_--;)if(v[_]===m)continue e;t&&v.push(m),h.push(g)}else d(v,m,n)||(v!==h&&v.push(m),h.push(g))}return h}var i=n(646),o=n(648),a=n(649),s=n(650),u=n(651),l=n(597),c=200;e.exports=r},function(e,t,n){function r(e){var t=-1,n=e?e.length:0;for(this.__data__=new i;++t<n;)this.push(e[t])}var i=n(569),o=n(647);r.prototype.push=o,e.exports=r},function(e,t,n){function r(e){var t=this.__data__;if(i(e)){var n=t.__data__,r="string"==typeof e?n.string:n.hash;r[e]=o}else t.set(e,o)}var i=n(583),o="__lodash_hash_undefined__";e.exports=r},function(e,t,n){function r(e,t){return!!e.length&&i(e,t,0)>-1}var i=n(485);e.exports=r},function(e,t){function n(e,t,n){for(var r=-1,i=e.length;++r<i;)if(n(t,e[r]))return!0;return!1}e.exports=n},function(e,t,n){function r(e,t){var n=e.__data__;if(i(t)){var r=n.__data__,a="string"==typeof t?r.string:r.hash;return a[t]===o}return n.has(t)}var i=n(583),o="__lodash_hash_undefined__";e.exports=r},function(e,t,n){var r=n(618),i=n(526),o=r&&2===new r([1,2]).size?function(e){return new r(e)}:i;e.exports=o},function(e,t,n){"use strict";function r(e){e=s.addLeadingZeros(e,4);var t=parseInt(e.substring(0,2),10),n=parseInt(e.substring(2,4),10);return 60*t+n}function i(e,t){var n=e.getTime()-t.getTime(),i=Math.floor(n/p),o=Math.floor(i/60),a=i%60;return r(""+s.addLeadingZeros(o,2)+s.addLeadingZeros(a,2))}var o=n(515).default,a=n(653),s=n(654),u=n(662),l=u.parseDateString,c=u.stringifyDate,d=u.getDateTime;e.exports=function(e){for(var t=[],n=t[t.length]={},s=n.segmentsList=[],u=null,p=void 0,f=void 0,h=0,v=e.length,y=0,g=0,m=void 0,_=new o,A=[],C=[];h!==v;){f=e[h],m&&f.conx||(m=f.airCmp,_.add(m)),f.oprdBy?C.push(f.oprdBy):C.push(f.airCmp);var b=r(f.fltTm);y+=b;var S=f.endDate;if(S||(f.dayChg?(S=l(f.stDt),S.setDate(S.getDate()+f.dayChg),S=c(S)):S=f.stDt),p={type:a.TYPE_FLIGHT,infoMap:{duration:b,airlineCode:f.airCmp,aircraftCode:f.plane,flightNumber:f.fltNm,marketingAirlineCode:m,operatingAirlineCode:f.oprdBy||f.airCmp,flightStats:f.flightInfo,reserveClass:f.reservClass,serviceClass:f.serviceClass||f.srvCls,baggageCode:f.bg||"",isLowcost:f.isLowcost},statsMap:f.flightInfo,fromMap:{airportCode:f.from,terminal:f.stTrm||"",date:f.stDt,time:f.stTm,dateObj:d(f.stDt,f.stTm)},toMap:{airportCode:f.to,terminal:f.endTrm||"",date:S,time:f.endTm,dateObj:d(S,f.endTm)}},u){var M=i(p.fromMap.dateObj,u.toMap.dateObj);s[s.length]={type:a.TYPE_TRANSFER,duration:M,"in":u.toMap.airportCode,needChangeTerminal:p.fromMap.terminal!==u.toMap.terminal,needChangeAirport:p.fromMap.airportCode!==u.toMap.airportCode},g+=1,y+=M}u=s[s.length]=p,h++,f.conx||(n.marketingAirlineCode=s[0].infoMap.marketingAirlineCode,n.operatingAirlineCode=s[0].infoMap.operatingAirlineCode,n.durationInMinutes=y,n.changes=g,g=0,y=0),f.conx||h===v||(u=null,A.push(C),C=[],n=t[t.length]={},s=n.segmentsList=[])}return t};var p=6e4},function(e,t,n){"use strict";var r={TRIPS______LIST:"tripsList",TRIPS______LIST_TIDY:"tripsListTidy",WAYS_______LIST:"waysList",WAYS_______LIST_TIDY:"waysListTidy",ADULTS_____COUNT:"adultsCount",ADULTS_____COUNT_TIDY:"adultsCountTidy",ADULTS_____COUNT_ADD:"adultsCountAdd",ADULTS_____PRICE:"adultsPrice",ADULTS_____PRICE_TIDY:"adultsPriceTidy",ADULTS_____TOTAL:"adultsTotal",ADULTS_____TOTAL_TIDY:"adultsTotalTidy",ADULTS_____LIST:"adultsList",ADULTS_____LIST_TIDY:"adultsListTidy",ADULTS_____FILTERED_LIST:"adultsFilteredList",ADULTS_____FILTERED_LIST_TIDY:"adultsFilteredListTidy",CHILDREN___COUNT:"childrenCount",CHILDREN___COUNT_TIDY:"childrenCountTidy",CHILDREN___COUNT_ADD:"childrenCountAdd",CHILDREN___PRICE:"childrenPrice",CHILDREN___PRICE_TIDY:"childrenPriceTidy",CHILDREN___TOTAL:"childrenTotal",CHILDREN___TOTAL_TIDY:"childrenTotalTidy",CHILDREN___LIST:"childrenList",CHILDREN___LIST_TIDY:"childrenListTidy",CHILDREN___FILTERED_LIST:"childrenFilteredList",CHILDREN___FILTERED_LIST_TIDY:"childrenFilteredListTidy",INFANTS____COUNT:"infantsCount",INFANTS____COUNT_TIDY:"infantsCountTidy",INFANTS____COUNT_ADD:"infantsCountAdd",INFANTS____PRICE:"infantsPrice",INFANTS____PRICE_TIDY:"infantsPriceTidy",INFANTS____TOTAL:"infantsTotal",INFANTS____TOTAL_TIDY:"infantsTotalTidy",INFANTS____LIST:"infantsList",INFANTS____LIST_TIDY:"infantsListTidy",INFANTS____FILTERED_LIST:"infantsFilteredList",INFANTS____FILTERED_LIST_TIDY:"infantsFilteredListTidy",PASSENGERS_COUNT:"passengersCount",PASSENGERS_COUNT_TIDY:"passengersCountTidy",PASSENGERS_TOTAL:"passengersTotal",PASSENGERS_TOTAL_TIDY:"passengersTotalTidy",PASSENGERS_LIST:"passengersList",PASSENGERS_LIST_TIDY:"passengersListTidy",PASSENGERS_FILTERED_LIST:"passengersFilteredList",PASSENGERS_FILTERED_LIST_TIDY:"passengersFilteredListTidy",GO_AHEAD:"goAhead",GO_BACK:"goBack",PROMO_CODE:"promoCode",USER_INFO:"userInfo",TYPE_FLIGHT:"typeFlight",TYPE_TRANSFER:"typeTransfer"};e.exports=r},function(e,t,n){"use strict";function r(e,t){var n=e,r=t.min,i=t.max;if(r>e&&100>=i-r-e){var a=o(e);if(a===o(r))n=r;else{var s=Math.pow(10,a),u=Math.floor(r/s)*s;isNaN(u)&&(u=0);var l=u+e;r>l?(u=Math.floor(i/s)*s,e=u+e):e=l,n=e}return n}return r>=e?n=r:e>=i&&(n=i),n}function i(e){return Math.pow(10,Math.max(Math.floor(u(Math.abs(e))),0))}function o(e){return(""+e).length}function a(e,t){var n=o(e);return t>n?""+l("0",t-n)+e:e}function s(e){return"string"==typeof e&&(e=e.replace(c,"")),e}var u=n(655).default,l=n(658).default,c=/\D+/g;e.exports={toRange:r,getTens:i,numDigits:o,addLeadingZeros:a,removeNonDigit:s}},function(e,t,n){e.exports={"default":n(656),__esModule:!0}},function(e,t,n){n(657),e.exports=n(35).Math.log10},[730,34],function(e,t,n){e.exports={"default":n(659),__esModule:!0}},function(e,t,n){n(660),e.exports=n(35).String.repeat},[731,34,661],[732,61,49],function(e,t,n){"use strict";function r(e){return"function"!=typeof e.getMonth&&(e=new Date(e)),e}var i=n(663),o=1e3,a=60*o,s=60*a,u=24*s,l={days:u,hours:s,minutes:a},c=function(e){return"function"!=typeof e.getMonth&&(e=new Date(e)),e.getTime()},d=function(e,t){return e=c(e),t=c(t),e>t},p=function(e,t){var n=arguments.length<=2||void 0===arguments[2]?"days":arguments[2];return e===t?!0:(e=c(e),t=c(t),Math.floor(e/l[n])===Math.floor(t/l[n]))},f=function(e,t){var n=arguments.length<=2||void 0===arguments[2]?"days":arguments[2];return e=c(e),t=c(t),Math.floor((t-e)/l[n])},h=function(e,t){var n=arguments.length<=2||void 0===arguments[2]?"days":arguments[2];return e=c(e),new Date(e+t*l[n])},v=/^(\d)\:/,y=/\:(\d)$/,g=function(e){return e.replace(v,"0$1:").replace(y,":0$1")},m=function(e){return i(e instanceof Date,"Date instance should be passed"),e.setUTCHours(0),e.setUTCMinutes(0),e.setUTCSeconds(0),e.setUTCMilliseconds(0),e},_=function(e){return"string"==typeof e&&(e=new Date(e+"Z")),new Date(e.getTime()+6e4*e.getTimezoneOffset())},A=function(e){return e=r(e),isNaN(e)?"":[e.getFullYear(),("0"+(e.getMonth()+1)).slice(-2),("0"+e.getDate()).slice(-2)].join("-")},C=function(e){var t=arguments.length<=1||void 0===arguments[1]?".":arguments[1];return e=r(e),isNaN(e)?"":[("0"+e.getDate()).slice(-2),("0"+(e.getMonth()+1)).slice(-2)].join(t)},b=function(e){var t=new Date(e);return new Date(t.getTime()+6e4*t.getTimezoneOffset())},S=function(e){var t=e.substring(6),n=e.substring(4,6),r=e.substring(0,4);return new Date(r,n-1,t)},M=function(e){var t=e.substring(0,2),n=e.substring(2,4),r=e.substring(4);return new Date(r,n-1,t)},T=function(e){return 10>e?"0"+e:e},E=function(e){var t=T(e.getDate()),n=T(e.getMonth()+1),r=e.getFullYear();return""+r+n+t},w=function(e){var t=T(e.getDate()),n=T(e.getMonth()+1),r=e.getFullYear();return""+t+n+r},x=function(e,t){var n=S(e),r=t.substring(0,2),i=t.substring(2,4);return n.setHours(r),n.setMinutes(i),n},k=function(e){return e=_(e),{hours:T(e.getHours()),minutes:T(e.getMinutes())}},I=function(e){var t=arguments.length<=1||void 0===arguments[1]?new Date:arguments[1],n=t.getFullYear(),r=t.getMonth(),i=t.getDate(),o=e.getMonth(),a=n-e.getFullYear();return o>r&&a--,o===r&&i<e.getDate()&&a--,a},P=function(e,t){var n=0;if(e.getDate()===t.getDate())return n;for(e=new Date(e);t>=e;)n++,e.setDate(e.getDate()+1);return n};e.exports={diff:f,isAfter:d,isSame:p,add:h,cleanUTCTime:m,addLeadingZeroesToHMString:g,formatISO:A,parseISOToLocal:b,formatShort:C,parseDateString:S,parseDateStringReverse:M,getDateTime:x,stringifyDate:E,stringifyDateReverse:w,parseDateToTime:k,calculateAge:I,convertToUTC:_,daysChanged:P}},function(e,t,n){"use strict";var r=function(e,t,n,r,i,o,a,s){if(!e){var u;if(void 0===t)u=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[n,r,i,o,a,s],c=0;u=new Error(t.replace(/%s/g,function(){return l[c++]})),u.name="Invariant Violation"}throw u.framesToPop=1,u}};e.exports=r},function(e,t){"use strict";var n=self.document.documentElement.lang,r={"uk-ua":"UAH","ru-ua":"UAH","kk-kz":"KZT","ru-kz":"KZT","en-gb":"GBP","en-us":"USD","en-ie":"EUR",de:"EUR",es:"EUR",tr:"TRY",br:"EUR",az:"EUR",ru:"RUB"};e.exports=r[n]},function(e,t){"use strict";e.exports=function(e,t,n,r){void 0===n&&(n="RUB");var i=e;return t!==n&&(i=e*r[t+n]),i}},function(e,t,n){var r=n(464),i=n(470).default,o=n(474).default,a=n(465).default,s=n(511).default,u=n(476),l=function(e){function t(n,r){o(this,t),e.call(this,n,r)}return i(t,e),t.prototype.render=function(){if(!this.props.children)return null;var e=this.props.preventUserClose?{hideClose:!0,closeOnOutsideClick:!1,closeOnEsc:!1}:{},t=this.props,n=(t.PortalComponent,t.LayoutComponent,t.className),i=s(t,["PortalComponent","LayoutComponent","className"]);return r(this.props.PortalComponent,a({},i,e),r(this.props.LayoutComponent,a({className:n,isOpen:i.isOpen,closeOnOutsideClick:this.props.closeOnOutsideClick,contentOptions:a({},this.props.contentOptions,e),closePortal:this.props.closePortal},e),this.props.children))},t}(u);l.defaultProps=n(667),e.exports=l},function(e,t,n){"use strict";var r=n(526);e.exports={onClose:r,PortalComponent:n(513),LayoutComponent:n(668),closeOnOutsideClick:!0}},function(e,t,n){var r,i=n(464),o=n(514).default,a=n(474).default,s=n(470).default,u=n(465).default,l=n(515).default,c=(n(466).default,{}),d=n(475),p=n(669),f={},h=n(670),v=function(e){return function(){return++e}}(-1),y=n(527),g=n(528),m=n(671),_=n(672),A=n(673),C=A.Motion,b=A.spring,S=n(539),M=n(525),T=(M.findDOMNode,{Motion:C}),E=function(){function e(){a(this,e),this._count=0}return e.prototype.add=function(){this._count++},e.prototype.remove=function(){var e=this;setTimeout(function(){e._count--},50)},e.prototype.getDefaultStyles=function(){return this._count>1?e.defaultLessAnimated:e.defaultStyles},e.prototype.getStyles=function(){return e.styles},o(e,null,[{key:"defaultStyles",value:{overlay:{opacity:0},body:{y:-5,opacity:.5}},enumerable:!0},{key:"defaultLessAnimated",value:{overlay:{opacity:1},body:{y:-2,opacity:.8}},enumerable:!0},{key:"styles",value:{overlay:{opacity:b(1)},body:{y:b(0),opacity:b(1)}},enumerable:!0}]),e}(),w=new E,x=function(e){function t(n,r){a(this,t),e.call(this,n,r),this.handleMouseDown=this.handleMouseDown.bind(this),this.handleMouseUp=this.handleMouseUp.bind(this),this.handleMouseDownOutside=this.handleMouseDownOutside.bind(this),this.handleMouseUpOutside=this.handleMouseUpOutside.bind(this),this.handleOutsideClick=this.handleOutsideClick.bind(this),this._id=v(),this.state={}}return s(t,e),t.prototype.componentDidMount=function(){this.update()},t.prototype.componentWillMount=function(){w.add()},t.prototype.componentWillUnmount=function(){w.remove(),this.remove()},t.prototype.componentWillReceiveProps=function(e){this.update(e)},t.prototype.add=function(){var e=this._id;if(!t.INSTS.has(e)){t.INSTS.add(e);var n=y(this.props.container,g(this).body),r={container:n,style:{overflow:n.style.overflow,paddingRight:n.style.paddingRight}},i={overflow:"hidden"};if(r.overflowing=m(n),r.overflowing){var o=parseInt(S(n,"paddingRight")||0,10)+_();i.paddingRight=o+"px"}this.setState({paddingRight:i.paddingRight||r.style.paddingRight}),S(n,i),t.DATA[e]=r}},t.prototype.remove=function(){var e=this._id;if(t.INSTS.has(e)){t.INSTS.delete(e);var n=t.DATA[e];delete t.DATA[e],0===t.INSTS.size&&S(n.container,u({},n.style,{overflow:"hidden"===n.style.overflow?"initial":n.style.overflow}))}},t.prototype.update=function(){var e=arguments.length<=0||void 0===arguments[0]?this.props:arguments[0];e.isOpen?this.add():this.remove()},t.prototype.getContentArgs=function(){return[this.props.closePortal]},t.prototype.handleMouseDown=function(e){this._inBody=!0,e.stopPropagation()},t.prototype.handleMouseUp=function(e){e.stopPropagation(),this._inOutside?(this._inBody=!0,this._inOutside=!1):this._inBody=!1},t.prototype.handleMouseDownOutside=function(e){e.stopPropagation(),this._inOutside=!0},t.prototype.handleMouseUpOutside=function(e){this._inOutside=!1,e.stopPropagation()},t.prototype._preventBubble=function(e){e.stopPropagation()},t.prototype.handleOutsideClick=function(e){return this._inBody?void(this._inBody=!1):void(this.props.closeOnOutsideClick&&this.props.closePortal(e))},t.prototype.render=function(){var e=this;if(!this.props.children)return null;var t=this.getContent(),n=t.header,o=t.body,a=t.footer,s=this.props,l=s.transitionStartStyles,f=s.transitionEndStyles,h=s.className,v=l||w.getDefaultStyles(this.props),y=f||w.getStyles(),g={maxHeight:"100%",maxWidth:"100%",padding:"8px "+(this.state.paddingRight||0)+" 8px 0"};return i("div",{b:"Layout"},i(T.Motion,{defaultStyle:v.overlay,style:y.overlay},function(e){return i("div",{style:e},i(p,null))}),i("div",{e:"container",onClick:this.handleOutsideClick,onMouseDown:this.handleMouseDownOutside,onMouseUp:this.handleMouseUpOutside,style:(r="Layout__container",c[r]||(c[r]=d(r)))},i("div",{style:{height:"100%",verticalAlign:"middle",display:"inline-block"}}),i("div",{e:"wrapper",style:(r="Layout__container__wrapper",c[r]||(c[r]=d(r)))},i("div",{style:g},i("div",{className:h,e:"body",onMouseDown:this.handleMouseDown,onMouseUp:this.handleMouseUp,onClick:this._preventBubble,style:(r="Layout__container__wrapper__body",c[r]||(c[r]=d(r)))},i(T.Motion,{defaultStyle:v.body,style:y.body},function(t){return i("div",{style:u({},t,{transform:"translateY("+t.y+"px)"})},i(e.props.ContentComponent,u({},e.props.contentOptions,{closePortal:e.props.closePortal,body:o,header:n,footer:a})))}))))))},o(t,null,[{key:"INSTS",value:new l,enumerable:!0},{key:"DATA",value:{},enumerable:!0}]),t}(h);x.defaultProps={theme:f,contentOptions:f,ContentComponent:n(685)},e.exports=x},function(e,t,n){var r,i=n(464),o=n(470).default,a=n(474).default,s={},u=n(475),l=n(476),c=function(e){function t(n,r){a(this,t),e.call(this,n,r)}return o(t,e),t.prototype.render=function(){return i("div",{b:"LayoutOverlay",style:(r="LayoutOverlay",s[r]||(s[r]=u(r)))})},t}(l);c.defaultProps={},e.exports=c},function(e,t,n){"use strict";var r=n(470).default,i=n(474).default,o=n(476),a=n(611),s=n(342),u=s.isValidElement,l=function(e){function t(){i(this,t),e.apply(this,arguments)}return r(t,e),t.prototype.getContentArgs=function(){return[]},t.prototype.getContent=function(){var e=this.props.children,t=void 0,n=void 0,r=void 0;return"function"==typeof e&&(e=e.apply(void 0,this.getContentArgs())),t=r=null,n=e,"object"==typeof e&&(a(e)||u(e)?n=e:(t=e.header,n=e.body,r=e.footer)),{header:t,body:n,footer:r}},t}(o);l.defaultProps={},e.exports=l},function(e,t,n){"use strict";function r(e){return e&&"body"===e.tagName.toLowerCase()}function i(e){var t=s(e),n=a(t),r=n.innerWidth;return t.body.clientWidth<r}function o(e){var t=a(e);return t||r(e)?i(e):e.scrollHeight>e.clientHeight}t.__esModule=!0,t.default=o;var a=n(535),s=n(529);e.exports=t.default},function(e,t,n){"use strict";var r,i=n(534);e.exports=function(e){if((!r||e)&&i){var t=document.createElement("div");t.style.position="absolute",t.style.top="-9999px",t.style.width="50px",t.style.height="50px",t.style.overflow="scroll",document.body.appendChild(t),r=t.offsetWidth-t.clientWidth,document.body.removeChild(t)}return r}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e.default:e}t.__esModule=!0;var i=n(674);t.Motion=r(i);var o=n(679);t.StaggeredMotion=r(o);var a=n(680);t.TransitionMotion=r(a);var s=n(682);t.spring=r(s);var u=n(683);t.presets=r(u);var l=n(684);t.reorderKeys=r(l)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{"default":e}}t.__esModule=!0;var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},o=n(675),a=r(o),s=n(676),u=r(s),l=n(677),c=r(l),d=n(111),p=r(d),f=n(110),h=r(f),v=n(678),y=r(v),g=n(302),m=r(g),_=1e3/60,A=m.default.createClass({displayName:"Motion",propTypes:{defaultStyle:g.PropTypes.objectOf(g.PropTypes.number),style:g.PropTypes.objectOf(g.PropTypes.oneOfType([g.PropTypes.number,g.PropTypes.object])).isRequired,children:g.PropTypes.func.isRequired,onRest:g.PropTypes.func},getInitialState:function(){var e=this.props,t=e.defaultStyle,n=e.style,r=t||u.default(n),i=a.default(r);return{currentStyle:r,currentVelocity:i,lastIdealStyle:r,lastIdealVelocity:i}},wasAnimating:!1,animationID:null,prevTime:0,accumulatedTime:0,unreadPropStyle:null,clearUnreadPropStyle:function(e){var t=!1,n=this.state,r=n.currentStyle,o=n.currentVelocity,a=n.lastIdealStyle,s=n.lastIdealVelocity;for(var u in e)if(e.hasOwnProperty(u)){var l=e[u];"number"==typeof l&&(t||(t=!0,r=i({},r),o=i({},o),a=i({},a),s=i({},s)),r[u]=l,o[u]=0,a[u]=l,s[u]=0)}t&&this.setState({currentStyle:r,currentVelocity:o,lastIdealStyle:a,lastIdealVelocity:s})},startAnimationIfNecessary:function(){var e=this;this.animationID=h.default(function(){var t=e.props.style;if(y.default(e.state.currentStyle,t,e.state.currentVelocity))return e.wasAnimating&&e.props.onRest&&e.props.onRest(),e.animationID=null,e.wasAnimating=!1,void(e.accumulatedTime=0);e.wasAnimating=!0;var n=p.default(),r=n-e.prevTime;if(e.prevTime=n,e.accumulatedTime=e.accumulatedTime+r,
e.accumulatedTime>10*_&&(e.accumulatedTime=0),0===e.accumulatedTime)return e.animationID=null,void e.startAnimationIfNecessary();var i=(e.accumulatedTime-Math.floor(e.accumulatedTime/_)*_)/_,o=Math.floor(e.accumulatedTime/_),a={},s={},u={},l={};for(var d in t)if(t.hasOwnProperty(d)){var f=t[d];if("number"==typeof f)u[d]=f,l[d]=0,a[d]=f,s[d]=0;else{for(var h=e.state.lastIdealStyle[d],v=e.state.lastIdealVelocity[d],g=0;o>g;g++){var m=c.default(_/1e3,h,v,f.val,f.stiffness,f.damping,f.precision);h=m[0],v=m[1]}var A=c.default(_/1e3,h,v,f.val,f.stiffness,f.damping,f.precision),C=A[0],b=A[1];u[d]=h+(C-h)*i,l[d]=v+(b-v)*i,a[d]=h,s[d]=v}}e.animationID=null,e.accumulatedTime-=o*_,e.setState({currentStyle:u,currentVelocity:l,lastIdealStyle:a,lastIdealVelocity:s}),e.unreadPropStyle=null,e.startAnimationIfNecessary()})},componentDidMount:function(){this.prevTime=p.default(),this.startAnimationIfNecessary()},componentWillReceiveProps:function(e){null!=this.unreadPropStyle&&this.clearUnreadPropStyle(this.unreadPropStyle),this.unreadPropStyle=e.style,null==this.animationID&&(this.prevTime=p.default(),this.startAnimationIfNecessary())},componentWillUnmount:function(){null!=this.animationID&&(h.default.cancel(this.animationID),this.animationID=null)},render:function(){var e=this.props.children(this.state.currentStyle);return e&&m.default.Children.only(e)}});t.default=A,e.exports=t.default},function(e,t){"use strict";function n(e){var t={};for(var n in e)e.hasOwnProperty(n)&&(t[n]=0);return t}t.__esModule=!0,t.default=n,e.exports=t.default},function(e,t){"use strict";function n(e){var t={};for(var n in e)e.hasOwnProperty(n)&&(t[n]="number"==typeof e[n]?e[n]:e[n].val);return t}t.__esModule=!0,t.default=n,e.exports=t.default},function(e,t){"use strict";function n(e,t,n,i,o,a,s){var u=-o*(t-i),l=-a*n,c=u+l,d=n+c*e,p=t+d*e;return Math.abs(d)<s&&Math.abs(p-i)<s?(r[0]=i,r[1]=0,r):(r[0]=p,r[1]=d,r)}t.__esModule=!0,t.default=n;var r=[];e.exports=t.default},function(e,t){"use strict";function n(e,t,n){for(var r in t)if(t.hasOwnProperty(r)){if(0!==n[r])return!1;var i="number"==typeof t[r]?t[r]:t[r].val;if(e[r]!==i)return!1}return!0}t.__esModule=!0,t.default=n,e.exports=t.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{"default":e}}function i(e,t,n){for(var r=0;r<e.length;r++)if(!g.default(e[r],t[r],n[r]))return!1;return!0}t.__esModule=!0;var o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},a=n(675),s=r(a),u=n(676),l=r(u),c=n(677),d=r(c),p=n(111),f=r(p),h=n(110),v=r(h),y=n(678),g=r(y),m=n(302),_=r(m),A=1e3/60,C=_.default.createClass({displayName:"StaggeredMotion",propTypes:{defaultStyles:m.PropTypes.arrayOf(m.PropTypes.objectOf(m.PropTypes.number)),styles:m.PropTypes.func.isRequired,children:m.PropTypes.func.isRequired},getInitialState:function(){var e=this.props,t=e.defaultStyles,n=e.styles,r=t||n().map(l.default),i=r.map(function(e){return s.default(e)});return{currentStyles:r,currentVelocities:i,lastIdealStyles:r,lastIdealVelocities:i}},animationID:null,prevTime:0,accumulatedTime:0,unreadPropStyles:null,clearUnreadPropStyle:function(e){for(var t=this.state,n=t.currentStyles,r=t.currentVelocities,i=t.lastIdealStyles,a=t.lastIdealVelocities,s=!1,u=0;u<e.length;u++){var l=e[u],c=!1;for(var d in l)if(l.hasOwnProperty(d)){var p=l[d];"number"==typeof p&&(c||(c=!0,s=!0,n[u]=o({},n[u]),r[u]=o({},r[u]),i[u]=o({},i[u]),a[u]=o({},a[u])),n[u][d]=p,r[u][d]=0,i[u][d]=p,a[u][d]=0)}}s&&this.setState({currentStyles:n,currentVelocities:r,lastIdealStyles:i,lastIdealVelocities:a})},startAnimationIfNecessary:function(){var e=this;this.animationID=v.default(function(){var t=e.props.styles(e.state.lastIdealStyles);if(i(e.state.currentStyles,t,e.state.currentVelocities))return e.animationID=null,void(e.accumulatedTime=0);var n=f.default(),r=n-e.prevTime;if(e.prevTime=n,e.accumulatedTime=e.accumulatedTime+r,e.accumulatedTime>10*A&&(e.accumulatedTime=0),0===e.accumulatedTime)return e.animationID=null,void e.startAnimationIfNecessary();for(var o=(e.accumulatedTime-Math.floor(e.accumulatedTime/A)*A)/A,a=Math.floor(e.accumulatedTime/A),s=[],u=[],l=[],c=[],p=0;p<t.length;p++){var h=t[p],v={},y={},g={},m={};for(var _ in h)if(h.hasOwnProperty(_)){var C=h[_];if("number"==typeof C)v[_]=C,y[_]=0,g[_]=C,m[_]=0;else{for(var b=e.state.lastIdealStyles[p][_],S=e.state.lastIdealVelocities[p][_],M=0;a>M;M++){var T=d.default(A/1e3,b,S,C.val,C.stiffness,C.damping,C.precision);b=T[0],S=T[1]}var E=d.default(A/1e3,b,S,C.val,C.stiffness,C.damping,C.precision),w=E[0],x=E[1];v[_]=b+(w-b)*o,y[_]=S+(x-S)*o,g[_]=b,m[_]=S}}l[p]=v,c[p]=y,s[p]=g,u[p]=m}e.animationID=null,e.accumulatedTime-=a*A,e.setState({currentStyles:l,currentVelocities:c,lastIdealStyles:s,lastIdealVelocities:u}),e.unreadPropStyles=null,e.startAnimationIfNecessary()})},componentDidMount:function(){this.prevTime=f.default(),this.startAnimationIfNecessary()},componentWillReceiveProps:function(e){null!=this.unreadPropStyles&&this.clearUnreadPropStyle(this.unreadPropStyles),this.unreadPropStyles=e.styles(this.state.lastIdealStyles),null==this.animationID&&(this.prevTime=f.default(),this.startAnimationIfNecessary())},componentWillUnmount:function(){null!=this.animationID&&(v.default.cancel(this.animationID),this.animationID=null)},render:function(){var e=this.props.children(this.state.currentStyles);return e&&_.default.Children.only(e)}});t.default=C,e.exports=t.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{"default":e}}function i(e,t,n){return null==t?e.map(function(e,t){return{key:e.key,data:e.data,style:n[t]}}):e.map(function(e,r){for(var i=0;i<t.length;i++)if(t[i].key===e.key)return{key:t[i].key,data:t[i].data,style:n[r]};return{key:e.key,data:e.data,style:n[r]}})}function o(e,t,n,r){if(r.length!==t.length)return!1;for(var i=0;i<r.length;i++)if(r[i].key!==t[i].key)return!1;for(var i=0;i<r.length;i++)if(!C.default(e[i],t[i].style,n[i]))return!1;return!0}function a(e,t,n,r,i,o,a,s){for(var u=v.default(n,r,function(e,n){var r=t(n);return null==r?null:C.default(i[e],r,o[e])?null:{key:n.key,data:n.data,style:r}}),c=[],d=[],p=[],f=[],h=0;h<u.length;h++){for(var y=u[h],g=null,m=0;m<n.length;m++)if(n[m].key===y.key){g=m;break}if(null==g){var _=e(y);c[h]=_,p[h]=_;var A=l.default(y.style);d[h]=A,f[h]=A}else c[h]=i[g],p[h]=a[g],d[h]=o[g],f[h]=s[g]}return[u,c,d,p,f]}t.__esModule=!0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=n(675),l=r(u),c=n(676),d=r(c),p=n(677),f=r(p),h=n(681),v=r(h),y=n(111),g=r(y),m=n(110),_=r(m),A=n(678),C=r(A),b=n(302),S=r(b),M=1e3/60,T=S.default.createClass({displayName:"TransitionMotion",propTypes:{defaultStyles:b.PropTypes.arrayOf(b.PropTypes.shape({key:b.PropTypes.string.isRequired,data:b.PropTypes.any,style:b.PropTypes.objectOf(b.PropTypes.number).isRequired})),styles:b.PropTypes.oneOfType([b.PropTypes.func,b.PropTypes.arrayOf(b.PropTypes.shape({key:b.PropTypes.string.isRequired,data:b.PropTypes.any,style:b.PropTypes.objectOf(b.PropTypes.oneOfType([b.PropTypes.number,b.PropTypes.object])).isRequired}))]).isRequired,children:b.PropTypes.func.isRequired,willLeave:b.PropTypes.func,willEnter:b.PropTypes.func},getDefaultProps:function(){return{willEnter:function(e){return d.default(e.style)},willLeave:function(){return null}}},getInitialState:function(){var e=this.props,t=e.defaultStyles,n=e.styles,r=e.willEnter,i=e.willLeave,o="function"==typeof n?n(t):n,s=void 0;s=null==t?o:t.map(function(e){for(var t=0;t<o.length;t++)if(o[t].key===e.key)return o[t];return e});var u=null==t?o.map(function(e){return d.default(e.style)}):t.map(function(e){return d.default(e.style)}),c=null==t?o.map(function(e){return l.default(e.style)}):t.map(function(e){return l.default(e.style)}),p=a(r,i,s,o,u,c,u,c),f=p[0],h=p[1],v=p[2],y=p[3],g=p[4];return{currentStyles:h,currentVelocities:v,lastIdealStyles:y,lastIdealVelocities:g,mergedPropsStyles:f}},animationID:null,prevTime:0,accumulatedTime:0,unreadPropStyles:null,clearUnreadPropStyle:function(e){for(var t=a(this.props.willEnter,this.props.willLeave,this.state.mergedPropsStyles,e,this.state.currentStyles,this.state.currentVelocities,this.state.lastIdealStyles,this.state.lastIdealVelocities),n=t[0],r=t[1],i=t[2],o=t[3],u=t[4],l=0;l<e.length;l++){var c=e[l].style,d=!1;for(var p in c)if(c.hasOwnProperty(p)){var f=c[p];"number"==typeof f&&(d||(d=!0,r[l]=s({},r[l]),i[l]=s({},i[l]),o[l]=s({},o[l]),u[l]=s({},u[l]),n[l]={key:n[l].key,data:n[l].data,style:s({},n[l].style)}),r[l][p]=f,i[l][p]=0,o[l][p]=f,u[l][p]=0,n[l].style[p]=f)}}this.setState({currentStyles:r,currentVelocities:i,mergedPropsStyles:n,lastIdealStyles:o,lastIdealVelocities:u})},startAnimationIfNecessary:function(){var e=this;this.animationID=_.default(function(){var t=e.props.styles,n="function"==typeof t?t(i(e.state.mergedPropsStyles,e.unreadPropStyles,e.state.lastIdealStyles)):t;if(o(e.state.currentStyles,n,e.state.currentVelocities,e.state.mergedPropsStyles))return e.animationID=null,void(e.accumulatedTime=0);var r=g.default(),s=r-e.prevTime;if(e.prevTime=r,e.accumulatedTime=e.accumulatedTime+s,e.accumulatedTime>10*M&&(e.accumulatedTime=0),0===e.accumulatedTime)return e.animationID=null,void e.startAnimationIfNecessary();for(var u=(e.accumulatedTime-Math.floor(e.accumulatedTime/M)*M)/M,l=Math.floor(e.accumulatedTime/M),c=a(e.props.willEnter,e.props.willLeave,e.state.mergedPropsStyles,n,e.state.currentStyles,e.state.currentVelocities,e.state.lastIdealStyles,e.state.lastIdealVelocities),d=c[0],p=c[1],h=c[2],v=c[3],y=c[4],m=0;m<d.length;m++){var _=d[m].style,A={},C={},b={},S={};for(var T in _)if(_.hasOwnProperty(T)){var E=_[T];if("number"==typeof E)A[T]=E,C[T]=0,b[T]=E,S[T]=0;else{for(var w=v[m][T],x=y[m][T],k=0;l>k;k++){var I=f.default(M/1e3,w,x,E.val,E.stiffness,E.damping,E.precision);w=I[0],x=I[1]}var P=f.default(M/1e3,w,x,E.val,E.stiffness,E.damping,E.precision),D=P[0],N=P[1];A[T]=w+(D-w)*u,C[T]=x+(N-x)*u,b[T]=w,S[T]=x}}v[m]=b,y[m]=S,p[m]=A,h[m]=C}e.animationID=null,e.accumulatedTime-=l*M,e.setState({currentStyles:p,currentVelocities:h,lastIdealStyles:v,lastIdealVelocities:y,mergedPropsStyles:d}),e.unreadPropStyles=null,e.startAnimationIfNecessary()})},componentDidMount:function(){this.prevTime=g.default(),this.startAnimationIfNecessary()},componentWillReceiveProps:function(e){this.unreadPropStyles&&this.clearUnreadPropStyle(this.unreadPropStyles),"function"==typeof e.styles?this.unreadPropStyles=e.styles(i(this.state.mergedPropsStyles,this.unreadPropStyles,this.state.lastIdealStyles)):this.unreadPropStyles=e.styles,null==this.animationID&&(this.prevTime=g.default(),this.startAnimationIfNecessary())},componentWillUnmount:function(){null!=this.animationID&&(_.default.cancel(this.animationID),this.animationID=null)},render:function(){var e=i(this.state.mergedPropsStyles,this.unreadPropStyles,this.state.currentStyles),t=this.props.children(e);return t&&S.default.Children.only(t)}});t.default=T,e.exports=t.default},function(e,t){"use strict";function n(e,t,n){for(var r={},i=0;i<e.length;i++)r[e[i].key]=i;for(var o={},i=0;i<t.length;i++)o[t[i].key]=i;for(var a=[],i=0;i<t.length;i++)a[i]=t[i];for(var i=0;i<e.length;i++)if(!o.hasOwnProperty(e[i].key)){var s=n(i,e[i]);null!=s&&a.push(s)}return a.sort(function(e,n){var i=o[e.key],a=o[n.key],s=r[e.key],u=r[n.key];if(null!=i&&null!=a)return o[e.key]-o[n.key];if(null!=s&&null!=u)return r[e.key]-r[n.key];if(null!=i){for(var l=0;l<t.length;l++){var c=t[l].key;if(r.hasOwnProperty(c)){if(i<o[c]&&u>r[c])return-1;if(i>o[c]&&u<r[c])return 1}}return 1}for(var l=0;l<t.length;l++){var c=t[l].key;if(r.hasOwnProperty(c)){if(a<o[c]&&s>r[c])return 1;if(a>o[c]&&s<r[c])return-1}}return-1})}t.__esModule=!0,t.default=n,e.exports=t.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{"default":e}}function i(e,t){return o({},u,t,{val:e})}t.__esModule=!0;var o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e};t.default=i;var a=n(683),s=r(a),u=o({},s.default.noWobble,{precision:.01});e.exports=t.default},function(e,t){"use strict";t.__esModule=!0,t.default={noWobble:{stiffness:170,damping:26},gentle:{stiffness:120,damping:14},wobbly:{stiffness:180,damping:12},stiff:{stiffness:210,damping:20}},e.exports=t.default},function(e,t,n){"use strict";function r(){}t.__esModule=!0,t.default=r;e.exports=t.default},function(e,t,n){var r,i=n(464),o=n(470).default,a=n(474).default,s={},u=n(475),l=n(476),c=n(686),d=n(687),p=n(525),f=(p.findDOMNode,function(e){function t(n,r){a(this,t),e.call(this,n,r)}return o(t,e),t.prototype.render=function(){var e=this.props,t=e.fixed,n=e.fixedHeader,o=e.fixedFooter,a=e.hideClose,l=e.closePortal,p=e.transparent,f=this.props,h=f.header,v=f.footer,y=t||n||o,g=[],m=a?null:i("div",{e:"closerWrapper",style:(r="Content__closerWrapper"+(p?" Content--isTransparent__closerWrapper":""),s[r]||(s[r]=u(r)))},i("div",{onClick:l,e:"closer",style:(r="Content__closerWrapper__closer"+(p?" Content--isTransparent__closerWrapper__closer":""),s[r]||(s[r]=u(r)))},i(d,null)));return o&&!n&&(h=null,g.push(i("div",{key:"header"},this.props.header,m))),g.push(i("div",{key:"body"},this.props.body)),n&&!o&&(v=null,g.push(i("div",{key:"footer"},this.props.footer))),i("div",{b:"Content",m:{isSticky:!y,isTransparent:p,isFixed:y&&v&&h,withFixedHeader:h&&(t||n),withFixedFooter:v&&(t||o)},style:(r="Content"+(p?" Content--isTransparent":""),s[r]||(s[r]=u(r)))},i(c,{showCloser:!h&&!v&&!a},m),i(c,{header:h},i("div",{e:"header"},i("div",{e:"inner"},h,m))),i("div",{e:"body",style:(r="Content__body"+(p?" Content--isTransparent__body":""),s[r]||(s[r]=u(r)))},i("div",{e:"inner"},g)),i(c,{footer:v},i("div",{e:"footer"},i("div",{e:"inner"}," ",v))))},t}(l));f.defaultProps={},e.exports=f},function(e,t,n){var r=n(464),i=n(511).default,o=n(104).default,a=n(611),s=r("noscript",null),u=function(e){switch(typeof e){case"function":return e();case"string":return r("span",null,e);default:return a(e)?r("span",null,e):e}};e.exports=function(e){var t=e.children,n=i(e,["children"]),r=function(e){return n[e]},a=o(n);return 1===a.length?n[a[0]]&&u(t)||s:a.every(r)&&u(t)||s}},function(e,t,n){var r=n(464),i=n(465).default;e.exports=function(e){var t=e.width,n=e.height;return t||n||(t=e.viewBox.split(" ")[2]),r("svg",i({width:t,height:n,viewBox:e.viewBox,preserveAspectRatio:"xMinYMin",xmlns:"http://www.w3.org/2000/svg"},e),r("path",{fill:e.fill,d:"M1.985 0L0 1.986 5.515 7.5 0 13.017 1.986 15 7.5 9.486 13.014 15 15 13.015 9.485 7.5 15 1.987 13.014.002 7.5 5.515 1.986 0z",fillRule:"evenodd"}))},e.exports.defaultProps={viewBox:"0 0 15 15",fill:"#BCC3C7"}},function(e,t,n){"use strict";var r=n(104).default,i={number:!0,string:!0};e.exports=function(e){return r(e).map(function(t){var n=e[t];return i[typeof n]||(n=JSON.stringify(n)),encodeURIComponent(t)+"="+encodeURIComponent(n)}).join("&")}},function(e,t){"use strict";e.exports=function(e){var t=e.url,n=e.data,r=e.resolver;return function(e){return e(t,{credentials:"include",method:"post",headers:{"Content-type":"application/x-www-form-urlencoded; charset=UTF-8"},body:n}).then(function(e){return e.json()}).then(r)}}},function(e,t,n,r,i,o,a,s,u,l,c,d,p,f,h,v,y,g,m,_,A,C){"use strict";var b=n(r),S=n(i),M=n(o),T=n(a),E=n(s),w=n(u),x=n(l),k=n(c),I=n(d),P=n(p),D=n(f),N=n(h),O=n(v),R=n(y),F=n(g),H=n(m),L=n(_),B=n(A),U=b.getDesc,K=b.setDesc,j=b.create,V=O.get,W=S.Symbol,G=S.JSON,J=G&&G.stringify,Y=!1,z=D("_hidden"),X=b.isEnum,Q=k("symbol-registry"),Z=k("symbols"),q="function"==typeof W,$=Object.prototype,ee=T&&x(function(){return 7!=j(K({},"a",{get:function(){return K(this,"a",{value:7}).a}})).a})?function(e,t,n){var r=U($,t);r&&delete $[t],K(e,t,n),r&&e!==$&&K($,t,r)}:K,te=function(e){var t=Z[e]=j(W.prototype);return t._k=e,T&&Y&&ee($,e,{configurable:!0,set:function(t){M(this,z)&&M(this[z],e)&&(this[z][e]=!1),ee(this,e,B(1,t))}}),t},ne=function(e){return"symbol"==typeof e},re=function(e,t,n){return n&&M(Z,t)?(n.enumerable?(M(e,z)&&e[z][t]&&(e[z][t]=!1),n=j(n,{enumerable:B(0,!1)})):(M(e,z)||K(e,z,B(1,{})),e[z][t]=!0),ee(e,t,n)):K(e,t,n)},ie=function(e,t){H(e);for(var n,r=R(t=L(t)),i=0,o=r.length;o>i;)re(e,n=r[i++],t[n]);return e},oe=function(e,t){return void 0===t?j(e):ie(j(e),t)},ae=function(e){var t=X.call(this,e);return t||!M(this,e)||!M(Z,e)||M(this,z)&&this[z][e]?t:!0},se=function(e,t){var n=U(e=L(e),t);return!n||!M(Z,t)||M(e,z)&&e[z][t]||(n.enumerable=!0),n},ue=function(e){for(var t,n=V(L(e)),r=[],i=0;n.length>i;)M(Z,t=n[i++])||t==z||r.push(t);return r},le=function(e){for(var t,n=V(L(e)),r=[],i=0;n.length>i;)M(Z,t=n[i++])&&r.push(Z[t]);return r},ce=function(e){if(void 0!==e&&!ne(e)){for(var t,n,r=[e],i=1,o=arguments;o.length>i;)r.push(o[i++]);return t=r[1],"function"==typeof t&&(n=t),!n&&F(t)||(t=function(e,t){return n&&(t=n.call(this,e,t)),ne(t)?void 0:t}),r[1]=t,J.apply(G,r)}},de=x(function(){var e=W();return"[null]"!=J([e])||"{}"!=J({a:e})||"{}"!=J(Object(e))});q||(W=function(){if(ne(this))throw TypeError("Symbol is not a constructor");return te(P(arguments.length>0?arguments[0]:void 0))},w(W.prototype,"toString",function(){return this._k}),ne=function(e){return e instanceof W},b.create=oe,b.isEnum=ae,b.getDesc=se,b.setDesc=re,b.setDescs=ie,b.getNames=O.get=ue,b.getSymbols=le,T&&!n(C)&&w($,"propertyIsEnumerable",ae,!0));var pe={"for":function(e){return M(Q,e+="")?Q[e]:Q[e]=W(e)},keyFor:function(e){return N(Q,e)},useSetter:function(){Y=!0},useSimple:function(){Y=!1}};b.each.call("hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),function(e){var t=D(e);pe[e]=q?t:te(t)}),Y=!0,E(E.G+E.W,{Symbol:W}),E(E.S,"Symbol",pe),E(E.S+E.F*!q,"Object",{create:oe,defineProperty:re,defineProperties:ie,getOwnPropertyDescriptor:se,getOwnPropertyNames:ue,getOwnPropertySymbols:le}),G&&E(E.S+E.F*(!q||de),"JSON",{stringify:ce}),I(W,"Symbol"),I(Math,"Math",!0),I(S.JSON,"JSON",!0)},function(e,t,n,r){e.exports=!n(r)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t,n,r){var i=n(r);e.exports=function(e,t,n){if(i(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,r){return e.call(t,n,r)};case 3:return function(n,r,i){return e.call(t,n,r,i)}}return function(){return e.apply(t,arguments)}}},function(e,t,n,r,i,o){var a=n(r),s=n(i);e.exports=n(o)?function(e,t,n){return a.setDesc(e,t,s(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t,n,r){var i=n(r),o="__core-js_shared__",a=i[o]||(i[o]={});e.exports=function(e){return a[e]||(a[e]={})}},function(e,t,n,r,i,o){var a=n(r).setDesc,s=n(i),u=n(o)("toStringTag");e.exports=function(e,t,n){e&&!s(e=n?e:e.prototype,u)&&a(e,u,{configurable:!0,value:t})}},function(e,t,n,r,i,o){var a=n(r)("wks"),s=n(i),u=n(o).Symbol;e.exports=function(e){return a[e]||(a[e]=u&&u[e]||(u||s)("Symbol."+e))}},function(e,t,n,r,i){var o=n(r),a=n(i);e.exports=function(e,t){for(var n,r=a(e),i=o.getKeys(r),s=i.length,u=0;s>u;)if(r[n=i[u++]]===t)return n}},function(e,t,n,r,i){var o=n(r),a=n(i);e.exports=function(e){return o(a(e))}},function(e,t,n,r){var i=n(r);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==i(e)?e.split(""):Object(e)}},function(e,t,n,r,i){var o=n(r),a=n(i).getNames,s={}.toString,u="object"==typeof window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],l=function(e){try{return a(e)}catch(t){return u.slice()}};e.exports.get=function(e){return u&&"[object Window]"==s.call(e)?l(e):a(o(e))}},function(e,t,n,r){var i=n(r);e.exports=function(e){var t=i.getKeys(e),n=i.getSymbols;if(n)for(var r,o=n(e),a=i.isEnum,s=0;o.length>s;)a.call(e,r=o[s++])&&t.push(r);return t}},function(e,t,n,r){var i=n(r);e.exports=Array.isArray||function(e){return"Array"==i(e)}},function(e,t,n,r){var i=n(r);e.exports=function(e){if(!i(e))throw TypeError(e+" is not an object!");return e}},function(e,t,n,r,i){"use strict";var o=n(r)(!0);n(i)(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,n=this._i;return n>=t.length?{value:void 0,done:!0}:(e=o(t,n),this._i+=e.length,{value:e,done:!1})})},function(e,t,n,r,i){var o=n(r),a=n(i);e.exports=function(e){return function(t,n){var r,i,s=String(a(t)),u=o(n),l=s.length;return 0>u||u>=l?e?"":void 0:(r=s.charCodeAt(u),55296>r||r>56319||u+1===l||(i=s.charCodeAt(u+1))<56320||i>57343?e?s.charAt(u):r:e?s.slice(u,u+2):(r-55296<<10)+(i-56320)+65536)}}},function(e,t,n,r,i,o,a,s,u,l,c,d,p){"use strict";var f=n(r),h=n(i),v=n(o),y=n(a),g=n(s),m=n(u),_=n(l),A=n(c),C=n(d).getProto,b=n(p)("iterator"),S=!([].keys&&"next"in[].keys()),M="@@iterator",T="keys",E="values",w=function(){return this};e.exports=function(e,t,n,r,i,o,a){_(n,t,r);var s,u,l=function(e){if(!S&&e in x)return x[e];switch(e){case T:return function(){return new n(this,e)};case E:return function(){return new n(this,e)}}return function(){return new n(this,e)}},c=t+" Iterator",d=i==E,p=!1,x=e.prototype,k=x[b]||x[M]||i&&x[i],I=k||l(i);if(k){var P=C(I.call(new e));A(P,c,!0),!f&&g(x,M)&&y(P,b,w),d&&k.name!==E&&(p=!0,I=function(){return k.call(this)})}if(f&&!a||!S&&!p&&x[b]||y(x,b,I),m[t]=I,m[c]=w,i)if(s={values:d?I:l(E),keys:o?I:l(T),entries:d?l("entries"):I},a)for(u in s)u in x||v(x,u,s[u]);else h(h.P+h.F*(S||p),t,s);return s}},function(e,t,n,r,i,o,a,s){"use strict";var u=n(r),l=n(i),c=n(o),d={};n(a)(d,n(s)("iterator"),function(){return this}),e.exports=function(e,t,n){e.prototype=u.create(d,{next:l(1,n)}),c(e,t+" Iterator")}},function(e,t,n,r,i,o,a,s){"use strict";var u=n(r),l=n(i),c=n(o),d=n(a);e.exports=n(s)(Array,"Array",function(e,t){this._t=d(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,n=this._i++;return!e||n>=e.length?(this._t=void 0,l(1)):"keys"==t?l(0,n):"values"==t?l(0,e[n]):l(0,[n,e[n]])},"values"),c.Arguments=c.Array,u("keys"),u("values"),u("entries")},function(e,t,n,r,i,o,a,s,u,l,c,d,p,f,h,v,y,g,m,_,A,C,b,S,M){"use strict";var T,E=n(r),w=n(i),x=n(o),k=n(a),I=n(s),P=n(u),D=n(l),N=n(c),O=n(d),R=n(p),F=n(f),H=n(h).set,L=n(v),B=n(y)("species"),U=n(g),K=n(m),j="Promise",V=x.process,W="process"==I(V),G=x[j],J=function(e){var t=new G(function(){});return e&&(t.constructor=Object),G.resolve(t)===t},Y=function(){function e(t){var n=new G(t);return H(n,e.prototype),n}var t=!1;try{if(t=G&&G.resolve&&J(),H(e,G),e.prototype=E.create(G.prototype,{constructor:{value:e}}),e.resolve(5).then(function(){})instanceof e||(t=!1),t&&n(_)){var r=!1;G.resolve(E.setDesc({},"then",{get:function(){r=!0}})),t=r}}catch(i){t=!1}return t}(),z=function(e,t){return w&&e===G&&t===T?!0:L(e,t)},X=function(e){var t=N(e)[B];return void 0!=t?t:e},Q=function(e){var t;return D(e)&&"function"==typeof(t=e.then)?t:!1},Z=function(e){var t,n;this.promise=new e(function(e,r){if(void 0!==t||void 0!==n)throw TypeError("Bad Promise constructor");t=e,n=r}),this.resolve=O(t),this.reject=O(n)},q=function(e){try{e()}catch(t){return{error:t}}},$=function(e,t){if(!e.n){e.n=!0;var n=e.c;K(function(){for(var r=e.v,i=1==e.s,o=0,a=function(t){var n,o,a=i?t.ok:t.fail,s=t.resolve,u=t.reject;try{a?(i||(e.h=!0),n=a===!0?r:a(r),n===t.promise?u(TypeError("Promise-chain cycle")):(o=Q(n))?o.call(n,s,u):s(n)):u(r)}catch(l){u(l)}};n.length>o;)a(n[o++]);n.length=0,e.n=!1,t&&setTimeout(function(){var t,n,i=e.p;ee(i)&&(W?V.emit("unhandledRejection",r,i):(t=x.onunhandledrejection)?t({promise:i,reason:r}):(n=x.console)&&n.error&&n.error("Unhandled promise rejection",r)),e.a=void 0},1)})}},ee=function(e){var t,n=e._d,r=n.a||n.c,i=0;if(n.h)return!1;for(;r.length>i;)if(t=r[i++],t.fail||!ee(t.promise))return!1;return!0},te=function(e){var t=this;t.d||(t.d=!0,t=t.r||t,t.v=e,t.s=2,t.a=t.c.slice(),$(t,!0))},ne=function(e){var t,n=this;if(!n.d){n.d=!0,n=n.r||n;try{if(n.p===e)throw TypeError("Promise can't be resolved itself");(t=Q(e))?K(function(){var r={r:n,d:!1};try{t.call(e,k(ne,r,1),k(te,r,1))}catch(i){te.call(r,i)}}):(n.v=e,n.s=1,$(n,!1))}catch(r){te.call({r:n,d:!1},r)}}};Y||(G=function(e){O(e);var t=this._d={p:R(this,G,j),c:[],a:void 0,s:0,d:!1,v:void 0,h:!1,n:!1};try{e(k(ne,t,1),k(te,t,1))}catch(n){te.call(t,n)}},n(A)(G.prototype,{then:function(e,t){var n=new Z(U(this,G)),r=n.promise,i=this._d;return n.ok="function"==typeof e?e:!0,n.fail="function"==typeof t&&t,i.c.push(n),i.a&&i.a.push(n),i.s&&$(i,!1),r},"catch":function(e){return this.then(void 0,e)}})),P(P.G+P.W+P.F*!Y,{Promise:G}),n(C)(G,j),n(b)(j),T=n(S)[j],P(P.S+P.F*!Y,j,{reject:function(e){var t=new Z(this),n=t.reject;return n(e),t.promise}}),P(P.S+P.F*(!Y||J(!0)),j,{resolve:function(e){if(e instanceof G&&z(e.constructor,this))return e;var t=new Z(this),n=t.resolve;return n(e),t.promise}}),P(P.S+P.F*!(Y&&n(M)(function(e){G.all(e).catch(function(){})})),j,{all:function(e){var t=X(this),n=new Z(t),r=n.resolve,i=n.reject,o=[],a=q(function(){F(e,!1,o.push,o);var n=o.length,a=Array(n);n?E.each.call(o,function(e,o){var s=!1;t.resolve(e).then(function(e){s||(s=!0,a[o]=e,--n||r(a))},i)}):r(a)});return a&&i(a.error),n.promise},race:function(e){var t=X(this),n=new Z(t),r=n.reject,i=q(function(){F(e,!1,function(e){t.resolve(e).then(n.resolve,r)})});return i&&r(i.error),n.promise}})},function(e,t,n,r,i){var o=n(r),a=n(i)("toStringTag"),s="Arguments"==o(function(){return arguments}());e.exports=function(e){var t,n,r;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(n=(t=Object(e))[a])?n:s?o(t):"Object"==(r=o(t))&&"function"==typeof t.callee?"Arguments":r}},function(e,t,n,r,i,o,a,s,u){var l=n(r),c=n(i),d=n(o),p=n(a),f=n(s),h=n(u);e.exports=function(e,t,n,r){var i,o,a,s=h(e),u=l(n,r,t?2:1),v=0;if("function"!=typeof s)throw TypeError(e+" is not iterable!");if(d(s))for(i=f(e.length);i>v;v++)t?u(p(o=e[v])[0],o[1]):u(e[v]);else for(a=s.call(e);!(o=a.next()).done;)c(a,u,o.value,t)}},function(e,t,n,r){var i=n(r);e.exports=function(e,t,n,r){try{return r?t(i(n)[0],n[1]):t(n)}catch(o){var a=e.return;throw void 0!==a&&i(a.call(e)),o}}},function(e,t,n,r,i){var o=n(r),a=n(i)("iterator"),s=Array.prototype;e.exports=function(e){return void 0!==e&&(o.Array===e||s[a]===e)}},function(e,t,n,r){var i=n(r),o=Math.min;e.exports=function(e){return e>0?o(i(e),9007199254740991):0}},function(e,t,n,r,i,o,a){var s=n(r),u=n(i)("iterator"),l=n(o);e.exports=n(a).getIteratorMethod=function(e){return void 0!=e?e[u]||e["@@iterator"]||l[s(e)]:void 0}},function(e,t,n,r,i,o,a){var s=n(r).getDesc,u=n(i),l=n(o),c=function(e,t){if(l(e),!u(t)&&null!==t)throw TypeError(t+": can't set as prototype!")};e.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(e,t,r){try{r=n(a)(Function.call,s(Object.prototype,"__proto__").set,2),r(e,[]),t=!(e instanceof Array)}catch(i){t=!0}return function(e,n){return c(e,n),t?e.__proto__=n:r(e,n),e}}({},!1):void 0),check:c}},function(e,t,n,r,i,o){var a=n(r),s=n(i),u=n(o)("species");e.exports=function(e,t){var n,r=a(e).constructor;return void 0===r||void 0==(n=a(r)[u])?t:s(n)}},function(e,t,n,r,i,o){var a,s,u,l=n(r),c=n(i).set,d=l.MutationObserver||l.WebKitMutationObserver,p=l.process,f=l.Promise,h="process"==n(o)(p),v=function(){var e,t,n;for(h&&(e=p.domain)&&(p.domain=null,e.exit());a;)t=a.domain,n=a.fn,t&&t.enter(),n(),t&&t.exit(),a=a.next;s=void 0,e&&e.enter()};if(h)u=function(){p.nextTick(v)};else if(d){var y=1,g=document.createTextNode("");new d(v).observe(g,{characterData:!0}),u=function(){g.data=y=-y}}else u=f&&f.resolve?function(){f.resolve().then(v)}:function(){c.call(l,v)};e.exports=function(e){var t={fn:e,next:void 0,domain:h&&p.domain};s&&(s.next=t),a||(a=t,u()),s=t}},function(e,t,n,r,i,o,a,s,u){var l,c,d,p=n(r),f=n(i),h=n(o),v=n(a),y=n(s),g=y.process,m=y.setImmediate,_=y.clearImmediate,A=y.MessageChannel,C=0,b={},S="onreadystatechange",M=function(){var e=+this;if(b.hasOwnProperty(e)){var t=b[e];delete b[e],t()}},T=function(e){M.call(e.data)};m&&_||(m=function(e){for(var t=[],n=1;arguments.length>n;)t.push(arguments[n++]);return b[++C]=function(){f("function"==typeof e?e:Function(e),t)},l(C),C},_=function(e){delete b[e]},"process"==n(u)(g)?l=function(e){g.nextTick(p(M,e,1))}:A?(c=new A,d=c.port2,c.port1.onmessage=T,l=p(d.postMessage,d,1)):y.addEventListener&&"function"==typeof postMessage&&!y.importScripts?(l=function(e){y.postMessage(e+"","*")},y.addEventListener("message",T,!1)):l=S in v("script")?function(e){h.appendChild(v("script"))[S]=function(){h.removeChild(this),M.call(e)}}:function(e){setTimeout(p(M,e,1),0)}),e.exports={set:m,clear:_}},function(e,t,n,r){e.exports=n(r).document&&document.documentElement},function(e,t,n,r,i){var o=n(r),a=n(i).document,s=o(a)&&o(a.createElement);e.exports=function(e){return s?a.createElement(e):{}}},function(e,t,n,r){var i=n(r);e.exports=function(e,t){for(var n in t)i(e,n,t[n]);return e}},function(e,t,n,r){var i=n(r)("iterator"),o=!1;try{var a=[7][i]();a.return=function(){o=!0},Array.from(a,function(){throw 2})}catch(s){}e.exports=function(e,t){if(!t&&!o)return!1;var n=!1;try{var r=[7],a=r[i]();a.next=function(){n=!0},r[i]=function(){return a},e(r)}catch(s){}return n}},function(e,t,n,r){var i=n(r);e.exports=function(e){return Object(i(e))}},function(e,t,n,r,i){var o=n(r);o(o.S+o.F,"Object",{assign:n(i)})},function(e,t,n,r,i,o,a){var s=n(r),u=n(i),l=n(o);e.exports=n(a)(function(){var e=Object.assign,t={},n={},r=Symbol(),i="abcdefghijklmnopqrst";return t[r]=7,i.split("").forEach(function(e){n[e]=e}),7!=e({},t)[r]||Object.keys(e({},n)).join("")!=i})?function(e,t){for(var n=u(e),r=arguments,i=r.length,o=1,a=s.getKeys,c=s.getSymbols,d=s.isEnum;i>o;)for(var p,f=l(r[o++]),h=c?a(f).concat(c(f)):a(f),v=h.length,y=0;v>y;)d.call(f,p=h[y++])&&(n[p]=f[p]);return n}:Object.assign},function(e,t,n,r,i){var o=n(r);o(o.S,"Object",{setPrototypeOf:n(i).set})},function(e,t,n,r,i,o){var a=n(r),s=n(i),u=n(o);e.exports=function(e,t){var n=(s.Object||{})[e]||Object[e],r={};r[e]=t(n),a(a.S+a.F*u(function(){n(1)}),"Object",r)}},function(e,t,n,r,i){var o=n(r);n(i)("keys",function(e){return function(t){return e(o(t))}})},function(e,t,n,r){var i=n(r);i(i.S,"Math",{log10:function(e){return Math.log(e)/Math.LN10}})},function(e,t,n,r,i){var o=n(r);o(o.P,"String",{repeat:n(i)})},function(e,t,n,r,i){"use strict";var o=n(r),a=n(i);e.exports=function(e){var t=String(a(this)),n="",r=o(e);if(0>r||r==1/0)throw RangeError("Count can't be negative");for(;r>0;(r>>>=1)&&(t+=t))1&r&&(n+=t);return n}},function(e,t,n,r,i,o,a,s,u,l,c){"use strict";var d=n(r),p=n(i),f=n(o),h=n(a),v=n(s),y=n(u),g=n(l);p(p.S+p.F*!n(c)(function(e){Array.from(e)}),"Array",{from:function(e){var t,n,r,i,o=f(e),a="function"==typeof this?this:Array,s=arguments,u=s.length,l=u>1?s[1]:void 0,c=void 0!==l,p=0,m=g(o);if(c&&(l=d(l,u>2?s[2]:void 0,2)),void 0==m||a==Array&&v(m))for(t=y(o.length),n=new a(t);t>p;p++)n[p]=c?l(o[p],p):o[p];else for(i=m.call(o),n=new a;!(r=i.next()).done;p++)n[p]=c?h(i,l,[r.value,p],!0):r.value;return n.length=p,n}})},function(e,t,n,r,i,o,a,s,u,l,c,d,p,f,h,v,y){"use strict";var g=n(r),m=n(i),_=n(o),A=n(a),C=n(s),b=n(u),S=n(l),M=n(c),T=n(d),E=n(p)("id"),w=n(f),x=n(h),k=n(v),I=n(y),P=Object.isExtensible||x,D=I?"_s":"size",N=0,O=function(e,t){if(!x(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!w(e,E)){if(!P(e))return"F";if(!t)return"E";m(e,E,++N)}return"O"+e[E]},R=function(e,t){var n,r=O(t);if("F"!==r)return e._i[r];for(n=e._f;n;n=n.n)if(n.k==t)return n};e.exports={getConstructor:function(e,t,n,r){var i=e(function(e,o){C(e,i,t),e._i=g.create(null),e._f=void 0,e._l=void 0,e[D]=0,void 0!=o&&S(o,n,e[r],e)});return _(i.prototype,{clear:function(){for(var e=this,t=e._i,n=e._f;n;n=n.n)n.r=!0,n.p&&(n.p=n.p.n=void 0),delete t[n.i];e._f=e._l=void 0,e[D]=0},"delete":function(e){var t=this,n=R(t,e);if(n){var r=n.n,i=n.p;delete t._i[n.i],n.r=!0,i&&(i.n=r),r&&(r.p=i),t._f==n&&(t._f=r),t._l==n&&(t._l=i),t[D]--}return!!n},forEach:function(e){for(var t,n=A(e,arguments.length>1?arguments[1]:void 0,3);t=t?t.n:this._f;)for(n(t.v,t.k,this);t&&t.r;)t=t.p;
},has:function(e){return!!R(this,e)}}),I&&g.setDesc(i.prototype,"size",{get:function(){return b(this[D])}}),i},def:function(e,t,n){var r,i,o=R(e,t);return o?o.v=n:(e._l=o={i:i=O(t,!0),k:t,v:n,p:r=e._l,n:void 0,r:!1},e._f||(e._f=o),r&&(r.n=o),e[D]++,"F"!==i&&(e._i[i]=o)),e},getEntry:R,setStrong:function(e,t,n){M(e,t,function(e,t){this._t=e,this._k=t,this._l=void 0},function(){for(var e=this,t=e._k,n=e._l;n&&n.r;)n=n.p;return e._t&&(e._l=n=n?n.n:e._t._f)?"keys"==t?T(0,n.k):"values"==t?T(0,n.v):T(0,[n.k,n.v]):(e._t=void 0,T(1))},n?"entries":"values",!n,!0),k(t)}}},function(e,t,n,r,i){"use strict";var o=n(r);n(i)("Set",function(e){return function(){return e(this,arguments.length>0?arguments[0]:void 0)}},{add:function(e){return o.def(this,e=0===e?0:e,e)}},o)},function(e,t,n,r,i){var o=n(r),a=n(i);e.exports=function(e){return function(){if(a(this)!=e)throw TypeError(e+"#toJSON isn't generic");var t=[];return o(this,!1,t.push,t),t}}},function(e,t,n,r,i){var o=n(r);o(o.P,"Set",{toJSON:n(i)("Set")})}]));

var tmpl_TripcoinsInfo, tmpl_PassengerSelect, tmpl_FreezeFooter, tmpl_PriceFooter, tmpl_BookingAviaBody, tmpl_SuggestPassenger, tmpl_moreFlightInfo;
var tmpl_topPanel2Button = '<div class="button ${className}"><div class="l"></div><div class="r"></div><div class="c"></div>${title}</div>';
var objPassengerSelect = null;
var fareRulesList = {};

function PassengerSelect(data){
	var self = this;
	this.data = data;
	this.params = this.data.params;
	this.params.customerLanguage = tw.language;
	this.fare = this.data.fare;
	this.searchResultMessages = this.data.searchResultMessages;
	try {
		this.isHotelsTabOpened = localStorage.isHotelsTabOpened === "true";
		localStorage.isHotelsTabOpened = false;
		delete localStorage.isHotelsTabOpened;
	} catch (e) {}

	tw.params.p = getURLParams().p || "1,0,0";

	this.paxInfo = {
		"adtCount": 0,
		"cnnCount": 0,
		"infCount": 0
	};

	this.priceFreeze = (tw.language == "ru") && this.fare.priceFreeze;
	this.passengers = [];
	this.counter = 0;
	this.elPageTitlePanel = document.getElementById('pageTitlePanel');

	this.data.fare.needTripcoinsTitle = true;
	this.elBlock = $.tmpl(tmpl_PassengerSelect, this.params)[0];
	this.elForm = $('form', this.elBlock)[0];

	this.elCharterWarn = $(".charter", this.elForm)[0];
	this.elTimeWarn = $(".timeWarn", this.elForm)[0];
	this.elRenew = $(".renew", this.elTimeWarn)[0];
	this.elFlightInfo = $(".ConfirmInfoFlight", this.elForm)[0];

	$(this.elRenew).click(function(){
		fadeOutBlock($('#topPanel2 .button.changeSearch').get()[0]);
		tw.oResult.ReloadSearchResult();
	});

	this.emailField = new Field({
		appendTo: $("#avia_book_email", this.elForm)[0],
		validate: true,
		name: "avia_book_email",
		type: "email"
	});

	this.updateEmail();

	$(".close_button", this.elForm).click(function(){
		if (typeof store !== 'undefined') {
			store.pub('unmountFareFamily', {});
		}

		self.hideBack();
	});

	this.activeCheckAvail = false;
	$(this.elForm).submit(function(event){
		event.preventDefault();
		self.submitForm();
	});

	this.analyzeFlight();
	//this.initComparingPrices();
	//this.initBonusPocket();

	$(this.elBlock).appendTo( tw.layout_results );
	this.needUserInfo = true;
	this.progressUserInfo = false;
	this.show();
	//this.inProcess this.visible переменные для result.js  hashchange

	$(document).on("authTrue", function(){
		self.updateEmail();
		//self.initBonusPocket();
		//self.setAmount();
		self.setPrices();
	});
	if (window.name === 'searchresults') {
		window.name = '';
	}

	twdevdisplay(this.params, 'reserv');
}
PassengerSelect.prototype.initAdButlerBanners = function(){
	var formPopup = this.elBlock;
	var formWidth = formPopup.querySelector('form').offsetWidth;
	var BOOKING_PAGE_MSG = 'BOOKING_PAGE_BANNER';
	var arrDirections = this.arrDirections;
	var arrDir = arrDirections[0];

	var directionInfoCountry = {
		from: ref.getCountryCode(arrDir.from),
		to: ref.getCountryCode(arrDir.to)
	};

	var directionInfoCity = {
		from: ref.getCityCode(arrDir.from),
		to: ref.getCityCode(arrDir.to)
	};

	var optionsTopBanner = {
		id: 'passengerSelectTopBanner',
		banner: 'passengerSelectTopBanner' + formWidth,
		keyword: []
	};

	if (arrDirections.length === 1) {
		var railwaysPromoKeywordCountry = (getAdButlerKeyWordByRoutes({
			promo: 'flightsToRailwaysCountry',
			departure: directionInfoCountry.from,
			arrival: directionInfoCountry.to
		}));

		railwaysPromoKeywordCountry && optionsTopBanner.keyword.push(railwaysPromoKeywordCountry);

		var railwaysPromoKeywordCity = (getAdButlerKeyWordByRoutes({
			promo: 'flightsToRailwaysCity',
			departure: directionInfoCity.from,
			arrival: directionInfoCity.to
		}));

		railwaysPromoKeywordCity && optionsTopBanner.keyword.push(railwaysPromoKeywordCity);
	}

	var optionsBottomBanner = {
		id: 'passengerSelectBottomBanner',
		banner: 'passengerSelectBottomBanner' + formWidth,
	};

	var isBookingPageBanner = this.fare.messages.some(function (item) {
		return (item != null) && ((item.msg === BOOKING_PAGE_MSG) || (item.cd === BOOKING_PAGE_MSG));
	});

	initComBlock(optionsTopBanner);

	if (isBookingPageBanner) {
		initComBlock(optionsBottomBanner);
	}
};


PassengerSelect.prototype.updateEmail = function(){
	if(tw.provider) {
		if(tw.visitor.email) {
			this.emailField.input.value = tw.visitor.email;
			this.emailField.update();
		}
		$('#bookFormAuth', this.elForm).html( l10n.searchResult.passengers.email2 );
	} else {
		$('#bookFormAuth .link', this.elForm).on('click', function(){
			objSocialAuth.show(objSocialAuth.regauthForm);
		});

		var bookEmail = readCookie('bookEmail') || readCookie('sales');
		if(bookEmail) {
			this.emailField.input.value = bookEmail;
			this.emailField.update();
		}
		$(this.emailField.input).blur(function(){
			setCookie({
				name: "bookEmail",
				value: this.value,
				days: 0.022
			});
		});
	}
};

PassengerSelect.prototype.submitForm = function() {
	var self = this;
	if (tw.ajaxCheckNames || this.activeCheckAvail) {
		return;
	}
	$("tbody tr", this.$table).each(function (i, currentDOMRow) {
		self.placeholderForIE(this.fields, false);
	});
	$('input', this.elForm).blur();
	$(this.elForm).focus();

	var callback = function () {
		checkNames(self.passengersForCheckNames, function () {
			tw.notificationMessages.closeAll();
			if (self.checkForEscortNotification()) {
				self.showEscortNotification();
			} else {
				self.getConfirmation();
			}
		}, function (warnPassengers) {
			/*var rows = $("td.fields>table tbody tr", this.elForm);
			 for (var i = 0, length = warnPassengers.length; i < length; i++) {
			 var id = warnPassengers[i].id;
			 rows[id].fields.firstName.addWarn();
			 rows[id].fields.lastName.addWarn();
			 }*/
		});
	};

	self.getData();
	if (self.checkData()) {
		var fareMsgs = ((this.Flight || {}).sourceFare || {}).infMsgs || [];
		var POPUNDER_HOTEL = 'POPUNDER_HOTEL';
		var canOpenHotelPopunder = fareMsgs.some(function(msg) {
			return (msg != null) && (msg === POPUNDER_HOTEL || msg.cd === POPUNDER_HOTEL || msg.msg === POPUNDER_HOTEL);
		});
		if (canOpenHotelPopunder && aviaAndHotelsSearch.isHotelsReadyToOpen() && !self.isHotelsTabOpened) {
			try {
				localStorage.lastAviaSearchingResults = JSON.stringify(objAvia.rawJSON);
				self.checkForEscortNotification();
				var adults = 0;
				var children = 0;
				self.passengers.forEach(function (item) {
					if (item.ageType === 'ADT') {
						adults += 1;
					} else {
						children += 1;
					}
				});
				// safe change data
				aviaAndHotelsSearch.updateData({
					directions: self.arrDirections,
					adults: adults,
					children: children
				});
				self.setCookiedPassengers(true);
				aviaAndHotelsSearch.openTabs({
					aviaLink: location.href
				});
				localStorage.isHotelsTabOpened = true;
			} catch (e) {
				try {
					localStorage.isHotelsTabOpened = false;
				} catch (e) {}
				callback();
			}
		} else {
			callback();
		}
	}
};

PassengerSelect.prototype.checkForEscortNotification = function() {
	var escortIsNeeded = false;
	var escortIsProvided = false;

	var passengers = this.passengers;
	for (var i = 0; i < passengers.length; i++) {
		var lastDirFirstTripDate = Date.parseAPI(this.arrDirections[this.arrDirections.length - 1].trips[0].stDt); // from setAgeTypes
		var birthDate = passengers[i].birthDate_Date;
		var date18ago = createShiftedDate(lastDirFirstTripDate, 18);

		if (birthDate <= date18ago) {
			escortIsProvided = true;
			break;
		} else {
			var date16ago = createShiftedDate(lastDirFirstTripDate, 16);
			var date12ago = createShiftedDate(lastDirFirstTripDate, 12);
			escortIsNeeded = birthDate > date16ago && birthDate <= date12ago
		}
	}

	return escortIsNeeded && !escortIsProvided;

	function createShiftedDate(date, yearsAgo) {
		var shiftedDate = new Date(date);
		shiftedDate = shiftedDate.setFullYear(shiftedDate.getFullYear() - yearsAgo);
		return shiftedDate;
	}
};

PassengerSelect.prototype.showEscortNotification = function() {
	var popup = addPopup({
		dom: $('<div/>').html(l10n.searchResult.popup.escortNotification),
		className: "commonPopup",
		close_button: true,
		button: l10n.searchResult.popup.okBuy
	});

	var self = this;
	$('button', popup).on('click', function() {
		self.getConfirmation();
		removePopup();
	});
};

PassengerSelect.prototype.initPromo = function(){
	var self = this;
	var promo = $('.promo', this.elForm)[0];
	if(!promo) return;
	if(this.Flight.removePromo) {
		$(promo).remove();
		return;
	} else if(this.fare.denyPromoCodeUse && tw.provider) {
		//$(promo).html(l10n.searchResult.passengers.cantUseBonuses);
		$(promo).remove();
		return;
	} else if(tw.oResult.obj.json.metaSearch) {
		//$(promo).html(l10n.searchResult.passengers.metaSearch);
		$(promo).remove();
		return;
	}
	if(!(tw.params.promocode && this.Flight.PromoAmount)) {
		$(promo).removeClass('invisible');
	}
	var promoField = new Field({
		appendTo: promo,
		name: 'promo',
		type: 'numberAndLatin',
		maxlength: 20
	});
	var checkBox = $('label input', promo)[0];
	$(checkBox).on('click', function() {
		if (this.checked){
			$(promoField.elField).removeClass('invisible');
		} else {
			$(promoField.elField).addClass('invisible');
		}
		if(tw.params.promocode && self.Flight.PromoAmount) {
			checkPromoCode();
		}
	});
	if(tw.params.promocode && this.Flight.PromoAmount) {
		this.convertPromoValue = true;
		$(promoField.input).on("keyup", function(){
			checkPromoCode();
		});
	} else {
		this.convertPromoValue = false;
	}
	var checkPromoCode = function(){
		if(checkBox.checked && promoField.input.value.toLowerCase() == tw.params.promocode.toLowerCase()) {
			self.convertPromoValue = true;
		} else {
			self.convertPromoValue = false;
		}
		//self.setAmount();
		self.setTotal();
	};
	if(tw.params.promocode) {
		promoField.input.value = tw.params.promocode;
		checkBox.checked = true;
	} else {
		$(promoField.elField).addClass('invisible');
	}
};
PassengerSelect.prototype.refreshPromo = function(){
	var promo = $('.promo', this.elForm)[0];
	if(promo){
		if(this.fare.denyPromoCodeUse && tw.provider) {
			$(promo).html(l10n.searchResult.passengers.cantUseBonuses);
		} else if(tw.oResult.obj.json.metaSearch) {
			$(promo).html(l10n.searchResult.passengers.metaSearch);
		}
	}
};
PassengerSelect.prototype.getUserInfo = function(){
	var self = this;
	var params = this.params;
	var count = 1;
	MakeRequest();
	function MakeRequest(){
		$.ajax({
			iframeId: "pm",
			type: "post",
			dataType: "json",
			url: '/_api/buyermanager/getUserInfo/',
			beforeSend: function(){
				self.progressUserInfo = true;
			},
			success: function(json){
				if (!json.error) {
					self.userInfo = json;
					if (self.userInfo.passengers.length > 0) {
						self.setSuggest();
					}
				} else {
					$(document).one("authTrue", function(){
						self.getUserInfo();
					});
				}
				self.needUserInfo = false;
			},
			error: function(){
				self.needUserInfo = true;
				if(count>0){
					MakeRequest();
					count--;
				}
			},
			complete: function(){
				self.progressUserInfo = false;
			}
		});
	}
};
PassengerSelect.prototype.setSuggest = function(){
	var self = this;
	if (this.userInfo.passengers.length > 0) {
		for (var i = 0, length = this.userInfo.passengers.length; i < length; i++) {
			this.userInfo.passengers[i].number = i;
		}
		this.setAgeTypes();
		this.$elSuggest = $('<div/>',{
			id: "passSuggest",
			class: "suggest"
		});

		this.link_onKeyDown = function(event){
			this.tempValue = this.value;
			self.onKeyDown(event);
		};
		$(this.elForm).delegate('input[type="text"][name*="lastName"], input[type="text"][name*="firstName"]', 'focus keyup', function(e){
			if(e.keyCode !== 38 && e.keyCode !== 40) {
				self.makeSuggest(this);
			}
		});
		$(this.elForm).delegate('input[type="text"][name*="lastName"], input[type="text"][name*="firstName"]', 'blur', function(){
			self.hideSuggest();
		});
		$(this.elForm).delegate('input[type="radio"]', 'change', function(){
			this.row.passenger = null;
		});
	}
};
PassengerSelect.prototype.setAgeTypes = function(){
	var lastDirFirstTripDate = Date.parseAPI(this.arrDirections[this.arrDirections.length - 1].trips[0].stDt);
	var date12ago = new Date(lastDirFirstTripDate);
	date12ago.setFullYear(date12ago.getFullYear() - 12);
	var date2ago = new Date(lastDirFirstTripDate);
	date2ago.setFullYear(date2ago.getFullYear() - 2);
	for (var j = 0, pLength = this.userInfo.passengers.length; j < pLength; j++) {
		var passenger = this.userInfo.passengers[j];
		passenger.birthDate_Date = Date.parseAPI(passenger.birthDate);
		if (passenger.birthDate_Date <= date12ago) {
			passenger.ageType = "ADT";
		} else if(date12ago < passenger.birthDate_Date && passenger.birthDate_Date <= date2ago){
			passenger.ageType = "CNN";
		} else if(date2ago < passenger.birthDate_Date) {
			passenger.ageType = "INF";
		}
	}
};
PassengerSelect.prototype.onKeyDown = function(event){
	switch (event.keyCode) {
		/*case 27: // <Esc>
		 this.hideSuggest();
		 break;*/
		case 38: // <Up>
			event.preventDefault();
			this.setPrevRowHover();
			break;
		case 40: // <Down>
			event.preventDefault();
			this.setNextRowHover();
			break;
		case 13: // <Enter>
			event.preventDefault();
			this.setCurrentResult();
			this.hideSuggest();
			break;
	}
};
PassengerSelect.prototype.makeSuggest = function(input){
	this.suggestRow = input.row;
	//var temp = JSON.stringify(this.filteredPassengers);
	/*к проверке на temp value добавляем проверку что менялось-добавлялось отчество:
	 в этом случае не обнуляем данные по пассажиру и в дальнейшем перезаписываем поле с именем и отчеством see remark1*/
	if (input.tempValue !== input.value && !(this.needMiddleName && input.id.indexOf('firstName') !== -1)){
		this.suggestRow.passenger = null;
	}
	this.filterPassengers();
	if (!this.suggestRow.passenger && input.value !== "" && this.filteredPassengers.length) {
		input.field.removeHint();
		//странное условие...
		//if(temp !== JSON.stringify(this.filteredPassengers)){
		this.drawSuggest();
		this.showSuggest(input);
		//}
	} else {
		this.hideSuggest();
		input.field.drawHint();
	}

};
PassengerSelect.prototype.filterPassengers = function(){
	this.filteredPassengers = [];
	var selectedPassengers = [];
	$("td.fields>table tbody tr", this.elForm).each(function(i){
		if (this.passenger) selectedPassengers.push(this.passenger);
	});
	for (var i = this.userInfo.passengers.length - 1; i >= 0; i--) {
		var passenger = this.userInfo.passengers[i];
		var selectedPassenger = false;
		for (var j = 0, jl = selectedPassengers.length; j < jl; j++){
			if (JSON.stringify(selectedPassengers[j]) == JSON.stringify(passenger)){
				selectedPassenger = true;
				break;
			}
		}
		if (selectedPassenger) continue;
		if ((this.suggestRow.ageType !== 'UND') && (passenger.ageType !== this.suggestRow.ageType)) continue;
		if (this.suggestRow.fields.lastName.translitValue || this.suggestRow.fields.firstName.translitValue) {
			if ($(this.suggestRow.fields.lastName.input).val() && passenger.lastName.indexOf(this.suggestRow.fields.lastName.translitValue) != 0) continue;
			if ($(this.suggestRow.fields.firstName.input).val() && passenger.firstName.indexOf(this.suggestRow.fields.firstName.translitValue) != 0) continue;
		} else {
			if ($(this.suggestRow.fields.lastName.input).val() && passenger.lastName.indexOf($(this.suggestRow.fields.lastName.input).val()) != 0) continue;
			if ($(this.suggestRow.fields.firstName.input).val() && passenger.firstName.indexOf($(this.suggestRow.fields.firstName.input).val()) != 0) continue;
		}
		this.filteredPassengers.unshift(passenger);
	}
	//ограничиваем саджест вывода до 6 человек (старое условие)
	this.filteredPassengers = this.filteredPassengers.slice(0,6);
};
PassengerSelect.prototype.drawSuggest = function(){
	var self = this;
	this.$elSuggest.empty();
	var dublicatePassengers = []; //в случае если не требуется паспорт а у пассажира много паспортов

	var ul = document.createElement("ul");
	for (var i = 0, length = this.filteredPassengers.length; i < length; i++) {
		var iPass = this.filteredPassengers[i];
		var pasString = iPass.lastName + iPass.firstName + iPass.birthDate;
		if(this.mustHidePassportNumber && ~dublicatePassengers.indexOf(pasString)) {
			continue;
		}
		var li = this.drawSuggestItem(iPass);
		ul.appendChild(li);
		dublicatePassengers.push(pasString);
	}
	this.$elSuggest.append(ul);
	this.setRowHover(ul.firstChild);
	$(ul).mousedown(function(){
		self.setCurrentResult();
	});
	$(ul).mouseout(function(){
		self.setRowHover(self.selectedRow);
	});
};
PassengerSelect.prototype.drawSuggestItem = function(pass){
	var self = this;
	var li = document.createElement("li");
	li.passenger = pass;
	$(li).html( $.tmpl(tmpl_SuggestPassenger, pass, {needMiddleName: this.needMiddleName, mustHidePassportNumber: this.mustHidePassportNumber}) );
	li.onmouseover = function(){
		self.setRowHover(this);
	};
	li.onmouseout = function(){
		self.dropRowHover(this);
	};
	return li;
};
PassengerSelect.prototype.setOffset = function(){
	var offset = $(this.suggestRow).offset();
	this.$elSuggest.css({
		top: offset.top + this.suggestRow.offsetHeight + "px",
		left: offset.left + "px",
		width: this.suggestRow.offsetWidth - 2 + "px"
	});
};
PassengerSelect.prototype.showSuggest = function(input){
	var self = this;
	this.setOffset();
	if (!document.getElementById(this.$elSuggest.attr('id'))) {
		this.setRowHover($("li:first-child", this.$elSuggest[0])[0]);
		this.$elSuggest.appendTo( document.body );
	};
	this.$elSuggest[0].input = input;
	$(input)
		.unbind("keydown", self.link_onKeyDown)
		.bind("keydown", self.link_onKeyDown);
};
PassengerSelect.prototype.hideSuggest = function(){
	var self = this;
	if (this.$elSuggest[0].input) {
		$(this.$elSuggest[0].input).unbind("keydown", self.link_onKeyDown);
		this.$elSuggest[0].input = null;
	}
	this.$elSuggest.detach();
};
PassengerSelect.prototype.setPrevRowHover = function() {
	if (this.selectedRow) {
		var PrewRow = this.selectedRow.previousSibling;
		if (PrewRow) {
			this.setRowHover(PrewRow);
		}
	}
};
PassengerSelect.prototype.setNextRowHover = function() {
	if (this.selectedRow) {
		var NextRow = this.selectedRow.nextSibling;
		if (NextRow) {
			this.setRowHover(NextRow);
		}
	} else {
		this.setRowHover(this.$elSuggest.find("li")[0]);
	}
};
PassengerSelect.prototype.setRowHover = function(elRow) {
	if (this.selectedRow) {
		this.dropRowHover(this.selectedRow);
	}
	$(elRow).addClass("hover");
	this.selectedRow = elRow;
};
PassengerSelect.prototype.dropRowHover = function(elRow){
	$(elRow).removeClass("hover");
};
PassengerSelect.prototype.setCurrentResult = function(){
	var passenger = this.selectedRow.passenger;
	this.suggestRow.fields.lastName.input.value = passenger.lastName;
	this.suggestRow.fields.lastName.input.tempValue = this.suggestRow.fields.lastName.input.value;
	this.suggestRow.fields.lastName.update();
	this.suggestRow.fields.firstName.input.value = passenger.firstName;
	if(this.needMiddleName && passenger.middleName) {
		this.suggestRow.fields.firstName.input.value += ' ' + passenger.middleName;
	}
	this.suggestRow.fields.firstName.input.tempValue = this.suggestRow.fields.firstName.input.value;
	this.suggestRow.fields.firstName.update();
	this.suggestRow.fields.birthDate.input.value = passenger.birthDate_Date.format("dd.mm.yyyy");
	this.suggestRow.fields.birthDate.update();
	if (this.suggestRow.ageType === 'UND') {
		this.writeAgeType(this.suggestRow);
		this.changePaxInfo(this.suggestRow.ageType, 1);
		this.setPlaceholder(this.suggestRow);
	}
	this.checkPassengersCount();

	if(this.needPassport){
		this.suggestRow.fields.passNumber.input.value = passenger.passNumber;
		this.suggestRow.fields.passNumber.update();
		/*if(passenger.needPassExpDate){
		 this.suggestRow.fields.passExpDate.input.value = Date.parseAPI(passenger.passExpDate).format("dd.mm.yyyy");
		 this.suggestRow.fields.passExpDate.setEnabled();
		 } else {
		 this.suggestRow.fields.passExpDate.input.value = "";
		 this.suggestRow.fields.passExpDate.value = null;
		 this.suggestRow.fields.passExpDate.setDisabled();
		 }*/
	}
	this.suggestRow.passenger = passenger;

	//пересчет цены
	this.setTotal();
};
PassengerSelect.prototype.drawMoreFlightInfo = function() {
	$('.m_flightInfo', this.elForm).remove();

	var flightTariffDetails = tw.oResult.flightTariffDetails || {};
	$('.innerContent', this.elForm).prepend($.tmpl(tmpl_moreFlightInfo, {
		"directions": this.arrDirections,
		"FlightIndex": this.Flight.FlightIndex,
		hasNoBaggage: flightTariffDetails.someDirsHasNoBaggage(this.arrDirections, this.Flight)
	}));
};

PassengerSelect.prototype.setCharterWarn = function(){
	if(this.fare.isCharter && tw.language == "ru") {
		$(this.elCharterWarn).html("Обращаем Ваше внимание на то, что Вы приобретаете чартерный перелет.<br>После оплаты билета на электронную почту, указанную при бронировании, направляется электронный ваучер, который является подтверждением покупки. <b>Электронные билеты будут выписаны и направлены Вам за 1-2 дня до вылета.</b>").removeClass("invisible");
	} else {
		$(this.elCharterWarn).empty().addClass("invisible");
	}
};
PassengerSelect.prototype.getChildrenPrices = function(){
	var self = this;
	var params = this.params;
	if(tw && tw.params && tw.params.srcmarker && params){
		params.srcmarker = tw.params.srcmarker;
	}
	if(tw && tw.oResult && tw.oResult.obj && tw.oResult.obj.json && params){
		params.searchId = tw.oResult.obj.json.srid;
	}

	if(tw && tw.currency){
		params.currency = tw.currency;
	}

	var makeChildrenRequest = true;
	if((this.isSirena || this.isSig) && tw.oResult.obj.json.metaSearch) {
		makeChildrenRequest = false;
	}

	var passengerTypesToRequest = getPassengerTypesFromParams(tw.params.p);

	if(this.fare.isLowcost) {
		var prcInf = this.fare.prcInf;
		this.fare.childPrices = {
			"cnnPriceInfo": {
				"amount": prcInf.adtAmountWC,
				"currency": this.fare.cur,
				"isFinal": true
			},
			"infPriceInfo": {
				"amount": prcInf.adtAmountWC,
				"currency": this.fare.cur,
				"isFinal": true
			}
		};
		self.setPrices();
		//self.setAmount();

	} else if(passengerTypesToRequest['cn'] > 0 || passengerTypesToRequest['in'] > 0) {
		var needToUpdateAny = false;
		if(passengerTypesToRequest['cn'] === 0 || passengerTypesToRequest['in'] === 0) {
			needToUpdateAny = true;
		}

		this.fare.childPrices = this.fare.childPrices || {};
		this.fare.childPrices.cnnPriceInfo = this.fare.childPrices.cnnPriceInfo || {};
		this.fare.childPrices.cnnPriceInfo.amount = this.fare.prcInf.cnnAmountWC;
		this.fare.childPrices.cnnPriceInfo.currency = this.fare.prcInf.cur;

		this.fare.childPrices.infPriceInfo = this.fare.childPrices.infPriceInfo || {};
		this.fare.childPrices.infPriceInfo.amount = this.fare.prcInf.infAmountWC || 0;
		this.fare.childPrices.infPriceInfo.currency = this.fare.prcInf.cur;
		if(makeChildrenRequest) {
			if(needToUpdateAny) {
				MakeRequest();
			} else {
				self.setPrices();
			}
		}
	} else if(makeChildrenRequest) {
		MakeRequest();
	}

	function MakeRequest(){
		$.ajax({
			iframeId: "pm",
			type: "post",
			dataType: "json",
			url: '/_api/confirmation/searchfare/',
			data: {
				"params": JSON.stringify(params)
			},
			timeout: 40000,
			beforeSend: function(xhr){
				self.searchxhr = xhr;
				$('.priceLeft table', self.elForm).after('<div class="smallLoader"></div>');
			},
			success: function(json){
				if(json.avail && JSON.stringify(params) == JSON.stringify(self.params)){
					var oldChildPrices = self.fare.childPrices;
					self.fare.childPrices = json;
					// if we call it with force true, but already had child prices, do not override them
					if(passengerTypesToRequest['cn'] > 0){
						self.fare.childPrices.cnnPriceInfo = oldChildPrices.cnnPriceInfo;
					} else if (self.fare.childPrices.cnnPriceInfo) {
						self.fare.childPrices.cnnPriceInfo.isFinal = true;
					}
					if(passengerTypesToRequest['in'] > 0){
						self.fare.childPrices.infPriceInfo = oldChildPrices.infPriceInfo;
					} else if (self.fare.childPrices.infPriceInfo) {
						self.fare.childPrices.infPriceInfo.isFinal = true;
					}

					/*$(self.$table[0].tBodies[0].rows).each(function(){
					 self.writeAgeType(this);
					 });*/

					self.setPrices();
					//self.setAmount();

					// для checkavail
					var fareKeys = ['fareKeyCNN', 'fareKeyCNNRT', 'fareKeyINF', 'fareKeyINFRT'];
					fareKeys.forEach(function(key) {
						var val = json[key];
						if (val) {
							params[key] = val;
						}
					});
				}
			},
			complete: function(){
				$('.smallLoader',self.elForm).remove();
			}
		});
	}
};
PassengerSelect.prototype.setPrices = function(){
	var text = "";
	//определение цен на странице
	var passengerTypesToRequest = getPassengerTypesFromParams(tw.params.p);
	var amtPrices = convertCurrency(this.fare.prcInf.adtAmountWC, this.fare.cur);
	var childPrices = this.fare.childPrices;
	if (this.currentFareFamilyBrand && this.currentFareFamilyBrand.currentKey === this.fare.frKey && this.isFareWasChoosen) {
		var currentFare = this.currentFareFamilyBrand.fare;
		amtPrices = currentFare.priceInfo.adtAmountWC;
		childPrices = {
			cnnPriceInfo: {
				cnnAmountWC: currentFare.cnnPriceInfo.cnnAmountWC,
				amount: currentFare.cnnPriceInfo.amount,
				currency: currentFare.cnnPriceInfo.currency,
				isFinal: true
			},
			infPriceInfo: {
				infAmountWC: currentFare.infPriceInfo.infAmountWC,
				amount: currentFare.infPriceInfo.amount,
				currency: currentFare.infPriceInfo.currency,
				isFinal: true
			}
		};
	} else {
		if (this.fare.childPrices && this.fare.childPrices.cnnPriceInfo && (passengerTypesToRequest.cn || this.fare.childPrices.cnnPriceInfo.isFinal)) {
			childPrices.cnnPriceInfo = {
				cnnAmountWC: this.fare.childPrices.cnnPriceInfo.cnnAmountWC || this.fare.childPrices.cnnPriceInfo.amount,
				amount: this.fare.childPrices.cnnPriceInfo.amount,
				currency: this.fare.childPrices.cnnPriceInfo.currency,
				isFinal: true
			}
		}
		if (this.fare.childPrices && this.fare.childPrices.infPriceInfo && (passengerTypesToRequest.in || this.fare.childPrices.infPriceInfo.isFinal)){
			childPrices.infPriceInfo = {
				//младенцы могут лететь бесплатно, и тогда с сервера приходит undefined
				infAmountWC: this.fare.childPrices.infPriceInfo.infAmountWC || this.fare.childPrices.infPriceInfo.amount,
				amount: this.fare.childPrices.infPriceInfo.amount,
				currency: this.fare.childPrices.infPriceInfo.currency,
				isFinal: true
			}
		}
	}

	//отрисовка цен на странице
	this.$priceInf[0].innerHTML = text + formatMoney(amtPrices);
	if (childPrices) {
		if (childPrices.cnnPriceInfo && (passengerTypesToRequest.cn || childPrices.cnnPriceInfo.isFinal)) {
			var cnnPriceInfo = childPrices.cnnPriceInfo;
			var cnnPrice = convertCurrency(cnnPriceInfo.cnnAmountWC, cnnPriceInfo.currency);
			this.$priceInf[1].innerHTML = text + formatMoney(cnnPrice);
			$('#cnnPrice', this.elForm).slideDown();
		}
		if (childPrices.infPriceInfo && (passengerTypesToRequest.in || childPrices.infPriceInfo.isFinal)){
			var infPriceInfo = childPrices.infPriceInfo;
			var infPrice = convertCurrency(infPriceInfo.infAmountWC, infPriceInfo.currency);
			this.$priceInf[2].innerHTML = text + formatMoney(infPrice);
			$('#infPrice', this.elForm).slideDown();
		}
	}

	//подсчет суммарного результата
	this.setTotal();
};

PassengerSelect.prototype.setTotal = function() {
	var $elToPay = $(".toPay", this.elForm);
	var adtCount = this.paxInfo.adtCount,
		cnnCount = this.paxInfo.cnnCount,
		infCount = this.paxInfo.infCount;

	if (this.currentFareFamilyBrand && this.currentFareFamilyBrand.currentKey === this.fare.frKey && this.isFareWasChoosen) {
		var currentFare = this.currentFareFamilyBrand.fare;
		var adultPrices = currentFare.priceInfo.adtAmountWC;
		var childPrices = currentFare;
	} else {
		adultPrices = this.fare.prcInf.adtAmountWC;
		childPrices = this.fare.childPrices;
	}

	var ccFee = this.fare.prcInf.ccFee || 0;
	var markupFee = this.fare.prcInf.markupFee || 0;
	var fee = ccFee + markupFee;
	var amount = convertCurrency(adtCount * adultPrices + fee, this.fare.cur);
	var fee = convertCurrency(fee, this.fare.cur);

	if (childPrices) {
		if (childPrices.cnnPriceInfo) {
			var cnnPriceInfo = childPrices.cnnPriceInfo;
			amount += cnnCount * convertCurrency(cnnPriceInfo.amount, cnnPriceInfo.currency);
		}
		if (childPrices.infPriceInfo) {
			var infPriceInfo = childPrices.infPriceInfo;
			amount += infCount * convertCurrency(infPriceInfo.amount, infPriceInfo.currency);
		}
	}
	this.refreshBonusPocket(amount);
	//freeze
	if(this.priceFreeze){
		this.priceFreeze.total = adtCount * convertCurrency(this.priceFreeze.firstPayment, this.priceFreeze.cur);
		this.priceFreeze.latetotal = adtCount * convertCurrency(this.priceFreeze.lastPayment + this.priceFreeze.commission, this.priceFreeze.cur);
		if (childPrices && childPrices.cnnPriceFreeze) {
			var fcnnPriceInfo = childPrices.cnnPriceFreeze;
			this.priceFreeze.total += cnnCount * convertCurrency(fcnnPriceInfo.firstPayment, fcnnPriceInfo.currency);
			this.priceFreeze.latetotal += cnnCount * convertCurrency(fcnnPriceInfo.lastPayment + fcnnPriceInfo.commission, fcnnPriceInfo.currency);
		}
		if (childPrices && childPrices.infPriceFreeze) {
			var finfPriceInfo = childPrices.infPriceFreeze;
			this.priceFreeze.total += infCount * convertCurrency(finfPriceInfo.firstPayment, finfPriceInfo.currency);
			this.priceFreeze.latetotal += infCount * convertCurrency(finfPriceInfo.lastPayment + finfPriceInfo.commission, finfPriceInfo.currency);
		}
		if(tw.currency != 'RUB'){
			this.priceFreeze.total = this.priceFreeze.total.toFixed(2);
			this.priceFreeze.latetotal = this.priceFreeze.latetotal.toFixed(2);
		} else {
			this.priceFreeze.total =  Math.ceil(this.priceFreeze.total);
			this.priceFreeze.latetotal =  Math.ceil(this.priceFreeze.latetotal);
		}
		this.setFreezeAmount();
	}


	if(tw.currency === 'RUB' || tw.currency === 'UAH'){
		this.amountToPay = Math.ceil(amount);
	}
	else{
		this.amountToPay = amount;
	}
	if(this.convertPromoValue) {
		this.amountToPayNoPromo = this.amountToPay;
		var promoAmount = this.Flight.PromoAmount;
		if(this.Flight.PromoPercent){
			promoAmount = this.amountToPay * this.Flight.PromoPercent / 100;
			if(parseInt(this.Flight.PromoMaxPercent) && promoAmount > this.Flight.PromoMaxPercent){
				promoAmount = this.Flight.PromoMaxPercent;
			}
		}
		if(promoAmount > this.amountToPay){
			promoAmount = this.amountToPay;
		}
		this.amountToPay = this.amountToPay - promoAmount;
	}
	$elToPay
		.html(
			l10n.searchResult.passengers.priceToPay
			+ " <span class=\"money money-formatted numbers\">"
			+ formatMoney(this.amountToPay)
			+ "</span>"
		);
	if(this.convertPromoValue) {
		$('.promoDiscount',this.elForm).removeClass('invisible').html( formatMoney(this.amountToPayNoPromo) );
	} else {
		$('.promoDiscount',this.elForm).addClass('invisible').empty();
	}

	if(fee) {
		$('.vsmall',this.elForm).remove();
		$('#lowcost_fee',this.elForm).html(
			l10n.makeorder.lowcost.duty + ' <span class="money-formatted">' + formatMoney(fee) + '</span>'
		);
	}

	var finalPriceText = l10n.searchResult.passengers.finalPriceText;
	if (this.searchResultMessages && this.searchResultMessages.SHOW_FINAL_PRICE_TEXT && finalPriceText) {
		$('.finalPriceText',this.elForm).text(finalPriceText);
	}

};
PassengerSelect.prototype.setAmount = function(){
	var $elToPay = $(".toPay", this.elForm);
	var adtCount = cnnCount = infCount = 0;

	var childPrices = this.fare.childPrices;
	var fareAmt = this.fare.amt;


	if (this.currentFareFamilyBrand && this.currentFareFamilyBrand.currentKey === this.fare.frKey && this.isFareWasChoosen) {
		var currentFare = this.currentFareFamilyBrand.fare;
		fareAmt = currentFare.priceInfo.adtAmountWC;
		childPrices = {
			cnnPriceInfo: {
				cnnAmountWC: currentFare.cnnPriceInfo.amount,
				amount: currentFare.cnnPriceInfo.amount,
				currency: currentFare.cnnPriceInfo.currency
			},
			infPriceInfo: {
				infAmountWC: currentFare.infPriceInfo.amount,
				amount: currentFare.infPriceInfo.amount,
				currency: currentFare.infPriceInfo.currency
			}
		}
	} else {
		fareAmt = this.fare.amt;
		if (this.fare.childPrices && this.fare.childPrices.cnnPriceInfo && this.fare.childPrices.infPriceInfo) {
			childPrices = {
				cnnPriceInfo: {
					cnnAmountWC: this.fare.childPrices.cnnPriceInfo.cnnAmountWC,
					amount: this.fare.childPrices.cnnPriceInfo.amount,
					currency: this.fare.childPrices.cnnPriceInfo.currency
				},
				infPriceInfo: {
					infAmountWC: this.fare.childPrices.infPriceInfo.infAmountWC,
					amount: this.fare.childPrices.infPriceInfo.amount,
					currency: this.fare.childPrices.infPriceInfo.currency
				}
			}
		}
	}


	$(this.$table[0].tBodies[0].rows).each(function () {
		if (this.fields.birthDate.value) {
			switch (this.ageType) {
				case "ADT":
					adtCount++;
					break;
				case "CNN":
					cnnCount++;
					break;
				case "INF":
					infCount++
					break;
			}
		}
	});

	var emptyForm = false;
	if(!adtCount && !cnnCount && !infCount) {
		adtCount = 1;
		emptyForm = true;
	}

	if(this.firstViewTotal && emptyForm && this.data.params.passengerCount) {
		var pasArray = this.data.params.passengerCount.split(',');
		adtCount = parseInt(pasArray[0]||1,10);
		cnnCount = parseInt(pasArray[1]||0,10);
		infCount = parseInt(pasArray[2]||0,10);
	}

	if (!childPrices) {
		adtCount += cnnCount + infCount;
	}

	var ccFee = this.fare.prcInf.ccFee || 0;
	var markupFee = this.fare.prcInf.markupFee || 0;
	var fee = ccFee + markupFee;
	var amount = convertCurrency(adtCount * fareAmt + fee, this.fare.cur);
	var fee = convertCurrency(fee, this.fare.cur);

	if (childPrices) {
		if (childPrices.cnnPriceInfo) {
			var cnnPriceInfo = childPrices.cnnPriceInfo;
			amount += cnnCount * convertCurrency(cnnPriceInfo.amount, cnnPriceInfo.currency);
		}
		if (childPrices.infPriceInfo) {
			var infPriceInfo = childPrices.infPriceInfo;
			amount += infCount * convertCurrency(infPriceInfo.amount, infPriceInfo.currency);
		}
	}
	this.refreshBonusPocket(amount);

	//freeze
	if(this.priceFreeze){
		this.priceFreeze.total = adtCount * convertCurrency(this.priceFreeze.firstPayment, this.priceFreeze.cur);
		this.priceFreeze.latetotal = adtCount * convertCurrency(this.priceFreeze.lastPayment + this.priceFreeze.commission, this.priceFreeze.cur);
		if (childPrices && childPrices.cnnPriceFreeze) {
			var fcnnPriceInfo = childPrices.cnnPriceFreeze;
			this.priceFreeze.total += cnnCount * convertCurrency(fcnnPriceInfo.firstPayment, fcnnPriceInfo.currency);
			this.priceFreeze.latetotal += cnnCount * convertCurrency(fcnnPriceInfo.lastPayment + fcnnPriceInfo.commission, fcnnPriceInfo.currency);
		}
		if (childPrices && childPrices.infPriceFreeze) {
			var finfPriceInfo = childPrices.infPriceFreeze;
			this.priceFreeze.total += infCount * convertCurrency(finfPriceInfo.firstPayment, finfPriceInfo.currency);
			this.priceFreeze.latetotal += infCount * convertCurrency(finfPriceInfo.lastPayment + finfPriceInfo.commission, finfPriceInfo.currency);
		}
		if(tw.currency != 'RUB'){
			this.priceFreeze.total = this.priceFreeze.total.toFixed(2);
			this.priceFreeze.latetotal = this.priceFreeze.latetotal.toFixed(2);
		} else {
			this.priceFreeze.total =  Math.ceil(this.priceFreeze.total);
			this.priceFreeze.latetotal =  Math.ceil(this.priceFreeze.latetotal);
		}
		this.setFreezeAmount();
	}


	if(tw.currency === 'RUB' || tw.currency === 'UAH'){
		this.amountToPay = Math.ceil(amount);
	}
	else{
		this.amountToPay = amount;
	}

	if(this.convertPromoValue) {
		this.amountToPayNoPromo = this.amountToPay;
		var promoAmount = this.Flight.PromoAmount;
		if(this.Flight.PromoPercent){
			promoAmount = this.amountToPay * this.Flight.PromoPercent / 100;
			if(parseInt(this.Flight.PromoMaxPercent) && promoAmount > this.Flight.PromoMaxPercent){
				promoAmount = this.Flight.PromoMaxPercent;
			}
		}
		if(promoAmount > this.amountToPay){
			promoAmount = this.amountToPay;
		}
		this.amountToPay = this.amountToPay - promoAmount;
	}
	$elToPay
		.html(
			l10n.searchResult.passengers.priceToPay
			+ " <span class=\"money money-formatted numbers\">"
			+ formatMoney(this.amountToPay)
			+ "</span>"
		);
	if(this.convertPromoValue) {
		$('.promoDiscount',this.elForm).removeClass('invisible').html( formatMoney(this.amountToPayNoPromo) );
	} else {
		$('.promoDiscount',this.elForm).addClass('invisible').empty();
	}

	if(fee) {
		$('.vsmall',this.elForm).remove();
		$('#lowcost_fee',this.elForm).html(
			l10n.makeorder.lowcost.duty + ' <span class="money-formatted">' + formatMoney(fee) + '</span>'
		);
	}

	var finalPriceText = l10n.searchResult.passengers.finalPriceText;
	if (this.searchResultMessages && this.searchResultMessages.SHOW_FINAL_PRICE_TEXT && finalPriceText) {
		$('.finalPriceText',this.elForm).text(finalPriceText);
	}

	/*else if(tw.language == "ru") {
	 if(String(this.Flight.html_tmpl.arrMiles).split(',').length == String(this.Flight.TripIds).split(',').length) {
	 var tmiles = 0;
	 var usdamt = convertCurrency(this.fare.amt, this.fare.cur, 'USD');
	 for(var mi=0, ml=this.Flight.html_tmpl.arrMiles.length; mi<ml; mi++) {
	 tmiles += this.Flight.html_tmpl.arrMiles[mi];
	 }
	 $('.vsmall',this.elForm).html( "$"+parseFloat(usdamt/tmiles).toFixed(2) +" "+l10n.searchResult.passengers.permile);
	 } else {
	 $('.vsmall',this.elForm).empty();
	 }
	 }*/
};
PassengerSelect.prototype.setTimeSpent = function(){
	$(this.elTimeWarn).addClass('invisible');
	var curTime = new Date();
	var dif = (curTime - this.params.DateCreated) / 60000;
	if (dif > 15) {
		$(this.elTimeWarn).removeClass('invisible');
	}
};
PassengerSelect.prototype.setBody = function(){

	var body = $('.body', this.elForm);
	var self = this;

	body.empty();
	if(this.needPassport) {
		$(this.elForm).addClass('formSirena');
	} else {
		$(this.elForm).removeClass('formSirena');
	}
	if(this.needMiddleName) {
		$(this.elForm).addClass('middle');
	} else {
		$(this.elForm).removeClass('middle');
	}
	$.tmpl($("#tmpl_BookingAviaBody").trim(), this).appendTo(body);

	this.showFreeCancelPurchaseBanner();
	this.showAppBanner();

	if(this.uaWarn) {
		$('#ua_warn',this.elForm).removeClass("invisible");
	} else {
		$('#ua_warn',this.elForm).remove();
	}

	if (this.umrahVisaWarn) {
		$('#umrah_visa_warn',this.elForm).removeClass("invisible");
	} else {
		$('#umrah_visa_warn',this.elForm).remove();
	}

	this.drawMoreFlightInfo();
	this.defineElements();
	this.fieldsPreset();

	if (typeof store !== 'undefined') {
		store.sub('SHOW_BAGGAGE_WARNING', function() { // FareFamilies -> SHOW_BAGGAGE_WARNING
			$('.noBaggageWarning').fadeIn(300);
		}, true);

		store.pub('initFareFamily', {
			containerId: 'fareFamilyContainer',
			params: $.extend({ bookPageVer: readCookie('xjsx-dislike') === 'true' ? 101 : 100 }, this.params),
			paxInfo: this.paxInfo,
			currentBrandIndex: this.currentFareFamilyBrand && this.currentFareFamilyBrand.currentKey === this.params.fareKey && this.isFareWasChoosen ? this.currentFareFamilyBrand.fare.index : 0
		});

		store.sub('fareFamilyChangeFare', function (fare) {
			try {
				if (!fare) {
					return false;
				}

				self.isFareWasChoosen = true;

				tw.oResult.hideTariffTooltip = !!fare.index;
				self.currentFareFamilyBrand = {
					fare: fare,
					currentKey: store.get('fareFamilyCurrentKey')
				};

				var $tripcoins = $('#popup_passengerSelect .tripcoins_info');
				if ($tripcoins.length) {
					var $item = $.tmplItem($tripcoins);
					$item.data = fare;
					$item.update();
				}

				//сбрасываем правила возврата и обмена
				self.fare.fareRulesFull = null;

				self.setPrices();
				// self.setAmount();

				self.updateTripcoins();
			} catch (err) {
				console.warn(err);
			}
		});
	}
};

PassengerSelect.prototype.updateTripcoins = function() {
	var fare = (this.currentFareFamilyBrand && this.currentFareFamilyBrand.fare) || this.fare;
	var paxInfo = this.paxInfo;

	var tripcoins =
		paxInfo.adtCount * fare.adtTripcoins +
		paxInfo.cnnCount * fare.cnnTripcoins +
		paxInfo.infCount * fare.infTripcoins;

	var tripcoinsItem = $.tmplItem($('.tripcoins_info', this.elForm));
	if (tripcoinsItem && tripcoinsItem.update) {
		tripcoinsItem.data = $.extend({}, fare, {
			tripcoins: tripcoins
		});
		tripcoinsItem.update();
	}
};

PassengerSelect.prototype.addBenefits = function() {
	if(tw.language.indexOf('ru') === -1) {
		return;
	}
	this.removeBenefits();
	var msgs = this.fare.messages;
	var type = 0;
	for(var i=0, l = msgs.length; i<l; i++) {
		var curmsg = msgs[i];
		if(curmsg.msg === "USP_BEFORE_RU") {
			type = 1;
			break;
		}
		if(curmsg.msg === "USP_3USP_RU") {
			type = 2;
			break;
		}
	}
	if(type) {
		$.tmpl(tmpl_Benefits, {variant: type}).appendTo( this.elBlock);
	}
};
PassengerSelect.prototype.removeBenefits = function() {
	$('.benefits', this.elBlock).remove();
};

PassengerSelect.prototype.isCanDeleteCookie = function () {
	return (objSocialAuth && objSocialAuth.checkAuthorized()) && !this.isHotelsTabOpened;
};

PassengerSelect.prototype.fieldsPreset = function(){
	if (this.isCanDeleteCookie()) {
		deleteCookie({
			name: "passengerConfirm"
		});
	}
	var cookiedPassengers = this.getCookiePassengers();
	var ageType = this.data.params.passengerCount.split(',');
	for(var pi=0, pl = ageType.length; pi < pl; pi++) {
		var pasCount = parseInt(ageType[pi],10);
		var curType = "ADT";
		if(pi==1) curType = "CNN";
		if(pi==2) curType = "INF";
		switch(curType) {
			case "ADT":
				this.paxInfo.adtCount = pasCount;
				break;
			case "CNN":
				this.paxInfo.cnnCount = pasCount;
				break;
			case "INF":
				this.paxInfo.infCount = pasCount;
				break;
			default:
				break;
		}

		for(var type_i=0, type_l = pasCount; type_i < type_l; type_i++) {
			this.addPassenger(curType);
			if (cookiedPassengers[curType].length > 0) {
				//Есть еще данные из кук
				cookiedPassengers[curType].reverse();
				var passengersInfo = cookiedPassengers[curType].pop();

				var row = $('tr',this.$table[0]);
				var rowCount = row.length;

				row = row[rowCount - 1];

				if (passengersInfo.length > 3 && passengersInfo[1] != '' && passengersInfo[2] != '' && passengersInfo[3] != '') {
					row.ageType = passengersInfo[0];
					row.fields.lastName.input.value = passengersInfo[1];
					row.fields.lastName.update();
					row.fields.firstName.input.value = passengersInfo[2];
					row.fields.firstName.update();
					row.fields.birthDate.input.value = passengersInfo[3];
					row.fields.birthDate.update();
					if (this.needPassport && passengersInfo[4]) {
						row.fields.passNumber.input.value = passengersInfo[4];
						row.fields.passNumber.update();
						if (!this.fare.childPrices && this.fare.gdsType === "R" && row.ageType !== "ADT") {
							this.getChildrenPrices();
						}
					}
				}
			}
		}
	}
	//плашка на изменение количества пассажиров
	if (this.counter >= tw.passengers.maxPassengers) {
		$('.noticeAddPassanger').addClass("disabled");
	}
};

PassengerSelect.prototype.getCookiePassengers = function(){
	var result = {
		'ADT': [],
		'CNN': [],
		'INF': []
	};
	this.CookiedPassengers = readCookie('passengerConfirm');
	if (this.CookiedPassengers && this.CookiedPassengers != '') {
		var passengersData = this.CookiedPassengers.split(';');
		for (var CookiedIndex = 0, CookiedLength = passengersData.length; CookiedIndex < CookiedLength; CookiedIndex++) {
			if (passengersData[CookiedIndex]) {
				var passengersInfo = passengersData[CookiedIndex].split(',');
				result[passengersInfo[0]].push(passengersInfo);
			}
		}
	}
	return result;
};
PassengerSelect.prototype.defineElements = function(){
	var self = this;
	this.$minus = $(".minus", this.elForm);
	this.$count = $(".count", this.elForm)[0];
	this.$plus = $(".plus", this.elForm);
	this.$priceInf = $(".priceInf", this.elForm);
	this.$table = $("td.fields>table", this.elForm);

	this.$minus.click( function(event){
		if( self.$table[0].tBodies[0].rows.length <2 ) {
			return;
		}
		self.removePassenger(0);
		self.setCookiedPassengers();
		$('.hint').remove();
	});
	$(this.$plus).click( function(event){
		if (!$(this).hasClass("disabled")) {
			self.addPassenger();
		}
	});
};
PassengerSelect.prototype.setFooter = function(){
	var self = this;
	$('.innerContent .footer', this.elForm).remove();
	$('.innerContent .freeze', this.elForm).remove();
	if(this.priceFreeze) {
		$('.innerContent', this.elForm).addClass('freezeContent');
		$('.innerContent', this.elForm).append( $.tmpl(tmpl_FreezeFooter) );
		$('#freezeButton', this.elForm).on('click', function(){
			self.selectFreeze = true;
			$(self.elForm).submit();
		});
	} else {
		$('.innerContent', this.elForm).removeClass('freezeContent');
		$('.innerContent', this.elForm).append( $.tmpl(tmpl_PriceFooter, this.data) );
	}
	this.initPromo();
};
PassengerSelect.prototype.setFreezeAmount = function(){
	$('#freezePay', this.elForm).html(' <b>' +formatMoney(this.priceFreeze.total) + ' ' + l10n.currency[tw.currency].Symbol + "</b>" + l10n.searchResult.passengers.freeze.buy[0]);
};
PassengerSelect.prototype.initBonusPocket = function(){
	var self = this;
	this.bonusPocket = $('.bonusPocket', this.elForm)[0];
	$(this.bonusPocket).removeClass('invisible');

	var elBonuses = $(".bonuses", this.bonusPocket)[0];
	var elBonusesIn = $(".bonusesIn", this.bonusPocket)[0];
	$(elBonuses).empty();
	$(elBonusesIn).empty();
	if(this.fare.noBonus && tw.provider){
		elBonusesIn.innerHTML = l10n.makeorder.bonus.cantUseBonuses;
	} else {
		elBonusesIn.innerHTML = l10n.makeorder.bonus.text[0];
	}
	$(elBonusesIn).append(' <span class="bonusAmount"></span>');

	var bonusDescription = l10n.makeorder.bonus.about;
	if (tw.provider) {
		if(tw.oResult.obj.json.metaSearch && tw.oResult.obj.json.metaSearch == 'aviasales'){
			$(elBonusesIn).addClass('invisible');
		}
		var bonusAmount = Math.ceil(tw.bonus.total);
		var bonusText = formatMoney(bonusAmount);
		elBonuses.innerHTML = l10n.makeorder.bonus.balance + bonusText + ' ≈ ';
		if (tw.bonus.currency != 'RUB') {
			bonusText = formatMoney(tw.bonus.total.toFixed(2));
		}
		elBonuses.innerHTML += bonusText + ' ' + l10n.currency[tw.bonus.currency].Abbr;
		//elBonuses.innerHTML += '<br/>' + bonusDescription;
		if(!tw.oResult.obj.json.metaSearch){
			$('<div class="useBonuses">'+l10n.searchResult.passengers.useBonuses+'</div>').insertAfter(elBonuses);
		}
	} else if(tw.oResult.obj.json.metaSearch){
		//WelcomeBonusText(elBonuses);
		elBonuses.innerHTML += l10n.makeorder.bonus.auth + ' ' + bonusDescription;
		$("span.link", elBonuses).click(function(){
			objSocialAuth.show(objSocialAuth.regauthForm);
		});
	} else {
		//WelcomeBonusText(elBonuses);
		elBonuses.innerHTML +=  bonusDescription;
		/*elBonuses.innerHTML = l10n.makeorder.bonus.auth + ' ' + bonusDescription;
		 $("span.link[id!='bonusDescription']", elBonuses).click(function(){
		 objSocialAuth.show(objSocialAuth.regauthForm);
		 });*/
	}
	this.bonusAmount = $('.bonusAmount', this.bonusPocket)[0];
	this.refreshPromo();
};
PassengerSelect.prototype.refreshBonusPocket = function(price){
	if(!this.bonusPocket) return;

	var money = parseFloat(price*0.01, 10);
	var num = price;
	/*if(tw.currency != 'RUB') {
	 num = convertCurrency(price, tw.currency, 'RUB');
	 money = money.toFixed(2);
	 }*/
	if(tw.bonus.currency != tw.currency) {
		num = convertCurrency(price, tw.currency, tw.bonus.currency);
		money = convertCurrency(money, tw.currency, tw.bonus.currency);
	}
	money = parseFloat(money,10);
	money = (tw.bonus.currency == "RUB" || tw.bonus.currency == "UAH")?Math.ceil(money):money.toFixed(2);
	num = (tw.bonus.currency == "RUB" || tw.bonus.currency == "UAH")?Math.ceil(num*0.01):(num*0.01).toFixed(2);
	num+='';
	var text = "";
	if(num.length==1) {
		num = "0"+num;
	}
	var last = parseInt( num.substr(num.length-1,1), 10);
	var prelast = parseInt( num.substr(num.length-2,1), 10);
	if (last == 1) {
		text = l10n.makeorder.bonus.text[1];
	} else if (0 < last && last < 5) {
		text = l10n.makeorder.bonus.text[2];
	} else {
		text = l10n.makeorder.bonus.text[3];
	}
	if (prelast == 1) {
		text = l10n.makeorder.bonus.text[3];
	}
	num = parseFloat( num );
	num = (tw.bonus.currency == "RUB" || tw.bonus.currency == "UAH")?formatMoney(num):formatMoney(num);
	$(this.bonusAmount).html(num +' ' + text + ' ≈ ' + formatMoney(money) +' ' + l10n.currency[tw.bonus.currency].Abbr);
};
PassengerSelect.prototype.setFlightInformation = function(){
	var self = this;
	$(this.elFlightInfo).html( $.tmpl(tmpl_FlightInformation, {Flight: this.Flight}) );
	if(fareRulesList[this.params.fareKeyRT]) {
		this.fareRulesFull = fareRulesList[this.params.fareKeyRT];
	} else if(fareRulesList[this.params.fareKey]) {
		this.fareRulesFull = fareRulesList[this.params.fareKey];
	} else {
		this.fareRulesFull = null;
	}
	$('.showFareRules', this.elForm).click(function(){
		var oData = {
			trips: self.params.trips,
			gdsInfo: self.params.gdsInfo,
			fareKey: self.params.fareKey
		};
		//если выбран тариф заменяем fic и fareKey
		if (self.currentFareFamilyBrand) {
			oData.trips.map(function (trip, idx) {
				trip.fic = self.currentFareFamilyBrand.fare.trips[idx].fic;
			});
			oData.fareKey = self.currentFareFamilyBrand.currentKey;
		}
		if(self.params.fareKeyRT) {
			oData.fareKeyRT = self.params.fareKeyRT;
		}
		showFareRules({
			url: "/_api/confirmation/getfarerules/",
			data: {
				params: JSON.stringify(oData)
			},
			obj: self.fare
		});
	});
};
PassengerSelect.prototype.show = function(data){
	var self = this;
	if (this.needUserInfo && !this.progressUserInfo) {
		this.getUserInfo();
	}

	$("html,body").animate({scrollTop: 0});
	removeInfoBaloon();
	this.setInformation(data);
	this.setBody();
	this.draw();
	$('.noticeAddPassenger .openSearch').click(function(event){
		self.showSearchFormAndScroll(event);
		event.preventDefault();
	});
	if (this.isHotelsTabOpened) {
		this.submitForm();
		setTimeout(function () {
			$('#layout_body').show();
		}, 600);
		this.isHotelsTabOpened = false;
	}
};
PassengerSelect.prototype.setInformation = function(infoData){
	var passengerSelect = this;
	if (infoData) {

		this.data = infoData;
		this.params = this.data.params;
		this.fare = this.data.fare;
		//for showing title currency bonus
		this.data.fare.needTripcoinsTitle = true;
		this.priceFreeze = (tw.language == "ru") ? this.fare.priceFreeze || false : false;
	}
	this.counter = 0;
	//for dirrections
	this.setDirections();
	//for count passengers
	this.data.params.passengerCount = tw.passengers.getStrCountPassenger();
	//for direction info
	this.setFlightInformationData();

	this.uaWarn = false;

	var gdsType = this.fare.gdsType;
	this.isSirena = (gdsType === "S");
	this.isSig = (gdsType === "R");
	this.needPassport = (this.isSirena || this.isSig);
	var messages = this.fare.messages;
	var cd;
	for(var i in messages) {
		cd = messages[i].cd;
		if(cd === "REDIRECT_SHOW_TOTAL_BOOKING") {
			this.firstViewTotal = true;
		} else
		if(cd === "SHOW_UA_WARN_RUS_BF") {
			this.uaWarn = true;
		} else
		if(cd === "SHOW_UMRAH_VISA_WARN") {
			this.umrahVisaWarn = true;
		} else
		if(cd === "REQUIRE_MIDDLE_NAME") {
			this.needMiddleName = true;
		} else
		if(cd === "PASSNUM_NOT_REQUIRED") {
			this.mustHidePassportNumber = true;
		}
		if(cd === "DISPLAY_PASSPORT_NUMBER_FIELD_ON_SEARCH") {
			this.needPassport = true;
		}
	}

	//kmqStats
	var routeKey = this.data.params.routeKey;
	var today = new Date();
	var startDate = Date.parseAPI(routeKey.substring(0,4));
	var DepthSearch = parseInt( Math.floor( (startDate.valueOf() - today.valueOf())/(86400000) ), 10);
	var StartMonth = startDate.getMonth()+1;
	var Duration = 0;
	if(routeKey.length == 14) {
		var endDate = Date.parseAPI(routeKey.substring(10,14));
		Duration = parseInt( Math.floor( (endDate.valueOf() - startDate.valueOf() )/(86400000) ), 10);
	}
	var pointFrom = routeKey.substring(4,7);
	var pointTo = routeKey.substring(7,10);
	var countryFrom = ref.getCountryCode(pointFrom);
	var cityFrom = ref.getCityCode(pointFrom);
	var countryTo = ref.getCountryCode(pointTo);
	var cityTo = ref.getCityCode(pointTo);
	var FlightType = (countryFrom==countryTo)?'DOM':'INT';
	this.kmqFlight = {
		"DepthSearch": DepthSearch,
		"StartMonth": StartMonth,
		"cityFrom": cityFrom,
		"countryFrom": countryFrom,
		"cityTo": cityTo,
		"countryTo": countryTo,
		"TypeRoute": kmqRouteType(routeKey),
		"FlightType": FlightType,
		"Duration": Duration,
		"GDS": this.fare.gdsType,
		"type": this.params.kmqSelection,
		"Segments": this.params.Segments,
		"Stops": this.params.Stops,
		"Country Agent": this.fare.agCnt,
		"Plating Carrier": this.fare.pltCrr,
		"Operating Carrier": String(this.params.Operating),
		"Marketing Carrier": String(this.params.Marketing),
		"Booking Class": String(this.params.BookingClass),
		"PriceRUB": Math.ceil(convertCurrency(this.fare.amt, this.fare.cur, "RUB")),
		"PriceUSD": Math.ceil(convertCurrency(this.fare.amt, this.fare.cur, "USD")),
		"PriceEUR": Math.ceil(convertCurrency(this.fare.amt, this.fare.cur, "EUR"))
	};
	if(tw.source && tw.source.tag){
		this.kmqFlight.type = 'meta_select';
	}
	$(document).trigger({
		"type": "selectFare",
		"searchRoute": routeKey,
		"selectedFlight": this.kmqFlight
	});
};
PassengerSelect.prototype.draw = function(){
	var self = this;

	this.$priceInf[0].innerHTML = " ";
	this.$priceInf[1].innerHTML = " ";
	this.$priceInf[2].innerHTML = " ";
	/*	if (this.fare.gdsType === "R") { //если Сирена типа R мы делаем запрос при вводе даты рождения
	 makeChildrenResponse = false;
	 }
	 if (tw.params.utm_source && tw.params.utm_source === "yandex" && this.data.params.passengerCount) {
	 var pasArray = this.data.params.passengerCount.split(',');
	 if ( (parseInt(pasArray[1]||0,10) + parseInt(pasArray[2]||0,10)) > 0) {
	 makeChildrenResponse = true; //if Yandex meta & noAdult > 1
	 }
	 }*/

	if(!this.fare.childPrices){
		this.getChildrenPrices();
	}
	this.setCharterWarn();
	this.setFlightInformation();
	this.setTimeSpent();
	this.setFooter();
	this.setPrices();
	this.addBenefits();

	var resultShowBlock = tw.oResult.ResultTable;
	if(tw.oResult.isAKVisible) {
		resultShowBlock = tw.oResult.AKFlightInformation;
	}
	this.inProcess = true;

	fadeOutBlock($('.FlightPriceInformation'));
	fadeOutBlock(resultShowBlock, function(){
		fadeInBlock(self.elBlock, function(){
			self.visible = true;
			self.inProcess = false;
		});
		self.initAdButlerBanners();
	});
	objSearchForm.hide(function(){
		self.setPageTitle();
	});
	objRecentSearches.hide();

	var flightHasMetaReturn;

	try {
		flightHasMetaReturn = this.Flight.sourceFare.infMsgs.some(function(message) {
			return message.msg === 'REDIRECTING_SS';
		});
	} catch (err) {
		console.log('MTR Msg problem:', err);
	}

	if (tw.metaReturn) {
		if (flightHasMetaReturn || window.hasFakeRedirectingSS) {
			tw.metaReturn.redirectForCurrentFlight = true;
			tw.metaReturn.addBannerByTimer();
		} else {
			tw.metaReturn.redirectForCurrentFlight = null;
		}
	}



};

PassengerSelect.prototype.showAppBanner = function() {
	var searchResultsMessages = tw.oResult.obj.json.searchResultMessages || {};
	var hasAppBanner1 = searchResultsMessages.TRY_MOB_APP_1;
	var hasAppBanner2 = searchResultsMessages.TRY_MOB_APP_2;

	if (hasAppBanner1 || hasAppBanner2) {
		var bannerContainer = $('#passengerSelectAppBanner');
		var template = $('#tmpl_TryApp');

		var size = 0;
		var data = {};

		if (this.needMiddleName) {
			size = this.needPassport ? 900 : 800;
		} else {
			size = this.needPassport ? 820 : 720;
		}

		var bannerType = (hasAppBanner1) ? 1 : (hasAppBanner2 ? 2 : false);

		if (bannerType) {
			data = {
				type: 'banner' + bannerType,
				src: '/images/passengerselect/app/app_' + bannerType + '_' + size + '.png',
			};

			bannerContainer.empty().html($.tmpl(template, data));
		}
	}
};

PassengerSelect.prototype.setDirections = function(){
	var arrDirections = [];
	var direction = {
		trips: []
	};
	for (var i = 0, length = this.params.trips.length; i < length; i++) {
		var trip = this.params.trips[i];

		trip.oStartDate = new Date.parseAPI(trip.stDt).setAPITime(trip.stTm);
		var tempEndDate= new Date(trip.oStartDate);
		if(trip.dayChg) {
			tempEndDate.setDate(tempEndDate.getDate() + trip.dayChg);
		}
		trip.oEndDate = tempEndDate.setAPITime(trip.endTm);
		direction.trips.push(trip);
		if (!trip.conx) {
			arrDirections.push(direction);
			direction = direction = {
				trips: []
			};
		}
	}
	for ( var di = 0, dl = arrDirections.length; di < dl; di++) {
		arrDirections[di].startDate = arrDirections[di].trips[0].oStartDate;
		arrDirections[di].from = arrDirections[di].trips[0].from;
		arrDirections[di].to = arrDirections[di].trips[ arrDirections[di].trips.length-1 ].to;
	}
	this.arrDirections = arrDirections;
};
PassengerSelect.prototype.moveButtonNewSearch = function(){
	var formNode= $('#popup_passengerSelect form')
	var posRightSideForm = formNode.innerWidth() + formNode.offset().left;
	var titleNode = $('#pageTitlePanel');
	var posRightSideTitle = titleNode.outerWidth(true) / 2 + titleNode.innerWidth() / 2;
	fadeInBlock($('#topPanel2 .button.changeSearch').get()[0]);
};
PassengerSelect.prototype.setFlightInformationData = function(){
	var self = this;
	this.Flight = $.extend(true,{},tw.oResult.DefaultAllFlights[self.params.FlightIndex]);
	if(!this.Flight.html_tmpl) {
		tw.oResult.addTemplateInformation(this.Flight);
	}
	this.Flight.flightLate = [];
	for(var i =0, l = this.Flight.TripIds.length; i< l; i++){
		this.Flight.flightLate.push( tw.oResult.MakeOnTimeDirectionInfo(this.Flight,i) );
	}
};
PassengerSelect.prototype.setPageTitle = function(){
	$('#pageTitle', this.elPageTitlePanel)[0].innerHTML = l10n.searchResult.passengers.pageTitle;
	this.setPageButtons();
	var self = this;
	fadeInBlock(this.elPageTitlePanel, function(){
		self.moveButtonNewSearch();
	});
	window.scrollTo(0, 0);
};
PassengerSelect.prototype.showSearchForm = function (showChooserPassanger) {
	fadeOutBlock(this.elPageTitlePanel, function(){
		objSearchForm.show(false);
		objSearchForm.checkCountPassengers();
		if (showChooserPassanger) objSearchForm.chooserPassengers.show();
	});
};
PassengerSelect.prototype.setPageButtons = function(){
	var self = this;
	$(".button", this.elPageTitlePanel).remove();
	$.tmpl(tmpl_topPanel2Button, {
		title: l10n.searchResult.passengers.backButton,
		className: "back"
	}).click(function(){
		self.hideBack();
	}).appendTo(this.elPageTitlePanel);
	$.tmpl(tmpl_topPanel2Button, {
		title: l10n.searchResult.passengers.newSearch,
		className: "changeSearch"
	}).click(function(){
		self.showSearchForm(false);
	}).appendTo(this.elPageTitlePanel);
};
PassengerSelect.prototype.hideBack = function(){
	var self = this;
	tw.metaReturn && tw.metaReturn.reset();
	this.inProcess = true;

	if (typeof store !== 'undefined') {
		store.pub('fareFamilyChangeFare', false);
		this.isFareWasChoosen = false;
	}

	$('.hint').remove();
	if(this.searchxhr) {
		this.searchxhr.abort();
		this.searchxhr = null;
	}

	var resultShowBlock = tw.oResult.ResultTable;
	if(tw.oResult.isAKVisible) {
		resultShowBlock = tw.oResult.AKFlightInformation;
		//при выборе перелёта и закрытии окна бронирования - убираем из хеша номер рейса и всё остальное
		window.location.hash = window.location.hash.split('|').slice(0,3).join('|');
	} else {
		delete tw.source;
		window.location.hash = window.location.hash.split('|')[0];
	}
	fadeOutBlock(this.elBlock, function(){
		if(self.params.fareKeyRT) {
			fareRulesList[self.params.fareKeyRT] = self.fareRulesFull;
		} else {
			fareRulesList[self.params.fareKey] = self.fareRulesFull;
		}
		fadeInBlock(resultShowBlock);
		fadeInBlock($('.FlightPriceInformation'));
		$('.hint').remove();
		self.visible = false;
		self.inProcess = false;

		$(self.elBlock).find('.FreeCancelPurchaseBanner').remove();
	});
	fadeOutBlock(this.elPageTitlePanel, function(){
		objSearchForm.show( objSearchForm.data.flightType !== 'oneway' );
	});

};
PassengerSelect.prototype.hide = function(){
	var self = this;

	$('.hint').remove();
	tw.metaReturn && tw.metaReturn.reset();
	fadeOutBlock(this.elBlock, function(){
		self.visible = false;
		$(self.elBlock).find('.FreeCancelPurchaseBanner').remove();
	});
	fadeOutBlock($('#topPanel2 .button.changeSearch').get()[0]);
};
PassengerSelect.prototype.addPassenger = function(ageType){
	this.addRow(ageType);
	this.checkPassengersCount();
};
PassengerSelect.prototype.removePassenger = function(){
	var tablePassengers =  this.$table[0].tBodies[0].rows;
	//изменяем количество пассажиров определенного типа и удаляем строку из таблицы
	this.changePaxInfo( this.removeRow() , -1);
	//поправляем цену
	this.setTotal();
	//url правим
	this.checkPassengersCount();
};
PassengerSelect.prototype.analyzeFlight = function(){
	this.foreignName = false;
	var countries = {RU:1,UA:1}
	for(var i = 0, length = this.params.trips.length; i < length; i++){
		var trip = this.params.trips[i];
		if(!countries[ ref.getCountryCode(trip.from) ] || !countries[ ref.getCountryCode(trip.to) ]){
			this.foreignName = true;
			break;
		}
	}
};
PassengerSelect.prototype.addRow = function(ageType){
	var self =this;
	var ageType = ageType || "UND";
	var table = this.$table[0];
	var row = table.tBodies[0].insertRow(-1);
	row.ageType = ageType;
	row.fields = {};

	if(tw.language == "en-ie" || tw.language == "en-gb" || tw.language == "tr") {
		var td3 = row.insertCell(-1);
		var td2 = row.insertCell(-1);
	} else {
		var td2 = row.insertCell(-1);
		var td3 = row.insertCell(-1);
	}
	row.fields.lastName = new Field({
		appendTo: td2,
		name: "lastName" + this.counter,
		value: this.passengers[this.counter] ? this.passengers[this.counter].lastName : "",
		type: "name1"
	});

	row.fields.lastName.input.row = row;
	row.fields.firstName = new Field({
		appendTo: td3,
		name: "firstName" + this.counter,
		value: this.passengers[this.counter] ? this.passengers[this.counter].firstName : "",
		type: "name1"
	});
	row.fields.firstName.input.row = row;

	/*	if(this.needMiddleName) {
	 var td4 = row.insertCell(-1);
	 row.fields.middleName = new Field({
	 appendTo: td4,
	 name: "middleName" + this.counter,
	 value: "",
	 type: "name1"
	 });
	 row.fields.middleName.input.row = row;
	 }*/

	var td5 = row.insertCell(-1);
	var lastDir = this.arrDirections[this.arrDirections.length - 1];
	var lastDirFirstTrip = lastDir.trips[0];
	var lastDirLastTrip = lastDir.trips[lastDir.trips.length -1];
	var min = null;
	var max = null;
	/*var lastDirFirstTripDate = Date.parseAPI(lastDirFirstTrip.stDt);
	 var lastDirLastTripDate = Date.parseAPI(lastDirLastTrip.stDt);
	 switch (row.ageType) {
	 case "ADT":
	 min = new Date();
	 min.setFullYear(min.getFullYear() - 110);
	 max = new Date(lastDirFirstTripDate);
	 max.setFullYear(max.getFullYear() - 12);
	 break;
	 case "CNN":
	 min = new Date(lastDirFirstTripDate);
	 min.setFullYear(min.getFullYear() - 12);
	 max = new Date(lastDirFirstTripDate);
	 max.setFullYear(max.getFullYear() - 2);
	 break;
	 case "INF":
	 min = new Date(lastDirFirstTripDate);
	 min.setFullYear(min.getFullYear() - 2);
	 max = new Date();
	 break;
	 }*/
	min = new Date();
	min.setFullYear(min.getFullYear() - 110);
	max = new Date();
	row.fields.birthDate = new Field({
		appendTo: td5,
		name: "birthDate" + this.counter,
		value: '',
		type: "birthDate",
		min: min,
		max: max
	});
	row.fields.birthDate.input.row = row;

	if(this.needPassport) {
		var td6 = row.insertCell(-1);
		row.fields.passNumber = new Field({
			appendTo: td6,
			name: "passNumber" + this.counter,
			value: "",
			type: "passport"
		});
		row.fields.passNumber.input.row = row;
	}

	this.$count.innerHTML = ++this.counter;

	$(row.fields.lastName.input).blur(function(){
		self.setCookiedPassengers();
	});
	$(row.fields.firstName.input).blur(function(){
		self.setCookiedPassengers();
	});
	$(row.fields.birthDate.input).on("keyup", function(e){
		var charCode = e.charCode || e.keyCode;
		var charCodeStr = String.fromCharCode(charCode);
		if(this.value.indexOf('_') == -1 && (charCode > 95 && charCode < 106 || /\d/.test(charCodeStr) )) {
			row.fields.birthDate.update();
		}
	});

	$(row.fields.birthDate.input).blur(function(event){
		setTimeout(function(){
			self.checkBirthField(row, event);
			if (!self.fare.childPrices && self.fare.gdsType === "R" && row.ageType !== "ADT") {
				self.getChildrenPrices();
			}
		},10);
	});
	if(this.needPassport) {
		$(row.fields.passNumber.input).blur(function(){
			setTimeout(function(){
				self.setCookiedPassengers();
			},10);
		});
		/*$(row.fields.passExpDate.input).blur(function(){
		 setTimeout(function(){
		 self.setCookiedPassengers();
		 },10);
		 });*/
	}
	this.setPlaceholder(row);
	$(table).removeClass("invisible");
};
PassengerSelect.prototype.checkBirthField = function (row, event) {
	if (row.fields.errorRow) {
		row.parentNode.removeChild(row.fields.errorRow);
		row.fields.errorRow = null;
	}
	if (row.fields.birthDate.value) {
		if (row.ageType === 'UND') {
			//пока полю не присвоен тип
			this.writeAgeType(row);
			this.setPlaceholder(row);
			this.changePaxInfo(row.ageType, 1);
			this.checkPassengersCount();
			this.setTotal();
			this.setCookiedPassengers();
		} else {
			if (row.ageType != this.getAgeType(row)) {
				//в поле ошибка с датой рождения
				$(row.fields.birthDate.elField).addClass('error');
				this.addPassengerError(row);
			} else {
				//все заполнено правильно
				this.setCookiedPassengers();
			}
		}
	}
};
PassengerSelect.prototype.addPassengerError = function (row) {
	var age = this.getAge(row);

	var localizationAge = l10n.searchResult.passengers.age;
	row.fields.errorRow = $.tmpl($('#tmpl_errorTr').trim(), {
		"count": (this.needPassport ? 4 : 3),
		"age": age ? age + " " + declOfNum(age, localizationAge) : localizationAge[3],
	})[0];
	$(row).after(row.fields.errorRow);

	var self = this;
	$('.openSearch', row.fields.errorRow).click(function (event){
		self.showSearchFormAndScroll(event);
		event.preventDefault();
	});
};
PassengerSelect.prototype.changePaxInfo = function (ageType, changeValue) {
	switch(ageType) {
		case "ADT":
			this.paxInfo.adtCount += changeValue;
			break;
		case "CNN":
			this.paxInfo.cnnCount += changeValue;
			break;
		case "INF":
			this.paxInfo.infCount += changeValue;
			break;
		default:
			break;
	}

	this.updateTripcoins();
};
PassengerSelect.prototype.setPlaceholder = function (row) {
	//set placeholders for inputs
	var localization = l10n.searchResult.passengers;
	var name = this.needMiddleName
		? localization.table.newHeader.Fullname
		: localization.table2[row.ageType]["Name"];

	$(row.fields.lastName.input).attr('placeholder', localization.table2[row.ageType]["Surname"]);
	$(row.fields.firstName.input).attr('placeholder', name);
	$(row.fields.birthDate.input).attr('placeholder', localization.table.newHeader.Birthday);
	if (this.needPassport) {
		$(row.fields.passNumber.input).attr('placeholder', localization.table.newHeader.Document);
	}
	this.placeholderForIE(row.fields, true);
};
PassengerSelect.prototype.placeholderForIE = function (fields, isSet) {
	//for IE9
	if (window.Placeholders) {
		fields = fields || this.fields;

		//определяем что будем делать: ставить или удалять
		var action = 'disable';
		if (isSet) {
			action = 'enable'
		}
		//действие
		Placeholders[action](fields.lastName.input, fields.firstName.input, fields.birthDate.input);
		if (this.needPassport) {
			Placeholders[action](fields.passNumber.input);
		}
	}
};

PassengerSelect.prototype.showSearchFormAndScroll = function (event) {
	this.showSearchForm(true);
	$(document).scrollTop( $('#layout_panels').offset().top );
	event.stopPropagation();
};
PassengerSelect.prototype.getAge = function(row) {
	var self = this;
	var trip = this.arrDirections[this.arrDirections.length - 1].trips[0];
	var birthDay = row.fields.birthDate.value;
	var lastDirFirstTripDate = Date.parseAPI(trip.stDt).setAPITime(trip.stTm);
	var ageDifMs = new Date(lastDirFirstTripDate) - new Date(birthDay);
	var ageDate = new Date(ageDifMs);
	return Math.ceil(ageDate.getUTCFullYear() - 1970);
};
PassengerSelect.prototype.getAgeType = function(row) {
	var self = this;
	var trip = this.arrDirections[this.arrDirections.length - 1].trips[0];
	var birthDay = row.fields.birthDate.value;

	var lastDirFirstTripDate = Date.parseAPI(trip.stDt).setAPITime(trip.stTm);
	var date12ago = new Date(lastDirFirstTripDate);
	date12ago.setFullYear(date12ago.getFullYear() - 12);
	var date2ago = new Date(lastDirFirstTripDate);
	date2ago.setFullYear(date2ago.getFullYear() - 2);
	if (birthDay <= date12ago) {
		return "ADT";
	} else if(date12ago < birthDay && birthDay <= date2ago){
		return "CNN";
	} else if(date2ago < birthDay) {
		return "INF";
	}
};
PassengerSelect.prototype.writeAgeType = function(row){
	row.ageType = this.getAgeType(row);
};
PassengerSelect.prototype.setCookiedPassengers = function(forceSave){
	var self = this;
	//функция вызывается по blur
	//а нам нужно новое обработанное и верифицированное значение поля
	//т е нужно поймать его после выполнения следующих обработчиков
	//если без setTimeout будет терятся последнее изменение

	var savePassengers = function () {
		if (self.isCanDeleteCookie() && !forceSave) {
			return;
		}
		self.CookiedPassengers = '';

		for (var j = 0, RJ = self.$table[0].tBodies[0].rows.length; j < RJ; j++) {
			var row = self.$table[0].tBodies[0].rows[j];
			if (row.ageType && row.fields.lastName.value && row.fields.firstName.value && row.fields.birthDate.value && !$(row.fields.birthDate.elField).hasClass('error')) {
				self.CookiedPassengers += row.ageType + ',' + row.fields.lastName.value + ',' + row.fields.firstName.value + ',' + row.fields.birthDate.value.format('dd.mm.yyyy');
				if (self.needPassport && row.fields.passNumber.value) {
					self.CookiedPassengers += ',' + row.fields.passNumber.value;
					/*if(row.fields.passExpDate.value){
					 self.CookiedPassengers+= ','+row.fields.passExpDate.value.format('dd.mm.yyyy');
					 }*/
				}
				self.CookiedPassengers += ';';
			}
		}
		setCookie({
			name: "passengerConfirm",
			value: self.CookiedPassengers,
			days: 0.022
		});
	};

	if (forceSave) {
		savePassengers();
	} else {
		setTimeout(savePassengers, 10);
	}
};
PassengerSelect.prototype.removeRow = function(){
	var ageType;
	var table = this.$table[0].tBodies[0];
	//если осталось только одно поле с обишкой или без
	if ((table.rows.length < 2) ||
		( $(table.rows[table.rows.length-1]).hasClass("errorTr") && table.rows.length < 3)) {
		return;
	}
	//если в последнем поле есть ошибка
	if ( $(table.rows[table.rows.length-1]).hasClass("errorTr") ) {
		table.deleteRow(-1);
	}
	ageType = table.rows[table.rows.length-1].ageType;
	table.deleteRow(-1);
	this.$count.innerHTML = --this.counter;
	return ageType;
};
PassengerSelect.prototype.checkPassengersCount = function(){
	/*
	//вылючил из-за того что
	//если включено нужно делать на выдаче рейсов дополнительный запрос
	//потому что суммарная цена берется из запроса
	var strCountsPassengers = this.paxInfo.adtCount + ',' + this.paxInfo.cnnCount + ',' + this.paxInfo.infCount;
	window.replaceLocation({
		hash: document.location.hash,
		url: document.location.pathname + "?pas=" + strCountsPassengers
	});
	*/
	var seatsCount = this.counter//this.$table[0].tBodies[0].rows.length;// + this.$table[1].tBodies[0].rows.length;
	if (seatsCount < 9) {
		$(this.$plus[0]).removeClass("disabled");
	} else {
		$(this.$plus[0]).addClass("disabled");
	}
	if (seatsCount > 1) {
		$(this.$minus[0]).removeClass("disabled");
	} else {
		$(this.$minus[0]).addClass("disabled");
	}
};
PassengerSelect.prototype.getData = function(){
	var self = this;
	this.passengers = [];
	this.passengersForCheckNames = [];
	$("td.fields>table tbody tr", this.elForm).each(function(i, currentDOMRow){
		if ($(currentDOMRow).hasClass("errorTr")) { return; }
		this.fields.firstName.update();
		this.fields.lastName.update();
		this.fields.birthDate.update();
		if(self.needPassport){
			//this.fields.passExpDate.update();
			this.fields.passNumber.update();
		}
		/*		if(self.needMiddleName) {
		 this.fields.middleName.update();
		 }*/
		if (this.passenger) {
			self.passengers[i] = this.passenger;
			self.passengers[i].id = i;
			self.passengers[i].ageType = this.ageType;
			self.passengers[i].birthDate_Date = this.fields.birthDate.value;
			if (isValidDate(self.passengers[i].birthDate_Date)) {
				self.passengers[i].birthDate = self.passengers[i].birthDate_Date.format("yyyymmdd");
			} else {
				self.passengers[i].birthDate = null;
			}
			if(self.needPassport) {
				self.passengers[i].passNumber = this.fields.passNumber.value;
				/*	if (this.fields.passExpDate.input.disabled) {
				 self.passengers[i].needPassExpDate = false;
				 } else {
				 self.passengers[i].needPassExpDate = true;
				 }
				 self.passengers[i].passExpDate_Date = this.fields.passExpDate.value;
				 if (isValidDate(self.passengers[i].passExpDate_Date)) {
				 self.passengers[i].passExpDate = self.passengers[i].passExpDate_Date.format("yyyymmdd");
				 } else {
				 self.passengers[i].passExpDate = null;
				 }*/
			}
			if(self.needMiddleName) { //перезаписываем имя + отчество у пассажира выбранного с помощью саджеста *remark1
				self.passengers[i].firstName = this.fields.firstName.value;
				//self.passengers[i].middleName = this.fields.middleName.value;
			}
		} else {
			self.passengers[i] = {
				id: i,
				firstName: this.fields.firstName.value,
				lastName: this.fields.lastName.value,
				ageType: this.ageType
			};
			self.passengers[i].birthDate_Date = this.fields.birthDate.value;
			if (isValidDate(self.passengers[i].birthDate_Date)) {
				self.passengers[i].birthDate = self.passengers[i].birthDate_Date.format("yyyymmdd");
			} else {
				self.passengers[i].birthDate = null;
			}
			if(self.needPassport) {
				self.passengers[i].passNumber = this.fields.passNumber.value;
				/*if (this.fields.passExpDate.input.disabled) {
				 self.passengers[i].needPassExpDate = false;
				 } else {
				 self.passengers[i].needPassExpDate = true;
				 }
				 self.passengers[i].passExpDate_Date = this.fields.passExpDate.value;
				 if (isValidDate(self.passengers[i].passExpDate_Date)) {
				 self.passengers[i].passExpDate = self.passengers[i].passExpDate_Date.format("yyyymmdd");
				 } else {
				 self.passengers[i].passExpDate = null;
				 }*/
			}
			/*if(self.needMiddleName) {
			 self.passengers[i].middleName = this.fields.middleName.value;
			 }*/
			self.passengersForCheckNames.push(self.passengers[i]);
		}
	});
	this.params.passengers = this.passengers;
	this.params.email = this.emailField.value;
	if (tw.params.test) {this.params.testGds = true;}
	if (tw.params.srcmarker) {this.params.srcmarker = tw.params.srcmarker;}

	if (this.elForm.promoFlag && this.elForm.promoFlag.checked && !this.Flight.denyPromoCodeUse) {
		this.elForm.promo.field.update();
		this.params.promo = this.elForm.promo.field.value;
	} else {
		delete this.params.promo;
	}
	twdevdisplay(this.params, 'reserv');
};
PassengerSelect.prototype.checkData = function(){
	var self = this;
	var adtCount = cnnCount = infCount = errors = 0;
	var errorField = null;

	if (!this.params.email || this.emailField.error) {
		errors++;
		this.emailField.addError();
		if (!errorField) {
			errorField = this.emailField;
		}
	}
	var $rows = $("tbody tr", this.$table);
	$rows.each(function(i, currentDOMRow){

		if ( $(currentDOMRow).hasClass("errorTr")) { return; }
		var curPfields = this.fields;
		var curPdata = self.params.passengers[i];

		if (!curPdata.lastName || curPfields.lastName.error) {
			errors++;
			curPfields.lastName.addError();
			if (!errorField) {
				errorField = curPfields.lastName;
			}
		}
		if (!curPdata.firstName || curPfields.firstName.error) {
			errors++;
			curPfields.firstName.addError();
			if (!errorField) {
				errorField = curPfields.firstName;
			}
		}
		if (!curPdata.birthDate || curPfields.birthDate.error) {
			errors++;
			curPfields.birthDate.addError();
			if (!errorField) {
				errorField = curPfields.birthDate;
			}
		} else {
			if (this.ageType != self.getAgeType(this)) {
				errors++;
				$(this.fields.birthDate.elField).addClass('error');
				if (!errorField) {
					errorField = curPfields.birthDate;
				}
			}
		}
		if(self.needPassport) {
			if (!curPdata.passNumber || curPfields.passNumber.error) {
				errors++;
				curPfields.passNumber.addError();
				if (!errorField) {
					errorField = curPfields.passNumber;
				}
			}
			/*if (curPdata.needPassExpDate && (!curPdata.passExpDate || curPfields.passExpDate.error)) {
			 errors++;
			 curPfields.passExpDate.addError();
			 if (!errorField) {
			 errorField = curPfields.passExpDate;
			 }
			 }*/
		}
		//проверку на middleName не делаем
		if (this.ageType == "ADT") {
			adtCount++;
		}
		if (this.ageType == "CNN") {
			cnnCount++;
		}
		if (this.ageType == "INF") {
			infCount++;
		}
	});

	var checkPromo = false;
	if (this.elForm.promoFlag && this.elForm.promoFlag.checked && this.params.promo === '') {
		errors++;
		this.elForm.promo.field.addError();
		if (!errorField) {
			errorField = this.elForm.promo.field;
		}
	}

	if(adtCount < infCount && !errors) {
		addPopup({
			error: true,
			close_button: true,
			reason: l10n.searchResult.passengers.popup.toomuchinfants[0],
			comment: l10n.searchResult.passengers.popup.toomuchinfants[1],
			button: l10n.popup.close,
			removeOnAction: true
		});
		return;
	}

	if(!adtCount && cnnCount && !errors) {
		addPopup({
			error: true,
			close_button: true,
			reason: l10n.searchResult.passengers.popup.needAdult[0],
			comment: l10n.searchResult.passengers.popup.needAdult[1],
			button: l10n.popup.close,
			removeOnAction: true
		});
		return;
	}

	if (errors) {
		if(!checkPromo) {
			$("html,body").animate({scrollTop: $(errorField.elField).offset().top - 80},"fast");
			errorField.input.focus();
			kmqRecord({name: 'DE_PassengerFIO'});
			delete this.selectFreeze;
			return false;
		}
	} else {
		$('.hint').remove();
		return true;
	}
};

PassengerSelect.prototype.getConfirmation = function(){
	var self = this;
	if(this.selectFreeze){
		if(tw.currency == "EUR") {
			this.kmqFlight.freezePriceEUR = parseFloat(this.amountToPay);
		} else {
			this.kmqFlight.freezePriceEUR = parseFloat(convertCurrency(this.amountToPay, tw.currency, "EUR").toFixed(2));
		}
		kmqRecord({name: 'CLICK_FREEZE', obj: this.kmqFlight, prefix: 'CF'});
	} else {
		delete this.kmqFlight.freezePriceEUR;
		kmqRecord({name: 'CLICK_BOOKING'});
	}
	this.hide();
	var requestOptions = {
		repeats: 1,
		RetryFunction: function(){
			MakeRequest();
		},
		ErrorFunction: function(){
			$(document.body).trigger("removeMiddleSearchRotation");
			removeLoader();
			fadeInBlock(tw.layout_results, function(){
				self.draw();
			});
			if(tw.oResult.isAKVisible) {
				tw.oResult.selectedAK = null;
			}
		}
	};

	var countTillTimeout = requestOptions.repeats;

	if (this.priceFreeze) {
		this.params.pf = true;
	} else {
		delete this.params.pf;
	}

	if(this.needPassport) {
		this.params.rpd = true;
	} else {
		delete this.params.rpd;
	}
	if(tw && tw.oResult && tw.oResult.obj && tw.oResult.obj.json && this.params && !this.params.searchId){
		this.params.searchId = tw.oResult.obj.json.srid;
	}
	//for similar_order error support
	this.params.ver = 2;

	if (this.currentFareFamilyBrand) {
		var currentFare = this.currentFareFamilyBrand.fare;
		var self = this;
		this.params.fareKey = currentFare.fareKey;

		currentFare.trips.forEach(function (trip, idx) {
			if (self.params.trips && self.params.trips[idx]) {
				self.params.trips[idx].fic = trip.fic;
				self.params.trips[idx].reservClass = trip.reservClass;
				self.params.trips[idx].serviceClass = trip.serviceClass;
			}
		});

	}

	/* write price to cookie for comparison in MO */
	/* SBPC - Search-Book Price Comparison */
	if (!this.params.promo && !this.Flight.PromoAmount) { // send only non promo variants due to stats pollution
		try {
			var trips = [];
			(this.arrDirections || []).forEach(function(dir) {
				(dir.trips || []).forEach(function(trip) {
					trips.push(trip);
				});
			});
			var idByTrips = trips.map(function(trip) {
				return [
					trip.from,
					trip.airCmp,
					trip.oprdBy || trip.airCmp,
					trip.fltNm,
				].join('');
			}).join('-');

			makeCookie('SBPC:' + idByTrips, this.amountToPay, 1);
		} catch(err) {
			console.warn('Price Comparison Problem', err);
		}
	}

	var dataParams = JSON.stringify(this.params);

	this.activeCheckAvail = true;
	fadeOutBlock(tw.layout_results, function(){
		MakeRequest();
	});
	function MakeRequest(){
		$.ajax({
			iframeId: "pm",
			type: "post",
			url: '/_api/confirmation/checkavail1/',
			dataType: "json",
			data: {
				"params": dataParams
			},
			timeout: 158000,
			beforeSend: function(){
				if ($('#loader').length === 0) {
					var elLayoutBody = document.getElementById("layout_body");
					appendLoader({
						appendTo: elLayoutBody,
						text: l10n.searchResult.passengers.checkavail,
						overlayIsVisible: true
					});
					//commercial
					try {
						$(document.body).trigger("removeMiddleSearchRotation");
						var opt = {
							"id": "com_searchRotation",
							"banner": 'passengerSelect'
						};

						var from = self.Flight.html_tmpl.AirportByCodeFrom[0];
						var to = self.Flight.html_tmpl.AirportByCodeTo[0];
						var keyword = [
							'O_CNT_' + ref.getCountryCode(from),
							'O_CITY_' + ref.getCityCode(from),
							'D_CNT_' + ref.getCountryCode(to),
							'D_CITY_' + ref.getCityCode(to),
							'AK_' + self.Flight.AK
						];
						switch(objSearchForm.data.cs) {
							case 'B':
								keyword.push('CS_BUSINESS');
								break;
							case 'F':
								keyword.push('CS_FIRST');
								break;
							case 'W':
								keyword.push('CS_PREMIUM');
								break;
							default:
								keyword.push('CS_ECONOMY');
								break;
						}
						opt.keyword = keyword;
						opt.onload = function() {
							$('#loader').animate({
								"margin-top": -15
							});
						}
						$('#layout_body').append('<div id="com_searchRotation"></div>');
						initComBlock(opt);
					} catch(e) {}
				}
			},
			success: function(json) {
				if(json.error == 'REQUEST_LIMIT_REACHED'){
					if(browser.mobile) {
						addPopup({
							error: true,
							reason: l10n.popup.systemError,
							comment: l10n.popup.systemComment,
							close_button: true,
							button: l10n.popup.close,
							removeOnAction: true
						});
					} else {
						var captcha = new CaptchaPopup();
						captcha.show(function captchaHandler(err,res){
							if( err || !res ){
								captcha.show(captchaHandler);
							} else {
								captcha.destroy();
								removePopup();
								self.getConfirmation();
							}
						});
					}
					return;
				}
				self.onCheckAvailSuccess(json, self.selectFreeze);
				delete self.selectFreeze;
			},
			complete: function(xhr){
				xhr.url = this.url;
				self.activeCheckAvail = false;
				checkAjaxError(xhr, requestOptions);
			},
			error: function(){
				if(countTillTimeout <1) {
					kmqRecord({name: 'BookingTimeOut', obj: self.kmqFlight, prefix: 'BTO'});
					delete self.selectFreeze;
				}
				countTillTimeout--;
			}
		});
	}
};
PassengerSelect.prototype.onCheckAvailSuccess = function(json, selectFreeze){
	var self = this;
	if(window.hasFakeCheckAvailError || (json.avail && json.id && json.reservations) || !json.avail || !json.id || json.error) {
		self.hideBack();
		/*fadeOutBlock(this.elPageTitlePanel, function(){
		 objSearchForm.show();
		 });*/
		//проверка вариантов, при коотрых показываем metaReturn (любая ошибка не связанная с промо, notavail, частичное бронирование)
		if (window.hasFakeCheckAvailError || !json.avail || !json.id || (json.error && json.error.indexOf('PROMO') === -1)) {
			if (window.hasFakeRedirectingSS || tw.metaReturn && tw.metaReturn.redirectForCurrentFlight) {
				// trigger doesnt work
				$(document.body).trigger("removeMiddleSearchRotation");

				removeLoader();
				tw.metaReturn.addBanner('confirmError');

				if (json.avail && json.id && json.reservations) { //частичное бронирование
					CancelPrereservation(json.id);
				}
				return;
			}
		}
	}

	var firstPassenger = self.passengers[0].lastName+'/'+self.passengers[0].firstName;
	var moreParams = {};
	if(json.wlo || json.wlc) {
		if(json.wlo) {
			moreParams["waitlistopened"] = json.wlo;
		}
		if(json.wlc) {
			moreParams["waitlistclosed"] = json.wlc;
		}
	}
	moreParams.bookingEmail = this.params.email||"NoInfo";
	if(document.referrer) {
		var referrer = unescape(document.referrer);
		referrer = referrer.replace((/(http:\/\/|https:\/\/)/g), "");
		moreParams.bookingReferrer = referrer.substring(0, referrer.indexOf('/') );
	}
	if(tw.ipinfo && tw.ipinfo.ip) {
		moreParams.bookingIP = tw.ipinfo.ip;
	}
	if(tw.ipinfo && tw.ipinfo.countryCode) {
		moreParams.bookingCountryCode = tw.ipinfo.countryCode;
	}
	moreParams.bookingFirstPassenger = firstPassenger;
	_kmq.push(['set', moreParams]);

	if (json.avail && json.id) {
		var gourl = "/m/?id=" + json.id + "&r=" + this.params.routeKey;
		if (selectFreeze) {
			gourl += '&fr=1';
		}

		var goToPay = function(){
			$(document).trigger({
				"type": "successBookingAvia",
				"selectedFlight": self.Flight,
				"kmqFlight": self.kmqFlight,
				"bookingData": self.data,
				"bookingParams": self.params,
				"request": json
			});
			setCookie({
				name: "accept_language",
				value: tw.language,
				days: 360,
				xdm: true
			});
			setCookie({
				name: "currency",
				value: tw.currency,
				days: 180,
				xdm: true
			});

			//OTT-5703
			/*			try {
			 var a = document.createElement('a'),
			 from = self.arrDirections[0].from,
			 to = self.arrDirections[0].to,
			 isDomestic = ref.getCountryCode(from) === ref.getCountryCode(to),
			 serviceClass = self.Flight.ServiceClasses[0][0],
			 isPremium = serviceClass === 'W',
			 trouteRef = ['OW', 'RT', 'MULTI'],
			 dirLength = self.arrDirections.length,
			 adt = 0, chd = 0, inf = 0,
			 tprice = self.data.fare.amt * (tw.currencyRates[self.data.fare.cur + 'USD'] || 1),
			 depth = Math.ceil((self.arrDirections[0].startDate - new Date()) / (1000 * 60 * 60 * 24)),
			 stops = self.Flight.StopTimes.map(function(arr){ return arr.length; }),
			 pdepth = 'more',
			 abParams = [];

			 for (var i = 0; i < self.passengers.length; i++) {
			 var ageType = self.passengers[i].ageType;
			 if (ageType === 'ADT') {
			 adt++;
			 } else if (ageType === 'CNN') {
			 chd++;
			 } else {
			 inf++;
			 }
			 }

			 if (depth <= 7) {
			 pdepth = 7;
			 } else if (depth <= 30) {
			 pdepth = 30;
			 } else if (depth <= 120) {
			 pdepth = 120;
			 }

			 a.href = gourl;

			 abParams.push('ROUTE=' + (isDomestic ? 'DOM' : 'INT'));
			 abParams.push('CLASS=' + (isPremium ? 'PE' : serviceClass));
			 abParams.push('TROUTE=' + trouteRef[dirLength > trouteRef.length ? 2 : (dirLength - 1)]);
			 abParams.push('ADT=' + adt);
			 abParams.push('CHD=' + chd);
			 abParams.push('INF=' + inf);
			 abParams.push('TPRICE=' + Math.round(tprice));
			 abParams.push('DPRICE=' + Math.ceil(tprice / 100));
			 abParams.push('DEPTH=' + depth);
			 abParams.push('PDEPTH=' + pdepth);
			 abParams.push('MAXSTOPS=' + Math.max.apply(Math, stops));
			 abParams.push('LANG=' + tw.language.toUpperCase());

			 if ($(objSocialAuth.loginLoader).hasClass('invisible')) {
			 a.search = a.search.replace(/&?ISAUTH\=[^&]+/g, '');
			 abParams.push('ISAUTH=' + (objSocialAuth.checkAuthorized() ? 'YES' : 'NO'));
			 }

			 a.search = a.search.replace(/&?(ROUTE|CLASS|TROUTE|ADT|CHD|INF|TPRICE|DPRICE|DEPTH|PDEPTH|MAXSTOPS|LANG)\=[^&]+/g, '');
			 a.search += (a.search ? '&' : '?') + abParams.join('&');
			 gourl = a.href;

			 } catch (e) {
			 console.error('abParamsOrder', e);
			 }*/

			//gglTarget
			try {dataLayer.push({'event': 'BookingCreated_'+tw.language});} catch (e) {}
			setTimeout(function(){
				window.location.href = gourl;
			}, 2000);
		};
		if (json.reservations) {
			//частичное бронирование
			$(document.body).trigger("removeMiddleSearchRotation");
			removeLoader();
			kmqRecord({name: 'PART_BOOKING', url: document.location.href, text: 'Booking not for all passengers. frKey: ' + self.Flight.sourceFare.frKey});
			//смотрим на каких пассажиров не забронировали
			var reservedPas = [];
			var unreservedPas = [];
			for (var ReservInd = 0, ReservL = json.reservations.length; ReservInd < ReservL; ReservInd++) {
				var curReserv = json.reservations[ReservInd];
				for (var PasInd = 0, PasL = curReserv.passengers.length; PasInd < PasL; PasInd++) {
					var curPas = curReserv.passengers[PasInd];
					if (curReserv.reserved === true) {
						reservedPas.push(curPas.firstName + ' ' + curPas.lastName);
					} else {
						unreservedPas.push(curPas.firstName + ' ' + curPas.lastName);
					}
				}
			}
			var obj = {
				id: json.id,
				unreservedPas: unreservedPas,
				reservedPas: reservedPas
			};
			var div = document.createElement('div');
			$.tmpl($("#tmpl_cancelPrereservationPopup").trim(), obj).appendTo(div);
			var popup = addPopup({
				dom: div,
				className: "commonPopup"
			});
			$('#continueToBook',popup).on('click', function(){
				goToPay();
			});
			$('#notAgree',popup).on('click', function(){
				CancelPrereservation($(this).attr('data-id'));
			});

			tw.oResult.RedrawResults();
		} else {
			goToPay();
		}
	} else if (!json.avail && !json.error) {
		//если новая цена
		$(document.body).trigger("removeMiddleSearchRotation");
		removeLoader();
		var prcInf = json.prcInf;
		if (prcInf && prcInf.amt && prcInf.cur) {
			//новая цена=> создаем fare в oFares, выписываем туда нужные поля
			var curFare = {
				frKey: json.frKey,
				gdsInf: "",
				cur: json.prcInf.cur,
				amt: json.prcInf.amt,
				gdsType: json.gdsType,
				refund: true
			};
			if (json.infMsgs) {
				for (var infMsgsIndex = 0, infMsgsL = json.infMsgs.length; infMsgsIndex < infMsgsL; infMsgsIndex++) {
					if (json.infMsgs[infMsgsIndex].cd == "NO_REFUND") {
						curFare.refund = false;
					}
				}
			}
			//ставим индекс gdsInf
			for (var someInd = 0, someL = tw.oResult.obj.json.gdsInfs.length; someInd < someL; someInd++) {
				var curGdsInf = tw.oResult.obj.json.gdsInfs[someInd].hash;
				if (curGdsInf == json.gdsInf) {
					curFare.gdsInf = someInd;
				}
			}
			//если пустой значит пришел новый gdsInf
			if (curFare.gdsInf === "") {
				var newInfo = {
					fareRulesRequestId: "",
					hash: json.gdsInf
				};
				curFare.gdsInf = tw.oResult.obj.json.gdsInfs.length;
				tw.oResult.obj.json.gdsInfs.push(newInfo);
			}

			tw.oResult.oFares.max++;
			tw.oResult.oFares[tw.oResult.oFares.max] = curFare;

			var newFlight = this.Flight;
			newFlight.sourceFare = curFare;
			delete newFlight.html_tmpl;
			newFlight.FareId = tw.oResult.oFares.max;

			//добавляем новые трипы в исходный массив, в клонированом объекте перезаписываем индексы трипов в направлениях и другие поля
			var oldTrpsLength = tw.oResult.obj.json.trps.length;
			var newLength = 0;
			for (var DirInd = 0, DirL = newFlight.TripIds.length; DirInd < DirL; DirInd++) {
				for (var TrpsInd = 0, TrpsL = newFlight.TripIds[DirInd].length; TrpsInd < TrpsL; TrpsInd++) {
					responsedTrip = json.trps[newLength];
					tw.oResult.obj.json.trps.push(responsedTrip);

					newFlight.TripIds[DirInd][TrpsInd] = parseInt(oldTrpsLength + newLength, 10);
					//newTrpCounter++;
					newFlight.Classes[DirInd][TrpsInd] = responsedTrip.cls;
					newFlight.Fics[DirInd][TrpsInd] = responsedTrip.fic;
					newFlight.TripsSeatAvl[DirInd][TrpsInd] = responsedTrip.stAvl;
					newFlight.ServiceClasses[DirInd][TrpsInd] = responsedTrip.srvCls;
					newLength++;
				}
			}
			//добавлем в выборку перезаписанный перелёт
			tw.oResult.DefaultAllFlights.push(newFlight);
			//удаляем старый вариант
			tw.oResult.DefaultAllFlights.splice(self.params.FlightIndex, 1);

			var priceOne = Math.ceil(convertCurrency(this.fare.amt, this.fare.cur));
			var priceTwo = Math.ceil(convertCurrency(json.prcInf.amt, json.prcInf.cur));
			var obj = {
				oldPrice: formatMoney(priceOne),
				newPrice: formatMoney(priceTwo)
			};
			var div = document.createElement('div');
			$.tmpl($("#tmpl_PriceChangedPopup").trim(), obj).appendTo(div);
			addPopup({
				dom: div,
				className: "commonPopup",
				close_button: true
			});
			$('#continueMaking', div).click(function(){
				var data = getFareConfirmationParams({
					confirm: newFlight
				});
				removePopup();
				self.setInformation(data);
				self.getData();
				self.getConfirmation();
			});
			var objInfo = self.kmqFlight;
			objInfo.PriceChangedPercent = (priceOne<priceTwo)? '+'+Math.ceil(priceOne/priceTwo*100): '-'+Math.ceil(priceTwo/priceOne*100);
			kmqRecord({name: 'NEW_PRICE', url: document.location.href, text: 'New Price. frKey: ' + self.Flight.sourceFare.frKey, obj: objInfo, prefix: 'NP'});
		} else {
			//если бы только 1 то правильный попап в CheckResultsData когда нет результатов;
			if (tw.oResult.DefaultAllFlights.length > 1) {
				addPopup({
					error: true,
					className: "notConfirmed",
					reason: l10n.searchResult.passengers.popup.notConfirmed.reason,
					comment: l10n.searchResult.passengers.popup.notConfirmed.comment,
					close_button: true,
					button: l10n.searchResult.passengers.popup.notConfirmed.action,
					removeOnAction: true
				});
			}
			//удаляем старый вариант
			tw.oResult.DefaultAllFlights.splice(self.params.FlightIndex, 1);
		}
		kmqRecord({name: 'FareNotConfirmed', url: document.location.href, text: 'FIO: ' + firstPassenger, obj: self.kmqFlight, prefix: 'FNC'});
		CheckResultsData();
	} else {
		$(document.body).trigger("removeMiddleSearchRotation");
		removeLoader();
		fadeInBlock(tw.layout_results);
		switch (json.error) {
			case "NOT_ENOUGHT_TIME_TO_DEPARTURE":
				addPopup({
					error: true,
					close_button: true,
					reason: l10n.popup.card.notEnoughtTimeToDeparture[0],
					comment: l10n.popup.card.notEnoughtTimeToDeparture[1],
					button: l10n.popup.close,
					removeOnAction: true
				});
				kmqRecord({name: 'NoTimeForDepartue', url: document.location.href, text: 'NOT_ENOUGHT_TIME_TO_DEPARTURE'});
				break;
			case "TOO_MUCH_RESERVATIONS":
				addPopup({
					error: true,
					close_button: true,
					reason: l10n.popup.manyReservations[0],
					comment: l10n.popup.manyReservations[1],
					button: l10n.popup.close,
					removeOnAction: true
				});
				kmqRecord({name: 'ManyReservations', url: document.location.href, text: 'TOO_MUCH_RESERVATIONS'});
				break;
			case "DUPLICATE_RESERVATIONS":
				addPopup({
					error: true,
					close_button: true,
					reason: l10n.popup.dublicateReservations[0],
					comment: l10n.popup.dublicateReservations[1],
					button: l10n.popup.close,
					removeOnAction: true
				});
				kmqRecord({name: 'DublicateReservations', text: 'FIO: ' + firstPassenger, obj: self.kmqFlight, prefix: 'DUB'});
				break;
			case "SIMILAR_ORDER":
				var div = document.createElement('div');
				$.tmpl($("#tmpl_SimilarOrder").trim()).appendTo(div);
				addPopup({
					dom: div,
					className: "commonPopup",
					close_button: true
				});
				$('#continueMaking', div).click(function(){
					removePopup();
					self.params.wantNew = true;
					self.getConfirmation();
				});
				kmqRecord({name: 'SimilarOrder', obj: self.kmqFlight, prefix: 'SIM'});
				break;
			case "DELAYED_PASSPORT":
				addPopup({
					error: true,
					close_button: true,
					reason: l10n.popup.warning,
					comment: l10n.searchResult.passengers.popup.delayedPassport,
					button: l10n.popup.close,
					removeOnAction: true
				});
				break;
			case "PROMO_USER_BLOCKED":
				addPopup({
					error: true,
					close_button: true,
					reason: l10n.searchResult.passengers.popup.cantCreateReservation,
					comment: l10n.searchResult.passengers.popup.promoUserBlocked,
					button: l10n.popup.close,
					removeOnAction: true
				});
				break;
			case "PROMO_WRONG_PASSANGER":
				addPopup({
					error: true,
					close_button: true,
					reason: l10n.searchResult.passengers.popup.cantCreateReservation,
					comment: l10n.searchResult.passengers.popup.promoWrongPassenger,
					button: l10n.popup.close,
					removeOnAction: true
				});
				break;
			case "PROMO_CODE_NOT_VALID": {
				var comment = l10n.searchResult.passengers.popup.promoCodeNotValid;
				var errorData = (json.errorData && json.errorData[0]) || {};
				if (errorData.cd === 'ORDER_TOO_CHEAP') {
					comment = l10n.searchResult.passengers.popup.orderTooCheapForPromoCode
						.replaceByHash({ 'amount': formatMoney(convertCurrency(errorData.from, errorData.cur, tw.currency)) });
				}

				addPopup({
					error: true,
					close_button: true,
					reason: l10n.searchResult.passengers.popup.cantCreateReservation,
					comment: comment,
					button: l10n.popup.close,
					removeOnAction: true
				});
			} break;
			case "PROMO_CODE_FOR_TEST_ORDERS":
				addPopup({
					error: true,
					close_button: true,
					reason: l10n.searchResult.passengers.popup.cantCreateReservation,
					comment: l10n.searchResult.passengers.popup.promoForTestOrders,
					button: l10n.popup.close,
					removeOnAction: true
				});
				break;
			case "PROMO_NOT_A_MOBILE_APP":
				var div = document.createElement('div');
				$.tmpl($("#tmpl_PromoTypeError").trim()).appendTo(div);
				addPopup({
					dom: div,
					className: "commonPopup",
					close_button: true
				});
				break;
			case "PROMO_WRONG_PROMO_TYPE":
				addPopup({
					error: true,
					close_button: true,
					reason: l10n.searchResult.passengers.popup.cantCreateReservation,
					comment: l10n.searchResult.passengers.popup.promoCodeWrongType,
					button: l10n.popup.close,
					removeOnAction: true
				});
				break;
			case "PROMO_BLOCKED":
				addPopup({
					error: true,
					close_button: true,
					reason: l10n.searchResult.passengers.popup.cantCreateReservation,
					comment: l10n.searchResult.passengers.popup.promoBlocked,
					button: l10n.popup.close,
					removeOnAction: true
				});
				break;
			case "TEST_PROFILE":
				addPopup({
					error: true,
					close_button: true,
					reason: l10n.searchResult.passengers.popup.cantCreateReservation,
					comment: l10n.searchResult.passengers.popup.tryCreateRealReservation,
					button: l10n.popup.close,
					removeOnAction: true
				});
				break;
			default:
				addPopup({
					error: true,
					reason: l10n.popup.warning,
					comment: l10n.searchResult.passengers.popup.notConfirmed.later,
					close_button: true,
					button: l10n.popup.close,
					removeOnAction: true
				});
				kmqRecord({name: 'FareNotConfirmed', url: document.location.href, text: 'FIO: ' + firstPassenger, obj: self.kmqFlight, prefix: 'FNC'});
				break;
		}
	}
};

PassengerSelect.prototype.showFreeCancelPurchaseBanner = function () {
	// сообщение ывода баннеров о бесплатной отмене заказа
	var fareMsgs = this.Flight.sourceFare.infMsgs || [];
	var BANNER_VOID = 'BANNER_VOID';
	var hasBannerVoidMsg = fareMsgs.some(function(msg) {
		return (msg != null) && (msg === BANNER_VOID || msg.cd === BANNER_VOID || msg.msg === BANNER_VOID);
	});

	this.bannerTemplate = $('#tmpl_freeCancelBnnr');

	if (tw.language === 'ru' && hasBannerVoidMsg) {
		//избегаем дублирования баннера при нажатии на backspace
		$(this.elBlock).find('.FreeCancelPurchaseBanner').remove();

		var bannerClassName = '';

		if (this.needMiddleName) {
			bannerClassName = this.needPassport ? 'xlarge' : 'middle';
		} else {
			bannerClassName = this.needPassport ? 'large' : 'small';
		}

		var dateOptions = {
			day: 'numeric',
			month: 'long'
		};

		var todayDate = new Intl.DateTimeFormat(tw.language, dateOptions).format();

		var data = {
			className: bannerClassName,
			title: 'Бесплатная отмена покупки',
			description: 'Если вы решите перенести полет или откажетесь от поездки, то сможете бесплатно сдать билет до&nbsp;' + todayDate + ' 21:00 (GMT +03:00)'
		};

		$(this.elBlock).append($.tmpl(this.bannerTemplate, data));
	}
};

function CheckResultsData(){
	$(document.body).trigger("removeMiddleSearchRotation");
	removeLoader();
	//перерисовываем
	tw.oResult.RedrawResults();
	//если пришел с момондо-like ресурса сразу на выбранную АК и затем пытался конфирмить
	if (tw.source) {
		delete tw.source;
		window.location.hash = window.location.hash.split('|')[0];
	}
	//при раскрытом варианте и если осталась АК в выборке после удаления - раскрываем снова
	if (tw.oResult.selectedAK) {
		var opt = tw.oResult.selectedAK.AK + '_' + tw.oResult.selectedAK.direct + '_' + tw.oResult.selectedAK.combined;
		if ($('.showAKvariants[opt="' + opt + '"]').length > 0) {
			try {
				tw.oResult.selectedAK = null;
				tw.oResult.MakeClickEvent($('.showAKvariants[opt="' + opt + '"]')[0]);
			}
			catch (e) {
			}
		}
	}
	if (tw.oResult.allFlights.length === 0) {
		addPopup({
			error: true,
			className: "notConfirmed",
			reason: l10n.searchResult.passengers.popup.notConfirmed.reason,
			comment: l10n.searchResult.passengers.popup.notConfirmed.noflights,
			close_button: true,
			button: l10n.popup.close,
			removeOnAction: true
		});
	}
}

function CancelPrereservation(id){
	removePopup();
	$.ajax({
		type: "post",
		dataType: "json",
		url: '/_api/confirmation/cancelconfirm/',
		data: {
			"id": id
		},
		timeout: 40000,
		success: function(){
		}
	});
};

$(document).ready(function(){
	tmpl_TripcoinsInfo = $("#tmpl_TripcoinsInfo").trim();
	tmpl_PassengerSelect = $("#tmpl_PassengerSelect").trim();
	tmpl_FlightInformation = $("#tmpl_ConfirmationFlightInformation").trim();
	tmpl_FreezeFooter = $("#tmpl_FreezeFooter").trim();
	tmpl_PriceFooter = $("#tmpl_PriceFooter").trim();
	tmpl_BookingAviaBody = $("#tmpl_BookingAviaBody").trim();
	tmpl_SuggestPassenger = $("#tmpl_SuggestPassenger").trim();
	tmpl_moreFlightInfo = $("#tmpl_moreFlightInfo").trim();
	tmpl_Benefits = $("#tmpl_Benefits").trim();
	$(document.body).bind("changeRequest", function(){
		objPassengerSelect=null;
	});
});

function showFareRules(options){
	this.options = options;
	var popup = document.getElementById("fareRules");

	if (!popup) {
		popup = addPopup({
			id: "fareRules",
			close_button: true
		});
	}

	if (!this.options.obj.fareRulesFull) {
		appendLoader({
			appendTo: popup,
			text: l10n.loaders.loading
		});
		getFareRules(this.options);
	} else {
		removeLoader();

		var elContent = document.createElement("div");
				elContent.className = "content";
				elContent.innerHTML = l10n.fareRules.head;
		if(this.options.wantPriceFreeze){
			elContent.innerHTML += l10n.fareRules.freezeRules;
		}

		var elCaution = document.createElement('div');
				elCaution.className = "caution";
				elCaution.innerHTML = l10n.fareRules.caution_notused;

		if (this.options.obj.fareRulesFull.routes.length > 1) {
			elCaution.innerHTML += l10n.fareRules.caution_strict;
		}
		if(this.options.obj.fareRulesFull.returnFeeAmount !== null &&
				this.options.obj.fareRulesFull.returnFeeAmount !== undefined &&
					this.options.obj.fareRulesFull.returnFeeAmount !== '') {
			elCaution.innerHTML += l10n.fareRules.caution_penalties_defined.replaceByHash({
				"refundFee": '<span class="money-formatted">' + formatMoney[this.options.obj.fareRulesFull.returnFeeCurrency](this.options.obj.fareRulesFull.returnFeeAmount) + '</span>',
				"exchangeFee": '<span class="money-formatted">' + formatMoney[this.options.obj.fareRulesFull.changeFeeCurrency](this.options.obj.fareRulesFull.changeFeeAmount) + '</span>'
			});
		} else {
			elCaution.innerHTML += l10n.fareRules.caution_penalties;
		}
			elContent.appendChild(elCaution);

		var elMenu = document.createElement('ul');
				elMenu.className = 'menu';

		var elRules = document.createElement('ul');
				elRules.className = 'rules';

		for (var i = 0, length = this.options.obj.fareRulesFull.routes.length; i < length; i++) {
			var route = this.options.obj.fareRulesFull.routes[i];

			var	elMenuItem = document.createElement('li');
				elMenuItem.index = i;
				elMenuItem.innerHTML += ref.getCityName(route.from) + ' → ' + ref.getCityName(route.to);
				elMenuItem.innerHTML += ', ' + route.airCompany + '-' + route.flightNumber;

				elMenuItem.innerHTML += ', '
				if(route.serviceClass == 'F') {
					elMenuItem.innerHTML += l10n.ticket.cls[3];
				} else if(route.serviceClass == 'B'){
					elMenuItem.innerHTML += l10n.ticket.cls[2];
				} else if(route.serviceClass == 'W'){
					elMenuItem.innerHTML += l10n.ticket.cls[1];
				} else {
					elMenuItem.innerHTML += l10n.ticket.cls[0];
				}
				if (route.reservClass) elMenuItem.innerHTML += ' (' + route.reservClass + ')';

				$(elMenuItem).wrapInner('<span class="link dotted">');
			elMenu.appendChild(elMenuItem);

			var	elRulesItem = document.createElement('li');

			var elTitle = document.createElement('div');
					elTitle.className = 'title';
					elTitle.innerHTML = ref.getCityName(route.from) + ' → ' + ref.getCityName(route.to);
				//var startDate = new Date(Date.parse(route.startDate));
				//elTitle.innerHTML += ', ' + startDate.getDate() + ' <span class="date">' + l10n.calendar.months_D[startDate.getMonth()].toLowerCase() + '</span>';
				//elTitle.innerHTML += ', <span class="weekday">' + l10n.calendar.days_N[startDate.getDay()].toLowerCase() + '</span>';
			elRulesItem.appendChild(elTitle);

			var elSubTitle = document.createElement("div");
				elSubTitle.className = "subTitle";
				elSubTitle.innerHTML = l10n.fareRules.tariff[0];
			if (route.withStops) {
				elSubTitle.innerHTML += " " + l10n.fareRules.tariff[1];
			} else {
				elSubTitle.innerHTML += " " + l10n.fareRules.tariff[2];
			}
			elRulesItem.appendChild(elSubTitle);

			var elNote = document.createElement("div");
					elNote.className = "note";
					elNote.innerHTML = l10n.fareRules.details;
			elRulesItem.appendChild(elNote);

			var elFull = document.createElement("div");
					elFull.className = "full";

			var elFullInner = document.createElement("div");
					elFullInner.innerHTML = route.rules;
					elFull.appendChild(elFullInner);
			elRulesItem.appendChild(elFull);

			elRules.appendChild(elRulesItem);

			if (!route.withStops) {
				var $toPenalties = $(".toPenalties", elNote);
				(function(elFull, rulesStr){
					$toPenalties.click(function(){
						var allLines = rulesStr.split("\n").length;
						var penaltiesLine = rulesStr.split(". PENALTIES")[0].split("\n").length;
						var scrollHeight = elFull.scrollHeight;
						scrollHeight -= parseInt($(elFull.firstChild).css("padding-top"), 10);
						scrollHeight -= parseInt($(elFull.firstChild).css("padding-bottom"), 10);
						var scrollToPenalties = ((scrollHeight / allLines) * penaltiesLine) + $(elFull).position().top + elContent.scrollTop;
						$(elContent).animate({
							scrollTop: scrollToPenalties
						}, "slow");
					});
				})(elFull, route.rules);
			}
		}

		if (elMenu.childNodes.length > 1) {
			elContent.appendChild(elMenu);
		}
		elContent.appendChild(elRules);
		$(elMenu.childNodes).click(function(){
			if (!$(this).hasClass('selected')) {
				$('li.selected', elMenu).removeClass('selected');
				$('li.selected', elRules).removeClass('selected');
				$(elRules.childNodes[this.index]).addClass('selected');
				$(this).addClass('selected');
			}
		});
		$(elMenu.childNodes[0]).click();

		popup.appendChild(elContent);

		if (browser.mobile) {
			if (this.options.obj.fareRulesFull.routes.length > 2) {
				$(elContent).wrapInner("<div/>");
				new iScroll(elContent);
			}
			$(".full", popup).each(function(){
				new iScroll(this);
			});
		}
	}
}


function getFareRules(options){
	var self = this;
	this.options = options;
	var requestOptions = {
		repeats: 1,
		backupRepeats: true,
		RetryFunction: function(){
			MakeRequest();
		}
	};
	kmqRecord({name: 'GF_BeforeBooking'});
	MakeRequest();
	function MakeRequest(){
		$.ajax({
			type: "post",
			dataType: "json",
			url: self.options.url,
			data: self.options.data,
			success: function(json){
				if (json.routes) {
					self.options.obj.fareRulesFull = json;
					if (document.getElementById("fareRules")) {
						showFareRules(self.options);
					}
				} else {
					addPopup({
						error: true,
						reason: l10n.fareRules.errorPopup.reason,
						comment: l10n.fareRules.errorPopup.tinkoff_more_info,
						close_button: true,
						button: l10n.popup.close,
						removeOnAction: true
					});
				}
			},
			complete: function(xhr){
				xhr.url = this.url;
				checkAjaxError(xhr, requestOptions);
			}
		});
	}
}



(function(root, factory) {
	if (typeof define === 'function' && define.amd) {
		define(factory);
	} else if (typeof exports === 'object') {
		module.exports = factory(require,exports,module);
	} else {
		root.ouibounce = factory();
	}
}(this, function(require,exports,module) {

	return function ouibounce(el, custom_config) {
		"use strict";

		var config     = custom_config || {},
			aggressive   = config.aggressive || false,
			sensitivity  = setDefault(config.sensitivity, 20),
			timer        = setDefault(config.timer, 1000),
			delay        = setDefault(config.delay, 0),
			callback     = config.callback || function() {},
			cookieExpire = setDefaultCookieExpire(config.cookieExpire) || '',
			cookieDomain = config.cookieDomain ? ';domain=' + config.cookieDomain : '',
			cookieName   = config.cookieName ? config.cookieName : 'viewedOuibounceModal',
			sitewide     = config.sitewide === true ? ';path=/' : '',
			_delayTimer  = null,
			_html        = document.documentElement,
			_disabled      = false;


		function setDefault(_property, _default) {
			return typeof _property === 'undefined' ? _default : _property;
		}

		function setDefaultCookieExpire(days) {
			// transform days to milliseconds
			var ms = days*24*60*60*1000;

			var date = new Date();
			date.setTime(date.getTime() + ms);

			return "; expires=" + date.toUTCString();
		}

		setTimeout(attachOuiBounce, timer);
		function attachOuiBounce() {
			if (isDisabled()) { return; }

			_html.addEventListener('mouseleave', handleMouseleave);
			_html.addEventListener('mouseenter', handleMouseenter);
			_html.addEventListener('keydown', handleKeydown);
		}

		function handleMouseleave(e) {
			if (e.clientY > sensitivity) { return; }

			_delayTimer = setTimeout(fire, delay);
		}

		function handleMouseenter() {
			if (_delayTimer) {
				clearTimeout(_delayTimer);
				_delayTimer = null;
			}
		}

		var disableKeydown = false;
		function handleKeydown(e) {
			if (disableKeydown) { return; }
			else if(!e.metaKey || e.keyCode !== 76) { return; }

			disableKeydown = true;
			_delayTimer = setTimeout(fire, delay);
		}

		function checkCookieValue(cookieName, value) {
			return parseCookies()[cookieName] === value;
		}

		function parseCookies() {
			// cookies are separated by '; '
			var cookies = document.cookie.split('; ');

			var ret = {};
			for (var i = cookies.length - 1; i >= 0; i--) {
				var el = cookies[i].split('=');
				ret[el[0]] = el[1];
			}
			return ret;
		}

		function isDisabled() {
			return checkCookieValue(cookieName, 'true') && !aggressive;
		}

		// You can use ouibounce without passing an element
		// https://github.com/carlsednaoui/ouibounce/issues/30
		function fire() {
			//console.log('_turnOff >>>', _active);
			if (isDisabled()) { return; }
			if (_disabled) { return; }

			//ott-popupCheck
			var divs = document.getElementsByTagName('div');
			for(var i = 0, l = divs.length; i < l; i++) {
				var curDiv = divs[i];
				if(curDiv.className.indexOf('popup') !== -1) {
					return;
				}
			}

			if (el) { el.style.display = 'block'; }

			callback();
			disable();
		}

		function disable(custom_options) {
			var options = custom_options || {};

			// you can pass a specific cookie expiration when using the OuiBounce API
			// ex: _ouiBounce.disable({ cookieExpire: 5 });
			if (typeof options.cookieExpire !== 'undefined') {
				cookieExpire = setDefaultCookieExpire(options.cookieExpire);
			}

			// you can pass use sitewide cookies too
			// ex: _ouiBounce.disable({ cookieExpire: 5, sitewide: true });
			if (options.sitewide === true) {
				sitewide = ';path=/';
			}

			// you can pass a domain string when the cookie should be read subdomain-wise
			// ex: _ouiBounce.disable({ cookieDomain: '.example.com' });
			if (typeof options.cookieDomain !== 'undefined') {
				cookieDomain = ';domain=' + options.cookieDomain;
			}

			if (typeof options.cookieName !== 'undefined') {
				cookieName = options.cookieName;
			}

			document.cookie = cookieName + '=true' + cookieExpire + cookieDomain + sitewide;

			// remove listeners
			_html.removeEventListener('mouseleave', handleMouseleave);
			_html.removeEventListener('mouseenter', handleMouseenter);
			_html.removeEventListener('keydown', handleKeydown);
		}

		function turnOn() {
			_disabled = false;
		};

		function turnOff() {
			_disabled = true;
		};

		return {
			turnOff: turnOff,
			turnOn: turnOn,
			fire: fire,
			disable: disable,
			isDisabled: isDisabled
		};
	};

}));

(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Qs = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
// Load modules

var Stringify = require('./stringify');
var Parse = require('./parse');


// Declare internals

var internals = {};


module.exports = {
    stringify: Stringify,
    parse: Parse
};

},{"./parse":2,"./stringify":3}],2:[function(require,module,exports){
// Load modules

var Utils = require('./utils');


// Declare internals

var internals = {
    delimiter: '&',
    depth: 5,
    arrayLimit: 20,
    parameterLimit: 1000,
    strictNullHandling: false,
    plainObjects: false,
    allowPrototypes: false,
    allowDots: false
};


internals.parseValues = function (str, options) {

    var obj = {};
    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);

    for (var i = 0, il = parts.length; i < il; ++i) {
        var part = parts[i];
        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;

        if (pos === -1) {
            obj[Utils.decode(part)] = '';

            if (options.strictNullHandling) {
                obj[Utils.decode(part)] = null;
            }
        }
        else {
            var key = Utils.decode(part.slice(0, pos));
            var val = Utils.decode(part.slice(pos + 1));

            if (!Object.prototype.hasOwnProperty.call(obj, key)) {
                obj[key] = val;
            }
            else {
                obj[key] = [].concat(obj[key]).concat(val);
            }
        }
    }

    return obj;
};


internals.parseObject = function (chain, val, options) {

    if (!chain.length) {
        return val;
    }

    var root = chain.shift();

    var obj;
    if (root === '[]') {
        obj = [];
        obj = obj.concat(internals.parseObject(chain, val, options));
    }
    else {
        obj = options.plainObjects ? Object.create(null) : {};
        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
        var index = parseInt(cleanRoot, 10);
        var indexString = '' + index;
        if (!isNaN(index) &&
            root !== cleanRoot &&
            indexString === cleanRoot &&
            index >= 0 &&
            (options.parseArrays &&
             index <= options.arrayLimit)) {

            obj = [];
            obj[index] = internals.parseObject(chain, val, options);
        }
        else {
            obj[cleanRoot] = internals.parseObject(chain, val, options);
        }
    }

    return obj;
};


internals.parseKeys = function (key, val, options) {

    if (!key) {
        return;
    }

    // Transform dot notation to bracket notation

    if (options.allowDots) {
        key = key.replace(/\.([^\.\[]+)/g, '[$1]');
    }

    // The regex chunks

    var parent = /^([^\[\]]*)/;
    var child = /(\[[^\[\]]*\])/g;

    // Get the parent

    var segment = parent.exec(key);

    // Stash the parent if it exists

    var keys = [];
    if (segment[1]) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects &&
            Object.prototype.hasOwnProperty(segment[1])) {

            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(segment[1]);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {

        ++i;
        if (!options.plainObjects &&
            Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {

            if (!options.allowPrototypes) {
                continue;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return internals.parseObject(keys, val, options);
};


module.exports = function (str, options) {

    options = options || {};
    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : internals.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : internals.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : internals.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;

    if (str === '' ||
        str === null ||
        typeof str === 'undefined') {

        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0, il = keys.length; i < il; ++i) {
        var key = keys[i];
        var newObj = internals.parseKeys(key, tempObj[key], options);
        obj = Utils.merge(obj, newObj, options);
    }

    return Utils.compact(obj);
};

},{"./utils":4}],3:[function(require,module,exports){
// Load modules

var Utils = require('./utils');


// Declare internals

var internals = {
    delimiter: '&',
    arrayPrefixGenerators: {
        brackets: function (prefix, key) {

            return prefix + '[]';
        },
        indices: function (prefix, key) {

            return prefix + '[' + key + ']';
        },
        repeat: function (prefix, key) {

            return prefix;
        }
    },
    strictNullHandling: false,
    skipNulls: false,
    encode: true
};


internals.stringify = function (obj, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter) {

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    }
    else if (Utils.isBuffer(obj)) {
        obj = obj.toString();
    }
    else if (obj instanceof Date) {
        obj = obj.toISOString();
    }
    else if (obj === null) {
        if (strictNullHandling) {
            return encode ? Utils.encode(prefix) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' ||
        typeof obj === 'number' ||
        typeof obj === 'boolean') {

        if (encode) {
            return [Utils.encode(prefix) + '=' + Utils.encode(obj)];
        }
        return [prefix + '=' + obj];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys = Array.isArray(filter) ? filter : Object.keys(obj);
    for (var i = 0, il = objKeys.length; i < il; ++i) {
        var key = objKeys[i];

        if (skipNulls &&
            obj[key] === null) {

            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
        }
        else {
            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
        }
    }

    return values;
};


module.exports = function (obj, options) {

    options = options || {};
    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : internals.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : internals.encode;
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    }
    else if (Array.isArray(options.filter)) {
        objKeys = filter = options.filter;
    }

    var keys = [];

    if (typeof obj !== 'object' ||
        obj === null) {

        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in internals.arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    }
    else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    }
    else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    for (var i = 0, il = objKeys.length; i < il; ++i) {
        var key = objKeys[i];

        if (skipNulls &&
            obj[key] === null) {

            continue;
        }

        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
    }

    return keys.join(delimiter);
};

},{"./utils":4}],4:[function(require,module,exports){
// Load modules


// Declare internals

var internals = {};
internals.hexTable = new Array(256);
for (var h = 0; h < 256; ++h) {
    internals.hexTable[h] = '%' + ((h < 16 ? '0' : '') + h.toString(16)).toUpperCase();
}


exports.arrayToObject = function (source, options) {

    var obj = options.plainObjects ? Object.create(null) : {};
    for (var i = 0, il = source.length; i < il; ++i) {
        if (typeof source[i] !== 'undefined') {

            obj[i] = source[i];
        }
    }

    return obj;
};


exports.merge = function (target, source, options) {

    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        }
        else if (typeof target === 'object') {
            target[source] = true;
        }
        else {
            target = [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        target = [target].concat(source);
        return target;
    }

    if (Array.isArray(target) &&
        !Array.isArray(source)) {

        target = exports.arrayToObject(target, options);
    }

    var keys = Object.keys(source);
    for (var k = 0, kl = keys.length; k < kl; ++k) {
        var key = keys[k];
        var value = source[key];

        if (!Object.prototype.hasOwnProperty.call(target, key)) {
            target[key] = value;
        }
        else {
            target[key] = exports.merge(target[key], value, options);
        }
    }

    return target;
};


exports.decode = function (str) {

    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function (str) {

    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    if (typeof str !== 'string') {
        str = '' + str;
    }

    var out = '';
    for (var i = 0, il = str.length; i < il; ++i) {
        var c = str.charCodeAt(i);

        if (c === 0x2D || // -
            c === 0x2E || // .
            c === 0x5F || // _
            c === 0x7E || // ~
            (c >= 0x30 && c <= 0x39) || // 0-9
            (c >= 0x41 && c <= 0x5A) || // a-z
            (c >= 0x61 && c <= 0x7A)) { // A-Z

            out += str[i];
            continue;
        }

        if (c < 0x80) {
            out += internals.hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out += internals.hexTable[0xC0 | (c >> 6)] + internals.hexTable[0x80 | (c & 0x3F)];
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out += internals.hexTable[0xE0 | (c >> 12)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
            continue;
        }

        ++i;
        c = 0x10000 + (((c & 0x3FF) << 10) | (str.charCodeAt(i) & 0x3FF));
        out += internals.hexTable[0xF0 | (c >> 18)] + internals.hexTable[0x80 | ((c >> 12) & 0x3F)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function (obj, refs) {

    if (typeof obj !== 'object' ||
        obj === null) {

        return obj;
    }

    refs = refs || [];
    var lookup = refs.indexOf(obj);
    if (lookup !== -1) {
        return refs[lookup];
    }

    refs.push(obj);

    if (Array.isArray(obj)) {
        var compacted = [];

        for (var i = 0, il = obj.length; i < il; ++i) {
            if (typeof obj[i] !== 'undefined') {
                compacted.push(obj[i]);
            }
        }

        return compacted;
    }

    var keys = Object.keys(obj);
    for (i = 0, il = keys.length; i < il; ++i) {
        var key = keys[i];
        obj[key] = exports.compact(obj[key], refs);
    }

    return obj;
};


exports.isRegExp = function (obj) {

    return Object.prototype.toString.call(obj) === '[object RegExp]';
};


exports.isBuffer = function (obj) {

    if (obj === null ||
        typeof obj === 'undefined') {

        return false;
    }

    return !!(obj.constructor &&
              obj.constructor.isBuffer &&
              obj.constructor.isBuffer(obj));
};

},{}]},{},[1])(1)
});
// Удаляет плашку расширения Travel Bar на результатах поиска

$(function () {
	var cancerousSVGd = "M56.971 52.729L44.243 40l12.728-12.728-4.242-4.243L40 35.757 27.272 23.029l-4.243 4.243L35.757 40 23.029 52.729l4.243 4.242L40 44.243l12.729 12.728z";

	// #fcefb4 / rgb(252, 239, 180) (поносно-жёлтый цвет Travel Bar)
	var cancerousColor = [
		50 * 4 + 25 * 2 + 2, //  252
		100 * 2 + 30 + 3 * 3, // 239
		6 * 3 * 10 // 180
	];

	var travelBarReported = false;

	function reportTravelBar() {
		if (travelBarReported) {
			return;
		}

		if (typeof kmqRecord === 'undefined') {
			return;
		}

		kmqRecord({ name: 'travel_bar' });
		travelBarReported = true;
	}

	function isCancerous(node) {
		var computedStyle = window.getComputedStyle(node);

		var rgbColor = 'rgb(' + cancerousColor.join(', ') + ')';

		if (computedStyle.backgroundColor === rgbColor) {
			return true;
		}

		var svg = node.querySelector('[d="' + cancerousSVGd + '"]');

		if (svg) {
			return true;
		}

		return false;
	}

	function cureCancer() {
		if (typeof MutationObserver === 'undefined') {
			return;
		}

		var bodyObserver = new MutationObserver(function (mutations) {
			mutations.forEach(function (mutation) {
				switch (mutation.type) {
					case 'attributes': {
						if (mutation.attributeName === 'style') {
							var style = document.body.style;
							var infectedProperty = 'margin-top';
							if (style[infectedProperty]) {
								style.removeProperty(infectedProperty);
							}
						}
						break;
					}
					case 'childList': {
						var addedNodes = mutation.addedNodes;
						
						for (var i = 0; i < addedNodes.length; i++) {
							var node = addedNodes[i];
							if (isCancerous(node)) {
								reportTravelBar();
								node.parentNode.removeChild(node);
							}
						}
						break;
					}
				}
			});
		});

		bodyObserver.observe(document.body, {
			attributes: true,
			childList: true,
			characterData: false
		});

		var headObserver = new MutationObserver(function (mutations) {
			var mutationAddedNodes = [];
			var removeAllMutationNodes = false;

			var hexColor = '#' + cancerousColor.map(function (n) {
				return n.toString(16);
			}).join('').toLowerCase();

			mutations.forEach(function (mutation) {
				// удаляем добавление стилей
				if (mutation.type === 'childList') {
					var addedNodes = mutation.addedNodes;

					for (var i = 0; i < addedNodes.length; i++) {
						var node = addedNodes[i];

						mutationAddedNodes.push(node);

						if (node.href && node.href.indexOf('PT+Sans')) {
							removeAllMutationNodes = true;
							continue;
						}

						var innerHTML = node.innerHTML.toLowerCase();

						if (innerHTML.indexOf(hexColor) >= 0) {
							removeAllMutationNodes = true;
							continue;
						}
					}
				}
			});

			if (removeAllMutationNodes) {
				reportTravelBar();

				for (var i = 0; i < mutationAddedNodes.length; i++) {
					var node = mutationAddedNodes[i];
					node.parentNode.removeChild(node);
				}
			}
		});

		headObserver.observe(document.head, {
			attributes: false,
			childList: true,
			characterData: false
		});
	}

	cureCancer();
});


